!function (e) {
  const t = e.en = e.en || {};
  t.dictionary = Object.assign(t.dictionary || {}, {
    "(may require <kbd>Fn</kbd>)": "(may require <kbd>Fn</kbd>)",
    "%0 of %1": "%0 of %1",
    Accept: "Accept",
    Accessibility: "Accessibility",
    "Accessibility help": "Accessibility help",
    "Align cell text to the bottom": "Align cell text to the bottom",
    "Align cell text to the center": "Align cell text to the center",
    "Align cell text to the left": "Align cell text to the left",
    "Align cell text to the middle": "Align cell text to the middle",
    "Align cell text to the right": "Align cell text to the right",
    "Align cell text to the top": "Align cell text to the top",
    "Align center": "Align center",
    "Align left": "Align left",
    "Align right": "Align right",
    "Align table to the left": "Align table to the left",
    "Align table to the right": "Align table to the right",
    Alignment: "Alignment",
    Aquamarine: "Aquamarine",
    Background: "Background",
    "Below, you can find a list of keyboard shortcuts that can be used in the editor.": "Below, you can find a list of keyboard shortcuts that can be used in the editor.",
    Big: "Big",
    Black: "Black",
    "Block quote": "Block quote",
    Blue: "Blue",
    Bold: "Bold",
    "Bold text": "Bold text",
    Border: "Border",
    "Break text": "Break text",
    "Bulleted List": "Bulleted List",
    "Bulleted list styles toolbar": "Bulleted list styles toolbar",
    Cancel: "Cancel",
    "Caption for image: %0": "Caption for image: %0",
    "Caption for the image": "Caption for the image",
    "Cell properties": "Cell properties",
    "Center table": "Center table",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Choose heading": "Choose heading",
    Circle: "Circle",
    Clear: "Clear",
    "Click to edit block": "Click to edit block",
    Close: "Close",
    "Close contextual balloons, dropdowns, and dialogs": "Close contextual balloons, dropdowns, and dialogs",
    Code: "Code",
    Color: "Color",
    "Color picker": "Color picker",
    Column: "Column",
    "Content editing keystrokes": "Content editing keystrokes",
    "Copy selected content": "Copy selected content",
    "Create link": "Create link",
    Custom: "Custom",
    "Custom image size": "Custom image size",
    Dashed: "Dashed",
    Decimal: "Decimal",
    "Decimal with leading zero": "Decimal with leading zero",
    "Decrease indent": "Decrease indent",
    "Decrease list item indent": "Decrease list item indent",
    Default: "Default",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    "Dim grey": "Dim grey",
    Dimensions: "Dimensions",
    Disc: "Disc",
    "Document colors": "Document colors",
    Dotted: "Dotted",
    Double: "Double",
    Downloadable: "Downloadable",
    "Drag to move": "Drag to move",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit block": "Edit block",
    "Edit link": "Edit link",
    "Editor block content toolbar": "Editor block content toolbar",
    "Editor contextual toolbar": "Editor contextual toolbar",
    "Editor dialog": "Editor dialog",
    "Editor editing area: %0": "Editor editing area: %0",
    "Editor menu bar": "Editor menu bar",
    "Editor toolbar": "Editor toolbar",
    "Enter image caption": "Enter image caption",
    "Enter table caption": "Enter table caption",
    "Entering a to-do list": "Entering a to-do list",
    "Error during image upload": "Error during image upload",
    "Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.": "Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.",
    "Font Background Color": "Font Background Color",
    "Font Color": "Font Color",
    "Font Family": "Font Family",
    "Font Size": "Font Size",
    "Full size image": "Full size image",
    Green: "Green",
    Grey: "Grey",
    Groove: "Groove",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    Height: "Height",
    "Help Contents. To close this dialog press ESC.": "Help Contents. To close this dialog press ESC.",
    HEX: "HEX",
    "Horizontal line": "Horizontal line",
    "Horizontal text alignment toolbar": "Horizontal text alignment toolbar",
    "HTML object": "HTML object",
    Huge: "Huge",
    "Image from computer": "Image from computer",
    "Image resize list": "Image resize list",
    "Image toolbar": "Image toolbar",
    "Image upload complete": "Image upload complete",
    "image widget": "image widget",
    "In line": "In line",
    "Increase indent": "Increase indent",
    "Increase list item indent": "Increase list item indent",
    Insert: "Insert",
    "Insert a hard break (a new paragraph)": "Insert a hard break (a new paragraph)",
    "Insert a new paragraph directly after a widget": "Insert a new paragraph directly after a widget",
    "Insert a new paragraph directly before a widget": "Insert a new paragraph directly before a widget",
    "Insert a new table row (when in the last cell of a table)": "Insert a new table row (when in the last cell of a table)",
    "Insert a soft break (a <code>&lt;br&gt;</code> element)": "Insert a soft break (a <code>&lt;br&gt;</code> element)",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert image": "Insert image",
    "Insert image via URL": "Insert image via URL",
    "Insert media": "Insert media",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    Inset: "Inset",
    "Invalid start index value.": "Invalid start index value.",
    Italic: "Italic",
    "Italic text": "Italic text",
    Justify: "Justify",
    "Justify cell text": "Justify cell text",
    "Keystrokes that can be used in a list": "Keystrokes that can be used in a list",
    "Keystrokes that can be used in a table cell": "Keystrokes that can be used in a table cell",
    "Keystrokes that can be used when a widget is selected (for example: image, table, etc.)": "Keystrokes that can be used when a widget is selected (for example: image, table, etc.)",
    "Leaving a to-do list": "Leaving a to-do list",
    "Left aligned image": "Left aligned image",
    "Light blue": "Light blue",
    "Light green": "Light green",
    "Light grey": "Light grey",
    Link: "Link",
    "Link image": "Link image",
    "Link URL": "Link URL",
    "Link URL must not be empty.": "Link URL must not be empty.",
    "List properties": "List properties",
    "Lower-latin": "Lower-latin",
    "Lower–roman": "Lower–roman",
    "Media toolbar": "Media toolbar",
    "Media URL": "Media URL",
    "media widget": "media widget",
    MENU_BAR_MENU_EDIT: "Edit",
    MENU_BAR_MENU_FILE: "File",
    MENU_BAR_MENU_FONT: "Font",
    MENU_BAR_MENU_FORMAT: "Format",
    MENU_BAR_MENU_HELP: "Help",
    MENU_BAR_MENU_INSERT: "Insert",
    MENU_BAR_MENU_TEXT: "Text",
    MENU_BAR_MENU_TOOLS: "Tools",
    MENU_BAR_MENU_VIEW: "View",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    "Move focus between form fields (inputs, buttons, etc.)": "Move focus between form fields (inputs, buttons, etc.)",
    "Move focus in and out of an active dialog window": "Move focus in and out of an active dialog window",
    "Move focus to the menu bar, navigate between menu bars": "Move focus to the menu bar, navigate between menu bars",
    "Move focus to the toolbar, navigate between toolbars": "Move focus to the toolbar, navigate between toolbars",
    "Move out of a link": "Move out of a link",
    "Move out of an inline code style": "Move out of an inline code style",
    "Move the caret to allow typing directly after a widget": "Move the caret to allow typing directly after a widget",
    "Move the caret to allow typing directly before a widget": "Move the caret to allow typing directly before a widget",
    "Move the selection to the next cell": "Move the selection to the next cell",
    "Move the selection to the previous cell": "Move the selection to the previous cell",
    "Navigate through the table": "Navigate through the table",
    "Navigate through the toolbar or menu bar": "Navigate through the toolbar or menu bar",
    Next: "Next",
    "No results found": "No results found",
    "No searchable items": "No searchable items",
    None: "None",
    "Numbered List": "Numbered List",
    "Numbered list styles toolbar": "Numbered list styles toolbar",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    "Open media in new tab": "Open media in new tab",
    "Open the accessibility help dialog": "Open the accessibility help dialog",
    Orange: "Orange",
    Original: "Original",
    Outset: "Outset",
    Padding: "Padding",
    Paragraph: "Paragraph",
    "Paste content": "Paste content",
    "Paste content as plain text": "Paste content as plain text",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    'Please enter a valid color (e.g. "ff0000").': 'Please enter a valid color (e.g. "ff0000").',
    "Press %0 for help.": "Press %0 for help.",
    "Press Enter to type after or press Shift + Enter to type before the widget": "Press Enter to type after or press Shift + Enter to type before the widget",
    Previous: "Previous",
    Purple: "Purple",
    Red: "Red",
    Redo: "Redo",
    "Remove color": "Remove color",
    "Remove Format": "Remove Format",
    "Replace from computer": "Replace from computer",
    "Replace image": "Replace image",
    "Replace image from computer": "Replace image from computer",
    "Resize image": "Resize image",
    "Resize image (in %0)": "Resize image (in %0)",
    "Resize image to %0": "Resize image to %0",
    "Resize image to the original size": "Resize image to the original size",
    "Restore default": "Restore default",
    "Reversed order": "Reversed order",
    "Revert autoformatting action": "Revert autoformatting action",
    "Rich Text Editor": "Rich Text Editor",
    Ridge: "Ridge",
    "Right aligned image": "Right aligned image",
    Row: "Row",
    Save: "Save",
    "Select all": "Select all",
    "Select column": "Select column",
    "Select row": "Select row",
    "Show more items": "Show more items",
    "Show source": "Show source",
    "Side image": "Side image",
    Small: "Small",
    Solid: "Solid",
    Source: "Source",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    Square: "Square",
    "Start at": "Start at",
    "Start index must be greater than 0.": "Start index must be greater than 0.",
    Strikethrough: "Strikethrough",
    "Strikethrough text": "Strikethrough text",
    Style: "Style",
    Subscript: "Subscript",
    Superscript: "Superscript",
    Table: "Table",
    "Table alignment toolbar": "Table alignment toolbar",
    "Table cell text alignment": "Table cell text alignment",
    "Table properties": "Table properties",
    "Table toolbar": "Table toolbar",
    "Text alignment": "Text alignment",
    "Text alignment toolbar": "Text alignment toolbar",
    "Text alternative": "Text alternative",
    'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".': 'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".',
    "The URL must not be empty.": "The URL must not be empty.",
    'The value is invalid. Try "10px" or "2em" or simply "2".': 'The value is invalid. Try "10px" or "2em" or simply "2".',
    "The value must not be empty.": "The value must not be empty.",
    "The value should be a plain number.": "The value should be a plain number.",
    "These keyboard shortcuts allow for quick access to content editing features.": "These keyboard shortcuts allow for quick access to content editing features.",
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    Tiny: "Tiny",
    "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.",
    "To-do List": "To-do List",
    "Toggle caption off": "Toggle caption off",
    "Toggle caption on": "Toggle caption on",
    "Toggle the circle list style": "Toggle the circle list style",
    "Toggle the decimal list style": "Toggle the decimal list style",
    "Toggle the decimal with leading zero list style": "Toggle the decimal with leading zero list style",
    "Toggle the disc list style": "Toggle the disc list style",
    "Toggle the lower–latin list style": "Toggle the lower–latin list style",
    "Toggle the lower–roman list style": "Toggle the lower–roman list style",
    "Toggle the square list style": "Toggle the square list style",
    "Toggle the upper–latin list style": "Toggle the upper–latin list style",
    "Toggle the upper–roman list style": "Toggle the upper–roman list style",
    Turquoise: "Turquoise",
    "Type or paste your content here.": "Type or paste your content here.",
    "Type your title": "Type your title",
    Underline: "Underline",
    "Underline text": "Underline text",
    Undo: "Undo",
    Unlink: "Unlink",
    Update: "Update",
    "Update image URL": "Update image URL",
    "Upload failed": "Upload failed",
    "Upload from computer": "Upload from computer",
    "Upload image from computer": "Upload image from computer",
    "Upload in progress": "Upload in progress",
    "Uploading image": "Uploading image",
    "Upper-latin": "Upper-latin",
    "Upper-roman": "Upper-roman",
    "Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.": "Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.",
    "User interface and content navigation keystrokes": "User interface and content navigation keystrokes",
    "Vertical text alignment toolbar": "Vertical text alignment toolbar",
    White: "White",
    "Widget toolbar": "Widget toolbar",
    Width: "Width",
    "Wrap text": "Wrap text",
    Yellow: "Yellow"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.ClassicEditor = t() : e.ClassicEditor = t();
}(self, () => (() => {
  var e,
    t,
    n = {
      5659: (e, t, n) => {
        const i = n(8156),
          o = {};
        for (const e of Object.keys(i)) o[i[e]] = e;
        const r = {
          rgb: {
            channels: 3,
            labels: "rgb"
          },
          hsl: {
            channels: 3,
            labels: "hsl"
          },
          hsv: {
            channels: 3,
            labels: "hsv"
          },
          hwb: {
            channels: 3,
            labels: "hwb"
          },
          cmyk: {
            channels: 4,
            labels: "cmyk"
          },
          xyz: {
            channels: 3,
            labels: "xyz"
          },
          lab: {
            channels: 3,
            labels: "lab"
          },
          lch: {
            channels: 3,
            labels: "lch"
          },
          hex: {
            channels: 1,
            labels: ["hex"]
          },
          keyword: {
            channels: 1,
            labels: ["keyword"]
          },
          ansi16: {
            channels: 1,
            labels: ["ansi16"]
          },
          ansi256: {
            channels: 1,
            labels: ["ansi256"]
          },
          hcg: {
            channels: 3,
            labels: ["h", "c", "g"]
          },
          apple: {
            channels: 3,
            labels: ["r16", "g16", "b16"]
          },
          gray: {
            channels: 1,
            labels: ["gray"]
          }
        };
        e.exports = r;
        for (const e of Object.keys(r)) {
          if (!("channels" in r[e])) throw new Error("missing channels property: " + e);
          if (!("labels" in r[e])) throw new Error("missing channel labels property: " + e);
          if (r[e].labels.length !== r[e].channels) throw new Error("channel and label counts mismatch: " + e);
          const {
            channels: t,
            labels: n
          } = r[e];
          delete r[e].channels, delete r[e].labels, Object.defineProperty(r[e], "channels", {
            value: t
          }), Object.defineProperty(r[e], "labels", {
            value: n
          });
        }
        r.rgb.hsl = function (e) {
          const t = e[0] / 255,
            n = e[1] / 255,
            i = e[2] / 255,
            o = Math.min(t, n, i),
            r = Math.max(t, n, i),
            s = r - o;
          let a, l;
          r === o ? a = 0 : t === r ? a = (n - i) / s : n === r ? a = 2 + (i - t) / s : i === r && (a = 4 + (t - n) / s), a = Math.min(60 * a, 360), a < 0 && (a += 360);
          const c = (o + r) / 2;
          return l = r === o ? 0 : c <= .5 ? s / (r + o) : s / (2 - r - o), [a, 100 * l, 100 * c];
        }, r.rgb.hsv = function (e) {
          let t, n, i, o, r;
          const s = e[0] / 255,
            a = e[1] / 255,
            l = e[2] / 255,
            c = Math.max(s, a, l),
            d = c - Math.min(s, a, l),
            u = function (e) {
              return (c - e) / 6 / d + .5;
            };
          return 0 === d ? (o = 0, r = 0) : (r = d / c, t = u(s), n = u(a), i = u(l), s === c ? o = i - n : a === c ? o = 1 / 3 + t - i : l === c && (o = 2 / 3 + n - t), o < 0 ? o += 1 : o > 1 && (o -= 1)), [360 * o, 100 * r, 100 * c];
        }, r.rgb.hwb = function (e) {
          const t = e[0],
            n = e[1];
          let i = e[2];
          const o = r.rgb.hsl(e)[0],
            s = 1 / 255 * Math.min(t, Math.min(n, i));
          return i = 1 - 1 / 255 * Math.max(t, Math.max(n, i)), [o, 100 * s, 100 * i];
        }, r.rgb.cmyk = function (e) {
          const t = e[0] / 255,
            n = e[1] / 255,
            i = e[2] / 255,
            o = Math.min(1 - t, 1 - n, 1 - i);
          return [100 * ((1 - t - o) / (1 - o) || 0), 100 * ((1 - n - o) / (1 - o) || 0), 100 * ((1 - i - o) / (1 - o) || 0), 100 * o];
        }, r.rgb.keyword = function (e) {
          const t = o[e];
          if (t) return t;
          let n,
            r = 1 / 0;
          for (const t of Object.keys(i)) {
            const o = i[t],
              l = (a = o, ((s = e)[0] - a[0]) ** 2 + (s[1] - a[1]) ** 2 + (s[2] - a[2]) ** 2);
            l < r && (r = l, n = t);
          }
          var s, a;
          return n;
        }, r.keyword.rgb = function (e) {
          return i[e];
        }, r.rgb.xyz = function (e) {
          let t = e[0] / 255,
            n = e[1] / 255,
            i = e[2] / 255;
          t = t > .04045 ? ((t + .055) / 1.055) ** 2.4 : t / 12.92, n = n > .04045 ? ((n + .055) / 1.055) ** 2.4 : n / 12.92, i = i > .04045 ? ((i + .055) / 1.055) ** 2.4 : i / 12.92;
          return [100 * (.4124 * t + .3576 * n + .1805 * i), 100 * (.2126 * t + .7152 * n + .0722 * i), 100 * (.0193 * t + .1192 * n + .9505 * i)];
        }, r.rgb.lab = function (e) {
          const t = r.rgb.xyz(e);
          let n = t[0],
            i = t[1],
            o = t[2];
          n /= 95.047, i /= 100, o /= 108.883, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, i = i > .008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116, o = o > .008856 ? o ** (1 / 3) : 7.787 * o + 16 / 116;
          return [116 * i - 16, 500 * (n - i), 200 * (i - o)];
        }, r.hsl.rgb = function (e) {
          const t = e[0] / 360,
            n = e[1] / 100,
            i = e[2] / 100;
          let o, r, s;
          if (0 === n) return s = 255 * i, [s, s, s];
          o = i < .5 ? i * (1 + n) : i + n - i * n;
          const a = 2 * i - o,
            l = [0, 0, 0];
          for (let e = 0; e < 3; e++) r = t + 1 / 3 * -(e - 1), r < 0 && r++, r > 1 && r--, s = 6 * r < 1 ? a + 6 * (o - a) * r : 2 * r < 1 ? o : 3 * r < 2 ? a + (o - a) * (2 / 3 - r) * 6 : a, l[e] = 255 * s;
          return l;
        }, r.hsl.hsv = function (e) {
          const t = e[0];
          let n = e[1] / 100,
            i = e[2] / 100,
            o = n;
          const r = Math.max(i, .01);
          i *= 2, n *= i <= 1 ? i : 2 - i, o *= r <= 1 ? r : 2 - r;
          return [t, 100 * (0 === i ? 2 * o / (r + o) : 2 * n / (i + n)), 100 * ((i + n) / 2)];
        }, r.hsv.rgb = function (e) {
          const t = e[0] / 60,
            n = e[1] / 100;
          let i = e[2] / 100;
          const o = Math.floor(t) % 6,
            r = t - Math.floor(t),
            s = 255 * i * (1 - n),
            a = 255 * i * (1 - n * r),
            l = 255 * i * (1 - n * (1 - r));
          switch (i *= 255, o) {
            case 0:
              return [i, l, s];
            case 1:
              return [a, i, s];
            case 2:
              return [s, i, l];
            case 3:
              return [s, a, i];
            case 4:
              return [l, s, i];
            case 5:
              return [i, s, a];
          }
        }, r.hsv.hsl = function (e) {
          const t = e[0],
            n = e[1] / 100,
            i = e[2] / 100,
            o = Math.max(i, .01);
          let r, s;
          s = (2 - n) * i;
          const a = (2 - n) * o;
          return r = n * o, r /= a <= 1 ? a : 2 - a, r = r || 0, s /= 2, [t, 100 * r, 100 * s];
        }, r.hwb.rgb = function (e) {
          const t = e[0] / 360;
          let n = e[1] / 100,
            i = e[2] / 100;
          const o = n + i;
          let r;
          o > 1 && (n /= o, i /= o);
          const s = Math.floor(6 * t),
            a = 1 - i;
          r = 6 * t - s, 1 & s && (r = 1 - r);
          const l = n + r * (a - n);
          let c, d, u;
          switch (s) {
            default:
            case 6:
            case 0:
              c = a, d = l, u = n;
              break;
            case 1:
              c = l, d = a, u = n;
              break;
            case 2:
              c = n, d = a, u = l;
              break;
            case 3:
              c = n, d = l, u = a;
              break;
            case 4:
              c = l, d = n, u = a;
              break;
            case 5:
              c = a, d = n, u = l;
          }
          return [255 * c, 255 * d, 255 * u];
        }, r.cmyk.rgb = function (e) {
          const t = e[0] / 100,
            n = e[1] / 100,
            i = e[2] / 100,
            o = e[3] / 100;
          return [255 * (1 - Math.min(1, t * (1 - o) + o)), 255 * (1 - Math.min(1, n * (1 - o) + o)), 255 * (1 - Math.min(1, i * (1 - o) + o))];
        }, r.xyz.rgb = function (e) {
          const t = e[0] / 100,
            n = e[1] / 100,
            i = e[2] / 100;
          let o, r, s;
          return o = 3.2406 * t + -1.5372 * n + -.4986 * i, r = -.9689 * t + 1.8758 * n + .0415 * i, s = .0557 * t + -.204 * n + 1.057 * i, o = o > .0031308 ? 1.055 * o ** (1 / 2.4) - .055 : 12.92 * o, r = r > .0031308 ? 1.055 * r ** (1 / 2.4) - .055 : 12.92 * r, s = s > .0031308 ? 1.055 * s ** (1 / 2.4) - .055 : 12.92 * s, o = Math.min(Math.max(0, o), 1), r = Math.min(Math.max(0, r), 1), s = Math.min(Math.max(0, s), 1), [255 * o, 255 * r, 255 * s];
        }, r.xyz.lab = function (e) {
          let t = e[0],
            n = e[1],
            i = e[2];
          t /= 95.047, n /= 100, i /= 108.883, t = t > .008856 ? t ** (1 / 3) : 7.787 * t + 16 / 116, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, i = i > .008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116;
          return [116 * n - 16, 500 * (t - n), 200 * (n - i)];
        }, r.lab.xyz = function (e) {
          let t, n, i;
          n = (e[0] + 16) / 116, t = e[1] / 500 + n, i = n - e[2] / 200;
          const o = n ** 3,
            r = t ** 3,
            s = i ** 3;
          return n = o > .008856 ? o : (n - 16 / 116) / 7.787, t = r > .008856 ? r : (t - 16 / 116) / 7.787, i = s > .008856 ? s : (i - 16 / 116) / 7.787, t *= 95.047, n *= 100, i *= 108.883, [t, n, i];
        }, r.lab.lch = function (e) {
          const t = e[0],
            n = e[1],
            i = e[2];
          let o;
          o = 360 * Math.atan2(i, n) / 2 / Math.PI, o < 0 && (o += 360);
          return [t, Math.sqrt(n * n + i * i), o];
        }, r.lch.lab = function (e) {
          const t = e[0],
            n = e[1],
            i = e[2] / 360 * 2 * Math.PI;
          return [t, n * Math.cos(i), n * Math.sin(i)];
        }, r.rgb.ansi16 = function (e) {
          let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          const [n, i, o] = e;
          let s = null === t ? r.rgb.hsv(e)[2] : t;
          if (s = Math.round(s / 50), 0 === s) return 30;
          let a = 30 + (Math.round(o / 255) << 2 | Math.round(i / 255) << 1 | Math.round(n / 255));
          return 2 === s && (a += 60), a;
        }, r.hsv.ansi16 = function (e) {
          return r.rgb.ansi16(r.hsv.rgb(e), e[2]);
        }, r.rgb.ansi256 = function (e) {
          const t = e[0],
            n = e[1],
            i = e[2];
          if (t === n && n === i) return t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232;
          return 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(i / 255 * 5);
        }, r.ansi16.rgb = function (e) {
          let t = e % 10;
          if (0 === t || 7 === t) return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
          const n = .5 * (1 + ~~(e > 50));
          return [(1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255];
        }, r.ansi256.rgb = function (e) {
          if (e >= 232) {
            const t = 10 * (e - 232) + 8;
            return [t, t, t];
          }
          let t;
          e -= 16;
          return [Math.floor(e / 36) / 5 * 255, Math.floor((t = e % 36) / 6) / 5 * 255, t % 6 / 5 * 255];
        }, r.rgb.hex = function (e) {
          const t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
          return "000000".substring(t.length) + t;
        }, r.hex.rgb = function (e) {
          const t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
          if (!t) return [0, 0, 0];
          let n = t[0];
          3 === t[0].length && (n = n.split("").map(e => e + e).join(""));
          const i = parseInt(n, 16);
          return [i >> 16 & 255, i >> 8 & 255, 255 & i];
        }, r.rgb.hcg = function (e) {
          const t = e[0] / 255,
            n = e[1] / 255,
            i = e[2] / 255,
            o = Math.max(Math.max(t, n), i),
            r = Math.min(Math.min(t, n), i),
            s = o - r;
          let a, l;
          return a = s < 1 ? r / (1 - s) : 0, l = s <= 0 ? 0 : o === t ? (n - i) / s % 6 : o === n ? 2 + (i - t) / s : 4 + (t - n) / s, l /= 6, l %= 1, [360 * l, 100 * s, 100 * a];
        }, r.hsl.hcg = function (e) {
          const t = e[1] / 100,
            n = e[2] / 100,
            i = n < .5 ? 2 * t * n : 2 * t * (1 - n);
          let o = 0;
          return i < 1 && (o = (n - .5 * i) / (1 - i)), [e[0], 100 * i, 100 * o];
        }, r.hsv.hcg = function (e) {
          const t = e[1] / 100,
            n = e[2] / 100,
            i = t * n;
          let o = 0;
          return i < 1 && (o = (n - i) / (1 - i)), [e[0], 100 * i, 100 * o];
        }, r.hcg.rgb = function (e) {
          const t = e[0] / 360,
            n = e[1] / 100,
            i = e[2] / 100;
          if (0 === n) return [255 * i, 255 * i, 255 * i];
          const o = [0, 0, 0],
            r = t % 1 * 6,
            s = r % 1,
            a = 1 - s;
          let l = 0;
          switch (Math.floor(r)) {
            case 0:
              o[0] = 1, o[1] = s, o[2] = 0;
              break;
            case 1:
              o[0] = a, o[1] = 1, o[2] = 0;
              break;
            case 2:
              o[0] = 0, o[1] = 1, o[2] = s;
              break;
            case 3:
              o[0] = 0, o[1] = a, o[2] = 1;
              break;
            case 4:
              o[0] = s, o[1] = 0, o[2] = 1;
              break;
            default:
              o[0] = 1, o[1] = 0, o[2] = a;
          }
          return l = (1 - n) * i, [255 * (n * o[0] + l), 255 * (n * o[1] + l), 255 * (n * o[2] + l)];
        }, r.hcg.hsv = function (e) {
          const t = e[1] / 100,
            n = t + e[2] / 100 * (1 - t);
          let i = 0;
          return n > 0 && (i = t / n), [e[0], 100 * i, 100 * n];
        }, r.hcg.hsl = function (e) {
          const t = e[1] / 100,
            n = e[2] / 100 * (1 - t) + .5 * t;
          let i = 0;
          return n > 0 && n < .5 ? i = t / (2 * n) : n >= .5 && n < 1 && (i = t / (2 * (1 - n))), [e[0], 100 * i, 100 * n];
        }, r.hcg.hwb = function (e) {
          const t = e[1] / 100,
            n = t + e[2] / 100 * (1 - t);
          return [e[0], 100 * (n - t), 100 * (1 - n)];
        }, r.hwb.hcg = function (e) {
          const t = e[1] / 100,
            n = 1 - e[2] / 100,
            i = n - t;
          let o = 0;
          return i < 1 && (o = (n - i) / (1 - i)), [e[0], 100 * i, 100 * o];
        }, r.apple.rgb = function (e) {
          return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
        }, r.rgb.apple = function (e) {
          return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
        }, r.gray.rgb = function (e) {
          return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
        }, r.gray.hsl = function (e) {
          return [0, 0, e[0]];
        }, r.gray.hsv = r.gray.hsl, r.gray.hwb = function (e) {
          return [0, 100, e[0]];
        }, r.gray.cmyk = function (e) {
          return [0, 0, 0, e[0]];
        }, r.gray.lab = function (e) {
          return [e[0], 0, 0];
        }, r.gray.hex = function (e) {
          const t = 255 & Math.round(e[0] / 100 * 255),
            n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
          return "000000".substring(n.length) + n;
        }, r.rgb.gray = function (e) {
          return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
        };
      },
      734: (e, t, n) => {
        const i = n(5659),
          o = n(8507),
          r = {};
        Object.keys(i).forEach(e => {
          r[e] = {}, Object.defineProperty(r[e], "channels", {
            value: i[e].channels
          }), Object.defineProperty(r[e], "labels", {
            value: i[e].labels
          });
          const t = o(e);
          Object.keys(t).forEach(n => {
            const i = t[n];
            r[e][n] = function (e) {
              const t = function () {
                for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
                  t[_key] = arguments[_key];
                }
                const n = t[0];
                if (null == n) return n;
                n.length > 1 && (t = n);
                const i = e(t);
                if ("object" == typeof i) for (let e = i.length, t = 0; t < e; t++) i[t] = Math.round(i[t]);
                return i;
              };
              return "conversion" in e && (t.conversion = e.conversion), t;
            }(i), r[e][n].raw = function (e) {
              const t = function () {
                for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  t[_key2] = arguments[_key2];
                }
                const n = t[0];
                return null == n ? n : (n.length > 1 && (t = n), e(t));
              };
              return "conversion" in e && (t.conversion = e.conversion), t;
            }(i);
          });
        }), e.exports = r;
      },
      8507: (e, t, n) => {
        const i = n(5659);
        function o(e) {
          const t = function () {
              const e = {},
                t = Object.keys(i);
              for (let n = t.length, i = 0; i < n; i++) e[t[i]] = {
                distance: -1,
                parent: null
              };
              return e;
            }(),
            n = [e];
          for (t[e].distance = 0; n.length;) {
            const e = n.pop(),
              o = Object.keys(i[e]);
            for (let i = o.length, r = 0; r < i; r++) {
              const i = o[r],
                s = t[i];
              -1 === s.distance && (s.distance = t[e].distance + 1, s.parent = e, n.unshift(i));
            }
          }
          return t;
        }
        function r(e, t) {
          return function (n) {
            return t(e(n));
          };
        }
        function s(e, t) {
          const n = [t[e].parent, e];
          let o = i[t[e].parent][e],
            s = t[e].parent;
          for (; t[s].parent;) n.unshift(t[s].parent), o = r(i[t[s].parent][s], o), s = t[s].parent;
          return o.conversion = n, o;
        }
        e.exports = function (e) {
          const t = o(e),
            n = {},
            i = Object.keys(t);
          for (let e = i.length, o = 0; o < e; o++) {
            const e = i[o];
            null !== t[e].parent && (n[e] = s(e, t));
          }
          return n;
        };
      },
      8156: e => {
        "use strict";

        e.exports = {
          aliceblue: [240, 248, 255],
          antiquewhite: [250, 235, 215],
          aqua: [0, 255, 255],
          aquamarine: [127, 255, 212],
          azure: [240, 255, 255],
          beige: [245, 245, 220],
          bisque: [255, 228, 196],
          black: [0, 0, 0],
          blanchedalmond: [255, 235, 205],
          blue: [0, 0, 255],
          blueviolet: [138, 43, 226],
          brown: [165, 42, 42],
          burlywood: [222, 184, 135],
          cadetblue: [95, 158, 160],
          chartreuse: [127, 255, 0],
          chocolate: [210, 105, 30],
          coral: [255, 127, 80],
          cornflowerblue: [100, 149, 237],
          cornsilk: [255, 248, 220],
          crimson: [220, 20, 60],
          cyan: [0, 255, 255],
          darkblue: [0, 0, 139],
          darkcyan: [0, 139, 139],
          darkgoldenrod: [184, 134, 11],
          darkgray: [169, 169, 169],
          darkgreen: [0, 100, 0],
          darkgrey: [169, 169, 169],
          darkkhaki: [189, 183, 107],
          darkmagenta: [139, 0, 139],
          darkolivegreen: [85, 107, 47],
          darkorange: [255, 140, 0],
          darkorchid: [153, 50, 204],
          darkred: [139, 0, 0],
          darksalmon: [233, 150, 122],
          darkseagreen: [143, 188, 143],
          darkslateblue: [72, 61, 139],
          darkslategray: [47, 79, 79],
          darkslategrey: [47, 79, 79],
          darkturquoise: [0, 206, 209],
          darkviolet: [148, 0, 211],
          deeppink: [255, 20, 147],
          deepskyblue: [0, 191, 255],
          dimgray: [105, 105, 105],
          dimgrey: [105, 105, 105],
          dodgerblue: [30, 144, 255],
          firebrick: [178, 34, 34],
          floralwhite: [255, 250, 240],
          forestgreen: [34, 139, 34],
          fuchsia: [255, 0, 255],
          gainsboro: [220, 220, 220],
          ghostwhite: [248, 248, 255],
          gold: [255, 215, 0],
          goldenrod: [218, 165, 32],
          gray: [128, 128, 128],
          green: [0, 128, 0],
          greenyellow: [173, 255, 47],
          grey: [128, 128, 128],
          honeydew: [240, 255, 240],
          hotpink: [255, 105, 180],
          indianred: [205, 92, 92],
          indigo: [75, 0, 130],
          ivory: [255, 255, 240],
          khaki: [240, 230, 140],
          lavender: [230, 230, 250],
          lavenderblush: [255, 240, 245],
          lawngreen: [124, 252, 0],
          lemonchiffon: [255, 250, 205],
          lightblue: [173, 216, 230],
          lightcoral: [240, 128, 128],
          lightcyan: [224, 255, 255],
          lightgoldenrodyellow: [250, 250, 210],
          lightgray: [211, 211, 211],
          lightgreen: [144, 238, 144],
          lightgrey: [211, 211, 211],
          lightpink: [255, 182, 193],
          lightsalmon: [255, 160, 122],
          lightseagreen: [32, 178, 170],
          lightskyblue: [135, 206, 250],
          lightslategray: [119, 136, 153],
          lightslategrey: [119, 136, 153],
          lightsteelblue: [176, 196, 222],
          lightyellow: [255, 255, 224],
          lime: [0, 255, 0],
          limegreen: [50, 205, 50],
          linen: [250, 240, 230],
          magenta: [255, 0, 255],
          maroon: [128, 0, 0],
          mediumaquamarine: [102, 205, 170],
          mediumblue: [0, 0, 205],
          mediumorchid: [186, 85, 211],
          mediumpurple: [147, 112, 219],
          mediumseagreen: [60, 179, 113],
          mediumslateblue: [123, 104, 238],
          mediumspringgreen: [0, 250, 154],
          mediumturquoise: [72, 209, 204],
          mediumvioletred: [199, 21, 133],
          midnightblue: [25, 25, 112],
          mintcream: [245, 255, 250],
          mistyrose: [255, 228, 225],
          moccasin: [255, 228, 181],
          navajowhite: [255, 222, 173],
          navy: [0, 0, 128],
          oldlace: [253, 245, 230],
          olive: [128, 128, 0],
          olivedrab: [107, 142, 35],
          orange: [255, 165, 0],
          orangered: [255, 69, 0],
          orchid: [218, 112, 214],
          palegoldenrod: [238, 232, 170],
          palegreen: [152, 251, 152],
          paleturquoise: [175, 238, 238],
          palevioletred: [219, 112, 147],
          papayawhip: [255, 239, 213],
          peachpuff: [255, 218, 185],
          peru: [205, 133, 63],
          pink: [255, 192, 203],
          plum: [221, 160, 221],
          powderblue: [176, 224, 230],
          purple: [128, 0, 128],
          rebeccapurple: [102, 51, 153],
          red: [255, 0, 0],
          rosybrown: [188, 143, 143],
          royalblue: [65, 105, 225],
          saddlebrown: [139, 69, 19],
          salmon: [250, 128, 114],
          sandybrown: [244, 164, 96],
          seagreen: [46, 139, 87],
          seashell: [255, 245, 238],
          sienna: [160, 82, 45],
          silver: [192, 192, 192],
          skyblue: [135, 206, 235],
          slateblue: [106, 90, 205],
          slategray: [112, 128, 144],
          slategrey: [112, 128, 144],
          snow: [255, 250, 250],
          springgreen: [0, 255, 127],
          steelblue: [70, 130, 180],
          tan: [210, 180, 140],
          teal: [0, 128, 128],
          thistle: [216, 191, 216],
          tomato: [255, 99, 71],
          turquoise: [64, 224, 208],
          violet: [238, 130, 238],
          wheat: [245, 222, 179],
          white: [255, 255, 255],
          whitesmoke: [245, 245, 245],
          yellow: [255, 255, 0],
          yellowgreen: [154, 205, 50]
        };
      },
      7930: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content code{background-color:#c7c7c74d;border-radius:2px;padding:.15em}.ck.ck-editor__editable .ck-code_selected{background-color:#c7c7c780}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-basic-styles/theme/code.css"],
          names: [],
          mappings: "AAKA,iBACC,0BAAuC,CAEvC,iBAAkB,CADlB,aAED,CAEA,0CACC,0BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content code {\n\tbackground-color: hsla(0, 0%, 78%, 0.3);\n\tpadding: .15em;\n\tborder-radius: 2px;\n}\n\n.ck.ck-editor__editable .ck-code_selected  {\n\tbackground-color: hsla(0, 0%, 78%, 0.5);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1487: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css"],
          names: [],
          mappings: "AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6356: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}.ck.ck-clipboard-drop-target-line{pointer-events:none;position:absolute}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) #0000 #0000 #0000;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}.ck.ck-clipboard-drop-target-line{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);height:0;margin-top:-1px}.ck.ck-clipboard-drop-target-line:before{border-style:solid;content:"";height:0;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-width)*-.5);width:0}[dir=ltr] .ck.ck-clipboard-drop-target-line:before{border-color:#0000 #0000 #0000 var(--ck-clipboard-drop-target-color);border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height);left:-1px}[dir=rtl] .ck.ck-clipboard-drop-target-line:before{border-color:#0000 var(--ck-clipboard-drop-target-color) #0000 #0000;border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0;right:-1px}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"],
          names: [],
          mappings: "AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CAIF,kCAEC,mBAAoB,CADpB,iBAED,CC9BA,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,oEAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CAOF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD,CAGD,kCAGC,gDAAiD,CADjD,sDAAuD,CADvD,QAAS,CAGT,eAwBD,CAtBC,yCAMC,kBAAmB,CALnB,UAAW,CAIX,QAAS,CAHT,iBAAkB,CAClB,uDAA0D,CAC1D,OAiBD,CArBA,mDAYE,oEAAuF,CADvF,+JAAoK,CAFpK,SAYF,CArBA,mDAmBE,oEAAuF,CADvF,+JAAmK,CAFnK,UAKF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\tposition: absolute;\n\tpointer-events: none;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"@ckeditor/ckeditor5-ui/theme/mixins/_dir.css\";\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\theight: 0;\n\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\tbackground: var(--ck-clipboard-drop-target-color);\n\tmargin-top: -1px;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-style: solid;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tleft: -1px;\n\n\t\t\tborder-width: calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height);\n\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tright: -1px;\n\n\t\t\tborder-width:calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0;\n\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2515: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-panel)}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{border:solid var(--ck-color-base-border);border-width:1px 1px 0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content.ck-sticky-panel__content_sticky{border-bottom-width:1px}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content .ck-menu-bar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content .ck-toolbar{border:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,8DCED,eDeC,CAjBA,mKCMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAcF,CAjBA,8DAOC,wCAAsB,CAAtB,sBAUD,CARC,8FACC,uBACD,CAEA,qJAEC,QACD,CAMH,yCAEC,0CAA2C,CCtB3C,eDgCD,CAZA,yHChBE,qCAAsC,CDqBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-panel);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-sticky-panel__content {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\tborder-bottom-width: 0;\n\n\t\t\t&.ck-sticky-panel__content_sticky {\n\t\t\t\tborder-bottom-width: 1px;\n\t\t\t}\n\n\t\t\t& .ck-menu-bar,\n\t\t\t& .ck-toolbar {\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      121: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}@media (forced-colors:active){.ck .ck-placeholder,.ck.ck-placeholder{forced-color-adjust:preserve-parent-color}}.ck .ck-placeholder:before,.ck.ck-placeholder:before{cursor:text}@media (forced-colors:none){.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text)}}@media (forced-colors:active){.ck .ck-placeholder:before,.ck.ck-placeholder:before{font-style:italic;margin-left:1px}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"],
          names: [],
          mappings: "AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC7BC,8BACC,uCCOA,yCDLA,CACD,CCOA,qDACC,WAmBD,CDvBA,4BACC,qDCMC,6CDJD,CACD,CAZA,8BACC,qDCsBC,iBAAkB,CAMlB,eD1BD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n\tposition: relative;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t@mixin ck-media-forced-colors {\n\t\t/*\n\t\t * This is needed for Edge on Windows to use the right color for the placeholder content (::before).\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t */\n\t\tforced-color-adjust: preserve-parent-color;\n\t}\n\n\t&::before {\n\t\tcursor: text;\n\n\t\t@mixin ck-media-default-colors {\n\t\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t\t}\n\n\t\t@mixin ck-media-forced-colors {\n\t\t\t/*\n\t\t\t * In the high contrast mode there is no telling between regular and placeholder text. Using\n\t\t\t * italic text to address that issue. See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t\t */\n\t\t\tfont-style: italic;\n\n\t\t\t/*\n\t\t\t * Without this margin, the caret will not show up and blink when the user puts the selection\n\t\t\t * in the placeholder (Edge on Windows). See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t\t */\n\t\t\tmargin-left: 1px;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8397: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css"],
          names: [],
          mappings: "AAMA,qDACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1263: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content .text-tiny{font-size:.7em}.ck-content .text-small{font-size:.85em}.ck-content .text-big{font-size:1.4em}.ck-content .text-huge{font-size:1.8em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-font/theme/fontsize.css"],
          names: [],
          mappings: "AAUC,uBACC,cACD,CAEA,wBACC,eACD,CAEA,sBACC,eACD,CAEA,uBACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* The values should be synchronized with the "FONT_SIZE_PRESET_UNITS" object in the "/src/fontsize/utils.js" file. */\n\n/* Styles should be prefixed with the `.ck-content` class.\nSee https://github.com/ckeditor/ckeditor5/issues/6636 */\n.ck-content {\n\t& .text-tiny {\n\t\tfont-size: .7em;\n\t}\n\n\t& .text-small {\n\t\tfont-size: .85em;\n\t}\n\n\t& .text-big {\n\t\tfont-size: 1.4em;\n\t}\n\n\t& .text-huge {\n\t\tfont-size: 1.8em;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7408: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"],
          names: [],
          mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5569: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-editor__editable .ck-horizontal-line{display:flow-root}.ck-content hr{background:#dedede;border:0;height:4px;margin:15px 0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css"],
          names: [],
          mappings: "AAMA,yCAEC,iBACD,CAEA,eAGC,kBAA2B,CAC3B,QAAS,CAFT,UAAW,CADX,aAID",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n\n.ck-editor__editable .ck-horizontal-line {\n\t/* Necessary to render properly next to floated objects, e.g. side image case. */\n\tdisplay: flow-root;\n}\n\n.ck-content hr {\n\tmargin: 15px 0;\n\theight: 4px;\n\tbackground: hsl(0, 0%, 87%);\n\tborder: 0;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2323: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-html-object-embed-unfocused-outline-width:1px}.ck-widget.html-object-embed{background-color:var(--ck-color-base-foreground);font-size:var(--ck-font-size-base);min-width:calc(76px + var(--ck-spacing-standard));padding:var(--ck-spacing-small);padding-top:calc(var(--ck-font-size-tiny) + var(--ck-spacing-large))}.ck-widget.html-object-embed:not(.ck-widget_selected):not(:hover){outline:var(--ck-html-object-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border)}.ck-widget.html-object-embed:before{background:#999;border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius);color:var(--ck-color-base-background);content:attr(data-html-object-embed-label);font-family:var(--ck-font-face);font-size:var(--ck-font-size-tiny);font-style:normal;font-weight:400;left:var(--ck-spacing-standard);padding:calc(var(--ck-spacing-tiny) + var(--ck-html-object-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);position:absolute;top:0;transition:background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck-widget.html-object-embed .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before{margin-left:50px}.ck-widget.html-object-embed .html-object-embed__content{pointer-events:none}div.ck-widget.html-object-embed{margin:1em auto}span.ck-widget.html-object-embed{display:inline-block}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-html-support/theme/datafilter.css"],
          names: [],
          mappings: "AAKA,MACC,kDACD,CAEA,6BAEC,gDAAiD,CADjD,kCAAmC,CAKnC,iDAAkD,CAHlD,+BAAgC,CAEhC,oEAgCD,CA7BC,kEACC,wGACD,CAEA,oCAOC,eAA4B,CAG5B,iEAAkE,CAClE,qCAAsC,CAPtC,0CAA2C,CAS3C,+BAAgC,CADhC,kCAAmC,CAVnC,iBAAkB,CADlB,eAAmB,CAKnB,+BAAgC,CAGhC,yIAA0I,CAN1I,iBAAkB,CAElB,KAAM,CAGN,0GAMD,CAGA,2HACC,gBACD,CAEA,yDAEC,mBACD,CAGD,gCACC,eACD,CAEA,iCACC,oBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-html-object-embed-unfocused-outline-width: 1px;\n}\n\n.ck-widget.html-object-embed {\n\tfont-size: var(--ck-font-size-base);\n\tbackground-color: var(--ck-color-base-foreground);\n\tpadding: var(--ck-spacing-small);\n\t/* Leave space for label */\n\tpadding-top: calc(var(--ck-font-size-tiny) + var(--ck-spacing-large));\n\tmin-width: calc(76px + var(--ck-spacing-standard));\n\n\t&:not(.ck-widget_selected):not(:hover) {\n\t\toutline: var(--ck-html-object-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border);\n\t}\n\n\t&::before {\n\t\tfont-weight: normal;\n\t\tfont-style: normal;\n\t\tposition: absolute;\n\t\tcontent: attr(data-html-object-embed-label);\n\t\ttop: 0;\n\t\tleft: var(--ck-spacing-standard);\n\t\tbackground: hsl(0deg 0% 60%);\n\t\ttransition: background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\t\tpadding: calc(var(--ck-spacing-tiny) + var(--ck-html-object-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);\n\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\tcolor: var(--ck-color-base-background);\n\t\tfont-size: var(--ck-font-size-tiny);\n\t\tfont-family: var(--ck-font-face);\n\t}\n\n\t/* Make space for label. */\n\t& .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before {\n\t\tmargin-left: 50px;\n\t}\n\n\t& .html-object-embed__content {\n\t\t/* Disable user interaction with embed content */\n\t\tpointer-events: none;\n\t}\n}\n\ndiv.ck-widget.html-object-embed {\n\tmargin: 1em auto;\n}\n\nspan.ck-widget.html-object-embed {\n\tdisplay: inline-block;\n}\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1468: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;height:auto;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image{z-index:1}.ck.ck-editor__editable .image.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable .image-inline img{height:auto}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css"],
          names: [],
          mappings: "AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBA2BD,CAjBC,uBAEC,aAAc,CAad,WAAY,CAVZ,aAAc,CAGd,cAAe,CAGf,cAKD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAKA,+BACC,SASD,CAHC,kDACC,SACD,CAMD,sCACC,SAkBD,CAZC,yDACC,SAUD,CAHC,qEACC,YACD,CAMF,0CACC,WACD,CAMC,0FACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%;\n\n\t\t\t/* Keep proportions of the block image if the height is set and the image is wider than the editor width.\n\t\t\tSee https://github.com/ckeditor/ckeditor5/issues/14542. */\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t/* When the picture is present it must act as a flex container to let the img resize properly */\n\t\t& picture {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t/* When the picture is present, it must act like a resizable img. */\n\t\t& picture,\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t/*\n\t * See https://github.com/ckeditor/ckeditor5/issues/15115.\n\t */\n\t& .image {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the selected image always stays on top of its siblings.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t\t */\n\t\t&.ck-widget_selected {\n\t\t\tz-index: 2;\n\t\t}\n\t}\n\n\t/*\n\t * See https://github.com/ckeditor/ckeditor5/issues/15115.\n\t */\n\t& .image-inline {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the selected inline image always stays on top of its siblings.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t\t */\n\t\t&.ck-widget_selected {\n\t\t\tz-index: 2;\n\n\t\t\t/*\n\t\t\t * Make sure the native browser selection style is not displayed.\n\t\t\t * Inline image widgets have their own styles for the selected state and\n\t\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t\t */\n\t\t\t& ::selection {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Keep proportions of the inline image if the height is set and the image is wider than the editor width.\n\tSee https://github.com/ckeditor/ckeditor5/issues/14542. */\n\t& .image-inline img {\n\t\theight: auto;\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5212: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highlighted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}@media (forced-colors:active){.ck-content .image>figcaption{background-color:unset;color:unset}}@media (forced-colors:none){.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}}@media (prefers-reduced-motion:reduce){.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:none}}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highlighted-background)}to{background-color:var(--ck-color-image-caption-background)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAOA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,oDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAYD,CAJC,8BAXD,8BAYE,sBAAuB,CACvB,WAEF,CADC,CCdA,4BACC,qEDmBA,iDCjBA,CACD,CDmBA,uCALD,qEAME,cAEF,CADC,CAGD,sCACC,GACC,qEACD,CAEA,GACC,yDACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highlighted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n\n\t/* Improve placeholder rendering in high-constrast mode (https://github.com/ckeditor/ckeditor5/issues/14907). */\n\t@media (forced-colors: active) {\n\t\tbackground-color: unset;\n\t\tcolor: unset;\n\t}\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\t@mixin ck-media-default-colors {\n\t\tanimation: ck-image-caption-highlight .6s ease-out;\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation: none;\n\t}\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highlighted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3111: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-image-custom-resize-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-image-custom-resize-form .ck-labeled-field-view{display:inline-block}.ck.ck-image-custom-resize-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-image-custom-resize-form{flex-wrap:wrap}.ck.ck-image-custom-resize-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-image-custom-resize-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecustomresizeform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,gCAIC,sBAAuB,CAHvB,YAAa,CACb,kBAAmB,CACnB,gBAsBD,CAnBC,uDACC,oBACD,CAEA,0CACC,YACD,CCbA,oCDCD,gCAeE,cAUF,CARE,uDACC,eACD,CAEA,2CACC,cACD,CCtBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-image-custom-resize-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: flex-start;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      219: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-image-insert-url .ck-image-insert-url__action-row{display:grid;grid-template-columns:repeat(2,1fr)}:root{--ck-image-insert-insert-by-url-width:250px}.ck.ck-image-insert-url{--ck-input-width:100%}.ck.ck-image-insert-url .ck-image-insert-url__action-row{grid-column-gap:var(--ck-spacing-large);margin-top:var(--ck-spacing-large)}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-cancel,.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-save{justify-content:center;min-width:auto}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}.ck.ck-image-insert-form>.ck.ck-button{display:block;padding:var(--ck-list-button-padding);width:100%}[dir=ltr] .ck.ck-image-insert-form>.ck.ck-button{text-align:left}[dir=rtl] .ck.ck-image-insert-form>.ck.ck-button{text-align:right}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:first-child){border-top:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:last-child){border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible,.ck.ck-image-insert-form>.ck.ck-image-insert-url{min-width:var(--ck-image-insert-insert-by-url-width)}.ck.ck-image-insert-form>.ck.ck-image-insert-url{padding:var(--ck-spacing-large)}.ck.ck-image-insert-form:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageinsert.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageinsert.css"],
          names: [],
          mappings: "AAMC,yDACC,YAAa,CACb,mCACD,CCFD,MACC,2CACD,CAEA,wBACC,qBAgBD,CAdC,yDACC,uCAAwC,CACxC,kCAWD,CATC,oJAEC,sBAAuB,CACvB,cACD,CAEA,sFACC,0BACD,CAKD,uCACC,aAAc,CAEd,qCAAsC,CADtC,UAUD,CAZA,iDAME,eAMF,CAZA,iDAUE,gBAEF,CAGC,8DACC,gDACD,CAEA,6DACC,mDACD,CAMD,6FAJC,oDAOD,CAHA,iDAEC,+BACD,CAEA,+BACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-image-insert-url {\n\t& .ck-image-insert-url__action-row {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-image-insert-insert-by-url-width: 250px;\n}\n\n.ck.ck-image-insert-url {\n\t--ck-input-width: 100%;\n\n\t& .ck-image-insert-url__action-row {\n\t\tgrid-column-gap: var(--ck-spacing-large);\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n\n.ck.ck-image-insert-form {\n\t& > .ck.ck-button {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tpadding: var(--ck-list-button-padding);\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& > .ck.ck-collapsible {\n\t\t&:not(:first-child) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t&:not(:last-child) {\n\t\t\tborder-bottom: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\tmin-width: var(--ck-image-insert-insert-by-url-width);\n\t}\n\n\t/* This is the case when there are no other integrations configured than insert by URL */\n\t& > .ck.ck-image-insert-url {\n\t\tmin-width: var(--ck-image-insert-insert-by-url-width);\n\t\tpadding: var(--ck-spacing-large);\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9025: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-editor__editable img.image_placeholder{background-size:100% 100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageplaceholder.css"],
          names: [],
          mappings: "AAMC,8CACC,yBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& img.image_placeholder {\n\t\tbackground-size: 100% 100%;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1240: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content img.image_resized{height:auto}.ck-content .image.image_resized{box-sizing:border-box;display:block;max-width:100%}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}.ck.ck-editor__editable td .image-inline.image_resized img,.ck.ck-editor__editable th .image-inline.image_resized img{max-width:100%}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageresize.css"],
          names: [],
          mappings: "AAMA,8BACC,WACD,CAEA,iCAQC,qBAAsB,CADtB,aAAc,CANd,cAkBD,CATC,qCAEC,UACD,CAEA,4CAEC,aACD,CAQC,sHACC,cACD,CAIF,oFACC,uCACD,CAEA,oFACC,sCACD,CAEA,oEACC,SACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Preserve aspect ratio of the resized image after introducing image height attribute. */\n.ck-content img.image_resized {\n\theight: auto;\n}\n\n.ck-content .image.image_resized {\n\tmax-width: 100%;\n\t/*\n\tThe `<figure>` element for resized images must not use `display:table` as browsers do not support `max-width` for it well.\n\tSee https://stackoverflow.com/questions/4019604/chrome-safari-ignoring-max-width-in-table/14420691#14420691 for more.\n\tFortunately, since we control the width, there is no risk that the image will look bad.\n\t*/\n\tdisplay: block;\n\tbox-sizing: border-box;\n\n\t& img {\n\t\t/* For resized images it is the `<figure>` element that determines the image width. */\n\t\twidth: 100%;\n\t}\n\n\t& > figcaption {\n\t\t/* The `<figure>` element uses `display:block`, so `<figcaption>` also has to. */\n\t\tdisplay: block;\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/* The resized inline image nested in the table should respect its parent size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline.image_resized img {\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n[dir="ltr"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-right: var(--ck-spacing-standard);\n}\n\n[dir="rtl"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-left: var(--ck-spacing-standard);\n}\n\n.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label {\n\twidth: 4em;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3885: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css"],
          names: [],
          mappings: "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4484: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@media (prefers-reduced-motion:reduce){.ck-image-upload-complete-icon{animation-duration:0ms}.ck-image-upload-complete-icon:after{animation:none;height:.45em;opacity:1;width:.3em}}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"],
          names: [],
          mappings: "AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFAqCD,CAjCC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAEA,uCA7CD,+BA8CE,sBASF,CAPE,qCACC,cAAe,CAGf,YAAc,CAFd,SAAU,CACV,UAED,CACD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation-duration: 0ms;\n\n\t\t&::after {\n\t\t\tanimation: none;\n\t\t\topacity: 1;\n\t\t\twidth: 0.3em;\n\t\t\theight: 0.45em;\n\t\t}\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6802: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid #0000;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"],
          names: [],
          mappings: "AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,4BAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n\t--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n\n\t&.image-inline {\n\t\twidth: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n\t}\n\n\t& img {\n\t\t/*\n\t\t * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n\t\t * There's nothing special about this number except that it should make the image placeholder look like\n\t\t * a real image during this short period after the upload started and before the image was read from the\n\t\t * file system (and a rich preview was loaded).\n\t\t */\n\t\taspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n\t}\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8034: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}@media (prefers-reduced-motion:reduce){.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:none;opacity:1}}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"],
          names: [],
          mappings: "AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBAMD,CAJC,uCAHD,yFAKE,cAAe,CADf,SAGF,CADC,CAKF,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\topacity: 1;\n\t\t\t\tanimation: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3644: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      278: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid #ffffff80}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css"],
          names: [],
          mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,2BACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1893: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"],
          names: [],
          mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9392: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-link-form{align-items:flex-start;display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"],
          names: [],
          mappings: "AAOA,iBAEC,sBAAuB,CADvB,YAkBD,CAfC,2BACC,YACD,CCPA,oCDCD,iBASE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CChBD,CDwBD,iCACC,aAYD,CALE,wHAEC,mCACD,CEhCF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& > .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6355: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{display:block;position:absolute}:root{--ck-link-image-indicator-icon-size:20;--ck-link-image-indicator-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{background-color:#0006;background-image:url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");background-position:50%;background-repeat:no-repeat;background-size:14px;border-radius:100%;content:"";height:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size));overflow:hidden;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);width:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size))}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkimage.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkimage.css"],
          names: [],
          mappings: "AASE,+FACC,aAAc,CACd,iBACD,CCPF,MAEC,sCAAuC,CACvC,oEACD,CAME,+FAUC,sBAAqC,CACrC,83BAA+3B,CAG/3B,uBAA2B,CAD3B,2BAA4B,CAD5B,oBAAqB,CAGrB,kBAAmB,CAdnB,UAAW,CAsBX,oGAAuG,CAFvG,eAAgB,CAbhB,sCAAwC,CADxC,oCAAsC,CAetC,mGAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Match the icon size with the upload indicator brought by the image upload feature. */\n\t--ck-link-image-indicator-icon-size: 20;\n\t--ck-link-image-indicator-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tcontent: "";\n\n\t\t\t/*\n\t\t\t * Smaller images should have the icon closer to the border.\n\t\t\t * Match the icon position with the upload indicator brought by the image upload feature.\n\t\t\t */\n\t\t\ttop: min(var(--ck-spacing-medium), 6%);\n\t\t\tright: min(var(--ck-spacing-medium), 6%);\n\n\t\t\tbackground-color: hsla(0, 0%, 0%, .4);\n\t\t\tbackground-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");\n\t\t\tbackground-size: 14px;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tborder-radius: 100%;\n\n\t\t\t/*\n\t\t\t* Use CSS math to simulate container queries.\n\t\t\t* https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t\t\t*/\n\t\t\toverflow: hidden;\n\t\t\twidth: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t\theight: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t}\n\t}\n}\n\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9309: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-editor__editable .ck-list-bogus-paragraph{display:block}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/documentlist.css"],
          names: [],
          mappings: "AAKA,8CACC,aACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-editor__editable .ck-list-bogus-paragraph {\n\tdisplay: block;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6498: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content ol{list-style-type:decimal}.ck-content ol ol{list-style-type:lower-latin}.ck-content ol ol ol{list-style-type:lower-roman}.ck-content ol ol ol ol{list-style-type:upper-latin}.ck-content ol ol ol ol ol{list-style-type:upper-roman}.ck-content ul{list-style-type:disc}.ck-content ul ul{list-style-type:circle}.ck-content ul ul ul,.ck-content ul ul ul ul{list-style-type:square}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/list.css"],
          names: [],
          mappings: "AAKA,eACC,uBAiBD,CAfC,kBACC,2BAaD,CAXC,qBACC,2BASD,CAPC,wBACC,2BAKD,CAHC,2BACC,2BACD,CAMJ,eACC,oBAaD,CAXC,kBACC,sBASD,CAJE,6CACC,sBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content ol {\n\tlist-style-type: decimal;\n\n\t& ol {\n\t\tlist-style-type: lower-latin;\n\n\t\t& ol {\n\t\t\tlist-style-type: lower-roman;\n\n\t\t\t& ol {\n\t\t\t\tlist-style-type: upper-latin;\n\n\t\t\t\t& ol {\n\t\t\t\t\tlist-style-type: upper-roman;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-content ul {\n\tlist-style-type: disc;\n\n\t& ul {\n\t\tlist-style-type: circle;\n\n\t\t& ul {\n\t\t\tlist-style-type: square;\n\n\t\t\t& ul {\n\t\t\t\tlist-style-type: square;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      661: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-list-properties.ck-list-properties_without-styles{padding:var(--ck-spacing-large)}.ck.ck-list-properties.ck-list-properties_without-styles>*{min-width:14em}.ck.ck-list-properties.ck-list-properties_without-styles>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-list-styles-list{grid-template-columns:repeat(4,auto)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible{border-top:1px solid var(--ck-color-base-border)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*{width:100%}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties .ck.ck-numbered-list-properties__start-index .ck-input{min-width:auto;width:100%}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order{background:#0000;margin-bottom:calc(var(--ck-spacing-tiny)*-1);padding-left:0;padding-right:0}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:active,.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:hover{background:none;border-color:#0000;box-shadow:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-list/listproperties.css"],
          names: [],
          mappings: "AAOC,yDACC,+BASD,CAPC,2DACC,cAKD,CAHC,6DACC,qCACD,CASD,wFACC,oCACD,CAGA,mFACC,gDAWD,CARE,+GACC,UAKD,CAHC,iHACC,qCACD,CAMJ,8EACC,cAAe,CACf,UACD,CAEA,uEACC,gBAAuB,CAGvB,6CAAgD,CAFhD,cAAe,CACf,eAQD,CALC,2JAGC,eAAgB,CADhB,kBAAyB,CADzB,eAGD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-properties {\n\t/* When there are no list styles and there is no collapsible. */\n\t&.ck-list-properties_without-styles {\n\t\tpadding: var(--ck-spacing-large);\n\n\t\t& > * {\n\t\t\tmin-width: 14em;\n\n\t\t\t& + * {\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * When the numbered list property fields (start at, reversed) should be displayed,\n\t * more horizontal space is needed. Reconfigure the style grid to create that space.\n\t */\n\t&.ck-list-properties_with-numbered-properties {\n\t\t& > .ck-list-styles-list {\n\t\t\tgrid-template-columns: repeat( 4, auto );\n\t\t}\n\n\t\t/* When list styles are rendered and property fields are in a collapsible. */\n\t\t& > .ck-collapsible {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t& > .ck-collapsible__children {\n\t\t\t\t& > * {\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t& + * {\n\t\t\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-numbered-list-properties__start-index .ck-input {\n\t\tmin-width: auto;\n\t\twidth: 100%;\n\t}\n\n\t& .ck.ck-numbered-list-properties__reversed-order {\n\t\tbackground: transparent;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-bottom: calc(-1 * var(--ck-spacing-tiny));\n\n\t\t&:active, &:hover {\n\t\t\tbox-shadow: none;\n\t\t\tborder-color: transparent;\n\t\t\tbackground: none;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9080: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-list-styles-list{display:grid}:root{--ck-list-style-button-size:44px}.ck.ck-list-styles-list{column-gap:var(--ck-spacing-medium);grid-template-columns:repeat(3,auto);padding:var(--ck-spacing-large);row-gap:var(--ck-spacing-medium)}.ck.ck-list-styles-list .ck-button{box-sizing:initial;margin:0;padding:0}.ck.ck-list-styles-list .ck-button,.ck.ck-list-styles-list .ck-button .ck-icon{height:var(--ck-list-style-button-size);width:var(--ck-list-style-button-size)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/liststyles.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-list/liststyles.css"],
          names: [],
          mappings: "AAKA,wBACC,YACD,CCFA,MACC,gCACD,CAEA,wBAGC,mCAAoC,CAFpC,oCAAwC,CAGxC,+BAAgC,CAFhC,gCA4BD,CAxBC,mCAiBC,kBAAuB,CAPvB,QAAS,CANT,SAmBD,CAJC,+EAhBA,uCAAwC,CADxC,sCAoBA",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-styles-list {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-list-style-button-size: 44px;\n}\n\n.ck.ck-list-styles-list {\n\tgrid-template-columns: repeat( 3, auto );\n\trow-gap: var(--ck-spacing-medium);\n\tcolumn-gap: var(--ck-spacing-medium);\n\tpadding: var(--ck-spacing-large);\n\n\t& .ck-button {\n\t\t/* Make the button look like a thumbnail (the icon "takes it all"). */\n\t\twidth: var(--ck-list-style-button-size);\n\t\theight: var(--ck-list-style-button-size);\n\t\tpadding: 0;\n\n\t\t/*\n\t\t * Buttons are aligned by the grid so disable default button margins to not collide with the\n\t\t * gaps in the grid.\n\t\t */\n\t\tmargin: 0;\n\n\t\t/*\n\t\t * Make sure the button border (which is displayed on focus, BTW) does not steal pixels\n\t\t * from the button dimensions and, as a result, decrease the size of the icon\n\t\t * (which becomes blurry as it scales down).\n\t\t */\n\t\tbox-sizing: content-box;\n\n\t\t& .ck-icon {\n\t\t\twidth: var(--ck-list-style-button-size);\n\t\t\theight: var(--ck-list-style-button-size);\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9042: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ':root{--ck-todo-list-checkmark-size:16px}.ck-content .todo-list{list-style:none}.ck-content .todo-list li{margin-bottom:5px;position:relative}.ck-content .todo-list li .todo-list{margin-top:5px}.ck-content .todo-list .todo-list__label>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-content[dir=rtl] .todo-list .todo-list__label>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-content .todo-list .todo-list__label>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}@media (prefers-reduced-motion:reduce){.ck-content .todo-list .todo-list__label>input:before{transition:none}}.ck-content .todo-list .todo-list__label>input:after{border-color:#0000;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:initial;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-content .todo-list .todo-list__label>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-content .todo-list .todo-list__label>input[checked]:after{border-color:#fff}.ck-content .todo-list .todo-list__label .todo-list__label__description{vertical-align:middle}.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}.ck-editor__editable.ck-content .todo-list .todo-list__label>input,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{cursor:pointer}.ck-editor__editable.ck-content .todo-list .todo-list__label>input:hover:before,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:hover:before{box-shadow:0 0 0 5px #0000001a}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-editor__editable.ck-content[dir=rtl] .todo-list .todo-list__label>span[contenteditable=false]>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}@media (prefers-reduced-motion:reduce){.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{transition:none}}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:after{border-color:#0000;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:initial;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:after{border-color:#fff}.ck-editor__editable.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/todolist.css"],
          names: [],
          mappings: "AAKA,MACC,kCACD,CA4EA,uBACC,eAwBD,CAtBC,0BAEC,iBAAkB,CADlB,iBAMD,CAHC,qCACC,cACD,CAIA,+CAtFD,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAqFC,CAFA,wDApEA,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAoEA,CAhED,sDAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UASD,CAHC,uCAXD,sDAYE,eAEF,CADC,CAGD,qDAaC,kBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,kBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+DACC,kBAA8B,CAC9B,oBACD,CAEA,8DACC,iBACD,CAwBA,wEACC,qBACD,CAEA,mGACC,iBACD,CAYD,kKAEC,cAKD,CAHC,4LACC,8BACD,CAMD,+FAxHA,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAuHA,CAFA,wGAtGC,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAsGD,CAlGA,sGAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UASD,CAHC,uCAXD,sGAYE,eAEF,CADC,CAGD,qGAaC,kBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,kBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+GACC,kBAA8B,CAC9B,oBACD,CAEA,8GACC,iBACD,CA2DA,uHACC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-todo-list-checkmark-size: 16px;\n}\n\n@define-mixin todo-list-checkbox {\n\t-webkit-appearance: none;\n\tdisplay: inline-block;\n\tposition: relative;\n\twidth: var(--ck-todo-list-checkmark-size);\n\theight: var(--ck-todo-list-checkmark-size);\n\tvertical-align: middle;\n\n\t/* Needed on iOS */\n\tborder: 0;\n\n\t/* LTR styles */\n\tleft: -25px;\n\tmargin-right: -15px;\n\tright: 0;\n\tmargin-left: 0;\n\n\t/* RTL styles */\n\t@nest [dir=rtl]& {\n\t\tleft: 0;\n\t\tmargin-right: 0;\n\t\tright: -25px;\n\t\tmargin-left: -15px;\n\t}\n\n\t&::before {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: border-box;\n\t\tcontent: '';\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px solid hsl(0, 0%, 20%);\n\t\tborder-radius: 2px;\n\t\ttransition: 250ms ease-in-out box-shadow;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\t}\n\n\t&::after {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: content-box;\n\t\tpointer-events: none;\n\t\tcontent: '';\n\n\t\t/* Calculate tick position, size and border-width proportional to the checkmark size. */\n\t\tleft: calc( var(--ck-todo-list-checkmark-size) / 3 );\n\t\ttop: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\twidth: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\theight: calc( var(--ck-todo-list-checkmark-size) / 2.6 );\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t\tborder-width: 0 calc( var(--ck-todo-list-checkmark-size) / 8 ) calc( var(--ck-todo-list-checkmark-size) / 8 ) 0;\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&[checked] {\n\t\t&::before {\n\t\t\tbackground: hsl(126, 64%, 41%);\n\t\t\tborder-color: hsl(126, 64%, 41%);\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: hsl(0, 0%, 100%);\n\t\t}\n\t}\n}\n\n/*\n * To-do list content styles.\n */\n.ck-content .todo-list {\n\tlist-style: none;\n\n\t& li {\n\t\tposition: relative;\n\t\tmargin-bottom: 5px;\n\n\t\t& .todo-list {\n\t\t\tmargin-top: 5px;\n\t\t}\n\t}\n\n\t& .todo-list__label {\n\t\t& > input {\n\t\t\t@mixin todo-list-checkbox;\n\t\t}\n\n\t\t& .todo-list__label__description {\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t&.todo-list__label_without-description input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n/*\n * To-do list editing view styles.\n */\n.ck-editor__editable.ck-content .todo-list .todo-list__label {\n\t/*\n\t * To-do list should be interactive only during the editing\n\t * (https://github.com/ckeditor/ckeditor5/issues/2090).\n\t */\n\t& > input,\n\t& > span[contenteditable=false] > input {\n\t\tcursor: pointer;\n\n\t\t&:hover::before {\n\t\t\tbox-shadow: 0 0 0 5px hsla(0, 0%, 0%, 0.1);\n\t\t}\n\t}\n\n\t/*\n\t * Document Lists - editing view has an additional span around checkbox.\n\t */\n\t& > span[contenteditable=false] > input {\n\t\t@mixin todo-list-checkbox;\n\t}\n\n\t&.todo-list__label_without-description {\n\t\t& input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7693: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css"],
          names: [],
          mappings: "AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4861: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgNDAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"],
          names: [],
          mappings: "AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,wvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,wiCACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAuMzc4IiBoZWlnaHQ9IjI1NC4xNjciIHZpZXdCb3g9IjAgMCA2Ni4yNDYgNjcuMjQ4Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcyLjUzMSAtMjE4LjQ1NSkgc2NhbGUoLjk4MDEyKSI+PHJlY3Qgcnk9IjUuMjM4IiByeD0iNS4yMzgiIHk9IjIzMS4zOTkiIHg9IjE3Ni4wMzEiIGhlaWdodD0iNjAuMDk5IiB3aWR0aD0iNjAuMDk5IiBmaWxsPSIjMzRhNjY4IiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjxwYXRoIGQ9Ik0yMDYuNDc3IDI2MC45bC0yOC45ODcgMjguOTg3YTUuMjE4IDUuMjE4IDAgMCAwIDMuNzggMS42MWg0OS42MjFjMS42OTQgMCAzLjE5LS43OTggNC4xNDYtMi4wMzd6IiBmaWxsPSIjNWM4OGM1Ii8+PHBhdGggZD0iTTIyNi43NDIgMjIyLjk4OGMtOS4yNjYgMC0xNi43NzcgNy4xNy0xNi43NzcgMTYuMDE0LjAwNyAyLjc2Mi42NjMgNS40NzQgMi4wOTMgNy44NzUuNDMuNzAzLjgzIDEuNDA4IDEuMTkgMi4xMDcuMzMzLjUwMi42NSAxLjAwNS45NSAxLjUwOC4zNDMuNDc3LjY3My45NTcuOTg4IDEuNDQgMS4zMSAxLjc2OSAyLjUgMy41MDIgMy42MzcgNS4xNjguNzkzIDEuMjc1IDEuNjgzIDIuNjQgMi40NjYgMy45OSAyLjM2MyA0LjA5NCA0LjAwNyA4LjA5MiA0LjYgMTMuOTE0di4wMTJjLjE4Mi40MTIuNTE2LjY2Ni44NzkuNjY3LjQwMy0uMDAxLjc2OC0uMzE0LjkzLS43OTkuNjAzLTUuNzU2IDIuMjM4LTkuNzI5IDQuNTg1LTEzLjc5NC43ODItMS4zNSAxLjY3My0yLjcxNSAyLjQ2NS0zLjk5IDEuMTM3LTEuNjY2IDIuMzI4LTMuNCAzLjYzOC01LjE2OS4zMTUtLjQ4Mi42NDUtLjk2Mi45ODgtMS40MzkuMy0uNTAzLjYxNy0xLjAwNi45NS0xLjUwOC4zNTktLjcuNzYtMS40MDQgMS4xOS0yLjEwNyAxLjQyNi0yLjQwMiAyLTUuMTE0IDIuMDA0LTcuODc1IDAtOC44NDQtNy41MTEtMTYuMDE0LTE2Ljc3Ni0xNi4wMTR6IiBmaWxsPSIjZGQ0YjNlIiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjxlbGxpcHNlIHJ5PSI1LjU2NCIgcng9IjUuODI4IiBjeT0iMjM5LjAwMiIgY3g9IjIyNi43NDIiIGZpbGw9IiM4MDJkMjciIHBhaW50LW9yZGVyPSJtYXJrZXJzIHN0cm9rZSBmaWxsIi8+PHBhdGggZD0iTTE5MC4zMDEgMjM3LjI4M2MtNC42NyAwLTguNDU3IDMuODUzLTguNDU3IDguNjA2czMuNzg2IDguNjA3IDguNDU3IDguNjA3YzMuMDQzIDAgNC44MDYtLjk1OCA2LjMzNy0yLjUxNiAxLjUzLTEuNTU3IDIuMDg3LTMuOTEzIDIuMDg3LTYuMjkgMC0uMzYyLS4wMjMtLjcyMi0uMDY0LTEuMDc5aC04LjI1N3YzLjA0M2g0Ljg1Yy0uMTk3Ljc1OS0uNTMxIDEuNDUtMS4wNTggMS45ODYtLjk0Mi45NTgtMi4wMjggMS41NDgtMy45MDEgMS41NDgtMi44NzYgMC01LjIwOC0yLjM3Mi01LjIwOC01LjI5OSAwLTIuOTI2IDIuMzMyLTUuMjk5IDUuMjA4LTUuMjk5IDEuMzk5IDAgMi42MTguNDA3IDMuNTg0IDEuMjkzbDIuMzgxLTIuMzhjMC0uMDAyLS4wMDMtLjAwNC0uMDA0LS4wMDUtMS41ODgtMS41MjQtMy42Mi0yLjIxNS01Ljk1NS0yLjIxNXptNC40MyA1LjY2bC4wMDMuMDA2di0uMDAzeiIgZmlsbD0iI2ZmZiIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48cGF0aCBkPSJNMjE1LjE4NCAyNTEuOTI5bC03Ljk4IDcuOTc5IDI4LjQ3NyAyOC40NzVjLjI4Ny0uNjQ5LjQ0OS0xLjM2Ni40NDktMi4xMjN2LTMxLjE2NWMtLjQ2OS42NzUtLjkzNCAxLjM0OS0xLjM4MiAyLjAwNS0uNzkyIDEuMjc1LTEuNjgyIDIuNjQtMi40NjUgMy45OS0yLjM0NyA0LjA2NS0zLjk4MiA4LjAzOC00LjU4NSAxMy43OTQtLjE2Mi40ODUtLjUyNy43OTgtLjkzLjc5OS0uMzYzLS4wMDEtLjY5Ny0uMjU1LS44NzktLjY2N3YtLjAxMmMtLjU5My01LjgyMi0yLjIzNy05LjgyLTQuNi0xMy45MTQtLjc4My0xLjM1LTEuNjczLTIuNzE1LTIuNDY2LTMuOTktMS4xMzctMS42NjYtMi4zMjctMy40LTMuNjM3LTUuMTY5bC0uMDAyLS4wMDN6IiBmaWxsPSIjYzNjM2MzIi8+PHBhdGggZD0iTTIxMi45ODMgMjQ4LjQ5NWwtMzYuOTUyIDM2Ljk1M3YuODEyYTUuMjI3IDUuMjI3IDAgMCAwIDUuMjM4IDUuMjM4aDEuMDE1bDM1LjY2Ni0zNS42NjZhMTM2LjI3NSAxMzYuMjc1IDAgMCAwLTIuNzY0LTMuOSAzNy41NzUgMzcuNTc1IDAgMCAwLS45ODktMS40NGMtLjI5OS0uNTAzLS42MTYtMS4wMDYtLjk1LTEuNTA4LS4wODMtLjE2Mi0uMTc2LS4zMjYtLjI2NC0uNDg5eiIgZmlsbD0iI2ZkZGM0ZiIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48cGF0aCBkPSJNMjExLjk5OCAyNjEuMDgzbC02LjE1MiA2LjE1MSAyNC4yNjQgMjQuMjY0aC43ODFhNS4yMjcgNS4yMjcgMCAwIDAgNS4yMzktNS4yMzh2LTEuMDQ1eiIgZmlsbD0iI2ZmZiIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48L2c+PC9zdmc+);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      986: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3989: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck-source-editing-area{overflow:hidden;position:relative}.ck-source-editing-area textarea,.ck-source-editing-area:after{border:1px solid #0000;font-family:monospace;font-size:var(--ck-font-size-normal);line-height:var(--ck-line-height-base);margin:0;padding:var(--ck-spacing-large);white-space:pre-wrap}.ck-source-editing-area:after{content:attr(data-value) " ";display:block;visibility:hidden}.ck-source-editing-area textarea{border-color:var(--ck-color-base-border);border-radius:0;box-sizing:border-box;height:100%;outline:none;overflow:hidden;position:absolute;resize:none;width:100%}.ck-rounded-corners .ck-source-editing-area textarea,.ck-source-editing-area textarea.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck-source-editing-area textarea:not([readonly]):focus{border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-source-editing/theme/sourceediting.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AASA,wBAEC,eAAgB,CADhB,iBAED,CAEA,+DAIC,sBAA6B,CAG7B,qBAAsB,CADtB,oCAAqC,CADrC,sCAAuC,CAFvC,QAAS,CADT,+BAAgC,CAMhC,oBACD,CAEA,8BACC,4BAA6B,CAE7B,aAAc,CADd,iBAED,CAEA,iCASC,wCAAyC,CC7BzC,eAAgB,CD2BhB,qBAAsB,CAJtB,WAAY,CAEZ,YAAa,CACb,eAAgB,CALhB,iBAAkB,CAGlB,WAAY,CAFZ,UAkBD,CApBA,yGChBE,qCAAsC,CD4BtC,wBAAyB,CACzB,yBAOF,CAJC,uDEpCA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFwCA",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck-source-editing-area {\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.ck-source-editing-area::after,\n.ck-source-editing-area textarea {\n\tpadding: var(--ck-spacing-large);\n\tmargin: 0;\n\tborder: 1px solid transparent;\n\tline-height: var(--ck-line-height-base);\n\tfont-size: var(--ck-font-size-normal);\n\tfont-family: monospace;\n\twhite-space: pre-wrap;\n}\n\n.ck-source-editing-area::after {\n\tcontent: attr(data-value) " ";\n\tvisibility: hidden;\n\tdisplay: block;\n}\n\n.ck-source-editing-area textarea {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tresize: none;\n\toutline: none;\n\toverflow: hidden;\n\tbox-sizing: border-box;\n\n\tborder-color: var(--ck-color-base-border);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not([readonly]):focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      173: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-input-color{display:flex;flex-direction:row-reverse;width:100%}.ck.ck-input-color>input.ck.ck-input-text{flex-grow:1;min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown{min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown>.ck-input-color__button .ck-dropdown__arrow{display:none}.ck.ck-input-color .ck.ck-input-color__button{display:flex}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview{overflow:hidden;position:relative}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{display:block;position:absolute}[dir=ltr] .ck.ck-input-color>.ck.ck-input-text{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-input-text{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-input-color>.ck.ck-input-text:focus{z-index:0}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{padding:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-left-radius:0;border-top-left-radius:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-left:1px solid #0000}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-right:1px solid #0000}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button.ck-disabled{background:var(--ck-color-input-disabled-background)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border-radius:0}.ck-rounded-corners .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview,.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border:1px solid var(--ck-color-input-border);height:20px;width:20px}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{background:red;border-radius:2px;height:150%;left:50%;top:-30%;transform:rotate(45deg);transform-origin:50%;width:8%}.ck.ck-input-color .ck.ck-input-color__remove-color{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);width:100%}.ck.ck-input-color .ck.ck-input-color__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-input-border)}[dir=ltr] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-right-radius:0}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-left-radius:0}.ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard);margin-right:0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/colorinput.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/colorinput.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,mBAEC,YAAa,CACb,0BAA2B,CAF3B,UAgCD,CA5BC,0CAEC,WAAY,CADZ,cAED,CAEA,sCACC,cAMD,CAHC,kFACC,YACD,CAGD,8CAEC,YAWD,CATC,kFAEC,eAAgB,CADhB,iBAOD,CAJC,0IAEC,aAAc,CADd,iBAED,CC1BF,+CAGE,4BAA6B,CAD7B,yBAcF,CAhBA,+CAQE,2BAA4B,CAD5B,wBASF,CAHC,2CACC,SACD,CAIA,wEACC,SA0CD,CA3CA,kFAKE,2BAA4B,CAD5B,wBAuCF,CApCE,8FACC,2BACD,CATF,kFAcE,4BAA6B,CAD7B,yBA8BF,CA3BE,8FACC,4BACD,CAGD,oFACC,oDACD,CAEA,4GC1CF,eD2DE,CAjBA,+PCtCD,qCDuDC,CAjBA,4GAKC,6CAA8C,CAD9C,WAAY,CADZ,UAcD,CAVC,oKAKC,cAA6B,CAC7B,iBAAkB,CAHlB,WAAY,CADZ,QAAS,CADT,QAAS,CAMT,uBAAwB,CACxB,oBAAqB,CAJrB,QAKD,CAKH,oDAIC,2BAA4B,CAC5B,4BAA6B,CAH7B,qEAAwE,CADxE,UA0BD,CApBC,gEACC,oDACD,CATD,8DAYE,yBAeF,CA3BA,8DAgBE,wBAWF,CARC,gEACC,uCAMD,CAPA,0EAKE,sCAAuC,CADvC,cAGF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-input-color {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\n\t& > input.ck.ck-input-text {\n\t\tmin-width: auto;\n\t\tflex-grow: 1;\n\t}\n\n\t& > div.ck.ck-dropdown {\n\t\tmin-width: auto;\n\n\t\t/* This dropdown has no arrow but a color preview instead. */\n\t\t& > .ck-input-color__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__button {\n\t\t/* Resolving issue with misaligned buttons on Safari (see #10589) */\n\t\tdisplay: flex;\n\n\t\t& .ck.ck-input-color__button__preview {\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\n\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\tposition: absolute;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_rounded.css";\n\n.ck.ck-input-color {\n\t& > .ck.ck-input-text {\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* Make sure the focused input is always on top of the dropdown button so its\n\t\t   outline and border are never cropped (also when the input is read-only). */\n\t\t&:focus {\n\t\t\tz-index: 0;\n\t\t}\n\t}\n\n\t& > .ck.ck-dropdown {\n\t\t& > .ck.ck-button.ck-input-color__button {\n\t\t\tpadding: 0;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-left: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-right: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.ck-disabled {\n\t\t\t\tbackground: var(--ck-color-input-disabled-background);\n\t\t\t}\n\n\t\t\t& > .ck.ck-input-color__button__preview {\n\t\t\t\t@mixin ck-rounded-corners;\n\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder: 1px solid var(--ck-color-input-border);\n\n\t\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\t\ttop: -30%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\theight: 150%;\n\t\t\t\t\twidth: 8%;\n\t\t\t\t\tbackground: hsl(0, 100%, 50%);\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\ttransform-origin: 50%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__remove-color {\n\t\twidth: 100%;\n\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-bottom: 1px solid var(--ck-color-input-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t}\n\n\t\t& .ck.ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1928: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-form{padding:0 0 var(--ck-spacing-large)}.ck.ck-form:focus{outline:none}.ck.ck-form .ck.ck-input-text{min-width:100%;width:0}.ck.ck-form .ck.ck-dropdown{min-width:100%}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button:not(:focus){border:1px solid var(--ck-color-base-border)}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button .ck-button__label{width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/form.css"],
          names: [],
          mappings: "AAKA,YACC,mCAyBD,CAvBC,kBAEC,YACD,CAEA,8BACC,cAAe,CACf,OACD,CAEA,4BACC,cAWD,CARE,6DACC,4CACD,CAEA,mEACC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form {\n\tpadding: 0 0 var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t& .ck.ck-input-text {\n\t\tmin-width: 100%;\n\t\twidth: 0;\n\t}\n\n\t& .ck.ck-dropdown {\n\t\tmin-width: 100%;\n\n\t\t& .ck-dropdown__button {\n\t\t\t&:not(:focus) {\n\t\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck-button__label {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1834: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-table-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-table-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row{padding:var(--ck-spacing-standard) var(--ck-spacing-large) 0}[dir=ltr] .ck.ck-form__row>:not(.ck-label)+*{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-form__row>:not(.ck-label)+*{margin-right:var(--ck-spacing-large)}.ck.ck-form__row>.ck-label{min-width:100%;width:100%}.ck.ck-form__row.ck-table-form__action-row{margin-top:var(--ck-spacing-large)}.ck.ck-form__row.ck-table-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/formrow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/formrow.css"],
          names: [],
          mappings: "AAKA,iBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAaD,CAVC,iCACC,WACD,CAGC,wHAEC,sBACD,CCbF,iBACC,4DA2BD,CAvBE,6CAEE,mCAMF,CARA,6CAME,oCAEF,CAGD,2BAEC,cAAe,CADf,UAED,CAEA,2CACC,kCAKD,CAHC,wEACC,0BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\tflex-grow: 1;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-form__row {\n\tpadding: var(--ck-spacing-standard) var(--ck-spacing-large) 0;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\t& + * {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-label {\n\t\twidth: 100%;\n\t\tmin-width: 100%;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3437: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label,.ck[dir=rtl] .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;margin:var(--ck-insert-table-dropdown-box-margin);min-height:var(--ck-insert-table-dropdown-box-height);min-width:var(--ck-insert-table-dropdown-box-width);outline:none;transition:none}@media (prefers-reduced-motion:reduce){.ck .ck-insert-table-dropdown-grid-box{transition:none}}.ck .ck-insert-table-dropdown-grid-box:focus{box-shadow:none}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"],
          names: [],
          mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,mFAEC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAFlB,iDAAkD,CADlD,qDAAsD,CADtD,mDAAoD,CAKpD,YAAa,CACb,eAcD,CAZC,uCATD,uCAUE,eAWF,CAVC,CAEA,6CACC,eACD,CAEA,6CAEC,6CAA8C,CAD9C,yCAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label,\n.ck[dir=rtl] .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\tmin-width: var(--ck-insert-table-dropdown-box-width);\n\tmin-height: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\toutline: none;\n\ttransition: none;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2524: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:#0000000d;font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/table.css"],
          names: [],
          mappings: "AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,oBAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4412: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-color-selector-caption-background:#f7f7f7;--ck-color-selector-caption-text:#333;--ck-color-selector-caption-highlighted-background:#fd0}.ck-content .table>figcaption{background-color:var(--ck-color-selector-caption-background);caption-side:top;color:var(--ck-color-selector-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;text-align:center;word-break:break-word}@media (forced-colors:active){.ck-content .table>figcaption{background-color:unset;color:unset}}@media (forced-colors:none){.ck.ck-editor__editable .table>figcaption.table__caption_highlighted{animation:ck-table-caption-highlight .6s ease-out}}.ck.ck-editor__editable .table>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}@keyframes ck-table-caption-highlight{0%{background-color:var(--ck-color-selector-caption-highlighted-background)}to{background-color:var(--ck-color-selector-caption-background)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecaption.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAOA,MACC,8CAAuD,CACvD,qCAAiD,CACjD,uDACD,CAGA,8BAMC,4DAA6D,CAJ7D,gBAAiB,CAGjB,2CAA4C,CAJ5C,qBAAsB,CAOtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,iBAAkB,CADlB,qBAaD,CCxBC,8BACC,8BDoBA,sBAAuB,CACvB,WCnBA,CACD,CAIA,4BDqBC,qEACC,iDACD,CCnBD,CDsBA,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAGD,sCACC,GACC,wEACD,CAEA,GACC,4DACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-selector-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-selector-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-selector-caption-highlighted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .table > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: top;\n\tword-break: break-word;\n\ttext-align: center;\n\tcolor: var(--ck-color-selector-caption-text);\n\tbackground-color: var(--ck-color-selector-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n\n\t/* Improve placeholder rendering in high-constrast mode (https://github.com/ckeditor/ckeditor5/issues/14907). */\n\t@mixin ck-media-forced-colors {\n\t\tbackground-color: unset;\n\t\tcolor: unset;\n\t}\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .table > figcaption {\n\t@mixin ck-media-default-colors {\n\t\t&.table__caption_highlighted {\n\t\t\tanimation: ck-table-caption-highlight .6s ease-out;\n\t\t}\n\t}\n\n\t&.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the table caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n}\n\n@keyframes ck-table-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-selector-caption-highlighted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-selector-caption-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9311: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row{flex-wrap:wrap}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:first-of-type{flex-grow:0.57}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:last-of-type{flex-grow:0.43}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar .ck-button{flex-grow:1}.ck.ck-table-cell-properties-form{width:320px}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__padding-row{align-self:flex-end;padding:0;width:25%}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecellproperties.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tablecellproperties.css"],
          names: [],
          mappings: "AAOE,6FACC,cAiBD,CAdE,0HAEC,cACD,CAEA,yHAEC,cACD,CAEA,uHACC,WACD,CClBJ,kCACC,WAkBD,CAfE,2FACC,mBAAoB,CACpB,SAAU,CACV,SACD,CAGC,4GACC,eAAgB,CAGhB,qCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\t&:first-of-type {\n\t\t\t\t\t/* 4 buttons out of 7 (h-alignment + v-alignment) = 0.57 */\n\t\t\t\t\tflex-grow: 0.57;\n\t\t\t\t}\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\t/* 3 buttons out of 7 (h-alignment + v-alignment) = 0.43 */\n\t\t\t\t\tflex-grow: 0.43;\n\t\t\t\t}\n\n\t\t\t\t& .ck-button {\n\t\t\t\t\tflex-grow: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__padding-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\t\t\twidth: 25%;\n\t\t}\n\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7642: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-color-selector-column-resizer-hover:var(--ck-color-base-active);--ck-table-column-resizer-width:7px;--ck-table-column-resizer-position-offset:calc(var(--ck-table-column-resizer-width)*-0.5 - 0.5px)}.ck-content .table .ck-table-resized{table-layout:fixed}.ck-content .table table{overflow:hidden}.ck-content .table td,.ck-content .table th{overflow-wrap:break-word;position:relative}.ck.ck-editor__editable .table .ck-table-column-resizer{bottom:0;cursor:col-resize;position:absolute;right:var(--ck-table-column-resizer-position-offset);top:0;user-select:none;width:var(--ck-table-column-resizer-width);z-index:var(--ck-z-default)}.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer,.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer{display:none}.ck.ck-editor__editable .table .ck-table-column-resizer:hover,.ck.ck-editor__editable .table .ck-table-column-resizer__active{background-color:var(--ck-color-selector-column-resizer-hover);bottom:-999999px;opacity:.25;top:-999999px}.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer{left:var(--ck-table-column-resizer-position-offset);right:unset}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecolumnresize.css"],
          names: [],
          mappings: "AAKA,MACC,oEAAqE,CACrE,mCAAoC,CAIpC,iGACD,CAEA,qCACC,kBACD,CAEA,yBACC,eACD,CAEA,4CAIC,wBAAyB,CACzB,iBACD,CAEA,wDAGC,QAAS,CAGT,iBAAkB,CALlB,iBAAkB,CAGlB,oDAAqD,CAFrD,KAAM,CAKN,gBAAiB,CAFjB,0CAA2C,CAG3C,2BACD,CAQA,qJACC,YACD,CAEA,8HAEC,8DAA+D,CAO/D,gBAAiB,CANjB,WAAa,CAKb,aAED,CAEA,iEACC,mDAAoD,CACpD,WACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-selector-column-resizer-hover: var(--ck-color-base-active);\n\t--ck-table-column-resizer-width: 7px;\n\n\t/* The offset used for absolute positioning of the resizer element, so that it is placed exactly above the cell border.\n\t   The value is: minus half the width of the resizer decreased additionaly by the half the width of the border (0.5px). */\n\t--ck-table-column-resizer-position-offset: calc(var(--ck-table-column-resizer-width) * -0.5 - 0.5px);\n}\n\n.ck-content .table .ck-table-resized {\n\ttable-layout: fixed;\n}\n\n.ck-content .table table {\n\toverflow: hidden;\n}\n\n.ck-content .table td,\n.ck-content .table th {\n\t/* To prevent text overflowing beyond its cell when columns are resized by resize handler\n\t(https://github.com/ckeditor/ckeditor5/pull/14379#issuecomment-1589460978). */\n\toverflow-wrap: break-word;\n\tposition: relative;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tright: var(--ck-table-column-resizer-position-offset);\n\twidth: var(--ck-table-column-resizer-width);\n\tcursor: col-resize;\n\tuser-select: none;\n\tz-index: var(--ck-z-default);\n}\n\n.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer {\n\tdisplay: none;\n}\n\n/* The resizer elements, which are extended to an extremely high height, break the drag & drop feature in Chrome. To make it work again,\n   all resizers must be hidden while the table is dragged. */\n.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer {\n\tdisplay: none;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer:hover,\n.ck.ck-editor__editable .table .ck-table-column-resizer__active {\n\tbackground-color: var(--ck-color-selector-column-resizer-hover);\n\topacity: 0.25;\n\t/* The resizer element resides in each cell so to occupy the entire height of the table, which is unknown from a CSS point of view,\n\t   it is extended to an extremely high height. Even for screens with a very high pixel density, the resizer will fulfill its role as\n\t   it should, i.e. for a screen of 476 ppi the total height of the resizer will take over 350 sheets of A4 format, which is totally\n\t   unrealistic height for a single table. */\n\ttop: -999999px;\n\tbottom: -999999px;\n}\n\n.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer {\n\tleft: var(--ck-table-column-resizer-position-offset);\n\tright: unset;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1674: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-color-selector-focused-cell-background:#9ec9fa4d}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-selector-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"],
          names: [],
          mappings: "AAKA,MACC,qDACD,CAKE,8QAGC,2DAA4D,CAK5D,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-selector-focused-cell-background: hsla(212, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-selector-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      786: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck.ck-table-form .ck-form__row.ck-table-form__background-row,.ck.ck-table-form .ck-form__row.ck-table-form__border-row{flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{align-items:center;flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view{align-items:center;display:flex;flex-direction:column-reverse}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view .ck.ck-dropdown,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{flex-grow:0}.ck.ck-table-form .ck.ck-labeled-field-view{position:relative}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{bottom:calc(var(--ck-table-properties-error-arrow-size)*-1);left:50%;position:absolute;transform:translate(-50%,100%);z-index:1}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{content:"";left:50%;position:absolute;top:calc(var(--ck-table-properties-error-arrow-size)*-1);transform:translateX(-50%)}:root{--ck-table-properties-error-arrow-size:6px;--ck-table-properties-min-error-width:150px}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-labeled-field-view>.ck-label{font-size:var(--ck-font-size-tiny);text-align:center}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-style,.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-width{max-width:80px;min-width:80px;width:80px}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{padding:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__height,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__width{margin:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{align-self:flex-end;display:inline-block;height:var(--ck-ui-component-min-height);line-height:var(--ck-ui-component-min-height);margin:0 var(--ck-spacing-small)}.ck.ck-table-form .ck.ck-labeled-field-view{padding-top:var(--ck-spacing-standard)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{border-radius:0}.ck-rounded-corners .ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status,.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{background:var(--ck-color-base-error);color:var(--ck-color-base-background);min-width:var(--ck-table-properties-min-error-width);padding:var(--ck-spacing-small) var(--ck-spacing-medium);text-align:center}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{border-color:#0000 #0000 var(--ck-color-base-error) #0000;border-style:solid;border-width:0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:ck-table-form-labeled-view-status-appear .15s ease both}@media (prefers-reduced-motion:reduce){.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:none}}.ck.ck-table-form .ck.ck-labeled-field-view .ck-input.ck-error:not(:focus)+.ck.ck-labeled-field-view__status{display:none}@keyframes ck-table-form-labeled-view-status-appear{0%{opacity:0}to{opacity:1}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableform.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableform.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAWE,wHACC,cACD,CAEA,8DAEC,kBAAmB,CADnB,cAgBD,CAbC,qFAGC,kBAAmB,CAFnB,YAAa,CACb,6BAMD,CAEA,sMACC,WACD,CAIF,4CAEC,iBAoBD,CAlBC,8EAGC,2DAAgE,CADhE,QAAS,CADT,iBAAkB,CAGlB,8BAA+B,CAG/B,SAUD,CAPC,oFACC,UAAW,CAGX,QAAS,CAFT,iBAAkB,CAClB,wDAA6D,CAE7D,0BACD,CChDH,MACC,0CAA2C,CAC3C,2CACD,CAMI,2FACC,kCAAmC,CACnC,iBACD,CAGD,8KAIC,cAAe,CADf,cAAe,CADf,UAGD,CAGD,8DACC,SAcD,CAZC,yMAEC,QACD,CAEA,iGACC,mBAAoB,CACpB,oBAAqB,CACrB,wCAAyC,CACzC,6CAA8C,CAC9C,gCACD,CAIF,4CACC,sCA6BD,CA3BC,8ECxCD,eD6DC,CArBA,mMCpCA,qCDyDA,CArBA,8EAGC,qCAAsC,CACtC,qCAAsC,CAEtC,oDAAqD,CADrD,wDAAyD,CAEzD,iBAcD,CAXC,oFACC,yDAA4E,CAE5E,kBAAmB,CADnB,kJAED,CAdD,8EAgBC,iEAKD,CAHC,uCAlBD,8EAmBE,cAEF,CADC,CAID,6GACC,YACD,CAIF,oDACC,GACC,SACD,CAEA,GACC,SACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__background-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tflex-wrap: wrap;\n\t\t\talign-items: center;\n\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& .ck.ck-dropdown {\n\t\t\t\t\tflex-grow: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\tflex-grow: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\t/* Allow absolute positioning of the status (error) balloons. */\n\t\tposition: relative;\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\tbottom: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\ttransform: translate(-50%,100%);\n\n\t\t\t/* Make sure the balloon status stays on top of other form elements. */\n\t\t\tz-index: 1;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translateX( -50% );\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n:root {\n\t--ck-table-properties-error-arrow-size: 6px;\n\t--ck-table-properties-min-error-width: 150px;\n}\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\t& > .ck-label {\n\t\t\t\t\tfont-size: var(--ck-font-size-tiny);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__border-style,\n\t\t\t& .ck-table-form__border-width {\n\t\t\t\twidth: 80px;\n\t\t\t\tmin-width: 80px;\n\t\t\t\tmax-width: 80px;\n\t\t\t}\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tpadding: 0;\n\n\t\t\t& .ck-table-form__dimensions-row__width,\n\t\t\t& .ck-table-form__dimensions-row__height {\n\t\t\t\tmargin: 0\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\talign-self: flex-end;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\theight: var(--ck-ui-component-min-height);\n\t\t\t\tline-height: var(--ck-ui-component-min-height);\n\t\t\t\tmargin: 0 var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: var(--ck-spacing-standard);\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\t@mixin ck-rounded-corners;\n\n\t\t\tbackground: var(--ck-color-base-error);\n\t\t\tcolor: var(--ck-color-base-background);\n\t\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\t\tmin-width: var(--ck-table-properties-min-error-width);\n\t\t\ttext-align: center;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tborder-color: transparent transparent var(--ck-color-base-error) transparent;\n\t\t\t\tborder-width: 0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size);\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\tanimation: ck-table-form-labeled-view-status-appear .15s ease both;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\tanimation: none;\n\t\t\t}\n\t\t}\n\n\t\t/* Hide the error balloon when the field is blurred. Makes the experience much more clear. */\n\t\t& .ck-input.ck-error:not(:focus) + .ck.ck-labeled-field-view__status {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n@keyframes ck-table-form-labeled-view-status-appear {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4703: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-content:baseline;flex-basis:0;flex-wrap:wrap}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items{flex-wrap:nowrap}.ck.ck-table-properties-form{width:320px}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-self:flex-end;padding:0}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items>*{width:40px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableproperties.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableproperties.css"],
          names: [],
          mappings: "AAOE,mFAGC,sBAAuB,CADvB,YAAa,CADb,cAOD,CAHC,qHACC,gBACD,CCTH,6BACC,WAmBD,CAhBE,mFACC,mBAAoB,CACpB,SAYD,CAVC,kGACC,eAAgB,CAGhB,qCAKD,CAHC,uHACC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-basis: 0;\n\t\t\talign-content: baseline;\n\n\t\t\t& .ck.ck-toolbar .ck-toolbar__items {\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\n\t\t\t\t& .ck-toolbar__items > * {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      892: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ':root{--ck-table-selected-cell-background:#9ecffa4d}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:#0000;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:initial}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"],
          names: [],
          mappings: "AAKA,MACC,6CACD,CAGC,0IAKC,gBAAiB,CAFjB,iBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,wBACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t/*\n\t\t * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9491.\n\t\t */\n\t\t& .ck-widget {\n\t\t\toutline: unset;\n\n\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1836: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-aria-live-announcer{left:-10000px;position:absolute;top:-10000px}.ck.ck-aria-live-region-list{list-style-type:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/arialiveannouncer/arialiveannouncer.css"],
          names: [],
          mappings: "AAKA,2BAEC,aAAc,CADd,iBAAkB,CAElB,YACD,CAEA,6BACC,oBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-aria-live-announcer {\n\tposition: absolute;\n\tleft: -10000px;\n\ttop: -10000px;\n}\n\n.ck.ck-aria-live-region-list {\n\tlist-style-type: none;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5558: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-autocomplete{position:relative}.ck.ck-autocomplete>.ck-search__results{position:absolute;z-index:var(--ck-z-panel)}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{bottom:100%}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{bottom:auto;top:100%}.ck.ck-autocomplete>.ck-search__results{border-radius:0}.ck-rounded-corners .ck.ck-autocomplete>.ck-search__results,.ck.ck-autocomplete>.ck-search__results.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-autocomplete>.ck-search__results{background:var(--ck-color-base-background);border:1px solid var(--ck-color-dropdown-panel-border);box-shadow:var(--ck-drop-shadow),0 0;max-height:200px;min-width:auto;overflow-y:auto}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-1px}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{border-top-left-radius:0;border-top-right-radius:0;margin-top:-1px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/autocomplete/autocomplete.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/autocomplete/autocomplete.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,oBACC,iBAeD,CAbC,wCACC,iBAAkB,CAClB,yBAUD,CARC,6DACC,WACD,CAEA,6DAEC,WAAY,CADZ,QAED,CCVD,wCCEA,eDuBA,CAzBA,uHCMC,qCDmBD,CAzBA,wCAMC,0CAA2C,CAC3C,sDAAuD,CEPxD,oCAA8B,CFI7B,gBAAiB,CAIjB,cAAe,CAHf,eAoBD,CAfC,6DACC,2BAA4B,CAC5B,4BAA6B,CAG7B,kBACD,CAEA,6DACC,wBAAyB,CACzB,yBAA0B,CAG1B,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-autocomplete {\n\tposition: relative;\n\n\t& > .ck-search__results {\n\t\tposition: absolute;\n\t\tz-index: var(--ck-z-panel);\n\n\t\t&.ck-search__results_n {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck.ck-autocomplete {\n\t& > .ck-search__results {\n\t\t@mixin ck-rounded-corners;\n\t\t@mixin ck-drop-shadow;\n\n\t\tmax-height: 200px;\n\t\toverflow-y: auto;\n\t\tbackground: var(--ck-color-base-background);\n\t\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\t\tmin-width: auto;\n\n\t\t&.ck-search__results_n {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-bottom: -1px;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-top-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-top: -1px;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5810: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}[dir=ltr] .ck.ck-button,[dir=ltr] a.ck.ck-button{justify-content:left}[dir=rtl] .ck.ck-button,[dir=rtl] a.ck.ck-button{justify-content:right}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid #0000;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}@media (prefers-reduced-motion:reduce){.ck.ck-button,a.ck.ck-button{transition:none}}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{opacity:.5}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AAQA,6BAMC,kBAAmB,CADnB,mBAAoB,CADpB,iBAAkB,CCHlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD0BD,CA9BA,iDASE,oBAqBF,CA9BA,iDAaE,qBAiBF,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEzBD,6BCAC,oDD+ID,CC5IE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eFgJD,CA/IA,wIEGE,qCF4IF,CA/IA,6BA6BC,uBAAwB,CANxB,sBAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBA0ID,CAhHC,uCA/BD,6BAgCE,eA+GF,CA9GC,CAEA,oFGpCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHyCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAWD,CAZA,6FAIE,mCAQF,CAZA,6FAQE,oCAIF,CAZA,yEAWC,UACD,CAIC,oIIxFD,oDJ4FC,CAOA,gLKnGD,kCLqGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCClIA,+CDsIA,CCnIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDmHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CClJC,mDDuJD,CCpJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDmID,2CAIC,wCACD,CAEA,uCAEC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../../mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\n\t@mixin ck-dir ltr {\n\t\tjustify-content: left;\n\t}\n\n\t@mixin ck-dir rtl {\n\t\tjustify-content: right;\n\t}\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\topacity: .5;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\n\t\tcolor: var(--ck-color-button-on-color);\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3986: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:#0000;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid #0000;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}@media (prefers-reduced-motion:reduce){.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{transition:none}}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:#0000;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,gBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eDgFA,CA5CA,yIChCC,qCD4ED,CA5CA,2DAKE,gBAuCF,CA5CA,2DAUE,iBAkCF,CA5CA,iDAkBC,uDAAwD,CAFxD,sBAA6B,CAD7B,iFAAsF,CAEtF,0CA2BD,CAxBC,2ECxDD,eDuEC,CAfA,6LCpDA,qCAAsC,CDsDpC,8CAaF,CAfA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAUD,CAHC,uCAZD,2EAaE,eAEF,CADC,CAGD,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEpFA,kCFsFA,CAGA,oCACC,kBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2px /* Border */\n\t);\n\t--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t/* Unlike a regular button, the switch button text color and background should never change.\n\t * Changing toggle switch (background, outline) is enough to carry the information about the\n\t * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)\n\t */\n\t&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {\n\t\tcolor: inherit;\n\t\tbackground: transparent;\n\t}\n\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Apply some smooth transition to the box-shadow and border. */\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n\t\tborder: 1px solid transparent;\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: var(--ck-switch-button-inner-hover-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t/* Overriding default .ck-button:focus styles + an outline around the toogle */\n\t&:focus {\n\t\tborder-color: transparent;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\n\t\t& .ck-button__toggle {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n\t\t\toutline-offset: 1px;\n\t\t\toutline: var(--ck-focus-ring);\n\t\t}\n\t}\n\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-on {\n\t\t& .ck-button__toggle {\n\t\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t\t}\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\t/*\n\t\t\t\t* Move the toggle switch to the right. It will be animated.\n\t\t\t\t*/\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3476: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-collapsible.ck-collapsible_collapsed>.ck-collapsible__children{display:none}:root{--ck-collapsible-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-collapsible>.ck.ck-button{border-radius:0;color:inherit;font-weight:700;padding:var(--ck-list-button-padding);width:100%}.ck.ck-collapsible>.ck.ck-button:focus{background:#0000}.ck.ck-collapsible>.ck.ck-button:active,.ck.ck-collapsible>.ck.ck-button:hover:not(:focus),.ck.ck-collapsible>.ck.ck-button:not(:focus){background:#0000;border-color:#0000;box-shadow:none}.ck.ck-collapsible>.ck.ck-button>.ck-icon{margin-right:var(--ck-spacing-medium);width:var(--ck-collapsible-arrow-size)}.ck.ck-collapsible>.ck-collapsible__children{padding:var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large)}.ck.ck-collapsible.ck-collapsible_collapsed>.ck.ck-button .ck-icon{transform:rotate(-90deg)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/collapsible/collapsible.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/collapsible/collapsible.css"],
          names: [],
          mappings: "AAMC,sEACC,YACD,CCHD,MACC,yDACD,CAGC,iCAIC,eAAgB,CAChB,aAAc,CAHd,eAAiB,CACjB,qCAAsC,CAFtC,UAoBD,CAdC,uCACC,gBACD,CAEA,wIACC,gBAAuB,CACvB,kBAAyB,CACzB,eACD,CAEA,0CACC,qCAAsC,CACtC,sCACD,CAGD,6CACC,gFACD,CAGC,mEACC,wBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-collapsible.ck-collapsible_collapsed {\n\t& > .ck-collapsible__children {\n\t\tdisplay: none;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-collapsible-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-collapsible {\n\t& > .ck.ck-button {\n\t\twidth: 100%;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-list-button-padding);\n\t\tborder-radius: 0;\n\t\tcolor: inherit;\n\n\t\t&:focus {\n\t\t\tbackground: transparent;\n\t\t}\n\n\t\t&:active, &:not(:focus), &:hover:not(:focus) {\n\t\t\tbackground: transparent;\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t& > .ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-medium);\n\t\t\twidth: var(--ck-collapsible-arrow-size);\n\t\t}\n\t}\n\n\t& > .ck-collapsible__children {\n\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large);\n\t}\n\n\t&.ck-collapsible_collapsed {\n\t\t& > .ck.ck-button .ck-icon {\n\t\t\ttransform: rotate(-90deg);\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4488: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{transition:box-shadow .2s ease}@media (forced-colors:none){.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile.ck-color-selector__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}}@media (forced-colors:active){.ck.ck-color-grid__tile{height:unset;min-height:unset;min-width:unset;padding:0 var(--ck-spacing-small);width:unset}.ck.ck-color-grid__tile .ck-button__label{display:inline-block}}@media (prefers-reduced-motion:reduce){.ck.ck-color-grid__tile{transition:none}}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAKA,kBACC,YACD,CCCA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBACC,8BAkED,CC3EC,4BACC,wBDgBA,QAAS,CAJT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CAJV,oCCTA,CDgBA,8HAIC,QACD,CAEA,+DACC,gDACD,CAEA,8BACC,8FACD,CAEA,gGAEC,iGACD,CCjCD,CAZA,8BACC,wBDqDA,YAAa,CAEb,gBAAiB,CADjB,eAAgB,CAEhB,iCAAkC,CAJlC,WClDA,CDwDA,0CACC,oBACD,CCzDD,CD4DA,uCAhDD,wBAiDE,eAkBF,CAjBC,CAEA,oCACC,YAAa,CACb,gBACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAGC,0CACC,aACD,CAIF,yBACC,oCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\ttransition: .2s ease box-shadow;\n\n\t@mixin ck-media-default-colors {\n\t\twidth: var(--ck-color-grid-tile-size);\n\t\theight: var(--ck-color-grid-tile-size);\n\t\tmin-width: var(--ck-color-grid-tile-size);\n\t\tmin-height: var(--ck-color-grid-tile-size);\n\t\tpadding: 0;\n\t\tborder: 0;\n\n\t\t&.ck-on,\n\t\t&:focus:not( .ck-disabled ),\n\t\t&:hover:not( .ck-disabled ) {\n\t\t\t/* Disable the default .ck-button\'s border ring. */\n\t\t\tborder: 0;\n\t\t}\n\n\t\t&.ck-color-selector__color-tile_bordered {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\t\t}\n\n\t\t&:focus:not( .ck-disabled ),\n\t\t&:hover:not( .ck-disabled ) {\n\t\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t\t}\n\t}\n\n\t/*\n\t * In high contrast mode, the colors are replaced with text labels.\n\t * See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t */\n\t@mixin ck-media-forced-colors {\n\t\twidth: unset;\n\t\theight: unset;\n\t\tmin-width: unset;\n\t\tmin-height: unset;\n\t\tpadding: 0 var(--ck-spacing-small);\n\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3900: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".color-picker-hex-input{width:max-content}.color-picker-hex-input .ck.ck-input{min-width:unset}.ck.ck-color-picker__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;margin:var(--ck-spacing-large) 0 0;width:unset}.ck.ck-color-picker__row .ck.ck-labeled-field-view{padding-top:unset}.ck.ck-color-picker__row .ck.ck-input-text{width:unset}.ck.ck-color-picker__row .ck-color-picker__hash-view{padding-right:var(--ck-spacing-medium);padding-top:var(--ck-spacing-tiny)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorpicker/colorpicker.css"],
          names: [],
          mappings: "AAKA,wBACC,iBAKD,CAHC,qCACC,eACD,CAGD,yBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAA8B,CAC9B,kCAAmC,CACnC,WAcD,CAZC,mDACC,iBACD,CAEA,2CACC,WACD,CAEA,qDAEC,sCAAuC,CADvC,kCAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.color-picker-hex-input {\n\twidth: max-content;\n\n\t& .ck.ck-input {\n\t\tmin-width: unset;\n\t}\n}\n\n.ck.ck-color-picker__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\tmargin: var(--ck-spacing-large) 0 0;\n\twidth: unset;\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: unset;\n\t}\n\n\t& .ck.ck-input-text {\n\t\twidth: unset;\n\t}\n\n\t& .ck-color-picker__hash-view {\n\t\tpadding-top: var(--ck-spacing-tiny);\n\t\tpadding-right: var(--ck-spacing-medium);\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9576: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{align-items:center;display:flex}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{justify-content:flex-start}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{display:flex;flex-direction:row;justify-content:space-around}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-cancel,.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-save{flex:1}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{width:100%}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-left:var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment label.ck.ck-color-grid__label{font-weight:unset}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker{padding:8px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker{height:100px;min-width:180px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation){border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue){border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius)}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue-pointer),.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation-pointer){height:15px;width:15px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{padding:0 8px 8px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorselector/colorselector.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorselector/colorselector.css"],
          names: [],
          mappings: "AAUE,oLAGC,kBAAmB,CADnB,YAMD,CARA,wMAME,0BAEF,CAKA,iFACC,YAAa,CACb,kBAAmB,CACnB,4BAMD,CAJC,oMAEC,MACD,CCrBD,oLAEC,UACD,CAEA,0FAEC,2BAA4B,CAC5B,4BAA6B,CAF7B,qEAiBD,CAbC,sGACC,gDACD,CAEA,gHAEE,uCAMF,CARA,gHAME,sCAEF,CAGD,6EACC,iBACD,CAKA,oEACC,WAoBD,CAlBC,sFACC,YAAa,CACb,eAeD,CAbC,wGACC,iEACD,CAEA,iGACC,iEACD,CAEA,yNAGC,WAAY,CADZ,UAED,CAIF,iFACC,iBACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-around;\n\n\t\t\t& .ck-button-save,\n\t\t\t& .ck-button-cancel {\n\t\t\t\tflex: 1\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck.ck-icon {\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& label.ck.ck-color-grid__label {\n\t\t\tfont-weight: unset;\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-picker {\n\t\t\tpadding: 8px;\n\n\t\t\t& .hex-color-picker {\n\t\t\t\theight: 100px;\n\t\t\t\tmin-width: 180px;\n\n\t\t\t\t&::part(saturation) {\n\t\t\t\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\t\t\t\t}\n\n\t\t\t\t&::part(hue) {\n\t\t\t\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\t\t\t}\n\n\t\t\t\t&::part(saturation-pointer),\n\t\t\t\t&::part(hue-pointer) {\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tpadding: 0 8px 8px;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8390: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-dialog-overlay{bottom:0;left:0;overscroll-behavior:none;position:fixed;right:0;top:0;user-select:none}.ck.ck-dialog-overlay.ck-dialog-overlay__transparent{animation:none;background:none;pointer-events:none}.ck.ck-dialog{overscroll-behavior:none;position:absolute;width:fit-content}.ck.ck-dialog .ck.ck-form__header{flex-shrink:0}.ck.ck-dialog .ck.ck-form__header .ck-form__header__label{cursor:grab}.ck.ck-dialog-overlay.ck-dialog-overlay__transparent .ck.ck-dialog{pointer-events:all}:root{--ck-dialog-overlay-background-color:#00000080;--ck-dialog-drop-shadow:0px 0px 6px 2px #00000026;--ck-dialog-max-width:100vw;--ck-dialog-max-height:90vh;--ck-color-dialog-background:var(--ck-color-base-background);--ck-color-dialog-form-header-border:var(--ck-color-base-border)}.ck.ck-dialog-overlay{animation:ck-dialog-fade-in .3s;background:var(--ck-dialog-overlay-background-color);z-index:var(--ck-z-dialog)}.ck.ck-dialog{border-radius:0}.ck-rounded-corners .ck.ck-dialog,.ck.ck-dialog.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dialog{--ck-drop-shadow:var(--ck-dialog-drop-shadow);background:var(--ck-color-dialog-background);border:1px solid var(--ck-color-base-border);box-shadow:var(--ck-drop-shadow),0 0;max-height:var(--ck-dialog-max-height);max-width:var(--ck-dialog-max-width)}.ck.ck-dialog .ck.ck-form__header{border-bottom:1px solid var(--ck-color-dialog-form-header-border)}@keyframes ck-dialog-fade-in{0%{background:#0000}to{background:var(--ck-dialog-overlay-background-color)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dialog/dialog.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dialog/dialog.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,sBAKC,QAAS,CACT,MAAO,CAJP,wBAAyB,CAEzB,cAAe,CAGf,OAAQ,CACR,KAAM,CAPN,gBAcD,CALC,qDAEC,cAAe,CACf,eAAgB,CAFhB,mBAGD,CAGD,cACC,wBAAyB,CAEzB,iBAAkB,CADlB,iBAcD,CAXC,kCACC,aAKD,CAHC,0DACC,WACD,CAVF,mEAcE,kBAEF,CC7BA,MACC,8CAA2D,CAC3D,iDAA8D,CAC9D,2BAA4B,CAC5B,2BAA4B,CAC5B,4DAA6D,CAC7D,gEACD,CAEA,sBACC,+BAAgC,CAChC,oDAAqD,CACrD,0BACD,CAEA,cCbC,eD2BD,CAdA,mECTE,qCDuBF,CAdA,cAIC,6CAA8C,CAE9C,4CAA6C,CAG7C,4CAA6C,CExB7C,oCAA8B,CFsB9B,sCAAuC,CACvC,oCAMD,CAHC,kCACC,iEACD,CAGD,6BACC,GACC,gBACD,CAEA,GACC,oDACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog-overlay {\n\tuser-select: none;\n\toverscroll-behavior: none;\n\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\n\t&.ck-dialog-overlay__transparent {\n\t\tpointer-events: none;\n\t\tanimation: none;\n\t\tbackground: none;\n\t}\n}\n\n.ck.ck-dialog {\n\toverscroll-behavior: none;\n\twidth: fit-content;\n\tposition: absolute;\n\n\t& .ck.ck-form__header  {\n\t\tflex-shrink: 0;\n\n\t\t& .ck-form__header__label {\n\t\t\tcursor: grab;\n\t\t}\n\t}\n\n\t@nest .ck.ck-dialog-overlay.ck-dialog-overlay__transparent & {\n\t\tpointer-events: all;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n:root {\n\t--ck-dialog-overlay-background-color: hsla( 0, 0%, 0%, .5 );\n\t--ck-dialog-drop-shadow: 0px 0px 6px 2px hsl(0deg 0% 0% / 15%);\n\t--ck-dialog-max-width: 100vw;\n\t--ck-dialog-max-height: 90vh;\n\t--ck-color-dialog-background: var(--ck-color-base-background);\n\t--ck-color-dialog-form-header-border: var(--ck-color-base-border);\n}\n\n.ck.ck-dialog-overlay {\n\tanimation: ck-dialog-fade-in .3s;\n\tbackground: var(--ck-dialog-overlay-background-color);\n\tz-index: var(--ck-z-dialog);\n}\n\n.ck.ck-dialog {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\t--ck-drop-shadow: var(--ck-dialog-drop-shadow);\n\n\tbackground: var(--ck-color-dialog-background);\n\tmax-height: var(--ck-dialog-max-height);\n\tmax-width: var(--ck-dialog-max-width);\n\tborder: 1px solid var(--ck-color-base-border);\n\n\t& .ck.ck-form__header {\n\t\tborder-bottom: 1px solid var(--ck-color-dialog-form-header-border);\n\t}\n}\n\n@keyframes ck-dialog-fade-in {\n\t0% {\n\t\tbackground: hsla( 0, 0%, 0%, 0 );\n\t}\n\n\t100% {\n\t\tbackground: var(--ck-dialog-overlay-background-color);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6533: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-dialog .ck.ck-dialog__actions{display:flex;justify-content:flex-end;padding:var(--ck-spacing-large)}.ck.ck-dialog .ck.ck-dialog__actions>*+*{margin-left:var(--ck-spacing-large)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dialog/dialogactions.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dialog/dialogactions.css"],
          names: [],
          mappings: "AAMC,qCACC,YAAa,CACb,wBAAyB,CCDzB,+BDED,CCAC,yCACC,mCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog {\n\t& .ck.ck-dialog__actions {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog {\n\t& .ck.ck-dialog__actions {\n\t\tpadding: var(--ck-spacing-large);\n\n\t\t& > * + * {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6608: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-panel)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-panel) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}.ck.ck-dropdown__panel:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eHkHD,CAhCA,qFG9EE,qCH8GF,CAhCA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAuBD,CAnBC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD,CAEA,6BACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\t}\n\n\t& .ck-dropdown__panel {\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-panel);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-panel) + 1 );\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8424: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-dropdown>.ck-dropdown__panel>.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown > .ck-dropdown__panel > .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child > .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child > .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4515: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton>.ck-splitbutton__arrow:not(:focus){border-bottom-width:0;border-top-width:0}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:focus:after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:focus:after{--ck-color-split-button-hover-border:var(--ck-color-focus-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CAKD,sDAEC,qBAAwB,CADxB,kBAED,CAQC,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGA,sIACC,iEACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCCzFA,eDmGA,CAVA,qHCrFC,qCD+FD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n}\n\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* Make sure the divider stretches 100% height of the button\n\thttps://github.com/ckeditor/ckeditor5/issues/10936 */\n\t& > .ck-splitbutton__arrow:not(:focus) {\n\t\tborder-top-width: 0px;\n\t\tborder-bottom-width: 0px;\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t/* Make sure the divider between the buttons looks fine when the button is focused */\n\t\t& > .ck-splitbutton__arrow:focus::after {\n\t\t\t--ck-color-split-button-hover-border: var(--ck-color-focus-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4245: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"],
          names: [],
          mappings: "AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8020: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-accessibility-help-dialog-max-width:600px;--ck-accessibility-help-dialog-max-height:400px;--ck-accessibility-help-dialog-border-color:#ccced1;--ck-accessibility-help-dialog-code-background-color:#ededed;--ck-accessibility-help-dialog-kbd-shadow-color:#9c9c9c}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content{border:1px solid #0000;max-height:var(--ck-accessibility-help-dialog-max-height);max-width:var(--ck-accessibility-help-dialog-max-width);overflow:auto;padding:var(--ck-spacing-large);user-select:text}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content{*{white-space:normal}}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content .ck-label{display:none}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h3{font-size:1.2em;font-weight:700}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h4{font-size:1em;font-weight:700}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h3,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h4,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content p,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content table{margin:1em 0}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl{border-bottom:none;border-top:1px solid var(--ck-accessibility-help-dialog-border-color);display:grid;grid-template-columns:2fr 1fr}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dd,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dt{border-bottom:1px solid var(--ck-accessibility-help-dialog-border-color);padding:.4em 0}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dt{grid-column-start:1}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dd{grid-column-start:2;text-align:right}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content code,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd{background:var(--ck-accessibility-help-dialog-code-background-color);border-radius:2px;display:inline-block;font-size:.9em;line-height:1;padding:.4em;text-align:center;vertical-align:middle}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content code{font-family:monospace}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd{box-shadow:0 1px 1px var(--ck-accessibility-help-dialog-kbd-shadow-color);margin:0 1px;min-width:1.8em}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd+kbd{margin-left:2px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/accessibilityhelp.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAQA,MACC,8CAA+C,CAC/C,+CAAgD,CAChD,mDAA8D,CAC9D,4DAAyE,CACzE,uDACD,CAEA,wEAOC,sBAA6B,CAJ7B,yDAA0D,CAD1D,uDAAwD,CAExD,aAAc,CAHd,+BAAgC,CAIhC,gBAgFD,CA5EC,8ECdA,2BAA2B,CCF3B,2CAA8B,CDC9B,YDkBA,CAZD,wEAcC,EACC,kBACD,CAqED,CAlEC,kFACC,YACD,CAEA,2EAEC,eAAgB,CADhB,eAED,CAEA,2EAEC,aAAc,CADd,eAED,CAEA,8SAIC,YACD,CAEA,2EAIC,kBAAmB,CADnB,qEAAsE,CAFtE,YAAa,CACb,6BAiBD,CAbC,4JACC,wEAAyE,CACzE,cACD,CAEA,8EACC,mBACD,CAEA,8EACC,mBAAoB,CACpB,gBACD,CAGD,yJAEC,oEAAqE,CAIrE,iBAAkB,CALlB,oBAAqB,CAOrB,cAAe,CAHf,aAAc,CAFd,YAAa,CAIb,iBAAkB,CAHlB,qBAKD,CAEA,6EACC,qBACD,CAEA,4EAEC,yEAA4E,CAC5E,YAAa,CAFb,eAOD,CAHC,gFACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-accessibility-help-dialog-max-width: 600px;\n\t--ck-accessibility-help-dialog-max-height: 400px;\n\t--ck-accessibility-help-dialog-border-color: hsl(220, 6%, 81%);\n\t--ck-accessibility-help-dialog-code-background-color: hsl(0deg 0% 92.94%);\n\t--ck-accessibility-help-dialog-kbd-shadow-color: hsl(0deg 0% 61%);\n}\n\n.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content {\n\tpadding: var(--ck-spacing-large);\n\tmax-width: var(--ck-accessibility-help-dialog-max-width);\n\tmax-height: var(--ck-accessibility-help-dialog-max-height);\n\toverflow: auto;\n\tuser-select: text;\n\n\tborder: 1px solid transparent;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t* {\n\t\twhite-space: normal;\n\t}\n\n\t/* Hide the main label of the content container. */\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t& h3 {\n\t\tfont-weight: bold;\n\t\tfont-size: 1.2em;\n\t}\n\n\t& h4 {\n\t\tfont-weight: bold;\n\t\tfont-size: 1em;\n\t}\n\n\t& p,\n\t& h3,\n\t& h4,\n\t& table {\n\t\tmargin: 1em 0;\n\t}\n\n\t& dl {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 2fr 1fr;\n\t\tborder-top: 1px solid var(--ck-accessibility-help-dialog-border-color);\n\t\tborder-bottom: none;\n\n\t\t& dt, & dd {\n\t\t\tborder-bottom: 1px solid var(--ck-accessibility-help-dialog-border-color);\n\t\t\tpadding: .4em 0;\n\t\t}\n\n\t\t& dt {\n\t\t\tgrid-column-start: 1;\n\t\t}\n\n\t\t& dd {\n\t\t\tgrid-column-start: 2;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& kbd, & code {\n\t\tdisplay: inline-block;\n\t\tbackground: var(--ck-accessibility-help-dialog-code-background-color);\n\t\tpadding: .4em;\n\t\tvertical-align: middle;\n\t\tline-height: 1;\n\t\tborder-radius: 2px;\n\t\ttext-align: center;\n\t\tfont-size: .9em;\n\t}\n\n\t& code {\n\t\tfont-family: monospace;\n\t}\n\n\t& kbd {\n\t\tmin-width: 1.8em;\n\t\tbox-shadow: 0px 1px 1px var(--ck-accessibility-help-dialog-kbd-shadow-color);\n\t\tmargin: 0 1px;\n\n\t\t& + kbd {\n\t\t\tmargin-left: 2px;\n\t\t}\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6888: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid #0000;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,sBAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,oDACD,CAIA,gEACC,iDACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-panel-background);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-panel-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3224: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__header h2.ck-form__header__label{flex-grow:1}:root{--ck-form-header-height:44px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}[dir=ltr] .ck.ck-form__header>.ck-icon{margin-right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-form__header>.ck-icon{margin-left:var(--ck-spacing-medium)}.ck.ck-form__header .ck-form__header__label{--ck-font-size-base:15px;font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"],
          names: [],
          mappings: "AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BAKD,CAHC,8CACC,WACD,CCPD,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAmBD,CAdC,uCAEE,qCAMF,CARA,uCAME,oCAEF,CAEA,4CACC,wBAAyB,CACzB,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\t& h2.ck-form__header__label {\n\t\tflex-grow: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-form-header-height: 44px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& > .ck-icon {\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-right: var(--ck-spacing-medium);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: var(--ck-spacing-medium);\n\t\t}\n\t}\n\n\t& .ck-form__header__label {\n\t\t--ck-font-size-base: 15px;\n\t\tfont-weight: bold;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6580: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-highlighted-text mark{background:var(--ck-color-highlight-background);font-size:inherit;font-weight:inherit;line-height:inherit;vertical-align:initial}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/highlightedtext/highlightedtext.css"],
          names: [],
          mappings: "AAKA,6BACC,+CAAgD,CAIhD,iBAAkB,CAFlB,mBAAoB,CACpB,mBAAoB,CAFpB,sBAID",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-highlighted-text mark {\n\tbackground: var(--ck-color-highlight-background);\n\tvertical-align: initial;\n\tfont-weight: inherit;\n\tline-height: inherit;\n\tfont-size: inherit;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6912: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"],
          names: [],
          mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\t}\n\n\t/* Allows dynamic coloring of an icon by inheriting its color from the parent. */\n\t&.ck-icon_inherit-color {\n\t\tcolor: inherit;\n\n\t\t& * {\n\t\t\tcolor: inherit;\n\n\t\t\t&:not([fill]) {\n\t\t\t\t/* Needed by FF. */\n\t\t\t\tfill: currentColor;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1272: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}@media (prefers-reduced-motion:reduce){.ck.ck-input{transition:none}}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}@media (prefers-reduced-motion:reduce){.ck.ck-input.ck-error{animation:none}}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eDmDD,CA9CA,iECDE,qCD+CF,CA9CA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DAkCD,CAhCC,uCAdD,aAeE,eA+BF,CA9BC,CAEA,mBEvBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YF2BA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BGnCD,oDHsCC,CAGD,sBAEC,sCAAuC,CADvC,+CAUD,CAPC,uCAJD,sBAKE,cAMF,CALC,CAEA,4BGjDD,iDHmDC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\tanimation: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3756: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"],
          names: [],
          mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7883: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0;transform:translate(calc(var(--ck-spacing-medium)*-1),-6px) scale(.75);transform-origin:100% 0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}@media (prefers-reduced-motion:reduce){.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transition:none}}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:#0000;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:#0000}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eDmHD,CA9GA,2FCDE,qCD+GF,CA3GC,mEACC,UAwCD,CAtCC,gFACC,KAoCD,CArCA,0FAIE,MAAS,CAGT,6DAA+D,CAF/D,oBAgCF,CArCA,0FAWE,OAAU,CAEV,sEAA0E,CAD1E,uBAyBF,CArCA,gFAkBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAH9C,mBAAoB,CAQpB,sBAAuB,CAKvB,+JAQD,CAHC,uCAlCD,gFAmCE,eAEF,CADC,CASD,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,2XAGE,+HAYF,CAfA,2XAOE,wIAQF,CAfA,uWAaC,gBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,gBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t\ttransform-origin: 0 0;\n\t\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t\ttransform-origin: 100% 0;\n\t\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), -6px) scale(.75);\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9118: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}:root{--ck-list-button-padding:calc(var(--ck-line-height-base)*0.11*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item>.ck-button{border-radius:0;min-height:unset;width:100%}[dir=ltr] .ck.ck-list__item>.ck-button{text-align:left}[dir=rtl] .ck.ck-list__item>.ck-button{text-align:right}.ck.ck-list__item>.ck-button{padding:var(--ck-list-button-padding)}.ck.ck-list__item>.ck-button:active{box-shadow:none}.ck.ck-list__item>.ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item>.ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item>.ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item>.ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item>.ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item>.ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item>.ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck-list .ck-list__group{padding-top:var(--ck-spacing-medium);:not(.ck-hidden)~&{border-top:1px solid var(--ck-color-base-border)}}.ck-list .ck-list__group>.ck-label{font-size:11px;font-weight:700;padding:var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium)}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEdD,MACC,qJAGD,CAEA,YCLC,eDUD,CALA,+DCDE,qCDMF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAGC,eAAgB,CAFhB,gBAAiB,CACjB,UAwCD,CA1CA,uCAME,eAoCF,CA1CA,uCAUE,gBAgCF,CA1CA,6BAgBC,qCA0BD,CAxBC,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,yBACC,oCAAqC,CAGrC,mBACC,gDACD,CAOD,CALC,mCACC,cAAe,CACf,eAAiB,CACjB,oFACD,CAGD,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-list-button-padding:\n\t\tcalc(.11 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n}\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& > .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\tborder-radius: 0;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding: var(--ck-list-button-padding);\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-switchbutton):not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& > .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-list .ck-list__group {\n\tpadding-top: var(--ck-spacing-medium);\n\n\t/* The group should have a border when it\'s not the first item. */\n\t*:not(.ck-hidden) ~ & {\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t}\n\n\t& > .ck-label {\n\t\tfont-size: 11px;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium);\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      20: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-menu-bar{background:var(--ck-color-base-background);border:1px solid var(--ck-color-toolbar-border);display:flex;flex-wrap:wrap;gap:var(--ck-spacing-small);justify-content:flex-start;padding:var(--ck-spacing-small);width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubar.css"],
          names: [],
          mappings: "AAKA,gBAIC,0CAA2C,CAG3C,+CAAgD,CANhD,YAAa,CACb,cAAe,CAIf,2BAA4B,CAH5B,0BAA2B,CAE3B,+BAAgC,CAGhC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: flex-start;\n\tbackground: var(--ck-color-base-background);\n\tpadding: var(--ck-spacing-small);\n\tgap: var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\twidth: 100%;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6681: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-menu-bar__menu{display:block;font-size:inherit;position:relative}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level{max-width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/menubar/menubarmenu.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenu.css"],
          names: [],
          mappings: "AAKA,sBACC,aAAc,CCCd,iBAAkB,CDAlB,iBACD,CCCC,kDACC,cACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\tdisplay: block;\n\tposition: relative;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t&.ck-menu-bar__menu_top-level {\n\t\tmax-width: 100%;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2833: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-menu-bar__menu>.ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button{padding:var(--ck-list-button-padding);width:100%}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button>.ck-button__label{flex-grow:1;overflow:hidden;text-overflow:ellipsis}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button.ck-disabled>.ck-button__label{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-menu-bar__menu>.ck-menu-bar__menu__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-menu-bar__menu>.ck-menu-bar__menu__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button{min-height:unset;padding:var(--ck-spacing-small) var(--ck-spacing-medium)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button .ck-button__label{line-height:unset;width:unset}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button .ck-icon{display:none}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button{border-radius:0}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:focus{border-color:#0000;box-shadow:none}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:focus:not(.ck-on){background:var(--ck-color-button-default-hover-background)}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:not(:has(.ck-button__icon))>.ck-button__label{margin-left:calc(var(--ck-icon-size) - var(--ck-spacing-small))}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{transform:rotate(-90deg)}[dir=rtl] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{transform:rotate(90deg)}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button.ck-disabled>.ck-menu-bar__menu__button__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/menubar/menubarmenubutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenubutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AAMC,mFACC,mBAAoB,CACpB,2BACD,CCIA,iDACC,qCAAsC,CACtC,UAuBD,CArBC,mEACC,WAAY,CACZ,eAAgB,CAChB,sBACD,CAEA,+ECdD,kCDgBC,CAGC,qFACC,oCACD,CAIA,qFACC,qCACD,CAOF,6EAEC,gBAAiB,CADjB,wDAgBD,CAbC,+FAEC,iBAAkB,CADlB,WAED,CAEA,mFACC,2BAA4B,CAC5B,4BACD,CAEA,sFACC,YACD,CAMD,mFACC,eAiDD,CA/CC,yFACC,kBAAyB,CACzB,eAKD,CAHC,qGACC,0DACD,CAID,iIACC,+DACD,CAEA,qHACC,mCASD,CAVA,+HAIE,wBAMF,CAVA,+HAQE,uBAEF,CAEA,iICrFD,kCDuFC,CAGC,+HAIC,sCAAuC,CAHvC,gCAID,CAIA,+HACC,+BAAgC,CAGhC,oCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu  {\n\t& > .ck-menu-bar__menu__button > .ck-menu-bar__menu__button__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-menu-bar__menu {\n\t/*\n\t * All menu buttons.\n\t */\n\t& > .ck-menu-bar__menu__button {\n\t\tpadding: var(--ck-list-button-padding);\n\t\twidth: 100%;\n\n\t\t& > .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t&.ck-disabled > .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Top-level menu buttons only.\n\t */\n\t&.ck-menu-bar__menu_top-level > .ck-menu-bar__menu__button {\n\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\tmin-height: unset;\n\n\t\t& .ck-button__label {\n\t\t\twidth: unset;\n\t\t\tline-height: unset;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/*\n\t * Sub-menu buttons.\n\t */\n\t&:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button {\n\t\tborder-radius: 0;\n\n\t\t&:focus {\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\n\t\t\t&:not(.ck-on) {\n\t\t\t\tbackground: var(--ck-color-button-default-hover-background);\n\t\t\t}\n\t\t}\n\n\t\t/* Spacing in buttons that miss the icon. */\n\t\t&:not(:has(.ck-button__icon)) > .ck-button__label {\n\t\t\tmargin-left: calc(var(--ck-icon-size) - var(--ck-spacing-small));\n\t\t}\n\n\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\ttransform: rotate(-90deg);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\ttransform: rotate(90deg);\n\t\t\t}\n\t\t}\n\n\t\t&.ck-disabled > .ck-menu-bar__menu__button__arrow {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t\t/* A space to accommodate the triangle. */\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t\t/* A space to accommodate the triangle. */\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5092: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-menu-bar-menu-item-min-width:18em}.ck.ck-menu-bar__menu .ck.ck-menu-bar__menu__item{min-width:var(--ck-menu-bar-menu-item-min-width)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenulistitem.css"],
          names: [],
          mappings: "AAKA,MACC,sCACD,CAEA,kDACC,gDACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-menu-bar-menu-item-min-width: 18em;\n}\n\n.ck.ck-menu-bar__menu .ck.ck-menu-bar__menu__item {\n\tmin-width: var(--ck-menu-bar-menu-item-min-width);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2992: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button{border-radius:0}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container,.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container .ck-spinner{--ck-toolbar-spinner-size:20px}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button:focus{border-color:#0000;box-shadow:none}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button:focus:not(.ck-on){background:var(--ck-color-button-default-hover-background)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__panel>ul>.ck-menu-bar__menu__item>.ck-menu-bar__menu__item__button:not(:has(.ck-button__icon))>.ck-button__label{margin-left:calc(var(--ck-icon-size) - var(--ck-spacing-small))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenulistitembutton.css"],
          names: [],
          mappings: "AASC,iEACC,eA0BD,CAxBC,0LAGC,8BACD,CAEA,uFAEC,4CAA+C,CAC/C,oCACD,CAMA,uEACC,kBAAyB,CACzB,eAKD,CAHC,mFACC,0DACD,CASD,uLACC,+DACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\t/*\n\t * List item buttons.\n\t */\n\t& .ck-button.ck-menu-bar__menu__item__button {\n\t\tborder-radius: 0;\n\n\t\t& > .ck-spinner-container,\n\t\t& > .ck-spinner-container .ck-spinner {\n\t\t\t/* These styles correspond to .ck-icon so that the spinner seamlessly replaces the icon. */\n\t\t\t--ck-toolbar-spinner-size: 20px;\n\t\t}\n\n\t\t& > .ck-spinner-container {\n\t\t\t/* These margins are the same as for .ck-icon. */\n\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/*\n\t\t * Hovered items automatically get focused. Default focus styles look odd\n\t\t * while moving across a huge list of items so let's get rid of them\n\t\t */\n\t\t&:focus {\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\n\t\t\t&:not(.ck-on) {\n\t\t\t\tbackground: var(--ck-color-button-default-hover-background);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * First-level sub-menu item buttons.\n\t */\n\t&.ck-menu-bar__menu_top-level > .ck-menu-bar__menu__panel > ul > .ck-menu-bar__menu__item > .ck-menu-bar__menu__item__button {\n\t\t/* Spacing in buttons that miss the icon. */\n\t\t&:not(:has(.ck-button__icon)) > .ck-button__label {\n\t\t\tmargin-left: calc(var(--ck-icon-size) - var(--ck-spacing-small));\n\t\t}\n\t}\n}\n\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5107: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-menu-bar-menu-max-width:75vw;--ck-menu-bar-nested-menu-horizontal-offset:5px}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{max-width:var(--ck-menu-bar-menu-max-width);position:absolute;z-index:var(--ck-z-panel)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw{bottom:100%}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw{bottom:auto;top:100%}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se{left:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw{right:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es{left:calc(100% - var(--ck-menu-bar-nested-menu-horizontal-offset))}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es{top:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en{bottom:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{right:calc(100% - var(--ck-menu-bar-nested-menu-horizontal-offset))}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{top:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn{bottom:0}:root{--ck-menu-bar-menu-panel-max-width:75vw}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{border-radius:0}.ck-rounded-corners .ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;height:fit-content;max-width:var(--ck-menu-bar-menu-panel-max-width)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se{border-top-left-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{border-top-right-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne{border-bottom-left-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn{border-bottom-right-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/menubar/menubarmenupanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenupanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MACC,iCAAkC,CAClC,+CACD,CAEA,mDAEC,2CAA4C,CAC5C,iBAAkB,CAFlB,yBAkDD,CA9CC,gLAEC,WACD,CAEA,gLAGC,WAAY,CADZ,QAED,CAEA,gLAEC,MACD,CAEA,gLAEC,OACD,CAEA,gLAEC,kEACD,CAEA,wFACC,KACD,CAEA,wFACC,QACD,CAEA,gLAEC,mEACD,CAEA,wFACC,KACD,CAEA,wFACC,QACD,CCpDD,MACC,uCACD,CAEA,mDCDC,eDmCD,CAlCA,6ICGE,qCD+BF,CAlCA,mDAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CETT,oCAA8B,CFU9B,kBAAmB,CACnB,iDA0BD,CAvBC,gLAEC,wBACD,CAEA,gLAEC,yBACD,CAEA,gLAEC,2BACD,CAEA,gLAEC,4BACD,CAEA,yDACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-menu-bar-menu-max-width: 75vw;\n\t--ck-menu-bar-nested-menu-horizontal-offset: 5px;\n}\n\n.ck.ck-menu-bar__menu > .ck.ck-menu-bar__menu__panel {\n\tz-index: var(--ck-z-panel);\n\tmax-width: var(--ck-menu-bar-menu-max-width);\n\tposition: absolute;\n\n\t&.ck-menu-bar__menu__panel_position_ne,\n\t&.ck-menu-bar__menu__panel_position_nw {\n\t\tbottom: 100%;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_se,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\ttop: 100%;\n\t\tbottom: auto;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ne,\n\t&.ck-menu-bar__menu__panel_position_se {\n\t\tleft: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_nw,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\tright: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_es,\n\t&.ck-menu-bar__menu__panel_position_en {\n\t\tleft: calc( 100% - var(--ck-menu-bar-nested-menu-horizontal-offset) );\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_es {\n\t\ttop: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_en {\n\t\tbottom: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws,\n\t&.ck-menu-bar__menu__panel_position_wn {\n\t\tright: calc( 100% - var(--ck-menu-bar-nested-menu-horizontal-offset) );\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws {\n\t\ttop: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_wn {\n\t\tbottom: 0px;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-menu-bar-menu-panel-max-width: 75vw;\n}\n\n.ck.ck-menu-bar__menu > .ck.ck-menu-bar__menu__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\theight: fit-content;\n\tmax-width: var(--ck-menu-bar-menu-panel-max-width);\n\n\t/* Corner border radius consistent with the button. */\n\t&.ck-menu-bar__menu__panel_position_es,\n\t&.ck-menu-bar__menu__panel_position_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_en,\n\t&.ck-menu-bar__menu__panel_position_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_wn,\n\t&.ck-menu-bar__menu__panel_position_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3617: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-panel)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:#0000 #0000 var(--ck-color-panel-border) #0000;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:#0000 #0000 var(--ck-color-panel-background) #0000;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) #0000 #0000;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) #0000 #0000 #0000;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:#0000 #0000 #0000 var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:#0000 #0000 #0000 var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:#0000 var(--ck-color-panel-border) #0000 #0000;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:#0000 var(--ck-color-panel-background) #0000 #0000;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,2DAA8E,CAC9E,kDACD,CAEA,2CACC,+DAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,qDAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,+DAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,2DAA8E,CAC9E,oDACD,CAEA,2CACC,+DAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,2DAA8E,CAC9E,mDACD,CAEA,2CACC,+DAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-panel);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-border-width: 1px;\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t\tmargin-top: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t\tmargin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_e"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-border);\n\t\t\tmargin-right: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-background);\n\t\t\tmargin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_w"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent var(--ck-color-panel-border) transparent transparent;\n\t\t\tmargin-left: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent var(--ck-color-panel-background) transparent transparent;\n\t\t\tmargin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_e {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_w {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9432: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"],
          names: [],
          mappings: "AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3449: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-panel) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-panel) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4315: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-panel)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-panel); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7817: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-number,.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"],
          names: [],
          mappings: "AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAoED,CAlEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA+CF,CA7CE,8CACC,wDAYD,CAVC,4HAEC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDrEH",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n\t&::after {\n\t\tcontent: "";\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tright: -1px;\n\t\ttop: -1px;\n\t\tbottom: -1px;\n\t\tz-index: 1;\n\t}\n\n\t&:focus::after {\n\t\tdisplay: none;\n\t}\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button {\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -1px;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom: -1px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t&:focus::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text,\n\t\t\t& .ck-input-number {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\t\t\tborder-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      610: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{position:absolute;top:50%;transform:translateY(-50%)}[dir=ltr] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{left:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{right:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view .ck-search__reset{position:absolute;top:50%;transform:translateY(-50%)}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{display:block}.ck.ck-search>.ck-search__results>.ck-search__info:not(.ck-hidden)~*{display:none}:root{--ck-search-field-view-horizontal-spacing:calc(var(--ck-icon-size) + var(--ck-spacing-medium))}.ck.ck-search>.ck-labeled-field-view .ck-input{width:100%}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon{--ck-labeled-field-label-default-position-x:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon>.ck-labeled-field-view__input-wrapper>.ck-icon{opacity:.5;pointer-events:none}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input,[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input:not(.ck-input-text_empty){padding-left:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset{--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset.ck-labeled-field-view_empty{--ck-labeled-field-empty-unfocused-max-width:100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{background:none;min-height:auto;min-width:auto;opacity:.5;padding:0}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{left:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset:hover{opacity:1}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input:not(.ck-input-text_empty),[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{padding-right:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-search__results{min-width:100%}.ck.ck-search>.ck-search__results>.ck-search__info{padding:var(--ck-spacing-medium) var(--ck-spacing-large);width:100%}.ck.ck-search>.ck-search__results>.ck-search__info *{white-space:normal}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{font-weight:700}.ck.ck-search>.ck-search__results>.ck-search__info>span:last-child{margin-top:var(--ck-spacing-medium)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/search/search.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/search/search.css"],
          names: [],
          mappings: "AASE,oFACC,iBAAkB,CAClB,OAAQ,CACR,0BASD,CAZA,8FAME,6BAMF,CAZA,8FAUE,8BAEF,CAEA,uDACC,iBAAkB,CAClB,OAAQ,CACR,0BACD,CAKC,oEACC,aACD,CAGA,qEACC,YACD,CChCH,MACC,8FACD,CAIE,+CACC,UACD,CAEA,gEACC,0FAoBD,CAlBC,+GACC,UAAW,CACX,mBACD,CAEA,0EACC,UAWD,CAJE,kMACC,2DACD,CAKH,iEACC,sGAwCD,CAtCC,6FACC,6HACD,CAEA,mFAIC,eAAgB,CAFhB,eAAgB,CADhB,cAAe,CAIf,UAAW,CACX,SAaD,CAnBA,6FASE,8BAUF,CAnBA,6FAaE,6BAMF,CAHC,yFACC,SACD,CAGD,2EACC,UAWD,CAZA,oMAUE,4DAEF,CAIF,kCACC,cAkBD,CAhBC,mDAEC,wDAAyD,CADzD,UAcD,CAXC,qDACC,kBACD,CAEA,oEACC,eACD,CAEA,mEACC,mCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\n\t\t& .ck-search__reset {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\t& > .ck-search__info {\n\t\t\t& > span:first-child {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t/* Hide the filtered view when nothing was found */\n\t\t\t&:not(.ck-hidden) ~ * {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-search-field-view-horizontal-spacing: calc(var(--ck-icon-size) + var(--ck-spacing-medium));\n}\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& .ck-input {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&.ck-search__query_with-icon {\n\t\t\t--ck-labeled-field-label-default-position-x: var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\t\topacity: .5;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-search__query_with-reset {\n\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t&.ck-labeled-field-view_empty {\n\t\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t& .ck-search__reset {\n\t\t\t\tmin-width: auto;\n\t\t\t\tmin-height: auto;\n\n\t\t\t\tbackground: none;\n\t\t\t\topacity: .5;\n\t\t\t\tpadding: 0;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\tmin-width: 100%;\n\n\t\t& > .ck-search__info {\n\t\t\twidth: 100%;\n\t\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large);\n\n\t\t\t& * {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\n\t\t\t& > span:first-child {\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\n\t\t\t& > span:last-child {\n\t\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\t}\n}\n\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4944: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-spinner-container{display:block;position:relative}.ck.ck-spinner{left:0;margin:0 auto;position:absolute;right:0;top:50%;transform:translateY(-50%);z-index:1}:root{--ck-toolbar-spinner-size:18px}.ck.ck-spinner-container{animation:rotate 1.5s linear infinite;height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}@media (prefers-reduced-motion:reduce){.ck.ck-spinner-container{animation-duration:3s}}.ck.ck-spinner{border:2px solid var(--ck-color-text);border-radius:50%;border-top:2px solid #0000;height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}@keyframes rotate{to{transform:rotate(1turn)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/spinner/spinner.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/spinner/spinner.css"],
          names: [],
          mappings: "AASA,yBACC,aAAc,CACd,iBACD,CAEA,eAGC,MAAO,CAEP,aAAc,CAJd,iBAAkB,CAGlB,OAAQ,CAFR,OAAQ,CAIR,0BAA2B,CAC3B,SACD,CCjBA,MACC,8BACD,CAEA,yBAGC,qCAAsC,CADtC,qCAAsC,CADtC,oCAOD,CAHC,uCALD,yBAME,qBAEF,CADC,CAGD,eAKC,qCAA6B,CAF7B,iBAAkB,CAElB,0BAA6B,CAH7B,qCAAsC,CADtC,oCAKD,CAEA,kBACC,GACC,uBACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\tdisplay: block;\n\tposition: relative;\n}\n\n.ck.ck-spinner {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n\ttransform: translateY(-50%);\n\tz-index: 1;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tanimation: 1.5s infinite rotate linear;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation-duration: 3s;\n\t}\n}\n\n.ck.ck-spinner {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tborder-radius: 50%;\n\tborder: 2px solid var(--ck-color-text);\n\tborder-top-color: transparent;\n}\n\n@keyframes rotate {\n\tto {\n\t\ttransform: rotate(360deg)\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8118: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-textarea{overflow-x:hidden}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/textarea/textarea.css"],
          names: [],
          mappings: "AASA,aACC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/*\n * This fixes a problem in Firefox when the initial height of the complement does not match the number of rows.\n * This bug is especially visible when rows=1.\n */\n.ck-textarea {\n\toverflow-x: hidden\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4893: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"],
          names: [],
          mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6808: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck.ck-toolbar:focus{outline:none}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDwGD,CA3GA,qECOE,qCDoGF,CA3GA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAuGD,CApGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAGD,qBACC,YACD,CAtGD,qCAyGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t/* A drop-down containing the nested toolbar with configured items. */\n\t& .ck-toolbar__nested-toolbar-dropdown {\n\t\t/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */\n\t\t& > .ck-dropdown__panel {\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& > .ck-button > .ck-button__label {\n\t\t\tmax-width: 7em;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2424: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck.ck-balloon-panel.ck-tooltip{--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-tooltip-text-padding:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium);-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;z-index:calc(var(--ck-z-dialog) + 100)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip.ck-tooltip_multi-line .ck-tooltip__text{display:inline-block;max-width:200px;padding:var(--ck-tooltip-text-padding) 0;white-space:break-spaces}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css"],
          names: [],
          mappings: "AAOA,gCCCC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,6BAA8B,CAC9B,8DAA+D,CAE/D,kCAAmC,CCNnC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CFFhB,sCACD,CCMC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAEA,wEAEC,oBAAqB,CAErB,eAAgB,CADhB,wCAAyC,CAFzC,wBAID,CArBD,gCAwBC,eAMD,CAHC,uCACC,YACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t@mixin ck-unselectable;\n\n\tz-index: calc( var(--ck-z-dialog) + 100 );\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t--ck-balloon-border-width: 0px;\n\t--ck-balloon-arrow-offset: 0px;\n\t--ck-balloon-arrow-half-width: 4px;\n\t--ck-balloon-arrow-height: 4px;\n\t--ck-tooltip-text-padding: 4px;\n\t--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n\tpadding: 0 var(--ck-spacing-medium);\n\n\t& .ck-tooltip__text {\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t}\n\n\t&.ck-tooltip_multi-line .ck-tooltip__text {\n\t\twhite-space: break-spaces;\n\t\tdisplay: inline-block;\n\t\tpadding: var(--ck-tooltip-text-padding) 0;\n\t\tmax-width: 200px;\n\t}\n\n\t/* Reset balloon panel styles */\n\tbox-shadow: none;\n\n\t/* Hide the default shadow of the .ck-balloon-panel tip */\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7247: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck-hidden{display:none!important}:root{--ck-z-default:1;--ck-z-panel:calc(var(--ck-z-default) + 999);--ck-z-dialog:9999}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-powered-by-line-height:10px;--ck-powered-by-padding-vertical:2px;--ck-powered-by-padding-horizontal:4px;--ck-powered-by-text-color:#4f4f4f;--ck-powered-by-border-radius:var(--ck-border-radius);--ck-powered-by-background:#fff;--ck-powered-by-border-color:var(--ck-color-focus-border)}.ck.ck-balloon-panel.ck-powered-by-balloon{--ck-border-radius:var(--ck-powered-by-border-radius);background:var(--ck-powered-by-background);box-shadow:none;min-height:unset;z-index:calc(var(--ck-z-panel) - 1)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by{line-height:var(--ck-powered-by-line-height)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by a{align-items:center;cursor:pointer;display:flex;filter:grayscale(80%);line-height:var(--ck-powered-by-line-height);opacity:.66;padding:var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-powered-by__label{color:var(--ck-powered-by-text-color);cursor:pointer;font-size:7.5px;font-weight:700;letter-spacing:-.2px;line-height:normal;margin-right:4px;padding-left:2px;text-transform:uppercase}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-icon{cursor:pointer;display:block}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by:hover a{filter:grayscale(0);opacity:1}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_inside]{border-color:#0000}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_border]{border:var(--ck-focus-ring);border-color:var(--ck-powered-by-border-color)}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:#77baf84d;--ck-color-focus-error-shadow:#ff401f4d;--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:#00000026;--ck-color-shadow-drop-active:#0003;--ck-color-shadow-inner:#0000001a;--ck-color-button-default-background:#0000;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:#0000;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:#0000001a;--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-dialog-background:var(--ck-custom-background);--ck-color-dialog-form-header-border:var(--ck-custom-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:#1fb0ff1a;--ck-color-link-fake-selection:#1fb0ff4d;--ck-color-highlight-background:#ff0;--ck-color-light-red:#fcc;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{word-wrap:break-word;background:#0000;border:0;box-sizing:border-box;height:auto;margin:0;padding:0;position:static;text-decoration:none;transition:none;vertical-align:middle;width:auto}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_poweredby.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"],
          names: [],
          mappings: "AAQA,WAGC,sBACD,CCPA,MACC,gBAAiB,CACjB,4CAA+C,CAC/C,kBACD,CCDA,oDAEC,yBACD,CCNA,MACC,gCAAiC,CACjC,oCAAqC,CACrC,sCAAuC,CACvC,kCAA2C,CAC3C,qDAAsD,CACtD,+BAA4C,CAC5C,yDACD,CAEA,2CACC,qDAAsD,CAGtD,0CAA2C,CAD3C,eAAgB,CAEhB,gBAAiB,CACjB,mCAiDD,CA/CC,6DACC,4CAoCD,CAlCC,+DAGC,kBAAmB,CAFnB,cAAe,CACf,YAAa,CAGb,qBAAsB,CACtB,4CAA6C,CAF7C,WAAY,CAGZ,qFACD,CAEA,mFASC,qCAAsC,CAFtC,cAAe,CANf,eAAgB,CAIhB,eAAiB,CAHjB,oBAAqB,CAMrB,kBAAmB,CAFnB,gBAAiB,CAHjB,gBAAiB,CACjB,wBAOD,CAEA,sEAEC,cAAe,CADf,aAED,CAGC,qEACC,mBAAqB,CACrB,SACD,CAIF,mEACC,kBACD,CAEA,mEACC,2BAA4B,CAC5B,8CACD,CChED,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,0CAA8D,CAC9D,uCAAyD,CACzD,yCAAqD,CACrD,gCAAsD,CACtD,mCAA0D,CAC1D,iCAAsD,CAItD,0CAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,mDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,+CAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,wDAAiE,CACjE,4DAAmE,CAInE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,6CAAmE,CACnE,wCAAgE,CAIhE,oCAAyD,CAIzD,yBAAgD,CChHhD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJgHD,CI1GA,2EAkBC,oBAAqB,CANrB,gBAAuB,CADvB,QAAS,CART,qBAAsB,CAEtB,WAAY,CAIZ,QAAS,CACT,SAAU,CAJV,eAAgB,CAOhB,oBAAqB,CAErB,eAAgB,CADhB,qBAAsB,CAVtB,UAeD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCxFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-panel: calc( var(--ck-z-default) + 999 );\n\t--ck-z-dialog: 9999;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-powered-by-line-height: 10px;\n\t--ck-powered-by-padding-vertical: 2px;\n\t--ck-powered-by-padding-horizontal: 4px;\n\t--ck-powered-by-text-color: hsl(0, 0%, 31%);\n\t--ck-powered-by-border-radius: var(--ck-border-radius);\n\t--ck-powered-by-background: hsl(0, 0%, 100%);\n\t--ck-powered-by-border-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-balloon-panel.ck-powered-by-balloon {\n\t--ck-border-radius: var(--ck-powered-by-border-radius);\n\n\tbox-shadow: none;\n\tbackground: var(--ck-powered-by-background);\n\tmin-height: unset;\n\tz-index: calc( var(--ck-z-panel) - 1 );\n\n\t& .ck.ck-powered-by {\n\t\tline-height: var(--ck-powered-by-line-height);\n\n\t\t& a {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\topacity: .66;\n\t\t\tfilter: grayscale(80%);\n\t\t\tline-height: var(--ck-powered-by-line-height);\n\t\t\tpadding: var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal);\n\t\t}\n\n\t\t& .ck-powered-by__label {\n\t\t\tfont-size: 7.5px;\n\t\t\tletter-spacing: -.2px;\n\t\t\tpadding-left: 2px;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: bold;\n\t\t\tmargin-right: 4px;\n\t\t\tcursor: pointer;\n\t\t\tline-height: normal;\n\t\t\tcolor: var(--ck-powered-by-text-color);\n\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\tdisplay: block;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t&:hover {\n\t\t\t& a {\n\t\t\t\tfilter: grayscale(0%);\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[class*="position_inside"] {\n\t\tborder-color: transparent;\n\t}\n\n\t&[class*="position_border"] {\n\t\tborder: var(--ck-focus-ring);\n\t\tborder-color: var(--ck-powered-by-border-color);\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(220, 6%, 81%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 50.2%, 42.5%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(218.2, 100%, 52.5%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t218, 81.8%, 56.9%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(212.4, 89.3%, 89%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(212, 100%, 97.1%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(211, 15%, 95%);\n\t--ck-color-button-on-color:\t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 57.6%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 49%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Dialog -------------------------------------------------------------------------------- */\n\n\t--ck-color-dialog-background: \t\t\t\t\t\t\t\tvar(--ck-custom-background);\n\t--ck-color-dialog-form-header-border: \t\t\t\t\t\tvar(--ck-custom-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n\n\t/* -- Search result highlight ---------------------------------------------------------------- */\n\n\t--ck-color-highlight-background:\t\t\t\t\t\t\thsl(60, 100%, 50%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------- */\n\n\t--ck-color-light-red:\t\t\t\t\t\t\t\t\t\thsl(0, 100%, 90%);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck-reset_all {\n\t& .ck-rtl *:not(.ck-reset_all-excluded *) {\n\t\ttext-align: right;\n\t}\n\n\t& iframe:not(.ck-reset_all-excluded *) {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *) {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *),\n\t& input[type="text"]:not(.ck-reset_all-excluded *),\n\t& input[type="password"]:not(.ck-reset_all-excluded *) {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n\t\tcursor: default;\n\t}\n\n\t& fieldset:not(.ck-reset_all-excluded *) {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9974: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:#0000;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget{transition:none}}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid #0000}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}@media (forced-colors:none){.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background)}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:initial;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{transition:none}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{transition:none}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CChFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,mBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAcD,CAZC,uCAND,eAOE,eAWF,CAVC,CAEA,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,sBAYD,CARC,yGCnCA,2BAA2B,CCF3B,qCAA8B,CDC9B,YD2CA,CGvCA,4BACC,yGHoCC,iEGlCD,CACD,CHuCA,4EAKC,wBAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAwCD,CA3BC,uCAzBD,4EA0BE,eA0BF,CAzBC,CAEA,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAeD,CAVC,kHACC,SAAU,CAGV,+DAKD,CAHC,uCAND,kHAOE,eAEF,CADC,CAKF,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t\t@mixin ck-media-default-colors {\n\t\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t\t}\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\n\t\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\t\ttransition: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6926: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"],
          names: [],
          mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6021: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([e.id, '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button{transition:none}}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button svg{transition:none}}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button:hover,.ck .ck-widget .ck-widget__type-around__button:hover svg line,.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:none}}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,#fff0,#ffffff4d);border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid #ffffff80;pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:#0000}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"],
          names: [],
          mappings: "AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAwED,CAhEC,uCATD,+CAUE,eA+DF,CA9DC,CAEA,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAwBD,CAlBC,uCAPD,mDAQE,eAiBF,CAhBC,CAEA,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DA4BD,CAtBE,kEACC,oDACD,CAEA,8DACC,wDACD,CAGD,uCAQE,qLACC,cACD,CAEF,CASD,uKA7FD,SAAU,CACV,mBA8FC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,kDAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,2BAAwC,CARxC,mBAUD,CAOC,6JAEC,mBACD,CAUA,yKACC,iDACD,CAMA,uOAxKD,SAAU,CACV,mBAyKC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAxNF,SAAU,CACV,mBAyNE,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\tanimation: none;\n\n\t\t\t\t& svg {\n\t\t\t\t\t& polyline {\n\t\t\t\t\t\tanimation: none;\n\t\t\t\t\t}\n\n\t\t\t\t\t& line {\n\t\t\t\t\t\tanimation: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6314: e => {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var n = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
            }).join("");
          }, t.i = function (e, n, i) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var o = {};
            if (i) for (var r = 0; r < this.length; r++) {
              var s = this[r][0];
              null != s && (o[s] = !0);
            }
            for (var a = 0; a < e.length; a++) {
              var l = [].concat(e[a]);
              i && o[l[0]] || (n && (l[2] ? l[2] = "".concat(n, " and ").concat(l[2]) : l[2] = n), t.push(l));
            }
          }, t;
        };
      },
      4991: e => {
        "use strict";

        function t(e, t) {
          return function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            var n = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
            if (null == n) return;
            var i,
              o,
              r = [],
              s = !0,
              a = !1;
            try {
              for (n = n.call(e); !(s = (i = n.next()).done) && (r.push(i.value), !t || r.length !== t); s = !0);
            } catch (e) {
              a = !0, o = e;
            } finally {
              try {
                s || null == n.return || n.return();
              } finally {
                if (a) throw o;
              }
            }
            return r;
          }(e, t) || function (e, t) {
            if (!e) return;
            if ("string" == typeof e) return n(e, t);
            var i = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === i && e.constructor && (i = e.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(e);
            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return n(e, t);
          }(e, t) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function n(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
          return i;
        }
        e.exports = function (e) {
          var n = t(e, 4),
            i = n[1],
            o = n[3];
          if (!o) return i;
          if ("function" == typeof btoa) {
            var r = btoa(unescape(encodeURIComponent(JSON.stringify(o)))),
              s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r),
              a = "/*# ".concat(s, " */"),
              l = o.sources.map(function (e) {
                return "/*# sourceURL=".concat(o.sourceRoot || "").concat(e, " */");
              });
            return [i].concat(l).concat([a]).join("\n");
          }
          return [i].join("\n");
        };
      },
      5072: (e, t, n) => {
        "use strict";

        var i,
          o = function () {
            return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
          },
          r = function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var n = document.querySelector(t);
                if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                  n = n.contentDocument.head;
                } catch (e) {
                  n = null;
                }
                e[t] = n;
              }
              return e[t];
            };
          }(),
          s = [];
        function a(e) {
          for (var t = -1, n = 0; n < s.length; n++) if (s[n].identifier === e) {
            t = n;
            break;
          }
          return t;
        }
        function l(e, t) {
          for (var n = {}, i = [], o = 0; o < e.length; o++) {
            var r = e[o],
              l = t.base ? r[0] + t.base : r[0],
              c = n[l] || 0,
              d = "".concat(l, " ").concat(c);
            n[l] = c + 1;
            var u = a(d),
              h = {
                css: r[1],
                media: r[2],
                sourceMap: r[3]
              };
            -1 !== u ? (s[u].references++, s[u].updater(h)) : s.push({
              identifier: d,
              updater: f(h, t),
              references: 1
            }), i.push(d);
          }
          return i;
        }
        function c(e) {
          var t = document.createElement("style"),
            i = e.attributes || {};
          if (void 0 === i.nonce) {
            var o = n.nc;
            o && (i.nonce = o);
          }
          if (Object.keys(i).forEach(function (e) {
            t.setAttribute(e, i[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var s = r(e.insert || "head");
            if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            s.appendChild(t);
          }
          return t;
        }
        var d,
          u = (d = [], function (e, t) {
            return d[e] = t, d.filter(Boolean).join("\n");
          });
        function h(e, t, n, i) {
          var o = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
          if (e.styleSheet) e.styleSheet.cssText = u(t, o);else {
            var r = document.createTextNode(o),
              s = e.childNodes;
            s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(r, s[t]) : e.appendChild(r);
          }
        }
        function m(e, t, n) {
          var i = n.css,
            o = n.media,
            r = n.sourceMap;
          if (o ? e.setAttribute("media", o) : e.removeAttribute("media"), r && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = i;else {
            for (; e.firstChild;) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(i));
          }
        }
        var p = null,
          g = 0;
        function f(e, t) {
          var n, i, o;
          if (t.singleton) {
            var r = g++;
            n = p || (p = c(t)), i = h.bind(null, n, r, !1), o = h.bind(null, n, r, !0);
          } else n = c(t), i = m.bind(null, n, t), o = function () {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(n);
          };
          return i(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              i(e = t);
            } else o();
          };
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = o());
          var n = l(e = e || [], t);
          return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var i = 0; i < n.length; i++) {
                var o = a(n[i]);
                s[o].references--;
              }
              for (var r = l(e, t), c = 0; c < n.length; c++) {
                var d = a(n[c]);
                0 === s[d].references && (s[d].updater(), s.splice(d, 1));
              }
              n = r;
            }
          };
        };
      },
      14: e => {
        const t = [{
          app: {
            dashboard: "Dashboard",
            Abschnitt_admin: "Verwaltung",
            section_operation: "Betrieb",
            section_analysis: "Analyse und Statistiken",
            planning: "Programmierung",
            events: "Ereignisse",
            events_movies: "Film",
            events_music_groups: "Künstler / Gruppen",
            events_drama: "Spiele",
            events_service: "Dienstleistungen",
            screenings: "Vorstellungen",
            programmations: "Programme",
            configuration: "Konfiguration",
            users: "Mitarbeiter",
            ticketack_users: "Ticketack Mitarbeiter",
            activities: "Kompetenzen",
            phases: "Phasen",
            sectors: "Sektoren",
            application_types: "Arten von Bewerbungen",
            applications: "Bewerbungen",
            form_layouts: "Forms",
            forms: "Formulare",
            personnal_fields: "Benutzerdefinierte Felder",
            teams: "Teams",
            ex_teams: "Betrieb von Teams",
            hardware: "Hardware",
            setting_and_hardware: "Konfiguration und Hardware",
            configuration_qr_codes: "QR-Codes",
            plan: "Planung",
            resources_keys: "Schlüsselverwaltung",
            places: "Räume",
            pricinglist: "Preisliste",
            email_layouts: "E-Mail-Vorlagen",
            tktInstances: "Ticketack-Instanzen",
            distributors: "Kartenautomaten",
            shop: "Geschäft",
            points_of_sale: "Verkaufsstellen",
            categories: "Kategorien",
            articles: "Artikeln",
            resources: "Ressourcen",
            cashregisters: "Registrierkasse",
            communication: "Kommunikation",
            message: "Nachricht",
            sections: "Abschnitte",
            login: "Anmelden",
            logout: "Abmelden",
            my_profil: "Mein Profil",
            publishing: "Veröffentlichung",
            posts: "Posts",
            channels: "Sendekanäle",
            sales: "Verkauf",
            company: "Unternehmen",
            articles_and_discount: "Produkte und Rabatte",
            tickettypes: "Tickettypen",
            layouts: "PDF-Vorlagen",
            pricinglists: "Preislisten",
            bucketlists: "Vorlagen für Kontingente",
            customers: "Customers",
            table_prev_button: "Vorig",
            table_next_button: "Weiter",
            table_page_label: "Seite",
            table_of_label: "von",
            table_rows_label: "Zeilen",
            table_no_data_message: "Keine Daten gefunden",
            stats: "Statistiken",
            tasks: "Zeitplan",
            salepoints: "Verkaufsstellen",
            post_categories: "Kategorien",
            messages: "Kommunikation",
            settings: "Einstellungen",
            cron_tasks: "Aufgaben",
            hide_sidebar: "Ausblenden",
            abilities: "Rollen",
            history: "Geschichte",
            errors_load_params: "Beim Laden der Einstellungen ist ein Fehler aufgetreten.",
            worker: {
              an_update_is_available: "Ein Update von Kronos ist verfügbar",
              click_here_to_update: "Klicken Sie unten, um Ihre Version von Kronos zu aktualisieren und die neuen Funktionen zu nutzen",
              do_update: "Aktualisieren"
            }
          },
          modules: {
            module_team: "Team-Management",
            module_planning: "Planung",
            module_shop: "Laden",
            module_resources: "Ressourcen",
            module_communications: "Kommunikations",
            module_publishing: "Publishing",
            module_administration: "Administration",
            module_super_admin: "Super admin"
          },
          login: {
            email: "E-mail",
            password: "Passwort"
          },
          users: {
            add_a_user: "Einen Mitarbeiter hinzufügen",
            user: "Mitarbeiter",
            user_plural: "Mitarbeiter",
            profile: "Profil",
            my_profile: "Mein Profil",
            contact: "Kontakt",
            address: "Adresse",
            other_informations: "Sonstige Angaben",
            firstname: "Vorname",
            lastname: "Nachname",
            fullname: "Vollständiger Name",
            email: "E-mail",
            role: "Rolle",
            password: "Passwort",
            password_confirmation: "Passwort (Bestätigung)",
            fix_phone: "Tel. Fest",
            mobile_phone: "Tel. Handy",
            pro_phone: "Tel. Profi",
            fax: "Fax",
            zip: "Postleitzahl",
            city: "Stadt",
            country: "Land",
            birthday: "Geburtsdatum",
            avs: "AVS-Nummer",
            bank: "Bank",
            bic: "BIC",
            iban: "IBAN",
            status: "Status",
            active: "Aktiv",
            inactive: "Inaktiv",
            enable: "Aktivieren",
            disable: "Deaktivieren",
            tkt_instance: "Ticketack-Instanz",
            company_placeholder: "Bitte geben Sie den Namen des Unternehmens ein",
            title_placeholder: "Bitte geben Sie den einen Anrede ein",
            firstname_placeholder: "Bitte geben Sie einen Vornamen ein",
            lastname_placeholder: "Bitte geben Sie einen Nachnamen ein",
            role_placeholder: "Bitte geben Sie eine Rolle ein",
            email_placeholder: "Bitte geben Sie eine E-Mail-Adresse ein",
            invalid_email: "Die angegebene E-Mail-Adresse ist ungültig",
            password_placeholder: "Bitte geben Sie ein Passwort ein",
            phone_placeholder: "Bitte geben Sie eine Telefonnummer ein",
            invalid_phone: "Bitte geben Sie ein gültiges Format ein (9 Ziffern ohne Vorwahl)",
            fax_placeholder: "Bitte geben Sie eine Faxnummer ein",
            address_placeholder: "Bitte geben Sie eine Postanschrift ein",
            zip_placeholder: "Bitte geben Sie eine Postleitzahl ein",
            city_placeholder: "Bitte geben Sie eine Stadt ein",
            country_placeholder: "Bitte geben Sie ein Land ein",
            avs_placeholder: "AVS",
            bank_placeholder: "Bank / KPCh",
            bic_placeholder: "BIC",
            iban_placeholder: "IBAN",
            activities: "Aktivitäten",
            update_my_profile: "Änderung meines Profils",
            update_user: "Bearbeit von {{ firstname }} {{ lastname }}",
            delete_my_profile: "Lösche von mein Profil",
            delete_user: "Lösche von {{ firstname }} {{ lastname }}",
            confirm_delete_my_profile: "Möchten Sie Ihr Konto wirklich löschen?",
            confirm_delete_this_profile: "Möchten Sie diesen Mitarbeiter wirklich löschen?",
            show: "Mitaerbeiter Anzeigen",
            edit: "Edit Mitarbeiter",
            delete: "Mitarbeiter löschen",
            hidden: "Versteckt",
            abilities: {
              users_abilities: "Benutzerspezifische Berechtigungen",
              pick_activities: "Aktivitäten zuweisen",
              enable: "Aktivieren",
              disable: "Deaktivieren",
              read_abilities: "Berechtigungen lesen",
              edit_abilities: "Berechtigungen bearbeiten",
              edit_templates: "Vorlagen bearbeiten"
            },
            skills: "Fähigkeiten",
            user_abilities: "Rechte",
            informations: "Allgemeine Informationen",
            availabilities: "Verfügbarkeiten",
            application: "Bewerbung",
            planning: "Programmierung"
          },
          tktUsers: {
            tktUsers: "Ticketack Mitarbeiters",
            name: "Mitarbeiters Name",
            roles_and_salepoints: "Rollen un Verkaufsstellen",
            role_plural: "Rollen",
            salepoint_plural: "Verkaufsstellen",
            add_a_ticketack_user: "Einen Ticketack Mitarbeiter hinzufügen",
            delete_tktUser: "Möchten Sie diesen Ticketack Mitarbeiter wirklich löschen?",
            change_password: "Ändere Passwort",
            roles_tooltips: {
              admin: "Gibt vollen Zugriff auf das System und die mit dieser Rolle verbundenen Gebühren",
              pos: "Erlaubt den Zugriff auf die Schnittstelle zur Verkaufsstelle (pos = point of sale)",
              "on-site": "Gibt an, dass der Nutzer Teil des Teams vor Ort ist (grundsätzlich mit pos zu verknüpfen), gibt Zugang zu den mit dieser Rolle verbundenen Tarifen",
              partner: "Gibt an, dass der Nutzer Teil des Teams eines Partners ist (grundsätzlich mit pos zu verbinden), gibt Zugang zu den mit dieser Rolle verbundenen Tarifen",
              overbooker: "Gibt an, dass der Nutzer mehr Plätze verkaufen/reservieren darf, als der Raum zulässt (erfordert ein 'overbooking'-Kontingent).",
              transfer: "Erlaubt die Umwandlung von Tickets von einem Tarif in einen anderen",
              accred: "Rolle für Akkreditierungsbeauftragte, (grundsätzlich mit pos zu verbinden), gibt Zugang zu den mit dieser Rolle verbundenen Tarifen",
              ticket_editor: "Zeigt an, dass der Nutzer die Daten eines Tickets ändern kann",
              refund: "Zeigt an, dass der Nutzer Rückerstattungen vornehmen kann",
              wallet_cashier: "Gibt an, dass der Nutzer außerhalb der Verkaufsstelle mit E-Geldbeuteln einkassieren kann (wird z. B. für Bars verwendet, die nicht mit ticketack verwaltet werden)",
              wallet_manager: "Zeigt an, dass der Nutzer E-Geldbeutels gutschreiben kann",
              accounting: "Erlaubt den Zugriff auf die Buchhaltungsdaten der unten angegebenen Verkaufsstellen",
              entry_check: "Sonderrolle für Einlasskontrolleure",
              stats: "Sonderrolle für den Zugang zu Statistiken",
              customer: "Zeigt an, dass der Nutzer über ein Kundenkonto im Ticketverkauf verfügt"
            }
          },
          customers: {
            customer: "Kunde",
            customers: "Kunden",
            add_a_customer: "Einen Kunden hinzufügen",
            passwords_do_not_match: "Die eingegebenen Passwörter stimmen nicht überein!",
            confirm_delete_customer: "Wollen Sie diesen Kunden wirklich löschen?",
            change_password: "Ändern Sie das Passwort.",
            profile: "Anmeldeprofil",
            contact: "Kontakt",
            other_informations: "Weitere Informationen",
            company: "Unternehmen",
            title: "Anrede",
            firstname: "Vorname",
            lastname: "Nachname",
            name: "Benutzername",
            fullname: "Vollständiger Name",
            verified: "Verifiziertes Konto",
            email: "E-Mail",
            salepoint_plural: "Verkaufsstellen",
            password: "Passwort",
            password_confirmation: "Passwort (Bestätigung)",
            phone: "Festnetztelefon",
            cell_phone: "Mobiltelefon",
            address: "Adresse",
            zip: "Postleitzahl",
            city: "Stadt",
            country: "Land",
            age: "Alter",
            birthdate: "Geburtsdatum",
            sex: "Geschlecht",
            language: "Sprache",
            name_placeholder: "Bitte geben Sie einen Benutzernamen ein.",
            firstname_placeholder: "Bitte geben Sie einen Vornamen ein.",
            lastname_placeholder: "Bitte geben Sie einen Nachnamen ein.",
            email_placeholder: "Bitte geben Sie eine E-Mail-Adresse ein.",
            password_placeholder: "Bitte geben Sie ein Passwort ein.",
            phone_placeholder: "Bitte geben Sie eine Festnetznummer ein.",
            cellphone_placeholder: "Geben Sie eine Mobiltelefonnummer ein.",
            invalid_phone: "Bitte geben Sie ein gültiges Format ein (9 Ziffern ohne Vorwahl).",
            address_placeholder: "Geben Sie eine Postanschrift ein.",
            zip_placeholder: "Bitte geben Sie eine Postleitzahl ein.",
            city_placeholder: "Bitte geben Sie eine Stadt ein.",
            country_placeholder: "Bitte geben Sie ein Land ein.",
            age_placeholder: "Bitte geben Sie ein Alter ein.",
            update_customer: "Ändern von {{ firstname }} {{ lastname }}",
            delete_customer: "Löschen von {{ firstname }} {{ lastname }}",
            confirm_delete_this_customer: "Möchten Sie diesen Kunden wirklich löschen?",
            show: "Den Kunden anzeigen",
            edit: "Den Kunden bearbeiten",
            delete: "Den Kunden löschen"
          },
          changelog: {
            changelog: "Changelog",
            features: "Features",
            i18n: "Übersetzungen",
            fixes: "Fixes",
            builds: "Builds",
            ui: "Visuelle Veränderungen"
          },
          sectors: {
            sector: "Sektor",
            sectors_plural: "Sektoren",
            available: "Verfügbare Sektoren",
            your_sectors: "Ihre Sektoren",
            sectors_description: "Wählen Sie die Sektoren, in denen Sie bereit sind zu arbeiten, in der Reihenfolge Ihrer Präferenzen.",
            informations: "Allgemeine Informationen",
            add: "Einen Sektor hinzufügen.",
            name: "Name",
            admins: "Verantwortliche",
            parent: "Übergeordneter Sektor",
            description: "Beschreibung",
            name_placeholder: "Bitte geben Sie einen Namen ein.",
            description_placeholder: "Bitte geben Sie eine Beschreibung ein.",
            confirm_delete: "Wollen Sie diesen Sektor wirklich löschen?",
            update_sector: "Bearbeiten von {{ name }}"
          },
          applicationTypes: {
            applicationType: "Art der Bewerbung",
            applicationTypes_plural: "Arten von Bewerbungen",
            information: "Allgemeine Informationen",
            add: "Bewerbungstyp hinzufügen",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein.",
            description: "Beschreibung",
            description_placeholder: "Bitte geben Sie eine Beschreibung ein.",
            form: "Formular",
            confirm_delete: "Möchten Sie diesen Typ wirklich löschen?",
            update_application_type: "Ändern von {{ name }}",
            notifications: "E-Mail-Benachrichtigungen",
            admins: "Administratoren, die über die Einreichung einer Bewerbung benachrichtigt werden sollen.",
            on_receive_email_id: "E-Mail, die an Administratoren gesendet werden soll, wenn sie eine Bewerbung einreichen.",
            on_submit_email_id: "E-Mail, die nach der Bewerbung an den Bewerber gesendet werden soll.",
            on_approve_email_id: "E-Mail, die an den Bewerber gesendet wird, wenn seine Bewerbung genehmigt wurde.",
            on_reject_email_id: "E-Mail, die an den Bewerber gesendet wird, wenn seine Bewerbung abgelehnt wird.",
            activities: "Kompetenzen",
            activities_to_assign_on_acceptation: "Bei Annahme der Bewerbung zuzuweisen"
          },
          availabilities: {
            availabilities_description: "Geben Sie Ihre Verfügbarkeitszeiträume an.",
            phases_description: "Dies sind die Zeiträume, in denen wir Sie brauchen:",
            add_an_availability: "Fügen Sie einen Verfügbarkeitszeitraum hinzu.",
            from: "Von",
            bis: "Bis"
          },
          places: {
            informations: "Allgemeine Informationen",
            add: "Einen Raum hinzufügen",
            place: "Raum",
            place_plural: "Räume",
            building: "Ort",
            building_placeholder: "Bitte geben Sie einen Ort an",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            number: "Nummer der Kinoleinwand",
            number_placeholder: "Bitte geben Sie eine Nummer ein",
            address: "Adresse",
            address_placeholder: "Bitte geben Sie eine Adresse ein",
            zip: "Postleitzahl",
            zip_placeholder: "Bitte geben Sie eine Postleitzahl ein",
            city: "Stadt",
            city_placeholder: "Bitte geben Sie eine Stadt ein",
            state: "Region",
            state_placeholder: "Bitte geben Sie eine Region ein",
            country: "Land",
            country_placeholder: "Bitte geben Sie ein Land ein",
            coordinates: "Geografische Koordinaten",
            coordinates_lat: "Breitengrad",
            coordinates_lat_placeholder: "Bitte geben Sie einen Breitengrad ein (e.g. 50.081396)",
            coordinates_long: "Längengrad",
            coordinates_long_placeholder: "Bitte geben Sie einen Längengrad ein (e.g. 14.425201)",
            capacity: "Kapazität",
            capacity_total: "Gesamtkapazität",
            capacity_prm: "PRM-Kapazität (in der Gesamtkapazität enthalten)",
            capacity_total_placeholder: "Bitte geben Sie die Gesamtkapazität ein (einschließlich der PRM-Kapazität).",
            capacity_prm_placeholder: "Bitte geben Sie die PRM-Kapazität ein.",
            update_place: "Bearbeit von {{ name }}",
            confirm_delete: "Möchten Sie diesen Raum wirklich löschen?",
            add_map: "Sitzplatzkarte hinzufügen",
            eventival_list_warning: "Sie können keine Räume hinzufügen oder löschen, da Sie eine Integration mit Eventival haben. Nur der Raumplan ist von Kronos aus zugänglich.",
            json_list_warning: "Sie können keine Räume hinzufügen oder löschen, da Sie eine Konfiguration für den Import von Voststellungen aus einer externen Quelle haben. Nur der Sitzplan ist von Kronos aus zugänglich.",
            eventival_form_warning: "Sie können diesen Raum nicht bearbeiten, da Sie eine Integration mit Eventival haben. Nur der Sitzplan und die PRM-Kapazität sind von Kronos aus zugänglich.",
            json_form_warning: "Sie können diesen Raum nicht bearbeiten, da Sie eine Konfiguration für den Import von Vorstellungen aus einer externen Quelle haben. Nur der Sitzplan und die PRM-Kapazität sind von Kronos aus zugänglich.",
            map: {
              seatsmap: "Sitzplatzkarte",
              classic: "Klassisch",
              sofa: "Sofa",
              "sofa-middle": "Sofa Mitte",
              "sofa-left": "Sofa Links",
              "sofa-right": "Sofa Rechts",
              "foldable-seat": "Klappsitz",
              wheelchair: "Rollstuhl",
              nbRows: "Anzahl der Reihen",
              nbColumns: "Anzahl der Spalten",
              overviewTitle: "Übersicht",
              gridParamsTitle: "Parameter",
              zoneOptionsTitle: "Optionen für das zu erstellende Gebiet",
              zoneTitle: "Gebiet {{ name }}",
              seatTitle: "Sitz {{ label }}",
              seatOptions: "Optionen für den Sitz {{ row }}:{{ seat_number }}",
              zoneOptions: "Optionen für die Zone {{ name }}",
              category_and_type: "Kategorie und Typ des Sitzes",
              numbering_options: "Scanoptionen",
              category: "Kategorie",
              zonelabel: "Beschriftung des Gebiets",
              top: "Oben",
              bottom: "Unten",
              seatposition: "Nummerierung der Sitze",
              l2r: "Links nach rechts",
              r2l: "Rechts nach links",
              tblr: "Von oben nach unten UND von links nach rechts",
              btlr: "Unten nach oben UND links nach rechts",
              tbrl: "Oben nach unten UND rechts nach links",
              btrl: "Unten nach oben UND rechts nach links",
              totalSeats: "Sitze insgesamt",
              zoneCoordinates: "Koordinaten des Gebiets",
              label: "Label",
              seattype: "Sitztyp",
              tooltipmsg: "Tab zum Bearbeiten des Sitzes und langes Drücken zum Entfernen/Hinzufügen eines Sitzes aus der Zone",
              seatdetail: "Details zum Sitz",
              startSeatNumber: "Nummer des ersten Sitzes",
              startRowNumber: "Nummer der ersten Reihe",
              saveSeat: "Sitz speichern",
              leaveSeat: "Sitz schließen",
              saveZone: "Bereich speichern",
              leaveZone: "Bereich schließen",
              leaveSelectionOptions: "Auswahl schließen",
              saveCategoryAndType: "Sitzkategorie und -typ speichern.",
              saveNumberingOptions: "Speichern Sie die Scanoptionen.",
              skippedSeatNumber: "Anzahl der zu überspringenden Sitze",
              stagePosition: "Position von Bildschirm/Szene",
              seatNumber: "Sitznummer",
              seatRow: "Seat row",
              number: "Nummer",
              rowType: "Art der Reihe",
              alphabet: "Alphabetisch",
              stagePositions: {
                top: "Nach oben",
                bottom: "Nach unten"
              },
              free: "frei",
              booked: "reserviert"
            },
            import: {
              imported_at: "Import von {{ Datum }}",
              resume: "Zusammenfassung",
              nb_deleted: "{{ nb }} Räume wurden gelöscht",
              nb_inserted: "{{ nb }} Räume wurden neu erstellt",
              nb_updated: "{{ nb }} Räume wurden aktualisiert",
              nb_invalid: "{{ nb }} ungültige(r) Raum(e)",
              inserted: "Raum(e) wurde(n) erstellt",
              updated: "Aktualisierte(r) Raum(e)",
              invalid: "Ungültige(r) Raum(e)",
              an_error_occured: "Bei der Synchronisation ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
              was_useless: "Der Import wurde erfolgreich durchgeführt, hatte aber keine Auswirkungen.",
              places_tab: "Räume"
            }
          },
          pricinglists: {
            _id: "Id",
            informations: "Informationen",
            add: "Preisliste hinzufügen",
            pricinglist_choice: "Eine Preisliste wählen",
            pricinglist: "Preisliste",
            pricinglist_plural: "Preislisten",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            description: "Beschreibung",
            description_placeholder: "Bitte geben Sie eine Beschreibung ein",
            nb_pricings: "Number of pricings",
            update_pricinglist: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this pricing list ?",
            pricings: "Preise",
            add_pricing: "Preise hinzufügen",
            new_pricing: "Neue Preise",
            pricing: {
              name: "Name",
              name_placeholder: "Pricing name",
              description: "Beschreibung",
              description_placeholder: "Bitte geben Sie eine Beschreibung ein",
              price: "Preis",
              value: "Value",
              value_per_screening: "Value by event",
              wallet_amount: "e-Wallet Betrag",
              eligibility: "Erreichbarkeit",
              eligibility_placeholder: "Kurzer Satz für das Personal, das die Tickets scannt...",
              VAT: "MwSt.",
              sellers: "Verkäufer",
              eshop_sort_weight: "Sortierung",
              category: "Kategorie",
              additional_class_names: "CSS-Klasse",
              limit_to_sellers: "Diesen Tarif auf die folgenden Rollen beschränken",
              limit_to_tickettypes: "Diesen Tarif auf die folgenden Tickettyp beschränken",
              exclude_tickettypes: "Diesen Tarif für die folgenden Tickettyp verbieten",
              not_before: "Gültig ab (noch nicht unterstützt)",
              not_after: "Gültig bis (noch nicht unterstützt)",
              pricing_choice: "Pricing wählen",
              pricing_add_layout: "Vorlage hinzufügen",
              refs: "Referenzen",
              tags: "Tags"
            }
          },
          bucketlists: {
            _id: "Benutzername",
            informations: "Allgemeine Informationen",
            add: "Kontingentvorlage hinzufügen",
            bucketlist: "Kontingentvorlage",
            bucketlist_choice: "Kontingentvorlage auswählen",
            bucketlist_plural: "Kontingentvorlagen",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein.",
            nb_buckets: "Anzahl der Kontingente",
            update_bucketlist: "Änderung von {{ name }}",
            confirm_delete: "Wollen Sie diese Kontingentvorlage wirklich löschen?",
            buckets: "Kontingente",
            buckets_maybe_plural: "Kontingent(e)",
            add_bucket: "Ein Kontingent hinzufügen",
            new_bucket: "Neues Kontingent",
            preview: "Vorschau",
            edit: "Bearbeiten",
            apply: "Kontingentvorlage anwenden",
            bucket: {
              bucket_add_layout: "Eine Vorlage hinzufügen",
              id: "Kennung",
              rules: "Regeln",
              can_take_from: "Kann nehmen von",
              capacity: "Kapazität:",
              total_capacity: "Gesamtkapazität",
              full_capacity: "Kapazität des Raumes",
              prm_capacity: "Kapazität für Behinderte (PMR)",
              remainder: "Rest der Kapazität",
              sellers: "Rollen",
              may_steal_from: "Dieses Kontingent kann von folgenden Kontingenten übernommen werden.",
              not_before: "Verfügbar seit",
              not_after: "Verfügbar bis",
              only_for_roles: "Dieses Kontingent auf bestimmte Rollen beschränken.",
              only_for_tickettypes: "Dieses Kontingent auf bestimmte Arten von Tickets beschränken.",
              no_role: "Keine",
              all_roles: "Alle",
              no_role_desc: "Dieses Kontingent kann von keiner Rolle verwendet werden.",
              all_roles_desc: "Dieses Kontingent kann von allen Rollen genutzt werden.",
              add_only_for_roles_rule: "Dieses Kontingent auf bestimmte Rollen beschränken.",
              remove_only_for_roles_rule: "Dieses Kontingent für alle Rollen freigeben.",
              no_tickettype: "Keine",
              all_tickettypes: "Alle",
              no_tickettype_desc: "Dieses Kontingent kann von keiner Ticketart verwendet werden.",
              all_tickettypes_desc: "Dieses Kontingent kann für jede Art von Ticket verwendet werden.",
              add_only_for_tickettypes_rule: "Dieses Kontingent auf bestimmte Arten von Tickets beschränken.",
              remove_only_for_tickettypes_rule: "Dieses Kontingent darf für alle Arten von Tickets verwendet werden.",
              since_always: "immer",
              for_ever: "immer",
              start_at: "Beginn der Vorstellung",
              stop_at: "Ende der Vorstellung",
              tickets: "Arten von Tickets",
              bucket_intern: "Dieses Kontingent wird intern vom System verwendet.",
              stash_bucket: "Dieses Kontingent kann nur einem anderen Kontingent geben."
            }
          },
          cron_tasks: {
            _id: "Benutzername",
            informations: "Allgemeine Informationen",
            add: "Aufgabe hinzufügen",
            cron_task: "Aufgabe",
            cron_task_plural: "Aufgaben",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein.",
            update_cron_task: "Änderung der Aufgabe {{ name }}",
            confirm_delete: "Wollen Sie diese Aufgabe wirklich löschen?",
            frequency: "Häufigkeit",
            request: "Anfrage",
            url: "URL",
            url_placeholder: "Bitte geben Sie die URL der Anfrage ein.",
            method: "HTTP-Methode",
            method_placeholder: "Bitte wählen Sie die zu verwendende Methode aus.",
            interval_description: "{{ nb }} Ausführungen mit dem Status {{ status }} zwischen {{ from }} und {{ to }}",
            nb_executions: "{{ nb }} Ausführungen",
            this_task_is_disabled: "Diese Aufgabe ist inaktiv.",
            disable_this_task: "Deaktivieren Sie diese Aufgabe.",
            enable_this_task: "Aktivieren Sie diese Aufgabe.",
            status_pending: "In der Warteschleife",
            status_in_progress: "In Bearbeitung",
            status_completed: "OK",
            status_failed: "Fehlerhaft"
          },
          roles: {
            default: "Default",
            eshop: "Online Sale",
            "on-site": "On site",
            partner: "Partner",
            accred: "Accred",
            admin: "Admin",
            mobile: "Mobile Anwendung",
            customer: "Kunde (verbunden)",
            pos: "Schnittstelle zur Verkaufsstelle",
            overbooker: "Buchungen erzwingen",
            transfer: "Übertragen",
            ticket_editor: "Ticket-Editor",
            refund: "Erstattung",
            wallet_cashier: "E-Wallet-Zahler",
            wallet_manager: "Manager der elektronischen Brieftasche",
            accounting: "Buchhaltung",
            entry_check: "Eingangsprüfung",
            stats: "Statistik",
            integrator: "Integrator",
            waiter: "Kellner"
          },
          help: {
            display: "Hilfe anzeigen",
            hide: "Hilfe ausblenden"
          },
          statstypes: {
            statstype_plural: "Arten von Statistiken",
            statstype: "Art der Statistik",
            reservations: "Buchungen",
            movie: "Film",
            movies: "Filme",
            ticket: "Fahrkarte",
            price: "Preis",
            entries: "Eintritte",
            prices: "Preise",
            halls: "Säle",
            percentage: "Prozentsatz.",
            income_daily: "Tagesabrechnung",
            box_office: "Box Office",
            income_hourly: "Stundenabrechnung",
            shopping_carts: "Warenkörbe",
            total: "Gesamt",
            screenings: "Vorstellungen",
            screenings_small: "Vorste.",
            show_screenings: "Anziegen die Vorstellungen",
            hide_screenings: "Anziegen die Vorstellungen",
            date: "Datum",
            gross: "Brutto",
            tax: "Lokale Steuer",
            exempt: "Netto",
            deduction: "Abzug",
            ast_text: "Die Einnahmen werden nur für Eintrittskarten berechnet, die Aufteilung der Einnahmen aus der Nutzung von Abonnements wird nicht berechnet. Wenn Sie an den Gesamteinnahmen eines Zeitraums interessiert sind, gehen Sie zum Kontoauszug.",
            print: "Ausdrucken",
            texts: {
              reservations: "Stand der Buchungen",
              movies: "Statistiken nach Film",
              prices: "Besucherstatistiken nach Tarifen",
              halls: "Statistiken nach Saal(en)",
              income_daily: "Eintritte und Einnahmen nach Wochentag",
              box_office: "Top-Eintrittszahlen und -Einnahmen",
              income_hourly: "Einträge und Einnahmen nach Uhrzeit",
              shopping_carts: "Liste der Warenkörbe"
            },
            form: {
              date_start: "Startdatum",
              date_start_tooltip: "Startdatum des Zeitraums, für den Sie sich interessieren",
              date_end: "Enddatum",
              date_end_tooltip: "Enddatum des Zeitraums, für den Sie sich interessieren.",
              cinema: "Kino",
              all_cinemas: "Alle Kinos",
              cinema_tooltip: "Wählen Sie das Kino aus.",
              hall: "Saal",
              all_halls: "Alle Räume",
              hall_tooltip: "Wählen Sie den Raum aus.",
              filters: "Filter",
              search: "Suchen",
              show: "Anzeigen",
              from: "von",
              to: "bis"
            },
            chart: {
              free_entries: "Kostenlos",
              free_entries_small: "Kostenl.",
              pass_entries: "Pass",
              pass_entries_small: "Pass",
              paid_entries: "Kostenpflichtig",
              paid_entries_small: "Kostenp.",
              income: "Einnahmen"
            }
          },
          widgets: {
            delete_confirm: "Wollen Sie dieses Widget wirklich löschen?",
            reset_confirm: "Wollen Sie das Panel wirklich zurücksetzen?",
            reset: "Zurücksetzen",
            edit_dashboard: "Bearbeiten",
            back: "Zurück",
            delete: "Löschen",
            settings_btn: "Einstellungen",
            save: "Speichern",
            cancel: "Abbrechen",
            "24h_revenue": "Rezept (letzte 24 Stunden)",
            "24h_entries": "Einträge (letzte 24 Stunden)",
            "7d_revenue": "Rezept (letzte 7 Tage)",
            "7d_entries": "Eingaben (letzte 7 Tage)",
            title_desc: {
              clock: "Uhr",
              clock_desc: "Zeigt die Uhrzeit und das Datum an.",
              weather: "Wetter",
              weather_desc: "Zeigt das Wetter an.",
              separator: "Trennzeichen",
              separator_desc: "Leerer Raum für das Layout des Dashboards.",
              shortcut: "Abkürzung",
              shortcut_desc: "Abkürzung, die sich an Ihre meistgenutzten Funktionen anpassen lässt.",
              graphBoxOffice: "Box Office",
              graphBoxOffice_desc: "Bestseller & Einnahmen",
              lastEvents: "Letzte Veranstaltungen",
              lastEvents_desc: "Zuletzt erstellte Veranstaltungen"
            },
            settings: {
              parameters: "Einstellungen",
              options: "Anzeigeoptionen",
              width: "Breite",
              color: "Farbe des Textes",
              bgColor: "Hintergrundfarbe",
              bgTransparent: "Transparenter Hintergrund",
              use_current_location: "Aktuelle Position verwenden",
              default: "Standard",
              zipcode: "Postleitzahl (CH)",
              shortcut_target: "Ziel der Abkürzung",
              chose_shortcut: "Abkürzung wählen",
              chose_shortcut_alert: "Bitte wählen Sie ein Ziel für die Abkürzung.",
              time_window: "Zeitraum",
              daily: "Täglich",
              weekly: "Wöchentlich",
              monthly: "Monatlich",
              entries_max: "Anzahl der Einträge",
              eventTypes: {
                movies: "Filme",
                dramas: "Theaterstücke",
                music_groups: "Musikgruppen",
                services: "Dienstleistungen",
                chose_eventType: "Art des Ereignisses",
                chose_event_alert: "Bitte wählen Sie einen Ereignistyp!",
                chose_eventNumber: "Anzahl der Ereignisse",
                latest_movies: "Neueste Filme",
                latest_dramas: "Neueste Theaterstücke",
                latest_groups: "Letzte Gruppen",
                latest_services: "Letzte Dienste",
                "show_event (Veranstaltung)": "Anzeigen",
                new_programming: "Programmieren"
              }
            }
          },
          tickettypes: {
            _id: "Id",
            informations: "Informations",
            add: "Add ticket type",
            tickettype: "ticket type",
            tickettype_plural: "Tickets types",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            description: "Beschreibung",
            description_placeholder: "Bitte geben Sie eine Beschreibung ein",
            renewable: "Erneuerbar",
            renewTypeInformation: {
              one_time_pass_price_information: "Die Preise für Einzelkarten werden in den Preislisten verwaltet.",
              choose_renew_type: "Bitte wählen Sie einen Verlängerungstyp aus.",
              help_text_show: "Die Informationstabelle anzeigen",
              help_text_hide: "Ausblenden der Informationstabelle",
              if_user_renews: "Wenn ein Benutzer verlängert",
              help_description: "In der Tabelle wird das Datum der Verlängerung des Abonnements festgelegt.",
              now_key: "Jetzt",
              expiration_key: "Ablauf",
              "start-of-year_key": "Jahresbeginn",
              latest_key: "So spät wie möglich",
              soonest_key: "Zum frühestmöglichen Zeitpunkt",
              before_expiration_date: "Vor dem Verfallsdatum",
              expiration_date: "Am Verfallsdatum",
              after_expiration_date: "Nach dem Verfallsdatum",
              now: "Jetzt",
              at_expiration_date: "Nach Ablauf des Verfallsdatums",
              start_of_next_year: "Beginn des nächsten Jahres",
              start_of_current_year: "Beginn des laufenden Jahres"
            },
            eshop_sort_weight: "Sortierung",
            update_tickettype: "{{ name }} bearbeiten",
            confirm_delete: "Möchten Sie diese Tickettyp wirklich löschen?",
            pricings: "Preise",
            pricings_maybe_plural: "Preis(e)",
            add_pricing: "Preis hinzufügen",
            new_duplicate_id: "Neue ID",
            id_already_used: "ID existiert bereits",
            pricing: {
              base_informations: "Allgemeine Informationen",
              display: "Anzeige",
              rules: "Regeln",
              name: "Name",
              name_placeholder: "Name des Preises",
              description: "Beschreibung",
              description_placeholder: "Bitte geben Sie eine Beschreibung ein",
              price: "Preis",
              value: "Wert",
              vat: "MwSt.",
              sellers: "Verkäufer",
              eshop_sort_weight: "Sortierung",
              category: "Kategorie",
              additional_class_names: "CSS-Klasse",
              limit_to_sellers: "Diesen Tarif auf die folgenden Rollen beschränken",
              limit_to_tickettypes: "Diesen Tarif auf die folgenden Tickettyp beschränken",
              exclude_tickettypes: "Diesen Tarif für die folgenden Tickettyp verbieten",
              not_before: "Gültig ab (noch nicht unterstützt)",
              not_after: "Gültig bis (noch nicht unterstützt)"
            },
            windows: "Reservierungsfenster",
            windows_maybe_plural: "Reservierungsfenster",
            add_window: "Regel hinzufügen",
            window: {
              screening_id: "Screening ID",
              duration: "Duration",
              start_at: "Für Veranstaltungen, die vor ... beginnen",
              stop_at: "une endet vor",
              nbookings: "Anzahl der Reservierungen",
              nsame_screening: "Für dieselbe Veranstaltung",
              overlap: "Überschneidungsregel",
              same_day: "Am gleichen Tag",
              overlap_question_positive: "Erlauben, dass gebuchte Veranstaltungen sich überschneiden um",
              overlap_question_negative: "Erzwingen, dass gebuchte Ereignisse einen Abstand von"
            },
            add_fields: "Definieren Sie optionale und obligatorische Felder",
            fields: "Felder",
            pdflayouts: "PDF-Vorlagen",
            emails: "E-mails",
            available_fields: {
              requested_description: "Bitte wählen Sie die gewünschten Felder aus",
              required_description: "Bitte wählen Sie die erforderlichen Felder aus",
              company: "Unternehmen",
              title: "Anrede",
              firstname: "Vorname",
              lastname: "Nachname",
              email: "E-Mail",
              address: "Adresse",
              zip: "Postleitzahl",
              city: "Stadt",
              country: "Land",
              phone: "Telefon",
              cellphone: "Mobiltelefon",
              age: "Alter",
              sex: "Geschlecht",
              gift_message: "Geschenk"
            }
          },
          screenings: {
            _id: "Kennung",
            refs: "Referenzen",
            informations: "Allgemeine Informationen",
            add: "Eine Vorstellung hinzufügen",
            screening: "Vorstellung",
            screening_plural: "Vorstellungen",
            name: "Name",
            place: "Ort",
            date: "Datum",
            buckets: "Kontigente",
            description: "Description",
            capacity: "Kapazität",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            description_placeholder: "Bitte geben Sie eine Beschreibung ein",
            capacity_placeholder: "Bitte geben Sie eine Kapazität ein",
            update_place: "Bearbeit von {{ name }}",
            confirm_delete: "Möchten Sie diese Vorstellung wirklich löschen?",
            title: "Titel",
            start_at: "Anfang",
            stop_at: "Ende",
            duration: "Dauer",
            starts: "Beginnt",
            date_disabled_tooltip: "Diese Vorstellung liegt in der Vergangenheit, läuft gerade oder hat bereits Reservierungen. Daher können Sie ihre Termine nicht ändern.",
            map_only_bookings: "Auf Kartenreservierungen",
            sections: "Abschnitte",
            no_section: "Kein Abschnitt",
            _3d: "3D",
            break: "Pause",
            format: "Format",
            version: "Version",
            version_small: "Vers.",
            week: "Woche",
            week_small: "Woch.",
            details: "Details",
            events: "Ereignisse",
            add_event: "Ein Ereignis hinzufügen",
            update_screening: "Bearbeit von {{ title }}",
            tasks: "Jobs",
            posters: "Bilder",
            add_poster: "Ein Bild hinzufügen",
            support: "Support",
            languages: "Sprachen",
            audio: "Audio",
            subtitles: "Untertitel",
            ignore_on_maccsbox: "Ignoriert auf Maccsbox",
            list: {
              total: "Total",
              confirmed: "Reserviert",
              unconfirmed: "verarbeitet wird",
              available: "verfügbar"
            },
            edit: {
              itemlist: {
                general: "Allgemein",
                bucket: "Kontigente",
                booking: "Reservationen",
                pricing: "Preise",
                history: "Logs",
                map: "Karte"
              },
              form: {
                original: "Original",
                name_placeholder: "Name der Vorstellung",
                description_placeholder: "Beschreibung der Vorstellung",
                note_placeholder: "Eine interne Anmerkung, nicht sichtbar öffentlich",
                general: {
                  names: "Namen",
                  descriptions: "Beschreibung",
                  place: "Ort",
                  dates: "Datums",
                  start_at: "Anfangsdatum",
                  stop_at: "Enddatum",
                  description: "Beschreibung",
                  note: "Anmerkung",
                  save_names: "Namen speichern",
                  save_place: "Ort speichern",
                  save_dates: "Datum speichern",
                  save_descriptions: "Beschreibung speichern",
                  save_note: "Anmerkung speichern",
                  save_pricings: "Preistabelle speichern"
                },
                buckets: {
                  id: "Identifikator",
                  rules: "Regeln",
                  can_take_from: "Kann stehlen von",
                  bookings: "Buchungen",
                  capacity: "Kapazität",
                  total_capacity: "Total",
                  no_role: "Keine",
                  all_roles: "Alle",
                  no_tickettype: "Keine",
                  all_tickettypes: "Alle",
                  since_always: "Seit jeher",
                  for_ever: "Für immer",
                  sellers: "Rollen",
                  not_before: "Verfügbar seit",
                  not_after: "Verfügbar bis",
                  tickets: "Tickettypen",
                  bucket_intern: "Dieses Kontingent ist nur beim System beandert",
                  stash_bucket: "Dieses Kontingent kann nur einem anderen geben"
                },
                logs: {
                  checkin: "Eingangsscan",
                  checkout: "Ausgangsscan",
                  confirm_booking: "Reservierung",
                  activate: "Tickets Aktivierung",
                  unbook: "Reservieierungs Stornierung",
                  date: "Datum",
                  action: "Aktion",
                  ticket: "Ticket",
                  by: "bei"
                },
                ticket: {
                  id: "Id",
                  one_time_pass: "Ticket pour séance unique",
                  new: "Neu",
                  activated: "gekauft",
                  blocked: "Blocked",
                  pending: "Warten auf Zahlung",
                  type: "Typ",
                  pricing: "Tarif",
                  value: "Wert",
                  booking_date: "Buchungsdatum",
                  status: "Status",
                  name: "Name",
                  email: "Email",
                  tel: "telefon",
                  nb_bookings: "{{ nb }} Buchungsdatum",
                  seats: "Sitzplatz",
                  scanned: "Scanned",
                  in_room: "Inside"
                },
                maps: {
                  change_map: "Raum ändern"
                }
              }
            },
            import: {
              imported_at: "Importiert am {{ date }}",
              resume: "Kurz und bündig",
              nb_deleted: "{{ nb }} Vorführungen wurden gelöscht.",
              nb_inserted: "{{ nb }} Vorführungen wurden erstellt.",
              nb_updated: "{{ nb }} Vorführungen wurden aktualisiert.",
              nb_invalid: "{{ nb }} Vorführungen sind ungültig.",
              inserted: "Erstellte(s) Screening(s)",
              updated: "Aktualisierte Überprüfung(en)",
              invalid: "Ungültige(s) Screening(s)",
              an_error_occured: "Bei der Synchronisierung ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
              was_useless: "Der Import war erfolgreich, hatte aber keine Auswirkungen.",
              screenings_tab: "Vorstellungen"
            }
          },
          tickets: {
            ticket: "Ticket",
            ticket_plural: "Tickets",
            status: {
              all: "Alle Status",
              new: "Neu",
              pending: "Wartet auf Zahlung",
              activated: "Aktiviert",
              blocked: "Gesperrt"
            },
            filters: {
              search: "Suche",
              search_placeholder: "Name, Vorname, E-Mail oder ID",
              status: "Status",
              tickettypes: "Ticketarten",
              filter_on_batches: "Nach Importen filtern",
              imported_at: "Tickets, die beim Import erstellt wurden, am",
              activated_at: "Tickets, die beim Import aktiviert wurden, am",
              filter_on_emails: "Nach erhaltenen E-Mails filtern",
              received_email: "Tickets, die diese E-Mail erhalten haben",
              received_email_placeholder: "Bitte wählen Sie eine E-Mail aus",
              not_received_email: "Tickets, die diese E-Mail nicht erhalten haben",
              not_received_email_placeholder: "Bitte wählen Sie eine E-Mail",
              filter_on_bookings: "Nach Reservierungen filtern",
              having_booked: "Tickets, die mindestens eine Reservierung haben",
              having_not_booked: "Tickets, die keine Reservierung haben",
              having_booked_screening_id: "Tickets, die diese Sitzung gebucht haben",
              having_booked_screening_id_placeholder: "Bitte wählen Sie eine Vorstellung"
            },
            columns: {
              _id: "Zugangsdaten",
              owner: "Inhaber",
              firstname: "Vorname",
              lastname: "Name",
              email: "E-mail",
              status: "Status",
              type: "Typ",
              activated_pricing: "Preis",
              nbookings: "Reservierungen"
            },
            created_at: "Erstellt am",
            import: {
              title: "Tickets importieren",
              desc: "Mit dem Ticketimport können Sie Tickets aus einer CSV-Datei importieren.",
              download_csv_file: "Download der CSV-Vorlagendatei",
              download_xlsx_file: "Download der xlsx-Vorlagendatei",
              tab_title: "Fahrkarten",
              file_goods: "Sie sind dabei, {{ nb }} Tickets zu importieren",
              file_errors: "Sie haben {{ nb }} Fehler in Ihrer CSV-Datei",
              file_errors_desc: "Bitte korrigieren Sie Ihre Datei und reichen Sie sie erneut ein",
              x_tickets_of_type: "{{ nb }} Tickets des Typs {{ name }}",
              x_tickets_of_price: "{{ nb }} Tickets zum Preis {{ name }}",
              send_x_emails: "Senden von {{ nb }} E-Mails",
              send_x_emails_of_type: "Senden von {{ nb }} E-Mails {{ name }}",
              choose_csv_file: "Bitte wählen Sie eine CSV-Datei",
              do_import: "Import starten",
              do_another_import: "Andere Datei importieren",
              line_x: "Zeile {{ line }}",
              preview_view: "Vorschau",
              resume_view: "Zusammenfassung",
              field_is_invalid: "Die Zelle {{ field }} ist ungültig",
              an_error_occured: "Während des Imports ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
              columns: {
                line: "Zeile",
                nb: "Anzahl",
                type: "Typ",
                pricing: "Preis",
                title: "Titel",
                firstname: "Vorname",
                lastname: "Nachname",
                email: "E-Mail",
                zip: "Zip",
                city: "Stadt",
                country: "Land",
                Foto: "Foto",
                Cellphone: "Telefon",
                sex: "Geschlecht",
                age: "Alter",
                language: "Sprache",
                company: "Unternehmen",
                screening: "Sitzung",
                row: "Rang",
                seat: "Nummer",
                prefix: "PDF-Präfix"
              },
              imported_at: "Import von {{ date }}",
              resume: "Zusammenfassung",
              nb_deleted: "{{ nb }} Banknoten wurden gelöscht",
              nb_inserted: "{{ nb }} Banknoten wurden erstellt",
              nb_updated: "{{ nb }} Banknoten wurden aktualisiert",
              nb_activated: "{{ nb }} Banknoten wurden aktiviert",
              nb_invalid: "{{ nb }} ungültige(r) Flugschein(e)",
              inserted: "Flugschein(e) erstellt",
              updated: "Flugschein(e) aktualisiert",
              activated: "Flugschein(e) aktiviert",
              invalid: "Flugschein(e) ungültig"
            },
            batch: {
              send_email: "Eine E-Mail senden"
            }
          },
          programmations: {
            add: "Programmierung hinzufügen",
            programmation: "Programmierung",
            programmation_plural: "Programmierungen",
            update_place: "Änderung",
            confirm_delete: "Möchten Sie diese Programmierungen wirklich löschen?",
            title: "Titel der Vorstellungen",
            title_placeholder: "Bitte geben Sie einen Titel für Vorstellungen ein",
            description: "Beschreibung der Vorstellung",
            timing: "Timing",
            days: "Tage",
            hours: "Stunden",
            period: "Dauer",
            start_at: "Anfang",
            stop_at: "Ende",
            _3d: "3D",
            break: "Pause",
            format: "Format {{ format }}",
            version: "Version {{ version }}",
            week: "Woche {{ week }}",
            details: "Optionen",
            events: "Ereignisse",
            add_event: "Ein Ereignis hinzufügen",
            update_programmation: "Änderung",
            all_days: "Jeden Tag",
            each_days: "Alle {{ days }}",
            at: "um {{ time }}",
            in_the_place: "im Raum {{ place }}",
            pricinglist: "Preisliste {{ pricinglist }}",
            bucketlist: "Kontingentvorlage {{ bucketlist }}",
            x_screenings: "{{ nb }} sitzungen",
            ignored_on_maccsbox: "Auf Maccsbox ignoriert.",
            copy_options_to_other: "Kopiere diese Optionen überall hin.",
            screenings: "Vorstellungen",
            generate_screenings: "Die Vorstellungen generieren",
            see_x_screenings: "Die {{ nb }} Vorstellungen sehen",
            regenerate_screenings: "Die Vorstellungen wieder generieren",
            tasks: "Jobs",
            support: "Support",
            support_dcp: "DCP",
            support_dvd: "DVD",
            support_blu_ray: "Blu-ray",
            support_video_file: "Videodatei",
            support_other: "andere",
            section: "Abschnitt",
            languages: "Sprachen",
            audio: "Audio",
            subtitles: "Untertitel",
            ignore_on_maccsbox: "Ignoriert auf Maccsbox",
            booking_option: "Buchungsoption",
            booking_mode: {
              title: "Art der Reservierung",
              normal: "Ticketack",
              free: "Freier Eintritt (ohne Gratistickets oder Kapazitätskontrollen)",
              free_placeholder: "Zusätzliche Anweisungen (optional)",
              email: "Reservierung per E-Mail",
              email_placeholder: "E-Mail-Adresse des Ansprechpartners",
              other: "Reservierung über eine Url",
              other_placeholder: "Zusätzliche Anweisungen, Link zum anderen System (optional)."
            }
          },
          tktInstances: {
            is_active: "Aktiv",
            informations: "Informationen",
            add: "Eine Ticketack-Instanz hinzufügen",
            tktInstance: "Ticketack-Instanz",
            tktInstance_plural: "Ticketack-Instanzen",
            name: "Name",
            slug: "Slug",
            engine_url: "Engine-URL",
            solego_url: "Solego URL",
            api_key: "API-Schlüssel",
            email: "E-Mail",
            name_placeholder: "Bitte geben Sie den Namen der Instanz ein",
            slug_placeholder: "Bitte geben Sie den Slug der Instanz ein",
            engine_url_placeholder: "Bitte geben Sie die Engine-URL ein",
            solego_url_placeholder: "Bitte geben Sie die solego URL ein",
            api_key_placeholder: "Bitte geben Sie Ihren API-Schlüssel ein",
            email_placeholder: "Bitte geben Sie Ihren E-Mail ein",
            options: "Optionen",
            languages: "Languages",
            modules: "Module",
            sms_username: "SMS Benutzer",
            sms_username_placeholder: "Bitte geben Sie den zu verwendenden SMS-Benutzer ein",
            sms_password: "SMS Passwort",
            sms_password_placeholder: "Bitte geben Sie das SMS-Passwort ein",
            update_tktInstance: "Bearbeit von {{ url }}",
            delete: "Löschung von der {{name}} Instanz",
            confirm_delete: "Möchten Sie diese Ticketack-Instanz wirklich löschen?"
          },
          abilities: {
            abilities_template: "Rechte Schablonen",
            name: "Name",
            template: "Schablone",
            create: "Schaffung",
            read: "Vorlesung",
            edit: "Auflage",
            delete: "Streichung",
            all: "Alles",
            self: "Selbst",
            other: "Andere",
            apply_template: "Wenden Sie das Schablone an",
            chose_abilities_placeholder: "Aussuchen",
            create_empty_field_name: "Bitte füllen Sie dieses Feld aus",
            create_name_already_used: "Dieser Name wird bereits verwendet",
            forbidden: "Verboten",
            forbidden_message: "Es scheint, dass Sie nicht die Rechte haben, auf diese Seite zuzugreifen.",
            home: "Startseite",
            layouts: "PDF- und E-Mail-Vorlagen"
          },
          resources: {
            informations: "Informationen",
            add: "Einen Schlüssel hinzufügen",
            number: "Nummer",
            number_placeholder: "Bitte geben Sie eine Nummer ein",
            type: "Typ",
            type_placeholder: "Bitte geben Sie einen Typ ein",
            comment: "Bemerkung",
            comment_placeholder: "Bitte geben Sie eine Bemerkung ein",
            user: "Benutzer",
            resource: "Schlüssel",
            resource_plural: "Schlüssel",
            update_resource: "Bearbeit von {{number}}",
            confirm_delete: "Möchten Sie diesen Schlüssel wirklich löschen?"
          },
          distributors: {
            informations: "Informationen",
            add: "Einen Distributor hinzufügen",
            distributor: "Distributor",
            distributor_plural: "Kartenautomaten",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            maccsbox_id: "Maccsbox-ID",
            contact_mail: "Kontakt E-Mail",
            report_mail: "Meldung E-Mail",
            maccsbox_id_placeholder: "Bitte geben Sie eine Maccsbox ID ein",
            contact_mail_placeholder: "E-Mail des Ditributor",
            report_mail_placeholder: "E-Mail, um den Meldung zu senden",
            address: "Adresse",
            address_placeholder: "Bitte geben Sie eine Adresse ein",
            zip: "Postleitzahl",
            zip_placeholder: "Bitte geben Sie eine Postleitzahl ein",
            city: "Stadt",
            city_placeholder: "Bitte geben Sie eine Stadt ein",
            country: "Land",
            country_placeholder: "Bitte geben Sie ein Land ein",
            update_distributor: "Bearbeit von {{ name }}",
            confirm_delete: "Möchten Sie diesen Distributor wirklich löschen"
          },
          events: {
            informations: "Allgemeine Informationen",
            add_movie: "Einen Film hinzufügen",
            add_artist: "Hinzufügen eines Künstlers",
            add_play: "Hinzufügen eines Stücks",
            add_service: "Hinzufügen eines Dienstes",
            sync_and_import: "Synchronisation und Import",
            tktsync_kronos: "Mit Ticketack synchronisieren",
            tktsync_eventival: "Eventival-Synchronisation",
            tktsync_json: "Synchronisation mit externer Quelle",
            tktsync_cinech: "Synchronisation mit Ciné.ch",
            tktsync_kronos_desc_screenings: "Die Synchronisation mit Ticketack ermöglicht es Ihnen, die Vorstellungen in Ihrem Ticketbüro auf der Grundlage Ihrer Kronos-Programme zu erstellen.",
            tktsync_kronos_desc_places: "",
            tktsync_eventival_desc_screenings: "Die Synchronisation mit Eventival ermöglicht es Ihnen, die Vorstellungen in Ihrem Ticketshop auf der Grundlage Ihres Programms auf Eventival zu erstellen.",
            tktsync_eventival_desc_places: "Die Säle werden von Eventival nach Ticketack kopiert.",
            tktsync_json_desc_screenings: "Die Synchronisation mit Ihrer externen Quelle ermöglicht es Ihnen, die Vorstellungen in Ihrem Ticketverkauf von dieser Quelle aus zu erstellen.",
            tktsync_json_desc_places: "Die Räume werden von dieser Quelle nach Ticketack kopiert.",
            tktsync_cinech_desc_screenings: "Die Synchronisation ermöglicht es Ihnen, die Vorstellungen in Ihrem Ticketsystem auf der Grundlage Ihres Programms auf Ciné.ch zu erstellen.",
            tktsync_cinech_desc_places: "Die Säle werden von Ciné.ch nach Ticketack kopiert.",
            tktsync_delete_future: "Zukünftige Vorstellungen werden zu Beginn der Synchronisation gelöscht.",
            tktsync_delete_existing: "Bestehende Vorstellungen werden gelöscht, bevor sie aktualisiert werden.",
            tktsync_no_delete: "Es werden keine Vorstellungen gelöscht.",
            sync_screenings_tab_kronos: "Sitzungen",
            sync_screenings_tab_eventival: "Sitzungen und Säle",
            sync_screenings_tab_json: "Sitzungen und Säle",
            sync_screenings_tab_cinech: "Sitzungen und Säle",
            run_tktsync: "Synchronisierung starten",
            event: "Ereignis",
            event_plural: "Ereignisse",
            title: "Titel",
            original_title: "Original-Titel",
            type: "Typ",
            description: "Beschreibung",
            title_placeholder: "Bitte geben Sie einen Titel ein",
            original_title_placeholder: "Bitte geben Sie einen Original-Titel ein",
            description_placeholder: "Bitte geben Sie eine Beschreibung ein",
            duration: "Dauer (min)",
            details: "Details",
            suisa: "SUISA",
            movie_link: "Offizielle Website",
            distributor: "Distributor",
            year: "Jahr",
            suisa_placeholder: "Bitte geben Sie eine SUISA-Nummer ein",
            movie_link_placeholder: "https://kronos.ticketack.com",
            year_placeholder: "Bitte geben Sie ein Erscheinungsjahr ein",
            l_min_age: "Gesetzliches Mindestalter.",
            s_min_age: "Empfohlenes Mindestalter.",
            a_min_age: "Mindestalter akzeptiert.",
            l_min_age_placeholder: "Bitte geben Sie ein gesetzliches Mindestalter ein",
            s_min_age_placeholder: "Bitte geben Sie ein empfohlenes Mindestalter ein",
            a_min_age_placeholder: "Bitte geben Sie ein Mindestalter ein",
            free_texts: "Freie Felder",
            free_text: "Felder",
            add_poster: "Ein Bild hinzufügen",
            posters: "Bilder",
            add_trailer: "Ein Video hinzufügen",
            trailers: "Videos",
            new_trailer_youtube_placeholder: "Geben Sie die ID eines auf Youtube gehosteten Videos ein",
            new_trailer_vimeo_placeholder: "Geben Sie die ID eines auf Vimeo gehosteten Videos ein",
            new_trailer_mp4_placeholder: "Geben Sie die Adresse einer Videodatei ein",
            genre: "Geschlecht",
            service_type: "Typ der Dienstleistung",
            add_section: "Eine Kategorie hinzufügen",
            update_event: "Bearbeit von {{ title }}",
            confirm_delete: "Möchten Sie dieses Ereignis wirklich löschen?",
            casting: "Guss",
            scheduling: "Zeitplan",
            new_people_firstname_placeholder: "Bitte geben Sie einen Vornamen ein",
            new_people_lastname_placeholder: "Bitte geben Sie einen Namen ein",
            activity_actor: "Schauspieler",
            activity_cast: "Guss",
            activity_director: "Regisseur",
            activity_editor: "Redaktionsleiter",
            activity_photography: "Kameramann",
            activity_music: "Musik",
            activity_producer: "Filmproduzent",
            activity_screenplay: "Filmautor",
            countries: "Land",
            original_language: "Originalsprache",
            subevent: {
              movie: "Film",
              drama: "Theaterstück",
              music_group: "Künstler/Gruppe",
              service: "Andere Aktivitäten"
            },
            subevents: {
              movie: "Filme",
              drama: "Theaterstücke",
              music_group: "Künstler/Gruppe",
              service: "Andere Aktivitäten",
              mine_movie: "Meine Filme",
              mine_drama: "Meine Theaterstücke",
              mine_music_group: "Meine Künstler/Gruppen",
              mine_service: "Meine anderen Aktivitäten",
              all_movie: "Alle Filme",
              all_drama: "Alle Theaterstücke",
              all_music_group: "Alle Künstler/Gruppen",
              all_service: "Alle anderen Aktivitäten"
            },
            search_placeholder: {
              movie: "Einen Film nach seinem Titel oder seiner SUISA-Nummer suchen.",
              drama: "Suche nach dem Namen eines Theaterstücks",
              music_group: "Suche nach einem Künstler oder einer Gruppe anhand des Namens.",
              service: "Suche nach einer anderen Aktivität durch ihren Namen"
            },
            add: {
              event: "Ein Ereignis hinzufügen",
              movie: "Einen Film hinzufügen",
              drama: "Ein Theaterstück hinzufügen",
              music_group: "Künstler/Gruppe hinzufügen",
              service: "Eine weitere Aktivität hinzufügen"
            },
            id: "Identifikator :",
            reference: "Referenz :"
          },
          common: {
            loading: "Laden ...",
            back: "Zurück",
            save: "Speichern",
            apply: "Bewerben",
            add: "Hinzufügen",
            cancel: "Stornieren",
            close: "Schließen",
            delete: "Löschen",
            edit: "Bearbeiten",
            duplicate: "Duplikat",
            copy_to_mine: {
              movie: "Kopieren in meine Filme",
              drama: "Kopieren in meine Theaterstücke",
              music_group: "Kopieren in meine Künstler/Gruppen",
              service: "Kopieren in meine anderen Aktivitäten"
            },
            actions: "Aktionen",
            show_options: "Optionen anzeigen",
            hide_options: "Optionen ausblenden",
            and: "und",
            see: "Ansicht",
            mo: "MO",
            tu: "Di",
            we: "MI",
            th: "DO",
            fr: "FR",
            sa: "SA",
            su: "SO",
            day: "Tag(e)",
            week: "Woche(n)",
            cinema_week: "Filmwoche(n).",
            month: "Monat(en)",
            year: "Jahr(e)",
            me: "Mir",
            no: "Nein",
            yes: "Ja",
            other: "Oder",
            are_you_sure: "Sind Sie sicher?",
            drag_one_file: "Ziehen Sie eine Datei hierher, oder klicken Sie, um sie auszuwählen.",
            yellow: "Gelb",
            yellow2: "Gelb alt.",
            magenta: "Magenta",
            magenta2: "Magenta alt.",
            green: "Grün",
            green2: "Grün alt.",
            red: "Rot",
            red2: "Rot alt.",
            blue: "Blau",
            blue2: "Blau alt.",
            white: "Weiß",
            black: "Schwarz",
            brown: "Braun",
            brown2: "Braun alt.",
            grey: "Grau",
            grey2: "Grau alt.",
            none: "Keine",
            invalid_id_input: "Bitte verwenden Sie nur Zahlen, Buchstaben oder das Zeichen _.",
            image_types: {
              default: "Standaard",
              banner: "Banner",
              logo: "Web-Logo (300px empfohlen)",
              slider: "Slider",
              poster: "Poster",
              "logo-a4": "Logo für A4 PDF",
              "logo-thermal": "Logo für Thermodruck (Schwarz/Weiß)",
              favicon: "Favicon (32x32px empfohlen)",
              appicon: "Web-App-Icon (192x192px empfohlen)",
              partners: "Partnerlogos",
              "partners-a4": "Partnerlogos für PDF A4",
              "partners-thermal": "Partnerlogos für den Thermodruck (Schwarz/Weiß)"
            },
            link_types: {
              article: "Artikel",
              category: "Artikel categorie",
              movie: "Film",
              screening: "Vertoning",
              url: "Url"
            },
            grammes: "gramm",
            mini_grammes: "g",
            centimeters: "Zentimeter",
            mini_centimeters: "cm",
            duration: {
              years: "Jahre",
              months: "Monate",
              days: "Tage",
              hours: "Stunden",
              Minuten: "Minuten",
              none: "Keine Dauer",
              custom: "Benutzerdefinierte Dauer",
              PT5M: "5 Minuten",
              PT10M: "10 Minuten",
              PT15M: "15 Minuten",
              PT30M: "30 Minuten",
              PT45M: "45 Minuten",
              PT1H: "1 Stunde",
              PT6H: "6 Stunden",
              PT12H: "12 Stunden",
              P1D: "1 Tag",
              P7D: "1 Woche",
              P1M: "1 Monat",
              P6M: "6 Monate",
              P1Y: "1 Jahr",
              P1Y6M: "18 Monate"
            },
            sex: {
              "n/c": "Keine Antwort",
              m: "Männlich",
              f: "Weiblich",
              o: "Andere"
            }
          },
          languages: {
            ov: "Originalversion",
            fr: "Französisch",
            de: "Deutsch",
            en: "Englisch",
            it: "Italienisch",
            gsw: "Schweizerdeutsch",
            fr_de: "Französisch & Deutsch"
          },
          posts: {
            informations: "Allgemeine Informationen",
            add: "Beitrag hinzufügen",
            post: "Beitrag",
            post_post: "Beitrag",
            post_plural: "Beiträge",
            name: "Name",
            title: "Titel",
            title_placeholder: "Bitte geben Sie einen Titel ein",
            sub_title: "Untertitel",
            sub_title_placeholder: "Bitte geben Sie einen Untertitel ein",
            content: "Meldung",
            content_placeholder: "Bitte geben Sie eine Nachricht ein",
            category: "Kategorie",
            choose_a_category: "Bitte wählen Sie eine Kategorie",
            tags: "Tags",
            posters: "Bilder",
            add_poster: "Ein Bild hinzufügen",
            trailers: "Videos",
            add_trailer: "Ein Video hinzufügen",
            published: "Veröffentlicht",
            archived: "archiviert",
            channels: "Broadcast channels",
            confirm_delete: "Wollen Sie diesen Beitrag wirklich löschen?",
            update_post: "Änderung von {{ name }}",
            show_all_categories: "Alle Kategorien",
            filter_by_category: "Categories",
            please_create_category: "Bitte erstellen Sie eine Kategorie",
            please_choose_category_or_make_a_search: "Bitte wählen Sie eine Kategorie oder machen Sie eine Suche",
            search: "Nachricht suchen",
            search_placeholder: "Geben Sie einen Nachrichtentitel ein",
            links: "links",
            please_create_link: "Selecteer een link type",
            links_placeholder_url: "Voer een url in https://www.url.com/{lang}",
            links_placeholder_article: "Voer het id van een artikel in",
            links_placeholder_category: "Voer het id van een artikel categorie in",
            links_placeholder_movie: "Voer het id van een film in",
            links_placeholder_screening: "Voer het id van een programma in"
          },
          post_categories: {
            Informationen: "Informationen",
            hinzufügen: "Einen Punkt der Kategorie hinzufügen",
            Veröffentlichung: "Veröffentlichung",
            post_category: "Kategorie",
            post_categories_plural: "Kategorien",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            confirm_delete: "Wollen Sie diesen Punkt der Katégorie wirklich löschen?",
            choose_a_category: "Bitte wählen Sie eine Kategorie",
            update_postcategory: "bearbeiten {{ name }}"
          },
          salepoints: {
            informations: "Allgemeine Informationen",
            add: "Eine Verkaufsstelle hinzufügen",
            salepoint: "Verkaufsstelle",
            salepoint_plural: "Verkaufsstellen",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            delivery_types: "Zustellungsarten",
            update_salepoint: "Bearbeit von {{ name }}",
            confirm_delete: "Möchten Sie diese Verkaufstelle wirklich löschen?",
            choose_a_salepoint: "Bitte wählen Sie eine Verkaufsstelle",
            default: "Standard",
            settings: "Customised configuration for this salepoint",
            pos_layout: "Verkaufsschnittstelle",
            layouts: {
              tickets: "Ticketing",
              articles: "Artikeln"
            },
            sell_pass: "Ermöglicht den Verkauf von Abonnements",
            places_ids: "Mit folgenden Räumen verknüpfen"
          },
          channels: {
            informations: "Allgemeine Informationen",
            add: "Kanal hinzufügen",
            publishing: "Veröffentlichung",
            channel: "Kanal",
            channels_plural: "Kanäle",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            confirm_delete: "Willst du diesen Kanal wirklich löschen?",
            choose_a_channel: "Bitte wählen Sie einen Kanal",
            update_channel: "Modifizierung des {{ name }}",
            salepoint: "Verkaufsstelle",
            cashregister: "Registrierkasse",
            slug: "Unique identifier",
            active_from: "Aktiv von",
            active_until: "Aktiv bis",
            only_for_roles: "Nur für folgende Rollen"
          },
          phases: {
            informations: "Allgemeine Informationen",
            add: "Eine Phase hinzufügen",
            phase: "Phase",
            phases_plural: "Phases",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            confirm_delete: "Möchten Sie diese Phase wirklich löschen ?",
            update_phase: "Bearbeit von {{ name }}",
            active_from: "Aktiv von",
            active_until: "Aktiv bis",
            from_to: "Vom {{ from }} bis zum {{ to }}"
          },
          articlecategories: {
            informations: "Allgemeine Informationen",
            add: "Eine Kategorie hinzufügen",
            articlecategory: "Kategorie",
            articlecategory_plural: "Kategorien",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            parent: "Übergeordnete Kategorie",
            description: "Beschreibung",
            pos: "Verkaufsstelle",
            add_poster: "Ein Bild hinzufügen",
            posters: "Bilder",
            update_salepoint: "Bearbeit von {{ name }}",
            update_articlecategory: "Kategorie bearbeiten",
            confirm_delete: "Möchten Sie diese Kategorie wirklich löschen?",
            choose_a_category: "Bitte wählen Sie eine Kategorie",
            please_choose_category: "Bitte wählen Sie eine Kategorie aus."
          },
          articles: {
            informations: "Allgemeine Informationen",
            add: "Artikel hinzufügen",
            add_discount_code: "Rabattcode hinzufügen",
            add_manual_discount: "Rabatt hinzufügen",
            add_product: "Produkt hinzufügen",
            choose_an_article: "Wählen Sie einen Artikel",
            article: "Artikel",
            article_plural: "Artikeln",
            list: "Liste anzeigen",
            order: "Reihenfolge verwalten",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            short_description: "Kurze Beschreibung",
            short_description_placeholder: "Bitte geben Sie eine kurze Beschreibung ein",
            category: "Kategorie",
            sort_weight: "Reihenfolge der Anzeige (kleinste zuerst)",
            description: "Lange Beschreibung",
            add_poster: "Ein Bild hinzufügen",
            posters: "Bilder",
            stock: "Gesamtbestand",
            pos: "Verkaufsstelle",
            variant: "Pricing",
            variants: "Preise",
            variant_name: "Name",
            variant_name_placeholder: "Name",
            variant_stock: "Lager",
            variant_stock_factor: "Auswirkungen auf den Gesamtlager",
            variant_gtin: "EAN-Code",
            variant_sku: "SKU",
            variant_price: "Preis",
            variant_variable_price: "Variabler Preis",
            variant_value: "Wert",
            variant_value_like_price: "Gleicher Wert wie der Preis",
            variant_purchasing_price: "Kaufpreis",
            variant_vat: "MwSt.",
            variant_discount: {
              code: "Code",
              value_amount: "Fix rebate",
              value_percentage: "Percentage %",
              target: "Applies",
              cart_target: "To the whole cart",
              last_item_target: "To the last cart item",
              only_for_roles: "Allow following roles",
              only_for_tickettypes: "Allow following ticket types",
              exclude_tickettypes: "Exclude following ticket types"
            },
            add_variant: "Ein Preis hinzufügen",
            update_article: "Änderungen von {{ name }}",
            confirm_delete: "Möchten Sie diesen Artikel wirklich löschen?",
            show_all_categories: "Alle Kategorien",
            filter_by_category: "Kategorien",
            filter_by_type: "Artikel Typen",
            please_create_category: "Bitte erstellen Sie eine Kategorie",
            please_choose_category: "Bitte wählen Sie eine Kategorie oder machen Sie eine Suche",
            type_product: "Produkt",
            type_manual_discount: "Rabatt",
            type_auto_discount: "Automatic Rabatt",
            type_code_discount: "Rabatt-Code",
            search: "Einen Artikel suchen",
            search_placeholder: "Eingabe eines Artikelnamens",
            stocks: {
              name: "Warenbestände",
              stock_type: "Typ des Warenbestands",
              type_none: "Keine Lagerverwaltung",
              type_article: "Lagerverwaltung nach Artikel",
              type_variant: "Lagerverwaltung nach Preis",
              availability: "Verfügbarkeit",
              variant_price: "Preis {{ index }}"
            },
            tags: "Tags",
            export_stocks: "Exportbestände",
            features: "Funktionen",
            add_feature: "Eine Funktion hinzufügen",
            delete_feature: "Diese Funktionen löschen",
            feature: {
              name: "Name",
              choices: "Value"
            },
            extras: "Options",
            add_extra: "Option hinzufügen",
            delete_extra: "Option löschen",
            extra: {
              name: "Option",
              min_nb_choices: "Min. number of choices",
              max_nb_choices: "Max. number of choices",
              choices: "Choice",
              add_choice: "Eine Auswahl hinzufügen",
              default_choice: "Default choice",
              default_choice_placeholder: "Bitte wählen Sie eine Option"
            },
            delivery: "Delivery",
            delivery_types: "Delivery modes"
          },
          activities: {
            informations: "Informationen",
            add: "Eine Aktivität hinzufügen",
            activity: "Aktivität",
            activity_plural: "Aktivitäten",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            is_exclusive: "exklusiv",
            update_activity: "Änderungen von {{ name }}",
            confirm_delete: "Möchten Sie diese Aktivität wirklich löschen",
            email_notification: "E-mail-Benachrichtigungen",
            sms_notification: "SMS-Benachrichtigungen",
            notification_none: "Ich möchte nicht benachrichtigt werden",
            notification_PT10M: "10 Minuten vorher",
            notification_PT30M: "30 Minuten vorher",
            notification_PT1H: "1 Stunde vorher",
            notification_PT2H: "2 Stunden vorher",
            notification_PT6H: "6 Stunden vorher",
            notification_P1D: "1 Tag vorher",
            notification_P2D: "2 Tage vorher",
            notification_P3D: "3 Tage vorher",
            reward: {
              title: "Belohnungen",
              ticket: {
                type: "Art des Tickets",
                type_desc: "Der Typ des Tickets, der für die Erstellung des Tickets verwendet werden soll, das als Belohnung dient.",
                pricing: "Preis",
                pricing_desc: "Der Preis, der für die Aktivierung des Belohnungstickets verwendet werden soll."
              },
              bookings: {
                title: "Buchungen",
                nb_hours: "Anzahl der Stunden für eine Buchung",
                nb_hours_desc: "Anzahl der Stunden, die benötigt werden, um das Recht auf eine Buchung zu erhalten.",
                at_the_end: "Am Ende der Schicht",
                at_the_end_desc: "Muss man bis zum Ende der Schicht warten, um das Recht auf eine Buchung zu erhalten?"
              },
              wallet: {
                title: "Geldbörse",
                nb_hours: "Anzahl der Stunden für 1 {{ currency }}",
                nb_hours_desc: "Anzahl der Stunden, die benötigt werden, um 1 {{ currency }} zu erhalten.",
                at_the_end: "Am Ende des Shifts.",
                at_the_end_desc: "Muss ich bis zum Ende des Shifts warten, um 1 {{ currency }} zu erhalten?"
              }
            }
          },
          Plan: {
            title: "Planung",
            calendar: "Kalender",
            week: "Woche",
            work_week: "Arbeitswoche",
            day: "Tag",
            month: "Monat",
            previous: "Vorher.",
            next: "Nächster.",
            today: "Heute",
            agenda: "Terminkalender",
            showMore: "+{{gesamt}} mehr",
            select_sector: "Bitte wählen Sie eine Branche aus.",
            from: "Vom",
            bis: "Bis",
            sector: "Sektor",
            event: {
              nb_volunteers: "{{ nb }} Freiwillige(r)",
              nb_validated: "{{ nb }} validiert(e)"
            }
          },
          shifts: {
            sector: "Sektor",
            dates: "Daten",
            start_at: "Von",
            stop_at: "Bis",
            volunteers: "Freiwillige",
            needs: "Bedarf",
            nb_volunteers: "Anzahl der Freiwilligen",
            assigned: "Zugewiesen",
            activity: "Aktivität",
            suggestions: "Vorschläge",
            no_suggestions_found: "Es stehen keine Freiwilligen zur Verfügung.",
            available: "Verfügbar",
            out_of_sector: "Außerhalb des Sektors",
            overbooked: "Überbucht",
            status: "Status der Aufgabe",
            status_new: "Neu (Freiwilliger wird vom Leiter ausgewählt)",
            status_free: "Zu besetzen (Freiwillige können diese Aufgabe übernehmen)",
            user_can_not_be_found: "Dieser Freiwillige wurde nicht gefunden."
          },
          tasks: {
            informations: "Informationen",
            add: "Ein Job hinzufügen",
            task: "Job",
            task_plural: "Jobs",
            is_exclusive: "Exclusiv",
            update_task: "Änderungen von {{ name }}",
            confirm_delete: "Möchten Sie dieses Job wirklich löschen?",
            activity: "Aktivität",
            start_at: "Anfang",
            stop_at: "Ende",
            start_at_gte: "Von",
            start_at_lte: "Bis",
            screening: "Vorstellung",
            phase: "Phase",
            sector: "Sektor",
            user: "Zugewiesen an",
            comment: "Kommentar",
            status: "Status",
            status_new: "Neu",
            status_free: "Gefüllt werden",
            status_assigned: "Zugewiesen",
            status_claimed: "Genommen",
            status_renounced: "Entfällt",
            timing: "Daten und Zeit",
            assign: "Zuweisen zu",
            claim: "Nehmen",
            accept: "Akzeptieren",
            refuse: "Ablehnen",
            renounce: "Auf geben",
            renounce_modal: {
              title: "Personalisierte Nachricht"
            },
            filters: {
              group: "Gruppen",
              group_by_days: "Pro Tag",
              group_by_screenings: "Pro Vorstellung",
              group_by_shifts: "Nach Schicht",
              group_by_sectors: "Nach Sektor",
              view_mode: "Gesehen",
              view_mode_details: "Detaillierte",
              view_mode_resume: "Zusammengefassung"
            },
            admins: "Leit. :",
            copy_to_clipboard: "In die Zwischenablage kopieren"
          },
          cashregisters: {
            informations: "Allgemeine Informationen",
            add: "Eine Registrierkasse hinzufügen",
            cashregister: "Registrierkasse",
            cashregister_plural: "Registrierkassen",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein",
            update_cashregister: "Änderungen von {{ name }}",
            confirm_delete: "Möchten Sie diese Registrierkasse wirklich löschen?",
            salepoint: "Verkaufsstelle",
            auto_closing: "Automatisches Schließen",
            auto_closing_enabled: "Aktivieren",
            auto_closing_disabled: "Deaktivieren"
          },
          messages: {
            informations: "Allgemeine Informationen",
            send: "Senden",
            send_message: "Eine Nachricht senden",
            message: "Nachricht",
            message_placeholder: "Bitte geben Sie eine Nachricht ein",
            recipients: "Empfänger",
            recipients_question: "An wen möchten Sie eine Nachricht senden?",
            recipients_desc: "Sie sind dabei, eine E-Mail an {{ nb }} Empfänger zu senden.",
            show_recipients: "Zeigen Sie die Empfänger an.",
            hide_recipients: "Empfänger ausblenden",
            users: "Mitarbeiter",
            users_placeholder: "Sie können einen oder mehrere Mitarbeiter auswählen.",
            activities: "Fähigkeiten",
            activities_placeholder: "Sie können eine oder mehrere Fähigkeiten auswählen.",
            message_desc: "Welche Nachricht möchten Sie senden?",
            layout_message: "Wählen Sie eine vordefinierte E-Mail.",
            layout_message_placeholder: "Sie können eine bestehende E-Mail auswählen.",
            subject: "Betreff Ihrer Nachricht",
            subject_placeholder: "Geben Sie den Betreff Ihrer Nachricht ein.",
            custom_message: "Fügen Sie eine benutzerdefinierte Nachricht hinzu."
          },
          sections: {
            informations: "Allgemeine Informationen",
            add: "Einen Abschnitt hinzufügen",
            section_plural: "Abschnitte",
            name: "Name",
            name_placeholder: "Bitte geben Sie einen Namen ein"
          },
          definition: {
            name: "Der Name der Ticketart in jeder der aktivierten Sprachen, dieser Name wird auf der Oberfläche des Verkaufspunktes und/oder Ihrer Webseite oder der des Ticketbüros angezeigt.",
            tkt_id: "Dies ist eine interne Kennung für diese Art von Abonnement, sie wird vom Ticketack-Team eingegeben und Sie müssen sich keine Gedanken darüber machen.",
            description: "Die Beschreibung der Art des Tickets, in jeder der aktivierten Sprachen, kann Kunden präsentiert werden, die ihren Kauf online tätigen. Es ist auch möglich, diese Beschreibung in das Layout des Tickets aufzunehmen.",
            eligibility: "Geben Sie hier einen kurzen Satz für Mitarbeiter ein, die Tickets an den Eingängen nur für die Tickets scannen, die ein Identifikationsdokument erfordern (z.B. Studentenausweis).",
            price: "Der Preis ist der Betrag, der dem Käufer berechnet wird.",
            value: "Der Wert ist der Buchwert dieses Tarifs aus Sicht der Ticketvergabe. Im Allgemeinen ist der Wert gleich dem Preis. Wenn Sie zusätzlich zum Preis Geld von Dritten haben, wenn Sie diesen Tarif verkaufen (z.B. Subvention); in diesem Fall geben Sie einen gleichwertigen Wert + die erhaltene Subvention an, das System berechnet dann automatisch die zu beanspruchenden Beträge. Im Gegenteil, wenn Sie einem Dritten einen Preis zahlen müssen (z.B. Provision von einem Dritten), geben Sie einen Wert an, der niedriger ist als der Preis. Schließlich, wenn der Preis im Voraus mit einem anderen System bezahlt wird - oder umgekehrt später bezahlt wird, z.B. auf Rechnung - dann geben Sie eine 0 und einen Wert an, der dem mit dem anderen System gesammelten Betrag entspricht.",
            value_per_screening: "Im Falle von Abonnements oder anderen Ticketarten für mehrere Veranstaltungen können Sie hier den pro Veranstaltung zuzuweisenden Wert aufteilen. Beispielsweise könnten Sie bei einer 10-Eintrittskarte zu CHF 100 beschließen, jeder Buchung CHF 10 zuzuweisen.",
            wallet_amount: "Dieser Betrag wird automatisch dem Ticketbörsenkonto gutgeschrieben.",
            category: "Im Falle von nummerierten Sitzen muss die Kategorie eines Tarifs der Kategorie der Sitze entsprechen, für die dieser Tarif verfügbar ist.",
            order: 'Die Ganzzahl, die die Reihenfolge des Tarifs definiert, je größer die Ganzzahl, desto "letzter" erscheint der Tarif.',
            css_class: "Ermöglicht die Angabe einer CSS-Klasse, um einem Tarif mithilfe Ihres benutzerdefinierten Stylesheets einen bestimmten visuellen Stil zu verleihen (dieser Stil kann auf dem Verkaufspunkt, E-Shop oder der mobilen Anwendung unterschiedlich sein).",
            valid_from: "Beginndatum der Gültigkeit des Tarifs.",
            valid_to: "Ablaufdatum des Tarifs.",
            role: "Geben Sie hier eine Liste von Benutzerrollen ein, die berechtigt sind, Tickets zu diesem Tarif zu verkaufen. Die standardmäßig verfügbaren Rollen sind wie folgt: ADMIN: alle ESHOP-Administratoren: Ihre Website, die Ticket-Website und die mobile Anwendung, falls verfügbar. ON-SITE: Ihr Personal an den Verkaufsstellen während der Veranstaltung. PARTNER: externe Partner (Touristenbüro, Partnergeschäfte usw.). ACCRED: alle Benutzer, die diese Rolle haben (in der Regel das Akkreditierungsbüro). Hinweis: Wenn keine Rolle ausgewählt ist, wird der Tarif deaktiviert. Hinweis: Um mehrere Rollen auszuwählen, halten Sie die Strg-Taste gedrückt.",
            pricing_limit: "Hier haben Sie die Möglichkeit, diesen Tarif nur für Personen anzuzeigen, die mit einer bestimmten Art von Ticket verbunden sind (Dauerkarte, Akkreditierung usw.).",
            pricing_forbiden: "Hier können Sie festlegen, dass eine Person, wenn sie mit einer bestimmten Art von Ticket angemeldet ist, diesen Tarif nicht sehen sollte.",
            screening_id: "Eine Ticketack-Vorstellungs-ID (dieses Feld wird normalerweise leer sein, da die Berechtigung eines Tickettyps für eine Vorstellung in der Regel mit den Kontingenten verwaltet wird.",
            duration: "Eine Dauer im ISO 8601-Format, z.B. P1Y, bedeutet, dass diese Regel ein Jahr ab dem Erstellungsdatum gültig ist.",
            reservation_number: "Entspricht der maximalen Anzahl von Vorstellungen, die der Käufer für diese Regel buchen kann.",
            same_screening: "Ermöglicht es Ihnen, die Anzahl der Male anzugeben, die Sie für die gleiche Vorstellung unter dieser Regel buchen können.",
            overlap: "Hier können Sie festlegen, ob es möglich ist, zwei Veranstaltungen zu buchen, die sich überlappen oder nahe beieinander liegen. Zum Beispiel erlaubt das System Ihnen, die Reservierung von zwei teilweise überlappenden Vorstellungen zu verbieten oder die Reservierung einer Vorstellung zu verbieten, die weniger als eine bestimmte Anzahl von Minuten nach dem Ende einer anderen Vorstellung beginnt. Überlappung ist im ISO 8601-Format definiert, z.B. PT0M bedeutet, dass das Ende einer Vorstellung nicht mit dem Beginn einer anderen innerhalb dieser Regel überlappen darf. Wenn Sie das Feld leer lassen, dann ist es möglich, mehrere überlappende Vorstellungen zu buchen, wenn der Rest der Regeldefinition es erlaubt. Wenn Sie PT10M angeben, dann muss der Beginn einer Vorstellung mindestens 10 Minuten nach dem Ende einer anderen Vorstellung, die innerhalb dieser Regel gebucht wurde, stattfinden. Schließlich, wenn Sie -PT15M angeben, dann ist es erlaubt, eine Vorstellung zu buchen, die bis zu 15 Minuten vor dem Ende der zuvor innerhalb dieser Regel gebuchten Vorstellung beginnt.",
            same_day: "Wenn Sie dieses Kästchen ankreuzen, müssen alle Abonnementbuchungen für Veranstaltungen am selben Tag sein. Diese Option wird hauptsächlich für Tagespässe ohne festes Datum verwendet. Bitte beachten Sie: Wenn Sie Veranstaltungen nach Mitternacht haben, kann diese Option unerwünscht sein, bitte kontaktieren Sie uns, um den besten Handlungsverlauf in diesem Fall zu ermitteln.",
            field: "Geben Sie hier eine Liste von Benutzerrollen an, die das Recht haben, auf dieses Kontingent zuzugreifen. Die standardmäßig verfügbaren Rollen sind wie folgt: ADMIN: Alle Administratoren. ESHOP: Ihre Website, die Ticketstelle und die mobile Anwendung, falls verfügbar ON-SITE: Ihr Personal an den Verkaufsstellen während der Veranstaltung. PARTNER: Externe Partner (Touristenbüro, Partnergeschäfte, etc.). ACCRED: Alle Benutzer, die diese Rolle haben (normalerweise das Akkreditierungsbüro).",
            "bucket.total_capacity": "Geben Sie hier die Gesamtkapazität dieses Kontingents an. Sie können eine feste Zahl oder einen arithmetischen Ausdruck eingeben, indem Sie die Variablen total_capacity, prm_capacity und/oder remainder verwenden. Bsp: total_capacity*0.9",
            "bucket.may_steal_from": "Wählen Sie die Kontingente, in denen er ‚fliegen kann.",
            "bucket.not_before": "Geben Sie hier das Datum an, ab dem dieses Kontingent gültig ist. Sie können ein festes Datum im Iso-8601-Format eingeben (z. B. 2024-11-25T16:41:00) oder einen Ausdruck der Form start_at+D3@06:00, um den Mittwoch (3. Tag der Woche) nach dem Startdatum um 6 Uhr morgens anzugeben. Oder stop_at-PT25M, um 25 Minuten vor dem Enddatum anzugeben. Oder start_at oder stop_at, um das Start- oder Enddatum anzugeben.",
            "bucket.not_after": "Geben Sie hier das Enddatum für die Gültigkeit dieses Kontingents an. Sie können ein festes Datum im Format iso 8601 (z. B. 2024-11-25T16:41:00) oder einen Ausdruck der Form start_at+D3@06:00 eingeben, um den Mittwoch (3. Tag der Woche) nach dem Startdatum um 6 Uhr morgens anzugeben. Oder stop_at-PT25M, um 25 Minuten vor dem Enddatum anzugeben. Oder start_at oder stop_at für das Start- oder Enddatum.",
            "bucket.only_for_roles": "Geben Sie hier eine Liste von Benutzerrollen an, die dieses Kontingent nutzen dürfen. Die standardmäßig verfügbaren Rollen sind wie folgt: ADMIN: alle Administratoren ESHOP: Ihre Website, die Website des Ticketverkaufs und die mobile Anwendung, falls verfügbar. ON-SITE: Ihre Mitarbeiter an den Verkaufsstellen während der Veranstaltung. PARTNER: externe Partner (Tourismusbüro, Partnergeschäfte usw.). ACCRED: Alle Nutzer, die über diese Rolle verfügen (in der Regel das Akkreditierungsbüro). Hinweis: Wenn keine Rolle ausgewählt ist, wird der Tarif deaktiviert. Hinweis: Um mehrere Rollen auszuwählen, halten Sie die Taste Ctrl gedrückt.",
            "bucket.only_for_tickettypes": "Geben Sie hier eine Liste der Ticketarten an, mit denen dieses Kontingent verwendet werden darf."
          },
          tags: {
            add_the_tag: "Das Tag hinzufügen"
          },
          layouts: {
            add_from_template: "Aus einer Vorlage hinzufügen",
            templates: {
              empty: "Leere Vorlage",
              empty_desc: "Vorlage, die nur das Logo und ein Text-Widget enthält.",
              order_confirmation: "Auftragsbestätigung",
              order_confirmation_desc: "Vollständige Vorlage zur Verwendung für Bestellbestätigungen"
            },
            x: "Position auf der horizontalen Achse",
            y: "Position auf der vertikalen Achse",
            please_choose_a_layout: "Bitte wählen Sie ein Layout",
            no_options: "Dieses Widget hat keine Option",
            width: "Breite",
            height: "Höhe",
            rotation: "Rotation",
            padding: "Polsterung",
            font_family: "Schriftfamilie",
            font_family_placeholder: "Bitte wählen Sie eine Schriftfamilie",
            font_family_variant: "Stil",
            font_family_variant_placeholder: "Bitte wählen Sie einen Stil",
            font_family_variant_bold: "Fett",
            font_family_variant_italic: "Kursiv",
            font_family_variant_boldItalic: "Fett und kursiv",
            font_size: "Schriftgröße",
            line_height: "Zeilenhöhe",
            object_fit: "Größenanpassung",
            object_fit_placeholder: "Bitte wählen Sie einen Größenanpassungsmodus",
            object_fit_none: "Dimensionen des Elternelements",
            object_fit_fill: "Elternelement proportional füllen",
            object_fit_cover: "Elternelement abdecken",
            object_fit_contain: "Im Elternelement enthalten",
            text: "Text",
            color: "Textfarbe",
            background_color: "Hintergrundfarbe",
            add_new_layout: "Ein Layout hinzufügen",
            layouts: "Vorlagen",
            lockRatio: "Proportionen beibehalten",
            update_layout: "Bearbeiten von {{ name }}",
            layout: {
              title: "Vorlage",
              name: "Vorlage-Name",
              name_placeholder: "Bitte geben Sie einen Namen ein",
              subject: "Betreff der E-Mail",
              subject_placeholder: "Bitte geben Sie einen Betreff ein",
              dimensions: "Abmessungen",
              type: "PDF-Typ",
              target: "Ziel",
              options: {
                bcc: "Als Blindkopie senden an",
                bcc_placeholder: "Geben Sie eine E-Mail-Adresse ein.",
                replyTo: "Antworten auf",
                replyTo_placeholder: "Geben Sie eine E-Mail-Adresse ein."
              }
            },
            linksColor: "Farbe der Links",
            groups: {
              layout: "Optionen dieser Vorlage",
              widgets: "Widgets dieser Vorlage"
            },
            general_options: "Grundlegende Optionen",
            style_options: "Stiloptionen",
            widgets_options: "Optionen für Widgets",
            layout_options: "Layout-Optionen",
            duplicate_layout: "Diese Vorlage duplizieren",
            delete_layout: "Diese Vorlage löschen",
            duplicate_widget: "Duplizieren Sie dieses Widget.",
            delete_widget: "Dieses Widget löschen.",
            apply_layout_style: "Diesen Stil speichern",
            page: "Seite",
            add_page: "Seite hinzufügen",
            show_on_page: "Auf der Seite anzeigen",
            on_all_pages: "Auf allen Seiten",
            on_odd_pages: "Auf ungeraden Seiten",
            on_even_pages: "Auf geraden Seiten",
            type_ticket: "Ticket",
            "type_ticket-bookings": "Buchungsübersicht",
            "type_cart-receipt": "Quittung",
            type_closing: "Abschluss",
            type_bill: "Rechnung",
            type_order: "Bestellung",
            target_paper: "Auf Standarddrucker drucken",
            target_thermal: "Auf Thermodrucker drucken",
            target_card: "Auf Karten Drucker drucken",
            target_other: "Andere",
            on_pricing: "Für die Preisgestaltung {{pricing}}",
            on_any_pricing: "Für alle Preisangaben",
            on_other_pricings: "Für alle anderen Preisangaben",
            add_pricing_emails: "Hinzufügen von Emails für diesen Preis",
            hook_creation: "Bei Erstellung",
            hook_activation: "Bei Aktivierung",
            hook_before_expiration: "Vor Ablauf",
            hook_expiration: "Beim Ablauf",
            hook_renewal: "Bei Verlängerung",
            hook_deletion: "Bei Löschung",
            page_options: "Seitenoptionen",
            add_widget: "Ein Widget auf dieser Seite hinzufügen",
            edit_widget: "Dieses Widget bearbeiten",
            list_widget: "Liste der Widgets auf dieser Seite",
            text_widgets: "Texte",
            text_custom: "Benutzerdefinierter Text",
            text_owner_info: "Eigentümerinformationen",
            text_screening_info: "Screening-Informationen",
            text_ticket_info: "Ticketinformationen",
            text_tickettype_info: "Tickettypinformationen",
            text_customer_info: "Kundeninformationen",
            text_environment_info: "Druckumgebung",
            text_link: "Verknüpfung",
            image_widgets: "Bilder",
            image_custom: "Benutzerdefiniertes Bild",
            image_qrcode: "QRCode",
            image_library: "Bibliotheksbild",
            image_owner_contact: "Foto des Eigentümers",
            shape_widgets: "Formen",
            shape_line: "Linie",
            shape_frame: "Rahmen",
            click_to_choose_image: "Klicken Sie, um ein Bild auszuwählen",
            new_widget: "Widget",
            move_backward: "Im Hintergrund",
            move_forward: "In den Vordergrund",
            layout_size: "Abmessungen",
            field_to_show: "Anzuzeigendes Feld",
            field_placeholder: "Bitte wählen Sie ein Feld",
            contact_field_title: "Anrede",
            contact_field_company: "Unternehmen",
            contact_field_firstname: "Vorname",
            contact_field_lastname: "Nachname",
            contact_field_fullname: "Vollständiger Name",
            "contact_field_fullname-reversed": "Vollständiger Name umgekehrt",
            contact_field_email: "E-Mail",
            contact_field_age: "Alter",
            contact_field_birthdate: "Geburtsdatum",
            contact_field_sex: "Geschlecht",
            contact_field_phone: "Telefon",
            contact_field_cellphone: "Mobiltelefon",
            contact_field_language: "Sprache",
            "contact_field_address.street": "Straße",
            "contact_field_address.city": "Stadt",
            "contact_field_address.zip": "Postleitzahl",
            "contact_field_address.country": "Land",
            screening_field_title: "Titel",
            screening_field_venue: "Ort",
            screening_field_place: "Raum",
            screening_field_address: "Adresse",
            screening_field_zip: "Postleitzahl",
            screening_field_city: "Stadt",
            screening_field_state: "Staat",
            screening_field_country: "Land",
            screening_field_start_at: "Startdatum",
            screening_field_stop_at: "Enddatum",
            screening_field_start_at_stop_at: "Startdatum - Enddatum",
            ticket_field_ticket_id: "TicketID",
            ticket_field_ticket_id_only: "TicketID (ohne Titel)",
            ticket_field_ticket_id_festivalscope: "TicketID (FestivalScope Gutscheinformat)",
            ticket_field_uuid: "UUID",
            ticket_field_activated_at: "Aktivierungsdatum",
            ticket_field_activated_pricing_name: "Preisname",
            ticket_field_activated_pricing_description: "Preisbeschreibung",
            ticket_field_activated_pricing_price: "Preis",
            ticket_field_first_window: "Gültigkeitsbeginn",
            ticket_field_last_window: "Gültigkeitsende",
            ticket_field_first_window_last_window: "Gültigkeitsbeginn - Gültigkeitsende",
            ticket_field_vat: "MWST",
            tickettype_field_name: "Name",
            tickettype_field_description: "Beschreibung",
            environment_field_printer: "Aktueller Benutzername",
            environment_field_salepoint: "Verkaufsstelle",
            environment_field_printed_at: "Druckdatum",
            customer_field_name: "Name",
            customer_field_name_short: "Kurzname",
            customer_field_phone: "Telefon",
            customer_field_address: "Adresse",
            customer_field_email: "E-Mail",
            customer_field_vat: "Umsatzsteuer-Identifikationsnummer",
            text_alignment: "Ausrichtung",
            text_alignment_placeholder: "Bitte wählen Sie eine Ausrichtung",
            text_alignment_left: "Links",
            text_alignment_center: "Mitte",
            text_alignment_right: "Rechts",
            text_alignment_justify: "Blocksatz",
            vat_format_placeholder: "Bitte wählen Sie ein Format",
            vat_format_with_vat: "8.1 % MwSt.",
            vat_format_value_only: "8.1%",
            vat_format_full: "{{ value }} % MwSt.",
            date_format: "Datums-/Zeitformat",
            date_option: "Datum Option",
            date_offset: "Datumsverschiebung",
            date_format_placeholder: "Bitte wählen Sie ein Format",
            date_format_LT: "00:00",
            date_format_LTS: "00:00:00",
            date_format_L: "01/01/1970",
            date_format_l: "1/1/1970",
            date_format_LL: "1. Januar 1970",
            date_format_ll: "1. Jan 1970",
            date_format_LLL: "1. Januar 1970 00:00",
            date_format_lll: "1. Jan 1970 00:00",
            date_format_LLLL: "Donnerstag, 1. Januar 1970 00:00",
            date_format_llll: "Do., 1. Jan. 1970 00:00",
            "date_format_dddd DD.MM": "Donnerstag 01.01",
            "date_format_dddd DD.MM.YYYY": "Donnerstag 01.01.1970",
            "date_format_dddd Do MMM": "Donnerstag 1. Jan.",
            "date_format_dddd Do MMMM": "Donnerstag 1. January",
            "date_format_dddd Do MMM YYYY": "Donnerstag 1. Jan 1970",
            "date_format_dddd Do MMMM YYYY": "Donnerstag 1. January 1970",
            "date_format_ddd DD.MM": "Do. 01.01",
            "date_format_ddd DD.MM.YYYY": "Do. 01.01.1970",
            "date_format_ddd Do MMM": "Do. 1. Jan.",
            "date_format_ddd Do MMMM": "Do. 1. January",
            "date_format_ddd Do MMM YYYY": "Do. 1. Jan. 1970",
            "date_format_ddd Do MMMM YYYY": "Do. 1. January 1970",
            date_format_midnight_hack: "01/01/1970 um halb Mitternacht",
            midnight: "um Mitternacht",
            midnight15: "um Viertel nach Mitternacht",
            midnight30: "um halb eins nach Mitternacht",
            border_color: "Randfarbe",
            border_width: "Randbreite",
            border_radius: "Ecken abrunden",
            border_style: "Randstil",
            border_style_placeholder: "Bitte wählen Sie einen Randstil",
            border_style_solid: "Durchgezogen",
            border_style_dashed: "Gestrichelt",
            text_decoration: "Textdekoration",
            text_decoration_placeholder: "Bitte wählen Sie eine Dekoration",
            text_decoration_none: "Keine",
            text_decoration_underline: "Unterstrichen",
            "text_decoration_line-through": "Durchgestrichen",
            text_transform_placeholder: "Wähle eine Transformation",
            text_transform_none: "Keine",
            text_transform_capitalize: "Jedes Wort Groß Schreiben",
            text_transform_uppercase: "GROẞBUCHSTABEN",
            text_transform_lowercase: "kleinbuchstaben",
            link: "Link",
            image_type: "Bildtyp",
            image_type_placeholder: "Bitte wählen Sie einen Bildtyp",
            widget_options: {
              groups: {
                options: "Optionen",
                position: "Platzierung",
                style: "Stil"
              }
            },
            send_test_email: "Senden einer Test-E-Mail.",
            subject: "Betreff",
            lang: "Sprache",
            recipient: "Empfänger",
            recipient_name: "Name",
            recipient_name_placeholder: "John Doe",
            recipient_address: "Adresse",
            recipient_address_placeholder: "john.doe@ticketack.com",
            context: "Kontext",
            context_ticket_id: "Ticket",
            context_ticket_id_placeholder: "Geben Sie eine Ticket-ID ein.",
            context_tickettype_id: "Art des Tickets.",
            context_tickettype_id_placeholder: "Wählen Sie einen Tickettyp aus.",
            context_screening_id: "Vorstellung",
            context_screening_id_placeholder: "Geben Sie eine Vorstellungs-ID ein.",
            context_place_id: "Raum",
            context_place_id_placeholder: "Wählen Sie einen Ort aus.",
            email_successfully_sent: "Die E-Mail wurde erfolgreich gesendet.",
            email_was_catched: "Nun… es wäre gesendet worden, wenn diese Ticketinstanz im Produktionsmodus wäre",
            click_on_preview_link: "Klicken Sie hier, um die gesendete E-Mail zu sehen.",
            shortcodes: {
              button: "Felder dyn.",
              "ticket.contact.firstname": "[Ticket] Vorname des Inhabers",
              "ticket.contact.lastname": "[Ticket] Name des Inhabers",
              "ticket.contact.title": "[Ticket] Titel des Inhabers",
              "ticket._id": "[Ticket] Ticket-ID",
              "ticket.activated_pricing.name.fr": "[Ticket] Name des Tarifs (fr)",
              "ticket.activated_pricing.name.en": "[Ticket] Name des Tarifs (en)",
              "ticket.activated_pricing.name.de": "[Ticket] Name des Tarifs (de)",
              "ticket.activated_pricing.description.fr": "[Ticket] Beschreibung des Tarifs (fr)",
              "ticket.activated_pricing.description.en": "[Ticket] Beschreibung des Tarifs (en)",
              "ticket.activated_pricing.description.de": "[Ticket] Beschreibung des Tarifs (de)",
              ticketID: "[Ticket] TicketID",
              "tickettype.description.fr": "[Tickettyp] Beschreibung (fr)",
              "tickettype.description.en": "[Tickettyp] Beschreibung (en)",
              "tickettype.description.de": "[Tickettyp] Beschreibung (de)",
              "ticket.view_link.fr": "[Ticket] Link zur Ansicht (fr)",
              "ticket.view_link.en": "[Ticket] Link zur Ansicht (en)",
              "ticket.view_link.de": "[Ticket] Link zur Ansicht (de)",
              "ticket.download_link.fr": "[Ticket] Link zum Herunterladen (fr)",
              "ticket.download_link.en": "[Ticket] Link zum Herunterladen (en)",
              "ticket.download_link.de": "[Ticket] Link zum Herunterladen (de)",
              "screening._id": "[Vorstellung] Kennung der Vorstellung",
              "screening.title.fr": "[Vorstellung] Titel (de)",
              "screening.title.en": "[Vorstellung] Titel (en)",
              "screening.title.de": "[Vorstellung] Titel (de)",
              "place._id": "[Raum] Kennung des Raums",
              "place.cinema": "[Raum] Niederlassung des Raums",
              "place.number": "[Raum] Nummer des Raums",
              "place.name": "[Raum] Name des Raums",
              "place.address": "[Raum] Adresse des Raums",
              "place.zip": "[Raum] Postleitzahl des Raums",
              "place.city": "[Raum] Stadt des Raums",
              "place.country": "[Raum] Land des Raums",
              "order.id": "[Bestellung] Nummer",
              "order.parts.subject": "[Bestellung] Titel",
              "order.parts.heading": "[Bestellung] Untertitel",
              "order.parts.content": "[Bestellung] Inhalt",
              "order.parts.payment": "[Bestellung] Zahlungsinformationen",
              "user.id": "[Mitarbeiter] Kennung des Mitarbeiters",
              "user.firstname": "[Mitarbeiter] Vorname des Mitarbeiters",
              "user.lastname": "[Mitarbeiter] Name des Mitarbeiters",
              "user.email": "[Mitarbeiter] E-Mail des Mitarbeiters",
              "application.id": "[Bewerbung] Kennung der Bewerbung",
              "application.user.id": "[Bewerbung] Identifikationsnummer des Freiwilligen",
              "application.user.firstname": "[Bewerbung] Vorname des Freiwilligen",
              "application.user.lastname": "[Bewerbung] Name des Freiwilligen",
              "application.user.email": "[Bewerbung] E-Mail-Adresse des Freiwilligen",
              "customer.id": "[Kunde] Kundennummer",
              "customer.firstname": "[Kunde] Vorname des Kunden",
              "customer.lastname": "[Kunde] Nachname des Kunden",
              "customer.email": "[Kunde] E-Mail-Adresse des Kunden",
              "custom.text.fr": "[Anpassbarer] Anpassbarer Text (fr)",
              "custom.text.en": "[Anpassbarer] Anpassbarer Text (en)",
              "custom.text.de": "[Anpassbarer] Anpassbarer Text (de)"
            }
          },
          forms: {
            please_choose_a_layout: "Bitte wählen Sie ein Formular aus.",
            no_options: "Dieses Widget hat keine Optionen.",
            text: "Einfacher Text",
            longtext: "Langer Text",
            richtext: "Rich Text",
            phone_number: "Telefonnummer",
            password: "Passwort",
            number: "Anzahl",
            datetime: "Datum",
            boolean: "Ja/ Nein",
            list: "Liste",
            file: "Datei",
            image: "Bild",
            add_new_layout: "Ein Formular hinzufügen",
            forms: "Formulare",
            form: {
              title: "Vorlage",
              name: "Name des Formulars",
              name_placeholder: "Bitte geben Sie einen Namen ein."
            },
            type_application: "Bewerbung als Freiwilliger",
            type_other: "Andere",
            add_new_form: "Ein Formular hinzufügen",
            add_field: "Ein Feld hinzufügen",
            edit_field: "Dieses Feld bearbeiten",
            list_field: "Liste der Felder im Formular",
            label: "Label",
            label_description: "Dies ist der Name des angezeigten Feldes.",
            name: "Name",
            name_description: "Dies ist der Name der Eigenschaft, die in der Datenbank gespeichert wird.",
            width: "Breite",
            width_description: "Die Breite dieses Feldes im Vergleich zur Breite der Zeile.",
            required: "Erforderlich",
            min: "Mindestwert",
            max: "Maximaler Wert",
            step: "Schritt (step)",
            with_time: "Zeit einbeziehen",
            extensions: "Erlaubte Dateien",
            choices: "Vorschläge",
            expanded: "Radiobuttons / Kontrollkästchen",
            multiple: "Mehrfachauswahl"
          },
          applications: {
            applications_plural: "Bewerbungen",
            public_form: "Öffentliches Formular",
            add: "Bewerbung hinzufügen",
            confirm_delete: "Wollen Sie diese Bewerbung wirklich löschen?",
            successfully_submitted: "Ihre Bewerbung wurde erfolgreich übermittelt.",
            please_choose_sector: "Bitte wählen Sie mindestens einen Sektor aus.",
            please_set_availabilities: "Bitte geben Sie mindestens einen Verfügbarkeitszeitraum an.",
            fullname: "Vollständiger Name",
            status: "Status",
            created_at: "Datum der Einreichung",
            max_nb_hours: "Max. Anzahl der Stunden",
            max_nb_hours_header: "Gesamtverfügbarkeit / pro Tag",
            max_nb_hours_per_day: "Max. Stunden pro Tag",
            nb_hours: "Anzahl der zugewiesenen Stunden",
            busy_rate: "Auslastungsgrad",
            status_all: "Alle Status",
            status_submitted: "Ausstehend",
            status_accepted: "Freigegeben",
            status_rejected: "Abgelehnt",
            accept_this_application: "Diesen Antrag annehmen",
            reject_this_application: "Diesen Antrag ablehnen",
            sectors: "Gewünschte Sektoren",
            export: "Bewerbungen exportieren",
            filters: {
              search: "Suche",
              search_placeholder: "Name, Vorname oder E-Mail",
              status: "Status",
              filter_on_shifts: "Nach Shifts filtern",
              having_shift: "Die mindestens eine zugewiesene Schicht haben",
              having_no_shift: "Die keine zugewiesenen Shifts haben.",
              filter_on_sectors: "Nach Sektoren filtern",
              desired_sectors: "Die einen dieser Sektoren angefordert haben.",
              shifts_in_sectors: "Die mindestens einen Shift in einem dieser Sektoren haben."
            }
          },
          settings: {
            setting: "Einstellungen",
            choose_a_field: "Bitte wählen Sie eine Kategorie",
            filter_by_category: "Kategorien",
            update_setting: "Aktualisieren",
            override_selected_fields: "Überschreiben Sie die allgemeine Einstellung.",
            choose_a_setting_to_override: "Wählen Sie einen Parameter, der geändert werden soll.",
            hide_help: "Hilfe ausblenden",
            show_help: "Hilfe anzeigen",
            dark_theme: "Dunkles Thema",
            light_theme: "Helles Thema",
            l10n: {
              title: "Lokalisierung",
              currency: "Hauptwährung",
              extra_currencies: "Zusätzliche Währungen",
              add_extra_currency: "Eine Währung hinzufügen",
              default_timezone: "Zeitzone",
              charset: "Charset",
              locales: {
                title: "Sprachen",
                default: "Standardsprache",
                all: "Verfügbare Sprachen",
                display: "Anzeige der Sprachen"
              },
              strftime_date_format: "Datumsformat",
              strftime_datetime_format: "Datums- und Zeitformat"
            },
            pdf: {
              title: "PDF-Vorlagen",
              edit_mode: "Bearbeiten",
              preview_mode: {
                title: "Vorschau",
                data_test: "Simulieren auf einem",
                choose_movies_list: "Für die Veranstaltung",
                choose_tickettypes_list: "Art des Tickets",
                choose_price: "Zum Preis gekauft"
              },
              layout_link: "Modell verwendet von :"
            },
            pos: {
              title: "Verkauf vor Ort",
              automatic_printing: {
                title: "Automatischer Druck",
                tickets: "Tickets",
                tickets_receipts: "Ticketquittungen",
                bookings: "Buchungsübersicht",
                articles_receipts: "Artikelquittungen"
              },
              booking_cancelation_policy: "Stornierungsbedingungen für Buchungen",
              booking_policy_allow_until: "Erlauben",
              booking_policy_question_positive: "vor Beginn der Vorstellung",
              booking_policy_question_negative: "nach Beginn der Vorstellung",
              default_policy: "Stornierung ist erlaubt, bis die Buchung gescannt wird",
              no_policy: "Stornierung ist nicht erlaubt",
              custom_policy: "Benutzerdefinierte Stornierungsrichtlinie",
              refund_policy: "Rückerstattungsrichtlinie (gilt nicht für Administrator-Konten)",
              "refund_policy.never": "Nie",
              "refund_policy.only_unclosed": "Nur wenn die Kasse nicht abgeschlossen ist",
              "refund_policy.always": "Immer",
              payment: {
                title: "Zahlung",
                show_calculator: "Rechner anzeigen",
                sumup_key: "Sumup-API-Schlüssel",
                methods: "Zahlungsmöglichkeiten"
              },
              requested_buyer_data: "Angeforderte Käuferdaten",
              required_buyer_data: "Erforderliche Käuferdaten",
              screening_capacity_warning_level: "Vorstellungen-Kapazität Warnstufe",
              show_past_screenings_button: 'Schaltfläche "Frühere Vorführungen" anzeigen',
              cancel_items: "Cancel items instead of removing them from cart",
              show_print_addition_button: 'Schaltfläche "Druckzusatz" anzeigen',
              show_send_order_button: 'Schaltfläche "Bestellung senden" anzeigen',
              additional_css: "Zusätzliche CSS-Datei URL für die Verkaufsstelle",
              additional_js: "Zusätzliche JS-Datei URL für die Verkaufsstelle",
              hide_screenings_started_since: "Vorstellungen ausblenden, die seit mehr als [Minuten] begonnen haben"
            },
            eshop: {
              title: "Online-Verkauf",
              uri: "Eshop-URL",
              booking_cancelation_policy: "Buchungsstornierungsrichtlinie",
              booking_expiration_duration: "Dauer des Ablaufs von Buchungen",
              iframe_integration: "Iframe-Integration",
              is_publicly_available: "Ist öffentlich verfügbar",
              allow_search_engines: "Erlaube Suchmaschinen-Indizierung",
              max_tickets_in_cart: "Max. Tickets im Warenkorb",
              max_tickets_per_screening: "Max. Tickets pro Vorführung",
              requested_buyer_data: "Angeforderte Käuferdaten",
              required_buyer_data: "Erforderliche Käuferdaten",
              enable_promo_code: "Eingabe von Promo-Codes zulassen",
              show_available_seats_to_customers: "Zeige verfügbare Plätze den Kunden",
              emails: {
                title: "E-mails",
                order_confirmation: "Bestätigung der Bestellung"
              },
              url_overrides: {
                title: "URL-Überschreibungen",
                pass_url: "Pass-URL",
                sanitary_measures_url: "URL für sanitäre Maßnahmen",
                data_protection_url: "Kontos Löschen URL",
                screenings_url: "Vorführungs-URL",
                ticket_url: "Ticket-Ansichts-URL",
                ticket_url_tooltip: "__UUID__ wird durch die einzigartige Kennung des Tickets ersetzt, wenn sie angegeben wird.",
                home_url: "Startseiten-URL",
                terms_conditions_url: "AGB-URL",
                privacy_policy_url: "Datenschutzrichtlinien-URL",
                article_url: "Artikel-URL",
                save_referer_for_host: "Referrer-URL",
                default_url: "Standard-URL",
                no_url: "Keine URL",
                custom_url: "Personalisierte URL"
              },
              donation: {
                title: "Spende",
                modes: "Modi",
                article: "Zu verwendender Artikel"
              },
              email: {
                title: "E-Mails",
                from: "Senden von",
                activation_error_to: "Sende Aktivierungsfehler an",
                bcc: "Als Blindkopie senden an",
                "reply-to": "Antworten an",
                override_to: "Empfänger erzwingen zu"
              },
              newsletter_registration: {
                title: "Newsletter-Registrierung",
                modes: "Modi",
                auto_subscribe: "Automatisch abonnieren",
                url: "URL",
                email: "E-Mail",
                callback: "Rückruf"
              },
              survey_registration: {
                title: "Umfrage-Registrierung",
                modes: "Modi",
                auto_subscribe: "Automatisch abonnieren",
                url: "URL",
                email: "E-Mail",
                callback: "Callback"
              },
              payment: {
                title: "Zahlung",
                methods: "Zahlungsmöglichkeiten",
                proxypay: {
                  title: "Proxypay",
                  url: "URL",
                  api_key: "API key",
                  env: "Environment",
                  sha_in: "SHA in",
                  sha_out: "SHA out",
                  seller: "Seller"
                }
              },
              registration: {
                title: "Registrierung der Benutzer",
                enabled: "Aktiviert",
                salepoints: "Zugewiesene Verkaufsstellen"
              },
              additional_css: "Zusätzliche CSS-Datei URL für Eshop",
              additional_js: "Zusätzliche JS-Datei URL für Eshop"
            },
            payment: {
              title: "Zahlung",
              methods: {
                title: "Zahlungsmethoden",
                onsite: "Zahlungsmethoden vor Ort",
                online: "Online-Zahlungsmittel"
              },
              method: {
                general_informations: "Grundlegende Informationen",
                _id: "Kennung",
                name: "Name",
                name_placeholder: "Bitte geben Sie einen Namen ein.",
                enabled: "Aktiviert",
                add: "Zahlungsmethode hinzufügen",
                confirm_delete: "Wollen Sie dieses Zahlungsmittel wirklich löschen?",
                rules: "Zahlungsgebühren",
                min_cart_amount: "Minimaler Warenkorb",
                price: "Festbetrag",
                percentage: "Prozentsatz",
                countries: "Länder",
                proxypay: {
                  url: "URL",
                  api_key: "API-Key",
                  env: "Umgebung",
                  sha_in: "SHA in",
                  sha_out: "SHA out",
                  seller: "Seller"
                },
                cash: {
                  show_calculator: "Taschenrechner anzeigen",
                  show_calculator_optional: "Optional",
                  show_calculator_always: "Immer",
                  show_calculator_never: "Nie"
                },
                sumup: {
                  key: "Sumup-API-Schlüssel"
                },
                twint: {
                  method: "Methode"
                },
                add_rule: "Hinzufügen einer Regel",
                remove_this_rule: "Diese Regel löschen.",
                new_method: "Neue Zahlungsmethode"
              }
            },
            mobile: {
              title: "Mobile Anwendung",
              sections: {
                title: "Abschnitte",
                navigation: "Navigation",
                screens: "Bildschirme",
                theme: "Thema",
                features: "Funktionen",
                config: "Konfiguration"
              },
              production_env: "Produktionsversion",
              preprod_env: "Pre-Produktionsversion",
              testing_env: "Testversion",
              copy_production: "Kopieren von Produktionsversion",
              copy_preprod: "Kopieren von Pre-Produktionsversion",
              copy_testing: "Kopieren von Testversion",
              to_testing: "auf Testversion",
              to_preprod: "auf Pre-Produktion",
              to_production: "auf Produktionversion",
              test_on_real_device: "Testen Sie die Anwendung auf einem realen Gerät.",
              download_the_app: 'Installieren Sie die Anwendung "Ticketack Viewer" (aus Ihrem Store) und starten Sie sie.',
              launch_the_app: "Starten Sie die Ticketack Viewer App auf Ihrem Handy.",
              scan_this_qr_code: "Scannen Sie den untenstehenden QR-Code.",
              first_configure_your_app: "Beenden Sie die Konfiguration Ihrer Anwendung (Registerkarte Konfiguration).",
              how_to_reset_the_app: "Sobald Ihre Anwendung auf Ihrem Handy eingerichtet ist, können Sie das Logo oben links 3 Sekunden lang gedrückt halten, um sie zurückzusetzen.",
              screens: {
                choose_a_screen: "Wählen Sie einen Bildschirm aus",
                home: "Startseite",
                program: "Programm",
                news: "Nachrichten",
                tickets: "Tickets",
                shop: "Shop",
                cart: "Warenkorb",
                favorites: "Favoriten",
                ratings: "Stimmen",
                widgets: "Widgets",
                widgets_desc: "Fügen Sie Widgets zu diesem Bildschirm hinzu.",
                add_widget: "Hinzufügen eines Widgets",
                choose_a_widget: "Wählen Sie ein Widget aus, das Sie hinzufügen möchten.",
                edit_a_widget: "Ändern Sie die Einstellungen des Widgets.",
                settings: {
                  title: "Konfiguration",
                  fixed_navigation: "Transparente obere Navigationsleiste",
                  screen_background: "Art des Hintergrundbildes",
                  background_image: "Hintergrundbild",
                  background_color: "Hintergrundfarbe",
                  allow_scroll: "Scrollen des Bildschirms zulassen",
                  news_post_category_id: "Stammkategorie für Nachrichten",
                  shop_category_id: "Stammkategorie für Artikel"
                },
                widget: {
                  ProgramList: {
                    title: "Programm",
                    description: "Listenansicht des Programms"
                  },
                  Shop: {
                    title: "Shop",
                    description: "Shop mit Artikeln"
                  },
                  FeaturedMovie: {
                    title: "Hervorgehobener Film",
                    description: "Hervorhebung eines Films (großes klickbares Bild)"
                  },
                  FeaturedScreening: {
                    title: "Hervorgehobene Vorstellung",
                    description: "Hervorhebung einer Filmvorführung (großes klickbares Bild)"
                  },
                  OnScreenMovies: {
                    title: "Filme werden gezeigt",
                    description: "Horizontale Liste der Filme, die im Kino laufen"
                  },
                  Section: {
                    title: "Abschnitt",
                    description: "Horizontale Liste von Filmen aus einer bestimmten Sektion"
                  },
                  Genre: {
                    title: "Genre",
                    description: "Horizontale Liste von Filmen aus einem bestimmten Genre"
                  },
                  Carousel: {
                    title: "Karussell",
                    description: "Karussell aus Bildern, die auf einen Artikel verweisen."
                  },
                  NewsList: {
                    title: "Liste von Artikeln",
                    description: "Vertikale Liste von Artikeln mit Kategoriefilter"
                  },
                  Discover: {
                    title: "Vertikales Karussell",
                    description: "Karussell mit vertikalen Bildern, die auf einen Artikel verweisen."
                  },
                  PostsGrid: {
                    title: "Raster von Artikeln",
                    description: "Raster mit Bildern, die auf einen Artikel verweisen."
                  },
                  settings: {
                    name: "Name dieses Widgets (erscheint nicht in der Anwendung)",
                    title: "Titel dieses Widgets, der in der Anwendung angezeigt wird.",
                    random_featured_movie: "Zufälliger Film",
                    featured_movie_id: "Kennung des Films, der hervorgehoben werden soll.",
                    featured_screening_id: "Kennung der Vorstellung, die hervorgehoben werden soll.",
                    post_category_id: "Kategorie der zu verwendenden Artikel",
                    section_id: "Kennung des Abschnitts, der angezeigt werden soll.",
                    section_name: "Name des Abschnitts, der angezeigt werden soll.",
                    nbDays: "Anzahl der Tage (1 nur für heute)",
                    hideMoviesTitles: "Filmtitel ausblenden",
                    show_only_future_screenings: "Zeigt nur zukünftige Vorstellungen an.",
                    nb_max_days: "Maximale Anzahl an Tagen, die angezeigt werden sollen.",
                    display_mode: "Anzeigemodus",
                    renderer_landscape: "Landschaftsmodus",
                    renderer_portrait: "Porträtmodus",
                    image_width: "Breite des Bildes (Verhältnis)",
                    image_height_ratio: "Verhältnis von Breite zu Höhe des Bildes",
                    nb_columns: "Anzahl der Spalten",
                    filter_on_places: "Nach Räumen filtern",
                    show_category_filter: "Filter nach Kategorien anzeigen"
                  }
                }
              },
              navigation: {
                tabs: "Tabs für die Navigation",
                tabs_desc: "Legen Sie die Tabs fest, die sich am unteren Rand der Anwendung befinden.",
                add_tab: "Tab hinzufügen.",
                choose_a_tab: "Wählen Sie einen Tab, den Sie hinzufügen möchten.",
                active_tab: "Standard-Tab",
                active_tab_desc: "Wählen Sie den Tab, der beim Start der Anwendung aktiv ist."
              },
              kronosUri: "Kronos URL",
              kronosApiKey: "Kronos API-Schlüssel",
              salepointId: "Verkaufsstelle",
              disableUserAccount: "Benutzerkonten deaktivieren",
              disableVotes: "Bewertungen deaktivieren",
              disableFavorites: "Favoriten deaktivieren",
              apiKey: "Engine API-Schlüssel (veraltet)",
              engineUri: "Engine URL (veraltet)",
              edition: "Ausgabe",
              screeningsFilters: {
                title: "Filter für Vorführungen",
                start_at_gte: "Start nach"
              },
              homeDisplay: {
                title: "Startbildschirm",
                showCarousel: "Karussell anzeigen",
                showFeaturedMovie: "Empfohlener Film anzeigen",
                showDiscover: "Entdecken anzeigen",
                showRestaurants: "Restaurants anzeigen",
                showOnScreenMovies: "Filme im Kino anzeigen",
                showTodayMovies: "Heutige Filme anzeigen",
                showSections: "Abschnitte anzeigen",
                showGenres: "Genres anzeigen",
                showGoodDeals: "Gute Angebote anzeigen"
              },
              shop: {
                title: "Shop",
                rootCategoryId: "Hauptkategorie"
              },
              posts: {
                title: "Beiträge",
                discover: "Entdecken",
                goodDeals: "Gute Angebote",
                pubs: {
                  title: "Werbung",
                  home: "Startbildschirm",
                  shop: "Shop",
                  program: "Programm"
                },
                news: {
                  title: "Nachrichten",
                  rootCategoryId: "Hauptkategorie"
                }
              },
              featured: {
                title: "Hervorgehobener Inhalt",
                screening: "Hervorgehobene Vorstellung",
                movie: "Hervorgehobener Film"
              },
              images: {
                title: "Bilder",
                format: "Format",
                nb_per_row: "Anzahl der Bilder pro Zeile"
              },
              theme: {
                title: "Thema",
                logo: "Logo (svg)",
                splash: "Splash",
                background_image: "Hintergrundbild",
                colors: {
                  title: "Farben",
                  background: "Hintergrundfarbe",
                  border: "Farbe des Randes",
                  primary: "Hauptfarbe",
                  "primary-inverse": "Inverse Hauptfarbe",
                  nav: {
                    title: "Navigation",
                    background: "Hintergrundfarbe",
                    border: "Farbe des Randes",
                    activeColor: "Farbe des aktiven Symbols",
                    inactiveColor: "Farbe des inaktiven Symbols"
                  }
                }
              },
              style: {
                title: "Allgemeiner Stil",
                border_radius: "Abgerundete Kanten"
              }
            },
            customer: {
              title: "Ihre Informationen",
              name: "Name",
              name_short: "Kurzname",
              phone: "Telefon",
              mail: "E-mail",
              address: "Adresse",
              addr_line0: "Adresse - Zeile 0",
              addr_line1: "Adresse - Zeile 1",
              addr_line2: "Adresse - Zeile 2",
              addr_line3: "Adresse - Zeile 3",
              assets_path: "Anpassungsordner",
              vat: "Umsatzsteuer-Identifikationsnummer",
              type: "Branche",
              type_placeholder: "Bitte wählen Sie eine Branche aus",
              types: {
                cinema: "Kino",
                cinemafestival: "Filmfestival",
                music: "Musik",
                musicfestival: "Musikfestival",
                theater: "Theater",
                recreationcenter: "Freizeitzentrum",
                recreationparc: "Freizeitpark",
                sport: "Sportclub",
                generic: "Andere"
              },
              informal: "Informelle Sprache verwenden (duzen)",
              tax: {
                title: "Steuern",
                vat_articles: "Standard-Mehrwertsteuer auf Artikel",
                vat_tickets: "Standard-Mehrwertsteuer für Fahrkarten",
                suisa: "SUISA-Gebühr",
                local: "Lokale Steuer"
              }
            },
            images: {
              title: "Bilder & Logos"
            },
            integrations: {
              title: "Integrationen",
              add: "Eine Integration hinzufügen",
              gtm: {
                title: "Google Tag Manager",
                id: "Container-ID"
              },
              wp: {
                title: "WordPress",
                websites: "Webseiten",
                name: "Name",
                uri: "URL",
                new_website_placeholder: "Name der Website",
                add_website: "Hinzufügen einer Website"
              },
              shift72: {
                title: "FestivalScope",
                api_key: "API Key",
                endpoint: "URI"
              },
              pantaflix: {
                title: "Pantaflix",
                places_ids: "Ort(e)",
                provider: "Id des Ticketverkaufs bei Pantaflix",
                content_id_prefix: "Präfix id des Inhalts"
              },
              own_it: {
                title: "Own It",
                api_key: "API-Schlüssel",
                places_ids: "Ort(e)",
                test: "Testmodus",
                codes_creation: {
                  title: "Erstellen von Codes",
                  product_id: "Bundle-ID",
                  tickettypes: "Arten von Tickets",
                  valid_from: "Gültig ab",
                  valid_until: "Gültig bis"
                }
              },
              kronos: {
                title: "Kronos",
                api_key: "API Key",
                import: {
                  title: "Einfuhren",
                  screenings: {
                    title: "Importe von Vorführungen",
                    enabled: "Aktiviert",
                    delete_future: "Zukünftige Vorstellungen unterdrücken",
                    delete_existing: "Vor dem Update bestehende Vorstellungen löschen"
                  }
                }
              },
              como: {
                title: "Como",
                api_key: "API Key",
                branch_id: "Zweigstellen-ID"
              },
              json: {
                title: "JSON Datenquelle",
                url: "URL",
                x_api_key: "API Key (X-Api-KEY header)",
                screenings_key: "Zugang zu den Screenings",
                places_key: "Zugang zu den Räumen",
                import: {
                  title: "Einfuhren",
                  screenings: {
                    title: "Importe von Vorführungen",
                    enabled: "Aktiviert",
                    delete_future: "Zukünftige Vorstellungen unterdrücken",
                    delete_existing: "Vor dem Update bestehende Vorstellungen löschen"
                  }
                }
              },
              eventival: {
                title: "Eventival",
                name: "Name",
                year: "Year",
                api_key: "API key",
                import: {
                  title: "Einfuhren",
                  screenings: {
                    title: "Importe von Vorführungen",
                    enabled: "Import aktivieren",
                    delete_future: "Zukünftige Vorstellungen unterdrücken",
                    delete_existing: "Vor dem Update bestehende Vorstellungen löschen",
                    fullfill_people: "Menschen erfüllen"
                  },
                  tickets: {
                    title: "Akkreditierungen importieren",
                    enabled: "Import aktivieren"
                  }
                }
              },
              weserv: {
                title: "Weserv Image-Proxy",
                proxy_img_host: "Proxy-Host"
              },
              fiona: {
                title: "Fiona",
                name: "Name",
                edition_id: "Edition",
                api_key: "API Key",
                import: {
                  title: "Einfuhren",
                  screenings: {
                    title: "Importe von Vorführungen",
                    enabled: "Aktiviert",
                    delete_future: "Zukünftige Vorstellungen unterdrücken",
                    delete_existing: "Vor dem Update bestehende Vorstellungen löschen"
                  }
                }
              },
              cinech: {
                title: "Ciné.ch",
                url: "Url",
                cinema_ids: "Kino-IDs",
                import: {
                  title: "Einfuhren",
                  screenings: {
                    title: "Importe von Vorführungen",
                    enabled: "Aktiviert",
                    delete_future: "Zukünftige Vorstellungen unterdrücken"
                  },
                  delete_existing: "Löschen vor der Aktualisierung"
                }
              },
              recaptcha: {
                title: "Google reCAPTCHA",
                public_key: "Schlüssel der Website",
                secret_key: "Geheimer Schlüssel"
              },
              mailchimp: {
                title: "Mailchimp",
                newsletter: "Newsletter-Registrierung",
                survey: "Umfrage-Registrierung",
                api_key: "API-Schlüssel",
                list_id: "Liste ID",
                merge_fields: {
                  title: "Zusammenzuführende Felder",
                  address: "Adresse",
                  zip: "Postleitzahl",
                  city: "Stadt",
                  country: "Land",
                  language: "Sprache"
                },
                interest: "Interessenschwerpunkt (ID)",
                tags: "Tags"
              },
              maccsbox: {
                title: "Maccsbox",
                ftp: {
                  title: "FTP configuration",
                  hostname: "Hostname",
                  username: "Username",
                  pasv: "PASV",
                  directory: "Directory",
                  password: "Password"
                }
              }
            }
          },
          payment_methods: {
            cash: "Cash",
            cash_collector: "Cash collector",
            ewallet: "E-Wallet",
            sumup: "Sumup",
            other_eft: "Manual EFT",
            zvt_eft: "EFT",
            eft_receipt_printable_after_debit: "Anbieten, dass das Ticket nach der Zahlung ausgedruckt wird",
            closing_eft_mode: "Automatische Schließung der TPE.",
            mode_never: "Nicht anbieten und nie schließen.",
            mode_yes: "Vorschlagen und standardmäßig ja wählen",
            mode_no: "Vorschlagen und standardmäßig nein wählen",
            mode_always: "Nicht vorschlagen und immer schließen",
            twint: "Twint",
            pos_transfer: "Transfer",
            free: "Free",
            later: "Later",
            proxypay: "Proxypay",
            eshop_transfer: "Transfer"
          },
          user_data: {
            title: "Anrede",
            company: "Unternehmen",
            firstname: "Vorname",
            lastname: "Nachname",
            address: "Adresse",
            zip: "Postleitzahl",
            city: "Stadt",
            country: "Land",
            age: "Alter",
            birthdate: "Geburtsdatum",
            sex: "Geschlecht",
            phone: "Telefon",
            cellphone: "Mobiltelefon",
            email: "E-Mail",
            tab: "Tischnummer",
            comment: "Kommentare"
          },
          envs: {
            test: "Test",
            prod: "Production"
          },
          donation: {
            checkout: "Checkout",
            header: "Header",
            footer: "Footer",
            email: "E-mail"
          },
          registration_callback: {
            email: "E-mail",
            callback: "Callback",
            url: "Url",
            mailchimp: "Mailchimp"
          },
          twint_methods: {
            sticker: "Sticker",
            beacon: "Beacon"
          },
          locales: {
            fr_CH: "Französisch",
            en_GB: "Englisch",
            de_CH: "Deutsch"
          },
          devices: {
            title: "Hardware",
            list: "Liste",
            map: "Arboreszenz"
          },
          collectors: {
            title: "Münzautomaten",
            manage: "Verwalten",
            manage_title: "Verwaltung des Münzautomaten {{name}}",
            connection: "Verbindung",
            connected: "Verbunden",
            disconnected: "Getrennt",
            status: "Status",
            statuses: {
              idle: "In der Warteschleife",
              draining: "Entleerung läuft",
              filling: "Aufladung läuft",
              cancellation: "Stornierung läuft",
              "treatment error": "Fehler bei der Behandlung",
              NU: "NU",
              autotest: "Selbsttest läuft",
              reset: "Zurücksetzen der aktuellen Truhe",
              exchange: "Wechsel läuft",
              unload: "Entlastung läuft",
              ticket: "Anzeige des Tickets",
              payment: "Zahlung läuft"
            },
            acceptation: {
              opened: "Kasse offen",
              closed: "Kasse geschlossen"
            },
            in_recyclers: "In den Recyclern",
            in_cashbox: "In der Cashbox",
            stats: "Stand der Hopper",
            moneyTypes: {
              5: "5 cts",
              10: "10 cts",
              20: "20 cts",
              50: "50 cts",
              100: "1 Fr",
              200: "2 Frs",
              500: "5 Frs",
              1e3: "10 Frs",
              2e3: "20 Frs",
              5e3: "50 Frs",
              1e4: "100 Frs"
            },
            coins: "Münzen",
            bills: "Banknoten",
            operations: "Operationen",
            lastEvents: "Letzte Nachrichten",
            lastTransactions: "Letzte Transaktionen",
            collect: "Einlösen",
            collect_desc: "Geld einnehmen",
            refund: "Zurückzahlen",
            refund_desc: "Geld zurückzahlen",
            debit_amount_label: "Betrag",
            debit_amount_label_placeholder: "Geben Sie den Betrag ein, der eingezogen werden soll.",
            refund_amount_label: "Betrag",
            refund_amount_label_placeholder: "Geben Sie den Betrag ein, den Sie zurückzahlen möchten.",
            change: "Geld wechseln",
            change_desc: "Geld umtauschen",
            do_change: "Den Geldwechsel starten",
            autotest: "Selbsttest",
            autotest_desc: "Führen Sie einen Selbsttest durch.",
            drain: "Entleeren",
            drain_desc: "Geld zurückholen",
            reset_chest: "Zurücksetzen",
            reset_chest_desc: "Führen Sie einen Cashbox-Reset durch.",
            do_drain: "Leerung starten",
            unload: "Entlastung",
            unload_desc: "Senden Sie Geld in die cashBox.",
            do_unload: "Entlastung starten",
            fillin: "Laden",
            fillin_desc: "Geld hinzufügen",
            validate_fillin: "Bestätigen Sie den Ladevorgang.",
            inserted: "Eingeworfene Münzen",
            in_the_recycler: "Im Recycler",
            in_the_cashbox: "In der Cashbox",
            modules: {
              title: "Module",
              BILLENAKTEUR: "Banknotenakzeptor",
              CASHBOX: "CashBox",
              SCHLÜSSELHÄNDLER1: "Scheinenausgabe 1",
              "BILLET2-AUSGABE": "Ausgabe von Banknoten 2",
              DISTRIBUTEUR_BILLET3: "Ticketausgabe 3",
              "FAHRKARTEN-AUSGABE4": "Ausgabe von Fahrkarten 4",
              ANNEHMER_PIECE: "Annahmestelle",
              VERTEILER: "Verteiler",
              VERTEILER_PIECE1: "Ausgabe 5 Fr.",
              DISTRIBUTOR_PIECE2: "Ausgabe 2 Fr.",
              VERTEILER_PIECE3: "Ausgabe 1 Fr.",
              DISTRIBUTEUR_PIECE4: "Ausgabe 50 ct.",
              DISTRIBUTEUR_PIECE5: "DISTRIB. 20 Rp.",
              DISTRIBUTEUR_PIECE6: "Distrib. 10 Rp.",
              "PIECE7-DISTRIBUTEUR": "Ausgabe 5 ct.",
              STATUS_BANKENALARM: "Banknotenalarm",
              ETAT_PIECE_ALARM: "Münzalarm",
              ETAT_CASHBOX: "CashBox-Status",
              PRES_BILLENAUSGANG: "Banknotenausgangsdruck",
              PRES_PIESORTIE: "Ausgabe von Münzen"
            }
          },
          printers: {
            title: "Drucker",
            manage_title: "Druckerverwaltung {{name}}",
            manage: "Verwalten",
            connection: "Verbindung",
            connected: "Verbunden",
            disconnected: "Getrennt",
            infos: "Informationen",
            id: "Kennung",
            name: "Name",
            host: "Host",
            status: "Status",
            last_connexion: "Letzte Verbindung",
            options: "Optionen",
            open_cash_drawer: "Öffnen Sie die Kassenschublade bei jedem Ausdruck",
            only_for_pos: "Nur bei diesen Verkaufsstellen sichtbar",
            ppd: "Druckmodus",
            profiles: {
              1: "Kartendrucker (Typ ZCxxx) mit schwarzem Farbband und deaktiviertem Duplex",
              3: "Thermodrucker (Typ ZDxx oder ZX) mit Endlospapier ohne Cutter",
              4: "Anderer Standarddrucker",
              6: "Anderer Thermodrucker",
              10: "Thermodrucker (Typ ZDxx oder ZX) mit Papier mit Löchern ohne Cutter",
              18: "Thermodrucker (Typ ZDxx oder ZX) mit Endlospapier und Cutter (Schneiden nach jeder Ticket)",
              26: "Thermodrucker (Typ ZDxx oder ZX) mit Papier mit Löchern und Cutter (Schneiden nach jeder Ticket)",
              50: "Thermodrucker (Typ ZDxx oder ZX) mit Endlospapier und Cutter (Schneiden am Ende des Druckvorgangs)",
              58: "Thermodrucker (Typ ZDxx oder ZX) mit Lochpapier und Cutter (Schneiden am Ende des Druckvorgangs)",
              65: "Kartendrucker (Typ ZCxxx) mit schwarzem Farbband und deaktiviertem Duplex",
              129: "Kartendrucker (Typ ZCxxx) mit schwarzem Farbband und Duplex aktiviert",
              193: "Kartendrucker (Typ ZCxxx) mit schwarzem Farbband und Duplex aktiviert"
            },
            automatic_printing: "Die Artikel in diesen Kategorien werden automatisch gedruckt."
          },
          efts: {
            title: "Zahlungsterminals",
            manage_title: "Verwaltung von Zahlungsterminals {{name}}",
            manage: "Verwalten",
            connection: "Anmelden",
            connected: "Verbunden",
            disconnected: "Getrennt",
            infos: "Informationen",
            id: "Kennung",
            name: "Name",
            host: "Host",
            status: "Status",
            last_connexion: "Letzte Verbindung",
            options: "Optionen",
            only_for_pos: "Nur an diesen Verkaufsstellen sichtbar",
            terminal_id: "Terminal ID Pixoo"
          },
          flash_info: {
            title: null,
            subtitle: null,
            content: null
          },
          logs: {
            source: {
              cinech: "Ciné.ch",
              eventival: "Eventival",
              json: "JSON Datenquelle",
              kronos: "Kronos",
              raw: "Datei"
            }
          },
          models: {
            customer: {
              name: "Ticketname",
              name_short: "Kurzer Name des Fahrkartenschalters",
              address: "Vollständige Adresse des Fahrkartenschalters",
              Telefon: "+41 22 364 80 00",
              email: "info@netoxygen.ch",
              vat: "CHE-105.599.869"
            },
            pricing: {
              name: "Tarifname",
              description: "Beschreibung des Tarifs"
            },
            environment: {
              printer: "Name des Kassierers",
              salepoint: "Name der Verkaufsstelle"
            },
            screening: {
              title: "Filmname",
              venue: "Name der Einrichtung",
              place: "Name des Saals",
              address: "Adresse des Kinos",
              zip: "PLZ",
              city: "Stadt",
              state: "Kanton",
              country: "Land"
            },
            tickettype: {
              name: "Name des Tickettyps",
              description: "Beschreibung des Tickettyps..."
            },
            owner_info: {
              title: "M.",
              company: "Firma",
              firstname: "Vorname",
              lastname: "Name",
              fullname: "Vorname Nachname",
              fullname_reversed: "Name Vorname",
              email: "vorname.name@ticketack.com",
              Alter: "42",
              Geschlecht: "M",
              phone: "0223648000",
              cellphone: "0791223344",
              Sprache: "de",
              address: {
                street: "Adresse",
                city: "Stadt",
                zip: "Plz",
                country: "Land"
              }
            }
          }
        }];
        e.exports = t.length <= 1 ? t[0] : t;
      },
      7206: e => {
        const t = [{
          app: {
            dashboard: "Dashboard",
            events: "Events",
            booking_survey: "Booking survey",
            tickets_clients: "Tickets and clients",
            tickets: "Tickets",
            booking_status: "Bookings status",
            section_admin: "Administration",
            section_operation: "Operation",
            section_analysis: "Analysis and stats",
            accounting: "Accounting",
            events_movies: "Movies",
            events_music_groups: "Artists/Groups",
            events_drama: "Plays",
            events_service: "Services",
            sales_list: "Sales list",
            other_activites: "Other activites",
            screenings: "Screenings",
            programmations: "Programmations",
            configuration: "Configuration",
            users: "Users",
            ticketack_users: "Ticketack users",
            activities: "Skills",
            phases: "Phases",
            sectors: "Sectors",
            application_types: "Types of applications",
            applications: "Applications",
            form_layouts: "Forms",
            forms: "Forms",
            personnal_fields: "Personalised fields",
            teams: "Teams",
            ex_teams: "Operating teams",
            hardware: "Hardware",
            setting_and_hardware: "Configuration and hardware",
            configuration_qr_codes: "QR codes",
            plan: "Planning",
            resources_keys: "Key management",
            places: "Rooms",
            pricinglist: "Pricing lists",
            email_layouts: "Email templates",
            tktInstances: "Ticketack instances",
            distributors: "Distributors",
            shop: "Shop",
            points_of_sale: "Points of sale",
            categories: "Categories",
            articles: "Articles",
            resources: "Resources",
            cashregisters: "Cash registers",
            communication: "Communication",
            message: "Message",
            sections: "Sections",
            login: "Log in",
            logout: "Log out",
            my_profil: "My profil",
            publishing: "Publishing",
            posts: "Posts",
            channels: "Broadcast channels",
            sale: "Sale",
            company: "Company",
            articles_and_discount: "Poducts and discounts",
            tickettypes: "Ticket Types",
            layouts: "PDF layouts",
            pricinglists: "Pricing lists",
            bucketlists: "Quota templates",
            customers: "Customers",
            table_prev_button: "Previous",
            table_next_button: "Next",
            table_page_label: "Page",
            table_of_label: "of",
            table_rows_label: "rows",
            table_no_data_message: "No data found",
            stats: "Statistics",
            tasks: "Planning",
            salepoints: "Salepoints",
            post_categories: "Catégories",
            messages: "Communication",
            settings: "Settings",
            cron_tasks: "Tasks",
            hide_sidebar: "Hide",
            edit_abilities: "Permissions",
            history: "History",
            errors_load_params: "An error occurred while loading parameters.",
            worker: {
              an_update_is_available: "An update of Kronos is available",
              click_here_to_update: "Click below to update your version of Kronos and enjoy the new features",
              do_update: "Upgrade"
            }
          },
          modules: {
            module_team: "Team management",
            module_planning: "Planning",
            module_shop: "Shop",
            module_resources: "Resources",
            module_communications: "Communications",
            module_publishing: "Publishing",
            module_administration: "Administration",
            module_super_admin: "Super admin"
          },
          login: {
            email: "Email",
            password: "Password"
          },
          users: {
            add_a_user: "Add an user",
            user: "User",
            user_plural: "Users",
            profile: "Profile",
            my_profile: "My profile",
            contact: "Contact",
            address: "Address",
            company: "Company",
            title: "Title",
            other_informations: "Other informations",
            firstname: "First name",
            lastname: "Last name",
            fullname: "Full name",
            email: "Email",
            role: "Role",
            password: "Password",
            password_confirmation: "Password (confirmation)",
            fix_phone: "Fix phone",
            mobile_phone: "Mobile phone",
            pro_phone: "Pro. phone",
            fax: "Fax",
            zip: "Zip",
            city: "City",
            country: "Country",
            birthday: "Birthday",
            avs: "AVS number",
            bank: "Bank",
            bic: "BIC",
            iban: "IBAN",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            disable: "Disable",
            tkt_instance: "Ticketack instance",
            firstname_placeholder: "Please enter a firstname",
            lastname_placeholder: "Please enter a last name",
            role_placeholder: "Please enter a role",
            email_placeholder: "Please enter an email",
            invalid_email: "The provided e-mail is invalid",
            password_placeholder: "Please enter a password",
            phone_placeholder: "Please enter a phone number",
            invalid_phone: "Please enter a valid format (9 digits without area code)",
            fax_placeholder: "Please enter a fax number",
            address_placeholder: "Please enter a postal address",
            zip_placeholder: "Please enter a zip code",
            city_placeholder: "Please enter a city",
            country_placeholder: "Please enter a country",
            avs_placeholder: "AVS",
            bank_placeholder: "Bank / CCP",
            bic_placeholder: "BIC",
            iban_placeholder: "IBAN",
            activities: "Activities",
            update_my_profile: "Edit my profile",
            update_user: "Edit {{ firstname }} {{ lastname }}",
            delete_my_profile: "Delete my account",
            delete_user: "Delete {{ firstname }} {{ lastname }}'s account",
            confirm_delete_my_profile: "Do you really want to delete your account?",
            confirm_delete_this_profile: "Do you really want to delete this account?",
            show: "Show user profile",
            edit: "Edit user profile",
            delete: "Delete user",
            hidden: "Hidden",
            abilities: {
              users_abilities: "Users specific permissions",
              pick_activities: "Assign activities",
              enable: "Enable",
              disable: "Disable",
              read_abilities: "Read permissions",
              edit_abilities: "Edit permissions",
              edit_templates: "Edit templates"
            },
            skills: "Skills",
            user_abilities: "Rights",
            informations: "General information",
            availabilities: "Availability",
            application: "Application",
            planning: "Planning"
          },
          tktUsers: {
            tktUsers: "Ticketack users",
            name: "User name",
            roles_and_salepoints: "roles and salepoints",
            role_plural: "Roles",
            salepoint_plural: "Salepoints",
            add_a_ticketack_user: "Add a Ticketack user",
            passwords_do_not_match: "The passwords you entered do not match!",
            delete_tktUser: "Do you really want to delete this Ticketack user?",
            change_password: "Change password",
            roles_tooltips: {
              admin: "Provides full access to the system and rates associated with this role",
              pos: "Allow access to the point of sale interface (pos = point of sale)",
              "on-site": "Indicates that the user is part of the on-site team (usually associated with pos), gives access to the rates associated with this role",
              partner: "Indicates that the user is part of a partner's team (usually associated with pos), gives access to the rates associated with this role",
              overbooker: "Indicates that the user is authorized to sell/reserve more seats than the room allows (requires an 'overbooking' quota).",
              transfer: "Authorizes conversion of tickets from one fare to another",
              accred: "Authorizes the user to manage accreditations, (usually associated with pos), gives access to the rates associated with this role",
              ticket_editor: "Indicates that the user can modify the data of a ticket",
              refund: "Indicates that the user can make refunds",
              wallet_cashier: "Indicates that the user can make cash receipts on an e-wallet outside the point of sale (used for example for bars not managed with ticketack)",
              wallet_manager: "Indicates that the user can credit e-wallets",
              accounting: "Authorizes access to the accounting data of the sales outlets listed below",
              entry_check: "Special role for entry-check",
              stats: "Special role for statistics access",
              customer: "Indicate that the used has a customer account on the system"
            }
          },
          customers: {
            customer: "Customer",
            customers: "Customers",
            add_a_customer: "Add a customer",
            passwords_do_not_match: "The passwords don't match!",
            confirm_delete_customer: "Do you really want to delete this customer?",
            change_password: "Change password",
            profile: "Login profile",
            contact: "Contact",
            other_informations: "Other information",
            company: "Company",
            title: "Title",
            firstname: "First name",
            lastname: "Last name",
            name: "Login",
            fullname: "Full name",
            verified: "Verified account",
            email: "E-mail",
            salepoint_plural: "Points of sale",
            password: "Password",
            password_confirmation: "Password (confirmation)",
            phone: "Home phone",
            cell_phone: "Mobile phone",
            address: "Address",
            zip: "Zip code",
            city: "City",
            country: "Country",
            age: "Age",
            birthdate: "Date of birth",
            sex: "Gender",
            language: "Language",
            name_placeholder: "Please enter a user name",
            company_placeholder: "Please enter the company name",
            title_placeholder: "Please enter a title",
            firstname_placeholder: "Please enter a first name",
            lastname_placeholder: "Please enter a last name",
            email_placeholder: "Please enter an email address",
            password_placeholder: "Please enter a password",
            phone_placeholder: "Please enter a landline phone number",
            cellphone_placeholder: "Please enter a mobile phone number",
            invalid_phone: "Please enter a valid format (9 digits without area code)",
            address_placeholder: "Please enter a postal address",
            zip_placeholder: "Please enter a zip code",
            city_placeholder: "Please enter a city",
            country_placeholder: "Please enter a country",
            age_placeholder: "Please enter an age",
            update_customer: "Modification of {{ firstname }} {{ lastname }}",
            delete_customer: "Delete {{ firstname }} {{ lastname }}",
            confirm_delete_this_customer: "Do you really want to delete this customer?",
            show: "Show the customer",
            edit: "Edit the customer",
            delete: "Delete the customer"
          },
          changelog: {
            changelog: "Changelog",
            features: "Features",
            i18n: "Translations",
            fixes: "Fixes",
            builds: "Builds",
            ui: "Visual changes"
          },
          sectors: {
            sector: "Sector",
            sectors_plural: "Sectors",
            available: "Available sectors",
            your_sectors: "Your sectors",
            sectors_description: "Choose the sectors in which you want to work, in order of preference.",
            informations: "General information",
            add: "Add a sector",
            name: "Name",
            admins: "Managers",
            parent: "Parent sector",
            description: "Description",
            name_placeholder: "Please enter a name",
            description_placeholder: "Please enter a description",
            confirm_delete: "Do you really want to delete this sector?",
            update_sector: "Modification to {{ name }}"
          },
          applicationTypes: {
            applicationType: "Type of application",
            applicationTypes_plural: "Types of application",
            informations: "General information",
            add: "Add an application type",
            name: "Name",
            name_placeholder: "Please enter a name",
            description: "Description",
            description_placeholder: "Please enter a description",
            form: "Form",
            confirm_delete: "Do you really want to delete this type?",
            update_application_type: "Modification of {{ name }}",
            notifications: "Email notifications",
            admins: "Administrators to be notified when an application is submitted",
            on_receive_email_id: "Email to be sent to administrators when an application is submitted",
            on_submit_email_id: "Email to be sent to the applicant when an application is submitted",
            on_approve_email_id: "Email to be sent to the applicant when the application is approved",
            on_reject_email_id: "Email to be sent to the applicant when their application is rejected",
            activities: "Skills",
            activities_to_assign_on_acceptation: "To be assigned to the acceptance of the application"
          },
          availabilities: {
            availabilities_description: "Specify your periods of availability",
            phases_description: "Here are the periods during which we need you:",
            add_an_availability: "Add an availability period",
            from: "Du",
            to: "To"
          },
          places: {
            informations: "Informations",
            maps: "Map",
            add: "Add a room",
            place: "Room",
            place_plural: "Rooms",
            building: "Venue",
            building_placeholder: "Please enter a bulding name",
            name: "Name",
            name_placeholder: "Please enter a name",
            number: "Screen number",
            number_placeholder: "Please enter a screen number",
            address: "Address",
            address_placeholder: "Please enter an address",
            zip: "Zip code",
            zip_placeholder: "Please enter a zip code",
            city: "City",
            city_placeholder: "Please enter a city",
            state: "State",
            state_placeholder: "Please enter a state",
            country: "Country",
            country_placeholder: "Please enter a country",
            coordinates: "Geographical coordinates",
            coordinates_lat: "Latitude",
            coordinates_lat_placeholder: "Please enter a latitude (e.g. 50.081396)",
            coordinates_long: "Longitude",
            coordinates_long_placeholder: "Please enter a longitude (e.g. 14.425201)",
            capacity: "Capacity",
            capacity_total: "Total capacity",
            capacity_prm: "PRM capacity (included in total capacity)",
            capacity_total_placeholder: "Please enter the total capacity (including PRM capacity)",
            capacity_prm_placeholder: "Please enter PRM capacity",
            update_place: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this place?",
            add_map: "Add a map",
            eventival_list_warning: "You cannot add or delete places because you have an integration with Eventival. Only the seating plan is accessible from Kronos.",
            json_list_warning: "You cannot add or remove places because you have an import configuration for screenings from an external source. Only the seating plan is accessible from Kronos.",
            eventival_form_warning: "You cannot edit this place because it is integrated with Eventival. Only the seating plan and the PRM capacity are accessible from Kronos.",
            json_form_warning: "You cannot edit this place because you have an import configuration for screenings from an external source. Only the seating plan and the PRM capacity are accessible from Kronos.",
            map: {
              seatsmap: "Seats Map",
              classic: "Classic",
              sofa: "Sofa",
              "sofa-middle": "Sofa middle",
              "sofa-left": "Sofa left",
              "sofa-right": "Sofa right",
              "foldable-seat": "Foldable",
              wheelchair: "Wheelchair",
              nbRows: "Number of rows",
              nbColumns: "Number of columns",
              overviewTitle: "Overview",
              gridParamsTitle: "Parameters",
              zoneOptionsTitle: "Options of the zone to be created",
              zoneTitle: "Zone {{ name }}",
              seatTitle: "Seat {{ label }}",
              seatOptions: "Seat options {{ row }}:{{ seat_number }}",
              zoneOptions: "Zone options {{ name }}",
              category_and_type: "Category and type of seats",
              numbering_options: "Numbering options",
              category: "Category",
              zonelabel: "Zone Label",
              top: "Top",
              bottom: "Bottom",
              seatposition: "Seat numbering",
              l2r: "Left to right",
              r2l: "Right to left",
              tblr: "Top to bottom AND left to right",
              btlr: "Bottom to top AND left to right",
              tbrl: "Top to bottom AND right to left",
              btrl: "Bottom to top AND right to left",
              totalSeats: "Total Seats",
              zoneCoordinates: "Zone coordinates",
              label: "Label",
              seattype: "Seat Type",
              tooltipmsg: "Tab to edit seat and long press to remove/add seat from zone",
              seatdetail: "Seat Detail",
              startSeatNumber: "Seats numbers offset",
              saveSeat: "Save the seat",
              leaveSeat: "Close the seat",
              saveZone: "Save zone",
              leaveZone: "Close zone",
              leaveSelectionOptions: "Close selection",
              saveCategoryAndType: "Save seat category and type",
              saveNumberingOptions: "Save scanning options",
              startRowNumber: "Number of the first row",
              skippedSeatNumber: "Skipped seat number",
              stagePosition: "Stage/Screen position",
              seatNumber: "Seat number",
              seatRow: "Seat row",
              number: "Number",
              rowType: "Row Type",
              alphabet: "Alphabetical",
              stagePositions: {
                top: "On top",
                bottom: "At the bottom"
              },
              free: "free",
              booked: "booked"
            },
            import: {
              imported_at: "Import from {{ date }}",
              resume: "In summary",
              nb_deleted: "{{ nb }} rooms have been deleted.",
              nb_inserted: "{{ nb }} rooms have been created.",
              nb_updated: "{{ nb }} rooms have been updated.",
              nb_invalid: "{{ nb }} room(s) are invalid.",
              inserted: "Room(s) created",
              updated: "Room(s) updated",
              invalid: "Invalid room(s)",
              an_error_occured: "An error has occurred during synchronisation. Please try again later.",
              was_useless: "The import was successful but had no effect.",
              places_tab: "Rooms"
            }
          },
          pricinglists: {
            _id: "Id",
            informations: "Information",
            add: "Add a pricing list",
            pricinglist: "Pricing list",
            pricinglist_choice: "Choice pricing list",
            pricinglist_plural: "Pricing lists",
            name: "Name",
            name_placeholder: "Please enter a name",
            description: "Description",
            description_placeholder: "Please enter a description",
            nb_pricings: "Number of pricings",
            update_pricinglist: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this pricing list?",
            pricings: "Pricings",
            add_pricing: "Add a pricing",
            new_pricing: "New pricing",
            pricing: {
              base_informations: "Base informations",
              display: "Display",
              rules: "Rules",
              name: "Name",
              name_placeholder: "Pricing name",
              description: "Description",
              description_placeholder: "Please enter a description",
              price: "Price",
              value: "Value",
              value_per_screening: "Value per event",
              wallet_amount: "Wallet amount",
              eligibility: "Eligibility",
              eligibility_placeholder: "Short sentence for staff scanning tickets...",
              VAT: "VAT",
              sellers: "Sellers",
              eshop_sort_weight: "Order",
              category: "Category",
              additional_class_names: "CSS class",
              limit_to_sellers: "Limit the pricing to following roles",
              limit_to_tickettypes: "Limit the pricing to following ticket type",
              exclude_tickettypes: "Prohibit this pricing for the following ticket types",
              not_before: "Valid from (not implemented)",
              not_after: "Valid to (not implemented)",
              pricing_choice: "Chose a pricing",
              pricing_add_layout: "Add layout",
              refs: "References",
              tags: "Tags"
            }
          },
          bucketlists: {
            _id: "Username",
            informations: "General information",
            add: "Add a quota model",
            bucketlist: "Quota template",
            bucketlist_choice: "Choose a quota template",
            bucketlist_plural: "Quota templates",
            name: "Name",
            name_placeholder: "Please enter a name",
            nb_buckets: "Number of quotas",
            update_bucketlist: "Modification of {{ name }}",
            confirm_delete: "Do you really want to delete this quota model?",
            buckets: "Quotas",
            buckets_maybe_plural: "Quota(s)",
            add_bucket: "Add a quota",
            new_bucket: "New quota",
            preview: "Preview",
            edit: "Edit",
            apply: "Apply a quota model",
            bucket: {
              bucket_add_layout: "Add a model",
              id: "Identifier",
              rules: "Rules",
              can_take_from: "Can take from",
              capacity: "Capacity:",
              total_capacity: "Total capacity",
              full_capacity: "Venue capacity",
              prm_capacity: "PMR capacity",
              remainder: "Rest of capacity",
              sellers: "Roles",
              may_steal_from: "This quota can take from the following quotas",
              not_before: "Available since",
              not_after: "Available until",
              only_for_roles: "Limit this quota to certain roles",
              only_for_tickettypes: "Limit this quota to certain ticket types",
              no_role: "No",
              all_roles: "All",
              no_role_desc: "This quota cannot be used by any role",
              all_roles_desc: "This quota can be used by all roles",
              add_only_for_roles_rule: "Restrict this quota to certain roles",
              remove_only_for_roles_rule: "Allow this quota for all roles",
              no_tickettype: "None",
              all_tickettypes: "All",
              no_tickettype_desc: "This quota cannot be used by any ticket type",
              all_tickettypes_desc: "This quota can be used by any ticket type",
              add_only_for_tickettypes_rule: "Limit this quota to certain ticket types.",
              remove_only_for_tickettypes_rule: "Allow this quota for all ticket types",
              since_always: "always",
              for_ever: "always",
              start_at: "start of screening",
              stop_at: "end of screening",
              tickets: "Ticket types",
              bucket_intern: "This quota is used internally by the system",
              stash_bucket: "This quota can only give to another quota."
            }
          },
          cron_tasks: {
            _id: "Username",
            informations: "General information",
            add: "Add a task",
            cron_task: "Task",
            cron_task_plural: "Tasks",
            name: "Name",
            name_placeholder: "Please enter a name",
            update_cron_task: "Modification of the task {{ name }}",
            confirm_delete: "Do you really want to delete this task?",
            frequency: "Frequency",
            request: "Request",
            url: "URL",
            url_placeholder: "Please enter the request URL",
            method: "HTTP method",
            method_placeholder: "Please select the method to be used",
            interval_description: "{{ nb }} executions with status {{ status }} between {{ from }} and {{ to }}",
            nb_executions: "{{ nb }} executions",
            this_task_is_disabled: "This task is inactive.",
            disable_this_task: "Disable this task",
            enable_this_task: "Enable this task",
            status_pending: "Pending",
            status_in_progress: "In progress",
            status_completed: "OK",
            status_failed: "In error"
          },
          roles: {
            default: "Default",
            eshop: "Online Sale",
            "on-site": "On site Sale",
            partner: "Partner",
            accred: "Accred",
            admin: "Admin",
            mobile: "Mobile application",
            customer: "Customer (connected)",
            pos: "Point of sale interface",
            overbooker: "Force bookings",
            transfer: "Transfer",
            ticket_editor: "Ticket editor",
            refund: "Refund",
            wallet_cashier: "E-wallet cashier",
            wallet_manager: "E-wallet manager",
            accounting: "Accounting",
            entry_check: "Entry check",
            stats: "Statistics",
            integrator: "Integrator",
            waiter: "Waiter"
          },
          help: {
            display: "Display help",
            hide: "Hide help"
          },
          statstypes: {
            statstype_plural: "Stats types",
            statstype: "Stat type",
            reservations: "Bookings",
            movies: "Movies",
            ticket: "Ticket",
            price: "Price",
            entries: "Entries",
            prices: "Prices",
            halls: "Halls",
            percentage: "Percentage",
            income_daily: "Daily income",
            box_office: "Box Office",
            income_hourly: "Hourly income",
            shopping_carts: "Shopping carts",
            total: "Total",
            screenings: "Screenings",
            screenings_small: "Screen.",
            show_screenings: "Show the screenings",
            hide_screenings: "Hide the screenings",
            date: "Date",
            gross: "Gross",
            tax: "Local tax",
            exempt: "Exempt",
            deduction: "Deduction",
            print: "Print",
            texts: {
              reservations: "État des réservations",
              movies: "Stats based on movies",
              prices: "Stats based on ticket rate",
              halls: "Stats based on halls",
              income_daily: "Entries and income based on week day",
              box_office: "Top entries and incomes",
              income_hourly: "Entries and income based on hour",
              shopping_carts: "Shopping carts stats"
            },
            form: {
              date_start: "Starting date",
              date_start_tooltip: "Pick a starting date",
              date_end: "Ending date",
              date_end_tooltip: "Pick an ending date",
              cinema: "Cinema",
              all_cinemas: "All cinemas",
              cinema_tooltip: "Pick a cinema",
              hall: "Room",
              all_halls: "All the rooms",
              hall_tooltip: "Pick a room",
              filters: "Filters",
              search: "Search",
              show: "Show",
              from: "from",
              to: "to"
            },
            chart: {
              free_entries: "Free",
              free_entries_small: "Free",
              pass_entries: "Pass",
              pass_entries_small: "Pass",
              paid_entries: "Paid",
              paid_entries_small: "Paid",
              income: "Income"
            }
          },
          widgets: {
            delete_confirm: "Do you really wish to delete this widget?",
            reset_confirm: "Do you really wish to reset the dashboard?",
            reset: "Reset",
            edit_dashboard: "Edit",
            back: "Back",
            delete: "Delete",
            settings_btn: "Settings",
            save: "Save",
            cancel: "Cancel",
            "24h_revenue": "Revenue (last 24h)",
            "24h_entries": "Entries (last 24h)",
            "7d_revenue": "Revenue (last 7 days)",
            "7d_entries": "Entries (last 7 days)",
            title_desc: {
              clock: "Clock",
              clock_desc: "Displays time and date",
              weather: "Weather",
              weather_desc: "Displays weather informations",
              separator: "Separator",
              separator_desc: "Empty space to help with dashboard layout",
              shortcut: "Shortcut",
              shortcut_desc: "Custom shortcut to your most used features",
              graphBoxOffice: "Box office",
              graphBoxOffice_desc: "Top sellers & revenue",
              lastEvents: "Last Events",
              lastEvents_desc: "Latest events created"
            },
            settings: {
              parameters: "Parameters",
              options: "Display options",
              width: "Width",
              color: "Text color",
              bgColor: "Background color",
              bgTransparent: "Transparent background",
              use_current_location: "Use current location",
              default: "Default",
              zipcode: "Zip code (CH)",
              shortcut_target: "Shortcut target",
              chose_shortcut: "Chose shortcut",
              chose_shortcut_alert: "Please select a shortcut!",
              time_window: "Time window",
              daily: "Daily",
              weekly: "Weekly",
              monthly: "Monthly",
              entries_max: "Max entries",
              eventTypes: {
                movies: "Movies",
                dramas: "Dramas",
                music_groups: "Music groups",
                services: "Service",
                chose_eventType: "Event type",
                chose_event_alert: "Please chose event type!",
                chose_eventNumber: "Event(s) count",
                latest_movies: "Latest movies",
                latest_dramas: "Latest dramas",
                latest_groups: "Latest music groups",
                latest_services: "Latest services",
                show_event: "Show",
                new_programmation: "Programmation"
              }
            }
          },
          tickettypes: {
            _id: "Id",
            informations: "Information",
            add: "Add ticket type",
            tickettype: "Ticket Type",
            tickettype_plural: "Ticket Types",
            name: "Name",
            name_placeholder: "Please enter a name",
            description: "Description",
            description_placeholder: "Please enter a description",
            renewable: "Renewable",
            renewTypeInformation: {
              one_time_pass_price_information: "One-time ticket prices are managed in the pricing lists.",
              choose_renew_type: "Please choose a renewal type",
              help_text_show: "Show the information table",
              help_text_hide: "Hide the information table",
              help_description: "The table defines the renewable date of the subscription.",
              if_user_renews: "If a user renews",
              now_key: "Now",
              expiration_key: "Expiration",
              "start-of-year_key": "Start of year",
              latest_key: "Latest possible",
              soonest_key: "Earliest possible",
              before_expiration_date: "Before the expiry date",
              expiration_date: "On the expiry date",
              after_expiration_date: "After the expiry date",
              now: "Now",
              at_expiration_date: "At the expiry date",
              start_of_next_year: "Beginning of next year",
              start_of_current_year: "Start of current year"
            },
            eshop_sort_weight: "Order",
            update_tickettype: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this ticket type?",
            pricings: "Pricings",
            pricings_maybe_plural: "Pricing(s)",
            add_pricing: "Add a pricing",
            new_duplicate_id: "New ID",
            id_already_used: "The ID is already used",
            pricing: {
              base_informations: "Base informations",
              display: "Display",
              rules: "Rules",
              name: "Name",
              name_placeholder: "Pricing Name",
              description: "Description",
              description_placeholder: "Please enter a description",
              price: "Price",
              value: "Value",
              vat: "VAT",
              sellers: "Sellers",
              eshop_sort_weight: "Ordre",
              category: "Category",
              additional_class_names: "CSS class",
              limit_to_sellers: "Limit the pricing to following roles",
              limit_to_tickettypes: "Limit the pricing to following ticket type",
              exclude_tickettypes: "Interdire ce tarif aux types de billets suivants",
              not_before: "Valid from (not implemented yet)",
              not_after: "Valid to (not implemented yet)"
            },
            windows: "Reservation windows",
            windows_maybe_plural: "Reservation window(s)",
            add_window: "Add rules",
            window: {
              screening_id: "Screening ID",
              duration: "Duration",
              start_at: "For events that start on or after",
              stop_at: "and finish on or before",
              nbookings: "Maximum number of bookings",
              nsame_screening: "For the same event",
              overlap: "Overlap rule",
              same_day: "Same day",
              overlap_question_positive: "Allow reserved events to overlap by",
              overlap_question_negative: "Force reserved events to be spaced by"
            },
            pdflayouts: "PDF Layouts",
            emails: "Emails",
            add_fields: "Define optional and mandatory fields",
            fields: "Fields",
            available_fields: {
              requested_description: "Please select requested fields",
              required_description: "Please select required fields",
              company: "Company",
              title: "Title",
              firstname: "First name",
              lastname: "Last name",
              email: "Mail",
              address: "Address",
              zip: "Zip code",
              city: "City",
              country: "Country",
              phone: "Phone",
              cellphone: "Cellphone",
              age: "Age",
              birthdate: "Birthdate",
              photo: "Photo",
              sex: "Gender",
              gift_message: "Is it a gift?"
            }
          },
          screenings: {
            _id: "Identifier",
            refs: "References",
            informations: "Information",
            add: "Add new screening",
            screening: "Screening",
            screening_plural: "Screenings",
            name: "Name",
            place: "Place",
            date: "Date",
            buckets: "Buckets",
            description: "Description",
            capacity: "Capacity",
            name_placeholder: "Please enter a name",
            description_placeholder: "Please enter a description",
            capacity_placeholder: "Please enter a capacity",
            update_place: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this screening?",
            title: "Title",
            map_only_bookings: "On map reservations",
            start_at: "Start at",
            stop_at: "Stop at",
            duration: "Duration",
            starts: "Starts",
            date_disabled_tooltip: "This screening is in the past, ongoing, or already has reservations. Therefore, you cannot change its dates.",
            sections: "Sections",
            no_section: "No section",
            _3d: "3D",
            break: "Break",
            format: "Format",
            version: "Version",
            version_small: "Vers.",
            week: "Week",
            week_small: "Week",
            details: "Details",
            events: "Events",
            add_event: "Add an event",
            update_screening: "Update {{ title }}",
            tasks: "Tasks",
            posters: "Images",
            add_poster: "Add an image",
            support: "Media",
            languages: "Languages",
            audio: "Audio",
            subtitles: "Subtitles",
            ignore_on_maccsbox: "Ignore on Maccsbox",
            list: {
              total: "Total",
              confirmed: "Confirmed",
              unconfirmed: "Unconfirmed",
              available: "Available"
            },
            edit: {
              itemlist: {
                general: "General",
                bucket: "Buckets",
                booking: "Bookings",
                pricing: "Pricings",
                history: "Logs",
                map: "Map"
              },
              form: {
                original: "Original",
                name_placeholder: "Enter a name",
                description_placeholder: "Enter a description",
                note_placeholder: "Enter a note (Not visible publicly)",
                version_placeholder: "Please input the language",
                format_placeholder: "Please input the format",
                general: {
                  names: "Names",
                  descriptions: "Descriptions",
                  place: "Place",
                  dates: "Dates",
                  start_at: "Start at",
                  stop_at: "Stop at",
                  description: "Description",
                  note: "Note",
                  save_names: "Save names",
                  save_place: "Save place",
                  save_dates: "Save dates",
                  save_descriptions: "Save descriptions",
                  save_note: "Save note"
                },
                buckets: {
                  id: "Identifier",
                  rules: "Rules",
                  can_take_from: "May steal from",
                  bookings: "Bookings",
                  capacity: "Capacity",
                  total_capacity: "Total",
                  no_role: "None",
                  all_roles: "All",
                  no_tickettype: "None",
                  all_tickettypes: "All",
                  since_always: "Since always",
                  for_ever: "For ever",
                  sellers: "Roles",
                  not_before: "Available since",
                  not_after: "Available until",
                  tickets: "Ticket types",
                  bucket_intern: "This bucket is used by the system internally",
                  stash_bucket: "This quota can only give another"
                },
                logs: {
                  checkin: "Check-in",
                  checkout: "Checkout",
                  confirm_booking: "Confirm booking",
                  activate: "Activated ticket",
                  unbook: "Cancel booking",
                  date: "Date",
                  action: "Action",
                  ticket: "Ticket",
                  by: "By"
                },
                ticket: {
                  id: "Id",
                  one_time_pass: "one time pass",
                  new: "New",
                  activated: "Activated",
                  blocked: "Blocked",
                  pending: "Payment pending",
                  type: "Type",
                  pricing: "Pricing",
                  value: "value",
                  booking_date: "Booking date",
                  status: "Status",
                  name: "Name",
                  email: "Email",
                  tel: "Phone",
                  nb_bookings: "{{ nb }} bookings",
                  seats: "Seat",
                  scanned: "Scanned",
                  in_room: "In room"
                },
                maps: {
                  change_map: "Change map"
                }
              }
            },
            import: {
              imported_at: "Imported on {{ date }}",
              resume: "In a nutshell",
              nb_deleted: "{{ nb }} screenings have been deleted",
              nb_inserted: "{{ nb }} screenings have been created",
              nb_updated: "{{ nb }} screenings have been updated",
              nb_invalid: "{{ nb }} screenings are invalid",
              inserted: "Created screening(s)",
              updated: "Updated screening(s)",
              invalid: "Invalid screening(s)",
              an_error_occured: "An error has occurred during synchronisation. Please try again later.",
              was_useless: "The import was successful but had no effect.",
              screenings_tab: "Screenings"
            }
          },
          tickets: {
            ticket: "Ticket",
            ticket_plural: "Tickets",
            status: {
              all: "All statuses",
              new: "New",
              pending: "Pending payment",
              activated: "Activated",
              blocked: "Blocked"
            },
            filters: {
              search: "Search",
              search_placeholder: "Name, first name, e-mail or ID",
              status: "Status",
              tickettypes: "Ticket types",
              filter_on_batches: "Filter on imports",
              imported_at: "Tickets created during the import of",
              activated_at: "Tickets activated during the import of",
              filter_on_emails: "Filter on received e-mails",
              received_email: "Tickets which received this email",
              received_email_placeholder: "Please choose an e-mail",
              not_received_email: "Tickets that have not received this email",
              not_received_email_placeholder: "Please choose an email",
              filter_on_bookings: "Filter on bookings",
              having_booked: "Tickets that have at least one booking",
              having_not_booked: "Tickets that have no booking",
              having_booked_screening_id: "Tickets that have booked this session",
              having_booked_screening_id_placeholder: "Please choose a screening"
            },
            columns: {
              _id: "Identifiers",
              owner: "Owner",
              firstname: "First name",
              lastname: "Last name",
              email: "E-mail",
              status: "Status",
              type: "Type",
              activated_pricing: "Price",
              nbookings: "Bookings",
              created_at: "Created on"
            },
            import: {
              title: "Import tickets",
              desc: "Import tickets allows you to import tickets from a CSV file.",
              download_csv_file: "Download the csv template file",
              download_xlsx_file: "Download the xlsx template file",
              tab_title: "Tickets",
              file_goods: "You are about to import {{ nb }} tickets",
              file_errors: "You have {{ nb }} error(s) in your CSV file",
              file_errors_desc: "Please correct your file and resubmit it",
              x_tickets_of_type: "{{ nb }} tickets of type {{ name }}",
              x_tickets_of_price: "{{ nb }} tickets at {{ name }} price",
              send_x_emails: "Send {{ nb }} emails",
              send_x_emails_of_type: "Send {{ nb }} emails {{ name }}",
              choose_csv_file: "Please choose a CSV file",
              do_import: "Start import",
              do_another_import: "Import another file",
              line_x: "Line {{ line }}",
              preview_view: "Preview",
              resume_view: "Summary",
              field_is_invalid: "The cell {{ field }} is invalid",
              an_error_occured: "An error has occurred during import. Please try again later.",
              columns: {
                line: "Line",
                nb: "Number",
                type: "Type",
                pricing: "Price",
                title: "Title",
                firstname: "First name",
                lastname: "Last name",
                email: "E-mail",
                zip: "Zip",
                city: "City",
                country: "Country",
                photo: "Photo",
                cellphone: "Phone",
                sex: "Sex",
                age: "Age",
                language: "Language",
                company: "Company",
                screening: "Séance",
                row: "Rang",
                seat: "Number",
                prefix: "PDF prefix"
              },
              imported_at: "Import from {{ date }}",
              resume: "In summary",
              nb_deleted: "{{ nb }} tickets have been deleted",
              nb_inserted: "{{ nb }} tickets have been created",
              nb_updated: "{{ nb }} tickets have been updated",
              nb_activated: "{{ nb }} tickets have been activated",
              nb_invalid: "{{ nb }} invalid ticket(s)",
              inserted: "Ticket(s) created",
              updated: "Ticket(s) updated",
              activated: "Ticket(s) activated",
              invalid: "Ticket(s) invalid"
            },
            batch: {
              send_email: "Send an e-mail"
            }
          },
          programmations: {
            add: "Add new programmation",
            programmation: "Programmation",
            programmation_plural: "Programmations",
            update_place: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this programmation?",
            title: "Screenings title",
            title_placeholder: "Please enter a title for the screenings",
            description: "Screenings description",
            timing: "Timing",
            days: "days",
            hours: "Hours",
            period: "Duration",
            start_at: "Start",
            stop_at: "End",
            _3d: "3D",
            break: "Break",
            format: "Format {{ format }}",
            version: "Version {{ version }}",
            week: "Week {{ week }}",
            details: "Options",
            events: "Events",
            add_event: "Add an event",
            update_programmation: "Update",
            all_days: "All days",
            each_days: "Every {{ days }}",
            at: "at {{ time }}",
            in_the_place: "in  {{ place }}",
            pricinglist: "Pricings list {{ pricinglist }}",
            bucketlist: "Buckets template {{ bucketlist }}",
            x_screenings: "{{ nb }} screenings",
            ignored_on_maccsbox: "Ignored on Maccsbox",
            copy_options_to_other: "Copy these options everywhere",
            screenings: "Screenings",
            generate_screenings: "Generate screenings",
            see_x_screenings: "See {{ nb }} screenings",
            regenerate_screenings: "Re-generate screenings",
            tasks: "Tasks",
            support: "Media",
            support_dcp: "DCP",
            support_dvd: "DVD",
            support_blu_ray: "Blu-ray",
            support_video_file: "Video file",
            support_other: "Other",
            section: "Section",
            languages: "Languages",
            audio: "Audio",
            subtitles: "Subtitles",
            ignore_on_maccsbox: "Ignore on Maccsbox",
            booking_option: "Booking option",
            booking_mode: {
              title: "Reservation method",
              normal: "Ticketack",
              free: "Free entrance (no free tickets or capacity checks)",
              free_placeholder: "Additional instructions (optional)",
              email: "Reservation by email",
              email_placeholder: "Contact e-mail address",
              other: "Reservation on another system",
              other_placeholder: "Additional instructions, link to other system (optional)"
            }
          },
          tktInstances: {
            is_active: "Active",
            informations: "Information",
            add: "Add new ticketack instance",
            tktInstance: "Ticketack instance",
            tktInstance_plural: "Ticketack instances",
            name: "Name",
            slug: "Slug",
            engine_url: "Engine URL",
            solego_url: "Solego URL",
            api_key: "API key",
            email: "Email",
            name_placeholder: "Please enter the instance name",
            slug_placeholder: "Please enter the instance slug",
            engine_url_placeholder: "Please enter the engine URL",
            solego_url_placeholder: "Please enter the solego URL",
            api_key_placeholder: "Please enter your ticketack user apikey",
            email_placeholder: "Please enter your email",
            options: "Options",
            modules: "Modules",
            languages: "Languages",
            sms_username: "SMS user",
            sms_username_placeholder: "Please enter the SMS username",
            sms_password: "SMS password",
            sms_password_placeholder: "Please enter the SMS password",
            update_tktInstance: "Edit {{ url }}",
            delete: "Delete {{ name }} instance",
            confirm_delete: "Do you really want to delete this ticketack instance?"
          },
          abilities: {
            abilities_template: "Abilities templates",
            name: "Name",
            template: "Template",
            create: "Create",
            read: "Read",
            edit: "Edit",
            delete: "Delete",
            all: "All",
            self: "Self",
            other: "Others",
            apply_template: "Apply template",
            chose_abilities_placeholder: "Chose…",
            create_empty_field_name: "Please provide a name",
            create_name_already_used: "Name already in use",
            forbidden: "Forbidden",
            forbidden_message: "It seems that you do not have the rights to access this page.",
            home: "Home",
            layouts: "PDF and email templates"
          },
          resources: {
            informations: "Information",
            add: "Add a key",
            number: "Number",
            number_placeholder: "Please enter a number",
            type: "Type",
            type_placeholder: "Please enter a type",
            comment: "Comment",
            comment_placeholder: "Please enter a comment",
            user: "User",
            resource: "Key",
            resource_plural: "Keys",
            update_resource: "Edit {{ number }}",
            confirm_delete: "Do you really want to delete this key?"
          },
          distributors: {
            informations: "Information",
            add: "Add a distributor",
            distributor: "Distributor",
            distributor_plural: "Distributors",
            name: "Name",
            name_placeholder: "Please enter a name",
            maccsbox_id: "ID Maccsbox",
            contact_mail: "Contact email",
            report_mail: "Report email",
            maccsbox_id_placeholder: "Please enter the Maccsbox ID",
            contact_mail_placeholder: "Distributor's email address",
            report_mail_placeholder: "Email address to send the report",
            address: "Address",
            address_placeholder: "Please enter an address",
            zip: "Zip code",
            zip_placeholder: "Please enter a zip",
            city: "City",
            city_placeholder: "Please enter a city",
            country: "Country",
            country_placeholder: "Please enter a country",
            update_distributor: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this distributor?"
          },
          events: {
            informations: "Information",
            add_movie: "Add a movie",
            add_artist: "Add an artist",
            add_play: "Add a play",
            add_service: "Add a service",
            sync_and_import: "Synchronisation and import",
            tktsync_kronos: "Synchronize with Ticketack",
            tktsync_eventival: "Eventival synchronization",
            tktsync_json: "Synchronize external source",
            tktsync_cinech: "Ciné.ch synchronization",
            tktsync_kronos_desc_screenings: "Synchronisation with Ticketack allows you to create screenings in your ticketing system from your Kronos programmations.",
            tktsync_kronos_desc_places: "",
            tktsync_eventival_desc_screenings: "Synchronisation with Eventival allows you to create screenings in your ticketing system from your Eventival programming.",
            tktsync_eventival_desc_places: "Venues will be copied from Eventival to Ticketack.",
            tktsync_json_desc_screenings: "Synchronisation with your external source allows screenings to be created in your ticketing system from this source.",
            tktsync_json_desc_places: "The venues will be copied from this source to Ticketack.",
            tktsync_cinech_desc_screenings: "Synchronisation allows you to create screenings in your ticketing system from your program on Ciné.ch.",
            tktsync_cinech_desc_places: "The venues will be copied from Ciné.ch to Ticketack.",
            tktsync_delete_future: "Future screenings will be deleted at the start of synchronisation.",
            tktsync_delete_existing: "Existing screenings will be deleted before they are updated.",
            tktsync_no_delete: "No screenings will be deleted.",
            sync_screenings_tab_kronos: "Screenings",
            sync_screenings_tab_eventival: "Screenings and venues",
            sync_screenings_tab_json: "Screenings and venues",
            sync_screenings_tab_cinech: "Screenings and venues",
            run_tktsync: "Run the synchronisation",
            event: "Event",
            event_plural: "Events",
            title: "Title",
            original_title: "Original title",
            type: "Type",
            description: "Description",
            title_placeholder: "Please enter a title",
            original_title_placeholder: "Please enter an original title",
            description_placeholder: "Please enter a description",
            duration: "Duration (min)",
            details: "Details",
            suisa: "SUISA",
            movie_link: "Official website",
            distributor: "Distributor",
            year: "Year",
            l_min_age: "Leg. min. age",
            s_min_age: "Sug. min age",
            a_min_age: "Acc. min. age",
            suisa_placeholder: "Please enter a SUISA number",
            movie_link_placeholder: "https://kronos.ticketack.com",
            year_placeholder: "Please enter a release year",
            l_min_age_placeholder: "Please enter a legal minimum age",
            s_min_age_placeholder: "Please enter a suggested minimum age",
            a_min_age_placeholder: "Please enter an accompanied minimum age",
            scheduling: "Scheduling",
            free_texts: "Free texts",
            free_text: "Text",
            add_poster: "Add an image",
            posters: "Images",
            add_trailer: "Add a video",
            trailers: "Videos",
            new_trailer_youtube_placeholder: "Add a Youtube ID",
            new_trailer_vimeo_placeholder: "Add a Vimeo ID",
            new_trailer_mp4_placeholder: "Add an mp4 video file direct link",
            genre: "Genre",
            service_type: "Service type de service",
            add_section: "Add a category",
            update_event: "Edit {{ title }}",
            confirm_delete: "Do you really want to delete this event?",
            casting: "Casting",
            new_people_firstname_placeholder: "Please enter a firstname",
            new_people_lastname_placeholder: "Please enter a lastname",
            activity_actor: "Actor",
            activity_cast: "Casting",
            activity_director: "Director",
            activity_editor: "Editor",
            activity_photography: "Photography",
            activity_music: "Music",
            activity_producer: "Producer",
            activity_screenplay: "Screenplay",
            countries: "Countries",
            original_language: "Original language",
            subevent: {
              movie: "Movie",
              drama: "Play",
              music_group: "Artist/Group",
              service: "Other activity"
            },
            subevents: {
              movie: "Movies",
              drama: "Plays",
              music_group: "Artists/Groups",
              service: "Other activities",
              mine_movie: "My movies",
              mine_drama: "My plays",
              mine_music_group: "My artists/groups",
              mine_service: "My other activities",
              all_movie: "All movies",
              all_drama: "All plays",
              all_music_group: "All artists/groups",
              all_service: "All other activities"
            },
            search_placeholder: {
              movie: "Search for a film by title or SUISA number",
              drama: "Search for a play by name",
              music_group: "Search for an artist/group by name",
              service: "Search for other activities by name"
            },
            add: {
              event: "Add an event",
              movie: "Add a film",
              drama: "Add a play",
              music_group: "Add an artist/group",
              service: "Add another activity"
            },
            id: "Identifier:",
            reference: "Reference:"
          },
          common: {
            loading: "Loading...",
            back: "Back",
            save: "Save",
            send: "Send",
            add: "Add",
            cancel: "Cancel",
            close: "Close",
            delete: "Delete",
            edit: "Edit",
            preview: "Preview",
            duplicate: "Duplicate",
            copy_to_mine: {
              movie: "Copy from my films",
              drama: "Copy from my plays",
              music_group: "Copy from my artists/groups",
              service: "Copy to my other activities"
            },
            actions: "Actions",
            show_options: "Show options",
            hide_options: "Hide options",
            and: "and",
            apply: "Apply",
            see: "See",
            mo: "MO",
            tu: "TU",
            we: "WE",
            th: "TH",
            fr: "FR",
            sa: "SA",
            su: "SU",
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
            day: "Day(s)",
            week: "Week(s)",
            cinema_week: "Cinema week(s)",
            month: "Month(s)",
            year: "Year(s)",
            me: "Me",
            no: "No",
            yes: "Yes",
            other: "Other",
            are_you_sure: "Are you sure?",
            drag_one_file: "Drag and drop a file here, or click to select it.",
            yellow: "Yellow",
            yellow2: "Yellow alt.",
            magenta: "Magenta",
            magenta2: "Magenta alt.",
            green: "Green",
            green2: "Green alt.",
            red: "Red",
            red2: "Red alt.",
            blue: "Blue",
            blue2: "Blue alt.",
            white: "White",
            black: "Black",
            brown: "Brown",
            brown2: "Brown alt.",
            grey: "Grey",
            grey2: "Grey alt.",
            none: "None",
            invalid_id_input: "Please only use numbers, letters or the _ key.",
            image_types: {
              default: "Default",
              banner: "Banner (landscape)",
              logo: "Web Logo (300px recommended)",
              poster: "Poster (portrait)",
              "logo-a4": "Logo for A4 PDF",
              "logo-thermal": "Logo for thermal printing (black & white)",
              favicon: "Favicon (32x32px recommended)",
              appicon: "Web App Icon (192x192px recommended)",
              partners: "Partners Logos",
              "partners-a4": "Partners logos for PDF A4",
              "partners-thermal": "Partners logos for thermal printing (black & white)"
            },
            link_types: {
              article: "Article",
              category: "Article category",
              movie: "Movie",
              screening: "Screening",
              url: "Url"
            },
            grammes: "grammes",
            mini_grammes: "g",
            centimeters: "centimètres",
            mini_centimeters: "cm",
            min: "min.",
            duration: {
              years: "Years",
              months: "Months",
              days: "Days",
              hours: "Hours",
              minutes: "Minutes",
              none: "No duration",
              custom: "Custom duration",
              PT5M: "5 minutes",
              PT10M: "10 minutes",
              PT15M: "15 minutes",
              PT30M: "30 minutes",
              PT45M: "45 minutes",
              PT1H: "1 hour",
              PT6H: "6 hours",
              PT12H: "12 hours",
              P1D: "1 day",
              P7D: "1 week",
              P1M: "1 month",
              P6M: "6 months",
              P1Y: "1 year",
              P1Y6M: "18 months"
            },
            sex: {
              "n/c": "No answer",
              m: "Male",
              f: "Female",
              o: "Other"
            }
          },
          languages: {
            ov: "Original version",
            fr: "French",
            de: "German",
            en: "English",
            it: "Italian",
            gsw: "Swiss German",
            fr_de: "French & German"
          },
          posts: {
            informations: "General information",
            add: "Add a post",
            post: "Post",
            post_post: "Post",
            post_plural: "Posts",
            name: "Name",
            title: "Title",
            title_placeholder: "Please enter a title",
            sub_title: "Subtitle",
            sub_title_placeholder: "Please enter a subtitle",
            content: "Message",
            content_placeholder: "Please enter a message",
            category: "Category",
            choose_a_category: "Please choose a category",
            tags: "Tags",
            posters: "Images",
            add_poster: "Add an image",
            trailers: "Videos",
            add_trailer: "Add a video",
            published: "Published",
            archived: "Archived",
            channels: "Broadcast channels",
            confirm_delete: "Do you really want to delete this post?",
            update_post: "Modification of {{ name }}.",
            show_all_categories: "All categories",
            filter_by_category: "Categories",
            please_create_category: "Please create a category",
            please_choose_category_or_make_a_search: "Please choose a category or make a search",
            search: "Search a post",
            search_placeholder: "Enter a post title",
            links: "Links",
            please_create_link: "Please choose a type of link",
            links_placeholder_url: "Enter a url https://www.url.com/{lang}",
            links_placeholder_article: "Enter the id of a movie",
            links_placeholder_category: "Enter the id of a article category",
            links_placeholder_movie: "Enter the id of a movie",
            links_placeholder_screening: "Enter the id of a screening"
          },
          post_categories: {
            informations: "General information",
            add: "Add a category",
            publishing: "publishing",
            post_category: "Category",
            post_categories_plural: "Categories",
            name: "Name",
            name_placeholder: "Please enter a name",
            confirm_delete: "Do you really want to delete this category?",
            choose_a_category: "Please choose a category",
            update_postcategory: "Modification of {{ name }}."
          },
          channels: {
            informations: "General information",
            add: "Add a channel",
            publishing: "Publishing",
            channel: "Channel",
            channels_plural: "Channels",
            name: "Name",
            name_placeholder: "Please enter a name",
            confirm_delete: "Do you really want to delete this channel?",
            choose_a_channel: "Please choose a channel",
            update_channel: "Modification of {{ name }}",
            salepoint: "Sale point",
            cashregister: "Cashregister",
            slug: "Uniaue identifier",
            active_from: "Active from",
            active_until: "Active until",
            only_for_roles: "Only for following roles"
          },
          phases: {
            informations: "General information",
            add: "Add a phase",
            phase: "Phase",
            phases_plural: "Phases",
            name: "Name",
            name_placeholder: "Please enter a name",
            confirm_delete: "Do you really want to delete this phase ?",
            update_phase: "Modification of {{ name }}.",
            active_from: "Active from",
            active_until: "Active until",
            from_to: "From {{ from }} to {{ to }}"
          },
          salepoints: {
            informations: "Information",
            add: "Add a point of sale",
            salepoint: "Point of sale",
            salepoint_plural: "Points of sale",
            name: "Name",
            name_placeholder: "Please enter a name",
            delivery_types: "Delivery modes",
            update_salepoint: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this point of sale?",
            choose_a_salepoint: "Please choose a point of sale",
            default: "By default",
            settings: "Customised configuration for this salepoint",
            pos_layout: "Point of sale type",
            layouts: {
              tickets: "Ticketing point of sale",
              articles: "Merchandising point of sale"
            },
            sell_pass: "Enable the sale of passes",
            places_ids: "Link to following places"
          },
          articlecategories: {
            informations: "Information",
            add: "Add a category",
            articlecategory: "Category",
            articlecategory_plural: "Categories",
            name: "Name",
            name_placeholder: "Please enter a name",
            parent: "Parent category",
            description: "Description",
            pos: "Sale point",
            add_poster: "Add an image",
            posters: "Images",
            update_salepoint: "Edit {{ name }}",
            update_articlecategory: "Edit category",
            confirm_delete: "Do you really want to delete this category?",
            choose_a_category: "Please choose a category",
            please_choose_category: "Please choose a category"
          },
          articles: {
            informations: "Information",
            add: "Add an article",
            add_discount_code: "Add a discount code",
            add_manual_discount: "Add a rebate",
            add_product: "Add a product",
            choose_an_article: "Choose an article",
            article: "Article",
            article_plural: "Articles",
            list: "Show the list",
            order: "Manage orders",
            name: "Name",
            name_placeholder: "Please enter an name",
            short_description: "Short description",
            short_description_placeholder: "Please enter a short description",
            category: "Category",
            sort_weight: "Display order (smallest first)",
            description: "Long description",
            add_poster: "Add an image",
            posters: "Images",
            stock: "Total stock",
            pos: "Sale point",
            variant: "Pricing",
            variants: "Pricings",
            variant_name: "Name",
            variant_name_placeholder: "Name",
            variant_stock: "Stock",
            variant_stock_factor: "Weight on total stock",
            variant_gtin: "EAN code",
            variant_sku: "SKU",
            variant_price: "Price",
            variant_variable_price: "Variable price",
            variant_value: "Value",
            variant_value_like_price: "Same value as the price",
            variant_purchasing_price: "Purchasing price",
            variant_vat: "VAT",
            variant_discount: {
              code: "Code",
              value_amount: "Fix rebate",
              value_percentage: "Percentage %",
              target: "Applies",
              cart_target: "To the whole cart",
              last_item_target: "To the last cart item",
              only_for_roles: "Allow following roles",
              only_for_tickettypes: "Allow following ticket types",
              exclude_tickettypes: "Exclude following ticket types"
            },
            add_variant: "Add a pricing",
            update_salepoint: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this article?",
            show_all_categories: "All categories",
            filter_by_category: "Categories",
            filter_by_type: "Articles types",
            please_create_category: "Please create a category",
            please_choose_category_or_make_a_search: "Please choose a category or make a search",
            type_product: "Product",
            type_manual_discount: "Rebate",
            type_auto_discount: "Automatic rebate",
            type_code_discount: "Discount code",
            search: "Search an article",
            search_placeholder: "Enter an article name",
            stocks: {
              name: "Stocks",
              stock_type: "Stock type",
              type_none: "No stock management",
              type_article: "Stock management by article",
              type_variant: "Stock management by pricing",
              availability: "Availability",
              variant_price: "Price {{ index }}"
            },
            tags: "Tags",
            export_stocks: "Export stocks",
            features: "Features",
            add_feature: "Add a feature",
            delete_feature: "Delete this feature",
            feature: {
              name: "Name",
              name_placeholder: "Please enter an name",
              short_description: "Short description",
              short_description_placeholder: "Please enter a short description",
              category: "Category",
              description: "Long description",
              add_poster: "Add an image",
              posters: "Images",
              stock: "Total stock",
              pos: "Sale point",
              variant: "Pricing",
              variants: "Pricings",
              variant_name: "Name",
              variant_name_placeholder: "Name",
              variant_stock: "Stock",
              variant_stock_factor: "Weight on total stock",
              variant_gtin: "EAN code",
              variant_sku: "SKU",
              variant_price: "Price",
              variant_variable_price: "Variable price",
              variant_value: "Value",
              variant_purchasing_price: "Purchasing price",
              variant_vat: "VAT",
              variant_discount: {
                code: "Code",
                value_amount: "Fix rebate",
                value_percentage: "Percentage %",
                target: "Applies",
                cart_target: "To the whole cart",
                last_item_target: "To the last cart item",
                only_for_roles: "Allow following roles",
                only_for_tickettypes: "Allow following ticket types",
                exclude_tickettypes: "Exclude following ticket types"
              },
              add_variant: "Add a pricing",
              update_salepoint: "Edit {{ name }}",
              confirm_delete: "Do you really want to delete this article?",
              show_all_categories: "All categories",
              filter_by_category: "Categories",
              filter_by_type: "Articles types",
              please_create_category: "Please create a category",
              please_choose_category_or_make_a_search: "Please choose a category or make a search",
              type_product: "Product",
              type_manual_discount: "Rebate",
              type_auto_discount: "Automatic rebate",
              type_code_discount: "Discount code",
              search: "Search an article",
              search_placeholder: "Enter an article name",
              stocks: {
                name: "Stocks",
                stock_type: "Stock type",
                type_none: "No stock management",
                type_article: "Stock management by article",
                type_variant: "Stock management by pricing",
                availability: "Availability",
                variant_price: "Price {{ index }}"
              },
              tags: "Tags",
              export_stocks: "Export stocks",
              features: "Features",
              add_feature: "Add a feature",
              delete_feature: "Delete this feature",
              feature: {
                name: "Name",
                choices: "Value"
              },
              extras: "Options",
              add_extra: "Add an option",
              delete_extra: "Delete this option",
              extra: {
                name: "Option",
                min_nb_choices: "Min. number of choices",
                max_nb_choices: "Max. number of choices",
                choices: "Choice",
                add_choice: "Add a choice",
                default_choice: "Default choice",
                default_choice_placeholder: "Please choose an option"
              },
              delivery: "Delivery",
              delivery_types: "Delivery modes"
            }
          },
          activities: {
            informations: "Information",
            add: "Add an activity",
            activity: "Activity",
            activity_plural: "Activities",
            name: "Name",
            name_placeholder: "Please enter a name",
            is_exclusive: "Exclusive",
            update_activity: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this activity?",
            email_notification: "Email Notifications",
            sms_notification: "SMS Notifications",
            notification_none: "I don't want to be notified",
            notification_PT10M: "10 minutes before",
            notification_PT30M: "30 minutes before",
            notification_PT1H: "1 hour before",
            notification_PT2H: "2 hours before",
            notification_PT6H: "6 hours before",
            notification_P1D: "1 day before",
            notification_P2D: "2 days before",
            notification_P3D: "3 days before",
            reward: {
              title: "Rewards",
              ticket: {
                type: "Type of ticket",
                type_desc: "Type of ticket to be used to create the reward ticket",
                pricing: "Tariff",
                pricing_desc: "Price to be used to activate the reward ticket"
              },
              bookings: {
                title: "Bookings",
                nb_hours: "Number of hours for a booking",
                nb_hours_desc: "Number of hours required to obtain the right to a booking",
                at_the_end: "At the end of the shift",
                at_the_end_desc: "Do you have to wait until the end of the shift to obtain the right to a reservation?"
              },
              wallet: {
                title: "Wallet",
                nb_hours: "Number of hours for 1 {{ currency }}",
                nb_hours_desc: "Number of hours required to obtain 1 {{ currency }}",
                at_the_end: "At the end of the shift",
                at_the_end_desc: "Is it necessary to wait until the end of the shift to obtain 1 {{ currency }}?"
              }
            }
          },
          plan: {
            title: "Planning",
            calendar: null,
            week: "Week",
            work_week: "Work week",
            day: "Day",
            month: "Month",
            previous: "Prev..",
            next: "Next",
            today: "Today",
            agenda: "Agenda",
            showMore: "+{{total}} more",
            select_sector: "Please choose a sector",
            from: "From",
            to: "To",
            sector: "Sector",
            event: {
              nb_volunteers: "{{ nb }} volunteer(s)",
              nb_validated: "{{ nb }} validated(s)"
            }
          },
          shifts: {
            sector: "Sector",
            dates: "Dates",
            start_at: "From",
            stop_at: "To",
            volunteers: "Volunteers",
            needs: "Needs",
            nb_volunteers: "Number of volunteers",
            assigned: "Assigned",
            activity: "Activity",
            suggestions: "Suggestions",
            no_suggestions_found: "No volunteers available",
            available: "Available",
            out_of_sector: "Out of sector",
            overbooked: "Overbooked",
            status: "Task status",
            status_new: "New (the volunteer is chosen by the manager)",
            status_free: "To be filled (volunteers can take on this task)",
            user_can_not_be_found: "This volunteer cannot be found"
          },
          tasks: {
            informations: "Information",
            add: "Add a task",
            task: "Task",
            task_plural: "Tasks",
            is_exclusive: "Exclusive",
            update_task: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this task?",
            activity: "Activity",
            start_at: "Start at",
            stop_at: "Stop at",
            start_at_gte: "From",
            start_at_lte: "To",
            screening: "Screening",
            phase: "Phase",
            sector: "Sector",
            user: "Assigned to",
            comment: "Comment",
            status: "Status",
            status_new: "New",
            status_free: "To provide",
            status_assigned: "Assigned",
            status_claimed: "Claimed",
            status_renounced: "Renounced",
            timing: "Timing",
            assign: "Assign to",
            claim: "Claim",
            accept: "Accept",
            refuse: "Refuse",
            renounce: "Renounce",
            abilities: {
              tasks_abilities: "Tasks' abilities",
              assign: "Assign",
              change_status: "Change status",
              claim_for_others: "Claim for other",
              renounce_for_others: "Renounce for other",
              claim: "Claim",
              renounce: "Renounce"
            },
            renounce_modal: {
              title: "Personnalized message"
            },
            filters: {
              group: "Group",
              group_by_days: "By day",
              group_by_screenings: "By screening",
              group_by_shifts: "By shift",
              group_by_sectors: "By sector",
              view_mode: "View",
              view_mode_details: "Detailed",
              view_mode_resume: "Resumed"
            },
            admins: "Resp. :",
            copy_to_clipboard: "Copy to clipboard"
          },
          cashregisters: {
            informations: "Information",
            add: "Add a cash register",
            cashregister: "Cash register",
            cashregister_plural: "Cash registers",
            name: "Name",
            name_placeholder: "Please enter a name",
            update_cashregister: "Edit {{ name }}",
            confirm_delete: "Do you really want to delete this cash register?",
            salepoint: "Sale point",
            auto_closing: "Automatic closing",
            auto_closing_enabled: "Enabled",
            auto_closing_disabled: "Disabled"
          },
          messages: {
            informations: "Information",
            send: "Send",
            send_message: "Send a message",
            message: "Message",
            message_placeholder: "Please write a message",
            recipients: "Recipients",
            recipients_question: "To whom would you like to send a message?",
            recipients_desc: "You are about to send an e-mail to {{ nb }} recipient(s).",
            show_recipients: "Show recipients",
            hide_recipients: "Hide recipients",
            users: "Employees",
            users_placeholder: "You can choose one or more users",
            activities: "Skills",
            activities_placeholder: "You can choose one or more skills",
            message_desc: "What message would you like to send?",
            layout_message: "Choose a pre-defined e-mail",
            layout_message_placeholder: "You can choose an existing e-mail",
            subject: "Subject of your message",
            subject_placeholder: "Enter the subject of your message",
            custom_message: "Add a custom message"
          },
          sections: {
            informations: "Information",
            add: "Add a section",
            section_plural: "Sections",
            name: "Name",
            name_placeholder: "Please enter a name"
          },
          definition: {
            name: "The name of the ticket type in each of the activated languages, this name will appear on the interface of the point of sale and/or your website or that of the ticket office.",
            tkt_id: "This is an internal identifier for this type of subscription, it will be entered by the Ticketack team and you don't have to worry about it.",
            description: "The description of the type of ticket, in each of the activated languages, can be presented to customers who make their purchase online. It is also possible to include this description in the layout of the ticket.",
            eligibility: "Indicate here a short sentence for staff who scan tickets at the entrances only for those tickets that require a piece of identification (e.g. student card).",
            price: "The price is the amount charged to the buyer.",
            value: "The value is the book value of this fare from a ticketing point of view. In general the value is equal to the price. If you have money from a third party in addition to the price when you sell this fare (subsidy for example); in this case indicate an equal value + the subsidy received, the system will then automatically calculate the amounts to be claimed. On the contrary, if you have to pay a third party a price (commission from a third party for example), indicate a value lower than the price. Finally, if the price is paid in advance using another system - or on the contrary will be paid later, for example on invoice - then indicate a 0 and a value corresponding to the amount collected on the other system.",
            value_per_screening: "In the case of subscriptions or other ticket types for several events, you can break down the value to be assigned per event here. For example, in the case of a 10 admission card at CHF 100, you could decide to assign CHF 10 to each booking.",
            wallet_amount: "This amount will be automatically credited to the ticket wallet.",
            category: "In the case of numbered seats, the category of a fare must correspond to the category of seats for which that fare is available.",
            order: 'The integer that defines the order of the tariff, the larger the integer, the "last" the tariff will appear.',
            css_class: "Allows you to specify a CSS class to give a particular visual style to a tariff using your custom style sheet (this style can be different on the point of sale, eshop or mobile application).",
            valid_from: "Start date of validity of the tariff.",
            valid_to: "Pricing expiry date.",
            role: " Enter here a list of user roles that are allowed to sell tickets at this rate. The default available roles are as follows: ADMIN: all ESHOP administrators: your website, the ticketing website and the mobile application if available. ON-SITE: your staff at the points of sale during the event. PARTNER: external partners (tourist office, partner shops, etc.). ACCRED: all users who have this role (generally the accreditation office). Note: if no role is selected, the tariff will be deactivated. Note: to select several roles, hold down the Ctrl key.",
            pricing_limit: "Here you have the possibility to display this tariff only for people who are connected with a specific type of ticket (season ticket, accreditation, etc.).",
            pricing_forbiden: "Here you can define that if a person is logged in with a specific type of ticket, they should not see this tariff.",
            screening_id: "A Ticketack session ID (this field will usually be empty as the eligibility of a ticket type for a session is usually managed with the quotas.",
            duration: "A duration in ISO 8601 format, e.g. P1Y, means that this rule is valid for one year from the date of creation.",
            reservation_number: "Corresponds to the maximum number of sessions that the buyer can book for this rule.",
            same_screening: "Allows you to indicate the number of times you can book for the same session under this rule.",
            overlap: "Here you can define whether it is possible to book two events that overlap or are close to each other. For example, the system allows you to prohibit the reservation of two partially overlapping sessions or to prohibit the reservation of a session that starts less than a certain number of minutes after the end of another session. Overlap is defined in ISO 8601 format, e.g. PT0M means that the end of one session cannot overlap with the start of another within this rule. If you leave the field blank then it will be possible to book several overlapping sessions if the rest of the rule definition allows it. If you indicate PT10M then the start of a session must take place at least 10 minutes after the end of another session booked within this rule. Finally if you indicate -PT15M then it is allowed to book a session that starts up to 15 minutes before the end of the session previously booked within this rule.",
            same_day: " If you tick this box, all subscription bookings must be for events taking place on the same day. This option is mainly used for day passes with no fixed date. Please note: if you have events after midnight, this option may be undesirable, please contact us to establish the best course of action in this case.",
            field: " Specify here a list of user roles that have the right to access this quota. The default available roles are as follows: admin: All administrators. eshop: Your website, the ticket office and the mobile application if available on-site: Your staff at the points of sale during the event. p artner: External partners (tourist office, partner shops, etc.). accred: All users who have this role (usually the accreditations office).",
            "bucket.total_capacity": "Enter the total capacity of this quota here. You can enter a fixed number or an arithmetic expression using the variables total_capacity, prm_capacity and/or remainder. Ex: total_capacity*0.9",
            "bucket.may_steal_from": "Choose the quotas from which this one can steal.",
            "bucket.not_before": "Indicate here the start date for the validity of this quota. You can enter a fixed date in iso 8601 format (e.g. 2024-11-25T16:41:00) or an expression in the form start_at+D3@06:00 to indicate the Wednesday (3rd day of the week) following the start date, at 6am. Or stop_at-PT25M, to indicate 25 minutes before the end date. Or start_at or stop_at for the start or end dates.",
            "bucket.not_after": "Enter the end date for the validity of this quota here. You can enter a fixed date in iso 8601 format (e.g. 2024-11-25T16:41:00) or an expression in the form start_at+D3@06:00 to indicate the Wednesday (3rd day of the week) following the start date, at 6am. Or stop_at-PT25M, to indicate 25 minutes before the end date. Or start_at or stop_at for start or end dates.",
            "bucket.only_for_roles": "Specify here a list of user roles that have the right to use this quota. The default roles are as follows: ADMIN: all ESHOP administrators: your website, ticketing site and mobile application if available. ON-SITE: your staff at the points of sale during the event. PARTNER: external partners (tourist office, partner shops, etc.). ACCRED: all users with this role (usually the accreditation office). Note: if no role is selected, the tariff will be deactivated. Note: to select several roles, hold down the Ctrl key down.",
            "bucket.only_for_tickettypes": "Specify here a list of ticket types with which this quota may be used."
          },
          tags: {
            add_the_tag: "Add the tag"
          },
          layouts: {
            add_from_template: "Add from a template",
            templates: {
              empty: "Empty template",
              empty_desc: "Template containing only the logo and a text widget",
              order_confirmation: "Order confirmation",
              order_confirmation_desc: "Complete template to use for order confirmations"
            },
            x: "Position on horizontal axis",
            y: "Position on vertical axis",
            please_choose_a_layout: "Please choose a layout",
            no_options: "This widget has no option",
            width: "Width",
            height: "Height",
            rotation: "Rotation",
            padding: "Padding",
            font_family: "Font family",
            font_family_placeholder: "Please choose a font family",
            font_family_variant: "Style",
            font_family_variant_placeholder: "Please choose a style",
            font_family_variant_bold: "Bold",
            font_family_variant_italic: "Italic",
            font_family_variant_boldItalic: "Bold and italic",
            font_size: "Font size",
            line_height: "Line heigth",
            object_fit: "Resizing",
            object_fit_placeholder: "Please choose a resizing mode",
            object_fit_none: "Parent's dimensions",
            object_fit_fill: "Fill parent proportionnally",
            object_fit_cover: "Cover parent",
            object_fit_contain: "Contained in parent",
            text: "Text",
            color: "Text color",
            background_color: "Background color",
            add_new_layout: "Add a layout",
            layouts: "Layouts",
            lockRatio: "Keep the proportions",
            update_layout: "Edit {{ name }}",
            layout: {
              title: "Layout",
              name: "Layout name",
              name_placeholder: "Please enter a name",
              subject: "Email subject",
              subject_placeholder: "Please enter a subject",
              dimensions: "Dimensions",
              type: "PDF type",
              target: "Target",
              options: {
                bcc: "Send blind copy to",
                bcc_placeholder: "Enter an e-mail address",
                replyTo: "Reply to",
                replyTo_placeholder: "Enter an e-mail address"
              }
            },
            linksColor: "Links color",
            groups: {
              layout: "Options for this template",
              widgets: "Widgets for this template"
            },
            general_options: "Basic options",
            style_options: "Style options",
            widgets_options: "Widget options",
            layout_options: "Layout options",
            duplicate_layout: "Duplicate this template",
            delete_layout: "Delete this template",
            duplicate_widget: "Duplicate this widget",
            delete_widget: "Delete this widget",
            apply_layout_style: "Save this style",
            page: "Page",
            add_page: "Add a page",
            show_on_page: "Show on page",
            on_all_pages: "On all pages",
            on_odd_pages: "On odd-numbered pages",
            on_even_pages: "On even-numbered pages",
            type_ticket: "Ticket",
            "type_ticket-bookings": "Bookings summary",
            "type_cart-receipt": "Receipt",
            type_closing: "Closing",
            type_bill: "Bill",
            type_order: "Order",
            target_paper: "Print on standard printer",
            target_thermal: "Print on on thermal printer",
            target_card: "Print on on card printer",
            target_other: "Other",
            on_pricing: "For pricing {{pricing}}",
            on_any_pricing: "For all pricings",
            on_other_pricings: "For all other pricings",
            add_pricing_emails: "Add emails for this pricing",
            hook_creation: "On creation",
            hook_activation: "On activation",
            hook_before_expiration: "Before expiration",
            hook_expiration: "On expiration",
            hook_renewal: "On renewal",
            hook_deletion: "On deletion",
            page_options: "Page options",
            add_widget: "Add a widget on this page",
            edit_widget: "Edit this widget",
            list_widget: "List of widgets on this page",
            text_widgets: "Texts",
            text_custom: "Custom text",
            text_owner_info: "Owner information",
            text_screening_info: "Screening information",
            text_ticket_info: "Ticket information",
            text_tickettype_info: "Ticket type information",
            text_customer_info: "Customer information",
            text_environment_info: "Printing environment",
            text_link: "Link",
            image_widgets: "Images",
            image_custom: "Custom image",
            image_qrcode: "QRCode",
            image_library: "Library image",
            image_owner_contact: "Owner photo",
            shape_widgets: "Shapes",
            shape_line: "Line",
            shape_frame: "Frame",
            click_to_choose_image: "Click to choose an image",
            new_widget: "Widget",
            move_backward: "In the background",
            move_forward: "To foreground",
            layout_size: "Dimensions",
            field_to_show: "Field to display",
            field_placeholder: "Please choose a field",
            contact_field_title: "Title",
            contact_field_company: "Company",
            contact_field_firstname: "First name",
            contact_field_lastname: "Last name",
            contact_field_fullname: "Full name",
            "contact_field_fullname-reversed": "Full name reversed",
            contact_field_email: "Email",
            contact_field_age: "Age",
            contact_field_birthdate: "Date of birth",
            contact_field_sex: "Gender",
            contact_field_phone: "Phone",
            contact_field_cellphone: "Mobile phone",
            contact_field_language: "Language",
            "contact_field_address.street": "Street",
            "contact_field_address.city": "City",
            "contact_field_address.zip": "Zip code",
            "contact_field_address.country": "Country",
            screening_field_title: "Title",
            screening_field_venue: "Venue",
            screening_field_place: "Room",
            screening_field_address: "Address",
            screening_field_zip: "Zip",
            screening_field_city: "City",
            screening_field_state: "State",
            screening_field_country: "Country",
            screening_field_start_at: "Start date",
            screening_field_stop_at: "End date",
            screening_field_start_at_stop_at: "Start date - End date",
            ticket_field_ticket_id: "TicketID",
            ticket_field_ticket_id_only: "TicketID (without title)",
            ticket_field_ticket_id_festivalscope: "TicketID (FestivalScope voucher format)",
            ticket_field_uuid: "UUID",
            ticket_field_activated_at: "Activation date",
            ticket_field_activated_pricing_name: "Pricing name",
            ticket_field_activated_pricing_description: "Pricing description",
            ticket_field_activated_pricing_price: "Pricing price",
            ticket_field_first_window: "Validity start date",
            ticket_field_last_window: "End date of validity",
            ticket_field_first_window_last_window: "Start date - end date of validity",
            ticket_field_vat: "VAT",
            tickettype_field_name: "Name",
            tickettype_field_description: "Description",
            environment_field_printer: "Current user name",
            environment_field_salepoint: "Salepoint",
            environment_field_printed_at: "Printing date",
            customer_field_name: "Name",
            customer_field_name_short: "Short name",
            customer_field_phone: "Phone",
            customer_field_address: "Address",
            customer_field_email: "Email",
            customer_field_vat: "VAT number",
            text_alignment: "Alignment",
            text_alignment_placeholder: "Please choose an alignment",
            text_alignment_left: "Left",
            text_alignment_center: "Center",
            text_alignment_right: "Right",
            text_alignment_justify: "Justified",
            vat_format_placeholder: "Please select a format",
            vat_format_with_vat: "VAT 8.1%",
            vat_format_value_only: "8.1%",
            vat_format_full: "VAT {{ value }}%",
            date_format: "Date/time format",
            date_option: "Date/time option",
            date_offset: "Date/time offset",
            date_format_placeholder: "Please select a format",
            date_format_LT: "00:00",
            date_format_LTS: "00:00:00",
            date_format_L: "01/01/1970",
            date_format_l: "1/1/1970",
            date_format_LL: "1 January 1970",
            date_format_ll: "1 Jan 1970",
            date_format_LLL: "1 January 1970 00:00",
            date_format_lll: "1 Jan 1970 00:00",
            date_format_LLLL: "Thursday, January 1, 1970 00:00",
            date_format_llll: "Thu Jan. 1, 1970 00:00",
            "date_format_dddd DD.MM": "Thursday 01.01",
            "date_format_dddd DD.MM.YYYY": "Thursday 01.01.1970",
            "date_format_dddd Do MMM": "Thursday 1st Jan",
            "date_format_dddd Do MMMM": "Thursday 1st January",
            "date_format_dddd Do MMM YYYY": "Thursday 1st Jan 1970",
            "date_format_dddd Do MMMM YYYY": "Thursday 1st January 1970",
            "date_format_ddd DD.MM": "Thu 01.01",
            "date_format_ddd DD.MM.YYYY": "Thu 01.01.1970",
            "date_format_ddd Do MMM": "Thu 1st Jan",
            "date_format_ddd Do MMMM": "Thu 1st January",
            "date_format_ddd Do MMM YYYY": "Thu 1st Jan 1970",
            "date_format_ddd Do MMMM YYYY": "Thu 1st January 1970",
            date_format_midnight_hack: "01/01/1970 at half past midnight",
            midnight: "at midnight",
            midnight15: "at quarter past midnight",
            midnight30: "at half past midnight",
            border_color: "Border color",
            border_width: "Border width",
            border_radius: "Rounded borders",
            border_style: "Border style",
            border_style_placeholder: "Please choose a border style",
            border_style_solid: "Solid",
            border_style_dashed: "Dashes",
            text_decoration: "Text decoration",
            text_decoration_placeholder: "Please choose a decoration",
            text_decoration_none: "None",
            text_decoration_underline: "Underline",
            "text_decoration_line-through": "Crossed out",
            text_transform_placeholder: "Choose a transformation",
            text_transform_none: "None",
            text_transform_capitalize: "Capitalize Every Word",
            text_transform_uppercase: "UPPERCASE",
            text_transform_lowercase: "lowercase",
            link: "Link",
            image_type: "Image type",
            image_type_placeholder: "Please select an image type",
            widget_options: {
              groups: {
                options: "Options",
                position: "Placement",
                style: "Style"
              }
            },
            send_test_email: "Send a test email",
            subject: "Subject",
            lang: "Language",
            recipient: "Recipient",
            recipient_name: "Name",
            recipient_name_placeholder: "John Doe",
            recipient_address: "Address",
            recipient_address_placeholder: "john.doe@ticketack.com",
            context: "Context",
            context_ticket_id: "Ticket",
            context_ticket_id_placeholder: "Enter a ticket identifier",
            context_tickettype_id: "Type of ticket",
            context_tickettype_id_placeholder: "Choose a ticket type",
            context_screening_id: "Session",
            context_screening_id_placeholder: "Enter a session identifier",
            context_place_id: "Venue",
            context_place_id_placeholder: "Choose a venue",
            email_successfully_sent: "The email has been sent successfully",
            email_was_catched: "Well… it would have been sent if this ticketing instance was in production mode",
            click_on_preview_link: "Click here to see the email sent",
            shortcodes: {
              button: "Shortcodes",
              "ticket.contact.firstname": "[Ticket] Owner firstname",
              "ticket.contact.lastname": "[Ticket] Owner lastname",
              "ticket.contact.title": "[Ticket] Owner title",
              "ticket._id": "[Ticket] Identifier",
              "ticket.activated_pricing.name.fr": "[Ticket] Pricing name (fr)",
              "ticket.activated_pricing.name.en": "[Ticket] Pricing name (en)",
              "ticket.activated_pricing.name.de": "[Ticket] Pricing name (de)",
              "ticket.activated_pricing.description.fr": "[Ticket] Pricing description (fr)",
              "ticket.activated_pricing.description.en": "[Ticket] Pricing description (en)",
              "ticket.activated_pricing.description.de": "[Ticket] Pricing description (de)",
              ticketID: "[Ticket] TicketID",
              "tickettype.description.fr": "[Ticket type] Description (fr)",
              "tickettype.description.en": "[Ticket type] Description (en)",
              "tickettype.description.de": "[Ticket type] Description (de)",
              "ticket.view_link.fr": "[Ticket] View link (fr)",
              "ticket.view_link.en": "[Ticket] View link (en)",
              "ticket.view_link.de": "[Ticket] View link (de)",
              "ticket.download_link.fr": "[Ticket] Download link (fr)",
              "ticket.download_link.en": "[Ticket] Download link (en)",
              "ticket.download_link.de": "[Ticket] Download link (de)",
              "screening._id": "[Screening] Identifier",
              "screening.title.fr": "[Screening] Title (fr)",
              "screening.title.en": "[Screening] Title (en)",
              "screening.title.de": "[Screening] Title (de)",
              "place._id": "[Venue] Identifier",
              "place.cinema": "[Venue] Building",
              "place.number": "[Venue] Number",
              "place.name": "[Venue] name",
              "place.address": "[Venue] Adress",
              "place.zip": "[Venue] Zip",
              "place.city": "[Venue] City",
              "place.country": "[Venue] Country",
              "user.id": "[User] User identifier",
              "user.firstname": "[User] User firstname",
              "user.lastname": "[User] User lastname",
              "user.email": "[User] User e-mail",
              "application.id": "[Application] Application identifier",
              "application.user.id": "[Application] Volunteer identifier",
              "application.user.firstname": "[Application] Volunteer firstname",
              "application.user.lastname": "[Application] Volunteer lastname",
              "application.user.email": "[Application] Volunteer e-mail",
              "customer.id": "[Customer] Customer identifier",
              "customer.firstname": "[Customer] Customer firstname",
              "customer.lastname": "[Customer] Customer lastname",
              "customer.email": "[Customer] Customer e-mail",
              "order.id": "[Order] Number",
              "order.parts.subject": "[Order] Title",
              "order.parts.heading": "[Order] Subtitle",
              "order.parts.content": "[Order] Content",
              "order.parts.payment": "[Order] Payment informations",
              "custom.text.fr": "[Custom] Custom text (fr)",
              "custom.text.en": "[Custom] Custom text (en)",
              "custom.text.de": "[Custom] Custom text (de)"
            }
          },
          forms: {
            please_choose_a_layout: "Please choose a form",
            no_options: "This widget has no options",
            text: "Simple text",
            longtext: "Long text",
            richtext: "Rich text",
            phone: "Phone number",
            password: "Password",
            number: "Number",
            datetime: "Date",
            boolean: "Yes/ No",
            list: "List",
            file: "File",
            image: "Image",
            add_new_layout: "Add a form",
            forms: "Forms",
            form: {
              title: "Template",
              name: "Form name",
              name_placeholder: "Please enter a name"
            },
            type_application: "Volunteer application",
            type_other: "Other",
            add_new_form: "Add a form",
            add_field: "Add a field",
            edit_field: "Modify this field",
            list_field: "List of fields in the form",
            label: "Label",
            label_description: "This is the name of the field displayed.",
            name: "Name",
            name_description: "This is the name of the property that will be stored in the database.",
            width: "Width",
            width_description: "The width of this field compared to the width of the line.",
            required: "Mandatory",
            min: "Minimum value",
            max: "Maximum value",
            step: "Step",
            with_time: "Include time",
            extensions: "Allowed files",
            choices: "Suggestions",
            expanded: "Radio buttons/checkboxes",
            multiple: "Multiple choice"
          },
          applications: {
            applications_plural: "Applications",
            public_form: "Public form",
            add: "Add an application",
            confirm_delete: "Do you really want to delete this application?",
            successfully_submitted: "Your application has been successfully submitted",
            please_choose_sector: "Please choose at least one sector",
            please_set_availabilities: "Please enter at least one period of availability",
            fullname: "Full name",
            status: "Status",
            created_at: "Date of submission",
            max_nb_hours: "Max nb of hours",
            max_nb_hours_header: "Total availability / per day",
            max_nb_hours_per_day: "Max hours per day",
            nb_hours: "Number of assigned hours",
            busy_rate: "Occupancy rate",
            status_all: "All statuses",
            status_submitted: "Pending",
            status_accepted: "Validated",
            status_rejected: "Refused",
            accept_this_application: "Accept this application",
            reject_this_application: "Reject this application",
            sectors: "Desired sectors",
            export: "Export applications",
            filters: {
              search: "Search",
              search_placeholder: "Name, first name or e-mail",
              status: "Status",
              filter_on_shifts: "Filter on shifts",
              having_shift: "Which have at least one assigned shift",
              having_no_shift: "Which have no shift assigned",
              filter_on_sectors: "Filter on sectors",
              desired_sectors: "Which have requested one of these sectors",
              shifts_in_sectors: "Which have at least one shift in one of these sectors"
            }
          },
          settings: {
            setting: "Settings",
            choose_a_field: "Please choose a category",
            filter_by_category: "Categories",
            update_setting: "Update",
            override_selected_fields: "Override the general parameter",
            choose_a_setting_to_override: "Choose a parameter to modify",
            hide_help: "Hide help",
            show_help: "Show help",
            dark_theme: "Dark theme",
            light_theme: "Light theme",
            l10n: {
              title: "Localization",
              currency: "Main currency",
              extra_currencies: "Additional currencies",
              add_extra_currency: "Add a currency",
              default_timezone: "Timezone",
              charset: "Charset",
              locales: {
                title: "Languages",
                default: "Default language",
                all: "Available languages",
                display: "Languages display"
              },
              strftime_date_format: "Date format",
              strftime_datetime_format: "Date and time format"
            },
            pdf: {
              title: "PDF Layouts",
              edit_mode: "Edit",
              preview_mode: {
                title: "Preview",
                data_test: "Simulate on a",
                choose_movies_list: "For the event",
                choose_tickettypes_list: "Type of ticket",
                choose_price: "Purchased at price"
              },
              layout_link: "Model used by :"
            },
            pos: {
              title: "On-site sales",
              automatic_printing: {
                title: "Automatic printing",
                tickets: "Tickets",
                tickets_receipts: "Tickets receipts",
                bookings: "Bookings summary",
                articles_receipts: "Articles receipts"
              },
              booking_cancelation_policy: "Booking cancellation policy",
              booking_policy_allow_until: "Allow until",
              booking_policy_question_positive: "before the screening starts",
              booking_policy_question_negative: "after the screening starts",
              default_policy: "Cancellation is allowed until the booking is scanned",
              no_policy: "Cancellation is not allowed",
              custom_policy: "Custom cancellation policy",
              refund_policy: "Refund Policy (does not apply to administrator accounts)",
              "refund_policy.never": "Never",
              "refund_policy.only_unclosed": "Only if the cash register is not closed",
              "refund_policy.always": "Always",
              payment: {
                title: "Payment",
                show_calculator: "Show calculator",
                sumup_key: "Sumup API key",
                methods: "Payment methods"
              },
              requested_buyer_data: "Requested buyer data",
              required_buyer_data: "Required buyer data",
              screening_capacity_warning_level: "Screening capacity warning level",
              show_past_screenings_button: 'Show "past screenings" button',
              cancel_items: "Cancel items instead of removing them from cart",
              show_print_addition_button: 'Show "print check" button',
              show_send_order_button: 'Show "send order" button',
              additional_css: "Extra POS CSS file URL",
              additional_js: "Extra POS JS file URL",
              hide_screenings_started_since: "Hide screenings that started since more than [minutes]"
            },
            payment: {
              title: "Payment",
              methods: {
                title: "Means of payment",
                onsite: "Means of payment onsite",
                online: "Online payment methods"
              },
              method: {
                general_informations: "Basic information",
                _id: "Identifier",
                name: "Name",
                name_placeholder: "Please enter a name",
                enabled: "Enabled",
                add: "Add a payment method",
                confirm_delete: "Do you really want to delete this payment method?",
                rules: "Payment fees",
                min_cart_amount: "Minimum cart",
                price: "Fixed amount",
                percentage: "Percentage",
                countries: "Countries",
                proxypay: {
                  url: "URL",
                  api_key: "API key",
                  env: "Environment",
                  sha_in: "SHA in",
                  sha_out: "SHA out",
                  seller: "Seller"
                },
                cash: {
                  show_calculator: "Show calculator",
                  show_calculator_optional: "Optional",
                  show_calculator_always: "Always",
                  show_calculator_never: "Never"
                },
                sumup: {
                  key: "Sumup API key"
                },
                twint: {
                  method: "Method"
                },
                add_rule: "Add a rule",
                remove_this_rule: "Remove this rule",
                new_method: "New payment method"
              }
            },
            eshop: {
              title: "Online sales",
              uri: "Eshop URL",
              booking_cancelation_policy: "Booking cancellation policy",
              booking_expiration_duration: "Bookings expiration duration",
              iframe_integration: "Iframe integration",
              is_publicly_available: "Is publicly available",
              allow_search_engines: "Allow search engines indexation",
              max_tickets_in_cart: "Max tickets in cart",
              max_tickets_per_screening: "Max tickets per screening",
              requested_buyer_data: "Requested buyer data",
              required_buyer_data: "Required buyer data",
              enable_promo_code: "Allow promo code input",
              show_available_seats_to_customers: "Show available seats to customers",
              emails: {
                title: "Emails",
                order_confirmation: "Order confirmation"
              },
              url_overrides: {
                title: "URL Overrides",
                pass_url: "Pass URL",
                sanitary_measures_url: "Sanitary measures URL",
                data_protection_url: "Account deletion URL",
                screenings_url: "Screenings URL",
                ticket_url: "Ticket view URL",
                ticket_url_tooltip: "__UUID__ will be replaced by the ticket's unique identifier if provided.",
                home_url: "Home URL",
                terms_conditions_url: "Terms conditions URL",
                privacy_policy_url: "Privacy policy URL",
                article_url: "Articles URL",
                save_referer_for_host: "Referrer URL",
                default_url: "Default URL",
                no_url: "No URL",
                custom_url: "Custom URL"
              },
              donation: {
                title: "Donation",
                modes: "Modes",
                article: "Article to use"
              },
              email: {
                title: "Emails",
                from: "Send from",
                activation_error_to: "Send activation errors to",
                bcc: "Send as blind copy to",
                "reply-to": "Reply to",
                override_to: "Force recipient to"
              },
              newsletter_registration: {
                title: "Newsletter registration",
                modes: "Modes",
                auto_subscribe: "Auto subscribe",
                url: "URL",
                email: "Email",
                callback: "Callback"
              },
              survey_registration: {
                title: "Survey registration",
                modes: "Modes",
                auto_subscribe: "Auto subscribe",
                url: "URL",
                email: "Email",
                callback: "Callback"
              },
              payment: {
                title: "Payment",
                methods: "Payment methods",
                proxypay: {
                  title: "Proxypay",
                  url: "URL",
                  api_key: "API key",
                  env: "Environment",
                  sha_in: "SHA in",
                  sha_out: "SHA out",
                  seller: "Seller"
                }
              },
              registration: {
                title: "Users registration",
                enabled: "Enabled",
                salepoints: "Assigned salepoints"
              },
              additional_css: "Extra Eshop CSS file URL",
              additional_js: "Extra Eshop JS file URL"
            },
            mobile: {
              title: "Mobile application",
              sections: {
                title: "Sections",
                navigation: "Navigation",
                screens: "Screens",
                theme: "Theme",
                features: "Features",
                config: "Configuration"
              },
              production_env: "Production version",
              preprod_env: "Pre-production version",
              testing_env: "Test version",
              copy_production_to_testing: "Copy production version to testing",
              copy_testing_to_production: "Copy testing version to production",
              copy_production: "Copy production version",
              copy_preprod: "Copy pre-production version",
              copy_testing: "Copy testing version",
              to_testing: "to testing",
              to_preprod: "to pre-production",
              to_production: "to production",
              test_on_real_device: "Test the application",
              download_the_app: 'Install (from your store) and launch the "Ticketack Viewer" application.',
              launch_the_app: 'Launch the "Ticketack Viewer" application on your phone',
              scan_this_qr_code: "Scan the QR Code below",
              first_configure_your_app: "Finish configuring your application (Configuration tab)",
              how_to_reset_the_app: "Once your application is configured on your phone, you can press and hold the logo in the top left corner for 3 seconds to reset it.",
              screens: {
                choose_a_screen: "Choose a screen",
                home: "Home",
                program: "Program",
                news: "News",
                tickets: "Tickets",
                shop: "Shop",
                cart: "Shopping cart",
                favorites: "Favorites",
                ratings: "Votes",
                widgets: "Widgets",
                widgets_desc: "Add widgets to this screen",
                add_widget: "Add a widget",
                choose_a_widget: "Choose a widget to add",
                edit_a_widget: "Change the settings for this widget",
                settings: {
                  title: "Configuration",
                  fixed_navigation: "Transparent top navigation bar",
                  screen_background: "Background type",
                  background_image: "Background image",
                  background_color: "Background color",
                  allow_scroll: "Allow screen scroll",
                  news_post_category_id: "News root category",
                  shop_category_id: "Root category of items"
                },
                widget: {
                  ProgramList: {
                    title: "Program",
                    description: "List view of the program"
                  },
                  Shop: {
                    title: "Shop",
                    description: "Items shop"
                  },
                  FeaturedMovie: {
                    title: "Featured Movie",
                    description: "FeaturedMovie (large clickable image)"
                  },
                  FeaturedScreening: {
                    title: "Featured Screening",
                    description: "Featured Screening (large clickable image)"
                  },
                  OnScreenMovies: {
                    title: "Films on screen",
                    description: "Horizontal list of films on screen"
                  },
                  Section: {
                    title: "Section",
                    description: "Horizontal list of films in a given section"
                  },
                  genre: {
                    title: "Genre",
                    description: "Horizontal list of films of a given genre"
                  },
                  Carousel: {
                    title: "Carousel",
                    description: "Carousel of images pointing to an article"
                  },
                  NewsList: {
                    title: "Posts list",
                    description: "Vertical list of posrts with category filter"
                  },
                  Discover: {
                    title: "Carousel vertical",
                    description: "Carousel of vertical images pointing to an article"
                  },
                  PostsGrid: {
                    title: "Posts grid",
                    description: "Grid of images pointing to an article"
                  },
                  settings: {
                    name: "Name of this widget (does not appear in the application)",
                    title: "Title of this widget to be displayed in the application",
                    random_featured_movie: "Random movie",
                    featured_movie_id: "Identifier of the movie to be featured",
                    featured_screening_id: "Identifier of the screening to be highlighted",
                    post_category_id: "Category of posts to use",
                    section_id: "Identifier of the section to display",
                    section_name: "Name of the section to display",
                    nbDays: "Number of days (1 for today only)",
                    hideMoviesTitles: "Hide movie titles",
                    show_only_future_screenings: "Show only future screenings",
                    nb_max_days: "Maximum number of days to display",
                    display_mode: "Display mode",
                    renderer_landscape: "Landscape mode",
                    renderer_portrait: "Portrait mode",
                    image_width: "Image width (proportion)",
                    image_height_ratio: "Image width to height ratio",
                    nb_columns: "Number of columns",
                    filter_on_places: "Filter on places",
                    show_category_filter: "Show categories filter"
                  }
                }
              },
              navigation: {
                tabs: "Navigation tabs",
                tabs_desc: "Set the navigation tabs at the bottom of the application.",
                add_tab: "Add a tab",
                choose_a_tab: "Choose a tab to add",
                active_tab: "Default tab",
                active_tab_desc: "Choose the active tab when the application is launched."
              },
              kronosUri: "Kronos URL",
              kronosApiKey: "Kronos API key",
              salepointId: "Salepoint",
              disableUserAccount: "Disable user accounts",
              disableVotes: "Disable ratings",
              disableFavorites: "Disable favorites",
              apiKey: "Engine API key (deprecated)",
              engineUri: "Engine URL (deprecated)",
              edition: "Ausgabe",
              screeningsFilters: {
                title: "Screneings filters",
                start_at_gte: "Start after"
              },
              homeDisplay: {
                title: "Home screen",
                showCarousel: "Show carousel",
                showFeaturedMovie: "Show featured movie",
                showDiscover: "Show Discover",
                showRestaurants: "Show restaurants",
                showOnScreenMovies: "Show on screen movies",
                showTodayMovies: "Show today movies",
                showSections: "Show sections",
                showGenres: "Show genres",
                showGoodDeals: "Show good deals"
              },
              shop: {
                title: "Shop",
                rootCategoryId: "Root category"
              },
              posts: {
                title: "Posts",
                discover: "Discover",
                goodDeals: "Good deals",
                pubs: {
                  title: "Ads",
                  home: "Home screen",
                  shop: "Shop",
                  program: "Program"
                },
                news: {
                  title: "News",
                  rootCategoryId: "Root category"
                }
              },
              featured: {
                title: "Featured content",
                screening: "Featured screening",
                movie: "Featured film"
              },
              images: {
                title: "Images",
                format: "Format",
                nb_per_row: "Number of images per line"
              },
              theme: {
                title: "Theme",
                logo: "Logo (svg)",
                splash: "Splash",
                background_image: "Background image",
                colors: {
                  title: "Colours",
                  background: "Background colour",
                  primary: "Primary colour",
                  "primary-inverse": "Reverse primary colour",
                  nav: {
                    title: "Navigation",
                    background: "Background colour",
                    border: "Border colour",
                    activeColor: "Color of the active icon",
                    inactiveColor: "Colour of inactive icons"
                  }
                },
                style: {
                  title: "General style",
                  border_radius: "Rounded borders"
                }
              }
            },
            customer: {
              title: "Your information",
              name: "Name",
              name_short: "Short name",
              phone: "Phone",
              mail: "Email",
              address: "Address",
              addr_line0: "Address - line 0",
              addr_line1: "Address - line 1",
              addr_line2: "Address - line 2",
              addr_line3: "Address - line 3",
              assets_path: "Customisation folder",
              vat: "VAT number",
              type: "Business sector",
              type_placeholder: "Please select a business sector",
              types: {
                cinema: "Cinema",
                cinemafestival: "Film festival",
                music: "Music",
                musicfestival: "Music festival",
                theater: "Theater",
                recreationcenter: "Leisure activities",
                recreationparc: "Leusure parc",
                sport: "Sport club",
                generic: "Other"
              },
              informal: "Use informal language",
              tax: {
                title: "Taxes",
                vat_articles: "Default VAT on articles",
                vat_tickets: "Default VAT on tickets",
                suisa: "SUISA tax",
                local: "Local tax"
              }
            },
            images: {
              title: "Images & logos"
            },
            integrations: {
              title: "Integrations",
              add: "Add integration",
              gtm: {
                title: "Google Tag Manager",
                id: "Container ID"
              },
              wp: {
                title: "WordPress",
                websites: "Websites",
                name: "Name",
                uri: "URL",
                new_website_placeholder: "Website name",
                add_website: "Add a website"
              },
              shift72: {
                title: "FestivalScope",
                api_key: "API Key",
                endpoint: "URI"
              },
              pantaflix: {
                title: "Pantaflix",
                places_ids: "Place(s)",
                provider: "Ticketing id at Pantaflix",
                content_id_prefix: "Content id prefix"
              },
              own_it: {
                title: "Own It",
                api_key: "API key",
                places_ids: "Place(s)",
                test: "Test mode",
                codes_creation: {
                  title: "Code creation",
                  product_id: "Bundle id.",
                  tickettypes: "Ticket types",
                  valid_from: "Valid from",
                  valid_until: "Valid until"
                }
              },
              kronos: {
                title: "Kronos",
                api_key: "API Key",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Screenings import",
                    enabled: "Enabled",
                    delete_future: "Delete future screenings",
                    delete_existing: "Delete existing screening before update"
                  }
                }
              },
              como: {
                title: "Como",
                api_key: "API Key",
                branch_id: "Branch Id"
              },
              json: {
                title: "JSON data source",
                url: "URL",
                x_api_key: "API Key (X-Api-KEY header)",
                screenings_key: "Screenings access property",
                places_key: "Places access property",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Screenings import",
                    enabled: "Enabled",
                    delete_future: "Delete future screenings",
                    delete_existing: "Delete existing screening before update"
                  }
                }
              },
              eventival: {
                title: "Eventival",
                name: "Name",
                year: "Year",
                api_key: "API key",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Screenings import",
                    enabled: "Activate import",
                    delete_future: "Delete future screenings",
                    delete_existing: "Delete existing screening before update",
                    fullfill_people: "Fullfill people"
                  },
                  tickets: {
                    title: "Accreditations import",
                    enabled: "Activate import"
                  }
                }
              },
              weserv: {
                title: "Weserv Images Proxy",
                proxy_img_host: "Proxy host"
              },
              fiona: {
                title: "Fiona",
                name: "Name",
                edition_id: "Edition",
                api_key: "API Key",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Screenings import",
                    enabled: "Enabled",
                    delete_future: "Delete future screenings",
                    delete_existing: "Delete existing screening before update"
                  }
                }
              },
              cinech: {
                title: "Ciné.ch",
                url: "Url",
                cinema_ids: "Cinema ids",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Screenings import",
                    enabled: "Enabled",
                    delete_future: "Delete future screenings",
                    delete_existing: "Delete before updating"
                  }
                }
              },
              recaptcha: {
                title: "Google reCAPTCHA",
                public_key: "Site key",
                secret_key: "Secret key"
              },
              mailchimp: {
                title: "Mailchimp",
                newsletter: "Newsletter registration",
                survey: "Survey registration",
                api_key: "API key",
                list_id: "List ID",
                merge_fields: {
                  title: "Fields to merge",
                  address: "Address",
                  zip: "Zip",
                  city: "City",
                  country: "Country",
                  language: "Language"
                },
                interest: "Interest identifier",
                tags: "Tags"
              },
              maccsbox: {
                title: "Maccsbox",
                ftp: {
                  title: "FTP configuration",
                  hostname: "Hostname",
                  username: "Username",
                  pasv: "PASV",
                  directory: "Directory",
                  password: "Password"
                }
              }
            }
          },
          payment_methods: {
            cash: "Cash",
            cash_collector: "Cash collector",
            ewallet: "E-Wallet",
            sumup: "Sumup",
            other_eft: "Manual EFT",
            zvt_eft: "EFT",
            eft_receipt_printable_after_debit: "Offer to print the ticket after payment",
            closing_eft_mode: "Automatic closing of the TPE",
            mode_never: "Do not offer and never close",
            mode_yes: "Propose and choose yes by default",
            mode_no: "Propose and choose no by default",
            mode_always: "Do not offer and always close",
            twint: "Twint",
            pos_transfer: "Transfer",
            free: "Free",
            later: "Later",
            proxypay: "Proxypay",
            eshop_transfer: "Transfer"
          },
          user_data: {
            company: "Company",
            title: "Title",
            firstname: "First name",
            lastname: "Last name",
            address: "Address",
            zip: "Zip",
            city: "City",
            country: "Country",
            age: "Age",
            birthdate: "Birth date",
            sex: "Sex",
            phone: "Phone",
            cellphone: "Cellphone",
            email: "Email",
            tab: "Table number",
            comment: "Comments"
          },
          envs: {
            test: "Test",
            prod: "Production"
          },
          donation: {
            checkout: "Checkout",
            header: "Header",
            footer: "Footer",
            email: "Email"
          },
          registration_callback: {
            email: "Email",
            callback: "Callback",
            url: "Url",
            mailchimp: "Mailchimp"
          },
          twint_methods: {
            sticker: "Sticker",
            beacon: "Beacon"
          },
          locales: {
            fr_CH: "French",
            en_GB: "English",
            de_CH: "German"
          },
          devices: {
            title: "Hardware",
            list: "List",
            map: "Tree"
          },
          collectors: {
            title: "Coin boxes",
            manage: "Manage",
            manage_title: "Manage coin box {{name}}",
            connection: "Connection",
            connected: "Connected",
            disconnected: "Disconnected",
            status: "Status",
            statuses: {
              idle: "Waiting",
              draining: "Draining in progress",
              filling: "Recharging in progress",
              cancellation: "Cancellation in progress",
              "treatment error": "Treatment error",
              NU: "NU",
              autotest: "Autotest in progress",
              reset: "Resetting the current trunk",
              exchange: "Exchange in progress",
              unload: "Unloading in progress",
              ticket: "Displaying the ticket",
              payment: "Payment in progress"
            },
            acceptation: {
              opened: "Cash desk open",
              closed: "Cash desk closed"
            },
            in_recyclers: "In the recyclers",
            in_cashbox: "In the cashbox",
            stats: "Hopper status",
            moneyTypes: {
              5: "5 cts",
              10: "10 cts",
              20: "20 cts",
              50: "50 cts",
              100: "1 Fr",
              200: "2 Frs",
              500: "5 Frs",
              1e3: "10 Frs",
              2e3: "20 Frs",
              5e3: "50 Frs",
              1e4: "100 Frs"
            },
            coins: "Coins",
            bills: "Notes",
            operations: "Operations",
            lastEvents: "Last messages",
            lastTransactions: "Last transactions",
            collect: "Collect",
            collect_desc: "Collect money",
            refund: "Refund",
            refund_desc: "Refund money",
            debit_amount_label: "Amount",
            debit_amount_label_placeholder: "Enter the amount to be collected",
            refund_amount_label: "Amount",
            refund_amount_label_placeholder: "Enter the amount to be refunded",
            change: "Make change",
            change_desc: "Exchange money",
            do_change: "Start exchange",
            autotest: "Self-test",
            autotest_desc: "Perform a self-test",
            drain: "Drain",
            drain_desc: "Recover money",
            reset_chest: "Reset to zero",
            reset_chest_desc: "Perform a cashbox reset",
            do_drain: "Start draining",
            unload: "Unload",
            unload_desc: "Send money to cashbox",
            do_unload: "Start unloading",
            fillin: "Load",
            fillin_desc: "Add money",
            validate_fillin: "Validate the load",
            inserted: "Inserted coins",
            in_the_recycler: "In the recycler",
            in_the_cashbox: "In the cash box",
            modules: {
              title: "Modules",
              ACCEPTEUR_BILLET: "Banknote acceptor",
              CASHBOX: "CashBox",
              TICKET_DISTRIBUTOR1: "Ticket distributor 1",
              TICKET_SHOPPER2: "Ticket dispenser 2",
              TICKET_SHOPPER3: "Ticket dispenser 3",
              TICKET_SHOPPER4: "Ticket dispenser 4",
              ACCEPTOR_PIECE: "Acceptor",
              DISTRIBUTOR: "Distributor",
              DISTRIBUTOR_PIECE1: "Distributor 5 Frs",
              DISTRIBUTOR_PIECE2: "Distributor 2 Frs",
              DISTRIBUTOR_PIECE3: "Distrib. 1 Fr",
              DISTRIBUTOR_PIECE4: "Distrib. 50 cts",
              DISTRIBUTOR_PIECE5: "Distrib. 20 cts",
              DISTRIBUTOR_PIECE6: "Distrib. 10 cts",
              DISTRIBUTOR_PIECE7: "Distrib. 5 cts",
              TICKET_STATUS: "Ticket alarm",
              STATUS_COIN_ALARM: "Coin alarm",
              STATUS_CASHBOX: "CashBox status",
              PRES_BILSORTIE: "Pres. notes out",
              PRES_PIESORTIE: "Pres. coins out"
            }
          },
          printers: {
            title: "Printers",
            manage_title: "Printer Management {{name}}",
            manage: "Manage",
            connection: "Connection",
            connected: "Connected",
            disconnected: "Disconnected",
            infos: "Information",
            id: "Identifier",
            name: "Name",
            host: "Host",
            status: "Status",
            last_connexion: "Last connection",
            options: "Options",
            open_cash_drawer: "Open the cash drawer each time you print",
            only_for_pos: "Visible only on these salepoints",
            ppd: "Print mode",
            profiles: {
              1: "Card printer (type ZCxxx) with Black Ribbon and Duplex disabled",
              3: "Thermal printer (type ZDxx or ZX) with continuous paper without cutter",
              4: "Other standard printer",
              6: "Other thermal printer",
              10: "Thermal printer (type ZDxx or ZX) with hole paper without cutter",
              18: "Thermal printer (type ZDxx or ZX) with continuous paper and cutter (cut after each ticket)",
              26: "Thermal printer (type ZDxx or ZX) with paper with holes and cutter (cut after each ticket)",
              50: "Thermal printer (type ZDxx or ZX) with continuous paper and cutter (cut at the end of printing)",
              58: "Thermal printer (type ZDxx or ZX) with paper with holes and cutter (cut at the end of printing)",
              65: "Card printer (type ZCxxx) with Color Ribbon and Duplex disabled",
              129: "Card printer (type ZCxxx) with Black Ribbon and Duplex enabled",
              193: "Card printer (type ZCxxx) with Color Ribbon and Duplex enabled"
            },
            automatic_printing: "Automatically print items in these categories"
          },
          efts: {
            title: "Payment terminals",
            manage_title: "Payment terminal management {{name}}",
            manage: "Manage",
            connection: "Connection",
            connected: "Connected",
            disconnected: "Disconnected",
            infos: "Information",
            id: "Identifier",
            name: "Name",
            host: "Host",
            status: "Status",
            last_connexion: "Last connection",
            options: "Options",
            only_for_pos: "Visible only on these salepoints",
            terminal_id: "Terminal ID Pixoo"
          },
          flash_info: {
            title: null,
            subtitle: null,
            content: null
          },
          logs: {
            source: {
              cinech: "Ciné.ch",
              eventival: "Eventival",
              json: "JSON data source",
              kronos: "Kronos",
              raw: "File"
            }
          },
          models: {
            customer: {
              name: "Name of the ticket office",
              name_short: "Short name of the ticket office",
              address: "Full address of the ticket office",
              phone: "+41 22 364 80 00",
              email: "info@netoxygen.ch",
              vat: "CHE-105.599.869"
            },
            pricing: {
              name: "Name of the pricing",
              description: "Pricing description"
            },
            environment: {
              printer: "Name of cashier",
              salepoint: "Name of point of sale"
            },
            screening: {
              title: "Name of the film",
              venue: "Name of establishment",
              place: "Name of the venue",
              address: "Address of the venue",
              zip: "Zip",
              city: "City",
              state: "State",
              country: "Country"
            },
            tickettype: {
              name: "Name of the ticket type",
              description: "Ticket type description"
            },
            owner_info: {
              title: "M.",
              company: "Company",
              firstname: "First name",
              lastname: "Name",
              fullname: "First name last name",
              fullname_reversed: "Last name first name",
              email: "firstname.lastname@ticketack.com",
              age: "42",
              sex: "M",
              phone: "0223648000",
              cellphone: "0791223344",
              language: "en",
              address: {
                street: "Address",
                city: "City",
                zip: "Zip",
                country: "Country"
              }
            }
          }
        }];
        e.exports = t.length <= 1 ? t[0] : t;
      },
      7531: e => {
        const t = [{
          app: {
            dashboard: "Tableau de bord",
            planning: "Planning",
            tickets: "Billets",
            booking_survey: "Relevé comptable",
            accounting: "Comptabilité",
            tickets_clients: "Billets et clients",
            booking_status: "État des réservations",
            section_admin: "Administration",
            section_operation: "Exploitation",
            section_analysis: "Analyse et statistiques",
            events: "Événements",
            events_movies: "Films",
            sales_list: "Relevé des ventes",
            events_music_groups: "Artistes/Groupes",
            events_drama: "Pièces de théâtre",
            events_service: "Services",
            other_activites: "Autres activités",
            screenings: "Séances",
            programmations: "Programmations",
            configuration: "Configuration",
            users: "Collaborateurs",
            ticketack_users: "Utilisateurs Ticketack",
            activities: "Compétences",
            phases: "Phases",
            sectors: "Secteurs",
            application_types: "Types de candidatures",
            applications: "Candidatures",
            form_layouts: "Formulaires",
            forms: "Formulaires",
            personnal_fields: "Champs personnalisés",
            teams: "Équipes",
            ex_teams: "Exploitation équipes",
            hardware: "Matériel",
            setting_and_hardware: "Configuration et matériel",
            configuration_qr_codes: "Codes QR",
            plan: "Planification",
            resources_keys: "Gestion des clés",
            places: "Salles",
            pricinglists: "Grilles tarifaires",
            bucketlists: "Modèles de contingents",
            tickettypes: "Types de billets",
            layouts: "Modèles PDF",
            email_layouts: "Modèles d'e-mails",
            tktInstances: "Instances Ticketack",
            distributors: "Distributeurs",
            shop: "Shop",
            points_of_sale: "Points de vente",
            categories: "Catégories",
            articles: "Articles",
            resources: "Ressources",
            cashregisters: "Caisses",
            communication: "Communication",
            message: "Message",
            sections: "Sections",
            login: "Connexion",
            logout: "Déconnexion",
            my_profil: "Mon profil",
            publishing: "Publication",
            posts: "Posts",
            channels: "Canaux de diffusion",
            sale: "Vente",
            company: "Entreprise",
            title: "Salutation",
            articles_and_discount: "Articles et Rabais",
            customers: "Clients",
            table_prev_button: "Précédente",
            table_next_button: "Suivante",
            table_page_label: "Page",
            table_of_label: "sur",
            table_rows_label: "lignes",
            table_no_data_message: "Aucune donnée trouvée",
            stats: "Statistiques",
            postcategories: "Catégories",
            articlecategories: "Catégories",
            tasks: "Planning",
            salepoints: "Points de vente",
            post_categories: "Catégories",
            messages: "Communication",
            settings: "Paramètres",
            cron_tasks: "Tâches",
            hide_sidebar: "Cacher",
            abilities: "Rôles",
            history: "Historique",
            errors_load_params: "Une erreur est survenue lors du chargement des paramètres.",
            worker: {
              an_update_is_available: "Une mise à jour de Kronos est disponible",
              click_here_to_update: "Cliquez ci-dessous pour mettre à jour votre version de Kronos et profiter des nouvelles fonctionnalités ?",
              do_update: "Mettre à jour"
            }
          },
          modules: {
            module_team: "Gestion d'équipe",
            module_planning: "Planification",
            module_shop: "Shop",
            module_resources: "Resources",
            module_communications: "Communications",
            module_publishing: "Publishing",
            module_administration: "Administration",
            module_super_admin: "Super admin"
          },
          login: {
            email: "E-mail",
            password: "Mot de passe"
          },
          users: {
            add_a_user: "Ajouter un collaborateur",
            user: "Collaborateur",
            user_plural: "Collaborateurs",
            profile: "Profil",
            my_profile: "Mon profil",
            contact: "Contact",
            company: "Entreprise",
            title: "Salutation",
            address: "Adresse",
            other_informations: "Autres informations",
            firstname: "Prénom",
            lastname: "Nom",
            fullname: "Nom complet",
            email: "E-mail",
            role: "Role",
            password: "Mot de passe",
            password_confirmation: "Mot de passe (confirmation)",
            fix_phone: "Tél. fixe",
            mobile_phone: "Tél. mobile",
            pro_phone: "Tél. pro",
            fax: "Fax",
            zip: "Code postal",
            city: "Ville",
            country: "Pays",
            birthday: "Date de naissance",
            avs: "N° AVS",
            bank: "Banque",
            bic: "BIC",
            iban: "IBAN",
            status: "Statut",
            active: "Actif",
            inactive: "Inactif",
            enable: "Activer",
            disable: "Désactiver",
            tkt_instance: "Instance Ticketack",
            company_placeholder: "Veuillez saisir le nom de l'entreprise",
            title_placeholder: "Veuillez saisir une salutation",
            firstname_placeholder: "Veuillez saisir un prénom",
            lastname_placeholder: "Veuillez saisir un nom",
            role_placeholder: "Veuillez choisir un rôle",
            email_placeholder: "Veuillez saisir une adresse e-mail",
            invalid_email: "L'adresse fournie est invalide",
            password_placeholder: "Veuillez saisir un mot de passe",
            phone_placeholder: "Veuillez saisir un numéro de téléphone",
            invalid_phone: "Veuillez entrer un format valide (9 chiffres sans indicatif)",
            fax_placeholder: "Veuillez saisir un numéro de fax",
            address_placeholder: "Veuillez saisir une adresse postale",
            zip_placeholder: "Veuillez saisir un code postal",
            city_placeholder: "Veuillez saisir une ville",
            country_placeholder: "Veuillez saisir un pays",
            avs_placeholder: "AVS",
            bank_placeholder: "Banque / CCP",
            bic_placeholder: "BIC",
            iban_placeholder: "IBAN",
            activities: "Activités",
            sectors: "Secteurs",
            update_my_profile: "Modification de mon profil",
            update_user: "Modification de {{ firstname }} {{ lastname }}",
            delete_my_profile: "Suppression de mon profil",
            delete_user: "Suppression de {{ firstname }} {{ lastname }}",
            confirm_delete_my_profile: "Voulez-vous vraiment supprimer votre compte ?",
            confirm_delete_this_profile: "Voulez-vous vraiment supprimer ce collaborateur ?",
            show: "Montrer le profil de l'utilisateur",
            edit: "Editer le profil de l'utilisateur",
            delete: "Supprimer l'utilisateur",
            hidden: "Caché",
            abilities: {
              users_abilities: "Droits liés aux utilisateurs",
              pick_activities: "Assigner activités",
              enable: "Activer",
              disable: "Désactiver",
              read_abilities: "Lire les droits",
              edit_abilities: "Éditer les droits",
              edit_templates: "Éditer les patrons"
            },
            skills: "Compétences",
            user_abilities: "Droits",
            informations: "Informations générales",
            availabilities: "Disponibilités",
            application: "Candidature",
            planning: "Planning"
          },
          tktUsers: {
            tktUsers: "Utilisateurs Ticketack",
            name: "Nom d'utilisateur",
            roles_and_salepoints: "Rôles et points de vente",
            role_plural: "Rôles",
            salepoint_plural: "Points de vente",
            add_a_ticketack_user: "Ajouter un utilisateur Ticketack",
            passwords_do_not_match: "Les mots de passe fournis ne correspondent pas!",
            delete_tktUser: "Voulez-vous vraiment supprimer cet utilisateur Ticketack ?",
            change_password: "Changer le mot de passe",
            roles_tooltips: {
              admin: "Donne un accès complet au système et aux tarifs associés à ce rôle",
              pos: "Autorise l’accès à l’interface de point de vente (pos = point of sale)",
              "on-site": "Indique que l'utilisateur fait partie de l’équipe sur site (à associer en principe avec pos), donne accès aux tarifs associés à ce rôle",
              partner: "Indique que l'utilisateur fait partie de l’équipe d'un partenaire (à associer en principe avec pos), donne accès aux tarifs associés à ce rôle",
              overbooker: "Indique que l'utilisateur est autorisé à vendre/réserver plus de places que la salle ne le permet (nécessite un contingent 'overbooking')",
              transfer: "Autorise la conversion de billets d'un tarif à l'autre",
              accred: "Rôle pour les responsables des accréditations, (à associer en principe avec pos), donne accès aux tarifs associés à ce rôle",
              ticket_editor: "Indique que l'utilisateur peut modifier les données d’un ticket",
              refund: "Indique que l'utilisateur peut effectuer des remboursements",
              wallet_cashier: "Indique que l’utilisateur peut effectuer des encaissements sur des portefeuilles électroniques hors point de vente (utilisé par exemple pour des bars non gérés avec ticketack)",
              wallet_manager: "Indique que l’utilisateur peut créditer des portefeuilles électroniques",
              accounting: "Autorise l’accès aux données comptables des points de ventes indiqués ci-dessous",
              entry_check: "Rôle spécial pour les contrôleurs d’entrée",
              stats: "Rôle spécial pour l’accès aux statistique",
              customer: "Indique que l'utilisateur dispose d'un compte client sur la billetterie"
            }
          },
          customers: {
            customer: "Client",
            customers: "Clients",
            add_a_customer: "Ajouter un client",
            passwords_do_not_match: "Les mots de passe fournis ne correspondent pas !",
            confirm_delete_customer: "Voulez-vous vraiment supprimer ce client ?",
            change_password: "Changer le mot de passe",
            profile: "Profil de connexion",
            contact: "Contact",
            other_informations: "Autres informations",
            company: "Entreprise",
            title: "Salutation",
            firstname: "Prénom",
            lastname: "Nom",
            name: "Nom d'utilisateur",
            fullname: "Nom complet",
            verified: "Compte vérifié",
            email: "E-mail",
            salepoint_plural: "Points de vente",
            password: "Mot de passe",
            password_confirmation: "Mot de passe (confirmation)",
            phone: "Tél. fixe",
            cell_phone: "Tél. mobile",
            address: "Adresse",
            zip: "Code postal",
            city: "Ville",
            country: "Pays",
            age: "Âge",
            birthdate: "Date de naissance",
            sex: "Genre",
            language: "Langue",
            name_placeholder: "Veuillez saisir un nom d'utilisateur",
            firstname_placeholder: "Veuillez saisir un prénom",
            lastname_placeholder: "Veuillez saisir un nom",
            email_placeholder: "Veuillez saisir une adresse e-mail",
            password_placeholder: "Veuillez saisir un mot de passe",
            phone_placeholder: "Veuillez saisir un numéro de téléphone fixe",
            cellphone_placeholder: "Veuillez saisir un numéro de téléphone mobile",
            invalid_phone: "Veuillez entrer un format valide (9 chiffres sans indicatif)",
            address_placeholder: "Veuillez saisir une adresse postale",
            zip_placeholder: "Veuillez saisir un code postal",
            city_placeholder: "Veuillez saisir une ville",
            country_placeholder: "Veuillez saisir un pays",
            age_placeholder: "Veuillez saisir un âge",
            update_customer: "Modification de {{ firstname }} {{ lastname }}",
            delete_customer: "Suppression de {{ firstname }} {{ lastname }}",
            confirm_delete_this_customer: "Voulez-vous vraiment supprimer ce client ?",
            show: "Montrer le client",
            edit: "Editer le client",
            delete: "Supprimer le client"
          },
          sectors: {
            sector: "Secteur",
            sectors_plural: "Secteurs",
            available: "Secteurs disponibles",
            your_sectors: "Vos secteurs",
            sectors_description: "Choisissez les secteurs dans lesquels vous souhaitez travailler, par ordre de préférence.",
            informations: "Informations générales",
            add: "Ajouter un secteur",
            name: "Nom",
            description: "Description",
            admins: "Responsables",
            parent: "Secteur parent",
            name_placeholder: "Veuillez saisir un nom",
            description_placeholder: "Veuillez saisir une description",
            confirm_delete: "Voulez-vous vraiment supprimer ce secteur ?",
            update_sector: "Modification de {{ name }}"
          },
          applicationTypes: {
            applicationType: "Type de candidature",
            applicationTypes_plural: "Types de candidature",
            informations: "Informations générales",
            add: "Ajouter un type de candidature",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            description: "Description",
            description_placeholder: "Veuillez saisir une description",
            form: "Formulaire",
            confirm_delete: "Voulez-vous vraiment supprimer ce type ?",
            update_application_type: "Modification de {{ name }}",
            notifications: "Notifications par e-mail",
            admins: "Administrateurs à notifier à la soumission d'une candidature",
            on_receive_email_id: "Email à envoyer aux administrateurs à la soumission d'une candidature",
            on_submit_email_id: "Email à envoyer au candidat à la soumission",
            on_approve_email_id: "Email à envoyer au candidat lors de l'approbation de sa candidature",
            on_reject_email_id: "Email à envoyer au candidat lors du refus de sa candidature",
            activities: "Compétences",
            activities_to_assign_on_acceptation: "À assigner à l'acceptation de la candidature"
          },
          availabilities: {
            availabilities_description: "Précisez vos périodes de disponibilité",
            phases_description: "Voici les périodes pendant lesquelles nous avons besoin de vous :",
            add_an_availability: "Ajouter une période de disponibilité",
            from: "Du",
            to: "Au"
          },
          changelog: {
            changelog: "Changelog",
            features: "Fonctionnalités",
            i18n: "Traductions",
            fixes: "Correctifs",
            builds: "Builds",
            ui: "Changements visuels"
          },
          places: {
            informations: "Informations générales",
            maps: "Plan de salle",
            add: "Ajouter une salle",
            place: "Salle",
            place_plural: "Salles",
            building: "Établissement",
            building_placeholder: "Veuillez saisir un nom d'établissement",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            number: "Numéro d'écran",
            number_placeholder: "Veuillez saisir un numéro d'écran",
            address: "Adresse",
            address_placeholder: "Veuillez saisir une adresse",
            zip: "Code postal",
            zip_placeholder: "Veuillez saisir un code postal",
            city: "Ville",
            city_placeholder: "Veuillez saisir une ville",
            state: "Région",
            state_placeholder: "Veuillez saisir une région",
            country: "Pays",
            country_placeholder: "Veuillez saisir un pays",
            coordinates: "Coordonnées géographiques",
            coordinates_lat: "Latitude",
            coordinates_lat_placeholder: "Veuillez saisir une latitude (e.g. 50.081396)",
            coordinates_long: "Longitude",
            coordinates_long_placeholder: "Veuillez saisir une longitude (e.g. 14.425201)",
            capacity: "Capacité",
            capacity_total: "Capacité totale",
            capacity_prm: "Capacité PMR (incluse dans la capacité totale)",
            capacity_total_placeholder: "Veuillez saisir la capacité totale (en comptant la capacité PMR)",
            capacity_prm_placeholder: "Veuillez saisir la capacité PMR",
            update_place: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette salle ?",
            add_map: "Ajouter un plan de salle",
            eventival_list_warning: "Vous ne pouvez pas ajouter ou supprimer de salle car vous avez une intégration avec Eventival. Seul le plan de salle est accessible depuis Kronos.",
            json_list_warning: "Vous ne pouvez pas ajouter ou supprimer de salle car vous avez une configuration d'import de séances depuis une source externe. Seul le plan de salle est accessible depuis Kronos.",
            eventival_form_warning: "Vous ne pouvez pas éditer cette salle car vous avez une intégration avec Eventival. Seuls le plan de salle et la capacité PMR sont accessibles depuis Kronos.",
            json_form_warning: "Vous ne pouvez pas éditer cette salle car vous avez une configuration d'import de séances depuis une source externe. Seuls le plan de salle et la capacité PMR sont accessibles depuis Kronos.",
            map: {
              seatsmap: "Plan de salle",
              classic: "Classique",
              sofa: "Canapé",
              "sofa-middle": "Canapé centre",
              "sofa-left": "Canapé gauche",
              "sofa-right": "Canapé droite",
              "foldable-seat": "Strapontin",
              wheelchair: "PMR",
              nbRows: "Nombre de rangs",
              nbColumns: "Nombre de colonnes",
              overviewTitle: "Vue d'ensemble",
              gridParamsTitle: "Paramètres",
              zoneOptionsTitle: "Options de la zone à créer",
              zoneTitle: "Zone {{ name }}",
              seatTitle: "Siège {{ label }}",
              seatOptions: "Options du siège {{ row }}:{{ seat_number }}",
              zoneOptions: "Options de la zone {{ name }}",
              category_and_type: "Catégorie et type de sièges",
              numbering_options: "Options de numérisation",
              category: "Catégorie",
              zonelabel: "Nom de zone",
              top: "Haut",
              bottom: "Bas",
              seatposition: "Direction de la numérotation des sièges",
              l2r: "De gauche à droite",
              r2l: "De droite à gauche",
              tblr: "De haut en bas ET de gauche à droite",
              btlr: "De bas en haut ET de gauche à droite",
              tbrl: "De haut en bas ET de droite à gauche",
              btrl: "Du bas en haut ET de droite à gauche",
              totalSeats: "Nb. total de sièges",
              zoneCoordinates: "Coordonnées de la zone",
              label: "Étiquette",
              seattype: "Type de siège",
              tooltipmsg: "Tab pour modifier le siège, clic long pour ajouter/supprimer le siège de la zone",
              seatdetail: "Détails du siège",
              startSeatNumber: "Numéro du premier siège",
              saveSeat: "Enregistrer le siège",
              leaveSeat: "Fermer le siège",
              saveZone: "Enregistrer la zone",
              leaveZone: "Fermer la zone",
              leaveSelectionOptions: "Fermer la sélection",
              saveCategoryAndType: "Enregistrer la catégorie et le type de siège",
              saveNumberingOptions: "Enregistrer les options de numérisation",
              startRowNumber: "Numéro du premier rang",
              skippedSeatNumber: "Nombre de sièges sautés",
              stagePosition: "Position de l'écran/de la scène",
              seatNumber: "Numéro de siège",
              seatRow: "Rang du siège",
              number: "Numéro",
              rowType: "Type de rang",
              alphabet: "Alphabetique",
              stagePositions: {
                top: "En haut",
                bottom: "En bas"
              },
              free: "libre",
              booked: "réservé"
            },
            import: {
              imported_at: "Import du {{ date }}",
              resume: "En résumé",
              nb_deleted: "{{ nb }} salles ont été supprimée(s)",
              nb_inserted: "{{ nb }} salles ont été créée(s)",
              nb_updated: "{{ nb }} salles ont été mise(s) à jour",
              nb_invalid: "{{ nb }} salles invalide(s)",
              inserted: "Salle(s) créée(s)",
              updated: "Salle(s) mise(s) à jour",
              invalid: "Salle(s) invalide(s)",
              an_error_occured: "Une erreur est survenue pendant la synchronisation. Veuillez ré-essayer plus tard.",
              was_useless: "L'import s'est bien déroulé mais il n'a eu aucun effet.",
              places_tab: "Salles"
            }
          },
          pricinglists: {
            _id: "Identifiant",
            informations: "Informations générales",
            add: "Ajouter une grille tarifaire",
            pricinglist: "Grille tarifaire",
            pricinglist_choice: "Choisir une grille tarifaire",
            pricinglist_plural: "Grille tarifaires",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            nb_pricings: "Nombre de tarifs",
            update_pricinglist: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette grille tarifaire ?",
            pricings: "Tarifs",
            pricings_maybe_plural: "Tarif(s)",
            add_pricing: "Ajouter un tarif",
            new_pricing: "Nouveau tarif",
            pricing: {
              base_informations: "Informations de base",
              display: "Affichage",
              rules: "Règles",
              name: "Nom",
              name_placeholder: "Nom du tarif",
              description: "Description",
              description_placeholder: "Veuillez saisir une description",
              price: "Prix",
              value: "Valeur",
              value_per_screening: "Valeur par événement",
              wallet_amount: "Porte-monnaie électronique",
              eligibility: "Éligibilité",
              eligibility_placeholder: "Phrase courte à destination du personnel qui scanne les billets...",
              VAT: "TVA",
              sellers: "Vendeurs",
              eshop_sort_weight: "Ordre",
              category: "Catégorie",
              additional_class_names: "Classe CSS",
              limit_to_sellers: "Limiter ce tarif aux rôles suivants",
              limit_to_tickettypes: "Limiter ce tarif aux types de billets suivants",
              exclude_tickettypes: "Interdire ce tarif aux types de billets suivants",
              not_before: "Valide à partir de",
              not_after: "Valide jusqu'à",
              pricing_choice: "Choisir un tarif",
              pricing_add_layout: "Ajouter un modèle",
              refs: "Références",
              tags: "Tags"
            }
          },
          bucketlists: {
            _id: "Identifiant",
            informations: "Informations générales",
            add: "Ajouter un modèle de contingent",
            bucketlist: "Modèle de contingents",
            bucketlist_choice: "Choisir un modèle de contingents",
            bucketlist_plural: "Modèles de contingents",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            nb_buckets: "Nombre de contingents",
            update_bucketlist: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer ce modèle de contingents ?",
            buckets: "Contingents",
            buckets_maybe_plural: "Contingent(s)",
            add_bucket: "Ajouter un contingent",
            new_bucket: "Nouveau contingent",
            preview: "Prévisualisation",
            edit: "Édition",
            apply: "Appliquer un modèle de contingents",
            bucket: {
              bucket_add_layout: "Ajouter un modèle",
              id: "Identifiant",
              rules: "Règles",
              can_take_from: "Peut prendre depuis",
              capacity: "Capacité :",
              total_capacity: "Capacité totale",
              full_capacity: "Capacité de la salle",
              prm_capacity: "Capacité PMR",
              remainder: "Reste de la capacité",
              sellers: "Rôles",
              may_steal_from: "Ce contingent peut prendre depuis les contingents suivants",
              not_before: "Disponible depuis",
              not_after: "Disponible jusqu'à",
              only_for_roles: "Limiter ce contingent à certains rôles",
              only_for_tickettypes: "Limiter ce contingent à certains types de billets",
              no_role: "Aucun",
              all_roles: "Tous",
              no_role_desc: "Ce contingent n'est utilisable par aucun rôle",
              all_roles_desc: "Ce contingent est utilisable par tous les rôles",
              add_only_for_roles_rule: "Limiter ce contingent à certains rôles",
              remove_only_for_roles_rule: "Autoriser ce contingent à tous les rôles",
              no_tickettype: "Aucun",
              all_tickettypes: "Tous",
              no_tickettype_desc: "Ce contingent n'est utilisable par aucun type de billet",
              all_tickettypes_desc: "Ce contingent est utilisable par tout type de billet",
              add_only_for_tickettypes_rule: "Limiter ce contingent à certains types de billets",
              remove_only_for_tickettypes_rule: "Autoriser ce contingent à tous les types de billets",
              since_always: "toujours",
              for_ever: "toujours",
              start_at: "le début de la séance",
              stop_at: "la fin de la séance",
              tickets: "Types de billets",
              bucket_intern: "Ce contingent est utilisé en interne par le système",
              stash_bucket: "Ce contingent ne peut que donner à un autre"
            }
          },
          cron_tasks: {
            _id: "Identifiant",
            informations: "Informations générales",
            add: "Ajouter une tâche",
            cron_task: "Tâche",
            cron_task_plural: "Tâches",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            update_cron_task: "Modification de la tâche {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette tâche ?",
            frequency: "Fréquence",
            request: "Requête",
            url: "URL",
            url_placeholder: "Veuillez saisir l'URL de la requête",
            method: "Méthode HTTP",
            method_placeholder: "Veuillez choisir la méthode à utiliser",
            interval_description: "{{ nb }} exécutions au statut {{ status }} entre le {{ from }} et le {{ to }}",
            nb_executions: "{{ nb }} exécutions",
            this_task_is_disabled: "Cette tâche est inactive",
            disable_this_task: "Désactiver cette tâche",
            enable_this_task: "Activer cette tâche",
            status_pending: "En attente",
            status_in_progress: "En cours",
            status_completed: "OK",
            status_failed: "En erreur"
          },
          roles: {
            default: "Par défaut",
            eshop: "Vente en ligne",
            "on-site": "Vente sur place",
            partner: "Partenaire",
            accred: "Accréditation",
            admin: "Administrateur",
            mobile: "Application mobile",
            customer: "Client connecté",
            pos: "Interface du point de vente",
            overbooker: "Forcer les reservations",
            transfer: "Transfert",
            ticket_editor: "Éditeur de billets",
            refund: "Remboursement",
            wallet_cashier: "Encaissement de e-portefeuille",
            wallet_manager: "Gestionnaire de e-portefeuille",
            accounting: "Comptabilité",
            entry_check: "Contrôle d'entrée",
            stats: "Statistiques",
            integrator: "Intégrateur",
            waiter: "Serveur"
          },
          help: {
            display: "Afficher les aides",
            hide: "Cacher les aides"
          },
          statstypes: {
            statstype_plural: "Types de statistiques",
            statstype: "Type de statistique",
            reservations: "Réservations",
            movie: "Film",
            movies: "Films",
            ticket: "Billet",
            price: "Tarif",
            entries: "Entrées",
            prices: "Tarifs",
            halls: "Salles",
            percentage: "Pourc.",
            income_daily: "Décompte journalier",
            box_office: "Box Office",
            income_hourly: "Décompte horaire",
            shopping_carts: "Paniers",
            total: "Total",
            screenings: "Séances",
            screenings_small: "Séanc.",
            show_screenings: "Afficher les séances",
            hide_screenings: "Cacher les séances",
            date: "Date",
            gross: "Brut",
            tax: "Impôt local",
            exempt: "Net",
            deduction: "Déduction",
            ast_text: "Recette calculée sur les billets pour une entrée uniquement, la répartition du revenu lié à l'utilisation d'abonnement n'est pas calculé. Si vous êtes intéressés à la recette totale sur une période, rendez-vous sur le relevé comptable.",
            print: "Imprimer",
            texts: {
              reservations: "État des réservations",
              movies: "Statistiques en fonction du film",
              prices: "Statistiques de fréquentation en fonction du tarif",
              halls: "Statistiques en fonction de(s) salle(s)",
              income_daily: "Entrées et recettes en fonction du jour de la semaine",
              box_office: "Top des entrées et recettes",
              income_hourly: "Entrées et recettes en fonction de l'heure",
              shopping_carts: "Liste des paniers"
            },
            form: {
              date_start: "Date de début",
              date_start_tooltip: "Date de début de la période qui vous intéresse",
              date_end: "Date de fin",
              date_end_tooltip: "Date de fin de la période qui vous intéresse",
              cinema: "Cinéma",
              all_cinemas: "Tous les cinémas",
              cinema_tooltip: "Choissisez le cinéma",
              hall: "Salle",
              all_halls: "Toutes les salles",
              hall_tooltip: "Choisissez la salle",
              filters: "Filtres",
              search: "Chercher",
              show: "Afficher",
              from: "du",
              to: "à"
            },
            chart: {
              paid_entries: "Payantes",
              paid_entries_small: "Pay.",
              free_entries: "Gratuites",
              free_entries_small: "Grat.",
              pass_entries: "Abonnements",
              pass_entries_small: "Abo.",
              income: "Recette"
            }
          },
          widgets: {
            delete_confirm: "Voulez-vous vraiment supprimer ce widget ?",
            reset_confirm: "Voulez-vous vraiment réinitialiser le tableau de bord ?",
            reset: "Réinitialiser",
            edit_dashboard: "Modifier",
            back: "Retour",
            delete: "Supprimer",
            settings_btn: "Paramètres",
            save: "Sauvegarder",
            cancel: "Annuler",
            "24h_revenue": "Recette (dernières 24h)",
            "24h_entries": "Entrées (dernières 24h)",
            "7d_revenue": "Recette (7 derniers jours)",
            "7d_entries": "Entrées (7 derniers jours)",
            title_desc: {
              clock: "Horloge",
              clock_desc: "Affiche l'heure et la date",
              weather: "Météo",
              weather_desc: "Affiche la météo",
              separator: "Séparateur",
              separator_desc: "Espace vide pour la mise en page du tableau de bord",
              shortcut: "Raccourci",
              shortcut_desc: "Raccourci adaptable à vos fonctionnalités les plus utilisées",
              graphBoxOffice: "Box office",
              graphBoxOffice_desc: "Meilleurs ventes & recettes",
              lastEvents: "Derniers événements",
              lastEvents_desc: "Derniers événements crées"
            },
            settings: {
              parameters: "Paramètres",
              options: "Options d'affichage",
              width: "Largeur",
              color: "Couleur du texte",
              bgColor: "Couleur de fond",
              bgTransparent: "Fond transparent",
              use_current_location: "Utiliser position actuelle",
              default: "Défaut",
              zipcode: "Code postal (CH)",
              shortcut_target: "Cible du raccourci",
              chose_shortcut: "Choisir raccourci",
              chose_shortcut_alert: "Veuillez choisir une cible pour le raccourci",
              time_window: "Période",
              daily: "Journalière",
              weekly: "Hébdomadaire",
              monthly: "Mensuel",
              entries_max: "Nombre d'entrées",
              eventTypes: {
                movies: "Films",
                dramas: "Pièces",
                music_groups: "Groupes de musique",
                services: "Services",
                chose_eventType: "Type d'évenement",
                chose_event_alert: "Choisissez un type d'événement svp!",
                chose_eventNumber: "Nombre d'événement(s)",
                latest_movies: "Derniers films",
                latest_dramas: "Dernières pièces",
                latest_groups: "Derniers groupes",
                latest_services: "Derniers services",
                show_event: "Afficher",
                new_programmation: "Programmer"
              }
            }
          },
          tickettypes: {
            _id: "Identifiant",
            informations: "Informations générales",
            add: "Ajouter un type de billet",
            tickettype: "Type de billet",
            tickettype_plural: "Types de billet",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            description: "Description",
            description_placeholder: "Veuillez saisir une description",
            renewable: "Renouvelable",
            renewTypeInformation: {
              one_time_pass_price_information: "Les tarifs des tickets pour séance unique sont gérés dans les grilles tarifaires",
              choose_renew_type: "Veuillez choisir un type de renouvellement",
              help_text_show: "Afficher le tableau d'informations",
              help_text_hide: "Cacher le tableau d'informations",
              help_description: "Le tableau définit la date de renouvellement de l'abonnement.",
              if_user_renews: "Si un utilisateur renouvelle",
              now_key: "Maintenant",
              expiration_key: "Expiration",
              "start-of-year_key": "Début d'année",
              latest_key: "Le plus tard possible",
              soonest_key: "Le plus tôt",
              before_expiration_date: "Avant la date de péremption",
              expiration_date: "À la date de péremption",
              after_expiration_date: "Après la date d'expiration",
              now: "Maintenant",
              at_expiration_date: "À la date de péremption",
              start_of_next_year: "Début de l'année prochaine",
              start_of_current_year: "Début de l'année en cours"
            },
            eshop_sort_weight: "Ordre",
            update_tickettype: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer ce type de billet ?",
            pricings: "Tarifs",
            add_pricing: "Ajouter un tarif",
            new_duplicate_id: "Nouvel identifiant",
            id_already_used: "L'identifiant existe déjà",
            pricing: {
              base_informations: "Informations de base",
              display: "Affichage",
              rules: "Règles",
              name: "Nom",
              name_placeholder: "Nom du tarif",
              description: "Description",
              description_placeholder: "Veuillez saisir une description",
              price: "Prix",
              value: "Valeur",
              vat: "TVA",
              sellers: "Vendeurs",
              eshop_sort_weight: "Ordre",
              category: "Catégorie",
              additional_class_names: "Classe CSS",
              limit_to_sellers: "Limiter ce tarif aux rôles suivants",
              limit_to_tickettypes: "Limiter ce tarif aux types de billets suivants",
              exclude_tickettypes: "Interdire ce tarif aux types de billets suivants",
              not_before: "Valide à partir de (non implémenté)",
              not_after: "Valide jusqu'à (non implémenté)"
            },
            windows: "Fenêtres de réservation",
            windows_maybe_plural: "Fenêtre(s) de réservation",
            add_window: "Ajouter une règle",
            window: {
              screening_id: "ID de séance",
              duration: "Durée",
              start_at: "Pour des événements commençant après",
              stop_at: "et se terminant avant",
              nbookings: "Nombre de réservations",
              nsame_screening: "Pour le même événement",
              overlap: "Règle de chevauchement",
              same_day: "Même jour",
              overlap_question_positive: "Autoriser les événements réservés à se chevaucher de",
              overlap_question_negative: "Obliger les événements réservés à être espacés de"
            },
            add_fields: "Definir des champs optionnels et obligatoires",
            fields: "Champs",
            pdflayouts: "Modèles PDF",
            emails: "E-mails",
            available_fields: {
              requested_description: "Veuillez choisir les champs optionnels",
              required_description: "Veuillez choisir les champs obligatoires",
              company: "Entreprise",
              title: "Salutation",
              firstname: "Prénom",
              lastname: "Nom",
              email: "E-mail",
              address: "Adresse",
              zip: "Code postal",
              city: "Ville",
              country: "Pays",
              phone: "Téléphone",
              cellphone: "Mobile",
              age: "Âge",
              birthdate: "Date de naissance",
              photo: "Photo",
              sex: "Sexe",
              gift_message: "Cadeau"
            }
          },
          screenings: {
            _id: "Identifiant",
            refs: "Références",
            informations: "Informations générales",
            add: "Ajouter une séance",
            screening: "Séance",
            screening_plural: "Séances",
            name: "Nom",
            place: "Lieu",
            date: "Date",
            buckets: "Contigents",
            description: "Description",
            capacity: "Capacité",
            name_placeholder: "Veuillez saisir un nom",
            description_placeholder: "Veuillez saisir une description",
            capacity_placeholder: "Veuillez saisir une capacité",
            update_place: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette séance ?",
            title: "Titre",
            start_at: "Début",
            stop_at: "Fin",
            date_disabled_tooltip: "Cette séance est dans le passé, en cours ou à déjà des réservations. Vous ne pouvez donc pas changer ses dates.",
            map_only_bookings: "Réservations sur plan",
            duration: "Durée",
            starts: "Commence",
            sections: "Sections",
            no_section: "Aucune section",
            _3d: "3D",
            break: "Entracte",
            format: "Format",
            version: "Version",
            version_small: "Vers.",
            week: "Semaine",
            week_small: "Sem.",
            details: "Détails",
            events: "Événements",
            add_event: "Ajouter un événement",
            update_screening: "Modification de {{ title }}",
            tasks: "Postes",
            posters: "Images",
            add_poster: "Ajouter une image",
            support: "Support",
            languages: "Languages",
            audio: "Audio",
            subtitles: "Sous-titres",
            ignore_on_maccsbox: "Ignorer sur Maccsbox",
            list: {
              total: "au total",
              confirmed: "réservées",
              unconfirmed: "en cours",
              available: "disponibles"
            },
            edit: {
              itemlist: {
                general: "Général",
                bucket: "Contigents",
                booking: "Réservations",
                pricing: "Tarifs",
                history: "Historique",
                map: "Plan"
              },
              form: {
                original: "Original",
                name_placeholder: "Saisissez un nom",
                description_placeholder: "Saissez une description",
                note_placeholder: "Saisir une note interne (non visible publiquement)",
                bucket_intern: "Ce contingent est utilisé en interne par le système",
                version_placeholder: "Saisir la langue",
                format_placeholder: "Saisir le format",
                general: {
                  names: "Noms",
                  descriptions: "Descriptions",
                  place: "Lieu",
                  dates: "Dates",
                  start_at: "Date de début",
                  stop_at: "Date de fin",
                  date_in_past_tooltip: "Cette séance est dans le passé, vous ne pouvez donc pas changer sa date",
                  description: "Description",
                  note: "Note",
                  save_names: "Enregistrer les noms",
                  save_place: "Enregistrer le lieu",
                  save_dates: "Enregistrer les dates",
                  save_descriptions: "Enregistrer les descriptions",
                  save_note: "Enregistrer la note",
                  save_pricings: "Enregistrer les tarifs"
                },
                buckets: {
                  id: "Identifiant",
                  rules: "Règles",
                  can_take_from: "Peut prendre depuis",
                  bookings: "Réservations",
                  capacity: "Capacité",
                  total_capacity: "total",
                  sellers: "Rôles",
                  not_before: "Disponible depuis",
                  not_after: "Disponible jusqu'à",
                  no_role: "Aucun",
                  all_roles: "Tous",
                  no_tickettype: "Aucun",
                  all_tickettypes: "Tous",
                  since_always: "Depuis toujours",
                  for_ever: "Pour toujours",
                  tickets: "Types de billets",
                  bucket_intern: "Ce contingent est utilisé en interne par le système",
                  stash_bucket: "Ce contingent ne peut que donner à un autre"
                },
                logs: {
                  checkin: "Scan d'entrée",
                  checkout: "Scan de sortie",
                  confirm_booking: "Réservation",
                  activate: "Activation du billet",
                  unbook: "Annulation de réservation",
                  date: "Date",
                  action: "Action",
                  ticket: "Billet",
                  by: "Par"
                },
                ticket: {
                  id: "Identifiant",
                  one_time_pass: "Ticket pour séance unique",
                  new: "Nouveau",
                  activated: "Activé",
                  blocked: "Bloqué",
                  pending: "En attente de paiement",
                  type: "Type",
                  pricing: "Tarif",
                  value: "Valeur",
                  booking_date: "Date de réservation",
                  status: "Status",
                  name: "Nom",
                  email: "E-mail",
                  tel: "Téléphone",
                  nb_bookings: "{{ nb }} réservations",
                  seats: "Siège",
                  scanned: "Scanné",
                  in_room: "En salle"
                },
                maps: {
                  change_map: "Changer la salle"
                }
              }
            },
            import: {
              imported_at: "Import du {{ date }}",
              resume: "En résumé",
              nb_deleted: "{{ nb }} séances ont été supprimée(s)",
              nb_inserted: "{{ nb }} séances ont été créée(s)",
              nb_updated: "{{ nb }} séances ont été mise(s) à jour",
              nb_invalid: "{{ nb }} séances invalide(s)",
              inserted: "Séance(s) créée(s)",
              updated: "Séance(s) mise(s) à jour",
              invalid: "Séance(s) invalide(s)",
              an_error_occured: "Une erreur est survenue pendant la synchronisation. Veuillez ré-essayer plus tard.",
              was_useless: "L'import s'est bien déroulé mais il n'a eu aucun effet.",
              screenings_tab: "Séances"
            }
          },
          tickets: {
            ticket: "Billet",
            ticket_plural: "Billets",
            status: {
              all: "Tous les statuts",
              new: "Nouveau",
              pending: "En attente de paiement",
              activated: "Activé",
              blocked: "Bloqué"
            },
            filters: {
              search: "Recherche",
              search_placeholder: "Nom, prénom, e-mail ou ID",
              status: "Statut",
              tickettypes: "Types de billet",
              filter_on_batches: "Filtrer sur les imports",
              imported_at: "Billets créés lors de l'import du",
              activated_at: "Billets activés lors de l'import du",
              filter_on_emails: "Filtrer sur les e-mails reçus",
              received_email: "Billets qui ont reçu cet e-mail",
              received_email_placeholder: "Veuillez choisir un e-mail",
              not_received_email: "Billets qui n'ont pas reçu cet e-mail",
              not_received_email_placeholder: "Veuillez choisir un e-mail",
              filter_on_bookings: "Filtrer sur les réservations",
              having_booked: "Billets qui ont au moins une réservation",
              having_not_booked: "Billets qui n'ont aucune réservation",
              having_booked_screening_id: "Billets qui ont réservé cette séance",
              having_booked_screening_id_placeholder: "Veuillez choisir une séance"
            },
            columns: {
              _id: "Identifiants",
              owner: "Détenteur",
              firstname: "Prénom",
              lastname: "Nom",
              email: "E-mail",
              status: "Statut",
              type: "Type",
              activated_pricing: "Tarif",
              nbookings: "Réservations",
              created_at: "Créé le"
            },
            import: {
              title: "Importer des billets",
              desc: "L'import de billets vous permet d'importer des billets depuis un fichier CSV.",
              download_csv_file: "Télécharger le fichier modèle csv",
              download_xlsx_file: "Télécharger le fichier modèle xlsx",
              tab_title: "Billets",
              file_goods: "Vous vous apprêtez à importer {{ nb }} billets",
              file_errors: "Vous avez {{ nb }} erreur(s) dans votre fichier CSV",
              file_errors_desc: "Veuillez corriger votre fichier et le resoumettre",
              x_tickets_of_type: "{{ nb }} billets de type {{ name }}",
              x_tickets_of_price: "{{ nb }} billets au tarif {{ name }}",
              send_x_emails: "Envoi de {{ nb }} e-mails",
              send_x_emails_of_type: "Envoi de {{ nb }} e-mails {{ name }}",
              choose_csv_file: "Veuillez choisir le fichier CSV à importer",
              do_import: "Lancer l'import",
              do_another_import: "Importer un autre fichier",
              line_x: "Ligne {{ line }}",
              preview_view: "Prévisualisation",
              resume_view: "En résumé",
              field_is_invalid: "La cellule {{ field }} est invalide",
              an_error_occured: "Une erreur est survenu pendant l'import. Veuillez ré-essayer plus tard.",
              columns: {
                line: "Ligne",
                nb: "Nombre",
                type: "Type",
                pricing: "Tarif",
                title: "Titre",
                firstname: "Prénom",
                lastname: "Nom",
                email: "E-mail",
                zip: "Zip",
                city: "Ville",
                country: "Pays",
                photo: "Photo",
                cellphone: "Téléphone",
                sex: "Sexe",
                age: "Àge",
                language: "Langue",
                company: "Entreprise",
                screening: "Séance",
                row: "Rang",
                seat: "Numéro",
                prefix: "Prefixe PDF"
              },
              imported_at: "Import du {{ date }}",
              resume: "En résumé",
              nb_deleted: "{{ nb }} billets ont été supprimé(s)",
              nb_inserted: "{{ nb }} billets ont été créé(s)",
              nb_updated: "{{ nb }} billets ont été mis(s) à jour",
              nb_activated: "{{ nb }} billets ont été activés",
              nb_invalid: "{{ nb }} billets invalide(s)",
              inserted: "Billet(s) créé(s)",
              updated: "Billet(s) mis(s) à jour",
              activated: "Billet(s) activé(s)",
              invalid: "Billet(s) invalide(s)"
            },
            batch: {
              send_email: "Envoyer un e-mail"
            }
          },
          programmations: {
            add: "Ajouter une programmation",
            programmation: "Programmation",
            programmation_plural: "Programmations",
            update_place: "Modification",
            confirm_delete: "Voulez-vous vraiment supprimer cette programmation ?",
            title: "Titre des séances",
            title_placeholder: "Veuillez saisir un titre pour les séances",
            description: "Description de la séance",
            timing: "Timing",
            days: "Jours",
            hours: "Horaires",
            period: "Durée",
            start_at: "Début",
            stop_at: "Fin",
            _3d: "3D",
            break: "Entracte",
            format: "Format {{ format }}",
            version: "Version {{ version }}",
            week: "Semaine {{ week }}",
            details: "Options",
            events: "Événements",
            add_event: "Ajouter un événement",
            update_programmation: "Modification",
            all_days: "Tous les jours",
            each_days: "Tous les {{ days }}",
            at: "à {{ time }}",
            in_the_place: "dans la salle {{ place }}",
            pricinglist: "Grille tarifaire {{ pricinglist }}",
            bucketlist: "Modèle de contingents {{ bucketlist }}",
            screenings: "Séances",
            generate_screenings: "Générer les séances",
            x_screenings: "{{ nb }} séances",
            see_x_screenings: "Voir les {{ nb }} séances",
            regenerate_screenings: "Re-générer les séances",
            tasks: "Postes",
            support: "Support",
            support_dcp: "DCP",
            support_dvd: "DVD",
            support_blu_ray: "Blu-ray",
            support_video_file: "Fichier vidéo",
            support_other: "Autre",
            section: "Section",
            languages: "Langues",
            audio: "Audio",
            subtitles: "Sous-titres",
            ignore_on_maccsbox: "Ignorer sur Maccsbox",
            ignored_on_maccsbox: "Ignoré sur Maccsbox",
            booking_option: "Option de réservation",
            booking_mode: {
              title: "Mode de Réservation",
              normal: "Billetterie Ticketack",
              free: "Entrée libre (sans billets gratuits ni contrôle de la capacité)",
              free_placeholder: "Instructions supplémentaires (facultatif)",
              email: "Réservation par e-mail",
              email_placeholder: "Adresse e-mail de contact",
              other: "Réservation sur un autre système",
              other_placeholder: "Instructions supplémentaires, lien vers l'autre système (facultatif)"
            },
            copy_options_to_other: "Copier ces options partout"
          },
          tktInstances: {
            is_active: "Active",
            informations: "Informations",
            add: "Ajouter une instance ticketack",
            tktInstance: "Instance ticketack",
            tktInstance_plural: "Instances ticketack",
            name: "Nom",
            slug: "Slug",
            engine_url: "URL de l'engine",
            solego_url: "URL de solego",
            api_key: "Clé d'API",
            email: "E-mail",
            name_placeholder: "Veuillez saisir le nom de l'instance",
            slug_placeholder: "Veuillez saisir le slug de l'instance",
            engine_url_placeholder: "Veuillez saisir l'URL de l'engine",
            solego_url_placeholder: "Veuillez saisir l'URL de solego",
            api_key_placeholder: "Veuillez saisir votre clé d'API",
            email_placeholder: "Veuillez saisir votre adresse e-mail",
            options: "Options",
            languages: "Langues",
            modules: "Modules",
            sms_username: "Utilisateur SMS",
            sms_username_placeholder: "Veuillez saisir le nom d'utilisateur de la passerelle SMS à utiliser",
            sms_password: "Mot de passe SMS",
            sms_password_placeholder: "Veuillez saisir le mot de passe correspondant à l'utilisateur de la passerelle SMS",
            update_tktInstance: "Modification de {{ url }}",
            delete: "Suppression de l'instance {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette instance ticketack ?"
          },
          abilities: {
            abilities_template: "Patrons d'autorisations",
            name: "Nom",
            template: "Patron",
            create: "Création",
            read: "Lecture",
            edit: "Édition",
            delete: "Supression",
            all: "Tous",
            self: "Les miens",
            other: "Tous",
            create_template: "Créer un patron d'autorisations",
            apply_template: "Appliquer le patron",
            chose_abilities_placeholder: "Choisir…",
            create_empty_field_name: "Veuillez renseigner ce champ",
            create_name_already_used: "Ce nom est déjà utilisé",
            forbidden: "Accès interdit",
            forbidden_message: "Il semble que vous n'avez pas les droits pour accèder à cette page",
            home: "Acceuil",
            layouts: "Modèles PDF et e-mails"
          },
          resources: {
            informations: "Informations",
            add: "Ajouter une clé",
            number: "Numéro",
            number_placeholder: "Veuillez saisir un numéro",
            type: "Type",
            type_placeholder: "Veuillez saisir un type",
            comment: "Remarque",
            comment_placeholder: "Veuillez saisir une remarque",
            user: "Utilisateur",
            resource: "Clé",
            resource_plural: "Clés",
            update_resource: "Modification de {{ number }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette clé ?"
          },
          distributors: {
            informations: "Informations",
            add: "Ajouter un distributeur",
            distributor: "Distributeur",
            distributor_plural: "Distributeurs",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            maccsbox_id: "ID Maccsbox",
            contact_mail: "E-mail de contact",
            report_mail: "E-mail rapport",
            maccsbox_id_placeholder: "Entrez l'ID Maccsbox",
            contact_mail_placeholder: "Addresse E-mail distributeur",
            report_mail_placeholder: "E-mail de destination pour l'envoi du rapport",
            address: "Adresse",
            address_placeholder: "Veuillez saisir une adresse",
            zip: "Code postal",
            zip_placeholder: "Veuillez saisir un code postal",
            city: "Ville",
            city_placeholder: "Veuillez saisir une ville",
            country: "Pays",
            country_placeholder: "Veuillez saisir un pays",
            update_distributor: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer ce distributeur ?"
          },
          events: {
            informations: "Informations générales",
            add_movie: "Ajouter un film",
            add_artist: "Ajouter un artiste",
            add_play: "Ajouter une pièce",
            add_service: "Ajouter un service",
            sync_and_import: "Synchronisation et import",
            tktsync_kronos: "Synchroniser avec Ticketack",
            tktsync_eventival: "Synchronisation Eventival",
            tktsync_json: "Synchronisation source externe",
            tktsync_cinech: "Synchronisation Ciné.ch",
            tktsync_kronos_desc_screenings: "La synchronisation avec Ticketack permet de créer les séances dans votre billetterie à partir de vos programmations Kronos.",
            tktsync_kronos_desc_places: "",
            tktsync_eventival_desc_screenings: "La synchronisation avec Eventival permet de créer les séances dans votre billetterie à partir de votre programmation sur Eventival.",
            tktsync_eventival_desc_places: "Les salles seront copiées depuis Eventival vers Ticketack.",
            tktsync_json_desc_screenings: "La synchronisation avec votre source externe permet de créer les séances dans votre billetterie à partir de cette source.",
            tktsync_json_desc_places: "Les salles seront copiées depuis cette source vers Ticketack.",
            tktsync_cinech_desc_screenings: "La synchronisation permet de créer les séances dans votre billetterie à partir de votre programmation sur Ciné.ch.",
            tktsync_cinech_desc_places: "Les salles seront copiées depuis Ciné.ch vers Ticketack.",
            tktsync_delete_future: "Les séances futures seront supprimées au début de la synchronisation.",
            tktsync_delete_existing: "Les séances existantes seront supprimées avant leur mise à jour.",
            tktsync_no_delete: "Aucune séance ne sera supprimée.",
            sync_screenings_tab_kronos: "Séances",
            sync_screenings_tab_eventival: "Séances et salles",
            sync_screenings_tab_json: "Séances et salles",
            sync_screenings_tab_cinech: "Séances et salles",
            run_tktsync: "Lancer la synchronisation",
            event: "Événement",
            event_plural: "Événements",
            title: "Titre",
            original_title: "Titre original",
            type: "Type",
            description: "Description",
            title_placeholder: "Veuillez saisir un titre",
            original_title_placeholder: "Veuillez saisir le titre original",
            description_placeholder: "Veuillez saisir une description",
            duration: "Durée (min)",
            details: "Details",
            suisa: "SUISA",
            movie_link: "Site officiel",
            distributor: "Distributeur",
            year: "Année",
            suisa_placeholder: "Veuillez saisir un numéro SUISA",
            movie_link_placeholder: "https://kronos.ticketack.com",
            year_placeholder: "Veuillez saisir une année de sortie",
            l_min_age: "Âge min. lég.",
            s_min_age: "Âge min. sug.",
            a_min_age: "Âge min. acc.",
            l_min_age_placeholder: "Veuillez saisir un âge minimum légal",
            s_min_age_placeholder: "Veuillez saisir un âge minimum suggéré",
            a_min_age_placeholder: "Veuillez saisir un âge minimum accompagné",
            free_texts: "Champs libres",
            free_text: "Champ",
            add_poster: "Ajouter une image",
            posters: "Images",
            add_trailer: "Ajouter une vidéo",
            trailers: "Vidéos",
            new_trailer_youtube_placeholder: "Saisissez l'ID d'une vidéo Youtube",
            new_trailer_vimeo_placeholder: "Saisissez l'ID d'une vidéo Vimeo",
            new_trailer_mp4_placeholder: "Saisissez l'adresse d'un fichier video mp4",
            genre: "Genre",
            service_type: "Type de service",
            add_section: "Ajouter une catégorie",
            update_event: "Modification de {{ title }}",
            confirm_delete: "Voulez-vous vraiment supprimer cet événement ?",
            casting: "Casting",
            scheduling: "Programmation",
            new_people_firstname_placeholder: "Veuillez saisir un prénom",
            new_people_lastname_placeholder: "Veuillez saisir un nom",
            activity_actor: "Acteur",
            activity_cast: "Casting",
            activity_director: "Réalisateur",
            activity_editor: "Directeur de la rédaction",
            activity_photography: "Directeur de la photographie",
            activity_music: "Musique",
            activity_producer: "Producteur",
            activity_screenplay: "Scénariste",
            countries: "Pays",
            original_language: "Langue originale",
            subevent: {
              movie: "Film",
              drama: "Pièce de théâtre",
              music_group: "Artiste/Groupe",
              service: "Autre activité"
            },
            subevents: {
              movie: "Films",
              drama: "Pièces de théâtre",
              music_group: "Artistes/Groupes",
              service: "Autres activités",
              mine_movie: "Mes films",
              mine_drama: "Mes pièces de théâtre",
              mine_music_group: "Mes artistes/Groupes",
              mine_service: "Mes autres activités",
              all_movie: "Tous les films",
              all_drama: "Toutes les pièces de théâtre",
              all_music_group: "Tous les artistes/groupes",
              all_service: "Toutes les autres activités"
            },
            search_placeholder: {
              movie: "Rechercher un film par son titre ou son numéro SUISA",
              drama: "Rechercher une pièce de théâtre par son nom",
              music_group: "Rechercher un artiste/groupe par son nom",
              service: "Rechercher une autres activités par son nom"
            },
            add: {
              event: "Ajouter un événement",
              movie: "Ajouter un film",
              drama: "Ajouter une pièce de théâtre",
              music_group: "Ajouter un artiste/groupe",
              service: "Ajouter une autre activité"
            },
            id: "Identifiant :",
            reference: "Référence :"
          },
          common: {
            loading: "Chargement en cours...",
            back: "Retour",
            save: "Enregistrer",
            apply: "Appliquer",
            send: "Envoyer",
            add: "Ajouter",
            cancel: "Annuler",
            close: "Fermer",
            delete: "Supprimer",
            edit: "Modifier",
            duplicate: "Dupliquer",
            copy_to_mine: {
              movie: "Copier dans mes films",
              drama: "Copier dans mes pièces de théâtre",
              music_group: "Copier dans mes artistes/groupes",
              service: "Copier dans mes autres activités"
            },
            actions: "Actions",
            show_options: "Afficher les options",
            hide_options: "Masquer les options",
            see: "Voir",
            mo: "LU",
            tu: "MA",
            we: "ME",
            th: "JE",
            fr: "VE",
            sa: "SA",
            su: "DI",
            monday: "Lundi",
            tuesday: "Mardi",
            wednesday: "Mercredi",
            thursday: "Jeudi",
            friday: "Vendredi",
            saturday: "Samedi",
            sunday: "Dimanche",
            day: "Jour(s)",
            week: "Semaine(s)",
            cinema_week: "Semaine(s) ciné.",
            month: "Mois",
            year: "Année(s)",
            me: "Moi",
            no: "Non",
            yes: "Oui",
            other: "Autre",
            are_you_sure: "Êtes-vous sûr ?",
            drag_one_file: "Glissez et déposez un fichier ici, ou cliquez pour le sélectionner.",
            yellow: "Jaune",
            yellow2: "Jaune alt.",
            magenta: "Magenta",
            magenta2: "Magenta alt.",
            green: "Vert",
            green2: "Vert alt.",
            red: "Rouge",
            red2: "Rouge alt.",
            blue: "Bleu",
            blue2: "Bleu alt.",
            white: "Blanc",
            black: "Noir",
            brown: "Marron",
            brown2: "Marron alt.",
            grey: "Gris",
            grey2: "Gris alt.",
            none: "Aucune",
            invalid_id_input: "SVP n'utiliser que des chiffres, lettres ou le caractère _.",
            image_types: {
              default: "Défaut",
              banner: "Bannière (paysage)",
              logo: "Logo Web (recommandé 300px)",
              poster: "Poster (portrait)",
              "logo-a4": "Logo pour PDF A4",
              "logo-thermal": "Logo pour impression thermique (noir/blanc)",
              favicon: "Favicon (recommandé 32x32px)",
              appicon: "Icône Web App (recommandé 192x192px)",
              partners: "Logos des partenaires",
              "partners-a4": "Logos des partenaires pour PDF A4",
              "partners-thermal": "Logos des partenaires pour impression thermique (noir/blanc)"
            },
            link_types: {
              article: "Article",
              category: "Catégorie d'article",
              movie: "Film",
              screening: "Programmation",
              url: "Url"
            },
            grammes: "grammes",
            mini_grammes: "g",
            centimeters: "centimètres",
            mini_centimeters: "cm",
            min: "min.",
            duration: {
              years: "Années",
              months: "Mois",
              days: "Jours",
              hours: "Heures",
              minutes: "Minutes",
              none: "Aucune durée",
              custom: "Durée personnalisée",
              PT5M: "5 minutes",
              PT10M: "10 minutes",
              PT15M: "15 minutes",
              PT30M: "30 minutes",
              PT45M: "45 minutes",
              PT1H: "1 heure",
              PT6H: "6 heures",
              PT12H: "12 heures",
              P1D: "1 jour",
              P7D: "1 semaine",
              P1M: "1 mois",
              P6M: "6 mois",
              P1Y: "1 an",
              P1Y6M: "18 mois"
            },
            sex: {
              "n/c": "Pas de réponse",
              m: "Masculin",
              f: "Féminin",
              o: "Autre"
            },
            and: "et"
          },
          languages: {
            ov: "Version originale",
            fr: "Français",
            de: "Allemand",
            en: "Anglais",
            it: "Italien",
            gsw: "Suisse-allemand",
            fr_de: "Français & Allemand"
          },
          posts: {
            informations: "Informations générales",
            add: "Ajouter un post",
            post: "Post",
            post_post: "Post",
            post_plural: "Posts",
            name: "Nom",
            title: "Titre",
            title_placeholder: "Veuillez saisir un titre",
            sub_title: "Sous-titre",
            sub_title_placeholder: "Veuillez saisir un sous-titre",
            content: "Contenu",
            content_placeholder: "Veuillez saisir un message",
            category: "Categorie",
            choose_a_category: "Veuillez choisir une catégorie",
            tags: "Tags",
            posters: "Images",
            add_poster: "Ajouter une image",
            trailers: "Vidéos",
            add_trailer: "Ajouter une vidéo",
            published: "Publié",
            archived: "Archivé",
            channels: "Canaux de diffusion",
            confirm_delete: "Voulez-vous vraiment supprimer ce post ?",
            update_post: "Modification de {{ name }}",
            show_all_categories: "Toutes les catégories",
            filter_by_category: "Catégories",
            please_create_category: "Veuillez créer une catégorie",
            please_choose_category_or_make_a_search: "Veuillez choisir une catégorie ou effectuer une recherche",
            search: "Rechercher un post",
            search_placeholder: "Saisissez le titre d'un post",
            links: "Lien",
            please_create_link: "Veuillez choisir un type de lien",
            links_placeholder_url: "Saisissez une url https://www.url.com/{lang}",
            links_placeholder_article: "Saisissez l'id d'un article",
            links_placeholder_category: "Saisissez l'id d'une catégorie d'article",
            links_placeholder_movie: "Saisissez l'id d'un film",
            links_placeholder_screening: "Saisissez l'id d'une programmation"
          },
          post_categories: {
            informations: "Informations générales",
            add: "Ajouter une catégorie",
            publishing: "Publicité",
            post_category: "Catégorie",
            post_categories_plural: "Catégories",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            confirm_delete: "Voulez-vous vraiment supprimer cette catégorie ?",
            choose_a_category: "Veuillez choisir une catégorie",
            update_postcategory: "Modification de {{ name }}"
          },
          channels: {
            informations: "Informations générales",
            add: "Ajouter un canal",
            publishing: "Publicité",
            channel: "Canal",
            channels_plural: "Canaux",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            confirm_delete: "Voulez-vous vraiment supprimer ce canal ?",
            choose_a_channel: "Veuillez choisir un canal",
            update_channel: "Modification de {{ name }}",
            salepoint: "Point de vente",
            cashregister: "Caisse",
            slug: "Identifiant unique",
            active_from: "Actif à partir du",
            active_until: "Actif jusqu'au",
            only_for_roles: "Limiter ce canal aux rôles suivants"
          },
          phases: {
            informations: "Informations générales",
            add: "Ajouter une une phase",
            phase: "Phase",
            phases_plural: "Phases",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            confirm_delete: "Voulez-vous vraiment supprimer cette phase ?",
            update_phase: "Modification de {{ name }}",
            active_from: "Date de début",
            active_until: "Date de fin",
            from_to: "Du {{ from }} au {{ to }}"
          },
          salepoints: {
            informations: "Informations générales",
            add: "Ajouter un point de vente",
            salepoint: "Point de vente",
            salepoint_plural: "Points de vente",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            delivery_types: "Modes de livraison",
            update_salepoint: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer ce point de vente ?",
            choose_a_salepoint: "Choisissez un point de vente",
            default: "Par défaut",
            settings: "Configuration personnalisée pour ce point de vente",
            pos_layout: "Interface de vente",
            layouts: {
              tickets: "Point de vente billetterie",
              articles: "Point de vente articles"
            },
            sell_pass: "Permettre la vente d'abonnements",
            places_ids: "Lier aux salles suivantes"
          },
          articlecategories: {
            informations: "Informations générales",
            add: "Ajouter une catégorie",
            articlecategory: "Catégorie",
            articlecategory_plural: "Catégories",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            parent: "Catégorie parente",
            description: "Description",
            pos: "Point de vente",
            add_poster: "Ajouter une image",
            posters: "Images",
            update_salepoint: "Modification de {{ name }}",
            update_articlecategory: "Modifier la catégorie",
            confirm_delete: "Voulez-vous vraiment supprimer cette catégorie ?",
            choose_a_category: "Veuillez choisir une catégorie",
            please_choose_category: "Veuillez choisir une catégorie"
          },
          articles: {
            informations: "Informations générales",
            add: "Ajouter un article",
            add_discount_code: "Ajouter un code promo",
            add_manual_discount: "Ajouter un rabais",
            add_product: "Ajouter un produit",
            choose_an_article: "Choisissez un article",
            article: "Article",
            article_plural: "Articles",
            list: "Afficher la liste",
            order: "Gérer l'ordre",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            short_description: "Description courte",
            short_description_placeholder: "Veuillez saisir une description courte",
            category: "Catégorie",
            sort_weight: "Ordre d'affichage (plus petit en premier)",
            description: "Description longue",
            add_poster: "Ajouter une image",
            posters: "Images",
            stock: "Stock total",
            pos: "Point de vente",
            variant: "Tarif",
            variants: "Tarifs",
            variant_name: "Nom",
            variant_name_placeholder: "Nom",
            variant_stock: "Stock",
            variant_stock_factor: "Impact sur le stock total",
            variant_gtin: "Code EAN",
            variant_sku: "SKU",
            variant_price: "Prix",
            variant_variable_price: "Prix variable",
            variant_value: "Valeur",
            variant_value_like_price: "Valeur identique au prix",
            variant_purchasing_price: "Prix d'achat",
            variant_vat: "TVA",
            variant_discount: {
              code: "Code",
              value_amount: "Rabais fixe",
              value_percentage: "Rabais en %",
              target: "S'applique",
              cart_target: "À tout le panier",
              last_item_target: "Au dernier élément du panier",
              only_for_roles: "Limiter ce tarif aux rôles suivants",
              only_for_tickettypes: "Limiter ce tarif aux types de billets suivants",
              exclude_tickettypes: "Interdire ce tarif aux types de billets suivants"
            },
            add_variant: "Ajouter un tarif",
            update_article: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cet article ?",
            show_all_categories: "Toutes les catégories",
            filter_by_category: "Catégories",
            filter_by_type: "Types d'articles",
            please_create_category: "Veuillez créer une catégorie",
            please_choose_category_or_make_a_search: "Veuillez choisir une catégorie ou effectuer une recherche",
            type_product: "Produit",
            type_manual_discount: "Rabais",
            type_auto_discount: "Rabais automatique",
            type_code_discount: "Code promo",
            search: "Rechercher un article",
            search_placeholder: "Saisissez le nom d'un article",
            stocks: {
              name: "Stocks",
              stock_type: "Type de stock",
              type_none: "Aucune gestion de stock",
              type_article: "Gestion du stock par article",
              type_variant: "Gestion du stock par tarif",
              availability: "Disponibilité",
              variant_price: "Prix {{ index }}"
            },
            tags: "Tags",
            export_stocks: "Exporter les stocks",
            features: "Caractéristiques",
            add_feature: "Ajouter une caractéristique",
            delete_feature: "Supprimer cette caractéristique",
            feature: {
              name: "Nom",
              choices: "Valeur"
            },
            extras: "Options",
            add_extra: "Ajouter une option",
            delete_extra: "Supprimer cette option",
            extra: {
              name: "Option",
              min_nb_choices: "Nombre de choix minimum",
              max_nb_choices: "Nombre de choix maximum",
              choices: "Choix",
              add_choice: "Ajouter un choix",
              default_choice: "Choix par défaut",
              default_choice_placeholder: "Veuillez choisir une option"
            },
            delivery: "Livraison",
            delivery_types: "Modes de livraison",
            packaging: "Packaging",
            delivery_width: "Largeur (cm)",
            delivery_width_placeholder: "Saisissez la largeur du packaging en centimètres",
            delivery_length: "Longueur (cm)",
            delivery_length_placeholder: "Saisissez la longueur du packaging en centimètres",
            delivery_height: "Hauteur (cm)",
            delivery_height_placeholder: "Saisissez la hauteur du packaging en centimètres",
            delivery_weight: "Poids (g)",
            delivery_weight_placeholder: "Saisissez le poids du packaging en grammes"
          },
          activities: {
            informations: "Informations",
            add: "Ajouter une activité",
            activity: "Activité",
            activity_plural: "Activités",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            is_exclusive: "Exclusive",
            update_activity: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette activité ?",
            email_notification: "Notifications par e-mail",
            sms_notification: "Notifications par SMS",
            notification_none: "Je ne souhaite pas être notifié",
            notification_PT10M: "10 minutes avant",
            notification_PT30M: "30 minutes avant",
            notification_PT1H: "1 heure avant",
            notification_PT2H: "2 heures avant",
            notification_PT6H: "6 heures avant",
            notification_P1D: "1 jour avant",
            notification_P2D: "2 jours avant",
            notification_P3D: "3 jours avant",
            reward: {
              title: "Récompenses",
              ticket: {
                type: "Type de ticket",
                type_desc: "Type de ticket à utiliser pour créer le ticket qui servira de récompense",
                pricing: "Tarif",
                pricing_desc: "Tarif à utiliser pour activer le ticket qui servira de récompense"
              },
              bookings: {
                title: "Réservations",
                nb_hours: "Nombre d'heures pour une réservation",
                nb_hours_desc: "Nombre d'heures nécessaires pour obtenir le droit à une réservation",
                at_the_end: "À la fin du shift",
                at_the_end_desc: "Faut-il attendre la fin du shift pour obtenir le droit à une réservation"
              },
              wallet: {
                title: "Porte-monnaie",
                nb_hours: "Nombre d'heures pour 1 {{ currency }}",
                nb_hours_desc: "Nombre d'heures nécessaires pour obtenir 1 {{ currency }}",
                at_the_end: "À la fin du shift",
                at_the_end_desc: "Faut-il attendre la fin du shift pour obtenir 1 {{ currency }}"
              }
            }
          },
          plan: {
            title: "Planification",
            calendar: {
              week: "Semaine",
              work_week: "Semaine de travail",
              day: "Jour",
              month: "Mois",
              previous: "Préc.",
              next: "Suiv.",
              today: "Aujourd'hui",
              agenda: "Agenda",
              showMore: "+{{total}} de plus"
            },
            select_sector: "Veuillez choisir un secteur",
            from: "Du",
            to: "Au",
            sector: "Secteur",
            event: {
              nb_volunteers: "{{ nb }} bénévole(s)",
              nb_validated: "{{ nb }} validés(s)"
            }
          },
          shifts: {
            sector: "Secteur",
            dates: "Dates",
            start_at: "Du",
            stop_at: "Au",
            volunteers: "Bénévoles",
            needs: "Besoins",
            nb_volunteers: "Nombre de bénévoles",
            assigned: "Assignés",
            activity: "Compétence",
            suggestions: "Suggestions",
            no_suggestions_found: "Aucun bénévole de disponible",
            available: "Disponibles",
            out_of_sector: "Hors secteur",
            overbooked: "Overbookés",
            status: "Statut des tâches",
            status_new: "Nouveau (le bénévole est choisi par le responsable)",
            status_free: "À pourvoir (les bénévoles peuvent prendre cette tâche)",
            user_can_not_be_found: "Ce bénévole est introuvable"
          },
          tasks: {
            informations: "Informations",
            add: "Ajouter un poste",
            task: "Poste",
            task_plural: "Postes",
            is_exclusive: "Exclusive",
            update_task: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer ce poste ?",
            activity: "Activité",
            start_at: "Début",
            stop_at: "Fin",
            start_at_gte: "Du",
            start_at_lte: "Au",
            screening: "Séance",
            phase: "Phase",
            sector: "Secteur",
            user: "Assigné à",
            comment: "Commentaire",
            status: "Statut",
            status_new: "Nouveau",
            status_free: "À pourvoir",
            status_assigned: "Assigné",
            status_claimed: "Pris",
            status_renounced: "Renoncé",
            timing: "Dates et heure",
            assign: "Assigner à",
            claim: "Prendre",
            accept: "Accepter",
            refuse: "Refuser",
            renounce: "Renoncer",
            abilities: {
              tasks_abilities: "Droits liés aux tâches",
              assign: "Assigner",
              change_status: "Changer status",
              claim_for_others: "Prendre à la place de",
              renounce_for_others: "Renoncer à la place de",
              claim: "Prendre",
              renounce: "Renoncer"
            },
            renounce_modal: {
              title: "Message personnalisé"
            },
            filters: {
              group: "Grouper",
              group_by_days: "Par jour",
              group_by_screenings: "Par séance",
              group_by_shifts: "Par shift",
              group_by_sectors: "Par secteur",
              view_mode: "Vue",
              view_mode_details: "Détaillée",
              view_mode_resume: "Résumée"
            },
            admins: "Resp. :",
            copy_to_clipboard: "Copier dans le presse-papiers"
          },
          cashregisters: {
            informations: "Informations générales",
            add: "Ajouter une caisse",
            cashregister: "Caisse",
            cashregister_plural: "Caisses",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom",
            update_cashregister: "Modification de {{ name }}",
            confirm_delete: "Voulez-vous vraiment supprimer cette caisse ?",
            salepoint: "Point de vente",
            auto_closing: "Clôture automatique",
            auto_closing_enabled: "Activé",
            auto_closing_disabled: "Désactivé"
          },
          messages: {
            informations: "Informations générales",
            send: "Envoyer",
            send_message: "Envoyer un message",
            message_placeholder: "Veuillez saisir un message",
            recipients: "Destinataires",
            recipients_question: "À qui souhaitez-vous envoyer un message ?",
            recipients_desc: "Vous vous apprêtez à envoyer un e-mail à {{ nb }} destinataire(s)",
            show_recipients: "Afficher les destinataires",
            hide_recipients: "Masquer les destinataires",
            users: "Collaborateurs",
            users_placeholder: "Vous pouvez choisir un ou plusieurs collaborateurs",
            activities: "Compétences",
            activities_placeholder: "Vous pouvez choisir une ou plusieurs compétences",
            message: "Message",
            message_desc: "Quel message souhaitez-vous envoyer ?",
            layout_message: "Choisissez un e-mail pré-défini",
            layout_message_placeholder: "Vous pouvez choisir un e-mail existant",
            subject: "Objet de votre message",
            subject_placeholder: "Saisissez l'objet de votre message",
            custom_message: "Ajouter un message personnalisé"
          },
          sections: {
            informations: "Informations générales",
            add: "Ajouter une section",
            section_plural: "Sections",
            name: "Nom",
            name_placeholder: "Veuillez saisir un nom"
          },
          definition: {
            name: "Le nom du type de ticket dans chacune des langues activées, ce nom apparaîtra sur l'interface du point de vente et/ou votre site Web ou celui de la billetterie.",
            tkt_id: "Il s'agit d'un identifiant interne de ce type d'abonnement, il sera saisi par l'équipe de Ticketack et vous n'avez pas besoin de vous en soucier.",
            description: "La description du type de ticket, dans chacune des langues activées, pourra être présentée aux clients qui font leur achat en ligne. Il est également possible de reprendre cette description dans le modèle PDF du ticket.",
            eligibility: "Indiquez ici une phrase courte à destination du personnel qui scanne les billets aux entrées uniquement pour les tarifs qui nécessitent une pièce de légitimation (carte d'étudiant par exemple).",
            price: "Le prix est le montant demandé à l'acheteur.",
            value: "La valeur est la valeur comptable de ce tarif du point de vue de la billetterie. En général la valeur est égale au prix. Si vous touchez de l'argent d'un tiers en plus du prix lorsque vous vendez ce tarif (subvention par exemple) ; dans ce cas indiquez une valeur égale au prix + la subvention touchée, le système calculera alors automatiquement les montants à réclamer. Au contraire, si vous devez reverser une partie du prix à un tiers (commission auprès d'un tiers par exemple), indiquez une valeur plus faible que le prix. Finalement si le tarif représente un billet payé à l'avance à l'aide d'un autre système – ou au contraire qui sera payé plus tard, par exemple sur facture - indiquez alors un prix de 0 et une valeur correspondant au montant encaissé sur l'autre système.",
            value_per_screening: "Dans le cas d'abonnement ou d'autres types de ticket pour plusieurs événements, vous pouvez ventiler ici la valeur à assigner par événement. Par exemple dans le cas d'une carte 10 entrées à 100 CHF, vous pourriez décider d'assigner 10 CHF à chaque réservation.",
            wallet_amount: "Ce montant sera automatiquement crédité sur le porte-monnaie des billets.",
            category: "Dans le cas de places numérotées, la catégorie d'un tarif doit correspondre à la catégorie des sièges pour lesquels ce tarif est disponible",
            order: "Entier qui défini l'ordre du tarif, plus l'entier est grand plus le tarif apparaîtra « en dernier ».",
            css_class: "Permet de spécifier une classe CSS afin de donner un style visuel particulier à un tarif au moyen de votre feuille de style personnalisée (ce style peut être différent sur le point de vente, le eshop ou l'application mobile).",
            valid_from: "Date de début de validité du tarif.",
            valid_to: "Date de fin de validité du tarif.",
            role: "Indiquez ici une liste de rôles utilisateurs qui ont le droit de vendre des billets à ce tarif.Les rôles disponibles par défaut sont les suivants : ADMIN : l'ensemble des administrateurs ESHOP : votre site Web, celui de la billetterie et l'application mobile si disponibles. ON-SITE : vos collaborateurs aux points de vente lors de l'événement. PARTNER : des partenaires externes (office du tourisme, magasins partenaires, etc.). ACCRED : l'ensemble des utilisateurs qui disposent de ce rôle (en général le bureau desaccréditations). Note : si aucun rôle n'est sélectionné, le tarif sera désactivé. Note : pour sélectionner plusieurs rôles, maintenez la touche Ctrl enfoncée.",
            pricing_limit: "Vous avez ici la possibilité de faire apparaître ce tarif uniquement pour les personnes qui sont connectées avec un type de ticket (abonnement, accréditation, etc.) spécifique.",
            pricing_forbiden: "Vous pouvez ici définir que si une personne est connectée avec un type spécifique de ticket, elle ne doit pas voir ce tarif.",
            screening_id: "Un identifiant de séance Ticketack (ce champ sera en général vide car l'éligibilité d'un type de ticket pour une séance est en général gérée avec les contingents.",
            duration: "Une durée au format ISO 8601, par exemple P1Y signifie que cette règle est valable pendant un an à partir de la date de création.",
            reservation_number: "Correspond au nombre de séances maximum que l'acheteur pourra réserver pour cette règle.",
            same_screening: "Permet d'indiquer le nombre de fois qu'on peut réserver pour la même séance dans le cadre de cette règle.",
            overlap: "Vous pouvez définir ici s'il est possible de réserver deux événements qui se chevauchent ou qui sont proches l'un de l'autre. Le système permet d'interdire par exemple la réservation de deux séances qui se chevauchent partiellement ou d'interdire de réserver une séance qui commence moins d'un certain nombre de minutes après la fin d'une autre séance. Le chevauchement est défini au format ISO 8601, par exemple PT0M signifie que la fin d'une séance ne peut pas du tout se chevaucher avec le début d'une autre au sein de cette règle. Si vous laissez le champ vide alors il sera possible de réserver plusieurs séances qui se chevauchent si le reste de la définition de la règle le permet. Si vous indiquez PT10M alors le début d'une séance doit avoir lieu au minimum 10 minutes après la fin d'une autre séance réservée au sein de cette règle. Finalement si vous indiquez -PT15M, alors il est autorisé de réserver une séance qui commence jusqu'à 15 minutes avant la fin de la séance précédemment réservée au sein de cette règle.",
            same_day: "Si vous cochez cette case, toutes les réservations de l'abonnement doivent être pour des événements ayant lieu le même jour. Cette option estessentiellement utilisée pour des cartes journalières sans date fixe. Attention : si vous avez des événements après minuit, cette option peut avoir un comportement indésirable, veuillez nous contacter pour établir la meilleure marche à suivre dans ce cas.",
            field: "Indiquez ici une liste de rôles utilisateurs qui ont le droit d'accéder à ce contingent. Les rôles disponibles par défaut sont les suivants : admin : l'ensemble des administrateurs. eshop : Votre site Web, celui de la billetterie et l'application mobile si disponibles on-site : Vos collaborateurs aux points de vente lors de l'événement. partner : Des partenaires externes (office du tourisme, magasins partenaires, etc.). accred : L'ensemble des utilisateurs qui disposent de ce rôle (en général le bureau des accréditations).",
            "bucket.total_capacity": "Indiquez ici la capacité total de ce contingent. Vous pouvez saisir un nombre fixe ou une expression arithmétique en utilisant les variables total_capacity, prm_capacity et/ou remainder. Ex: total_capacity*0.9",
            "bucket.may_steal_from": 'Choisissez les contingents dans lesquels celui-ci peut "voler"',
            "bucket.not_before": "Indiquez ici la date de début de validité de ce contingent. Vous pouvez saisir une date fixe au format iso 8601 (par ex. 2024-11-25T16:41:00) ou une expression de la forme start_at+D3@06:00 pour indiquer le mercredi (3ème jour de la semaine) suivant la date de début, à 6h du matin. Ou encore stop_at-PT25M, pour indiquer 25 minutes avant la date de fin. Ou encore start_at ou stop_at pour les dates de début ou de fin.",
            "bucket.not_after": "Indiquez ici la date de fin de validité de ce contingent. Vous pouvez saisir une date fixe au format iso 8601 (par ex. 2024-11-25T16:41:00) ou une expression de la forme start_at+D3@06:00 pour indiquer le mercredi (3ème jour de la semaine) suivant la date de début, à 6h du matin. Ou encore stop_at-PT25M, pour indiquer 25 minutes avant la date de fin. Ou encore start_at ou stop_at pour les dates de début ou de fin.",
            "bucket.only_for_roles": "Indiquez ici une liste de rôles utilisateurs qui ont le droit d'utiliser ce contingent. Les rôles disponibles par défaut sont les suivants : ADMIN : l'ensemble des administrateurs ESHOP : votre site Web, celui de la billetterie et l'application mobile si disponibles. ON-SITE : vos collaborateurs aux points de vente lors de l'événement. PARTNER : des partenaires externes (office du tourisme, magasins partenaires, etc.). ACCRED : l'ensemble des utilisateurs qui disposent de ce rôle (en général le bureau desaccréditations). Note : si aucun rôle n'est sélectionné, le tarif sera désactivé. Note : pour sélectionner plusieurs rôles, maintenez la touche Ctrl enfoncée.",
            "bucket.only_for_tickettypes": "Indiquez ici une liste de types de billets avec lesquels il est permis d'utiliser ce contingent."
          },
          tags: {
            add_the_tag: "Ajouter le tag"
          },
          layouts: {
            add_from_template: "Ajouter à partir d'un modèle",
            templates: {
              empty: "Modèle vide",
              empty_desc: "Modèle ne contenant que le logo et un widget de type texte",
              order_confirmation: "Confirmation de commande",
              order_confirmation_desc: "Modèle complet à utiliser pour les confirmations de commande"
            },
            x: "Position sur l'axe horizontal",
            y: "Position sur l'axe vertical",
            please_choose_a_layout: "Veuillez choisir un modèle",
            no_options: "Ce widget n'a pas d'option",
            width: "Largeur",
            height: "Hauteur",
            rotation: "Rotation",
            padding: "Marges intérieures",
            font_family: "Police",
            font_family_placeholder: "Veuillez choisir une police",
            font_family_variant: "Variante",
            font_family_variant_placeholder: "Veuillez choisir une variante",
            font_family_variant_bold: "Gras",
            font_family_variant_italic: "Italique",
            font_family_variant_boldItalic: "Gras et italique",
            font_size: "Taille de la police",
            line_height: "Hauteur de ligne",
            object_fit: "Redimensionnement",
            object_fit_placeholder: "Veuillez choisir un mode de redimensionnement",
            object_fit_none: "Dimensions du parent",
            object_fit_fill: "Remplir le parent proportionnellement",
            object_fit_cover: "Couvrir le parent",
            object_fit_contain: "Contenu dans le parent",
            text: "Texte",
            color: "Couleur du texte",
            linksColor: "Couleur des liens",
            background_color: "Couleur de fond",
            add_new_layout: "Ajouter un modèle",
            lockRatio: "Conserver les proportions",
            reset_image: "Réinitialiser l'image",
            layouts: "Modèles",
            update_layout: "Modification de {{ name }}",
            groups: {
              layout: "Options de ce modèle",
              widgets: "Widgets de ce modèle"
            },
            layout: {
              title: "Template",
              name: "Nom du modèle",
              name_placeholder: "Veuillez saisir un nom",
              subject: "Objet de l'e-mail",
              subject_placeholder: "Veuillez saisir un objet",
              dimensions: "Dimensions",
              type: "Type de PDF",
              target: "Destination",
              options: {
                bcc: "Envoyer en copie cachée à",
                bcc_placeholder: "Saisissez une adresse e-mail",
                replyTo: "Répondre à",
                replyTo_placeholder: "Saisissez une adresse e-mail"
              }
            },
            general_options: "Options de base",
            style_options: "Options de style",
            widgets_options: "Options des widgets",
            layout_options: "Options du modèle",
            duplicate_layout: "Dupliquer ce modèle",
            delete_layout: "Supprimer ce modèle",
            duplicate_widget: "Dupliquer ce widget",
            delete_widget: "Supprimer ce widget",
            apply_layout_style: "Enregistrer ce style",
            page: "Page",
            add_page: "Ajouter une page",
            show_on_page: "Afficher sur la page",
            on_all_pages: "Sur toutes les pages",
            on_odd_pages: "Sur les pages impaires",
            on_even_pages: "Sur les pages paires",
            type_ticket: "Ticket",
            "type_ticket-bookings": "Résumé de réservations",
            "type_cart-receipt": "Quittance",
            type_closing: "Clôture de caisse",
            type_bill: "Addition",
            type_order: "Préparation de commande",
            target_paper: "Impression sur imprimante standard",
            target_thermal: "Impression sur imprimante thermique",
            target_card: "Impression sur imprimante à carte",
            target_other: "Autre",
            on_pricing: "Pour le tarif {{pricing}}",
            on_any_pricing: "Pour tous les tarifs",
            on_other_pricings: "Pour tous les autres tarifs",
            add_pricing_emails: "Ajouter des e-mails pour ce tarif",
            hook_creation: "À la création",
            hook_activation: "À l'activation",
            hook_before_expiration: "Avant l'expiration",
            hook_expiration: "À l'expiration",
            hook_renewal: "Au renouvellement",
            hook_deletion: "À la suppression",
            page_options: "Options de la page",
            add_widget: "Ajouter un widget sur cette page",
            edit_widget: "Modifier ce widget",
            list_widget: "Liste des widgets sur cette page",
            text_widgets: "Textes",
            text_custom: "Texte personnalisé",
            text_owner_info: "Information du détenteur",
            text_screening_info: "Information de la séance",
            text_ticket_info: "Information du ticket",
            text_tickettype_info: "Information du type de ticket",
            text_customer_info: "Information de la billetterie",
            text_environment_info: "Environnement d'impression",
            text_link: "Lien",
            image_widgets: "Images",
            image_custom: "Image personnalisée",
            image_qrcode: "QRCode",
            image_library: "Image de la bibliothèque",
            image_owner_contact: "Photo du détenteur",
            shape_widgets: "Formes",
            shape_line: "Ligne",
            shape_frame: "Cadre",
            click_to_choose_image: "Cliquez pour choisir une image",
            new_widget: "Widget",
            move_backward: "À l'arrière plan",
            move_forward: "Au premier plan",
            layout_size: "Dimensions",
            field_to_show: "Champ à afficher",
            field_placeholder: "Veuillez choisir un champ",
            contact_field_title: "Salutation",
            contact_field_company: "Entreprise",
            contact_field_firstname: "Prénom",
            contact_field_lastname: "Nom",
            contact_field_fullname: "Nom complet",
            "contact_field_fullname-reversed": "Nom complet inversé",
            contact_field_email: "E-mail",
            contact_field_age: "Âge",
            contact_field_birthdate: "Date de naissance",
            contact_field_sex: "Genre",
            contact_field_phone: "Téléphone",
            contact_field_cellphone: "Téléphone mobile",
            contact_field_language: "Langue",
            "contact_field_address.street": "Rue",
            "contact_field_address.city": "Ville",
            "contact_field_address.zip": "Code postal",
            "contact_field_address.country": "Pays",
            screening_field_title: "Titre",
            screening_field_venue: "Établissement",
            screening_field_place: "Salle",
            screening_field_address: "Adresse",
            screening_field_zip: "Code postal",
            screening_field_city: "Ville",
            screening_field_state: "État",
            screening_field_country: "Pays",
            screening_field_start_at: "Date de début",
            screening_field_stop_at: "Date de fin",
            screening_field_start_at_stop_at: "Date de début - Date de fin",
            ticket_field_ticket_id: "TicketID",
            ticket_field_ticket_id_only: "TicketID (sans le titre)",
            ticket_field_ticket_id_festivalscope: "TicketID (format voucher FestivalScope)",
            ticket_field_uuid: "UUID",
            ticket_field_activated_at: "Date d'activation",
            ticket_field_activated_pricing_name: "Nom du tarif",
            ticket_field_activated_pricing_description: "Description du tarif",
            ticket_field_activated_pricing_price: "Prix",
            ticket_field_first_window: "Date de début de validité",
            ticket_field_last_window: "Date de fin de validité",
            ticket_field_first_window_last_window: "Date de début  - date de fin de validité",
            ticket_field_vat: "TVA",
            tickettype_field_name: "Nom",
            tickettype_field_description: "Description",
            environment_field_printer: "Nom de l'utilisateur courant",
            environment_field_salepoint: "Point de vente",
            environment_field_printed_at: "Date d'impression",
            customer_field_name: "Nom",
            customer_field_name_short: "Nom court",
            customer_field_phone: "Téléphone",
            customer_field_address: "Adresse",
            customer_field_email: "E-mail",
            customer_field_vat: "Numéro de TVA",
            text_alignment: "Alignement",
            text_alignment_placeholder: "Veullez choisir un alignement",
            text_alignment_left: "À gauche",
            text_alignment_center: "Centré",
            text_alignment_right: "À droite",
            text_alignment_justify: "Justifié",
            vat_format_placeholder: "Veuillez choisir un format",
            vat_format: "Format de TVA",
            vat_format_with_vat: "TVA 8.1%",
            vat_format_value_only: "8.1%",
            vat_format_full: "TVA {{ value }}%",
            date_format: "Format de date/heure",
            date_option: "Option de la date/heure",
            date_offset: "Décalage",
            date_format_placeholder: "Veuillez choisir un format",
            date_format_LT: "00:00",
            date_format_LTS: "00:00:00",
            date_format_L: "01/01/1970",
            date_format_l: "1/1/1970",
            date_format_LL: "1 janvier 1970",
            date_format_ll: "1 janv. 1970",
            date_format_LLL: "1 janvier 1970 00:00",
            date_format_lll: "1 janv. 1970 00:00",
            date_format_LLLL: "jeudi 1 janvier 1970 00:00",
            date_format_llll: "jeu. 1 janv. 1970 00:00",
            "date_format_dddd DD.MM": "jeudi 01.01",
            "date_format_dddd DD.MM.YYYY": "jeudi 01.01.1970",
            "date_format_dddd Do MMM": "jeudi 1er janv.",
            "date_format_dddd Do MMMM": "jeudi 1er janvier",
            "date_format_dddd Do MMM YYYY": "jeudi 1er janv. 1970",
            "date_format_dddd Do MMMM YYYY": "jeudi 1er janvier 1970",
            "date_format_ddd DD.MM": "jeu. 01.01",
            "date_format_ddd DD.MM.YYYY": "jeu. 01.01.1970",
            "date_format_ddd Do MMM": "jeu. 1er janv.",
            "date_format_ddd Do MMMM": "jeu. 1er janvier",
            "date_format_ddd Do MMM YYYY": "jeu. 1er janv. 1970",
            "date_format_ddd Do MMMM YYYY": "jeu. 1er janvier 1970",
            date_format_midnight_hack: "01/01/1970 à minuit et demi",
            midnight: "à minuit",
            midnight15: "à minuit et quart",
            midnight30: "à minuit et demi",
            border_color: "Couleur de la bordure",
            border_width: "Largeur de la bordure",
            border_radius: "Arrondir les coins",
            border_style: "Style de bordure",
            border_style_placeholder: "Veuillez choisir un style de bordure",
            border_style_solid: "Plein",
            border_style_dashed: "Tirets",
            text_decoration: "Décoration du texte",
            text_decoration_placeholder: "Veuillez choisir une décoration",
            text_decoration_none: "Aucune",
            text_decoration_underline: "Souligné",
            "text_decoration_line-through": "Barré",
            text_transform: "Transformation du texte",
            text_transform_placeholder: "Veuillez choisir une transformation",
            text_transform_none: "Aucune",
            text_transform_capitalize: "Majuscule À Chaque Mot",
            text_transform_uppercase: "MAJUSCULES",
            text_transform_lowercase: "minuscules",
            link: "Lien",
            image_type: "Type d'image",
            image_type_placeholder: "Veuillez choisir un type d'image",
            widget_options: {
              groups: {
                options: "Options",
                position: "Placement",
                style: "Style"
              }
            },
            send_test_email: "Envoyer un e-mail de test",
            subject: "Sujet",
            lang: "Langue",
            recipient: "Destinataire",
            recipient_name: "Nom",
            recipient_name_placeholder: "John Doe",
            recipient_address: "Adresse",
            recipient_address_placeholder: "john.doe@ticketack.com",
            context: "Contexte",
            context_ticket_id: "Billet",
            context_ticket_id_placeholder: "Entrez un identifiant de billet",
            context_tickettype_id: "Type de billet",
            context_tickettype_id_placeholder: "Choisissez un type de billet",
            context_screening_id: "Séance",
            context_screening_id_placeholder: "Entrez un identifiant de séance",
            context_place_id: "Salle",
            context_place_id_placeholder: "Choisissez une salle",
            email_successfully_sent: "L'e-mail a été envoyé avec succès",
            email_was_catched: "Enfin… il l'aurait été si cette billetterie était exécutée en mode production",
            click_on_preview_link: "Cliquez ici pour voir l'e-mail envoyé",
            shortcodes: {
              button: "Champs dyn.",
              "application._id": "[Ticket] Identifiant du ticket",
              "ticket.contact.firstname": "[Ticket] Prénom du détenteur",
              "ticket.contact.lastname": "[Ticket] Nom du détenteur",
              "ticket.contact.title": "[Ticket] Titre du détenteur",
              "ticket._id": "[Ticket] Identifiant du ticket",
              "ticket.activated_pricing.name.fr": "[Ticket] Nom du tarif (fr)",
              "ticket.activated_pricing.name.en": "[Ticket] Nom du tarif (en)",
              "ticket.activated_pricing.name.de": "[Ticket] Nom du tarif (de)",
              "ticket.activated_pricing.description.fr": "[Ticket] Description du tarif (fr)",
              "ticket.activated_pricing.description.en": "[Ticket] Description du tarif (en)",
              "ticket.activated_pricing.description.de": "[Ticket] Description du tarif (de)",
              "ticket.view_link.fr": "[Ticket] Lien de visualisation (fr)",
              "ticket.view_link.en": "[Ticket] Lien de visualisation (en)",
              "ticket.view_link.de": "[Ticket] Lien de visualisation (de)",
              "ticket.download_link.fr": "[Ticket] Lien de téléchargement (fr)",
              "ticket.download_link.en": "[Ticket] Lien de téléchargement (en)",
              "ticket.download_link.de": "[Ticket] Lien de téléchargement (de)",
              ticketID: "[Ticket] TicketID",
              "tickettype.description.fr": "[Type de billet] Description (fr)",
              "tickettype.description.en": "[Type de billet] Description (en)",
              "tickettype.description.de": "[Type de billet] Description (de)",
              "screening._id": "[Séance] Identifiant de la séance",
              "screening.title.fr": "[Séance] Titre (fr)",
              "screening.title.en": "[Séance] Titre (en)",
              "screening.title.de": "[Séance] Titre (de)",
              "place._id": "[Salle] Identifiant de la salle",
              "place.cinema": "[Salle] Établissement de la salle",
              "place.number": "[Salle] Numéro de la salle",
              "place.name": "[Salle] Nom de la salle",
              "place.address": "[Salle] Adresse de la salle",
              "place.zip": "[Salle] Code postal de la salle",
              "place.city": "[Salle] Ville de la salle",
              "place.country": "[Salle] Pays de la salle",
              "user.id": "[Collaborateur] Identifiant du collaborateur",
              "user.firstname": "[Collaborateur] Prénom du collaborateur",
              "user.lastname": "[Collaborateur] Nom du collaborateur",
              "user.email": "[Collaborateur] E-mail du collaborateur",
              "application.id": "[Candidature] Identitifant de la candidature",
              "application.user.id": "[Candidature] Identitifant du bénévole",
              "application.user.firstname": "[Candidature] Prénom du bénévole",
              "application.user.lastname": "[Candidature] Nom du bénévole",
              "application.user.email": "[Candidature] E-mail du bénévole",
              "customer.id": "[Client] Identifiant du client",
              "customer.firstname": "[Client] Prénom du client",
              "customer.lastname": "[Client] Nom du client",
              "customer.email": "[Client] E-mail du client",
              "order.id": "[Commande] Numéro",
              "order.parts.subject": "[Commande] Titre",
              "order.parts.heading": "[Commande] Sous-titre",
              "order.parts.content": "[Commande] Contenu",
              "order.parts.payment": "[Commande] Informations de paiement",
              "custom.text.fr": "[Personnalisable] Texte personnalisable (fr)",
              "custom.text.en": "[Personnalisable] Texte personnalisable (en)",
              "custom.text.de": "[Personnalisable] Texte personnalisable (de)"
            }
          },
          forms: {
            please_choose_a_layout: "Veuillez choisir un formulaire",
            no_options: "Ce widget n'a pas d'option",
            text: "Texte simple",
            longtext: "Texte long",
            richtext: "Texte riche",
            phone: "Numéro de téléphone",
            password: "Mot de passe",
            number: "Nombre",
            datetime: "Date",
            boolean: "Oui/ Non",
            list: "Liste",
            file: "Fichier",
            image: "Image",
            add_new_layout: "Ajouter un formulaire",
            forms: "Formulaires",
            form: {
              title: "Template",
              name: "Nom du formulaire",
              name_placeholder: "Veuillez saisir un nom"
            },
            type_application: "Candidature de bénévole",
            type_other: "Autre",
            add_new_form: "Ajouter un formulaire",
            add_field: "Ajouter un champ",
            edit_field: "Modifier ce champ",
            list_field: "Liste des champs dans le formulaire",
            label: "Label",
            label_description: "Il s'agit du nom de champ affiché.",
            name: "Nom",
            name_description: "Il s'agit du nom de la propriété qui sera stockée en base de données.",
            width: "Largeur",
            width_description: "Largeur de ce champ comparée à la largeur de la ligne.",
            required: "Obligatoire",
            min: "Valeur minimum",
            max: "Valeur maximum",
            step: "Pas (step)",
            with_time: "Inclure l'heure",
            extensions: "Fichiers autorisés",
            choices: "Propositions",
            expanded: "Boutons radio / cases à cocher",
            multiple: "Choix multiple"
          },
          applications: {
            applications_plural: "Candidatures",
            public_form: "Formulaire public",
            add: "Ajouter une candidature",
            confirm_delete: "Voulez-vous vraiment supprimer cette candidature ?",
            successfully_submitted: "Votre candidature a bien été transmise",
            please_choose_sector: "Veuillez choisr au moins un secteur",
            please_set_availabilities: "Veuillez saisir au moins une période de disponibilité",
            fullname: "Nom complet",
            status: "Statut",
            created_at: "Date de soumission",
            max_nb_hours: "Nb. max d'heures",
            max_nb_hours_header: "Disponibilité totale / par jour",
            max_nb_hours_per_day: "Nb. max d'heures par jour",
            nb_hours: "Nb. d'heures assignées",
            busy_rate: "Taux d'occupation",
            status_all: "Tous les statuts",
            status_submitted: "En attente",
            status_accepted: "Validée",
            status_rejected: "Refusée",
            accept_this_application: "Accepter cette candidature",
            reject_this_application: "Refuser cette candidature",
            sectors: "Secteurs souhaités",
            export: "Exporter les candidatures",
            filters: {
              search: "Recherche",
              search_placeholder: "Nom, prénom ou e-mail",
              status: "Statut",
              filter_on_shifts: "Filtrer sur les shifts",
              having_shift: "Qui ont au moins un shift assigné",
              having_no_shift: "Qui n'ont aucun shift assigné",
              filter_on_sectors: "Filtrer sur les secteurs",
              desired_sectors: "Qui ont demandé un de ces secteurs",
              shifts_in_sectors: "Qui ont au moins un shift dans un de ces secteurs"
            }
          },
          settings: {
            setting: "Paramètres",
            choose_a_field: "Veuillez choisir une catégorie",
            override_selected_fields: "Remplacer le paramètre général",
            choose_a_setting_to_override: "Choisissez un paramètre à modifier",
            filter_by_category: "Catégories",
            update_setting: "Modification",
            hide_help: "Cacher les aides",
            show_help: "Montrer les aides",
            dark_theme: "Thème sombre",
            light_theme: "Thème clair",
            l10n: {
              title: "Localisation",
              currency: "Devise principale",
              extra_currencies: "Devises supplémentaires",
              add_extra_currency: "Ajouter une devise",
              default_timezone: "Timezone",
              charset: "Codage de caractères",
              locales: {
                title: "Langues",
                default: "Langue par défaut",
                all: "Langues disponibles",
                display: "Affichage des langues"
              },
              strftime_date_format: "Format de date",
              strftime_datetime_format: "Format de date et heure"
            },
            pdf: {
              title: "Modèles PDF",
              edit_mode: "Édition",
              preview_mode: {
                title: "Prévisualisation",
                data_test: "Simuler sur un",
                choose_movies_list: "Pour l'événement",
                choose_tickettypes_list: "Type de billet",
                choose_price: "Acheté au tarif"
              },
              layout_link: "Modèle utilisé par :"
            },
            pos: {
              title: "Vente sur place",
              automatic_printing: {
                title: "Impression automatique",
                tickets: "Tickets",
                tickets_receipts: "Reçus des tickets",
                bookings: "Réservations",
                articles_receipts: "Reçus des articles"
              },
              booking_cancelation_policy: "Politique d'annulation",
              booking_policy_allow_until: "Autoriser jusqu'à",
              booking_policy_question_positive: "avant le début de la séance",
              booking_policy_question_negative: "après le début de la séance",
              default_policy: "L'annulation est autorisée jusqu'au scan de la réservation",
              no_policy: "L'annulation n'est pas autorisée",
              custom_policy: "Politique d'annulation personnalisée",
              refund_policy: "Politique de remboursement (ne s'applique pas aux comptes administrateurs)",
              "refund_policy.never": "Jamais",
              "refund_policy.only_unclosed": "Uniquement si la caisse n'est pas clôturée",
              "refund_policy.always": "Toujours",
              payment: {
                title: "Paiement",
                methods: "Moyens de paiement",
                cash: {
                  title: "Paiement en espèces",
                  show_calculator: "Afficher la calculatrice"
                },
                sumup: {
                  title: "Paiement Sumup",
                  key: "Clé d'API Sumup"
                },
                twint: {
                  title: "Paiement Twint",
                  method: "Méthode"
                }
              },
              requested_buyer_data: "Données acheteur opt.",
              required_buyer_data: "Données acheteur obl.",
              screening_capacity_warning_level: "Alerte jauge",
              show_past_screenings_button: 'Afficher le bouton "Séances passées"',
              cancel_items: "Annuler les éléments du panier plutôt que les supprimer",
              show_print_addition_button: 'Afficher le bouton "Addition"',
              show_send_order_button: 'Afficher le bouton "Préparation"',
              additional_css: "URL du fichier CSS supplémentaire pour la vente sur place",
              additional_js: "URL du fichier JS supplémentaire pour la vente sur place",
              hide_screenings_started_since: "Cacher les séances qui ont commencé depuis plus de [minutes]"
            },
            eshop: {
              title: "Vente en ligne",
              uri: "URL du e-shop",
              booking_cancelation_policy: "Politique d'annulation",
              booking_expiration_duration: "Délai avant expiration des réservations",
              iframe_integration: "Intégration iframe",
              is_publicly_available: "Disponibilité publique",
              allow_search_engines: "Autoriser l'indexation par les moteurs de recherche",
              max_tickets_in_cart: "Nb. max. de tickets dans le panier",
              max_tickets_per_screening: "Nb. max. de tickets par séance",
              requested_buyer_data: "Données acheteur opt.",
              required_buyer_data: "Données acheteur obl.",
              enable_promo_code: "Permettre la saisie d'un code promo",
              show_available_seats_to_customers: "Afficher le nombre de sièges disponibles",
              emails: {
                title: "E-mails",
                order_confirmation: "Confirmation de commande"
              },
              url_overrides: {
                title: "Shop client",
                pass_url: "URL des pass",
                sanitary_measures_url: "URL des mesures sanitaires",
                data_protection_url: "URL de suppression de compte",
                screenings_url: "URL des séances",
                home_url: "URL de la homepage",
                terms_conditions_url: "URL des conditions générales",
                privacy_policy_url: "URL des règles de confidentialité",
                article_url: "URL des articles",
                ticket_url: "URL de la vue d'un ticket",
                ticket_url_tooltip: "__UUID__ sera remplacé par l'identifiant unique du ticket dans l'url fournie le cas échéant.",
                save_referer_for_host: "URL du referrer",
                default_url: "URL par défaut",
                no_url: "Pas d'URL",
                custom_url: "URL personnalisée"
              },
              donation: {
                title: "Don",
                modes: "Modes",
                article: "Article à utiliser comme don"
              },
              email: {
                title: "E-mails",
                from: "Envoyer depuis",
                activation_error_to: "Envoyer les erreurs d'activation à",
                bcc: "Envoyer en copie cachée à",
                "reply-to": "Répondre à",
                override_to: "Forcer l'envoi de tous les e-mails à"
              },
              newsletter_registration: {
                title: "Abonnement newsletter",
                modes: "Modes",
                auto_subscribe: "Abonnement automatique",
                url: "URL",
                email: "E-mail",
                callback: "Callback"
              },
              survey_registration: {
                title: "Sondage",
                modes: "Modes",
                auto_subscribe: "Abonnement automatique",
                url: "URL",
                email: "E-mail",
                callback: "Callback"
              },
              payment: {
                title: "Paiement",
                methods: "Moyens de paiement",
                proxypay: {
                  title: "Proxypay",
                  url: "URL",
                  api_key: "Clé d'API",
                  env: "Environnement",
                  sha_in: "SHA in",
                  sha_out: "SHA out",
                  gateway: "Passerelle",
                  seller: "Seller"
                }
              },
              registration: {
                title: "Inscription des utilisateurs",
                enabled: "Autorisée",
                salepoints: "Points de vente assignés à l'inscription"
              },
              additional_css: "URL du fichier CSS supplémentaire pour le e-shop",
              additional_js: "URL du fichier JS supplémentaire pour le e-shop"
            },
            payment: {
              title: "Paiement",
              methods: {
                title: "Moyens de paiement",
                onsite: "Moyens de paiement sur place",
                online: "Moyens de paiement en ligne"
              },
              method: {
                general_informations: "Informations de base",
                _id: "Identifiant",
                name: "Nom",
                name_placeholder: "Veuillez saisir un nom",
                enabled: "Activé",
                add: "Ajouter un moyen de paiement",
                confirm_delete: "Voulez-vous vraiment supprimer ce moyen de paiement ?",
                rules: "Frais de paiement",
                min_cart_amount: "Panier minimum",
                price: "Montant fixe",
                percentage: "Pourcentage",
                countries: "Pays",
                proxypay: {
                  url: "URL",
                  api_key: "API key",
                  env: "Environment",
                  sha_in: "SHA in",
                  sha_out: "SHA out",
                  seller: "Seller"
                },
                cash: {
                  show_calculator: "Afficher la calculatrice",
                  show_calculator_optional: "Optionnel",
                  show_calculator_always: "Toujours",
                  show_calculator_never: "Jamais"
                },
                sumup: {
                  key: "Clé d'API Sumup"
                },
                twint: {
                  method: "Méthode"
                },
                add_rule: "Ajouter une règle",
                remove_this_rule: "Supprimer cette règle",
                new_method: "Nouveau moyen de paiement"
              }
            },
            delivery: {
              title: "Livraison",
              onsite: "Sur place",
              takeaway: "À emporter",
              pickup: "À récupérer sur place",
              shipment: "Livraison à domicile",
              virtual: "Virtuel",
              types: "Modes de livraison",
              type: {
                general_informations: "Informations de base",
                _id: "Identifiant",
                type: "Type de livraison",
                name: "Nom",
                name_placeholder: "Veuillez saisir un nom",
                add: "Ajouter un mode de livraison",
                confirm_delete: "Voulez-vous vraiment supprimer ce mode de livraison ?",
                rules: "Règles",
                min_cart_amount: "Panier minimum",
                max_weight: "Poids maximum",
                mini_max_weight: "P",
                max_width: "Largeur maximum",
                mini_max_width: "l",
                max_length: "Longueur maximum",
                mini_max_length: "L",
                max_height: "Hauteur maximum",
                max_length_width_height: "Largeur + Longueur + Hauteur maximum",
                mini_max_length_width_height: "L + l + H",
                mini_max_height: "H",
                price: "Prix",
                countries: "Pays",
                add_rule: "Ajouter une règle",
                remove_this_rule: "Supprimer cette règle",
                new_method: "Nouveau mode de livraison"
              }
            },
            mobile: {
              title: "Application mobile",
              sections: {
                title: "Sections",
                navigation: "Navigation",
                screens: "Écrans",
                theme: "Thème",
                features: "Fonctionnalités",
                config: "Configuration"
              },
              production_env: "Version de production",
              preprod_env: "Version de pré-production",
              testing_env: "Version de test",
              copy_production: "Copier la version de production",
              copy_preprod: "Copier la version de pré-production",
              copy_testing: "Copier la version de testing",
              to_testing: "vers le testing",
              to_preprod: "vers la pré-production",
              to_production: "vers la production",
              test_on_real_device: "Tester l'application",
              download_the_app: 'Installez (depuis votre store) et lancez l\'application "Ticketack Viewer".',
              launch_the_app: 'Lancez l\'application "Ticketack Viewer" sur votre téléphone',
              scan_this_qr_code: "Scannez le QR Code ci-dessous",
              first_configure_your_app: "Veuillez finir de configurer votre application (onglet Configuration)",
              how_to_reset_the_app: "Une fois que votre application est configurée sur votre téléphone, vous pouvez rester appuyé 3 secondes sur le logo en haut à gauche afin de la réinitialiser.",
              screens: {
                choose_a_screen: "Choisissez un écran",
                home: "Accueil",
                program: "Programme",
                news: "News",
                tickets: "Tickets",
                shop: "Shop",
                cart: "Panier",
                favorites: "Favoris",
                ratings: "Votes",
                widgets: "Widgets",
                widgets_desc: "Ajoutez des widgets à cet écran",
                add_widget: "Ajouter un widget",
                choose_a_widget: "Choisissez un widget à ajouter",
                edit_a_widget: "Modifiez les paramètres de ce widget",
                settings: {
                  title: "Configuration",
                  fixed_navigation: "Barre de navigation du haut transparente",
                  screen_background: "Type de fond d'écran",
                  background_image: "Image de fond",
                  background_color: "Couleur de fond",
                  allow_scroll: "Autoriser le défilement de l'écran",
                  news_post_category_id: "Catégorie racine des news",
                  shop_category_id: "Catégorie racine des articles"
                },
                widget: {
                  RichText: {
                    title: "Texte",
                    description: "Texte riche"
                  },
                  ProgramList: {
                    title: "Programme",
                    description: "Vue en liste du programme"
                  },
                  Shop: {
                    title: "Shop",
                    description: "Shop d'articles"
                  },
                  FeaturedMovie: {
                    title: "Film mis en avant",
                    description: "Mise en avant d'un film (grosse image cliquable)"
                  },
                  FeaturedScreening: {
                    title: "Séance mise en avant",
                    description: "Mise en avant d'une séance (grosse image cliquable)"
                  },
                  OnScreenMovies: {
                    title: "Films à l'affiche",
                    description: "Liste horizontale des films à l'affiche"
                  },
                  Section: {
                    title: "Section",
                    description: "Liste horizontale de films d'une section donnée"
                  },
                  Genre: {
                    title: "Genre",
                    description: "Liste horizontale de films d'un genre donnée"
                  },
                  Carousel: {
                    title: "Carousel",
                    description: "Carousel d'images pointant vers un article"
                  },
                  NewsList: {
                    title: "Liste d'articles",
                    description: "Liste verticale d'articles avec filtre de catégorie"
                  },
                  Discover: {
                    title: "Carousel vertical",
                    description: "Carousel d'images verticales pointant vers un article"
                  },
                  PostsGrid: {
                    title: "Grille d'articles",
                    description: "Grille d'images pointant vers un article"
                  },
                  settings: {
                    name: "Nom de ce widget (n'apparaît pas dans l'application)",
                    title: "Titre de ce widget à afficher dans l'application",
                    random_featured_movie: "Film aléatoire",
                    featured_movie_id: "Identifiant du film à mettre en avant",
                    featured_screening_id: "Identifiant de la séance à mettre en avant",
                    post_category_id: "Catégorie d'articles à utiliser",
                    section_id: "Identifiant de la section à afficher",
                    section_name: "Nom de la section à afficher",
                    nbDays: "Nombre de jours (1 pour aujourd'hui uniquement)",
                    hideMoviesTitles: "Masquer les titres de films",
                    show_only_future_screenings: "N'afficher que les séances futures",
                    nb_max_days: "Nombre maximum de jours à afficher",
                    display_mode: "Mode d'affichage",
                    renderer_landscape: "Mode paysage",
                    renderer_portrait: "Mode portrait",
                    image_width: "Largeur de l'image (proportion)",
                    image_height_ratio: "Rapport largeur / hauteur de l'image",
                    nb_columns: "Nombre de colonnes",
                    filter_on_places: "Filtrer sur les salles",
                    show_category_filter: "Afficher le filtre de catégories",
                    text_type: "Type de texte",
                    text_types: {
                      h1: "Grand titre",
                      h2: "Titre moyen",
                      h3: "Petit titre",
                      p: "Texte normal"
                    }
                  }
                }
              },
              navigation: {
                tabs: "Onglets de navigation",
                tabs_desc: "Définissez les onglets de navigation situés au bas de l'application.",
                add_tab: "Ajouter un onglet",
                choose_a_tab: "Choisissez un onglet à ajouter",
                active_tab: "Onglet par défaut",
                active_tab_desc: "Choisissez l'onglet actif lorsque l'application est lancée."
              },
              kronosUri: "URL de Kronos",
              kronosApiKey: "Clé d'API pour Kronos",
              salepointId: "Point de vente",
              disableUserAccount: "Désactiver les comptes utilisateur",
              disableVotes: "Désactiver les votes",
              disableFavorites: "Désactiver les favoris",
              apiKey: "Clé d'API pour l'engine (deprecated)",
              engineUri: "URL de l'engine (deprecated)",
              edition: "Édition",
              screeningsFilters: {
                title: "Filtres pour les séances",
                start_at_gte: "Débutent après"
              },
              homeDisplay: {
                title: "Écran d'accueil",
                showCarousel: "Afficher le carousel",
                showFeaturedMovie: "Afficher le film mis en avant",
                showDiscover: "Afficher le bloc Découvertes",
                showRestaurants: "Afficher les restaurants",
                showOnScreenMovies: "Afficher les films à l'affiche",
                showTodayMovies: "Afficher les films d'aujourd'hui",
                showSections: "Afficher les sections",
                showGenres: "Afficher les genres",
                showGoodDeals: "Afficher les Bons plans"
              },
              shop: {
                title: "Shop",
                rootCategoryId: "Catégorie racine"
              },
              posts: {
                title: "Posts",
                discover: "Découvrir",
                goodDeals: "Bons plans",
                pubs: {
                  title: "Pubs",
                  home: "Écran d'accueil",
                  shop: "Shop",
                  program: "Programme"
                },
                news: {
                  title: "News",
                  rootCategoryId: "Catégorie racine"
                }
              },
              featured: {
                title: "Contenu mis en avant",
                screening: "Séance mise en avant",
                movie: "Film mis en avant"
              },
              images: {
                title: "Images",
                format: "Format",
                nb_per_row: "Nombre d'images par ligne"
              },
              theme: {
                title: "Thème",
                logo: "Logo (svg)",
                splash: "Splash",
                background_image: "Image de fond",
                colors: {
                  title: "Couleurs",
                  background: "Couleur de fond",
                  primary: "Couleur principale",
                  "primary-inverse": "Couleur principale inverse",
                  nav: {
                    title: "Navigation",
                    background: "Couleur de fond",
                    border: "Couleur de la bordure",
                    activeColor: "Couleur de l'icône active",
                    inactiveColor: "Couleur des icônes inactives"
                  }
                },
                style: {
                  title: "Style général",
                  border_radius: "Bords arrondis"
                }
              }
            },
            customer: {
              title: "Vos informations",
              name: "Nom",
              name_short: "Nom court",
              phone: "Téléphone",
              mail: "E-mail",
              address: "Adresse",
              addr_line0: "Adresse - ligne 0",
              addr_line1: "Adresse - ligne 1",
              addr_line2: "Adresse - ligne 2",
              addr_line3: "Adresse - ligne 3",
              assets_path: "Dossier de customisation",
              vat: "Numéro de TVA",
              type: "Secteur d'activité",
              type_placeholder: "Veuillez choisir un secteur d'activité",
              types: {
                cinema: "Cinéma",
                cinemafestival: "Festival de cinéma",
                music: "Musique",
                musicfestival: "Festival de musique",
                theater: "Théâtre",
                recreationcenter: "Centre de loisirs",
                recreationparc: "Parc de loisirs",
                sport: "Club sportif",
                generic: "Autre"
              },
              informal: "Utiliser le language informel (tutoiement)",
              email: {
                title: "E-mails",
                mail: "E-mail de contact",
                from: "Envoyer depuis",
                errors_to: "Envoyer les erreurs d'activation à",
                bcc: "Envoyer en copie cachée à",
                "reply-to": "Répondre à",
                override_to: "Forcer l'envoi de tous les e-mails à"
              },
              tax: {
                title: "Taxes",
                vat_articles: "TVA par défaut des articles",
                vat_tickets: "TVA par défaut des tickets",
                suisa: "Taxe SUISA",
                local: "Impôt local"
              }
            },
            images: {
              title: "Images & logos"
            },
            integrations: {
              title: "Intégrations",
              list: "Liste des intégrations",
              add: "Ajouter une intégration",
              gtm: {
                title: "Google Tag Manager",
                id: "Identifiant de conteneur"
              },
              wp: {
                title: "WordPress",
                websites: "Site web",
                name: "Nom",
                uri: "URL",
                new_website_placeholder: "Nom de votre site wordpress",
                add_website: "Ajouter un site"
              },
              shift72: {
                title: "FestivalScope",
                api_key: "Clé d'API",
                endpoint: "URI"
              },
              pantaflix: {
                title: "Pantaflix",
                places_ids: "Salle(s)",
                provider: "Id de la billetterie chez Pantaflix",
                content_id_prefix: "Préfixe de l'id de contenu"
              },
              own_it: {
                title: "Own It",
                api_key: "Clé d'API",
                places_ids: "Salle(s)",
                test: "Mode test",
                codes_creation: {
                  title: "Création de codes",
                  product_id: "Id. de bundle",
                  tickettypes: "Types de billets",
                  valid_from: "Valide à partir de",
                  valid_until: "Valide jusqu'à"
                }
              },
              kronos: {
                title: "Kronos",
                api_key: "Clé d'API",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Import des séances",
                    enabled: "Activé",
                    delete_future: "Suppression des séances futures",
                    delete_existing: "Suppression avant mise à jour"
                  }
                }
              },
              como: {
                title: "Como",
                api_key: "Clé d'API",
                branch_id: "Id de filiale"
              },
              json: {
                title: "Source de données JSON",
                url: "URL",
                x_api_key: "Clé d'API (en-tête X-Api-KEY)",
                screenings_key: "Propriété d'accès aux screenings",
                places_key: "Propriété d'accès aux salles",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Import des séances",
                    enabled: "Activé",
                    delete_future: "Suppression des séances futures",
                    delete_existing: "Suppression avant mise à jour"
                  }
                }
              },
              eventival: {
                title: "Eventival",
                name: "Nom",
                year: "Année",
                api_key: "Clé d'API",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Import des séances",
                    enabled: "Activer l'import",
                    delete_future: "Suppression des séances futures",
                    delete_existing: "Suppression avant mise à jour",
                    fullfill_people: "Importer les people"
                  },
                  tickets: {
                    title: "Import des accréditations",
                    enabled: "Activer l'import"
                  }
                }
              },
              weserv: {
                title: "Proxy d'images Weserv",
                proxy_img_host: "Hôte du proxy"
              },
              fiona: {
                title: "Fiona",
                name: "Nom",
                edition_id: "Édition",
                api_key: "Clé d'API",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Import des séances",
                    enabled: "Activé",
                    delete_future: "Suppression des séances futures",
                    delete_existing: "Suppression avant mise à jour"
                  }
                }
              },
              cinech: {
                title: "Ciné.ch",
                url: "Url",
                cinema_ids: "Identifiants de cinémas",
                import: {
                  title: "Imports",
                  screenings: {
                    title: "Import des séances",
                    enabled: "Activé",
                    delete_future: "Suppression des séances futures",
                    delete_existing: "Suppression avant mise à jour"
                  }
                }
              },
              recaptcha: {
                title: "Google reCAPTCHA",
                public_key: "Clé du site",
                secret_key: "Clé secrète"
              },
              mailchimp: {
                title: "Mailchimp",
                newsletter: "Abonnement newsletter",
                survey: "Sondage",
                api_key: "Clé d'API",
                list_id: "Identifiant de la liste",
                merge_fields: {
                  title: "Champs à fusionner",
                  address: "Adresse",
                  zip: "Code postal",
                  city: "Ville",
                  country: "Pays",
                  language: "Langue"
                },
                interest: "Identifiant du centre d'intérêt",
                tags: "Tags"
              },
              maccsbox: {
                title: "Maccsbox",
                ftp: {
                  title: "Configuration FTP",
                  hostname: "Hôte",
                  username: "Login",
                  pasv: "PASV",
                  directory: "Dossier",
                  password: "Mot de passe"
                }
              }
            }
          },
          payment_methods: {
            cash: "Cash",
            cash_collector: "Monnayeur",
            ewallet: "Porte-monnaie électronique",
            sumup: "Sumup",
            other_eft: "TPE manuel",
            zvt_eft: "TPE",
            eft_receipt_printable_after_debit: "Proposer l'impression du billet après le paiement",
            closing_eft_mode: "Clôture automatique du TPE",
            mode_never: "Ne pas proposer et ne jamais clôturer",
            mode_yes: "Proposer en choisissant oui par défaut",
            mode_no: "Proposer et choisissant non par défaut",
            mode_always: "Ne pas proposer et toujours clôturer",
            twint: "Twint",
            pos_transfer: "Virement",
            free: "Gratuit",
            later: "Paiement sur place",
            proxypay: "Proxypay",
            eshop_transfer: "Virement"
          },
          user_data: {
            company: "Entreprise",
            title: "Salutation",
            firstname: "Prénom",
            lastname: "Nom",
            address: "Adresse",
            zip: "Code postal",
            city: "Ville",
            country: "Pays",
            age: "Âge",
            birthdate: "Date de naissance",
            sex: "Genre",
            phone: "Téléphone fixe",
            cellphone: "Téléphone portable",
            email: "E-mail",
            tab: "Numéro de table",
            comment: "Commentaires"
          },
          envs: {
            test: "Test",
            prod: "Production"
          },
          donation: {
            checkout: "Fin du processus de vente",
            header: "En-tête",
            footer: "Pied de page",
            email: "E-mail"
          },
          registration_callback: {
            email: "E-mail",
            callback: "Callback",
            url: "Url",
            mailchimp: "Mailchimp"
          },
          twint_methods: {
            sticker: "Autocollant",
            beacon: "Beacon"
          },
          locales: {
            fr_CH: "Français",
            en_GB: "Anglais",
            de_CH: "Allemand"
          },
          devices: {
            title: "Matériel",
            list: "Liste",
            map: "Arborescence"
          },
          collectors: {
            title: "Monnayeurs",
            manage: "Gérer",
            manage_title: "Gestion du monnayeur {{name}}",
            connection: "Connexion",
            connected: "Connecté",
            disconnected: "Déconnecté",
            status: "État",
            statuses: {
              idle: "En attente",
              draining: "Vidange en cours",
              filling: "Rechargement en cours",
              cancellation: "Annulation en cours",
              "treatment error": "Erreur de traitement",
              NU: "NU",
              autotest: "Autotest en cours",
              reset: "Remise à zéro du coffre en cours",
              exchange: "Change en cours",
              unload: "Délestage en cours",
              ticket: "Affichage du ticket",
              payment: "Paiement en cours"
            },
            acceptation: {
              opened: "Caisse ouverte",
              closed: "Caisse fermée"
            },
            in_recyclers: "Dans les recycleurs",
            in_cashbox: "Dans la cashbox",
            stats: "État des hoppers",
            moneyTypes: {
              5: "5 cts",
              10: "10 cts",
              20: "20 cts",
              50: "50 cts",
              100: "1 Fr",
              200: "2 Frs",
              500: "5 Frs",
              1e3: "10 Frs",
              2e3: "20 Frs",
              5e3: "50 Frs",
              1e4: "100 Frs"
            },
            coins: "Pièces",
            bills: "Billets",
            operations: "Opérations",
            lastEvents: "Derniers messages",
            lastTransactions: "Dernières transactions",
            collect: "Encaisser",
            collect_desc: "Encaissez de l'argent",
            refund: "Rembourser",
            refund_desc: "Remboursez de l'argent",
            debit_amount_label: "Montant",
            debit_amount_label_placeholder: "Saisissez le montant à encaisser",
            refund_amount_label: "Montant",
            refund_amount_label_placeholder: "Saisissez le montant à rembourser",
            change: "Faire du change",
            change_desc: "Échangez de l'argent",
            do_change: "Lancer le change",
            autotest: "Auto-test",
            autotest_desc: "Effectuez un auto-test",
            drain: "Vidange",
            drain_desc: "Récupérez de l'argent",
            reset_chest: "Remise à zéro",
            reset_chest_desc: "Effectuez une ràz de la cashbox",
            do_drain: "Lancer la vidange",
            unload: "Délestage",
            unload_desc: "Envoyez de l'argent dans la cashBox",
            do_unload: "Lancer le délestage",
            fillin: "Chargement",
            fillin_desc: "Ajoutez de l'argent",
            validate_fillin: "Validez le chargement",
            inserted: "Pièces insérées",
            in_the_recycler: "Dans le recycleur",
            in_the_cashbox: "Dans la cash box",
            modules: {
              title: "Modules",
              ACCEPTEUR_BILLET: "Accepteur billets",
              CASHBOX: "CashBox",
              DISTRIBUTEUR_BILLET1: "Distrib. billet 1",
              DISTRIBUTEUR_BILLET2: "Distrib. billet 2",
              DISTRIBUTEUR_BILLET3: "Distrib. billet 3",
              DISTRIBUTEUR_BILLET4: "Distrib. billet 4",
              ACCEPTEUR_PIECE: "Accepteur",
              REPARTITEUR: "Répartiteur",
              DISTRIBUTEUR_PIECE1: "Distrib. 5 Frs",
              DISTRIBUTEUR_PIECE2: "Distrib. 2 Frs",
              DISTRIBUTEUR_PIECE3: "Distrib. 1 Fr",
              DISTRIBUTEUR_PIECE4: "Distrib. 50 cts",
              DISTRIBUTEUR_PIECE5: "Distrib. 20 cts",
              DISTRIBUTEUR_PIECE6: "Distrib. 10 cts",
              DISTRIBUTEUR_PIECE7: "Distrib. 5 cts",
              ETAT_ALARME_BILLET: "Alarme billets",
              ETAT_ALARME_PIECE: "Alarme pièces",
              ETAT_CASHBOX: "État CashBox",
              PRES_BILSORTIE: "Pres. billets sortie",
              PRES_PIESORTIE: "Pres. pièces sortie"
            }
          },
          printers: {
            title: "Imprimantes",
            manage_title: "Gestion de l'imprimante {{name}}",
            manage: "Gérer",
            connection: "Connexion",
            connected: "Connectée",
            disconnected: "Déconnectée",
            infos: "Informations",
            id: "Identifiant",
            name: "Nom",
            host: "Hôte",
            status: "Statut",
            last_connexion: "Dernière connexion",
            options: "Options",
            open_cash_drawer: "Ouvrir le tiroir-caisse à chaque impression",
            only_for_pos: "Visible uniquement sur ces points de vente",
            ppd: "Mode d'impression",
            profiles: {
              1: "Imprimante à carte (type ZCxxx) en noir, recto uniquement",
              3: "Imprimante thermique (type ZDxx ou ZX) avec papier continu sans cutter",
              4: "Autre imprimante standard",
              6: "Autre imprimante thermique",
              10: "Imprimante thermique (type ZDxx ou ZX) avec papier à trou sans cutter",
              18: "Imprimante thermique (type ZDxx ou ZX) avec papier continu et cutter (découpe après chaque billet)",
              26: "Imprimante thermique (type ZDxx ou ZX) avec papier à trou et cutter (découpe après chaque billet)",
              50: "Imprimante thermique (type ZDxx ou ZX) avec papier continu et cutter (découpe à la fin de l'impression)",
              58: "Imprimante thermique (type ZDxx ou ZX) avec papier à trou et cutter (découpe à la fin de l'impression)",
              65: "Imprimante à carte (type ZCxxx) en couleur, recto uniquement",
              129: "Imprimante à carte (type ZCxxx) en noir, recto-verso",
              193: "Imprimante à carte (type ZCxxx) en couleur, recto-verso"
            },
            automatic_printing: "Imprimer automatiquement les articles de ces catégories"
          },
          efts: {
            title: "Terminaux de paiement",
            manage_title: "Gestion du terminal de paiement {{name}}",
            manage: "Gérer",
            connection: "Connexion",
            connected: "Connecté",
            disconnected: "Déconnecté",
            infos: "Informations",
            id: "Identifiant",
            name: "Nom",
            host: "Hôte",
            status: "Statut",
            last_connexion: "Dernière connexion",
            options: "Options",
            only_for_pos: "Visible uniquement sur ces points de vente",
            terminal_id: "Terminal ID Pixoo"
          },
          flash_info: {
            title: null,
            subtitle: null,
            content: null
          },
          logs: {
            source: {
              cinech: "Ciné.ch",
              eventival: "Eventival",
              json: "Source de données JSON",
              kronos: "Kronos",
              raw: "Fichier"
            }
          },
          models: {
            customer: {
              name: "Nom de la billetterie",
              name_short: "Nom court de la billetterie",
              address: "Adresse complète de la billetterie",
              phone: "+41 22 364 80 00",
              email: "info@netoxygen.ch",
              vat: "CHE-105.599.869"
            },
            pricing: {
              name: "Nom du tarif",
              description: "Description du tarif"
            },
            environment: {
              printer: "Nom du caissier",
              salepoint: "Nom du point de vente"
            },
            screening: {
              title: "Nom du film",
              venue: "Nom de l\\'établissement",
              place: "Nom de la salle",
              address: "Adresse de la salle",
              zip: "Zip",
              city: "Ville",
              state: "Canton",
              country: "Pays"
            },
            tickettype: {
              name: "Nom du type de billet",
              description: "Description du type de billet..."
            },
            owner_info: {
              title: "M.",
              company: "société",
              firstname: "Prénom",
              lastname: "Nom",
              fullname: "Prénom nom",
              fullname_reversed: "Nom prénom",
              email: "prénom.nom@ticketack.com",
              age: "42",
              sex: "M",
              phone: "0223648000",
              cellphone: "0791223344",
              language: "fr",
              address: {
                street: "Adresse",
                city: "Ville",
                zip: "zip",
                country: "Pays"
              }
            }
          }
        }];
        e.exports = t.length <= 1 ? t[0] : t;
      },
      1664: e => {
        "use strict";

        var t = Object.getOwnPropertySymbols,
          n = Object.prototype.hasOwnProperty,
          i = Object.prototype.propertyIsEnumerable;
        e.exports = function () {
          try {
            if (!Object.assign) return !1;
            var e = new String("abc");
            if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
            for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
            if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
              return t[e];
            }).join("")) return !1;
            var i = {};
            return "abcdefghijklmnopqrst".split("").forEach(function (e) {
              i[e] = e;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
          } catch (e) {
            return !1;
          }
        }() ? Object.assign : function (e, o) {
          for (var r, s, a = function (e) {
              if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(e);
            }(e), l = 1; l < arguments.length; l++) {
            for (var c in r = Object(arguments[l])) n.call(r, c) && (a[c] = r[c]);
            if (t) {
              s = t(r);
              for (var d = 0; d < s.length; d++) i.call(r, s[d]) && (a[s[d]] = r[s[d]]);
            }
          }
          return a;
        };
      },
      4403: (e, t, n) => {
        "use strict";

        var i = n(1664),
          o = "function" == typeof Symbol && Symbol.for,
          r = o ? Symbol.for("react.element") : 60103,
          s = o ? Symbol.for("react.portal") : 60106,
          a = o ? Symbol.for("react.fragment") : 60107,
          l = o ? Symbol.for("react.strict_mode") : 60108,
          c = o ? Symbol.for("react.profiler") : 60114,
          d = o ? Symbol.for("react.provider") : 60109,
          u = o ? Symbol.for("react.context") : 60110,
          h = o ? Symbol.for("react.forward_ref") : 60112,
          m = o ? Symbol.for("react.suspense") : 60113,
          p = o ? Symbol.for("react.memo") : 60115,
          g = o ? Symbol.for("react.lazy") : 60116,
          f = "function" == typeof Symbol && Symbol.iterator;
        function k(e) {
          for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
          return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var b = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {}
          },
          _ = {};
        function w(e, t, n) {
          this.props = e, this.context = t, this.refs = _, this.updater = n || b;
        }
        function A() {}
        function v(e, t, n) {
          this.props = e, this.context = t, this.refs = _, this.updater = n || b;
        }
        w.prototype.isReactComponent = {}, w.prototype.setState = function (e, t) {
          if ("object" != typeof e && "function" != typeof e && null != e) throw Error(k(85));
          this.updater.enqueueSetState(this, e, t, "setState");
        }, w.prototype.forceUpdate = function (e) {
          this.updater.enqueueForceUpdate(this, e, "forceUpdate");
        }, A.prototype = w.prototype;
        var C = v.prototype = new A();
        C.constructor = v, i(C, w.prototype), C.isPureReactComponent = !0;
        var y = {
            current: null
          },
          x = Object.prototype.hasOwnProperty,
          E = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };
        function S(e, t, n) {
          var i,
            o = {},
            s = null,
            a = null;
          if (null != t) for (i in void 0 !== t.ref && t.ref, void 0 !== t.key && "" + t.key, t) x.call(t, i) && !E.hasOwnProperty(i) && (o[i] = t[i]);
          var l = arguments.length - 2;
          if (1 === l) o.children = n;else if (1 < l) {
            for (var c = Array(l), d = 0; d < l; d++) c[d] = arguments[d + 2];
            o.children = c;
          }
          if (e && e.defaultProps) for (i in e.defaultProps) void 0 === o[i] && (o[i] = l[i]);
          return {
            $$typeof: r,
            type: e,
            key: s,
            ref: a,
            props: o,
            _owner: y.current
          };
        }
        function D(e) {
          return "object" == typeof e && null !== e && e.$$typeof === r;
        }
        var T = /\/+/g,
          I = [];
        function B(e, t, n, i) {
          if (I.length) {
            var o = I.pop();
            return o.result = e, o.keyPrefix = t, o.func = n, o.context = i, o.count = 0, o;
          }
          return {
            result: e,
            keyPrefix: t,
            func: n,
            context: i,
            count: 0
          };
        }
        function M(e) {
          e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > I.length && I.push(e);
        }
        function P(e, t, n, i) {
          var o = typeof e;
          "undefined" !== o && "boolean" !== o || null;
          var a = !1;
          if (null === e) !0;else switch (o) {
            case "string":
            case "number":
              !0;
              break;
            case "object":
              switch (e.$$typeof) {
                case r:
                case s:
                  !0;
              }
          }
          if (a) return n(i, e, "" === t ? "." + N(e, 0) : t), 1;
          if (Array.isArray(e)) for (var l = 0; l < e.length; l++) {
            var c = t + N(e[l], l);
            P(o, c, n, i);
          } else if (null === e || "object" != typeof e ? null : "function" == typeof (f && e[f] || e["@@iterator"]) ? c : null, "function" == typeof c) for (c.call(e), 0; !e.next().done;) P(o.value, t + N(o, l++), n, i);else if ("object" === o) throw Error(k(31, "[object Object]" === n ? "object with keys {" + Object.keys(e).join(", ") + "}" : n, ""));
          return a;
        }
        function z(e, t, n) {
          return null == e ? 0 : P(e, "", t, n);
        }
        function N(e, t) {
          return "object" == typeof e && null !== e && null != e.key ? function (e) {
            var t = {
              "=": "=0",
              ":": "=2"
            };
            return "$" + ("" + e).replace(/[=:]/g, function (e) {
              return t[e];
            });
          }(e.key) : t.toString(36);
        }
        function L(e, t) {
          e.func.call(e.context, t, e.count++);
        }
        function R(e, t, n) {
          var i = e.result,
            o = e.keyPrefix;
          e.func.call(e.context, t, e.count++), Array.isArray(e) ? V(e, i, n, function (e) {
            return e;
          }) : null != e && (D(e) && function (e, t) {
            return {
              $$typeof: r,
              type: e.type,
              key: t,
              ref: e.ref,
              props: e.props,
              _owner: e._owner
            };
          }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(T, "$&/") + "/") + n), i.push(e));
        }
        function V(e, t, n, i, o) {
          var r = "";
          null != n && ("" + n).replace(T, "$&/") + "/", z(e, R, B(t, r, i, o)), M(t);
        }
        var O = {
          current: null
        };
        function F() {
          var e = O.current;
          if (null === e) throw Error(k(321));
          return e;
        }
        t.createContext = function (e, t) {
          return void 0 === t && (t = null), (e = {
            $$typeof: u,
            _calculateChangedBits: t,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null
          }).Provider = {
            $$typeof: d,
            _context: e
          }, e.Consumer = e;
        };
      },
      3696: (e, t, n) => {
        "use strict";

        e.exports = n(4403);
      }
    },
    i = {};
  function o(e) {
    var t = i[e];
    if (void 0 !== t) return t.exports;
    var r = i[e] = {
      id: e,
      exports: {}
    };
    return n[e](r, r.exports, o), r.exports;
  }
  o.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return o.d(t, {
      a: t
    }), t;
  }, t = Object.getPrototypeOf ? e => Object.getPrototypeOf(e) : e => e.__proto__, o.t = function (n, i) {
    if (1 & i && (n = this(n)), 8 & i) return n;
    if ("object" == typeof n && n) {
      if (4 & i && n.__esModule) return n;
      if (16 & i && "function" == typeof n.then) return n;
    }
    var r = Object.create(null);
    o.r(r);
    var s = {};
    e = e || [null, t({}), t([]), t(t)];
    for (var a = 2 & i && n; "object" == typeof a && !~e.indexOf(a); a = t(a)) Object.getOwnPropertyNames(a).forEach(e => s[e] = () => n[e]);
    return s.default = () => n, o.d(r, s), r;
  }, o.d = (e, t) => {
    for (var n in t) o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, o.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), o.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.nc = void 0;
  var r = {};
  return (() => {
    "use strict";

    let e;
    o.d(r, {
      default: () => qM
    });
    try {
      e = {
        window,
        document
      };
    } catch (t) {
      e = {
        window: {},
        document: {}
      };
    }
    const t = e;
    const n = function () {
        try {
          return navigator.userAgent.toLowerCase();
        } catch (e) {
          return "";
        }
      }(),
      i = {
        isMac: a(n),
        isWindows: function (e) {
          return e.indexOf("windows") > -1;
        }(n),
        isGecko: function (e) {
          return !!e.match(/gecko\/\d+/);
        }(n),
        isSafari: function (e) {
          return e.indexOf(" applewebkit/") > -1 && -1 === e.indexOf("chrome");
        }(n),
        isiOS: function (e) {
          return !!e.match(/iphone|ipad/i) || a(e) && navigator.maxTouchPoints > 0;
        }(n),
        isAndroid: function (e) {
          return e.indexOf("android") > -1;
        }(n),
        isBlink: function (e) {
          return e.indexOf("chrome/") > -1 && e.indexOf("edge/") < 0;
        }(n),
        get isMediaForcedColors() {
          return !!t.window.matchMedia && t.window.matchMedia("(forced-colors: active)").matches;
        },
        get isMotionReduced() {
          return !!t.window.matchMedia && t.window.matchMedia("(prefers-reduced-motion)").matches;
        },
        features: {
          isRegExpUnicodePropertySupported: function () {
            let e = !1;
            try {
              e = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
            } catch (e) {}
            return e;
          }()
        }
      },
      s = i;
    function a(e) {
      return e.indexOf("macintosh") > -1;
    }
    function l(e, t, n, i) {
      n = n || function (e, t) {
        return e === t;
      };
      const o = Array.isArray(e) ? e : Array.prototype.slice.call(e),
        r = Array.isArray(t) ? t : Array.prototype.slice.call(t),
        s = function (e, t, n) {
          const i = c(e, t, n);
          if (-1 === i) return {
            firstIndex: -1,
            lastIndexOld: -1,
            lastIndexNew: -1
          };
          const o = d(e, i),
            r = d(t, i),
            s = c(o, r, n),
            a = e.length - s,
            l = t.length - s;
          return {
            firstIndex: i,
            lastIndexOld: a,
            lastIndexNew: l
          };
        }(o, r, n),
        a = i ? function (e, t) {
          const {
            firstIndex: n,
            lastIndexOld: i,
            lastIndexNew: o
          } = e;
          if (-1 === n) return Array(t).fill("equal");
          let r = [];
          n > 0 && (r = r.concat(Array(n).fill("equal")));
          o - n > 0 && (r = r.concat(Array(o - n).fill("insert")));
          i - n > 0 && (r = r.concat(Array(i - n).fill("delete")));
          o < t && (r = r.concat(Array(t - o).fill("equal")));
          return r;
        }(s, r.length) : function (e, t) {
          const n = [],
            {
              firstIndex: i,
              lastIndexOld: o,
              lastIndexNew: r
            } = t;
          r - i > 0 && n.push({
            index: i,
            type: "insert",
            values: e.slice(i, r)
          });
          o - i > 0 && n.push({
            index: i + (r - i),
            type: "delete",
            howMany: o - i
          });
          return n;
        }(r, s);
      return a;
    }
    function c(e, t, n) {
      for (let i = 0; i < Math.max(e.length, t.length); i++) if (void 0 === e[i] || void 0 === t[i] || !n(e[i], t[i])) return i;
      return -1;
    }
    function d(e, t) {
      return e.slice(t).reverse();
    }
    function u(e, t, n) {
      n = n || function (e, t) {
        return e === t;
      };
      const i = e.length,
        o = t.length;
      if (i > 200 || o > 200 || i + o > 300) return u.fastDiff(e, t, n, !0);
      let r, s;
      if (o < i) {
        const n = e;
        e = t, t = n, r = "delete", s = "insert";
      } else r = "insert", s = "delete";
      const a = e.length,
        l = t.length,
        c = l - a,
        d = {},
        h = {};
      function m(i) {
        const o = (void 0 !== h[i - 1] ? h[i - 1] : -1) + 1,
          c = void 0 !== h[i + 1] ? h[i + 1] : -1,
          u = o > c ? -1 : 1;
        d[i + u] && (d[i] = d[i + u].slice(0)), d[i] || (d[i] = []), d[i].push(o > c ? r : s);
        let m = Math.max(o, c),
          p = m - i;
        for (; p < a && m < l && n(e[p], t[m]);) p++, m++, d[i].push("equal");
        return m;
      }
      let p,
        g = 0;
      do {
        for (p = -g; p < c; p++) h[p] = m(p);
        for (p = c + g; p > c; p--) h[p] = m(p);
        h[c] = m(c), g++;
      } while (h[c] !== l);
      return d[c].slice(1);
    }
    u.fastDiff = l;
    const h = function () {
      return function e() {
        e.called = !0;
      };
    };
    class m {
      constructor(e, t) {
        this.source = e, this.name = t, this.path = [], this.stop = h(), this.off = h();
      }
    }
    const p = new Array(256).fill("").map((e, t) => ("0" + t.toString(16)).slice(-2));
    function g() {
      const e = 4294967296 * Math.random() >>> 0,
        t = 4294967296 * Math.random() >>> 0,
        n = 4294967296 * Math.random() >>> 0,
        i = 4294967296 * Math.random() >>> 0;
      return "e" + p[255 & e] + p[e >> 8 & 255] + p[e >> 16 & 255] + p[e >> 24 & 255] + p[255 & t] + p[t >> 8 & 255] + p[t >> 16 & 255] + p[t >> 24 & 255] + p[255 & n] + p[n >> 8 & 255] + p[n >> 16 & 255] + p[n >> 24 & 255] + p[255 & i] + p[i >> 8 & 255] + p[i >> 16 & 255] + p[i >> 24 & 255];
    }
    const f = {
      get() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "normal";
        return "number" != typeof e ? this[e] || this.normal : e;
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    };
    function k(e, t) {
      const n = f.get(t.priority);
      for (let i = 0; i < e.length; i++) if (f.get(e[i].priority) < n) return void e.splice(i, 0, t);
      e.push(t);
    }
    const b = "https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html";
    class _ extends Error {
      constructor(e, t, n) {
        super(function (e, t) {
          const n = new WeakSet(),
            i = (e, t) => {
              if ("object" == typeof t && null !== t) {
                if (n.has(t)) return "[object ".concat(t.constructor.name, "]");
                n.add(t);
              }
              return t;
            },
            o = t ? " ".concat(JSON.stringify(t, i)) : "",
            r = A(e);
          return e + o + r;
        }(e, n)), this.name = "CKEditorError", this.context = t, this.data = n;
      }
      is(e) {
        return "CKEditorError" === e;
      }
      static rethrowUnexpectedError(e, t) {
        if (e.is && e.is("CKEditorError")) throw e;
        const n = new _(e.message, t);
        throw n.stack = e.stack, n;
      }
    }
    function w(e, t) {
      console.warn(...v(e, t));
    }
    function A(e) {
      return "\nRead more: ".concat(b, "#error-").concat(e);
    }
    function v(e, t) {
      const n = A(e);
      return t ? [e, t, n] : [e, n];
    }
    const C = "41.4.2",
      y = new Date(2024, 4, 17);
    if (globalThis.CKEDITOR_VERSION) throw new _("ckeditor-duplicated-modules", null);
    globalThis.CKEDITOR_VERSION = C;
    const x = Symbol("listeningTo"),
      E = Symbol("emitterId"),
      S = Symbol("delegations"),
      D = T(Object);
    function T(e) {
      if (!e) return D;
      return class extends e {
        on(e, t, n) {
          this.listenTo(this, e, t, n);
        }
        once(e, t, n) {
          var _this = this;
          let i = !1;
          this.listenTo(this, e, function (e) {
            for (var _len3 = arguments.length, n = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              n[_key3 - 1] = arguments[_key3];
            }
            i || (i = !0, e.off(), t.call(_this, e, ...n));
          }, n);
        }
        off(e, t) {
          this.stopListening(this, e, t);
        }
        listenTo(e, t, n) {
          let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          let o, r;
          this[x] || (this[x] = {});
          const s = this[x];
          B(e) || I(e);
          const a = B(e);
          (o = s[a]) || (o = s[a] = {
            emitter: e,
            callbacks: {}
          }), (r = o.callbacks[t]) || (r = o.callbacks[t] = []), r.push(n), function (e, t, n, i, o) {
            t._addEventListener ? t._addEventListener(n, i, o) : e._addEventListener.call(t, n, i, o);
          }(this, e, t, n, i);
        }
        stopListening(e, t, n) {
          const i = this[x];
          let o = e && B(e);
          const r = i && o ? i[o] : void 0,
            s = r && t ? r.callbacks[t] : void 0;
          if (!(!i || e && !r || t && !s)) if (n) {
            L(this, e, t, n);
            -1 !== s.indexOf(n) && (1 === s.length ? delete r.callbacks[t] : L(this, e, t, n));
          } else if (s) {
            for (; n = s.pop();) L(this, e, t, n);
            delete r.callbacks[t];
          } else if (r) {
            for (t in r.callbacks) this.stopListening(e, t);
            delete i[o];
          } else {
            for (o in i) this.stopListening(i[o].emitter);
            delete this[x];
          }
        }
        fire(e) {
          try {
            const n = e instanceof m ? e : new m(this, e),
              i = n.name;
            let o = z(this, i);
            for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              t[_key4 - 1] = arguments[_key4];
            }
            if (n.path.push(this), o) {
              const e = [n, ...t];
              o = Array.from(o);
              for (let t = 0; t < o.length && (o[t].callback.apply(this, e), n.off.called && (delete n.off.called, this._removeEventListener(i, o[t].callback)), !n.stop.called); t++);
            }
            const r = this[S];
            if (r) {
              const e = r.get(i),
                o = r.get("*");
              e && N(e, n, t), o && N(o, n, t);
            }
            return n.return;
          } catch (e) {
            _.rethrowUnexpectedError(e, this);
          }
        }
        delegate() {
          for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            e[_key5] = arguments[_key5];
          }
          return {
            to: (t, n) => {
              this[S] || (this[S] = new Map()), e.forEach(e => {
                const i = this[S].get(e);
                i ? i.set(t, n) : this[S].set(e, new Map([[t, n]]));
              });
            }
          };
        }
        stopDelegating(e, t) {
          if (this[S]) if (e) {
            if (t) {
              const n = this[S].get(e);
              n && n.delete(t);
            } else this[S].delete(e);
          } else this[S].clear();
        }
        _addEventListener(e, t, n) {
          !function (e, t) {
            const n = M(e);
            if (n[t]) return;
            let i = t,
              o = null;
            const r = [];
            for (; "" !== i && !n[i];) n[i] = {
              callbacks: [],
              childEvents: []
            }, r.push(n[i]), o && n[i].childEvents.push(o), o = i, i = i.substr(0, i.lastIndexOf(":"));
            if ("" !== i) {
              for (const e of r) e.callbacks = n[i].callbacks.slice();
              n[i].childEvents.push(o);
            }
          }(this, e);
          const i = P(this, e),
            o = {
              callback: t,
              priority: f.get(n.priority)
            };
          for (const e of i) k(e, o);
        }
        _removeEventListener(e, t) {
          const n = P(this, e);
          for (const e of n) for (let n = 0; n < e.length; n++) e[n].callback == t && (e.splice(n, 1), n--);
        }
      };
    }
    function I(e, t) {
      e[E] || (e[E] = t || g());
    }
    function B(e) {
      return e[E];
    }
    function M(e) {
      return e._events || Object.defineProperty(e, "_events", {
        value: {}
      }), e._events;
    }
    function P(e, t) {
      const n = M(e)[t];
      if (!n) return [];
      let i = [n.callbacks];
      for (let t = 0; t < n.childEvents.length; t++) {
        const o = P(e, n.childEvents[t]);
        i = i.concat(o);
      }
      return i;
    }
    function z(e, t) {
      let n;
      return e._events && (n = e._events[t]) && n.callbacks.length ? n.callbacks : t.indexOf(":") > -1 ? z(e, t.substr(0, t.lastIndexOf(":"))) : null;
    }
    function N(e, t, n) {
      for (let [i, o] of e) {
        o ? "function" == typeof o && (o = o(t.name)) : o = t.name;
        const e = new m(t.source, o);
        e.path = [...t.path], i.fire(e, ...n);
      }
    }
    function L(e, t, n, i) {
      t._removeEventListener ? t._removeEventListener(n, i) : e._removeEventListener.call(t, n, i);
    }
    ["on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(e => {
      T[e] = D.prototype[e];
    });
    const R = function (e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      },
      V = Symbol("observableProperties"),
      O = Symbol("boundObservables"),
      F = Symbol("boundProperties"),
      j = Symbol("decoratedMethods"),
      H = Symbol("decoratedOriginal"),
      U = q(T());
    function q(e) {
      if (!e) return U;
      return class extends e {
        set(e, t) {
          if (R(e)) return void Object.keys(e).forEach(t => {
            this.set(t, e[t]);
          }, this);
          G(this);
          const n = this[V];
          if (e in this && !n.has(e)) throw new _("observable-set-cannot-override", this);
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            get: () => n.get(e),
            set(t) {
              const i = n.get(e);
              let o = this.fire("set:".concat(e), e, t, i);
              void 0 === o && (o = t), i === o && n.has(e) || (n.set(e, o), this.fire("change:".concat(e), e, o, i));
            }
          }), this[e] = t;
        }
        bind() {
          for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            e[_key6] = arguments[_key6];
          }
          if (!e.length || !Y(e)) throw new _("observable-bind-wrong-properties", this);
          if (new Set(e).size !== e.length) throw new _("observable-bind-duplicate-properties", this);
          G(this);
          const t = this[F];
          e.forEach(e => {
            if (t.has(e)) throw new _("observable-bind-rebind", this);
          });
          const n = new Map();
          return e.forEach(e => {
            const i = {
              property: e,
              to: []
            };
            t.set(e, i), n.set(e, i);
          }), {
            to: K,
            toMany: W,
            _observable: this,
            _bindProperties: e,
            _to: [],
            _bindings: n
          };
        }
        unbind() {
          if (!this[V]) return;
          const t = this[F],
            n = this[O];
          for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            e[_key7] = arguments[_key7];
          }
          if (e.length) {
            if (!Y(e)) throw new _("observable-unbind-wrong-properties", this);
            e.forEach(e => {
              const i = t.get(e);
              i && (i.to.forEach(_ref => {
                let [e, t] = _ref;
                const o = n.get(e),
                  r = o[t];
                r.delete(i), r.size || delete o[t], Object.keys(o).length || (n.delete(e), this.stopListening(e, "change"));
              }), t.delete(e));
            });
          } else n.forEach((e, t) => {
            this.stopListening(t, "change");
          }), n.clear(), t.clear();
        }
        decorate(e) {
          G(this);
          const t = this[e];
          if (!t) throw new _("observablemixin-cannot-decorate-undefined", this, {
            object: this,
            methodName: e
          });
          this.on(e, (e, n) => {
            e.return = t.apply(this, n);
          }), this[e] = function () {
            for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
              t[_key8] = arguments[_key8];
            }
            return this.fire(e, t);
          }, this[e][H] = t, this[j] || (this[j] = []), this[j].push(e);
        }
        stopListening(e, t, n) {
          if (!e && this[j]) {
            for (const e of this[j]) this[e] = this[e][H];
            delete this[j];
          }
          super.stopListening(e, t, n);
        }
      };
    }
    function G(e) {
      e[V] || (Object.defineProperty(e, V, {
        value: new Map()
      }), Object.defineProperty(e, O, {
        value: new Map()
      }), Object.defineProperty(e, F, {
        value: new Map()
      }));
    }
    function K() {
      const t = function () {
          for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            e[_key9] = arguments[_key9];
          }
          if (!e.length) throw new _("observable-bind-to-parse-error", null);
          const t = {
            to: []
          };
          let n;
          "function" == typeof e[e.length - 1] && (t.callback = e.pop());
          return e.forEach(e => {
            if ("string" == typeof e) n.properties.push(e);else {
              if ("object" != typeof e) throw new _("observable-bind-to-parse-error", null);
              n = {
                observable: e,
                properties: []
              }, t.to.push(n);
            }
          }), t;
        }(...arguments),
        n = Array.from(this._bindings.keys()),
        i = n.length;
      if (!t.callback && t.to.length > 1) throw new _("observable-bind-to-no-callback", this);
      if (i > 1 && t.callback) throw new _("observable-bind-to-extra-callback", this);
      var o;
      t.to.forEach(e => {
        if (e.properties.length && e.properties.length !== i) throw new _("observable-bind-to-properties-length", this);
        e.properties.length || (e.properties = this._bindProperties);
      }), this._to = t.to, t.callback && (this._bindings.get(n[0]).callback = t.callback), o = this._observable, this._to.forEach(e => {
        const t = o[O];
        let n;
        t.get(e.observable) || o.listenTo(e.observable, "change", (i, r) => {
          n = t.get(e.observable)[r], n && n.forEach(e => {
            $(o, e.property);
          });
        });
      }), function (e) {
        let t;
        e._bindings.forEach((n, i) => {
          e._to.forEach(o => {
            t = o.properties[n.callback ? 0 : e._bindProperties.indexOf(i)], n.to.push([o.observable, t]), function (e, t, n, i) {
              const o = e[O],
                r = o.get(n),
                s = r || {};
              s[i] || (s[i] = new Set());
              s[i].add(t), r || o.set(n, s);
            }(e._observable, n, o.observable, t);
          });
        });
      }(this), this._bindProperties.forEach(e => {
        $(this._observable, e);
      });
    }
    function W(e, t, n) {
      if (this._bindings.size > 1) throw new _("observable-bind-to-many-not-one-binding", this);
      this.to(...function (e, t) {
        const n = e.map(e => [e, t]);
        return Array.prototype.concat.apply([], n);
      }(e, t), n);
    }
    function Y(e) {
      return e.every(e => "string" == typeof e);
    }
    function $(e, t) {
      const n = e[F].get(t);
      let i;
      n.callback ? i = n.callback.apply(e, n.to.map(e => e[0][e[1]])) : (i = n.to[0], i = i[0][i[1]]), Object.prototype.hasOwnProperty.call(e, t) ? e[t] = i : e.set(t, i);
    }
    ["set", "bind", "unbind", "decorate", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(e => {
      q[e] = U.prototype[e];
    });
    class Z {
      constructor() {
        this._replacedElements = [];
      }
      replace(e, t) {
        this._replacedElements.push({
          element: e,
          newElement: t
        }), e.style.display = "none", t && e.parentNode.insertBefore(t, e.nextSibling);
      }
      restore() {
        this._replacedElements.forEach(_ref2 => {
          let {
            element: e,
            newElement: t
          } = _ref2;
          e.style.display = "", t && t.remove();
        }), this._replacedElements = [];
      }
    }
    function Q(e) {
      let t = 0;
      for (const n of e) t++;
      return t;
    }
    function J(e, t) {
      const n = Math.min(e.length, t.length);
      for (let i = 0; i < n; i++) if (e[i] != t[i]) return i;
      return e.length == t.length ? "same" : e.length < t.length ? "prefix" : "extension";
    }
    function X(e) {
      return !(!e || !e[Symbol.iterator]);
    }
    const ee = "object" == typeof global && global && global.Object === Object && global;
    var te = "object" == typeof self && self && self.Object === Object && self;
    const ne = ee || te || Function("return this")();
    const ie = ne.Symbol;
    var oe = Object.prototype,
      re = oe.hasOwnProperty,
      se = oe.toString,
      ae = ie ? ie.toStringTag : void 0;
    const le = function (e) {
      var t = re.call(e, ae),
        n = e[ae];
      try {
        e[ae] = void 0;
        var i = !0;
      } catch (e) {}
      var o = se.call(e);
      return i && (t ? e[ae] = n : delete e[ae]), o;
    };
    var ce = Object.prototype.toString;
    const de = function (e) {
      return ce.call(e);
    };
    var ue = ie ? ie.toStringTag : void 0;
    const he = function (e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : ue && ue in Object(e) ? le(e) : de(e);
    };
    const me = Array.isArray;
    const pe = function (e) {
      return null != e && "object" == typeof e;
    };
    const ge = function (e) {
      return "string" == typeof e || !me(e) && pe(e) && "[object String]" == he(e);
    };
    function fe(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      const o = n && n.xmlns,
        r = o ? e.createElementNS(o, t) : e.createElement(t);
      for (const e in n) r.setAttribute(e, n[e]);
      !ge(i) && X(i) || (i = [i]);
      for (let t of i) ge(t) && (t = e.createTextNode(t)), r.appendChild(t);
      return r;
    }
    const ke = function (e, t) {
      return function (n) {
        return e(t(n));
      };
    };
    const be = ke(Object.getPrototypeOf, Object);
    var _e = Function.prototype,
      we = Object.prototype,
      Ae = _e.toString,
      ve = we.hasOwnProperty,
      Ce = Ae.call(Object);
    const ye = function (e) {
      if (!pe(e) || "[object Object]" != he(e)) return !1;
      var t = be(e);
      if (null === t) return !0;
      var n = ve.call(t, "constructor") && t.constructor;
      return "function" == typeof n && n instanceof n && Ae.call(n) == Ce;
    };
    const xe = function () {
      this.__data__ = [], this.size = 0;
    };
    const Ee = function (e, t) {
      return e === t || e != e && t != t;
    };
    const Se = function (e, t) {
      for (var n = e.length; n--;) if (Ee(e[n][0], t)) return n;
      return -1;
    };
    var De = Array.prototype.splice;
    const Te = function (e) {
      var t = this.__data__,
        n = Se(t, e);
      return !(n < 0) && (n == t.length - 1 ? t.pop() : De.call(t, n, 1), --this.size, !0);
    };
    const Ie = function (e) {
      var t = this.__data__,
        n = Se(t, e);
      return n < 0 ? void 0 : t[n][1];
    };
    const Be = function (e) {
      return Se(this.__data__, e) > -1;
    };
    const Me = function (e, t) {
      var n = this.__data__,
        i = Se(n, e);
      return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
    };
    function Pe(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var i = e[t];
        this.set(i[0], i[1]);
      }
    }
    Pe.prototype.clear = xe, Pe.prototype.delete = Te, Pe.prototype.get = Ie, Pe.prototype.has = Be, Pe.prototype.set = Me;
    const ze = Pe;
    const Ne = function () {
      this.__data__ = new ze(), this.size = 0;
    };
    const Le = function (e) {
      var t = this.__data__,
        n = t.delete(e);
      return this.size = t.size, n;
    };
    const Re = function (e) {
      return this.__data__.get(e);
    };
    const Ve = function (e) {
      return this.__data__.has(e);
    };
    const Oe = function (e) {
      if (!R(e)) return !1;
      var t = he(e);
      return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    };
    const Fe = ne["__core-js_shared__"];
    var je = function () {
      var e = /[^.]+$/.exec(Fe && Fe.keys && Fe.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }();
    const He = function (e) {
      return !!je && je in e;
    };
    var Ue = Function.prototype.toString;
    const qe = function (e) {
      if (null != e) {
        try {
          return Ue.call(e);
        } catch (e) {}
        try {
          return e + "";
        } catch (e) {}
      }
      return "";
    };
    var Ge = /^\[object .+?Constructor\]$/,
      Ke = Function.prototype,
      We = Object.prototype,
      Ye = Ke.toString,
      $e = We.hasOwnProperty,
      Ze = RegExp("^" + Ye.call($e).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    const Qe = function (e) {
      return !(!R(e) || He(e)) && (Oe(e) ? Ze : Ge).test(qe(e));
    };
    const Je = function (e, t) {
      return null == e ? void 0 : e[t];
    };
    const Xe = function (e, t) {
      var n = Je(e, t);
      return Qe(n) ? n : void 0;
    };
    const et = Xe(ne, "Map");
    const tt = Xe(Object, "create");
    const nt = function () {
      this.__data__ = tt ? tt(null) : {}, this.size = 0;
    };
    const it = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
    var ot = Object.prototype.hasOwnProperty;
    const rt = function (e) {
      var t = this.__data__;
      if (tt) {
        var n = t[e];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }
      return ot.call(t, e) ? t[e] : void 0;
    };
    var st = Object.prototype.hasOwnProperty;
    const at = function (e) {
      var t = this.__data__;
      return tt ? void 0 !== t[e] : st.call(t, e);
    };
    const lt = function (e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = tt && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
    function ct(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var i = e[t];
        this.set(i[0], i[1]);
      }
    }
    ct.prototype.clear = nt, ct.prototype.delete = it, ct.prototype.get = rt, ct.prototype.has = at, ct.prototype.set = lt;
    const dt = ct;
    const ut = function () {
      this.size = 0, this.__data__ = {
        hash: new dt(),
        map: new (et || ze)(),
        string: new dt()
      };
    };
    const ht = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
    const mt = function (e, t) {
      var n = e.__data__;
      return ht(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    };
    const pt = function (e) {
      var t = mt(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
    const gt = function (e) {
      return mt(this, e).get(e);
    };
    const ft = function (e) {
      return mt(this, e).has(e);
    };
    const kt = function (e, t) {
      var n = mt(this, e),
        i = n.size;
      return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
    };
    function bt(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var i = e[t];
        this.set(i[0], i[1]);
      }
    }
    bt.prototype.clear = ut, bt.prototype.delete = pt, bt.prototype.get = gt, bt.prototype.has = ft, bt.prototype.set = kt;
    const _t = bt;
    const wt = function (e, t) {
      var n = this.__data__;
      if (n instanceof ze) {
        var i = n.__data__;
        if (!et || i.length < 199) return i.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new _t(i);
      }
      return n.set(e, t), this.size = n.size, this;
    };
    function At(e) {
      var t = this.__data__ = new ze(e);
      this.size = t.size;
    }
    At.prototype.clear = Ne, At.prototype.delete = Le, At.prototype.get = Re, At.prototype.has = Ve, At.prototype.set = wt;
    const vt = At;
    const Ct = function (e, t) {
      for (var n = -1, i = null == e ? 0 : e.length; ++n < i && !1 !== t(e[n], n, e););
      return e;
    };
    const yt = function () {
      try {
        var e = Xe(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();
    const xt = function (e, t, n) {
      "__proto__" == t && yt ? yt(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : e[t] = n;
    };
    var Et = Object.prototype.hasOwnProperty;
    const St = function (e, t, n) {
      var i = e[t];
      Et.call(e, t) && Ee(i, n) && (void 0 !== n || t in e) || xt(e, t, n);
    };
    const Dt = function (e, t, n, i) {
      var o = !n;
      n || (n = {});
      for (var r = -1, s = t.length; ++r < s;) {
        var a = t[r],
          l = i ? i(n[a], e[a], a, n, e) : void 0;
        void 0 === l && (l = e[a]), o ? xt(n, a, l) : St(n, a, l);
      }
      return n;
    };
    const Tt = function (e, t) {
      for (var n = -1, i = Array(e); ++n < e;) i[n] = t(n);
      return i;
    };
    const It = function (e) {
      return pe(e) && "[object Arguments]" == he(e);
    };
    var Bt = Object.prototype,
      Mt = Bt.hasOwnProperty,
      Pt = Bt.propertyIsEnumerable;
    const zt = It(function () {
      return arguments;
    }()) ? It : function (e) {
      return pe(e) && Mt.call(e, "callee") && !Pt.call(e, "callee");
    };
    const Nt = function () {
      return !1;
    };
    var Lt = "object" == typeof exports && exports && !exports.nodeType && exports,
      Rt = Lt && "object" == typeof module && module && !module.nodeType && module,
      Vt = Rt && Rt.exports === Lt ? ne.Buffer : void 0;
    const Ot = (Vt ? Vt.isBuffer : void 0) || Nt;
    var Ft = /^(?:0|[1-9]\d*)$/;
    const jt = function (e, t) {
      var n = typeof e;
      return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && Ft.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
    const Ht = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
    };
    var Ut = {};
    Ut["[object Float32Array]"] = Ut["[object Float64Array]"] = Ut["[object Int8Array]"] = Ut["[object Int16Array]"] = Ut["[object Int32Array]"] = Ut["[object Uint8Array]"] = Ut["[object Uint8ClampedArray]"] = Ut["[object Uint16Array]"] = Ut["[object Uint32Array]"] = !0, Ut["[object Arguments]"] = Ut["[object Array]"] = Ut["[object ArrayBuffer]"] = Ut["[object Boolean]"] = Ut["[object DataView]"] = Ut["[object Date]"] = Ut["[object Error]"] = Ut["[object Function]"] = Ut["[object Map]"] = Ut["[object Number]"] = Ut["[object Object]"] = Ut["[object RegExp]"] = Ut["[object Set]"] = Ut["[object String]"] = Ut["[object WeakMap]"] = !1;
    const qt = function (e) {
      return pe(e) && Ht(e.length) && !!Ut[he(e)];
    };
    const Gt = function (e) {
      return function (t) {
        return e(t);
      };
    };
    var Kt = "object" == typeof exports && exports && !exports.nodeType && exports,
      Wt = Kt && "object" == typeof module && module && !module.nodeType && module,
      Yt = Wt && Wt.exports === Kt && ee.process;
    const $t = function () {
      try {
        var e = Wt && Wt.require && Wt.require("util").types;
        return e || Yt && Yt.binding && Yt.binding("util");
      } catch (e) {}
    }();
    var Zt = $t && $t.isTypedArray;
    const Qt = Zt ? Gt(Zt) : qt;
    var Jt = Object.prototype.hasOwnProperty;
    const Xt = function (e, t) {
      var n = me(e),
        i = !n && zt(e),
        o = !n && !i && Ot(e),
        r = !n && !i && !o && Qt(e),
        s = n || i || o || r,
        a = s ? Tt(e.length, String) : [],
        l = a.length;
      for (var c in e) !t && !Jt.call(e, c) || s && ("length" == c || o && ("offset" == c || "parent" == c) || r && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || jt(c, l)) || a.push(c);
      return a;
    };
    var en = Object.prototype;
    const tn = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || en);
    };
    const nn = ke(Object.keys, Object);
    var on = Object.prototype.hasOwnProperty;
    const rn = function (e) {
      if (!tn(e)) return nn(e);
      var t = [];
      for (var n in Object(e)) on.call(e, n) && "constructor" != n && t.push(n);
      return t;
    };
    const sn = function (e) {
      return null != e && Ht(e.length) && !Oe(e);
    };
    const an = function (e) {
      return sn(e) ? Xt(e) : rn(e);
    };
    const ln = function (e, t) {
      return e && Dt(t, an(t), e);
    };
    const cn = function (e) {
      var t = [];
      if (null != e) for (var n in Object(e)) t.push(n);
      return t;
    };
    var dn = Object.prototype.hasOwnProperty;
    const un = function (e) {
      if (!R(e)) return cn(e);
      var t = tn(e),
        n = [];
      for (var i in e) ("constructor" != i || !t && dn.call(e, i)) && n.push(i);
      return n;
    };
    const hn = function (e) {
      return sn(e) ? Xt(e, !0) : un(e);
    };
    const mn = function (e, t) {
      return e && Dt(t, hn(t), e);
    };
    var pn = "object" == typeof exports && exports && !exports.nodeType && exports,
      gn = pn && "object" == typeof module && module && !module.nodeType && module,
      fn = gn && gn.exports === pn ? ne.Buffer : void 0,
      kn = fn ? fn.allocUnsafe : void 0;
    const bn = function (e, t) {
      if (t) return e.slice();
      var n = e.length,
        i = kn ? kn(n) : new e.constructor(n);
      return e.copy(i), i;
    };
    const _n = function (e, t) {
      var n = -1,
        i = e.length;
      for (t || (t = Array(i)); ++n < i;) t[n] = e[n];
      return t;
    };
    const wn = function (e, t) {
      for (var n = -1, i = null == e ? 0 : e.length, o = 0, r = []; ++n < i;) {
        var s = e[n];
        t(s, n, e) && (r[o++] = s);
      }
      return r;
    };
    const An = function () {
      return [];
    };
    var vn = Object.prototype.propertyIsEnumerable,
      Cn = Object.getOwnPropertySymbols;
    const yn = Cn ? function (e) {
      return null == e ? [] : (e = Object(e), wn(Cn(e), function (t) {
        return vn.call(e, t);
      }));
    } : An;
    const xn = function (e, t) {
      return Dt(e, yn(e), t);
    };
    const En = function (e, t) {
      for (var n = -1, i = t.length, o = e.length; ++n < i;) e[o + n] = t[n];
      return e;
    };
    const Sn = Object.getOwnPropertySymbols ? function (e) {
      for (var t = []; e;) En(t, yn(e)), e = be(e);
      return t;
    } : An;
    const Dn = function (e, t) {
      return Dt(e, Sn(e), t);
    };
    const Tn = function (e, t, n) {
      var i = t(e);
      return me(e) ? i : En(i, n(e));
    };
    const In = function (e) {
      return Tn(e, an, yn);
    };
    const Bn = function (e) {
      return Tn(e, hn, Sn);
    };
    const Mn = Xe(ne, "DataView");
    const Pn = Xe(ne, "Promise");
    const zn = Xe(ne, "Set");
    const Nn = Xe(ne, "WeakMap");
    var Ln = "[object Map]",
      Rn = "[object Promise]",
      Vn = "[object Set]",
      On = "[object WeakMap]",
      Fn = "[object DataView]",
      jn = qe(Mn),
      Hn = qe(et),
      Un = qe(Pn),
      qn = qe(zn),
      Gn = qe(Nn),
      Kn = he;
    (Mn && Kn(new Mn(new ArrayBuffer(1))) != Fn || et && Kn(new et()) != Ln || Pn && Kn(Pn.resolve()) != Rn || zn && Kn(new zn()) != Vn || Nn && Kn(new Nn()) != On) && (Kn = function (e) {
      var t = he(e),
        n = "[object Object]" == t ? e.constructor : void 0,
        i = n ? qe(n) : "";
      if (i) switch (i) {
        case jn:
          return Fn;
        case Hn:
          return Ln;
        case Un:
          return Rn;
        case qn:
          return Vn;
        case Gn:
          return On;
      }
      return t;
    });
    const Wn = Kn;
    var Yn = Object.prototype.hasOwnProperty;
    const $n = function (e) {
      var t = e.length,
        n = new e.constructor(t);
      return t && "string" == typeof e[0] && Yn.call(e, "index") && (n.index = e.index, n.input = e.input), n;
    };
    const Zn = ne.Uint8Array;
    const Qn = function (e) {
      var t = new e.constructor(e.byteLength);
      return new Zn(t).set(new Zn(e)), t;
    };
    const Jn = function (e, t) {
      var n = t ? Qn(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.byteLength);
    };
    var Xn = /\w*$/;
    const ei = function (e) {
      var t = new e.constructor(e.source, Xn.exec(e));
      return t.lastIndex = e.lastIndex, t;
    };
    var ti = ie ? ie.prototype : void 0,
      ni = ti ? ti.valueOf : void 0;
    const ii = function (e) {
      return ni ? Object(ni.call(e)) : {};
    };
    const oi = function (e, t) {
      var n = t ? Qn(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.length);
    };
    const ri = function (e, t, n) {
      var i = e.constructor;
      switch (t) {
        case "[object ArrayBuffer]":
          return Qn(e);
        case "[object Boolean]":
        case "[object Date]":
          return new i(+e);
        case "[object DataView]":
          return Jn(e, n);
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return oi(e, n);
        case "[object Map]":
        case "[object Set]":
          return new i();
        case "[object Number]":
        case "[object String]":
          return new i(e);
        case "[object RegExp]":
          return ei(e);
        case "[object Symbol]":
          return ii(e);
      }
    };
    var si = Object.create;
    const ai = function () {
      function e() {}
      return function (t) {
        if (!R(t)) return {};
        if (si) return si(t);
        e.prototype = t;
        var n = new e();
        return e.prototype = void 0, n;
      };
    }();
    const li = function (e) {
      return "function" != typeof e.constructor || tn(e) ? {} : ai(be(e));
    };
    const ci = function (e) {
      return pe(e) && "[object Map]" == Wn(e);
    };
    var di = $t && $t.isMap;
    const ui = di ? Gt(di) : ci;
    const hi = function (e) {
      return pe(e) && "[object Set]" == Wn(e);
    };
    var mi = $t && $t.isSet;
    const pi = mi ? Gt(mi) : hi;
    var gi = "[object Arguments]",
      fi = "[object Function]",
      ki = "[object Object]",
      bi = {};
    bi[gi] = bi["[object Array]"] = bi["[object ArrayBuffer]"] = bi["[object DataView]"] = bi["[object Boolean]"] = bi["[object Date]"] = bi["[object Float32Array]"] = bi["[object Float64Array]"] = bi["[object Int8Array]"] = bi["[object Int16Array]"] = bi["[object Int32Array]"] = bi["[object Map]"] = bi["[object Number]"] = bi[ki] = bi["[object RegExp]"] = bi["[object Set]"] = bi["[object String]"] = bi["[object Symbol]"] = bi["[object Uint8Array]"] = bi["[object Uint8ClampedArray]"] = bi["[object Uint16Array]"] = bi["[object Uint32Array]"] = !0, bi["[object Error]"] = bi[fi] = bi["[object WeakMap]"] = !1;
    const _i = function e(t, n, i, o, r, s) {
      var a,
        l = 1 & n,
        c = 2 & n,
        d = 4 & n;
      if (i && (a = r ? i(t, o, r, s) : i(t)), void 0 !== a) return a;
      if (!R(t)) return t;
      var u = me(t);
      if (u) {
        if (a = $n(t), !l) return _n(t, a);
      } else {
        var h = Wn(t),
          m = h == fi || "[object GeneratorFunction]" == h;
        if (Ot(t)) return bn(t, l);
        if (h == ki || h == gi || m && !r) {
          if (a = c || m ? {} : li(t), !l) return c ? Dn(t, mn(a, t)) : xn(t, ln(a, t));
        } else {
          if (!bi[h]) return r ? t : {};
          a = ri(t, h, l);
        }
      }
      s || (s = new vt());
      var p = s.get(t);
      if (p) return p;
      s.set(t, a), pi(t) ? t.forEach(function (o) {
        a.add(e(o, n, i, o, t, s));
      }) : ui(t) && t.forEach(function (o, r) {
        a.set(r, e(o, n, i, r, t, s));
      });
      var g = u ? void 0 : (d ? c ? Bn : In : c ? hn : an)(t);
      return Ct(g || t, function (o, r) {
        g && (o = t[r = o]), St(a, r, e(o, n, i, r, t, s));
      }), a;
    };
    const wi = function (e, t) {
      return _i(e, 5, t = "function" == typeof t ? t : void 0);
    };
    const Ai = function (e) {
      return pe(e) && 1 === e.nodeType && !ye(e);
    };
    class vi {
      constructor(e, t) {
        this._config = {}, t && this.define(Ci(t)), e && this._setObjectToTarget(this._config, e);
      }
      set(e, t) {
        this._setToTarget(this._config, e, t);
      }
      define(e, t) {
        this._setToTarget(this._config, e, t, !0);
      }
      get(e) {
        return this._getFromSource(this._config, e);
      }
      *names() {
        for (const e of Object.keys(this._config)) yield e;
      }
      _setToTarget(e, t, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        if (ye(t)) return void this._setObjectToTarget(e, t, i);
        const o = t.split(".");
        t = o.pop();
        for (const t of o) ye(e[t]) || (e[t] = {}), e = e[t];
        if (ye(n)) return ye(e[t]) || (e[t] = {}), e = e[t], void this._setObjectToTarget(e, n, i);
        i && void 0 !== e[t] || (e[t] = n);
      }
      _getFromSource(e, t) {
        const n = t.split(".");
        t = n.pop();
        for (const t of n) {
          if (!ye(e[t])) {
            e = null;
            break;
          }
          e = e[t];
        }
        return e ? Ci(e[t]) : void 0;
      }
      _setObjectToTarget(e, t, n) {
        Object.keys(t).forEach(i => {
          this._setToTarget(e, i, t[i], n);
        });
      }
    }
    function Ci(e) {
      return wi(e, yi);
    }
    function yi(e) {
      return Ai(e) || "function" == typeof e ? e : void 0;
    }
    function xi(e) {
      if (e) {
        if (e.defaultView) return e instanceof e.defaultView.Document;
        if (e.ownerDocument && e.ownerDocument.defaultView) return e instanceof e.ownerDocument.defaultView.Node;
      }
      return !1;
    }
    function Ei(e) {
      const t = Object.prototype.toString.apply(e);
      return "[object Window]" == t || "[object global]" == t;
    }
    const Si = Di(T());
    function Di(e) {
      if (!e) return Si;
      return class extends e {
        listenTo(e, t, n) {
          let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          if (xi(e) || Ei(e)) {
            const o = {
                capture: !!i.useCapture,
                passive: !!i.usePassive
              },
              r = this._getProxyEmitter(e, o) || new Ti(e, o);
            this.listenTo(r, t, n, i);
          } else super.listenTo(e, t, n, i);
        }
        stopListening(e, t, n) {
          if (xi(e) || Ei(e)) {
            const i = this._getAllProxyEmitters(e);
            for (const e of i) this.stopListening(e, t, n);
          } else super.stopListening(e, t, n);
        }
        _getProxyEmitter(e, t) {
          return function (e, t) {
            const n = e[x];
            return n && n[t] ? n[t].emitter : null;
          }(this, Ii(e, t));
        }
        _getAllProxyEmitters(e) {
          return [{
            capture: !1,
            passive: !1
          }, {
            capture: !1,
            passive: !0
          }, {
            capture: !0,
            passive: !1
          }, {
            capture: !0,
            passive: !0
          }].map(t => this._getProxyEmitter(e, t)).filter(e => !!e);
        }
      };
    }
    ["_getProxyEmitter", "_getAllProxyEmitters", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(e => {
      Di[e] = Si.prototype[e];
    });
    class Ti extends T() {
      constructor(e, t) {
        super(), I(this, Ii(e, t)), this._domNode = e, this._options = t;
      }
      attach(e) {
        if (this._domListeners && this._domListeners[e]) return;
        const t = this._createDomListener(e);
        this._domNode.addEventListener(e, t, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[e] = t;
      }
      detach(e) {
        let t;
        !this._domListeners[e] || (t = this._events[e]) && t.callbacks.length || this._domListeners[e].removeListener();
      }
      _addEventListener(e, t, n) {
        this.attach(e), T().prototype._addEventListener.call(this, e, t, n);
      }
      _removeEventListener(e, t) {
        T().prototype._removeEventListener.call(this, e, t), this.detach(e);
      }
      _createDomListener(e) {
        const t = t => {
          this.fire(e, t);
        };
        return t.removeListener = () => {
          this._domNode.removeEventListener(e, t, this._options), delete this._domListeners[e];
        }, t;
      }
    }
    function Ii(e, t) {
      let n = function (e) {
        return e["data-ck-expando"] || (e["data-ck-expando"] = g());
      }(e);
      for (const e of Object.keys(t).sort()) t[e] && (n += "-" + e);
      return n;
    }
    function Bi(e) {
      const t = e.ownerDocument.defaultView.getComputedStyle(e);
      return {
        top: parseInt(t.borderTopWidth, 10),
        right: parseInt(t.borderRightWidth, 10),
        bottom: parseInt(t.borderBottomWidth, 10),
        left: parseInt(t.borderLeftWidth, 10)
      };
    }
    function Mi(e) {
      return "[object Text]" == Object.prototype.toString.call(e);
    }
    function Pi(e) {
      return "[object Range]" == Object.prototype.toString.apply(e);
    }
    function zi(e) {
      return e && e.parentNode ? e.offsetParent === t.document.body ? null : e.offsetParent : null;
    }
    const Ni = ["top", "right", "bottom", "left", "width", "height"];
    class Li {
      constructor(e) {
        const t = Pi(e);
        if (Object.defineProperty(this, "_source", {
          value: e._source || e,
          writable: !0,
          enumerable: !1
        }), Oi(e) || t) {
          if (t) {
            const t = Li.getDomRangeRects(e);
            Ri(this, Li.getBoundingRect(t));
          } else Ri(this, e.getBoundingClientRect());
        } else if (Ei(e)) {
          const {
            innerWidth: t,
            innerHeight: n
          } = e;
          Ri(this, {
            top: 0,
            right: t,
            bottom: n,
            left: 0,
            width: t,
            height: n
          });
        } else Ri(this, e);
      }
      clone() {
        return new Li(this);
      }
      moveTo(e, t) {
        return this.top = t, this.right = e + this.width, this.bottom = t + this.height, this.left = e, this;
      }
      moveBy(e, t) {
        return this.top += t, this.right += e, this.left += e, this.bottom += t, this;
      }
      getIntersection(e) {
        const t = {
          top: Math.max(this.top, e.top),
          right: Math.min(this.right, e.right),
          bottom: Math.min(this.bottom, e.bottom),
          left: Math.max(this.left, e.left),
          width: 0,
          height: 0
        };
        if (t.width = t.right - t.left, t.height = t.bottom - t.top, t.width < 0 || t.height < 0) return null;
        {
          const e = new Li(t);
          return e._source = this._source, e;
        }
      }
      getIntersectionArea(e) {
        const t = this.getIntersection(e);
        return t ? t.getArea() : 0;
      }
      getArea() {
        return this.width * this.height;
      }
      getVisible() {
        const e = this._source;
        let t = this.clone();
        if (Vi(e)) return t;
        let n,
          i = e,
          o = e.parentNode || e.commonAncestorContainer;
        for (; o && !Vi(o);) {
          const e = "visible" === ((r = o) instanceof HTMLElement ? r.ownerDocument.defaultView.getComputedStyle(r).overflow : "visible");
          i instanceof HTMLElement && "absolute" === Fi(i) && (n = i);
          const s = Fi(o);
          if (e || n && ("relative" === s && e || "relative" !== s)) {
            i = o, o = o.parentNode;
            continue;
          }
          const a = new Li(o),
            l = t.getIntersection(a);
          if (!l) return null;
          l.getArea() < t.getArea() && (t = l), i = o, o = o.parentNode;
        }
        var r;
        return t;
      }
      isEqual(e) {
        for (const t of Ni) if (this[t] !== e[t]) return !1;
        return !0;
      }
      contains(e) {
        const t = this.getIntersection(e);
        return !(!t || !t.isEqual(e));
      }
      toAbsoluteRect() {
        const {
            scrollX: e,
            scrollY: n
          } = t.window,
          i = this.clone().moveBy(e, n);
        if (Oi(i._source)) {
          const e = zi(i._source);
          e && function (e, t) {
            const n = new Li(t),
              i = Bi(t);
            let o = 0,
              r = 0;
            o -= n.left, r -= n.top, o += t.scrollLeft, r += t.scrollTop, o -= i.left, r -= i.top, e.moveBy(o, r);
          }(i, e);
        }
        return i;
      }
      excludeScrollbarsAndBorders() {
        const e = this._source;
        let t, n, i;
        if (Ei(e)) t = e.innerWidth - e.document.documentElement.clientWidth, n = e.innerHeight - e.document.documentElement.clientHeight, i = e.getComputedStyle(e.document.documentElement).direction;else {
          const o = Bi(e);
          t = e.offsetWidth - e.clientWidth - o.left - o.right, n = e.offsetHeight - e.clientHeight - o.top - o.bottom, i = e.ownerDocument.defaultView.getComputedStyle(e).direction, this.left += o.left, this.top += o.top, this.right -= o.right, this.bottom -= o.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
        }
        return this.width -= t, "ltr" === i ? this.right -= t : this.left += t, this.height -= n, this.bottom -= n, this;
      }
      static getDomRangeRects(e) {
        const t = [],
          n = Array.from(e.getClientRects());
        if (n.length) for (const e of n) t.push(new Li(e));else {
          let n = e.startContainer;
          Mi(n) && (n = n.parentNode);
          const i = new Li(n.getBoundingClientRect());
          i.right = i.left, i.width = 0, t.push(i);
        }
        return t;
      }
      static getBoundingRect(e) {
        const t = {
          left: Number.POSITIVE_INFINITY,
          top: Number.POSITIVE_INFINITY,
          right: Number.NEGATIVE_INFINITY,
          bottom: Number.NEGATIVE_INFINITY,
          width: 0,
          height: 0
        };
        let n = 0;
        for (const i of e) n++, t.left = Math.min(t.left, i.left), t.top = Math.min(t.top, i.top), t.right = Math.max(t.right, i.right), t.bottom = Math.max(t.bottom, i.bottom);
        return 0 == n ? null : (t.width = t.right - t.left, t.height = t.bottom - t.top, new Li(t));
      }
    }
    function Ri(e, t) {
      for (const n of Ni) e[n] = t[n];
    }
    function Vi(e) {
      return !!Oi(e) && e === e.ownerDocument.body;
    }
    function Oi(e) {
      return null !== e && "object" == typeof e && 1 === e.nodeType && "function" == typeof e.getBoundingClientRect;
    }
    function Fi(e) {
      return e instanceof HTMLElement ? e.ownerDocument.defaultView.getComputedStyle(e).position : "static";
    }
    class ji {
      constructor(e, t) {
        ji._observerInstance || ji._createObserver(), this._element = e, this._callback = t, ji._addElementCallback(e, t), ji._observerInstance.observe(e);
      }
      get element() {
        return this._element;
      }
      destroy() {
        ji._deleteElementCallback(this._element, this._callback);
      }
      static _addElementCallback(e, t) {
        ji._elementCallbacks || (ji._elementCallbacks = new Map());
        let n = ji._elementCallbacks.get(e);
        n || (n = new Set(), ji._elementCallbacks.set(e, n)), n.add(t);
      }
      static _deleteElementCallback(e, t) {
        const n = ji._getElementCallbacks(e);
        n && (n.delete(t), n.size || (ji._elementCallbacks.delete(e), ji._observerInstance.unobserve(e))), ji._elementCallbacks && !ji._elementCallbacks.size && (ji._observerInstance = null, ji._elementCallbacks = null);
      }
      static _getElementCallbacks(e) {
        return ji._elementCallbacks ? ji._elementCallbacks.get(e) : null;
      }
      static _createObserver() {
        ji._observerInstance = new t.window.ResizeObserver(e => {
          for (const t of e) {
            const e = ji._getElementCallbacks(t.target);
            if (e) for (const n of e) n(t);
          }
        });
      }
    }
    ji._observerInstance = null, ji._elementCallbacks = null;
    const Hi = ji;
    function Ui(e, t) {
      e instanceof HTMLTextAreaElement && (e.value = t), e.innerHTML = t;
    }
    function qi(e) {
      return t => t + e;
    }
    function Gi(e) {
      let t = 0;
      for (; e.previousSibling;) e = e.previousSibling, t++;
      return t;
    }
    function Ki(e, t, n) {
      e.insertBefore(n, e.childNodes[t] || null);
    }
    function Wi(e) {
      return e && e.nodeType === Node.COMMENT_NODE;
    }
    function Yi(e) {
      try {
        t.document.createAttribute(e);
      } catch (e) {
        return !1;
      }
      return !0;
    }
    function $i(e) {
      return !!(e && e.getClientRects && e.getClientRects().length);
    }
    function Zi(_ref3) {
      let {
        element: e,
        target: n,
        positions: i,
        limiter: o,
        fitInViewport: r,
        viewportOffsetConfig: s
      } = _ref3;
      Oe(n) && (n = n()), Oe(o) && (o = o());
      const a = zi(e),
        l = function (e) {
          e = Object.assign({
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }, e);
          const n = new Li(t.window);
          return n.top += e.top, n.height -= e.top, n.bottom -= e.bottom, n.height -= e.bottom, n;
        }(s),
        c = new Li(e),
        d = Qi(n, l);
      let u;
      if (!d || !l.getIntersection(d)) return null;
      const h = {
        targetRect: d,
        elementRect: c,
        positionedElementAncestor: a,
        viewportRect: l
      };
      if (o || r) {
        if (o) {
          const e = Qi(o, l);
          e && (h.limiterRect = e);
        }
        u = function (e, t) {
          const {
              elementRect: n
            } = t,
            i = n.getArea(),
            o = e.map(e => new Ji(e, t)).filter(e => !!e.name);
          let r = 0,
            s = null;
          for (const e of o) {
            const {
              limiterIntersectionArea: t,
              viewportIntersectionArea: n
            } = e;
            if (t === i) return e;
            const o = n ** 2 + t ** 2;
            o > r && (r = o, s = e);
          }
          return s;
        }(i, h);
      } else u = new Ji(i[0], h);
      return u;
    }
    function Qi(e, t) {
      const n = new Li(e).getVisible();
      return n ? n.getIntersection(t) : null;
    }
    class Ji {
      constructor(e, t) {
        const n = e(t.targetRect, t.elementRect, t.viewportRect, t.limiterRect);
        if (!n) return;
        const {
          left: i,
          top: o,
          name: r,
          config: s
        } = n;
        this.name = r, this.config = s, this._positioningFunctionCoordinates = {
          left: i,
          top: o
        }, this._options = t;
      }
      get left() {
        return this._absoluteRect.left;
      }
      get top() {
        return this._absoluteRect.top;
      }
      get limiterIntersectionArea() {
        const e = this._options.limiterRect;
        return e ? e.getIntersectionArea(this._rect) : 0;
      }
      get viewportIntersectionArea() {
        return this._options.viewportRect.getIntersectionArea(this._rect);
      }
      get _rect() {
        return this._cachedRect || (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top)), this._cachedRect;
      }
      get _absoluteRect() {
        return this._cachedAbsoluteRect || (this._cachedAbsoluteRect = this._rect.toAbsoluteRect()), this._cachedAbsoluteRect;
      }
    }
    function Xi(e) {
      const t = e.parentNode;
      t && t.removeChild(e);
    }
    function eo(_ref4) {
      let {
        window: e,
        rect: t,
        alignToTop: n,
        forceScroll: i,
        viewportOffset: o
      } = _ref4;
      const r = t.clone().moveBy(0, o.bottom),
        s = t.clone().moveBy(0, -o.top),
        a = new Li(e).excludeScrollbarsAndBorders(),
        l = n && i,
        c = [s, r].every(e => a.contains(e));
      let {
        scrollX: d,
        scrollY: u
      } = e;
      const h = d,
        m = u;
      l ? u -= a.top - t.top + o.top : c || (io(s, a) ? u -= a.top - t.top + o.top : no(r, a) && (u += n ? t.top - a.top - o.top : t.bottom - a.bottom + o.bottom)), c || (oo(t, a) ? d -= a.left - t.left + o.left : ro(t, a) && (d += t.right - a.right + o.right)), d == h && u === m || e.scrollTo(d, u);
    }
    function to(_ref5) {
      let {
        parent: e,
        getRect: t,
        alignToTop: n,
        forceScroll: i,
        ancestorOffset: o = 0,
        limiterElement: r
      } = _ref5;
      const s = so(e),
        a = n && i;
      let l, c, d;
      const u = r || s.document.body;
      for (; e != u;) c = t(), l = new Li(e).excludeScrollbarsAndBorders(), d = l.contains(c), a ? e.scrollTop -= l.top - c.top + o : d || (io(c, l) ? e.scrollTop -= l.top - c.top + o : no(c, l) && (e.scrollTop += n ? c.top - l.top - o : c.bottom - l.bottom + o)), d || (oo(c, l) ? e.scrollLeft -= l.left - c.left + o : ro(c, l) && (e.scrollLeft += c.right - l.right + o)), e = e.parentNode;
    }
    function no(e, t) {
      return e.bottom > t.bottom;
    }
    function io(e, t) {
      return e.top < t.top;
    }
    function oo(e, t) {
      return e.left < t.left;
    }
    function ro(e, t) {
      return e.right > t.right;
    }
    function so(e) {
      return Pi(e) ? e.startContainer.ownerDocument.defaultView : e.ownerDocument.defaultView;
    }
    function ao(e) {
      if (Pi(e)) {
        let t = e.commonAncestorContainer;
        return Mi(t) && (t = t.parentNode), t;
      }
      return e.parentNode;
    }
    function lo(e, t) {
      const n = so(e),
        i = new Li(e);
      if (n === t) return i;
      {
        let e = n;
        for (; e != t;) {
          const t = e.frameElement,
            n = new Li(t).excludeScrollbarsAndBorders();
          i.moveBy(n.left, n.top), e = e.parent;
        }
      }
      return i;
    }
    const co = {
        ctrl: "⌃",
        cmd: "⌘",
        alt: "⌥",
        shift: "⇧"
      },
      uo = {
        ctrl: "Ctrl+",
        alt: "Alt+",
        shift: "Shift+"
      },
      ho = {
        37: "←",
        38: "↑",
        39: "→",
        40: "↓",
        9: "⇥",
        33: "Page Up",
        34: "Page Down"
      },
      mo = function () {
        const e = {
          pageup: 33,
          pagedown: 34,
          arrowleft: 37,
          arrowup: 38,
          arrowright: 39,
          arrowdown: 40,
          backspace: 8,
          delete: 46,
          enter: 13,
          space: 32,
          esc: 27,
          tab: 9,
          ctrl: 1114112,
          shift: 2228224,
          alt: 4456448,
          cmd: 8912896
        };
        for (let t = 65; t <= 90; t++) {
          e[String.fromCharCode(t).toLowerCase()] = t;
        }
        for (let t = 48; t <= 57; t++) e[t - 48] = t;
        for (let t = 112; t <= 123; t++) e["f" + (t - 111)] = t;
        return Object.assign(e, {
          "'": 222,
          ",": 108,
          "-": 109,
          ".": 110,
          "/": 111,
          ";": 186,
          "=": 187,
          "[": 219,
          "\\": 220,
          "]": 221,
          "`": 223
        }), e;
      }(),
      po = Object.fromEntries(Object.entries(mo).map(_ref6 => {
        let [e, t] = _ref6;
        let n;
        return n = t in ho ? ho[t] : e.charAt(0).toUpperCase() + e.slice(1), [t, n];
      }));
    function go(e) {
      let t;
      if ("string" == typeof e) {
        if (t = mo[e.toLowerCase()], !t) throw new _("keyboard-unknown-key", null, {
          key: e
        });
      } else t = e.keyCode + (e.altKey ? mo.alt : 0) + (e.ctrlKey ? mo.ctrl : 0) + (e.shiftKey ? mo.shift : 0) + (e.metaKey ? mo.cmd : 0);
      return t;
    }
    function fo(e) {
      return "string" == typeof e && (e = function (e) {
        return e.split("+").map(e => e.trim());
      }(e)), e.map(e => "string" == typeof e ? function (e) {
        if (e.endsWith("!")) return go(e.slice(0, -1));
        const t = go(e);
        return (s.isMac || s.isiOS) && t == mo.ctrl ? mo.cmd : t;
      }(e) : e).reduce((e, t) => t + e, 0);
    }
    function ko(e) {
      let t = fo(e);
      return Object.entries(s.isMac || s.isiOS ? co : uo).reduce((e, _ref7) => {
        let [n, i] = _ref7;
        return t & mo[n] && (t &= ~mo[n], e += i), e;
      }, "") + (t ? po[t] : "");
    }
    function bo(e, t) {
      const n = "ltr" === t;
      switch (e) {
        case mo.arrowleft:
          return n ? "left" : "right";
        case mo.arrowright:
          return n ? "right" : "left";
        case mo.arrowup:
          return "up";
        case mo.arrowdown:
          return "down";
      }
    }
    function _o(e) {
      return Array.isArray(e) ? e : [e];
    }
    const wo = function (e, t, n) {
      (void 0 !== n && !Ee(e[t], n) || void 0 === n && !(t in e)) && xt(e, t, n);
    };
    const Ao = function (e) {
      return function (t, n, i) {
        for (var o = -1, r = Object(t), s = i(t), a = s.length; a--;) {
          var l = s[e ? a : ++o];
          if (!1 === n(r[l], l, r)) break;
        }
        return t;
      };
    }();
    const vo = function (e) {
      return pe(e) && sn(e);
    };
    const Co = function (e, t) {
      if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
    };
    const yo = function (e) {
      return Dt(e, hn(e));
    };
    const xo = function (e, t, n, i, o, r, s) {
      var a = Co(e, n),
        l = Co(t, n),
        c = s.get(l);
      if (c) wo(e, n, c);else {
        var d = r ? r(a, l, n + "", e, t, s) : void 0,
          u = void 0 === d;
        if (u) {
          var h = me(l),
            m = !h && Ot(l),
            p = !h && !m && Qt(l);
          d = l, h || m || p ? me(a) ? d = a : vo(a) ? d = _n(a) : m ? (u = !1, d = bn(l, !0)) : p ? (u = !1, d = oi(l, !0)) : d = [] : ye(l) || zt(l) ? (d = a, zt(a) ? d = yo(a) : R(a) && !Oe(a) || (d = li(l))) : u = !1;
        }
        u && (s.set(l, d), o(d, l, i, r, s), s.delete(l)), wo(e, n, d);
      }
    };
    const Eo = function e(t, n, i, o, r) {
      t !== n && Ao(n, function (s, a) {
        if (r || (r = new vt()), R(s)) xo(t, n, a, i, e, o, r);else {
          var l = o ? o(Co(t, a), s, a + "", t, n, r) : void 0;
          void 0 === l && (l = s), wo(t, a, l);
        }
      }, hn);
    };
    const So = function (e) {
      return e;
    };
    const Do = function (e, t, n) {
      switch (n.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, n[0]);
        case 2:
          return e.call(t, n[0], n[1]);
        case 3:
          return e.call(t, n[0], n[1], n[2]);
      }
      return e.apply(t, n);
    };
    var To = Math.max;
    const Io = function (e, t, n) {
      return t = To(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var i = arguments, o = -1, r = To(i.length - t, 0), s = Array(r); ++o < r;) s[o] = i[t + o];
        o = -1;
        for (var a = Array(t + 1); ++o < t;) a[o] = i[o];
        return a[t] = n(s), Do(e, this, a);
      };
    };
    const Bo = function (e) {
      return function () {
        return e;
      };
    };
    const Mo = yt ? function (e, t) {
      return yt(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Bo(t),
        writable: !0
      });
    } : So;
    var Po = Date.now;
    const zo = function (e) {
      var t = 0,
        n = 0;
      return function () {
        var i = Po(),
          o = 16 - (i - n);
        if (n = i, o > 0) {
          if (++t >= 800) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    };
    const No = zo(Mo);
    const Lo = function (e, t) {
      return No(Io(e, t, So), e + "");
    };
    const Ro = function (e, t, n) {
      if (!R(n)) return !1;
      var i = typeof t;
      return !!("number" == i ? sn(n) && jt(t, n.length) : "string" == i && t in n) && Ee(n[t], e);
    };
    const Vo = function (e) {
      return Lo(function (t, n) {
        var i = -1,
          o = n.length,
          r = o > 1 ? n[o - 1] : void 0,
          s = o > 2 ? n[2] : void 0;
        for (r = e.length > 3 && "function" == typeof r ? (o--, r) : void 0, s && Ro(n[0], n[1], s) && (r = o < 3 ? void 0 : r, o = 1), t = Object(t); ++i < o;) {
          var a = n[i];
          a && e(t, a, i, r);
        }
        return t;
      });
    };
    const Oo = Vo(function (e, t, n) {
      Eo(e, t, n);
    });
    function Fo(e, n) {
      let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      let o = arguments.length > 3 ? arguments[3] : undefined;
      if ("number" != typeof i) throw new _("translation-service-quantity-not-a-number", null, {
        quantity: i
      });
      const r = o || t.window.CKEDITOR_TRANSLATIONS,
        s = function (e) {
          return Object.keys(e).length;
        }(r);
      1 === s && (e = Object.keys(r)[0]);
      const a = n.id || n.string;
      if (0 === s || !function (e, t, n) {
        return !!n[e] && !!n[e].dictionary[t];
      }(e, a, r)) return 1 !== i ? n.plural : n.string;
      const l = r[e].dictionary,
        c = r[e].getPluralForm || (e => 1 === e ? 0 : 1),
        d = l[a];
      if ("string" == typeof d) return d;
      return d[Number(c(i))];
    }
    t.window.CKEDITOR_TRANSLATIONS || (t.window.CKEDITOR_TRANSLATIONS = {});
    const jo = ["ar", "ara", "dv", "div", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
    function Ho(e) {
      return jo.includes(e) ? "rtl" : "ltr";
    }
    class Uo {
      constructor() {
        let {
          uiLanguage: e = "en",
          contentLanguage: t,
          translations: n
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.uiLanguage = e, this.contentLanguage = t || this.uiLanguage, this.uiLanguageDirection = Ho(this.uiLanguage), this.contentLanguageDirection = Ho(this.contentLanguage), this.translations = function (e) {
          return Array.isArray(e) ? e.reduce((e, t) => Oo(e, t)) : e;
        }(n), this.t = (e, t) => this._t(e, t);
      }
      get language() {
        return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
      }
      _t(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        t = _o(t), "string" == typeof e && (e = {
          string: e
        });
        const n = !!e.plural ? t[0] : 1;
        return function (e, t) {
          return e.replace(/%(\d+)/g, (e, n) => n < t.length ? t[n] : e);
        }(Fo(this.uiLanguage, e, n, this.translations), t);
      }
    }
    class qo extends T() {
      constructor() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        const n = X(e);
        if (n || (t = e), this._items = [], this._itemMap = new Map(), this._idProperty = t.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [], n) for (const t of e) this._items.push(t), this._itemMap.set(this._getItemIdBeforeAdding(t), t);
      }
      get length() {
        return this._items.length;
      }
      get first() {
        return this._items[0] || null;
      }
      get last() {
        return this._items[this.length - 1] || null;
      }
      add(e, t) {
        return this.addMany([e], t);
      }
      addMany(e, t) {
        if (void 0 === t) t = this._items.length;else if (t > this._items.length || t < 0) throw new _("collection-add-item-invalid-index", this);
        let n = 0;
        for (const i of e) {
          const e = this._getItemIdBeforeAdding(i),
            o = t + n;
          this._items.splice(o, 0, i), this._itemMap.set(e, i), this.fire("add", i, o), n++;
        }
        return this.fire("change", {
          added: e,
          removed: [],
          index: t
        }), this;
      }
      get(e) {
        let t;
        if ("string" == typeof e) t = this._itemMap.get(e);else {
          if ("number" != typeof e) throw new _("collection-get-invalid-arg", this);
          t = this._items[e];
        }
        return t || null;
      }
      has(e) {
        if ("string" == typeof e) return this._itemMap.has(e);
        {
          const t = e[this._idProperty];
          return t && this._itemMap.has(t);
        }
      }
      getIndex(e) {
        let t;
        return t = "string" == typeof e ? this._itemMap.get(e) : e, t ? this._items.indexOf(t) : -1;
      }
      remove(e) {
        const [t, n] = this._remove(e);
        return this.fire("change", {
          added: [],
          removed: [t],
          index: n
        }), t;
      }
      map(e, t) {
        return this._items.map(e, t);
      }
      forEach(e, t) {
        this._items.forEach(e, t);
      }
      find(e, t) {
        return this._items.find(e, t);
      }
      filter(e, t) {
        return this._items.filter(e, t);
      }
      clear() {
        this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
        const e = Array.from(this._items);
        for (; this.length;) this._remove(0);
        this.fire("change", {
          added: [],
          removed: e,
          index: 0
        });
      }
      bindTo(e) {
        if (this._bindToCollection) throw new _("collection-bind-to-rebind", this);
        return this._bindToCollection = e, {
          as: e => {
            this._setUpBindToBinding(t => new e(t));
          },
          using: e => {
            "function" == typeof e ? this._setUpBindToBinding(e) : this._setUpBindToBinding(t => t[e]);
          }
        };
      }
      _setUpBindToBinding(e) {
        const t = this._bindToCollection,
          n = (n, i, o) => {
            const r = t._bindToCollection == this,
              s = t._bindToInternalToExternalMap.get(i);
            if (r && s) this._bindToExternalToInternalMap.set(i, s), this._bindToInternalToExternalMap.set(s, i);else {
              const n = e(i);
              if (!n) return void this._skippedIndexesFromExternal.push(o);
              let r = o;
              for (const e of this._skippedIndexesFromExternal) o > e && r--;
              for (const e of t._skippedIndexesFromExternal) r >= e && r++;
              this._bindToExternalToInternalMap.set(i, n), this._bindToInternalToExternalMap.set(n, i), this.add(n, r);
              for (let e = 0; e < t._skippedIndexesFromExternal.length; e++) r <= t._skippedIndexesFromExternal[e] && t._skippedIndexesFromExternal[e]++;
            }
          };
        for (const e of t) n(0, e, t.getIndex(e));
        this.listenTo(t, "add", n), this.listenTo(t, "remove", (e, t, n) => {
          const i = this._bindToExternalToInternalMap.get(t);
          i && this.remove(i), this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((e, t) => (n < t && e.push(t - 1), n > t && e.push(t), e), []);
        });
      }
      _getItemIdBeforeAdding(e) {
        const t = this._idProperty;
        let n;
        if (t in e) {
          if (n = e[t], "string" != typeof n) throw new _("collection-add-invalid-id", this);
          if (this.get(n)) throw new _("collection-add-item-already-exists", this);
        } else e[t] = n = g();
        return n;
      }
      _remove(e) {
        let t,
          n,
          i,
          o = !1;
        const r = this._idProperty;
        if ("string" == typeof e ? (n = e, i = this._itemMap.get(n), o = !i, i && (t = this._items.indexOf(i))) : "number" == typeof e ? (t = e, i = this._items[t], o = !i, i && (n = i[r])) : (i = e, n = i[r], t = this._items.indexOf(i), o = -1 == t || !this._itemMap.get(n)), o) throw new _("collection-remove-404", this);
        this._items.splice(t, 1), this._itemMap.delete(n);
        const s = this._bindToInternalToExternalMap.get(i);
        return this._bindToInternalToExternalMap.delete(i), this._bindToExternalToInternalMap.delete(s), this.fire("remove", i, t), [i, t];
      }
      [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
      }
    }
    function Go(e) {
      const t = e.next();
      return t.done ? null : t.value;
    }
    class Ko extends Di(q()) {
      constructor() {
        super(), this._elements = new Set(), this._nextEventLoopTimeout = null, this.set("isFocused", !1), this.set("focusedElement", null);
      }
      add(e) {
        if (this._elements.has(e)) throw new _("focustracker-add-element-already-exist", this);
        this.listenTo(e, "focus", () => this._focus(e), {
          useCapture: !0
        }), this.listenTo(e, "blur", () => this._blur(), {
          useCapture: !0
        }), this._elements.add(e);
      }
      remove(e) {
        e === this.focusedElement && this._blur(), this._elements.has(e) && (this.stopListening(e), this._elements.delete(e));
      }
      destroy() {
        this.stopListening();
      }
      _focus(e) {
        clearTimeout(this._nextEventLoopTimeout), this.focusedElement = e, this.isFocused = !0;
      }
      _blur() {
        clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(() => {
          this.focusedElement = null, this.isFocused = !1;
        }, 0);
      }
    }
    class Wo {
      constructor() {
        this._listener = new (Di())();
      }
      listenTo(e) {
        this._listener.listenTo(e, "keydown", (e, t) => {
          this._listener.fire("_keydown:" + go(t), t);
        });
      }
      set(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = fo(e),
          o = n.priority;
        this._listener.listenTo(this._listener, "_keydown:" + i, (e, n) => {
          t(n, () => {
            n.preventDefault(), n.stopPropagation(), e.stop();
          }), e.return = !0;
        }, {
          priority: o
        });
      }
      press(e) {
        return !!this._listener.fire("_keydown:" + go(e), e);
      }
      stopListening(e) {
        this._listener.stopListening(e);
      }
      destroy() {
        this.stopListening();
      }
    }
    function Yo(e) {
      return X(e) ? new Map(e) : function (e) {
        const t = new Map();
        for (const n in e) t.set(n, e[n]);
        return t;
      }(e);
    }
    function $o(e, t) {
      let n;
      function i() {
        for (var _len10 = arguments.length, o = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          o[_key10] = arguments[_key10];
        }
        i.cancel(), n = setTimeout(() => e(...o), t);
      }
      return i.cancel = () => {
        clearTimeout(n);
      }, i;
    }
    function Zo(e, t) {
      return !!(n = e.charAt(t - 1)) && 1 == n.length && /[\ud800-\udbff]/.test(n) && function (e) {
        return !!e && 1 == e.length && /[\udc00-\udfff]/.test(e);
      }(e.charAt(t));
      var n;
    }
    function Qo(e, t) {
      return !!(n = e.charAt(t)) && 1 == n.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);
      var n;
    }
    const Jo = function () {
      const e = /\p{Regional_Indicator}{2}/u.source,
        t = "(?:" + [/\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u, /\p{Emoji}\u{FE0F}?\u{20E3}/u, /\p{Emoji}\u{FE0F}/u, /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u].map(e => e.source).join("|") + ")";
      return new RegExp("".concat(e, "|").concat(t, "(?:\u200D").concat(t, ")*"), "ug");
    }();
    function Xo(e, t) {
      const n = String(e).matchAll(Jo);
      return Array.from(n).some(e => e.index < t && t < e.index + e[0].length);
    }
    class er extends qo {
      constructor() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        super(e, {
          idProperty: "viewUid"
        }), this.on("add", (e, t, n) => {
          this._renderViewIntoCollectionParent(t, n);
        }), this.on("remove", (e, t) => {
          t.element && this._parentElement && t.element.remove();
        }), this._parentElement = null;
      }
      destroy() {
        this.map(e => e.destroy());
      }
      setParent(e) {
        this._parentElement = e;
        for (const e of this) this._renderViewIntoCollectionParent(e);
      }
      delegate() {
        for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          e[_key11] = arguments[_key11];
        }
        if (!e.length || !function (e) {
          return e.every(e => "string" == typeof e);
        }(e)) throw new _("ui-viewcollection-delegate-wrong-events", this);
        return {
          to: t => {
            for (const n of this) for (const i of e) n.delegate(i).to(t);
            this.on("add", (n, i) => {
              for (const n of e) i.delegate(n).to(t);
            }), this.on("remove", (n, i) => {
              for (const n of e) i.stopDelegating(n, t);
            });
          }
        };
      }
      _renderViewIntoCollectionParent(e, t) {
        e.isRendered || e.render(), e.element && this._parentElement && this._parentElement.insertBefore(e.element, this._parentElement.children[t]);
      }
      remove(e) {
        return super.remove(e);
      }
    }
    class tr extends T() {
      constructor(e) {
        super(), Object.assign(this, ur(dr(e))), this._isRendered = !1, this._revertData = null;
      }
      render() {
        const e = this._renderNode({
          intoFragment: !0
        });
        return this._isRendered = !0, e;
      }
      apply(e) {
        return this._revertData = {
          children: [],
          bindings: [],
          attributes: {}
        }, this._renderNode({
          node: e,
          intoFragment: !1,
          isApplying: !0,
          revertData: this._revertData
        }), e;
      }
      revert(e) {
        if (!this._revertData) throw new _("ui-template-revert-not-applied", [this, e]);
        this._revertTemplateFromNode(e, this._revertData);
      }
      *getViews() {
        yield* function* e(t) {
          if (t.children) for (const n of t.children) kr(n) ? yield n : br(n) && (yield* e(n));
        }(this);
      }
      static bind(e, t) {
        return {
          to: (n, i) => new ir({
            eventNameOrFunction: n,
            attribute: n,
            observable: e,
            emitter: t,
            callback: i
          }),
          if: (n, i, o) => new or({
            observable: e,
            emitter: t,
            attribute: n,
            valueIfTrue: i,
            callback: o
          })
        };
      }
      static extend(e, t) {
        if (e._isRendered) throw new _("template-extend-render", [this, e]);
        gr(e, ur(dr(t)));
      }
      _renderNode(e) {
        let t;
        if (t = e.node ? this.tag && this.text : this.tag ? this.text : !this.text, t) throw new _("ui-template-wrong-syntax", this);
        return this.text ? this._renderText(e) : this._renderElement(e);
      }
      _renderElement(e) {
        let t = e.node;
        return t || (t = e.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(e), this._renderElementChildren(e), this._setUpListeners(e), t;
      }
      _renderText(e) {
        let t = e.node;
        return t ? e.revertData.text = t.textContent : t = e.node = document.createTextNode(""), rr(this.text) ? this._bindToObservable({
          schema: this.text,
          updater: ar(t),
          data: e
        }) : t.textContent = this.text.join(""), t;
      }
      _renderAttributes(e) {
        if (!this.attributes) return;
        const t = e.node,
          n = e.revertData;
        for (const i in this.attributes) {
          const o = t.getAttribute(i),
            r = this.attributes[i];
          n && (n.attributes[i] = o);
          const s = wr(r) ? r[0].ns : null;
          if (rr(r)) {
            const a = wr(r) ? r[0].value : r;
            n && Ar(i) && a.unshift(o), this._bindToObservable({
              schema: a,
              updater: lr(t, i, s),
              data: e
            });
          } else if ("style" == i && "string" != typeof r[0]) this._renderStyleAttribute(r[0], e);else {
            n && o && Ar(i) && r.unshift(o);
            const e = r.map(e => e && e.value || e).reduce((e, t) => e.concat(t), []).reduce(mr, "");
            fr(e) || t.setAttributeNS(s, i, e);
          }
        }
      }
      _renderStyleAttribute(e, t) {
        const n = t.node;
        for (const i in e) {
          const o = e[i];
          rr(o) ? this._bindToObservable({
            schema: [o],
            updater: cr(n, i),
            data: t
          }) : n.style[i] = o;
        }
      }
      _renderElementChildren(e) {
        const t = e.node,
          n = e.intoFragment ? document.createDocumentFragment() : t,
          i = e.isApplying;
        let o = 0;
        for (const r of this.children) if (_r(r)) {
          if (!i) {
            r.setParent(t);
            for (const e of r) n.appendChild(e.element);
          }
        } else if (kr(r)) i || (r.isRendered || r.render(), n.appendChild(r.element));else if (xi(r)) n.appendChild(r);else if (i) {
          const t = {
            children: [],
            bindings: [],
            attributes: {}
          };
          e.revertData.children.push(t), r._renderNode({
            intoFragment: !1,
            node: n.childNodes[o++],
            isApplying: !0,
            revertData: t
          });
        } else n.appendChild(r.render());
        e.intoFragment && t.appendChild(n);
      }
      _setUpListeners(e) {
        if (this.eventListeners) for (const t in this.eventListeners) {
          const n = this.eventListeners[t].map(n => {
            const [i, o] = t.split("@");
            return n.activateDomEventListener(i, o, e);
          });
          e.revertData && e.revertData.bindings.push(n);
        }
      }
      _bindToObservable(_ref8) {
        let {
          schema: e,
          updater: t,
          data: n
        } = _ref8;
        const i = n.revertData;
        sr(e, t, n);
        const o = e.filter(e => !fr(e)).filter(e => e.observable).map(i => i.activateAttributeListener(e, t, n));
        i && i.bindings.push(o);
      }
      _revertTemplateFromNode(e, t) {
        for (const e of t.bindings) for (const t of e) t();
        if (t.text) return void (e.textContent = t.text);
        const n = e;
        for (const e in t.attributes) {
          const i = t.attributes[e];
          null === i ? n.removeAttribute(e) : n.setAttribute(e, i);
        }
        for (let e = 0; e < t.children.length; ++e) this._revertTemplateFromNode(n.childNodes[e], t.children[e]);
      }
    }
    class nr {
      constructor(e) {
        this.attribute = e.attribute, this.observable = e.observable, this.emitter = e.emitter, this.callback = e.callback;
      }
      getValue(e) {
        const t = this.observable[this.attribute];
        return this.callback ? this.callback(t, e) : t;
      }
      activateAttributeListener(e, t, n) {
        const i = () => sr(e, t, n);
        return this.emitter.listenTo(this.observable, "change:".concat(this.attribute), i), () => {
          this.emitter.stopListening(this.observable, "change:".concat(this.attribute), i);
        };
      }
    }
    class ir extends nr {
      constructor(e) {
        super(e), this.eventNameOrFunction = e.eventNameOrFunction;
      }
      activateDomEventListener(e, t, n) {
        const i = (e, n) => {
          t && !n.target.matches(t) || ("function" == typeof this.eventNameOrFunction ? this.eventNameOrFunction(n) : this.observable.fire(this.eventNameOrFunction, n));
        };
        return this.emitter.listenTo(n.node, e, i), () => {
          this.emitter.stopListening(n.node, e, i);
        };
      }
    }
    class or extends nr {
      constructor(e) {
        super(e), this.valueIfTrue = e.valueIfTrue;
      }
      getValue(e) {
        return !fr(super.getValue(e)) && (this.valueIfTrue || !0);
      }
    }
    function rr(e) {
      return !!e && (e.value && (e = e.value), Array.isArray(e) ? e.some(rr) : e instanceof nr);
    }
    function sr(e, t, _ref9) {
      let {
        node: n
      } = _ref9;
      const i = function (e, t) {
        return e.map(e => e instanceof nr ? e.getValue(t) : e);
      }(e, n);
      let o;
      o = 1 == e.length && e[0] instanceof or ? i[0] : i.reduce(mr, ""), fr(o) ? t.remove() : t.set(o);
    }
    function ar(e) {
      return {
        set(t) {
          e.textContent = t;
        },
        remove() {
          e.textContent = "";
        }
      };
    }
    function lr(e, t, n) {
      return {
        set(i) {
          e.setAttributeNS(n, t, i);
        },
        remove() {
          e.removeAttributeNS(n, t);
        }
      };
    }
    function cr(e, t) {
      return {
        set(n) {
          e.style[t] = n;
        },
        remove() {
          e.style[t] = null;
        }
      };
    }
    function dr(e) {
      return wi(e, e => {
        if (e && (e instanceof nr || br(e) || kr(e) || _r(e))) return e;
      });
    }
    function ur(e) {
      if ("string" == typeof e ? e = function (e) {
        return {
          text: [e]
        };
      }(e) : e.text && function (e) {
        e.text = _o(e.text);
      }(e), e.on && (e.eventListeners = function (e) {
        for (const t in e) hr(e, t);
        return e;
      }(e.on), delete e.on), !e.text) {
        e.attributes && function (e) {
          for (const t in e) e[t].value && (e[t].value = _o(e[t].value)), hr(e, t);
        }(e.attributes);
        const t = [];
        if (e.children) if (_r(e.children)) t.push(e.children);else for (const n of e.children) br(n) || kr(n) || xi(n) ? t.push(n) : t.push(new tr(n));
        e.children = t;
      }
      return e;
    }
    function hr(e, t) {
      e[t] = _o(e[t]);
    }
    function mr(e, t) {
      return fr(t) ? e : fr(e) ? t : "".concat(e, " ").concat(t);
    }
    function pr(e, t) {
      for (const n in t) e[n] ? e[n].push(...t[n]) : e[n] = t[n];
    }
    function gr(e, t) {
      if (t.attributes && (e.attributes || (e.attributes = {}), pr(e.attributes, t.attributes)), t.eventListeners && (e.eventListeners || (e.eventListeners = {}), pr(e.eventListeners, t.eventListeners)), t.text && e.text.push(...t.text), t.children && t.children.length) {
        if (e.children.length != t.children.length) throw new _("ui-template-extend-children-mismatch", e);
        let n = 0;
        for (const i of t.children) gr(e.children[n++], i);
      }
    }
    function fr(e) {
      return !e && 0 !== e;
    }
    function kr(e) {
      return e instanceof Er;
    }
    function br(e) {
      return e instanceof tr;
    }
    function _r(e) {
      return e instanceof er;
    }
    function wr(e) {
      return R(e[0]) && e[0].ns;
    }
    function Ar(e) {
      return "class" == e || "style" == e;
    }
    var vr = o(5072),
      Cr = o.n(vr),
      yr = o(7247),
      xr = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(yr.A, xr);
    yr.A.locals;
    class Er extends Di(q()) {
      constructor(e) {
        super(), this.element = null, this.isRendered = !1, this.locale = e, this.t = e && e.t, this._viewCollections = new qo(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", (t, n) => {
          n.locale = e, n.t = e && e.t;
        }), this.decorate("render");
      }
      get bindTemplate() {
        return this._bindTemplate ? this._bindTemplate : this._bindTemplate = tr.bind(this, this);
      }
      createCollection(e) {
        const t = new er(e);
        return this._viewCollections.add(t), t;
      }
      registerChild(e) {
        X(e) || (e = [e]);
        for (const t of e) this._unboundChildren.add(t);
      }
      deregisterChild(e) {
        X(e) || (e = [e]);
        for (const t of e) this._unboundChildren.remove(t);
      }
      setTemplate(e) {
        this.template = new tr(e);
      }
      extendTemplate(e) {
        tr.extend(this.template, e);
      }
      render() {
        if (this.isRendered) throw new _("ui-view-render-already-rendered", this);
        this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
      }
      destroy() {
        this.stopListening(), this._viewCollections.map(e => e.destroy()), this.template && this.template._revertData && this.template.revert(this.element);
      }
    }
    function Sr(_ref10) {
      let {
        emitter: e,
        activator: t,
        callback: n,
        contextElements: i
      } = _ref10;
      e.listenTo(document, "mousedown", (e, o) => {
        if (!t()) return;
        const r = "function" == typeof o.composedPath ? o.composedPath() : [],
          s = "function" == typeof i ? i() : i;
        for (const e of s) if (e.contains(o.target) || r.includes(e)) return;
        n();
      });
    }
    function Dr(e) {
      return class extends e {
        disableCssTransitions() {
          this._isCssTransitionsDisabled = !0;
        }
        enableCssTransitions() {
          this._isCssTransitionsDisabled = !1;
        }
        constructor() {
          super(...arguments), this.set("_isCssTransitionsDisabled", !1), this.initializeCssTransitionDisablerMixin();
        }
        initializeCssTransitionDisablerMixin() {
          this.extendTemplate({
            attributes: {
              class: [this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
            }
          });
        }
      };
    }
    function Tr(_ref11) {
      let {
        view: e
      } = _ref11;
      e.listenTo(e.element, "submit", (t, n) => {
        n.preventDefault(), e.fire("submit");
      }, {
        useCapture: !0
      });
    }
    function Ir(_ref12) {
      let {
        keystrokeHandler: e,
        focusTracker: t,
        gridItems: n,
        numberOfColumns: i,
        uiLanguageDirection: o
      } = _ref12;
      const r = "number" == typeof i ? () => i : i;
      function s(e) {
        return i => {
          const o = n.find(e => e.element === t.focusedElement),
            r = n.getIndex(o),
            s = e(r, n);
          n.get(s).focus(), i.stopPropagation(), i.preventDefault();
        };
      }
      function a(e, t) {
        return e === t - 1 ? 0 : e + 1;
      }
      function l(e, t) {
        return 0 === e ? t - 1 : e - 1;
      }
      e.set("arrowright", s((e, t) => "rtl" === o ? l(e, t.length) : a(e, t.length))), e.set("arrowleft", s((e, t) => "rtl" === o ? a(e, t.length) : l(e, t.length))), e.set("arrowup", s((e, t) => {
        let n = e - r();
        return n < 0 && (n = e + r() * Math.floor(t.length / r()), n > t.length - 1 && (n -= r())), n;
      })), e.set("arrowdown", s((e, t) => {
        let n = e + r();
        return n > t.length - 1 && (n = e % r()), n;
      }));
    }
    class Br extends q() {
      constructor(e) {
        super(), this._disableStack = new Set(), this.editor = e, this.set("isEnabled", !0);
      }
      forceDisabled(e) {
        this._disableStack.add(e), 1 == this._disableStack.size && (this.on("set:isEnabled", Mr, {
          priority: "highest"
        }), this.isEnabled = !1);
      }
      clearForceDisabled(e) {
        this._disableStack.delete(e), 0 == this._disableStack.size && (this.off("set:isEnabled", Mr), this.isEnabled = !0);
      }
      destroy() {
        this.stopListening();
      }
      static get isContextPlugin() {
        return !1;
      }
    }
    function Mr(e) {
      e.return = !1, e.stop();
    }
    class Pr extends q() {
      constructor(e) {
        super(), this.editor = e, this.set("value", void 0), this.set("isEnabled", !1), this._affectsData = !0, this._isEnabledBasedOnSelection = !0, this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", () => {
          this.refresh();
        }), this.listenTo(e, "change:isReadOnly", () => {
          this.refresh();
        }), this.on("set:isEnabled", t => {
          if (!this.affectsData) return;
          const n = e.model.document.selection,
            i = !("$graveyard" == n.getFirstPosition().root.rootName) && e.model.canEditAt(n);
          (e.isReadOnly || this._isEnabledBasedOnSelection && !i) && (t.return = !1, t.stop());
        }, {
          priority: "highest"
        }), this.on("execute", e => {
          this.isEnabled || e.stop();
        }, {
          priority: "high"
        });
      }
      get affectsData() {
        return this._affectsData;
      }
      set affectsData(e) {
        this._affectsData = e;
      }
      refresh() {
        this.isEnabled = !0;
      }
      forceDisabled(e) {
        this._disableStack.add(e), 1 == this._disableStack.size && (this.on("set:isEnabled", zr, {
          priority: "highest"
        }), this.isEnabled = !1);
      }
      clearForceDisabled(e) {
        this._disableStack.delete(e), 0 == this._disableStack.size && (this.off("set:isEnabled", zr), this.refresh());
      }
      execute() {}
      destroy() {
        this.stopListening();
      }
    }
    function zr(e) {
      e.return = !1, e.stop();
    }
    class Nr extends Pr {
      constructor() {
        super(...arguments), this._childCommandsDefinitions = [];
      }
      refresh() {}
      execute() {
        const t = this._getFirstEnabledCommand();
        for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          e[_key12] = arguments[_key12];
        }
        return !!t && t.execute(e);
      }
      registerChildCommand(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        k(this._childCommandsDefinitions, {
          command: e,
          priority: t.priority || "normal"
        }), e.on("change:isEnabled", () => this._checkEnabled()), this._checkEnabled();
      }
      _checkEnabled() {
        this.isEnabled = !!this._getFirstEnabledCommand();
      }
      _getFirstEnabledCommand() {
        const e = this._childCommandsDefinitions.find(_ref13 => {
          let {
            command: e
          } = _ref13;
          return e.isEnabled;
        });
        return e && e.command;
      }
    }
    class Lr extends T() {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        super(), this._plugins = new Map(), this._context = e, this._availablePlugins = new Map();
        for (const e of t) e.pluginName && this._availablePlugins.set(e.pluginName, e);
        this._contextPlugins = new Map();
        for (const [e, t] of n) this._contextPlugins.set(e, t), this._contextPlugins.set(t, e), e.pluginName && this._availablePlugins.set(e.pluginName, e);
      }
      *[Symbol.iterator]() {
        for (const e of this._plugins) "function" == typeof e[0] && (yield e);
      }
      get(e) {
        const t = this._plugins.get(e);
        if (!t) {
          let t = e;
          throw "function" == typeof e && (t = e.pluginName || e.name), new _("plugincollection-plugin-not-loaded", this._context, {
            plugin: t
          });
        }
        return t;
      }
      has(e) {
        return this._plugins.has(e);
      }
      init(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        const i = this,
          o = this._context;
        !function e(t) {
          let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
          t.forEach(t => {
            a(t) && (n.has(t) || (n.add(t), t.pluginName && !i._availablePlugins.has(t.pluginName) && i._availablePlugins.set(t.pluginName, t), t.requires && e(t.requires, n)));
          });
        }(e), u(e);
        const r = [...function e(t) {
          let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
          return t.map(e => a(e) ? e : i._availablePlugins.get(e)).reduce((t, i) => n.has(i) ? t : (n.add(i), i.requires && (u(i.requires, i), e(i.requires, n).forEach(e => t.add(e))), t.add(i)), new Set());
        }(e.filter(e => !c(e, t)))];
        !function (e, t) {
          for (const n of t) {
            if ("function" != typeof n) throw new _("plugincollection-replace-plugin-invalid-type", null, {
              pluginItem: n
            });
            const t = n.pluginName;
            if (!t) throw new _("plugincollection-replace-plugin-missing-name", null, {
              pluginItem: n
            });
            if (n.requires && n.requires.length) throw new _("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
              pluginName: t
            });
            const o = i._availablePlugins.get(t);
            if (!o) throw new _("plugincollection-plugin-for-replacing-not-exist", null, {
              pluginName: t
            });
            const r = e.indexOf(o);
            if (-1 === r) {
              if (i._contextPlugins.has(o)) return;
              throw new _("plugincollection-plugin-for-replacing-not-loaded", null, {
                pluginName: t
              });
            }
            if (o.requires && o.requires.length) throw new _("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
              pluginName: t
            });
            e.splice(r, 1, n), i._availablePlugins.set(t, n);
          }
        }(r, n);
        const s = function (e) {
          return e.map(e => {
            let t = i._contextPlugins.get(e);
            return t = t || new e(o), i._add(e, t), t;
          });
        }(r);
        return h(s, "init").then(() => h(s, "afterInit")).then(() => s);
        function a(e) {
          return "function" == typeof e;
        }
        function l(e) {
          return a(e) && !!e.isContextPlugin;
        }
        function c(e, t) {
          return t.some(t => t === e || d(e) === t || d(t) === e);
        }
        function d(e) {
          return a(e) ? e.pluginName || e.name : e;
        }
        function u(e) {
          let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          e.map(e => a(e) ? e : i._availablePlugins.get(e) || e).forEach(e => {
            !function (e, t) {
              if (a(e)) return;
              if (t) throw new _("plugincollection-soft-required", o, {
                missingPlugin: e,
                requiredBy: d(t)
              });
              throw new _("plugincollection-plugin-not-found", o, {
                plugin: e
              });
            }(e, n), function (e, t) {
              if (!l(t)) return;
              if (l(e)) return;
              throw new _("plugincollection-context-required", o, {
                plugin: d(e),
                requiredBy: d(t)
              });
            }(e, n), function (e, n) {
              if (!n) return;
              if (!c(e, t)) return;
              throw new _("plugincollection-required", o, {
                plugin: d(e),
                requiredBy: d(n)
              });
            }(e, n);
          });
        }
        function h(e, t) {
          return e.reduce((e, n) => n[t] ? i._contextPlugins.has(n) ? e : e.then(n[t].bind(n)) : e, Promise.resolve());
        }
      }
      destroy() {
        const e = [];
        for (const [, t] of this) "function" != typeof t.destroy || this._contextPlugins.has(t) || e.push(t.destroy());
        return Promise.all(e);
      }
      _add(e, t) {
        this._plugins.set(e, t);
        const n = e.pluginName;
        if (n) {
          if (this._plugins.has(n)) throw new _("plugincollection-plugin-name-conflict", null, {
            pluginName: n,
            plugin1: this._plugins.get(n).constructor,
            plugin2: e
          });
          this._plugins.set(n, t);
        }
      }
    }
    class Rr {
      constructor(e) {
        this._contextOwner = null;
        const {
          translations: t,
          ...n
        } = e || {};
        this.config = new vi(n, this.constructor.defaultConfig);
        const i = this.constructor.builtinPlugins;
        this.config.define("plugins", i), this.plugins = new Lr(this, i);
        const o = this.config.get("language") || {};
        this.locale = new Uo({
          uiLanguage: "string" == typeof o ? o : o.ui,
          contentLanguage: this.config.get("language.content"),
          translations: t
        }), this.t = this.locale.t, this.editors = new qo();
      }
      initPlugins() {
        const e = this.config.get("plugins") || [],
          t = this.config.get("substitutePlugins") || [];
        for (const n of e.concat(t)) {
          if ("function" != typeof n) throw new _("context-initplugins-constructor-only", null, {
            Plugin: n
          });
          if (!0 !== n.isContextPlugin) throw new _("context-initplugins-invalid-plugin", null, {
            Plugin: n
          });
        }
        return this.plugins.init(e, [], t);
      }
      destroy() {
        return Promise.all(Array.from(this.editors, e => e.destroy())).then(() => this.plugins.destroy());
      }
      _addEditor(e, t) {
        if (this._contextOwner) throw new _("context-addeditor-private-context");
        this.editors.add(e), t && (this._contextOwner = e);
      }
      _removeEditor(e) {
        return this.editors.has(e) && this.editors.remove(e), this._contextOwner === e ? this.destroy() : Promise.resolve();
      }
      _getEditorConfig() {
        const e = {};
        for (const t of this.config.names()) ["plugins", "removePlugins", "extraPlugins"].includes(t) || (e[t] = this.config.get(t));
        return e;
      }
      static create(e) {
        return new Promise(t => {
          const n = new this(e);
          t(n.initPlugins().then(() => n));
        });
      }
    }
    class Vr extends q() {
      constructor(e) {
        super(), this.context = e;
      }
      destroy() {
        this.stopListening();
      }
      static get isContextPlugin() {
        return !0;
      }
    }
    var Or = o(121),
      Fr = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Or.A, Fr);
    Or.A.locals;
    const jr = new WeakMap();
    let Hr = !1;
    function Ur(_ref14) {
      let {
        view: e,
        element: t,
        text: n,
        isDirectHost: i = !0,
        keepOnFocus: o = !1
      } = _ref14;
      const r = e.document;
      function s(n) {
        jr.get(r).set(t, {
          text: n,
          isDirectHost: i,
          keepOnFocus: o,
          hostElement: i ? t : null
        }), e.change(e => Wr(r, e));
      }
      jr.has(r) || (jr.set(r, new Map()), r.registerPostFixer(e => Wr(r, e)), r.on("change:isComposing", () => {
        e.change(e => Wr(r, e));
      }, {
        priority: "high"
      })), t.is("editableElement") && t.on("change:placeholder", (e, t, n) => {
        s(n);
      }), t.placeholder ? s(t.placeholder) : n && s(n), n && function () {
        Hr || w("enableplaceholder-deprecated-text-option");
        Hr = !0;
      }();
    }
    function qr(e, t) {
      return !t.hasClass("ck-placeholder") && (e.addClass("ck-placeholder", t), !0);
    }
    function Gr(e, t) {
      return !!t.hasClass("ck-placeholder") && (e.removeClass("ck-placeholder", t), !0);
    }
    function Kr(e, t) {
      if (!e.isAttached()) return !1;
      const n = Array.from(e.getChildren()).some(e => !e.is("uiElement"));
      if (n) return !1;
      const i = e.document,
        o = i.selection.anchor;
      return (!i.isComposing || !o || o.parent !== e) && (!!t || !i.isFocused || !!o && o.parent !== e);
    }
    function Wr(e, t) {
      const n = jr.get(e),
        i = [];
      let o = !1;
      for (const [e, r] of n) r.isDirectHost && (i.push(e), Yr(t, e, r) && (o = !0));
      for (const [e, r] of n) {
        if (r.isDirectHost) continue;
        const n = $r(e);
        n && (i.includes(n) || (r.hostElement = n, Yr(t, e, r) && (o = !0)));
      }
      return o;
    }
    function Yr(e, t, n) {
      const {
        text: i,
        isDirectHost: o,
        hostElement: r
      } = n;
      let s = !1;
      r.getAttribute("data-placeholder") !== i && (e.setAttribute("data-placeholder", i, r), s = !0);
      return (o || 1 == t.childCount) && Kr(r, n.keepOnFocus) ? qr(e, r) && (s = !0) : Gr(e, r) && (s = !0), s;
    }
    function $r(e) {
      if (e.childCount) {
        const t = e.getChild(0);
        if (t.is("element") && !t.is("uiElement") && !t.is("attributeElement")) return t;
      }
      return null;
    }
    class Zr {
      is() {
        throw new Error("is() method is abstract");
      }
    }
    const Qr = function (e) {
      return _i(e, 4);
    };
    class Jr extends T(Zr) {
      constructor(e) {
        super(), this.document = e, this.parent = null;
      }
      get index() {
        let e;
        if (!this.parent) return null;
        if (-1 == (e = this.parent.getChildIndex(this))) throw new _("view-node-not-found-in-parent", this);
        return e;
      }
      get nextSibling() {
        const e = this.index;
        return null !== e && this.parent.getChild(e + 1) || null;
      }
      get previousSibling() {
        const e = this.index;
        return null !== e && this.parent.getChild(e - 1) || null;
      }
      get root() {
        let e = this;
        for (; e.parent;) e = e.parent;
        return e;
      }
      isAttached() {
        return this.root.is("rootElement");
      }
      getPath() {
        const e = [];
        let t = this;
        for (; t.parent;) e.unshift(t.index), t = t.parent;
        return e;
      }
      getAncestors() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = [];
        let n = e.includeSelf ? this : this.parent;
        for (; n;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return t;
      }
      getCommonAncestor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.getAncestors(t),
          i = e.getAncestors(t);
        let o = 0;
        for (; n[o] == i[o] && n[o];) o++;
        return 0 === o ? null : n[o - 1];
      }
      isBefore(e) {
        if (this == e) return !1;
        if (this.root !== e.root) return !1;
        const t = this.getPath(),
          n = e.getPath(),
          i = J(t, n);
        switch (i) {
          case "prefix":
            return !0;
          case "extension":
            return !1;
          default:
            return t[i] < n[i];
        }
      }
      isAfter(e) {
        return this != e && this.root === e.root && !this.isBefore(e);
      }
      _remove() {
        this.parent._removeChildren(this.index);
      }
      _fireChange(e, t) {
        this.fire("change:".concat(e), t), this.parent && this.parent._fireChange(e, t);
      }
      toJSON() {
        const e = Qr(this);
        return delete e.parent, e;
      }
    }
    Jr.prototype.is = function (e) {
      return "node" === e || "view:node" === e;
    };
    class Xr extends Jr {
      constructor(e, t) {
        super(e), this._textData = t;
      }
      get data() {
        return this._textData;
      }
      get _data() {
        return this.data;
      }
      set _data(e) {
        this._fireChange("text", this), this._textData = e;
      }
      isSimilar(e) {
        return e instanceof Xr && (this === e || this.data === e.data);
      }
      _clone() {
        return new Xr(this.document, this.data);
      }
    }
    Xr.prototype.is = function (e) {
      return "$text" === e || "view:$text" === e || "text" === e || "view:text" === e || "node" === e || "view:node" === e;
    };
    class es extends Zr {
      constructor(e, t, n) {
        if (super(), this.textNode = e, t < 0 || t > e.data.length) throw new _("view-textproxy-wrong-offsetintext", this);
        if (n < 0 || t + n > e.data.length) throw new _("view-textproxy-wrong-length", this);
        this.data = e.data.substring(t, t + n), this.offsetInText = t;
      }
      get offsetSize() {
        return this.data.length;
      }
      get isPartial() {
        return this.data.length !== this.textNode.data.length;
      }
      get parent() {
        return this.textNode.parent;
      }
      get root() {
        return this.textNode.root;
      }
      get document() {
        return this.textNode.document;
      }
      getAncestors() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = [];
        let n = e.includeSelf ? this.textNode : this.parent;
        for (; null !== n;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return t;
      }
    }
    es.prototype.is = function (e) {
      return "$textProxy" === e || "view:$textProxy" === e || "textProxy" === e || "view:textProxy" === e;
    };
    class ts {
      constructor() {
        this._patterns = [], this.add(...arguments);
      }
      add() {
        for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
          e[_key13] = arguments[_key13];
        }
        for (let t of e) ("string" == typeof t || t instanceof RegExp) && (t = {
          name: t
        }), this._patterns.push(t);
      }
      match() {
        for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
          e[_key14] = arguments[_key14];
        }
        for (const t of e) for (const e of this._patterns) {
          const n = ns(t, e);
          if (n) return {
            element: t,
            pattern: e,
            match: n
          };
        }
        return null;
      }
      matchAll() {
        const t = [];
        for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
          e[_key15] = arguments[_key15];
        }
        for (const n of e) for (const e of this._patterns) {
          const i = ns(n, e);
          i && t.push({
            element: n,
            pattern: e,
            match: i
          });
        }
        return t.length > 0 ? t : null;
      }
      getElementName() {
        if (1 !== this._patterns.length) return null;
        const e = this._patterns[0],
          t = e.name;
        return "function" == typeof e || !t || t instanceof RegExp ? null : t;
      }
    }
    function ns(e, t) {
      if ("function" == typeof t) return t(e);
      const n = {};
      return t.name && (n.name = function (e, t) {
        if (e instanceof RegExp) return !!t.match(e);
        return e === t;
      }(t.name, e.name), !n.name) || t.attributes && (n.attributes = function (e, t) {
        const n = new Set(t.getAttributeKeys());
        ye(e) ? (void 0 !== e.style && w("matcher-pattern-deprecated-attributes-style-key", e), void 0 !== e.class && w("matcher-pattern-deprecated-attributes-class-key", e)) : (n.delete("style"), n.delete("class"));
        return is(e, n, e => t.getAttribute(e));
      }(t.attributes, e), !n.attributes) || t.classes && (n.classes = function (e, t) {
        return is(e, t.getClassNames(), () => {});
      }(t.classes, e), !n.classes) || t.styles && (n.styles = function (e, t) {
        return is(e, t.getStyleNames(!0), e => t.getStyle(e));
      }(t.styles, e), !n.styles) ? null : n;
    }
    function is(e, t, n) {
      const i = function (e) {
          if (Array.isArray(e)) return e.map(e => ye(e) ? (void 0 !== e.key && void 0 !== e.value || w("matcher-pattern-missing-key-or-value", e), [e.key, e.value]) : [e, !0]);
          if (ye(e)) return Object.entries(e);
          return [[e, !0]];
        }(e),
        o = Array.from(t),
        r = [];
      if (i.forEach(_ref15 => {
        let [e, t] = _ref15;
        o.forEach(i => {
          (function (e, t) {
            return !0 === e || e === t || e instanceof RegExp && t.match(e);
          })(e, i) && function (e, t, n) {
            if (!0 === e) return !0;
            const i = n(t);
            return e === i || e instanceof RegExp && !!String(i).match(e);
          }(t, i, n) && r.push(i);
        });
      }), i.length && !(r.length < i.length)) return r;
    }
    const os = function (e) {
      return "symbol" == typeof e || pe(e) && "[object Symbol]" == he(e);
    };
    var rs = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      ss = /^\w*$/;
    const as = function (e, t) {
      if (me(e)) return !1;
      var n = typeof e;
      return !("number" != n && "symbol" != n && "boolean" != n && null != e && !os(e)) || ss.test(e) || !rs.test(e) || null != t && e in Object(t);
    };
    function ls(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
      var n = function () {
        var i = arguments,
          o = t ? t.apply(this, i) : i[0],
          r = n.cache;
        if (r.has(o)) return r.get(o);
        var s = e.apply(this, i);
        return n.cache = r.set(o, s) || r, s;
      };
      return n.cache = new (ls.Cache || _t)(), n;
    }
    ls.Cache = _t;
    const cs = ls;
    const ds = function (e) {
      var t = cs(e, function (e) {
          return 500 === n.size && n.clear(), e;
        }),
        n = t.cache;
      return t;
    };
    var us = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      hs = /\\(\\)?/g,
      ms = ds(function (e) {
        var t = [];
        return 46 === e.charCodeAt(0) && t.push(""), e.replace(us, function (e, n, i, o) {
          t.push(i ? o.replace(hs, "$1") : n || e);
        }), t;
      });
    const ps = ms;
    const gs = function (e, t) {
      for (var n = -1, i = null == e ? 0 : e.length, o = Array(i); ++n < i;) o[n] = t(e[n], n, e);
      return o;
    };
    var fs = ie ? ie.prototype : void 0,
      ks = fs ? fs.toString : void 0;
    const bs = function e(t) {
      if ("string" == typeof t) return t;
      if (me(t)) return gs(t, e) + "";
      if (os(t)) return ks ? ks.call(t) : "";
      var n = t + "";
      return "0" == n && 1 / t == -1 / 0 ? "-0" : n;
    };
    const _s = function (e) {
      return null == e ? "" : bs(e);
    };
    const ws = function (e, t) {
      return me(e) ? e : as(e, t) ? [e] : ps(_s(e));
    };
    const As = function (e) {
      var t = null == e ? 0 : e.length;
      return t ? e[t - 1] : void 0;
    };
    const vs = function (e) {
      if ("string" == typeof e || os(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
    };
    const Cs = function (e, t) {
      for (var n = 0, i = (t = ws(t, e)).length; null != e && n < i;) e = e[vs(t[n++])];
      return n && n == i ? e : void 0;
    };
    const ys = function (e, t, n) {
      var i = -1,
        o = e.length;
      t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
      for (var r = Array(o); ++i < o;) r[i] = e[i + t];
      return r;
    };
    const xs = function (e, t) {
      return t.length < 2 ? e : Cs(e, ys(t, 0, -1));
    };
    const Es = function (e, t) {
      return t = ws(t, e), null == (e = xs(e, t)) || delete e[vs(As(t))];
    };
    const Ss = function (e, t) {
      return null == e || Es(e, t);
    };
    const Ds = function (e, t, n) {
      var i = null == e ? void 0 : Cs(e, t);
      return void 0 === i ? n : i;
    };
    const Ts = function (e, t, n, i) {
      if (!R(e)) return e;
      for (var o = -1, r = (t = ws(t, e)).length, s = r - 1, a = e; null != a && ++o < r;) {
        var l = vs(t[o]),
          c = n;
        if ("__proto__" === l || "constructor" === l || "prototype" === l) return e;
        if (o != s) {
          var d = a[l];
          void 0 === (c = i ? i(d, l, a) : void 0) && (c = R(d) ? d : jt(t[o + 1]) ? [] : {});
        }
        St(a, l, c), a = a[l];
      }
      return e;
    };
    const Is = function (e, t, n) {
      return null == e ? e : Ts(e, t, n);
    };
    class Bs {
      constructor(e) {
        this._styles = {}, this._styleProcessor = e;
      }
      get isEmpty() {
        return !Object.entries(this._styles).length;
      }
      get size() {
        return this.isEmpty ? 0 : this.getStyleNames().length;
      }
      setTo(e) {
        this.clear();
        const t = function (e) {
          let t = null,
            n = 0,
            i = 0,
            o = null;
          const r = new Map();
          if ("" === e) return r;
          ";" != e.charAt(e.length - 1) && (e += ";");
          for (let s = 0; s < e.length; s++) {
            const a = e.charAt(s);
            if (null === t) switch (a) {
              case ":":
                o || (o = e.substr(n, s - n), i = s + 1);
                break;
              case '"':
              case "'":
                t = a;
                break;
              case ";":
                {
                  const t = e.substr(i, s - i);
                  o && r.set(o.trim(), t.trim()), o = null, n = s + 1;
                  break;
                }
            } else a === t && (t = null);
          }
          return r;
        }(e);
        for (const [e, n] of t) this._styleProcessor.toNormalizedForm(e, n, this._styles);
      }
      has(e) {
        if (this.isEmpty) return !1;
        const t = this._styleProcessor.getReducedForm(e, this._styles).find(_ref16 => {
          let [t] = _ref16;
          return t === e;
        });
        return Array.isArray(t);
      }
      set(e, t) {
        if (R(e)) for (const [t, n] of Object.entries(e)) this._styleProcessor.toNormalizedForm(t, n, this._styles);else this._styleProcessor.toNormalizedForm(e, t, this._styles);
      }
      remove(e) {
        const t = Ps(e);
        Ss(this._styles, t), delete this._styles[e], this._cleanEmptyObjectsOnPath(t);
      }
      getNormalized(e) {
        return this._styleProcessor.getNormalized(e, this._styles);
      }
      toString() {
        return this.isEmpty ? "" : this.getStylesEntries().map(e => e.join(":")).sort().join(";") + ";";
      }
      getAsString(e) {
        if (this.isEmpty) return;
        if (this._styles[e] && !R(this._styles[e])) return this._styles[e];
        const t = this._styleProcessor.getReducedForm(e, this._styles).find(_ref17 => {
          let [t] = _ref17;
          return t === e;
        });
        return Array.isArray(t) ? t[1] : void 0;
      }
      getStyleNames() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        if (this.isEmpty) return [];
        if (e) return this._styleProcessor.getStyleNames(this._styles);
        return this.getStylesEntries().map(_ref18 => {
          let [e] = _ref18;
          return e;
        });
      }
      clear() {
        this._styles = {};
      }
      getStylesEntries() {
        const e = [],
          t = Object.keys(this._styles);
        for (const n of t) e.push(...this._styleProcessor.getReducedForm(n, this._styles));
        return e;
      }
      _cleanEmptyObjectsOnPath(e) {
        const t = e.split(".");
        if (!(t.length > 1)) return;
        const n = t.splice(0, t.length - 1).join("."),
          i = Ds(this._styles, n);
        if (!i) return;
        !Object.keys(i).length && this.remove(n);
      }
    }
    class Ms {
      constructor() {
        this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
      }
      toNormalizedForm(e, t, n) {
        if (R(t)) zs(n, Ps(e), t);else if (this._normalizers.has(e)) {
          const i = this._normalizers.get(e),
            {
              path: o,
              value: r
            } = i(t);
          zs(n, o, r);
        } else zs(n, e, t);
      }
      getNormalized(e, t) {
        if (!e) return Oo({}, t);
        if (void 0 !== t[e]) return t[e];
        if (this._extractors.has(e)) {
          const n = this._extractors.get(e);
          if ("string" == typeof n) return Ds(t, n);
          const i = n(e, t);
          if (i) return i;
        }
        return Ds(t, Ps(e));
      }
      getReducedForm(e, t) {
        const n = this.getNormalized(e, t);
        if (void 0 === n) return [];
        if (this._reducers.has(e)) {
          return this._reducers.get(e)(n);
        }
        return [[e, n]];
      }
      getStyleNames(e) {
        const t = Array.from(this._consumables.keys()).filter(t => {
            const n = this.getNormalized(t, e);
            return n && "object" == typeof n ? Object.keys(n).length : n;
          }),
          n = new Set([...t, ...Object.keys(e)]);
        return Array.from(n);
      }
      getRelatedStyles(e) {
        return this._consumables.get(e) || [];
      }
      setNormalizer(e, t) {
        this._normalizers.set(e, t);
      }
      setExtractor(e, t) {
        this._extractors.set(e, t);
      }
      setReducer(e, t) {
        this._reducers.set(e, t);
      }
      setStyleRelation(e, t) {
        this._mapStyleNames(e, t);
        for (const n of t) this._mapStyleNames(n, [e]);
      }
      _mapStyleNames(e, t) {
        this._consumables.has(e) || this._consumables.set(e, []), this._consumables.get(e).push(...t);
      }
    }
    function Ps(e) {
      return e.replace("-", ".");
    }
    function zs(e, t, n) {
      let i = n;
      R(n) && (i = Oo({}, Ds(e, t), n)), Is(e, t, i);
    }
    class Ns extends Jr {
      constructor(e, t, n, i) {
        if (super(e), this._unsafeAttributesToRender = [], this._customProperties = new Map(), this.name = t, this._attrs = function (e) {
          const t = Yo(e);
          for (const [e, n] of t) null === n ? t.delete(e) : "string" != typeof n && t.set(e, String(n));
          return t;
        }(n), this._children = [], i && this._insertChild(0, i), this._classes = new Set(), this._attrs.has("class")) {
          const e = this._attrs.get("class");
          Ls(this._classes, e), this._attrs.delete("class");
        }
        this._styles = new Bs(this.document.stylesProcessor), this._attrs.has("style") && (this._styles.setTo(this._attrs.get("style")), this._attrs.delete("style"));
      }
      get childCount() {
        return this._children.length;
      }
      get isEmpty() {
        return 0 === this._children.length;
      }
      getChild(e) {
        return this._children[e];
      }
      getChildIndex(e) {
        return this._children.indexOf(e);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      *getAttributeKeys() {
        this._classes.size > 0 && (yield "class"), this._styles.isEmpty || (yield "style"), yield* this._attrs.keys();
      }
      *getAttributes() {
        yield* this._attrs.entries(), this._classes.size > 0 && (yield ["class", this.getAttribute("class")]), this._styles.isEmpty || (yield ["style", this.getAttribute("style")]);
      }
      getAttribute(e) {
        if ("class" == e) return this._classes.size > 0 ? [...this._classes].join(" ") : void 0;
        if ("style" == e) {
          const e = this._styles.toString();
          return "" == e ? void 0 : e;
        }
        return this._attrs.get(e);
      }
      hasAttribute(e) {
        return "class" == e ? this._classes.size > 0 : "style" == e ? !this._styles.isEmpty : this._attrs.has(e);
      }
      isSimilar(e) {
        if (!(e instanceof Ns)) return !1;
        if (this === e) return !0;
        if (this.name != e.name) return !1;
        if (this._attrs.size !== e._attrs.size || this._classes.size !== e._classes.size || this._styles.size !== e._styles.size) return !1;
        for (const [t, n] of this._attrs) if (!e._attrs.has(t) || e._attrs.get(t) !== n) return !1;
        for (const t of this._classes) if (!e._classes.has(t)) return !1;
        for (const t of this._styles.getStyleNames()) if (!e._styles.has(t) || e._styles.getAsString(t) !== this._styles.getAsString(t)) return !1;
        return !0;
      }
      hasClass() {
        for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
          e[_key16] = arguments[_key16];
        }
        for (const t of e) if (!this._classes.has(t)) return !1;
        return !0;
      }
      getClassNames() {
        return this._classes.keys();
      }
      getStyle(e) {
        return this._styles.getAsString(e);
      }
      getNormalizedStyle(e) {
        return this._styles.getNormalized(e);
      }
      getStyleNames(e) {
        return this._styles.getStyleNames(e);
      }
      hasStyle() {
        for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
          e[_key17] = arguments[_key17];
        }
        for (const t of e) if (!this._styles.has(t)) return !1;
        return !0;
      }
      findAncestor() {
        for (var _len18 = arguments.length, e = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
          e[_key18] = arguments[_key18];
        }
        const t = new ts(...e);
        let n = this.parent;
        for (; n && !n.is("documentFragment");) {
          if (t.match(n)) return n;
          n = n.parent;
        }
        return null;
      }
      getCustomProperty(e) {
        return this._customProperties.get(e);
      }
      *getCustomProperties() {
        yield* this._customProperties.entries();
      }
      getIdentity() {
        const e = Array.from(this._classes).sort().join(","),
          t = this._styles.toString(),
          n = Array.from(this._attrs).map(e => "".concat(e[0], "=\"").concat(e[1], "\"")).sort().join(" ");
        return this.name + ("" == e ? "" : " class=\"".concat(e, "\"")) + (t ? " style=\"".concat(t, "\"") : "") + ("" == n ? "" : " ".concat(n));
      }
      shouldRenderUnsafeAttribute(e) {
        return this._unsafeAttributesToRender.includes(e);
      }
      _clone() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        const t = [];
        if (e) for (const n of this.getChildren()) t.push(n._clone(e));
        const n = new this.constructor(this.document, this.name, this._attrs, t);
        return n._classes = new Set(this._classes), n._styles.set(this._styles.getNormalized()), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n._unsafeAttributesToRender = this._unsafeAttributesToRender, n;
      }
      _appendChild(e) {
        return this._insertChild(this.childCount, e);
      }
      _insertChild(e, t) {
        this._fireChange("children", this);
        let n = 0;
        const i = function (e, t) {
          if ("string" == typeof t) return [new Xr(e, t)];
          X(t) || (t = [t]);
          return Array.from(t).map(t => "string" == typeof t ? new Xr(e, t) : t instanceof es ? new Xr(e, t.data) : t);
        }(this.document, t);
        for (const t of i) null !== t.parent && t._remove(), t.parent = this, t.document = this.document, this._children.splice(e, 0, t), e++, n++;
        return n;
      }
      _removeChildren(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        this._fireChange("children", this);
        for (let n = e; n < e + t; n++) this._children[n].parent = null;
        return this._children.splice(e, t);
      }
      _setAttribute(e, t) {
        const n = String(t);
        this._fireChange("attributes", this), "class" == e ? Ls(this._classes, n) : "style" == e ? this._styles.setTo(n) : this._attrs.set(e, n);
      }
      _removeAttribute(e) {
        return this._fireChange("attributes", this), "class" == e ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == e ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(e);
      }
      _addClass(e) {
        this._fireChange("attributes", this);
        for (const t of _o(e)) this._classes.add(t);
      }
      _removeClass(e) {
        this._fireChange("attributes", this);
        for (const t of _o(e)) this._classes.delete(t);
      }
      _setStyle(e, t) {
        this._fireChange("attributes", this), "string" != typeof e ? this._styles.set(e) : this._styles.set(e, t);
      }
      _removeStyle(e) {
        this._fireChange("attributes", this);
        for (const t of _o(e)) this._styles.remove(t);
      }
      _setCustomProperty(e, t) {
        this._customProperties.set(e, t);
      }
      _removeCustomProperty(e) {
        return this._customProperties.delete(e);
      }
    }
    function Ls(e, t) {
      const n = t.split(/\s+/);
      e.clear(), n.forEach(t => e.add(t));
    }
    Ns.prototype.is = function (e, t) {
      return t ? t === this.name && ("element" === e || "view:element" === e) : "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    class Rs extends Ns {
      constructor(e, t, n, i) {
        super(e, t, n, i), this.getFillerOffset = Vs;
      }
    }
    function Vs() {
      const e = [...this.getChildren()],
        t = e[this.childCount - 1];
      if (t && t.is("element", "br")) return this.childCount;
      for (const t of e) if (!t.is("uiElement")) return null;
      return this.childCount;
    }
    Rs.prototype.is = function (e, t) {
      return t ? t === this.name && ("containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    class Os extends q(Rs) {
      constructor(e, t, n, i) {
        super(e, t, n, i), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("placeholder", void 0), this.bind("isReadOnly").to(e), this.bind("isFocused").to(e, "isFocused", t => t && e.selection.editableElement == this), this.listenTo(e.selection, "change", () => {
          this.isFocused = e.isFocused && e.selection.editableElement == this;
        });
      }
      destroy() {
        this.stopListening();
      }
    }
    Os.prototype.is = function (e, t) {
      return t ? t === this.name && ("editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    const Fs = Symbol("rootName");
    class js extends Os {
      constructor(e, t) {
        super(e, t), this.rootName = "main";
      }
      get rootName() {
        return this.getCustomProperty(Fs);
      }
      set rootName(e) {
        this._setCustomProperty(Fs, e);
      }
      set _name(e) {
        this.name = e;
      }
    }
    js.prototype.is = function (e, t) {
      return t ? t === this.name && ("rootElement" === e || "view:rootElement" === e || "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "rootElement" === e || "view:rootElement" === e || "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    class Hs {
      constructor() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!e.boundaries && !e.startPosition) throw new _("view-tree-walker-no-start-position", null);
        if (e.direction && "forward" != e.direction && "backward" != e.direction) throw new _("view-tree-walker-unknown-direction", e.startPosition, {
          direction: e.direction
        });
        this.boundaries = e.boundaries || null, e.startPosition ? this._position = Us._createAt(e.startPosition) : this._position = Us._createAt(e.boundaries["backward" == e.direction ? "end" : "start"]), this.direction = e.direction || "forward", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }
      [Symbol.iterator]() {
        return this;
      }
      get position() {
        return this._position;
      }
      skip(e) {
        let t, n;
        do {
          n = this.position, t = this.next();
        } while (!t.done && e(t.value));
        t.done || (this._position = n);
      }
      next() {
        return "forward" == this.direction ? this._next() : this._previous();
      }
      _next() {
        let e = this.position.clone();
        const t = this.position,
          n = e.parent;
        if (null === n.parent && e.offset === n.childCount) return {
          done: !0,
          value: void 0
        };
        if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
          done: !0,
          value: void 0
        };
        let i;
        if (n instanceof Xr) {
          if (e.isAtEnd) return this._position = Us._createAfter(n), this._next();
          i = n.data[e.offset];
        } else i = n.getChild(e.offset);
        if (i instanceof Ns) {
          if (this.shallow) {
            if (this.boundaries && this.boundaries.end.isBefore(e)) return {
              done: !0,
              value: void 0
            };
            e.offset++;
          } else e = new Us(i, 0);
          return this._position = e, this._formatReturnValue("elementStart", i, t, e, 1);
        }
        if (i instanceof Xr) {
          if (this.singleCharacters) return e = new Us(i, 0), this._position = e, this._next();
          let n,
            o = i.data.length;
          return i == this._boundaryEndParent ? (o = this.boundaries.end.offset, n = new es(i, 0, o), e = Us._createAfter(n)) : (n = new es(i, 0, i.data.length), e.offset++), this._position = e, this._formatReturnValue("text", n, t, e, o);
        }
        if ("string" == typeof i) {
          let i;
          if (this.singleCharacters) i = 1;else {
            i = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - e.offset;
          }
          const o = new es(n, e.offset, i);
          return e.offset += i, this._position = e, this._formatReturnValue("text", o, t, e, i);
        }
        return e = Us._createAfter(n), this._position = e, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, t, e);
      }
      _previous() {
        let e = this.position.clone();
        const t = this.position,
          n = e.parent;
        if (null === n.parent && 0 === e.offset) return {
          done: !0,
          value: void 0
        };
        if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
          done: !0,
          value: void 0
        };
        let i;
        if (n instanceof Xr) {
          if (e.isAtStart) return this._position = Us._createBefore(n), this._previous();
          i = n.data[e.offset - 1];
        } else i = n.getChild(e.offset - 1);
        if (i instanceof Ns) return this.shallow ? (e.offset--, this._position = e, this._formatReturnValue("elementStart", i, t, e, 1)) : (e = new Us(i, i.childCount), this._position = e, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", i, t, e));
        if (i instanceof Xr) {
          if (this.singleCharacters) return e = new Us(i, i.data.length), this._position = e, this._previous();
          let n,
            o = i.data.length;
          if (i == this._boundaryStartParent) {
            const t = this.boundaries.start.offset;
            n = new es(i, t, i.data.length - t), o = n.data.length, e = Us._createBefore(n);
          } else n = new es(i, 0, i.data.length), e.offset--;
          return this._position = e, this._formatReturnValue("text", n, t, e, o);
        }
        if ("string" == typeof i) {
          let i;
          if (this.singleCharacters) i = 1;else {
            const t = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
            i = e.offset - t;
          }
          e.offset -= i;
          const o = new es(n, e.offset, i);
          return this._position = e, this._formatReturnValue("text", o, t, e, i);
        }
        return e = Us._createBefore(n), this._position = e, this._formatReturnValue("elementStart", n, t, e, 1);
      }
      _formatReturnValue(e, t, n, i, o) {
        return t instanceof es && (t.offsetInText + t.data.length == t.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = Us._createAfter(t.textNode) : (i = Us._createAfter(t.textNode), this._position = i)), 0 === t.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = Us._createBefore(t.textNode) : (i = Us._createBefore(t.textNode), this._position = i))), {
          done: !1,
          value: {
            type: e,
            item: t,
            previousPosition: n,
            nextPosition: i,
            length: o
          }
        };
      }
    }
    class Us extends Zr {
      constructor(e, t) {
        super(), this.parent = e, this.offset = t;
      }
      get nodeAfter() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
      }
      get nodeBefore() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
      }
      get isAtStart() {
        return 0 === this.offset;
      }
      get isAtEnd() {
        const e = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
        return this.offset === e;
      }
      get root() {
        return this.parent.root;
      }
      get editableElement() {
        let e = this.parent;
        for (; !(e instanceof Os);) {
          if (!e.parent) return null;
          e = e.parent;
        }
        return e;
      }
      getShiftedBy(e) {
        const t = Us._createAt(this),
          n = t.offset + e;
        return t.offset = n < 0 ? 0 : n, t;
      }
      getLastMatchingPosition(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        t.startPosition = this;
        const n = new Hs(t);
        return n.skip(e), n.position;
      }
      getAncestors() {
        return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
          includeSelf: !0
        });
      }
      getCommonAncestor(e) {
        const t = this.getAncestors(),
          n = e.getAncestors();
        let i = 0;
        for (; t[i] == n[i] && t[i];) i++;
        return 0 === i ? null : t[i - 1];
      }
      isEqual(e) {
        return this.parent == e.parent && this.offset == e.offset;
      }
      isBefore(e) {
        return "before" == this.compareWith(e);
      }
      isAfter(e) {
        return "after" == this.compareWith(e);
      }
      compareWith(e) {
        if (this.root !== e.root) return "different";
        if (this.isEqual(e)) return "same";
        const t = this.parent.is("node") ? this.parent.getPath() : [],
          n = e.parent.is("node") ? e.parent.getPath() : [];
        t.push(this.offset), n.push(e.offset);
        const i = J(t, n);
        switch (i) {
          case "prefix":
            return "before";
          case "extension":
            return "after";
          default:
            return t[i] < n[i] ? "before" : "after";
        }
      }
      getWalker() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return e.startPosition = this, new Hs(e);
      }
      clone() {
        return new Us(this.parent, this.offset);
      }
      static _createAt(e, t) {
        if (e instanceof Us) return new this(e.parent, e.offset);
        {
          const n = e;
          if ("end" == t) t = n.is("$text") ? n.data.length : n.childCount;else {
            if ("before" == t) return this._createBefore(n);
            if ("after" == t) return this._createAfter(n);
            if (0 !== t && !t) throw new _("view-createpositionat-offset-required", n);
          }
          return new Us(n, t);
        }
      }
      static _createAfter(e) {
        if (e.is("$textProxy")) return new Us(e.textNode, e.offsetInText + e.data.length);
        if (!e.parent) throw new _("view-position-after-root", e, {
          root: e
        });
        return new Us(e.parent, e.index + 1);
      }
      static _createBefore(e) {
        if (e.is("$textProxy")) return new Us(e.textNode, e.offsetInText);
        if (!e.parent) throw new _("view-position-before-root", e, {
          root: e
        });
        return new Us(e.parent, e.index);
      }
    }
    Us.prototype.is = function (e) {
      return "position" === e || "view:position" === e;
    };
    class qs extends Zr {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        super(), this.start = e.clone(), this.end = t ? t.clone() : e.clone();
      }
      *[Symbol.iterator]() {
        yield* new Hs({
          boundaries: this,
          ignoreElementEnd: !0
        });
      }
      get isCollapsed() {
        return this.start.isEqual(this.end);
      }
      get isFlat() {
        return this.start.parent === this.end.parent;
      }
      get root() {
        return this.start.root;
      }
      getEnlarged() {
        let e = this.start.getLastMatchingPosition(Gs, {
            direction: "backward"
          }),
          t = this.end.getLastMatchingPosition(Gs);
        return e.parent.is("$text") && e.isAtStart && (e = Us._createBefore(e.parent)), t.parent.is("$text") && t.isAtEnd && (t = Us._createAfter(t.parent)), new qs(e, t);
      }
      getTrimmed() {
        let e = this.start.getLastMatchingPosition(Gs);
        if (e.isAfter(this.end) || e.isEqual(this.end)) return new qs(e, e);
        let t = this.end.getLastMatchingPosition(Gs, {
          direction: "backward"
        });
        const n = e.nodeAfter,
          i = t.nodeBefore;
        return n && n.is("$text") && (e = new Us(n, 0)), i && i.is("$text") && (t = new Us(i, i.data.length)), new qs(e, t);
      }
      isEqual(e) {
        return this == e || this.start.isEqual(e.start) && this.end.isEqual(e.end);
      }
      containsPosition(e) {
        return e.isAfter(this.start) && e.isBefore(this.end);
      }
      containsRange(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        e.isCollapsed && (t = !1);
        const n = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
          i = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
        return n && i;
      }
      getDifference(e) {
        const t = [];
        return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new qs(this.start, e.start)), this.containsPosition(e.end) && t.push(new qs(e.end, this.end))) : t.push(this.clone()), t;
      }
      getIntersection(e) {
        if (this.isIntersecting(e)) {
          let t = this.start,
            n = this.end;
          return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new qs(t, n);
        }
        return null;
      }
      getWalker() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return e.boundaries = this, new Hs(e);
      }
      getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
      }
      getContainedElement() {
        if (this.isCollapsed) return null;
        let e = this.start.nodeAfter,
          t = this.end.nodeBefore;
        return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (e = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (t = this.end.parent.previousSibling), e && e.is("element") && e === t ? e : null;
      }
      clone() {
        return new qs(this.start, this.end);
      }
      getItems() {
        var _this2 = this;
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          e.boundaries = _this2, e.ignoreElementEnd = !0;
          const t = new Hs(e);
          for (const e of t) yield e.item;
        }();
      }
      getPositions() {
        var _this3 = this;
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          e.boundaries = _this3;
          const t = new Hs(e);
          yield t.position;
          for (const e of t) yield e.nextPosition;
        }();
      }
      isIntersecting(e) {
        return this.start.isBefore(e.end) && this.end.isAfter(e.start);
      }
      static _createFromParentsAndOffsets(e, t, n, i) {
        return new this(new Us(e, t), new Us(n, i));
      }
      static _createFromPositionAndShift(e, t) {
        const n = e,
          i = e.getShiftedBy(t);
        return t > 0 ? new this(n, i) : new this(i, n);
      }
      static _createIn(e) {
        return this._createFromParentsAndOffsets(e, 0, e, e.childCount);
      }
      static _createOn(e) {
        const t = e.is("$textProxy") ? e.offsetSize : 1;
        return this._createFromPositionAndShift(Us._createBefore(e), t);
      }
    }
    function Gs(e) {
      return !(!e.item.is("attributeElement") && !e.item.is("uiElement"));
    }
    qs.prototype.is = function (e) {
      return "range" === e || "view:range" === e;
    };
    class Ks extends T(Zr) {
      constructor() {
        super(), this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", arguments.length && this.setTo(...arguments);
      }
      get isFake() {
        return this._isFake;
      }
      get fakeSelectionLabel() {
        return this._fakeSelectionLabel;
      }
      get anchor() {
        if (!this._ranges.length) return null;
        const e = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? e.end : e.start).clone();
      }
      get focus() {
        if (!this._ranges.length) return null;
        const e = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? e.start : e.end).clone();
      }
      get isCollapsed() {
        return 1 === this.rangeCount && this._ranges[0].isCollapsed;
      }
      get rangeCount() {
        return this._ranges.length;
      }
      get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
      }
      get editableElement() {
        return this.anchor ? this.anchor.editableElement : null;
      }
      *getRanges() {
        for (const e of this._ranges) yield e.clone();
      }
      getFirstRange() {
        let e = null;
        for (const t of this._ranges) e && !t.start.isBefore(e.start) || (e = t);
        return e ? e.clone() : null;
      }
      getLastRange() {
        let e = null;
        for (const t of this._ranges) e && !t.end.isAfter(e.end) || (e = t);
        return e ? e.clone() : null;
      }
      getFirstPosition() {
        const e = this.getFirstRange();
        return e ? e.start.clone() : null;
      }
      getLastPosition() {
        const e = this.getLastRange();
        return e ? e.end.clone() : null;
      }
      isEqual(e) {
        if (this.isFake != e.isFake) return !1;
        if (this.isFake && this.fakeSelectionLabel != e.fakeSelectionLabel) return !1;
        if (this.rangeCount != e.rangeCount) return !1;
        if (0 === this.rangeCount) return !0;
        if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
        for (const t of this._ranges) {
          let n = !1;
          for (const i of e._ranges) if (t.isEqual(i)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      isSimilar(e) {
        if (this.isBackward != e.isBackward) return !1;
        const t = Q(this.getRanges());
        if (t != Q(e.getRanges())) return !1;
        if (0 == t) return !0;
        for (let t of this.getRanges()) {
          t = t.getTrimmed();
          let n = !1;
          for (let i of e.getRanges()) if (i = i.getTrimmed(), t.start.isEqual(i.start) && t.end.isEqual(i.end)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      getSelectedElement() {
        return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
      }
      setTo() {
        for (var _len19 = arguments.length, e = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
          e[_key19] = arguments[_key19];
        }
        let [t, n, i] = e;
        if ("object" == typeof n && (i = n, n = void 0), null === t) this._setRanges([]), this._setFakeOptions(i);else if (t instanceof Ks || t instanceof Ws) this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({
          fake: t.isFake,
          label: t.fakeSelectionLabel
        });else if (t instanceof qs) this._setRanges([t], i && i.backward), this._setFakeOptions(i);else if (t instanceof Us) this._setRanges([new qs(t)]), this._setFakeOptions(i);else if (t instanceof Jr) {
          const e = !!i && !!i.backward;
          let o;
          if (void 0 === n) throw new _("view-selection-setto-required-second-parameter", this);
          o = "in" == n ? qs._createIn(t) : "on" == n ? qs._createOn(t) : new qs(Us._createAt(t, n)), this._setRanges([o], e), this._setFakeOptions(i);
        } else {
          if (!X(t)) throw new _("view-selection-setto-not-selectable", this);
          this._setRanges(t, i && i.backward), this._setFakeOptions(i);
        }
        this.fire("change");
      }
      setFocus(e, t) {
        if (null === this.anchor) throw new _("view-selection-setfocus-no-ranges", this);
        const n = Us._createAt(e, t);
        if ("same" == n.compareWith(this.focus)) return;
        const i = this.anchor;
        this._ranges.pop(), "before" == n.compareWith(i) ? this._addRange(new qs(n, i), !0) : this._addRange(new qs(i, n)), this.fire("change");
      }
      _setRanges(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        e = Array.from(e), this._ranges = [];
        for (const t of e) this._addRange(t);
        this._lastRangeBackward = !!t;
      }
      _setFakeOptions() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._isFake = !!e.fake, this._fakeSelectionLabel = e.fake && e.label || "";
      }
      _addRange(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        if (!(e instanceof qs)) throw new _("view-selection-add-range-not-range", this);
        this._pushRange(e), this._lastRangeBackward = !!t;
      }
      _pushRange(e) {
        for (const t of this._ranges) if (e.isIntersecting(t)) throw new _("view-selection-range-intersects", this, {
          addedRange: e,
          intersectingRange: t
        });
        this._ranges.push(new qs(e.start, e.end));
      }
    }
    Ks.prototype.is = function (e) {
      return "selection" === e || "view:selection" === e;
    };
    class Ws extends T(Zr) {
      constructor() {
        super(), this._selection = new Ks(), this._selection.delegate("change").to(this), arguments.length && this._selection.setTo(...arguments);
      }
      get isFake() {
        return this._selection.isFake;
      }
      get fakeSelectionLabel() {
        return this._selection.fakeSelectionLabel;
      }
      get anchor() {
        return this._selection.anchor;
      }
      get focus() {
        return this._selection.focus;
      }
      get isCollapsed() {
        return this._selection.isCollapsed;
      }
      get rangeCount() {
        return this._selection.rangeCount;
      }
      get isBackward() {
        return this._selection.isBackward;
      }
      get editableElement() {
        return this._selection.editableElement;
      }
      get _ranges() {
        return this._selection._ranges;
      }
      *getRanges() {
        yield* this._selection.getRanges();
      }
      getFirstRange() {
        return this._selection.getFirstRange();
      }
      getLastRange() {
        return this._selection.getLastRange();
      }
      getFirstPosition() {
        return this._selection.getFirstPosition();
      }
      getLastPosition() {
        return this._selection.getLastPosition();
      }
      getSelectedElement() {
        return this._selection.getSelectedElement();
      }
      isEqual(e) {
        return this._selection.isEqual(e);
      }
      isSimilar(e) {
        return this._selection.isSimilar(e);
      }
      _setTo() {
        this._selection.setTo(...arguments);
      }
      _setFocus(e, t) {
        this._selection.setFocus(e, t);
      }
    }
    Ws.prototype.is = function (e) {
      return "selection" === e || "documentSelection" == e || "view:selection" == e || "view:documentSelection" == e;
    };
    class Ys extends m {
      constructor(e, t, n) {
        super(e, t), this.startRange = n, this._eventPhase = "none", this._currentTarget = null;
      }
      get eventPhase() {
        return this._eventPhase;
      }
      get currentTarget() {
        return this._currentTarget;
      }
    }
    const $s = Symbol("bubbling contexts");
    function Zs(e) {
      return class extends e {
        fire(e) {
          try {
            const n = e instanceof m ? e : new m(this, e),
              i = ea(this);
            if (!i.size) return;
            for (var _len20 = arguments.length, t = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
              t[_key20 - 1] = arguments[_key20];
            }
            if (Qs(n, "capturing", this), Js(i, "$capture", n, ...t)) return n.return;
            const o = n.startRange || this.selection.getFirstRange(),
              r = o ? o.getContainedElement() : null,
              s = !!r && Boolean(Xs(i, r));
            let a = r || function (e) {
              if (!e) return null;
              const t = e.start.parent,
                n = e.end.parent,
                i = t.getPath(),
                o = n.getPath();
              return i.length > o.length ? t : n;
            }(o);
            if (Qs(n, "atTarget", a), !s) {
              if (Js(i, "$text", n, ...t)) return n.return;
              Qs(n, "bubbling", a);
            }
            for (; a;) {
              if (a.is("rootElement")) {
                if (Js(i, "$root", n, ...t)) return n.return;
              } else if (a.is("element") && Js(i, a.name, n, ...t)) return n.return;
              if (Js(i, a, n, ...t)) return n.return;
              a = a.parent, Qs(n, "bubbling", a);
            }
            return Qs(n, "bubbling", this), Js(i, "$document", n, ...t), n.return;
          } catch (e) {
            _.rethrowUnexpectedError(e, this);
          }
        }
        _addEventListener(e, t, n) {
          const i = _o(n.context || "$document"),
            o = ea(this);
          for (const r of i) {
            let i = o.get(r);
            i || (i = new (T())(), o.set(r, i)), this.listenTo(i, e, t, n);
          }
        }
        _removeEventListener(e, t) {
          const n = ea(this);
          for (const i of n.values()) this.stopListening(i, e, t);
        }
      };
    }
    {
      const e = Zs(Object);
      ["fire", "_addEventListener", "_removeEventListener"].forEach(t => {
        Zs[t] = e.prototype[t];
      });
    }
    function Qs(e, t, n) {
      e instanceof Ys && (e._eventPhase = t, e._currentTarget = n);
    }
    function Js(e, t, n) {
      const o = "string" == typeof t ? e.get(t) : Xs(e, t);
      for (var _len21 = arguments.length, i = new Array(_len21 > 3 ? _len21 - 3 : 0), _key21 = 3; _key21 < _len21; _key21++) {
        i[_key21 - 3] = arguments[_key21];
      }
      return !!o && (o.fire(n, ...i), n.stop.called);
    }
    function Xs(e, t) {
      for (const [n, i] of e) if ("function" == typeof n && n(t)) return i;
      return null;
    }
    function ea(e) {
      return e[$s] || (e[$s] = new Map()), e[$s];
    }
    class ta extends Zs(q()) {
      constructor(e) {
        super(), this._postFixers = new Set(), this.selection = new Ws(), this.roots = new qo({
          idProperty: "rootName"
        }), this.stylesProcessor = e, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isSelecting", !1), this.set("isComposing", !1);
      }
      getRoot() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this.roots.get(e);
      }
      registerPostFixer(e) {
        this._postFixers.add(e);
      }
      destroy() {
        this.roots.forEach(e => e.destroy()), this.stopListening();
      }
      _callPostFixers(e) {
        let t = !1;
        do {
          for (const n of this._postFixers) if (t = n(e), t) break;
        } while (t);
      }
    }
    class na extends Ns {
      constructor(e, t, n, i) {
        super(e, t, n, i), this._priority = 10, this._id = null, this._clonesGroup = null, this.getFillerOffset = oa;
      }
      get priority() {
        return this._priority;
      }
      get id() {
        return this._id;
      }
      getElementsWithSameId() {
        if (null === this.id) throw new _("attribute-element-get-elements-with-same-id-no-id", this);
        return new Set(this._clonesGroup);
      }
      isSimilar(e) {
        return null !== this.id || null !== e.id ? this.id === e.id : super.isSimilar(e) && this.priority == e.priority;
      }
      _clone() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        const t = super._clone(e);
        return t._priority = this._priority, t._id = this._id, t;
      }
    }
    na.DEFAULT_PRIORITY = 10;
    const ia = na;
    function oa() {
      if (ra(this)) return null;
      let e = this.parent;
      for (; e && e.is("attributeElement");) {
        if (ra(e) > 1) return null;
        e = e.parent;
      }
      return !e || ra(e) > 1 ? null : this.childCount;
    }
    function ra(e) {
      return Array.from(e.getChildren()).filter(e => !e.is("uiElement")).length;
    }
    na.prototype.is = function (e, t) {
      return t ? t === this.name && ("attributeElement" === e || "view:attributeElement" === e || "element" === e || "view:element" === e) : "attributeElement" === e || "view:attributeElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    class sa extends Ns {
      constructor(e, t, n, i) {
        super(e, t, n, i), this.getFillerOffset = aa;
      }
      _insertChild(e, t) {
        if (t && (t instanceof Jr || Array.from(t).length > 0)) throw new _("view-emptyelement-cannot-add", [this, t]);
        return 0;
      }
    }
    function aa() {
      return null;
    }
    sa.prototype.is = function (e, t) {
      return t ? t === this.name && ("emptyElement" === e || "view:emptyElement" === e || "element" === e || "view:element" === e) : "emptyElement" === e || "view:emptyElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    class la extends Ns {
      constructor(e, t, n, i) {
        super(e, t, n, i), this.getFillerOffset = da;
      }
      _insertChild(e, t) {
        if (t && (t instanceof Jr || Array.from(t).length > 0)) throw new _("view-uielement-cannot-add", [this, t]);
        return 0;
      }
      render(e, t) {
        return this.toDomElement(e);
      }
      toDomElement(e) {
        const t = e.createElement(this.name);
        for (const e of this.getAttributeKeys()) t.setAttribute(e, this.getAttribute(e));
        return t;
      }
    }
    function ca(e) {
      e.document.on("arrowKey", (t, n) => function (e, t, n) {
        if (t.keyCode == mo.arrowright) {
          const e = t.domTarget.ownerDocument.defaultView.getSelection(),
            i = 1 == e.rangeCount && e.getRangeAt(0).collapsed;
          if (i || t.shiftKey) {
            const t = e.focusNode,
              o = e.focusOffset,
              r = n.domPositionToView(t, o);
            if (null === r) return;
            let s = !1;
            const a = r.getLastMatchingPosition(e => (e.item.is("uiElement") && (s = !0), !(!e.item.is("uiElement") && !e.item.is("attributeElement"))));
            if (s) {
              const t = n.viewPositionToDom(a);
              i ? e.collapse(t.parent, t.offset) : e.extend(t.parent, t.offset);
            }
          }
        }
      }(0, n, e.domConverter), {
        priority: "low"
      });
    }
    function da() {
      return null;
    }
    la.prototype.is = function (e, t) {
      return t ? t === this.name && ("uiElement" === e || "view:uiElement" === e || "element" === e || "view:element" === e) : "uiElement" === e || "view:uiElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    class ua extends Ns {
      constructor(e, t, n, i) {
        super(e, t, n, i), this.getFillerOffset = ha;
      }
      _insertChild(e, t) {
        if (t && (t instanceof Jr || Array.from(t).length > 0)) throw new _("view-rawelement-cannot-add", [this, t]);
        return 0;
      }
      render(e, t) {}
    }
    function ha() {
      return null;
    }
    ua.prototype.is = function (e, t) {
      return t ? t === this.name && ("rawElement" === e || "view:rawElement" === e || "element" === e || "view:element" === e) : "rawElement" === e || "view:rawElement" === e || e === this.name || e === "view:" + this.name || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
    };
    class ma extends T(Zr) {
      constructor(e, t) {
        super(), this._children = [], this._customProperties = new Map(), this.document = e, t && this._insertChild(0, t);
      }
      [Symbol.iterator]() {
        return this._children[Symbol.iterator]();
      }
      get childCount() {
        return this._children.length;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      get root() {
        return this;
      }
      get parent() {
        return null;
      }
      get name() {}
      get getFillerOffset() {}
      getCustomProperty(e) {
        return this._customProperties.get(e);
      }
      *getCustomProperties() {
        yield* this._customProperties.entries();
      }
      _appendChild(e) {
        return this._insertChild(this.childCount, e);
      }
      getChild(e) {
        return this._children[e];
      }
      getChildIndex(e) {
        return this._children.indexOf(e);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      _insertChild(e, t) {
        this._fireChange("children", this);
        let n = 0;
        const i = function (e, t) {
          if ("string" == typeof t) return [new Xr(e, t)];
          X(t) || (t = [t]);
          return Array.from(t).map(t => "string" == typeof t ? new Xr(e, t) : t instanceof es ? new Xr(e, t.data) : t);
        }(this.document, t);
        for (const t of i) null !== t.parent && t._remove(), t.parent = this, this._children.splice(e, 0, t), e++, n++;
        return n;
      }
      _removeChildren(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        this._fireChange("children", this);
        for (let n = e; n < e + t; n++) this._children[n].parent = null;
        return this._children.splice(e, t);
      }
      _fireChange(e, t) {
        this.fire("change:" + e, t);
      }
      _setCustomProperty(e, t) {
        this._customProperties.set(e, t);
      }
      _removeCustomProperty(e) {
        return this._customProperties.delete(e);
      }
    }
    ma.prototype.is = function (e) {
      return "documentFragment" === e || "view:documentFragment" === e;
    };
    class pa {
      constructor(e) {
        this._cloneGroups = new Map(), this._slotFactory = null, this.document = e;
      }
      setSelection() {
        this.document.selection._setTo(...arguments);
      }
      setSelectionFocus(e, t) {
        this.document.selection._setFocus(e, t);
      }
      createDocumentFragment(e) {
        return new ma(this.document, e);
      }
      createText(e) {
        return new Xr(this.document, e);
      }
      createAttributeElement(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = new ia(this.document, e, t);
        return "number" == typeof n.priority && (i._priority = n.priority), n.id && (i._id = n.id), n.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), i;
      }
      createContainerElement(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        let o = null;
        ye(n) ? i = n : o = n;
        const r = new Rs(this.document, e, t, o);
        return i.renderUnsafeAttributes && r._unsafeAttributesToRender.push(...i.renderUnsafeAttributes), r;
      }
      createEditableElement(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = new Os(this.document, e, t);
        return n.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), i;
      }
      createEmptyElement(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = new sa(this.document, e, t);
        return n.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), i;
      }
      createUIElement(e, t, n) {
        const i = new la(this.document, e, t);
        return n && (i.render = n), i;
      }
      createRawElement(e, t, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const o = new ua(this.document, e, t);
        return n && (o.render = n), i.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...i.renderUnsafeAttributes), o;
      }
      setAttribute(e, t, n) {
        n._setAttribute(e, t);
      }
      removeAttribute(e, t) {
        t._removeAttribute(e);
      }
      addClass(e, t) {
        t._addClass(e);
      }
      removeClass(e, t) {
        t._removeClass(e);
      }
      setStyle(e, t, n) {
        ye(e) && void 0 === n ? t._setStyle(e) : n._setStyle(e, t);
      }
      removeStyle(e, t) {
        t._removeStyle(e);
      }
      setCustomProperty(e, t, n) {
        n._setCustomProperty(e, t);
      }
      removeCustomProperty(e, t) {
        return t._removeCustomProperty(e);
      }
      breakAttributes(e) {
        return e instanceof Us ? this._breakAttributes(e) : this._breakAttributesRange(e);
      }
      breakContainer(e) {
        const t = e.parent;
        if (!t.is("containerElement")) throw new _("view-writer-break-non-container-element", this.document);
        if (!t.parent) throw new _("view-writer-break-root", this.document);
        if (e.isAtStart) return Us._createBefore(t);
        if (!e.isAtEnd) {
          const n = t._clone(!1);
          this.insert(Us._createAfter(t), n);
          const i = new qs(e, Us._createAt(t, "end")),
            o = new Us(n, 0);
          this.move(i, o);
        }
        return Us._createAfter(t);
      }
      mergeAttributes(e) {
        const t = e.offset,
          n = e.parent;
        if (n.is("$text")) return e;
        if (n.is("attributeElement") && 0 === n.childCount) {
          const e = n.parent,
            t = n.index;
          return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new Us(e, t));
        }
        const i = n.getChild(t - 1),
          o = n.getChild(t);
        if (!i || !o) return e;
        if (i.is("$text") && o.is("$text")) return _a(i, o);
        if (i.is("attributeElement") && o.is("attributeElement") && i.isSimilar(o)) {
          const e = i.childCount;
          return i._appendChild(o.getChildren()), o._remove(), this._removeFromClonedElementsGroup(o), this.mergeAttributes(new Us(i, e));
        }
        return e;
      }
      mergeContainers(e) {
        const t = e.nodeBefore,
          n = e.nodeAfter;
        if (!(t && n && t.is("containerElement") && n.is("containerElement"))) throw new _("view-writer-merge-containers-invalid-position", this.document);
        const i = t.getChild(t.childCount - 1),
          o = i instanceof Xr ? Us._createAt(i, "end") : Us._createAt(t, "end");
        return this.move(qs._createIn(n), Us._createAt(t, "end")), this.remove(qs._createOn(n)), o;
      }
      insert(e, t) {
        Aa(t = X(t) ? [...t] : [t], this.document);
        const n = t.reduce((e, t) => {
          const n = e[e.length - 1],
            i = !t.is("uiElement");
          return n && n.breakAttributes == i ? n.nodes.push(t) : e.push({
            breakAttributes: i,
            nodes: [t]
          }), e;
        }, []);
        let i = null,
          o = e;
        for (const {
          nodes: e,
          breakAttributes: t
        } of n) {
          const n = this._insertNodes(o, e, t);
          i || (i = n.start), o = n.end;
        }
        return i ? new qs(i, o) : new qs(e);
      }
      remove(e) {
        const t = e instanceof qs ? e : qs._createOn(e);
        if (Ca(t, this.document), t.isCollapsed) return new ma(this.document);
        const {
            start: n,
            end: i
          } = this._breakAttributesRange(t, !0),
          o = n.parent,
          r = i.offset - n.offset,
          s = o._removeChildren(n.offset, r);
        for (const e of s) this._removeFromClonedElementsGroup(e);
        const a = this.mergeAttributes(n);
        return t.start = a, t.end = a.clone(), new ma(this.document, s);
      }
      clear(e, t) {
        Ca(e, this.document);
        const n = e.getWalker({
          direction: "backward",
          ignoreElementEnd: !0
        });
        for (const i of n) {
          const n = i.item;
          let o;
          if (n.is("element") && t.isSimilar(n)) o = qs._createOn(n);else if (!i.nextPosition.isAfter(e.start) && n.is("$textProxy")) {
            const e = n.getAncestors().find(e => e.is("element") && t.isSimilar(e));
            e && (o = qs._createIn(e));
          }
          o && (o.end.isAfter(e.end) && (o.end = e.end), o.start.isBefore(e.start) && (o.start = e.start), this.remove(o));
        }
      }
      move(e, t) {
        let n;
        if (t.isAfter(e.end)) {
          const i = (t = this._breakAttributes(t, !0)).parent,
            o = i.childCount;
          e = this._breakAttributesRange(e, !0), n = this.remove(e), t.offset += i.childCount - o;
        } else n = this.remove(e);
        return this.insert(t, n);
      }
      wrap(e, t) {
        if (!(t instanceof ia)) throw new _("view-writer-wrap-invalid-attribute", this.document);
        if (Ca(e, this.document), e.isCollapsed) {
          let i = e.start;
          i.parent.is("element") && (n = i.parent, !Array.from(n.getChildren()).some(e => !e.is("uiElement"))) && (i = i.getLastMatchingPosition(e => e.item.is("uiElement"))), i = this._wrapPosition(i, t);
          const o = this.document.selection;
          return o.isCollapsed && o.getFirstPosition().isEqual(e.start) && this.setSelection(i), new qs(i);
        }
        return this._wrapRange(e, t);
        var n;
      }
      unwrap(e, t) {
        if (!(t instanceof ia)) throw new _("view-writer-unwrap-invalid-attribute", this.document);
        if (Ca(e, this.document), e.isCollapsed) return e;
        const {
            start: n,
            end: i
          } = this._breakAttributesRange(e, !0),
          o = n.parent,
          r = this._unwrapChildren(o, n.offset, i.offset, t),
          s = this.mergeAttributes(r.start);
        s.isEqual(r.start) || r.end.offset--;
        const a = this.mergeAttributes(r.end);
        return new qs(s, a);
      }
      rename(e, t) {
        const n = new Rs(this.document, e, t.getAttributes());
        return this.insert(Us._createAfter(t), n), this.move(qs._createIn(t), Us._createAt(n, 0)), this.remove(qs._createOn(t)), n;
      }
      clearClonedElementsGroup(e) {
        this._cloneGroups.delete(e);
      }
      createPositionAt(e, t) {
        return Us._createAt(e, t);
      }
      createPositionAfter(e) {
        return Us._createAfter(e);
      }
      createPositionBefore(e) {
        return Us._createBefore(e);
      }
      createRange(e, t) {
        return new qs(e, t);
      }
      createRangeOn(e) {
        return qs._createOn(e);
      }
      createRangeIn(e) {
        return qs._createIn(e);
      }
      createSelection() {
        for (var _len22 = arguments.length, e = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
          e[_key22] = arguments[_key22];
        }
        return new Ks(...e);
      }
      createSlot() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "children";
        if (!this._slotFactory) throw new _("view-writer-invalid-create-slot-context", this.document);
        return this._slotFactory(this, e);
      }
      _registerSlotFactory(e) {
        this._slotFactory = e;
      }
      _clearSlotFactory() {
        this._slotFactory = null;
      }
      _insertNodes(e, t, n) {
        let i, o;
        if (i = n ? ga(e) : e.parent.is("$text") ? e.parent.parent : e.parent, !i) throw new _("view-writer-invalid-position-container", this.document);
        o = n ? this._breakAttributes(e, !0) : e.parent.is("$text") ? ba(e) : e;
        const r = i._insertChild(o.offset, t);
        for (const e of t) this._addToClonedElementsGroup(e);
        const s = o.getShiftedBy(r),
          a = this.mergeAttributes(o);
        a.isEqual(o) || s.offset--;
        const l = this.mergeAttributes(s);
        return new qs(a, l);
      }
      _wrapChildren(e, t, n, i) {
        let o = t;
        const r = [];
        for (; o < n;) {
          const t = e.getChild(o),
            n = t.is("$text"),
            s = t.is("attributeElement");
          if (s && this._wrapAttributeElement(i, t)) r.push(new Us(e, o));else if (n || !s || fa(i, t)) {
            const n = i._clone();
            t._remove(), n._appendChild(t), e._insertChild(o, n), this._addToClonedElementsGroup(n), r.push(new Us(e, o));
          } else this._wrapChildren(t, 0, t.childCount, i);
          o++;
        }
        let s = 0;
        for (const e of r) {
          if (e.offset -= s, e.offset == t) continue;
          this.mergeAttributes(e).isEqual(e) || (s++, n--);
        }
        return qs._createFromParentsAndOffsets(e, t, e, n);
      }
      _unwrapChildren(e, t, n, i) {
        let o = t;
        const r = [];
        for (; o < n;) {
          const t = e.getChild(o);
          if (t.is("attributeElement")) {
            if (t.isSimilar(i)) {
              const i = t.getChildren(),
                s = t.childCount;
              t._remove(), e._insertChild(o, i), this._removeFromClonedElementsGroup(t), r.push(new Us(e, o), new Us(e, o + s)), o += s, n += s - 1;
            } else this._unwrapAttributeElement(i, t) ? (r.push(new Us(e, o), new Us(e, o + 1)), o++) : (this._unwrapChildren(t, 0, t.childCount, i), o++);
          } else o++;
        }
        let s = 0;
        for (const e of r) {
          if (e.offset -= s, e.offset == t || e.offset == n) continue;
          this.mergeAttributes(e).isEqual(e) || (s++, n--);
        }
        return qs._createFromParentsAndOffsets(e, t, e, n);
      }
      _wrapRange(e, t) {
        const {
            start: n,
            end: i
          } = this._breakAttributesRange(e, !0),
          o = n.parent,
          r = this._wrapChildren(o, n.offset, i.offset, t),
          s = this.mergeAttributes(r.start);
        s.isEqual(r.start) || r.end.offset--;
        const a = this.mergeAttributes(r.end);
        return new qs(s, a);
      }
      _wrapPosition(e, t) {
        if (t.isSimilar(e.parent)) return ka(e.clone());
        e.parent.is("$text") && (e = ba(e));
        const n = this.createAttributeElement("_wrapPosition-fake-element");
        n._priority = Number.POSITIVE_INFINITY, n.isSimilar = () => !1, e.parent._insertChild(e.offset, n);
        const i = new qs(e, e.getShiftedBy(1));
        this.wrap(i, t);
        const o = new Us(n.parent, n.index);
        n._remove();
        const r = o.nodeBefore,
          s = o.nodeAfter;
        return r instanceof Xr && s instanceof Xr ? _a(r, s) : ka(o);
      }
      _wrapAttributeElement(e, t) {
        if (!ya(e, t)) return !1;
        if (e.name !== t.name || e.priority !== t.priority) return !1;
        for (const n of e.getAttributeKeys()) if ("class" !== n && "style" !== n && t.hasAttribute(n) && t.getAttribute(n) !== e.getAttribute(n)) return !1;
        for (const n of e.getStyleNames()) if (t.hasStyle(n) && t.getStyle(n) !== e.getStyle(n)) return !1;
        for (const n of e.getAttributeKeys()) "class" !== n && "style" !== n && (t.hasAttribute(n) || this.setAttribute(n, e.getAttribute(n), t));
        for (const n of e.getStyleNames()) t.hasStyle(n) || this.setStyle(n, e.getStyle(n), t);
        for (const n of e.getClassNames()) t.hasClass(n) || this.addClass(n, t);
        return !0;
      }
      _unwrapAttributeElement(e, t) {
        if (!ya(e, t)) return !1;
        if (e.name !== t.name || e.priority !== t.priority) return !1;
        for (const n of e.getAttributeKeys()) if ("class" !== n && "style" !== n && (!t.hasAttribute(n) || t.getAttribute(n) !== e.getAttribute(n))) return !1;
        if (!t.hasClass(...e.getClassNames())) return !1;
        for (const n of e.getStyleNames()) if (!t.hasStyle(n) || t.getStyle(n) !== e.getStyle(n)) return !1;
        for (const n of e.getAttributeKeys()) "class" !== n && "style" !== n && this.removeAttribute(n, t);
        return this.removeClass(Array.from(e.getClassNames()), t), this.removeStyle(Array.from(e.getStyleNames()), t), !0;
      }
      _breakAttributesRange(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = e.start,
          i = e.end;
        if (Ca(e, this.document), e.isCollapsed) {
          const n = this._breakAttributes(e.start, t);
          return new qs(n, n);
        }
        const o = this._breakAttributes(i, t),
          r = o.parent.childCount,
          s = this._breakAttributes(n, t);
        return o.offset += o.parent.childCount - r, new qs(s, o);
      }
      _breakAttributes(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = e.offset,
          i = e.parent;
        if (e.parent.is("emptyElement")) throw new _("view-writer-cannot-break-empty-element", this.document);
        if (e.parent.is("uiElement")) throw new _("view-writer-cannot-break-ui-element", this.document);
        if (e.parent.is("rawElement")) throw new _("view-writer-cannot-break-raw-element", this.document);
        if (!t && i.is("$text") && va(i.parent)) return e.clone();
        if (va(i)) return e.clone();
        if (i.is("$text")) return this._breakAttributes(ba(e), t);
        if (n == i.childCount) {
          const e = new Us(i.parent, i.index + 1);
          return this._breakAttributes(e, t);
        }
        if (0 === n) {
          const e = new Us(i.parent, i.index);
          return this._breakAttributes(e, t);
        }
        {
          const e = i.index + 1,
            o = i._clone();
          i.parent._insertChild(e, o), this._addToClonedElementsGroup(o);
          const r = i.childCount - n,
            s = i._removeChildren(n, r);
          o._appendChild(s);
          const a = new Us(i.parent, e);
          return this._breakAttributes(a, t);
        }
      }
      _addToClonedElementsGroup(e) {
        if (!e.root.is("rootElement")) return;
        if (e.is("element")) for (const t of e.getChildren()) this._addToClonedElementsGroup(t);
        const t = e.id;
        if (!t) return;
        let n = this._cloneGroups.get(t);
        n || (n = new Set(), this._cloneGroups.set(t, n)), n.add(e), e._clonesGroup = n;
      }
      _removeFromClonedElementsGroup(e) {
        if (e.is("element")) for (const t of e.getChildren()) this._removeFromClonedElementsGroup(t);
        const t = e.id;
        if (!t) return;
        const n = this._cloneGroups.get(t);
        n && n.delete(e);
      }
    }
    function ga(e) {
      let t = e.parent;
      for (; !va(t);) {
        if (!t) return;
        t = t.parent;
      }
      return t;
    }
    function fa(e, t) {
      return e.priority < t.priority || !(e.priority > t.priority) && e.getIdentity() < t.getIdentity();
    }
    function ka(e) {
      const t = e.nodeBefore;
      if (t && t.is("$text")) return new Us(t, t.data.length);
      const n = e.nodeAfter;
      return n && n.is("$text") ? new Us(n, 0) : e;
    }
    function ba(e) {
      if (e.offset == e.parent.data.length) return new Us(e.parent.parent, e.parent.index + 1);
      if (0 === e.offset) return new Us(e.parent.parent, e.parent.index);
      const t = e.parent.data.slice(e.offset);
      return e.parent._data = e.parent.data.slice(0, e.offset), e.parent.parent._insertChild(e.parent.index + 1, new Xr(e.root.document, t)), new Us(e.parent.parent, e.parent.index + 1);
    }
    function _a(e, t) {
      const n = e.data.length;
      return e._data += t.data, t._remove(), new Us(e, n);
    }
    const wa = [Xr, ia, Rs, sa, ua, la];
    function Aa(e, t) {
      for (const n of e) {
        if (!wa.some(e => n instanceof e)) throw new _("view-writer-insert-invalid-node-type", t);
        n.is("$text") || Aa(n.getChildren(), t);
      }
    }
    function va(e) {
      return e && (e.is("containerElement") || e.is("documentFragment"));
    }
    function Ca(e, t) {
      const n = ga(e.start),
        i = ga(e.end);
      if (!n || !i || n !== i) throw new _("view-writer-invalid-range-container", t);
    }
    function ya(e, t) {
      return null === e.id && null === t.id;
    }
    const xa = e => e.createTextNode(" "),
      Ea = e => {
        const t = e.createElement("span");
        return t.dataset.ckeFiller = "true", t.innerText = " ", t;
      },
      Sa = e => {
        const t = e.createElement("br");
        return t.dataset.ckeFiller = "true", t;
      },
      Da = 7,
      Ta = "⁠".repeat(Da);
    function Ia(e) {
      return "string" == typeof e ? e.substr(0, Da) === Ta : Mi(e) && e.data.substr(0, Da) === Ta;
    }
    function Ba(e) {
      return e.data.length == Da && Ia(e);
    }
    function Ma(e) {
      const t = "string" == typeof e ? e : e.data;
      return Ia(e) ? t.slice(Da) : t;
    }
    function Pa(e, t) {
      if (t.keyCode == mo.arrowleft) {
        const e = t.domTarget.ownerDocument.defaultView.getSelection();
        if (1 == e.rangeCount && e.getRangeAt(0).collapsed) {
          const t = e.getRangeAt(0).startContainer,
            n = e.getRangeAt(0).startOffset;
          Ia(t) && n <= Da && e.collapse(t, 0);
        }
      }
    }
    var za = o(8397),
      Na = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(za.A, Na);
    za.A.locals;
    class La extends q() {
      constructor(e, t) {
        super(), this.domDocuments = new Set(), this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this._inlineFiller = null, this._fakeSelectionContainer = null, this.domConverter = e, this.selection = t, this.set("isFocused", !1), this.set("isSelecting", !1), s.isBlink && !s.isAndroid && this.on("change:isSelecting", () => {
          this.isSelecting || this.render();
        }), this.set("isComposing", !1), this.on("change:isComposing", () => {
          this.isComposing || this.render();
        });
      }
      markToSync(e, t) {
        if ("text" === e) this.domConverter.mapViewToDom(t.parent) && this.markedTexts.add(t);else {
          if (!this.domConverter.mapViewToDom(t)) return;
          if ("attributes" === e) this.markedAttributes.add(t);else {
            if ("children" !== e) {
              throw new _("view-renderer-unknown-type", this);
            }
            this.markedChildren.add(t);
          }
        }
      }
      render() {
        if (this.isComposing && !s.isAndroid) return;
        let e = null;
        const t = !(s.isBlink && !s.isAndroid) || !this.isSelecting;
        for (const e of this.markedChildren) this._updateChildrenMappings(e);
        t ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? e = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (e = this.selection.getFirstPosition(), this.markedChildren.add(e.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (e = this.domConverter.domPositionToView(this._inlineFiller), e && e.parent.is("$text") && (e = Us._createBefore(e.parent)));
        for (const e of this.markedAttributes) this._updateAttrs(e);
        for (const t of this.markedChildren) this._updateChildren(t, {
          inlineFillerPosition: e
        });
        for (const t of this.markedTexts) !this.markedChildren.has(t.parent) && this.domConverter.mapViewToDom(t.parent) && this._updateText(t, {
          inlineFillerPosition: e
        });
        if (t) if (e) {
          const t = this.domConverter.viewPositionToDom(e),
            n = t.parent.ownerDocument;
          Ia(t.parent) ? this._inlineFiller = t.parent : this._inlineFiller = Ra(n, t.parent, t.offset);
        } else this._inlineFiller = null;
        this._updateFocus(), this._updateSelection(), this.domConverter._clearTemporaryCustomProperties(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
      }
      _updateChildrenMappings(e) {
        const t = this.domConverter.mapViewToDom(e);
        if (!t) return;
        const n = Array.from(t.childNodes),
          i = Array.from(this.domConverter.viewChildrenToDom(e, {
            withChildren: !1
          })),
          o = this._diffNodeLists(n, i),
          r = this._findUpdateActions(o, n, i, Va);
        if (-1 !== r.indexOf("update")) {
          const t = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          for (const o of r) if ("update" === o) {
            const o = t.equal + t.insert,
              r = t.equal + t.delete,
              s = e.getChild(o);
            !s || s.is("uiElement") || s.is("rawElement") || this._updateElementMappings(s, n[r]), Xi(i[o]), t.equal++;
          } else t[o]++;
        }
      }
      _updateElementMappings(e, t) {
        this.domConverter.unbindDomElement(t), this.domConverter.bindElements(t, e), this.markedChildren.add(e), this.markedAttributes.add(e);
      }
      _getInlineFillerPosition() {
        const e = this.selection.getFirstPosition();
        return e.parent.is("$text") ? Us._createBefore(e.parent) : e;
      }
      _isSelectionInInlineFiller() {
        if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
        const e = this.selection.getFirstPosition(),
          t = this.domConverter.viewPositionToDom(e);
        return !!(t && Mi(t.parent) && Ia(t.parent));
      }
      _removeInlineFiller() {
        const e = this._inlineFiller;
        if (!Ia(e)) throw new _("view-renderer-filler-was-lost", this);
        Ba(e) ? e.remove() : e.data = e.data.substr(Da), this._inlineFiller = null;
      }
      _needsInlineFillerAtSelection() {
        if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
        const e = this.selection.getFirstPosition(),
          t = e.parent,
          n = e.offset;
        if (!this.domConverter.mapViewToDom(t.root)) return !1;
        if (!t.is("element")) return !1;
        if (!function (e) {
          if ("false" == e.getAttribute("contenteditable")) return !1;
          const t = e.findAncestor(e => e.hasAttribute("contenteditable"));
          return !t || "true" == t.getAttribute("contenteditable");
        }(t)) return !1;
        const i = e.nodeBefore,
          o = e.nodeAfter;
        return !(i instanceof Xr || o instanceof Xr) && !!(n !== t.getFillerOffset() || i && i.is("element", "br")) && (!s.isAndroid || !i && !o);
      }
      _updateText(e, t) {
        const n = this.domConverter.findCorrespondingDomText(e);
        let i = this.domConverter.viewToDom(e).data;
        const o = t.inlineFillerPosition;
        o && o.parent == e.parent && o.offset == e.index && (i = Ta + i), ja(n, i);
      }
      _updateAttrs(e) {
        const t = this.domConverter.mapViewToDom(e);
        if (!t) return;
        const n = Array.from(t.attributes).map(e => e.name),
          i = e.getAttributeKeys();
        for (const n of i) this.domConverter.setDomElementAttribute(t, n, e.getAttribute(n), e);
        for (const i of n) e.hasAttribute(i) || this.domConverter.removeDomElementAttribute(t, i);
      }
      _updateChildren(e, t) {
        const n = this.domConverter.mapViewToDom(e);
        if (!n) return;
        if (s.isAndroid) {
          let e = null;
          for (const t of Array.from(n.childNodes)) {
            if (e && Mi(e) && Mi(t)) {
              n.normalize();
              break;
            }
            e = t;
          }
        }
        const i = t.inlineFillerPosition,
          o = n.childNodes,
          r = Array.from(this.domConverter.viewChildrenToDom(e, {
            bind: !0
          }));
        i && i.parent === e && Ra(n.ownerDocument, r, i.offset);
        const a = this._diffNodeLists(o, r),
          l = this._findUpdateActions(a, o, r, Oa);
        let c = 0;
        const d = new Set();
        for (const e of l) "delete" === e ? (d.add(o[c]), Xi(o[c])) : "equal" !== e && "update" !== e || c++;
        c = 0;
        for (const e of l) "insert" === e ? (Ki(n, c, r[c]), c++) : "update" === e ? (ja(o[c], r[c].data), c++) : "equal" === e && (this._markDescendantTextToSync(this.domConverter.domToView(r[c])), c++);
        for (const e of d) e.parentNode || this.domConverter.unbindDomElement(e);
      }
      _diffNodeLists(e, t) {
        return e = function (e, t) {
          const n = Array.from(e);
          if (0 == n.length || !t) return n;
          const i = n[n.length - 1];
          i == t && n.pop();
          return n;
        }(e, this._fakeSelectionContainer), u(e, t, Fa.bind(null, this.domConverter));
      }
      _findUpdateActions(e, t, n, i) {
        if (-1 === e.indexOf("insert") || -1 === e.indexOf("delete")) return e;
        let o = [],
          r = [],
          s = [];
        const a = {
          equal: 0,
          insert: 0,
          delete: 0
        };
        for (const l of e) "insert" === l ? s.push(n[a.equal + a.insert]) : "delete" === l ? r.push(t[a.equal + a.delete]) : (o = o.concat(u(r, s, i).map(e => "equal" === e ? "update" : e)), o.push("equal"), r = [], s = []), a[l]++;
        return o.concat(u(r, s, i).map(e => "equal" === e ? "update" : e));
      }
      _markDescendantTextToSync(e) {
        if (e) if (e.is("$text")) this.markedTexts.add(e);else if (e.is("element")) for (const t of e.getChildren()) this._markDescendantTextToSync(t);
      }
      _updateSelection() {
        if (s.isBlink && !s.isAndroid && this.isSelecting && !this.markedChildren.size) return;
        if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
        const e = this.domConverter.mapViewToDom(this.selection.editableElement);
        this.isFocused && e && (this.selection.isFake ? this._updateFakeSelection(e) : this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected ? (this._removeFakeSelection(), this._updateDomSelection(e)) : this.isComposing && s.isAndroid || this._updateDomSelection(e));
      }
      _updateFakeSelection(e) {
        const t = e.ownerDocument;
        this._fakeSelectionContainer || (this._fakeSelectionContainer = function (e) {
          const t = e.createElement("div");
          return t.className = "ck-fake-selection-container", Object.assign(t.style, {
            position: "fixed",
            top: 0,
            left: "-9999px",
            width: "42px"
          }), t.textContent = " ", t;
        }(t));
        const n = this._fakeSelectionContainer;
        if (this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(e)) return;
        n.parentElement && n.parentElement == e || e.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
        const i = t.getSelection(),
          o = t.createRange();
        i.removeAllRanges(), o.selectNodeContents(n), i.addRange(o);
      }
      _updateDomSelection(e) {
        const t = e.ownerDocument.defaultView.getSelection();
        if (!this._domSelectionNeedsUpdate(t)) return;
        const n = this.domConverter.viewPositionToDom(this.selection.anchor),
          i = this.domConverter.viewPositionToDom(this.selection.focus);
        t.setBaseAndExtent(n.parent, n.offset, i.parent, i.offset), s.isGecko && function (e, t) {
          let n = e.parent,
            i = e.offset;
          Mi(n) && Ba(n) && (i = Gi(n) + 1, n = n.parentNode);
          if (n.nodeType != Node.ELEMENT_NODE || i != n.childNodes.length - 1) return;
          const o = n.childNodes[i];
          o && "BR" == o.tagName && t.addRange(t.getRangeAt(0));
        }(i, t);
      }
      _domSelectionNeedsUpdate(e) {
        if (!this.domConverter.isDomSelectionCorrect(e)) return !0;
        const t = e && this.domConverter.domSelectionToView(e);
        return (!t || !this.selection.isEqual(t)) && !(!this.selection.isCollapsed && this.selection.isSimilar(t));
      }
      _fakeSelectionNeedsUpdate(e) {
        const t = this._fakeSelectionContainer,
          n = e.ownerDocument.getSelection();
        return !t || t.parentElement !== e || n.anchorNode !== t && !t.contains(n.anchorNode) || t.textContent !== this.selection.fakeSelectionLabel;
      }
      _removeDomSelection() {
        for (const e of this.domDocuments) {
          const t = e.getSelection();
          if (t.rangeCount) {
            const n = e.activeElement,
              i = this.domConverter.mapDomToView(n);
            n && i && t.removeAllRanges();
          }
        }
      }
      _removeFakeSelection() {
        const e = this._fakeSelectionContainer;
        e && e.remove();
      }
      _updateFocus() {
        if (this.isFocused) {
          const e = this.selection.editableElement;
          e && this.domConverter.focus(e);
        }
      }
    }
    function Ra(e, t, n) {
      const i = t instanceof Array ? t : t.childNodes,
        o = i[n];
      if (Mi(o)) return o.data = Ta + o.data, o;
      {
        const o = e.createTextNode(Ta);
        return Array.isArray(t) ? i.splice(n, 0, o) : Ki(t, n, o), o;
      }
    }
    function Va(e, t) {
      return xi(e) && xi(t) && !Mi(e) && !Mi(t) && !Wi(e) && !Wi(t) && e.tagName.toLowerCase() === t.tagName.toLowerCase();
    }
    function Oa(e, t) {
      return xi(e) && xi(t) && Mi(e) && Mi(t);
    }
    function Fa(e, t, n) {
      return t === n || (Mi(t) && Mi(n) ? t.data === n.data : !(!e.isBlockFiller(t) || !e.isBlockFiller(n)));
    }
    function ja(e, t) {
      const n = e.data;
      if (n == t) return;
      const i = l(n, t);
      for (const t of i) "insert" === t.type ? e.insertData(t.index, t.values.join("")) : e.deleteData(t.index, t.howMany);
    }
    const Ha = Sa(t.document),
      Ua = xa(t.document),
      qa = Ea(t.document),
      Ga = "data-ck-unsafe-attribute-",
      Ka = "data-ck-unsafe-element";
    class Wa {
      constructor(e) {
        let {
          blockFillerMode: n,
          renderingMode: i = "editing"
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap(), this._rawContentElementMatcher = new ts(), this._inlineObjectElementMatcher = new ts(), this._elementsWithTemporaryCustomProperties = new Set(), this.document = e, this.renderingMode = i, this.blockFillerMode = n || ("editing" === i ? "br" : "nbsp"), this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this.unsafeElements = ["script", "style"], this._domDocument = "editing" === this.renderingMode ? t.document : t.document.implementation.createHTMLDocument("");
      }
      bindFakeSelection(e, t) {
        this._fakeSelectionMapping.set(e, new Ks(t));
      }
      fakeSelectionToView(e) {
        return this._fakeSelectionMapping.get(e);
      }
      bindElements(e, t) {
        this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
      }
      unbindDomElement(e) {
        const t = this._domToViewMapping.get(e);
        if (t) {
          this._domToViewMapping.delete(e), this._viewToDomMapping.delete(t);
          for (const t of Array.from(e.children)) this.unbindDomElement(t);
        }
      }
      bindDocumentFragments(e, t) {
        this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
      }
      shouldRenderAttribute(e, t, n) {
        return "data" === this.renderingMode || !(e = e.toLowerCase()).startsWith("on") && ("srcdoc" !== e || !t.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) && ("img" === n && ("src" === e || "srcset" === e) || "source" === n && "srcset" === e || !t.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
      }
      setContentOf(e, t) {
        if ("data" === this.renderingMode) return void (e.innerHTML = t);
        const n = new DOMParser().parseFromString(t, "text/html"),
          i = n.createDocumentFragment(),
          o = n.body.childNodes;
        for (; o.length > 0;) i.appendChild(o[0]);
        const r = n.createTreeWalker(i, NodeFilter.SHOW_ELEMENT),
          s = [];
        let a;
        for (; a = r.nextNode();) s.push(a);
        for (const e of s) {
          for (const t of e.getAttributeNames()) this.setDomElementAttribute(e, t, e.getAttribute(t));
          const t = e.tagName.toLowerCase();
          this._shouldRenameElement(t) && (Qa(t), e.replaceWith(this._createReplacementDomElement(t, e)));
        }
        for (; e.firstChild;) e.firstChild.remove();
        e.append(i);
      }
      viewToDom(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (e.is("$text")) {
          const t = this._processDataFromViewText(e);
          return this._domDocument.createTextNode(t);
        }
        {
          const n = e;
          if (this.mapViewToDom(n)) {
            if (!n.getCustomProperty("editingPipeline:doNotReuseOnce")) return this.mapViewToDom(n);
            this._elementsWithTemporaryCustomProperties.add(n);
          }
          let i;
          if (n.is("documentFragment")) i = this._domDocument.createDocumentFragment(), t.bind && this.bindDocumentFragments(i, n);else {
            if (n.is("uiElement")) return i = "$comment" === n.name ? this._domDocument.createComment(n.getCustomProperty("$rawContent")) : n.render(this._domDocument, this), t.bind && this.bindElements(i, n), i;
            this._shouldRenameElement(n.name) ? (Qa(n.name), i = this._createReplacementDomElement(n.name)) : i = n.hasAttribute("xmlns") ? this._domDocument.createElementNS(n.getAttribute("xmlns"), n.name) : this._domDocument.createElement(n.name), n.is("rawElement") && n.render(i, this), t.bind && this.bindElements(i, n);
            for (const e of n.getAttributeKeys()) this.setDomElementAttribute(i, e, n.getAttribute(e), n);
          }
          if (!1 !== t.withChildren) for (const e of this.viewChildrenToDom(n, t)) i instanceof HTMLTemplateElement ? i.content.appendChild(e) : i.appendChild(e);
          return i;
        }
      }
      setDomElementAttribute(e, t, n, i) {
        const o = this.shouldRenderAttribute(t, n, e.tagName.toLowerCase()) || i && i.shouldRenderUnsafeAttribute(t);
        o || w("domconverter-unsafe-attribute-detected", {
          domElement: e,
          key: t,
          value: n
        }), Yi(t) ? (e.hasAttribute(t) && !o ? e.removeAttribute(t) : e.hasAttribute(Ga + t) && o && e.removeAttribute(Ga + t), e.setAttribute(o ? t : Ga + t, n)) : w("domconverter-invalid-attribute-detected", {
          domElement: e,
          key: t,
          value: n
        });
      }
      removeDomElementAttribute(e, t) {
        t != Ka && (e.removeAttribute(t), e.removeAttribute(Ga + t));
      }
      viewChildrenToDom(e) {
        var _this4 = this;
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function* () {
          const n = e.getFillerOffset && e.getFillerOffset();
          let i = 0;
          for (const o of e.getChildren()) {
            n === i && (yield _this4._getBlockFiller());
            const e = o.is("element") && !!o.getCustomProperty("dataPipeline:transparentRendering") && !Go(o.getAttributes());
            e && "data" == _this4.renderingMode ? yield* _this4.viewChildrenToDom(o, t) : (e && w("domconverter-transparent-rendering-unsupported-in-editing-pipeline", {
              viewElement: o
            }), yield _this4.viewToDom(o, t)), i++;
          }
          n === i && (yield _this4._getBlockFiller());
        }();
      }
      viewRangeToDom(e) {
        const t = this.viewPositionToDom(e.start),
          n = this.viewPositionToDom(e.end),
          i = this._domDocument.createRange();
        return i.setStart(t.parent, t.offset), i.setEnd(n.parent, n.offset), i;
      }
      viewPositionToDom(e) {
        const t = e.parent;
        if (t.is("$text")) {
          const n = this.findCorrespondingDomText(t);
          if (!n) return null;
          let i = e.offset;
          return Ia(n) && (i += Da), {
            parent: n,
            offset: i
          };
        }
        {
          let n, i, o;
          if (0 === e.offset) {
            if (n = this.mapViewToDom(t), !n) return null;
            o = n.childNodes[0];
          } else {
            const t = e.nodeBefore;
            if (i = t.is("$text") ? this.findCorrespondingDomText(t) : this.mapViewToDom(t), !i) return null;
            n = i.parentNode, o = i.nextSibling;
          }
          if (Mi(o) && Ia(o)) return {
            parent: o,
            offset: Da
          };
          return {
            parent: n,
            offset: i ? Gi(i) + 1 : 0
          };
        }
      }
      domToView(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = [],
          i = this._domToView(e, t, n),
          o = i.next().value;
        return o ? (i.next(), this._processDomInlineNodes(null, n, t), o.is("$text") && 0 == o.data.length ? null : o) : null;
      }
      domChildrenToView(e) {
        var _this5 = this;
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return function* () {
          let i = [];
          i = e instanceof HTMLTemplateElement ? [...e.content.childNodes] : [...e.childNodes];
          for (let o = 0; o < i.length; o++) {
            const r = i[o],
              s = _this5._domToView(r, t, n),
              a = s.next().value;
            null !== a && (_this5._isBlockViewElement(a) && _this5._processDomInlineNodes(e, n, t), yield a, s.next());
          }
          _this5._processDomInlineNodes(e, n, t);
        }();
      }
      domSelectionToView(e) {
        if (function (e) {
          if (!s.isGecko) return !1;
          if (!e.rangeCount) return !1;
          const t = e.getRangeAt(0).startContainer;
          try {
            Object.prototype.toString.call(t);
          } catch (e) {
            return !0;
          }
          return !1;
        }(e)) return new Ks([]);
        if (1 === e.rangeCount) {
          let t = e.getRangeAt(0).startContainer;
          Mi(t) && (t = t.parentNode);
          const n = this.fakeSelectionToView(t);
          if (n) return n;
        }
        const t = this.isDomSelectionBackward(e),
          n = [];
        for (let t = 0; t < e.rangeCount; t++) {
          const i = e.getRangeAt(t),
            o = this.domRangeToView(i);
          o && n.push(o);
        }
        return new Ks(n, {
          backward: t
        });
      }
      domRangeToView(e) {
        const t = this.domPositionToView(e.startContainer, e.startOffset),
          n = this.domPositionToView(e.endContainer, e.endOffset);
        return t && n ? new qs(t, n) : null;
      }
      domPositionToView(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (this.isBlockFiller(e)) return this.domPositionToView(e.parentNode, Gi(e));
        const n = this.mapDomToView(e);
        if (n && (n.is("uiElement") || n.is("rawElement"))) return Us._createBefore(n);
        if (Mi(e)) {
          if (Ba(e)) return this.domPositionToView(e.parentNode, Gi(e));
          const n = this.findCorrespondingViewText(e);
          let i = t;
          return n ? (Ia(e) && (i -= Da, i = i < 0 ? 0 : i), new Us(n, i)) : null;
        }
        if (0 === t) {
          const t = this.mapDomToView(e);
          if (t) return new Us(t, 0);
        } else {
          const n = e.childNodes[t - 1];
          if (Mi(n) && Ba(n) || n && this.isBlockFiller(n)) return this.domPositionToView(n.parentNode, Gi(n));
          const i = Mi(n) ? this.findCorrespondingViewText(n) : this.mapDomToView(n);
          if (i && i.parent) return new Us(i.parent, i.index + 1);
        }
        return null;
      }
      mapDomToView(e) {
        return this.getHostViewElement(e) || this._domToViewMapping.get(e);
      }
      findCorrespondingViewText(e) {
        if (Ba(e)) return null;
        const t = this.getHostViewElement(e);
        if (t) return t;
        const n = e.previousSibling;
        if (n) {
          if (!this.isElement(n)) return null;
          const e = this.mapDomToView(n);
          if (e) {
            const t = e.nextSibling;
            return t instanceof Xr ? t : null;
          }
        } else {
          const t = this.mapDomToView(e.parentNode);
          if (t) {
            const e = t.getChild(0);
            return e instanceof Xr ? e : null;
          }
        }
        return null;
      }
      mapViewToDom(e) {
        return this._viewToDomMapping.get(e);
      }
      findCorrespondingDomText(e) {
        const t = e.previousSibling;
        return t && this.mapViewToDom(t) ? this.mapViewToDom(t).nextSibling : !t && e.parent && this.mapViewToDom(e.parent) ? this.mapViewToDom(e.parent).childNodes[0] : null;
      }
      focus(e) {
        const n = this.mapViewToDom(e);
        if (n && n.ownerDocument.activeElement !== n) {
          const {
              scrollX: e,
              scrollY: i
            } = t.window,
            o = [];
          $a(n, e => {
            const {
              scrollLeft: t,
              scrollTop: n
            } = e;
            o.push([t, n]);
          }), n.focus(), $a(n, e => {
            const [t, n] = o.shift();
            e.scrollLeft = t, e.scrollTop = n;
          }), t.window.scrollTo(e, i);
        }
      }
      _clearDomSelection() {
        const e = this.mapViewToDom(this.document.selection.editableElement);
        if (!e) return;
        const t = e.ownerDocument.defaultView.getSelection(),
          n = this.domSelectionToView(t);
        n && n.rangeCount > 0 && t.removeAllRanges();
      }
      isElement(e) {
        return e && e.nodeType == Node.ELEMENT_NODE;
      }
      isDocumentFragment(e) {
        return e && e.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
      }
      isBlockFiller(e) {
        return "br" == this.blockFillerMode ? e.isEqualNode(Ha) : !("BR" !== e.tagName || !Za(e, this.blockElements) || 1 !== e.parentNode.childNodes.length) || e.isEqualNode(qa) || function (e, t) {
          const n = e.isEqualNode(Ua);
          return n && Za(e, t) && 1 === e.parentNode.childNodes.length;
        }(e, this.blockElements);
      }
      isDomSelectionBackward(e) {
        if (e.isCollapsed) return !1;
        const t = this._domDocument.createRange();
        try {
          t.setStart(e.anchorNode, e.anchorOffset), t.setEnd(e.focusNode, e.focusOffset);
        } catch (e) {
          return !1;
        }
        const n = t.collapsed;
        return t.detach(), n;
      }
      getHostViewElement(e) {
        const t = function (e) {
          const t = [];
          let n = e;
          for (; n && n.nodeType != Node.DOCUMENT_NODE;) t.unshift(n), n = n.parentNode;
          return t;
        }(e);
        for (t.pop(); t.length;) {
          const e = t.pop(),
            n = this._domToViewMapping.get(e);
          if (n && (n.is("uiElement") || n.is("rawElement"))) return n;
        }
        return null;
      }
      isDomSelectionCorrect(e) {
        return this._isDomSelectionPositionCorrect(e.anchorNode, e.anchorOffset) && this._isDomSelectionPositionCorrect(e.focusNode, e.focusOffset);
      }
      registerRawContentMatcher(e) {
        this._rawContentElementMatcher.add(e);
      }
      registerInlineObjectMatcher(e) {
        this._inlineObjectElementMatcher.add(e);
      }
      _clearTemporaryCustomProperties() {
        for (const e of this._elementsWithTemporaryCustomProperties) e._removeCustomProperty("editingPipeline:doNotReuseOnce");
        this._elementsWithTemporaryCustomProperties.clear();
      }
      _getBlockFiller() {
        switch (this.blockFillerMode) {
          case "nbsp":
            return xa(this._domDocument);
          case "markedNbsp":
            return Ea(this._domDocument);
          case "br":
            return Sa(this._domDocument);
        }
      }
      _isDomSelectionPositionCorrect(e, t) {
        if (Mi(e) && Ia(e) && t < Da) return !1;
        if (this.isElement(e) && Ia(e.childNodes[t])) return !1;
        const n = this.mapDomToView(e);
        return !n || !n.is("uiElement") && !n.is("rawElement");
      }
      *_domToView(e, t, n) {
        if (this.isBlockFiller(e)) return null;
        const i = this.getHostViewElement(e);
        if (i) return i;
        if (Wi(e) && t.skipComments) return null;
        if (Mi(e)) {
          if (Ba(e)) return null;
          {
            const t = e.data;
            if ("" === t) return null;
            const i = new Xr(this.document, t);
            return n.push(i), i;
          }
        }
        {
          let i = this.mapDomToView(e);
          if (i) return this._isInlineObjectElement(i) && n.push(i), i;
          if (this.isDocumentFragment(e)) i = new ma(this.document), t.bind && this.bindDocumentFragments(e, i);else {
            i = this._createViewElement(e, t), t.bind && this.bindElements(e, i);
            const o = e.attributes;
            if (o) for (let e = o.length, t = 0; t < e; t++) i._setAttribute(o[t].name, o[t].value);
            if (this._isViewElementWithRawContent(i, t)) return i._setCustomProperty("$rawContent", e.innerHTML), this._isBlockViewElement(i) || n.push(i), i;
            if (Wi(e)) return i._setCustomProperty("$rawContent", e.data), i;
          }
          yield i;
          const o = [];
          if (!1 !== t.withChildren) for (const n of this.domChildrenToView(e, t, o)) i._appendChild(n);
          if (this._isInlineObjectElement(i)) n.push(i);else for (const e of o) n.push(e);
        }
      }
      _processDomInlineNodes(e, t, n) {
        if (!t.length) return;
        if (e && !this.isDocumentFragment(e) && !this._isBlockDomElement(e)) return;
        let i = !1;
        for (let e = 0; e < t.length; e++) {
          const o = t[e];
          if (!o.is("$text")) {
            i = !1;
            continue;
          }
          let r,
            s = !1;
          if (Ya(o, this.preElements)) r = Ma(o.data);else {
            r = o.data.replace(/[ \n\t\r]{1,}/g, " "), s = /[^\S\u00A0]/.test(r.charAt(r.length - 1));
            const a = e > 0 ? t[e - 1] : null,
              l = e + 1 < t.length ? t[e + 1] : null,
              c = !a || a.is("element") && "br" == a.name || i,
              d = !l && !Ia(o.data);
            !1 !== n.withChildren && (c && (r = r.replace(/^ /, "")), d && (r = r.replace(/ $/, ""))), r = Ma(r), r = r.replace(/ \u00A0/g, "  ");
            const u = l && l.is("element") && "br" != l.name,
              h = l && l.is("$text") && " " == l.data.charAt(0);
            (/[ \u00A0]\u00A0$/.test(r) || !l || u || h) && (r = r.replace(/\u00A0$/, " ")), (c || a && a.is("element") && "br" != a.name) && (r = r.replace(/^\u00A0/, " "));
          }
          0 == r.length && o.parent ? (o._remove(), t.splice(e, 1), e--) : (o._data = r, i = s);
        }
        t.length = 0;
      }
      _processDataFromViewText(e) {
        let t = e.data;
        if (e.getAncestors().some(e => this.preElements.includes(e.name))) return t;
        if (" " == t.charAt(0)) {
          const n = this._getTouchingInlineViewNode(e, !1);
          !(n && n.is("$textProxy") && this._nodeEndsWithSpace(n)) && n || (t = " " + t.substr(1));
        }
        if (" " == t.charAt(t.length - 1)) {
          const n = this._getTouchingInlineViewNode(e, !0),
            i = n && n.is("$textProxy") && " " == n.data.charAt(0);
          " " != t.charAt(t.length - 2) && n && !i || (t = t.substr(0, t.length - 1) + " ");
        }
        return t.replace(/ {2}/g, "  ");
      }
      _nodeEndsWithSpace(e) {
        if (e.getAncestors().some(e => this.preElements.includes(e.name))) return !1;
        const t = this._processDataFromViewText(e);
        return " " == t.charAt(t.length - 1);
      }
      _getTouchingInlineViewNode(e, t) {
        const n = new Hs({
          startPosition: t ? Us._createAfter(e) : Us._createBefore(e),
          direction: t ? "forward" : "backward"
        });
        for (const e of n) {
          if (e.item.is("element", "br")) return null;
          if (this._isInlineObjectElement(e.item)) return e.item;
          if (e.item.is("containerElement")) return null;
          if (e.item.is("$textProxy")) return e.item;
        }
        return null;
      }
      _isBlockDomElement(e) {
        return this.isElement(e) && this.blockElements.includes(e.tagName.toLowerCase());
      }
      _isBlockViewElement(e) {
        return e.is("element") && this.blockElements.includes(e.name);
      }
      _isInlineObjectElement(e) {
        return !!e.is("element") && ("br" == e.name || this.inlineObjectElements.includes(e.name) || !!this._inlineObjectElementMatcher.match(e));
      }
      _createViewElement(e, t) {
        if (Wi(e)) return new la(this.document, "$comment");
        const n = t.keepOriginalCase ? e.tagName : e.tagName.toLowerCase();
        return new Ns(this.document, n);
      }
      _isViewElementWithRawContent(e, t) {
        return !1 !== t.withChildren && e.is("element") && !!this._rawContentElementMatcher.match(e);
      }
      _shouldRenameElement(e) {
        const t = e.toLowerCase();
        return "editing" === this.renderingMode && this.unsafeElements.includes(t);
      }
      _createReplacementDomElement(e, t) {
        const n = this._domDocument.createElement("span");
        if (n.setAttribute(Ka, e), t) {
          for (; t.firstChild;) n.appendChild(t.firstChild);
          for (const e of t.getAttributeNames()) n.setAttribute(e, t.getAttribute(e));
        }
        return n;
      }
    }
    function Ya(e, t) {
      return e.getAncestors().some(e => e.is("element") && t.includes(e.name));
    }
    function $a(e, t) {
      let n = e;
      for (; n;) t(n), n = n.parentElement;
    }
    function Za(e, t) {
      const n = e.parentNode;
      return !!n && !!n.tagName && t.includes(n.tagName.toLowerCase());
    }
    function Qa(e) {
      "script" === e && w("domconverter-unsafe-script-element-detected"), "style" === e && w("domconverter-unsafe-style-element-detected");
    }
    class Ja extends Di() {
      constructor(e) {
        super(), this._isEnabled = !1, this.view = e, this.document = e.document;
      }
      get isEnabled() {
        return this._isEnabled;
      }
      enable() {
        this._isEnabled = !0;
      }
      disable() {
        this._isEnabled = !1;
      }
      destroy() {
        this.disable(), this.stopListening();
      }
      checkShouldIgnoreEventFromTarget(e) {
        return e && 3 === e.nodeType && (e = e.parentNode), !(!e || 1 !== e.nodeType) && e.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
      }
    }
    const Xa = Vo(function (e, t) {
      Dt(t, hn(t), e);
    });
    class el {
      constructor(e, t, n) {
        this.view = e, this.document = e.document, this.domEvent = t, this.domTarget = t.target, Xa(this, n);
      }
      get target() {
        return this.view.domConverter.mapDomToView(this.domTarget);
      }
      preventDefault() {
        this.domEvent.preventDefault();
      }
      stopPropagation() {
        this.domEvent.stopPropagation();
      }
    }
    class tl extends Ja {
      constructor() {
        super(...arguments), this.useCapture = !1;
      }
      observe(e) {
        ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(t => {
          this.listenTo(e, t, (e, t) => {
            this.isEnabled && !this.checkShouldIgnoreEventFromTarget(t.target) && this.onDomEvent(t);
          }, {
            useCapture: this.useCapture
          });
        });
      }
      stopObserving(e) {
        this.stopListening(e);
      }
      fire(e, t, n) {
        this.isEnabled && this.document.fire(e, new el(this.view, t, n));
      }
    }
    class nl extends tl {
      constructor() {
        super(...arguments), this.domEventType = ["keydown", "keyup"];
      }
      onDomEvent(e) {
        const t = {
          keyCode: e.keyCode,
          altKey: e.altKey,
          ctrlKey: e.ctrlKey,
          shiftKey: e.shiftKey,
          metaKey: e.metaKey,
          get keystroke() {
            return go(this);
          }
        };
        this.fire(e.type, e, t);
      }
    }
    const il = function () {
      return ne.Date.now();
    };
    var ol = /\s/;
    const rl = function (e) {
      for (var t = e.length; t-- && ol.test(e.charAt(t)););
      return t;
    };
    var sl = /^\s+/;
    const al = function (e) {
      return e ? e.slice(0, rl(e) + 1).replace(sl, "") : e;
    };
    var ll = /^[-+]0x[0-9a-f]+$/i,
      cl = /^0b[01]+$/i,
      dl = /^0o[0-7]+$/i,
      ul = parseInt;
    const hl = function (e) {
      if ("number" == typeof e) return e;
      if (os(e)) return NaN;
      if (R(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = R(t) ? t + "" : t;
      }
      if ("string" != typeof e) return 0 === e ? e : +e;
      e = al(e);
      var n = cl.test(e);
      return n || dl.test(e) ? ul(e.slice(2), n ? 2 : 8) : ll.test(e) ? NaN : +e;
    };
    var ml = Math.max,
      pl = Math.min;
    const gl = function (e, t, n) {
      var i,
        o,
        r,
        s,
        a,
        l,
        c = 0,
        d = !1,
        u = !1,
        h = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      function m(t) {
        var n = i,
          r = o;
        return i = o = void 0, c = t, s = e.apply(r, n);
      }
      function p(e) {
        var n = e - l;
        return void 0 === l || n >= t || n < 0 || u && e - c >= r;
      }
      function g() {
        var e = il();
        if (p(e)) return f(e);
        a = setTimeout(g, function (e) {
          var n = t - (e - l);
          return u ? pl(n, r - (e - c)) : n;
        }(e));
      }
      function f(e) {
        return a = void 0, h && i ? m(e) : (i = o = void 0, s);
      }
      function k() {
        var e = il(),
          n = p(e);
        if (i = arguments, o = this, l = e, n) {
          if (void 0 === a) return function (e) {
            return c = e, a = setTimeout(g, t), d ? m(e) : s;
          }(l);
          if (u) return clearTimeout(a), a = setTimeout(g, t), m(l);
        }
        return void 0 === a && (a = setTimeout(g, t)), s;
      }
      return t = hl(t) || 0, R(n) && (d = !!n.leading, r = (u = "maxWait" in n) ? ml(hl(n.maxWait) || 0, t) : r, h = "trailing" in n ? !!n.trailing : h), k.cancel = function () {
        void 0 !== a && clearTimeout(a), c = 0, i = l = o = a = void 0;
      }, k.flush = function () {
        return void 0 === a ? s : f(il());
      }, k;
    };
    class fl extends Ja {
      constructor(e) {
        super(e), this._fireSelectionChangeDoneDebounced = gl(e => {
          this.document.fire("selectionChangeDone", e);
        }, 200);
      }
      observe() {
        const e = this.document;
        e.on("arrowKey", (t, n) => {
          e.selection.isFake && this.isEnabled && n.preventDefault();
        }, {
          context: "$capture"
        }), e.on("arrowKey", (t, n) => {
          e.selection.isFake && this.isEnabled && this._handleSelectionMove(n.keyCode);
        }, {
          priority: "lowest"
        });
      }
      stopObserving() {}
      destroy() {
        super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
      }
      _handleSelectionMove(e) {
        const t = this.document.selection,
          n = new Ks(t.getRanges(), {
            backward: t.isBackward,
            fake: !1
          });
        e != mo.arrowleft && e != mo.arrowup || n.setTo(n.getFirstPosition()), e != mo.arrowright && e != mo.arrowdown || n.setTo(n.getLastPosition());
        const i = {
          oldSelection: t,
          newSelection: n,
          domSelection: null
        };
        this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
      }
    }
    const kl = function (e) {
      return this.__data__.set(e, "__lodash_hash_undefined__"), this;
    };
    const bl = function (e) {
      return this.__data__.has(e);
    };
    function _l(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.__data__ = new _t(); ++t < n;) this.add(e[t]);
    }
    _l.prototype.add = _l.prototype.push = kl, _l.prototype.has = bl;
    const wl = _l;
    const Al = function (e, t) {
      for (var n = -1, i = null == e ? 0 : e.length; ++n < i;) if (t(e[n], n, e)) return !0;
      return !1;
    };
    const vl = function (e, t) {
      return e.has(t);
    };
    const Cl = function (e, t, n, i, o, r) {
      var s = 1 & n,
        a = e.length,
        l = t.length;
      if (a != l && !(s && l > a)) return !1;
      var c = r.get(e),
        d = r.get(t);
      if (c && d) return c == t && d == e;
      var u = -1,
        h = !0,
        m = 2 & n ? new wl() : void 0;
      for (r.set(e, t), r.set(t, e); ++u < a;) {
        var p = e[u],
          g = t[u];
        if (i) var f = s ? i(g, p, u, t, e, r) : i(p, g, u, e, t, r);
        if (void 0 !== f) {
          if (f) continue;
          h = !1;
          break;
        }
        if (m) {
          if (!Al(t, function (e, t) {
            if (!vl(m, t) && (p === e || o(p, e, n, i, r))) return m.push(t);
          })) {
            h = !1;
            break;
          }
        } else if (p !== g && !o(p, g, n, i, r)) {
          h = !1;
          break;
        }
      }
      return r.delete(e), r.delete(t), h;
    };
    const yl = function (e) {
      var t = -1,
        n = Array(e.size);
      return e.forEach(function (e, i) {
        n[++t] = [i, e];
      }), n;
    };
    const xl = function (e) {
      var t = -1,
        n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = e;
      }), n;
    };
    var El = ie ? ie.prototype : void 0,
      Sl = El ? El.valueOf : void 0;
    const Dl = function (e, t, n, i, o, r, s) {
      switch (n) {
        case "[object DataView]":
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;
        case "[object ArrayBuffer]":
          return !(e.byteLength != t.byteLength || !r(new Zn(e), new Zn(t)));
        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return Ee(+e, +t);
        case "[object Error]":
          return e.name == t.name && e.message == t.message;
        case "[object RegExp]":
        case "[object String]":
          return e == t + "";
        case "[object Map]":
          var a = yl;
        case "[object Set]":
          var l = 1 & i;
          if (a || (a = xl), e.size != t.size && !l) return !1;
          var c = s.get(e);
          if (c) return c == t;
          i |= 2, s.set(e, t);
          var d = Cl(a(e), a(t), i, o, r, s);
          return s.delete(e), d;
        case "[object Symbol]":
          if (Sl) return Sl.call(e) == Sl.call(t);
      }
      return !1;
    };
    var Tl = Object.prototype.hasOwnProperty;
    const Il = function (e, t, n, i, o, r) {
      var s = 1 & n,
        a = In(e),
        l = a.length;
      if (l != In(t).length && !s) return !1;
      for (var c = l; c--;) {
        var d = a[c];
        if (!(s ? d in t : Tl.call(t, d))) return !1;
      }
      var u = r.get(e),
        h = r.get(t);
      if (u && h) return u == t && h == e;
      var m = !0;
      r.set(e, t), r.set(t, e);
      for (var p = s; ++c < l;) {
        var g = e[d = a[c]],
          f = t[d];
        if (i) var k = s ? i(f, g, d, t, e, r) : i(g, f, d, e, t, r);
        if (!(void 0 === k ? g === f || o(g, f, n, i, r) : k)) {
          m = !1;
          break;
        }
        p || (p = "constructor" == d);
      }
      if (m && !p) {
        var b = e.constructor,
          _ = t.constructor;
        b == _ || !("constructor" in e) || !("constructor" in t) || "function" == typeof b && b instanceof b && "function" == typeof _ && _ instanceof _ || (m = !1);
      }
      return r.delete(e), r.delete(t), m;
    };
    var Bl = "[object Arguments]",
      Ml = "[object Array]",
      Pl = "[object Object]",
      zl = Object.prototype.hasOwnProperty;
    const Nl = function (e, t, n, i, o, r) {
      var s = me(e),
        a = me(t),
        l = s ? Ml : Wn(e),
        c = a ? Ml : Wn(t),
        d = (l = l == Bl ? Pl : l) == Pl,
        u = (c = c == Bl ? Pl : c) == Pl,
        h = l == c;
      if (h && Ot(e)) {
        if (!Ot(t)) return !1;
        s = !0, d = !1;
      }
      if (h && !d) return r || (r = new vt()), s || Qt(e) ? Cl(e, t, n, i, o, r) : Dl(e, t, l, n, i, o, r);
      if (!(1 & n)) {
        var m = d && zl.call(e, "__wrapped__"),
          p = u && zl.call(t, "__wrapped__");
        if (m || p) {
          var g = m ? e.value() : e,
            f = p ? t.value() : t;
          return r || (r = new vt()), o(g, f, n, i, r);
        }
      }
      return !!h && (r || (r = new vt()), Il(e, t, n, i, o, r));
    };
    const Ll = function e(t, n, i, o, r) {
      return t === n || (null == t || null == n || !pe(t) && !pe(n) ? t != t && n != n : Nl(t, n, i, o, e, r));
    };
    const Rl = function (e, t, n) {
      var i = (n = "function" == typeof n ? n : void 0) ? n(e, t) : void 0;
      return void 0 === i ? Ll(e, t, void 0, n) : !!i;
    };
    class Vl extends Ja {
      constructor(e) {
        super(e), this._config = {
          childList: !0,
          characterData: !0,
          subtree: !0
        }, this.domConverter = e.domConverter, this.renderer = e._renderer, this._domElements = new Set(), this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
      }
      flush() {
        this._onMutations(this._mutationObserver.takeRecords());
      }
      observe(e) {
        this._domElements.add(e), this.isEnabled && this._mutationObserver.observe(e, this._config);
      }
      stopObserving(e) {
        if (this._domElements.delete(e), this.isEnabled) {
          this._mutationObserver.disconnect();
          for (const e of this._domElements) this._mutationObserver.observe(e, this._config);
        }
      }
      enable() {
        super.enable();
        for (const e of this._domElements) this._mutationObserver.observe(e, this._config);
      }
      disable() {
        super.disable(), this._mutationObserver.disconnect();
      }
      destroy() {
        super.destroy(), this._mutationObserver.disconnect();
      }
      _onMutations(e) {
        if (0 === e.length) return;
        const t = this.domConverter,
          n = new Set(),
          i = new Set();
        for (const n of e) {
          const e = t.mapDomToView(n.target);
          e && (e.is("uiElement") || e.is("rawElement") || "childList" !== n.type || this._isBogusBrMutation(n) || i.add(e));
        }
        for (const o of e) {
          const e = t.mapDomToView(o.target);
          if ((!e || !e.is("uiElement") && !e.is("rawElement")) && "characterData" === o.type) {
            const e = t.findCorrespondingViewText(o.target);
            e && !i.has(e.parent) ? n.add(e) : !e && Ia(o.target) && i.add(t.mapDomToView(o.target.parentNode));
          }
        }
        let o = !1;
        for (const e of n) o = !0, this.renderer.markToSync("text", e);
        for (const e of i) {
          const n = t.mapViewToDom(e),
            i = Array.from(e.getChildren()),
            r = Array.from(t.domChildrenToView(n, {
              withChildren: !1
            }));
          Rl(i, r, Ol) || (o = !0, this.renderer.markToSync("children", e));
        }
        o && this.view.forceRender();
      }
      _isBogusBrMutation(e) {
        let t = null;
        return null === e.nextSibling && 0 === e.removedNodes.length && 1 == e.addedNodes.length && (t = this.domConverter.domToView(e.addedNodes[0], {
          withChildren: !1
        })), t && t.is("element", "br");
      }
    }
    function Ol(e, t) {
      if (!Array.isArray(e)) return e === t || !(!e.is("$text") || !t.is("$text")) && e.data === t.data;
    }
    class Fl extends tl {
      constructor(e) {
        super(e), this._isFocusChanging = !1, this.domEventType = ["focus", "blur"], this.useCapture = !0;
        const t = this.document;
        t.on("focus", () => {
          this._isFocusChanging = !0, this._renderTimeoutId = setTimeout(() => {
            this.flush(), e.change(() => {});
          }, 50);
        }), t.on("blur", (n, i) => {
          const o = t.selection.editableElement;
          null !== o && o !== i.target || (t.isFocused = !1, this._isFocusChanging = !1, e.change(() => {}));
        });
      }
      flush() {
        this._isFocusChanging && (this._isFocusChanging = !1, this.document.isFocused = !0);
      }
      onDomEvent(e) {
        this.fire(e.type, e);
      }
      destroy() {
        this._renderTimeoutId && clearTimeout(this._renderTimeoutId), super.destroy();
      }
    }
    class jl extends Ja {
      constructor(e) {
        super(e), this.mutationObserver = e.getObserver(Vl), this.focusObserver = e.getObserver(Fl), this.selection = this.document.selection, this.domConverter = e.domConverter, this._documents = new WeakSet(), this._fireSelectionChangeDoneDebounced = gl(e => {
          this.document.fire("selectionChangeDone", e);
        }, 200), this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3), this._documentIsSelectingInactivityTimeoutDebounced = gl(() => this.document.isSelecting = !1, 5e3), this._loopbackCounter = 0;
      }
      observe(e) {
        const t = e.ownerDocument,
          n = () => {
            this.document.isSelecting && (this._handleSelectionChange(null, t), this.document.isSelecting = !1, this._documentIsSelectingInactivityTimeoutDebounced.cancel());
          };
        this.listenTo(e, "selectstart", () => {
          this.document.isSelecting = !0, this._documentIsSelectingInactivityTimeoutDebounced();
        }, {
          priority: "highest"
        }), this.listenTo(e, "keydown", n, {
          priority: "highest",
          useCapture: !0
        }), this.listenTo(e, "keyup", n, {
          priority: "highest",
          useCapture: !0
        }), this._documents.has(t) || (this.listenTo(t, "mouseup", n, {
          priority: "highest",
          useCapture: !0
        }), this.listenTo(t, "selectionchange", (e, n) => {
          this.document.isComposing && !s.isAndroid || (this._handleSelectionChange(n, t), this._documentIsSelectingInactivityTimeoutDebounced());
        }), this._documents.add(t));
      }
      stopObserving(e) {
        this.stopListening(e);
      }
      destroy() {
        super.destroy(), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
      }
      _reportInfiniteLoop() {}
      _handleSelectionChange(e, t) {
        if (!this.isEnabled) return;
        const n = t.defaultView.getSelection();
        if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
        this.mutationObserver.flush();
        const i = this.domConverter.domSelectionToView(n);
        if (0 != i.rangeCount) {
          if (this.view.hasDomSelection = !0, this.focusObserver.flush(), !this.selection.isEqual(i) || !this.domConverter.isDomSelectionCorrect(n)) if (++this._loopbackCounter > 60) this._reportInfiniteLoop();else if (this.selection.isSimilar(i)) this.view.forceRender();else {
            const e = {
              oldSelection: this.selection,
              newSelection: i,
              domSelection: n
            };
            this.document.fire("selectionChange", e), this._fireSelectionChangeDoneDebounced(e);
          }
        } else this.view.hasDomSelection = !1;
      }
      _clearInfiniteLoop() {
        this._loopbackCounter = 0;
      }
    }
    class Hl extends tl {
      constructor(e) {
        super(e), this.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        const t = this.document;
        t.on("compositionstart", () => {
          t.isComposing = !0;
        }, {
          priority: "low"
        }), t.on("compositionend", () => {
          t.isComposing = !1;
        }, {
          priority: "low"
        });
      }
      onDomEvent(e) {
        this.fire(e.type, e, {
          data: e.data
        });
      }
    }
    class Ul {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._files = t.cacheFiles ? ql(e) : null, this._native = e;
      }
      get files() {
        return this._files || (this._files = ql(this._native)), this._files;
      }
      get types() {
        return this._native.types;
      }
      getData(e) {
        return this._native.getData(e);
      }
      setData(e, t) {
        this._native.setData(e, t);
      }
      set effectAllowed(e) {
        this._native.effectAllowed = e;
      }
      get effectAllowed() {
        return this._native.effectAllowed;
      }
      set dropEffect(e) {
        this._native.dropEffect = e;
      }
      get dropEffect() {
        return this._native.dropEffect;
      }
      setDragImage(e, t, n) {
        this._native.setDragImage(e, t, n);
      }
      get isCanceled() {
        return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
      }
    }
    function ql(e) {
      const t = Array.from(e.files || []),
        n = Array.from(e.items || []);
      return t.length ? t : n.filter(e => "file" === e.kind).map(e => e.getAsFile());
    }
    class Gl extends tl {
      constructor() {
        super(...arguments), this.domEventType = "beforeinput";
      }
      onDomEvent(e) {
        const t = e.getTargetRanges(),
          n = this.view,
          i = n.document;
        let o = null,
          r = null,
          a = [];
        if (e.dataTransfer && (o = new Ul(e.dataTransfer)), null !== e.data ? r = e.data : o && (r = o.getData("text/plain")), i.selection.isFake) a = Array.from(i.selection.getRanges());else if (t.length) a = t.map(e => {
          const t = n.domConverter.domPositionToView(e.startContainer, e.startOffset),
            i = n.domConverter.domPositionToView(e.endContainer, e.endOffset);
          return t ? n.createRange(t, i) : i ? n.createRange(i) : void 0;
        }).filter(e => !!e);else if (s.isAndroid) {
          const t = e.target.ownerDocument.defaultView.getSelection();
          a = Array.from(n.domConverter.domSelectionToView(t).getRanges());
        }
        if (s.isAndroid && "insertCompositionText" == e.inputType && r && r.endsWith("\n")) this.fire(e.type, e, {
          inputType: "insertParagraph",
          targetRanges: [n.createRange(a[0].end)]
        });else if ("insertText" == e.inputType && r && r.includes("\n")) {
          const t = r.split(/\n{1,2}/g);
          let n = a;
          for (let r = 0; r < t.length; r++) {
            const s = t[r];
            "" != s && (this.fire(e.type, e, {
              data: s,
              dataTransfer: o,
              targetRanges: n,
              inputType: e.inputType,
              isComposing: e.isComposing
            }), n = [i.selection.getFirstRange()]), r + 1 < t.length && (this.fire(e.type, e, {
              inputType: "insertParagraph",
              targetRanges: n
            }), n = [i.selection.getFirstRange()]);
          }
        } else this.fire(e.type, e, {
          data: r,
          dataTransfer: o,
          targetRanges: a,
          inputType: e.inputType,
          isComposing: e.isComposing
        });
      }
    }
    class Kl extends Ja {
      constructor(e) {
        super(e), this.document.on("keydown", (e, t) => {
          if (this.isEnabled && ((n = t.keyCode) == mo.arrowright || n == mo.arrowleft || n == mo.arrowup || n == mo.arrowdown)) {
            const n = new Ys(this.document, "arrowKey", this.document.selection.getFirstRange());
            this.document.fire(n, t), n.stop.called && e.stop();
          }
          var n;
        });
      }
      observe() {}
      stopObserving() {}
    }
    class Wl extends Ja {
      constructor(e) {
        super(e);
        const t = this.document;
        t.on("keydown", (e, n) => {
          if (!this.isEnabled || n.keyCode != mo.tab || n.ctrlKey) return;
          const i = new Ys(t, "tab", t.selection.getFirstRange());
          t.fire(i, n), i.stop.called && e.stop();
        });
      }
      observe() {}
      stopObserving() {}
    }
    const Yl = function (e) {
      return _i(e, 5);
    };
    class $l extends q() {
      constructor(e) {
        super(), this.domRoots = new Map(), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this.document = new ta(e), this.domConverter = new Wa(this.document), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new La(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting", "isComposing").to(this.document, "isFocused", "isSelecting", "isComposing"), this._writer = new pa(this.document), this.addObserver(Vl), this.addObserver(Fl), this.addObserver(jl), this.addObserver(nl), this.addObserver(fl), this.addObserver(Hl), this.addObserver(Kl), this.addObserver(Gl), this.addObserver(Wl), this.document.on("arrowKey", Pa, {
          priority: "low"
        }), ca(this), this.on("render", () => {
          this._render(), this.document.fire("layoutChanged"), this._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", () => {
          this._hasChangedSinceTheLastRendering = !0;
        }), this.listenTo(this.document, "change:isFocused", () => {
          this._hasChangedSinceTheLastRendering = !0;
        }), s.isiOS && this.listenTo(this.document, "blur", (e, t) => {
          this.domConverter.mapDomToView(t.domEvent.relatedTarget) || this.domConverter._clearDomSelection();
        });
      }
      attachDomRoot(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
        const n = this.document.getRoot(t);
        n._name = e.tagName.toLowerCase();
        const i = {};
        for (const {
          name: t,
          value: o
        } of Array.from(e.attributes)) i[t] = o, "class" === t ? this._writer.addClass(o.split(" "), n) : this._writer.setAttribute(t, o, n);
        this._initialDomRootAttributes.set(e, i);
        const o = () => {
          this._writer.setAttribute("contenteditable", (!n.isReadOnly).toString(), n), n.isReadOnly ? this._writer.addClass("ck-read-only", n) : this._writer.removeClass("ck-read-only", n);
        };
        o(), this.domRoots.set(t, e), this.domConverter.bindElements(e, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(e.ownerDocument), n.on("change:children", (e, t) => this._renderer.markToSync("children", t)), n.on("change:attributes", (e, t) => this._renderer.markToSync("attributes", t)), n.on("change:text", (e, t) => this._renderer.markToSync("text", t)), n.on("change:isReadOnly", () => this.change(o)), n.on("change", () => {
          this._hasChangedSinceTheLastRendering = !0;
        });
        for (const n of this._observers.values()) n.observe(e, t);
      }
      detachDomRoot(e) {
        const t = this.domRoots.get(e);
        Array.from(t.attributes).forEach(_ref19 => {
          let {
            name: e
          } = _ref19;
          return t.removeAttribute(e);
        });
        const n = this._initialDomRootAttributes.get(t);
        for (const e in n) t.setAttribute(e, n[e]);
        this.domRoots.delete(e), this.domConverter.unbindDomElement(t);
        for (const e of this._observers.values()) e.stopObserving(t);
      }
      getDomRoot() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this.domRoots.get(e);
      }
      addObserver(e) {
        let t = this._observers.get(e);
        if (t) return t;
        t = new e(this), this._observers.set(e, t);
        for (const [e, n] of this.domRoots) t.observe(n, e);
        return t.enable(), t;
      }
      getObserver(e) {
        return this._observers.get(e);
      }
      disableObservers() {
        for (const e of this._observers.values()) e.disable();
      }
      enableObservers() {
        for (const e of this._observers.values()) e.enable();
      }
      scrollToTheSelection() {
        let {
          alignToTop: e,
          forceScroll: t,
          viewportOffset: n = 20,
          ancestorOffset: i = 20
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const o = this.document.selection.getFirstRange();
        if (!o) return;
        const r = Yl({
          alignToTop: e,
          forceScroll: t,
          viewportOffset: n,
          ancestorOffset: i
        });
        "number" == typeof n && (n = {
          top: n,
          bottom: n,
          left: n,
          right: n
        });
        const s = {
          target: this.domConverter.viewRangeToDom(o),
          viewportOffset: n,
          ancestorOffset: i,
          alignToTop: e,
          forceScroll: t
        };
        this.fire("scrollToTheSelection", s, r), function (_ref20) {
          let {
            target: e,
            viewportOffset: t = 0,
            ancestorOffset: n = 0,
            alignToTop: i,
            forceScroll: o
          } = _ref20;
          const r = so(e);
          let s = r,
            a = null;
          for (t = function (e) {
            return "number" == typeof e ? {
              top: e,
              bottom: e,
              left: e,
              right: e
            } : e;
          }(t); s;) {
            let l;
            l = ao(s == r ? e : a), to({
              parent: l,
              getRect: () => lo(e, s),
              alignToTop: i,
              ancestorOffset: n,
              forceScroll: o
            });
            const c = lo(e, s);
            if (eo({
              window: s,
              rect: c,
              viewportOffset: t,
              alignToTop: i,
              forceScroll: o
            }), s.parent != s) {
              if (a = s.frameElement, s = s.parent, !a) return;
            } else s = null;
          }
        }(s);
      }
      focus() {
        if (!this.document.isFocused) {
          const e = this.document.selection.editableElement;
          e && (this.domConverter.focus(e), this.forceRender());
        }
      }
      change(e) {
        if (this.isRenderingInProgress || this._postFixersInProgress) throw new _("cannot-change-view-tree", this);
        try {
          if (this._ongoingChange) return e(this._writer);
          this._ongoingChange = !0;
          const t = e(this._writer);
          return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), t;
        } catch (e) {
          _.rethrowUnexpectedError(e, this);
        }
      }
      forceRender() {
        this._hasChangedSinceTheLastRendering = !0, this.getObserver(Fl).flush(), this.change(() => {});
      }
      destroy() {
        for (const e of this._observers.values()) e.destroy();
        this.document.destroy(), this.stopListening();
      }
      createPositionAt(e, t) {
        return Us._createAt(e, t);
      }
      createPositionAfter(e) {
        return Us._createAfter(e);
      }
      createPositionBefore(e) {
        return Us._createBefore(e);
      }
      createRange(e, t) {
        return new qs(e, t);
      }
      createRangeOn(e) {
        return qs._createOn(e);
      }
      createRangeIn(e) {
        return qs._createIn(e);
      }
      createSelection() {
        for (var _len23 = arguments.length, e = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
          e[_key23] = arguments[_key23];
        }
        return new Ks(...e);
      }
      _disableRendering(e) {
        this._renderingDisabled = e, 0 == e && this.change(() => {});
      }
      _render() {
        this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
      }
    }
    class Zl {
      is() {
        throw new Error("is() method is abstract");
      }
    }
    class Ql extends Zl {
      constructor(e) {
        super(), this.parent = null, this._attrs = Yo(e);
      }
      get document() {
        return null;
      }
      get index() {
        let e;
        if (!this.parent) return null;
        if (null === (e = this.parent.getChildIndex(this))) throw new _("model-node-not-found-in-parent", this);
        return e;
      }
      get startOffset() {
        let e;
        if (!this.parent) return null;
        if (null === (e = this.parent.getChildStartOffset(this))) throw new _("model-node-not-found-in-parent", this);
        return e;
      }
      get offsetSize() {
        return 1;
      }
      get endOffset() {
        return this.parent ? this.startOffset + this.offsetSize : null;
      }
      get nextSibling() {
        const e = this.index;
        return null !== e && this.parent.getChild(e + 1) || null;
      }
      get previousSibling() {
        const e = this.index;
        return null !== e && this.parent.getChild(e - 1) || null;
      }
      get root() {
        let e = this;
        for (; e.parent;) e = e.parent;
        return e;
      }
      isAttached() {
        return null !== this.parent && this.root.isAttached();
      }
      getPath() {
        const e = [];
        let t = this;
        for (; t.parent;) e.unshift(t.startOffset), t = t.parent;
        return e;
      }
      getAncestors() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = [];
        let n = e.includeSelf ? this : this.parent;
        for (; n;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return t;
      }
      getCommonAncestor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.getAncestors(t),
          i = e.getAncestors(t);
        let o = 0;
        for (; n[o] == i[o] && n[o];) o++;
        return 0 === o ? null : n[o - 1];
      }
      isBefore(e) {
        if (this == e) return !1;
        if (this.root !== e.root) return !1;
        const t = this.getPath(),
          n = e.getPath(),
          i = J(t, n);
        switch (i) {
          case "prefix":
            return !0;
          case "extension":
            return !1;
          default:
            return t[i] < n[i];
        }
      }
      isAfter(e) {
        return this != e && this.root === e.root && !this.isBefore(e);
      }
      hasAttribute(e) {
        return this._attrs.has(e);
      }
      getAttribute(e) {
        return this._attrs.get(e);
      }
      getAttributes() {
        return this._attrs.entries();
      }
      getAttributeKeys() {
        return this._attrs.keys();
      }
      toJSON() {
        const e = {};
        return this._attrs.size && (e.attributes = Array.from(this._attrs).reduce((e, t) => (e[t[0]] = t[1], e), {})), e;
      }
      _clone(e) {
        return new this.constructor(this._attrs);
      }
      _remove() {
        this.parent._removeChildren(this.index);
      }
      _setAttribute(e, t) {
        this._attrs.set(e, t);
      }
      _setAttributesTo(e) {
        this._attrs = Yo(e);
      }
      _removeAttribute(e) {
        return this._attrs.delete(e);
      }
      _clearAttributes() {
        this._attrs.clear();
      }
    }
    Ql.prototype.is = function (e) {
      return "node" === e || "model:node" === e;
    };
    class Jl {
      constructor(e) {
        this._nodes = [], e && this._insertNodes(0, e);
      }
      [Symbol.iterator]() {
        return this._nodes[Symbol.iterator]();
      }
      get length() {
        return this._nodes.length;
      }
      get maxOffset() {
        return this._nodes.reduce((e, t) => e + t.offsetSize, 0);
      }
      getNode(e) {
        return this._nodes[e] || null;
      }
      getNodeIndex(e) {
        const t = this._nodes.indexOf(e);
        return -1 == t ? null : t;
      }
      getNodeStartOffset(e) {
        const t = this.getNodeIndex(e);
        return null === t ? null : this._nodes.slice(0, t).reduce((e, t) => e + t.offsetSize, 0);
      }
      indexToOffset(e) {
        if (e == this._nodes.length) return this.maxOffset;
        const t = this._nodes[e];
        if (!t) throw new _("model-nodelist-index-out-of-bounds", this);
        return this.getNodeStartOffset(t);
      }
      offsetToIndex(e) {
        let t = 0;
        for (const n of this._nodes) {
          if (e >= t && e < t + n.offsetSize) return this.getNodeIndex(n);
          t += n.offsetSize;
        }
        if (t != e) throw new _("model-nodelist-offset-out-of-bounds", this, {
          offset: e,
          nodeList: this
        });
        return this.length;
      }
      _insertNodes(e, t) {
        for (const e of t) if (!(e instanceof Ql)) throw new _("model-nodelist-insertnodes-not-node", this);
        this._nodes = function (e, t, n, i) {
          if (Math.max(t.length, e.length) > 1e4) return e.slice(0, n).concat(t).concat(e.slice(n + i, e.length));
          {
            const o = Array.from(e);
            return o.splice(n, i, ...t), o;
          }
        }(this._nodes, Array.from(t), e, 0);
      }
      _removeNodes(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return this._nodes.splice(e, t);
      }
      toJSON() {
        return this._nodes.map(e => e.toJSON());
      }
    }
    class Xl extends Ql {
      constructor(e, t) {
        super(t), this._data = e || "";
      }
      get offsetSize() {
        return this.data.length;
      }
      get data() {
        return this._data;
      }
      toJSON() {
        const e = super.toJSON();
        return e.data = this.data, e;
      }
      _clone() {
        return new Xl(this.data, this.getAttributes());
      }
      static fromJSON(e) {
        return new Xl(e.data, e.attributes);
      }
    }
    Xl.prototype.is = function (e) {
      return "$text" === e || "model:$text" === e || "text" === e || "model:text" === e || "node" === e || "model:node" === e;
    };
    class ec extends Zl {
      constructor(e, t, n) {
        if (super(), this.textNode = e, t < 0 || t > e.offsetSize) throw new _("model-textproxy-wrong-offsetintext", this);
        if (n < 0 || t + n > e.offsetSize) throw new _("model-textproxy-wrong-length", this);
        this.data = e.data.substring(t, t + n), this.offsetInText = t;
      }
      get startOffset() {
        return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
      }
      get offsetSize() {
        return this.data.length;
      }
      get endOffset() {
        return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
      }
      get isPartial() {
        return this.offsetSize !== this.textNode.offsetSize;
      }
      get parent() {
        return this.textNode.parent;
      }
      get root() {
        return this.textNode.root;
      }
      getPath() {
        const e = this.textNode.getPath();
        return e.length > 0 && (e[e.length - 1] += this.offsetInText), e;
      }
      getAncestors() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = [];
        let n = e.includeSelf ? this : this.parent;
        for (; n;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return t;
      }
      hasAttribute(e) {
        return this.textNode.hasAttribute(e);
      }
      getAttribute(e) {
        return this.textNode.getAttribute(e);
      }
      getAttributes() {
        return this.textNode.getAttributes();
      }
      getAttributeKeys() {
        return this.textNode.getAttributeKeys();
      }
    }
    ec.prototype.is = function (e) {
      return "$textProxy" === e || "model:$textProxy" === e || "textProxy" === e || "model:textProxy" === e;
    };
    class tc extends Ql {
      constructor(e, t, n) {
        super(t), this._children = new Jl(), this.name = e, n && this._insertChild(0, n);
      }
      get childCount() {
        return this._children.length;
      }
      get maxOffset() {
        return this._children.maxOffset;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      getChild(e) {
        return this._children.getNode(e);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      getChildIndex(e) {
        return this._children.getNodeIndex(e);
      }
      getChildStartOffset(e) {
        return this._children.getNodeStartOffset(e);
      }
      offsetToIndex(e) {
        return this._children.offsetToIndex(e);
      }
      getNodeByPath(e) {
        let t = this;
        for (const n of e) t = t.getChild(t.offsetToIndex(n));
        return t;
      }
      findAncestor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let n = t.includeSelf ? this : this.parent;
        for (; n;) {
          if (n.name === e) return n;
          n = n.parent;
        }
        return null;
      }
      toJSON() {
        const e = super.toJSON();
        if (e.name = this.name, this._children.length > 0) {
          e.children = [];
          for (const t of this._children) e.children.push(t.toJSON());
        }
        return e;
      }
      _clone() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        const t = e ? Array.from(this._children).map(e => e._clone(!0)) : void 0;
        return new tc(this.name, this.getAttributes(), t);
      }
      _appendChild(e) {
        this._insertChild(this.childCount, e);
      }
      _insertChild(e, t) {
        const n = function (e) {
          if ("string" == typeof e) return [new Xl(e)];
          X(e) || (e = [e]);
          return Array.from(e).map(e => "string" == typeof e ? new Xl(e) : e instanceof ec ? new Xl(e.data, e.getAttributes()) : e);
        }(t);
        for (const e of n) null !== e.parent && e._remove(), e.parent = this;
        this._children._insertNodes(e, n);
      }
      _removeChildren(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        const n = this._children._removeNodes(e, t);
        for (const e of n) e.parent = null;
        return n;
      }
      static fromJSON(e) {
        let t;
        if (e.children) {
          t = [];
          for (const n of e.children) n.name ? t.push(tc.fromJSON(n)) : t.push(Xl.fromJSON(n));
        }
        return new tc(e.name, e.attributes, t);
      }
    }
    tc.prototype.is = function (e, t) {
      return t ? t === this.name && ("element" === e || "model:element" === e) : "element" === e || "model:element" === e || "node" === e || "model:node" === e;
    };
    class nc {
      constructor(e) {
        if (!e || !e.boundaries && !e.startPosition) throw new _("model-tree-walker-no-start-position", null);
        const t = e.direction || "forward";
        if ("forward" != t && "backward" != t) throw new _("model-tree-walker-unknown-direction", e, {
          direction: t
        });
        this.direction = t, this.boundaries = e.boundaries || null, e.startPosition ? this._position = e.startPosition.clone() : this._position = oc._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }
      [Symbol.iterator]() {
        return this;
      }
      get position() {
        return this._position;
      }
      skip(e) {
        let t, n, i, o;
        do {
          i = this.position, o = this._visitedParent, ({
            done: t,
            value: n
          } = this.next());
        } while (!t && e(n));
        t || (this._position = i, this._visitedParent = o);
      }
      next() {
        return "forward" == this.direction ? this._next() : this._previous();
      }
      _next() {
        const e = this.position,
          t = this.position.clone(),
          n = this._visitedParent;
        if (null === n.parent && t.offset === n.maxOffset) return {
          done: !0,
          value: void 0
        };
        if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
          done: !0,
          value: void 0
        };
        const i = rc(t, n),
          o = i || sc(t, n, i);
        if (o instanceof tc) {
          if (this.shallow) {
            if (this.boundaries && this.boundaries.end.isBefore(t)) return {
              done: !0,
              value: void 0
            };
            t.offset++;
          } else t.path.push(0), this._visitedParent = o;
          return this._position = t, ic("elementStart", o, e, t, 1);
        }
        if (o instanceof Xl) {
          let i;
          if (this.singleCharacters) i = 1;else {
            let e = o.endOffset;
            this._boundaryEndParent == n && this.boundaries.end.offset < e && (e = this.boundaries.end.offset), i = e - t.offset;
          }
          const r = t.offset - o.startOffset,
            s = new ec(o, r, i);
          return t.offset += i, this._position = t, ic("text", s, e, t, i);
        }
        return t.path.pop(), t.offset++, this._position = t, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : ic("elementEnd", n, e, t);
      }
      _previous() {
        const e = this.position,
          t = this.position.clone(),
          n = this._visitedParent;
        if (null === n.parent && 0 === t.offset) return {
          done: !0,
          value: void 0
        };
        if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
          done: !0,
          value: void 0
        };
        const i = t.parent,
          o = rc(t, i),
          r = o || ac(t, i, o);
        if (r instanceof tc) return t.offset--, this.shallow ? (this._position = t, ic("elementStart", r, e, t, 1)) : (t.path.push(r.maxOffset), this._position = t, this._visitedParent = r, this.ignoreElementEnd ? this._previous() : ic("elementEnd", r, e, t));
        if (r instanceof Xl) {
          let i;
          if (this.singleCharacters) i = 1;else {
            let e = r.startOffset;
            this._boundaryStartParent == n && this.boundaries.start.offset > e && (e = this.boundaries.start.offset), i = t.offset - e;
          }
          const o = t.offset - r.startOffset,
            s = new ec(r, o - i, i);
          return t.offset -= i, this._position = t, ic("text", s, e, t, i);
        }
        return t.path.pop(), this._position = t, this._visitedParent = n.parent, ic("elementStart", n, e, t, 1);
      }
    }
    function ic(e, t, n, i, o) {
      return {
        done: !1,
        value: {
          type: e,
          item: t,
          previousPosition: n,
          nextPosition: i,
          length: o
        }
      };
    }
    class oc extends Zl {
      constructor(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        if (super(), !e.is("element") && !e.is("documentFragment")) throw new _("model-position-root-invalid", e);
        if (!(t instanceof Array) || 0 === t.length) throw new _("model-position-path-incorrect-format", e, {
          path: t
        });
        e.is("rootElement") ? t = t.slice() : (t = [...e.getPath(), ...t], e = e.root), this.root = e, this.path = t, this.stickiness = n;
      }
      get offset() {
        return this.path[this.path.length - 1];
      }
      set offset(e) {
        this.path[this.path.length - 1] = e;
      }
      get parent() {
        let e = this.root;
        for (let t = 0; t < this.path.length - 1; t++) if (e = e.getChild(e.offsetToIndex(this.path[t])), !e) throw new _("model-position-path-incorrect", this, {
          position: this
        });
        if (e.is("$text")) throw new _("model-position-path-incorrect", this, {
          position: this
        });
        return e;
      }
      get index() {
        return this.parent.offsetToIndex(this.offset);
      }
      get textNode() {
        return rc(this, this.parent);
      }
      get nodeAfter() {
        const e = this.parent;
        return sc(this, e, rc(this, e));
      }
      get nodeBefore() {
        const e = this.parent;
        return ac(this, e, rc(this, e));
      }
      get isAtStart() {
        return 0 === this.offset;
      }
      get isAtEnd() {
        return this.offset == this.parent.maxOffset;
      }
      compareWith(e) {
        if (this.root != e.root) return "different";
        const t = J(this.path, e.path);
        switch (t) {
          case "same":
            return "same";
          case "prefix":
            return "before";
          case "extension":
            return "after";
          default:
            return this.path[t] < e.path[t] ? "before" : "after";
        }
      }
      getLastMatchingPosition(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        t.startPosition = this;
        const n = new nc(t);
        return n.skip(e), n.position;
      }
      getParentPath() {
        return this.path.slice(0, -1);
      }
      getAncestors() {
        const e = this.parent;
        return e.is("documentFragment") ? [e] : e.getAncestors({
          includeSelf: !0
        });
      }
      findAncestor(e) {
        const t = this.parent;
        return t.is("element") ? t.findAncestor(e, {
          includeSelf: !0
        }) : null;
      }
      getCommonPath(e) {
        if (this.root != e.root) return [];
        const t = J(this.path, e.path),
          n = "string" == typeof t ? Math.min(this.path.length, e.path.length) : t;
        return this.path.slice(0, n);
      }
      getCommonAncestor(e) {
        const t = this.getAncestors(),
          n = e.getAncestors();
        let i = 0;
        for (; t[i] == n[i] && t[i];) i++;
        return 0 === i ? null : t[i - 1];
      }
      getShiftedBy(e) {
        const t = this.clone(),
          n = t.offset + e;
        return t.offset = n < 0 ? 0 : n, t;
      }
      isAfter(e) {
        return "after" == this.compareWith(e);
      }
      isBefore(e) {
        return "before" == this.compareWith(e);
      }
      isEqual(e) {
        return "same" == this.compareWith(e);
      }
      isTouching(e) {
        if (this.root !== e.root) return !1;
        const t = Math.min(this.path.length, e.path.length);
        for (let n = 0; n < t; n++) {
          const t = this.path[n] - e.path[n];
          if (t < -1 || t > 1) return !1;
          if (1 === t) return lc(e, this, n);
          if (-1 === t) return lc(this, e, n);
        }
        return this.path.length === e.path.length || (this.path.length > e.path.length ? cc(this.path, t) : cc(e.path, t));
      }
      hasSameParentAs(e) {
        if (this.root !== e.root) return !1;
        return "same" == J(this.getParentPath(), e.getParentPath());
      }
      getTransformedByOperation(e) {
        let t;
        switch (e.type) {
          case "insert":
            t = this._getTransformedByInsertOperation(e);
            break;
          case "move":
          case "remove":
          case "reinsert":
            t = this._getTransformedByMoveOperation(e);
            break;
          case "split":
            t = this._getTransformedBySplitOperation(e);
            break;
          case "merge":
            t = this._getTransformedByMergeOperation(e);
            break;
          default:
            t = oc._createAt(this);
        }
        return t;
      }
      _getTransformedByInsertOperation(e) {
        return this._getTransformedByInsertion(e.position, e.howMany);
      }
      _getTransformedByMoveOperation(e) {
        return this._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
      }
      _getTransformedBySplitOperation(e) {
        const t = e.movedRange;
        return t.containsPosition(this) || t.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(e.splitPosition, e.moveTargetPosition) : e.graveyardPosition ? this._getTransformedByMove(e.graveyardPosition, e.insertionPosition, 1) : this._getTransformedByInsertion(e.insertionPosition, 1);
      }
      _getTransformedByMergeOperation(e) {
        const t = e.movedRange;
        let n;
        return t.containsPosition(this) || t.start.isEqual(this) ? (n = this._getCombined(e.sourcePosition, e.targetPosition), e.sourcePosition.isBefore(e.targetPosition) && (n = n._getTransformedByDeletion(e.deletionPosition, 1))) : n = this.isEqual(e.deletionPosition) ? oc._createAt(e.deletionPosition) : this._getTransformedByMove(e.deletionPosition, e.graveyardPosition, 1), n;
      }
      _getTransformedByDeletion(e, t) {
        const n = oc._createAt(this);
        if (this.root != e.root) return n;
        if ("same" == J(e.getParentPath(), this.getParentPath())) {
          if (e.offset < this.offset) {
            if (e.offset + t > this.offset) return null;
            n.offset -= t;
          }
        } else if ("prefix" == J(e.getParentPath(), this.getParentPath())) {
          const i = e.path.length - 1;
          if (e.offset <= this.path[i]) {
            if (e.offset + t > this.path[i]) return null;
            n.path[i] -= t;
          }
        }
        return n;
      }
      _getTransformedByInsertion(e, t) {
        const n = oc._createAt(this);
        if (this.root != e.root) return n;
        if ("same" == J(e.getParentPath(), this.getParentPath())) (e.offset < this.offset || e.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += t);else if ("prefix" == J(e.getParentPath(), this.getParentPath())) {
          const i = e.path.length - 1;
          e.offset <= this.path[i] && (n.path[i] += t);
        }
        return n;
      }
      _getTransformedByMove(e, t, n) {
        if (t = t._getTransformedByDeletion(e, n), e.isEqual(t)) return oc._createAt(this);
        const i = this._getTransformedByDeletion(e, n);
        return null === i || e.isEqual(this) && "toNext" == this.stickiness || e.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(e, t) : i._getTransformedByInsertion(t, n);
      }
      _getCombined(e, t) {
        const n = e.path.length - 1,
          i = oc._createAt(t);
        return i.stickiness = this.stickiness, i.offset = i.offset + this.path[n] - e.offset, i.path = [...i.path, ...this.path.slice(n + 1)], i;
      }
      toJSON() {
        return {
          root: this.root.toJSON(),
          path: Array.from(this.path),
          stickiness: this.stickiness
        };
      }
      clone() {
        return new this.constructor(this.root, this.path, this.stickiness);
      }
      static _createAt(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        if (e instanceof oc) return new oc(e.root, e.path, e.stickiness);
        {
          const i = e;
          if ("end" == t) t = i.maxOffset;else {
            if ("before" == t) return this._createBefore(i, n);
            if ("after" == t) return this._createAfter(i, n);
            if (0 !== t && !t) throw new _("model-createpositionat-offset-required", [this, e]);
          }
          if (!i.is("element") && !i.is("documentFragment")) throw new _("model-position-parent-incorrect", [this, e]);
          const o = i.getPath();
          return o.push(t), new this(i.root, o, n);
        }
      }
      static _createAfter(e, t) {
        if (!e.parent) throw new _("model-position-after-root", [this, e], {
          root: e
        });
        return this._createAt(e.parent, e.endOffset, t);
      }
      static _createBefore(e, t) {
        if (!e.parent) throw new _("model-position-before-root", e, {
          root: e
        });
        return this._createAt(e.parent, e.startOffset, t);
      }
      static fromJSON(e, t) {
        if ("$graveyard" === e.root) {
          const n = new oc(t.graveyard, e.path);
          return n.stickiness = e.stickiness, n;
        }
        if (!t.getRoot(e.root)) throw new _("model-position-fromjson-no-root", t, {
          rootName: e.root
        });
        return new oc(t.getRoot(e.root), e.path, e.stickiness);
      }
    }
    function rc(e, t) {
      const n = t.getChild(t.offsetToIndex(e.offset));
      return n && n.is("$text") && n.startOffset < e.offset ? n : null;
    }
    function sc(e, t, n) {
      return null !== n ? null : t.getChild(t.offsetToIndex(e.offset));
    }
    function ac(e, t, n) {
      return null !== n ? null : t.getChild(t.offsetToIndex(e.offset) - 1);
    }
    function lc(e, t, n) {
      return n + 1 !== e.path.length && !!cc(t.path, n + 1) && !!function (e, t) {
        let n = e.parent,
          i = e.path.length - 1,
          o = 0;
        for (; i >= t;) {
          if (e.path[i] + o !== n.maxOffset) return !1;
          o = 1, i--, n = n.parent;
        }
        return !0;
      }(e, n + 1);
    }
    function cc(e, t) {
      for (; t < e.length;) {
        if (0 !== e[t]) return !1;
        t++;
      }
      return !0;
    }
    oc.prototype.is = function (e) {
      return "position" === e || "model:position" === e;
    };
    class dc extends Zl {
      constructor(e, t) {
        super(), this.start = oc._createAt(e), this.end = t ? oc._createAt(t) : oc._createAt(e), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }
      *[Symbol.iterator]() {
        yield* new nc({
          boundaries: this,
          ignoreElementEnd: !0
        });
      }
      get isCollapsed() {
        return this.start.isEqual(this.end);
      }
      get isFlat() {
        return "same" == J(this.start.getParentPath(), this.end.getParentPath());
      }
      get root() {
        return this.start.root;
      }
      containsPosition(e) {
        return e.isAfter(this.start) && e.isBefore(this.end);
      }
      containsRange(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        e.isCollapsed && (t = !1);
        const n = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
          i = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
        return n && i;
      }
      containsItem(e) {
        const t = oc._createBefore(e);
        return this.containsPosition(t) || this.start.isEqual(t);
      }
      isEqual(e) {
        return this.start.isEqual(e.start) && this.end.isEqual(e.end);
      }
      isIntersecting(e) {
        return this.start.isBefore(e.end) && this.end.isAfter(e.start);
      }
      getDifference(e) {
        const t = [];
        return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new dc(this.start, e.start)), this.containsPosition(e.end) && t.push(new dc(e.end, this.end))) : t.push(new dc(this.start, this.end)), t;
      }
      getIntersection(e) {
        if (this.isIntersecting(e)) {
          let t = this.start,
            n = this.end;
          return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new dc(t, n);
        }
        return null;
      }
      getJoined(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        let n = this.isIntersecting(e);
        if (n || (n = this.start.isBefore(e.start) ? t ? this.end.isTouching(e.start) : this.end.isEqual(e.start) : t ? e.end.isTouching(this.start) : e.end.isEqual(this.start)), !n) return null;
        let i = this.start,
          o = this.end;
        return e.start.isBefore(i) && (i = e.start), e.end.isAfter(o) && (o = e.end), new dc(i, o);
      }
      getMinimalFlatRanges() {
        const e = [],
          t = this.start.getCommonPath(this.end).length,
          n = oc._createAt(this.start);
        let i = n.parent;
        for (; n.path.length > t + 1;) {
          const t = i.maxOffset - n.offset;
          0 !== t && e.push(new dc(n, n.getShiftedBy(t))), n.path = n.path.slice(0, -1), n.offset++, i = i.parent;
        }
        for (; n.path.length <= this.end.path.length;) {
          const t = this.end.path[n.path.length - 1],
            i = t - n.offset;
          0 !== i && e.push(new dc(n, n.getShiftedBy(i))), n.offset = t, n.path.push(0);
        }
        return e;
      }
      getWalker() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return e.boundaries = this, new nc(e);
      }
      getItems() {
        var _this6 = this;
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          e.boundaries = _this6, e.ignoreElementEnd = !0;
          const t = new nc(e);
          for (const e of t) yield e.item;
        }();
      }
      getPositions() {
        var _this7 = this;
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          e.boundaries = _this7;
          const t = new nc(e);
          yield t.position;
          for (const e of t) yield e.nextPosition;
        }();
      }
      getTransformedByOperation(e) {
        switch (e.type) {
          case "insert":
            return this._getTransformedByInsertOperation(e);
          case "move":
          case "remove":
          case "reinsert":
            return this._getTransformedByMoveOperation(e);
          case "split":
            return [this._getTransformedBySplitOperation(e)];
          case "merge":
            return [this._getTransformedByMergeOperation(e)];
        }
        return [new dc(this.start, this.end)];
      }
      getTransformedByOperations(e) {
        const t = [new dc(this.start, this.end)];
        for (const n of e) for (let e = 0; e < t.length; e++) {
          const i = t[e].getTransformedByOperation(n);
          t.splice(e, 1, ...i), e += i.length - 1;
        }
        for (let e = 0; e < t.length; e++) {
          const n = t[e];
          for (let i = e + 1; i < t.length; i++) {
            const e = t[i];
            (n.containsRange(e) || e.containsRange(n) || n.isEqual(e)) && t.splice(i, 1);
          }
        }
        return t;
      }
      getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
      }
      getContainedElement() {
        if (this.isCollapsed) return null;
        const e = this.start.nodeAfter,
          t = this.end.nodeBefore;
        return e && e.is("element") && e === t ? e : null;
      }
      toJSON() {
        return {
          start: this.start.toJSON(),
          end: this.end.toJSON()
        };
      }
      clone() {
        return new this.constructor(this.start, this.end);
      }
      _getTransformedByInsertOperation(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return this._getTransformedByInsertion(e.position, e.howMany, t);
      }
      _getTransformedByMoveOperation(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = e.sourcePosition,
          i = e.howMany,
          o = e.targetPosition;
        return this._getTransformedByMove(n, o, i, t);
      }
      _getTransformedBySplitOperation(e) {
        const t = this.start._getTransformedBySplitOperation(e);
        let n = this.end._getTransformedBySplitOperation(e);
        return this.end.isEqual(e.insertionPosition) && (n = this.end.getShiftedBy(1)), t.root != n.root && (n = this.end.getShiftedBy(-1)), new dc(t, n);
      }
      _getTransformedByMergeOperation(e) {
        if (this.start.isEqual(e.targetPosition) && this.end.isEqual(e.deletionPosition)) return new dc(this.start);
        let t = this.start._getTransformedByMergeOperation(e),
          n = this.end._getTransformedByMergeOperation(e);
        return t.root != n.root && (n = this.end.getShiftedBy(-1)), t.isAfter(n) ? (e.sourcePosition.isBefore(e.targetPosition) ? (t = oc._createAt(n), t.offset = 0) : (e.deletionPosition.isEqual(t) || (n = e.deletionPosition), t = e.targetPosition), new dc(t, n)) : new dc(t, n);
      }
      _getTransformedByInsertion(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        if (n && this.containsPosition(e)) return [new dc(this.start, e), new dc(e.getShiftedBy(t), this.end._getTransformedByInsertion(e, t))];
        {
          const n = new dc(this.start, this.end);
          return n.start = n.start._getTransformedByInsertion(e, t), n.end = n.end._getTransformedByInsertion(e, t), [n];
        }
      }
      _getTransformedByMove(e, t, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        if (this.isCollapsed) {
          const i = this.start._getTransformedByMove(e, t, n);
          return [new dc(i)];
        }
        const o = dc._createFromPositionAndShift(e, n),
          r = t._getTransformedByDeletion(e, n);
        if (this.containsPosition(t) && !i && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
          const i = this.start._getTransformedByMove(e, t, n),
            o = this.end._getTransformedByMove(e, t, n);
          return [new dc(i, o)];
        }
        let s;
        const a = this.getDifference(o);
        let l = null;
        const c = this.getIntersection(o);
        if (1 == a.length ? l = new dc(a[0].start._getTransformedByDeletion(e, n), a[0].end._getTransformedByDeletion(e, n)) : 2 == a.length && (l = new dc(this.start, this.end._getTransformedByDeletion(e, n))), s = l ? l._getTransformedByInsertion(r, n, null !== c || i) : [], c) {
          const e = new dc(c.start._getCombined(o.start, r), c.end._getCombined(o.start, r));
          2 == s.length ? s.splice(1, 0, e) : s.push(e);
        }
        return s;
      }
      _getTransformedByDeletion(e, t) {
        let n = this.start._getTransformedByDeletion(e, t),
          i = this.end._getTransformedByDeletion(e, t);
        return null == n && null == i ? null : (null == n && (n = e), null == i && (i = e), new dc(n, i));
      }
      static _createFromPositionAndShift(e, t) {
        const n = e,
          i = e.getShiftedBy(t);
        return t > 0 ? new this(n, i) : new this(i, n);
      }
      static _createIn(e) {
        return new this(oc._createAt(e, 0), oc._createAt(e, e.maxOffset));
      }
      static _createOn(e) {
        return this._createFromPositionAndShift(oc._createBefore(e), e.offsetSize);
      }
      static _createFromRanges(e) {
        if (0 === e.length) throw new _("range-create-from-ranges-empty-array", null);
        if (1 == e.length) return e[0].clone();
        const t = e[0];
        e.sort((e, t) => e.start.isAfter(t.start) ? 1 : -1);
        const n = e.indexOf(t),
          i = new this(t.start, t.end);
        if (n > 0) for (let t = n - 1; e[t].end.isEqual(i.start); t++) i.start = oc._createAt(e[t].start);
        for (let t = n + 1; t < e.length && e[t].start.isEqual(i.end); t++) i.end = oc._createAt(e[t].end);
        return i;
      }
      static fromJSON(e, t) {
        return new this(oc.fromJSON(e.start, t), oc.fromJSON(e.end, t));
      }
    }
    dc.prototype.is = function (e) {
      return "range" === e || "model:range" === e;
    };
    class uc extends T() {
      constructor() {
        super(), this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._deferredBindingRemovals = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", (e, t) => {
          if (t.viewPosition) return;
          const n = this._modelToViewMapping.get(t.modelPosition.parent);
          if (!n) throw new _("mapping-model-position-view-parent-not-found", this, {
            modelPosition: t.modelPosition
          });
          t.viewPosition = this.findPositionIn(n, t.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", (e, t) => {
          if (t.modelPosition) return;
          const n = this.findMappedViewAncestor(t.viewPosition),
            i = this._viewToModelMapping.get(n),
            o = this._toModelOffset(t.viewPosition.parent, t.viewPosition.offset, n);
          t.modelPosition = oc._createAt(i, o);
        }, {
          priority: "low"
        });
      }
      bindElements(e, t) {
        this._modelToViewMapping.set(e, t), this._viewToModelMapping.set(t, e);
      }
      unbindViewElement(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.toModelElement(e);
        if (this._elementToMarkerNames.has(e)) for (const t of this._elementToMarkerNames.get(e)) this._unboundMarkerNames.add(t);
        t.defer ? this._deferredBindingRemovals.set(e, e.root) : (this._viewToModelMapping.delete(e), this._modelToViewMapping.get(n) == e && this._modelToViewMapping.delete(n));
      }
      unbindModelElement(e) {
        const t = this.toViewElement(e);
        this._modelToViewMapping.delete(e), this._viewToModelMapping.get(t) == e && this._viewToModelMapping.delete(t);
      }
      bindElementToMarker(e, t) {
        const n = this._markerNameToElements.get(t) || new Set();
        n.add(e);
        const i = this._elementToMarkerNames.get(e) || new Set();
        i.add(t), this._markerNameToElements.set(t, n), this._elementToMarkerNames.set(e, i);
      }
      unbindElementFromMarkerName(e, t) {
        const n = this._markerNameToElements.get(t);
        n && (n.delete(e), 0 == n.size && this._markerNameToElements.delete(t));
        const i = this._elementToMarkerNames.get(e);
        i && (i.delete(t), 0 == i.size && this._elementToMarkerNames.delete(e));
      }
      flushUnboundMarkerNames() {
        const e = Array.from(this._unboundMarkerNames);
        return this._unboundMarkerNames.clear(), e;
      }
      flushDeferredBindings() {
        for (const [e, t] of this._deferredBindingRemovals) e.root == t && this.unbindViewElement(e);
        this._deferredBindingRemovals = new Map();
      }
      clearBindings() {
        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this._deferredBindingRemovals = new Map();
      }
      toModelElement(e) {
        return this._viewToModelMapping.get(e);
      }
      toViewElement(e) {
        return this._modelToViewMapping.get(e);
      }
      toModelRange(e) {
        return new dc(this.toModelPosition(e.start), this.toModelPosition(e.end));
      }
      toViewRange(e) {
        return new qs(this.toViewPosition(e.start), this.toViewPosition(e.end));
      }
      toModelPosition(e) {
        const t = {
          viewPosition: e,
          mapper: this
        };
        return this.fire("viewToModelPosition", t), t.modelPosition;
      }
      toViewPosition(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = {
          modelPosition: e,
          mapper: this,
          isPhantom: t.isPhantom
        };
        return this.fire("modelToViewPosition", n), n.viewPosition;
      }
      markerNameToElements(e) {
        const t = this._markerNameToElements.get(e);
        if (!t) return null;
        const n = new Set();
        for (const e of t) if (e.is("attributeElement")) for (const t of e.getElementsWithSameId()) n.add(t);else n.add(e);
        return n;
      }
      registerViewToModelLength(e, t) {
        this._viewToModelLengthCallbacks.set(e, t);
      }
      findMappedViewAncestor(e) {
        let t = e.parent;
        for (; !this._viewToModelMapping.has(t);) t = t.parent;
        return t;
      }
      _toModelOffset(e, t, n) {
        if (n != e) {
          return this._toModelOffset(e.parent, e.index, n) + this._toModelOffset(e, t, e);
        }
        if (e.is("$text")) return t;
        let i = 0;
        for (let n = 0; n < t; n++) i += this.getModelLength(e.getChild(n));
        return i;
      }
      getModelLength(e) {
        if (this._viewToModelLengthCallbacks.get(e.name)) {
          return this._viewToModelLengthCallbacks.get(e.name)(e);
        }
        if (this._viewToModelMapping.has(e)) return 1;
        if (e.is("$text")) return e.data.length;
        if (e.is("uiElement")) return 0;
        {
          let t = 0;
          for (const n of e.getChildren()) t += this.getModelLength(n);
          return t;
        }
      }
      findPositionIn(e, t) {
        let n,
          i = 0,
          o = 0,
          r = 0;
        if (e.is("$text")) return new Us(e, t);
        for (; o < t;) n = e.getChild(r), i = this.getModelLength(n), o += i, r++;
        return o == t ? this._moveViewPositionToTextNode(new Us(e, r)) : this.findPositionIn(n, t - (o - i));
      }
      _moveViewPositionToTextNode(e) {
        const t = e.nodeBefore,
          n = e.nodeAfter;
        return t instanceof Xr ? new Us(t, t.data.length) : n instanceof Xr ? new Us(n, 0) : e;
      }
    }
    class hc {
      constructor() {
        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }
      add(e, t) {
        t = mc(t), e instanceof ec && (e = this._getSymbolForTextProxy(e)), this._consumable.has(e) || this._consumable.set(e, new Map()), this._consumable.get(e).set(t, !0);
      }
      consume(e, t) {
        return t = mc(t), e instanceof ec && (e = this._getSymbolForTextProxy(e)), !!this.test(e, t) && (this._consumable.get(e).set(t, !1), !0);
      }
      test(e, t) {
        t = mc(t), e instanceof ec && (e = this._getSymbolForTextProxy(e));
        const n = this._consumable.get(e);
        if (void 0 === n) return null;
        const i = n.get(t);
        return void 0 === i ? null : i;
      }
      revert(e, t) {
        t = mc(t), e instanceof ec && (e = this._getSymbolForTextProxy(e));
        const n = this.test(e, t);
        return !1 === n ? (this._consumable.get(e).set(t, !0), !0) : !0 !== n && null;
      }
      verifyAllConsumed(e) {
        const t = [];
        for (const [n, i] of this._consumable) for (const [o, r] of i) {
          const i = o.split(":")[0];
          r && e == i && t.push({
            event: o,
            item: n.name || n.description
          });
        }
        if (t.length) throw new _("conversion-model-consumable-not-consumed", null, {
          items: t
        });
      }
      _getSymbolForTextProxy(e) {
        let t = null;
        const n = this._textProxyRegistry.get(e.startOffset);
        if (n) {
          const i = n.get(e.endOffset);
          i && (t = i.get(e.parent));
        }
        return t || (t = this._addSymbolForTextProxy(e)), t;
      }
      _addSymbolForTextProxy(e) {
        const t = e.startOffset,
          n = e.endOffset,
          i = e.parent,
          o = Symbol("$textProxy:" + e.data);
        let r, s;
        return r = this._textProxyRegistry.get(t), r || (r = new Map(), this._textProxyRegistry.set(t, r)), s = r.get(n), s || (s = new Map(), r.set(n, s)), s.set(i, o), o;
      }
    }
    function mc(e) {
      const t = e.split(":");
      return "insert" == t[0] ? t[0] : "addMarker" == t[0] || "removeMarker" == t[0] ? e : t.length > 1 ? t[0] + ":" + t[1] : t[0];
    }
    class pc extends T() {
      constructor(e) {
        super(), this._conversionApi = {
          dispatcher: this,
          ...e
        }, this._firedEventsMap = new WeakMap();
      }
      convertChanges(e, t, n) {
        const i = this._createConversionApi(n, e.getRefreshedItems());
        for (const t of e.getMarkersToRemove()) this._convertMarkerRemove(t.name, t.range, i);
        const o = this._reduceChanges(e.getChanges());
        for (const e of o) "insert" === e.type ? this._convertInsert(dc._createFromPositionAndShift(e.position, e.length), i) : "reinsert" === e.type ? this._convertReinsert(dc._createFromPositionAndShift(e.position, e.length), i) : "remove" === e.type ? this._convertRemove(e.position, e.length, e.name, i) : this._convertAttribute(e.range, e.attributeKey, e.attributeOldValue, e.attributeNewValue, i);
        i.mapper.flushDeferredBindings();
        for (const e of i.mapper.flushUnboundMarkerNames()) {
          const n = t.get(e).getRange();
          this._convertMarkerRemove(e, n, i), this._convertMarkerAdd(e, n, i);
        }
        for (const t of e.getMarkersToAdd()) this._convertMarkerAdd(t.name, t.range, i);
        i.consumable.verifyAllConsumed("insert");
      }
      convert(e, t, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const o = this._createConversionApi(n, void 0, i);
        this._convertInsert(e, o);
        for (const [e, n] of t) this._convertMarkerAdd(e, n, o);
        o.consumable.verifyAllConsumed("insert");
      }
      convertSelection(e, t, n) {
        const i = this._createConversionApi(n);
        this.fire("cleanSelection", {
          selection: e
        }, i);
        const o = e.getFirstPosition().root;
        if (!i.mapper.toViewElement(o)) return;
        const r = Array.from(t.getMarkersAtPosition(e.getFirstPosition()));
        if (this._addConsumablesForSelection(i.consumable, e, r), this.fire("selection", {
          selection: e
        }, i), e.isCollapsed) {
          for (const t of r) if (i.consumable.test(e, "addMarker:" + t.name)) {
            const n = t.getRange();
            if (!gc(e.getFirstPosition(), t, i.mapper)) continue;
            const o = {
              item: e,
              markerName: t.name,
              markerRange: n
            };
            this.fire("addMarker:".concat(t.name), o, i);
          }
          for (const t of e.getAttributeKeys()) if (i.consumable.test(e, "attribute:" + t)) {
            const n = {
              item: e,
              range: e.getFirstRange(),
              attributeKey: t,
              attributeOldValue: null,
              attributeNewValue: e.getAttribute(t)
            };
            this.fire("attribute:".concat(t, ":$text"), n, i);
          }
        }
      }
      _convertInsert(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        n.doNotAddConsumables || this._addConsumablesForInsert(t.consumable, e);
        for (const n of Array.from(e.getWalker({
          shallow: !0
        })).map(fc)) this._testAndFire("insert", n, t);
      }
      _convertRemove(e, t, n, i) {
        this.fire("remove:".concat(n), {
          position: e,
          length: t
        }, i);
      }
      _convertAttribute(e, t, n, i, o) {
        this._addConsumablesForRange(o.consumable, e, "attribute:".concat(t));
        for (const r of e) {
          const e = {
            item: r.item,
            range: dc._createFromPositionAndShift(r.previousPosition, r.length),
            attributeKey: t,
            attributeOldValue: n,
            attributeNewValue: i
          };
          this._testAndFire("attribute:".concat(t), e, o);
        }
      }
      _convertReinsert(e, t) {
        const n = Array.from(e.getWalker({
          shallow: !0
        }));
        this._addConsumablesForInsert(t.consumable, n);
        for (const e of n.map(fc)) this._testAndFire("insert", {
          ...e,
          reconversion: !0
        }, t);
      }
      _convertMarkerAdd(e, t, n) {
        if ("$graveyard" == t.root.rootName) return;
        const i = "addMarker:".concat(e);
        if (n.consumable.add(t, i), this.fire(i, {
          markerName: e,
          markerRange: t
        }, n), n.consumable.consume(t, i)) {
          this._addConsumablesForRange(n.consumable, t, i);
          for (const o of t.getItems()) {
            if (!n.consumable.test(o, i)) continue;
            const r = {
              item: o,
              range: dc._createOn(o),
              markerName: e,
              markerRange: t
            };
            this.fire(i, r, n);
          }
        }
      }
      _convertMarkerRemove(e, t, n) {
        "$graveyard" != t.root.rootName && this.fire("removeMarker:".concat(e), {
          markerName: e,
          markerRange: t
        }, n);
      }
      _reduceChanges(e) {
        const t = {
          changes: e
        };
        return this.fire("reduceChanges", t), t.changes;
      }
      _addConsumablesForInsert(e, t) {
        for (const n of t) {
          const t = n.item;
          if (null === e.test(t, "insert")) {
            e.add(t, "insert");
            for (const n of t.getAttributeKeys()) e.add(t, "attribute:" + n);
          }
        }
        return e;
      }
      _addConsumablesForRange(e, t, n) {
        for (const i of t.getItems()) e.add(i, n);
        return e;
      }
      _addConsumablesForSelection(e, t, n) {
        e.add(t, "selection");
        for (const i of n) e.add(t, "addMarker:" + i.name);
        for (const n of t.getAttributeKeys()) e.add(t, "attribute:" + n);
        return e;
      }
      _testAndFire(e, t, n) {
        const i = function (e, t) {
            const n = t.item.is("element") ? t.item.name : "$text";
            return "".concat(e, ":").concat(n);
          }(e, t),
          o = t.item.is("$textProxy") ? n.consumable._getSymbolForTextProxy(t.item) : t.item,
          r = this._firedEventsMap.get(n),
          s = r.get(o);
        if (s) {
          if (s.has(i)) return;
          s.add(i);
        } else r.set(o, new Set([i]));
        this.fire(i, t, n);
      }
      _testAndFireAddAttributes(e, t) {
        const n = {
          item: e,
          range: dc._createOn(e)
        };
        for (const e of n.item.getAttributeKeys()) n.attributeKey = e, n.attributeOldValue = null, n.attributeNewValue = n.item.getAttribute(e), this._testAndFire("attribute:".concat(e), n, t);
      }
      _createConversionApi(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = {
          ...this._conversionApi,
          consumable: new hc(),
          writer: e,
          options: n,
          convertItem: e => this._convertInsert(dc._createOn(e), i),
          convertChildren: e => this._convertInsert(dc._createIn(e), i, {
            doNotAddConsumables: !0
          }),
          convertAttributes: e => this._testAndFireAddAttributes(e, i),
          canReuseView: e => !t.has(i.mapper.toModelElement(e))
        };
        return this._firedEventsMap.set(i, new Map()), i;
      }
    }
    function gc(e, t, n) {
      const i = t.getRange(),
        o = Array.from(e.getAncestors());
      o.shift(), o.reverse();
      return !o.some(e => {
        if (i.containsItem(e)) {
          return !!n.toViewElement(e).getCustomProperty("addHighlight");
        }
      });
    }
    function fc(e) {
      return {
        item: e.item,
        range: dc._createFromPositionAndShift(e.previousPosition, e.length)
      };
    }
    class kc extends T(Zl) {
      constructor() {
        super(), this._lastRangeBackward = !1, this._attrs = new Map(), this._ranges = [], arguments.length && this.setTo(...arguments);
      }
      get anchor() {
        if (this._ranges.length > 0) {
          const e = this._ranges[this._ranges.length - 1];
          return this._lastRangeBackward ? e.end : e.start;
        }
        return null;
      }
      get focus() {
        if (this._ranges.length > 0) {
          const e = this._ranges[this._ranges.length - 1];
          return this._lastRangeBackward ? e.start : e.end;
        }
        return null;
      }
      get isCollapsed() {
        return 1 === this._ranges.length && this._ranges[0].isCollapsed;
      }
      get rangeCount() {
        return this._ranges.length;
      }
      get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
      }
      isEqual(e) {
        if (this.rangeCount != e.rangeCount) return !1;
        if (0 === this.rangeCount) return !0;
        if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
        for (const t of this._ranges) {
          let n = !1;
          for (const i of e._ranges) if (t.isEqual(i)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      *getRanges() {
        for (const e of this._ranges) yield new dc(e.start, e.end);
      }
      getFirstRange() {
        let e = null;
        for (const t of this._ranges) e && !t.start.isBefore(e.start) || (e = t);
        return e ? new dc(e.start, e.end) : null;
      }
      getLastRange() {
        let e = null;
        for (const t of this._ranges) e && !t.end.isAfter(e.end) || (e = t);
        return e ? new dc(e.start, e.end) : null;
      }
      getFirstPosition() {
        const e = this.getFirstRange();
        return e ? e.start.clone() : null;
      }
      getLastPosition() {
        const e = this.getLastRange();
        return e ? e.end.clone() : null;
      }
      setTo() {
        for (var _len24 = arguments.length, e = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
          e[_key24] = arguments[_key24];
        }
        let [t, n, i] = e;
        if ("object" == typeof n && (i = n, n = void 0), null === t) this._setRanges([]);else if (t instanceof kc) this._setRanges(t.getRanges(), t.isBackward);else if (t && "function" == typeof t.getRanges) this._setRanges(t.getRanges(), t.isBackward);else if (t instanceof dc) this._setRanges([t], !!i && !!i.backward);else if (t instanceof oc) this._setRanges([new dc(t)]);else if (t instanceof Ql) {
          const e = !!i && !!i.backward;
          let o;
          if ("in" == n) o = dc._createIn(t);else if ("on" == n) o = dc._createOn(t);else {
            if (void 0 === n) throw new _("model-selection-setto-required-second-parameter", [this, t]);
            o = new dc(oc._createAt(t, n));
          }
          this._setRanges([o], e);
        } else {
          if (!X(t)) throw new _("model-selection-setto-not-selectable", [this, t]);
          this._setRanges(t, i && !!i.backward);
        }
      }
      _setRanges(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = Array.from(e),
          i = n.some(t => {
            if (!(t instanceof dc)) throw new _("model-selection-set-ranges-not-range", [this, e]);
            return this._ranges.every(e => !e.isEqual(t));
          });
        (n.length !== this._ranges.length || i) && (this._replaceAllRanges(n), this._lastRangeBackward = !!t, this.fire("change:range", {
          directChange: !0
        }));
      }
      setFocus(e, t) {
        if (null === this.anchor) throw new _("model-selection-setfocus-no-ranges", [this, e]);
        const n = oc._createAt(e, t);
        if ("same" == n.compareWith(this.focus)) return;
        const i = this.anchor;
        this._ranges.length && this._popRange(), "before" == n.compareWith(i) ? (this._pushRange(new dc(n, i)), this._lastRangeBackward = !0) : (this._pushRange(new dc(i, n)), this._lastRangeBackward = !1), this.fire("change:range", {
          directChange: !0
        });
      }
      getAttribute(e) {
        return this._attrs.get(e);
      }
      getAttributes() {
        return this._attrs.entries();
      }
      getAttributeKeys() {
        return this._attrs.keys();
      }
      hasAttribute(e) {
        return this._attrs.has(e);
      }
      removeAttribute(e) {
        this.hasAttribute(e) && (this._attrs.delete(e), this.fire("change:attribute", {
          attributeKeys: [e],
          directChange: !0
        }));
      }
      setAttribute(e, t) {
        this.getAttribute(e) !== t && (this._attrs.set(e, t), this.fire("change:attribute", {
          attributeKeys: [e],
          directChange: !0
        }));
      }
      getSelectedElement() {
        return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
      }
      *getSelectedBlocks() {
        const e = new WeakSet();
        for (const t of this.getRanges()) {
          const n = wc(t.start, e);
          vc(n, t) && (yield n);
          for (const n of t.getWalker()) {
            const i = n.item;
            "elementEnd" == n.type && _c(i, e, t) && (yield i);
          }
          const i = wc(t.end, e);
          Cc(i, t) && (yield i);
        }
      }
      containsEntireContent() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;
        const t = oc._createAt(e, 0),
          n = oc._createAt(e, "end");
        return t.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
      }
      _pushRange(e) {
        this._checkRange(e), this._ranges.push(new dc(e.start, e.end));
      }
      _checkRange(e) {
        for (let t = 0; t < this._ranges.length; t++) if (e.isIntersecting(this._ranges[t])) throw new _("model-selection-range-intersects", [this, e], {
          addedRange: e,
          intersectingRange: this._ranges[t]
        });
      }
      _replaceAllRanges(e) {
        this._removeAllRanges();
        for (const t of e) this._pushRange(t);
      }
      _removeAllRanges() {
        for (; this._ranges.length > 0;) this._popRange();
      }
      _popRange() {
        this._ranges.pop();
      }
    }
    function bc(e, t) {
      return !t.has(e) && (t.add(e), e.root.document.model.schema.isBlock(e) && !!e.parent);
    }
    function _c(e, t, n) {
      return bc(e, t) && Ac(e, n);
    }
    function wc(e, t) {
      const n = e.parent.root.document.model.schema,
        i = e.parent.getAncestors({
          parentFirst: !0,
          includeSelf: !0
        });
      let o = !1;
      const r = i.find(e => !o && (o = n.isLimit(e), !o && bc(e, t)));
      return i.forEach(e => t.add(e)), r;
    }
    function Ac(e, t) {
      const n = function (e) {
        const t = e.root.document.model.schema;
        let n = e.parent;
        for (; n;) {
          if (t.isBlock(n)) return n;
          n = n.parent;
        }
      }(e);
      if (!n) return !0;
      return !t.containsRange(dc._createOn(n), !0);
    }
    function vc(e, t) {
      return !!e && (!(!t.isCollapsed && !e.isEmpty) || !t.start.isTouching(oc._createAt(e, e.maxOffset)) && Ac(e, t));
    }
    function Cc(e, t) {
      return !!e && (!(!t.isCollapsed && !e.isEmpty) || !t.end.isTouching(oc._createAt(e, 0)) && Ac(e, t));
    }
    kc.prototype.is = function (e) {
      return "selection" === e || "model:selection" === e;
    };
    class yc extends T(dc) {
      constructor(e, t) {
        super(e, t), xc.call(this);
      }
      detach() {
        this.stopListening();
      }
      toRange() {
        return new dc(this.start, this.end);
      }
      static fromRange(e) {
        return new yc(e.start, e.end);
      }
    }
    function xc() {
      this.listenTo(this.root.document.model, "applyOperation", (e, t) => {
        const n = t[0];
        n.isDocumentOperation && Ec.call(this, n);
      }, {
        priority: "low"
      });
    }
    function Ec(e) {
      const t = this.getTransformedByOperation(e),
        n = dc._createFromRanges(t),
        i = !n.isEqual(this),
        o = function (e, t) {
          switch (t.type) {
            case "insert":
              return e.containsPosition(t.position);
            case "move":
            case "remove":
            case "reinsert":
            case "merge":
              return e.containsPosition(t.sourcePosition) || e.start.isEqual(t.sourcePosition) || e.containsPosition(t.targetPosition);
            case "split":
              return e.containsPosition(t.splitPosition) || e.containsPosition(t.insertionPosition);
          }
          return !1;
        }(this, e);
      let r = null;
      if (i) {
        "$graveyard" == n.root.rootName && (r = "remove" == e.type ? e.sourcePosition : e.deletionPosition);
        const t = this.toRange();
        this.start = n.start, this.end = n.end, this.fire("change:range", t, {
          deletionPosition: r
        });
      } else o && this.fire("change:content", this.toRange(), {
        deletionPosition: r
      });
    }
    yc.prototype.is = function (e) {
      return "liveRange" === e || "model:liveRange" === e || "range" == e || "model:range" === e;
    };
    const Sc = "selection:";
    class Dc extends T(Zl) {
      constructor(e) {
        super(), this._selection = new Tc(e), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
      }
      get isCollapsed() {
        return this._selection.isCollapsed;
      }
      get anchor() {
        return this._selection.anchor;
      }
      get focus() {
        return this._selection.focus;
      }
      get rangeCount() {
        return this._selection.rangeCount;
      }
      get hasOwnRange() {
        return this._selection.hasOwnRange;
      }
      get isBackward() {
        return this._selection.isBackward;
      }
      get isGravityOverridden() {
        return this._selection.isGravityOverridden;
      }
      get markers() {
        return this._selection.markers;
      }
      get _ranges() {
        return this._selection._ranges;
      }
      getRanges() {
        return this._selection.getRanges();
      }
      getFirstPosition() {
        return this._selection.getFirstPosition();
      }
      getLastPosition() {
        return this._selection.getLastPosition();
      }
      getFirstRange() {
        return this._selection.getFirstRange();
      }
      getLastRange() {
        return this._selection.getLastRange();
      }
      getSelectedBlocks() {
        return this._selection.getSelectedBlocks();
      }
      getSelectedElement() {
        return this._selection.getSelectedElement();
      }
      containsEntireContent(e) {
        return this._selection.containsEntireContent(e);
      }
      destroy() {
        this._selection.destroy();
      }
      getAttributeKeys() {
        return this._selection.getAttributeKeys();
      }
      getAttributes() {
        return this._selection.getAttributes();
      }
      getAttribute(e) {
        return this._selection.getAttribute(e);
      }
      hasAttribute(e) {
        return this._selection.hasAttribute(e);
      }
      refresh() {
        this._selection.updateMarkers(), this._selection._updateAttributes(!1);
      }
      observeMarkers(e) {
        this._selection.observeMarkers(e);
      }
      _setFocus(e, t) {
        this._selection.setFocus(e, t);
      }
      _setTo() {
        this._selection.setTo(...arguments);
      }
      _setAttribute(e, t) {
        this._selection.setAttribute(e, t);
      }
      _removeAttribute(e) {
        this._selection.removeAttribute(e);
      }
      _getStoredAttributes() {
        return this._selection.getStoredAttributes();
      }
      _overrideGravity() {
        return this._selection.overrideGravity();
      }
      _restoreGravity(e) {
        this._selection.restoreGravity(e);
      }
      static _getStoreAttributeKey(e) {
        return Sc + e;
      }
      static _isStoreAttributeKey(e) {
        return e.startsWith(Sc);
      }
    }
    Dc.prototype.is = function (e) {
      return "selection" === e || "model:selection" == e || "documentSelection" == e || "model:documentSelection" == e;
    };
    class Tc extends kc {
      constructor(e) {
        super(), this.markers = new qo({
          idProperty: "name"
        }), this._attributePriority = new Map(), this._selectionRestorePosition = null, this._hasChangedRange = !1, this._overriddenGravityRegister = new Set(), this._observedMarkers = new Set(), this._model = e.model, this._document = e, this.listenTo(this._model, "applyOperation", (e, t) => {
          const n = t[0];
          n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type && (0 == this._ranges.length && this._selectionRestorePosition && this._fixGraveyardSelection(this._selectionRestorePosition), this._selectionRestorePosition = null, this._hasChangedRange && (this._hasChangedRange = !1, this.fire("change:range", {
            directChange: !1
          })));
        }, {
          priority: "lowest"
        }), this.on("change:range", () => {
          this._validateSelectionRanges(this.getRanges());
        }), this.listenTo(this._model.markers, "update", (e, t, n, i) => {
          this._updateMarker(t, i);
        }), this.listenTo(this._document, "change", (e, t) => {
          !function (e, t) {
            const n = e.document.differ;
            for (const i of n.getChanges()) {
              if ("insert" != i.type) continue;
              const n = i.position.parent;
              i.length === n.maxOffset && e.enqueueChange(t, e => {
                const t = Array.from(n.getAttributeKeys()).filter(e => e.startsWith(Sc));
                for (const i of t) e.removeAttribute(i, n);
              });
            }
          }(this._model, t);
        });
      }
      get isCollapsed() {
        return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
      }
      get anchor() {
        return super.anchor || this._document._getDefaultRange().start;
      }
      get focus() {
        return super.focus || this._document._getDefaultRange().end;
      }
      get rangeCount() {
        return this._ranges.length ? this._ranges.length : 1;
      }
      get hasOwnRange() {
        return this._ranges.length > 0;
      }
      get isGravityOverridden() {
        return !!this._overriddenGravityRegister.size;
      }
      destroy() {
        for (let e = 0; e < this._ranges.length; e++) this._ranges[e].detach();
        this.stopListening();
      }
      *getRanges() {
        this._ranges.length ? yield* super.getRanges() : yield this._document._getDefaultRange();
      }
      getFirstRange() {
        return super.getFirstRange() || this._document._getDefaultRange();
      }
      getLastRange() {
        return super.getLastRange() || this._document._getDefaultRange();
      }
      setTo() {
        super.setTo(...arguments), this._updateAttributes(!0), this.updateMarkers();
      }
      setFocus(e, t) {
        super.setFocus(e, t), this._updateAttributes(!0), this.updateMarkers();
      }
      setAttribute(e, t) {
        if (this._setAttribute(e, t)) {
          const t = [e];
          this.fire("change:attribute", {
            attributeKeys: t,
            directChange: !0
          });
        }
      }
      removeAttribute(e) {
        if (this._removeAttribute(e)) {
          const t = [e];
          this.fire("change:attribute", {
            attributeKeys: t,
            directChange: !0
          });
        }
      }
      overrideGravity() {
        const e = g();
        return this._overriddenGravityRegister.add(e), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), e;
      }
      restoreGravity(e) {
        if (!this._overriddenGravityRegister.has(e)) throw new _("document-selection-gravity-wrong-restore", this, {
          uid: e
        });
        this._overriddenGravityRegister.delete(e), this.isGravityOverridden || this._updateAttributes(!0);
      }
      observeMarkers(e) {
        this._observedMarkers.add(e), this.updateMarkers();
      }
      _replaceAllRanges(e) {
        this._validateSelectionRanges(e), super._replaceAllRanges(e);
      }
      _popRange() {
        this._ranges.pop().detach();
      }
      _pushRange(e) {
        const t = this._prepareRange(e);
        t && this._ranges.push(t);
      }
      _validateSelectionRanges(e) {
        for (const t of e) if (!this._document._validateSelectionRange(t)) throw new _("document-selection-wrong-position", this, {
          range: t
        });
      }
      _prepareRange(e) {
        if (this._checkRange(e), e.root == this._document.graveyard) return;
        const t = yc.fromRange(e);
        return t.on("change:range", (e, n, i) => {
          if (this._hasChangedRange = !0, t.root == this._document.graveyard) {
            this._selectionRestorePosition = i.deletionPosition;
            const e = this._ranges.indexOf(t);
            this._ranges.splice(e, 1), t.detach();
          }
        }), t;
      }
      updateMarkers() {
        if (!this._observedMarkers.size) return;
        const e = [];
        let t = !1;
        for (const t of this._model.markers) {
          const n = t.name.split(":", 1)[0];
          if (!this._observedMarkers.has(n)) continue;
          const i = t.getRange();
          for (const n of this.getRanges()) i.containsRange(n, !n.isCollapsed) && e.push(t);
        }
        const n = Array.from(this.markers);
        for (const n of e) this.markers.has(n) || (this.markers.add(n), t = !0);
        for (const n of Array.from(this.markers)) e.includes(n) || (this.markers.remove(n), t = !0);
        t && this.fire("change:marker", {
          oldMarkers: n,
          directChange: !1
        });
      }
      _updateMarker(e, t) {
        const n = e.name.split(":", 1)[0];
        if (!this._observedMarkers.has(n)) return;
        let i = !1;
        const o = Array.from(this.markers),
          r = this.markers.has(e);
        if (t) {
          let n = !1;
          for (const e of this.getRanges()) if (t.containsRange(e, !e.isCollapsed)) {
            n = !0;
            break;
          }
          n && !r ? (this.markers.add(e), i = !0) : !n && r && (this.markers.remove(e), i = !0);
        } else r && (this.markers.remove(e), i = !0);
        i && this.fire("change:marker", {
          oldMarkers: o,
          directChange: !1
        });
      }
      _updateAttributes(e) {
        const t = Yo(this._getSurroundingAttributes()),
          n = Yo(this.getAttributes());
        if (e) this._attributePriority = new Map(), this._attrs = new Map();else for (const [e, t] of this._attributePriority) "low" == t && (this._attrs.delete(e), this._attributePriority.delete(e));
        this._setAttributesTo(t);
        const i = [];
        for (const [e, t] of this.getAttributes()) n.has(e) && n.get(e) === t || i.push(e);
        for (const [e] of n) this.hasAttribute(e) || i.push(e);
        i.length > 0 && this.fire("change:attribute", {
          attributeKeys: i,
          directChange: !1
        });
      }
      _setAttribute(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        const i = n ? "normal" : "low";
        if ("low" == i && "normal" == this._attributePriority.get(e)) return !1;
        return super.getAttribute(e) !== t && (this._attrs.set(e, t), this._attributePriority.set(e, i), !0);
      }
      _removeAttribute(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        const n = t ? "normal" : "low";
        return ("low" != n || "normal" != this._attributePriority.get(e)) && (this._attributePriority.set(e, n), !!super.hasAttribute(e) && (this._attrs.delete(e), !0));
      }
      _setAttributesTo(e) {
        const t = new Set();
        for (const [t, n] of this.getAttributes()) e.get(t) !== n && this._removeAttribute(t, !1);
        for (const [n, i] of e) {
          this._setAttribute(n, i, !1) && t.add(n);
        }
        return t;
      }
      *getStoredAttributes() {
        const e = this.getFirstPosition().parent;
        if (this.isCollapsed && e.isEmpty) for (const t of e.getAttributeKeys()) if (t.startsWith(Sc)) {
          const n = t.substr(10);
          yield [n, e.getAttribute(t)];
        }
      }
      _getSurroundingAttributes() {
        const e = this.getFirstPosition(),
          t = this._model.schema;
        if ("$graveyard" == e.root.rootName) return null;
        let n = null;
        if (this.isCollapsed) {
          const i = e.textNode ? e.textNode : e.nodeBefore,
            o = e.textNode ? e.textNode : e.nodeAfter;
          if (this.isGravityOverridden || (n = Ic(i, t)), n || (n = Ic(o, t)), !this.isGravityOverridden && !n) {
            let e = i;
            for (; e && !n;) e = e.previousSibling, n = Ic(e, t);
          }
          if (!n) {
            let e = o;
            for (; e && !n;) e = e.nextSibling, n = Ic(e, t);
          }
          n || (n = this.getStoredAttributes());
        } else {
          const e = this.getFirstRange();
          for (const i of e) {
            if (i.item.is("element") && t.isObject(i.item)) {
              n = Ic(i.item, t);
              break;
            }
            if ("text" == i.type) {
              n = i.item.getAttributes();
              break;
            }
          }
        }
        return n;
      }
      _fixGraveyardSelection(e) {
        const t = this._model.schema.getNearestSelectionRange(e);
        t && this._pushRange(t);
      }
    }
    function Ic(e, t) {
      if (!e) return null;
      if (e instanceof ec || e instanceof Xl) return e.getAttributes();
      if (!t.isInline(e)) return null;
      if (!t.isObject(e)) return [];
      const n = [];
      for (const [i, o] of e.getAttributes()) t.checkAttribute("$text", i) && !1 !== t.getAttributeProperties(i).copyFromObject && n.push([i, o]);
      return n;
    }
    class Bc {
      constructor(e) {
        this._dispatchers = e;
      }
      add(e) {
        for (const t of this._dispatchers) e(t);
        return this;
      }
    }
    class Mc extends Bc {
      elementToElement(e) {
        return this.add(function (e) {
          const t = Vc(e.model),
            n = Oc(e.view, "container");
          t.attributes.length && (t.children = !0);
          return i => {
            i.on("insert:".concat(t.name), Nc(n, qc(t)), {
              priority: e.converterPriority || "normal"
            }), (t.children || t.attributes.length) && i.on("reduceChanges", Uc(t), {
              priority: "low"
            });
          };
        }(e));
      }
      elementToStructure(e) {
        return this.add(function (e) {
          const t = Vc(e.model),
            n = Oc(e.view, "container");
          return t.children = !0, i => {
            if (i._conversionApi.schema.checkChild(t.name, "$text")) throw new _("conversion-element-to-structure-disallowed-text", i, {
              elementName: t.name
            });
            var o, r;
            i.on("insert:".concat(t.name), (o = n, r = qc(t), (e, t, n) => {
              if (!r(t.item, n.consumable, {
                preflight: !0
              })) return;
              const i = new Map();
              n.writer._registerSlotFactory(function (e, t, n) {
                return (i, o) => {
                  const r = i.createContainerElement("$slot");
                  let s = null;
                  if ("children" === o) s = Array.from(e.getChildren());else {
                    if ("function" != typeof o) throw new _("conversion-slot-mode-unknown", n.dispatcher, {
                      modeOrFilter: o
                    });
                    s = Array.from(e.getChildren()).filter(e => o(e));
                  }
                  return t.set(r, s), r;
                };
              }(t.item, i, n));
              const s = o(t.item, n, t);
              if (n.writer._clearSlotFactory(), !s) return;
              !function (e, t, n) {
                const i = Array.from(t.values()).flat(),
                  o = new Set(i);
                if (o.size != i.length) throw new _("conversion-slot-filter-overlap", n.dispatcher, {
                  element: e
                });
                if (o.size != e.childCount) throw new _("conversion-slot-filter-incomplete", n.dispatcher, {
                  element: e
                });
              }(t.item, i, n), r(t.item, n.consumable);
              const a = n.mapper.toViewPosition(t.range.start);
              n.mapper.bindElements(t.item, s), n.writer.insert(a, s), n.convertAttributes(t.item), function (e, t, n, i) {
                n.mapper.on("modelToViewPosition", s, {
                  priority: "highest"
                });
                let o = null,
                  r = null;
                for ([o, r] of t) Gc(e, r, n, i), n.writer.move(n.writer.createRangeIn(o), n.writer.createPositionBefore(o)), n.writer.remove(o);
                function s(e, t) {
                  const n = t.modelPosition.nodeAfter,
                    i = r.indexOf(n);
                  i < 0 || (t.viewPosition = t.mapper.findPositionIn(o, i));
                }
                n.mapper.off("modelToViewPosition", s);
              }(s, i, n, {
                reconversion: t.reconversion
              });
            }), {
              priority: e.converterPriority || "normal"
            }), i.on("reduceChanges", Uc(t), {
              priority: "low"
            });
          };
        }(e));
      }
      attributeToElement(e) {
        return this.add(function (e) {
          e = Yl(e);
          let t = e.model;
          "string" == typeof t && (t = {
            key: t
          });
          let n = "attribute:".concat(t.key);
          t.name && (n += ":" + t.name);
          if (t.values) for (const n of t.values) e.view[n] = Oc(e.view[n], "attribute");else e.view = Oc(e.view, "attribute");
          const i = Fc(e);
          return t => {
            t.on(n, zc(i), {
              priority: e.converterPriority || "normal"
            });
          };
        }(e));
      }
      attributeToAttribute(e) {
        return this.add(function (e) {
          e = Yl(e);
          let t = e.model;
          "string" == typeof t && (t = {
            key: t
          });
          let n = "attribute:".concat(t.key);
          t.name && (n += ":" + t.name);
          if (t.values) for (const n of t.values) e.view[n] = jc(e.view[n]);else e.view = jc(e.view);
          const i = Fc(e);
          return t => {
            var o;
            t.on(n, (o = i, (e, t, n) => {
              if (!n.consumable.test(t.item, e.name)) return;
              const i = o(t.attributeOldValue, n, t),
                r = o(t.attributeNewValue, n, t);
              if (!i && !r) return;
              n.consumable.consume(t.item, e.name);
              const s = n.mapper.toViewElement(t.item),
                a = n.writer;
              if (!s) throw new _("conversion-attribute-to-attribute-on-text", n.dispatcher, t);
              if (null !== t.attributeOldValue && i) if ("class" == i.key) {
                const e = "string" == typeof i.value ? i.value.split(/\s+/) : i.value;
                for (const t of e) a.removeClass(t, s);
              } else if ("style" == i.key) {
                if ("string" == typeof i.value) {
                  const e = new Bs(a.document.stylesProcessor);
                  e.setTo(i.value);
                  for (const [t] of e.getStylesEntries()) a.removeStyle(t, s);
                } else {
                  const e = Object.keys(i.value);
                  for (const t of e) a.removeStyle(t, s);
                }
              } else a.removeAttribute(i.key, s);
              if (null !== t.attributeNewValue && r) if ("class" == r.key) {
                const e = "string" == typeof r.value ? r.value.split(/\s+/) : r.value;
                for (const t of e) a.addClass(t, s);
              } else if ("style" == r.key) {
                if ("string" == typeof r.value) {
                  const e = new Bs(a.document.stylesProcessor);
                  e.setTo(r.value);
                  for (const [t, n] of e.getStylesEntries()) a.setStyle(t, n, s);
                } else {
                  const e = Object.keys(r.value);
                  for (const t of e) a.setStyle(t, r.value[t], s);
                }
              } else a.setAttribute(r.key, r.value, s);
            }), {
              priority: e.converterPriority || "normal"
            });
          };
        }(e));
      }
      markerToElement(e) {
        return this.add(function (e) {
          const t = Oc(e.view, "ui");
          return n => {
            n.on("addMarker:".concat(e.model), Lc(t), {
              priority: e.converterPriority || "normal"
            }), n.on("removeMarker:".concat(e.model), (e, t, n) => {
              const i = n.mapper.markerNameToElements(t.markerName);
              if (i) {
                for (const e of i) n.mapper.unbindElementFromMarkerName(e, t.markerName), n.writer.clear(n.writer.createRangeOn(e), e);
                n.writer.clearClonedElementsGroup(t.markerName), e.stop();
              }
            }, {
              priority: e.converterPriority || "normal"
            });
          };
        }(e));
      }
      markerToHighlight(e) {
        return this.add(function (e) {
          return t => {
            var n;
            t.on("addMarker:".concat(e.model), (n = e.view, (e, t, i) => {
              if (!t.item) return;
              if (!(t.item instanceof kc || t.item instanceof Dc || t.item.is("$textProxy"))) return;
              const o = Hc(n, t, i);
              if (!o) return;
              if (!i.consumable.consume(t.item, e.name)) return;
              const r = i.writer,
                s = Pc(r, o),
                a = r.document.selection;
              if (t.item instanceof kc || t.item instanceof Dc) r.wrap(a.getFirstRange(), s);else {
                const e = i.mapper.toViewRange(t.range),
                  n = r.wrap(e, s);
                for (const e of n.getItems()) if (e.is("attributeElement") && e.isSimilar(s)) {
                  i.mapper.bindElementToMarker(e, t.markerName);
                  break;
                }
              }
            }), {
              priority: e.converterPriority || "normal"
            }), t.on("addMarker:".concat(e.model), function (e) {
              return (t, n, i) => {
                if (!n.item) return;
                if (!(n.item instanceof tc)) return;
                const o = Hc(e, n, i);
                if (!o) return;
                if (!i.consumable.test(n.item, t.name)) return;
                const r = i.mapper.toViewElement(n.item);
                if (r && r.getCustomProperty("addHighlight")) {
                  i.consumable.consume(n.item, t.name);
                  for (const e of dc._createIn(n.item)) i.consumable.consume(e.item, t.name);
                  r.getCustomProperty("addHighlight")(r, o, i.writer), i.mapper.bindElementToMarker(r, n.markerName);
                }
              };
            }(e.view), {
              priority: e.converterPriority || "normal"
            }), t.on("removeMarker:".concat(e.model), function (e) {
              return (t, n, i) => {
                if (n.markerRange.isCollapsed) return;
                const o = Hc(e, n, i);
                if (!o) return;
                const r = Pc(i.writer, o),
                  s = i.mapper.markerNameToElements(n.markerName);
                if (s) {
                  for (const e of s) if (i.mapper.unbindElementFromMarkerName(e, n.markerName), e.is("attributeElement")) i.writer.unwrap(i.writer.createRangeOn(e), r);else {
                    e.getCustomProperty("removeHighlight")(e, o.id, i.writer);
                  }
                  i.writer.clearClonedElementsGroup(n.markerName), t.stop();
                }
              };
            }(e.view), {
              priority: e.converterPriority || "normal"
            });
          };
        }(e));
      }
      markerToData(e) {
        return this.add(function (e) {
          e = Yl(e);
          const t = e.model;
          let n = e.view;
          n || (n = n => ({
            group: t,
            name: n.substr(e.model.length + 1)
          }));
          return i => {
            var o;
            i.on("addMarker:".concat(t), (o = n, (e, t, n) => {
              const i = o(t.markerName, n);
              if (!i) return;
              const r = t.markerRange;
              n.consumable.consume(r, e.name) && (Rc(r, !1, n, t, i), Rc(r, !0, n, t, i), e.stop());
            }), {
              priority: e.converterPriority || "normal"
            }), i.on("removeMarker:".concat(t), function (e) {
              return (t, n, i) => {
                const o = e(n.markerName, i);
                if (!o) return;
                const r = i.mapper.markerNameToElements(n.markerName);
                if (r) {
                  for (const e of r) i.mapper.unbindElementFromMarkerName(e, n.markerName), e.is("containerElement") ? (s("data-".concat(o.group, "-start-before"), e), s("data-".concat(o.group, "-start-after"), e), s("data-".concat(o.group, "-end-before"), e), s("data-".concat(o.group, "-end-after"), e)) : i.writer.clear(i.writer.createRangeOn(e), e);
                  i.writer.clearClonedElementsGroup(n.markerName), t.stop();
                }
                function s(e, t) {
                  if (t.hasAttribute(e)) {
                    const n = new Set(t.getAttribute(e).split(","));
                    n.delete(o.name), 0 == n.size ? i.writer.removeAttribute(e, t) : i.writer.setAttribute(e, Array.from(n).join(","), t);
                  }
                }
              };
            }(n), {
              priority: e.converterPriority || "normal"
            });
          };
        }(e));
      }
    }
    function Pc(e, t) {
      const n = e.createAttributeElement("span", t.attributes);
      return t.classes && n._addClass(t.classes), "number" == typeof t.priority && (n._priority = t.priority), n._id = t.id, n;
    }
    function zc(e) {
      return (t, n, i) => {
        if (!i.consumable.test(n.item, t.name)) return;
        const o = e(n.attributeOldValue, i, n),
          r = e(n.attributeNewValue, i, n);
        if (!o && !r) return;
        i.consumable.consume(n.item, t.name);
        const s = i.writer,
          a = s.document.selection;
        if (n.item instanceof kc || n.item instanceof Dc) s.wrap(a.getFirstRange(), r);else {
          let e = i.mapper.toViewRange(n.range);
          null !== n.attributeOldValue && o && (e = s.unwrap(e, o)), null !== n.attributeNewValue && r && s.wrap(e, r);
        }
      };
    }
    function Nc(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Wc;
      return (n, i, o) => {
        if (!t(i.item, o.consumable, {
          preflight: !0
        })) return;
        const r = e(i.item, o, i);
        if (!r) return;
        t(i.item, o.consumable);
        const s = o.mapper.toViewPosition(i.range.start);
        o.mapper.bindElements(i.item, r), o.writer.insert(s, r), o.convertAttributes(i.item), Gc(r, i.item.getChildren(), o, {
          reconversion: i.reconversion
        });
      };
    }
    function Lc(e) {
      return (t, n, i) => {
        n.isOpening = !0;
        const o = e(n, i);
        n.isOpening = !1;
        const r = e(n, i);
        if (!o || !r) return;
        const s = n.markerRange;
        if (s.isCollapsed && !i.consumable.consume(s, t.name)) return;
        for (const e of s) if (!i.consumable.consume(e.item, t.name)) return;
        const a = i.mapper,
          l = i.writer;
        l.insert(a.toViewPosition(s.start), o), i.mapper.bindElementToMarker(o, n.markerName), s.isCollapsed || (l.insert(a.toViewPosition(s.end), r), i.mapper.bindElementToMarker(r, n.markerName)), t.stop();
      };
    }
    function Rc(e, t, n, i, o) {
      const r = t ? e.start : e.end,
        s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
        a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;
      if (s || a) {
        let e, r;
        t && s || !t && !a ? (e = s, r = !0) : (e = a, r = !1);
        const l = n.mapper.toViewElement(e);
        if (l) return void function (e, t, n, i, o, r) {
          const s = "data-".concat(r.group, "-").concat(t ? "start" : "end", "-").concat(n ? "before" : "after"),
            a = e.hasAttribute(s) ? e.getAttribute(s).split(",") : [];
          a.unshift(r.name), i.writer.setAttribute(s, a.join(","), e), i.mapper.bindElementToMarker(e, o.markerName);
        }(l, t, r, n, i, o);
      }
      !function (e, t, n, i, o) {
        const r = "".concat(o.group, "-").concat(t ? "start" : "end"),
          s = o.name ? {
            name: o.name
          } : null,
          a = n.writer.createUIElement(r, s);
        n.writer.insert(e, a), n.mapper.bindElementToMarker(a, i.markerName);
      }(n.mapper.toViewPosition(r), t, n, i, o);
    }
    function Vc(e) {
      return "string" == typeof e && (e = {
        name: e
      }), {
        name: e.name,
        attributes: e.attributes ? _o(e.attributes) : [],
        children: !!e.children
      };
    }
    function Oc(e, t) {
      return "function" == typeof e ? e : (n, i) => function (e, t, n) {
        "string" == typeof e && (e = {
          name: e
        });
        let i;
        const o = t.writer,
          r = Object.assign({}, e.attributes);
        if ("container" == n) i = o.createContainerElement(e.name, r);else if ("attribute" == n) {
          const t = {
            priority: e.priority || ia.DEFAULT_PRIORITY
          };
          i = o.createAttributeElement(e.name, r, t);
        } else i = o.createUIElement(e.name, r);
        if (e.styles) {
          const t = Object.keys(e.styles);
          for (const n of t) o.setStyle(n, e.styles[n], i);
        }
        if (e.classes) {
          const t = e.classes;
          if ("string" == typeof t) o.addClass(t, i);else for (const e of t) o.addClass(e, i);
        }
        return i;
      }(e, i, t);
    }
    function Fc(e) {
      return e.model.values ? (t, n, i) => {
        const o = e.view[t];
        return o ? o(t, n, i) : null;
      } : e.view;
    }
    function jc(e) {
      return "string" == typeof e ? t => ({
        key: e,
        value: t
      }) : "object" == typeof e ? e.value ? () => e : t => ({
        key: e.key,
        value: t
      }) : e;
    }
    function Hc(e, t, n) {
      const i = "function" == typeof e ? e(t, n) : e;
      return i ? (i.priority || (i.priority = 10), i.id || (i.id = t.markerName), i) : null;
    }
    function Uc(e) {
      const t = function (e) {
        return (t, n) => {
          if (!t.is("element", e.name)) return !1;
          if ("attribute" == n.type) {
            if (e.attributes.includes(n.attributeKey)) return !0;
          } else if (e.children) return !0;
          return !1;
        };
      }(e);
      return (e, n) => {
        const i = [];
        n.reconvertedElements || (n.reconvertedElements = new Set());
        for (const e of n.changes) {
          const o = "attribute" == e.type ? e.range.start.nodeAfter : e.position.parent;
          if (o && t(o, e)) {
            if (!n.reconvertedElements.has(o)) {
              n.reconvertedElements.add(o);
              const e = oc._createBefore(o);
              let t = i.length;
              for (let n = i.length - 1; n >= 0; n--) {
                const o = i[n],
                  r = ("attribute" == o.type ? o.range.start : o.position).compareWith(e);
                if ("before" == r || "remove" == o.type && "same" == r) break;
                t = n;
              }
              i.splice(t, 0, {
                type: "remove",
                name: o.name,
                position: e,
                length: 1
              }, {
                type: "reinsert",
                name: o.name,
                position: e,
                length: 1
              });
            }
          } else i.push(e);
        }
        n.changes = i;
      };
    }
    function qc(e) {
      return function (t, n) {
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const o = ["insert"];
        for (const n of e.attributes) t.hasAttribute(n) && o.push("attribute:".concat(n));
        return !!o.every(e => n.test(t, e)) && (i.preflight || o.forEach(e => n.consume(t, e)), !0);
      };
    }
    function Gc(e, t, n, i) {
      for (const o of t) Kc(e.root, o, n, i) || n.convertItem(o);
    }
    function Kc(e, t, n, i) {
      const {
        writer: o,
        mapper: r
      } = n;
      if (!i.reconversion) return !1;
      const s = r.toViewElement(t);
      return !(!s || s.root == e) && !!n.canReuseView(s) && (o.move(o.createRangeOn(s), r.toViewPosition(oc._createBefore(t))), !0);
    }
    function Wc(e, t) {
      let {
        preflight: n
      } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return n ? t.test(e, "insert") : t.consume(e, "insert");
    }
    function Yc(e) {
      const {
        schema: t,
        document: n
      } = e.model;
      for (const i of n.getRoots()) if (i.isEmpty && !t.checkChild(i, "$text") && t.checkChild(i, "paragraph")) return e.insertElement("paragraph", i), !0;
      return !1;
    }
    function $c(e, t, n) {
      const i = n.createContext(e);
      return !!n.checkChild(i, "paragraph") && !!n.checkChild(i.push("paragraph"), t);
    }
    function Zc(e, t) {
      const n = t.createElement("paragraph");
      return t.insert(n, e), t.createPositionAt(n, 0);
    }
    class Qc extends Bc {
      elementToElement(e) {
        return this.add(Jc(e));
      }
      elementToAttribute(e) {
        return this.add(function (e) {
          e = Yl(e), td(e);
          const t = nd(e, !1),
            n = Xc(e.view),
            i = n ? "element:".concat(n) : "element";
          return n => {
            n.on(i, t, {
              priority: e.converterPriority || "low"
            });
          };
        }(e));
      }
      attributeToAttribute(e) {
        return this.add(function (e) {
          e = Yl(e);
          let t = null;
          ("string" == typeof e.view || e.view.key) && (t = function (e) {
            "string" == typeof e.view && (e.view = {
              key: e.view
            });
            const t = e.view.key,
              n = void 0 === e.view.value ? /[\s\S]*/ : e.view.value;
            let i;
            if ("class" == t || "style" == t) {
              const e = "class" == t ? "classes" : "styles";
              i = {
                [e]: n
              };
            } else i = {
              attributes: {
                [t]: n
              }
            };
            e.view.name && (i.name = e.view.name);
            return e.view = i, t;
          }(e));
          td(e, t);
          const n = nd(e, !0);
          return t => {
            t.on("element", n, {
              priority: e.converterPriority || "low"
            });
          };
        }(e));
      }
      elementToMarker(e) {
        return this.add(function (e) {
          const t = function (e) {
            return (t, n) => {
              const i = "string" == typeof e ? e : e(t, n);
              return n.writer.createElement("$marker", {
                "data-name": i
              });
            };
          }(e.model);
          return Jc({
            ...e,
            model: t
          });
        }(e));
      }
      dataToMarker(e) {
        return this.add(function (e) {
          e = Yl(e), e.model || (e.model = t => t ? e.view + ":" + t : e.view);
          const t = {
              view: e.view,
              model: e.model
            },
            n = ed(id(t, "start")),
            i = ed(id(t, "end"));
          return o => {
            o.on("element:".concat(e.view, "-start"), n, {
              priority: e.converterPriority || "normal"
            }), o.on("element:".concat(e.view, "-end"), i, {
              priority: e.converterPriority || "normal"
            });
            const r = f.low,
              s = f.highest,
              a = f.get(e.converterPriority) / s;
            o.on("element", function (e) {
              return (t, n, i) => {
                const o = "data-".concat(e.view);
                function r(t, o) {
                  for (const r of o) {
                    const o = e.model(r, i),
                      s = i.writer.createElement("$marker", {
                        "data-name": o
                      });
                    i.writer.insert(s, t), n.modelCursor.isEqual(t) ? n.modelCursor = n.modelCursor.getShiftedBy(1) : n.modelCursor = n.modelCursor._getTransformedByInsertion(t, 1), n.modelRange = n.modelRange._getTransformedByInsertion(t, 1)[0];
                  }
                }
                (i.consumable.test(n.viewItem, {
                  attributes: o + "-end-after"
                }) || i.consumable.test(n.viewItem, {
                  attributes: o + "-start-after"
                }) || i.consumable.test(n.viewItem, {
                  attributes: o + "-end-before"
                }) || i.consumable.test(n.viewItem, {
                  attributes: o + "-start-before"
                })) && (n.modelRange || Object.assign(n, i.convertChildren(n.viewItem, n.modelCursor)), i.consumable.consume(n.viewItem, {
                  attributes: o + "-end-after"
                }) && r(n.modelRange.end, n.viewItem.getAttribute(o + "-end-after").split(",")), i.consumable.consume(n.viewItem, {
                  attributes: o + "-start-after"
                }) && r(n.modelRange.end, n.viewItem.getAttribute(o + "-start-after").split(",")), i.consumable.consume(n.viewItem, {
                  attributes: o + "-end-before"
                }) && r(n.modelRange.start, n.viewItem.getAttribute(o + "-end-before").split(",")), i.consumable.consume(n.viewItem, {
                  attributes: o + "-start-before"
                }) && r(n.modelRange.start, n.viewItem.getAttribute(o + "-start-before").split(",")));
              };
            }(t), {
              priority: r + a
            });
          };
        }(e));
      }
    }
    function Jc(e) {
      const t = ed(e = Yl(e)),
        n = Xc(e.view),
        i = n ? "element:".concat(n) : "element";
      return n => {
        n.on(i, t, {
          priority: e.converterPriority || "normal"
        });
      };
    }
    function Xc(e) {
      return "string" == typeof e ? e : "object" == typeof e && "string" == typeof e.name ? e.name : null;
    }
    function ed(e) {
      const t = new ts(e.view);
      return (n, i, o) => {
        const r = t.match(i.viewItem);
        if (!r) return;
        const s = r.match;
        if (s.name = !0, !o.consumable.test(i.viewItem, s)) return;
        const a = function (e, t, n) {
          return e instanceof Function ? e(t, n) : n.writer.createElement(e);
        }(e.model, i.viewItem, o);
        a && o.safeInsert(a, i.modelCursor) && (o.consumable.consume(i.viewItem, s), o.convertChildren(i.viewItem, a), o.updateConversionResult(a, i));
      };
    }
    function td(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      const n = null === t || (e => e.getAttribute(t)),
        i = "object" != typeof e.model ? e.model : e.model.key,
        o = "object" != typeof e.model || void 0 === e.model.value ? n : e.model.value;
      e.model = {
        key: i,
        value: o
      };
    }
    function nd(e, t) {
      const n = new ts(e.view);
      return (i, o, r) => {
        if (!o.modelRange && t) return;
        const s = n.match(o.viewItem);
        if (!s) return;
        if (!function (e, t) {
          const n = "function" == typeof e ? e(t) : e;
          if ("object" == typeof n && !Xc(n)) return !1;
          return !n.classes && !n.attributes && !n.styles;
        }(e.view, o.viewItem) ? delete s.match.name : s.match.name = !0, !r.consumable.test(o.viewItem, s.match)) return;
        const a = e.model.key,
          l = "function" == typeof e.model.value ? e.model.value(o.viewItem, r) : e.model.value;
        if (null === l) return;
        o.modelRange || Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor));
        const c = function (e, t, n, i) {
          let o = !1;
          for (const r of Array.from(e.getItems({
            shallow: n
          }))) i.schema.checkAttribute(r, t.key) && (o = !0, r.hasAttribute(t.key) || i.writer.setAttribute(t.key, t.value, r));
          return o;
        }(o.modelRange, {
          key: a,
          value: l
        }, t, r);
        c && (r.consumable.test(o.viewItem, {
          name: !0
        }) && (s.match.name = !0), r.consumable.consume(o.viewItem, s.match));
      };
    }
    function id(e, t) {
      return {
        view: "".concat(e.view, "-").concat(t),
        model: (t, n) => {
          const i = t.getAttribute("name"),
            o = e.model(i, n);
          return n.writer.createElement("$marker", {
            "data-name": o
          });
        }
      };
    }
    function od(e) {
      e.document.registerPostFixer(t => function (e, t) {
        const n = t.document.selection,
          i = t.schema,
          o = [];
        let r = !1;
        for (const e of n.getRanges()) {
          const t = rd(e, i);
          t && !t.isEqual(e) ? (o.push(t), r = !0) : o.push(e);
        }
        r && e.setSelection(function (e) {
          const t = [...e],
            n = new Set();
          let i = 1;
          for (; i < t.length;) {
            const e = t[i],
              o = t.slice(0, i);
            for (const [r, s] of o.entries()) if (!n.has(r)) if (e.isEqual(s)) n.add(r);else if (e.isIntersecting(s)) {
              n.add(r), n.add(i);
              const o = e.getJoined(s);
              t.push(o);
            }
            i++;
          }
          return t.filter((e, t) => !n.has(t));
        }(o), {
          backward: n.isBackward
        });
        return !1;
      }(t, e));
    }
    function rd(e, t) {
      return e.isCollapsed ? function (e, t) {
        const n = e.start,
          i = t.getNearestSelectionRange(n);
        if (!i) {
          const e = n.getAncestors().reverse().find(e => t.isObject(e));
          return e ? dc._createOn(e) : null;
        }
        if (!i.isCollapsed) return i;
        const o = i.start;
        if (n.isEqual(o)) return null;
        return new dc(o);
      }(e, t) : function (e, t) {
        const {
            start: n,
            end: i
          } = e,
          o = t.checkChild(n, "$text"),
          r = t.checkChild(i, "$text"),
          s = t.getLimitElement(n),
          a = t.getLimitElement(i);
        if (s === a) {
          if (o && r) return null;
          if (function (e, t, n) {
            const i = e.nodeAfter && !n.isLimit(e.nodeAfter) || n.checkChild(e, "$text"),
              o = t.nodeBefore && !n.isLimit(t.nodeBefore) || n.checkChild(t, "$text");
            return i || o;
          }(n, i, t)) {
            const e = n.nodeAfter && t.isSelectable(n.nodeAfter) ? null : t.getNearestSelectionRange(n, "forward"),
              o = i.nodeBefore && t.isSelectable(i.nodeBefore) ? null : t.getNearestSelectionRange(i, "backward"),
              r = e ? e.start : n,
              s = o ? o.end : i;
            return new dc(r, s);
          }
        }
        const l = s && !s.is("rootElement"),
          c = a && !a.is("rootElement");
        if (l || c) {
          const e = n.nodeAfter && i.nodeBefore && n.nodeAfter.parent === i.nodeBefore.parent,
            o = l && (!e || !ad(n.nodeAfter, t)),
            r = c && (!e || !ad(i.nodeBefore, t));
          let d = n,
            u = i;
          return o && (d = oc._createBefore(sd(s, t))), r && (u = oc._createAfter(sd(a, t))), new dc(d, u);
        }
        return null;
      }(e, t);
    }
    function sd(e, t) {
      let n = e,
        i = n;
      for (; t.isLimit(i) && i.parent;) n = i, i = i.parent;
      return n;
    }
    function ad(e, t) {
      return e && t.isSelectable(e);
    }
    class ld extends q() {
      constructor(e, t) {
        super(), this.model = e, this.view = new $l(t), this.mapper = new uc(), this.downcastDispatcher = new pc({
          mapper: this.mapper,
          schema: e.schema
        });
        const n = this.model.document,
          i = n.selection,
          o = this.model.markers;
        var r, a, l;
        this.listenTo(this.model, "_beforeChanges", () => {
          this.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", () => {
          this.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(n, "change", () => {
          this.view.change(e => {
            this.downcastDispatcher.convertChanges(n.differ, o, e), this.downcastDispatcher.convertSelection(i, o, e);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (e, t) {
          return (n, i) => {
            const o = i.newSelection,
              r = [];
            for (const e of o.getRanges()) r.push(t.toModelRange(e));
            const s = e.createSelection(r, {
              backward: o.isBackward
            });
            s.isEqual(e.document.selection) || e.change(e => {
              e.setSelection(s);
            });
          };
        }(this.model, this.mapper)), this.listenTo(this.view.document, "beforeinput", (r = this.mapper, a = this.model.schema, l = this.view, (e, t) => {
          if (!l.document.isComposing || s.isAndroid) for (let e = 0; e < t.targetRanges.length; e++) {
            const n = t.targetRanges[e],
              i = r.toModelRange(n),
              o = rd(i, a);
            o && !o.isEqual(i) && (t.targetRanges[e] = r.toViewRange(o));
          }
        }), {
          priority: "high"
        }), this.downcastDispatcher.on("insert:$text", (e, t, n) => {
          if (!n.consumable.consume(t.item, e.name)) return;
          const i = n.writer,
            o = n.mapper.toViewPosition(t.range.start),
            r = i.createText(t.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("insert", (e, t, n) => {
          n.convertAttributes(t.item), t.reconversion || !t.item.is("element") || t.item.isEmpty || n.convertChildren(t.item);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", (e, t, n) => {
          const i = n.mapper.toViewPosition(t.position),
            o = t.position.getShiftedBy(t.length),
            r = n.mapper.toViewPosition(o, {
              isPhantom: !0
            }),
            s = n.writer.createRange(i, r),
            a = n.writer.remove(s.getTrimmed());
          for (const e of n.writer.createRangeIn(a).getItems()) n.mapper.unbindViewElement(e, {
            defer: !0
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("cleanSelection", (e, t, n) => {
          const i = n.writer,
            o = i.document.selection;
          for (const e of o.getRanges()) e.isCollapsed && e.end.parent.isAttached() && n.writer.mergeAttributes(e.start);
          i.setSelection(null);
        }), this.downcastDispatcher.on("selection", (e, t, n) => {
          const i = t.selection;
          if (i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          const o = [];
          for (const e of i.getRanges()) o.push(n.mapper.toViewRange(e));
          n.writer.setSelection(o, {
            backward: i.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", (e, t, n) => {
          const i = t.selection;
          if (!i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          const o = n.writer,
            r = i.getFirstPosition(),
            s = n.mapper.toViewPosition(r),
            a = o.breakAttributes(s);
          o.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(e => {
          if ("$graveyard" == e.rootName) return null;
          const t = new js(this.view.document, e.name);
          return t.rootName = e.rootName, this.mapper.bindElements(e, t), t;
        });
      }
      destroy() {
        this.view.destroy(), this.stopListening();
      }
      reconvertMarker(e) {
        const t = "string" == typeof e ? e : e.name,
          n = this.model.markers.get(t);
        if (!n) throw new _("editingcontroller-reconvertmarker-marker-not-exist", this, {
          markerName: t
        });
        this.model.change(() => {
          this.model.markers._refresh(n);
        });
      }
      reconvertItem(e) {
        this.model.change(() => {
          this.model.document.differ._refreshItem(e);
        });
      }
    }
    class cd {
      constructor() {
        this._consumables = new Map();
      }
      add(e, t) {
        let n;
        e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !0) : (this._consumables.has(e) ? n = this._consumables.get(e) : (n = new ud(e), this._consumables.set(e, n)), n.add(t));
      }
      test(e, t) {
        const n = this._consumables.get(e);
        return void 0 === n ? null : e.is("$text") || e.is("documentFragment") ? n : n.test(t);
      }
      consume(e, t) {
        return !!this.test(e, t) && (e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !1) : this._consumables.get(e).consume(t), !0);
      }
      revert(e, t) {
        const n = this._consumables.get(e);
        void 0 !== n && (e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !0) : n.revert(t));
      }
      static consumablesFromElement(e) {
        const t = {
            element: e,
            name: !0,
            attributes: [],
            classes: [],
            styles: []
          },
          n = e.getAttributeKeys();
        for (const e of n) "style" != e && "class" != e && t.attributes.push(e);
        const i = e.getClassNames();
        for (const e of i) t.classes.push(e);
        const o = e.getStyleNames();
        for (const e of o) t.styles.push(e);
        return t;
      }
      static createFrom(e, t) {
        if (t || (t = new cd()), e.is("$text")) return t.add(e), t;
        e.is("element") && t.add(e, cd.consumablesFromElement(e)), e.is("documentFragment") && t.add(e);
        for (const n of e.getChildren()) t = cd.createFrom(n, t);
        return t;
      }
    }
    const dd = ["attributes", "classes", "styles"];
    class ud {
      constructor(e) {
        this.element = e, this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }
      add(e) {
        e.name && (this._canConsumeName = !0);
        for (const t of dd) t in e && this._add(t, e[t]);
      }
      test(e) {
        if (e.name && !this._canConsumeName) return this._canConsumeName;
        for (const t of dd) if (t in e) {
          const n = this._test(t, e[t]);
          if (!0 !== n) return n;
        }
        return !0;
      }
      consume(e) {
        e.name && (this._canConsumeName = !1);
        for (const t of dd) t in e && this._consume(t, e[t]);
      }
      revert(e) {
        e.name && (this._canConsumeName = !0);
        for (const t of dd) t in e && this._revert(t, e[t]);
      }
      _add(e, t) {
        const n = _o(t),
          i = this._consumables[e];
        for (const t of n) {
          if ("attributes" === e && ("class" === t || "style" === t)) throw new _("viewconsumable-invalid-attribute", this);
          if (i.set(t, !0), "styles" === e) for (const e of this.element.document.stylesProcessor.getRelatedStyles(t)) i.set(e, !0);
        }
      }
      _test(e, t) {
        const n = _o(t),
          i = this._consumables[e];
        for (const t of n) if ("attributes" !== e || "class" !== t && "style" !== t) {
          const e = i.get(t);
          if (void 0 === e) return null;
          if (!e) return !1;
        } else {
          const e = "class" == t ? "classes" : "styles",
            n = this._test(e, [...this._consumables[e].keys()]);
          if (!0 !== n) return n;
        }
        return !0;
      }
      _consume(e, t) {
        const n = _o(t),
          i = this._consumables[e];
        for (const t of n) if ("attributes" !== e || "class" !== t && "style" !== t) {
          if (i.set(t, !1), "styles" == e) for (const e of this.element.document.stylesProcessor.getRelatedStyles(t)) i.set(e, !1);
        } else {
          const e = "class" == t ? "classes" : "styles";
          this._consume(e, [...this._consumables[e].keys()]);
        }
      }
      _revert(e, t) {
        const n = _o(t),
          i = this._consumables[e];
        for (const t of n) if ("attributes" !== e || "class" !== t && "style" !== t) {
          !1 === i.get(t) && i.set(t, !0);
        } else {
          const e = "class" == t ? "classes" : "styles";
          this._revert(e, [...this._consumables[e].keys()]);
        }
      }
    }
    class hd extends q() {
      constructor() {
        super(), this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", (e, t) => {
          t[0] = new md(t[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", (e, t) => {
          t[0] = new md(t[0]), t[1] = this.getDefinition(t[1]);
        }, {
          priority: "highest"
        });
      }
      register(e, t) {
        if (this._sourceDefinitions[e]) throw new _("schema-cannot-register-item-twice", this, {
          itemName: e
        });
        this._sourceDefinitions[e] = [Object.assign({}, t)], this._clearCache();
      }
      extend(e, t) {
        if (!this._sourceDefinitions[e]) throw new _("schema-cannot-extend-missing-item", this, {
          itemName: e
        });
        this._sourceDefinitions[e].push(Object.assign({}, t)), this._clearCache();
      }
      getDefinitions() {
        return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
      }
      getDefinition(e) {
        let t;
        return t = "string" == typeof e ? e : "is" in e && (e.is("$text") || e.is("$textProxy")) ? "$text" : e.name, this.getDefinitions()[t];
      }
      isRegistered(e) {
        return !!this.getDefinition(e);
      }
      isBlock(e) {
        const t = this.getDefinition(e);
        return !(!t || !t.isBlock);
      }
      isLimit(e) {
        const t = this.getDefinition(e);
        return !!t && !(!t.isLimit && !t.isObject);
      }
      isObject(e) {
        const t = this.getDefinition(e);
        return !!t && !!(t.isObject || t.isLimit && t.isSelectable && t.isContent);
      }
      isInline(e) {
        const t = this.getDefinition(e);
        return !(!t || !t.isInline);
      }
      isSelectable(e) {
        const t = this.getDefinition(e);
        return !!t && !(!t.isSelectable && !t.isObject);
      }
      isContent(e) {
        const t = this.getDefinition(e);
        return !!t && !(!t.isContent && !t.isObject);
      }
      checkChild(e, t) {
        return !!t && this._checkContextMatch(t, e);
      }
      checkAttribute(e, t) {
        const n = this.getDefinition(e.last);
        return !!n && n.allowAttributes.includes(t);
      }
      checkMerge(e, t) {
        if (e instanceof oc) {
          const t = e.nodeBefore,
            n = e.nodeAfter;
          if (!(t instanceof tc)) throw new _("schema-check-merge-no-element-before", this);
          if (!(n instanceof tc)) throw new _("schema-check-merge-no-element-after", this);
          return this.checkMerge(t, n);
        }
        for (const n of t.getChildren()) if (!this.checkChild(e, n)) return !1;
        return !0;
      }
      addChildCheck(e) {
        this.on("checkChild", (t, _ref21) => {
          let [n, i] = _ref21;
          if (!i) return;
          const o = e(n, i);
          "boolean" == typeof o && (t.stop(), t.return = o);
        }, {
          priority: "high"
        });
      }
      addAttributeCheck(e) {
        this.on("checkAttribute", (t, _ref22) => {
          let [n, i] = _ref22;
          const o = e(n, i);
          "boolean" == typeof o && (t.stop(), t.return = o);
        }, {
          priority: "high"
        });
      }
      setAttributeProperties(e, t) {
        this._attributeProperties[e] = Object.assign(this.getAttributeProperties(e), t);
      }
      getAttributeProperties(e) {
        return this._attributeProperties[e] || {};
      }
      getLimitElement(e) {
        let t;
        if (e instanceof oc) t = e.parent;else {
          t = (e instanceof dc ? [e] : Array.from(e.getRanges())).reduce((e, t) => {
            const n = t.getCommonAncestor();
            return e ? e.getCommonAncestor(n, {
              includeSelf: !0
            }) : n;
          }, null);
        }
        for (; !this.isLimit(t) && t.parent;) t = t.parent;
        return t;
      }
      checkAttributeInSelection(e, t) {
        if (e.isCollapsed) {
          const n = [...e.getFirstPosition().getAncestors(), new Xl("", e.getAttributes())];
          return this.checkAttribute(n, t);
        }
        {
          const n = e.getRanges();
          for (const e of n) for (const n of e) if (this.checkAttribute(n.item, t)) return !0;
        }
        return !1;
      }
      *getValidRanges(e, t) {
        e = function* (e) {
          for (const t of e) yield* t.getMinimalFlatRanges();
        }(e);
        for (const n of e) yield* this._getValidRangesForRange(n, t);
      }
      getNearestSelectionRange(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
        if ("$graveyard" == e.root.rootName) return null;
        if (this.checkChild(e, "$text")) return new dc(e);
        let n, i;
        const o = e.getAncestors().reverse().find(e => this.isLimit(e)) || e.root;
        "both" != t && "backward" != t || (n = new nc({
          boundaries: dc._createIn(o),
          startPosition: e,
          direction: "backward"
        })), "both" != t && "forward" != t || (i = new nc({
          boundaries: dc._createIn(o),
          startPosition: e
        }));
        for (const e of function* (e, t) {
          let n = !1;
          for (; !n;) {
            if (n = !0, e) {
              const t = e.next();
              t.done || (n = !1, yield {
                walker: e,
                value: t.value
              });
            }
            if (t) {
              const e = t.next();
              e.done || (n = !1, yield {
                walker: t,
                value: e.value
              });
            }
          }
        }(n, i)) {
          const t = e.walker == n ? "elementEnd" : "elementStart",
            i = e.value;
          if (i.type == t && this.isObject(i.item)) return dc._createOn(i.item);
          if (this.checkChild(i.nextPosition, "$text")) return new dc(i.nextPosition);
        }
        return null;
      }
      findAllowedParent(e, t) {
        let n = e.parent;
        for (; n;) {
          if (this.checkChild(n, t)) return n;
          if (this.isLimit(n)) return null;
          n = n.parent;
        }
        return null;
      }
      setAllowedAttributes(e, t, n) {
        const i = n.model;
        for (const [o, r] of Object.entries(t)) i.schema.checkAttribute(e, o) && n.setAttribute(o, r, e);
      }
      removeDisallowedAttributes(e, t) {
        for (const n of e) if (n.is("$text")) Ed(this, n, t);else {
          const e = dc._createIn(n).getPositions();
          for (const n of e) {
            Ed(this, n.nodeBefore || n.parent, t);
          }
        }
      }
      getAttributesWithProperty(e, t, n) {
        const i = {};
        for (const [o, r] of e.getAttributes()) {
          const e = this.getAttributeProperties(o);
          void 0 !== e[t] && (void 0 !== n && n !== e[t] || (i[o] = r));
        }
        return i;
      }
      createContext(e) {
        return new md(e);
      }
      _clearCache() {
        this._compiledDefinitions = null;
      }
      _compile() {
        const e = {},
          t = this._sourceDefinitions,
          n = Object.keys(t);
        for (const i of n) e[i] = pd(t[i], i);
        for (const t of n) gd(e, t);
        for (const t of n) fd(e, t);
        for (const t of n) kd(e, t);
        for (const t of n) bd(e, t), _d(e, t);
        for (const t of n) wd(e, t), Ad(e, t), vd(e, t);
        this._compiledDefinitions = e;
      }
      _checkContextMatch(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.length - 1;
        const i = t.getItem(n);
        if (e.allowIn.includes(i.name)) {
          if (0 == n) return !0;
          {
            const e = this.getDefinition(i);
            return this._checkContextMatch(e, t, n - 1);
          }
        }
        return !1;
      }
      *_getValidRangesForRange(e, t) {
        let n = e.start,
          i = e.start;
        for (const o of e.getItems({
          shallow: !0
        })) o.is("element") && (yield* this._getValidRangesForRange(dc._createIn(o), t)), this.checkAttribute(o, t) || (n.isEqual(i) || (yield new dc(n, i)), n = oc._createAfter(o)), i = oc._createAfter(o);
        n.isEqual(i) || (yield new dc(n, i));
      }
      findOptimalInsertionRange(e, t) {
        const n = e.getSelectedElement();
        if (n && this.isObject(n) && !this.isInline(n)) return "before" == t || "after" == t ? new dc(oc._createAt(n, t)) : dc._createOn(n);
        const i = Go(e.getSelectedBlocks());
        if (!i) return new dc(e.focus);
        if (i.isEmpty) return new dc(oc._createAt(i, 0));
        const o = oc._createAfter(i);
        return e.focus.isTouching(o) ? new dc(o) : new dc(oc._createBefore(i));
      }
    }
    class md {
      constructor(e) {
        if (e instanceof md) return e;
        let t;
        t = "string" == typeof e ? [e] : Array.isArray(e) ? e : e.getAncestors({
          includeSelf: !0
        }), this._items = t.map(xd);
      }
      get length() {
        return this._items.length;
      }
      get last() {
        return this._items[this._items.length - 1];
      }
      [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
      }
      push(e) {
        const t = new md([e]);
        return t._items = [...this._items, ...t._items], t;
      }
      getItem(e) {
        return this._items[e];
      }
      *getNames() {
        yield* this._items.map(e => e.name);
      }
      endsWith(e) {
        return Array.from(this.getNames()).join(" ").endsWith(e);
      }
      startsWith(e) {
        return Array.from(this.getNames()).join(" ").startsWith(e);
      }
    }
    function pd(e, t) {
      const n = {
        name: t,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        allowChildren: [],
        inheritTypesFrom: []
      };
      return function (e, t) {
        for (const n of e) {
          const e = Object.keys(n).filter(e => e.startsWith("is"));
          for (const i of e) t[i] = !!n[i];
        }
      }(e, n), Cd(e, n, "allowIn"), Cd(e, n, "allowContentOf"), Cd(e, n, "allowWhere"), Cd(e, n, "allowAttributes"), Cd(e, n, "allowAttributesOf"), Cd(e, n, "allowChildren"), Cd(e, n, "inheritTypesFrom"), function (e, t) {
        for (const n of e) {
          const e = n.inheritAllFrom;
          e && (t.allowContentOf.push(e), t.allowWhere.push(e), t.allowAttributesOf.push(e), t.inheritTypesFrom.push(e));
        }
      }(e, n), n;
    }
    function gd(e, t) {
      const n = e[t];
      for (const i of n.allowChildren) {
        const n = e[i];
        n && n.allowIn.push(t);
      }
      n.allowChildren.length = 0;
    }
    function fd(e, t) {
      for (const n of e[t].allowContentOf) if (e[n]) {
        yd(e, n).forEach(e => {
          e.allowIn.push(t);
        });
      }
      delete e[t].allowContentOf;
    }
    function kd(e, t) {
      for (const n of e[t].allowWhere) {
        const i = e[n];
        if (i) {
          const n = i.allowIn;
          e[t].allowIn.push(...n);
        }
      }
      delete e[t].allowWhere;
    }
    function bd(e, t) {
      for (const n of e[t].allowAttributesOf) {
        const i = e[n];
        if (i) {
          const n = i.allowAttributes;
          e[t].allowAttributes.push(...n);
        }
      }
      delete e[t].allowAttributesOf;
    }
    function _d(e, t) {
      const n = e[t];
      for (const t of n.inheritTypesFrom) {
        const i = e[t];
        if (i) {
          const e = Object.keys(i).filter(e => e.startsWith("is"));
          for (const t of e) t in n || (n[t] = i[t]);
        }
      }
      delete n.inheritTypesFrom;
    }
    function wd(e, t) {
      const n = e[t],
        i = n.allowIn.filter(t => e[t]);
      n.allowIn = Array.from(new Set(i));
    }
    function Ad(e, t) {
      const n = e[t];
      for (const i of n.allowIn) {
        e[i].allowChildren.push(t);
      }
    }
    function vd(e, t) {
      const n = e[t];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }
    function Cd(e, t, n) {
      for (const i of e) {
        const e = i[n];
        "string" == typeof e ? t[n].push(e) : Array.isArray(e) && t[n].push(...e);
      }
    }
    function yd(e, t) {
      const n = e[t];
      return (i = e, Object.keys(i).map(e => i[e])).filter(e => e.allowIn.includes(n.name));
      var i;
    }
    function xd(e) {
      return "string" == typeof e || e.is("documentFragment") ? {
        name: "string" == typeof e ? e : "$documentFragment",
        *getAttributeKeys() {},
        getAttribute() {}
      } : {
        name: e.is("element") ? e.name : "$text",
        *getAttributeKeys() {
          yield* e.getAttributeKeys();
        },
        getAttribute: t => e.getAttribute(t)
      };
    }
    function Ed(e, t, n) {
      for (const i of t.getAttributeKeys()) e.checkAttribute(t, i) || n.removeAttribute(i, t);
    }
    class Sd extends T() {
      constructor(e) {
        super(), this._splitParts = new Map(), this._cursorParents = new Map(), this._modelCursor = null, this._emptyElementsToKeep = new Set(), this.conversionApi = {
          ...e,
          consumable: null,
          writer: null,
          store: null,
          convertItem: (e, t) => this._convertItem(e, t),
          convertChildren: (e, t) => this._convertChildren(e, t),
          safeInsert: (e, t) => this._safeInsert(e, t),
          updateConversionResult: (e, t) => this._updateConversionResult(e, t),
          splitToAllowedParent: (e, t) => this._splitToAllowedParent(e, t),
          getSplitParts: e => this._getSplitParts(e),
          keepEmptyElement: e => this._keepEmptyElement(e)
        };
      }
      convert(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
        this.fire("viewCleanup", e), this._modelCursor = function (e, t) {
          let n;
          for (const i of new md(e)) {
            const e = {};
            for (const t of i.getAttributeKeys()) e[t] = i.getAttribute(t);
            const o = t.createElement(i.name, e);
            n && t.insert(o, n), n = oc._createAt(o, 0);
          }
          return n;
        }(n, t), this.conversionApi.writer = t, this.conversionApi.consumable = cd.createFrom(e), this.conversionApi.store = {};
        const {
            modelRange: i
          } = this._convertItem(e, this._modelCursor),
          o = t.createDocumentFragment();
        if (i) {
          this._removeEmptyElements();
          for (const e of Array.from(this._modelCursor.parent.getChildren())) t.append(e, o);
          o.markers = function (e, t) {
            const n = new Set(),
              i = new Map(),
              o = dc._createIn(e).getItems();
            for (const e of o) e.is("element", "$marker") && n.add(e);
            for (const e of n) {
              const n = e.getAttribute("data-name"),
                o = t.createPositionBefore(e);
              i.has(n) ? i.get(n).end = o.clone() : i.set(n, new dc(o.clone())), t.remove(e);
            }
            return i;
          }(o, t);
        }
        return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this._emptyElementsToKeep.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
      }
      _convertItem(e, t) {
        const n = {
          viewItem: e,
          modelCursor: t,
          modelRange: null
        };
        if (e.is("element") ? this.fire("element:".concat(e.name), n, this.conversionApi) : e.is("$text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof dc)) throw new _("view-conversion-dispatcher-incorrect-result", this);
        return {
          modelRange: n.modelRange,
          modelCursor: n.modelCursor
        };
      }
      _convertChildren(e, t) {
        let n = t.is("position") ? t : oc._createAt(t, 0);
        const i = new dc(n);
        for (const t of Array.from(e.getChildren())) {
          const e = this._convertItem(t, n);
          e.modelRange instanceof dc && (i.end = e.modelRange.end, n = e.modelCursor);
        }
        return {
          modelRange: i,
          modelCursor: n
        };
      }
      _safeInsert(e, t) {
        const n = this._splitToAllowedParent(e, t);
        return !!n && (this.conversionApi.writer.insert(e, n.position), !0);
      }
      _updateConversionResult(e, t) {
        const n = this._getSplitParts(e),
          i = this.conversionApi.writer;
        t.modelRange || (t.modelRange = i.createRange(i.createPositionBefore(e), i.createPositionAfter(n[n.length - 1])));
        const o = this._cursorParents.get(e);
        t.modelCursor = o ? i.createPositionAt(o, 0) : t.modelRange.end;
      }
      _splitToAllowedParent(e, t) {
        const {
          schema: n,
          writer: i
        } = this.conversionApi;
        let o = n.findAllowedParent(t, e);
        if (o) {
          if (o === t.parent) return {
            position: t
          };
          this._modelCursor.parent.getAncestors().includes(o) && (o = null);
        }
        if (!o) return $c(t, e, n) ? {
          position: Zc(t, i)
        } : null;
        const r = this.conversionApi.writer.split(t, o),
          s = [];
        for (const e of r.range.getWalker()) if ("elementEnd" == e.type) s.push(e.item);else {
          const t = s.pop(),
            n = e.item;
          this._registerSplitPair(t, n);
        }
        const a = r.range.end.parent;
        return this._cursorParents.set(e, a), {
          position: r.position,
          cursorParent: a
        };
      }
      _registerSplitPair(e, t) {
        this._splitParts.has(e) || this._splitParts.set(e, [e]);
        const n = this._splitParts.get(e);
        this._splitParts.set(t, n), n.push(t);
      }
      _getSplitParts(e) {
        let t;
        return t = this._splitParts.has(e) ? this._splitParts.get(e) : [e], t;
      }
      _keepEmptyElement(e) {
        this._emptyElementsToKeep.add(e);
      }
      _removeEmptyElements() {
        let e = !1;
        for (const t of this._splitParts.keys()) t.isEmpty && !this._emptyElementsToKeep.has(t) && (this.conversionApi.writer.remove(t), this._splitParts.delete(t), e = !0);
        e && this._removeEmptyElements();
      }
    }
    class Dd {
      getHtml(e) {
        const n = t.document.implementation.createHTMLDocument("").createElement("div");
        return n.appendChild(e), n.innerHTML;
      }
    }
    class Td {
      constructor(e) {
        this.skipComments = !0, this.domParser = new DOMParser(), this.domConverter = new Wa(e, {
          renderingMode: "data"
        }), this.htmlWriter = new Dd();
      }
      toData(e) {
        const t = this.domConverter.viewToDom(e);
        return this.htmlWriter.getHtml(t);
      }
      toView(e) {
        const t = this._toDom(e);
        return this.domConverter.domToView(t, {
          skipComments: this.skipComments
        });
      }
      registerRawContentMatcher(e) {
        this.domConverter.registerRawContentMatcher(e);
      }
      useFillerType(e) {
        this.domConverter.blockFillerMode = "marked" == e ? "markedNbsp" : "nbsp";
      }
      _toDom(e) {
        e.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (e = "<body>".concat(e, "</body>"));
        const t = this.domParser.parseFromString(e, "text/html"),
          n = t.createDocumentFragment(),
          i = t.body.childNodes;
        for (; i.length > 0;) n.appendChild(i[0]);
        return n;
      }
    }
    class Id extends T() {
      constructor(e, t) {
        super(), this.model = e, this.mapper = new uc(), this.downcastDispatcher = new pc({
          mapper: this.mapper,
          schema: e.schema
        }), this.downcastDispatcher.on("insert:$text", (e, t, n) => {
          if (!n.consumable.consume(t.item, e.name)) return;
          const i = n.writer,
            o = n.mapper.toViewPosition(t.range.start),
            r = i.createText(t.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("insert", (e, t, n) => {
          n.convertAttributes(t.item), t.reconversion || !t.item.is("element") || t.item.isEmpty || n.convertChildren(t.item);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new Sd({
          schema: e.schema
        }), this.viewDocument = new ta(t), this.stylesProcessor = t, this.htmlProcessor = new Td(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new pa(this.viewDocument), this.upcastDispatcher.on("text", (e, t, _ref23) => {
          let {
            schema: n,
            consumable: i,
            writer: o
          } = _ref23;
          let r = t.modelCursor;
          if (!i.test(t.viewItem)) return;
          if (!n.checkChild(r, "$text")) {
            if (!$c(r, "$text", n)) return;
            if (0 == t.viewItem.data.trim().length) return;
            const e = r.nodeBefore;
            r = Zc(r, o), e && e.is("element", "$marker") && (o.move(o.createRangeOn(e), r), r = o.createPositionAfter(e));
          }
          i.consume(t.viewItem);
          const s = o.createText(t.viewItem.data);
          o.insert(s, r), t.modelRange = o.createRange(r, r.getShiftedBy(s.offsetSize)), t.modelCursor = t.modelRange.end;
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", (e, t, n) => {
          if (!t.modelRange && n.consumable.consume(t.viewItem, {
            name: !0
          })) {
            const {
              modelRange: e,
              modelCursor: i
            } = n.convertChildren(t.viewItem, t.modelCursor);
            t.modelRange = e, t.modelCursor = i;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", (e, t, n) => {
          if (!t.modelRange && n.consumable.consume(t.viewItem, {
            name: !0
          })) {
            const {
              modelRange: e,
              modelCursor: i
            } = n.convertChildren(t.viewItem, t.modelCursor);
            t.modelRange = e, t.modelCursor = i;
          }
        }, {
          priority: "lowest"
        }), q().prototype.decorate.call(this, "init"), q().prototype.decorate.call(this, "set"), q().prototype.decorate.call(this, "get"), q().prototype.decorate.call(this, "toView"), q().prototype.decorate.call(this, "toModel"), this.on("init", () => {
          this.fire("ready");
        }, {
          priority: "lowest"
        }), this.on("ready", () => {
          this.model.enqueueChange({
            isUndoable: !1
          }, Yc);
        }, {
          priority: "lowest"
        });
      }
      get() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          rootName: t = "main",
          trim: n = "empty"
        } = e;
        if (!this._checkIfRootsExists([t])) throw new _("datacontroller-get-non-existent-root", this);
        const i = this.model.document.getRoot(t);
        return i.isAttached() || w("datacontroller-get-detached-root", this), "empty" !== n || this.model.hasContent(i, {
          ignoreWhitespaces: !0
        }) ? this.stringify(i, e) : "";
      }
      stringify(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.toView(e, t);
        return this.processor.toData(n);
      }
      toView(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.viewDocument,
          i = this._viewWriter;
        this.mapper.clearBindings();
        const o = dc._createIn(e),
          r = new ma(n);
        this.mapper.bindElements(e, r);
        const s = e.is("documentFragment") ? e.markers : function (e) {
          const t = [],
            n = e.root.document;
          if (!n) return new Map();
          const i = dc._createIn(e);
          for (const e of n.model.markers) {
            const n = e.getRange(),
              o = n.isCollapsed,
              r = n.start.isEqual(i.start) || n.end.isEqual(i.end);
            if (o && r) t.push([e.name, n]);else {
              const o = i.getIntersection(n);
              o && t.push([e.name, o]);
            }
          }
          return t.sort((_ref24, _ref25) => {
            let [e, t] = _ref24;
            let [n, i] = _ref25;
            if ("after" !== t.end.compareWith(i.start)) return 1;
            if ("before" !== t.start.compareWith(i.end)) return -1;
            switch (t.start.compareWith(i.start)) {
              case "before":
                return 1;
              case "after":
                return -1;
              default:
                switch (t.end.compareWith(i.end)) {
                  case "before":
                    return 1;
                  case "after":
                    return -1;
                  default:
                    return n.localeCompare(e);
                }
            }
          }), new Map(t);
        }(e);
        return this.downcastDispatcher.convert(o, s, i, t), r;
      }
      init(e) {
        if (this.model.document.version) throw new _("datacontroller-init-document-not-empty", this);
        let t = {};
        if ("string" == typeof e ? t.main = e : t = e, !this._checkIfRootsExists(Object.keys(t))) throw new _("datacontroller-init-non-existent-root", this);
        return this.model.enqueueChange({
          isUndoable: !1
        }, e => {
          for (const n of Object.keys(t)) {
            const i = this.model.document.getRoot(n);
            e.insert(this.parse(t[n], i), i, 0);
          }
        }), Promise.resolve();
      }
      set(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let n = {};
        if ("string" == typeof e ? n.main = e : n = e, !this._checkIfRootsExists(Object.keys(n))) throw new _("datacontroller-set-non-existent-root", this);
        this.model.enqueueChange(t.batchType || {}, e => {
          e.setSelection(null), e.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
          for (const t of Object.keys(n)) {
            const i = this.model.document.getRoot(t);
            e.remove(e.createRangeIn(i)), e.insert(this.parse(n[t], i), i, 0);
          }
        });
      }
      parse(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
        const n = this.processor.toView(e);
        return this.toModel(n, t);
      }
      toModel(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
        return this.model.change(n => this.upcastDispatcher.convert(e, n, t));
      }
      addStyleProcessorRules(e) {
        e(this.stylesProcessor);
      }
      registerRawContentMatcher(e) {
        this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(e), this.htmlProcessor.registerRawContentMatcher(e);
      }
      destroy() {
        this.stopListening();
      }
      _checkIfRootsExists(e) {
        for (const t of e) if (!this.model.document.getRoot(t)) return !1;
        return !0;
      }
    }
    class Bd {
      constructor(e, t) {
        this._helpers = new Map(), this._downcast = _o(e), this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = _o(t), this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }
      addAlias(e, t) {
        const n = this._downcast.includes(t);
        if (!this._upcast.includes(t) && !n) throw new _("conversion-add-alias-dispatcher-not-registered", this);
        this._createConversionHelpers({
          name: e,
          dispatchers: [t],
          isDowncast: n
        });
      }
      for(e) {
        if (!this._helpers.has(e)) throw new _("conversion-for-unknown-group", this);
        return this._helpers.get(e);
      }
      elementToElement(e) {
        this.for("downcast").elementToElement(e);
        for (const {
          model: t,
          view: n
        } of Md(e)) this.for("upcast").elementToElement({
          model: t,
          view: n,
          converterPriority: e.converterPriority
        });
      }
      attributeToElement(e) {
        this.for("downcast").attributeToElement(e);
        for (const {
          model: t,
          view: n
        } of Md(e)) this.for("upcast").elementToAttribute({
          view: n,
          model: t,
          converterPriority: e.converterPriority
        });
      }
      attributeToAttribute(e) {
        this.for("downcast").attributeToAttribute(e);
        for (const {
          model: t,
          view: n
        } of Md(e)) this.for("upcast").attributeToAttribute({
          view: n,
          model: t
        });
      }
      _createConversionHelpers(_ref26) {
        let {
          name: e,
          dispatchers: t,
          isDowncast: n
        } = _ref26;
        if (this._helpers.has(e)) throw new _("conversion-group-exists", this);
        const i = n ? new Mc(t) : new Qc(t);
        this._helpers.set(e, i);
      }
    }
    function* Md(e) {
      if (e.model.values) for (const t of e.model.values) {
        const n = {
            key: e.model.key,
            value: t
          },
          i = e.view[t],
          o = e.upcastAlso ? e.upcastAlso[t] : void 0;
        yield* Pd(n, i, o);
      } else yield* Pd(e.model, e.view, e.upcastAlso);
    }
    function* Pd(e, t, n) {
      if (yield {
        model: e,
        view: t
      }, n) for (const t of _o(n)) yield {
        model: e,
        view: t
      };
    }
    class zd {
      constructor(e) {
        this.baseVersion = e, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }
      _validate() {}
      toJSON() {
        const e = Object.assign({}, this);
        return e.__className = this.constructor.className, delete e.batch, delete e.isDocumentOperation, e;
      }
      static get className() {
        return "Operation";
      }
      static fromJSON(e, t) {
        return new this(e.baseVersion);
      }
    }
    function Nd(e, t) {
      const n = Vd(t),
        i = n.reduce((e, t) => e + t.offsetSize, 0),
        o = e.parent;
      Fd(e);
      const r = e.index;
      return o._insertChild(r, n), Od(o, r + n.length), Od(o, r), new dc(e, e.getShiftedBy(i));
    }
    function Ld(e) {
      if (!e.isFlat) throw new _("operation-utils-remove-range-not-flat", this);
      const t = e.start.parent;
      Fd(e.start), Fd(e.end);
      const n = t._removeChildren(e.start.index, e.end.index - e.start.index);
      return Od(t, e.start.index), n;
    }
    function Rd(e, t) {
      if (!e.isFlat) throw new _("operation-utils-move-range-not-flat", this);
      const n = Ld(e);
      return Nd(t = t._getTransformedByDeletion(e.start, e.end.offset - e.start.offset), n);
    }
    function Vd(e) {
      const t = [];
      !function e(n) {
        if ("string" == typeof n) t.push(new Xl(n));else if (n instanceof ec) t.push(new Xl(n.data, n.getAttributes()));else if (n instanceof Ql) t.push(n);else if (X(n)) for (const t of n) e(t);else {}
      }(e);
      for (let e = 1; e < t.length; e++) {
        const n = t[e],
          i = t[e - 1];
        n instanceof Xl && i instanceof Xl && jd(n, i) && (t.splice(e - 1, 2, new Xl(i.data + n.data, i.getAttributes())), e--);
      }
      return t;
    }
    function Od(e, t) {
      const n = e.getChild(t - 1),
        i = e.getChild(t);
      if (n && i && n.is("$text") && i.is("$text") && jd(n, i)) {
        const o = new Xl(n.data + i.data, n.getAttributes());
        e._removeChildren(t - 1, 2), e._insertChild(t - 1, o);
      }
    }
    function Fd(e) {
      const t = e.textNode,
        n = e.parent;
      if (t) {
        const i = e.offset - t.startOffset,
          o = t.index;
        n._removeChildren(o, 1);
        const r = new Xl(t.data.substr(0, i), t.getAttributes()),
          s = new Xl(t.data.substr(i), t.getAttributes());
        n._insertChild(o, [r, s]);
      }
    }
    function jd(e, t) {
      const n = e.getAttributes(),
        i = t.getAttributes();
      for (const e of n) {
        if (e[1] !== t.getAttribute(e[0])) return !1;
        i.next();
      }
      return i.next().done;
    }
    class Hd extends zd {
      constructor(e, t, n, i) {
        super(i), this.sourcePosition = e.clone(), this.sourcePosition.stickiness = "toNext", this.howMany = t, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNone";
      }
      get type() {
        return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
      }
      get affectedSelectable() {
        return [dc._createFromPositionAndShift(this.sourcePosition, this.howMany), dc._createFromPositionAndShift(this.targetPosition, 0)];
      }
      clone() {
        return new Hd(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
      }
      getMovedRangeStart() {
        return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
      }
      getReversed() {
        const e = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
        return new Hd(this.getMovedRangeStart(), this.howMany, e, this.baseVersion + 1);
      }
      _validate() {
        const e = this.sourcePosition.parent,
          t = this.targetPosition.parent,
          n = this.sourcePosition.offset,
          i = this.targetPosition.offset;
        if (n + this.howMany > e.maxOffset) throw new _("move-operation-nodes-do-not-exist", this);
        if (e === t && n < i && i < n + this.howMany) throw new _("move-operation-range-into-itself", this);
        if (this.sourcePosition.root == this.targetPosition.root && "prefix" == J(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
          const e = this.sourcePosition.path.length - 1;
          if (this.targetPosition.path[e] >= n && this.targetPosition.path[e] < n + this.howMany) throw new _("move-operation-node-into-itself", this);
        }
      }
      _execute() {
        Rd(dc._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
      }
      toJSON() {
        const e = super.toJSON();
        return e.sourcePosition = this.sourcePosition.toJSON(), e.targetPosition = this.targetPosition.toJSON(), e;
      }
      static get className() {
        return "MoveOperation";
      }
      static fromJSON(e, t) {
        const n = oc.fromJSON(e.sourcePosition, t),
          i = oc.fromJSON(e.targetPosition, t);
        return new this(n, e.howMany, i, e.baseVersion);
      }
    }
    class Ud extends zd {
      constructor(e, t, n) {
        super(n), this.position = e.clone(), this.position.stickiness = "toNone", this.nodes = new Jl(Vd(t)), this.shouldReceiveAttributes = !1;
      }
      get type() {
        return "insert";
      }
      get howMany() {
        return this.nodes.maxOffset;
      }
      get affectedSelectable() {
        return this.position.clone();
      }
      clone() {
        const e = new Jl([...this.nodes].map(e => e._clone(!0))),
          t = new Ud(this.position, e, this.baseVersion);
        return t.shouldReceiveAttributes = this.shouldReceiveAttributes, t;
      }
      getReversed() {
        const e = this.position.root.document.graveyard,
          t = new oc(e, [0]);
        return new Hd(this.position, this.nodes.maxOffset, t, this.baseVersion + 1);
      }
      _validate() {
        const e = this.position.parent;
        if (!e || e.maxOffset < this.position.offset) throw new _("insert-operation-position-invalid", this);
      }
      _execute() {
        const e = this.nodes;
        this.nodes = new Jl([...e].map(e => e._clone(!0))), Nd(this.position, e);
      }
      toJSON() {
        const e = super.toJSON();
        return e.position = this.position.toJSON(), e.nodes = this.nodes.toJSON(), e;
      }
      static get className() {
        return "InsertOperation";
      }
      static fromJSON(e, t) {
        const n = [];
        for (const t of e.nodes) t.name ? n.push(tc.fromJSON(t)) : n.push(Xl.fromJSON(t));
        const i = new Ud(oc.fromJSON(e.position, t), n, e.baseVersion);
        return i.shouldReceiveAttributes = e.shouldReceiveAttributes, i;
      }
    }
    class qd extends zd {
      constructor(e, t, n, i, o) {
        super(o), this.splitPosition = e.clone(), this.splitPosition.stickiness = "toNext", this.howMany = t, this.insertionPosition = n, this.graveyardPosition = i ? i.clone() : null, this.graveyardPosition && (this.graveyardPosition.stickiness = "toNext");
      }
      get type() {
        return "split";
      }
      get moveTargetPosition() {
        const e = this.insertionPosition.path.slice();
        return e.push(0), new oc(this.insertionPosition.root, e);
      }
      get movedRange() {
        const e = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new dc(this.splitPosition, e);
      }
      get affectedSelectable() {
        const e = [dc._createFromPositionAndShift(this.splitPosition, 0), dc._createFromPositionAndShift(this.insertionPosition, 0)];
        return this.graveyardPosition && e.push(dc._createFromPositionAndShift(this.graveyardPosition, 0)), e;
      }
      clone() {
        return new qd(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
      }
      getReversed() {
        const e = this.splitPosition.root.document.graveyard,
          t = new oc(e, [0]);
        return new Gd(this.moveTargetPosition, this.howMany, this.splitPosition, t, this.baseVersion + 1);
      }
      _validate() {
        const e = this.splitPosition.parent,
          t = this.splitPosition.offset;
        if (!e || e.maxOffset < t) throw new _("split-operation-position-invalid", this);
        if (!e.parent) throw new _("split-operation-split-in-root", this);
        if (this.howMany != e.maxOffset - this.splitPosition.offset) throw new _("split-operation-how-many-invalid", this);
        if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new _("split-operation-graveyard-position-invalid", this);
      }
      _execute() {
        const e = this.splitPosition.parent;
        if (this.graveyardPosition) Rd(dc._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
          const t = e._clone();
          Nd(this.insertionPosition, t);
        }
        Rd(new dc(oc._createAt(e, this.splitPosition.offset), oc._createAt(e, e.maxOffset)), this.moveTargetPosition);
      }
      toJSON() {
        const e = super.toJSON();
        return e.splitPosition = this.splitPosition.toJSON(), e.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (e.graveyardPosition = this.graveyardPosition.toJSON()), e;
      }
      static get className() {
        return "SplitOperation";
      }
      static getInsertionPosition(e) {
        const t = e.path.slice(0, -1);
        return t[t.length - 1]++, new oc(e.root, t, "toPrevious");
      }
      static fromJSON(e, t) {
        const n = oc.fromJSON(e.splitPosition, t),
          i = oc.fromJSON(e.insertionPosition, t),
          o = e.graveyardPosition ? oc.fromJSON(e.graveyardPosition, t) : null;
        return new this(n, e.howMany, i, o, e.baseVersion);
      }
    }
    class Gd extends zd {
      constructor(e, t, n, i, o) {
        super(o), this.sourcePosition = e.clone(), this.sourcePosition.stickiness = "toPrevious", this.howMany = t, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNext", this.graveyardPosition = i.clone();
      }
      get type() {
        return "merge";
      }
      get deletionPosition() {
        return new oc(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
      }
      get movedRange() {
        const e = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new dc(this.sourcePosition, e);
      }
      get affectedSelectable() {
        const e = this.sourcePosition.parent;
        return [dc._createOn(e), dc._createFromPositionAndShift(this.targetPosition, 0), dc._createFromPositionAndShift(this.graveyardPosition, 0)];
      }
      clone() {
        return new Gd(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
      }
      getReversed() {
        const e = this.targetPosition._getTransformedByMergeOperation(this),
          t = this.sourcePosition.path.slice(0, -1),
          n = new oc(this.sourcePosition.root, t)._getTransformedByMergeOperation(this);
        return new qd(e, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
      }
      _validate() {
        const e = this.sourcePosition.parent,
          t = this.targetPosition.parent;
        if (!e.parent) throw new _("merge-operation-source-position-invalid", this);
        if (!t.parent) throw new _("merge-operation-target-position-invalid", this);
        if (this.howMany != e.maxOffset) throw new _("merge-operation-how-many-invalid", this);
      }
      _execute() {
        const e = this.sourcePosition.parent;
        Rd(dc._createIn(e), this.targetPosition), Rd(dc._createOn(e), this.graveyardPosition);
      }
      toJSON() {
        const e = super.toJSON();
        return e.sourcePosition = e.sourcePosition.toJSON(), e.targetPosition = e.targetPosition.toJSON(), e.graveyardPosition = e.graveyardPosition.toJSON(), e;
      }
      static get className() {
        return "MergeOperation";
      }
      static fromJSON(e, t) {
        const n = oc.fromJSON(e.sourcePosition, t),
          i = oc.fromJSON(e.targetPosition, t),
          o = oc.fromJSON(e.graveyardPosition, t);
        return new this(n, e.howMany, i, o, e.baseVersion);
      }
    }
    class Kd extends zd {
      constructor(e, t, n, i, o, r) {
        super(r), this.name = e, this.oldRange = t ? t.clone() : null, this.newRange = n ? n.clone() : null, this.affectsData = o, this._markers = i;
      }
      get type() {
        return "marker";
      }
      get affectedSelectable() {
        const e = [];
        return this.oldRange && e.push(this.oldRange.clone()), this.newRange && (this.oldRange ? e.push(...this.newRange.getDifference(this.oldRange)) : e.push(this.newRange.clone())), e;
      }
      clone() {
        return new Kd(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
      }
      getReversed() {
        return new Kd(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
      }
      _execute() {
        this.newRange ? this._markers._set(this.name, this.newRange, !0, this.affectsData) : this._markers._remove(this.name);
      }
      toJSON() {
        const e = super.toJSON();
        return this.oldRange && (e.oldRange = this.oldRange.toJSON()), this.newRange && (e.newRange = this.newRange.toJSON()), delete e._markers, e;
      }
      static get className() {
        return "MarkerOperation";
      }
      static fromJSON(e, t) {
        return new Kd(e.name, e.oldRange ? dc.fromJSON(e.oldRange, t) : null, e.newRange ? dc.fromJSON(e.newRange, t) : null, t.model.markers, e.affectsData, e.baseVersion);
      }
    }
    const Wd = function (e, t) {
      return Ll(e, t);
    };
    class Yd extends zd {
      constructor(e, t, n, i, o) {
        super(o), this.range = e.clone(), this.key = t, this.oldValue = void 0 === n ? null : n, this.newValue = void 0 === i ? null : i;
      }
      get type() {
        return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
      }
      get affectedSelectable() {
        return this.range.clone();
      }
      clone() {
        return new Yd(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
      }
      getReversed() {
        return new Yd(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
      }
      toJSON() {
        const e = super.toJSON();
        return e.range = this.range.toJSON(), e;
      }
      _validate() {
        if (!this.range.isFlat) throw new _("attribute-operation-range-not-flat", this);
        for (const e of this.range.getItems({
          shallow: !0
        })) {
          if (null !== this.oldValue && !Wd(e.getAttribute(this.key), this.oldValue)) throw new _("attribute-operation-wrong-old-value", this, {
            item: e,
            key: this.key,
            value: this.oldValue
          });
          if (null === this.oldValue && null !== this.newValue && e.hasAttribute(this.key)) throw new _("attribute-operation-attribute-exists", this, {
            node: e,
            key: this.key
          });
        }
      }
      _execute() {
        Wd(this.oldValue, this.newValue) || function (e, t, n) {
          Fd(e.start), Fd(e.end);
          for (const i of e.getItems({
            shallow: !0
          })) {
            const e = i.is("$textProxy") ? i.textNode : i;
            null !== n ? e._setAttribute(t, n) : e._removeAttribute(t), Od(e.parent, e.index);
          }
          Od(e.end.parent, e.end.index);
        }(this.range, this.key, this.newValue);
      }
      static get className() {
        return "AttributeOperation";
      }
      static fromJSON(e, t) {
        return new Yd(dc.fromJSON(e.range, t), e.key, e.oldValue, e.newValue, e.baseVersion);
      }
    }
    class $d extends zd {
      get type() {
        return "noop";
      }
      get affectedSelectable() {
        return null;
      }
      clone() {
        return new $d(this.baseVersion);
      }
      getReversed() {
        return new $d(this.baseVersion + 1);
      }
      _execute() {}
      static get className() {
        return "NoOperation";
      }
    }
    class Zd extends zd {
      constructor(e, t, n, i) {
        super(i), this.position = e, this.position.stickiness = "toNext", this.oldName = t, this.newName = n;
      }
      get type() {
        return "rename";
      }
      get affectedSelectable() {
        return this.position.nodeAfter;
      }
      clone() {
        return new Zd(this.position.clone(), this.oldName, this.newName, this.baseVersion);
      }
      getReversed() {
        return new Zd(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
      }
      _validate() {
        const e = this.position.nodeAfter;
        if (!(e instanceof tc)) throw new _("rename-operation-wrong-position", this);
        if (e.name !== this.oldName) throw new _("rename-operation-wrong-name", this);
      }
      _execute() {
        this.position.nodeAfter.name = this.newName;
      }
      toJSON() {
        const e = super.toJSON();
        return e.position = this.position.toJSON(), e;
      }
      static get className() {
        return "RenameOperation";
      }
      static fromJSON(e, t) {
        return new Zd(oc.fromJSON(e.position, t), e.oldName, e.newName, e.baseVersion);
      }
    }
    class Qd extends zd {
      constructor(e, t, n, i, o) {
        super(o), this.root = e, this.key = t, this.oldValue = void 0 === n ? null : n, this.newValue = void 0 === i ? null : i;
      }
      get type() {
        return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
      }
      get affectedSelectable() {
        return this.root;
      }
      clone() {
        return new Qd(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
      }
      getReversed() {
        return new Qd(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
      }
      _validate() {
        if (this.root != this.root.root || this.root.is("documentFragment")) throw new _("rootattribute-operation-not-a-root", this, {
          root: this.root,
          key: this.key
        });
        if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new _("rootattribute-operation-wrong-old-value", this, {
          root: this.root,
          key: this.key
        });
        if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new _("rootattribute-operation-attribute-exists", this, {
          root: this.root,
          key: this.key
        });
      }
      _execute() {
        null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
      }
      toJSON() {
        const e = super.toJSON();
        return e.root = this.root.toJSON(), e;
      }
      static get className() {
        return "RootAttributeOperation";
      }
      static fromJSON(e, t) {
        if (!t.getRoot(e.root)) throw new _("rootattribute-operation-fromjson-no-root", this, {
          rootName: e.root
        });
        return new Qd(t.getRoot(e.root), e.key, e.oldValue, e.newValue, e.baseVersion);
      }
    }
    class Jd extends zd {
      constructor(e, t, n, i, o) {
        if (super(o), this.rootName = e, this.elementName = t, this.isAdd = n, this._document = i, !this._document.getRoot(this.rootName)) {
          this._document.createRoot(this.elementName, this.rootName)._isAttached = !1;
        }
      }
      get type() {
        return this.isAdd ? "addRoot" : "detachRoot";
      }
      get affectedSelectable() {
        return this._document.getRoot(this.rootName);
      }
      clone() {
        return new Jd(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
      }
      getReversed() {
        return new Jd(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
      }
      _execute() {
        this._document.getRoot(this.rootName)._isAttached = this.isAdd;
      }
      toJSON() {
        const e = super.toJSON();
        return delete e._document, e;
      }
      static get className() {
        return "RootOperation";
      }
      static fromJSON(e, t) {
        return new Jd(e.rootName, e.elementName, e.isAdd, t, e.baseVersion);
      }
    }
    const Xd = {};
    Xd[Yd.className] = Yd, Xd[Ud.className] = Ud, Xd[Kd.className] = Kd, Xd[Hd.className] = Hd, Xd[$d.className] = $d, Xd[zd.className] = zd, Xd[Zd.className] = Zd, Xd[Qd.className] = Qd, Xd[Jd.className] = Jd, Xd[qd.className] = qd, Xd[Gd.className] = Gd;
    class eu {
      static fromJSON(e, t) {
        return Xd[e.__className].fromJSON(e, t);
      }
    }
    const tu = new Map();
    function nu(e, t, n) {
      let i = tu.get(e);
      i || (i = new Map(), tu.set(e, i)), i.set(t, n);
    }
    function iu(e) {
      return [e];
    }
    function ou(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const i = function (e, t) {
        const n = tu.get(e);
        return n && n.has(t) ? n.get(t) : iu;
      }(e.constructor, t.constructor);
      try {
        return i(e = e.clone(), t, n);
      } catch (e) {
        throw e;
      }
    }
    function ru(e, t, n) {
      e = e.slice(), t = t.slice();
      const i = new su(n.document, n.useRelations, n.forceWeakRemove);
      i.setOriginalOperations(e), i.setOriginalOperations(t);
      const o = i.originalOperations;
      if (0 == e.length || 0 == t.length) return {
        operationsA: e,
        operationsB: t,
        originalOperations: o
      };
      const r = new WeakMap();
      for (const t of e) r.set(t, 0);
      const s = {
        nextBaseVersionA: e[e.length - 1].baseVersion + 1,
        nextBaseVersionB: t[t.length - 1].baseVersion + 1,
        originalOperationsACount: e.length,
        originalOperationsBCount: t.length
      };
      let a = 0;
      for (; a < e.length;) {
        const n = e[a],
          o = r.get(n);
        if (o == t.length) {
          a++;
          continue;
        }
        const s = t[o],
          l = ou(n, s, i.getContext(n, s, !0)),
          c = ou(s, n, i.getContext(s, n, !1));
        i.updateRelation(n, s), i.setOriginalOperations(l, n), i.setOriginalOperations(c, s);
        for (const e of l) r.set(e, o + c.length);
        e.splice(a, 1, ...l), t.splice(o, 1, ...c);
      }
      if (n.padWithNoOps) {
        const n = e.length - s.originalOperationsACount,
          i = t.length - s.originalOperationsBCount;
        lu(e, i - n), lu(t, n - i);
      }
      return au(e, s.nextBaseVersionB), au(t, s.nextBaseVersionA), {
        operationsA: e,
        operationsB: t,
        originalOperations: o
      };
    }
    class su {
      constructor(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        this.originalOperations = new Map(), this._history = e.history, this._useRelations = t, this._forceWeakRemove = !!n, this._relations = new Map();
      }
      setOriginalOperations(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        const n = t ? this.originalOperations.get(t) : null;
        for (const t of e) this.originalOperations.set(t, n || t);
      }
      updateRelation(e, t) {
        if (e instanceof Hd) t instanceof Gd ? e.targetPosition.isEqual(t.sourcePosition) || t.movedRange.containsPosition(e.targetPosition) ? this._setRelation(e, t, "insertAtSource") : e.targetPosition.isEqual(t.deletionPosition) ? this._setRelation(e, t, "insertBetween") : e.targetPosition.isAfter(t.sourcePosition) && this._setRelation(e, t, "moveTargetAfter") : t instanceof Hd && (e.targetPosition.isEqual(t.sourcePosition) || e.targetPosition.isBefore(t.sourcePosition) ? this._setRelation(e, t, "insertBefore") : this._setRelation(e, t, "insertAfter"));else if (e instanceof qd) {
          if (t instanceof Gd) e.splitPosition.isBefore(t.sourcePosition) && this._setRelation(e, t, "splitBefore");else if (t instanceof Hd) if (e.splitPosition.isEqual(t.sourcePosition) || e.splitPosition.isBefore(t.sourcePosition)) this._setRelation(e, t, "splitBefore");else {
            const n = dc._createFromPositionAndShift(t.sourcePosition, t.howMany);
            if (e.splitPosition.hasSameParentAs(t.sourcePosition) && n.containsPosition(e.splitPosition)) {
              const i = n.end.offset - e.splitPosition.offset,
                o = e.splitPosition.offset - n.start.offset;
              this._setRelation(e, t, {
                howMany: i,
                offset: o
              });
            }
          }
        } else if (e instanceof Gd) t instanceof Gd ? (e.targetPosition.isEqual(t.sourcePosition) || this._setRelation(e, t, "mergeTargetNotMoved"), e.sourcePosition.isEqual(t.targetPosition) && this._setRelation(e, t, "mergeSourceNotMoved"), e.sourcePosition.isEqual(t.sourcePosition) && this._setRelation(e, t, "mergeSameElement")) : t instanceof qd ? e.sourcePosition.isEqual(t.splitPosition) && this._setRelation(e, t, "splitAtSource") : t instanceof Hd && t.howMany > 0 && (e.sourcePosition.isEqual(t.sourcePosition.getShiftedBy(t.howMany)) && this._setRelation(e, t, "mergeSourceAffected"), e.targetPosition.isEqual(t.sourcePosition) && this._setRelation(e, t, "mergeTargetWasBefore"));else if (e instanceof Kd) {
          const n = e.newRange;
          if (!n) return;
          if (t instanceof Hd) {
            const i = dc._createFromPositionAndShift(t.sourcePosition, t.howMany),
              o = i.containsPosition(n.start) || i.start.isEqual(n.start),
              r = i.containsPosition(n.end) || i.end.isEqual(n.end);
            !o && !r || i.containsRange(n) || this._setRelation(e, t, {
              side: o ? "left" : "right",
              path: o ? n.start.path.slice() : n.end.path.slice()
            });
          } else if (t instanceof Gd) {
            const i = n.start.isEqual(t.targetPosition),
              o = n.start.isEqual(t.deletionPosition),
              r = n.end.isEqual(t.deletionPosition),
              s = n.end.isEqual(t.sourcePosition);
            (i || o || r || s) && this._setRelation(e, t, {
              wasInLeftElement: i,
              wasStartBeforeMergedElement: o,
              wasEndBeforeMergedElement: r,
              wasInRightElement: s
            });
          }
        }
      }
      getContext(e, t, n) {
        return {
          aIsStrong: n,
          aWasUndone: this._wasUndone(e),
          bWasUndone: this._wasUndone(t),
          abRelation: this._useRelations ? this._getRelation(e, t) : null,
          baRelation: this._useRelations ? this._getRelation(t, e) : null,
          forceWeakRemove: this._forceWeakRemove
        };
      }
      _wasUndone(e) {
        const t = this.originalOperations.get(e);
        return t.wasUndone || this._history.isUndoneOperation(t);
      }
      _getRelation(e, t) {
        const n = this.originalOperations.get(t),
          i = this._history.getUndoneOperation(n);
        if (!i) return null;
        const o = this.originalOperations.get(e),
          r = this._relations.get(o);
        return r && r.get(i) || null;
      }
      _setRelation(e, t, n) {
        const i = this.originalOperations.get(e),
          o = this.originalOperations.get(t);
        let r = this._relations.get(i);
        r || (r = new Map(), this._relations.set(i, r)), r.set(o, n);
      }
    }
    function au(e, t) {
      for (const n of e) n.baseVersion = t++;
    }
    function lu(e, t) {
      for (let n = 0; n < t; n++) e.push(new $d(0));
    }
    function cu(e, t, n) {
      const i = e.nodes.getNode(0).getAttribute(t);
      if (i == n) return null;
      const o = new dc(e.position, e.position.getShiftedBy(e.howMany));
      return new Yd(o, t, i, n, 0);
    }
    function du(e, t) {
      return null === e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany);
    }
    function uu(e, t) {
      const n = [];
      for (let i = 0; i < e.length; i++) {
        const o = e[i],
          r = new Hd(o.start, o.end.offset - o.start.offset, t, 0);
        n.push(r);
        for (let t = i + 1; t < e.length; t++) e[t] = e[t]._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany)[0];
        t = t._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany);
      }
      return n;
    }
    nu(Yd, Yd, (e, t, n) => {
      if (e.key === t.key && e.range.start.hasSameParentAs(t.range.start)) {
        const i = e.range.getDifference(t.range).map(t => new Yd(t, e.key, e.oldValue, e.newValue, 0)),
          o = e.range.getIntersection(t.range);
        return o && n.aIsStrong && i.push(new Yd(o, t.key, t.newValue, e.newValue, 0)), 0 == i.length ? [new $d(0)] : i;
      }
      return [e];
    }), nu(Yd, Ud, (e, t) => {
      if (e.range.start.hasSameParentAs(t.position) && e.range.containsPosition(t.position)) {
        const n = e.range._getTransformedByInsertion(t.position, t.howMany, !t.shouldReceiveAttributes).map(t => new Yd(t, e.key, e.oldValue, e.newValue, e.baseVersion));
        if (t.shouldReceiveAttributes) {
          const i = cu(t, e.key, e.oldValue);
          i && n.unshift(i);
        }
        return n;
      }
      return e.range = e.range._getTransformedByInsertion(t.position, t.howMany, !1)[0], [e];
    }), nu(Yd, Gd, (e, t) => {
      const n = [];
      e.range.start.hasSameParentAs(t.deletionPosition) && (e.range.containsPosition(t.deletionPosition) || e.range.start.isEqual(t.deletionPosition)) && n.push(dc._createFromPositionAndShift(t.graveyardPosition, 1));
      const i = e.range._getTransformedByMergeOperation(t);
      return i.isCollapsed || n.push(i), n.map(t => new Yd(t, e.key, e.oldValue, e.newValue, e.baseVersion));
    }), nu(Yd, Hd, (e, t) => {
      const n = function (e, t) {
        const n = dc._createFromPositionAndShift(t.sourcePosition, t.howMany);
        let i = null,
          o = [];
        n.containsRange(e, !0) ? i = e : e.start.hasSameParentAs(n.start) ? (o = e.getDifference(n), i = e.getIntersection(n)) : o = [e];
        const r = [];
        for (let e of o) {
          e = e._getTransformedByDeletion(t.sourcePosition, t.howMany);
          const n = t.getMovedRangeStart(),
            i = e.start.hasSameParentAs(n),
            o = e._getTransformedByInsertion(n, t.howMany, i);
          r.push(...o);
        }
        i && r.push(i._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany, !1)[0]);
        return r;
      }(e.range, t);
      return n.map(t => new Yd(t, e.key, e.oldValue, e.newValue, e.baseVersion));
    }), nu(Yd, qd, (e, t) => {
      if (e.range.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.range.end.offset++, [e];
      if (e.range.start.hasSameParentAs(t.splitPosition) && e.range.containsPosition(t.splitPosition)) {
        const n = e.clone();
        return n.range = new dc(t.moveTargetPosition.clone(), e.range.end._getCombined(t.splitPosition, t.moveTargetPosition)), e.range.end = t.splitPosition.clone(), e.range.end.stickiness = "toPrevious", [e, n];
      }
      return e.range = e.range._getTransformedBySplitOperation(t), [e];
    }), nu(Ud, Yd, (e, t) => {
      const n = [e];
      if (e.shouldReceiveAttributes && e.position.hasSameParentAs(t.range.start) && t.range.containsPosition(e.position)) {
        const i = cu(e, t.key, t.newValue);
        i && n.push(i);
      }
      return n;
    }), nu(Ud, Ud, (e, t, n) => (e.position.isEqual(t.position) && n.aIsStrong || (e.position = e.position._getTransformedByInsertOperation(t)), [e])), nu(Ud, Hd, (e, t) => (e.position = e.position._getTransformedByMoveOperation(t), [e])), nu(Ud, qd, (e, t) => (e.position = e.position._getTransformedBySplitOperation(t), [e])), nu(Ud, Gd, (e, t) => (e.position = e.position._getTransformedByMergeOperation(t), [e])), nu(Kd, Ud, (e, t) => (e.oldRange && (e.oldRange = e.oldRange._getTransformedByInsertOperation(t)[0]), e.newRange && (e.newRange = e.newRange._getTransformedByInsertOperation(t)[0]), [e])), nu(Kd, Kd, (e, t, n) => {
      if (e.name == t.name) {
        if (!n.aIsStrong) return [new $d(0)];
        e.oldRange = t.newRange ? t.newRange.clone() : null;
      }
      return [e];
    }), nu(Kd, Gd, (e, t) => (e.oldRange && (e.oldRange = e.oldRange._getTransformedByMergeOperation(t)), e.newRange && (e.newRange = e.newRange._getTransformedByMergeOperation(t)), [e])), nu(Kd, Hd, (e, t, n) => {
      if (e.oldRange && (e.oldRange = dc._createFromRanges(e.oldRange._getTransformedByMoveOperation(t))), e.newRange) {
        if (n.abRelation) {
          const i = dc._createFromRanges(e.newRange._getTransformedByMoveOperation(t));
          if ("left" == n.abRelation.side && t.targetPosition.isEqual(e.newRange.start)) return e.newRange.end = i.end, e.newRange.start.path = n.abRelation.path, [e];
          if ("right" == n.abRelation.side && t.targetPosition.isEqual(e.newRange.end)) return e.newRange.start = i.start, e.newRange.end.path = n.abRelation.path, [e];
        }
        e.newRange = dc._createFromRanges(e.newRange._getTransformedByMoveOperation(t));
      }
      return [e];
    }), nu(Kd, qd, (e, t, n) => {
      if (e.oldRange && (e.oldRange = e.oldRange._getTransformedBySplitOperation(t)), e.newRange) {
        if (n.abRelation) {
          const i = e.newRange._getTransformedBySplitOperation(t);
          return e.newRange.start.isEqual(t.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? e.newRange.start = oc._createAt(t.insertionPosition) : e.newRange.start.isEqual(t.splitPosition) && !n.abRelation.wasInLeftElement && (e.newRange.start = oc._createAt(t.moveTargetPosition)), e.newRange.end.isEqual(t.splitPosition) && n.abRelation.wasInRightElement ? e.newRange.end = oc._createAt(t.moveTargetPosition) : e.newRange.end.isEqual(t.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? e.newRange.end = oc._createAt(t.insertionPosition) : e.newRange.end = i.end, [e];
        }
        e.newRange = e.newRange._getTransformedBySplitOperation(t);
      }
      return [e];
    }), nu(Gd, Ud, (e, t) => (e.sourcePosition.hasSameParentAs(t.position) && (e.howMany += t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByInsertOperation(t), e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t), [e])), nu(Gd, Gd, (e, t, n) => {
      if (e.sourcePosition.isEqual(t.sourcePosition) && e.targetPosition.isEqual(t.targetPosition)) {
        if (n.bWasUndone) {
          const n = t.graveyardPosition.path.slice();
          return n.push(0), e.sourcePosition = new oc(t.graveyardPosition.root, n), e.howMany = 0, [e];
        }
        return [new $d(0)];
      }
      if (e.sourcePosition.isEqual(t.sourcePosition) && !e.targetPosition.isEqual(t.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
        const i = "$graveyard" == e.targetPosition.root.rootName,
          o = "$graveyard" == t.targetPosition.root.rootName;
        if (o && !i || !(i && !o) && n.aIsStrong) {
          const n = t.targetPosition._getTransformedByMergeOperation(t),
            i = e.targetPosition._getTransformedByMergeOperation(t);
          return [new Hd(n, e.howMany, i, 0)];
        }
        return [new $d(0)];
      }
      return e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByMergeOperation(t), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), e.graveyardPosition.isEqual(t.graveyardPosition) && n.aIsStrong || (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)), [e];
    }), nu(Gd, Hd, (e, t, n) => {
      const i = dc._createFromPositionAndShift(t.sourcePosition, t.howMany);
      return "remove" == t.type && !n.bWasUndone && !n.forceWeakRemove && e.deletionPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(e.sourcePosition) ? [new $d(0)] : (t.sourcePosition.getShiftedBy(t.howMany).isEqual(e.sourcePosition) ? e.sourcePosition.stickiness = "toNone" : t.targetPosition.isEqual(e.sourcePosition) && "mergeSourceAffected" == n.abRelation ? e.sourcePosition.stickiness = "toNext" : t.sourcePosition.isEqual(e.targetPosition) ? (e.targetPosition.stickiness = "toNone", e.howMany -= t.howMany) : t.targetPosition.isEqual(e.targetPosition) && "mergeTargetWasBefore" == n.abRelation ? (e.targetPosition.stickiness = "toPrevious", e.howMany += t.howMany) : (e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.sourcePosition.hasSameParentAs(t.sourcePosition) && (e.howMany -= t.howMany)), e.sourcePosition = e.sourcePosition._getTransformedByMoveOperation(t), e.targetPosition = e.targetPosition._getTransformedByMoveOperation(t), e.sourcePosition.stickiness = "toPrevious", e.targetPosition.stickiness = "toNext", e.graveyardPosition.isEqual(t.targetPosition) || (e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t)), [e]);
    }), nu(Gd, qd, (e, t, n) => {
      if (t.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByDeletion(t.graveyardPosition, 1), e.deletionPosition.isEqual(t.graveyardPosition) && (e.howMany = t.howMany)), e.targetPosition.isEqual(t.splitPosition)) {
        const i = 0 != t.howMany,
          o = t.graveyardPosition && e.deletionPosition.isEqual(t.graveyardPosition);
        if (i || o || "mergeTargetNotMoved" == n.abRelation) return e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t), [e];
      }
      if (e.sourcePosition.isEqual(t.splitPosition)) {
        if ("mergeSourceNotMoved" == n.abRelation) return e.howMany = 0, e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
        if ("mergeSameElement" == n.abRelation || e.sourcePosition.offset > 0) return e.sourcePosition = t.moveTargetPosition.clone(), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
      }
      return e.sourcePosition.hasSameParentAs(t.splitPosition) && (e.howMany = t.splitPosition.offset), e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
    }), nu(Hd, Ud, (e, t) => {
      const n = dc._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByInsertOperation(t, !1)[0];
      return e.sourcePosition = n.start, e.howMany = n.end.offset - n.start.offset, e.targetPosition.isEqual(t.position) || (e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t)), [e];
    }), nu(Hd, Hd, (e, t, n) => {
      const i = dc._createFromPositionAndShift(e.sourcePosition, e.howMany),
        o = dc._createFromPositionAndShift(t.sourcePosition, t.howMany);
      let r,
        s = n.aIsStrong,
        a = !n.aIsStrong;
      if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = e.targetPosition.isEqual(t.targetPosition) && a ? e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany) : e.targetPosition._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), du(e, t) && du(t, e)) return [t.getReversed()];
      if (i.containsPosition(t.targetPosition) && i.containsRange(o, !0)) return i.start = i.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), i.end = i.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), uu([i], r);
      if (o.containsPosition(e.targetPosition) && o.containsRange(i, !0)) return i.start = i.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), i.end = i.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), uu([i], r);
      const l = J(e.sourcePosition.getParentPath(), t.sourcePosition.getParentPath());
      if ("prefix" == l || "extension" == l) return i.start = i.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), i.end = i.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), uu([i], r);
      "remove" != e.type || "remove" == t.type || n.aWasUndone || n.forceWeakRemove ? "remove" == e.type || "remove" != t.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
      const c = [],
        d = i.getDifference(o);
      for (const e of d) {
        e.start = e.start._getTransformedByDeletion(t.sourcePosition, t.howMany), e.end = e.end._getTransformedByDeletion(t.sourcePosition, t.howMany);
        const n = "same" == J(e.start.getParentPath(), t.getMovedRangeStart().getParentPath()),
          i = e._getTransformedByInsertion(t.getMovedRangeStart(), t.howMany, n);
        c.push(...i);
      }
      const u = i.getIntersection(o);
      return null !== u && s && (u.start = u.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), u.end = u.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), 0 === c.length ? c.push(u) : 1 == c.length ? o.start.isBefore(i.start) || o.start.isEqual(i.start) ? c.unshift(u) : c.push(u) : c.splice(1, 0, u)), 0 === c.length ? [new $d(e.baseVersion)] : uu(c, r);
    }), nu(Hd, qd, (e, t, n) => {
      let i = e.targetPosition.clone();
      e.targetPosition.isEqual(t.insertionPosition) && t.graveyardPosition && "moveTargetAfter" != n.abRelation || (i = e.targetPosition._getTransformedBySplitOperation(t));
      const o = dc._createFromPositionAndShift(e.sourcePosition, e.howMany);
      if (o.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.howMany++, e.targetPosition = i, [e];
      if (o.start.hasSameParentAs(t.splitPosition) && o.containsPosition(t.splitPosition)) {
        let e = new dc(t.splitPosition, o.end);
        e = e._getTransformedBySplitOperation(t);
        return uu([new dc(o.start, t.splitPosition), e], i);
      }
      e.targetPosition.isEqual(t.splitPosition) && "insertAtSource" == n.abRelation && (i = t.moveTargetPosition), e.targetPosition.isEqual(t.insertionPosition) && "insertBetween" == n.abRelation && (i = e.targetPosition);
      const r = [o._getTransformedBySplitOperation(t)];
      if (t.graveyardPosition) {
        const i = o.start.isEqual(t.graveyardPosition) || o.containsPosition(t.graveyardPosition);
        e.howMany > 1 && i && !n.aWasUndone && r.push(dc._createFromPositionAndShift(t.insertionPosition, 1));
      }
      return uu(r, i);
    }), nu(Hd, Gd, (e, t, n) => {
      const i = dc._createFromPositionAndShift(e.sourcePosition, e.howMany);
      if (t.deletionPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.sourcePosition)) if ("remove" != e.type || n.forceWeakRemove) {
        if (1 == e.howMany) return n.bWasUndone ? (e.sourcePosition = t.graveyardPosition.clone(), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), [e]) : [new $d(0)];
      } else if (!n.aWasUndone) {
        const n = [];
        let i = t.graveyardPosition.clone(),
          o = t.targetPosition._getTransformedByMergeOperation(t);
        e.howMany > 1 && (n.push(new Hd(e.sourcePosition, e.howMany - 1, e.targetPosition, 0)), i = i._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1), o = o._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1));
        const r = t.deletionPosition._getCombined(e.sourcePosition, e.targetPosition),
          s = new Hd(i, 1, r, 0),
          a = s.getMovedRangeStart().path.slice();
        a.push(0);
        const l = new oc(s.targetPosition.root, a);
        o = o._getTransformedByMove(i, r, 1);
        const c = new Hd(o, t.howMany, l, 0);
        return n.push(s), n.push(c), n;
      }
      const o = dc._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByMergeOperation(t);
      return e.sourcePosition = o.start, e.howMany = o.end.offset - o.start.offset, e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), [e];
    }), nu(Zd, Ud, (e, t) => (e.position = e.position._getTransformedByInsertOperation(t), [e])), nu(Zd, Gd, (e, t) => e.position.isEqual(t.deletionPosition) ? (e.position = t.graveyardPosition.clone(), e.position.stickiness = "toNext", [e]) : (e.position = e.position._getTransformedByMergeOperation(t), [e])), nu(Zd, Hd, (e, t) => (e.position = e.position._getTransformedByMoveOperation(t), [e])), nu(Zd, Zd, (e, t, n) => {
      if (e.position.isEqual(t.position)) {
        if (!n.aIsStrong) return [new $d(0)];
        e.oldName = t.newName;
      }
      return [e];
    }), nu(Zd, qd, (e, t) => {
      if ("same" == J(e.position.path, t.splitPosition.getParentPath()) && !t.graveyardPosition) {
        const t = new Zd(e.position.getShiftedBy(1), e.oldName, e.newName, 0);
        return [e, t];
      }
      return e.position = e.position._getTransformedBySplitOperation(t), [e];
    }), nu(Qd, Qd, (e, t, n) => {
      if (e.root === t.root && e.key === t.key) {
        if (!n.aIsStrong || e.newValue === t.newValue) return [new $d(0)];
        e.oldValue = t.newValue;
      }
      return [e];
    }), nu(Jd, Jd, (e, t) => e.rootName === t.rootName && e.isAdd === t.isAdd ? [new $d(0)] : [e]), nu(qd, Ud, (e, t) => (e.splitPosition.hasSameParentAs(t.position) && e.splitPosition.offset < t.position.offset && (e.howMany += t.howMany), e.splitPosition = e.splitPosition._getTransformedByInsertOperation(t), e.insertionPosition = e.insertionPosition._getTransformedByInsertOperation(t), [e])), nu(qd, Gd, (e, t, n) => {
      if (!e.graveyardPosition && !n.bWasUndone && e.splitPosition.hasSameParentAs(t.sourcePosition)) {
        const n = t.graveyardPosition.path.slice();
        n.push(0);
        const i = new oc(t.graveyardPosition.root, n),
          o = qd.getInsertionPosition(new oc(t.graveyardPosition.root, n)),
          r = new qd(i, 0, o, null, 0);
        return e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t), e.insertionPosition = qd.getInsertionPosition(e.splitPosition), e.graveyardPosition = r.insertionPosition.clone(), e.graveyardPosition.stickiness = "toNext", [r, e];
      }
      return e.splitPosition.hasSameParentAs(t.deletionPosition) && !e.splitPosition.isAfter(t.deletionPosition) && e.howMany--, e.splitPosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t), e.insertionPosition = qd.getInsertionPosition(e.splitPosition), e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)), [e];
    }), nu(qd, Hd, (e, t, n) => {
      const i = dc._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (e.graveyardPosition) {
        const o = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
        if (!n.bWasUndone && o) {
          const n = e.splitPosition._getTransformedByMoveOperation(t),
            i = e.graveyardPosition._getTransformedByMoveOperation(t),
            o = i.path.slice();
          o.push(0);
          const r = new oc(i.root, o);
          return [new Hd(n, e.howMany, r, 0)];
        }
        e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t);
      }
      const o = e.splitPosition.isEqual(t.targetPosition);
      if (o && ("insertAtSource" == n.baRelation || "splitBefore" == n.abRelation)) return e.howMany += t.howMany, e.splitPosition = e.splitPosition._getTransformedByDeletion(t.sourcePosition, t.howMany), e.insertionPosition = qd.getInsertionPosition(e.splitPosition), [e];
      if (o && n.abRelation && n.abRelation.howMany) {
        const {
          howMany: t,
          offset: i
        } = n.abRelation;
        return e.howMany += t, e.splitPosition = e.splitPosition.getShiftedBy(i), [e];
      }
      if (e.splitPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(e.splitPosition)) {
        const n = t.howMany - (e.splitPosition.offset - t.sourcePosition.offset);
        return e.howMany -= n, e.splitPosition.hasSameParentAs(t.targetPosition) && e.splitPosition.offset < t.targetPosition.offset && (e.howMany += t.howMany), e.splitPosition = t.sourcePosition.clone(), e.insertionPosition = qd.getInsertionPosition(e.splitPosition), [e];
      }
      return t.sourcePosition.isEqual(t.targetPosition) || (e.splitPosition.hasSameParentAs(t.sourcePosition) && e.splitPosition.offset <= t.sourcePosition.offset && (e.howMany -= t.howMany), e.splitPosition.hasSameParentAs(t.targetPosition) && e.splitPosition.offset < t.targetPosition.offset && (e.howMany += t.howMany)), e.splitPosition.stickiness = "toNone", e.splitPosition = e.splitPosition._getTransformedByMoveOperation(t), e.splitPosition.stickiness = "toNext", e.graveyardPosition ? e.insertionPosition = e.insertionPosition._getTransformedByMoveOperation(t) : e.insertionPosition = qd.getInsertionPosition(e.splitPosition), [e];
    }), nu(qd, qd, (e, t, n) => {
      if (e.splitPosition.isEqual(t.splitPosition)) {
        if (!e.graveyardPosition && !t.graveyardPosition) return [new $d(0)];
        if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) return [new $d(0)];
        if ("splitBefore" == n.abRelation) return e.howMany = 0, e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t), [e];
      }
      if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) {
        const i = "$graveyard" == e.splitPosition.root.rootName,
          o = "$graveyard" == t.splitPosition.root.rootName;
        if (o && !i || !(i && !o) && n.aIsStrong) {
          const n = [];
          return t.howMany && n.push(new Hd(t.moveTargetPosition, t.howMany, t.splitPosition, 0)), e.howMany && n.push(new Hd(e.splitPosition, e.howMany, e.moveTargetPosition, 0)), n;
        }
        return [new $d(0)];
      }
      if (e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t)), e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.abRelation) return e.howMany++, [e];
      if (t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.baRelation) {
        const n = t.insertionPosition.path.slice();
        n.push(0);
        const i = new oc(t.insertionPosition.root, n);
        return [e, new Hd(e.insertionPosition, 1, i, 0)];
      }
      return e.splitPosition.hasSameParentAs(t.splitPosition) && e.splitPosition.offset < t.splitPosition.offset && (e.howMany -= t.howMany), e.splitPosition = e.splitPosition._getTransformedBySplitOperation(t), e.insertionPosition = qd.getInsertionPosition(e.splitPosition), [e];
    });
    class hu extends T(oc) {
      constructor(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        if (super(e, t, n), !this.root.is("rootElement")) throw new _("model-liveposition-root-not-rootelement", e);
        mu.call(this);
      }
      detach() {
        this.stopListening();
      }
      toPosition() {
        return new oc(this.root, this.path.slice(), this.stickiness);
      }
      static fromPosition(e, t) {
        return new this(e.root, e.path.slice(), t || e.stickiness);
      }
    }
    function mu() {
      this.listenTo(this.root.document.model, "applyOperation", (e, t) => {
        const n = t[0];
        n.isDocumentOperation && pu.call(this, n);
      }, {
        priority: "low"
      });
    }
    function pu(e) {
      const t = this.getTransformedByOperation(e);
      if (!this.isEqual(t)) {
        const e = this.toPosition();
        this.path = t.path, this.root = t.root, this.fire("change", e);
      }
    }
    hu.prototype.is = function (e) {
      return "livePosition" === e || "model:livePosition" === e || "position" == e || "model:position" === e;
    };
    class gu {
      constructor() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        "string" == typeof e && (e = "transparent" === e ? {
          isUndoable: !1
        } : {}, w("batch-constructor-deprecated-string-type"));
        const {
          isUndoable: t = !0,
          isLocal: n = !0,
          isUndo: i = !1,
          isTyping: o = !1
        } = e;
        this.operations = [], this.isUndoable = t, this.isLocal = n, this.isUndo = i, this.isTyping = o;
      }
      get type() {
        return w("batch-type-deprecated"), "default";
      }
      get baseVersion() {
        for (const e of this.operations) if (null !== e.baseVersion) return e.baseVersion;
        return null;
      }
      addOperation(e) {
        return e.batch = this, this.operations.push(e), e;
      }
    }
    class fu {
      constructor(e) {
        this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changedRoots = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null, this._refreshedItems = new Set(), this._markerCollection = e;
      }
      get isEmpty() {
        return 0 == this._changesInElement.size && 0 == this._changedMarkers.size && 0 == this._changedRoots.size;
      }
      bufferOperation(e) {
        const t = e;
        switch (t.type) {
          case "insert":
            if (this._isInInsertedElement(t.position.parent)) return;
            this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);
            break;
          case "addAttribute":
          case "removeAttribute":
          case "changeAttribute":
            for (const e of t.range.getItems({
              shallow: !0
            })) this._isInInsertedElement(e.parent) || this._markAttribute(e);
            break;
          case "remove":
          case "move":
          case "reinsert":
            {
              if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) return;
              const e = this._isInInsertedElement(t.sourcePosition.parent),
                n = this._isInInsertedElement(t.targetPosition.parent);
              e || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), n || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
              break;
            }
          case "rename":
            {
              if (this._isInInsertedElement(t.position.parent)) return;
              this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);
              const e = dc._createFromPositionAndShift(t.position, 1);
              for (const t of this._markerCollection.getMarkersIntersectingRange(e)) {
                const e = t.getData();
                this.bufferMarkerChange(t.name, e, e);
              }
              break;
            }
          case "split":
            {
              const e = t.splitPosition.parent;
              this._isInInsertedElement(e) || this._markRemove(e, t.splitPosition.offset, t.howMany), this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
              break;
            }
          case "merge":
            {
              const e = t.sourcePosition.parent;
              this._isInInsertedElement(e.parent) || this._markRemove(e.parent, e.startOffset, 1);
              const n = t.graveyardPosition.parent;
              this._markInsert(n, t.graveyardPosition.offset, 1);
              const i = t.targetPosition.parent;
              this._isInInsertedElement(i) || this._markInsert(i, t.targetPosition.offset, e.maxOffset);
              break;
            }
          case "detachRoot":
          case "addRoot":
            {
              const e = t.affectedSelectable;
              if (!e._isLoaded) return;
              if (e.isAttached() == t.isAdd) return;
              this._bufferRootStateChange(t.rootName, t.isAdd);
              break;
            }
          case "addRootAttribute":
          case "removeRootAttribute":
          case "changeRootAttribute":
            {
              if (!t.root._isLoaded) return;
              const e = t.root.rootName;
              this._bufferRootAttributeChange(e, t.key, t.oldValue, t.newValue);
              break;
            }
        }
        this._cachedChanges = null;
      }
      bufferMarkerChange(e, t, n) {
        t.range && t.range.root.is("rootElement") && !t.range.root._isLoaded && (t.range = null), n.range && n.range.root.is("rootElement") && !n.range.root._isLoaded && (n.range = null);
        let i = this._changedMarkers.get(e);
        i ? i.newMarkerData = n : (i = {
          newMarkerData: n,
          oldMarkerData: t
        }, this._changedMarkers.set(e, i)), null == i.oldMarkerData.range && null == n.range && this._changedMarkers.delete(e);
      }
      getMarkersToRemove() {
        const e = [];
        for (const [t, n] of this._changedMarkers) null != n.oldMarkerData.range && e.push({
          name: t,
          range: n.oldMarkerData.range
        });
        return e;
      }
      getMarkersToAdd() {
        const e = [];
        for (const [t, n] of this._changedMarkers) null != n.newMarkerData.range && e.push({
          name: t,
          range: n.newMarkerData.range
        });
        return e;
      }
      getChangedMarkers() {
        return Array.from(this._changedMarkers).map(_ref27 => {
          let [e, t] = _ref27;
          return {
            name: e,
            data: {
              oldRange: t.oldMarkerData.range,
              newRange: t.newMarkerData.range
            }
          };
        });
      }
      hasDataChanges() {
        if (this.getChanges().length) return !0;
        if (this._changedRoots.size > 0) return !0;
        for (const {
          newMarkerData: e,
          oldMarkerData: t
        } of this._changedMarkers.values()) {
          if (e.affectsData !== t.affectsData) return !0;
          if (e.affectsData) {
            const n = e.range && !t.range,
              i = !e.range && t.range,
              o = e.range && t.range && !e.range.isEqual(t.range);
            if (n || i || o) return !0;
          }
        }
        return !1;
      }
      getChanges() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this._cachedChanges) return e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
        let t = [];
        for (const e of this._changesInElement.keys()) {
          const n = this._changesInElement.get(e).sort((e, t) => e.offset === t.offset ? e.type != t.type ? "remove" == e.type ? -1 : 1 : 0 : e.offset < t.offset ? -1 : 1),
            i = this._elementSnapshots.get(e),
            o = ku(e.getChildren()),
            r = bu(i.length, n);
          let s = 0,
            a = 0;
          for (const n of r) if ("i" === n) t.push(this._getInsertDiff(e, s, o[s])), s++;else if ("r" === n) t.push(this._getRemoveDiff(e, s, i[a])), a++;else if ("a" === n) {
            const n = o[s].attributes,
              r = i[a].attributes;
            let l;
            if ("$text" == o[s].name) l = new dc(oc._createAt(e, s), oc._createAt(e, s + 1));else {
              const t = e.offsetToIndex(s);
              l = new dc(oc._createAt(e, s), oc._createAt(e.getChild(t), 0));
            }
            t.push(...this._getAttributesDiff(l, r, n)), s++, a++;
          } else s++, a++;
        }
        t.sort((e, t) => e.position.root != t.position.root ? e.position.root.rootName < t.position.root.rootName ? -1 : 1 : e.position.isEqual(t.position) ? e.changeCount - t.changeCount : e.position.isBefore(t.position) ? -1 : 1);
        for (let e = 1, n = 0; e < t.length; e++) {
          const i = t[n],
            o = t[e],
            r = "remove" == i.type && "remove" == o.type && "$text" == i.name && "$text" == o.name && i.position.isEqual(o.position),
            s = "insert" == i.type && "insert" == o.type && "$text" == i.name && "$text" == o.name && i.position.parent == o.position.parent && i.position.offset + i.length == o.position.offset,
            a = "attribute" == i.type && "attribute" == o.type && i.position.parent == o.position.parent && i.range.isFlat && o.range.isFlat && i.position.offset + i.length == o.position.offset && i.attributeKey == o.attributeKey && i.attributeOldValue == o.attributeOldValue && i.attributeNewValue == o.attributeNewValue;
          r || s || a ? (i.length++, a && (i.range.end = i.range.end.getShiftedBy(1)), t[e] = null) : n = e;
        }
        t = t.filter(e => e);
        for (const e of t) delete e.changeCount, "attribute" == e.type && (delete e.position, delete e.length);
        return this._changeCount = 0, this._cachedChangesWithGraveyard = t, this._cachedChanges = t.filter(_u), e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
      }
      getChangedRoots() {
        return Array.from(this._changedRoots.values()).map(e => {
          const t = {
            ...e
          };
          return void 0 !== t.state && delete t.attributes, t;
        });
      }
      getRefreshedItems() {
        return new Set(this._refreshedItems);
      }
      reset() {
        this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._changedRoots.clear(), this._refreshedItems = new Set(), this._cachedChanges = null;
      }
      _bufferRootStateChange(e, t) {
        if (!this._changedRoots.has(e)) return void this._changedRoots.set(e, {
          name: e,
          state: t ? "attached" : "detached"
        });
        const n = this._changedRoots.get(e);
        void 0 !== n.state ? (delete n.state, void 0 === n.attributes && this._changedRoots.delete(e)) : n.state = t ? "attached" : "detached";
      }
      _bufferRootAttributeChange(e, t, n, i) {
        const o = this._changedRoots.get(e) || {
            name: e
          },
          r = o.attributes || {};
        if (r[t]) {
          const e = r[t];
          i === e.oldValue ? delete r[t] : e.newValue = i;
        } else r[t] = {
          oldValue: n,
          newValue: i
        };
        0 === Object.entries(r).length ? (delete o.attributes, void 0 === o.state && this._changedRoots.delete(e)) : (o.attributes = r, this._changedRoots.set(e, o));
      }
      _refreshItem(e) {
        if (this._isInInsertedElement(e.parent)) return;
        this._markRemove(e.parent, e.startOffset, e.offsetSize), this._markInsert(e.parent, e.startOffset, e.offsetSize), this._refreshedItems.add(e);
        const t = dc._createOn(e);
        for (const e of this._markerCollection.getMarkersIntersectingRange(t)) {
          const t = e.getData();
          this.bufferMarkerChange(e.name, t, t);
        }
        this._cachedChanges = null;
      }
      _bufferRootLoad(e) {
        if (e.isAttached()) {
          this._bufferRootStateChange(e.rootName, !0), this._markInsert(e, 0, e.maxOffset);
          for (const t of e.getAttributeKeys()) this._bufferRootAttributeChange(e.rootName, t, null, e.getAttribute(t));
          for (const t of this._markerCollection) if (t.getRange().root == e) {
            const e = t.getData();
            this.bufferMarkerChange(t.name, {
              ...e,
              range: null
            }, e);
          }
        }
      }
      _markInsert(e, t, n) {
        if (e.root.is("rootElement") && !e.root._isLoaded) return;
        const i = {
          type: "insert",
          offset: t,
          howMany: n,
          count: this._changeCount++
        };
        this._markChange(e, i);
      }
      _markRemove(e, t, n) {
        if (e.root.is("rootElement") && !e.root._isLoaded) return;
        const i = {
          type: "remove",
          offset: t,
          howMany: n,
          count: this._changeCount++
        };
        this._markChange(e, i), this._removeAllNestedChanges(e, t, n);
      }
      _markAttribute(e) {
        if (e.root.is("rootElement") && !e.root._isLoaded) return;
        const t = {
          type: "attribute",
          offset: e.startOffset,
          howMany: e.offsetSize,
          count: this._changeCount++
        };
        this._markChange(e.parent, t);
      }
      _markChange(e, t) {
        this._makeSnapshot(e);
        const n = this._getChangesForElement(e);
        this._handleChange(t, n), n.push(t);
        for (let e = 0; e < n.length; e++) n[e].howMany < 1 && (n.splice(e, 1), e--);
      }
      _getChangesForElement(e) {
        let t;
        return this._changesInElement.has(e) ? t = this._changesInElement.get(e) : (t = [], this._changesInElement.set(e, t)), t;
      }
      _makeSnapshot(e) {
        this._elementSnapshots.has(e) || this._elementSnapshots.set(e, ku(e.getChildren()));
      }
      _handleChange(e, t) {
        e.nodesToHandle = e.howMany;
        for (const n of t) {
          const i = e.offset + e.howMany,
            o = n.offset + n.howMany;
          if ("insert" == e.type && ("insert" == n.type && (e.offset <= n.offset ? n.offset += e.howMany : e.offset < o && (n.howMany += e.nodesToHandle, e.nodesToHandle = 0)), "remove" == n.type && e.offset < n.offset && (n.offset += e.howMany), "attribute" == n.type)) if (e.offset <= n.offset) n.offset += e.howMany;else if (e.offset < o) {
            const o = n.howMany;
            n.howMany = e.offset - n.offset, t.unshift({
              type: "attribute",
              offset: i,
              howMany: o - n.howMany,
              count: this._changeCount++
            });
          }
          if ("remove" == e.type) {
            if ("insert" == n.type) if (i <= n.offset) n.offset -= e.howMany;else if (i <= o) {
              if (e.offset < n.offset) {
                const t = i - n.offset;
                n.offset = e.offset, n.howMany -= t, e.nodesToHandle -= t;
              } else n.howMany -= e.nodesToHandle, e.nodesToHandle = 0;
            } else if (e.offset <= n.offset) e.nodesToHandle -= n.howMany, n.howMany = 0;else if (e.offset < o) {
              const t = o - e.offset;
              n.howMany -= t, e.nodesToHandle -= t;
            }
            if ("remove" == n.type && (i <= n.offset ? n.offset -= e.howMany : e.offset < n.offset && (e.nodesToHandle += n.howMany, n.howMany = 0)), "attribute" == n.type) if (i <= n.offset) n.offset -= e.howMany;else if (e.offset < n.offset) {
              const t = i - n.offset;
              n.offset = e.offset, n.howMany -= t;
            } else if (e.offset < o) if (i <= o) {
              const i = n.howMany;
              n.howMany = e.offset - n.offset;
              const o = i - n.howMany - e.nodesToHandle;
              t.unshift({
                type: "attribute",
                offset: e.offset,
                howMany: o,
                count: this._changeCount++
              });
            } else n.howMany -= o - e.offset;
          }
          if ("attribute" == e.type) {
            if ("insert" == n.type) if (e.offset < n.offset && i > n.offset) {
              if (i > o) {
                const e = {
                  type: "attribute",
                  offset: o,
                  howMany: i - o,
                  count: this._changeCount++
                };
                this._handleChange(e, t), t.push(e);
              }
              e.nodesToHandle = n.offset - e.offset, e.howMany = e.nodesToHandle;
            } else e.offset >= n.offset && e.offset < o && (i > o ? (e.nodesToHandle = i - o, e.offset = o) : e.nodesToHandle = 0);
            if ("remove" == n.type && e.offset < n.offset && i > n.offset) {
              const o = {
                type: "attribute",
                offset: n.offset,
                howMany: i - n.offset,
                count: this._changeCount++
              };
              this._handleChange(o, t), t.push(o), e.nodesToHandle = n.offset - e.offset, e.howMany = e.nodesToHandle;
            }
            "attribute" == n.type && (e.offset >= n.offset && i <= o ? (e.nodesToHandle = 0, e.howMany = 0, e.offset = 0) : e.offset <= n.offset && i >= o && (n.howMany = 0));
          }
        }
        e.howMany = e.nodesToHandle, delete e.nodesToHandle;
      }
      _getInsertDiff(e, t, n) {
        return {
          type: "insert",
          position: oc._createAt(e, t),
          name: n.name,
          attributes: new Map(n.attributes),
          length: 1,
          changeCount: this._changeCount++,
          _element: n.element
        };
      }
      _getRemoveDiff(e, t, n) {
        return {
          type: "remove",
          position: oc._createAt(e, t),
          name: n.name,
          attributes: new Map(n.attributes),
          length: 1,
          changeCount: this._changeCount++,
          _element: n.element
        };
      }
      _getAttributesDiff(e, t, n) {
        const i = [];
        n = new Map(n);
        for (const [o, r] of t) {
          const t = n.has(o) ? n.get(o) : null;
          t !== r && i.push({
            type: "attribute",
            position: e.start,
            range: e.clone(),
            length: 1,
            attributeKey: o,
            attributeOldValue: r,
            attributeNewValue: t,
            changeCount: this._changeCount++
          }), n.delete(o);
        }
        for (const [t, o] of n) i.push({
          type: "attribute",
          position: e.start,
          range: e.clone(),
          length: 1,
          attributeKey: t,
          attributeOldValue: null,
          attributeNewValue: o,
          changeCount: this._changeCount++
        });
        return i;
      }
      _isInInsertedElement(e) {
        const t = e.parent;
        if (!t) return !1;
        const n = this._changesInElement.get(t),
          i = e.startOffset;
        if (n) for (const e of n) if ("insert" == e.type && i >= e.offset && i < e.offset + e.howMany) return !0;
        return this._isInInsertedElement(t);
      }
      _removeAllNestedChanges(e, t, n) {
        const i = new dc(oc._createAt(e, t), oc._createAt(e, t + n));
        for (const e of i.getItems({
          shallow: !0
        })) e.is("element") && (this._elementSnapshots.delete(e), this._changesInElement.delete(e), this._removeAllNestedChanges(e, 0, e.maxOffset));
      }
    }
    function ku(e) {
      const t = [];
      for (const n of e) if (n.is("$text")) for (let e = 0; e < n.data.length; e++) t.push({
        name: "$text",
        attributes: new Map(n.getAttributes())
      });else t.push({
        name: n.name,
        attributes: new Map(n.getAttributes()),
        element: n
      });
      return t;
    }
    function bu(e, t) {
      const n = [];
      let i = 0,
        o = 0;
      for (const e of t) {
        if (e.offset > i) {
          for (let t = 0; t < e.offset - i; t++) n.push("e");
          o += e.offset - i;
        }
        if ("insert" == e.type) {
          for (let t = 0; t < e.howMany; t++) n.push("i");
          i = e.offset + e.howMany;
        } else if ("remove" == e.type) {
          for (let t = 0; t < e.howMany; t++) n.push("r");
          i = e.offset, o += e.howMany;
        } else n.push(..."a".repeat(e.howMany).split("")), i = e.offset + e.howMany, o += e.howMany;
      }
      if (o < e) for (let t = 0; t < e - o - i; t++) n.push("e");
      return n;
    }
    function _u(e) {
      const t = "position" in e && "$graveyard" == e.position.root.rootName,
        n = "range" in e && "$graveyard" == e.range.root.rootName;
      return !t && !n;
    }
    class wu {
      constructor() {
        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set(), this._baseVersionToOperationIndex = new Map(), this._version = 0, this._gaps = new Map();
      }
      get version() {
        return this._version;
      }
      set version(e) {
        this._operations.length && e > this._version + 1 && this._gaps.set(this._version, e), this._version = e;
      }
      get lastOperation() {
        return this._operations[this._operations.length - 1];
      }
      addOperation(e) {
        if (e.baseVersion !== this.version) throw new _("model-document-history-addoperation-incorrect-version", this, {
          operation: e,
          historyVersion: this.version
        });
        this._operations.push(e), this._version++, this._baseVersionToOperationIndex.set(e.baseVersion, this._operations.length - 1);
      }
      getOperations(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.version;
        if (!this._operations.length) return [];
        const n = this._operations[0];
        void 0 === e && (e = n.baseVersion);
        let i = t - 1;
        for (const [t, n] of this._gaps) e > t && e < n && (e = n), i > t && i < n && (i = t - 1);
        if (i < n.baseVersion || e > this.lastOperation.baseVersion) return [];
        let o = this._baseVersionToOperationIndex.get(e);
        void 0 === o && (o = 0);
        let r = this._baseVersionToOperationIndex.get(i);
        return void 0 === r && (r = this._operations.length - 1), this._operations.slice(o, r + 1);
      }
      getOperation(e) {
        const t = this._baseVersionToOperationIndex.get(e);
        if (void 0 !== t) return this._operations[t];
      }
      setOperationAsUndone(e, t) {
        this._undoPairs.set(t, e), this._undoneOperations.add(e);
      }
      isUndoingOperation(e) {
        return this._undoPairs.has(e);
      }
      isUndoneOperation(e) {
        return this._undoneOperations.has(e);
      }
      getUndoneOperation(e) {
        return this._undoPairs.get(e);
      }
      reset() {
        this._version = 0, this._undoPairs = new Map(), this._operations = [], this._undoneOperations = new Set(), this._gaps = new Map(), this._baseVersionToOperationIndex = new Map();
      }
    }
    class Au extends tc {
      constructor(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";
        super(t), this._isAttached = !0, this._isLoaded = !0, this._document = e, this.rootName = n;
      }
      get document() {
        return this._document;
      }
      isAttached() {
        return this._isAttached;
      }
      toJSON() {
        return this.rootName;
      }
    }
    Au.prototype.is = function (e, t) {
      return t ? t === this.name && ("rootElement" === e || "model:rootElement" === e || "element" === e || "model:element" === e) : "rootElement" === e || "model:rootElement" === e || "element" === e || "model:element" === e || "node" === e || "model:node" === e;
    };
    const vu = "$graveyard";
    class Cu extends T() {
      constructor(e) {
        super(), this.model = e, this.history = new wu(), this.selection = new Dc(this), this.roots = new qo({
          idProperty: "rootName"
        }), this.differ = new fu(e.markers), this.isReadOnly = !1, this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", vu), this.listenTo(e, "applyOperation", (e, t) => {
          const n = t[0];
          n.isDocumentOperation && this.differ.bufferOperation(n);
        }, {
          priority: "high"
        }), this.listenTo(e, "applyOperation", (e, t) => {
          const n = t[0];
          n.isDocumentOperation && this.history.addOperation(n);
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", () => {
          this._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(e.markers, "update", (e, t, n, i, o) => {
          const r = {
            ...t.getData(),
            range: i
          };
          this.differ.bufferMarkerChange(t.name, o, r), null === n && t.on("change", (e, n) => {
            const i = t.getData();
            this.differ.bufferMarkerChange(t.name, {
              ...i,
              range: n
            }, i);
          });
        }), this.registerPostFixer(e => {
          let t = !1;
          for (const n of this.roots) n.isAttached() || n.isEmpty || (e.remove(e.createRangeIn(n)), t = !0);
          for (const n of this.model.markers) n.getRange().root.isAttached() || (e.removeMarker(n), t = !0);
          return t;
        });
      }
      get version() {
        return this.history.version;
      }
      set version(e) {
        this.history.version = e;
      }
      get graveyard() {
        return this.getRoot(vu);
      }
      createRoot() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
        if (this.roots.get(t)) throw new _("model-document-createroot-name-exists", this, {
          name: t
        });
        const n = new Au(this, e, t);
        return this.roots.add(n), n;
      }
      destroy() {
        this.selection.destroy(), this.stopListening();
      }
      getRoot() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this.roots.get(e);
      }
      getRootNames() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        return this.getRoots(e).map(e => e.rootName);
      }
      getRoots() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        return this.roots.filter(t => t != this.graveyard && (e || t.isAttached()) && t._isLoaded);
      }
      registerPostFixer(e) {
        this._postFixers.add(e);
      }
      toJSON() {
        const e = Qr(this);
        return e.selection = "[engine.model.DocumentSelection]", e.model = "[engine.model.Model]", e;
      }
      _handleChangeBlock(e) {
        this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(e), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", e.batch) : this.fire("change", e.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
      }
      _hasDocumentChangedFromTheLastChangeBlock() {
        return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
      }
      _getDefaultRoot() {
        const e = this.getRoots();
        return e.length ? e[0] : this.graveyard;
      }
      _getDefaultRange() {
        const e = this._getDefaultRoot(),
          t = this.model,
          n = t.schema,
          i = t.createPositionFromPath(e, [0]);
        return n.getNearestSelectionRange(i) || t.createRange(i);
      }
      _validateSelectionRange(e) {
        return yu(e.start) && yu(e.end);
      }
      _callPostFixers(e) {
        let t = !1;
        do {
          for (const n of this._postFixers) if (this.selection.refresh(), t = n(e), t) break;
        } while (t);
      }
    }
    function yu(e) {
      const t = e.textNode;
      if (t) {
        const n = t.data,
          i = e.offset - t.startOffset;
        return !Zo(n, i) && !Qo(n, i);
      }
      return !0;
    }
    class xu extends T() {
      constructor() {
        super(...arguments), this._markers = new Map();
      }
      [Symbol.iterator]() {
        return this._markers.values();
      }
      has(e) {
        const t = e instanceof Eu ? e.name : e;
        return this._markers.has(t);
      }
      get(e) {
        return this._markers.get(e) || null;
      }
      _set(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        const o = e instanceof Eu ? e.name : e;
        if (o.includes(",")) throw new _("markercollection-incorrect-marker-name", this);
        const r = this._markers.get(o);
        if (r) {
          const e = r.getData(),
            s = r.getRange();
          let a = !1;
          return s.isEqual(t) || (r._attachLiveRange(yc.fromRange(t)), a = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, a = !0), "boolean" == typeof i && i != r.affectsData && (r._affectsData = i, a = !0), a && this.fire("update:".concat(o), r, s, t, e), r;
        }
        const s = yc.fromRange(t),
          a = new Eu(o, s, n, i);
        return this._markers.set(o, a), this.fire("update:".concat(o), a, null, t, {
          ...a.getData(),
          range: null
        }), a;
      }
      _remove(e) {
        const t = e instanceof Eu ? e.name : e,
          n = this._markers.get(t);
        return !!n && (this._markers.delete(t), this.fire("update:".concat(t), n, n.getRange(), null, n.getData()), this._destroyMarker(n), !0);
      }
      _refresh(e) {
        const t = e instanceof Eu ? e.name : e,
          n = this._markers.get(t);
        if (!n) throw new _("markercollection-refresh-marker-not-exists", this);
        const i = n.getRange();
        this.fire("update:".concat(t), n, i, i, n.getData());
      }
      *getMarkersAtPosition(e) {
        for (const t of this) t.getRange().containsPosition(e) && (yield t);
      }
      *getMarkersIntersectingRange(e) {
        for (const t of this) null !== t.getRange().getIntersection(e) && (yield t);
      }
      destroy() {
        for (const e of this._markers.values()) this._destroyMarker(e);
        this._markers = null, this.stopListening();
      }
      *getMarkersGroup(e) {
        for (const t of this._markers.values()) t.name.startsWith(e + ":") && (yield t);
      }
      _destroyMarker(e) {
        e.stopListening(), e._detachLiveRange();
      }
    }
    class Eu extends T(Zl) {
      constructor(e, t, n, i) {
        super(), this.name = e, this._liveRange = this._attachLiveRange(t), this._managedUsingOperations = n, this._affectsData = i;
      }
      get managedUsingOperations() {
        if (!this._liveRange) throw new _("marker-destroyed", this);
        return this._managedUsingOperations;
      }
      get affectsData() {
        if (!this._liveRange) throw new _("marker-destroyed", this);
        return this._affectsData;
      }
      getData() {
        return {
          range: this.getRange(),
          affectsData: this.affectsData,
          managedUsingOperations: this.managedUsingOperations
        };
      }
      getStart() {
        if (!this._liveRange) throw new _("marker-destroyed", this);
        return this._liveRange.start.clone();
      }
      getEnd() {
        if (!this._liveRange) throw new _("marker-destroyed", this);
        return this._liveRange.end.clone();
      }
      getRange() {
        if (!this._liveRange) throw new _("marker-destroyed", this);
        return this._liveRange.toRange();
      }
      _attachLiveRange(e) {
        return this._liveRange && this._detachLiveRange(), e.delegate("change:range").to(this), e.delegate("change:content").to(this), this._liveRange = e, e;
      }
      _detachLiveRange() {
        this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
      }
    }
    Eu.prototype.is = function (e) {
      return "marker" === e || "model:marker" === e;
    };
    class Su extends zd {
      constructor(e, t) {
        super(null), this.sourcePosition = e.clone(), this.howMany = t;
      }
      get type() {
        return "detach";
      }
      get affectedSelectable() {
        return null;
      }
      toJSON() {
        const e = super.toJSON();
        return e.sourcePosition = this.sourcePosition.toJSON(), e;
      }
      _validate() {
        if (this.sourcePosition.root.document) throw new _("detach-operation-on-document-node", this);
      }
      _execute() {
        Ld(dc._createFromPositionAndShift(this.sourcePosition, this.howMany));
      }
      static get className() {
        return "DetachOperation";
      }
    }
    class Du extends Zl {
      constructor(e) {
        super(), this.markers = new Map(), this._children = new Jl(), e && this._insertChild(0, e);
      }
      [Symbol.iterator]() {
        return this.getChildren();
      }
      get childCount() {
        return this._children.length;
      }
      get maxOffset() {
        return this._children.maxOffset;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      get nextSibling() {
        return null;
      }
      get previousSibling() {
        return null;
      }
      get root() {
        return this;
      }
      get parent() {
        return null;
      }
      get document() {
        return null;
      }
      isAttached() {
        return !1;
      }
      getAncestors() {
        return [];
      }
      getChild(e) {
        return this._children.getNode(e);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      getChildIndex(e) {
        return this._children.getNodeIndex(e);
      }
      getChildStartOffset(e) {
        return this._children.getNodeStartOffset(e);
      }
      getPath() {
        return [];
      }
      getNodeByPath(e) {
        let t = this;
        for (const n of e) t = t.getChild(t.offsetToIndex(n));
        return t;
      }
      offsetToIndex(e) {
        return this._children.offsetToIndex(e);
      }
      toJSON() {
        const e = [];
        for (const t of this._children) e.push(t.toJSON());
        return e;
      }
      static fromJSON(e) {
        const t = [];
        for (const n of e) n.name ? t.push(tc.fromJSON(n)) : t.push(Xl.fromJSON(n));
        return new Du(t);
      }
      _appendChild(e) {
        this._insertChild(this.childCount, e);
      }
      _insertChild(e, t) {
        const n = function (e) {
          if ("string" == typeof e) return [new Xl(e)];
          X(e) || (e = [e]);
          return Array.from(e).map(e => "string" == typeof e ? new Xl(e) : e instanceof ec ? new Xl(e.data, e.getAttributes()) : e);
        }(t);
        for (const e of n) null !== e.parent && e._remove(), e.parent = this;
        this._children._insertNodes(e, n);
      }
      _removeChildren(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        const n = this._children._removeNodes(e, t);
        for (const e of n) e.parent = null;
        return n;
      }
    }
    Du.prototype.is = function (e) {
      return "documentFragment" === e || "model:documentFragment" === e;
    };
    class Tu {
      constructor(e, t) {
        this.model = e, this.batch = t;
      }
      createText(e, t) {
        return new Xl(e, t);
      }
      createElement(e, t) {
        return new tc(e, t);
      }
      createDocumentFragment() {
        return new Du();
      }
      cloneElement(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        return e._clone(t);
      }
      insert(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (this._assertWriterUsedCorrectly(), e instanceof Xl && "" == e.data) return;
        const i = oc._createAt(t, n);
        if (e.parent) {
          if (zu(e.root, i.root)) return void this.move(dc._createOn(e), i);
          if (e.root.document) throw new _("model-writer-insert-forbidden-move", this);
          this.remove(e);
        }
        const o = i.root.document ? i.root.document.version : null,
          r = new Ud(i, e, o);
        if (e instanceof Xl && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), e instanceof Du) for (const [t, n] of e.markers) {
          const e = oc._createAt(n.root, 0),
            o = {
              range: new dc(n.start._getCombined(e, i), n.end._getCombined(e, i)),
              usingOperation: !0,
              affectsData: !0
            };
          this.model.markers.has(t) ? this.updateMarker(t, o) : this.addMarker(t, o);
        }
      }
      insertText(e, t, n, i) {
        t instanceof Du || t instanceof tc || t instanceof oc ? this.insert(this.createText(e), t, n) : this.insert(this.createText(e, t), n, i);
      }
      insertElement(e, t, n, i) {
        t instanceof Du || t instanceof tc || t instanceof oc ? this.insert(this.createElement(e), t, n) : this.insert(this.createElement(e, t), n, i);
      }
      append(e, t) {
        this.insert(e, t, "end");
      }
      appendText(e, t, n) {
        t instanceof Du || t instanceof tc ? this.insert(this.createText(e), t, "end") : this.insert(this.createText(e, t), n, "end");
      }
      appendElement(e, t, n) {
        t instanceof Du || t instanceof tc ? this.insert(this.createElement(e), t, "end") : this.insert(this.createElement(e, t), n, "end");
      }
      setAttribute(e, t, n) {
        if (this._assertWriterUsedCorrectly(), n instanceof dc) {
          const i = n.getMinimalFlatRanges();
          for (const n of i) Iu(this, e, t, n);
        } else Bu(this, e, t, n);
      }
      setAttributes(e, t) {
        for (const [n, i] of Yo(e)) this.setAttribute(n, i, t);
      }
      removeAttribute(e, t) {
        if (this._assertWriterUsedCorrectly(), t instanceof dc) {
          const n = t.getMinimalFlatRanges();
          for (const t of n) Iu(this, e, null, t);
        } else Bu(this, e, null, t);
      }
      clearAttributes(e) {
        this._assertWriterUsedCorrectly();
        const t = e => {
          for (const t of e.getAttributeKeys()) this.removeAttribute(t, e);
        };
        if (e instanceof dc) for (const n of e.getItems()) t(n);else t(e);
      }
      move(e, t, n) {
        if (this._assertWriterUsedCorrectly(), !(e instanceof dc)) throw new _("writer-move-invalid-range", this);
        if (!e.isFlat) throw new _("writer-move-range-not-flat", this);
        const i = oc._createAt(t, n);
        if (i.isEqual(e.start)) return;
        if (this._addOperationForAffectedMarkers("move", e), !zu(e.root, i.root)) throw new _("writer-move-different-document", this);
        const o = e.root.document ? e.root.document.version : null,
          r = new Hd(e.start, e.end.offset - e.start.offset, i, o);
        this.batch.addOperation(r), this.model.applyOperation(r);
      }
      remove(e) {
        this._assertWriterUsedCorrectly();
        const t = (e instanceof dc ? e : dc._createOn(e)).getMinimalFlatRanges().reverse();
        for (const e of t) this._addOperationForAffectedMarkers("move", e), Pu(e.start, e.end.offset - e.start.offset, this.batch, this.model);
      }
      merge(e) {
        this._assertWriterUsedCorrectly();
        const t = e.nodeBefore,
          n = e.nodeAfter;
        if (this._addOperationForAffectedMarkers("merge", e), !(t instanceof tc)) throw new _("writer-merge-no-element-before", this);
        if (!(n instanceof tc)) throw new _("writer-merge-no-element-after", this);
        e.root.document ? this._merge(e) : this._mergeDetached(e);
      }
      createPositionFromPath(e, t, n) {
        return this.model.createPositionFromPath(e, t, n);
      }
      createPositionAt(e, t) {
        return this.model.createPositionAt(e, t);
      }
      createPositionAfter(e) {
        return this.model.createPositionAfter(e);
      }
      createPositionBefore(e) {
        return this.model.createPositionBefore(e);
      }
      createRange(e, t) {
        return this.model.createRange(e, t);
      }
      createRangeIn(e) {
        return this.model.createRangeIn(e);
      }
      createRangeOn(e) {
        return this.model.createRangeOn(e);
      }
      createSelection() {
        return this.model.createSelection(...arguments);
      }
      _mergeDetached(e) {
        const t = e.nodeBefore,
          n = e.nodeAfter;
        this.move(dc._createIn(n), oc._createAt(t, "end")), this.remove(n);
      }
      _merge(e) {
        const t = oc._createAt(e.nodeBefore, "end"),
          n = oc._createAt(e.nodeAfter, 0),
          i = e.root.document.graveyard,
          o = new oc(i, [0]),
          r = e.root.document.version,
          s = new Gd(n, e.nodeAfter.maxOffset, t, o, r);
        this.batch.addOperation(s), this.model.applyOperation(s);
      }
      rename(e, t) {
        if (this._assertWriterUsedCorrectly(), !(e instanceof tc)) throw new _("writer-rename-not-element-instance", this);
        const n = e.root.document ? e.root.document.version : null,
          i = new Zd(oc._createBefore(e), e.name, t, n);
        this.batch.addOperation(i), this.model.applyOperation(i);
      }
      split(e, t) {
        this._assertWriterUsedCorrectly();
        let n,
          i,
          o = e.parent;
        if (!o.parent) throw new _("writer-split-element-no-parent", this);
        if (t || (t = o.parent), !e.parent.getAncestors({
          includeSelf: !0
        }).includes(t)) throw new _("writer-split-invalid-limit-element", this);
        do {
          const t = o.root.document ? o.root.document.version : null,
            r = o.maxOffset - e.offset,
            s = qd.getInsertionPosition(e),
            a = new qd(e, r, s, null, t);
          this.batch.addOperation(a), this.model.applyOperation(a), n || i || (n = o, i = e.parent.nextSibling), o = (e = this.createPositionAfter(e.parent)).parent;
        } while (o !== t);
        return {
          position: e,
          range: new dc(oc._createAt(n, "end"), oc._createAt(i, 0))
        };
      }
      wrap(e, t) {
        if (this._assertWriterUsedCorrectly(), !e.isFlat) throw new _("writer-wrap-range-not-flat", this);
        const n = t instanceof tc ? t : new tc(t);
        if (n.childCount > 0) throw new _("writer-wrap-element-not-empty", this);
        if (null !== n.parent) throw new _("writer-wrap-element-attached", this);
        this.insert(n, e.start);
        const i = new dc(e.start.getShiftedBy(1), e.end.getShiftedBy(1));
        this.move(i, oc._createAt(n, 0));
      }
      unwrap(e) {
        if (this._assertWriterUsedCorrectly(), null === e.parent) throw new _("writer-unwrap-element-no-parent", this);
        this.move(dc._createIn(e), this.createPositionAfter(e)), this.remove(e);
      }
      addMarker(e, t) {
        if (this._assertWriterUsedCorrectly(), !t || "boolean" != typeof t.usingOperation) throw new _("writer-addmarker-no-usingoperation", this);
        const n = t.usingOperation,
          i = t.range,
          o = void 0 !== t.affectsData && t.affectsData;
        if (this.model.markers.has(e)) throw new _("writer-addmarker-marker-exists", this);
        if (!i) throw new _("writer-addmarker-no-range", this);
        return n ? (Mu(this, e, null, i, o), this.model.markers.get(e)) : this.model.markers._set(e, i, n, o);
      }
      updateMarker(e, t) {
        this._assertWriterUsedCorrectly();
        const n = "string" == typeof e ? e : e.name,
          i = this.model.markers.get(n);
        if (!i) throw new _("writer-updatemarker-marker-not-exists", this);
        if (!t) return w("writer-updatemarker-reconvert-using-editingcontroller", {
          markerName: n
        }), void this.model.markers._refresh(i);
        const o = "boolean" == typeof t.usingOperation,
          r = "boolean" == typeof t.affectsData,
          s = r ? t.affectsData : i.affectsData;
        if (!o && !t.range && !r) throw new _("writer-updatemarker-wrong-options", this);
        const a = i.getRange(),
          l = t.range ? t.range : a;
        o && t.usingOperation !== i.managedUsingOperations ? t.usingOperation ? Mu(this, n, null, l, s) : (Mu(this, n, a, null, s), this.model.markers._set(n, l, void 0, s)) : i.managedUsingOperations ? Mu(this, n, a, l, s) : this.model.markers._set(n, l, void 0, s);
      }
      removeMarker(e) {
        this._assertWriterUsedCorrectly();
        const t = "string" == typeof e ? e : e.name;
        if (!this.model.markers.has(t)) throw new _("writer-removemarker-no-marker", this);
        const n = this.model.markers.get(t);
        if (!n.managedUsingOperations) return void this.model.markers._remove(t);
        Mu(this, t, n.getRange(), null, n.affectsData);
      }
      addRoot(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
        this._assertWriterUsedCorrectly();
        const n = this.model.document.getRoot(e);
        if (n && n.isAttached()) throw new _("writer-addroot-root-exists", this);
        const i = this.model.document,
          o = new Jd(e, t, !0, i, i.version);
        return this.batch.addOperation(o), this.model.applyOperation(o), this.model.document.getRoot(e);
      }
      detachRoot(e) {
        this._assertWriterUsedCorrectly();
        const t = "string" == typeof e ? this.model.document.getRoot(e) : e;
        if (!t || !t.isAttached()) throw new _("writer-detachroot-no-root", this);
        for (const e of this.model.markers) e.getRange().root === t && this.removeMarker(e);
        for (const e of t.getAttributeKeys()) this.removeAttribute(e, t);
        this.remove(this.createRangeIn(t));
        const n = this.model.document,
          i = new Jd(t.rootName, t.name, !1, n, n.version);
        this.batch.addOperation(i), this.model.applyOperation(i);
      }
      setSelection() {
        this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(...arguments);
      }
      setSelectionFocus(e, t) {
        this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(e, t);
      }
      setSelectionAttribute(e, t) {
        if (this._assertWriterUsedCorrectly(), "string" == typeof e) this._setSelectionAttribute(e, t);else for (const [t, n] of Yo(e)) this._setSelectionAttribute(t, n);
      }
      removeSelectionAttribute(e) {
        if (this._assertWriterUsedCorrectly(), "string" == typeof e) this._removeSelectionAttribute(e);else for (const t of e) this._removeSelectionAttribute(t);
      }
      overrideSelectionGravity() {
        return this.model.document.selection._overrideGravity();
      }
      restoreSelectionGravity(e) {
        this.model.document.selection._restoreGravity(e);
      }
      _setSelectionAttribute(e, t) {
        const n = this.model.document.selection;
        if (n.isCollapsed && n.anchor.parent.isEmpty) {
          const i = Dc._getStoreAttributeKey(e);
          this.setAttribute(i, t, n.anchor.parent);
        }
        n._setAttribute(e, t);
      }
      _removeSelectionAttribute(e) {
        const t = this.model.document.selection;
        if (t.isCollapsed && t.anchor.parent.isEmpty) {
          const n = Dc._getStoreAttributeKey(e);
          this.removeAttribute(n, t.anchor.parent);
        }
        t._removeAttribute(e);
      }
      _assertWriterUsedCorrectly() {
        if (this.model._currentWriter !== this) throw new _("writer-incorrect-use", this);
      }
      _addOperationForAffectedMarkers(e, t) {
        for (const n of this.model.markers) {
          if (!n.managedUsingOperations) continue;
          const i = n.getRange();
          let o = !1;
          if ("move" === e) {
            const e = t;
            o = e.containsPosition(i.start) || e.start.isEqual(i.start) || e.containsPosition(i.end) || e.end.isEqual(i.end);
          } else {
            const e = t,
              n = e.nodeBefore,
              r = e.nodeAfter,
              s = i.start.parent == n && i.start.isAtEnd,
              a = i.end.parent == r && 0 == i.end.offset,
              l = i.end.nodeAfter == r,
              c = i.start.nodeAfter == r;
            o = s || a || l || c;
          }
          o && this.updateMarker(n.name, {
            range: i
          });
        }
      }
    }
    function Iu(e, t, n, i) {
      const o = e.model,
        r = o.document;
      let s,
        a,
        l,
        c = i.start;
      for (const e of i.getWalker({
        shallow: !0
      })) l = e.item.getAttribute(t), s && a != l && (a != n && d(), c = s), s = e.nextPosition, a = l;
      function d() {
        const i = new dc(c, s),
          l = i.root.document ? r.version : null,
          d = new Yd(i, t, a, n, l);
        e.batch.addOperation(d), o.applyOperation(d);
      }
      s instanceof oc && s != c && a != n && d();
    }
    function Bu(e, t, n, i) {
      const o = e.model,
        r = o.document,
        s = i.getAttribute(t);
      let a, l;
      if (s != n) {
        if (i.root === i) {
          const e = i.document ? r.version : null;
          l = new Qd(i, t, s, n, e);
        } else {
          a = new dc(oc._createBefore(i), e.createPositionAfter(i));
          const o = a.root.document ? r.version : null;
          l = new Yd(a, t, s, n, o);
        }
        e.batch.addOperation(l), o.applyOperation(l);
      }
    }
    function Mu(e, t, n, i, o) {
      const r = e.model,
        s = r.document,
        a = new Kd(t, n, i, r.markers, !!o, s.version);
      e.batch.addOperation(a), r.applyOperation(a);
    }
    function Pu(e, t, n, i) {
      let o;
      if (e.root.document) {
        const n = i.document,
          r = new oc(n.graveyard, [0]);
        o = new Hd(e, t, r, n.version);
      } else o = new Su(e, t);
      n.addOperation(o), i.applyOperation(o);
    }
    function zu(e, t) {
      return e === t || e instanceof Au && t instanceof Au;
    }
    function Nu(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (t.isCollapsed) return;
      const i = t.getFirstRange();
      if ("$graveyard" == i.root.rootName) return;
      const o = e.schema;
      e.change(e => {
        if (!n.doNotResetEntireContent && function (e, t) {
          const n = e.getLimitElement(t);
          if (!t.containsEntireContent(n)) return !1;
          const i = t.getFirstRange();
          if (i.start.parent == i.end.parent) return !1;
          return e.checkChild(n, "paragraph");
        }(o, t)) return void function (e, t) {
          const n = e.model.schema.getLimitElement(t);
          e.remove(e.createRangeIn(n)), Ou(e, e.createPositionAt(n, 0), t);
        }(e, t);
        const r = {};
        if (!n.doNotAutoparagraph) {
          const e = t.getSelectedElement();
          e && Object.assign(r, o.getAttributesWithProperty(e, "copyOnReplace", !0));
        }
        const [s, a] = function (e) {
          const t = e.root.document.model,
            n = e.start;
          let i = e.end;
          if (t.hasContent(e, {
            ignoreMarkers: !0
          })) {
            const n = function (e) {
              const t = e.parent,
                n = t.root.document.model.schema,
                i = t.getAncestors({
                  parentFirst: !0,
                  includeSelf: !0
                });
              for (const e of i) {
                if (n.isLimit(e)) return null;
                if (n.isBlock(e)) return e;
              }
            }(i);
            if (n && i.isTouching(t.createPositionAt(n, 0))) {
              const n = t.createSelection(e);
              t.modifySelection(n, {
                direction: "backward"
              });
              const o = n.getLastPosition(),
                r = t.createRange(o, i);
              t.hasContent(r, {
                ignoreMarkers: !0
              }) || (i = o);
            }
          }
          return [hu.fromPosition(n, "toPrevious"), hu.fromPosition(i, "toNext")];
        }(i);
        s.isTouching(a) || e.remove(e.createRange(s, a)), n.leaveUnmerged || (!function (e, t, n) {
          const i = e.model;
          if (!Vu(e.model.schema, t, n)) return;
          const [o, r] = function (e, t) {
            const n = e.getAncestors(),
              i = t.getAncestors();
            let o = 0;
            for (; n[o] && n[o] == i[o];) o++;
            return [n[o], i[o]];
          }(t, n);
          if (!o || !r) return;
          !i.hasContent(o, {
            ignoreMarkers: !0
          }) && i.hasContent(r, {
            ignoreMarkers: !0
          }) ? Ru(e, t, n, o.parent) : Lu(e, t, n, o.parent);
        }(e, s, a), o.removeDisallowedAttributes(s.parent.getChildren(), e)), Fu(e, t, s), !n.doNotAutoparagraph && function (e, t) {
          const n = e.checkChild(t, "$text"),
            i = e.checkChild(t, "paragraph");
          return !n && i;
        }(o, s) && Ou(e, s, t, r), s.detach(), a.detach();
      });
    }
    function Lu(e, t, n, i) {
      const o = t.parent,
        r = n.parent;
      if (o != i && r != i) {
        for (t = e.createPositionAfter(o), (n = e.createPositionBefore(r)).isEqual(t) || e.insert(r, t), e.merge(t); n.parent.isEmpty;) {
          const t = n.parent;
          n = e.createPositionBefore(t), e.remove(t);
        }
        Vu(e.model.schema, t, n) && Lu(e, t, n, i);
      }
    }
    function Ru(e, t, n, i) {
      const o = t.parent,
        r = n.parent;
      if (o != i && r != i) {
        for (t = e.createPositionAfter(o), (n = e.createPositionBefore(r)).isEqual(t) || e.insert(o, n); t.parent.isEmpty;) {
          const n = t.parent;
          t = e.createPositionBefore(n), e.remove(n);
        }
        n = e.createPositionBefore(r), function (e, t) {
          const n = t.nodeBefore,
            i = t.nodeAfter;
          n.name != i.name && e.rename(n, i.name);
          e.clearAttributes(n), e.setAttributes(Object.fromEntries(i.getAttributes()), n), e.merge(t);
        }(e, n), Vu(e.model.schema, t, n) && Ru(e, t, n, i);
      }
    }
    function Vu(e, t, n) {
      const i = t.parent,
        o = n.parent;
      return i != o && !e.isLimit(i) && !e.isLimit(o) && function (e, t, n) {
        const i = new dc(e, t);
        for (const e of i.getWalker()) if (n.isLimit(e.item)) return !1;
        return !0;
      }(t, n, e);
    }
    function Ou(e, t, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const o = e.createElement("paragraph");
      e.model.schema.setAllowedAttributes(o, i, e), e.insert(o, t), Fu(e, n, e.createPositionAt(o, 0));
    }
    function Fu(e, t, n) {
      t instanceof Dc ? e.setSelection(n) : t.setTo(n);
    }
    function ju(e, t) {
      const n = [];
      Array.from(e.getItems({
        direction: "backward"
      })).map(e => t.createRangeOn(e)).filter(t => (t.start.isAfter(e.start) || t.start.isEqual(e.start)) && (t.end.isBefore(e.end) || t.end.isEqual(e.end))).forEach(e => {
        n.push(e.start.parent), t.remove(e);
      }), n.forEach(e => {
        let n = e;
        for (; n.parent && n.isEmpty;) {
          const e = t.createRangeOn(n);
          n = n.parent, t.remove(e);
        }
      });
    }
    class Hu {
      constructor(e, t, n) {
        this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null, this._nodeToSelect = null, this.model = e, this.writer = t, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = e.schema, this._documentFragment = t.createDocumentFragment(), this._documentFragmentPosition = t.createPositionAt(this._documentFragment, 0);
      }
      handleNodes(e) {
        for (const t of Array.from(e)) this._handleNode(t);
        this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
      }
      _updateLastNodeFromAutoParagraph(e) {
        const t = this.writer.createPositionAfter(this._lastNode),
          n = this.writer.createPositionAfter(e);
        if (n.isAfter(t)) {
          if (this._lastNode = e, this.position.parent != e || !this.position.isAtEnd) throw new _("insertcontent-invalid-insertion-position", this);
          this.position = n, this._setAffectedBoundaries(this.position);
        }
      }
      getSelectionRange() {
        return this._nodeToSelect ? dc._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
      }
      getAffectedRange() {
        return this._affectedStart ? new dc(this._affectedStart, this._affectedEnd) : null;
      }
      destroy() {
        this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
      }
      _handleNode(e) {
        if (this.schema.isObject(e)) return void this._handleObject(e);
        let t = this._checkAndAutoParagraphToAllowedPosition(e);
        t || (t = this._checkAndSplitToAllowedPosition(e), t) ? (this._appendToFragment(e), this._firstNode || (this._firstNode = e), this._lastNode = e) : this._handleDisallowedNode(e);
      }
      _insertPartialFragment() {
        if (this._documentFragment.isEmpty) return;
        const e = hu.fromPosition(this.position, "toNext");
        this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = e.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = e.toPosition(), e.detach();
      }
      _handleObject(e) {
        this._checkAndSplitToAllowedPosition(e) ? this._appendToFragment(e) : this._tryAutoparagraphing(e);
      }
      _handleDisallowedNode(e) {
        e.is("element") ? this.handleNodes(e.getChildren()) : this._tryAutoparagraphing(e);
      }
      _appendToFragment(e) {
        if (!this.schema.checkChild(this.position, e)) throw new _("insertcontent-wrong-position", this, {
          node: e,
          position: this.position
        });
        this.writer.insert(e, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(e.offsetSize), this.schema.isObject(e) && !this.schema.checkChild(this.position, "$text") ? this._nodeToSelect = e : this._nodeToSelect = null, this._filterAttributesOf.push(e);
      }
      _setAffectedBoundaries(e) {
        this._affectedStart || (this._affectedStart = hu.fromPosition(e, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(e) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = hu.fromPosition(e, "toNext"));
      }
      _mergeOnLeft() {
        const e = this._firstNode;
        if (!(e instanceof tc)) return;
        if (!this._canMergeLeft(e)) return;
        const t = hu._createBefore(e);
        t.stickiness = "toNext";
        const n = hu.fromPosition(this.position, "toNext");
        this._affectedStart.isEqual(t) && (this._affectedStart.detach(), this._affectedStart = hu._createAt(t.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = hu._createAt(t.nodeBefore, "end", "toNext")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
      }
      _mergeOnRight() {
        const e = this._lastNode;
        if (!(e instanceof tc)) return;
        if (!this._canMergeRight(e)) return;
        const t = hu._createAfter(e);
        if (t.stickiness = "toNext", !this.position.isEqual(t)) throw new _("insertcontent-invalid-insertion-position", this);
        this.position = oc._createAt(t.nodeBefore, "end");
        const n = hu.fromPosition(this.position, "toPrevious");
        this._affectedEnd.isEqual(t) && (this._affectedEnd.detach(), this._affectedEnd = hu._createAt(t.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = hu._createAt(t.nodeBefore, 0, "toPrevious")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
      }
      _canMergeLeft(e) {
        const t = e.previousSibling;
        return t instanceof tc && this.canMergeWith.has(t) && this.model.schema.checkMerge(t, e);
      }
      _canMergeRight(e) {
        const t = e.nextSibling;
        return t instanceof tc && this.canMergeWith.has(t) && this.model.schema.checkMerge(e, t);
      }
      _tryAutoparagraphing(e) {
        const t = this.writer.createElement("paragraph");
        this._getAllowedIn(this.position.parent, t) && this.schema.checkChild(t, e) && (t._appendChild(e), this._handleNode(t));
      }
      _checkAndAutoParagraphToAllowedPosition(e) {
        if (this.schema.checkChild(this.position.parent, e)) return !0;
        if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", e)) return !1;
        this._insertPartialFragment();
        const t = this.writer.createElement("paragraph");
        return this.writer.insert(t, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = t, this.position = this.writer.createPositionAt(t, 0), !0;
      }
      _checkAndSplitToAllowedPosition(e) {
        const t = this._getAllowedIn(this.position.parent, e);
        if (!t) return !1;
        for (t != this.position.parent && this._insertPartialFragment(); t != this.position.parent;) if (this.position.isAtStart) {
          const e = this.position.parent;
          this.position = this.writer.createPositionBefore(e), e.isEmpty && e.parent === t && this.writer.remove(e);
        } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
          const e = this.writer.createPositionAfter(this.position.parent);
          this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = e, this.canMergeWith.add(this.position.nodeAfter);
        }
        return !0;
      }
      _getAllowedIn(e, t) {
        return this.schema.checkChild(e, t) ? e : this.schema.isLimit(e) ? null : this._getAllowedIn(e.parent, t);
      }
    }
    function Uu(e, t, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (!e.schema.isObject(t)) throw new _("insertobject-element-not-an-object", e, {
        object: t
      });
      const o = n || e.document.selection;
      let r = o;
      i.findOptimalPosition && e.schema.isBlock(t) && (r = e.createSelection(e.schema.findOptimalInsertionRange(o, i.findOptimalPosition)));
      const s = Go(o.getSelectedBlocks()),
        a = {};
      return s && Object.assign(a, e.schema.getAttributesWithProperty(s, "copyOnReplace", !0)), e.change(n => {
        r.isCollapsed || e.deleteContent(r, {
          doNotAutoparagraph: !0
        });
        let o = t;
        const s = r.anchor.parent;
        !e.schema.checkChild(s, t) && e.schema.checkChild(s, "paragraph") && e.schema.checkChild("paragraph", t) && (o = n.createElement("paragraph"), n.insert(t, o)), e.schema.setAllowedAttributes(o, a, n);
        const l = e.insertContent(o, r);
        return l.isCollapsed || i.setSelection && function (e, t, n, i) {
          const o = e.model;
          if ("on" == n) return void e.setSelection(t, "on");
          if ("after" != n) throw new _("insertobject-invalid-place-parameter-value", o);
          let r = t.nextSibling;
          if (o.schema.isInline(t)) return void e.setSelection(t, "after");
          const s = r && o.schema.checkChild(r, "$text");
          !s && o.schema.checkChild(t.parent, "paragraph") && (r = e.createElement("paragraph"), o.schema.setAllowedAttributes(r, i, e), o.insertContent(r, e.createPositionAfter(t)));
          r && e.setSelection(r, 0);
        }(n, t, i.setSelection, a), l;
      });
    }
    const qu = ' ,.?!:;"-()';
    function Gu(e, t) {
      const {
          isForward: n,
          walker: i,
          unit: o,
          schema: r,
          treatEmojiAsSingleUnit: s
        } = e,
        {
          type: a,
          item: l,
          nextPosition: c
        } = t;
      if ("text" == a) return "word" === e.unit ? function (e, t) {
        let n = e.position.textNode;
        n || (n = t ? e.position.nodeAfter : e.position.nodeBefore);
        for (; n && n.is("$text");) {
          const i = e.position.offset - n.startOffset;
          if (Yu(n, i, t)) n = t ? e.position.nodeAfter : e.position.nodeBefore;else {
            if (Wu(n.data, i, t)) break;
            e.next();
          }
        }
        return e.position;
      }(i, n) : function (e, t, n) {
        const i = e.position.textNode;
        if (i) {
          const o = i.data;
          let r = e.position.offset - i.startOffset;
          for (; Zo(o, r) || "character" == t && Qo(o, r) || n && Xo(o, r);) e.next(), r = e.position.offset - i.startOffset;
        }
        return e.position;
      }(i, o, s);
      if (a == (n ? "elementStart" : "elementEnd")) {
        if (r.isSelectable(l)) return oc._createAt(l, n ? "after" : "before");
        if (r.checkChild(c, "$text")) return c;
      } else {
        if (r.isLimit(l)) return void i.skip(() => !0);
        if (r.checkChild(c, "$text")) return c;
      }
    }
    function Ku(e, t) {
      const n = e.root,
        i = oc._createAt(n, t ? "end" : 0);
      return t ? new dc(e, i) : new dc(i, e);
    }
    function Wu(e, t, n) {
      const i = t + (n ? 0 : -1);
      return qu.includes(e.charAt(i));
    }
    function Yu(e, t, n) {
      return t === (n ? e.offsetSize : 0);
    }
    class $u extends q() {
      constructor() {
        super(), this.markers = new xu(), this.document = new Cu(this), this.schema = new hd(), this._pendingChanges = [], this._currentWriter = null, ["deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(e => this.decorate(e)), this.on("applyOperation", (e, t) => {
          t[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$container", {
          allowIn: ["$root", "$container"]
        }), this.schema.register("$block", {
          allowIn: ["$root", "$container"],
          isBlock: !0
        }), this.schema.register("$blockObject", {
          allowWhere: "$block",
          isBlock: !0,
          isObject: !0
        }), this.schema.register("$inlineObject", {
          allowWhere: "$text",
          allowAttributesOf: "$text",
          isInline: !0,
          isObject: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0,
          isContent: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$documentFragment", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$marker"), this.schema.addChildCheck((e, t) => {
          if ("$marker" === t.name) return !0;
        }), od(this), this.document.registerPostFixer(Yc), this.on("insertContent", (e, _ref28) => {
          let [t, n] = _ref28;
          e.return = function (e, t, n) {
            return e.change(i => {
              const o = n || e.document.selection;
              o.isCollapsed || e.deleteContent(o, {
                doNotAutoparagraph: !0
              });
              const r = new Hu(e, i, o.anchor),
                s = [];
              let a;
              if (t.is("documentFragment")) {
                if (t.markers.size) {
                  const e = [];
                  for (const [n, i] of t.markers) {
                    const {
                        start: t,
                        end: o
                      } = i,
                      r = t.isEqual(o);
                    e.push({
                      position: t,
                      name: n,
                      isCollapsed: r
                    }, {
                      position: o,
                      name: n,
                      isCollapsed: r
                    });
                  }
                  e.sort((_ref29, _ref30) => {
                    let {
                      position: e
                    } = _ref29;
                    let {
                      position: t
                    } = _ref30;
                    return e.isBefore(t) ? 1 : -1;
                  });
                  for (const {
                    position: n,
                    name: o,
                    isCollapsed: r
                  } of e) {
                    let e = null,
                      a = null;
                    const l = n.parent === t && n.isAtStart,
                      c = n.parent === t && n.isAtEnd;
                    l || c ? r && (a = l ? "start" : "end") : (e = i.createElement("$marker"), i.insert(e, n)), s.push({
                      name: o,
                      element: e,
                      collapsed: a
                    });
                  }
                }
                a = t.getChildren();
              } else a = [t];
              r.handleNodes(a);
              let l = r.getSelectionRange();
              if (t.is("documentFragment") && s.length) {
                const e = l ? yc.fromRange(l) : null,
                  t = {};
                for (let e = s.length - 1; e >= 0; e--) {
                  const {
                      name: n,
                      element: o,
                      collapsed: a
                    } = s[e],
                    l = !t[n];
                  if (l && (t[n] = []), o) {
                    const e = i.createPositionAt(o, "before");
                    t[n].push(e), i.remove(o);
                  } else {
                    const e = r.getAffectedRange();
                    if (!e) {
                      a && t[n].push(r.position);
                      continue;
                    }
                    a ? t[n].push(e[a]) : t[n].push(l ? e.start : e.end);
                  }
                }
                for (const [e, [n, o]] of Object.entries(t)) n && o && n.root === o.root && n.root.document && !i.model.markers.has(e) && i.addMarker(e, {
                  usingOperation: !0,
                  affectsData: !0,
                  range: new dc(n, o)
                });
                e && (l = e.toRange(), e.detach());
              }
              l && (o instanceof Dc ? i.setSelection(l) : o.setTo(l));
              const c = r.getAffectedRange() || e.createRange(o.anchor);
              return r.destroy(), c;
            });
          }(this, t, n);
        }), this.on("insertObject", (e, _ref31) => {
          let [t, n, i] = _ref31;
          e.return = Uu(this, t, n, i);
        }), this.on("canEditAt", e => {
          const t = !this.document.isReadOnly;
          e.return = t, t || e.stop();
        });
      }
      change(e) {
        try {
          return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
            batch: new gu(),
            callback: e
          }), this._runPendingChanges()[0]) : e(this._currentWriter);
        } catch (e) {
          _.rethrowUnexpectedError(e, this);
        }
      }
      enqueueChange(e, t) {
        try {
          e ? "function" == typeof e ? (t = e, e = new gu()) : e instanceof gu || (e = new gu(e)) : e = new gu(), this._pendingChanges.push({
            batch: e,
            callback: t
          }), 1 == this._pendingChanges.length && this._runPendingChanges();
        } catch (e) {
          _.rethrowUnexpectedError(e, this);
        }
      }
      applyOperation(e) {
        e._execute();
      }
      insertContent(e, t, n) {
        const o = Zu(t, n);
        for (var _len25 = arguments.length, i = new Array(_len25 > 3 ? _len25 - 3 : 0), _key25 = 3; _key25 < _len25; _key25++) {
          i[_key25 - 3] = arguments[_key25];
        }
        return this.fire("insertContent", [e, o, n, ...i]);
      }
      insertObject(e, t, n, i) {
        const r = Zu(t, n);
        for (var _len26 = arguments.length, o = new Array(_len26 > 4 ? _len26 - 4 : 0), _key26 = 4; _key26 < _len26; _key26++) {
          o[_key26 - 4] = arguments[_key26];
        }
        return this.fire("insertObject", [e, r, i, i, ...o]);
      }
      deleteContent(e, t) {
        Nu(this, e, t);
      }
      modifySelection(e, t) {
        !function (e, t) {
          let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          const i = e.schema,
            o = "backward" != n.direction,
            r = n.unit ? n.unit : "character",
            s = !!n.treatEmojiAsSingleUnit,
            a = t.focus,
            l = new nc({
              boundaries: Ku(a, o),
              singleCharacters: !0,
              direction: o ? "forward" : "backward"
            }),
            c = {
              walker: l,
              schema: i,
              isForward: o,
              unit: r,
              treatEmojiAsSingleUnit: s
            };
          let d;
          for (; d = l.next();) {
            if (d.done) return;
            const n = Gu(c, d.value);
            if (n) return void (t instanceof Dc ? e.change(e => {
              e.setSelectionFocus(n);
            }) : t.setFocus(n));
          }
        }(this, e, t);
      }
      getSelectedContent(e) {
        return function (e, t) {
          return e.change(e => {
            const n = e.createDocumentFragment(),
              i = t.getFirstRange();
            if (!i || i.isCollapsed) return n;
            const o = i.start.root,
              r = i.start.getCommonPath(i.end),
              s = o.getNodeByPath(r);
            let a;
            a = i.start.parent == i.end.parent ? i : e.createRange(e.createPositionAt(s, i.start.path[r.length]), e.createPositionAt(s, i.end.path[r.length] + 1));
            const l = a.end.offset - a.start.offset;
            for (const t of a.getItems({
              shallow: !0
            })) t.is("$textProxy") ? e.appendText(t.data, t.getAttributes(), n) : e.append(e.cloneElement(t, !0), n);
            if (a != i) {
              const t = i._getTransformedByMove(a.start, e.createPositionAt(n, 0), l)[0],
                o = e.createRange(e.createPositionAt(n, 0), t.start);
              ju(e.createRange(t.end, e.createPositionAt(n, "end")), e), ju(o, e);
            }
            return n;
          });
        }(this, e);
      }
      hasContent(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = e instanceof dc ? e : dc._createIn(e);
        if (n.isCollapsed) return !1;
        const {
          ignoreWhitespaces: i = !1,
          ignoreMarkers: o = !1
        } = t;
        if (!o) for (const e of this.markers.getMarkersIntersectingRange(n)) if (e.affectsData) return !0;
        for (const e of n.getItems()) if (this.schema.isContent(e)) {
          if (!e.is("$textProxy")) return !0;
          if (!i) return !0;
          if (-1 !== e.data.search(/\S/)) return !0;
        }
        return !1;
      }
      canEditAt(e) {
        const t = Zu(e);
        return this.fire("canEditAt", [t]);
      }
      createPositionFromPath(e, t, n) {
        return new oc(e, t, n);
      }
      createPositionAt(e, t) {
        return oc._createAt(e, t);
      }
      createPositionAfter(e) {
        return oc._createAfter(e);
      }
      createPositionBefore(e) {
        return oc._createBefore(e);
      }
      createRange(e, t) {
        return new dc(e, t);
      }
      createRangeIn(e) {
        return dc._createIn(e);
      }
      createRangeOn(e) {
        return dc._createOn(e);
      }
      createSelection() {
        for (var _len27 = arguments.length, e = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
          e[_key27] = arguments[_key27];
        }
        return new kc(...e);
      }
      createBatch(e) {
        return new gu(e);
      }
      createOperationFromJSON(e) {
        return eu.fromJSON(e, this.document);
      }
      destroy() {
        this.document.destroy(), this.stopListening();
      }
      _runPendingChanges() {
        const e = [];
        this.fire("_beforeChanges");
        try {
          for (; this._pendingChanges.length;) {
            const t = this._pendingChanges[0].batch;
            this._currentWriter = new Tu(this, t);
            const n = this._pendingChanges[0].callback(this._currentWriter);
            e.push(n), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }
        } finally {
          this._pendingChanges.length = 0, this._currentWriter = null, this.fire("_afterChanges");
        }
        return e;
      }
    }
    function Zu(e, t) {
      if (e) return e instanceof kc || e instanceof Dc ? e : e instanceof Ql ? t || 0 === t ? new kc(e, t) : e.is("rootElement") ? new kc(e, "in") : new kc(e, "on") : new kc(e);
    }
    class Qu extends tl {
      constructor() {
        super(...arguments), this.domEventType = "click";
      }
      onDomEvent(e) {
        this.fire(e.type, e);
      }
    }
    class Ju extends tl {
      constructor() {
        super(...arguments), this.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
      }
      onDomEvent(e) {
        this.fire(e.type, e);
      }
    }
    class Xu {
      constructor(e) {
        this.document = e;
      }
      createDocumentFragment(e) {
        return new ma(this.document, e);
      }
      createElement(e, t, n) {
        return new Ns(this.document, e, t, n);
      }
      createText(e) {
        return new Xr(this.document, e);
      }
      clone(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return e._clone(t);
      }
      appendChild(e, t) {
        return t._appendChild(e);
      }
      insertChild(e, t, n) {
        return n._insertChild(e, t);
      }
      removeChildren(e, t, n) {
        return n._removeChildren(e, t);
      }
      remove(e) {
        const t = e.parent;
        return t ? this.removeChildren(t.getChildIndex(e), 1, t) : [];
      }
      replace(e, t) {
        const n = e.parent;
        if (n) {
          const i = n.getChildIndex(e);
          return this.removeChildren(i, 1, n), this.insertChild(i, t, n), !0;
        }
        return !1;
      }
      unwrapElement(e) {
        const t = e.parent;
        if (t) {
          const n = t.getChildIndex(e);
          this.remove(e), this.insertChild(n, e.getChildren(), t);
        }
      }
      rename(e, t) {
        const n = new Ns(this.document, e, t.getAttributes(), t.getChildren());
        return this.replace(t, n) ? n : null;
      }
      setAttribute(e, t, n) {
        n._setAttribute(e, t);
      }
      removeAttribute(e, t) {
        t._removeAttribute(e);
      }
      addClass(e, t) {
        t._addClass(e);
      }
      removeClass(e, t) {
        t._removeClass(e);
      }
      setStyle(e, t, n) {
        ye(e) && void 0 === n ? t._setStyle(e) : n._setStyle(e, t);
      }
      removeStyle(e, t) {
        t._removeStyle(e);
      }
      setCustomProperty(e, t, n) {
        n._setCustomProperty(e, t);
      }
      removeCustomProperty(e, t) {
        return t._removeCustomProperty(e);
      }
      createPositionAt(e, t) {
        return Us._createAt(e, t);
      }
      createPositionAfter(e) {
        return Us._createAfter(e);
      }
      createPositionBefore(e) {
        return Us._createBefore(e);
      }
      createRange(e, t) {
        return new qs(e, t);
      }
      createRangeOn(e) {
        return qs._createOn(e);
      }
      createRangeIn(e) {
        return qs._createIn(e);
      }
      createSelection() {
        for (var _len28 = arguments.length, e = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
          e[_key28] = arguments[_key28];
        }
        return new Ks(...e);
      }
    }
    const eh = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i,
      th = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i,
      nh = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
      ih = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i,
      oh = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
      rh = /\w+\((?:[^()]|\([^()]*\))*\)|\S+/gi,
      sh = new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "activeborder", "activecaption", "appworkspace", "background", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "captiontext", "graytext", "highlight", "highlighttext", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infobackground", "infotext", "menu", "menutext", "scrollbar", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "window", "windowframe", "windowtext", "rebeccapurple", "currentcolor", "transparent"]);
    function ah(e) {
      return e.startsWith("#") ? eh.test(e) : e.startsWith("rgb") ? th.test(e) || nh.test(e) : e.startsWith("hsl") ? ih.test(e) || oh.test(e) : sh.has(e.toLowerCase());
    }
    const lh = ["none", "hidden", "dotted", "dashed", "solid", "double", "groove", "ridge", "inset", "outset"];
    function ch(e) {
      return lh.includes(e);
    }
    const dh = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
    function uh(e) {
      return dh.test(e);
    }
    const hh = /^[+-]?[0-9]*([.][0-9]+)?%$/;
    function mh(e) {
      return hh.test(e);
    }
    const ph = ["repeat-x", "repeat-y", "repeat", "space", "round", "no-repeat"];
    function gh(e) {
      return ph.includes(e);
    }
    const fh = ["center", "top", "bottom", "left", "right"];
    function kh(e) {
      return fh.includes(e);
    }
    const bh = ["fixed", "scroll", "local"];
    function _h(e) {
      return bh.includes(e);
    }
    const wh = /^url\(/;
    function Ah(e) {
      return wh.test(e);
    }
    function vh() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      if ("" === e) return {
        top: void 0,
        right: void 0,
        bottom: void 0,
        left: void 0
      };
      const t = Eh(e),
        n = t[0],
        i = t[2] || n,
        o = t[1] || n;
      return {
        top: n,
        bottom: i,
        right: o,
        left: t[3] || o
      };
    }
    function Ch(e) {
      return t => {
        const {
            top: n,
            right: i,
            bottom: o,
            left: r
          } = t,
          s = [];
        return [n, i, r, o].every(e => !!e) ? s.push([e, yh(t)]) : (n && s.push([e + "-top", n]), i && s.push([e + "-right", i]), o && s.push([e + "-bottom", o]), r && s.push([e + "-left", r])), s;
      };
    }
    function yh(_ref32) {
      let {
        top: e,
        right: t,
        bottom: n,
        left: i
      } = _ref32;
      const o = [];
      return i !== t ? o.push(e, t, n, i) : n !== e ? o.push(e, t, n) : t !== e ? o.push(e, t) : o.push(e), o.join(" ");
    }
    function xh(e) {
      return t => ({
        path: e,
        value: vh(t)
      });
    }
    function Eh(e) {
      const t = e.matchAll(rh);
      return Array.from(t).map(e => e[0]);
    }
    function Sh(e) {
      e.setNormalizer("background", e => {
        const t = {},
          n = Eh(e);
        for (const e of n) gh(e) ? (t.repeat = t.repeat || [], t.repeat.push(e)) : kh(e) ? (t.position = t.position || [], t.position.push(e)) : _h(e) ? t.attachment = e : ah(e) ? t.color = e : Ah(e) && (t.image = e);
        return {
          path: "background",
          value: t
        };
      }), e.setNormalizer("background-color", e => ({
        path: "background.color",
        value: e
      })), e.setReducer("background", e => {
        const t = [];
        return t.push(["background-color", e.color]), t;
      }), e.setStyleRelation("background", ["background-color"]);
    }
    function Dh(e) {
      e.setNormalizer("border", e => {
        const {
          color: t,
          style: n,
          width: i
        } = Nh(e);
        return {
          path: "border",
          value: {
            color: vh(t),
            style: vh(n),
            width: vh(i)
          }
        };
      }), e.setNormalizer("border-top", Th("top")), e.setNormalizer("border-right", Th("right")), e.setNormalizer("border-bottom", Th("bottom")), e.setNormalizer("border-left", Th("left")), e.setNormalizer("border-color", Ih("color")), e.setNormalizer("border-width", Ih("width")), e.setNormalizer("border-style", Ih("style")), e.setNormalizer("border-top-color", Mh("color", "top")), e.setNormalizer("border-top-style", Mh("style", "top")), e.setNormalizer("border-top-width", Mh("width", "top")), e.setNormalizer("border-right-color", Mh("color", "right")), e.setNormalizer("border-right-style", Mh("style", "right")), e.setNormalizer("border-right-width", Mh("width", "right")), e.setNormalizer("border-bottom-color", Mh("color", "bottom")), e.setNormalizer("border-bottom-style", Mh("style", "bottom")), e.setNormalizer("border-bottom-width", Mh("width", "bottom")), e.setNormalizer("border-left-color", Mh("color", "left")), e.setNormalizer("border-left-style", Mh("style", "left")), e.setNormalizer("border-left-width", Mh("width", "left")), e.setExtractor("border-top", Ph("top")), e.setExtractor("border-right", Ph("right")), e.setExtractor("border-bottom", Ph("bottom")), e.setExtractor("border-left", Ph("left")), e.setExtractor("border-top-color", "border.color.top"), e.setExtractor("border-right-color", "border.color.right"), e.setExtractor("border-bottom-color", "border.color.bottom"), e.setExtractor("border-left-color", "border.color.left"), e.setExtractor("border-top-width", "border.width.top"), e.setExtractor("border-right-width", "border.width.right"), e.setExtractor("border-bottom-width", "border.width.bottom"), e.setExtractor("border-left-width", "border.width.left"), e.setExtractor("border-top-style", "border.style.top"), e.setExtractor("border-right-style", "border.style.right"), e.setExtractor("border-bottom-style", "border.style.bottom"), e.setExtractor("border-left-style", "border.style.left"), e.setReducer("border-color", Ch("border-color")), e.setReducer("border-style", Ch("border-style")), e.setReducer("border-width", Ch("border-width")), e.setReducer("border-top", Lh("top")), e.setReducer("border-right", Lh("right")), e.setReducer("border-bottom", Lh("bottom")), e.setReducer("border-left", Lh("left")), e.setReducer("border", function () {
        return t => {
          const n = zh(t, "top"),
            i = zh(t, "right"),
            o = zh(t, "bottom"),
            r = zh(t, "left"),
            s = [n, i, o, r],
            a = {
              width: e(s, "width"),
              style: e(s, "style"),
              color: e(s, "color")
            },
            l = Rh(a, "all");
          if (l.length) return l;
          const c = Object.entries(a).reduce((e, _ref33) => {
            let [t, n] = _ref33;
            return n && (e.push(["border-".concat(t), n]), s.forEach(e => delete e[t])), e;
          }, []);
          return [...c, ...Rh(n, "top"), ...Rh(i, "right"), ...Rh(o, "bottom"), ...Rh(r, "left")];
        };
        function e(e, t) {
          return e.map(e => e[t]).reduce((e, t) => e == t ? e : null);
        }
      }()), e.setStyleRelation("border", ["border-color", "border-style", "border-width", "border-top", "border-right", "border-bottom", "border-left", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), e.setStyleRelation("border-color", ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"]), e.setStyleRelation("border-style", ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"]), e.setStyleRelation("border-width", ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), e.setStyleRelation("border-top", ["border-top-color", "border-top-style", "border-top-width"]), e.setStyleRelation("border-right", ["border-right-color", "border-right-style", "border-right-width"]), e.setStyleRelation("border-bottom", ["border-bottom-color", "border-bottom-style", "border-bottom-width"]), e.setStyleRelation("border-left", ["border-left-color", "border-left-style", "border-left-width"]);
    }
    function Th(e) {
      return t => {
        const {
            color: n,
            style: i,
            width: o
          } = Nh(t),
          r = {};
        return void 0 !== n && (r.color = {
          [e]: n
        }), void 0 !== i && (r.style = {
          [e]: i
        }), void 0 !== o && (r.width = {
          [e]: o
        }), {
          path: "border",
          value: r
        };
      };
    }
    function Ih(e) {
      return t => ({
        path: "border",
        value: Bh(t, e)
      });
    }
    function Bh(e, t) {
      return {
        [t]: vh(e)
      };
    }
    function Mh(e, t) {
      return n => ({
        path: "border",
        value: {
          [e]: {
            [t]: n
          }
        }
      });
    }
    function Ph(e) {
      return (t, n) => {
        if (n.border) return zh(n.border, e);
      };
    }
    function zh(e, t) {
      const n = {};
      return e.width && e.width[t] && (n.width = e.width[t]), e.style && e.style[t] && (n.style = e.style[t]), e.color && e.color[t] && (n.color = e.color[t]), n;
    }
    function Nh(e) {
      const t = {},
        n = Eh(e);
      for (const e of n) uh(e) || /thin|medium|thick/.test(e) ? t.width = e : ch(e) ? t.style = e : t.color = e;
      return t;
    }
    function Lh(e) {
      return t => Rh(t, e);
    }
    function Rh(e, t) {
      const n = [];
      if (e && e.width && n.push("width"), e && e.style && n.push("style"), e && e.color && n.push("color"), 3 == n.length) {
        const i = n.map(t => e[t]).join(" ");
        return ["all" == t ? ["border", i] : ["border-".concat(t), i]];
      }
      return "all" == t ? [] : n.map(n => ["border-".concat(t, "-").concat(n), e[n]]);
    }
    function Vh(e) {
      e.setNormalizer("padding", xh("padding")), e.setNormalizer("padding-top", e => ({
        path: "padding.top",
        value: e
      })), e.setNormalizer("padding-right", e => ({
        path: "padding.right",
        value: e
      })), e.setNormalizer("padding-bottom", e => ({
        path: "padding.bottom",
        value: e
      })), e.setNormalizer("padding-left", e => ({
        path: "padding.left",
        value: e
      })), e.setReducer("padding", Ch("padding")), e.setStyleRelation("padding", ["padding-top", "padding-right", "padding-bottom", "padding-left"]);
    }
    class Oh {
      constructor() {
        this._commands = new Map();
      }
      add(e, t) {
        this._commands.set(e, t);
      }
      get(e) {
        return this._commands.get(e);
      }
      execute(e) {
        const n = this.get(e);
        if (!n) throw new _("commandcollection-command-not-found", this, {
          commandName: e
        });
        for (var _len29 = arguments.length, t = new Array(_len29 > 1 ? _len29 - 1 : 0), _key29 = 1; _key29 < _len29; _key29++) {
          t[_key29 - 1] = arguments[_key29];
        }
        return n.execute(...t);
      }
      *names() {
        yield* this._commands.keys();
      }
      *commands() {
        yield* this._commands.values();
      }
      [Symbol.iterator]() {
        return this._commands[Symbol.iterator]();
      }
      destroy() {
        for (const e of this.commands()) e.destroy();
      }
    }
    class Fh extends Wo {
      constructor(e) {
        super(), this.editor = e;
      }
      set(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if ("string" == typeof t) {
          const e = t;
          t = (t, n) => {
            this.editor.execute(e), n();
          };
        }
        super.set(e, t, n);
      }
    }
    const jh = "contentEditing",
      Hh = "common";
    class Uh {
      constructor(e) {
        this.keystrokeInfos = new Map(), this._editor = e;
        const t = e.config.get("menuBar.isVisible"),
          n = e.locale.t;
        this.addKeystrokeInfoCategory({
          id: jh,
          label: n("Content editing keystrokes"),
          description: n("These keyboard shortcuts allow for quick access to content editing features.")
        });
        const i = [{
          label: n("Close contextual balloons, dropdowns, and dialogs"),
          keystroke: "Esc"
        }, {
          label: n("Open the accessibility help dialog"),
          keystroke: "Alt+0"
        }, {
          label: n("Move focus between form fields (inputs, buttons, etc.)"),
          keystroke: [["Tab"], ["Shift+Tab"]]
        }, {
          label: n("Move focus to the toolbar, navigate between toolbars"),
          keystroke: "Alt+F10",
          mayRequireFn: !0
        }, {
          label: n("Navigate through the toolbar or menu bar"),
          keystroke: [["arrowup"], ["arrowright"], ["arrowdown"], ["arrowleft"]]
        }, {
          label: n("Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content."),
          keystroke: [["Enter"], ["Space"]]
        }];
        t && i.push({
          label: n("Move focus to the menu bar, navigate between menu bars"),
          keystroke: "Alt+F9",
          mayRequireFn: !0
        }), this.addKeystrokeInfoCategory({
          id: "navigation",
          label: n("User interface and content navigation keystrokes"),
          description: n("Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface."),
          groups: [{
            id: "common",
            keystrokes: i
          }]
        });
      }
      addKeystrokeInfoCategory(_ref34) {
        let {
          id: e,
          label: t,
          description: n,
          groups: i
        } = _ref34;
        this.keystrokeInfos.set(e, {
          id: e,
          label: t,
          description: n,
          groups: new Map()
        }), this.addKeystrokeInfoGroup({
          categoryId: e,
          id: Hh
        }), i && i.forEach(t => {
          this.addKeystrokeInfoGroup({
            categoryId: e,
            ...t
          });
        });
      }
      addKeystrokeInfoGroup(_ref35) {
        let {
          categoryId: e = jh,
          id: t,
          label: n,
          keystrokes: i
        } = _ref35;
        const o = this.keystrokeInfos.get(e);
        if (!o) throw new _("accessibility-unknown-keystroke-info-category", this._editor, {
          groupId: t,
          categoryId: e
        });
        o.groups.set(t, {
          id: t,
          label: n,
          keystrokes: i || []
        });
      }
      addKeystrokeInfos(_ref36) {
        let {
          categoryId: e = jh,
          groupId: t = Hh,
          keystrokes: n
        } = _ref36;
        if (!this.keystrokeInfos.has(e)) throw new _("accessibility-unknown-keystroke-info-category", this._editor, {
          categoryId: e,
          keystrokes: n
        });
        const i = this.keystrokeInfos.get(e);
        if (!i.groups.has(t)) throw new _("accessibility-unknown-keystroke-info-group", this._editor, {
          groupId: t,
          categoryId: e,
          keystrokes: n
        });
        i.groups.get(t).keystrokes.push(...n);
      }
    }
    class qh extends q() {
      constructor() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super();
        const t = this.constructor,
          {
            translations: n,
            ...i
          } = t.defaultConfig || {},
          {
            translations: o = n,
            ...r
          } = e,
          s = e.language || i.language;
        this._context = e.context || new Rr({
          language: s,
          translations: o
        }), this._context._addEditor(this, !e.context);
        const a = Array.from(t.builtinPlugins || []);
        this.config = new vi(r, i), this.config.define("plugins", a), this.config.define(this._context._getEditorConfig()), this.plugins = new Lr(this, a, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this._readOnlyLocks = new Set(), this.commands = new Oh(), this.set("state", "initializing"), this.once("ready", () => this.state = "ready", {
          priority: "high"
        }), this.once("destroy", () => this.state = "destroyed", {
          priority: "high"
        }), this.model = new $u(), this.on("change:isReadOnly", () => {
          this.model.document.isReadOnly = this.isReadOnly;
        });
        const l = new Ms();
        this.data = new Id(this.model, l), this.editing = new ld(this.model, l), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new Bd([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new Fh(this), this.keystrokes.listenTo(this.editing.view.document), this.accessibility = new Uh(this);
      }
      get isReadOnly() {
        return this._readOnlyLocks.size > 0;
      }
      set isReadOnly(e) {
        throw new _("editor-isreadonly-has-no-setter");
      }
      enableReadOnlyMode(e) {
        if ("string" != typeof e && "symbol" != typeof e) throw new _("editor-read-only-lock-id-invalid", null, {
          lockId: e
        });
        this._readOnlyLocks.has(e) || (this._readOnlyLocks.add(e), 1 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", !0, !1));
      }
      disableReadOnlyMode(e) {
        if ("string" != typeof e && "symbol" != typeof e) throw new _("editor-read-only-lock-id-invalid", null, {
          lockId: e
        });
        this._readOnlyLocks.has(e) && (this._readOnlyLocks.delete(e), 0 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", !1, !0));
      }
      setData(e) {
        this.data.set(e);
      }
      getData(e) {
        return this.data.get(e);
      }
      initPlugins() {
        const e = this.config,
          t = e.get("plugins"),
          n = e.get("removePlugins") || [],
          i = e.get("extraPlugins") || [],
          o = e.get("substitutePlugins") || [];
        return this.plugins.init(t.concat(i), n, o);
      }
      destroy() {
        let e = Promise.resolve();
        return "initializing" == this.state && (e = new Promise(e => this.once("ready", e))), e.then(() => {
          this.fire("destroy"), this.stopListening(), this.commands.destroy();
        }).then(() => this.plugins.destroy()).then(() => {
          this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
        }).then(() => this._context._removeEditor(this));
      }
      execute(e) {
        try {
          for (var _len30 = arguments.length, t = new Array(_len30 > 1 ? _len30 - 1 : 0), _key30 = 1; _key30 < _len30; _key30++) {
            t[_key30 - 1] = arguments[_key30];
          }
          return this.commands.execute(e, ...t);
        } catch (e) {
          _.rethrowUnexpectedError(e, this);
        }
      }
      focus() {
        this.editing.view.focus();
      }
      static create() {
        throw new Error("This is an abstract method.");
      }
    }
    function Gh(e) {
      return class extends e {
        updateSourceElement(e) {
          if (!this.sourceElement) throw new _("editor-missing-sourceelement", this);
          const t = this.config.get("updateSourceElementOnDestroy"),
            n = this.sourceElement instanceof HTMLTextAreaElement;
          if (!t && !n) return void Ui(this.sourceElement, "");
          const i = "string" == typeof e ? e : this.data.get();
          Ui(this.sourceElement, i);
        }
      };
    }
    Gh.updateSourceElement = Gh(Object).prototype.updateSourceElement;
    class Kh extends Vr {
      static get pluginName() {
        return "PendingActions";
      }
      init() {
        this.set("hasAny", !1), this._actions = new qo({
          idProperty: "_id"
        }), this._actions.delegate("add", "remove").to(this);
      }
      add(e) {
        if ("string" != typeof e) throw new _("pendingactions-add-invalid-message", this);
        const t = new (q())();
        return t.set("message", e), this._actions.add(t), this.hasAny = !0, t;
      }
      remove(e) {
        this._actions.remove(e), this.hasAny = !!this._actions.length;
      }
      get first() {
        return this._actions.get(0);
      }
      [Symbol.iterator]() {
        return this._actions[Symbol.iterator]();
      }
    }
    const Wh = {
      bold: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
      cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
      caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
      check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
      cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>',
      colorPalette: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.209 18.717A8.5 8.5 0 1 1 18.686 9.6h-.008l.002.12a3 3 0 0 1-2.866 2.997h-.268l-.046-.002v.002h-4.791a2 2 0 1 0 0 4 1 1 0 1 1-.128 1.992 8.665 8.665 0 0 1-.372.008Zm-3.918-7.01a1.25 1.25 0 1 0-2.415-.648 1.25 1.25 0 0 0 2.415.647ZM5.723 8.18a1.25 1.25 0 1 0 .647-2.414 1.25 1.25 0 0 0-.647 2.414ZM9.76 6.155a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Zm4.028 1.759a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Z"/></svg>',
      eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
      history: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1z"/><path d="M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052z"/><path d="M11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z"/></svg>',
      image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.66 9.118a.693.693 0 0 1 .956.032l3.65 3.411 2.422-2.238a.695.695 0 0 1 .945 0L17.5 13.6V2.5h-15v11.1l4.16-4.482ZM17.8 1c.652 0 1.2.47 1.2 1.1v14.362c0 .64-.532 1.038-1.184 1.038H2.184C1.532 17.5 1 17.103 1 16.462V2.1C1 1.47 1.537 1 2.2 1h15.6Zm-5.655 6a2.128 2.128 0 0 1 .157-2.364A2.133 2.133 0 1 1 12.145 7Z"/></svg>',
      imageUpload: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h9.494a2.97 2.97 0 0 1-.414-.287 2.998 2.998 0 0 1-1.055-2.03 3.003 3.003 0 0 1 .693-2.185l.383-.455-.02.018-3.65-3.41a.695.695 0 0 0-.957-.034L1.5 13.6V2.5h15v5.535a2.97 2.97 0 0 1 1.412.932l.088.105V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.713 2.803a2.146 2.146 0 0 0-2.049 1.992 2.14 2.14 0 0 0 1.28 2.096 2.13 2.13 0 0 0 2.644-3.11 2.134 2.134 0 0 0-1.875-.978Z"/><path d="M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.784.784 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79Z"/><path d="M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.784.784 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79Z"/></svg>',
      imageAssetManager: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1c-.662 0-1.2.47-1.2 1.1v14.248c0 .64.533 1.152 1.185 1.152h6.623v-7.236L6.617 9.15a.694.694 0 0 0-.957-.033L1.602 13.55V2.553l14.798.003V9.7H18V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.723 2.805a2.094 2.094 0 0 0-1.621.832 2.127 2.127 0 0 0 1.136 3.357 2.13 2.13 0 0 0 2.611-1.506 2.133 2.133 0 0 0-.76-2.244 2.13 2.13 0 0 0-1.366-.44Z"/><path clip-rule="evenodd" d="M19.898 12.369v6.187a.844.844 0 0 1-.844.844h-8.719a.844.844 0 0 1-.843-.844v-7.312a.844.844 0 0 1 .843-.844h2.531a.843.843 0 0 1 .597.248l.838.852h4.75c.223 0 .441.114.6.272a.844.844 0 0 1 .247.597Zm-1.52.654-4.377.02-1.1-1.143H11v6h7.4l-.023-4.877Z"/></svg>',
      imageUrl: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h7.029a5.401 5.401 0 0 1 .615-4.338l.762-1.232-2.975-2.78a.696.696 0 0 0-.957-.033L1.5 13.6V2.5h15v6.023c.449.131.887.32 1.307.573l.058.033c.046.028.09.057.135.086V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.713 2.803a2.15 2.15 0 0 0-1.611.834 2.118 2.118 0 0 0-.438 1.158 2.14 2.14 0 0 0 1.277 2.096 2.132 2.132 0 0 0 2.645-3.11 2.13 2.13 0 0 0-1.873-.978Z"/><path d="M16.63 10.294a3.003 3.003 0 0 0-4.142.887l-.117.177a.647.647 0 0 0-.096.492.664.664 0 0 0 .278.418.7.7 0 0 0 .944-.234 1.741 1.741 0 0 1 2.478-.463 1.869 1.869 0 0 1 .476 2.55.637.637 0 0 0-.071.5.646.646 0 0 0 .309.396.627.627 0 0 0 .869-.19l.027-.041a3.226 3.226 0 0 0-.956-4.492Zm-6.061 3.78-.044.066a3.228 3.228 0 0 0 .82 4.403 3.005 3.005 0 0 0 4.275-.798l.13-.197a.626.626 0 0 0 .092-.475.638.638 0 0 0-.268-.402.713.713 0 0 0-.99.26l-.018.029a1.741 1.741 0 0 1-2.477.461 1.87 1.87 0 0 1-.475-2.55l.029-.047a.647.647 0 0 0 .086-.485.66.66 0 0 0-.275-.408l-.04-.027a.609.609 0 0 0-.845.17Z"/><path d="M15.312 13.925c.24-.36.154-.838-.19-1.067-.346-.23-.82-.124-1.059.236l-1.268 1.907c-.239.36-.153.838.192 1.067.345.23.818.123 1.057-.236l1.268-1.907Z"/></svg>',
      lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
      textAlternative: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.035 1C2.446 1 2 1.54 2 2.098V10.5h1.5v-8h13v8H18V2.098C18 1.539 17.48 1 16.9 1H3.035Zm10.453 2.61a1.885 1.885 0 0 0-1.442.736 1.89 1.89 0 0 0 1.011 2.976 1.903 1.903 0 0 0 2.253-1.114 1.887 1.887 0 0 0-1.822-2.598ZM7.463 8.163a.611.611 0 0 0-.432.154L5.071 10.5h5.119L7.88 8.348a.628.628 0 0 0-.417-.185Zm6.236 1.059a.62.62 0 0 0-.42.164L12.07 10.5h2.969l-.92-1.113a.618.618 0 0 0-.42-.165ZM.91 11.5a.91.91 0 0 0-.91.912v6.877c0 .505.405.91.91.91h18.178a.91.91 0 0 0 .912-.91v-6.877a.908.908 0 0 0-.912-.912H.91ZM3.668 13h1.947l2.135 5.7H5.898l-.28-.946H3.601l-.278.945H1.516L3.668 13Zm4.947 0h1.801v4.3h2.7v1.4h-4.5V13h-.001Zm4.5 0h5.4v1.4h-1.798v4.3h-1.701v-4.3h-1.9V13h-.001Zm-8.517 1.457-.614 2.059h1.262l-.648-2.059Z"/></svg>',
      loupe: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.68 13.74h-.001l4.209 4.208a1 1 0 1 0 1.414-1.414l-4.267-4.268a6 6 0 1 0-1.355 1.474ZM13 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"/></svg>',
      previousArrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>',
      nextArrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>',
      importExport: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></svg>',
      paragraph: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>',
      plus: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>',
      text: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></svg>',
      alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
      alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
      alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
      alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
      alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
      alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
      objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
      objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectSizeCustom: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:v="https://vecta.io/nano" viewBox="0 0 20 20"><path d="M.95 1.43a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h.75v6.3H.95a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-.65h1.932l1.539-1.5H5v-.95a.95.95 0 0 0-.95-.95H3.2v-6.3h.85A.95.95 0 0 0 5 5.48v-.55h10v.55a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-3.1a.95.95 0 0 0-.95-.95h-3.1a.95.95 0 0 0-.95.95v1.05H5V2.38a.95.95 0 0 0-.95-.95H.95zm.55 3.5v-2h2v2h-2zm0 9.3v2h2v-2h-2zm15-11.3v2h2v-2h-2z"/><path d="M8.139 20.004v-2.388l7.045-7.048 2.391 2.391-7.046 7.046h-2.39zm11.421-9.101a.64.64 0 0 1-.138.206l-1.165 1.168-2.391-2.391 1.167-1.163a.63.63 0 0 1 .206-.138.635.635 0 0 1 .243-.049.63.63 0 0 1 .449.187l1.491 1.488c.059.059.108.129.138.206s.049.16.049.243a.6.6 0 0 1-.049.243z"/></svg>',
      objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
      objectSizeLarge: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M13 5.5H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM13 7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 2 7h11Z"/></svg>',
      objectSizeSmall: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M7 9.5H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2ZM7 11a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4A.5.5 0 0 1 2 11h5Z"/></svg>',
      objectSizeMedium: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M10 7.5H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2ZM10 9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6A.5.5 0 0 1 2 9h8Z"/></svg>',
      pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
      pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
      quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
      threeVerticalDots: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>',
      dragIndicator: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/></svg>',
      redo: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>',
      undo: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
      bulletedList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>',
      numberedList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
      todoList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m2.315 14.705 2.224-2.24a.689.689 0 0 1 .963 0 .664.664 0 0 1 0 .949L2.865 16.07a.682.682 0 0 1-.112.089.647.647 0 0 1-.852-.051L.688 14.886a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0l.717.722zm5.185.045a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75zM2.329 5.745l2.21-2.226a.689.689 0 0 1 .963 0 .664.664 0 0 1 0 .95L2.865 7.125a.685.685 0 0 1-.496.196.644.644 0 0 1-.468-.187L.688 5.912a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0l.73.736zM7.5 5.75A.75.75 0 0 1 8.25 5h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
      codeBlock: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.87 12.61a.75.75 0 0 1-.089.976l-.085.07-3.154 2.254 3.412 2.414a.75.75 0 0 1 .237.95l-.057.095a.75.75 0 0 1-.95.237l-.096-.058-4.272-3.022-.003-1.223 4.01-2.867a.75.75 0 0 1 1.047.174zm2.795-.231.095.057 4.011 2.867-.003 1.223-4.272 3.022-.095.058a.75.75 0 0 1-.88-.151l-.07-.086-.058-.095a.75.75 0 0 1 .15-.88l.087-.07 3.412-2.414-3.154-2.253-.085-.071a.75.75 0 0 1 .862-1.207zM16 0a2 2 0 0 1 2 2v9.354l-.663-.492-.837-.001V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3.118L7.156 19H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14zM5.009 15l.003 1H3v-1h2.009zm2.188-2-1.471 1H5v-1h2.197zM10 11v.095L8.668 12H7v-1h3zm4-2v1H7V9h7zm0-2v1H7V7h7zm-4-2v1H5V5h5zM6 3v1H3V3h3z"/></svg>',
      browseFiles: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>',
      heading1: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 9v10h-2v-8h-2V9h4zM4 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11H4v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v4.5z"/></svg>',
      heading2: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm16.076 8.343V18.5h-6.252c.067-.626.27-1.22.61-1.78.338-.561 1.006-1.305 2.005-2.232.804-.749 1.297-1.257 1.479-1.523.245-.368.368-.732.368-1.092 0-.398-.107-.703-.32-.917-.214-.214-.51-.32-.886-.32-.372 0-.669.111-.889.336-.22.224-.347.596-.38 1.117l-1.778-.178c.106-.982.438-1.686.997-2.114.558-.427 1.257-.64 2.095-.64.918 0 1.64.247 2.164.742.525.495.787 1.11.787 1.847 0 .419-.075.818-.225 1.197-.15.378-.388.775-.714 1.19-.216.275-.605.67-1.168 1.187-.563.516-.92.859-1.07 1.028a3.11 3.11 0 0 0-.365.495h3.542z"/></svg>',
      heading3: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm9.989 7.53 1.726-.209c.055.44.203.777.445 1.01.24.232.533.349.876.349.368 0 .678-.14.93-.42.251-.279.377-.655.377-1.13 0-.448-.12-.803-.362-1.066a1.153 1.153 0 0 0-.882-.393c-.228 0-.501.044-.819.133l.197-1.453c.482.012.85-.092 1.105-.315.253-.222.38-.517.38-.885 0-.313-.093-.563-.279-.75-.186-.185-.434-.278-.743-.278a1.07 1.07 0 0 0-.78.317c-.216.212-.347.52-.394.927l-1.644-.28c.114-.562.287-1.012.517-1.348.231-.337.553-.601.965-.794a3.24 3.24 0 0 1 1.387-.289c.876 0 1.579.28 2.108.838.436.457.653.973.653 1.549 0 .817-.446 1.468-1.339 1.955.533.114.96.37 1.28.768.319.398.478.878.478 1.441 0 .817-.298 1.513-.895 2.088-.596.576-1.339.864-2.228.864-.842 0-1.54-.243-2.094-.727-.555-.485-.876-1.118-.965-1.901z"/></svg>',
      heading4: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm13.55 10v-1.873h-3.81v-1.561l4.037-5.91h1.498v5.904h1.156v1.567h-1.156V18.5H17.05zm0-3.44v-3.18l-2.14 3.18h2.14z"/></svg>',
      heading5: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm9.578 7.607 1.777-.184c.05.402.201.72.45.955a1.223 1.223 0 0 0 1.81-.101c.258-.303.387-.759.387-1.368 0-.572-.128-1-.384-1.286-.256-.285-.59-.428-1-.428-.512 0-.971.226-1.377.679l-1.448-.21.915-4.843h4.716v1.67H15.56l-.28 1.58a2.697 2.697 0 0 1 1.219-.298 2.68 2.68 0 0 1 2.012.863c.55.576.825 1.323.825 2.241a3.36 3.36 0 0 1-.666 2.05c-.605.821-1.445 1.232-2.52 1.232-.86 0-1.56-.23-2.101-.692-.542-.461-.866-1.081-.971-1.86z"/></svg>',
      heading6: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm15.595 2.973-1.726.19c-.043-.355-.153-.617-.33-.787-.178-.169-.409-.253-.692-.253-.377 0-.695.169-.956.507-.26.339-.424 1.043-.492 2.114.445-.525.997-.787 1.657-.787.745 0 1.383.284 1.914.85.531.568.797 1.3.797 2.197 0 .952-.28 1.716-.838 2.291-.559.576-1.276.864-2.152.864-.94 0-1.712-.365-2.317-1.095-.605-.73-.908-1.927-.908-3.59 0-1.705.316-2.935.946-3.688.63-.753 1.45-1.13 2.457-1.13.706 0 1.291.198 1.755.594.463.395.758.97.885 1.723zm-4.043 3.891c0 .58.133 1.028.4 1.343.266.315.57.473.914.473.33 0 .605-.13.825-.388.22-.258.33-.68.33-1.27 0-.604-.118-1.047-.355-1.329a1.115 1.115 0 0 0-.89-.422c-.342 0-.632.134-.869.403s-.355.666-.355 1.19z"/></svg>',
      horizontalLine: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 9h16v2H2z"/></svg>',
      html: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17 0a2 2 0 0 1 2 2v7a1 1 0 0 1 1 1v5a1 1 0 0 1-.883.993l-.118.006L19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2l-.001-1.001-.116-.006A1 1 0 0 1 0 15v-5a1 1 0 0 1 .999-1L1 2a2 2 0 0 1 2-2h14zm.499 15.999h-15L2.5 17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5l-.001-1.001zm-3.478-6.013-.014.014H14v.007l-1.525 1.525-1.46-1.46-.015.013V10h-1v5h1v-3.53l1.428 1.43.048.043.131-.129L14 11.421V15h1v-5h-.965l-.014-.014zM2 10H1v5h1v-2h2v2h1v-5H4v2H2v-2zm7 0H6v1h1v4h1v-4h1v-1zm8 0h-1v5h3v-1h-2v-4zm0-8.5H3a.5.5 0 0 0-.5.5l-.001 6.999h15L17.5 2a.5.5 0 0 0-.5-.5zM10 7v1H4V7h6zm3-2v1H4V5h9zm-3-2v1H4V3h6z"/></svg>',
      indent: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
      outdent: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>',
      table: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 5.5v3h4v-3H3Zm0 4v3h4v-3H3Zm0 4v3h4v-3H3Zm5 3h4v-3H8v3Zm5 0h4v-3h-4v3Zm4-4v-3h-4v3h4Zm0-4v-3h-4v3h4Zm1.5 8A1.5 1.5 0 0 1 17 18H3a1.5 1.5 0 0 1-1.5-1.5V3c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13.5Zm-6.5-4v-3H8v3h4Zm0-4v-3H8v3h4Z"/></svg>'
    };
    var Yh = o(3756),
      $h = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Yh.A, $h);
    Yh.A.locals;
    class Zh extends Er {
      constructor(e) {
        super(e), this.set("text", void 0), this.set("for", void 0), this.id = "ck-editor__label_".concat(g());
        const t = this.bindTemplate;
        this.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            id: this.id,
            for: t.to("for")
          },
          children: [{
            text: t.to("text")
          }]
        });
      }
    }
    class Qh extends Er {
      constructor(e, t) {
        super(e);
        const n = e.t,
          i = new Zh();
        i.text = n("Help Contents. To close this dialog press ESC."), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-accessibility-help-dialog__content"],
            "aria-labelledby": i.id,
            role: "document",
            tabindex: -1
          },
          children: [fe(document, "p", {}, n("Below, you can find a list of keyboard shortcuts that can be used in the editor.")), ...this._createCategories(Array.from(t.values())), i]
        });
      }
      focus() {
        this.element.focus();
      }
      _createCategories(e) {
        return e.map(e => {
          const t = [fe(document, "h3", {}, e.label), ...Array.from(e.groups.values()).map(e => this._createGroup(e)).flat()];
          return e.description && t.splice(1, 0, fe(document, "p", {}, e.description)), fe(document, "section", {}, t);
        });
      }
      _createGroup(e) {
        const t = e.keystrokes.sort((e, t) => e.label.localeCompare(t.label)).map(e => this._createGroupRow(e)).flat(),
          n = [fe(document, "dl", {}, t)];
        return e.label && n.unshift(fe(document, "h4", {}, e.label)), n;
      }
      _createGroupRow(e) {
        const t = this.locale.t,
          n = fe(document, "dt"),
          i = fe(document, "dd"),
          o = function (e) {
            if ("string" == typeof e) return [[e]];
            if ("string" == typeof e[0]) return [e];
            return e;
          }(e.keystroke),
          r = [];
        for (const e of o) r.push(e.map(Jh).join(""));
        return n.innerHTML = e.label, i.innerHTML = r.join(", ") + (e.mayRequireFn && s.isMac ? " ".concat(t("(may require <kbd>Fn</kbd>)")) : ""), [n, i];
      }
    }
    function Jh(e) {
      return ko(e).split("+").map(e => "<kbd>".concat(e, "</kbd>")).join("+");
    }
    const Xh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 6.628a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/><path d="M8.5 9.125a.3.3 0 0 0-.253-.296L5.11 8.327a.75.75 0 1 1 .388-1.449l4.04.716c.267.072.624.08.893.009l4.066-.724a.75.75 0 1 1 .388 1.45l-3.132.5a.3.3 0 0 0-.253.296v1.357a.3.3 0 0 0 .018.102l1.615 4.438a.75.75 0 0 1-1.41.513l-1.35-3.71a.3.3 0 0 0-.281-.197h-.209a.3.3 0 0 0-.282.198l-1.35 3.711a.75.75 0 0 1-1.41-.513l1.64-4.509a.3.3 0 0 0 .019-.103V9.125Z"/><path clip-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17Zm0 1.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z"/></svg>';
    var em = o(8020),
      tm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(em.A, tm);
    em.A.locals;
    class nm extends Br {
      constructor() {
        super(...arguments), this.contentView = null;
      }
      static get requires() {
        return [Kg];
      }
      static get pluginName() {
        return "AccessibilityHelp";
      }
      init() {
        const e = this.editor,
          t = e.locale.t;
        e.ui.componentFactory.add("accessibilityHelp", () => {
          const e = this._createButton(um);
          return e.set({
            tooltip: !0,
            withText: !1,
            label: t("Accessibility help")
          }), e;
        }), e.ui.componentFactory.add("menuBar:accessibilityHelp", () => {
          const e = this._createButton(qk);
          return e.label = t("Accessibility"), e;
        }), e.keystrokes.set("Alt+0", (e, t) => {
          this._showDialog(), t();
        }), this._setupRootLabels();
      }
      _createButton(e) {
        const t = new e(this.editor.locale);
        return t.set({
          keystroke: "Alt+0",
          icon: Xh
        }), t.on("execute", () => this._showDialog()), t;
      }
      _setupRootLabels() {
        const e = this.editor,
          t = e.editing.view,
          n = e.t;
        function i(e, t) {
          const i = "".concat(t.getAttribute("aria-label"), ". ").concat(n("Press %0 for help.", [ko("Alt+0")]));
          e.setAttribute("aria-label", i, t);
        }
        e.ui.on("ready", () => {
          t.change(e => {
            for (const n of t.document.roots) i(e, n);
          }), e.on("addRoot", (n, o) => {
            const r = e.editing.view.document.getRoot(o.rootName);
            t.change(e => i(e, r));
          }, {
            priority: "low"
          });
        });
      }
      _showDialog() {
        const e = this.editor,
          t = e.plugins.get("Dialog"),
          n = e.locale.t;
        this.contentView || (this.contentView = new Qh(e.locale, e.accessibility.keystrokeInfos)), t.show({
          id: "accessibilityHelp",
          className: "ck-accessibility-help-dialog",
          title: n("Accessibility help"),
          icon: Xh,
          hasCloseButton: !0,
          content: this.contentView
        });
      }
    }
    class im extends er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        super(t), this.locale = e;
      }
      get bodyCollectionContainer() {
        return this._bodyCollectionContainer;
      }
      attachToDom() {
        this._bodyCollectionContainer = new tr({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
            dir: this.locale.uiLanguageDirection
          },
          children: this
        }).render();
        let e = document.querySelector(".ck-body-wrapper");
        e || (e = fe(document, "div", {
          class: "ck-body-wrapper"
        }), document.body.appendChild(e)), e.appendChild(this._bodyCollectionContainer);
      }
      detachFromDom() {
        super.destroy(), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
        const e = document.querySelector(".ck-body-wrapper");
        e && 0 == e.childElementCount && e.remove();
      }
    }
    var om = o(6912),
      rm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(om.A, rm);
    om.A.locals;
    class sm extends Er {
      constructor() {
        super();
        const e = this.bindTemplate;
        this.set("content", ""), this.set("viewBox", "0 0 20 20"), this.set("fillColor", ""), this.set("isColorInherited", !0), this.set("isVisible", !0), this.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon", e.if("isVisible", "ck-hidden", e => !e), "ck-reset_all-excluded", e.if("isColorInherited", "ck-icon_inherit-color")],
            viewBox: e.to("viewBox")
          }
        });
      }
      render() {
        super.render(), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", () => {
          this._updateXMLContent(), this._colorFillPaths();
        }), this.on("change:fillColor", () => {
          this._colorFillPaths();
        });
      }
      _updateXMLContent() {
        if (this.content) {
          const e = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
            t = e.getAttribute("viewBox");
          t && (this.viewBox = t);
          for (const {
            name: t,
            value: n
          } of Array.from(e.attributes)) sm.presentationalAttributeNames.includes(t) && this.element.setAttribute(t, n);
          for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
          for (; e.childNodes.length > 0;) this.element.appendChild(e.childNodes[0]);
        }
      }
      _colorFillPaths() {
        this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(e => {
          e.style.fill = this.fillColor;
        });
      }
    }
    sm.presentationalAttributeNames = ["alignment-baseline", "baseline-shift", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "paint-order", "pointer-events", "shape-rendering", "stop-color", "stop-opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-overflow", "text-rendering", "transform", "unicode-bidi", "vector-effect", "visibility", "white-space", "word-spacing", "writing-mode"];
    const am = sm;
    class lm extends Er {
      constructor() {
        super(), this.set({
          style: void 0,
          text: void 0,
          id: void 0
        });
        const e = this.bindTemplate;
        this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__label"],
            style: e.to("style"),
            id: e.to("id")
          },
          children: [{
            text: e.to("text")
          }]
        });
      }
    }
    var cm = o(5810),
      dm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(cm.A, dm);
    cm.A.locals;
    class um extends Er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new lm();
        super(e), this._focusDelayed = null;
        const n = this.bindTemplate,
          i = g();
        this.set("ariaLabel", void 0), this.set("ariaLabelledBy", "ck-editor__aria-label_".concat(i)), this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isVisible", !0), this.set("isToggleable", !1), this.set("keystroke", void 0), this.set("label", void 0), this.set("role", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.set("withKeystroke", !1), this.children = this.createCollection(), this.labelView = this._setupLabelView(t), this.iconView = new am(), this.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), this.keystrokeView = this._createKeystrokeView(), this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
        const o = {
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", n.to("class"), n.if("isEnabled", "ck-disabled", e => !e), n.if("isVisible", "ck-hidden", e => !e), n.to("isOn", e => e ? "ck-on" : "ck-off"), n.if("withText", "ck-button_with-text"), n.if("withKeystroke", "ck-button_with-keystroke")],
            role: n.to("role"),
            type: n.to("type", e => e || "button"),
            tabindex: n.to("tabindex"),
            "aria-checked": n.to("ariaChecked"),
            "aria-label": n.to("ariaLabel"),
            "aria-labelledby": n.to("ariaLabelledBy"),
            "aria-disabled": n.if("isEnabled", !0, e => !e),
            "aria-pressed": n.to("isOn", e => !!this.isToggleable && String(!!e)),
            "data-cke-tooltip-text": n.to("_tooltipString"),
            "data-cke-tooltip-position": n.to("tooltipPosition")
          },
          children: this.children,
          on: {
            click: n.to(e => {
              this.isEnabled ? this.fire("execute") : e.preventDefault();
            })
          }
        };
        s.isSafari && (this._focusDelayed || (this._focusDelayed = $o(() => this.focus(), 0)), o.on.mousedown = n.to(() => {
          this._focusDelayed();
        }), o.on.mouseup = n.to(() => {
          this._focusDelayed.cancel();
        })), this.setTemplate(o);
      }
      render() {
        super.render(), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
      }
      focus() {
        this.element.focus();
      }
      destroy() {
        this._focusDelayed && this._focusDelayed.cancel(), super.destroy();
      }
      _setupLabelView(e) {
        return e.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy"), e;
      }
      _createKeystrokeView() {
        const e = new Er();
        return e.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__keystroke"]
          },
          children: [{
            text: this.bindTemplate.to("keystroke", e => ko(e))
          }]
        }), e;
      }
      _getTooltipString(e, t, n) {
        return e ? "string" == typeof e ? e : (n && (n = ko(n)), e instanceof Function ? e(t, n) : "".concat(t).concat(n ? " (".concat(n, ")") : "")) : "";
      }
    }
    var hm = o(3986),
      mm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(hm.A, mm);
    hm.A.locals;
    class pm extends um {
      constructor(e) {
        super(e), this.isToggleable = !0, this.toggleSwitchView = this._createToggleView(), this.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
      }
      render() {
        super.render(), this.children.add(this.toggleSwitchView);
      }
      _createToggleView() {
        const e = new Er();
        return e.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__toggle"]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle__inner"]
            }
          }]
        }), e;
      }
    }
    class gm extends um {
      constructor(e) {
        super(e), this.buttonView = this, this._fileInputView = new fm(e), this._fileInputView.bind("acceptedType").to(this), this._fileInputView.bind("allowMultipleFiles").to(this), this._fileInputView.delegate("done").to(this), this.on("execute", () => {
          this._fileInputView.open();
        }), this.extendTemplate({
          attributes: {
            class: "ck-file-dialog-button"
          }
        });
      }
      render() {
        super.render(), this.children.add(this._fileInputView);
      }
    }
    class fm extends Er {
      constructor(e) {
        super(e), this.set("acceptedType", void 0), this.set("allowMultipleFiles", !1);
        const t = this.bindTemplate;
        this.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: t.to("acceptedType"),
            multiple: t.to("allowMultipleFiles")
          },
          on: {
            change: t.to(() => {
              this.element && this.element.files && this.element.files.length && this.fire("done", this.element.files), this.element.value = "";
            })
          }
        });
      }
      open() {
        this.element.click();
      }
    }
    const km = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
    var bm = o(3476),
      _m = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(bm.A, _m);
    bm.A.locals;
    class wm extends Er {
      constructor(e, t) {
        super(e);
        const n = this.bindTemplate;
        this.set("isCollapsed", !1), this.set("label", ""), this.buttonView = this._createButtonView(), this.children = this.createCollection(), this.set("_collapsibleAriaLabelUid", void 0), t && this.children.addMany(t), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-collapsible", n.if("isCollapsed", "ck-collapsible_collapsed")]
          },
          children: [this.buttonView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-collapsible__children"],
              role: "region",
              hidden: n.if("isCollapsed", "hidden"),
              "aria-labelledby": n.to("_collapsibleAriaLabelUid")
            },
            children: this.children
          }]
        });
      }
      render() {
        super.render(), this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
      }
      focus() {
        this.buttonView.focus();
      }
      _createButtonView() {
        const e = new um(this.locale),
          t = e.bindTemplate;
        return e.set({
          withText: !0,
          icon: km
        }), e.extendTemplate({
          attributes: {
            "aria-expanded": t.to("isOn", e => String(e))
          }
        }), e.bind("label").to(this), e.bind("isOn").to(this, "isCollapsed", e => !e), e.on("execute", () => {
          this.isCollapsed = !this.isCollapsed;
        }), e;
      }
    }
    function Am(e, t) {
      const n = e.t,
        i = {
          Black: n("Black"),
          "Dim grey": n("Dim grey"),
          Grey: n("Grey"),
          "Light grey": n("Light grey"),
          White: n("White"),
          Red: n("Red"),
          Orange: n("Orange"),
          Yellow: n("Yellow"),
          "Light green": n("Light green"),
          Green: n("Green"),
          Aquamarine: n("Aquamarine"),
          Turquoise: n("Turquoise"),
          "Light blue": n("Light blue"),
          Blue: n("Blue"),
          Purple: n("Purple")
        };
      return t.map(e => {
        const t = i[e.label];
        return t && t != e.label && (e.label = t), e;
      });
    }
    function vm(e) {
      return e.map(Cm).filter(e => !!e);
    }
    function Cm(e) {
      return "string" == typeof e ? {
        model: e,
        label: e,
        hasBorder: !1,
        view: {
          name: "span",
          styles: {
            color: e
          }
        }
      } : {
        model: e.color,
        label: e.label || e.color,
        hasBorder: void 0 !== e.hasBorder && e.hasBorder,
        view: {
          name: "span",
          styles: {
            color: "".concat(e.color)
          }
        }
      };
    }
    class ym extends um {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.set("color", void 0), this.set("hasBorder", !1), this.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>', this.extendTemplate({
          attributes: {
            style: {
              backgroundColor: t.to("color", e => s.isMediaForcedColors ? null : e)
            },
            class: ["ck", "ck-color-grid__tile", t.if("hasBorder", "ck-color-selector__color-tile_bordered")]
          }
        });
      }
      render() {
        super.render(), this.iconView.fillColor = "hsl(0, 0%, 100%)";
      }
    }
    var xm = o(4488),
      Em = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(xm.A, Em);
    xm.A.locals;
    class Sm extends Er {
      constructor(e, t) {
        super(e);
        const n = t && t.colorDefinitions ? t.colorDefinitions : [];
        this.columns = t && t.columns ? t.columns : 5;
        const i = {
          gridTemplateColumns: "repeat( ".concat(this.columns, ", 1fr)")
        };
        this.set("selectedColor", void 0), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.items.on("add", (e, t) => {
          t.isOn = t.color === this.selectedColor;
        }), n.forEach(e => {
          const t = new ym();
          t.set({
            color: e.color,
            label: e.label,
            tooltip: !0,
            hasBorder: e.options.hasBorder
          }), t.on("execute", () => {
            this.fire("execute", {
              value: e.color,
              hasBorder: e.options.hasBorder,
              label: e.label
            });
          }), this.items.add(t);
        }), this.setTemplate({
          tag: "div",
          children: this.items,
          attributes: {
            class: ["ck", "ck-color-grid"],
            style: i
          }
        }), this.on("change:selectedColor", (e, t, n) => {
          for (const e of this.items) e.isOn = e.color === n;
        });
      }
      focus() {
        this.items.length && this.items.first.focus();
      }
      focusLast() {
        this.items.length && this.items.last.focus();
      }
      render() {
        super.render();
        for (const e of this.items) this.focusTracker.add(e.element);
        this.items.on("add", (e, t) => {
          this.focusTracker.add(t.element);
        }), this.items.on("remove", (e, t) => {
          this.focusTracker.remove(t.element);
        }), this.keystrokes.listenTo(this.element), Ir({
          keystrokeHandler: this.keystrokes,
          focusTracker: this.focusTracker,
          gridItems: this.items,
          numberOfColumns: this.columns,
          uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
    }
    var Dm = o(8156);
    const Tm = function (e) {
      var t,
        n,
        i = [],
        o = 1;
      if ("string" == typeof e) {
        if (Dm[e]) i = Dm[e].slice(), n = "rgb";else if ("transparent" === e) o = 0, n = "rgb", i = [0, 0, 0];else if (/^#[A-Fa-f0-9]+$/.test(e)) {
          var r = e.slice(1);
          o = 1, (l = r.length) <= 4 ? (i = [parseInt(r[0] + r[0], 16), parseInt(r[1] + r[1], 16), parseInt(r[2] + r[2], 16)], 4 === l && (o = parseInt(r[3] + r[3], 16) / 255)) : (i = [parseInt(r[0] + r[1], 16), parseInt(r[2] + r[3], 16), parseInt(r[4] + r[5], 16)], 8 === l && (o = parseInt(r[6] + r[7], 16) / 255)), i[0] || (i[0] = 0), i[1] || (i[1] = 0), i[2] || (i[2] = 0), n = "rgb";
        } else if (t = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(e)) {
          var s = t[1],
            a = "rgb" === s;
          n = r = s.replace(/a$/, "");
          var l = "cmyk" === r ? 4 : "gray" === r ? 1 : 3;
          i = t[2].trim().split(/\s*[,\/]\s*|\s+/).map(function (e, t) {
            if (/%$/.test(e)) return t === l ? parseFloat(e) / 100 : "rgb" === r ? 255 * parseFloat(e) / 100 : parseFloat(e);
            if ("h" === r[t]) {
              if (/deg$/.test(e)) return parseFloat(e);
              if (void 0 !== Im[e]) return Im[e];
            }
            return parseFloat(e);
          }), s === r && i.push(1), o = a || void 0 === i[l] ? 1 : i[l], i = i.slice(0, l);
        } else e.length > 10 && /[0-9](?:\s|\/)/.test(e) && (i = e.match(/([0-9]+)/g).map(function (e) {
          return parseFloat(e);
        }), n = e.match(/([a-z])/gi).join("").toLowerCase());
      } else isNaN(e) ? Array.isArray(e) || e.length ? (i = [e[0], e[1], e[2]], n = "rgb", o = 4 === e.length ? e[3] : 1) : e instanceof Object && (null != e.r || null != e.red || null != e.R ? (n = "rgb", i = [e.r || e.red || e.R || 0, e.g || e.green || e.G || 0, e.b || e.blue || e.B || 0]) : (n = "hsl", i = [e.h || e.hue || e.H || 0, e.s || e.saturation || e.S || 0, e.l || e.lightness || e.L || e.b || e.brightness]), o = e.a || e.alpha || e.opacity || 1, null != e.opacity && (o /= 100)) : (n = "rgb", i = [e >>> 16, (65280 & e) >>> 8, 255 & e]);
      return {
        space: n,
        values: i,
        alpha: o
      };
    };
    var Im = {
      red: 0,
      orange: 60,
      yellow: 120,
      green: 180,
      blue: 240,
      purple: 300
    };
    var Bm = o(734),
      Mm = o.t(Bm, 2);
    function Pm(e, t) {
      if (!e) return "";
      const n = zm(e);
      if (!n) return "";
      if (n.space === t) return e;
      if (i = n, !Object.keys(Mm).includes(i.space)) return "";
      var i;
      const o = Mm[n.space][t];
      if (!o) return "";
      return function (e, t) {
        switch (t) {
          case "hex":
            return "#".concat(e);
          case "rgb":
            return "rgb( ".concat(e[0], ", ").concat(e[1], ", ").concat(e[2], " )");
          case "hsl":
            return "hsl( ".concat(e[0], ", ").concat(e[1], "%, ").concat(e[2], "% )");
          case "hwb":
            return "hwb( ".concat(e[0], ", ").concat(e[1], ", ").concat(e[2], " )");
          case "lab":
            return "lab( ".concat(e[0], "% ").concat(e[1], " ").concat(e[2], " )");
          case "lch":
            return "lch( ".concat(e[0], "% ").concat(e[1], " ").concat(e[2], " )");
          default:
            return "";
        }
      }(o("hex" === n.space ? n.hexValue : n.values), t);
    }
    function zm(e) {
      if (e.startsWith("#")) {
        const t = Tm(e);
        return {
          space: "hex",
          values: t.values,
          hexValue: e,
          alpha: t.alpha
        };
      }
      const t = Tm(e);
      return t.space ? t : null;
    }
    var Nm = o(7883),
      Lm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Nm.A, Lm);
    Nm.A.locals;
    class Rm extends Er {
      constructor(e, t) {
        super(e);
        const n = "ck-labeled-field-view-".concat(g()),
          i = "ck-labeled-field-view-status-".concat(g());
        this.fieldView = t(this, n, i), this.set("label", void 0), this.set("isEnabled", !0), this.set("isEmpty", !0), this.set("isFocused", !1), this.set("errorText", null), this.set("infoText", null), this.set("class", void 0), this.set("placeholder", void 0), this.labelView = this._createLabelView(n), this.statusView = this._createStatusView(i), this.fieldWrapperChildren = this.createCollection([this.fieldView, this.labelView]), this.bind("_statusText").to(this, "errorText", this, "infoText", (e, t) => e || t);
        const o = this.bindTemplate;
        this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view", o.to("class"), o.if("isEnabled", "ck-disabled", e => !e), o.if("isEmpty", "ck-labeled-field-view_empty"), o.if("isFocused", "ck-labeled-field-view_focused"), o.if("placeholder", "ck-labeled-field-view_placeholder"), o.if("errorText", "ck-error")]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__input-wrapper"]
            },
            children: this.fieldWrapperChildren
          }, this.statusView]
        });
      }
      _createLabelView(e) {
        const t = new Zh(this.locale);
        return t.for = e, t.bind("text").to(this, "label"), t;
      }
      _createStatusView(e) {
        const t = new Er(this.locale),
          n = this.bindTemplate;
        return t.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view__status", n.if("errorText", "ck-labeled-field-view__status_error"), n.if("_statusText", "ck-hidden", e => !e)],
            id: e,
            role: n.if("errorText", "alert")
          },
          children: [{
            text: n.to("_statusText")
          }]
        }), t;
      }
      focus(e) {
        this.fieldView.focus(e);
      }
    }
    class Vm extends Er {
      constructor(e) {
        var _this8;
        (super(e), _this8 = this), this.set("value", void 0), this.set("id", void 0), this.set("placeholder", void 0), this.set("tabIndex", void 0), this.set("isReadOnly", !1), this.set("hasError", !1), this.set("ariaDescribedById", void 0), this.set("ariaLabel", void 0), this.focusTracker = new Ko(), this.bind("isFocused").to(this.focusTracker), this.set("isEmpty", !0);
        const t = this.bindTemplate;
        this.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck", "ck-input", t.if("isFocused", "ck-input_focused"), t.if("isEmpty", "ck-input-text_empty"), t.if("hasError", "ck-error")],
            id: t.to("id"),
            placeholder: t.to("placeholder"),
            tabindex: t.to("tabIndex"),
            readonly: t.to("isReadOnly"),
            "aria-invalid": t.if("hasError", !0),
            "aria-describedby": t.to("ariaDescribedById"),
            "aria-label": t.to("ariaLabel")
          },
          on: {
            input: t.to(function () {
              for (var _len31 = arguments.length, e = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
                e[_key31] = arguments[_key31];
              }
              _this8.fire("input", ...e), _this8._updateIsEmpty();
            }),
            change: t.to(this._updateIsEmpty.bind(this))
          }
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", (e, t, n) => {
          this._setDomElementValue(n), this._updateIsEmpty();
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy();
      }
      select() {
        this.element.select();
      }
      focus() {
        this.element.focus();
      }
      reset() {
        this.value = this.element.value = "", this._updateIsEmpty();
      }
      _updateIsEmpty() {
        this.isEmpty = !this.element.value;
      }
      _setDomElementValue(e) {
        this.element.value = e || 0 === e ? e : "";
      }
    }
    var Om = o(1272),
      Fm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Om.A, Fm);
    Om.A.locals;
    class jm extends Vm {
      constructor(e) {
        super(e), this.set("inputMode", "text");
        const t = this.bindTemplate;
        this.extendTemplate({
          attributes: {
            inputmode: t.to("inputMode")
          }
        });
      }
    }
    class Hm extends jm {
      constructor(e) {
        super(e), this.extendTemplate({
          attributes: {
            type: "text",
            class: ["ck-input-text"]
          }
        });
      }
    }
    class Um extends jm {
      constructor(e) {
        let {
          min: t,
          max: n,
          step: i
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e);
        const o = this.bindTemplate;
        this.set("min", t), this.set("max", n), this.set("step", i), this.extendTemplate({
          attributes: {
            type: "number",
            class: ["ck-input-number"],
            min: o.to("min"),
            max: o.to("max"),
            step: o.to("step")
          }
        });
      }
    }
    var qm = o(8118),
      Gm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(qm.A, Gm);
    qm.A.locals;
    class Km extends Er {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", t.to("position", e => "ck-dropdown__panel_".concat(e)), t.if("isVisible", "ck-dropdown__panel-visible")],
            tabindex: "-1"
          },
          children: this.children,
          on: {
            selectstart: t.to(e => {
              "input" !== e.target.tagName.toLocaleLowerCase() && e.preventDefault();
            })
          }
        });
      }
      focus() {
        if (this.children.length) {
          const e = this.children.first;
          "function" == typeof e.focus ? e.focus() : w("ui-dropdown-panel-focus-child-missing-focus", {
            childView: this.children.first,
            dropdownPanel: this
          });
        }
      }
      focusLast() {
        if (this.children.length) {
          const e = this.children.last;
          "function" == typeof e.focusLast ? e.focusLast() : e.focus();
        }
      }
    }
    var Wm = o(6608),
      Ym = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Wm.A, Ym);
    Wm.A.locals;
    class $m extends Er {
      constructor(e, t, n) {
        super(e);
        const i = this.bindTemplate;
        this.buttonView = t, this.panelView = n, this.set("isOpen", !1), this.set("isEnabled", !0), this.set("class", void 0), this.set("id", void 0), this.set("panelPosition", "auto"), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new Wo(), this.focusTracker = new Ko(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", i.to("class"), i.if("isEnabled", "ck-disabled", e => !e)],
            id: i.to("id"),
            "aria-describedby": i.to("ariaDescribedById")
          },
          children: [t, n]
        }), t.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"],
            "data-cke-tooltip-disabled": i.to("isOpen")
          }
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", () => {
          this.isOpen = !this.isOpen;
        }), this.on("change:isOpen", (e, t, n) => {
          if (n) if ("auto" === this.panelPosition) {
            const e = $m._getOptimalPosition({
              element: this.panelView.element,
              target: this.buttonView.element,
              fitInViewport: !0,
              positions: this._panelPositions
            });
            this.panelView.position = e ? e.name : this._panelPositions[0].name;
          } else this.panelView.position = this.panelPosition;
        }), this.keystrokes.listenTo(this.element);
        const e = (e, t) => {
          this.isOpen && (this.isOpen = !1, t());
        };
        this.keystrokes.set("arrowdown", (e, t) => {
          this.buttonView.isEnabled && !this.isOpen && (this.isOpen = !0, t());
        }), this.keystrokes.set("arrowright", (e, t) => {
          this.isOpen && t();
        }), this.keystrokes.set("arrowleft", e), this.keystrokes.set("esc", e);
      }
      focus() {
        this.buttonView.focus();
      }
      get _panelPositions() {
        const {
          south: e,
          north: t,
          southEast: n,
          southWest: i,
          northEast: o,
          northWest: r,
          southMiddleEast: s,
          southMiddleWest: a,
          northMiddleEast: l,
          northMiddleWest: c
        } = $m.defaultPanelPositions;
        return "rtl" !== this.locale.uiLanguageDirection ? [n, i, s, a, e, o, r, l, c, t] : [i, n, a, s, e, r, o, c, l, t];
      }
    }
    $m.defaultPanelPositions = {
      south: (e, t) => ({
        top: e.bottom,
        left: e.left - (t.width - e.width) / 2,
        name: "s"
      }),
      southEast: e => ({
        top: e.bottom,
        left: e.left,
        name: "se"
      }),
      southWest: (e, t) => ({
        top: e.bottom,
        left: e.left - t.width + e.width,
        name: "sw"
      }),
      southMiddleEast: (e, t) => ({
        top: e.bottom,
        left: e.left - (t.width - e.width) / 4,
        name: "sme"
      }),
      southMiddleWest: (e, t) => ({
        top: e.bottom,
        left: e.left - 3 * (t.width - e.width) / 4,
        name: "smw"
      }),
      north: (e, t) => ({
        top: e.top - t.height,
        left: e.left - (t.width - e.width) / 2,
        name: "n"
      }),
      northEast: (e, t) => ({
        top: e.top - t.height,
        left: e.left,
        name: "ne"
      }),
      northWest: (e, t) => ({
        top: e.top - t.height,
        left: e.left - t.width + e.width,
        name: "nw"
      }),
      northMiddleEast: (e, t) => ({
        top: e.top - t.height,
        left: e.left - (t.width - e.width) / 4,
        name: "nme"
      }),
      northMiddleWest: (e, t) => ({
        top: e.top - t.height,
        left: e.left - 3 * (t.width - e.width) / 4,
        name: "nmw"
      })
    }, $m._getOptimalPosition = Zi;
    const Zm = $m;
    class Qm extends um {
      constructor(e) {
        super(e), this.arrowView = this._createArrowView(), this.extendTemplate({
          attributes: {
            "aria-haspopup": !0,
            "aria-expanded": this.bindTemplate.to("isOn", e => String(e))
          }
        }), this.delegate("execute").to(this, "open");
      }
      render() {
        super.render(), this.children.add(this.arrowView);
      }
      _createArrowView() {
        const e = new am();
        return e.content = km, e.extendTemplate({
          attributes: {
            class: "ck-dropdown__arrow"
          }
        }), e;
      }
    }
    class Jm extends T() {
      constructor(e) {
        if (super(), this.focusables = e.focusables, this.focusTracker = e.focusTracker, this.keystrokeHandler = e.keystrokeHandler, this.actions = e.actions, e.actions && e.keystrokeHandler) for (const t in e.actions) {
          let n = e.actions[t];
          "string" == typeof n && (n = [n]);
          for (const i of n) e.keystrokeHandler.set(i, (e, n) => {
            this[t](), n();
          });
        }
        this.on("forwardCycle", () => this.focusFirst(), {
          priority: "low"
        }), this.on("backwardCycle", () => this.focusLast(), {
          priority: "low"
        });
      }
      get first() {
        return this.focusables.find(Xm) || null;
      }
      get last() {
        return this.focusables.filter(Xm).slice(-1)[0] || null;
      }
      get next() {
        return this._getDomFocusableItem(1);
      }
      get previous() {
        return this._getDomFocusableItem(-1);
      }
      get current() {
        let e = null;
        return null === this.focusTracker.focusedElement ? null : (this.focusables.find((t, n) => {
          const i = t.element === this.focusTracker.focusedElement;
          return i && (e = n), i;
        }), e);
      }
      focusFirst() {
        this._focus(this.first, 1);
      }
      focusLast() {
        this._focus(this.last, -1);
      }
      focusNext() {
        const e = this.next;
        e && this.focusables.getIndex(e) === this.current || e === this.first ? this.fire("forwardCycle") : this._focus(e, 1);
      }
      focusPrevious() {
        const e = this.previous;
        e && this.focusables.getIndex(e) === this.current || e === this.last ? this.fire("backwardCycle") : this._focus(e, -1);
      }
      _focus(e, t) {
        e && this.focusTracker.focusedElement !== e.element && e.focus(t);
      }
      _getDomFocusableItem(e) {
        const t = this.focusables.length;
        if (!t) return null;
        const n = this.current;
        if (null === n) return this[1 === e ? "first" : "last"];
        let i = this.focusables.get(n),
          o = (n + t + e) % t;
        do {
          const n = this.focusables.get(o);
          if (Xm(n)) {
            i = n;
            break;
          }
          o = (o + t + e) % t;
        } while (o !== n);
        return i;
      }
    }
    function Xm(e) {
      return ep(e) && $i(e.element);
    }
    function ep(e) {
      return !(!("focus" in e) || "function" != typeof e.focus);
    }
    class tp extends Er {
      constructor(e) {
        super(e), this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
      }
    }
    class np extends Er {
      constructor(e) {
        super(e), this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__line-break"]
          }
        });
      }
    }
    function ip(e) {
      if (Array.isArray(e)) return {
        items: e,
        removeItems: []
      };
      const t = {
        items: [],
        removeItems: []
      };
      return e ? {
        ...t,
        ...e
      } : t;
    }
    var op = o(6808),
      rp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(op.A, rp);
    op.A.locals;
    const sp = {
      alignLeft: Wh.alignLeft,
      bold: Wh.bold,
      importExport: Wh.importExport,
      paragraph: Wh.paragraph,
      plus: Wh.plus,
      text: Wh.text,
      threeVerticalDots: Wh.threeVerticalDots,
      pilcrow: Wh.pilcrow,
      dragIndicator: Wh.dragIndicator
    };
    class ap extends Er {
      constructor(e, t) {
        super(e);
        const n = this.bindTemplate,
          i = this.t;
        this.options = t || {}, this.set("ariaLabel", i("Editor toolbar")), this.set("maxWidth", "auto"), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.set("class", void 0), this.set("isCompact", !1), this.itemsView = new lp(e), this.children = this.createCollection(), this.children.add(this.itemsView), this.focusables = this.createCollection();
        const o = "rtl" === e.uiLanguageDirection;
        this._focusCycler = new Jm({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: [o ? "arrowright" : "arrowleft", "arrowup"],
            focusNext: [o ? "arrowleft" : "arrowright", "arrowdown"]
          }
        });
        const r = ["ck", "ck-toolbar", n.to("class"), n.if("isCompact", "ck-toolbar_compact")];
        var s;
        this.options.shouldGroupWhenFull && this.options.isFloating && r.push("ck-toolbar_floating"), this.setTemplate({
          tag: "div",
          attributes: {
            class: r,
            role: "toolbar",
            "aria-label": n.to("ariaLabel"),
            style: {
              maxWidth: n.to("maxWidth")
            },
            tabindex: -1
          },
          children: this.children,
          on: {
            mousedown: (s = this, s.bindTemplate.to(e => {
              e.target === s.element && e.preventDefault();
            }))
          }
        }), this._behavior = this.options.shouldGroupWhenFull ? new dp(this) : new cp(this);
      }
      render() {
        super.render(), this.focusTracker.add(this.element);
        for (const e of this.items) this.focusTracker.add(e.element);
        this.items.on("add", (e, t) => {
          this.focusTracker.add(t.element);
        }), this.items.on("remove", (e, t) => {
          this.focusTracker.remove(t.element);
        }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
      }
      destroy() {
        return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), super.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      fillFromConfig(e, t, n) {
        this.items.addMany(this._buildItemsFromConfig(e, t, n));
      }
      _buildItemsFromConfig(e, t, n) {
        const i = ip(e),
          o = n || i.removeItems;
        return this._cleanItemsConfiguration(i.items, t, o).map(e => R(e) ? this._createNestedToolbarDropdown(e, t, o) : "|" === e ? new tp() : "-" === e ? new np() : t.create(e)).filter(e => !!e);
      }
      _cleanItemsConfiguration(e, t, n) {
        const i = e.filter((e, i, o) => "|" === e || -1 === n.indexOf(e) && ("-" === e ? !this.options.shouldGroupWhenFull || (w("toolbarview-line-break-ignored-when-grouping-items", o), !1) : !(!R(e) && !t.has(e)) || (w("toolbarview-item-unavailable", {
          item: e
        }), !1)));
        return this._cleanSeparatorsAndLineBreaks(i);
      }
      _cleanSeparatorsAndLineBreaks(e) {
        const t = e => "-" !== e && "|" !== e,
          n = e.length,
          i = e.findIndex(t);
        if (-1 === i) return [];
        const o = n - e.slice().reverse().findIndex(t);
        return e.slice(i, o).filter((e, n, i) => {
          if (t(e)) return !0;
          return !(n > 0 && i[n - 1] === e);
        });
      }
      _createNestedToolbarDropdown(e, t, n) {
        let {
          label: i,
          icon: o,
          items: r,
          tooltip: s = !0,
          withText: a = !1
        } = e;
        if (r = this._cleanItemsConfiguration(r, t, n), !r.length) return null;
        const l = yp(this.locale);
        return i || w("toolbarview-nested-toolbar-dropdown-missing-label", e), l.class = "ck-toolbar__nested-toolbar-dropdown", l.buttonView.set({
          label: i,
          tooltip: s,
          withText: !!a
        }), !1 !== o ? l.buttonView.icon = sp[o] || o || Wh.threeVerticalDots : l.buttonView.withText = !0, xp(l, () => l.toolbarView._buildItemsFromConfig(r, t, n)), l;
      }
    }
    class lp extends Er {
      constructor(e) {
        super(e), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar__items"]
          },
          children: this.children
        });
      }
    }
    class cp {
      constructor(e) {
        const t = e.bindTemplate;
        e.set("isVertical", !1), e.itemsView.children.bindTo(e.items).using(e => e), e.focusables.bindTo(e.items).using(e => ep(e) ? e : null), e.extendTemplate({
          attributes: {
            class: [t.if("isVertical", "ck-toolbar_vertical")]
          }
        });
      }
      render() {}
      destroy() {}
    }
    class dp {
      constructor(e) {
        this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, this.view = e, this.viewChildren = e.children, this.viewFocusables = e.focusables, this.viewItemsView = e.itemsView, this.viewFocusTracker = e.focusTracker, this.viewLocale = e.locale, this.ungroupedItems = e.createCollection(), this.groupedItems = e.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), e.itemsView.children.bindTo(this.ungroupedItems).using(e => e), this.ungroupedItems.on("change", this._updateFocusCyclableItems.bind(this)), e.children.on("change", this._updateFocusCyclableItems.bind(this)), e.items.on("change", (e, t) => {
          const n = t.index,
            i = Array.from(t.added);
          for (const e of t.removed) n >= this.ungroupedItems.length ? this.groupedItems.remove(e) : this.ungroupedItems.remove(e);
          for (let e = n; e < n + i.length; e++) {
            const t = i[e - n];
            e > this.ungroupedItems.length ? this.groupedItems.add(t, e - this.ungroupedItems.length) : this.ungroupedItems.add(t, e);
          }
          this._updateGrouping();
        }), e.extendTemplate({
          attributes: {
            class: ["ck-toolbar_grouping"]
          }
        });
      }
      render(e) {
        this.viewElement = e.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(e);
      }
      destroy() {
        this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
      }
      _updateGrouping() {
        if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
        if (!$i(this.viewElement)) return void (this.shouldUpdateGroupingOnNextResize = !0);
        const e = this.groupedItems.length;
        let t;
        for (; this._areItemsOverflowing;) this._groupLastItem(), t = !0;
        if (!t && this.groupedItems.length) {
          for (; this.groupedItems.length && !this._areItemsOverflowing;) this._ungroupFirstItem();
          this._areItemsOverflowing && this._groupLastItem();
        }
        this.groupedItems.length !== e && this.view.fire("groupedItemsUpdate");
      }
      get _areItemsOverflowing() {
        if (!this.ungroupedItems.length) return !1;
        const e = this.viewElement,
          n = this.viewLocale.uiLanguageDirection,
          i = new Li(e.lastChild),
          o = new Li(e);
        if (!this.cachedPadding) {
          const i = t.window.getComputedStyle(e),
            o = "ltr" === n ? "paddingRight" : "paddingLeft";
          this.cachedPadding = Number.parseInt(i[o]);
        }
        return "ltr" === n ? i.right > o.right - this.cachedPadding : i.left < o.left + this.cachedPadding;
      }
      _enableGroupingOnResize() {
        let e;
        this.resizeObserver = new Hi(this.viewElement, t => {
          e && e === t.contentRect.width && !this.shouldUpdateGroupingOnNextResize || (this.shouldUpdateGroupingOnNextResize = !1, this._updateGrouping(), e = t.contentRect.width);
        }), this._updateGrouping();
      }
      _enableGroupingOnMaxWidthChange(e) {
        e.on("change:maxWidth", () => {
          this._updateGrouping();
        });
      }
      _groupLastItem() {
        this.groupedItems.length || (this.viewChildren.add(new tp()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
      }
      _ungroupFirstItem() {
        this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
      }
      _createGroupedItemsDropdown() {
        const e = this.viewLocale,
          t = e.t,
          n = yp(e);
        return n.class = "ck-toolbar__grouped-dropdown", n.panelPosition = "ltr" === e.uiLanguageDirection ? "sw" : "se", xp(n, this.groupedItems), n.buttonView.set({
          label: t("Show more items"),
          tooltip: !0,
          tooltipPosition: "rtl" === e.uiLanguageDirection ? "se" : "sw",
          icon: Wh.threeVerticalDots
        }), n;
      }
      _updateFocusCyclableItems() {
        this.viewFocusables.clear(), this.ungroupedItems.map(e => {
          ep(e) && this.viewFocusables.add(e);
        }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
      }
    }
    class up extends Er {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.set("isVisible", !0), this.children = this.createCollection(), this.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item", t.if("isVisible", "ck-hidden", e => !e)],
            role: "presentation"
          },
          children: this.children
        });
      }
      focus() {
        this.children.first && this.children.first.focus();
      }
    }
    class hp extends Er {
      constructor(e) {
        super(e), this.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
      }
    }
    class mp extends Er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Zh();
        super(e);
        const n = this.bindTemplate,
          i = new fp(e);
        this.set({
          label: "",
          isVisible: !0
        }), this.labelView = t, this.labelView.bind("text").to(this, "label"), this.children = this.createCollection(), this.children.addMany([this.labelView, i]), i.set({
          role: "group",
          ariaLabelledBy: t.id
        }), i.focusTracker.destroy(), i.keystrokes.destroy(), this.items = i.items, this.setTemplate({
          tag: "li",
          attributes: {
            role: "presentation",
            class: ["ck", "ck-list__group", n.if("isVisible", "ck-hidden", e => !e)]
          },
          children: this.children
        });
      }
      focus() {
        if (this.items) {
          const e = this.items.find(e => !(e instanceof hp));
          e && e.focus();
        }
      }
    }
    var pp = o(9118),
      gp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(pp.A, gp);
    pp.A.locals;
    class fp extends Er {
      constructor(e) {
        super(e), this._listItemGroupToChangeListeners = new WeakMap();
        const t = this.bindTemplate;
        this.focusables = new er(), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this._focusCycler = new Jm({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), this.set("ariaLabel", void 0), this.set("ariaLabelledBy", void 0), this.set("role", void 0), this.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"],
            role: t.to("role"),
            "aria-label": t.to("ariaLabel"),
            "aria-labelledby": t.to("ariaLabelledBy")
          },
          children: this.items
        });
      }
      render() {
        super.render();
        for (const e of this.items) e instanceof mp ? this._registerFocusableItemsGroup(e) : e instanceof up && this._registerFocusableListItem(e);
        this.items.on("change", (e, t) => {
          for (const e of t.removed) e instanceof mp ? this._deregisterFocusableItemsGroup(e) : e instanceof up && this._deregisterFocusableListItem(e);
          for (const e of Array.from(t.added).reverse()) e instanceof mp ? this._registerFocusableItemsGroup(e, t.index) : this._registerFocusableListItem(e, t.index);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusFirst() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      _registerFocusableListItem(e, t) {
        this.focusTracker.add(e.element), this.focusables.add(e, t);
      }
      _deregisterFocusableListItem(e) {
        this.focusTracker.remove(e.element), this.focusables.remove(e);
      }
      _getOnGroupItemsChangeCallback(e) {
        return (t, n) => {
          for (const e of n.removed) this._deregisterFocusableListItem(e);
          for (const t of Array.from(n.added).reverse()) this._registerFocusableListItem(t, this.items.getIndex(e) + n.index);
        };
      }
      _registerFocusableItemsGroup(e, t) {
        Array.from(e.items).forEach((e, n) => {
          const i = void 0 !== t ? t + n : void 0;
          this._registerFocusableListItem(e, i);
        });
        const n = this._getOnGroupItemsChangeCallback(e);
        this._listItemGroupToChangeListeners.set(e, n), e.items.on("change", n);
      }
      _deregisterFocusableItemsGroup(e) {
        for (const t of e.items) this._deregisterFocusableListItem(t);
        e.items.off("change", this._listItemGroupToChangeListeners.get(e)), this._listItemGroupToChangeListeners.delete(e);
      }
    }
    var kp = o(4515),
      bp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(kp.A, bp);
    kp.A.locals;
    class _p extends Er {
      constructor(e, t) {
        super(e);
        const n = this.bindTemplate;
        this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isToggleable", !1), this.set("isVisible", !0), this.set("keystroke", void 0), this.set("withKeystroke", !1), this.set("label", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.children = this.createCollection(), this.actionView = this._createActionView(t), this.arrowView = this._createArrowView(), this.keystrokes = new Wo(), this.focusTracker = new Ko(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-splitbutton", n.to("class"), n.if("isVisible", "ck-hidden", e => !e), this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", (e, t) => {
          this.focusTracker.focusedElement === this.actionView.element && (this.arrowView.focus(), t());
        }), this.keystrokes.set("arrowleft", (e, t) => {
          this.focusTracker.focusedElement === this.arrowView.element && (this.actionView.focus(), t());
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this.actionView.focus();
      }
      _createActionView(e) {
        const t = e || new um();
        return e || t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), t.extendTemplate({
          attributes: {
            class: "ck-splitbutton__action"
          }
        }), t.delegate("execute").to(this), t;
      }
      _createArrowView() {
        const e = new um(),
          t = e.bindTemplate;
        return e.icon = km, e.extendTemplate({
          attributes: {
            class: ["ck-splitbutton__arrow"],
            "data-cke-tooltip-disabled": t.to("isOn"),
            "aria-haspopup": !0,
            "aria-expanded": t.to("isOn", e => String(e))
          }
        }), e.bind("isEnabled").to(this), e.bind("label").to(this), e.bind("tooltip").to(this), e.delegate("execute").to(this, "open"), e;
      }
    }
    var wp = o(4245),
      Ap = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(wp.A, Ap);
    wp.A.locals;
    var vp = o(8424),
      Cp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(vp.A, Cp);
    vp.A.locals;
    function yp(e) {
      let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Qm;
      const i = "function" == typeof n ? new n(e) : n,
        o = new Km(e),
        r = new Zm(e, i, o);
      return i.bind("isEnabled").to(r), i instanceof _p ? i.arrowView.bind("isOn").to(r, "isOpen") : i.bind("isOn").to(r, "isOpen"), function (e) {
        (function (e) {
          e.on("render", () => {
            Sr({
              emitter: e,
              activator: () => e.isOpen,
              callback: () => {
                e.isOpen = !1;
              },
              contextElements: () => [e.element, ...e.focusTracker._elements]
            });
          });
        })(e), function (e) {
          e.on("execute", t => {
            t.source instanceof pm || (e.isOpen = !1);
          });
        }(e), function (e) {
          e.focusTracker.on("change:isFocused", (t, n, i) => {
            e.isOpen && !i && (e.isOpen = !1);
          });
        }(e), function (e) {
          e.keystrokes.set("arrowdown", (t, n) => {
            e.isOpen && (e.panelView.focus(), n());
          }), e.keystrokes.set("arrowup", (t, n) => {
            e.isOpen && (e.panelView.focusLast(), n());
          });
        }(e), function (e) {
          e.on("change:isOpen", (n, i, o) => {
            if (o) return;
            const r = e.panelView.element;
            r && r.contains(t.document.activeElement) && e.buttonView.focus();
          });
        }(e), function (e) {
          e.on("change:isOpen", (t, n, i) => {
            i && e.panelView.focus();
          }, {
            priority: "low"
          });
        }(e);
      }(r), r;
    }
    function xp(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      e.extendTemplate({
        attributes: {
          class: ["ck-toolbar-dropdown"]
        }
      }), e.isOpen ? Ep(e, t, n) : e.once("change:isOpen", () => Ep(e, t, n), {
        priority: "highest"
      }), n.enableActiveItemFocusOnDropdownOpen && Tp(e, () => e.toolbarView.items.find(e => e.isOn));
    }
    function Ep(e, t, n) {
      const i = e.locale,
        o = i.t,
        r = e.toolbarView = new ap(i),
        s = "function" == typeof t ? t() : t;
      r.ariaLabel = n.ariaLabel || o("Dropdown toolbar"), n.maxWidth && (r.maxWidth = n.maxWidth), n.class && (r.class = n.class), n.isCompact && (r.isCompact = n.isCompact), n.isVertical && (r.isVertical = !0), s instanceof er ? r.items.bindTo(s).using(e => e) : r.items.addMany(s), e.panelView.children.add(r), r.items.delegate("execute").to(e);
    }
    function Sp(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      e.isOpen ? Dp(e, t, n) : e.once("change:isOpen", () => Dp(e, t, n), {
        priority: "highest"
      }), Tp(e, () => e.listView.items.find(e => e instanceof up && e.children.first.isOn));
    }
    function Dp(e, t, n) {
      const i = e.locale,
        o = e.listView = new fp(i),
        r = "function" == typeof t ? t() : t;
      o.ariaLabel = n.ariaLabel, o.role = n.role, Ip(e, o.items, r, i), e.panelView.children.add(o), o.items.delegate("execute").to(e);
    }
    function Tp(e, t) {
      e.on("change:isOpen", () => {
        if (!e.isOpen) return;
        const n = t();
        n && ("function" == typeof n.focus ? n.focus() : w("ui-dropdown-focus-child-on-open-child-missing-focus", {
          view: n
        }));
      }, {
        priority: f.low - 10
      });
    }
    function Ip(e, t, n, i) {
      t.bindTo(n).using(t => {
        if ("separator" === t.type) return new hp(i);
        if ("group" === t.type) {
          const n = new mp(i);
          return n.set({
            label: t.label
          }), Ip(e, n.items, t.items, i), n.items.delegate("execute").to(e), n;
        }
        if ("button" === t.type || "switchbutton" === t.type) {
          const e = new up(i);
          let n;
          return "button" === t.type ? (n = new um(i), n.bind("ariaChecked").to(n, "isOn")) : n = new pm(i), n.bind(...Object.keys(t.model)).to(t.model), n.delegate("execute").to(e), e.children.add(n), e;
        }
        return null;
      });
    }
    const Bp = (e, t, n) => {
        const i = new Hm(e.locale);
        return i.set({
          id: t,
          ariaDescribedById: n
        }), i.bind("isReadOnly").to(e, "isEnabled", e => !e), i.bind("hasError").to(e, "errorText", e => !!e), i.on("input", () => {
          e.errorText = null;
        }), e.bind("isEmpty", "isFocused", "placeholder").to(i), i;
      },
      Mp = (e, t, n) => {
        const i = new Um(e.locale);
        return i.set({
          id: t,
          ariaDescribedById: n,
          inputMode: "numeric"
        }), i.bind("isReadOnly").to(e, "isEnabled", e => !e), i.bind("hasError").to(e, "errorText", e => !!e), i.on("input", () => {
          e.errorText = null;
        }), e.bind("isEmpty", "isFocused", "placeholder").to(i), i;
      },
      Pp = (e, t, n) => {
        const i = yp(e.locale);
        return i.set({
          id: t,
          ariaDescribedById: n
        }), i.bind("isEnabled").to(e), i;
      },
      zp = function (e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        return e > n ? n : e < t ? t : e;
      },
      Np = function (e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.pow(10, t);
        return Math.round(n * e) / n;
      },
      Lp = (Math.PI, e => ("#" === e[0] && (e = e.substring(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 4 === e.length ? Np(parseInt(e[3] + e[3], 16) / 255, 2) : 1
      } : {
        r: parseInt(e.substring(0, 2), 16),
        g: parseInt(e.substring(2, 4), 16),
        b: parseInt(e.substring(4, 6), 16),
        a: 8 === e.length ? Np(parseInt(e.substring(6, 8), 16) / 255, 2) : 1
      })),
      Rp = _ref37 => {
        let {
          h: e,
          s: t,
          v: n,
          a: i
        } = _ref37;
        const o = (200 - t) * n / 100;
        return {
          h: Np(e),
          s: Np(o > 0 && o < 200 ? t * n / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
          l: Np(o / 2),
          a: Np(i, 2)
        };
      },
      Vp = e => {
        const {
          h: t,
          s: n,
          l: i
        } = Rp(e);
        return "hsl(".concat(t, ", ").concat(n, "%, ").concat(i, "%)");
      },
      Op = _ref38 => {
        let {
          h: e,
          s: t,
          v: n,
          a: i
        } = _ref38;
        e = e / 360 * 6, t /= 100, n /= 100;
        const o = Math.floor(e),
          r = n * (1 - t),
          s = n * (1 - (e - o) * t),
          a = n * (1 - (1 - e + o) * t),
          l = o % 6;
        return {
          r: Np(255 * [n, s, r, r, a, n][l]),
          g: Np(255 * [a, n, n, s, r, r][l]),
          b: Np(255 * [r, r, a, n, n, s][l]),
          a: Np(i, 2)
        };
      },
      Fp = e => {
        const t = e.toString(16);
        return t.length < 2 ? "0" + t : t;
      },
      jp = _ref39 => {
        let {
          r: e,
          g: t,
          b: n,
          a: i
        } = _ref39;
        const o = i < 1 ? Fp(Np(255 * i)) : "";
        return "#" + Fp(e) + Fp(t) + Fp(n) + o;
      },
      Hp = _ref40 => {
        let {
          r: e,
          g: t,
          b: n,
          a: i
        } = _ref40;
        const o = Math.max(e, t, n),
          r = o - Math.min(e, t, n),
          s = r ? o === e ? (t - n) / r : o === t ? 2 + (n - e) / r : 4 + (e - t) / r : 0;
        return {
          h: Np(60 * (s < 0 ? s + 6 : s)),
          s: Np(o ? r / o * 100 : 0),
          v: Np(o / 255 * 100),
          a: i
        };
      },
      Up = (e, t) => {
        if (e === t) return !0;
        for (const n in e) if (e[n] !== t[n]) return !1;
        return !0;
      },
      qp = {},
      Gp = e => {
        let t = qp[e];
        return t || (t = document.createElement("template"), t.innerHTML = e, qp[e] = t), t;
      },
      Kp = (e, t, n) => {
        e.dispatchEvent(new CustomEvent(t, {
          bubbles: !0,
          detail: n
        }));
      };
    let Wp = !1;
    const Yp = e => "touches" in e,
      $p = (e, t) => {
        const n = Yp(t) ? t.touches[0] : t,
          i = e.el.getBoundingClientRect();
        Kp(e.el, "move", e.getMove({
          x: zp((n.pageX - (i.left + window.pageXOffset)) / i.width),
          y: zp((n.pageY - (i.top + window.pageYOffset)) / i.height)
        }));
      };
    class Zp {
      constructor(e, t, n, i) {
        const o = Gp("<div role=\"slider\" tabindex=\"0\" part=\"".concat(t, "\" ").concat(n, "><div part=\"").concat(t, "-pointer\"></div></div>"));
        e.appendChild(o.content.cloneNode(!0));
        const r = e.querySelector("[part=".concat(t, "]"));
        r.addEventListener("mousedown", this), r.addEventListener("touchstart", this), r.addEventListener("keydown", this), this.el = r, this.xy = i, this.nodes = [r.firstChild, r];
      }
      set dragging(e) {
        const t = e ? document.addEventListener : document.removeEventListener;
        t(Wp ? "touchmove" : "mousemove", this), t(Wp ? "touchend" : "mouseup", this);
      }
      handleEvent(e) {
        switch (e.type) {
          case "mousedown":
          case "touchstart":
            if (e.preventDefault(), !(e => !(Wp && !Yp(e) || (Wp || (Wp = Yp(e)), 0)))(e) || !Wp && 0 != e.button) return;
            this.el.focus(), $p(this, e), this.dragging = !0;
            break;
          case "mousemove":
          case "touchmove":
            e.preventDefault(), $p(this, e);
            break;
          case "mouseup":
          case "touchend":
            this.dragging = !1;
            break;
          case "keydown":
            ((e, t) => {
              const n = t.keyCode;
              n > 40 || e.xy && n < 37 || n < 33 || (t.preventDefault(), Kp(e.el, "move", e.getMove({
                x: 39 === n ? .01 : 37 === n ? -.01 : 34 === n ? .05 : 33 === n ? -.05 : 35 === n ? 1 : 36 === n ? -1 : 0,
                y: 40 === n ? .01 : 38 === n ? -.01 : 0
              }, !0)));
            })(this, e);
        }
      }
      style(e) {
        e.forEach((e, t) => {
          for (const n in e) this.nodes[t].style.setProperty(n, e[n]);
        });
      }
    }
    class Qp extends Zp {
      constructor(e) {
        super(e, "hue", 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', !1);
      }
      update(_ref41) {
        let {
          h: e
        } = _ref41;
        this.h = e, this.style([{
          left: e / 360 * 100 + "%",
          color: Vp({
            h: e,
            s: 100,
            v: 100,
            a: 1
          })
        }]), this.el.setAttribute("aria-valuenow", "".concat(Np(e)));
      }
      getMove(e, t) {
        return {
          h: t ? zp(this.h + 360 * e.x, 0, 360) : 360 * e.x
        };
      }
    }
    class Jp extends Zp {
      constructor(e) {
        super(e, "saturation", 'aria-label="Color"', !0);
      }
      update(e) {
        this.hsva = e, this.style([{
          top: 100 - e.v + "%",
          left: "".concat(e.s, "%"),
          color: Vp(e)
        }, {
          "background-color": Vp({
            h: e.h,
            s: 100,
            v: 100,
            a: 1
          })
        }]), this.el.setAttribute("aria-valuetext", "Saturation ".concat(Np(e.s), "%, Brightness ").concat(Np(e.v), "%"));
      }
      getMove(e, t) {
        return {
          s: t ? zp(this.hsva.s + 100 * e.x, 0, 100) : 100 * e.x,
          v: t ? zp(this.hsva.v - 100 * e.y, 0, 100) : Math.round(100 - 100 * e.y)
        };
      }
    }
    const Xp = Symbol("same"),
      eg = Symbol("color"),
      tg = Symbol("hsva"),
      ng = Symbol("update"),
      ig = Symbol("parts"),
      og = Symbol("css"),
      rg = Symbol("sliders");
    class sg extends HTMLElement {
      static get observedAttributes() {
        return ["color"];
      }
      get [og]() {
        return [':host{display:flex;flex-direction:column;position:relative;width:200px;height:200px;user-select:none;-webkit-user-select:none;cursor:default}:host([hidden]){display:none!important}[role=slider]{position:relative;touch-action:none;user-select:none;-webkit-user-select:none;outline:0}[role=slider]:last-child{border-radius:0 0 8px 8px}[part$=pointer]{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;display:flex;place-content:center center;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}[part$=pointer]::after{content:"";width:100%;height:100%;border-radius:inherit;background-color:currentColor}[role=slider]:focus [part$=pointer]{transform:translate(-50%,-50%) scale(1.1)}', "[part=hue]{flex:0 0 24px;background:linear-gradient(to right,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%)}[part=hue-pointer]{top:50%;z-index:2}", "[part=saturation]{flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,rgba(255,255,255,0));box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part=saturation-pointer]{z-index:3}"];
      }
      get [rg]() {
        return [Jp, Qp];
      }
      get color() {
        return this[eg];
      }
      set color(e) {
        if (!this[Xp](e)) {
          const t = this.colorModel.toHsva(e);
          this[ng](t), this[eg] = e;
        }
      }
      constructor() {
        super();
        const e = Gp("<style>".concat(this[og].join(""), "</style>")),
          t = this.attachShadow({
            mode: "open"
          });
        t.appendChild(e.content.cloneNode(!0)), t.addEventListener("move", this), this[ig] = this[rg].map(e => new e(t));
      }
      connectedCallback() {
        if (this.hasOwnProperty("color")) {
          const e = this.color;
          delete this.color, this.color = e;
        } else this.color || (this.color = this.colorModel.defaultColor);
      }
      attributeChangedCallback(e, t, n) {
        const i = this.colorModel.fromAttr(n);
        this[Xp](i) || (this.color = i);
      }
      handleEvent(e) {
        const t = this[tg],
          n = {
            ...t,
            ...e.detail
          };
        let i;
        this[ng](n), Up(n, t) || this[Xp](i = this.colorModel.fromHsva(n)) || (this[eg] = i, Kp(this, "color-changed", {
          value: i
        }));
      }
      [Xp](e) {
        return this.color && this.colorModel.equal(e, this.color);
      }
      [ng](e) {
        this[tg] = e, this[ig].forEach(t => t.update(e));
      }
    }
    const ag = {
      defaultColor: "#000",
      toHsva: e => Hp(Lp(e)),
      fromHsva: _ref42 => {
        let {
          h: e,
          s: t,
          v: n
        } = _ref42;
        return jp(Op({
          h: e,
          s: t,
          v: n,
          a: 1
        }));
      },
      equal: (e, t) => e.toLowerCase() === t.toLowerCase() || Up(Lp(e), Lp(t)),
      fromAttr: e => e
    };
    class lg extends sg {
      get colorModel() {
        return ag;
      }
    }
    var cg = o(3900),
      dg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(cg.A, dg);
    cg.A.locals;
    class ug extends Er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e), this.set({
          color: "",
          _hexColor: ""
        }), this.hexInputRow = this._createInputRow();
        const n = this.createCollection();
        t.hideInput || n.add(this.hexInputRow), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-picker"],
            tabindex: -1
          },
          children: n
        }), this._config = t, this._debounceColorPickerEvent = gl(e => {
          this.set("color", e), this.fire("colorSelected", {
            color: this.color
          });
        }, 150, {
          leading: !0
        }), this.on("set:color", (e, t, n) => {
          e.return = Pm(n, this._config.format || "hsl");
        }), this.on("change:color", () => {
          this._hexColor = hg(this.color);
        }), this.on("change:_hexColor", () => {
          document.activeElement !== this.picker && this.picker.setAttribute("color", this._hexColor), hg(this.color) != hg(this._hexColor) && (this.color = this._hexColor);
        });
      }
      render() {
        var e, n;
        if (super.render(), e = "hex-color-picker", n = lg, void 0 === customElements.get(e) && customElements.define(e, n), this.picker = t.document.createElement("hex-color-picker"), this.picker.setAttribute("class", "hex-color-picker"), this.picker.setAttribute("tabindex", "-1"), this._createSlidersView(), this.element) {
          this.hexInputRow.element ? this.element.insertBefore(this.picker, this.hexInputRow.element) : this.element.appendChild(this.picker);
          const e = document.createElement("style");
          e.textContent = '[role="slider"]:focus [part$="pointer"] {border: 1px solid #fff;outline: 1px solid var(--ck-color-focus-border);box-shadow: 0 0 0 2px #fff;}', this.picker.shadowRoot.appendChild(e);
        }
        this.picker.addEventListener("color-changed", e => {
          const t = e.detail.value;
          this._debounceColorPickerEvent(t);
        });
      }
      focus() {
        if (!this._config.hideInput && (s.isGecko || s.isiOS || s.isSafari)) {
          this.hexInputRow.children.get(1).focus();
        }
        this.slidersView.first.focus();
      }
      _createSlidersView() {
        const e = [...this.picker.shadowRoot.children].filter(e => "slider" === e.getAttribute("role")).map(e => new mg(e));
        this.slidersView = this.createCollection(), e.forEach(e => {
          this.slidersView.add(e);
        });
      }
      _createInputRow() {
        const e = this._createColorInput();
        return new gg(this.locale, e);
      }
      _createColorInput() {
        const e = new Rm(this.locale, Bp),
          {
            t
          } = this.locale;
        return e.set({
          label: t("HEX"),
          class: "color-picker-hex-input"
        }), e.fieldView.bind("value").to(this, "_hexColor", t => e.isFocused ? e.fieldView.value : t.startsWith("#") ? t.substring(1) : t), e.fieldView.on("input", () => {
          const t = e.fieldView.element.value;
          if (t) {
            const e = fg(t);
            e && this._debounceColorPickerEvent(e);
          }
        }), e;
      }
      isValid() {
        const {
          t: e
        } = this.locale;
        return this.resetValidationStatus(), !!this.hexInputRow.getParsedColor() || (this.hexInputRow.inputView.errorText = e('Please enter a valid color (e.g. "ff0000").'), !1);
      }
      resetValidationStatus() {
        this.hexInputRow.inputView.errorText = null;
      }
    }
    function hg(e) {
      let t = function (e) {
        if (!e) return "";
        const t = zm(e);
        return t ? "hex" === t.space ? t.hexValue : Pm(e, "hex") : "#000";
      }(e);
      return t || (t = "#000"), 4 === t.length && (t = "#" + [t[1], t[1], t[2], t[2], t[3], t[3]].join("")), t.toLowerCase();
    }
    class mg extends Er {
      constructor(e) {
        super(), this.element = e;
      }
      focus() {
        this.element.focus();
      }
    }
    class pg extends Er {
      constructor(e) {
        super(e), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-picker__hash-view"]
          },
          children: "#"
        });
      }
    }
    class gg extends Er {
      constructor(e, t) {
        super(e), this.inputView = t, this.children = this.createCollection([new pg(), this.inputView]), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-picker__row"]
          },
          children: this.children
        });
      }
      getParsedColor() {
        return fg(this.inputView.fieldView.element.value);
      }
    }
    function fg(e) {
      if (!e) return null;
      const t = e.trim().replace(/^#/, "");
      return [3, 4, 6, 8].includes(t.length) && /^(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})$/.test(t) ? "#".concat(t) : null;
    }
    class kg extends q(qo) {
      constructor(e) {
        super(e), this.set("isEmpty", !0), this.on("change", () => {
          this.set("isEmpty", 0 === this.length);
        });
      }
      add(e, t) {
        return this.find(t => t.color === e.color) ? this : super.add(e, t);
      }
      hasColor(e) {
        return !!this.find(t => t.color === e);
      }
    }
    const {
      eraser: bg,
      colorPalette: _g
    } = Wh;
    class wg extends Er {
      constructor(e, _ref43) {
        let {
          colors: t,
          columns: n,
          removeButtonLabel: i,
          documentColorsLabel: o,
          documentColorsCount: r,
          colorPickerLabel: s,
          focusTracker: a,
          focusables: l
        } = _ref43;
        super(e);
        const c = this.bindTemplate;
        this.set("isVisible", !0), this.focusTracker = a, this.items = this.createCollection(), this.colorDefinitions = t, this.columns = n, this.documentColors = new kg(), this.documentColorsCount = r, this._focusables = l, this._removeButtonLabel = i, this._colorPickerLabel = s, this._documentColorsLabel = o, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-color-grids-fragment", c.if("isVisible", "ck-hidden", e => !e)]
          },
          children: this.items
        }), this.removeColorButtonView = this._createRemoveColorButton(), this.items.add(this.removeColorButtonView);
      }
      updateDocumentColors(e, t) {
        const n = e.document,
          i = this.documentColorsCount;
        this.documentColors.clear();
        for (const o of n.getRoots()) {
          const n = e.createRangeIn(o);
          for (const e of n.getItems()) if (e.is("$textProxy") && e.hasAttribute(t) && (this._addColorToDocumentColors(e.getAttribute(t)), this.documentColors.length >= i)) return;
        }
      }
      updateSelectedColors() {
        const e = this.documentColorsGrid,
          t = this.staticColorsGrid,
          n = this.selectedColor;
        t.selectedColor = n, e && (e.selectedColor = n);
      }
      render() {
        if (super.render(), this.staticColorsGrid = this._createStaticColorsGrid(), this.items.add(this.staticColorsGrid), this.documentColorsCount) {
          const e = tr.bind(this.documentColors, this.documentColors),
            t = new Zh(this.locale);
          t.text = this._documentColorsLabel, t.extendTemplate({
            attributes: {
              class: ["ck", "ck-color-grid__label", e.if("isEmpty", "ck-hidden")]
            }
          }), this.items.add(t), this.documentColorsGrid = this._createDocumentColorsGrid(), this.items.add(this.documentColorsGrid);
        }
        this._createColorPickerButton(), this._addColorSelectorElementsToFocusTracker();
      }
      focus() {
        this.removeColorButtonView.focus();
      }
      destroy() {
        super.destroy();
      }
      addColorPickerButton() {
        this.colorPickerButtonView && (this.items.add(this.colorPickerButtonView), this.focusTracker.add(this.colorPickerButtonView.element), this._focusables.add(this.colorPickerButtonView));
      }
      _addColorSelectorElementsToFocusTracker() {
        this.focusTracker.add(this.removeColorButtonView.element), this._focusables.add(this.removeColorButtonView), this.staticColorsGrid && (this.focusTracker.add(this.staticColorsGrid.element), this._focusables.add(this.staticColorsGrid)), this.documentColorsGrid && (this.focusTracker.add(this.documentColorsGrid.element), this._focusables.add(this.documentColorsGrid));
      }
      _createColorPickerButton() {
        this.colorPickerButtonView = new um(), this.colorPickerButtonView.set({
          label: this._colorPickerLabel,
          withText: !0,
          icon: _g,
          class: "ck-color-selector__color-picker"
        }), this.colorPickerButtonView.on("execute", () => {
          this.fire("colorPicker:show");
        });
      }
      _createRemoveColorButton() {
        const e = new um();
        return e.set({
          withText: !0,
          icon: bg,
          label: this._removeButtonLabel
        }), e.class = "ck-color-selector__remove-color", e.on("execute", () => {
          this.fire("execute", {
            value: null,
            source: "removeColorButton"
          });
        }), e.render(), e;
      }
      _createStaticColorsGrid() {
        const e = new Sm(this.locale, {
          colorDefinitions: this.colorDefinitions,
          columns: this.columns
        });
        return e.on("execute", (e, t) => {
          this.fire("execute", {
            value: t.value,
            source: "staticColorsGrid"
          });
        }), e;
      }
      _createDocumentColorsGrid() {
        const e = tr.bind(this.documentColors, this.documentColors),
          t = new Sm(this.locale, {
            columns: this.columns
          });
        return t.extendTemplate({
          attributes: {
            class: e.if("isEmpty", "ck-hidden")
          }
        }), t.items.bindTo(this.documentColors).using(e => {
          const t = new ym();
          return t.set({
            color: e.color,
            hasBorder: e.options && e.options.hasBorder
          }), e.label && t.set({
            label: e.label,
            tooltip: !0
          }), t.on("execute", () => {
            this.fire("execute", {
              value: e.color,
              source: "documentColorsGrid"
            });
          }), t;
        }), this.documentColors.on("change:isEmpty", (e, n, i) => {
          i && (t.selectedColor = null);
        }), t;
      }
      _addColorToDocumentColors(e) {
        const t = this.colorDefinitions.find(t => t.color === e);
        t ? this.documentColors.add(Object.assign({}, t)) : this.documentColors.add({
          color: e,
          label: e,
          options: {
            hasBorder: !1
          }
        });
      }
    }
    class Ag extends Er {
      constructor(e, _ref44) {
        let {
          focusTracker: t,
          focusables: n,
          keystrokes: i,
          colorPickerViewConfig: o
        } = _ref44;
        super(e), this.items = this.createCollection(), this.focusTracker = t, this.keystrokes = i, this.set("isVisible", !1), this.set("selectedColor", void 0), this._focusables = n, this._colorPickerViewConfig = o;
        const r = this.bindTemplate,
          {
            saveButtonView: s,
            cancelButtonView: a
          } = this._createActionButtons();
        this.saveButtonView = s, this.cancelButtonView = a, this.actionBarView = this._createActionBarView({
          saveButtonView: s,
          cancelButtonView: a
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-color-picker-fragment", r.if("isVisible", "ck-hidden", e => !e)]
          },
          children: this.items
        });
      }
      render() {
        super.render();
        const e = new ug(this.locale, {
          ...this._colorPickerViewConfig
        });
        this.colorPickerView = e, this.colorPickerView.render(), this.selectedColor && (e.color = this.selectedColor), this.listenTo(this, "change:selectedColor", (t, n, i) => {
          e.color = i;
        }), this.items.add(this.colorPickerView), this.items.add(this.actionBarView), this._addColorPickersElementsToFocusTracker(), this._stopPropagationOnArrowsKeys(), this._executeOnEnterPress(), this._executeUponColorChange();
      }
      destroy() {
        super.destroy();
      }
      focus() {
        this.colorPickerView.focus();
      }
      resetValidationStatus() {
        this.colorPickerView.resetValidationStatus();
      }
      _executeOnEnterPress() {
        this.keystrokes.set("enter", e => {
          this.isVisible && this.focusTracker.focusedElement !== this.cancelButtonView.element && this.colorPickerView.isValid() && (this.fire("execute", {
            value: this.selectedColor
          }), e.stopPropagation(), e.preventDefault());
        });
      }
      _stopPropagationOnArrowsKeys() {
        const e = e => e.stopPropagation();
        this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e);
      }
      _addColorPickersElementsToFocusTracker() {
        for (const e of this.colorPickerView.slidersView) this.focusTracker.add(e.element), this._focusables.add(e);
        const e = this.colorPickerView.hexInputRow.children.get(1);
        e.element && (this.focusTracker.add(e.element), this._focusables.add(e)), this.focusTracker.add(this.saveButtonView.element), this._focusables.add(this.saveButtonView), this.focusTracker.add(this.cancelButtonView.element), this._focusables.add(this.cancelButtonView);
      }
      _createActionBarView(_ref45) {
        let {
          saveButtonView: e,
          cancelButtonView: t
        } = _ref45;
        const n = new Er(),
          i = this.createCollection();
        return i.add(e), i.add(t), n.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-selector_action-bar"]
          },
          children: i
        }), n;
      }
      _createActionButtons() {
        const e = this.locale,
          t = e.t,
          n = new um(e),
          i = new um(e);
        return n.set({
          icon: Wh.check,
          class: "ck-button-save",
          type: "button",
          withText: !1,
          label: t("Accept")
        }), i.set({
          icon: Wh.cancel,
          class: "ck-button-cancel",
          type: "button",
          withText: !1,
          label: t("Cancel")
        }), n.on("execute", () => {
          this.colorPickerView.isValid() && this.fire("execute", {
            source: "colorPickerSaveButton",
            value: this.selectedColor
          });
        }), i.on("execute", () => {
          this.fire("colorPicker:cancel");
        }), {
          saveButtonView: n,
          cancelButtonView: i
        };
      }
      _executeUponColorChange() {
        this.colorPickerView.on("colorSelected", (e, t) => {
          this.fire("execute", {
            value: t.color,
            source: "colorPicker"
          }), this.set("selectedColor", t.color);
        });
      }
    }
    var vg = o(9576),
      Cg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(vg.A, Cg);
    vg.A.locals;
    class yg extends Er {
      constructor(e, _ref46) {
        let {
          colors: t,
          columns: n,
          removeButtonLabel: i,
          documentColorsLabel: o,
          documentColorsCount: r,
          colorPickerLabel: s,
          colorPickerViewConfig: a
        } = _ref46;
        super(e), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this._focusables = new er(), this._colorPickerViewConfig = a, this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.colorGridsFragmentView = new wg(e, {
          colors: t,
          columns: n,
          removeButtonLabel: i,
          documentColorsLabel: o,
          documentColorsCount: r,
          colorPickerLabel: s,
          focusTracker: this.focusTracker,
          focusables: this._focusables
        }), this.colorPickerFragmentView = new Ag(e, {
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokes: this.keystrokes,
          colorPickerViewConfig: a
        }), this.set("_isColorGridsFragmentVisible", !0), this.set("_isColorPickerFragmentVisible", !1), this.set("selectedColor", void 0), this.colorGridsFragmentView.bind("isVisible").to(this, "_isColorGridsFragmentVisible"), this.colorPickerFragmentView.bind("isVisible").to(this, "_isColorPickerFragmentVisible"), this.on("change:selectedColor", (e, t, n) => {
          this.colorGridsFragmentView.set("selectedColor", n), this.colorPickerFragmentView.set("selectedColor", n);
        }), this.colorGridsFragmentView.on("change:selectedColor", (e, t, n) => {
          this.set("selectedColor", n);
        }), this.colorPickerFragmentView.on("change:selectedColor", (e, t, n) => {
          this.set("selectedColor", n);
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-selector"]
          },
          children: this.items
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      appendUI() {
        this._appendColorGridsFragment(), this._colorPickerViewConfig && this._appendColorPickerFragment();
      }
      showColorPickerFragment() {
        this.colorPickerFragmentView.colorPickerView && !this._isColorPickerFragmentVisible && (this._isColorPickerFragmentVisible = !0, this.colorPickerFragmentView.focus(), this.colorPickerFragmentView.resetValidationStatus(), this._isColorGridsFragmentVisible = !1);
      }
      showColorGridsFragment() {
        this._isColorGridsFragmentVisible || (this._isColorGridsFragmentVisible = !0, this.colorGridsFragmentView.focus(), this._isColorPickerFragmentVisible = !1);
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      updateDocumentColors(e, t) {
        this.colorGridsFragmentView.updateDocumentColors(e, t);
      }
      updateSelectedColors() {
        this.colorGridsFragmentView.updateSelectedColors();
      }
      _appendColorGridsFragment() {
        this.items.length || (this.items.add(this.colorGridsFragmentView), this.colorGridsFragmentView.delegate("execute").to(this), this.colorGridsFragmentView.delegate("colorPicker:show").to(this));
      }
      _appendColorPickerFragment() {
        2 !== this.items.length && (this.items.add(this.colorPickerFragmentView), this.colorGridsFragmentView.colorPickerButtonView && this.colorGridsFragmentView.colorPickerButtonView.on("execute", () => {
          this.showColorPickerFragment();
        }), this.colorGridsFragmentView.addColorPickerButton(), this.colorPickerFragmentView.delegate("execute").to(this), this.colorPickerFragmentView.delegate("colorPicker:cancel").to(this));
      }
    }
    class xg {
      constructor(e) {
        this._components = new Map(), this.editor = e;
      }
      *names() {
        for (const e of this._components.values()) yield e.originalName;
      }
      add(e, t) {
        this._components.set(Eg(e), {
          callback: t,
          originalName: e
        });
      }
      create(e) {
        if (!this.has(e)) throw new _("componentfactory-item-missing", this, {
          name: e
        });
        return this._components.get(Eg(e)).callback(this.editor.locale);
      }
      has(e) {
        return this._components.has(Eg(e));
      }
    }
    function Eg(e) {
      return String(e).toLowerCase();
    }
    var Sg = o(3224),
      Dg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Sg.A, Dg);
    Sg.A.locals;
    class Tg extends Er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e);
        const n = this.bindTemplate;
        this.set("label", t.label || ""), this.set("class", t.class || null), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-form__header", n.to("class")]
          },
          children: this.children
        }), t.icon && (this.iconView = new am(), this.iconView.content = t.icon, this.children.add(this.iconView));
        const i = new Er(e);
        i.setTemplate({
          tag: "h2",
          attributes: {
            class: ["ck", "ck-form__header__label"],
            role: "presentation"
          },
          children: [{
            text: n.to("label")
          }]
        }), this.children.add(i);
      }
    }
    var Ig = o(6533),
      Bg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Ig.A, Bg);
    Ig.A.locals;
    class Mg extends Er {
      constructor(e) {
        super(e), this.children = this.createCollection(), this.keystrokes = new Wo(), this._focusTracker = new Ko(), this._focusables = new er(), this.focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this._focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog__actions"]
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element);
      }
      setButtons(e) {
        for (const t of e) {
          const e = new um(this.locale);
          let n;
          for (n in e.on("execute", () => t.onExecute()), t.onCreate && t.onCreate(e), t) "onExecute" != n && "onCreate" != n && e.set(n, t[n]);
          this.children.add(e);
        }
        this._updateFocusCyclableItems();
      }
      focus(e) {
        -1 === e ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
      }
      _updateFocusCyclableItems() {
        Array.from(this.children).forEach(e => {
          this._focusables.add(e), this._focusTracker.add(e.element);
        });
      }
    }
    class Pg extends Er {
      constructor(e) {
        super(e), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog__content"]
          },
          children: this.children
        });
      }
      reset() {
        for (; this.children.length;) this.children.remove(0);
      }
    }
    var zg = o(8390),
      Ng = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(zg.A, Ng);
    zg.A.locals;
    const Lg = "screen-center",
      Rg = "editor-center",
      Vg = "editor-top-side",
      Og = "editor-top-center",
      Fg = "editor-bottom-center",
      jg = "editor-above-center",
      Hg = "editor-below-center",
      Ug = qi("px");
    class qg extends function (e) {
      return class extends e {
        constructor() {
          super(...arguments), this._onDragBound = this._onDrag.bind(this), this._onDragEndBound = this._onDragEnd.bind(this), this._lastDraggingCoordinates = {
            x: 0,
            y: 0
          }, this.on("render", () => {
            this._attachListeners();
          }), this.set("isDragging", !1);
        }
        _attachListeners() {
          this.listenTo(this.element, "mousedown", this._onDragStart.bind(this)), this.listenTo(this.element, "touchstart", this._onDragStart.bind(this));
        }
        _attachDragListeners() {
          this.listenTo(t.document, "mouseup", this._onDragEndBound), this.listenTo(t.document, "touchend", this._onDragEndBound), this.listenTo(t.document, "mousemove", this._onDragBound), this.listenTo(t.document, "touchmove", this._onDragBound);
        }
        _detachDragListeners() {
          this.stopListening(t.document, "mouseup", this._onDragEndBound), this.stopListening(t.document, "touchend", this._onDragEndBound), this.stopListening(t.document, "mousemove", this._onDragBound), this.stopListening(t.document, "touchmove", this._onDragBound);
        }
        _onDragStart(e, t) {
          if (!this._isHandleElementPressed(t)) return;
          this._attachDragListeners();
          let n = 0,
            i = 0;
          t instanceof MouseEvent ? (n = t.clientX, i = t.clientY) : (n = t.touches[0].clientX, i = t.touches[0].clientY), this._lastDraggingCoordinates = {
            x: n,
            y: i
          }, this.isDragging = !0;
        }
        _onDrag(e, t) {
          if (!this.isDragging) return void this._detachDragListeners();
          let n = 0,
            i = 0;
          t instanceof MouseEvent ? (n = t.clientX, i = t.clientY) : (n = t.touches[0].clientX, i = t.touches[0].clientY), t.preventDefault(), this.fire("drag", {
            deltaX: Math.round(n - this._lastDraggingCoordinates.x),
            deltaY: Math.round(i - this._lastDraggingCoordinates.y)
          }), this._lastDraggingCoordinates = {
            x: n,
            y: i
          };
        }
        _onDragEnd() {
          this._detachDragListeners(), this.isDragging = !1;
        }
        _isHandleElementPressed(e) {
          return !!this.dragHandleElement && (this.dragHandleElement === e.target || e.target instanceof HTMLElement && this.dragHandleElement.contains(e.target));
        }
      };
    }(Er) {
      constructor(e, _ref47) {
        let {
          getCurrentDomRoot: t,
          getViewportOffset: n
        } = _ref47;
        super(e), this.wasMoved = !1;
        const i = this.bindTemplate,
          o = e.t;
        this.set("className", ""), this.set("ariaLabel", o("Editor dialog")), this.set("isModal", !1), this.set("position", Lg), this.set("_isVisible", !1), this.set("_isTransparent", !1), this.set("_top", 0), this.set("_left", 0), this._getCurrentDomRoot = t, this._getViewportOffset = n, this.decorate("moveTo"), this.parts = this.createCollection(), this.keystrokes = new Wo(), this.focusTracker = new Ko(), this._focusables = new er(), this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog-overlay", i.if("isModal", "ck-dialog-overlay__transparent", e => !e), i.if("_isVisible", "ck-hidden", e => !e)],
            tabindex: "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              tabindex: "-1",
              class: ["ck", "ck-dialog", i.to("className")],
              role: "dialog",
              "aria-label": i.to("ariaLabel"),
              style: {
                top: i.to("_top", e => Ug(e)),
                left: i.to("_left", e => Ug(e)),
                visibility: i.if("_isTransparent", "hidden")
              }
            },
            children: this.parts
          }]
        });
      }
      render() {
        super.render(), this.keystrokes.set("Esc", (e, t) => {
          this.fire("close", {
            source: "escKeyPress"
          }), t();
        }), this.on("drag", (e, _ref48) => {
          let {
            deltaX: t,
            deltaY: n
          } = _ref48;
          this.wasMoved = !0, this.moveBy(t, n);
        }), this.listenTo(t.window, "resize", () => {
          this._isVisible && !this.wasMoved && this.updatePosition();
        }), this.listenTo(t.document, "scroll", () => {
          this._isVisible && !this.wasMoved && this.updatePosition();
        }), this.on("change:_isVisible", (e, t, n) => {
          n && (this._isTransparent = !0, setTimeout(() => {
            this.updatePosition(), this._isTransparent = !1, this.focus();
          }, 10));
        }), this.keystrokes.listenTo(this.element);
      }
      get dragHandleElement() {
        return this.headerView ? this.headerView.element : null;
      }
      setupParts(_ref49) {
        let {
          icon: e,
          title: t,
          hasCloseButton: n = !0,
          content: i,
          actionButtons: o
        } = _ref49;
        t && (this.headerView = new Tg(this.locale, {
          icon: e
        }), n && (this.closeButtonView = this._createCloseButton(), this.headerView.children.add(this.closeButtonView)), this.headerView.label = t, this.ariaLabel = t, this.parts.add(this.headerView, 0)), i && (i instanceof Er && (i = [i]), this.contentView = new Pg(this.locale), this.contentView.children.addMany(i), this.parts.add(this.contentView)), o && (this.actionsView = new Mg(this.locale), this.actionsView.setButtons(o), this.parts.add(this.actionsView)), this._updateFocusCyclableItems();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      moveTo(e, t) {
        const n = this._getViewportRect(),
          i = this._getDialogRect();
        e + i.width > n.right && (e = n.right - i.width), e < n.left && (e = n.left), t < n.top && (t = n.top), this._moveTo(e, t);
      }
      _moveTo(e, t) {
        this._left = e, this._top = t;
      }
      moveBy(e, t) {
        this.moveTo(this._left + e, this._top + t);
      }
      _moveOffScreen() {
        this._moveTo(-9999, -9999);
      }
      updatePosition() {
        if (!this.element || !this.element.parentNode) return;
        const e = this._getViewportRect();
        let t,
          n = this.position;
        this._getCurrentDomRoot() ? t = this._getVisibleDomRootRect(e) : n = Lg;
        const i = qg.defaultOffset,
          o = this._getDialogRect();
        switch (n) {
          case Vg:
            if (t) {
              const e = "ltr" === this.locale.contentLanguageDirection ? t.right - o.width - i : t.left + i;
              this.moveTo(e, t.top + i);
            } else this._moveOffScreen();
            break;
          case Rg:
            t ? this.moveTo(Math.round(t.left + t.width / 2 - o.width / 2), Math.round(t.top + t.height / 2 - o.height / 2)) : this._moveOffScreen();
            break;
          case Lg:
            this.moveTo(Math.round((e.width - o.width) / 2), Math.round((e.height - o.height) / 2));
            break;
          case Og:
            t ? this.moveTo(Math.round(t.left + t.width / 2 - o.width / 2), t.top + i) : this._moveOffScreen();
            break;
          case Fg:
            t ? this.moveTo(Math.round(t.left + t.width / 2 - o.width / 2), t.bottom - o.height - i) : this._moveOffScreen();
            break;
          case jg:
            t ? this.moveTo(Math.round(t.left + t.width / 2 - o.width / 2), t.top - o.height - i) : this._moveOffScreen();
            break;
          case Hg:
            t ? this.moveTo(Math.round(t.left + t.width / 2 - o.width / 2), t.bottom + i) : this._moveOffScreen();
        }
      }
      _getVisibleDomRootRect(e) {
        let t = new Li(this._getCurrentDomRoot()).getVisible();
        return t ? (t = e.getIntersection(t), t || null) : null;
      }
      _getDialogRect() {
        return new Li(this.element.firstElementChild);
      }
      _getViewportRect() {
        return function (e) {
          e = Object.assign({
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }, e);
          const n = new Li(t.window);
          return n.top += e.top, n.height -= e.top, n.bottom -= e.bottom, n.height -= e.bottom, n.left += e.left, n.right -= e.right, n.width -= e.left + e.right, n;
        }(this._getViewportOffset());
      }
      _updateFocusCyclableItems() {
        const e = [];
        if (this.contentView) for (const t of this.contentView.children) ep(t) && e.push(t);
        this.actionsView && e.push(this.actionsView), this.closeButtonView && e.push(this.closeButtonView), e.forEach(e => {
          var t;
          this._focusables.add(e), this.focusTracker.add(e.element), ep(t = e) && "focusCycler" in t && t.focusCycler instanceof Jm && (this.listenTo(e.focusCycler, "forwardCycle", e => {
            this._focusCycler.focusNext(), this._focusCycler.next !== this._focusCycler.focusables.get(this._focusCycler.current) && e.stop();
          }), this.listenTo(e.focusCycler, "backwardCycle", e => {
            this._focusCycler.focusPrevious(), this._focusCycler.previous !== this._focusCycler.focusables.get(this._focusCycler.current) && e.stop();
          }));
        });
      }
      _createCloseButton() {
        const e = new um(this.locale),
          t = this.locale.t;
        return e.set({
          label: t("Close"),
          tooltip: !0,
          icon: Wh.cancel
        }), e.on("execute", () => this.fire("close", {
          source: "closeButton"
        })), e;
      }
    }
    qg.defaultOffset = 15;
    const Gg = qg;
    class Kg extends Br {
      static get pluginName() {
        return "Dialog";
      }
      constructor(e) {
        super(e);
        const t = e.t;
        this._initShowHideListeners(), this._initFocusToggler(), this._initMultiRootIntegration(), this.set("id", null), e.accessibility.addKeystrokeInfos({
          categoryId: "navigation",
          keystrokes: [{
            label: t("Move focus in and out of an active dialog window"),
            keystroke: "Ctrl+F6",
            mayRequireFn: !0
          }]
        });
      }
      _initShowHideListeners() {
        this.on("show", (e, t) => {
          this._show(t);
        }), this.on("show", (e, t) => {
          t.onShow && t.onShow(this);
        }, {
          priority: "low"
        }), this.on("hide", () => {
          Kg._visibleDialogPlugin && Kg._visibleDialogPlugin._hide();
        }), this.on("hide", () => {
          this._onHide && (this._onHide(this), this._onHide = void 0);
        }, {
          priority: "low"
        });
      }
      _initFocusToggler() {
        const e = this.editor;
        e.keystrokes.set("Ctrl+F6", (t, n) => {
          this.isOpen && !this.view.isModal && (this.view.focusTracker.isFocused ? e.editing.view.focus() : this.view.focus(), n());
        });
      }
      _initMultiRootIntegration() {
        const e = this.editor.model;
        e.document.on("change:data", () => {
          if (!this.view) return;
          const t = e.document.differ.getChangedRoots();
          for (const e of t) e.state && this.view.updatePosition();
        });
      }
      show(e) {
        this.hide(), this.fire("show:".concat(e.id), e);
      }
      _show(_ref50) {
        let {
          id: e,
          icon: t,
          title: n,
          hasCloseButton: i = !0,
          content: o,
          actionButtons: r,
          className: s,
          isModal: a,
          position: l,
          onHide: c
        } = _ref50;
        const d = this.editor;
        this.view = new Gg(d.locale, {
          getCurrentDomRoot: () => d.editing.view.getDomRoot(d.model.document.selection.anchor.root.rootName),
          getViewportOffset: () => d.ui.viewportOffset
        });
        const u = this.view;
        u.on("close", () => {
          this.hide();
        }), d.ui.view.body.add(u), d.ui.focusTracker.add(u.element), d.keystrokes.listenTo(u.element), l || (l = a ? Lg : Rg), u.set({
          position: l,
          _isVisible: !0,
          className: s,
          isModal: a
        }), u.setupParts({
          icon: t,
          title: n,
          hasCloseButton: i,
          content: o,
          actionButtons: r
        }), this.id = e, c && (this._onHide = c), this.isOpen = !0, Kg._visibleDialogPlugin = this;
      }
      hide() {
        Kg._visibleDialogPlugin && Kg._visibleDialogPlugin.fire("hide:".concat(Kg._visibleDialogPlugin.id));
      }
      _hide() {
        if (!this.view) return;
        const e = this.editor,
          t = this.view;
        t.contentView && t.contentView.reset(), e.ui.view.body.remove(t), e.ui.focusTracker.remove(t.element), e.keystrokes.stopListening(t.element), t.destroy(), e.editing.view.focus(), this.id = null, this.isOpen = !1, Kg._visibleDialogPlugin = null;
      }
    }
    var Wg = o(3617),
      Yg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Wg.A, Yg);
    Wg.A.locals;
    const $g = qi("px"),
      Zg = t.document.body,
      Qg = {
        top: -99999,
        left: -99999,
        name: "arrowless",
        config: {
          withArrow: !1
        }
      };
    class Jg extends Er {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.set("top", 0), this.set("left", 0), this.set("position", "arrow_nw"), this.set("isVisible", !1), this.set("withArrow", !0), this.set("class", void 0), this._pinWhenIsVisibleCallback = null, this.content = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", t.to("position", e => "ck-balloon-panel_".concat(e)), t.if("isVisible", "ck-balloon-panel_visible"), t.if("withArrow", "ck-balloon-panel_with-arrow"), t.to("class")],
            style: {
              top: t.to("top", $g),
              left: t.to("left", $g)
            }
          },
          children: this.content
        });
      }
      show() {
        this.isVisible = !0;
      }
      hide() {
        this.isVisible = !1;
      }
      attachTo(e) {
        this.show();
        const t = Jg.defaultPositions,
          n = Object.assign({}, {
            element: this.element,
            positions: [t.southArrowNorth, t.southArrowNorthMiddleWest, t.southArrowNorthMiddleEast, t.southArrowNorthWest, t.southArrowNorthEast, t.northArrowSouth, t.northArrowSouthMiddleWest, t.northArrowSouthMiddleEast, t.northArrowSouthWest, t.northArrowSouthEast, t.viewportStickyNorth],
            limiter: Zg,
            fitInViewport: !0
          }, e),
          i = Jg._getOptimalPosition(n) || Qg,
          o = parseInt(i.left),
          r = parseInt(i.top),
          s = i.name,
          a = i.config || {},
          {
            withArrow: l = !0
          } = a;
        this.top = r, this.left = o, this.position = s, this.withArrow = l;
      }
      pin(e) {
        this.unpin(), this._pinWhenIsVisibleCallback = () => {
          this.isVisible ? this._startPinning(e) : this._stopPinning();
        }, this._startPinning(e), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
      }
      unpin() {
        this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
      }
      _startPinning(e) {
        this.attachTo(e);
        const n = ef(e.target),
          i = e.limiter ? ef(e.limiter) : Zg;
        this.listenTo(t.document, "scroll", (t, o) => {
          const r = o.target,
            s = n && r.contains(n),
            a = i && r.contains(i);
          !s && !a && n && i || this.attachTo(e);
        }, {
          useCapture: !0
        }), this.listenTo(t.window, "resize", () => {
          this.attachTo(e);
        });
      }
      _stopPinning() {
        this.stopListening(t.document, "scroll"), this.stopListening(t.window, "resize");
      }
    }
    Jg.arrowSideOffset = 25, Jg.arrowHeightOffset = 10, Jg.stickyVerticalOffset = 20, Jg._getOptimalPosition = Zi, Jg.defaultPositions = tf();
    const Xg = Jg;
    function ef(e) {
      return Ai(e) ? e : Pi(e) ? e.commonAncestorContainer : "function" == typeof e ? ef(e()) : null;
    }
    function tf() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const {
        sideOffset: t = Jg.arrowSideOffset,
        heightOffset: n = Jg.arrowHeightOffset,
        stickyVerticalOffset: i = Jg.stickyVerticalOffset,
        config: o
      } = e;
      return {
        northWestArrowSouthWest: (e, n) => ({
          top: r(e, n),
          left: e.left - t,
          name: "arrow_sw",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouthMiddleWest: (e, n) => ({
          top: r(e, n),
          left: e.left - .25 * n.width - t,
          name: "arrow_smw",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouth: (e, t) => ({
          top: r(e, t),
          left: e.left - t.width / 2,
          name: "arrow_s",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouthMiddleEast: (e, n) => ({
          top: r(e, n),
          left: e.left - .75 * n.width + t,
          name: "arrow_sme",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouthEast: (e, n) => ({
          top: r(e, n),
          left: e.left - n.width + t,
          name: "arrow_se",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthWest: (e, n) => ({
          top: r(e, n),
          left: e.left + e.width / 2 - t,
          name: "arrow_sw",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthMiddleWest: (e, n) => ({
          top: r(e, n),
          left: e.left + e.width / 2 - .25 * n.width - t,
          name: "arrow_smw",
          ...(o && {
            config: o
          })
        }),
        northArrowSouth: (e, t) => ({
          top: r(e, t),
          left: e.left + e.width / 2 - t.width / 2,
          name: "arrow_s",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthMiddleEast: (e, n) => ({
          top: r(e, n),
          left: e.left + e.width / 2 - .75 * n.width + t,
          name: "arrow_sme",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthEast: (e, n) => ({
          top: r(e, n),
          left: e.left + e.width / 2 - n.width + t,
          name: "arrow_se",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthWest: (e, n) => ({
          top: r(e, n),
          left: e.right - t,
          name: "arrow_sw",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthMiddleWest: (e, n) => ({
          top: r(e, n),
          left: e.right - .25 * n.width - t,
          name: "arrow_smw",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouth: (e, t) => ({
          top: r(e, t),
          left: e.right - t.width / 2,
          name: "arrow_s",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthMiddleEast: (e, n) => ({
          top: r(e, n),
          left: e.right - .75 * n.width + t,
          name: "arrow_sme",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthEast: (e, n) => ({
          top: r(e, n),
          left: e.right - n.width + t,
          name: "arrow_se",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthWest: e => ({
          top: s(e),
          left: e.left - t,
          name: "arrow_nw",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthMiddleWest: (e, n) => ({
          top: s(e),
          left: e.left - .25 * n.width - t,
          name: "arrow_nmw",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorth: (e, t) => ({
          top: s(e),
          left: e.left - t.width / 2,
          name: "arrow_n",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthMiddleEast: (e, n) => ({
          top: s(e),
          left: e.left - .75 * n.width + t,
          name: "arrow_nme",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthEast: (e, n) => ({
          top: s(e),
          left: e.left - n.width + t,
          name: "arrow_ne",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthWest: e => ({
          top: s(e),
          left: e.left + e.width / 2 - t,
          name: "arrow_nw",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthMiddleWest: (e, n) => ({
          top: s(e),
          left: e.left + e.width / 2 - .25 * n.width - t,
          name: "arrow_nmw",
          ...(o && {
            config: o
          })
        }),
        southArrowNorth: (e, t) => ({
          top: s(e),
          left: e.left + e.width / 2 - t.width / 2,
          name: "arrow_n",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthMiddleEast: (e, n) => ({
          top: s(e),
          left: e.left + e.width / 2 - .75 * n.width + t,
          name: "arrow_nme",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthEast: (e, n) => ({
          top: s(e),
          left: e.left + e.width / 2 - n.width + t,
          name: "arrow_ne",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthWest: e => ({
          top: s(e),
          left: e.right - t,
          name: "arrow_nw",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthMiddleWest: (e, n) => ({
          top: s(e),
          left: e.right - .25 * n.width - t,
          name: "arrow_nmw",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorth: (e, t) => ({
          top: s(e),
          left: e.right - t.width / 2,
          name: "arrow_n",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthMiddleEast: (e, n) => ({
          top: s(e),
          left: e.right - .75 * n.width + t,
          name: "arrow_nme",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthEast: (e, n) => ({
          top: s(e),
          left: e.right - n.width + t,
          name: "arrow_ne",
          ...(o && {
            config: o
          })
        }),
        westArrowEast: (e, t) => ({
          top: e.top + e.height / 2 - t.height / 2,
          left: e.left - t.width - n,
          name: "arrow_e",
          ...(o && {
            config: o
          })
        }),
        eastArrowWest: (e, t) => ({
          top: e.top + e.height / 2 - t.height / 2,
          left: e.right + n,
          name: "arrow_w",
          ...(o && {
            config: o
          })
        }),
        viewportStickyNorth: (e, t, n, r) => {
          const s = r || n;
          return e.getIntersection(s) ? s.height - e.height > i ? null : {
            top: s.top + i,
            left: e.left + e.width / 2 - t.width / 2,
            name: "arrowless",
            config: {
              withArrow: !1,
              ...o
            }
          } : null;
        }
      };
      function r(e, t) {
        return e.top - t.height - n;
      }
      function s(e) {
        return e.bottom + n;
      }
    }
    var nf = o(2424),
      of = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(nf.A, of);
    nf.A.locals;
    const rf = "ck-tooltip";
    class sf extends Di() {
      constructor(e) {
        if (super(), this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this._resizeObserver = null, this._mutationObserver = null, sf._editors.add(e), sf._instance) return sf._instance;
        sf._instance = this, this.tooltipTextView = new Er(e.locale), this.tooltipTextView.set("text", ""), this.tooltipTextView.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip__text"]
          },
          children: [{
            text: this.tooltipTextView.bindTemplate.to("text")
          }]
        }), this.balloonPanelView = new Xg(e.locale), this.balloonPanelView.class = rf, this.balloonPanelView.content.add(this.tooltipTextView), this._mutationObserver = function (e) {
          const t = new MutationObserver(() => {
            e();
          });
          return {
            attach(e) {
              t.observe(e, {
                attributes: !0,
                attributeFilter: ["data-cke-tooltip-text", "data-cke-tooltip-position"]
              });
            },
            detach() {
              t.disconnect();
            }
          };
        }(() => {
          this._updateTooltipPosition();
        }), this._pinTooltipDebounced = gl(this._pinTooltip, 600), this._unpinTooltipDebounced = gl(this._unpinTooltip, 400), this.listenTo(t.document, "keydown", this._onKeyDown.bind(this), {
          useCapture: !0
        }), this.listenTo(t.document, "mouseenter", this._onEnterOrFocus.bind(this), {
          useCapture: !0
        }), this.listenTo(t.document, "mouseleave", this._onLeaveOrBlur.bind(this), {
          useCapture: !0
        }), this.listenTo(t.document, "focus", this._onEnterOrFocus.bind(this), {
          useCapture: !0
        }), this.listenTo(t.document, "blur", this._onLeaveOrBlur.bind(this), {
          useCapture: !0
        }), this.listenTo(t.document, "scroll", this._onScroll.bind(this), {
          useCapture: !0
        }), this._watchdogExcluded = !0;
      }
      destroy(e) {
        const t = e.ui.view && e.ui.view.body;
        sf._editors.delete(e), this.stopListening(e.ui), t && t.has(this.balloonPanelView) && t.remove(this.balloonPanelView), sf._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), sf._instance = null);
      }
      static getPositioningFunctions(e) {
        const t = sf.defaultBalloonPositions;
        return {
          s: [t.southArrowNorth, t.southArrowNorthEast, t.southArrowNorthWest],
          n: [t.northArrowSouth],
          e: [t.eastArrowWest],
          w: [t.westArrowEast],
          sw: [t.southArrowNorthEast],
          se: [t.southArrowNorthWest]
        }[e];
      }
      _onKeyDown(e, t) {
        "Escape" === t.key && this._currentElementWithTooltip && (this._unpinTooltip(), t.stopPropagation());
      }
      _onEnterOrFocus(e, _ref51) {
        let {
          target: t
        } = _ref51;
        const n = lf(t);
        n ? n !== this._currentElementWithTooltip && (this._unpinTooltip(), this._pinTooltipDebounced(n, cf(n))) : "focus" === e.name && this._unpinTooltip();
      }
      _onLeaveOrBlur(e, _ref52) {
        let {
          target: t,
          relatedTarget: n
        } = _ref52;
        if ("mouseleave" === e.name) {
          if (!Ai(t)) return;
          const e = this.balloonPanelView.element,
            i = e && (e === n || e.contains(n)),
            o = !i && t === e;
          if (i) return void this._unpinTooltipDebounced.cancel();
          if (!o && this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
          const r = lf(t),
            s = lf(n);
          (o || r && r !== s) && this._unpinTooltipDebounced();
        } else {
          if (this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
          this._unpinTooltipDebounced();
        }
      }
      _onScroll(e, _ref53) {
        let {
          target: t
        } = _ref53;
        this._currentElementWithTooltip && (t.contains(this.balloonPanelView.element) && t.contains(this._currentElementWithTooltip) || this._unpinTooltip());
      }
      _pinTooltip(e, _ref54) {
        let {
          text: t,
          position: n,
          cssClass: i
        } = _ref54;
        this._unpinTooltip();
        const o = Go(sf._editors.values()).ui.view.body;
        o.has(this.balloonPanelView) || o.add(this.balloonPanelView), this.tooltipTextView.text = t, this.balloonPanelView.pin({
          target: e,
          positions: sf.getPositioningFunctions(n)
        }), this._resizeObserver = new Hi(e, () => {
          $i(e) || this._unpinTooltip();
        }), this._mutationObserver.attach(e), this.balloonPanelView.class = [rf, i].filter(e => e).join(" ");
        for (const e of sf._editors) this.listenTo(e.ui, "update", this._updateTooltipPosition.bind(this), {
          priority: "low"
        });
        this._currentElementWithTooltip = e, this._currentTooltipPosition = n;
      }
      _unpinTooltip() {
        this._unpinTooltipDebounced.cancel(), this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
        for (const e of sf._editors) this.stopListening(e.ui, "update");
        this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this.tooltipTextView.text = "", this._resizeObserver && this._resizeObserver.destroy(), this._mutationObserver.detach();
      }
      _updateTooltipPosition() {
        if (!this._currentElementWithTooltip) return;
        const e = cf(this._currentElementWithTooltip);
        $i(this._currentElementWithTooltip) && e.text ? this.balloonPanelView.pin({
          target: this._currentElementWithTooltip,
          positions: sf.getPositioningFunctions(e.position)
        }) : this._unpinTooltip();
      }
    }
    sf.defaultBalloonPositions = tf({
      heightOffset: 5,
      sideOffset: 13
    }), sf._editors = new Set(), sf._instance = null;
    const af = sf;
    function lf(e) {
      return Ai(e) ? e.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
    }
    function cf(e) {
      return {
        text: e.dataset.ckeTooltipText,
        position: e.dataset.ckeTooltipPosition || "s",
        cssClass: e.dataset.ckeTooltipClass || ""
      };
    }
    const df = function (e, t, n) {
        var i = !0,
          o = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return R(n) && (i = "leading" in n ? !!n.leading : i, o = "trailing" in n ? !!n.trailing : o), gl(e, t, {
          leading: i,
          maxWait: t,
          trailing: o
        });
      },
      uf = 50,
      hf = 350,
      mf = "Powered by";
    class pf extends Di() {
      constructor(e) {
        super(), this.editor = e, this._balloonView = null, this._lastFocusedEditableElement = null, this._showBalloonThrottled = df(this._showBalloon.bind(this), 50, {
          leading: !0
        }), e.on("ready", this._handleEditorReady.bind(this));
      }
      destroy() {
        const e = this._balloonView;
        e && (e.unpin(), this._balloonView = null), this._showBalloonThrottled.cancel(), this.stopListening();
      }
      _handleEditorReady() {
        const e = this.editor;
        (!!e.config.get("ui.poweredBy.forceVisible") || "VALID" !== function (e) {
          function t(e) {
            return e.length >= 40 && e.length <= 255 ? "VALID" : "INVALID";
          }
          if (!e) return "INVALID";
          let n = "";
          try {
            n = atob(e);
          } catch (e) {
            return "INVALID";
          }
          const i = n.split("-"),
            o = i[0],
            r = i[1];
          if (!r) return t(e);
          try {
            atob(r);
          } catch (n) {
            try {
              if (atob(o), !atob(o).length) return t(e);
            } catch (n) {
              return t(e);
            }
          }
          if (o.length < 40 || o.length > 255) return "INVALID";
          let s = "";
          try {
            atob(o), s = atob(r);
          } catch (e) {
            return "INVALID";
          }
          if (8 !== s.length) return "INVALID";
          const a = Number(s.substring(0, 4)),
            l = Number(s.substring(4, 6)) - 1,
            c = Number(s.substring(6, 8)),
            d = new Date(a, l, c);
          return d < y || isNaN(Number(d)) ? "INVALID" : "VALID";
        }(e.config.get("licenseKey"))) && e.ui.view && (e.ui.focusTracker.on("change:isFocused", (e, t, n) => {
          this._updateLastFocusedEditableElement(), n ? this._showBalloon() : this._hideBalloon();
        }), e.ui.focusTracker.on("change:focusedElement", (e, t, n) => {
          this._updateLastFocusedEditableElement(), n && this._showBalloon();
        }), e.ui.on("update", () => {
          this._showBalloonThrottled();
        }));
      }
      _createBalloonView() {
        const e = this.editor,
          t = this._balloonView = new Xg(),
          n = kf(e),
          i = new gf(e.locale, n.label);
        t.content.add(i), t.set({
          class: "ck-powered-by-balloon"
        }), e.ui.view.body.add(t), e.ui.focusTracker.add(t.element), this._balloonView = t;
      }
      _showBalloon() {
        if (!this._lastFocusedEditableElement) return;
        const e = function (e, t) {
          const n = kf(e),
            i = "right" === n.side ? function (e, t) {
              return ff(e, t, (e, n) => e.left + e.width - n.width - t.horizontalOffset);
            }(t, n) : function (e, t) {
              return ff(e, t, e => e.left + t.horizontalOffset);
            }(t, n);
          return {
            target: t,
            positions: [i]
          };
        }(this.editor, this._lastFocusedEditableElement);
        e && (this._balloonView || this._createBalloonView(), this._balloonView.pin(e));
      }
      _hideBalloon() {
        this._balloonView && this._balloonView.unpin();
      }
      _updateLastFocusedEditableElement() {
        const e = this.editor,
          t = e.ui.focusTracker.isFocused,
          n = e.ui.focusTracker.focusedElement;
        if (!t || !n) return void (this._lastFocusedEditableElement = null);
        const i = Array.from(e.ui.getEditableElementsNames()).map(t => e.ui.getEditableElement(t));
        i.includes(n) ? this._lastFocusedEditableElement = n : this._lastFocusedEditableElement = i[0];
      }
    }
    class gf extends Er {
      constructor(e, t) {
        super(e);
        const n = new am(),
          i = this.bindTemplate;
        n.set({
          content: '<svg xmlns="http://www.w3.org/2000/svg" width="53" height="10" viewBox="0 0 53 10"><path fill="#1C2331" d="M31.724 1.492a15.139 15.139 0 0 0 .045 1.16 2.434 2.434 0 0 0-.687-.34 3.68 3.68 0 0 0-1.103-.166 2.332 2.332 0 0 0-1.14.255 1.549 1.549 0 0 0-.686.87c-.15.41-.225.98-.225 1.712 0 .939.148 1.659.444 2.161.297.503.792.754 1.487.754.452.015.9-.094 1.294-.316.296-.174.557-.4.771-.669l.14.852h1.282V.007h-1.623v1.485ZM31 6.496a1.77 1.77 0 0 1-.494.061.964.964 0 0 1-.521-.127.758.758 0 0 1-.296-.466 3.984 3.984 0 0 1-.093-.992 4.208 4.208 0 0 1 .098-1.052.753.753 0 0 1 .307-.477 1.08 1.08 0 0 1 .55-.122c.233-.004.466.026.69.089l.483.144v2.553c-.11.076-.213.143-.307.2a1.73 1.73 0 0 1-.417.189ZM35.68 0l-.702.004c-.322.002-.482.168-.48.497l.004.581c.002.33.164.493.486.49l.702-.004c.322-.002.481-.167.48-.496L36.165.49c-.002-.33-.164-.493-.486-.491ZM36.145 2.313l-1.612.01.034 5.482 1.613-.01-.035-5.482ZM39.623.79 37.989.8 38 2.306l-.946.056.006 1.009.949-.006.024 2.983c.003.476.143.844.419 1.106.275.26.658.39 1.148.387.132 0 .293-.01.483-.03.19-.02.38-.046.57-.08.163-.028.324-.068.482-.119l-.183-1.095-.702.004a.664.664 0 0 1-.456-.123.553.553 0 0 1-.14-.422l-.016-2.621 1.513-.01-.006-1.064-1.514.01-.01-1.503ZM46.226 2.388c-.41-.184-.956-.274-1.636-.27-.673.004-1.215.101-1.627.29-.402.179-.72.505-.888.91-.18.419-.268.979-.264 1.68.004.688.1 1.24.285 1.655.172.404.495.724.9.894.414.18.957.268 1.63.264.68-.004 1.224-.099 1.632-.284.4-.176.714-.501.878-.905.176-.418.263-.971.258-1.658-.004-.702-.097-1.261-.28-1.677a1.696 1.696 0 0 0-.888-.9Zm-.613 3.607a.77.77 0 0 1-.337.501 1.649 1.649 0 0 1-1.317.009.776.776 0 0 1-.343-.497 4.066 4.066 0 0 1-.105-1.02 4.136 4.136 0 0 1 .092-1.03.786.786 0 0 1 .337-.507 1.59 1.59 0 0 1 1.316-.008.79.79 0 0 1 .344.502c.078.337.113.683.105 1.03.012.343-.019.685-.092 1.02ZM52.114 2.07a2.67 2.67 0 0 0-1.128.278c-.39.191-.752.437-1.072.73l-.157-.846-1.273.008.036 5.572 1.623-.01-.024-3.78c.35-.124.646-.22.887-.286.26-.075.53-.114.8-.118l.45-.003.144-1.546-.286.001ZM22.083 7.426l-1.576-2.532a2.137 2.137 0 0 0-.172-.253 1.95 1.95 0 0 0-.304-.29.138.138 0 0 1 .042-.04 1.7 1.7 0 0 0 .328-.374l1.75-2.71c.01-.015.025-.028.024-.048-.01-.01-.021-.007-.031-.007L20.49 1.17a.078.078 0 0 0-.075.045l-.868 1.384c-.23.366-.46.732-.688 1.099a.108.108 0 0 1-.112.06c-.098-.005-.196-.001-.294-.002-.018 0-.038.006-.055-.007.002-.02.002-.039.005-.058a4.6 4.6 0 0 0 .046-.701V1.203c0-.02-.009-.032-.03-.03h-.033L16.93 1.17c-.084 0-.073-.01-.073.076v6.491c-.001.018.006.028.025.027h1.494c.083 0 .072.007.072-.071v-2.19c0-.055-.003-.11-.004-.166a3.366 3.366 0 0 0-.05-.417h.06c.104 0 .209.002.313-.002a.082.082 0 0 1 .084.05c.535.913 1.07 1.824 1.607 2.736a.104.104 0 0 0 .103.062c.554-.003 1.107-.002 1.66-.002l.069-.003-.019-.032-.188-.304ZM27.112 6.555c-.005-.08-.004-.08-.082-.08h-2.414c-.053 0-.106-.003-.159-.011a.279.279 0 0 1-.246-.209.558.558 0 0 1-.022-.15c0-.382 0-.762-.002-1.143 0-.032.007-.049.042-.044h2.504c.029.003.037-.012.034-.038V3.814c0-.089.013-.078-.076-.078h-2.44c-.07 0-.062.003-.062-.06v-.837c0-.047.004-.093.013-.14a.283.283 0 0 1 .241-.246.717.717 0 0 1 .146-.011h2.484c.024.002.035-.009.036-.033l.003-.038.03-.496c.01-.183.024-.365.034-.548.005-.085.003-.087-.082-.094-.218-.018-.437-.038-.655-.05a17.845 17.845 0 0 0-.657-.026 72.994 72.994 0 0 0-1.756-.016 1.7 1.7 0 0 0-.471.064 1.286 1.286 0 0 0-.817.655c-.099.196-.149.413-.145.633v3.875c0 .072.003.144.011.216a1.27 1.27 0 0 0 .711 1.029c.228.113.48.167.734.158.757-.005 1.515.002 2.272-.042.274-.016.548-.034.82-.053.03-.002.043-.008.04-.041-.008-.104-.012-.208-.019-.312a69.964 69.964 0 0 1-.05-.768ZM16.14 7.415l-.127-1.075c-.004-.03-.014-.04-.044-.037a13.125 13.125 0 0 1-.998.073c-.336.01-.672.02-1.008.016-.116-.001-.233-.014-.347-.039a.746.746 0 0 1-.45-.262c-.075-.1-.132-.211-.167-.33a3.324 3.324 0 0 1-.126-.773 9.113 9.113 0 0 1-.015-.749c0-.285.022-.57.065-.852.023-.158.066-.312.127-.46a.728.728 0 0 1 .518-.443 1.64 1.64 0 0 1 .397-.048c.628-.001 1.255.003 1.882.05.022.001.033-.006.036-.026l.003-.031.06-.55c.019-.177.036-.355.057-.532.004-.034-.005-.046-.04-.056a5.595 5.595 0 0 0-1.213-.21 10.783 10.783 0 0 0-.708-.02c-.24-.003-.48.01-.719.041a3.477 3.477 0 0 0-.625.14 1.912 1.912 0 0 0-.807.497c-.185.2-.33.433-.424.688a4.311 4.311 0 0 0-.24 1.096c-.031.286-.045.572-.042.86-.006.43.024.86.091 1.286.04.25.104.497.193.734.098.279.26.53.473.734.214.205.473.358.756.446.344.11.702.17 1.063.177a8.505 8.505 0 0 0 1.578-.083 6.11 6.11 0 0 0 .766-.18c.03-.008.047-.023.037-.057a.157.157 0 0 1-.003-.025Z"/><path fill="#AFE229" d="M6.016 6.69a1.592 1.592 0 0 0-.614.21c-.23.132-.422.32-.56.546-.044.072-.287.539-.287.539l-.836 1.528.009.006c.038.025.08.046.123.063.127.046.26.07.395.073.505.023 1.011-.007 1.517-.003.29.009.58.002.869-.022a.886.886 0 0 0 .395-.116.962.962 0 0 0 .312-.286c.056-.083.114-.163.164-.249.24-.408.48-.816.718-1.226.075-.128.148-.257.222-.386l.112-.192a1.07 1.07 0 0 0 .153-.518l-1.304.023s-1.258-.005-1.388.01Z"/><path fill="#771BFF" d="m2.848 9.044.76-1.39.184-.352c-.124-.067-.245-.14-.367-.21-.346-.204-.706-.384-1.045-.6a.984.984 0 0 1-.244-.207c-.108-.134-.136-.294-.144-.46-.021-.409-.002-.818-.009-1.227-.003-.195 0-.39.003-.585.004-.322.153-.553.427-.713l.833-.488c.22-.13.44-.257.662-.385.05-.029.105-.052.158-.077.272-.128.519-.047.76.085l.044.028c.123.06.242.125.358.196.318.178.635.357.952.537.095.056.187.117.275.184.194.144.254.35.266.578.016.284.007.569.006.853-.001.28.004.558 0 .838.592-.003 1.259 0 1.259 0l.723-.013c-.003-.292-.007-.584-.007-.876 0-.524.015-1.048-.016-1.571-.024-.42-.135-.8-.492-1.067a5.02 5.02 0 0 0-.506-.339A400.52 400.52 0 0 0 5.94.787C5.722.664 5.513.524 5.282.423 5.255.406 5.228.388 5.2.373 4.758.126 4.305-.026 3.807.21c-.097.046-.197.087-.29.14A699.896 699.896 0 0 0 .783 1.948c-.501.294-.773.717-.778 1.31-.004.36-.009.718-.001 1.077.016.754-.017 1.508.024 2.261.016.304.07.6.269.848.127.15.279.28.448.382.622.4 1.283.734 1.92 1.11l.183.109Z"/></svg>\n',
          isColorInherited: !1
        }), n.extendTemplate({
          attributes: {
            style: {
              width: "53px",
              height: "10px"
            }
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-powered-by"],
            "aria-hidden": !0
          },
          children: [{
            tag: "a",
            attributes: {
              href: "https://ckeditor.com/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
              target: "_blank",
              tabindex: "-1"
            },
            children: [...(t ? [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-powered-by__label"]
              },
              children: [t]
            }] : []), n],
            on: {
              dragstart: i.to(e => e.preventDefault())
            }
          }]
        });
      }
    }
    function ff(e, t, n) {
      return (i, o) => {
        const r = new Li(e);
        if (r.width < hf || r.height < uf) return null;
        let s;
        s = "inside" === t.position ? r.bottom - o.height : r.bottom - o.height / 2, s -= t.verticalOffset;
        const a = n(r, o),
          l = i.clone().moveTo(a, s).getIntersection(o.clone().moveTo(a, s)).getVisible();
        return !l || l.getArea() < o.getArea() ? null : {
          top: s,
          left: a,
          name: "position_".concat(t.position, "-side_").concat(t.side),
          config: {
            withArrow: !1
          }
        };
      };
    }
    function kf(e) {
      const t = e.config.get("ui.poweredBy"),
        n = t && t.position || "border";
      return {
        position: n,
        label: mf,
        verticalOffset: "inside" === n ? 5 : 0,
        horizontalOffset: 5,
        side: "ltr" === e.locale.contentLanguageDirection ? "right" : "left",
        ...t
      };
    }
    var bf = o(1836),
      _f = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(bf.A, _f);
    bf.A.locals;
    const wf = {
      POLITE: "polite",
      ASSERTIVE: "assertive"
    };
    class Af {
      constructor(e) {
        this.editor = e, e.once("ready", () => {
          for (const e of Object.values(wf)) this.announce("", e);
        });
      }
      announce(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : wf.POLITE;
        const n = this.editor;
        if (!n.ui.view) return;
        this.view || (this.view = new vf(n.locale), n.ui.view.body.add(this.view));
        const {
          politeness: i,
          isUnsafeHTML: o
        } = "string" == typeof t ? {
          politeness: t
        } : t;
        let r = this.view.regionViews.find(e => e.politeness === i);
        r || (r = new Cf(n, i), this.view.regionViews.add(r)), r.announce({
          announcement: e,
          isUnsafeHTML: o
        });
      }
    }
    class vf extends Er {
      constructor(e) {
        super(e), this.regionViews = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-aria-live-announcer"]
          },
          children: this.regionViews
        });
      }
    }
    class Cf extends Er {
      constructor(e, t) {
        super(e.locale), this.setTemplate({
          tag: "div",
          attributes: {
            role: "region",
            "aria-live": t,
            "aria-relevant": "additions"
          },
          children: [{
            tag: "ul",
            attributes: {
              class: ["ck", "ck-aria-live-region-list"]
            }
          }]
        }), e.on("destroy", () => {
          null !== this._pruneAnnouncementsInterval && (clearInterval(this._pruneAnnouncementsInterval), this._pruneAnnouncementsInterval = null);
        }), this.politeness = t, this._domConverter = e.data.htmlProcessor.domConverter, this._pruneAnnouncementsInterval = setInterval(() => {
          this.element && this._listElement.firstChild && this._listElement.firstChild.remove();
        }, 5e3);
      }
      announce(_ref55) {
        let {
          announcement: e,
          isUnsafeHTML: t
        } = _ref55;
        if (!e.trim().length) return;
        const n = document.createElement("li");
        t ? this._domConverter.setContentOf(n, e) : n.innerText = e, this._listElement.appendChild(n);
      }
      get _listElement() {
        return this.element.querySelector("ul");
      }
    }
    class yf extends q() {
      constructor(e) {
        super(), this.isReady = !1, this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [];
        const t = e.editing.view;
        this.editor = e, this.componentFactory = new xg(e), this.focusTracker = new Ko(), this.tooltipManager = new af(e), this.poweredBy = new pf(e), this.ariaLiveAnnouncer = new Af(e), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this.once("ready", () => {
          this.isReady = !0;
        }), this.listenTo(t.document, "layoutChanged", this.update.bind(this)), this.listenTo(t, "scrollToTheSelection", this._handleScrollToTheSelection.bind(this)), this._initFocusTracking();
      }
      get element() {
        return null;
      }
      update() {
        this.fire("update");
      }
      destroy() {
        this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor), this.poweredBy.destroy();
        for (const e of this._editableElementsMap.values()) e.ckeditorInstance = null, this.editor.keystrokes.stopListening(e);
        this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [];
      }
      setEditableElement(e, t) {
        this._editableElementsMap.set(e, t), t.ckeditorInstance || (t.ckeditorInstance = this.editor), this.focusTracker.add(t);
        const n = () => {
          this.editor.editing.view.getDomRoot(e) || this.editor.keystrokes.listenTo(t);
        };
        this.isReady ? n() : this.once("ready", n);
      }
      removeEditableElement(e) {
        const t = this._editableElementsMap.get(e);
        t && (this._editableElementsMap.delete(e), this.editor.keystrokes.stopListening(t), this.focusTracker.remove(t), t.ckeditorInstance = null);
      }
      getEditableElement() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this._editableElementsMap.get(e);
      }
      getEditableElementsNames() {
        return this._editableElementsMap.keys();
      }
      addToolbar(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        e.isRendered ? (this.focusTracker.add(e.element), this.editor.keystrokes.listenTo(e.element)) : e.once("render", () => {
          this.focusTracker.add(e.element), this.editor.keystrokes.listenTo(e.element);
        }), this._focusableToolbarDefinitions.push({
          toolbarView: e,
          options: t
        });
      }
      get _editableElements() {
        return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
          editorUI: this
        }), this._editableElementsMap;
      }
      _readViewportOffsetFromConfig() {
        const e = this.editor,
          t = e.config.get("ui.viewportOffset");
        if (t) return t;
        const n = e.config.get("toolbar.viewportTopOffset");
        return n ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
          top: n
        }) : {
          top: 0
        };
      }
      _initFocusTracking() {
        const e = this.editor,
          t = e.editing.view;
        let n, i;
        e.keystrokes.set("Alt+F10", (e, o) => {
          const r = this.focusTracker.focusedElement;
          Array.from(this._editableElementsMap.values()).includes(r) && !Array.from(t.domRoots.values()).includes(r) && (n = r);
          const s = this._getCurrentFocusedToolbarDefinition();
          s && i || (i = this._getFocusableCandidateToolbarDefinitions());
          for (let e = 0; e < i.length; e++) {
            const e = i.shift();
            if (i.push(e), e !== s && this._focusFocusableCandidateToolbar(e)) {
              s && s.options.afterBlur && s.options.afterBlur();
              break;
            }
          }
          o();
        }), e.keystrokes.set("Esc", (t, i) => {
          const o = this._getCurrentFocusedToolbarDefinition();
          o && (n ? (n.focus(), n = null) : e.editing.view.focus(), o.options.afterBlur && o.options.afterBlur(), i());
        });
      }
      _getFocusableCandidateToolbarDefinitions() {
        const e = [];
        for (const t of this._focusableToolbarDefinitions) {
          const {
            toolbarView: n,
            options: i
          } = t;
          ($i(n.element) || i.beforeFocus) && e.push(t);
        }
        return e.sort((e, t) => xf(e) - xf(t)), e;
      }
      _getCurrentFocusedToolbarDefinition() {
        for (const e of this._focusableToolbarDefinitions) if (e.toolbarView.element && e.toolbarView.element.contains(this.focusTracker.focusedElement)) return e;
        return null;
      }
      _focusFocusableCandidateToolbar(e) {
        const {
          toolbarView: t,
          options: {
            beforeFocus: n
          }
        } = e;
        return n && n(), !!$i(t.element) && (t.focus(), !0);
      }
      _handleScrollToTheSelection(e, t) {
        const n = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          ...this.viewportOffset
        };
        t.viewportOffset.top += n.top, t.viewportOffset.bottom += n.bottom, t.viewportOffset.left += n.left, t.viewportOffset.right += n.right;
      }
    }
    function xf(e) {
      const {
        toolbarView: t,
        options: n
      } = e;
      let i = 10;
      return $i(t.element) && i--, n.isContextual && i--, i;
    }
    var Ef = o(6888),
      Sf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Ef.A, Sf);
    Ef.A.locals;
    class Df extends Er {
      constructor(e) {
        super(e), this.body = new im(e);
      }
      render() {
        super.render(), this.body.attachToDom();
      }
      destroy() {
        return this.body.detachFromDom(), super.destroy();
      }
    }
    class Tf extends Df {
      constructor(e) {
        super(e), this.top = this.createCollection(), this.main = this.createCollection(), this._voiceLabelView = this._createVoiceLabel(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: e.uiLanguageDirection,
            lang: e.uiLanguage,
            "aria-labelledby": this._voiceLabelView.id
          },
          children: [this._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: this.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: this.main
          }]
        });
      }
      _createVoiceLabel() {
        const e = this.t,
          t = new Zh();
        return t.text = e("Rich Text Editor"), t.extendTemplate({
          attributes: {
            class: "ck-voice-label"
          }
        }), t;
      }
    }
    class If extends Er {
      constructor(e, t, n) {
        super(e), this.name = null, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: e.contentLanguage,
            dir: e.contentLanguageDirection
          }
        }), this.set("isFocused", !1), this._editableElement = n, this._hasExternalElement = !!this._editableElement, this._editingView = t;
      }
      render() {
        super.render(), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", () => this._updateIsFocusedClasses()), this._updateIsFocusedClasses();
      }
      destroy() {
        this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
      }
      get hasExternalElement() {
        return this._hasExternalElement;
      }
      _updateIsFocusedClasses() {
        const e = this._editingView;
        function t(t) {
          e.change(n => {
            const i = e.document.getRoot(t.name);
            n.addClass(t.isFocused ? "ck-focused" : "ck-blurred", i), n.removeClass(t.isFocused ? "ck-blurred" : "ck-focused", i);
          });
        }
        e.isRenderingInProgress ? function n(i) {
          e.once("change:isRenderingInProgress", (e, o, r) => {
            r ? n(i) : t(i);
          });
        }(this) : t(this);
      }
    }
    class Bf extends If {
      constructor(e, t, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super(e, t, n);
        const o = e.t;
        this.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        }), this._generateLabel = i.label || (() => o("Editor editing area: %0", this.name));
      }
      render() {
        super.render();
        const e = this._editingView;
        e.change(t => {
          const n = e.document.getRoot(this.name);
          t.setAttribute("aria-label", this._generateLabel(this), n);
        });
      }
    }
    class Mf extends Vr {
      static get pluginName() {
        return "Notification";
      }
      init() {
        this.on("show:warning", (e, t) => {
          window.alert(t.message);
        }, {
          priority: "lowest"
        });
      }
      showSuccess(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._showNotification({
          message: e,
          type: "success",
          namespace: t.namespace,
          title: t.title
        });
      }
      showInfo(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._showNotification({
          message: e,
          type: "info",
          namespace: t.namespace,
          title: t.title
        });
      }
      showWarning(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._showNotification({
          message: e,
          type: "warning",
          namespace: t.namespace,
          title: t.title
        });
      }
      _showNotification(e) {
        const t = e.namespace ? "show:".concat(e.type, ":").concat(e.namespace) : "show:".concat(e.type);
        this.fire(t, {
          message: e.message,
          type: e.type,
          title: e.title || ""
        });
      }
    }
    class Pf extends q() {
      constructor(e, t) {
        super(), t && Xa(this, t), e && this.set(e);
      }
    }
    var zf = o(9432),
      Nf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(zf.A, Nf);
    zf.A.locals;
    var Lf = o(3449),
      Rf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Lf.A, Rf);
    Lf.A.locals;
    const Vf = qi("px");
    class Of extends Br {
      static get pluginName() {
        return "ContextualBalloon";
      }
      constructor(e) {
        super(e), this._viewToStack = new Map(), this._idToStack = new Map(), this._view = null, this._rotatorView = null, this._fakePanelsView = null, this.positionLimiter = () => {
          const e = this.editor.editing.view,
            t = e.document.selection.editableElement;
          return t ? e.domConverter.mapViewToDom(t.root) : null;
        }, this.set("visibleView", null), this.set("_numberOfStacks", 0), this.set("_singleViewMode", !1);
      }
      destroy() {
        super.destroy(), this._view && this._view.destroy(), this._rotatorView && this._rotatorView.destroy(), this._fakePanelsView && this._fakePanelsView.destroy();
      }
      get view() {
        return this._view || this._createPanelView(), this._view;
      }
      hasView(e) {
        return Array.from(this._viewToStack.keys()).includes(e);
      }
      add(e) {
        if (this._view || this._createPanelView(), this.hasView(e.view)) throw new _("contextualballoon-add-view-exist", [this, e]);
        const t = e.stackId || "main";
        if (!this._idToStack.has(t)) return this._idToStack.set(t, new Map([[e.view, e]])), this._viewToStack.set(e.view, this._idToStack.get(t)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !e.singleViewMode || this.showStack(t));
        const n = this._idToStack.get(t);
        e.singleViewMode && this.showStack(t), n.set(e.view, e), this._viewToStack.set(e.view, n), n === this._visibleStack && this._showView(e);
      }
      remove(e) {
        if (!this.hasView(e)) throw new _("contextualballoon-remove-view-not-exist", [this, e]);
        const t = this._viewToStack.get(e);
        this._singleViewMode && this.visibleView === e && (this._singleViewMode = !1), this.visibleView === e && (1 === t.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(t.values())[t.size - 2])), 1 === t.size ? (this._idToStack.delete(this._getStackId(t)), this._numberOfStacks = this._idToStack.size) : t.delete(e), this._viewToStack.delete(e);
      }
      updatePosition(e) {
        e && (this._visibleStack.get(this.visibleView).position = e), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
      }
      showStack(e) {
        this.visibleStack = e;
        const t = this._idToStack.get(e);
        if (!t) throw new _("contextualballoon-showstack-stack-not-exist", this);
        this._visibleStack !== t && this._showView(Array.from(t.values()).pop());
      }
      _createPanelView() {
        this._view = new Xg(this.editor.locale), this.editor.ui.view.body.add(this._view), this.editor.ui.focusTracker.add(this._view.element), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
      }
      get _visibleStack() {
        return this._viewToStack.get(this.visibleView);
      }
      _getStackId(e) {
        return Array.from(this._idToStack.entries()).find(t => t[1] === e)[0];
      }
      _showNextStack() {
        const e = Array.from(this._idToStack.values());
        let t = e.indexOf(this._visibleStack) + 1;
        e[t] || (t = 0), this.showStack(this._getStackId(e[t]));
      }
      _showPrevStack() {
        const e = Array.from(this._idToStack.values());
        let t = e.indexOf(this._visibleStack) - 1;
        e[t] || (t = e.length - 1), this.showStack(this._getStackId(e[t]));
      }
      _createRotatorView() {
        const e = new Ff(this.editor.locale),
          t = this.editor.locale.t;
        return this.view.content.add(e), e.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (e, t) => !t && e > 1), e.on("change:isNavigationVisible", () => this.updatePosition(), {
          priority: "low"
        }), e.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (e, n) => {
          if (n < 2) return "";
          const i = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
          return t("%0 of %1", [i, n]);
        }), e.buttonNextView.on("execute", () => {
          e.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
        }), e.buttonPrevView.on("execute", () => {
          e.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
        }), e;
      }
      _createFakePanelsView() {
        const e = new jf(this.editor.locale, this.view);
        return e.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (e, t) => !t && e >= 2 ? Math.min(e - 1, 2) : 0), e.listenTo(this.view, "change:top", () => e.updatePosition()), e.listenTo(this.view, "change:left", () => e.updatePosition()), this.editor.ui.view.body.add(e), e;
      }
      _showView(_ref56) {
        let {
          view: e,
          balloonClassName: t = "",
          withArrow: n = !0,
          singleViewMode: i = !1
        } = _ref56;
        this.view.class = t, this.view.withArrow = n, this._rotatorView.showView(e), this.visibleView = e, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), i && (this._singleViewMode = !0);
      }
      _getBalloonPosition() {
        let e = Array.from(this._visibleStack.values()).pop().position;
        return e && (e.limiter || (e = Object.assign({}, e, {
          limiter: this.positionLimiter
        })), e = Object.assign({}, e, {
          viewportOffsetConfig: this.editor.ui.viewportOffset
        })), e;
      }
    }
    class Ff extends Er {
      constructor(e) {
        super(e);
        const t = e.t,
          n = this.bindTemplate;
        this.set("isNavigationVisible", !0), this.focusTracker = new Ko(), this.buttonPrevView = this._createButtonView(t("Previous"), Wh.previousArrow), this.buttonNextView = this._createButtonView(t("Next"), Wh.nextArrow), this.content = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", e => e ? "" : "ck-hidden")]
            },
            children: [this.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, this.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: this.content
          }]
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy();
      }
      showView(e) {
        this.hideView(), this.content.add(e);
      }
      hideView() {
        this.content.clear();
      }
      _createButtonView(e, t) {
        const n = new um(this.locale);
        return n.set({
          label: e,
          icon: t,
          tooltip: !0
        }), n;
      }
    }
    class jf extends Er {
      constructor(e, t) {
        super(e);
        const n = this.bindTemplate;
        this.set("top", 0), this.set("left", 0), this.set("height", 0), this.set("width", 0), this.set("numberOfPanels", 0), this.content = this.createCollection(), this._balloonPanelView = t, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", e => e ? "" : "ck-hidden")],
            style: {
              top: n.to("top", Vf),
              left: n.to("left", Vf),
              width: n.to("width", Vf),
              height: n.to("height", Vf)
            }
          },
          children: this.content
        }), this.on("change:numberOfPanels", (e, t, n, i) => {
          n > i ? this._addPanels(n - i) : this._removePanels(i - n), this.updatePosition();
        });
      }
      _addPanels(e) {
        for (; e--;) {
          const e = new Er();
          e.setTemplate({
            tag: "div"
          }), this.content.add(e), this.registerChild(e);
        }
      }
      _removePanels(e) {
        for (; e--;) {
          const e = this.content.last;
          this.content.remove(e), this.deregisterChild(e), e.destroy();
        }
      }
      updatePosition() {
        if (this.numberOfPanels) {
          const {
              top: e,
              left: t
            } = this._balloonPanelView,
            {
              width: n,
              height: i
            } = new Li(this._balloonPanelView.element);
          Object.assign(this, {
            top: e,
            left: t,
            width: n,
            height: i
          });
        }
      }
    }
    var Hf = o(4315),
      Uf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Hf.A, Uf);
    Hf.A.locals;
    const qf = qi("px");
    class Gf extends Er {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.set("isActive", !1), this.set("isSticky", !1), this.set("limiterElement", null), this.set("limiterBottomOffset", 50), this.set("viewportTopOffset", 0), this.set("_marginLeft", null), this.set("_isStickyToTheBottomOfLimiter", !1), this.set("_stickyTopOffset", null), this.set("_stickyBottomOffset", null), this.content = this.createCollection(), this._contentPanelPlaceholder = new tr({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: t.to("isSticky", e => e ? "block" : "none"),
              height: t.to("isSticky", e => e ? qf(this._contentPanelRect.height) : null)
            }
          }
        }).render(), this.contentPanelElement = new tr({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", t.if("isSticky", "ck-sticky-panel__content_sticky"), t.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: t.to("isSticky", e => e ? qf(this._contentPanelPlaceholder.getBoundingClientRect().width) : null),
              top: t.to("_stickyTopOffset", e => e ? qf(e) : e),
              bottom: t.to("_stickyBottomOffset", e => e ? qf(e) : e),
              marginLeft: t.to("_marginLeft")
            }
          },
          children: this.content
        }).render(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [this._contentPanelPlaceholder, this.contentPanelElement]
        });
      }
      render() {
        super.render(), this.checkIfShouldBeSticky(), this.listenTo(t.document, "scroll", () => {
          this.checkIfShouldBeSticky();
        }, {
          useCapture: !0
        }), this.listenTo(this, "change:isActive", () => {
          this.checkIfShouldBeSticky();
        });
      }
      checkIfShouldBeSticky() {
        if (!this.limiterElement || !this.isActive) return void this._unstick();
        const e = new Li(this.limiterElement);
        let n = e.getVisible();
        if (n) {
          const e = new Li(t.window);
          e.top += this.viewportTopOffset, e.height -= this.viewportTopOffset, n = n.getIntersection(e);
        }
        if (n && e.top < n.top) {
          const t = n.top;
          if (t + this._contentPanelRect.height + this.limiterBottomOffset > n.bottom) {
            const t = Math.max(e.bottom - n.bottom, 0) + this.limiterBottomOffset;
            e.bottom - t > e.top + this._contentPanelRect.height ? this._stickToBottomOfLimiter(t) : this._unstick();
          } else this._contentPanelRect.height + this.limiterBottomOffset < e.height ? this._stickToTopOfAncestors(t) : this._unstick();
        } else this._unstick();
      }
      _stickToTopOfAncestors(e) {
        this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = e, this._stickyBottomOffset = null, this._marginLeft = qf(-t.window.scrollX);
      }
      _stickToBottomOfLimiter(e) {
        this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !0, this._stickyTopOffset = null, this._stickyBottomOffset = e, this._marginLeft = qf(-t.window.scrollX);
      }
      _unstick() {
        this.isSticky = !1, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = null, this._stickyBottomOffset = null, this._marginLeft = null;
      }
      get _contentPanelRect() {
        return new Li(this.contentPanelElement);
      }
    }
    class Kf extends Rm {
      constructor(e, t) {
        const n = e.t,
          i = Object.assign({}, {
            showResetButton: !0,
            showIcon: !0,
            creator: Bp
          }, t);
        super(e, i.creator), this.label = t.label, this._viewConfig = i, this._viewConfig.showIcon && (this.iconView = new am(), this.iconView.content = Wh.loupe, this.fieldWrapperChildren.add(this.iconView, 0), this.extendTemplate({
          attributes: {
            class: "ck-search__query_with-icon"
          }
        })), this._viewConfig.showResetButton && (this.resetButtonView = new um(e), this.resetButtonView.set({
          label: n("Clear"),
          icon: Wh.cancel,
          class: "ck-search__reset",
          isVisible: !1,
          tooltip: !0
        }), this.resetButtonView.on("execute", () => {
          this.reset(), this.focus(), this.fire("reset");
        }), this.resetButtonView.bind("isVisible").to(this.fieldView, "isEmpty", e => !e), this.fieldWrapperChildren.add(this.resetButtonView), this.extendTemplate({
          attributes: {
            class: "ck-search__query_with-reset"
          }
        }));
      }
      reset() {
        this.fieldView.reset(), this._viewConfig.showResetButton && (this.resetButtonView.isVisible = !1);
      }
    }
    class Wf extends Er {
      constructor() {
        super();
        const e = this.bindTemplate;
        this.set({
          isVisible: !1,
          primaryText: "",
          secondaryText: ""
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search__info", e.if("isVisible", "ck-hidden", e => !e)],
            tabindex: -1
          },
          children: [{
            tag: "span",
            children: [{
              text: [e.to("primaryText")]
            }]
          }, {
            tag: "span",
            children: [{
              text: [e.to("secondaryText")]
            }]
          }]
        });
      }
      focus() {
        this.element.focus();
      }
    }
    class Yf extends Er {
      constructor(e) {
        super(e), this.children = this.createCollection(), this.focusTracker = new Ko(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search__results"],
            tabindex: -1
          },
          children: this.children
        }), this._focusCycler = new Jm({
          focusables: this.children,
          focusTracker: this.focusTracker
        });
      }
      render() {
        super.render();
        for (const e of this.children) this.focusTracker.add(e.element);
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusFirst() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
    }
    var $f = /[\\^$.*+?()[\]{}|]/g,
      Zf = RegExp($f.source);
    const Qf = function (e) {
      return (e = _s(e)) && Zf.test(e) ? e.replace($f, "\\$&") : e;
    };
    var Jf = o(610),
      Xf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Jf.A, Xf);
    Jf.A.locals;
    class ek extends Er {
      constructor(e, t) {
        super(e), this._config = t, this.filteredView = t.filteredView, this.queryView = this._createSearchTextQueryView(), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.resultsView = new Yf(e), this.children = this.createCollection(), this.focusableChildren = this.createCollection([this.queryView, this.resultsView]), this.set("isEnabled", !0), this.set("resultsCount", 0), this.set("totalItemsCount", 0), t.infoView && t.infoView.instance ? this.infoView = t.infoView.instance : (this.infoView = new Wf(), this._enableDefaultInfoViewBehavior(), this.on("render", () => {
          this.search("");
        })), this.resultsView.children.addMany([this.infoView, this.filteredView]), this.focusCycler = new Jm({
          focusables: this.focusableChildren,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.on("search", (e, _ref57) => {
          let {
            resultsCount: t,
            totalItemsCount: n
          } = _ref57;
          this.resultsCount = t, this.totalItemsCount = n;
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search", t.class || null],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.children.addMany([this.queryView, this.resultsView]);
        const e = e => e.stopPropagation();
        for (const e of this.focusableChildren) this.focusTracker.add(e.element);
        this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e);
      }
      focus() {
        this.queryView.focus();
      }
      reset() {
        this.queryView.reset(), this.search("");
      }
      search(e) {
        const t = e ? new RegExp(Qf(e), "ig") : null,
          n = this.filteredView.filter(t);
        this.fire("search", {
          query: e,
          ...n
        });
      }
      _createSearchTextQueryView() {
        const e = new Kf(this.locale, this._config.queryView);
        return this.listenTo(e.fieldView, "input", () => {
          this.search(e.fieldView.element.value);
        }), e.on("reset", () => this.reset()), e.bind("isEnabled").to(this), e;
      }
      _enableDefaultInfoViewBehavior() {
        const e = this.locale.t,
          t = this.infoView;
        function n(e, _ref58) {
          let {
            query: t,
            resultsCount: n,
            totalItemsCount: i
          } = _ref58;
          return "function" == typeof e ? e(t, n, i) : e;
        }
        this.on("search", (i, o) => {
          if (o.resultsCount) t.set({
            isVisible: !1
          });else {
            const i = this._config.infoView && this._config.infoView.text;
            let r, s;
            o.totalItemsCount ? i && i.notFound ? (r = i.notFound.primary, s = i.notFound.secondary) : (r = e("No results found"), s = "") : i && i.noSearchableItems ? (r = i.noSearchableItems.primary, s = i.noSearchableItems.secondary) : (r = e("No searchable items"), s = ""), t.set({
              primaryText: n(r, o),
              secondaryText: n(s, o),
              isVisible: !0
            });
          }
        });
      }
    }
    var tk = o(5558),
      nk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(tk.A, nk);
    tk.A.locals;
    class ik extends ek {
      constructor(e, n) {
        super(e, n), this._config = n;
        const i = qi("px");
        this.extendTemplate({
          attributes: {
            class: ["ck-autocomplete"]
          }
        });
        const o = this.resultsView.bindTemplate;
        this.resultsView.set("isVisible", !1), this.resultsView.set("_position", "s"), this.resultsView.set("_width", 0), this.resultsView.extendTemplate({
          attributes: {
            class: [o.if("isVisible", "ck-hidden", e => !e), o.to("_position", e => "ck-search__results_".concat(e))],
            style: {
              width: o.to("_width", i)
            }
          }
        }), this.focusTracker.on("change:isFocused", (e, t, i) => {
          this._updateResultsVisibility(), i ? this.resultsView.element.scrollTop = 0 : n.resetOnBlur && this.queryView.reset();
        }), this.on("search", () => {
          this._updateResultsVisibility(), this._updateResultsViewWidthAndPosition();
        }), this.keystrokes.set("esc", (e, t) => {
          this.resultsView.isVisible && (this.queryView.focus(), this.resultsView.isVisible = !1, t());
        }), this.listenTo(t.document, "scroll", () => {
          this._updateResultsViewWidthAndPosition();
        }), this.on("change:isEnabled", () => {
          this._updateResultsVisibility();
        }), this.filteredView.on("execute", (e, _ref59) => {
          let {
            value: t
          } = _ref59;
          this.focus(), this.reset(), this.queryView.fieldView.value = this.queryView.fieldView.element.value = t, this.resultsView.isVisible = !1;
        }), this.resultsView.on("change:isVisible", () => {
          this._updateResultsViewWidthAndPosition();
        });
      }
      _updateResultsViewWidthAndPosition() {
        if (!this.resultsView.isVisible) return;
        this.resultsView._width = new Li(this.queryView.fieldView.element).width;
        const e = ik._getOptimalPosition({
          element: this.resultsView.element,
          target: this.queryView.element,
          fitInViewport: !0,
          positions: ik.defaultResultsPositions
        });
        this.resultsView._position = e ? e.name : "s";
      }
      _updateResultsVisibility() {
        const e = void 0 === this._config.queryMinChars ? 0 : this._config.queryMinChars,
          t = this.queryView.fieldView.element.value.length;
        this.resultsView.isVisible = this.focusTracker.isFocused && this.isEnabled && t >= e;
      }
    }
    ik.defaultResultsPositions = [e => ({
      top: e.bottom,
      left: e.left,
      name: "s"
    }), (e, t) => ({
      top: e.top - t.height,
      left: e.left,
      name: "n"
    })], ik._getOptimalPosition = Zi;
    const ok = function (e) {
      return function (t) {
        return null == e ? void 0 : e[t];
      };
    };
    ok({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    });
    var rk = /[&<>"']/g;
    RegExp(rk.source);
    var sk = o(6580),
      ak = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(sk.A, ak);
    sk.A.locals;
    var lk = o(4944),
      ck = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(lk.A, ck);
    lk.A.locals;
    qi("px");
    var dk = o(4893),
      uk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(dk.A, uk);
    dk.A.locals, qi("px");
    qi("px");
    var hk = o(2833),
      mk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(hk.A, mk);
    hk.A.locals;
    class pk extends um {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.set({
          withText: !0,
          role: "menuitem"
        }), this.arrowView = this._createArrowView(), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__button"],
            "aria-haspopup": !0,
            "aria-expanded": this.bindTemplate.to("isOn", e => String(e)),
            "data-cke-tooltip-disabled": t.to("isOn")
          },
          on: {
            mouseenter: t.to("mouseenter")
          }
        });
      }
      render() {
        super.render(), this.children.add(this.arrowView);
      }
      _createArrowView() {
        const e = new am();
        return e.content = km, e.extendTemplate({
          attributes: {
            class: "ck-menu-bar__menu__button__arrow"
          }
        }), e;
      }
    }
    var gk = o(5092),
      fk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(gk.A, fk);
    gk.A.locals;
    class kk extends up {
      constructor(e, t) {
        super(e);
        const n = this.bindTemplate;
        this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item"]
          },
          on: {
            mouseenter: n.to("mouseenter")
          }
        }), this.delegate("mouseenter").to(t);
      }
    }
    const bk = {
        toggleMenusAndFocusItemsOnHover(e) {
          e.on("menu:mouseenter", t => {
            if (e.isOpen) {
              for (const n of e.menus) {
                const e = t.path[0],
                  i = e instanceof kk && e.children.first === n;
                n.isOpen = (t.path.includes(n) || i) && n.isEnabled;
              }
              t.source.focus();
            }
          });
        },
        focusCycleMenusOnArrows(e) {
          const t = "rtl" === e.locale.uiLanguageDirection;
          function n(t, n) {
            const i = e.children.getIndex(t),
              o = t.isOpen,
              r = e.children.length,
              s = e.children.get((i + r + n) % r);
            t.isOpen = !1, o && (s.isOpen = !0), s.buttonView.focus();
          }
          e.on("menu:arrowright", e => {
            n(e.source, t ? -1 : 1);
          }), e.on("menu:arrowleft", e => {
            n(e.source, t ? 1 : -1);
          });
        },
        closeMenusWhenTheBarCloses(e) {
          e.on("change:isOpen", () => {
            e.isOpen || e.menus.forEach(e => {
              e.isOpen = !1;
            });
          });
        },
        closeMenuWhenAnotherOnTheSameLevelOpens(e) {
          e.on("menu:change:isOpen", (t, n, i) => {
            i && e.menus.filter(e => t.source.parentMenuView === e.parentMenuView && t.source !== e && e.isOpen).forEach(e => {
              e.isOpen = !1;
            });
          });
        },
        closeOnClickOutside(e) {
          Sr({
            emitter: e,
            activator: () => e.isOpen,
            callback: () => e.close(),
            contextElements: () => e.children.map(e => e.element)
          });
        }
      },
      _k = {
        openAndFocusPanelOnArrowDownKey(e) {
          e.keystrokes.set("arrowdown", (t, n) => {
            e.focusTracker.focusedElement === e.buttonView.element && (e.isOpen || (e.isOpen = !0), e.panelView.focus(), n());
          });
        },
        openOnArrowRightKey(e) {
          const t = "rtl" === e.locale.uiLanguageDirection ? "arrowleft" : "arrowright";
          e.keystrokes.set(t, (t, n) => {
            e.focusTracker.focusedElement === e.buttonView.element && e.isEnabled && (e.isOpen || (e.isOpen = !0), e.panelView.focus(), n());
          });
        },
        openOnButtonClick(e) {
          e.buttonView.on("execute", () => {
            e.isOpen = !0, e.panelView.focus();
          });
        },
        toggleOnButtonClick(e) {
          e.buttonView.on("execute", () => {
            e.isOpen = !e.isOpen, e.isOpen && e.panelView.focus();
          });
        },
        closeOnArrowLeftKey(e) {
          const t = "rtl" === e.locale.uiLanguageDirection ? "arrowright" : "arrowleft";
          e.keystrokes.set(t, (t, n) => {
            e.isOpen && (e.isOpen = !1, e.focus(), n());
          });
        },
        closeOnEscKey(e) {
          e.keystrokes.set("esc", (t, n) => {
            e.isOpen && (e.isOpen = !1, e.focus(), n());
          });
        },
        closeOnParentClose(e) {
          e.parentMenuView.on("change:isOpen", (t, n, i) => {
            i || t.source !== e.parentMenuView || (e.isOpen = !1);
          });
        }
      },
      wk = {
        southEast: e => ({
          top: e.bottom,
          left: e.left,
          name: "se"
        }),
        southWest: (e, t) => ({
          top: e.bottom,
          left: e.left - t.width + e.width,
          name: "sw"
        }),
        northEast: (e, t) => ({
          top: e.top - t.height,
          left: e.left,
          name: "ne"
        }),
        northWest: (e, t) => ({
          top: e.top - t.height,
          left: e.left - t.width + e.width,
          name: "nw"
        }),
        eastSouth: e => ({
          top: e.top,
          left: e.right - 5,
          name: "es"
        }),
        eastNorth: (e, t) => ({
          top: e.top - t.height,
          left: e.right - 5,
          name: "en"
        }),
        westSouth: (e, t) => ({
          top: e.top,
          left: e.left - t.width + 5,
          name: "ws"
        }),
        westNorth: (e, t) => ({
          top: e.top - t.height,
          left: e.left - t.width + 5,
          name: "wn"
        })
      },
      Ak = [{
        menuId: "file",
        label: "File",
        groups: [{
          groupId: "export",
          items: ["menuBar:exportPdf", "menuBar:exportWord"]
        }, {
          groupId: "import",
          items: ["menuBar:importWord"]
        }, {
          groupId: "revisionHistory",
          items: ["menuBar:revisionHistory"]
        }]
      }, {
        menuId: "edit",
        label: "Edit",
        groups: [{
          groupId: "undo",
          items: ["menuBar:undo", "menuBar:redo"]
        }, {
          groupId: "selectAll",
          items: ["menuBar:selectAll"]
        }, {
          groupId: "findAndReplace",
          items: ["menuBar:findAndReplace"]
        }]
      }, {
        menuId: "view",
        label: "View",
        groups: [{
          groupId: "sourceEditing",
          items: ["menuBar:sourceEditing"]
        }, {
          groupId: "showBlocks",
          items: ["menuBar:showBlocks"]
        }, {
          groupId: "restrictedEditingException",
          items: ["menuBar:restrictedEditingException"]
        }]
      }, {
        menuId: "insert",
        label: "Insert",
        groups: [{
          groupId: "insertMainWidgets",
          items: ["menuBar:uploadImage", "menuBar:ckbox", "menuBar:ckfinder", "menuBar:insertTable"]
        }, {
          groupId: "insertInline",
          items: ["menuBar:link", "menuBar:comment"]
        }, {
          groupId: "insertMinorWidgets",
          items: ["menuBar:insertTemplate", "menuBar:blockQuote", "menuBar:codeBlock", "menuBar:htmlEmbed"]
        }, {
          groupId: "insertStructureWidgets",
          items: ["menuBar:horizontalLine", "menuBar:pageBreak", "menuBar:tableOfContents"]
        }, {
          groupId: "restrictedEditing",
          items: ["menuBar:restrictedEditing"]
        }]
      }, {
        menuId: "format",
        label: "Format",
        groups: [{
          groupId: "textAndFont",
          items: [{
            menuId: "text",
            label: "Text",
            groups: [{
              groupId: "basicStyles",
              items: ["menuBar:bold", "menuBar:italic", "menuBar:underline", "menuBar:strikethrough", "menuBar:superscript", "menuBar:subscript", "menuBar:code"]
            }, {
              groupId: "textPartLanguage",
              items: ["menuBar:textPartLanguage"]
            }]
          }, {
            menuId: "font",
            label: "Font",
            groups: [{
              groupId: "fontProperties",
              items: ["menuBar:fontSize", "menuBar:fontFamily"]
            }, {
              groupId: "fontColors",
              items: ["menuBar:fontColor", "menuBar:fontBackgroundColor"]
            }, {
              groupId: "highlight",
              items: ["menuBar:highlight"]
            }]
          }, "menuBar:heading"]
        }, {
          groupId: "list",
          items: ["menuBar:bulletedList", "menuBar:numberedList", "menuBar:todoList"]
        }, {
          groupId: "indent",
          items: ["menuBar:alignment", "menuBar:indent", "menuBar:outdent"]
        }, {
          groupId: "caseChange",
          items: ["menuBar:caseChange"]
        }, {
          groupId: "removeFormat",
          items: ["menuBar:removeFormat"]
        }]
      }, {
        menuId: "tools",
        label: "Tools",
        groups: [{
          groupId: "aiTools",
          items: ["menuBar:aiAssistant", "menuBar:aiCommands"]
        }, {
          groupId: "tools",
          items: ["menuBar:trackChanges", "menuBar:commentsArchive"]
        }]
      }, {
        menuId: "help",
        label: "Help",
        groups: [{
          groupId: "help",
          items: ["menuBar:accessibilityHelp"]
        }]
      }];
    function vk(_ref60) {
      let {
        normalizedConfig: e,
        locale: t,
        componentFactory: n
      } = _ref60;
      const i = Yl(e);
      return function (e, t) {
        const n = t.removeItems,
          i = [];
        t.items = t.items.filter(_ref61 => {
          let {
            menuId: e
          } = _ref61;
          return !n.includes(e) || (i.push(e), !1);
        }), Ek(t.items, e => {
          e.groups = e.groups.filter(_ref62 => {
            let {
              groupId: e
            } = _ref62;
            return !n.includes(e) || (i.push(e), !1);
          });
          for (const t of e.groups) t.items = t.items.filter(e => {
            const t = Bk(e);
            return !n.includes(t) || (i.push(t), !1);
          });
        });
        for (const t of n) i.includes(t) || w("menu-bar-item-could-not-be-removed", {
          menuBarConfig: e,
          itemName: t
        });
      }(e, i), function (e, t) {
        const n = t.addItems,
          i = [];
        for (const e of n) {
          const n = Tk(e.position),
            o = Ik(e.position);
          if (Sk(e)) {
            if (o) {
              const r = t.items.findIndex(e => e.menuId === o);
              if (-1 != r) "before" === n ? (t.items.splice(r, 0, e.menu), i.push(e)) : "after" === n && (t.items.splice(r + 1, 0, e.menu), i.push(e));else {
                Ck(t, e.menu, o, n) && i.push(e);
              }
            } else "start" === n ? (t.items.unshift(e.menu), i.push(e)) : "end" === n && (t.items.push(e.menu), i.push(e));
          } else if (Dk(e)) Ek(t.items, t => {
            if (t.menuId === o) "start" === n ? (t.groups.unshift(e.group), i.push(e)) : "end" === n && (t.groups.push(e.group), i.push(e));else {
              const r = t.groups.findIndex(e => e.groupId === o);
              -1 !== r && ("before" === n ? (t.groups.splice(r, 0, e.group), i.push(e)) : "after" === n && (t.groups.splice(r + 1, 0, e.group), i.push(e)));
            }
          });else {
            Ck(t, e.item, o, n) && i.push(e);
          }
        }
        for (const t of n) i.includes(t) || w("menu-bar-item-could-not-be-added", {
          menuBarConfig: e,
          addedItemConfig: t
        });
      }(e, i), function (e, t, n) {
        Ek(t.items, i => {
          for (const o of i.groups) o.items = o.items.filter(o => {
            const r = "string" == typeof o && !n.has(o);
            return r && !t.isUsingDefaultConfig && w("menu-bar-item-unavailable", {
              menuBarConfig: e,
              parentMenuConfig: Yl(i),
              componentName: o
            }), !r;
          });
        });
      }(e, i, n), yk(e, i), function (e, t) {
        const n = t.t,
          i = {
            File: n({
              string: "File",
              id: "MENU_BAR_MENU_FILE"
            }),
            Edit: n({
              string: "Edit",
              id: "MENU_BAR_MENU_EDIT"
            }),
            View: n({
              string: "View",
              id: "MENU_BAR_MENU_VIEW"
            }),
            Insert: n({
              string: "Insert",
              id: "MENU_BAR_MENU_INSERT"
            }),
            Format: n({
              string: "Format",
              id: "MENU_BAR_MENU_FORMAT"
            }),
            Tools: n({
              string: "Tools",
              id: "MENU_BAR_MENU_TOOLS"
            }),
            Help: n({
              string: "Help",
              id: "MENU_BAR_MENU_HELP"
            }),
            Text: n({
              string: "Text",
              id: "MENU_BAR_MENU_TEXT"
            }),
            Font: n({
              string: "Font",
              id: "MENU_BAR_MENU_FONT"
            })
          };
        Ek(e.items, e => {
          e.label in i && (e.label = i[e.label]);
        });
      }(i, t), i;
    }
    function Ck(e, t, n, i) {
      let o = !1;
      return Ek(e.items, e => {
        for (const {
          groupId: r,
          items: s
        } of e.groups) {
          if (o) return;
          if (r === n) "start" === i ? (s.unshift(t), o = !0) : "end" === i && (s.push(t), o = !0);else {
            const e = s.findIndex(e => Bk(e) === n);
            -1 !== e && ("before" === i ? (s.splice(e, 0, t), o = !0) : "after" === i && (s.splice(e + 1, 0, t), o = !0));
          }
        }
      }), o;
    }
    function yk(e, t) {
      const n = t.isUsingDefaultConfig;
      let i = !1;
      t.items = t.items.filter(t => !!t.groups.length || (xk(e, t, n), !1)), t.items.length ? (Ek(t.items, t => {
        t.groups = t.groups.filter(e => !!e.items.length || (i = !0, !1));
        for (const o of t.groups) o.items = o.items.filter(t => !(Mk(t) && !t.groups.length) || (xk(e, t, n), i = !0, !1));
      }), i && yk(e, t)) : xk(e, e, n);
    }
    function xk(e, t, n) {
      n || w("menu-bar-menu-empty", {
        menuBarConfig: e,
        emptyMenuConfig: t
      });
    }
    function Ek(e, t) {
      if (Array.isArray(e)) for (const t of e) n(t);
      function n(e) {
        t(e);
        for (const t of e.groups) for (const e of t.items) Mk(e) && n(e);
      }
    }
    function Sk(e) {
      return "object" == typeof e && "menu" in e;
    }
    function Dk(e) {
      return "object" == typeof e && "group" in e;
    }
    function Tk(e) {
      return e.startsWith("start") ? "start" : e.startsWith("end") ? "end" : e.startsWith("after") ? "after" : "before";
    }
    function Ik(e) {
      const t = e.match(/^[^:]+:(.+)/);
      return t ? t[1] : null;
    }
    function Bk(e) {
      return "string" == typeof e ? e : e.menuId;
    }
    function Mk(e) {
      return "object" == typeof e && "menuId" in e;
    }
    function Pk(e, t) {
      const n = t.element;
      e.ui.focusTracker.add(n), e.keystrokes.listenTo(n);
      const i = function (e) {
        let t;
        return t = "items" in e && e.items ? {
          items: e.items,
          removeItems: [],
          addItems: [],
          isVisible: !0,
          isUsingDefaultConfig: !1,
          ...e
        } : {
          items: Yl(Ak),
          addItems: [],
          removeItems: [],
          isVisible: !0,
          isUsingDefaultConfig: !0,
          ...e
        }, t;
      }(e.config.get("menuBar") || {});
      t.fillFromConfig(i, e.ui.componentFactory), e.keystrokes.set("Esc", (t, i) => {
        n.contains(e.ui.focusTracker.focusedElement) && (e.editing.view.focus(), i());
      }), e.keystrokes.set("Alt+F9", (i, o) => {
        n.contains(e.ui.focusTracker.focusedElement) || (t.focus(), o());
      });
    }
    var zk = o(5107),
      Nk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(zk.A, Nk);
    zk.A.locals;
    class Lk extends Er {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-menu-bar__menu__panel", t.to("position", e => "ck-menu-bar__menu__panel_position_".concat(e)), t.if("isVisible", "ck-hidden", e => !e)],
            tabindex: "-1"
          },
          children: this.children,
          on: {
            selectstart: t.to(e => {
              "input" !== e.target.tagName.toLocaleLowerCase() && e.preventDefault();
            })
          }
        });
      }
      focus() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        this.children.length && (1 === e ? this.children.first.focus() : this.children.last.focus());
      }
    }
    var Rk = o(6681),
      Vk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Rk.A, Vk);
    Rk.A.locals;
    class Ok extends Er {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.buttonView = new pk(e), this.buttonView.delegate("mouseenter").to(this), this.buttonView.bind("isOn", "isEnabled").to(this, "isOpen", "isEnabled"), this.panelView = new Lk(e), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new Wo(), this.focusTracker = new Ko(), this.set("isOpen", !1), this.set("isEnabled", !0), this.set("panelPosition", "w"), this.set("class", void 0), this.set("parentMenuView", null), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-menu-bar__menu", t.to("class"), t.if("isEnabled", "ck-disabled", e => !e), t.if("parentMenuView", "ck-menu-bar__menu_top-level", e => !e)]
          },
          children: [this.buttonView, this.panelView]
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.keystrokes.listenTo(this.element), _k.closeOnEscKey(this), this._repositionPanelOnOpen();
      }
      _attachBehaviors() {
        this.parentMenuView ? (_k.openOnButtonClick(this), _k.openOnArrowRightKey(this), _k.closeOnArrowLeftKey(this), _k.closeOnParentClose(this)) : (this._propagateArrowKeystrokeEvents(), _k.openAndFocusPanelOnArrowDownKey(this), _k.toggleOnButtonClick(this));
      }
      _propagateArrowKeystrokeEvents() {
        this.keystrokes.set("arrowright", (e, t) => {
          this.fire("arrowright"), t();
        }), this.keystrokes.set("arrowleft", (e, t) => {
          this.fire("arrowleft"), t();
        });
      }
      _repositionPanelOnOpen() {
        this.on("change:isOpen", (e, t, n) => {
          if (!n) return;
          const i = Ok._getOptimalPosition({
            element: this.panelView.element,
            target: this.buttonView.element,
            fitInViewport: !0,
            positions: this._panelPositions
          });
          this.panelView.position = i ? i.name : this._panelPositions[0].name;
        });
      }
      focus() {
        this.buttonView.focus();
      }
      get _panelPositions() {
        const {
          southEast: e,
          southWest: t,
          northEast: n,
          northWest: i,
          westSouth: o,
          eastSouth: r,
          westNorth: s,
          eastNorth: a
        } = wk;
        return "ltr" === this.locale.uiLanguageDirection ? this.parentMenuView ? [r, a, o, s] : [e, t, n, i] : this.parentMenuView ? [o, s, r, a] : [t, e, i, n];
      }
    }
    Ok._getOptimalPosition = Zi;
    const Fk = Ok;
    class jk extends fp {
      constructor(e) {
        super(e), this.role = "menu";
      }
    }
    var Hk = o(2992),
      Uk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Hk.A, Uk);
    Hk.A.locals;
    class qk extends um {
      constructor(e) {
        super(e), this.set({
          withText: !0,
          withKeystroke: !0,
          tooltip: !1,
          role: "menuitem"
        }), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item__button"]
          }
        });
      }
    }
    class Gk extends gm {
      constructor(e) {
        super(e), this.set({
          withText: !0,
          withKeystroke: !0,
          tooltip: !1,
          role: "menuitem"
        }), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item__button"]
          }
        });
      }
    }
    var Kk = o(20),
      Wk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Kk.A, Wk);
    Kk.A.locals;
    const Yk = ["mouseenter", "arrowleft", "arrowright", "change:isOpen"];
    class $k extends Er {
      constructor(e) {
        super(e), this.menus = [];
        const t = e.t;
        this.set("isOpen", !1), this._setupIsOpenUpdater(), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-menu-bar"],
            "aria-label": t("Editor menu bar"),
            role: "menubar"
          },
          children: this.children
        });
      }
      fillFromConfig(e, t) {
        const n = vk({
          normalizedConfig: e,
          locale: this.locale,
          componentFactory: t
        }).items.map(e => this._createMenu({
          componentFactory: t,
          menuDefinition: e
        }));
        this.children.addMany(n);
      }
      render() {
        super.render(), bk.toggleMenusAndFocusItemsOnHover(this), bk.closeMenusWhenTheBarCloses(this), bk.closeMenuWhenAnotherOnTheSameLevelOpens(this), bk.focusCycleMenusOnArrows(this), bk.closeOnClickOutside(this);
      }
      focus() {
        this.children.first && this.children.first.focus();
      }
      close() {
        for (const e of this.children) e.isOpen = !1;
      }
      registerMenu(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        t ? (e.delegate(...Yk).to(t), e.parentMenuView = t) : e.delegate(...Yk).to(this, e => "menu:" + e), e._attachBehaviors(), this.menus.push(e);
      }
      _createMenu(_ref63) {
        let {
          componentFactory: e,
          menuDefinition: t,
          parentMenuView: n
        } = _ref63;
        const i = this.locale,
          o = new Fk(i);
        return this.registerMenu(o, n), o.buttonView.set({
          label: t.label
        }), o.once("change:isOpen", () => {
          const n = new jk(i);
          n.ariaLabel = t.label, o.panelView.children.add(n), n.items.addMany(this._createMenuItems({
            menuDefinition: t,
            parentMenuView: o,
            componentFactory: e
          }));
        }), o;
      }
      _createMenuItems(_ref64) {
        let {
          menuDefinition: e,
          parentMenuView: t,
          componentFactory: n
        } = _ref64;
        const i = this.locale,
          o = [];
        for (const r of e.groups) {
          for (const e of r.items) {
            const r = new kk(i, t);
            if (R(e)) r.children.add(this._createMenu({
              componentFactory: n,
              menuDefinition: e,
              parentMenuView: t
            }));else {
              const i = this._createMenuItemContentFromFactory({
                componentName: e,
                componentFactory: n,
                parentMenuView: t
              });
              if (!i) continue;
              r.children.add(i);
            }
            o.push(r);
          }
          r !== e.groups[e.groups.length - 1] && o.push(new hp(i));
        }
        return o;
      }
      _createMenuItemContentFromFactory(_ref65) {
        let {
          componentName: e,
          parentMenuView: t,
          componentFactory: n
        } = _ref65;
        const i = n.create(e);
        return i instanceof Fk || i instanceof qk || i instanceof Gk ? (this._registerMenuTree(i, t), i.on("execute", () => {
          this.close();
        }), i) : (w("menu-bar-component-unsupported", {
          componentName: e,
          componentView: i
        }), null);
      }
      _registerMenuTree(e, t) {
        if (!(e instanceof Fk)) return void e.delegate("mouseenter").to(t);
        this.registerMenu(e, t);
        const n = e.panelView.children.filter(e => e instanceof jk)[0];
        if (!n) return void e.delegate("mouseenter").to(t);
        const i = n.items.filter(e => e instanceof up);
        for (const t of i) this._registerMenuTree(t.children.get(0), e);
      }
      _setupIsOpenUpdater() {
        let e;
        this.on("menu:change:isOpen", (t, n, i) => {
          clearTimeout(e), i ? this.isOpen = !0 : e = setTimeout(() => {
            this.isOpen = Array.from(this.children).some(e => e.isOpen);
          }, 0);
        });
      }
    }
    class Zk extends yf {
      constructor(e, t) {
        super(e), this.view = t, this._toolbarConfig = ip(e.config.get("toolbar")), this._elementReplacer = new Z(), this.listenTo(e.editing.view, "scrollToTheSelection", this._handleScrollToTheSelectionWithStickyPanel.bind(this));
      }
      get element() {
        return this.view.element;
      }
      init(e) {
        const t = this.editor,
          n = this.view,
          i = t.editing.view,
          o = n.editable,
          r = i.document.getRoot();
        o.name = r.rootName, n.render();
        const s = o.element;
        this.setEditableElement(o.name, s), n.editable.bind("isFocused").to(this.focusTracker), i.attachDomRoot(s), e && this._elementReplacer.replace(e, this.element), this._initPlaceholder(), this._initToolbar(), n.menuBarView && Pk(t, n.menuBarView), this._initDialogPluginIntegration(), this.fire("ready");
      }
      destroy() {
        super.destroy();
        const e = this.view,
          t = this.editor.editing.view;
        this._elementReplacer.restore(), t.detachDomRoot(e.editable.name), e.destroy();
      }
      _initToolbar() {
        const e = this.view;
        e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), e.stickyPanel.limiterElement = e.element, e.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", _ref66 => {
          let {
            top: e
          } = _ref66;
          return e || 0;
        }), e.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), this.addToolbar(e.toolbar);
      }
      _initPlaceholder() {
        const e = this.editor,
          t = e.editing.view,
          n = t.document.getRoot(),
          i = e.sourceElement;
        let o;
        const r = e.config.get("placeholder");
        r && (o = "string" == typeof r ? r : r[this.view.editable.name]), !o && i && "textarea" === i.tagName.toLowerCase() && (o = i.getAttribute("placeholder")), o && (n.placeholder = o), Ur({
          view: t,
          element: n,
          isDirectHost: !1,
          keepOnFocus: !0
        });
      }
      _handleScrollToTheSelectionWithStickyPanel(e, t, n) {
        const i = this.view.stickyPanel;
        if (i.isSticky) {
          const e = new Li(i.element).height;
          t.viewportOffset.top += e;
        } else {
          const e = () => {
            this.editor.editing.view.scrollToTheSelection(n);
          };
          this.listenTo(i, "change:isSticky", e), setTimeout(() => {
            this.stopListening(i, "change:isSticky", e);
          }, 20);
        }
      }
      _initDialogPluginIntegration() {
        if (!this.editor.plugins.has("Dialog")) return;
        const e = this.view.stickyPanel,
          t = this.editor.plugins.get("Dialog");
        t.on("show", () => {
          const n = t.view;
          n.on("moveTo", (t, i) => {
            if (!e.isSticky || n.wasMoved) return;
            const o = new Li(e.contentPanelElement);
            i[1] < o.bottom + Gg.defaultOffset && (i[1] = o.bottom + Gg.defaultOffset);
          }, {
            priority: "high"
          });
        }, {
          priority: "low"
        });
      }
    }
    var Qk = o(2515),
      Jk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Qk.A, Jk);
    Qk.A.locals;
    class Xk extends Tf {
      constructor(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super(e), this.stickyPanel = new Gf(e), this.toolbar = new ap(e, {
          shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
        }), n.useMenuBar && (this.menuBarView = new $k(e)), this.editable = new Bf(e, t);
      }
      render() {
        super.render(), this.menuBarView ? this.stickyPanel.content.addMany([this.menuBarView, this.toolbar]) : this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
      }
    }
    class eb {
      constructor(e) {
        if (this.crashes = [], this.state = "initializing", this._now = Date.now, this.crashes = [], this._crashNumberLimit = "number" == typeof e.crashNumberLimit ? e.crashNumberLimit : 3, this._minimumNonErrorTimePeriod = "number" == typeof e.minimumNonErrorTimePeriod ? e.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = e => {
          const t = "error" in e ? e.error : e.reason;
          t instanceof Error && this._handleError(t, e);
        }, this._listeners = {}, !this._restart) throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
      }
      destroy() {
        this._stopErrorHandling(), this._listeners = {};
      }
      on(e, t) {
        this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(t);
      }
      off(e, t) {
        this._listeners[e] = this._listeners[e].filter(e => e !== t);
      }
      _fire(e) {
        const n = this._listeners[e] || [];
        for (var _len32 = arguments.length, t = new Array(_len32 > 1 ? _len32 - 1 : 0), _key32 = 1; _key32 < _len32; _key32++) {
          t[_key32 - 1] = arguments[_key32];
        }
        for (const e of n) e.apply(this, [null, ...t]);
      }
      _startErrorHandling() {
        window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
      }
      _stopErrorHandling() {
        window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
      }
      _handleError(e, t) {
        if (this._shouldReactToError(e)) {
          this.crashes.push({
            message: e.message,
            stack: e.stack,
            filename: t instanceof ErrorEvent ? t.filename : void 0,
            lineno: t instanceof ErrorEvent ? t.lineno : void 0,
            colno: t instanceof ErrorEvent ? t.colno : void 0,
            date: this._now()
          });
          const n = this._shouldRestart();
          this.state = "crashed", this._fire("stateChange"), this._fire("error", {
            error: e,
            causesRestart: n
          }), n ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
        }
      }
      _shouldReactToError(e) {
        return e.is && e.is("CKEditorError") && void 0 !== e.context && null !== e.context && "ready" === this.state && this._isErrorComingFromThisItem(e);
      }
      _shouldRestart() {
        if (this.crashes.length <= this._crashNumberLimit) return !0;
        return (this.crashes[this.crashes.length - 1].date - this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
      }
    }
    function tb(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
      const n = [e],
        i = new Set();
      let o = 0;
      for (; n.length > o;) {
        const e = n[o++];
        if (!i.has(e) && nb(e) && !t.has(e)) if (i.add(e), Symbol.iterator in e) try {
          for (const t of e) n.push(t);
        } catch (e) {} else for (const t in e) "defaultValue" !== t && n.push(e[t]);
      }
      return i;
    }
    function nb(e) {
      const t = Object.prototype.toString.call(e),
        n = typeof e;
      return !("number" === n || "boolean" === n || "string" === n || "symbol" === n || "function" === n || "[object Date]" === t || "[object RegExp]" === t || "[object Module]" === t || null == e || e._watchdogExcluded || e instanceof EventTarget || e instanceof Event);
    }
    function ib(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
      if (e === t && "object" == typeof (i = e) && null !== i) return !0;
      var i;
      const o = tb(e, n),
        r = tb(t, n);
      for (const e of o) if (r.has(e)) return !0;
      return !1;
    }
    class ob extends eb {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t), this._editor = null, this._lifecyclePromise = null, this._initUsingData = !0, this._editables = {}, this._throttledSave = df(this._save.bind(this), "number" == typeof t.saveInterval ? t.saveInterval : 5e3), e && (this._creator = (t, n) => e.create(t, n)), this._destructor = e => e.destroy();
      }
      get editor() {
        return this._editor;
      }
      get _item() {
        return this._editor;
      }
      setCreator(e) {
        this._creator = e;
      }
      setDestructor(e) {
        this._destructor = e;
      }
      _restart() {
        return Promise.resolve().then(() => (this.state = "initializing", this._fire("stateChange"), this._destroy())).catch(e => {
          console.error("An error happened during the editor destroying.", e);
        }).then(() => {
          const e = {},
            t = [],
            n = this._config.rootsAttributes || {},
            i = {};
          for (const [o, r] of Object.entries(this._data.roots)) r.isLoaded ? (e[o] = "", i[o] = n[o] || {}) : t.push(o);
          const o = {
            ...this._config,
            extraPlugins: this._config.extraPlugins || [],
            lazyRoots: t,
            rootsAttributes: i,
            _watchdogInitialData: this._data
          };
          return delete o.initialData, o.extraPlugins.push(rb), this._initUsingData ? this.create(e, o, o.context) : Ai(this._elementOrData) ? this.create(this._elementOrData, o, o.context) : this.create(this._editables, o, o.context);
        }).then(() => {
          this._fire("restart");
        });
      }
      create() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._elementOrData;
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._config;
        let n = arguments.length > 2 ? arguments[2] : undefined;
        return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (super._startErrorHandling(), this._elementOrData = e, this._initUsingData = "string" == typeof e || Object.keys(e).length > 0 && "string" == typeof Object.values(e)[0], this._config = this._cloneEditorConfiguration(t) || {}, this._config.context = n, this._creator(e, this._config))).then(e => {
          this._editor = e, e.model.document.on("change:data", this._throttledSave), this._lastDocumentVersion = e.model.document.version, this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this.state = "ready", this._fire("stateChange");
        }).finally(() => {
          this._lifecyclePromise = null;
        }), this._lifecyclePromise;
      }
      destroy() {
        return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy())).finally(() => {
          this._lifecyclePromise = null;
        }), this._lifecyclePromise;
      }
      _destroy() {
        return Promise.resolve().then(() => {
          this._stopErrorHandling(), this._throttledSave.cancel();
          const e = this._editor;
          return this._editor = null, e.model.document.off("change:data", this._throttledSave), this._destructor(e);
        });
      }
      _save() {
        const e = this._editor.model.document.version;
        try {
          this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this._lastDocumentVersion = e;
        } catch (e) {
          console.error(e, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
        }
      }
      _setExcludedProperties(e) {
        this._excludedProps = e;
      }
      _getData() {
        const e = this._editor,
          t = e.model.document.roots.filter(e => e.isAttached() && "$graveyard" != e.rootName),
          {
            plugins: n
          } = e,
          i = n.has("CommentsRepository") && n.get("CommentsRepository"),
          o = n.has("TrackChanges") && n.get("TrackChanges"),
          r = {
            roots: {},
            markers: {},
            commentThreads: JSON.stringify([]),
            suggestions: JSON.stringify([])
          };
        t.forEach(e => {
          r.roots[e.rootName] = {
            content: JSON.stringify(Array.from(e.getChildren())),
            attributes: JSON.stringify(Array.from(e.getAttributes())),
            isLoaded: e._isLoaded
          };
        });
        for (const t of e.model.markers) t._affectsData && (r.markers[t.name] = {
          rangeJSON: t.getRange().toJSON(),
          usingOperation: t._managedUsingOperations,
          affectsData: t._affectsData
        });
        return i && (r.commentThreads = JSON.stringify(i.getCommentThreads({
          toJSON: !0,
          skipNotAttached: !0
        }))), o && (r.suggestions = JSON.stringify(o.getSuggestions({
          toJSON: !0,
          skipNotAttached: !0
        }))), r;
      }
      _getEditables() {
        const e = {};
        for (const t of this.editor.model.document.getRootNames()) {
          const n = this.editor.ui.getEditableElement(t);
          n && (e[t] = n);
        }
        return e;
      }
      _isErrorComingFromThisItem(e) {
        return ib(this._editor, e.context, this._excludedProps);
      }
      _cloneEditorConfiguration(e) {
        return wi(e, (e, t) => Ai(e) || "context" === t ? e : void 0);
      }
    }
    class rb {
      constructor(e) {
        this.editor = e, this._data = e.config.get("_watchdogInitialData");
      }
      init() {
        this.editor.data.on("init", e => {
          e.stop(), this.editor.model.enqueueChange({
            isUndoable: !1
          }, e => {
            this._restoreCollaborationData(), this._restoreEditorData(e);
          }), this.editor.data.fire("ready");
        }, {
          priority: 999
        });
      }
      _createNode(e, t) {
        if ("name" in t) {
          const n = e.createElement(t.name, t.attributes);
          if (t.children) for (const i of t.children) n._appendChild(this._createNode(e, i));
          return n;
        }
        return e.createText(t.data, t.attributes);
      }
      _restoreEditorData(e) {
        const t = this.editor;
        Object.entries(this._data.roots).forEach(_ref67 => {
          let [n, {
            content: i,
            attributes: o
          }] = _ref67;
          const r = JSON.parse(i),
            s = JSON.parse(o),
            a = t.model.document.getRoot(n);
          for (const [t, n] of s) e.setAttribute(t, n, a);
          for (const t of r) {
            const n = this._createNode(e, t);
            e.insert(n, a, "end");
          }
        }), Object.entries(this._data.markers).forEach(_ref68 => {
          let [n, i] = _ref68;
          const {
              document: o
            } = t.model,
            {
              rangeJSON: {
                start: r,
                end: s
              },
              ...a
            } = i,
            l = o.getRoot(r.root),
            c = e.createPositionFromPath(l, r.path, r.stickiness),
            d = e.createPositionFromPath(l, s.path, s.stickiness),
            u = e.createRange(c, d);
          e.addMarker(n, {
            range: u,
            ...a
          });
        });
      }
      _restoreCollaborationData() {
        const e = JSON.parse(this._data.commentThreads),
          t = JSON.parse(this._data.suggestions);
        e.forEach(e => {
          const t = this.editor.config.get("collaboration.channelId"),
            n = this.editor.plugins.get("CommentsRepository");
          if (n.hasCommentThread(e.threadId)) {
            n.getCommentThread(e.threadId).remove();
          }
          n.addCommentThread({
            channelId: t,
            ...e
          });
        }), t.forEach(e => {
          const t = this.editor.plugins.get("TrackChangesEditing");
          if (t.hasSuggestion(e.id)) {
            t.getSuggestion(e.id).attributes = e.attributes;
          } else t.addSuggestionData(e);
        });
      }
    }
    const sb = Symbol("MainQueueId");
    class ab {
      constructor() {
        this._onEmptyCallbacks = [], this._queues = new Map(), this._activeActions = 0;
      }
      onEmpty(e) {
        this._onEmptyCallbacks.push(e);
      }
      enqueue(e, t) {
        const n = e === sb;
        this._activeActions++, this._queues.get(e) || this._queues.set(e, Promise.resolve());
        const i = (n ? Promise.all(this._queues.values()) : Promise.all([this._queues.get(sb), this._queues.get(e)])).then(t),
          o = i.catch(() => {});
        return this._queues.set(e, o), i.finally(() => {
          this._activeActions--, this._queues.get(e) === o && 0 === this._activeActions && this._onEmptyCallbacks.forEach(e => e());
        });
      }
    }
    function lb(e) {
      return Array.isArray(e) ? e : [e];
    }
    class cb extends Gh(qh) {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!ub(e) && void 0 !== t.initialData) throw new _("editor-create-initial-data", null);
        super(t), this.config.define("menuBar.isVisible", !1), void 0 === this.config.get("initialData") && this.config.set("initialData", function (e) {
          return ub(e) ? (t = e, t instanceof HTMLTextAreaElement ? t.value : t.innerHTML) : e;
          var t;
        }(e)), ub(e) && (this.sourceElement = e), this.model.document.createRoot();
        const n = !this.config.get("toolbar.shouldNotGroupWhenFull"),
          i = this.config.get("menuBar"),
          o = new Xk(this.locale, this.editing.view, {
            shouldToolbarGroupWhenFull: n,
            useMenuBar: i.isVisible
          });
        this.ui = new Zk(this, o), function (e) {
          if (!Oe(e.updateSourceElement)) throw new _("attachtoform-missing-elementapi-interface", e);
          const t = e.sourceElement;
          if (function (e) {
            return !!e && "textarea" === e.tagName.toLowerCase();
          }(t) && t.form) {
            let n;
            const i = t.form,
              o = () => e.updateSourceElement();
            Oe(i.submit) && (n = i.submit, i.submit = () => {
              o(), n.apply(i);
            }), i.addEventListener("submit", o), e.on("destroy", () => {
              i.removeEventListener("submit", o), n && (i.submit = n);
            });
          }
        }(this);
      }
      destroy() {
        return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
      }
      static create(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new Promise(n => {
          const i = new this(e, t);
          n(i.initPlugins().then(() => i.ui.init(ub(e) ? e : null)).then(() => i.data.init(i.config.get("initialData"))).then(() => i.fire("ready")).then(() => i));
        });
      }
    }
    cb.Context = Rr, cb.EditorWatchdog = ob, cb.ContextWatchdog = class extends eb {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t), this._watchdogs = new Map(), this._context = null, this._contextProps = new Set(), this._actionQueues = new ab(), this._watchdogConfig = t, this._creator = t => e.create(t), this._destructor = e => e.destroy(), this._actionQueues.onEmpty(() => {
          "initializing" === this.state && (this.state = "ready", this._fire("stateChange"));
        });
      }
      setCreator(e) {
        this._creator = e;
      }
      setDestructor(e) {
        this._destructor = e;
      }
      get context() {
        return this._context;
      }
      create() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return this._actionQueues.enqueue(sb, () => (this._contextConfig = e, this._create()));
      }
      getItem(e) {
        return this._getWatchdog(e)._item;
      }
      getItemState(e) {
        return this._getWatchdog(e).state;
      }
      add(e) {
        const t = lb(e);
        return Promise.all(t.map(e => this._actionQueues.enqueue(e.id, () => {
          if ("destroyed" === this.state) throw new Error("Cannot add items to destroyed watchdog.");
          if (!this._context) throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
          let t;
          if (this._watchdogs.has(e.id)) throw new Error("Item with the given id is already added: '".concat(e.id, "'."));
          if ("editor" === e.type) return t = new ob(null, this._watchdogConfig), t.setCreator(e.creator), t._setExcludedProperties(this._contextProps), e.destructor && t.setDestructor(e.destructor), this._watchdogs.set(e.id, t), t.on("error", (n, _ref69) => {
            let {
              error: i,
              causesRestart: o
            } = _ref69;
            this._fire("itemError", {
              itemId: e.id,
              error: i
            }), o && this._actionQueues.enqueue(e.id, () => new Promise(n => {
              const i = () => {
                t.off("restart", i), this._fire("itemRestart", {
                  itemId: e.id
                }), n();
              };
              t.on("restart", i);
            }));
          }), t.create(e.sourceElementOrData, e.config, this._context);
          throw new Error("Not supported item type: '".concat(e.type, "'."));
        })));
      }
      remove(e) {
        const t = lb(e);
        return Promise.all(t.map(e => this._actionQueues.enqueue(e, () => {
          const t = this._getWatchdog(e);
          return this._watchdogs.delete(e), t.destroy();
        })));
      }
      destroy() {
        return this._actionQueues.enqueue(sb, () => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
      }
      _restart() {
        return this._actionQueues.enqueue(sb, () => (this.state = "initializing", this._fire("stateChange"), this._destroy().catch(e => {
          console.error("An error happened during destroying the context or items.", e);
        }).then(() => this._create()).then(() => this._fire("restart"))));
      }
      _create() {
        return Promise.resolve().then(() => (this._startErrorHandling(), this._creator(this._contextConfig))).then(e => (this._context = e, this._contextProps = tb(this._context), Promise.all(Array.from(this._watchdogs.values()).map(e => (e._setExcludedProperties(this._contextProps), e.create(void 0, void 0, this._context))))));
      }
      _destroy() {
        return Promise.resolve().then(() => {
          this._stopErrorHandling();
          const e = this._context;
          return this._context = null, this._contextProps = new Set(), Promise.all(Array.from(this._watchdogs.values()).map(e => e.destroy())).then(() => this._destructor(e));
        });
      }
      _getWatchdog(e) {
        const t = this._watchdogs.get(e);
        if (!t) throw new Error("Item with the given id was not registered: ".concat(e, "."));
        return t;
      }
      _isErrorComingFromThisItem(e) {
        for (const t of this._watchdogs.values()) if (t._isErrorComingFromThisItem(e)) return !1;
        return ib(this._context, e.context);
      }
    };
    const db = cb;
    function ub(e) {
      return Ai(e);
    }
    const hb = ["left", "right", "center", "justify"];
    function mb(e) {
      return hb.includes(e);
    }
    function pb(e, t) {
      return "rtl" == t.contentLanguageDirection ? "right" === e : "left" === e;
    }
    function gb(e) {
      const t = e.map(e => {
          let t;
          return t = "string" == typeof e ? {
            name: e
          } : e, t;
        }).filter(e => {
          const t = hb.includes(e.name);
          return t || w("alignment-config-name-not-recognized", {
            option: e
          }), t;
        }),
        n = t.filter(e => Boolean(e.className)).length;
      if (n && n < t.length) throw new _("alignment-config-classnames-are-missing", {
        configuredOptions: e
      });
      return t.forEach((t, n, i) => {
        const o = i.slice(n + 1);
        if (o.some(e => e.name == t.name)) throw new _("alignment-config-name-already-defined", {
          option: t,
          configuredOptions: e
        });
        if (t.className) {
          if (o.some(e => e.className == t.className)) throw new _("alignment-config-classname-already-defined", {
            option: t,
            configuredOptions: e
          });
        }
      }), t;
    }
    const fb = "alignment";
    class kb extends Pr {
      refresh() {
        const e = this.editor.locale,
          t = Go(this.editor.model.document.selection.getSelectedBlocks());
        this.isEnabled = Boolean(t) && this._canBeAligned(t), this.isEnabled && t.hasAttribute("alignment") ? this.value = t.getAttribute("alignment") : this.value = "rtl" === e.contentLanguageDirection ? "right" : "left";
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor,
          n = t.locale,
          i = t.model,
          o = i.document,
          r = e.value;
        i.change(e => {
          const t = Array.from(o.selection.getSelectedBlocks()).filter(e => this._canBeAligned(e)),
            i = t[0].getAttribute("alignment");
          pb(r, n) || i === r || !r ? function (e, t) {
            for (const n of e) t.removeAttribute(fb, n);
          }(t, e) : function (e, t, n) {
            for (const i of e) t.setAttribute(fb, n, i);
          }(t, e, r);
        });
      }
      _canBeAligned(e) {
        return this.editor.model.schema.checkAttribute(e, fb);
      }
    }
    class bb extends Br {
      static get pluginName() {
        return "AlignmentEditing";
      }
      constructor(e) {
        super(e), e.config.define("alignment", {
          options: hb.map(e => ({
            name: e
          }))
        });
      }
      init() {
        const e = this.editor,
          t = e.locale,
          n = e.model.schema,
          i = gb(e.config.get("alignment.options")).filter(e => mb(e.name) && !pb(e.name, t)),
          o = i.some(e => !!e.className);
        n.extend("$block", {
          allowAttributes: "alignment"
        }), e.model.schema.setAttributeProperties("alignment", {
          isFormatting: !0
        }), o ? e.conversion.attributeToAttribute(function (e) {
          const t = {};
          for (const n of e) t[n.name] = {
            key: "class",
            value: n.className
          };
          const n = {
            model: {
              key: "alignment",
              values: e.map(e => e.name)
            },
            view: t
          };
          return n;
        }(i)) : e.conversion.for("downcast").attributeToAttribute(function (e) {
          const t = {};
          for (const {
            name: n
          } of e) t[n] = {
            key: "style",
            value: {
              "text-align": n
            }
          };
          const n = {
            model: {
              key: "alignment",
              values: e.map(e => e.name)
            },
            view: t
          };
          return n;
        }(i));
        const r = function (e) {
          const t = [];
          for (const {
            name: n
          } of e) t.push({
            view: {
              key: "style",
              value: {
                "text-align": n
              }
            },
            model: {
              key: "alignment",
              value: n
            }
          });
          return t;
        }(i);
        for (const t of r) e.conversion.for("upcast").attributeToAttribute(t);
        const s = function (e) {
          const t = [];
          for (const {
            name: n
          } of e) t.push({
            view: {
              key: "align",
              value: n
            },
            model: {
              key: "alignment",
              value: n
            }
          });
          return t;
        }(i);
        for (const t of s) e.conversion.for("upcast").attributeToAttribute(t);
        e.commands.add("alignment", new kb(e));
      }
    }
    const _b = new Map([["left", Wh.alignLeft], ["right", Wh.alignRight], ["center", Wh.alignCenter], ["justify", Wh.alignJustify]]);
    class wb extends Br {
      get localizedOptionTitles() {
        const e = this.editor.t;
        return {
          left: e("Align left"),
          right: e("Align right"),
          center: e("Align center"),
          justify: e("Justify")
        };
      }
      static get pluginName() {
        return "AlignmentUI";
      }
      init() {
        const e = gb(this.editor.config.get("alignment.options"));
        e.map(e => e.name).filter(mb).forEach(e => this._addButton(e)), this._addToolbarDropdown(e), this._addMenuBarMenu(e);
      }
      _addButton(e) {
        this.editor.ui.componentFactory.add("alignment:".concat(e), t => this._createButton(t, e));
      }
      _createButton(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = this.editor,
          o = i.commands.get("alignment"),
          r = new um(e);
        return r.set({
          label: this.localizedOptionTitles[t],
          icon: _b.get(t),
          tooltip: !0,
          isToggleable: !0,
          ...n
        }), r.bind("isEnabled").to(o), r.bind("isOn").to(o, "value", e => e === t), this.listenTo(r, "execute", () => {
          i.execute("alignment", {
            value: t
          }), i.editing.view.focus();
        }), r;
      }
      _addToolbarDropdown(e) {
        const t = this.editor;
        t.ui.componentFactory.add("alignment", n => {
          const i = yp(n),
            o = "rtl" === n.uiLanguageDirection ? "w" : "e",
            r = n.t;
          xp(i, () => e.map(e => this._createButton(n, e.name, {
            tooltipPosition: o
          })), {
            enableActiveItemFocusOnDropdownOpen: !0,
            isVertical: !0,
            ariaLabel: r("Text alignment toolbar")
          }), i.buttonView.set({
            label: r("Text alignment"),
            tooltip: !0
          }), i.extendTemplate({
            attributes: {
              class: "ck-alignment-dropdown"
            }
          });
          const s = "rtl" === n.contentLanguageDirection ? _b.get("right") : _b.get("left"),
            a = t.commands.get("alignment");
          return i.buttonView.bind("icon").to(a, "value", e => _b.get(e) || s), i.bind("isEnabled").to(a, "isEnabled"), this.listenTo(i, "execute", () => {
            t.editing.view.focus();
          }), i;
        });
      }
      _addMenuBarMenu(e) {
        const t = this.editor;
        t.ui.componentFactory.add("menuBar:alignment", n => {
          const i = t.commands.get("alignment"),
            o = n.t,
            r = new Fk(n),
            s = new jk(n);
          r.bind("isEnabled").to(i), s.set({
            ariaLabel: o("Text alignment"),
            role: "menu"
          }), r.buttonView.set({
            label: o("Text alignment")
          });
          for (const o of e) {
            const e = new kk(n, r),
              a = new qk(n);
            a.extendTemplate({
              attributes: {
                "aria-checked": a.bindTemplate.to("isOn")
              }
            }), a.delegate("execute").to(r), a.set({
              label: this.localizedOptionTitles[o.name],
              icon: _b.get(o.name)
            }), a.on("execute", () => {
              t.execute("alignment", {
                value: o.name
              }), t.editing.view.focus();
            }), a.bind("isOn").to(i, "value", e => e === o.name), a.bind("isEnabled").to(i, "isEnabled"), e.children.add(a), s.items.add(e);
          }
          return r.panelView.children.add(s), r;
        });
      }
    }
    class Ab {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
        this._batch = null, this.model = e, this._size = 0, this.limit = t, this._isLocked = !1, this._changeCallback = (e, t) => {
          t.isLocal && t.isUndoable && t !== this._batch && this._reset(!0);
        }, this._selectionChangeCallback = () => {
          this._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }
      get batch() {
        return this._batch || (this._batch = this.model.createBatch({
          isTyping: !0
        })), this._batch;
      }
      get size() {
        return this._size;
      }
      input(e) {
        this._size += e, this._size >= this.limit && this._reset(!0);
      }
      get isLocked() {
        return this._isLocked;
      }
      lock() {
        this._isLocked = !0;
      }
      unlock() {
        this._isLocked = !1;
      }
      destroy() {
        this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
      }
      _reset() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        this.isLocked && !e || (this._batch = null, this._size = 0);
      }
    }
    class vb extends Pr {
      constructor(e, t) {
        super(e), this._buffer = new Ab(e.model, t), this._isEnabledBasedOnSelection = !1;
      }
      get buffer() {
        return this._buffer;
      }
      destroy() {
        super.destroy(), this._buffer.destroy();
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document,
          i = e.text || "",
          o = i.length;
        let r = n.selection;
        if (e.selection ? r = e.selection : e.range && (r = t.createSelection(e.range)), !t.canEditAt(r)) return;
        const s = e.resultRange;
        t.enqueueChange(this._buffer.batch, e => {
          this._buffer.lock();
          const a = Array.from(n.selection.getAttributes());
          t.deleteContent(r), i && t.insertContent(e.createText(i, a), r), s ? e.setSelection(s) : r.is("documentSelection") || e.setSelection(r), this._buffer.unlock(), this._buffer.input(o);
        });
      }
    }
    const Cb = ["insertText", "insertReplacementText"];
    class yb extends Ja {
      constructor(e) {
        super(e), this.focusObserver = e.getObserver(Fl), s.isAndroid && Cb.push("insertCompositionText");
        const t = e.document;
        t.on("beforeinput", (n, i) => {
          if (!this.isEnabled) return;
          const {
            data: o,
            targetRanges: r,
            inputType: s,
            domEvent: a
          } = i;
          if (!Cb.includes(s)) return;
          this.focusObserver.flush();
          const l = new m(t, "insertText");
          t.fire(l, new el(e, a, {
            text: o,
            selection: e.createSelection(r)
          })), l.stop.called && n.stop();
        }), t.on("compositionend", (n, _ref70) => {
          let {
            data: i,
            domEvent: o
          } = _ref70;
          this.isEnabled && !s.isAndroid && i && t.fire("insertText", new el(e, o, {
            text: i,
            selection: t.selection
          }));
        }, {
          priority: "lowest"
        });
      }
      observe() {}
      stopObserving() {}
    }
    class xb extends Br {
      static get pluginName() {
        return "Input";
      }
      init() {
        const e = this.editor,
          t = e.model,
          n = e.editing.view,
          i = t.document.selection;
        n.addObserver(yb);
        const o = new vb(e, e.config.get("typing.undoStep") || 20);
        e.commands.add("insertText", o), e.commands.add("input", o), this.listenTo(n.document, "insertText", (i, o) => {
          n.document.isComposing || o.preventDefault();
          const {
              text: r,
              selection: a,
              resultRange: l
            } = o,
            c = Array.from(a.getRanges()).map(t => e.editing.mapper.toModelRange(t));
          let d = r;
          if (s.isAndroid) {
            const e = Array.from(c[0].getItems()).reduce((e, t) => e + (t.is("$textProxy") ? t.data : ""), "");
            e && (e.length <= d.length ? d.startsWith(e) && (d = d.substring(e.length), c[0].start = c[0].start.getShiftedBy(e.length)) : e.startsWith(d) && (c[0].start = c[0].start.getShiftedBy(d.length), d = ""));
          }
          const u = {
            text: d,
            selection: t.createSelection(c)
          };
          l && (u.resultRange = e.editing.mapper.toModelRange(l)), e.execute("insertText", u), n.scrollToTheSelection();
        }), s.isAndroid ? this.listenTo(n.document, "keydown", (e, r) => {
          !i.isCollapsed && 229 == r.keyCode && n.document.isComposing && Eb(t, o);
        }) : this.listenTo(n.document, "compositionstart", () => {
          i.isCollapsed || Eb(t, o);
        });
      }
    }
    function Eb(e, t) {
      if (!t.isEnabled) return;
      const n = t.buffer;
      n.lock(), e.enqueueChange(n.batch, () => {
        e.deleteContent(e.document.selection);
      }), n.unlock();
    }
    class Sb extends Pr {
      constructor(e, t) {
        super(e), this.direction = t, this._buffer = new Ab(e.model, e.config.get("typing.undoStep")), this._isEnabledBasedOnSelection = !1;
      }
      get buffer() {
        return this._buffer;
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document;
        t.enqueueChange(this._buffer.batch, i => {
          this._buffer.lock();
          const o = i.createSelection(e.selection || n.selection);
          if (!t.canEditAt(o)) return;
          const r = e.sequence || 1,
            s = o.isCollapsed;
          if (o.isCollapsed && t.modifySelection(o, {
            direction: this.direction,
            unit: e.unit,
            treatEmojiAsSingleUnit: !0
          }), this._shouldEntireContentBeReplacedWithParagraph(r)) return void this._replaceEntireContentWithParagraph(i);
          if (this._shouldReplaceFirstBlockWithParagraph(o, r)) return void this.editor.execute("paragraph", {
            selection: o
          });
          if (o.isCollapsed) return;
          let a = 0;
          o.getFirstRange().getMinimalFlatRanges().forEach(e => {
            a += Q(e.getWalker({
              singleCharacters: !0,
              ignoreElementEnd: !0,
              shallow: !0
            }));
          }), t.deleteContent(o, {
            doNotResetEntireContent: s,
            direction: this.direction
          }), this._buffer.input(a), i.setSelection(o), this._buffer.unlock();
        });
      }
      _shouldEntireContentBeReplacedWithParagraph(e) {
        if (e > 1) return !1;
        const t = this.editor.model,
          n = t.document.selection,
          i = t.schema.getLimitElement(n);
        if (!(n.isCollapsed && n.containsEntireContent(i))) return !1;
        if (!t.schema.checkChild(i, "paragraph")) return !1;
        const o = i.getChild(0);
        return !o || !o.is("element", "paragraph");
      }
      _replaceEntireContentWithParagraph(e) {
        const t = this.editor.model,
          n = t.document.selection,
          i = t.schema.getLimitElement(n),
          o = e.createElement("paragraph");
        e.remove(e.createRangeIn(i)), e.insert(o, i), e.setSelection(o, 0);
      }
      _shouldReplaceFirstBlockWithParagraph(e, t) {
        const n = this.editor.model;
        if (t > 1 || "backward" != this.direction) return !1;
        if (!e.isCollapsed) return !1;
        const i = e.getFirstPosition(),
          o = n.schema.getLimitElement(i),
          r = o.getChild(0);
        return i.parent == r && !!e.containsEntireContent(r) && !!n.schema.checkChild(o, "paragraph") && "paragraph" != r.name;
      }
    }
    const Db = "word",
      Tb = "selection",
      Ib = "backward",
      Bb = "forward",
      Mb = {
        deleteContent: {
          unit: Tb,
          direction: Ib
        },
        deleteContentBackward: {
          unit: "codePoint",
          direction: Ib
        },
        deleteWordBackward: {
          unit: Db,
          direction: Ib
        },
        deleteHardLineBackward: {
          unit: Tb,
          direction: Ib
        },
        deleteSoftLineBackward: {
          unit: Tb,
          direction: Ib
        },
        deleteContentForward: {
          unit: "character",
          direction: Bb
        },
        deleteWordForward: {
          unit: Db,
          direction: Bb
        },
        deleteHardLineForward: {
          unit: Tb,
          direction: Bb
        },
        deleteSoftLineForward: {
          unit: Tb,
          direction: Bb
        }
      };
    class Pb extends Ja {
      constructor(e) {
        super(e);
        const t = e.document;
        let n = 0;
        t.on("keydown", () => {
          n++;
        }), t.on("keyup", () => {
          n = 0;
        }), t.on("beforeinput", (i, o) => {
          if (!this.isEnabled) return;
          const {
              targetRanges: r,
              domEvent: a,
              inputType: l
            } = o,
            c = Mb[l];
          if (!c) return;
          const d = {
            direction: c.direction,
            unit: c.unit,
            sequence: n
          };
          d.unit == Tb && (d.selectionToRemove = e.createSelection(r[0])), "deleteContentBackward" === l && (s.isAndroid && (d.sequence = 1), function (e) {
            if (1 != e.length || e[0].isCollapsed) return !1;
            const t = e[0].getWalker({
              direction: "backward",
              singleCharacters: !0,
              ignoreElementEnd: !0
            });
            let n = 0;
            for (const {
              nextPosition: e,
              item: i
            } of t) {
              if (e.parent.is("$text")) {
                const t = e.parent.data,
                  i = e.offset;
                if (Zo(t, i) || Qo(t, i) || Xo(t, i)) continue;
                n++;
              } else (i.is("containerElement") || i.is("emptyElement")) && n++;
              if (n > 1) return !0;
            }
            return !1;
          }(r) && (d.unit = Tb, d.selectionToRemove = e.createSelection(r)));
          const u = new Ys(t, "delete", r[0]);
          t.fire(u, new el(e, a, d)), u.stop.called && i.stop();
        }), s.isBlink && function (e) {
          const t = e.view,
            n = t.document;
          let i = null,
            o = !1;
          function r(e) {
            return e == mo.backspace || e == mo.delete;
          }
          function s(e) {
            return e == mo.backspace ? Ib : Bb;
          }
          n.on("keydown", (e, _ref71) => {
            let {
              keyCode: t
            } = _ref71;
            i = t, o = !1;
          }), n.on("keyup", (a, _ref72) => {
            let {
              keyCode: l,
              domEvent: c
            } = _ref72;
            const d = n.selection,
              u = e.isEnabled && l == i && r(l) && !d.isCollapsed && !o;
            if (i = null, u) {
              const e = d.getFirstRange(),
                i = new Ys(n, "delete", e),
                o = {
                  unit: Tb,
                  direction: s(l),
                  selectionToRemove: d
                };
              n.fire(i, new el(t, c, o));
            }
          }), n.on("beforeinput", (e, _ref73) => {
            let {
              inputType: t
            } = _ref73;
            const n = Mb[t];
            r(i) && n && n.direction == s(i) && (o = !0);
          }, {
            priority: "high"
          }), n.on("beforeinput", (e, _ref74) => {
            let {
              inputType: t,
              data: n
            } = _ref74;
            i == mo.delete && "insertText" == t && "" == n && e.stop();
          }, {
            priority: "high"
          });
        }(this);
      }
      observe() {}
      stopObserving() {}
    }
    class zb extends Br {
      static get pluginName() {
        return "Delete";
      }
      init() {
        const e = this.editor,
          t = e.editing.view,
          n = t.document,
          i = e.model.document;
        t.addObserver(Pb), this._undoOnBackspace = !1;
        const o = new Sb(e, "forward");
        e.commands.add("deleteForward", o), e.commands.add("forwardDelete", o), e.commands.add("delete", new Sb(e, "backward")), this.listenTo(n, "delete", (i, o) => {
          n.isComposing || o.preventDefault();
          const {
              direction: r,
              sequence: s,
              selectionToRemove: a,
              unit: l
            } = o,
            c = "forward" === r ? "deleteForward" : "delete",
            d = {
              sequence: s
            };
          if ("selection" == l) {
            const t = Array.from(a.getRanges()).map(t => e.editing.mapper.toModelRange(t));
            d.selection = e.model.createSelection(t);
          } else d.unit = l;
          e.execute(c, d), t.scrollToTheSelection();
        }, {
          priority: "low"
        }), this.editor.plugins.has("UndoEditing") && (this.listenTo(n, "delete", (t, n) => {
          this._undoOnBackspace && "backward" == n.direction && 1 == n.sequence && "codePoint" == n.unit && (this._undoOnBackspace = !1, e.execute("undo"), n.preventDefault(), t.stop());
        }, {
          context: "$capture"
        }), this.listenTo(i, "change", () => {
          this._undoOnBackspace = !1;
        }));
      }
      requestUndoOnBackspace() {
        this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
      }
    }
    class Nb extends Br {
      static get requires() {
        return [xb, zb];
      }
      static get pluginName() {
        return "Typing";
      }
    }
    function Lb(e, t) {
      let n = e.start;
      return {
        text: Array.from(e.getWalker({
          ignoreElementEnd: !1
        })).reduce((e, _ref75) => {
          let {
            item: i
          } = _ref75;
          return i.is("$text") || i.is("$textProxy") ? e + i.data : (n = t.createPositionAfter(i), "");
        }, ""),
        range: t.createRange(n, e.end)
      };
    }
    class Rb extends q() {
      constructor(e, t) {
        super(), this.model = e, this.testCallback = t, this._hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", () => {
          this.isEnabled ? this._startListening() : (this.stopListening(e.document.selection), this.stopListening(e.document));
        }), this._startListening();
      }
      get hasMatch() {
        return this._hasMatch;
      }
      _startListening() {
        const e = this.model.document;
        this.listenTo(e.selection, "change:range", (t, _ref76) => {
          let {
            directChange: n
          } = _ref76;
          n && (e.selection.isCollapsed ? this._evaluateTextBeforeSelection("selection") : this.hasMatch && (this.fire("unmatched"), this._hasMatch = !1));
        }), this.listenTo(e, "change:data", (e, t) => {
          !t.isUndo && t.isLocal && this._evaluateTextBeforeSelection("data", {
            batch: t
          });
        });
      }
      _evaluateTextBeforeSelection(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.model,
          i = n.document.selection,
          o = n.createRange(n.createPositionAt(i.focus.parent, 0), i.focus),
          {
            text: r,
            range: s
          } = Lb(o, n),
          a = this.testCallback(r);
        if (!a && this.hasMatch && this.fire("unmatched"), this._hasMatch = !!a, a) {
          const n = Object.assign(t, {
            text: r,
            range: s
          });
          "object" == typeof a && Object.assign(n, a), this.fire("matched:".concat(e), n);
        }
      }
    }
    class Vb extends Br {
      static get pluginName() {
        return "TwoStepCaretMovement";
      }
      constructor(e) {
        super(e), this._isNextGravityRestorationSkipped = !1, this.attributes = new Set(), this._overrideUid = null;
      }
      init() {
        const e = this.editor,
          t = e.model,
          n = e.editing.view,
          i = e.locale,
          o = t.document.selection;
        this.listenTo(n.document, "arrowKey", (e, t) => {
          if (!o.isCollapsed) return;
          if (t.shiftKey || t.altKey || t.ctrlKey) return;
          const n = t.keyCode == mo.arrowright,
            r = t.keyCode == mo.arrowleft;
          if (!n && !r) return;
          const s = i.contentLanguageDirection;
          let a = !1;
          a = "ltr" === s && n || "rtl" === s && r ? this._handleForwardMovement(t) : this._handleBackwardMovement(t), !0 === a && e.stop();
        }, {
          context: "$text",
          priority: "highest"
        }), this.listenTo(o, "change:range", (e, t) => {
          this._isNextGravityRestorationSkipped ? this._isNextGravityRestorationSkipped = !1 : this._isGravityOverridden && (!t.directChange && qb(o.getFirstPosition(), this.attributes) || this._restoreGravity());
        }), this._enableClickingAfterNode(), this._enableInsertContentSelectionAttributesFixer(), this._handleDeleteContentAfterNode();
      }
      registerAttribute(e) {
        this.attributes.add(e);
      }
      _handleForwardMovement(e) {
        const t = this.attributes,
          n = this.editor.model,
          i = n.document.selection,
          o = i.getFirstPosition();
        return !this._isGravityOverridden && (!o.isAtStart || !Ob(i, t)) && !!qb(o, t) && (Hb(e), Ob(i, t) && qb(o, t, !0) ? jb(n, t) : this._overrideGravity(), !0);
      }
      _handleBackwardMovement(e) {
        const t = this.attributes,
          n = this.editor.model,
          i = n.document.selection,
          o = i.getFirstPosition();
        return this._isGravityOverridden ? (Hb(e), this._restoreGravity(), qb(o, t, !0) ? jb(n, t) : Fb(n, t, o), !0) : o.isAtStart ? !!Ob(i, t) && (Hb(e), Fb(n, t, o), !0) : !Ob(i, t) && qb(o, t, !0) ? (Hb(e), Fb(n, t, o), !0) : !!Ub(o, t) && (o.isAtEnd && !Ob(i, t) && qb(o, t) ? (Hb(e), Fb(n, t, o), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1));
      }
      _enableClickingAfterNode() {
        const e = this.editor,
          t = e.model,
          n = t.document.selection,
          i = e.editing.view.document;
        e.editing.view.addObserver(Ju);
        let o = !1;
        this.listenTo(i, "mousedown", () => {
          o = !0;
        }), this.listenTo(i, "selectionChange", () => {
          const e = this.attributes;
          if (!o) return;
          if (o = !1, !n.isCollapsed) return;
          if (!Ob(n, e)) return;
          const i = n.getFirstPosition();
          qb(i, e) && (i.isAtStart || qb(i, e, !0) ? jb(t, e) : this._isGravityOverridden || this._overrideGravity());
        });
      }
      _enableInsertContentSelectionAttributesFixer() {
        const e = this.editor.model,
          t = e.document.selection,
          n = this.attributes;
        this.listenTo(e, "insertContent", () => {
          const i = t.getFirstPosition();
          Ob(t, n) && qb(i, n) && jb(e, n);
        }, {
          priority: "low"
        });
      }
      _handleDeleteContentAfterNode() {
        const e = this.editor,
          t = e.model,
          n = t.document.selection,
          i = e.editing.view;
        let o = !1,
          r = !1;
        this.listenTo(i.document, "delete", (e, t) => {
          o = "backward" === t.direction;
        }, {
          priority: "high"
        }), this.listenTo(t, "deleteContent", () => {
          if (!o) return;
          const e = n.getFirstPosition();
          r = Ob(n, this.attributes) && !Ub(e, this.attributes);
        }, {
          priority: "high"
        }), this.listenTo(t, "deleteContent", () => {
          o && (o = !1, r || e.model.enqueueChange(() => {
            const e = n.getFirstPosition();
            Ob(n, this.attributes) && qb(e, this.attributes) && (e.isAtStart || qb(e, this.attributes, !0) ? jb(t, this.attributes) : this._isGravityOverridden || this._overrideGravity());
          }));
        }, {
          priority: "low"
        });
      }
      get _isGravityOverridden() {
        return !!this._overrideUid;
      }
      _overrideGravity() {
        this._overrideUid = this.editor.model.change(e => e.overrideSelectionGravity());
      }
      _restoreGravity() {
        this.editor.model.change(e => {
          e.restoreSelectionGravity(this._overrideUid), this._overrideUid = null;
        });
      }
    }
    function Ob(e, t) {
      for (const n of t) if (e.hasAttribute(n)) return !0;
      return !1;
    }
    function Fb(e, t, n) {
      const i = n.nodeBefore;
      e.change(n => {
        if (i) {
          const t = [],
            o = e.schema.isObject(i) && e.schema.isInline(i);
          for (const [n, r] of i.getAttributes()) !e.schema.checkAttribute("$text", n) || o && !1 === e.schema.getAttributeProperties(n).copyFromObject || t.push([n, r]);
          n.setSelectionAttribute(t);
        } else n.removeSelectionAttribute(t);
      });
    }
    function jb(e, t) {
      e.change(e => {
        e.removeSelectionAttribute(t);
      });
    }
    function Hb(e) {
      e.preventDefault();
    }
    function Ub(e, t) {
      return qb(e.getShiftedBy(-1), t);
    }
    function qb(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      const {
        nodeBefore: i,
        nodeAfter: o
      } = e;
      for (const e of t) {
        const t = i ? i.getAttribute(e) : void 0,
          r = o ? o.getAttribute(e) : void 0;
        if ((!n || void 0 !== t && void 0 !== r) && r !== t) return !0;
      }
      return !1;
    }
    const Gb = {
        copyright: {
          from: "(c)",
          to: "©"
        },
        registeredTrademark: {
          from: "(r)",
          to: "®"
        },
        trademark: {
          from: "(tm)",
          to: "™"
        },
        oneHalf: {
          from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
          to: [null, "½", null]
        },
        oneThird: {
          from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
          to: [null, "⅓", null]
        },
        twoThirds: {
          from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
          to: [null, "⅔", null]
        },
        oneForth: {
          from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
          to: [null, "¼", null]
        },
        threeQuarters: {
          from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
          to: [null, "¾", null]
        },
        lessThanOrEqual: {
          from: "<=",
          to: "≤"
        },
        greaterThanOrEqual: {
          from: ">=",
          to: "≥"
        },
        notEqual: {
          from: "!=",
          to: "≠"
        },
        arrowLeft: {
          from: "<-",
          to: "←"
        },
        arrowRight: {
          from: "->",
          to: "→"
        },
        horizontalEllipsis: {
          from: "...",
          to: "…"
        },
        enDash: {
          from: /(^| )(--)( )$/,
          to: [null, "–", null]
        },
        emDash: {
          from: /(^| )(---)( )$/,
          to: [null, "—", null]
        },
        quotesPrimary: {
          from: Qb('"'),
          to: [null, "“", null, "”"]
        },
        quotesSecondary: {
          from: Qb("'"),
          to: [null, "‘", null, "’"]
        },
        quotesPrimaryEnGb: {
          from: Qb("'"),
          to: [null, "‘", null, "’"]
        },
        quotesSecondaryEnGb: {
          from: Qb('"'),
          to: [null, "“", null, "”"]
        },
        quotesPrimaryPl: {
          from: Qb('"'),
          to: [null, "„", null, "”"]
        },
        quotesSecondaryPl: {
          from: Qb("'"),
          to: [null, "‚", null, "’"]
        }
      },
      Kb = {
        symbols: ["copyright", "registeredTrademark", "trademark"],
        mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
        typography: ["horizontalEllipsis", "enDash", "emDash"],
        quotes: ["quotesPrimary", "quotesSecondary"]
      },
      Wb = ["symbols", "mathematical", "typography", "quotes"];
    function Yb(e) {
      return "string" == typeof e ? new RegExp("(".concat(Qf(e), ")$")) : e;
    }
    function $b(e) {
      return "string" == typeof e ? () => [e] : e instanceof Array ? () => e : e;
    }
    function Zb(e) {
      return (e.textNode ? e.textNode : e.nodeAfter).getAttributes();
    }
    function Qb(e) {
      return new RegExp("(^|\\s)(".concat(e, ")([^").concat(e, "]*)(").concat(e, ")$"));
    }
    function Jb(e, t, n, i) {
      return i.createRange(Xb(e, t, n, !0, i), Xb(e, t, n, !1, i));
    }
    function Xb(e, t, n, i, o) {
      let r = e.textNode || (i ? e.nodeBefore : e.nodeAfter),
        s = null;
      for (; r && r.getAttribute(t) == n;) s = r, r = i ? r.previousSibling : r.nextSibling;
      return s ? o.createPositionAt(s, i ? "before" : "after") : e;
    }
    function e_(e, t, n, i) {
      let o,
        r = null;
      "function" == typeof i ? o = i : (r = e.commands.get(i), o = () => {
        e.execute(i);
      }), e.model.document.on("change:data", (s, a) => {
        if (r && !r.isEnabled || !t.isEnabled) return;
        const l = Go(e.model.document.selection.getRanges());
        if (!l.isCollapsed) return;
        if (a.isUndo || !a.isLocal) return;
        const c = Array.from(e.model.document.differ.getChanges()),
          d = c[0];
        if (1 != c.length || "insert" !== d.type || "$text" != d.name || 1 != d.length) return;
        const u = d.position.parent;
        if (u.is("element", "codeBlock")) return;
        if (u.is("element", "listItem") && "function" != typeof i && !["numberedList", "bulletedList", "todoList"].includes(i)) return;
        if (r && !0 === r.value) return;
        const h = u.getChild(0),
          m = e.model.createRangeOn(h);
        if (!m.containsRange(l) && !l.end.isEqual(m.end)) return;
        const p = n.exec(h.data.substr(0, l.end.offset));
        p && e.model.enqueueChange(t => {
          const n = t.createPositionAt(u, 0),
            i = t.createPositionAt(u, p[0].length),
            r = new yc(n, i);
          if (!1 !== o({
            match: p
          })) {
            t.remove(r);
            const n = e.model.document.selection.getFirstRange(),
              i = t.createRangeIn(u);
            !u.isEmpty || i.isEqual(n) || i.containsRange(n, !0) || t.remove(u);
          }
          r.detach(), e.model.enqueueChange(() => {
            e.plugins.get("Delete").requestUndoOnBackspace();
          });
        });
      });
    }
    function t_(e, t, n, i) {
      let o, r;
      n instanceof RegExp ? o = n : r = n, r = r || (e => {
        let t;
        const n = [],
          i = [];
        for (; null !== (t = o.exec(e)) && !(t && t.length < 4);) {
          let {
            index: e,
            1: o,
            2: r,
            3: s
          } = t;
          const a = o + r + s;
          e += t[0].length - a.length;
          const l = [e, e + o.length],
            c = [e + o.length + r.length, e + o.length + r.length + s.length];
          n.push(l), n.push(c), i.push([e + o.length, e + o.length + r.length]);
        }
        return {
          remove: n,
          format: i
        };
      }), e.model.document.on("change:data", (n, o) => {
        if (o.isUndo || !o.isLocal || !t.isEnabled) return;
        const s = e.model,
          a = s.document.selection;
        if (!a.isCollapsed) return;
        const l = Array.from(s.document.differ.getChanges()),
          c = l[0];
        if (1 != l.length || "insert" !== c.type || "$text" != c.name || 1 != c.length) return;
        const d = a.focus,
          u = d.parent,
          {
            text: h,
            range: m
          } = function (e, t) {
            let n = e.start;
            const i = Array.from(e.getItems()).reduce((e, i) => !i.is("$text") && !i.is("$textProxy") || i.getAttribute("code") ? (n = t.createPositionAfter(i), "") : e + i.data, "");
            return {
              text: i,
              range: t.createRange(n, e.end)
            };
          }(s.createRange(s.createPositionAt(u, 0), d), s),
          p = r(h),
          g = n_(m.start, p.format, s),
          f = n_(m.start, p.remove, s);
        g.length && f.length && s.enqueueChange(t => {
          if (!1 !== i(t, g)) {
            for (const e of f.reverse()) t.remove(e);
            s.enqueueChange(() => {
              e.plugins.get("Delete").requestUndoOnBackspace();
            });
          }
        });
      });
    }
    function n_(e, t, n) {
      return t.filter(e => void 0 !== e[0] && void 0 !== e[1]).map(t => n.createRange(e.getShiftedBy(t[0]), e.getShiftedBy(t[1])));
    }
    function i_(e, t) {
      return (n, i) => {
        if (!e.commands.get(t).isEnabled) return !1;
        const o = e.model.schema.getValidRanges(i, t);
        for (const e of o) n.setAttribute(t, !0, e);
        n.removeSelectionAttribute(t);
      };
    }
    class o_ extends Pr {
      constructor(e, t) {
        super(e), this.attributeKey = t;
      }
      refresh() {
        const e = this.editor.model,
          t = e.document;
        this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = e.schema.checkAttributeInSelection(t.selection, this.attributeKey);
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document.selection,
          i = void 0 === e.forceValue ? !this.value : e.forceValue;
        t.change(e => {
          if (n.isCollapsed) i ? e.setSelectionAttribute(this.attributeKey, !0) : e.removeSelectionAttribute(this.attributeKey);else {
            const o = t.schema.getValidRanges(n.getRanges(), this.attributeKey);
            for (const t of o) i ? e.setAttribute(this.attributeKey, i, t) : e.removeAttribute(this.attributeKey, t);
          }
        });
      }
      _getValueFromFirstAllowedNode() {
        const e = this.editor.model,
          t = e.schema,
          n = e.document.selection;
        if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
        for (const e of n.getRanges()) for (const n of e.getItems()) if (t.checkAttribute(n, this.attributeKey)) return n.hasAttribute(this.attributeKey);
        return !1;
      }
    }
    const r_ = "bold";
    class s_ extends Br {
      static get pluginName() {
        return "BoldEditing";
      }
      init() {
        const e = this.editor,
          t = this.editor.t;
        e.model.schema.extend("$text", {
          allowAttributes: r_
        }), e.model.schema.setAttributeProperties(r_, {
          isFormatting: !0,
          copyOnEnter: !0
        }), e.conversion.attributeToElement({
          model: r_,
          view: "strong",
          upcastAlso: ["b", e => {
            const t = e.getStyle("font-weight");
            return t && ("bold" == t || Number(t) >= 600) ? {
              name: !0,
              styles: ["font-weight"]
            } : null;
          }]
        }), e.commands.add(r_, new o_(e, r_)), e.keystrokes.set("CTRL+B", r_), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Bold text"),
            keystroke: "CTRL+B"
          }]
        });
      }
    }
    function a_(_ref77) {
      let {
        editor: e,
        commandName: t,
        plugin: n,
        icon: i,
        label: o,
        keystroke: r
      } = _ref77;
      return s => {
        const a = e.commands.get(t),
          l = new s(e.locale);
        return l.set({
          label: o,
          icon: i,
          keystroke: r,
          isToggleable: !0
        }), l.bind("isEnabled").to(a, "isEnabled"), n.listenTo(l, "execute", () => {
          e.execute(t), e.editing.view.focus();
        }), l;
      };
    }
    const l_ = "bold";
    class c_ extends Br {
      static get pluginName() {
        return "BoldUI";
      }
      init() {
        const e = this.editor,
          t = e.locale.t,
          n = e.commands.get(l_),
          i = a_({
            editor: e,
            commandName: l_,
            plugin: this,
            icon: Wh.bold,
            label: t("Bold"),
            keystroke: "CTRL+B"
          });
        e.ui.componentFactory.add(l_, () => {
          const e = i(um);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(n, "value"), e;
        }), e.ui.componentFactory.add("menuBar:" + l_, () => i(qk));
      }
    }
    var d_ = o(7930),
      u_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(d_.A, u_);
    d_.A.locals;
    const h_ = "italic";
    class m_ extends Br {
      static get pluginName() {
        return "ItalicEditing";
      }
      init() {
        const e = this.editor,
          t = this.editor.t;
        e.model.schema.extend("$text", {
          allowAttributes: h_
        }), e.model.schema.setAttributeProperties(h_, {
          isFormatting: !0,
          copyOnEnter: !0
        }), e.conversion.attributeToElement({
          model: h_,
          view: "i",
          upcastAlso: ["em", {
            styles: {
              "font-style": "italic"
            }
          }]
        }), e.commands.add(h_, new o_(e, h_)), e.keystrokes.set("CTRL+I", h_), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Italic text"),
            keystroke: "CTRL+I"
          }]
        });
      }
    }
    const p_ = "italic";
    class g_ extends Br {
      static get pluginName() {
        return "ItalicUI";
      }
      init() {
        const e = this.editor,
          t = e.commands.get(p_),
          n = e.locale.t,
          i = a_({
            editor: e,
            commandName: p_,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
            keystroke: "CTRL+I",
            label: n("Italic")
          });
        e.ui.componentFactory.add(p_, () => {
          const e = i(um);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(t, "value"), e;
        }), e.ui.componentFactory.add("menuBar:" + p_, () => i(qk));
      }
    }
    const f_ = "strikethrough";
    class k_ extends Br {
      static get pluginName() {
        return "StrikethroughEditing";
      }
      init() {
        const e = this.editor,
          t = this.editor.t;
        e.model.schema.extend("$text", {
          allowAttributes: f_
        }), e.model.schema.setAttributeProperties(f_, {
          isFormatting: !0,
          copyOnEnter: !0
        }), e.conversion.attributeToElement({
          model: f_,
          view: "s",
          upcastAlso: ["del", "strike", {
            styles: {
              "text-decoration": "line-through"
            }
          }]
        }), e.commands.add(f_, new o_(e, f_)), e.keystrokes.set("CTRL+SHIFT+X", "strikethrough"), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Strikethrough text"),
            keystroke: "CTRL+SHIFT+X"
          }]
        });
      }
    }
    const b_ = "strikethrough";
    class __ extends Br {
      static get pluginName() {
        return "StrikethroughUI";
      }
      init() {
        const e = this.editor,
          t = e.locale.t,
          n = a_({
            editor: e,
            commandName: b_,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 16.4c-.8-.4-1.5-.9-2.2-1.5a.6.6 0 0 1-.2-.5l.3-.6h1c1 1.2 2.1 1.7 3.7 1.7 1 0 1.8-.3 2.3-.6.6-.4.6-1.2.6-1.3.2-1.2-.9-2.1-.9-2.1h2.1c.3.7.4 1.2.4 1.7v.8l-.6 1.2c-.6.8-1.1 1-1.6 1.2a6 6 0 0 1-2.4.6c-1 0-1.8-.3-2.5-.6zM6.8 9 6 8.3c-.4-.5-.5-.8-.5-1.6 0-.7.1-1.3.5-1.8.4-.6 1-1 1.6-1.3a6.3 6.3 0 0 1 4.7 0 4 4 0 0 1 1.7 1l.3.7c0 .1.2.4-.2.7-.4.2-.9.1-1 0a3 3 0 0 0-1.2-1c-.4-.2-1-.3-2-.4-.7 0-1.4.2-2 .6-.8.6-1 .8-1 1.5 0 .8.5 1 1.2 1.5.6.4 1.1.7 1.9 1H6.8z"/><path d="M3 10.5V9h14v1.5z"/></svg>',
            keystroke: "CTRL+SHIFT+X",
            label: t("Strikethrough")
          });
        e.ui.componentFactory.add(b_, () => {
          const t = n(um),
            i = e.commands.get(b_);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(i, "value"), t;
        }), e.ui.componentFactory.add("menuBar:" + b_, () => n(qk));
      }
    }
    const w_ = "superscript";
    class A_ extends Br {
      static get pluginName() {
        return "SuperscriptEditing";
      }
      init() {
        const e = this.editor;
        e.model.schema.extend("$text", {
          allowAttributes: w_
        }), e.model.schema.setAttributeProperties(w_, {
          isFormatting: !0,
          copyOnEnter: !0
        }), e.conversion.attributeToElement({
          model: w_,
          view: "sup",
          upcastAlso: [{
            styles: {
              "vertical-align": "super"
            }
          }]
        }), e.commands.add(w_, new o_(e, w_));
      }
    }
    const v_ = "superscript";
    class C_ extends Br {
      static get pluginName() {
        return "SuperscriptUI";
      }
      init() {
        const e = this.editor,
          t = e.locale.t,
          n = a_({
            editor: e,
            commandName: v_,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.677 8.678h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309zM7.03 10.349l3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82z"/></svg>',
            label: t("Superscript")
          });
        e.ui.componentFactory.add(v_, () => {
          const t = n(um),
            i = e.commands.get(v_);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(i, "value"), t;
        }), e.ui.componentFactory.add("menuBar:" + v_, () => n(qk));
      }
    }
    const y_ = "underline";
    class x_ extends Br {
      static get pluginName() {
        return "UnderlineEditing";
      }
      init() {
        const e = this.editor,
          t = this.editor.t;
        e.model.schema.extend("$text", {
          allowAttributes: y_
        }), e.model.schema.setAttributeProperties(y_, {
          isFormatting: !0,
          copyOnEnter: !0
        }), e.conversion.attributeToElement({
          model: y_,
          view: "u",
          upcastAlso: {
            styles: {
              "text-decoration": "underline"
            }
          }
        }), e.commands.add(y_, new o_(e, y_)), e.keystrokes.set("CTRL+U", "underline"), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Underline text"),
            keystroke: "CTRL+U"
          }]
        });
      }
    }
    const E_ = "underline";
    class S_ extends Br {
      static get pluginName() {
        return "UnderlineUI";
      }
      init() {
        const e = this.editor,
          t = e.commands.get(E_),
          n = e.locale.t,
          i = a_({
            editor: e,
            commandName: E_,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>',
            label: n("Underline"),
            keystroke: "CTRL+U"
          });
        e.ui.componentFactory.add(E_, () => {
          const e = i(um);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(t, "value"), e;
        }), e.ui.componentFactory.add("menuBar:" + E_, () => i(qk));
      }
    }
    function* D_(e, t) {
      for (const n of t) n && e.getAttributeProperties(n[0]).copyOnEnter && (yield n);
    }
    class T_ extends Pr {
      execute() {
        this.editor.model.change(e => {
          this.enterBlock(e), this.fire("afterExecute", {
            writer: e
          });
        });
      }
      enterBlock(e) {
        const t = this.editor.model,
          n = t.document.selection,
          i = t.schema,
          o = n.isCollapsed,
          r = n.getFirstRange(),
          s = r.start.parent,
          a = r.end.parent;
        if (i.isLimit(s) || i.isLimit(a)) return o || s != a || t.deleteContent(n), !1;
        if (o) {
          const t = D_(e.model.schema, n.getAttributes());
          return I_(e, r.start), e.setSelectionAttribute(t), !0;
        }
        {
          const i = !(r.start.isAtStart && r.end.isAtEnd),
            o = s == a;
          if (t.deleteContent(n, {
            leaveUnmerged: i
          }), i) {
            if (o) return I_(e, n.focus), !0;
            e.setSelection(a, 0);
          }
        }
        return !1;
      }
    }
    function I_(e, t) {
      e.split(t), e.setSelection(t.parent.nextSibling, 0);
    }
    const B_ = {
      insertParagraph: {
        isSoft: !1
      },
      insertLineBreak: {
        isSoft: !0
      }
    };
    class M_ extends Ja {
      constructor(e) {
        super(e);
        const t = this.document;
        let n = !1;
        t.on("keydown", (e, t) => {
          n = t.shiftKey;
        }), t.on("beforeinput", (i, o) => {
          if (!this.isEnabled) return;
          let r = o.inputType;
          s.isSafari && n && "insertParagraph" == r && (r = "insertLineBreak");
          const a = o.domEvent,
            l = B_[r];
          if (!l) return;
          const c = new Ys(t, "enter", o.targetRanges[0]);
          t.fire(c, new el(e, a, {
            isSoft: l.isSoft
          })), c.stop.called && i.stop();
        });
      }
      observe() {}
      stopObserving() {}
    }
    class P_ extends Br {
      static get pluginName() {
        return "Enter";
      }
      init() {
        const e = this.editor,
          t = e.editing.view,
          n = t.document,
          i = this.editor.t;
        t.addObserver(M_), e.commands.add("enter", new T_(e)), this.listenTo(n, "enter", (i, o) => {
          n.isComposing || o.preventDefault(), o.isSoft || (e.execute("enter"), t.scrollToTheSelection());
        }, {
          priority: "low"
        }), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: i("Insert a hard break (a new paragraph)"),
            keystroke: "Enter"
          }]
        });
      }
    }
    class z_ extends Pr {
      execute() {
        const e = this.editor.model,
          t = e.document;
        e.change(n => {
          !function (e, t, n) {
            const i = n.isCollapsed,
              o = n.getFirstRange(),
              r = o.start.parent,
              s = o.end.parent,
              a = r == s;
            if (i) {
              const i = D_(e.schema, n.getAttributes());
              N_(e, t, o.end), t.removeSelectionAttribute(n.getAttributeKeys()), t.setSelectionAttribute(i);
            } else {
              const i = !(o.start.isAtStart && o.end.isAtEnd);
              e.deleteContent(n, {
                leaveUnmerged: i
              }), a ? N_(e, t, n.focus) : i && t.setSelection(s, 0);
            }
          }(e, n, t.selection), this.fire("afterExecute", {
            writer: n
          });
        });
      }
      refresh() {
        const e = this.editor.model,
          t = e.document;
        this.isEnabled = function (e, t) {
          if (t.rangeCount > 1) return !1;
          const n = t.anchor;
          if (!n || !e.checkChild(n, "softBreak")) return !1;
          const i = t.getFirstRange(),
            o = i.start.parent,
            r = i.end.parent;
          if ((L_(o, e) || L_(r, e)) && o !== r) return !1;
          return !0;
        }(e.schema, t.selection);
      }
    }
    function N_(e, t, n) {
      const i = t.createElement("softBreak");
      e.insertContent(i, n), t.setSelection(i, "after");
    }
    function L_(e, t) {
      return !e.is("rootElement") && (t.isLimit(e) || L_(e.parent, t));
    }
    class R_ extends Br {
      static get pluginName() {
        return "ShiftEnter";
      }
      init() {
        const e = this.editor,
          t = e.model.schema,
          n = e.conversion,
          i = e.editing.view,
          o = i.document,
          r = this.editor.t;
        t.register("softBreak", {
          allowWhere: "$text",
          isInline: !0
        }), n.for("upcast").elementToElement({
          model: "softBreak",
          view: "br"
        }), n.for("downcast").elementToElement({
          model: "softBreak",
          view: (e, _ref78) => {
            let {
              writer: t
            } = _ref78;
            return t.createEmptyElement("br");
          }
        }), i.addObserver(M_), e.commands.add("shiftEnter", new z_(e)), this.listenTo(o, "enter", (t, n) => {
          o.isComposing || n.preventDefault(), n.isSoft && (e.execute("shiftEnter"), i.scrollToTheSelection());
        }, {
          priority: "low"
        }), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: r("Insert a soft break (a <code>&lt;br&gt;</code> element)"),
            keystroke: "Shift+Enter"
          }]
        });
      }
    }
    class V_ extends Pr {
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.schema,
          i = t.document.selection,
          o = Array.from(i.getSelectedBlocks()),
          r = void 0 === e.forceValue ? !this.value : e.forceValue;
        t.change(e => {
          if (r) {
            const t = o.filter(e => O_(e) || j_(n, e));
            this._applyQuote(e, t);
          } else this._removeQuote(e, o.filter(O_));
        });
      }
      _getValue() {
        const e = Go(this.editor.model.document.selection.getSelectedBlocks());
        return !(!e || !O_(e));
      }
      _checkEnabled() {
        if (this.value) return !0;
        const e = this.editor.model.document.selection,
          t = this.editor.model.schema,
          n = Go(e.getSelectedBlocks());
        return !!n && j_(t, n);
      }
      _removeQuote(e, t) {
        F_(e, t).reverse().forEach(t => {
          if (t.start.isAtStart && t.end.isAtEnd) return void e.unwrap(t.start.parent);
          if (t.start.isAtStart) {
            const n = e.createPositionBefore(t.start.parent);
            return void e.move(t, n);
          }
          t.end.isAtEnd || e.split(t.end);
          const n = e.createPositionAfter(t.end.parent);
          e.move(t, n);
        });
      }
      _applyQuote(e, t) {
        const n = [];
        F_(e, t).reverse().forEach(t => {
          let i = O_(t.start);
          i || (i = e.createElement("blockQuote"), e.wrap(t, i)), n.push(i);
        }), n.reverse().reduce((t, n) => t.nextSibling == n ? (e.merge(e.createPositionAfter(t)), t) : n);
      }
    }
    function O_(e) {
      return "blockQuote" == e.parent.name ? e.parent : null;
    }
    function F_(e, t) {
      let n,
        i = 0;
      const o = [];
      for (; i < t.length;) {
        const r = t[i],
          s = t[i + 1];
        n || (n = e.createPositionBefore(r)), s && r.nextSibling == s || (o.push(e.createRange(n, e.createPositionAfter(r))), n = null), i++;
      }
      return o;
    }
    function j_(e, t) {
      const n = e.checkChild(t.parent, "blockQuote"),
        i = e.checkChild(["$root", "blockQuote"], t);
      return n && i;
    }
    class H_ extends Br {
      static get pluginName() {
        return "BlockQuoteEditing";
      }
      static get requires() {
        return [P_, zb];
      }
      init() {
        const e = this.editor,
          t = e.model.schema;
        e.commands.add("blockQuote", new V_(e)), t.register("blockQuote", {
          inheritAllFrom: "$container"
        }), e.conversion.elementToElement({
          model: "blockQuote",
          view: "blockquote"
        }), e.model.document.registerPostFixer(n => {
          const i = e.model.document.differ.getChanges();
          for (const e of i) if ("insert" == e.type) {
            const i = e.position.nodeAfter;
            if (!i) continue;
            if (i.is("element", "blockQuote") && i.isEmpty) return n.remove(i), !0;
            if (i.is("element", "blockQuote") && !t.checkChild(e.position, i)) return n.unwrap(i), !0;
            if (i.is("element")) {
              const e = n.createRangeIn(i);
              for (const i of e.getItems()) if (i.is("element", "blockQuote") && !t.checkChild(n.createPositionBefore(i), i)) return n.unwrap(i), !0;
            }
          } else if ("remove" == e.type) {
            const t = e.position.parent;
            if (t.is("element", "blockQuote") && t.isEmpty) return n.remove(t), !0;
          }
          return !1;
        });
        const n = this.editor.editing.view.document,
          i = e.model.document.selection,
          o = e.commands.get("blockQuote");
        this.listenTo(n, "enter", (t, n) => {
          if (!i.isCollapsed || !o.value) return;
          i.getLastPosition().parent.isEmpty && (e.execute("blockQuote"), e.editing.view.scrollToTheSelection(), n.preventDefault(), t.stop());
        }, {
          context: "blockquote"
        }), this.listenTo(n, "delete", (t, n) => {
          if ("backward" != n.direction || !i.isCollapsed || !o.value) return;
          const r = i.getLastPosition().parent;
          r.isEmpty && !r.previousSibling && (e.execute("blockQuote"), e.editing.view.scrollToTheSelection(), n.preventDefault(), t.stop());
        }, {
          context: "blockquote"
        });
      }
    }
    var U_ = o(1487),
      q_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(U_.A, q_);
    U_.A.locals;
    class G_ extends Br {
      static get pluginName() {
        return "BlockQuoteUI";
      }
      init() {
        const e = this.editor,
          t = e.commands.get("blockQuote");
        e.ui.componentFactory.add("blockQuote", () => {
          const e = this._createButton(um);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(t, "value"), e;
        }), e.ui.componentFactory.add("menuBar:blockQuote", () => this._createButton(qk));
      }
      _createButton(e) {
        const t = this.editor,
          n = t.locale,
          i = t.commands.get("blockQuote"),
          o = new e(t.locale),
          r = n.t;
        return o.set({
          label: r("Block quote"),
          icon: Wh.quote,
          isToggleable: !0
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          t.execute("blockQuote"), t.editing.view.focus();
        }), o;
      }
    }
    class K_ extends tl {
      constructor(e) {
        super(e), this.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"];
        const t = this.document;
        function n(e) {
          return (n, i) => {
            i.preventDefault();
            const o = i.dropRange ? [i.dropRange] : null,
              r = new m(t, e);
            t.fire(r, {
              dataTransfer: i.dataTransfer,
              method: n.name,
              targetRanges: o,
              target: i.target,
              domEvent: i.domEvent
            }), r.stop.called && i.stopPropagation();
          };
        }
        this.listenTo(t, "paste", n("clipboardInput"), {
          priority: "low"
        }), this.listenTo(t, "drop", n("clipboardInput"), {
          priority: "low"
        }), this.listenTo(t, "dragover", n("dragging"), {
          priority: "low"
        });
      }
      onDomEvent(e) {
        const t = "clipboardData" in e ? e.clipboardData : e.dataTransfer,
          n = "drop" == e.type || "paste" == e.type,
          i = {
            dataTransfer: new Ul(t, {
              cacheFiles: n
            })
          };
        "drop" != e.type && "dragover" != e.type || (i.dropRange = function (e, t) {
          const n = t.target.ownerDocument,
            i = t.clientX,
            o = t.clientY;
          let r;
          n.caretRangeFromPoint && n.caretRangeFromPoint(i, o) ? r = n.caretRangeFromPoint(i, o) : t.rangeParent && (r = n.createRange(), r.setStart(t.rangeParent, t.rangeOffset), r.collapse(!0));
          if (r) return e.domConverter.domRangeToView(r);
          return null;
        }(this.view, e)), this.fire(e.type, e, i);
      }
    }
    const W_ = ["figcaption", "li"],
      Y_ = ["ol", "ul"];
    function $_(e) {
      if (e.is("$text") || e.is("$textProxy")) return e.data;
      if (e.is("element", "img") && e.hasAttribute("alt")) return e.getAttribute("alt");
      if (e.is("element", "br")) return "\n";
      let t = "",
        n = null;
      for (const i of e.getChildren()) t += Z_(i, n) + $_(i), n = i;
      return t;
    }
    function Z_(e, t) {
      return t ? e.is("element", "li") && !e.isEmpty && e.getChild(0).is("containerElement") || Y_.includes(e.name) && Y_.includes(t.name) ? "\n\n" : e.is("containerElement") || t.is("containerElement") ? W_.includes(e.name) || W_.includes(t.name) ? "\n" : "\n\n" : "" : "";
    }
    const Q_ = function (e, t) {
      return e && Ao(e, t, an);
    };
    const J_ = function (e, t, n, i) {
      var o = n.length,
        r = o,
        s = !i;
      if (null == e) return !r;
      for (e = Object(e); o--;) {
        var a = n[o];
        if (s && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
      }
      for (; ++o < r;) {
        var l = (a = n[o])[0],
          c = e[l],
          d = a[1];
        if (s && a[2]) {
          if (void 0 === c && !(l in e)) return !1;
        } else {
          var u = new vt();
          if (i) var h = i(c, d, l, e, t, u);
          if (!(void 0 === h ? Ll(d, c, 3, i, u) : h)) return !1;
        }
      }
      return !0;
    };
    const X_ = function (e) {
      return e == e && !R(e);
    };
    const ew = function (e) {
      for (var t = an(e), n = t.length; n--;) {
        var i = t[n],
          o = e[i];
        t[n] = [i, o, X_(o)];
      }
      return t;
    };
    const tw = function (e, t) {
      return function (n) {
        return null != n && n[e] === t && (void 0 !== t || e in Object(n));
      };
    };
    const nw = function (e) {
      var t = ew(e);
      return 1 == t.length && t[0][2] ? tw(t[0][0], t[0][1]) : function (n) {
        return n === e || J_(n, e, t);
      };
    };
    const iw = function (e, t) {
      return null != e && t in Object(e);
    };
    const ow = function (e, t, n) {
      for (var i = -1, o = (t = ws(t, e)).length, r = !1; ++i < o;) {
        var s = vs(t[i]);
        if (!(r = null != e && n(e, s))) break;
        e = e[s];
      }
      return r || ++i != o ? r : !!(o = null == e ? 0 : e.length) && Ht(o) && jt(s, o) && (me(e) || zt(e));
    };
    const rw = function (e, t) {
      return null != e && ow(e, t, iw);
    };
    const sw = function (e, t) {
      return as(e) && X_(t) ? tw(vs(e), t) : function (n) {
        var i = Ds(n, e);
        return void 0 === i && i === t ? rw(n, e) : Ll(t, i, 3);
      };
    };
    const aw = function (e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    };
    const lw = function (e) {
      return function (t) {
        return Cs(t, e);
      };
    };
    const cw = function (e) {
      return as(e) ? aw(vs(e)) : lw(e);
    };
    const dw = function (e) {
      return "function" == typeof e ? e : null == e ? So : "object" == typeof e ? me(e) ? sw(e[0], e[1]) : nw(e) : cw(e);
    };
    const uw = function (e, t) {
      var n = {};
      return t = dw(t, 3), Q_(e, function (e, i, o) {
        xt(n, i, t(e, i, o));
      }), n;
    };
    class hw extends Br {
      constructor() {
        super(...arguments), this._markersToCopy = new Map();
      }
      static get pluginName() {
        return "ClipboardMarkersUtils";
      }
      _registerMarkerToCopy(e, t) {
        this._markersToCopy.set(e, t);
      }
      _copySelectedFragmentWithMarkers(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e => e.model.getSelectedContent(e.model.document.selection);
        return this.editor.model.change(i => {
          const o = i.model.document.selection;
          i.setSelection(t);
          const r = this._insertFakeMarkersIntoSelection(i, i.model.document.selection, e),
            s = n(i),
            a = this._removeFakeMarkersInsideElement(i, s);
          for (const [e, t] of Object.entries(r)) {
            a[e] || (a[e] = i.createRangeIn(s));
            for (const e of t) i.remove(e);
          }
          s.markers.clear();
          for (const [e, t] of Object.entries(a)) s.markers.set(e, t);
          return i.setSelection(o), s;
        });
      }
      _pasteMarkersIntoTransformedElement(e, t) {
        const n = this._getPasteMarkersFromRangeMap(e);
        return this.editor.model.change(e => {
          const i = this._insertFakeMarkersElements(e, n),
            o = t(e),
            r = this._removeFakeMarkersInsideElement(e, o);
          for (const t of Object.values(i).flat()) e.remove(t);
          for (const [t, n] of Object.entries(r)) e.model.markers.has(t) || e.addMarker(t, {
            usingOperation: !0,
            affectsData: !0,
            range: n
          });
          return o;
        });
      }
      _pasteFragmentWithMarkers(e) {
        const t = this._getPasteMarkersFromRangeMap(e.markers);
        e.markers.clear();
        for (const n of t) e.markers.set(n.name, n.range);
        return this.editor.model.insertContent(e);
      }
      _forceMarkersCopy(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          allowedActions: "all",
          copyPartiallySelected: !0,
          duplicateOnPaste: !0
        };
        const i = this._markersToCopy.get(e);
        this._markersToCopy.set(e, n), t(), i ? this._markersToCopy.set(e, i) : this._markersToCopy.delete(e);
      }
      _isMarkerCopyable(e, t) {
        const n = this._getMarkerClipboardConfig(e);
        if (!n) return !1;
        if (!t) return !0;
        const {
          allowedActions: i
        } = n;
        return "all" === i || i.includes(t);
      }
      _hasMarkerConfiguration(e) {
        return !!this._getMarkerClipboardConfig(e);
      }
      _getMarkerClipboardConfig(e) {
        const [t] = e.split(":");
        return this._markersToCopy.get(t) || null;
      }
      _insertFakeMarkersIntoSelection(e, t, n) {
        const i = this._getCopyableMarkersFromSelection(e, t, n);
        return this._insertFakeMarkersElements(e, i);
      }
      _getCopyableMarkersFromSelection(e, t, n) {
        const i = Array.from(t.getRanges()),
          o = new Set(i.flatMap(t => Array.from(e.model.markers.getMarkersIntersectingRange(t))));
        return Array.from(o).filter(e => {
          if (!this._isMarkerCopyable(e.name, n)) return !1;
          const {
            copyPartiallySelected: t
          } = this._getMarkerClipboardConfig(e.name);
          if (!t) {
            const t = e.getRange();
            return i.some(e => e.containsRange(t, !0));
          }
          return !0;
        }).map(e => ({
          name: "dragstart" === n ? this._getUniqueMarkerName(e.name) : e.name,
          range: e.getRange()
        }));
      }
      _getPasteMarkersFromRangeMap(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        const {
          model: n
        } = this.editor;
        return (e instanceof Map ? Array.from(e.entries()) : Object.entries(e)).flatMap(_ref79 => {
          let [e, i] = _ref79;
          if (!this._hasMarkerConfiguration(e)) return [{
            name: e,
            range: i
          }];
          if (this._isMarkerCopyable(e, t)) {
            const t = this._getMarkerClipboardConfig(e),
              o = n.markers.has(e) && "$graveyard" === n.markers.get(e).getRange().root.rootName;
            return (t.duplicateOnPaste || o) && (e = this._getUniqueMarkerName(e)), [{
              name: e,
              range: i
            }];
          }
          return [];
        });
      }
      _insertFakeMarkersElements(e, t) {
        const n = {},
          i = t.flatMap(e => {
            const {
              start: t,
              end: n
            } = e.range;
            return [{
              position: t,
              marker: e,
              type: "start"
            }, {
              position: n,
              marker: e,
              type: "end"
            }];
          }).sort((_ref80, _ref81) => {
            let {
              position: e
            } = _ref80;
            let {
              position: t
            } = _ref81;
            return e.isBefore(t) ? 1 : -1;
          });
        for (const {
          position: t,
          marker: o,
          type: r
        } of i) {
          const i = e.createElement("$marker", {
            "data-name": o.name,
            "data-type": r
          });
          n[o.name] || (n[o.name] = []), n[o.name].push(i), e.insert(i, t);
        }
        return n;
      }
      _removeFakeMarkersInsideElement(e, t) {
        const n = this._getAllFakeMarkersFromElement(e, t).reduce((t, n) => {
          const i = n.markerElement && e.createPositionBefore(n.markerElement);
          let o = t[n.name],
            r = !1;
          if (o && o.start && o.end) {
            this._getMarkerClipboardConfig(n.name).duplicateOnPaste ? t[this._getUniqueMarkerName(n.name)] = t[n.name] : r = !0, o = null;
          }
          return r || (t[n.name] = {
            ...o,
            [n.type]: i
          }), n.markerElement && e.remove(n.markerElement), t;
        }, {});
        return uw(n, n => new dc(n.start || e.createPositionFromPath(t, [0]), n.end || e.createPositionAt(t, "end")));
      }
      _getAllFakeMarkersFromElement(e, t) {
        const n = Array.from(e.createRangeIn(t)).flatMap(_ref82 => {
            let {
              item: e
            } = _ref82;
            if (!e.is("element", "$marker")) return [];
            const t = e.getAttribute("data-name"),
              n = e.getAttribute("data-type");
            return [{
              markerElement: e,
              name: t,
              type: n
            }];
          }),
          i = [],
          o = [];
        for (const e of n) {
          if ("end" === e.type) {
            n.some(t => t.name === e.name && "start" === t.type) || i.push({
              markerElement: null,
              name: e.name,
              type: "start"
            });
          }
          if ("start" === e.type) {
            n.some(t => t.name === e.name && "end" === t.type) || o.unshift({
              markerElement: null,
              name: e.name,
              type: "end"
            });
          }
        }
        return [...i, ...n, ...o];
      }
      _getUniqueMarkerName(e) {
        const t = e.split(":"),
          n = g().substring(1, 6);
        return 3 === t.length ? "".concat(t.slice(0, 2).join(":"), ":").concat(n) : "".concat(t.join(":"), ":").concat(n);
      }
    }
    class mw extends Br {
      static get pluginName() {
        return "ClipboardPipeline";
      }
      static get requires() {
        return [hw];
      }
      init() {
        this.editor.editing.view.addObserver(K_), this._setupPasteDrop(), this._setupCopyCut();
      }
      _fireOutputTransformationEvent(e, t, n) {
        const i = this.editor.plugins.get("ClipboardMarkersUtils");
        this.editor.model.enqueueChange({
          isUndoable: "cut" === n
        }, () => {
          const o = i._copySelectedFragmentWithMarkers(n, t);
          this.fire("outputTransformation", {
            dataTransfer: e,
            content: o,
            method: n
          });
        });
      }
      _setupPasteDrop() {
        const e = this.editor,
          t = e.model,
          n = e.editing.view,
          i = n.document,
          o = this.editor.plugins.get("ClipboardMarkersUtils");
        this.listenTo(i, "clipboardInput", (t, n) => {
          "paste" != n.method || e.model.canEditAt(e.model.document.selection) || t.stop();
        }, {
          priority: "highest"
        }), this.listenTo(i, "clipboardInput", (e, t) => {
          const i = t.dataTransfer;
          let o;
          if (t.content) o = t.content;else {
            let e = "";
            i.getData("text/html") ? e = function (e) {
              return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (e, t) => 1 == t.length ? " " : t).replace(/<!--[\s\S]*?-->/g, "");
            }(i.getData("text/html")) : i.getData("text/plain") && (((r = (r = i.getData("text/plain")).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || r.includes("<br>")) && (r = "<p>".concat(r, "</p>")), e = r), o = this.editor.data.htmlProcessor.toView(e);
          }
          var r;
          const s = new m(this, "inputTransformation");
          this.fire(s, {
            content: o,
            dataTransfer: i,
            targetRanges: t.targetRanges,
            method: t.method
          }), s.stop.called && e.stop(), n.scrollToTheSelection();
        }, {
          priority: "low"
        }), this.listenTo(this, "inputTransformation", (e, n) => {
          if (n.content.isEmpty) return;
          const i = this.editor.data.toModel(n.content, "$clipboardHolder");
          0 != i.childCount && (e.stop(), t.change(() => {
            this.fire("contentInsertion", {
              content: i,
              method: n.method,
              dataTransfer: n.dataTransfer,
              targetRanges: n.targetRanges
            });
          }));
        }, {
          priority: "low"
        }), this.listenTo(this, "contentInsertion", (e, t) => {
          t.resultRange = o._pasteFragmentWithMarkers(t.content);
        }, {
          priority: "low"
        });
      }
      _setupCopyCut() {
        const e = this.editor,
          t = e.model.document,
          n = e.editing.view.document,
          i = (e, n) => {
            const i = n.dataTransfer;
            n.preventDefault(), this._fireOutputTransformationEvent(i, t.selection, e.name);
          };
        this.listenTo(n, "copy", i, {
          priority: "low"
        }), this.listenTo(n, "cut", (t, n) => {
          e.model.canEditAt(e.model.document.selection) ? i(t, n) : n.preventDefault();
        }, {
          priority: "low"
        }), this.listenTo(this, "outputTransformation", (t, i) => {
          const o = e.data.toView(i.content);
          n.fire("clipboardOutput", {
            dataTransfer: i.dataTransfer,
            content: o,
            method: i.method
          });
        }, {
          priority: "low"
        }), this.listenTo(n, "clipboardOutput", (n, i) => {
          i.content.isEmpty || (i.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(i.content)), i.dataTransfer.setData("text/plain", $_(i.content))), "cut" == i.method && e.model.deleteContent(t.selection);
        }, {
          priority: "low"
        });
      }
    }
    class pw extends T() {
      constructor() {
        super(...arguments), this._stack = [];
      }
      add(e, t) {
        const n = this._stack,
          i = n[0];
        this._insertDescriptor(e);
        const o = n[0];
        i === o || gw(i, o) || this.fire("change:top", {
          oldDescriptor: i,
          newDescriptor: o,
          writer: t
        });
      }
      remove(e, t) {
        const n = this._stack,
          i = n[0];
        this._removeDescriptor(e);
        const o = n[0];
        i === o || gw(i, o) || this.fire("change:top", {
          oldDescriptor: i,
          newDescriptor: o,
          writer: t
        });
      }
      _insertDescriptor(e) {
        const t = this._stack,
          n = t.findIndex(t => t.id === e.id);
        if (gw(e, t[n])) return;
        n > -1 && t.splice(n, 1);
        let i = 0;
        for (; t[i] && fw(t[i], e);) i++;
        t.splice(i, 0, e);
      }
      _removeDescriptor(e) {
        const t = this._stack,
          n = t.findIndex(t => t.id === e);
        n > -1 && t.splice(n, 1);
      }
    }
    function gw(e, t) {
      return e && t && e.priority == t.priority && kw(e.classes) == kw(t.classes);
    }
    function fw(e, t) {
      return e.priority > t.priority || !(e.priority < t.priority) && kw(e.classes) > kw(t.classes);
    }
    function kw(e) {
      return Array.isArray(e) ? e.sort().join(",") : e;
    }
    const bw = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>',
      _w = "ck-widget",
      ww = "ck-widget_selected";
    function Aw(e) {
      return !!e.is("element") && !!e.getCustomProperty("widget");
    }
    function vw(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!e.is("containerElement")) throw new _("widget-to-widget-wrong-element-type", null, {
        element: e
      });
      return t.setAttribute("contenteditable", "false", e), t.addClass(_w, e), t.setCustomProperty("widget", !0, e), e.getFillerOffset = Dw, t.setCustomProperty("widgetLabel", [], e), n.label && function (e, t) {
        const n = e.getCustomProperty("widgetLabel");
        n.push(t);
      }(e, n.label), n.hasSelectionHandle && function (e, t) {
        const n = t.createUIElement("div", {
          class: "ck ck-widget__selection-handle"
        }, function (e) {
          const t = this.toDomElement(e),
            n = new am();
          return n.set("content", bw), n.render(), t.appendChild(n.element), t;
        });
        t.insert(t.createPositionAt(e, 0), n), t.addClass(["ck-widget_with-selection-handle"], e);
      }(e, t), xw(e, t), e;
    }
    function Cw(e, t, n) {
      if (t.classes && n.addClass(_o(t.classes), e), t.attributes) for (const i in t.attributes) n.setAttribute(i, t.attributes[i], e);
    }
    function yw(e, t, n) {
      if (t.classes && n.removeClass(_o(t.classes), e), t.attributes) for (const i in t.attributes) n.removeAttribute(i, e);
    }
    function xw(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Cw;
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : yw;
      const o = new pw();
      o.on("change:top", (t, o) => {
        o.oldDescriptor && i(e, o.oldDescriptor, o.writer), o.newDescriptor && n(e, o.newDescriptor, o.writer);
      });
      t.setCustomProperty("addHighlight", (e, t, n) => o.add(t, n), e), t.setCustomProperty("removeHighlight", (e, t, n) => o.remove(t, n), e);
    }
    function Ew(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return t.addClass(["ck-editor__editable", "ck-editor__nested-editable"], e), t.setAttribute("role", "textbox", e), t.setAttribute("tabindex", "-1", e), n.label && t.setAttribute("aria-label", n.label, e), t.setAttribute("contenteditable", e.isReadOnly ? "false" : "true", e), e.on("change:isReadOnly", (n, i, o) => {
        t.setAttribute("contenteditable", o ? "false" : "true", e);
      }), e.on("change:isFocused", (n, i, o) => {
        o ? t.addClass("ck-editor__nested-editable_focused", e) : t.removeClass("ck-editor__nested-editable_focused", e);
      }), xw(e, t), e;
    }
    function Sw(e, t) {
      const n = e.getSelectedElement();
      if (n) {
        const i = Bw(e);
        if (i) return t.createRange(t.createPositionAt(n, i));
      }
      return t.schema.findOptimalInsertionRange(e);
    }
    function Dw() {
      return null;
    }
    const Tw = "widget-type-around";
    function Iw(e, t, n) {
      return !!e && Aw(e) && !n.isInline(t);
    }
    function Bw(e) {
      return e.getAttribute(Tw);
    }
    var Mw = o(6021),
      Pw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Mw.A, Pw);
    Mw.A.locals;
    const zw = ["before", "after"],
      Nw = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild,
      Lw = "ck-widget__type-around_disabled";
    class Rw extends Br {
      constructor() {
        super(...arguments), this._currentFakeCaretModelElement = null;
      }
      static get pluginName() {
        return "WidgetTypeAround";
      }
      static get requires() {
        return [P_, zb];
      }
      init() {
        const e = this.editor,
          t = e.editing.view;
        this.on("change:isEnabled", (n, i, o) => {
          t.change(e => {
            for (const n of t.document.roots) o ? e.removeClass(Lw, n) : e.addClass(Lw, n);
          }), o || e.model.change(e => {
            e.removeSelectionAttribute(Tw);
          });
        }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
      }
      destroy() {
        super.destroy(), this._currentFakeCaretModelElement = null;
      }
      _insertParagraph(e, t) {
        const n = this.editor,
          i = n.editing.view,
          o = n.model.schema.getAttributesWithProperty(e, "copyOnReplace", !0);
        n.execute("insertParagraph", {
          position: n.model.createPositionAt(e, t),
          attributes: o
        }), i.focus(), i.scrollToTheSelection();
      }
      _listenToIfEnabled(e, t, n, i) {
        var _this9 = this;
        this.listenTo(e, t, function () {
          _this9.isEnabled && n(...arguments);
        }, i);
      }
      _insertParagraphAccordingToFakeCaretPosition() {
        const e = this.editor.model.document.selection,
          t = Bw(e);
        if (!t) return !1;
        const n = e.getSelectedElement();
        return this._insertParagraph(n, t), !0;
      }
      _enableTypeAroundUIInjection() {
        const e = this.editor,
          t = e.model.schema,
          n = e.locale.t,
          i = {
            before: n("Insert paragraph before block"),
            after: n("Insert paragraph after block")
          };
        e.editing.downcastDispatcher.on("insert", (e, o, r) => {
          const s = r.mapper.toViewElement(o.item);
          if (s && Iw(s, o.item, t)) {
            !function (e, t, n) {
              const i = e.createUIElement("div", {
                class: "ck ck-reset_all ck-widget__type-around"
              }, function (e) {
                const n = this.toDomElement(e);
                return function (e, t) {
                  for (const n of zw) {
                    const i = new tr({
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_".concat(n)],
                        title: t[n],
                        "aria-hidden": "true"
                      },
                      children: [e.ownerDocument.importNode(Nw, !0)]
                    });
                    e.appendChild(i.render());
                  }
                }(n, t), function (e) {
                  const t = new tr({
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-widget__type-around__fake-caret"]
                    }
                  });
                  e.appendChild(t.render());
                }(n), n;
              });
              e.insert(e.createPositionAt(n, "end"), i);
            }(r.writer, i, s);
            s.getCustomProperty("widgetLabel").push(() => this.isEnabled ? n("Press Enter to type after or press Shift + Enter to type before the widget") : "");
          }
        }, {
          priority: "low"
        });
      }
      _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
        const e = this.editor,
          t = e.model,
          n = t.document.selection,
          i = t.schema,
          o = e.editing.view;
        function r(e) {
          return "ck-widget_type-around_show-fake-caret_".concat(e);
        }
        this._listenToIfEnabled(o.document, "arrowKey", (e, t) => {
          this._handleArrowKeyPress(e, t);
        }, {
          context: [Aw, "$text"],
          priority: "high"
        }), this._listenToIfEnabled(n, "change:range", (t, n) => {
          n.directChange && e.model.change(e => {
            e.removeSelectionAttribute(Tw);
          });
        }), this._listenToIfEnabled(t.document, "change:data", () => {
          const t = n.getSelectedElement();
          if (t) {
            if (Iw(e.editing.mapper.toViewElement(t), t, i)) return;
          }
          e.model.change(e => {
            e.removeSelectionAttribute(Tw);
          });
        }), this._listenToIfEnabled(e.editing.downcastDispatcher, "selection", (e, t, n) => {
          const o = n.writer;
          if (this._currentFakeCaretModelElement) {
            const e = n.mapper.toViewElement(this._currentFakeCaretModelElement);
            e && (o.removeClass(zw.map(r), e), this._currentFakeCaretModelElement = null);
          }
          const s = t.selection.getSelectedElement();
          if (!s) return;
          const a = n.mapper.toViewElement(s);
          if (!Iw(a, s, i)) return;
          const l = Bw(t.selection);
          l && (o.addClass(r(l), a), this._currentFakeCaretModelElement = s);
        }), this._listenToIfEnabled(e.ui.focusTracker, "change:isFocused", (t, n, i) => {
          i || e.model.change(e => {
            e.removeSelectionAttribute(Tw);
          });
        });
      }
      _handleArrowKeyPress(e, t) {
        const n = this.editor,
          i = n.model,
          o = i.document.selection,
          r = i.schema,
          s = n.editing.view,
          a = function (e, t) {
            const n = bo(e, t);
            return "down" === n || "right" === n;
          }(t.keyCode, n.locale.contentLanguageDirection),
          l = s.document.selection.getSelectedElement();
        let c;
        Iw(l, n.editing.mapper.toModelElement(l), r) ? c = this._handleArrowKeyPressOnSelectedWidget(a) : o.isCollapsed ? c = this._handleArrowKeyPressWhenSelectionNextToAWidget(a) : t.shiftKey || (c = this._handleArrowKeyPressWhenNonCollapsedSelection(a)), c && (t.preventDefault(), e.stop());
      }
      _handleArrowKeyPressOnSelectedWidget(e) {
        const t = this.editor.model,
          n = Bw(t.document.selection);
        return t.change(t => {
          if (!n) return t.setSelectionAttribute(Tw, e ? "after" : "before"), !0;
          if (!(n === (e ? "after" : "before"))) return t.removeSelectionAttribute(Tw), !0;
          return !1;
        });
      }
      _handleArrowKeyPressWhenSelectionNextToAWidget(e) {
        const t = this.editor,
          n = t.model,
          i = n.schema,
          o = t.plugins.get("Widget"),
          r = o._getObjectElementNextToSelection(e);
        return !!Iw(t.editing.mapper.toViewElement(r), r, i) && (n.change(t => {
          o._setSelectionOverElement(r), t.setSelectionAttribute(Tw, e ? "before" : "after");
        }), !0);
      }
      _handleArrowKeyPressWhenNonCollapsedSelection(e) {
        const t = this.editor,
          n = t.model,
          i = n.schema,
          o = t.editing.mapper,
          r = n.document.selection,
          s = e ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter;
        return !!Iw(o.toViewElement(s), s, i) && (n.change(t => {
          t.setSelection(s, "on"), t.setSelectionAttribute(Tw, e ? "after" : "before");
        }), !0);
      }
      _enableInsertingParagraphsOnButtonClick() {
        const e = this.editor,
          t = e.editing.view;
        this._listenToIfEnabled(t.document, "mousedown", (n, i) => {
          const o = i.domTarget.closest(".ck-widget__type-around__button");
          if (!o) return;
          const r = function (e) {
              return e.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
            }(o),
            s = function (e, t) {
              const n = e.closest(".ck-widget");
              return t.mapDomToView(n);
            }(o, t.domConverter),
            a = e.editing.mapper.toModelElement(s);
          this._insertParagraph(a, r), i.preventDefault(), n.stop();
        });
      }
      _enableInsertingParagraphsOnEnterKeypress() {
        const e = this.editor,
          t = e.model.document.selection,
          n = e.editing.view;
        this._listenToIfEnabled(n.document, "enter", (n, i) => {
          if ("atTarget" != n.eventPhase) return;
          const o = t.getSelectedElement(),
            r = e.editing.mapper.toViewElement(o),
            s = e.model.schema;
          let a;
          this._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : Iw(r, o, s) && (this._insertParagraph(o, i.isSoft ? "before" : "after"), a = !0), a && (i.preventDefault(), n.stop());
        }, {
          context: Aw
        });
      }
      _enableInsertingParagraphsOnTypingKeystroke() {
        const e = this.editor.editing.view.document;
        this._listenToIfEnabled(e, "insertText", (t, n) => {
          this._insertParagraphAccordingToFakeCaretPosition() && (n.selection = e.selection);
        }, {
          priority: "high"
        }), s.isAndroid ? this._listenToIfEnabled(e, "keydown", (e, t) => {
          229 == t.keyCode && this._insertParagraphAccordingToFakeCaretPosition();
        }) : this._listenToIfEnabled(e, "compositionstart", () => {
          this._insertParagraphAccordingToFakeCaretPosition();
        }, {
          priority: "high"
        });
      }
      _enableDeleteIntegration() {
        const e = this.editor,
          t = e.editing.view,
          n = e.model,
          i = n.schema;
        this._listenToIfEnabled(t.document, "delete", (t, o) => {
          if ("atTarget" != t.eventPhase) return;
          const r = Bw(n.document.selection);
          if (!r) return;
          const s = o.direction,
            a = n.document.selection.getSelectedElement(),
            l = "forward" == s;
          if ("before" === r === l) e.execute("delete", {
            selection: n.createSelection(a, "on")
          });else {
            const t = i.getNearestSelectionRange(n.createPositionAt(a, r), s);
            if (t) if (t.isCollapsed) {
              const o = n.createSelection(t.start);
              if (n.modifySelection(o, {
                direction: s
              }), o.focus.isEqual(t.start)) {
                const e = function (e, t) {
                  let n = t;
                  for (const i of t.getAncestors({
                    parentFirst: !0
                  })) {
                    if (i.childCount > 1 || e.isLimit(i)) break;
                    n = i;
                  }
                  return n;
                }(i, t.start.parent);
                n.deleteContent(n.createSelection(e, "on"), {
                  doNotAutoparagraph: !0
                });
              } else n.change(n => {
                n.setSelection(t), e.execute(l ? "deleteForward" : "delete");
              });
            } else n.change(n => {
              n.setSelection(t), e.execute(l ? "deleteForward" : "delete");
            });
          }
          o.preventDefault(), t.stop();
        }, {
          context: Aw
        });
      }
      _enableInsertContentIntegration() {
        const e = this.editor,
          t = this.editor.model,
          n = t.document.selection;
        this._listenToIfEnabled(e.model, "insertContent", (e, _ref83) => {
          let [i, o] = _ref83;
          if (o && !o.is("documentSelection")) return;
          const r = Bw(n);
          return r ? (e.stop(), t.change(e => {
            const o = n.getSelectedElement(),
              s = t.createPositionAt(o, r),
              a = e.createSelection(s),
              l = t.insertContent(i, a);
            return e.setSelection(a), l;
          })) : void 0;
        }, {
          priority: "high"
        });
      }
      _enableInsertObjectIntegration() {
        const e = this.editor,
          t = this.editor.model.document.selection;
        this._listenToIfEnabled(e.model, "insertObject", (e, n) => {
          const [, i, o = {}] = n;
          if (i && !i.is("documentSelection")) return;
          const r = Bw(t);
          r && (o.findOptimalPosition = r, n[3] = o);
        }, {
          priority: "high"
        });
      }
      _enableDeleteContentIntegration() {
        const e = this.editor,
          t = this.editor.model.document.selection;
        this._listenToIfEnabled(e.model, "deleteContent", (e, _ref84) => {
          let [n] = _ref84;
          if (n && !n.is("documentSelection")) return;
          Bw(t) && e.stop();
        }, {
          priority: "high"
        });
      }
    }
    function Vw(e) {
      const t = e.model;
      return (n, i) => {
        const o = i.keyCode == mo.arrowup,
          r = i.keyCode == mo.arrowdown,
          s = i.shiftKey,
          a = t.document.selection;
        if (!o && !r) return;
        const l = r;
        if (s && function (e, t) {
          return !e.isCollapsed && e.isBackward == t;
        }(a, l)) return;
        const c = function (e, t, n) {
          const i = e.model;
          if (n) {
            const e = t.isCollapsed ? t.focus : t.getLastPosition(),
              n = Ow(i, e, "forward");
            if (!n) return null;
            const o = i.createRange(e, n),
              r = Fw(i.schema, o, "backward");
            return r ? i.createRange(e, r) : null;
          }
          {
            const e = t.isCollapsed ? t.focus : t.getFirstPosition(),
              n = Ow(i, e, "backward");
            if (!n) return null;
            const o = i.createRange(n, e),
              r = Fw(i.schema, o, "forward");
            return r ? i.createRange(r, e) : null;
          }
        }(e, a, l);
        if (c) {
          if (c.isCollapsed) {
            if (a.isCollapsed) return;
            if (s) return;
          }
          (c.isCollapsed || function (e, t, n) {
            const i = e.model,
              o = e.view.domConverter;
            if (n) {
              const e = i.createSelection(t.start);
              i.modifySelection(e), e.focus.isAtEnd || t.start.isEqual(e.focus) || (t = i.createRange(e.focus, t.end));
            }
            const r = e.mapper.toViewRange(t),
              s = o.viewRangeToDom(r),
              a = Li.getDomRangeRects(s);
            let l;
            for (const e of a) if (void 0 !== l) {
              if (Math.round(e.top) >= l) return !1;
              l = Math.max(l, Math.round(e.bottom));
            } else l = Math.round(e.bottom);
            return !0;
          }(e, c, l)) && (t.change(e => {
            const n = l ? c.end : c.start;
            if (s) {
              const i = t.createSelection(a.anchor);
              i.setFocus(n), e.setSelection(i);
            } else e.setSelection(n);
          }), n.stop(), i.preventDefault(), i.stopPropagation());
        }
      };
    }
    function Ow(e, t, n) {
      const i = e.schema,
        o = e.createRangeIn(t.root),
        r = "forward" == n ? "elementStart" : "elementEnd";
      for (const {
        previousPosition: e,
        item: s,
        type: a
      } of o.getWalker({
        startPosition: t,
        direction: n
      })) {
        if (i.isLimit(s) && !i.isInline(s)) return e;
        if (a == r && i.isBlock(s)) return null;
      }
      return null;
    }
    function Fw(e, t, n) {
      const i = "backward" == n ? t.end : t.start;
      if (e.checkChild(i, "$text")) return i;
      for (const {
        nextPosition: i
      } of t.getWalker({
        direction: n
      })) if (e.checkChild(i, "$text")) return i;
      return null;
    }
    var jw = o(9974),
      Hw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(jw.A, Hw);
    jw.A.locals;
    class Uw extends Br {
      constructor() {
        super(...arguments), this._previouslySelected = new Set();
      }
      static get pluginName() {
        return "Widget";
      }
      static get requires() {
        return [Rw, zb];
      }
      init() {
        var _this10 = this;
        const e = this.editor,
          t = e.editing.view,
          n = t.document,
          i = e.t;
        this.editor.editing.downcastDispatcher.on("selection", (t, n, i) => {
          const o = i.writer,
            r = n.selection;
          if (r.isCollapsed) return;
          const s = r.getSelectedElement();
          if (!s) return;
          const a = e.editing.mapper.toViewElement(s);
          var l;
          Aw(a) && i.consumable.consume(r, "selection") && o.setSelection(o.createRangeOn(a), {
            fake: !0,
            label: (l = a, l.getCustomProperty("widgetLabel").reduce((e, t) => "function" == typeof t ? e ? e + ". " + t() : t() : e ? e + ". " + t : t, ""))
          });
        }), this.editor.editing.downcastDispatcher.on("selection", (e, t, n) => {
          this._clearPreviouslySelectedWidgets(n.writer);
          const i = n.writer,
            o = i.document.selection;
          let r = null;
          for (const e of o.getRanges()) for (const t of e) {
            const e = t.item;
            Aw(e) && !qw(e, r) && (i.addClass(ww, e), this._previouslySelected.add(e), r = e);
          }
        }, {
          priority: "low"
        }), t.addObserver(Ju), this.listenTo(n, "mousedown", function () {
          return _this10._onMousedown(...arguments);
        }), this.listenTo(n, "arrowKey", function () {
          _this10._handleSelectionChangeOnArrowKeyPress(...arguments);
        }, {
          context: [Aw, "$text"]
        }), this.listenTo(n, "arrowKey", function () {
          _this10._preventDefaultOnArrowKeyPress(...arguments);
        }, {
          context: "$root"
        }), this.listenTo(n, "arrowKey", Vw(this.editor.editing), {
          context: "$text"
        }), this.listenTo(n, "delete", (e, t) => {
          this._handleDelete("forward" == t.direction) && (t.preventDefault(), e.stop());
        }, {
          context: "$root"
        }), this.listenTo(n, "tab", (e, t) => {
          "atTarget" == e.eventPhase && (t.shiftKey || this._selectFirstNestedEditable() && (t.preventDefault(), e.stop()));
        }, {
          context: Aw,
          priority: "low"
        }), this.listenTo(n, "tab", (e, t) => {
          t.shiftKey && this._selectAncestorWidget() && (t.preventDefault(), e.stop());
        }, {
          priority: "low"
        }), this.listenTo(n, "keydown", (e, t) => {
          t.keystroke == mo.esc && this._selectAncestorWidget() && (t.preventDefault(), e.stop());
        }, {
          priority: "low"
        }), e.accessibility.addKeystrokeInfoGroup({
          id: "widget",
          label: i("Keystrokes that can be used when a widget is selected (for example: image, table, etc.)"),
          keystrokes: [{
            label: i("Insert a new paragraph directly after a widget"),
            keystroke: "Enter"
          }, {
            label: i("Insert a new paragraph directly before a widget"),
            keystroke: "Shift+Enter"
          }, {
            label: i("Move the caret to allow typing directly before a widget"),
            keystroke: [["arrowup"], ["arrowleft"]]
          }, {
            label: i("Move the caret to allow typing directly after a widget"),
            keystroke: [["arrowdown"], ["arrowright"]]
          }]
        });
      }
      _onMousedown(e, t) {
        const n = this.editor,
          i = n.editing.view,
          o = i.document;
        let r = t.target;
        if (t.domEvent.detail >= 3) return void (this._selectBlockContent(r) && t.preventDefault());
        if (function (e) {
          let t = e;
          for (; t;) {
            if (t.is("editableElement") && !t.is("rootElement")) return !0;
            if (Aw(t)) return !1;
            t = t.parent;
          }
          return !1;
        }(r)) return;
        if (!Aw(r) && (r = r.findAncestor(Aw), !r)) return;
        s.isAndroid && t.preventDefault(), o.isFocused || i.focus();
        const a = n.editing.mapper.toModelElement(r);
        this._setSelectionOverElement(a);
      }
      _selectBlockContent(e) {
        const t = this.editor,
          n = t.model,
          i = t.editing.mapper,
          o = n.schema,
          r = i.findMappedViewAncestor(this.editor.editing.view.createPositionAt(e, 0)),
          s = function (e, t) {
            for (const n of e.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            })) {
              if (t.checkChild(n, "$text")) return n;
              if (t.isLimit(n) && !t.isObject(n)) break;
            }
            return null;
          }(i.toModelElement(r), n.schema);
        return !!s && (n.change(e => {
          const t = o.isLimit(s) ? null : function (e, t) {
              const n = new nc({
                startPosition: e
              });
              for (const {
                item: e
              } of n) {
                if (t.isLimit(e) || !e.is("element")) return null;
                if (t.checkChild(e, "$text")) return e;
              }
              return null;
            }(e.createPositionAfter(s), o),
            n = e.createPositionAt(s, 0),
            i = t ? e.createPositionAt(t, 0) : e.createPositionAt(s, "end");
          e.setSelection(e.createRange(n, i));
        }), !0);
      }
      _handleSelectionChangeOnArrowKeyPress(e, t) {
        const n = t.keyCode,
          i = this.editor.model,
          o = i.schema,
          r = i.document.selection,
          s = r.getSelectedElement(),
          a = bo(n, this.editor.locale.contentLanguageDirection),
          l = "down" == a || "right" == a,
          c = "up" == a || "down" == a;
        if (s && o.isObject(s)) {
          const n = l ? r.getLastPosition() : r.getFirstPosition(),
            s = o.getNearestSelectionRange(n, l ? "forward" : "backward");
          return void (s && (i.change(e => {
            e.setSelection(s);
          }), t.preventDefault(), e.stop()));
        }
        if (!r.isCollapsed && !t.shiftKey) {
          const n = r.getFirstPosition(),
            s = r.getLastPosition(),
            a = n.nodeAfter,
            c = s.nodeBefore;
          return void ((a && o.isObject(a) || c && o.isObject(c)) && (i.change(e => {
            e.setSelection(l ? s : n);
          }), t.preventDefault(), e.stop()));
        }
        if (!r.isCollapsed) return;
        const d = this._getObjectElementNextToSelection(l);
        if (d && o.isObject(d)) {
          if (o.isInline(d) && c) return;
          this._setSelectionOverElement(d), t.preventDefault(), e.stop();
        }
      }
      _preventDefaultOnArrowKeyPress(e, t) {
        const n = this.editor.model,
          i = n.schema,
          o = n.document.selection.getSelectedElement();
        o && i.isObject(o) && (t.preventDefault(), e.stop());
      }
      _handleDelete(e) {
        const t = this.editor.model.document.selection;
        if (!this.editor.model.canEditAt(t)) return;
        if (!t.isCollapsed) return;
        const n = this._getObjectElementNextToSelection(e);
        return n ? (this.editor.model.change(e => {
          let i = t.anchor.parent;
          for (; i.isEmpty;) {
            const t = i;
            i = t.parent, e.remove(t);
          }
          this._setSelectionOverElement(n);
        }), !0) : void 0;
      }
      _setSelectionOverElement(e) {
        this.editor.model.change(t => {
          t.setSelection(t.createRangeOn(e));
        });
      }
      _getObjectElementNextToSelection(e) {
        const t = this.editor.model,
          n = t.schema,
          i = t.document.selection,
          o = t.createSelection(i);
        if (t.modifySelection(o, {
          direction: e ? "forward" : "backward"
        }), o.isEqual(i)) return null;
        const r = e ? o.focus.nodeBefore : o.focus.nodeAfter;
        return r && n.isObject(r) ? r : null;
      }
      _clearPreviouslySelectedWidgets(e) {
        for (const t of this._previouslySelected) e.removeClass(ww, t);
        this._previouslySelected.clear();
      }
      _selectFirstNestedEditable() {
        const e = this.editor,
          t = this.editor.editing.view.document;
        for (const n of t.selection.getFirstRange().getItems()) if (n.is("editableElement")) {
          const t = e.editing.mapper.toModelElement(n);
          if (!t) continue;
          const i = e.model.createPositionAt(t, 0),
            o = e.model.schema.getNearestSelectionRange(i, "forward");
          return e.model.change(e => {
            e.setSelection(o);
          }), !0;
        }
        return !1;
      }
      _selectAncestorWidget() {
        const e = this.editor,
          t = e.editing.mapper,
          n = e.editing.view.document.selection.getFirstPosition().parent,
          i = (n.is("$text") ? n.parent : n).findAncestor(Aw);
        if (!i) return !1;
        const o = t.toModelElement(i);
        return !!o && (e.model.change(e => {
          e.setSelection(o, "on");
        }), !0);
      }
    }
    function qw(e, t) {
      return !!t && Array.from(e.getAncestors()).includes(t);
    }
    class Gw extends Br {
      constructor() {
        super(...arguments), this._toolbarDefinitions = new Map();
      }
      static get requires() {
        return [Of];
      }
      static get pluginName() {
        return "WidgetToolbarRepository";
      }
      init() {
        const e = this.editor;
        if (e.plugins.has("BalloonToolbar")) {
          const t = e.plugins.get("BalloonToolbar");
          this.listenTo(t, "show", t => {
            (function (e) {
              const t = e.getSelectedElement();
              return !(!t || !Aw(t));
            })(e.editing.view.document.selection) && t.stop();
          }, {
            priority: "high"
          });
        }
        this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", () => {
          this._updateToolbarsVisibility();
        }), this.listenTo(e.ui, "update", () => {
          this._updateToolbarsVisibility();
        }), this.listenTo(e.ui.focusTracker, "change:isFocused", () => {
          this._updateToolbarsVisibility();
        }, {
          priority: "low"
        });
      }
      destroy() {
        super.destroy();
        for (const e of this._toolbarDefinitions.values()) e.view.destroy();
      }
      register(e, _ref85) {
        let {
          ariaLabel: t,
          items: n,
          getRelatedElement: i,
          balloonClassName: o = "ck-toolbar-container"
        } = _ref85;
        if (!n.length) return void w("widget-toolbar-no-items", {
          toolbarId: e
        });
        const r = this.editor,
          s = r.t,
          a = new ap(r.locale);
        if (a.ariaLabel = t || s("Widget toolbar"), this._toolbarDefinitions.has(e)) throw new _("widget-toolbar-duplicated", this, {
          toolbarId: e
        });
        const l = {
          view: a,
          getRelatedElement: i,
          balloonClassName: o,
          itemsConfig: n,
          initialized: !1
        };
        r.ui.addToolbar(a, {
          isContextual: !0,
          beforeFocus: () => {
            const e = i(r.editing.view.document.selection);
            e && this._showToolbar(l, e);
          },
          afterBlur: () => {
            this._hideToolbar(l);
          }
        }), this._toolbarDefinitions.set(e, l);
      }
      _updateToolbarsVisibility() {
        let e = 0,
          t = null,
          n = null;
        for (const i of this._toolbarDefinitions.values()) {
          const o = i.getRelatedElement(this.editor.editing.view.document.selection);
          if (this.isEnabled && o) {
            if (this.editor.ui.focusTracker.isFocused) {
              const r = o.getAncestors().length;
              r > e && (e = r, t = o, n = i);
            } else this._isToolbarVisible(i) && this._hideToolbar(i);
          } else this._isToolbarInBalloon(i) && this._hideToolbar(i);
        }
        n && this._showToolbar(n, t);
      }
      _hideToolbar(e) {
        this._balloon.remove(e.view), this.stopListening(this._balloon, "change:visibleView");
      }
      _showToolbar(e, t) {
        this._isToolbarVisible(e) ? Kw(this.editor, t) : this._isToolbarInBalloon(e) || (e.initialized || (e.initialized = !0, e.view.fillFromConfig(e.itemsConfig, this.editor.ui.componentFactory)), this._balloon.add({
          view: e.view,
          position: Ww(this.editor, t),
          balloonClassName: e.balloonClassName
        }), this.listenTo(this._balloon, "change:visibleView", () => {
          for (const e of this._toolbarDefinitions.values()) if (this._isToolbarVisible(e)) {
            const t = e.getRelatedElement(this.editor.editing.view.document.selection);
            Kw(this.editor, t);
          }
        }));
      }
      _isToolbarVisible(e) {
        return this._balloon.visibleView === e.view;
      }
      _isToolbarInBalloon(e) {
        return this._balloon.hasView(e.view);
      }
    }
    function Kw(e, t) {
      const n = e.plugins.get("ContextualBalloon"),
        i = Ww(e, t);
      n.updatePosition(i);
    }
    function Ww(e, t) {
      const n = e.editing.view,
        i = Xg.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(t),
        positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast, i.viewportStickyNorth]
      };
    }
    q();
    q();
    var Yw = o(6926),
      $w = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Yw.A, $w);
    Yw.A.locals;
    const Zw = qi("px");
    class Qw extends Er {
      constructor() {
        super();
        const e = this.bindTemplate;
        this.set({
          isVisible: !1,
          left: null,
          top: null,
          width: null
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-clipboard-drop-target-line", e.if("isVisible", "ck-hidden", e => !e)],
            style: {
              left: e.to("left", e => Zw(e)),
              top: e.to("top", e => Zw(e)),
              width: e.to("width", e => Zw(e))
            }
          }
        });
      }
    }
    class Jw extends Br {
      constructor() {
        super(...arguments), this.removeDropMarkerDelayed = $o(() => this.removeDropMarker(), 40), this._updateDropMarkerThrottled = df(e => this._updateDropMarker(e), 40), this._reconvertMarkerThrottled = df(() => {
          this.editor.model.markers.has("drop-target") && this.editor.editing.reconvertMarker("drop-target");
        }, 0), this._dropTargetLineView = new Qw(), this._domEmitter = new (Di())(), this._scrollables = new Map();
      }
      static get pluginName() {
        return "DragDropTarget";
      }
      init() {
        this._setupDropMarker();
      }
      destroy() {
        this._domEmitter.stopListening();
        for (const {
          resizeObserver: e
        } of this._scrollables.values()) e.destroy();
        return this._updateDropMarkerThrottled.cancel(), this.removeDropMarkerDelayed.cancel(), this._reconvertMarkerThrottled.cancel(), super.destroy();
      }
      updateDropMarker(e, t, n, i, o, r) {
        this.removeDropMarkerDelayed.cancel();
        const s = Xw(this.editor, e, t, n, i, o, r);
        if (s) return r && r.containsRange(s) ? this.removeDropMarker() : void this._updateDropMarkerThrottled(s);
      }
      getFinalDropRange(e, t, n, i, o, r) {
        const s = Xw(this.editor, e, t, n, i, o, r);
        return this.removeDropMarker(), s;
      }
      removeDropMarker() {
        const e = this.editor.model;
        this.removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), this._dropTargetLineView.isVisible = !1, e.markers.has("drop-target") && e.change(e => {
          e.removeMarker("drop-target");
        });
      }
      _setupDropMarker() {
        const e = this.editor;
        e.ui.view.body.add(this._dropTargetLineView), e.conversion.for("editingDowncast").markerToHighlight({
          model: "drop-target",
          view: {
            classes: ["ck-clipboard-drop-target-range"]
          }
        }), e.conversion.for("editingDowncast").markerToElement({
          model: "drop-target",
          view: (t, _ref86) => {
            let {
              writer: n
            } = _ref86;
            if (e.model.schema.checkChild(t.markerRange.start, "$text")) return this._dropTargetLineView.isVisible = !1, this._createDropTargetPosition(n);
            t.markerRange.isCollapsed ? this._updateDropTargetLine(t.markerRange) : this._dropTargetLineView.isVisible = !1;
          }
        });
      }
      _updateDropMarker(e) {
        const t = this.editor,
          n = t.model.markers;
        t.model.change(t => {
          n.has("drop-target") ? n.get("drop-target").getRange().isEqual(e) || t.updateMarker("drop-target", {
            range: e
          }) : t.addMarker("drop-target", {
            range: e,
            usingOperation: !1,
            affectsData: !1
          });
        });
      }
      _createDropTargetPosition(e) {
        return e.createUIElement("span", {
          class: "ck ck-clipboard-drop-target-position"
        }, function (e) {
          const t = this.toDomElement(e);
          return t.append("⁠", e.createElement("span"), "⁠"), t;
        });
      }
      _updateDropTargetLine(e) {
        const n = this.editor.editing,
          i = e.start.nodeBefore,
          o = e.start.nodeAfter,
          r = e.start.parent,
          s = i ? n.mapper.toViewElement(i) : null,
          a = s ? n.view.domConverter.mapViewToDom(s) : null,
          l = o ? n.mapper.toViewElement(o) : null,
          c = l ? n.view.domConverter.mapViewToDom(l) : null,
          d = n.mapper.toViewElement(r);
        if (!d) return;
        const u = n.view.domConverter.mapViewToDom(d),
          h = this._getScrollableRect(d),
          {
            scrollX: m,
            scrollY: p
          } = t.window,
          g = a ? new Li(a) : null,
          f = c ? new Li(c) : null,
          k = new Li(u).excludeScrollbarsAndBorders(),
          b = g ? g.bottom : k.top,
          _ = f ? f.top : k.bottom,
          w = t.window.getComputedStyle(u),
          A = b <= _ ? (b + _) / 2 : _;
        if (h.top < A && A < h.bottom) {
          const e = k.left + parseFloat(w.paddingLeft),
            t = k.right - parseFloat(w.paddingRight),
            n = Math.max(e + m, h.left),
            i = Math.min(t + m, h.right);
          this._dropTargetLineView.set({
            isVisible: !0,
            left: n,
            top: A + p,
            width: i - n
          });
        } else this._dropTargetLineView.isVisible = !1;
      }
      _getScrollableRect(e) {
        const n = e.root.rootName;
        let i;
        if (this._scrollables.has(n)) i = this._scrollables.get(n).domElement;else {
          i = function (e) {
            let n = e;
            do {
              n = n.parentElement;
              const e = t.window.getComputedStyle(n).overflowY;
              if ("auto" == e || "scroll" == e) break;
            } while ("BODY" != n.tagName);
            return n;
          }(this.editor.editing.view.domConverter.mapViewToDom(e)), this._domEmitter.listenTo(i, "scroll", this._reconvertMarkerThrottled, {
            usePassive: !0
          });
          const o = new Hi(i, this._reconvertMarkerThrottled);
          this._scrollables.set(n, {
            domElement: i,
            resizeObserver: o
          });
        }
        return new Li(i).excludeScrollbarsAndBorders();
      }
    }
    function Xw(e, t, n, i, o, r, s) {
      const a = e.model,
        l = e.editing.mapper;
      let c = iA(e, t);
      for (; c;) {
        if (!r) if (a.schema.checkChild(c, "$text")) {
          if (n) {
            const t = n[0].start,
              r = l.toModelPosition(t);
            if (!s || Array.from(s.getItems()).every(e => a.schema.checkChild(r, e))) {
              if (a.schema.checkChild(r, "$text")) return a.createRange(r);
              if (t) return tA(e, iA(e, t.parent), i, o);
            }
          }
        } else if (a.schema.isInline(c)) return tA(e, c, i, o);
        if (a.schema.isBlock(c)) return tA(e, c, i, o);
        if (a.schema.checkChild(c, "$block")) {
          const t = Array.from(c.getChildren()).filter(t => t.is("element") && !eA(e, t));
          let n = 0,
            r = t.length;
          if (0 == r) return a.createRange(a.createPositionAt(c, "end"));
          for (; n < r - 1;) {
            const s = Math.floor((n + r) / 2);
            "before" == nA(e, t[s], i, o) ? r = s : n = s;
          }
          return tA(e, t[n], i, o);
        }
        c = c.parent;
      }
      return null;
    }
    function eA(e, n) {
      const i = e.editing.mapper,
        o = e.editing.view.domConverter,
        r = i.toViewElement(n);
      if (!r) return !0;
      const s = o.mapViewToDom(r);
      return "none" != t.window.getComputedStyle(s).float;
    }
    function tA(e, t, n, i) {
      const o = e.model;
      return o.createRange(o.createPositionAt(t, nA(e, t, n, i)));
    }
    function nA(e, t, n, i) {
      const o = e.editing.mapper,
        r = e.editing.view.domConverter,
        s = o.toViewElement(t),
        a = r.mapViewToDom(s),
        l = new Li(a);
      return e.model.schema.isInline(t) ? n < (l.left + l.right) / 2 ? "before" : "after" : i < (l.top + l.bottom) / 2 ? "before" : "after";
    }
    function iA(e, t) {
      const n = e.editing.mapper,
        i = e.editing.view,
        o = n.toModelElement(t);
      if (o) return o;
      const r = i.createPositionBefore(t),
        s = n.findMappedViewAncestor(r);
      return n.toModelElement(s);
    }
    class oA extends Br {
      constructor() {
        super(...arguments), this._isBlockDragging = !1, this._domEmitter = new (Di())();
      }
      static get pluginName() {
        return "DragDropBlockToolbar";
      }
      init() {
        const e = this.editor;
        if (this.listenTo(e, "change:isReadOnly", (e, t, n) => {
          n ? (this.forceDisabled("readOnlyMode"), this._isBlockDragging = !1) : this.clearForceDisabled("readOnlyMode");
        }), s.isAndroid && this.forceDisabled("noAndroidSupport"), e.plugins.has("BlockToolbar")) {
          const n = e.plugins.get("BlockToolbar").buttonView.element;
          this._domEmitter.listenTo(n, "dragstart", (e, t) => this._handleBlockDragStart(t)), this._domEmitter.listenTo(t.document, "dragover", (e, t) => this._handleBlockDragging(t)), this._domEmitter.listenTo(t.document, "drop", (e, t) => this._handleBlockDragging(t)), this._domEmitter.listenTo(t.document, "dragend", () => this._handleBlockDragEnd(), {
            useCapture: !0
          }), this.isEnabled && n.setAttribute("draggable", "true"), this.on("change:isEnabled", (e, t, i) => {
            n.setAttribute("draggable", i ? "true" : "false");
          });
        }
      }
      destroy() {
        return this._domEmitter.stopListening(), super.destroy();
      }
      _handleBlockDragStart(e) {
        if (!this.isEnabled) return;
        const t = this.editor.model,
          n = t.document.selection,
          i = this.editor.editing.view,
          o = Array.from(n.getSelectedBlocks()),
          r = t.createRange(t.createPositionBefore(o[0]), t.createPositionAfter(o[o.length - 1]));
        t.change(e => e.setSelection(r)), this._isBlockDragging = !0, i.focus(), i.getObserver(K_).onDomEvent(e);
      }
      _handleBlockDragging(e) {
        if (!this.isEnabled || !this._isBlockDragging) return;
        const t = e.clientX + ("ltr" == this.editor.locale.contentLanguageDirection ? 100 : -100),
          n = e.clientY,
          i = document.elementFromPoint(t, n),
          o = this.editor.editing.view;
        i && i.closest(".ck-editor__editable") && o.getObserver(K_).onDomEvent({
          ...e,
          type: e.type,
          dataTransfer: e.dataTransfer,
          target: i,
          clientX: t,
          clientY: n,
          preventDefault: () => e.preventDefault(),
          stopPropagation: () => e.stopPropagation()
        });
      }
      _handleBlockDragEnd() {
        this._isBlockDragging = !1;
      }
    }
    var rA = o(6356),
      sA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(rA.A, sA);
    rA.A.locals;
    class aA extends Br {
      constructor() {
        super(...arguments), this._clearDraggableAttributesDelayed = $o(() => this._clearDraggableAttributes(), 40), this._blockMode = !1, this._domEmitter = new (Di())();
      }
      static get pluginName() {
        return "DragDrop";
      }
      static get requires() {
        return [mw, Uw, Jw, oA];
      }
      init() {
        const e = this.editor,
          t = e.editing.view;
        this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, t.addObserver(K_), t.addObserver(Ju), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDraggableAttributeHandling(), this.listenTo(e, "change:isReadOnly", (e, t, n) => {
          n ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
        }), this.on("change:isEnabled", (e, t, n) => {
          n || this._finalizeDragging(!1);
        }), s.isAndroid && this.forceDisabled("noAndroidSupport");
      }
      destroy() {
        return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._previewContainer && this._previewContainer.remove(), this._domEmitter.stopListening(), this._clearDraggableAttributesDelayed.cancel(), super.destroy();
      }
      _setupDragging() {
        const e = this.editor,
          n = e.model,
          i = e.editing.view,
          o = i.document,
          r = e.plugins.get(Jw);
        this.listenTo(o, "dragstart", (e, t) => {
          if (t.target && t.target.is("editableElement")) return void t.preventDefault();
          if (this._prepareDraggedRange(t.target), !this._draggedRange) return void t.preventDefault();
          this._draggingUid = g(), t.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy", t.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
          const i = n.createSelection(this._draggedRange.toRange());
          this.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(t.dataTransfer, i, "dragstart");
          const {
              dataTransfer: o,
              domTarget: r,
              domEvent: s
            } = t,
            {
              clientX: a
            } = s;
          this._updatePreview({
            dataTransfer: o,
            domTarget: r,
            clientX: a
          }), t.stopPropagation(), this.isEnabled || (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
        }, {
          priority: "low"
        }), this.listenTo(o, "dragend", (e, t) => {
          this._finalizeDragging(!t.dataTransfer.isCanceled && "move" == t.dataTransfer.dropEffect);
        }, {
          priority: "low"
        }), this._domEmitter.listenTo(t.document, "dragend", () => {
          this._blockMode = !1;
        }, {
          useCapture: !0
        }), this.listenTo(o, "dragenter", () => {
          this.isEnabled && i.focus();
        }), this.listenTo(o, "dragleave", () => {
          r.removeDropMarkerDelayed();
        }), this.listenTo(o, "dragging", (e, t) => {
          if (!this.isEnabled) return void (t.dataTransfer.dropEffect = "none");
          const {
            clientX: n,
            clientY: i
          } = t.domEvent;
          r.updateDropMarker(t.target, t.targetRanges, n, i, this._blockMode, this._draggedRange), this._draggedRange || (t.dataTransfer.dropEffect = "copy"), s.isGecko || ("copy" == t.dataTransfer.effectAllowed ? t.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(t.dataTransfer.effectAllowed) && (t.dataTransfer.dropEffect = "move")), e.stop();
        }, {
          priority: "low"
        });
      }
      _setupClipboardInputIntegration() {
        const e = this.editor,
          t = e.editing.view.document,
          n = e.plugins.get(Jw);
        this.listenTo(t, "clipboardInput", (t, i) => {
          if ("drop" != i.method) return;
          const {
              clientX: o,
              clientY: r
            } = i.domEvent,
            s = n.getFinalDropRange(i.target, i.targetRanges, o, r, this._blockMode, this._draggedRange);
          if (!s) return this._finalizeDragging(!1), void t.stop();
          this._draggedRange && this._draggingUid != i.dataTransfer.getData("application/ckeditor5-dragging-uid") && (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
          if ("move" == lA(i.dataTransfer) && this._draggedRange && this._draggedRange.containsRange(s, !0)) return this._finalizeDragging(!1), void t.stop();
          i.targetRanges = [e.editing.mapper.toViewRange(s)];
        }, {
          priority: "high"
        });
      }
      _setupContentInsertionIntegration() {
        const e = this.editor.plugins.get(mw);
        e.on("contentInsertion", (e, t) => {
          if (!this.isEnabled || "drop" !== t.method) return;
          const n = t.targetRanges.map(e => this.editor.editing.mapper.toModelRange(e));
          this.editor.model.change(e => e.setSelection(n));
        }, {
          priority: "high"
        }), e.on("contentInsertion", (e, t) => {
          if (!this.isEnabled || "drop" !== t.method) return;
          const n = "move" == lA(t.dataTransfer),
            i = !t.resultRange || !t.resultRange.isCollapsed;
          this._finalizeDragging(i && n);
        }, {
          priority: "lowest"
        });
      }
      _setupDraggableAttributeHandling() {
        const e = this.editor,
          t = e.editing.view,
          n = t.document;
        this.listenTo(n, "mousedown", (i, o) => {
          if (s.isAndroid || !o) return;
          this._clearDraggableAttributesDelayed.cancel();
          let r = cA(o.target);
          if (s.isBlink && !e.isReadOnly && !r && !n.selection.isCollapsed) {
            const e = n.selection.getSelectedElement();
            e && Aw(e) || (r = n.selection.editableElement);
          }
          r && (t.change(e => {
            e.setAttribute("draggable", "true", r);
          }), this._draggableElement = e.editing.mapper.toModelElement(r));
        }), this.listenTo(n, "mouseup", () => {
          s.isAndroid || this._clearDraggableAttributesDelayed();
        });
      }
      _clearDraggableAttributes() {
        const e = this.editor.editing;
        e.view.change(t => {
          this._draggableElement && "$graveyard" != this._draggableElement.root.rootName && t.removeAttribute("draggable", e.mapper.toViewElement(this._draggableElement)), this._draggableElement = null;
        });
      }
      _finalizeDragging(e) {
        const t = this.editor,
          n = t.model;
        if (t.plugins.get(Jw).removeDropMarker(), this._clearDraggableAttributes(), t.plugins.has("WidgetToolbarRepository")) {
          t.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop");
        }
        this._draggingUid = "", this._previewContainer && (this._previewContainer.remove(), this._previewContainer = void 0), this._draggedRange && (e && this.isEnabled && n.change(e => {
          const t = n.createSelection(this._draggedRange);
          n.deleteContent(t, {
            doNotAutoparagraph: !0
          });
          const i = t.getFirstPosition().parent;
          i.isEmpty && !n.schema.checkChild(i, "$text") && n.schema.checkChild(i, "paragraph") && e.insertElement("paragraph", i, 0);
        }), this._draggedRange.detach(), this._draggedRange = null);
      }
      _prepareDraggedRange(e) {
        const t = this.editor,
          n = t.model,
          i = n.document.selection,
          o = e ? cA(e) : null;
        if (o) {
          const e = t.editing.mapper.toModelElement(o);
          if (this._draggedRange = yc.fromRange(n.createRangeOn(e)), this._blockMode = n.schema.isBlock(e), t.plugins.has("WidgetToolbarRepository")) {
            t.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
          }
          return;
        }
        if (i.isCollapsed && !i.getFirstPosition().parent.isEmpty) return;
        const r = Array.from(i.getSelectedBlocks()),
          s = i.getFirstRange();
        if (0 == r.length) return void (this._draggedRange = yc.fromRange(s));
        const a = dA(n, r);
        if (r.length > 1) this._draggedRange = yc.fromRange(a), this._blockMode = !0;else if (1 == r.length) {
          const e = s.start.isTouching(a.start) && s.end.isTouching(a.end);
          this._draggedRange = yc.fromRange(e ? a : s), this._blockMode = e;
        }
        n.change(e => e.setSelection(this._draggedRange.toRange()));
      }
      _updatePreview(_ref87) {
        let {
          dataTransfer: e,
          domTarget: n,
          clientX: i
        } = _ref87;
        const o = this.editor.editing.view,
          r = o.document.selection.editableElement,
          a = o.domConverter.mapViewToDom(r),
          l = t.window.getComputedStyle(a);
        this._previewContainer ? this._previewContainer.firstElementChild && this._previewContainer.removeChild(this._previewContainer.firstElementChild) : (this._previewContainer = fe(t.document, "div", {
          style: "position: fixed; left: -999999px;"
        }), t.document.body.appendChild(this._previewContainer));
        const c = new Li(a);
        if (a.contains(n)) return;
        const d = parseFloat(l.paddingLeft),
          u = fe(t.document, "div");
        u.className = "ck ck-content", u.style.width = l.width, u.style.paddingLeft = "".concat(c.left - i + d, "px"), s.isiOS && (u.style.backgroundColor = "white"), u.innerHTML = e.getData("text/html"), e.setDragImage(u, 0, 0), this._previewContainer.appendChild(u);
      }
    }
    function lA(e) {
      return s.isGecko ? e.dropEffect : ["all", "copyMove"].includes(e.effectAllowed) ? "move" : "copy";
    }
    function cA(e) {
      if (e.is("editableElement")) return null;
      if (e.hasClass("ck-widget__selection-handle")) return e.findAncestor(Aw);
      if (Aw(e)) return e;
      const t = e.findAncestor(e => Aw(e) || e.is("editableElement"));
      return Aw(t) ? t : null;
    }
    function dA(e, t) {
      const n = t[0],
        i = t[t.length - 1],
        o = n.getCommonAncestor(i),
        r = e.createPositionBefore(n),
        s = e.createPositionAfter(i);
      if (o && o.is("element") && !e.schema.isLimit(o)) {
        const t = e.createRangeOn(o),
          n = r.isTouching(t.start),
          i = s.isTouching(t.end);
        if (n && i) return dA(e, [o]);
      }
      return e.createRange(r, s);
    }
    class uA extends Br {
      static get pluginName() {
        return "PastePlainText";
      }
      static get requires() {
        return [mw];
      }
      init() {
        const e = this.editor,
          t = e.model,
          n = e.editing.view,
          i = n.document,
          o = t.document.selection;
        let r = !1;
        n.addObserver(K_), this.listenTo(i, "keydown", (e, t) => {
          r = t.shiftKey;
        }), e.plugins.get(mw).on("contentInsertion", (e, n) => {
          (r || function (e, t) {
            if (e.childCount > 1) return !1;
            const n = e.getChild(0);
            if (t.isObject(n)) return !1;
            return 0 == Array.from(n.getAttributeKeys()).length;
          }(n.content, t.schema)) && t.change(e => {
            const i = Array.from(o.getAttributes()).filter(_ref88 => {
              let [e] = _ref88;
              return t.schema.getAttributeProperties(e).isFormatting;
            });
            o.isCollapsed || t.deleteContent(o, {
              doNotAutoparagraph: !0
            }), i.push(...o.getAttributes());
            const r = e.createRangeIn(n.content);
            for (const t of r.getItems()) t.is("$textProxy") && e.setAttributes(i, t);
          });
        });
      }
    }
    class hA extends Br {
      static get pluginName() {
        return "Clipboard";
      }
      static get requires() {
        return [hw, mw, aA, uA];
      }
      init() {
        const e = this.editor,
          t = this.editor.t;
        e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Copy selected content"),
            keystroke: "CTRL+C"
          }, {
            label: t("Paste content"),
            keystroke: "CTRL+V"
          }, {
            label: t("Paste content as plain text"),
            keystroke: "CTRL+SHIFT+V"
          }]
        });
      }
    }
    class mA extends Pr {
      constructor(e) {
        super(e), this.affectsData = !1;
      }
      execute() {
        const e = this.editor.model,
          t = e.document.selection;
        let n = e.schema.getLimitElement(t);
        if (t.containsEntireContent(n) || !pA(e.schema, n)) do {
          if (n = n.parent, !n) return;
        } while (!pA(e.schema, n));
        e.change(e => {
          e.setSelection(n, "in");
        });
      }
    }
    function pA(e, t) {
      return e.isLimit(t) && (e.checkChild(t, "$text") || e.checkChild(t, "paragraph"));
    }
    const gA = fo("Ctrl+A");
    class fA extends Br {
      static get pluginName() {
        return "SelectAllEditing";
      }
      init() {
        const e = this.editor,
          t = e.t,
          n = e.editing.view.document;
        e.commands.add("selectAll", new mA(e)), this.listenTo(n, "keydown", (t, n) => {
          go(n) === gA && (e.execute("selectAll"), n.preventDefault());
        }), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Select all"),
            keystroke: "CTRL+A"
          }]
        });
      }
    }
    class kA extends Br {
      static get pluginName() {
        return "SelectAllUI";
      }
      init() {
        const e = this.editor;
        e.ui.componentFactory.add("selectAll", () => {
          const e = this._createButton(um);
          return e.set({
            tooltip: !0
          }), e;
        }), e.ui.componentFactory.add("menuBar:selectAll", () => this._createButton(qk));
      }
      _createButton(e) {
        const t = this.editor,
          n = t.locale,
          i = t.commands.get("selectAll"),
          o = new e(t.locale),
          r = n.t;
        return o.set({
          label: r("Select all"),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
          keystroke: "Ctrl+A"
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          t.execute("selectAll"), t.editing.view.focus();
        }), o;
      }
    }
    class bA extends Br {
      static get requires() {
        return [fA, kA];
      }
      static get pluginName() {
        return "SelectAll";
      }
    }
    class _A extends Pr {
      constructor(e) {
        super(e), this._stack = [], this._createdBatches = new WeakSet(), this.refresh(), this._isEnabledBasedOnSelection = !1, this.listenTo(e.data, "set", (e, t) => {
          t[1] = {
            ...t[1]
          };
          const n = t[1];
          n.batchType || (n.batchType = {
            isUndoable: !1
          });
        }, {
          priority: "high"
        }), this.listenTo(e.data, "set", (e, t) => {
          t[1].batchType.isUndoable || this.clearStack();
        });
      }
      refresh() {
        this.isEnabled = this._stack.length > 0;
      }
      get createdBatches() {
        return this._createdBatches;
      }
      addBatch(e) {
        const t = this.editor.model.document.selection,
          n = {
            ranges: t.hasOwnRange ? Array.from(t.getRanges()) : [],
            isBackward: t.isBackward
          };
        this._stack.push({
          batch: e,
          selection: n
        }), this.refresh();
      }
      clearStack() {
        this._stack = [], this.refresh();
      }
      _restoreSelection(e, t, n) {
        const i = this.editor.model,
          o = i.document,
          r = [],
          s = e.map(e => e.getTransformedByOperations(n)),
          a = s.flat();
        for (const e of s) {
          const t = e.filter(e => e.root != o.graveyard).filter(e => !AA(e, a));
          t.length && (wA(t), r.push(t[0]));
        }
        r.length && i.change(e => {
          e.setSelection(r, {
            backward: t
          });
        });
      }
      _undo(e, t) {
        const n = this.editor.model,
          i = n.document;
        this._createdBatches.add(t);
        const o = e.operations.slice().filter(e => e.isDocumentOperation);
        o.reverse();
        for (const e of o) {
          const o = e.baseVersion + 1,
            r = Array.from(i.history.getOperations(o)),
            s = ru([e.getReversed()], r, {
              useRelations: !0,
              document: this.editor.model.document,
              padWithNoOps: !1,
              forceWeakRemove: !0
            }).operationsA;
          for (let o of s) {
            const r = o.affectedSelectable;
            r && !n.canEditAt(r) && (o = new $d(o.baseVersion)), t.addOperation(o), n.applyOperation(o), i.history.setOperationAsUndone(e, o);
          }
        }
      }
    }
    function wA(e) {
      e.sort((e, t) => e.start.isBefore(t.start) ? -1 : 1);
      for (let t = 1; t < e.length; t++) {
        const n = e[t - 1].getJoined(e[t], !0);
        n && (t--, e.splice(t, 2, n));
      }
    }
    function AA(e, t) {
      return t.some(t => t !== e && t.containsRange(e, !0));
    }
    class vA extends _A {
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        const t = e ? this._stack.findIndex(t => t.batch == e) : this._stack.length - 1,
          n = this._stack.splice(t, 1)[0],
          i = this.editor.model.createBatch({
            isUndo: !0
          });
        this.editor.model.enqueueChange(i, () => {
          this._undo(n.batch, i);
          const e = this.editor.model.document.history.getOperations(n.batch.baseVersion);
          this._restoreSelection(n.selection.ranges, n.selection.isBackward, e);
        }), this.fire("revert", n.batch, i), this.refresh();
      }
    }
    class CA extends _A {
      execute() {
        const e = this._stack.pop(),
          t = this.editor.model.createBatch({
            isUndo: !0
          });
        this.editor.model.enqueueChange(t, () => {
          const n = e.batch.operations[e.batch.operations.length - 1].baseVersion + 1,
            i = this.editor.model.document.history.getOperations(n);
          this._restoreSelection(e.selection.ranges, e.selection.isBackward, i), this._undo(e.batch, t);
        }), this.refresh();
      }
    }
    class yA extends Br {
      constructor() {
        super(...arguments), this._batchRegistry = new WeakSet();
      }
      static get pluginName() {
        return "UndoEditing";
      }
      init() {
        const e = this.editor,
          t = e.t;
        this._undoCommand = new vA(e), this._redoCommand = new CA(e), e.commands.add("undo", this._undoCommand), e.commands.add("redo", this._redoCommand), this.listenTo(e.model, "applyOperation", (e, t) => {
          const n = t[0];
          if (!n.isDocumentOperation) return;
          const i = n.batch,
            o = this._redoCommand.createdBatches.has(i),
            r = this._undoCommand.createdBatches.has(i);
          this._batchRegistry.has(i) || (this._batchRegistry.add(i), i.isUndoable && (o ? this._undoCommand.addBatch(i) : r || (this._undoCommand.addBatch(i), this._redoCommand.clearStack())));
        }, {
          priority: "highest"
        }), this.listenTo(this._undoCommand, "revert", (e, t, n) => {
          this._redoCommand.addBatch(n);
        }), e.keystrokes.set("CTRL+Z", "undo"), e.keystrokes.set("CTRL+Y", "redo"), e.keystrokes.set("CTRL+SHIFT+Z", "redo"), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Undo"),
            keystroke: "CTRL+Z"
          }, {
            label: t("Redo"),
            keystroke: [["CTRL+Y"], ["CTRL+SHIFT+Z"]]
          }]
        });
      }
    }
    class xA extends Br {
      static get pluginName() {
        return "UndoUI";
      }
      init() {
        const e = this.editor,
          t = e.locale,
          n = e.t,
          i = "ltr" == t.uiLanguageDirection ? Wh.undo : Wh.redo,
          o = "ltr" == t.uiLanguageDirection ? Wh.redo : Wh.undo;
        this._addButtonsToFactory("undo", n("Undo"), "CTRL+Z", i), this._addButtonsToFactory("redo", n("Redo"), "CTRL+Y", o);
      }
      _addButtonsToFactory(e, t, n, i) {
        const o = this.editor;
        o.ui.componentFactory.add(e, () => {
          const o = this._createButton(um, e, t, n, i);
          return o.set({
            tooltip: !0
          }), o;
        }), o.ui.componentFactory.add("menuBar:" + e, () => this._createButton(qk, e, t, n, i));
      }
      _createButton(e, t, n, i, o) {
        const r = this.editor,
          s = r.locale,
          a = r.commands.get(t),
          l = new e(s);
        return l.set({
          label: n,
          icon: o,
          keystroke: i
        }), l.bind("isEnabled").to(a, "isEnabled"), this.listenTo(l, "execute", () => {
          r.execute(t), r.editing.view.focus();
        }), l;
      }
    }
    class EA extends Br {
      static get requires() {
        return [yA, xA];
      }
      static get pluginName() {
        return "Undo";
      }
    }
    class SA extends Pr {
      constructor(e, t) {
        super(e), this.attributeKey = t;
      }
      refresh() {
        const e = this.editor.model,
          t = e.document;
        this.value = t.selection.getAttribute(this.attributeKey), this.isEnabled = e.schema.checkAttributeInSelection(t.selection, this.attributeKey);
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document.selection,
          i = e.value,
          o = e.batch,
          r = e => {
            if (n.isCollapsed) i ? e.setSelectionAttribute(this.attributeKey, i) : e.removeSelectionAttribute(this.attributeKey);else {
              const o = t.schema.getValidRanges(n.getRanges(), this.attributeKey);
              for (const t of o) i ? e.setAttribute(this.attributeKey, i, t) : e.removeAttribute(this.attributeKey, t);
            }
          };
        o ? t.enqueueChange(o, e => {
          r(e);
        }) : t.change(e => {
          r(e);
        });
      }
    }
    const DA = "fontColor",
      TA = "fontBackgroundColor";
    function IA(e) {
      return t => t.getStyle(e).replace(/\s/g, "");
    }
    function BA(e) {
      return (t, _ref89) => {
        let {
          writer: n
        } = _ref89;
        return n.createAttributeElement("span", {
          style: "".concat(e, ":").concat(t)
        }, {
          priority: 7
        });
      };
    }
    var MA = o(1263),
      PA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(MA.A, PA);
    MA.A.locals;
    class zA extends SA {
      constructor(e) {
        super(e, DA);
      }
    }
    class NA extends Br {
      static get pluginName() {
        return "FontColorEditing";
      }
      constructor(e) {
        super(e), e.config.define(DA, {
          colors: [{
            color: "hsl(0, 0%, 0%)",
            label: "Black"
          }, {
            color: "hsl(0, 0%, 30%)",
            label: "Dim grey"
          }, {
            color: "hsl(0, 0%, 60%)",
            label: "Grey"
          }, {
            color: "hsl(0, 0%, 90%)",
            label: "Light grey"
          }, {
            color: "hsl(0, 0%, 100%)",
            label: "White",
            hasBorder: !0
          }, {
            color: "hsl(0, 75%, 60%)",
            label: "Red"
          }, {
            color: "hsl(30, 75%, 60%)",
            label: "Orange"
          }, {
            color: "hsl(60, 75%, 60%)",
            label: "Yellow"
          }, {
            color: "hsl(90, 75%, 60%)",
            label: "Light green"
          }, {
            color: "hsl(120, 75%, 60%)",
            label: "Green"
          }, {
            color: "hsl(150, 75%, 60%)",
            label: "Aquamarine"
          }, {
            color: "hsl(180, 75%, 60%)",
            label: "Turquoise"
          }, {
            color: "hsl(210, 75%, 60%)",
            label: "Light blue"
          }, {
            color: "hsl(240, 75%, 60%)",
            label: "Blue"
          }, {
            color: "hsl(270, 75%, 60%)",
            label: "Purple"
          }],
          columns: 5
        }), e.conversion.for("upcast").elementToAttribute({
          view: {
            name: "span",
            styles: {
              color: /[\s\S]+/
            }
          },
          model: {
            key: DA,
            value: IA("color")
          }
        }), e.conversion.for("upcast").elementToAttribute({
          view: {
            name: "font",
            attributes: {
              color: /^#?\w+$/
            }
          },
          model: {
            key: DA,
            value: e => e.getAttribute("color")
          }
        }), e.conversion.for("downcast").attributeToElement({
          model: DA,
          view: BA("color")
        }), e.commands.add(DA, new zA(e)), e.model.schema.extend("$text", {
          allowAttributes: DA
        }), e.model.schema.setAttributeProperties(DA, {
          isFormatting: !0,
          copyOnEnter: !0
        });
      }
    }
    class LA extends Br {
      constructor(e, _ref90) {
        let {
          commandName: t,
          componentName: n,
          icon: i,
          dropdownLabel: o
        } = _ref90;
        super(e), this.commandName = t, this.componentName = n, this.icon = i, this.dropdownLabel = o, this.columns = e.config.get("".concat(this.componentName, ".columns"));
      }
      init() {
        const e = this.editor,
          t = e.locale,
          n = t.t,
          i = e.commands.get(this.commandName),
          o = e.config.get(this.componentName),
          r = Am(t, vm(o.colors)),
          s = o.documentColors,
          a = !1 !== o.colorPicker;
        e.ui.componentFactory.add(this.componentName, t => {
          const l = yp(t);
          let c = !1;
          const d = function (_ref91) {
            let {
              dropdownView: e,
              colors: t,
              columns: n,
              removeButtonLabel: i,
              colorPickerLabel: o,
              documentColorsLabel: r,
              documentColorsCount: s,
              colorPickerViewConfig: a
            } = _ref91;
            const l = e.locale,
              c = new yg(l, {
                colors: t,
                columns: n,
                removeButtonLabel: i,
                colorPickerLabel: o,
                documentColorsLabel: r,
                documentColorsCount: s,
                colorPickerViewConfig: a
              });
            return e.colorSelectorView = c, e.panelView.children.add(c), c;
          }({
            dropdownView: l,
            colors: r.map(e => ({
              label: e.label,
              color: e.model,
              options: {
                hasBorder: e.hasBorder
              }
            })),
            columns: this.columns,
            removeButtonLabel: n("Remove color"),
            colorPickerLabel: n("Color picker"),
            documentColorsLabel: 0 !== s ? n("Document colors") : "",
            documentColorsCount: void 0 === s ? this.columns : s,
            colorPickerViewConfig: !!a && (o.colorPicker || {})
          });
          return d.bind("selectedColor").to(i, "value"), l.buttonView.set({
            label: this.dropdownLabel,
            icon: this.icon,
            tooltip: !0
          }), l.extendTemplate({
            attributes: {
              class: "ck-color-ui-dropdown"
            }
          }), l.bind("isEnabled").to(i), d.on("execute", (t, n) => {
            l.isOpen && e.execute(this.commandName, {
              value: n.value,
              batch: this._undoStepBatch
            }), "colorPicker" !== n.source && e.editing.view.focus(), "colorPickerSaveButton" === n.source && (l.isOpen = !1);
          }), d.on("colorPicker:show", () => {
            this._undoStepBatch = e.model.createBatch();
          }), d.on("colorPicker:cancel", () => {
            this._undoStepBatch.operations.length && (l.isOpen = !1, e.execute("undo", this._undoStepBatch)), e.editing.view.focus();
          }), l.on("change:isOpen", (t, n, i) => {
            c || (c = !0, l.colorSelectorView.appendUI()), i && (0 !== s && d.updateDocumentColors(e.model, this.componentName), d.updateSelectedColors(), d.showColorGridsFragment());
          }), Tp(l, () => l.colorSelectorView.colorGridsFragmentView.staticColorsGrid.items.find(e => e.isOn)), l;
        }), e.ui.componentFactory.add("menuBar:".concat(this.componentName), t => {
          const o = new Fk(t);
          o.buttonView.set({
            label: this.dropdownLabel,
            icon: this.icon
          }), o.bind("isEnabled").to(i);
          let a = !1;
          const l = new yg(t, {
            colors: r.map(e => ({
              label: e.label,
              color: e.model,
              options: {
                hasBorder: e.hasBorder
              }
            })),
            columns: this.columns,
            removeButtonLabel: n("Remove color"),
            colorPickerLabel: n("Color picker"),
            documentColorsLabel: 0 !== s ? n("Document colors") : "",
            documentColorsCount: void 0 === s ? this.columns : s,
            colorPickerViewConfig: !1
          });
          return l.bind("selectedColor").to(i, "value"), l.delegate("execute").to(o), l.on("execute", (t, n) => {
            e.execute(this.commandName, {
              value: n.value,
              batch: this._undoStepBatch
            }), e.editing.view.focus();
          }), o.on("change:isOpen", (t, n, i) => {
            a || (a = !0, l.appendUI()), i && (0 !== s && l.updateDocumentColors(e.model, this.componentName), l.updateSelectedColors(), l.showColorGridsFragment());
          }), o.panelView.children.add(l), o;
        });
      }
    }
    class RA extends LA {
      constructor(e) {
        const t = e.locale.t;
        super(e, {
          commandName: DA,
          componentName: DA,
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 10.3 10 4.5l-2.4 5.8h4.8zm.5 1.2H7.1L5.7 15H4.2l5-12h1.6l5 12h-1.5L13 11.5zm3.1 7H4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z"/></svg>',
          dropdownLabel: t("Font Color")
        });
      }
      static get pluginName() {
        return "FontColorUI";
      }
    }
    class VA extends SA {
      constructor(e) {
        super(e, TA);
      }
    }
    class OA extends Br {
      static get pluginName() {
        return "FontBackgroundColorEditing";
      }
      constructor(e) {
        super(e), e.config.define(TA, {
          colors: [{
            color: "hsl(0, 0%, 0%)",
            label: "Black"
          }, {
            color: "hsl(0, 0%, 30%)",
            label: "Dim grey"
          }, {
            color: "hsl(0, 0%, 60%)",
            label: "Grey"
          }, {
            color: "hsl(0, 0%, 90%)",
            label: "Light grey"
          }, {
            color: "hsl(0, 0%, 100%)",
            label: "White",
            hasBorder: !0
          }, {
            color: "hsl(0, 75%, 60%)",
            label: "Red"
          }, {
            color: "hsl(30, 75%, 60%)",
            label: "Orange"
          }, {
            color: "hsl(60, 75%, 60%)",
            label: "Yellow"
          }, {
            color: "hsl(90, 75%, 60%)",
            label: "Light green"
          }, {
            color: "hsl(120, 75%, 60%)",
            label: "Green"
          }, {
            color: "hsl(150, 75%, 60%)",
            label: "Aquamarine"
          }, {
            color: "hsl(180, 75%, 60%)",
            label: "Turquoise"
          }, {
            color: "hsl(210, 75%, 60%)",
            label: "Light blue"
          }, {
            color: "hsl(240, 75%, 60%)",
            label: "Blue"
          }, {
            color: "hsl(270, 75%, 60%)",
            label: "Purple"
          }],
          columns: 5
        }), e.data.addStyleProcessorRules(Sh), e.conversion.for("upcast").elementToAttribute({
          view: {
            name: "span",
            styles: {
              "background-color": /[\s\S]+/
            }
          },
          model: {
            key: TA,
            value: IA("background-color")
          }
        }), e.conversion.for("downcast").attributeToElement({
          model: TA,
          view: BA("background-color")
        }), e.commands.add(TA, new VA(e)), e.model.schema.extend("$text", {
          allowAttributes: TA
        }), e.model.schema.setAttributeProperties(TA, {
          isFormatting: !0,
          copyOnEnter: !0
        });
      }
    }
    class FA extends LA {
      constructor(e) {
        const t = e.locale.t;
        super(e, {
          commandName: TA,
          componentName: TA,
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M4 2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8.38 9.262H7.62L10 5.506l2.38 5.756zm.532 1.285L14.34 16h1.426L10.804 4H9.196L4.234 16H5.66l1.428-3.453h5.824z"/></svg>',
          dropdownLabel: t("Font Background Color")
        });
      }
      static get pluginName() {
        return "FontBackgroundColorUI";
      }
    }
    class jA extends Pr {
      constructor(e) {
        super(e), this._isEnabledBasedOnSelection = !1;
      }
      refresh() {
        const e = this.editor.model,
          t = Go(e.document.selection.getSelectedBlocks());
        this.value = !!t && t.is("element", "paragraph"), this.isEnabled = !!t && HA(t, e.schema);
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document,
          i = e.selection || n.selection;
        t.canEditAt(i) && t.change(e => {
          const n = i.getSelectedBlocks();
          for (const i of n) !i.is("element", "paragraph") && HA(i, t.schema) && e.rename(i, "paragraph");
        });
      }
    }
    function HA(e, t) {
      return t.checkChild(e.parent, "paragraph") && !t.isObject(e);
    }
    class UA extends Pr {
      constructor(e) {
        super(e), this._isEnabledBasedOnSelection = !1;
      }
      execute(e) {
        const t = this.editor.model,
          n = e.attributes;
        let i = e.position;
        t.canEditAt(i) && t.change(e => {
          if (i = this._findPositionToInsertParagraph(i, e), !i) return;
          const o = e.createElement("paragraph");
          n && t.schema.setAllowedAttributes(o, n, e), t.insertContent(o, i), e.setSelection(o, "in");
        });
      }
      _findPositionToInsertParagraph(e, t) {
        const n = this.editor.model;
        if (n.schema.checkChild(e, "paragraph")) return e;
        const i = n.schema.findAllowedParent(e, "paragraph");
        if (!i) return null;
        const o = e.parent,
          r = n.schema.checkChild(o, "$text");
        return o.isEmpty || r && e.isAtEnd ? n.createPositionAfter(o) : !o.isEmpty && r && e.isAtStart ? n.createPositionBefore(o) : t.split(e, i).position;
      }
    }
    class qA extends Br {
      static get pluginName() {
        return "Paragraph";
      }
      init() {
        const e = this.editor,
          t = e.model;
        e.commands.add("paragraph", new jA(e)), e.commands.add("insertParagraph", new UA(e)), t.schema.register("paragraph", {
          inheritAllFrom: "$block"
        }), e.conversion.elementToElement({
          model: "paragraph",
          view: "p"
        }), e.conversion.for("upcast").elementToElement({
          model: (e, _ref92) => {
            let {
              writer: t
            } = _ref92;
            return qA.paragraphLikeElements.has(e.name) ? e.isEmpty ? null : t.createElement("paragraph") : null;
          },
          view: /.+/,
          converterPriority: "low"
        });
      }
    }
    qA.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
    const GA = qA;
    class KA extends Pr {
      constructor(e, t) {
        super(e), this.modelElements = t;
      }
      refresh() {
        const e = Go(this.editor.model.document.selection.getSelectedBlocks());
        this.value = !!e && this.modelElements.includes(e.name) && e.name, this.isEnabled = !!e && this.modelElements.some(t => WA(e, t, this.editor.model.schema));
      }
      execute(e) {
        const t = this.editor.model,
          n = t.document,
          i = e.value;
        t.change(e => {
          const o = Array.from(n.selection.getSelectedBlocks()).filter(e => WA(e, i, t.schema));
          for (const t of o) t.is("element", i) || e.rename(t, i);
        });
      }
    }
    function WA(e, t, n) {
      return n.checkChild(e.parent, t) && !n.isObject(e);
    }
    const YA = "paragraph";
    class $A extends Br {
      static get pluginName() {
        return "HeadingEditing";
      }
      constructor(e) {
        super(e), e.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
      }
      static get requires() {
        return [GA];
      }
      init() {
        const e = this.editor,
          t = e.config.get("heading.options"),
          n = [];
        for (const i of t) "paragraph" !== i.model && (e.model.schema.register(i.model, {
          inheritAllFrom: "$block"
        }), e.conversion.elementToElement(i), n.push(i.model));
        this._addDefaultH1Conversion(e), e.commands.add("heading", new KA(e, n));
      }
      afterInit() {
        const e = this.editor,
          t = e.commands.get("enter"),
          n = e.config.get("heading.options");
        t && this.listenTo(t, "afterExecute", (t, i) => {
          const o = e.model.document.selection.getFirstPosition().parent;
          n.some(e => o.is("element", e.model)) && !o.is("element", YA) && 0 === o.childCount && i.writer.rename(o, YA);
        });
      }
      _addDefaultH1Conversion(e) {
        e.conversion.for("upcast").elementToElement({
          model: "heading1",
          view: "h1",
          converterPriority: f.low + 1
        });
      }
    }
    var ZA = o(7408),
      QA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(ZA.A, QA);
    ZA.A.locals;
    class JA extends Br {
      static get pluginName() {
        return "HeadingUI";
      }
      init() {
        const e = this.editor,
          t = e.t,
          n = function (e) {
            const t = e.t,
              n = {
                Paragraph: t("Paragraph"),
                "Heading 1": t("Heading 1"),
                "Heading 2": t("Heading 2"),
                "Heading 3": t("Heading 3"),
                "Heading 4": t("Heading 4"),
                "Heading 5": t("Heading 5"),
                "Heading 6": t("Heading 6")
              };
            return e.config.get("heading.options").map(e => {
              const t = n[e.title];
              return t && t != e.title && (e.title = t), e;
            });
          }(e),
          i = t("Choose heading"),
          o = t("Heading");
        e.ui.componentFactory.add("heading", t => {
          const r = {},
            s = new qo(),
            a = e.commands.get("heading"),
            l = e.commands.get("paragraph"),
            c = [a];
          for (const e of n) {
            const t = {
              type: "button",
              model: new Pf({
                label: e.title,
                class: e.class,
                role: "menuitemradio",
                withText: !0
              })
            };
            "paragraph" === e.model ? (t.model.bind("isOn").to(l, "value"), t.model.set("commandName", "paragraph"), c.push(l)) : (t.model.bind("isOn").to(a, "value", t => t === e.model), t.model.set({
              commandName: "heading",
              commandValue: e.model
            })), s.add(t), r[e.model] = e.title;
          }
          const d = yp(t);
          return Sp(d, s, {
            ariaLabel: o,
            role: "menu"
          }), d.buttonView.set({
            ariaLabel: o,
            ariaLabelledBy: void 0,
            isOn: !1,
            withText: !0,
            tooltip: o
          }), d.extendTemplate({
            attributes: {
              class: ["ck-heading-dropdown"]
            }
          }), d.bind("isEnabled").toMany(c, "isEnabled", function () {
            for (var _len33 = arguments.length, e = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
              e[_key33] = arguments[_key33];
            }
            return e.some(e => e);
          }), d.buttonView.bind("label").to(a, "value", l, "value", (e, t) => {
            const n = t ? "paragraph" : e;
            return "boolean" == typeof n ? i : r[n] ? r[n] : i;
          }), d.buttonView.bind("ariaLabel").to(a, "value", l, "value", (e, t) => {
            const n = t ? "paragraph" : e;
            return "boolean" == typeof n ? o : r[n] ? "".concat(r[n], ", ").concat(o) : o;
          }), this.listenTo(d, "execute", t => {
            const {
              commandName: n,
              commandValue: i
            } = t.source;
            e.execute(n, i ? {
              value: i
            } : void 0), e.editing.view.focus();
          }), d;
        }), e.ui.componentFactory.add("menuBar:heading", i => {
          const o = new Fk(i),
            r = e.commands.get("heading"),
            s = e.commands.get("paragraph"),
            a = [r],
            l = new jk(i);
          o.set({
            class: "ck-heading-dropdown"
          }), l.set({
            ariaLabel: t("Heading"),
            role: "menu"
          }), o.buttonView.set({
            label: t("Heading")
          }), o.panelView.children.add(l);
          for (const t of n) {
            const n = new kk(i, o),
              c = new qk(i);
            n.children.add(c), l.items.add(n), c.set({
              label: t.title,
              role: "menuitemradio",
              class: t.class
            }), c.bind("ariaChecked").to(c, "isOn"), c.delegate("execute").to(o), c.on("execute", () => {
              const n = "paragraph" === t.model ? "paragraph" : "heading";
              e.execute(n, {
                value: t.model
              }), e.editing.view.focus();
            }), "paragraph" === t.model ? (c.bind("isOn").to(s, "value"), a.push(s)) : c.bind("isOn").to(r, "value", e => e === t.model);
          }
          return o.bind("isEnabled").toMany(a, "isEnabled", function () {
            for (var _len34 = arguments.length, e = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
              e[_key34] = arguments[_key34];
            }
            return e.some(e => e);
          }), o;
        });
      }
    }
    new Set(["paragraph", "heading1", "heading2", "heading3", "heading4", "heading5", "heading6"]);
    class XA extends Pr {
      refresh() {
        const e = this.editor.model,
          t = e.schema,
          n = e.document.selection;
        this.isEnabled = function (e, t, n) {
          const i = function (e, t) {
            const n = Sw(e, t),
              i = n.start.parent;
            if (i.isEmpty && !i.is("element", "$root")) return i.parent;
            return i;
          }(e, n);
          return t.checkChild(i, "horizontalLine");
        }(n, t, e);
      }
      execute() {
        const e = this.editor.model;
        e.change(t => {
          const n = t.createElement("horizontalLine");
          e.insertObject(n, null, null, {
            setSelection: "after"
          });
        });
      }
    }
    var ev = o(5569),
      tv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(ev.A, tv);
    ev.A.locals;
    class nv extends Br {
      static get pluginName() {
        return "HorizontalLineEditing";
      }
      init() {
        const e = this.editor,
          t = e.model.schema,
          n = e.t,
          i = e.conversion;
        t.register("horizontalLine", {
          inheritAllFrom: "$blockObject"
        }), i.for("dataDowncast").elementToElement({
          model: "horizontalLine",
          view: (e, _ref93) => {
            let {
              writer: t
            } = _ref93;
            return t.createEmptyElement("hr");
          }
        }), i.for("editingDowncast").elementToStructure({
          model: "horizontalLine",
          view: (e, _ref94) => {
            let {
              writer: t
            } = _ref94;
            const i = n("Horizontal line"),
              o = t.createContainerElement("div", null, t.createEmptyElement("hr"));
            return t.addClass("ck-horizontal-line", o), t.setCustomProperty("hr", !0, o), function (e, t, n) {
              return t.setCustomProperty("horizontalLine", !0, e), vw(e, t, {
                label: n
              });
            }(o, t, i);
          }
        }), i.for("upcast").elementToElement({
          view: "hr",
          model: "horizontalLine"
        }), e.commands.add("horizontalLine", new XA(e));
      }
    }
    class iv extends Br {
      static get pluginName() {
        return "HorizontalLineUI";
      }
      init() {
        const e = this.editor;
        e.ui.componentFactory.add("horizontalLine", () => {
          const e = this._createButton(um);
          return e.set({
            tooltip: !0
          }), e;
        }), e.ui.componentFactory.add("menuBar:horizontalLine", () => this._createButton(qk));
      }
      _createButton(e) {
        const t = this.editor,
          n = t.locale,
          i = t.commands.get("horizontalLine"),
          o = new e(t.locale),
          r = n.t;
        return o.set({
          label: r("Horizontal line"),
          icon: Wh.horizontalLine
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          t.execute("horizontalLine"), t.editing.view.focus();
        }), o;
      }
    }
    const ov = function (e, t, n, i) {
      var o = -1,
        r = null == e ? 0 : e.length;
      for (i && r && (n = e[++o]); ++o < r;) n = t(n, e[o], o, e);
      return n;
    };
    const rv = ok({
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    });
    var sv = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
      av = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
    const lv = function (e) {
      return (e = _s(e)) && e.replace(sv, rv).replace(av, "");
    };
    var cv = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    const dv = function (e) {
      return e.match(cv) || [];
    };
    var uv = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    const hv = function (e) {
      return uv.test(e);
    };
    var mv = "\\ud800-\\udfff",
      pv = "\\u2700-\\u27bf",
      gv = "a-z\\xdf-\\xf6\\xf8-\\xff",
      fv = "A-Z\\xc0-\\xd6\\xd8-\\xde",
      kv = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
      bv = "[" + kv + "]",
      _v = "\\d+",
      wv = "[" + pv + "]",
      Av = "[" + gv + "]",
      vv = "[^" + mv + kv + _v + pv + gv + fv + "]",
      Cv = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      yv = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      xv = "[" + fv + "]",
      Ev = "(?:" + Av + "|" + vv + ")",
      Sv = "(?:" + xv + "|" + vv + ")",
      Dv = "(?:['’](?:d|ll|m|re|s|t|ve))?",
      Tv = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
      Iv = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
      Bv = "[\\ufe0e\\ufe0f]?",
      Mv = Bv + Iv + ("(?:\\u200d(?:" + ["[^" + mv + "]", Cv, yv].join("|") + ")" + Bv + Iv + ")*"),
      Pv = "(?:" + [wv, Cv, yv].join("|") + ")" + Mv,
      zv = RegExp([xv + "?" + Av + "+" + Dv + "(?=" + [bv, xv, "$"].join("|") + ")", Sv + "+" + Tv + "(?=" + [bv, xv + Ev, "$"].join("|") + ")", xv + "?" + Ev + "+" + Dv, xv + "+" + Tv, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", _v, Pv].join("|"), "g");
    const Nv = function (e) {
      return e.match(zv) || [];
    };
    const Lv = function (e, t, n) {
      return e = _s(e), void 0 === (t = n ? void 0 : t) ? hv(e) ? Nv(e) : dv(e) : e.match(t) || [];
    };
    var Rv = RegExp("['’]", "g");
    const Vv = function (e) {
      return function (t) {
        return ov(Lv(lv(t).replace(Rv, "")), e, "");
      };
    };
    const Ov = function (e, t, n) {
      var i = e.length;
      return n = void 0 === n ? i : n, !t && n >= i ? e : ys(e, t, n);
    };
    var Fv = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    const jv = function (e) {
      return Fv.test(e);
    };
    const Hv = function (e) {
      return e.split("");
    };
    var Uv = "\\ud800-\\udfff",
      qv = "[" + Uv + "]",
      Gv = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      Kv = "\\ud83c[\\udffb-\\udfff]",
      Wv = "[^" + Uv + "]",
      Yv = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      $v = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      Zv = "(?:" + Gv + "|" + Kv + ")" + "?",
      Qv = "[\\ufe0e\\ufe0f]?",
      Jv = Qv + Zv + ("(?:\\u200d(?:" + [Wv, Yv, $v].join("|") + ")" + Qv + Zv + ")*"),
      Xv = "(?:" + [Wv + Gv + "?", Gv, Yv, $v, qv].join("|") + ")",
      eC = RegExp(Kv + "(?=" + Kv + ")|" + Xv + Jv, "g");
    const tC = function (e) {
      return e.match(eC) || [];
    };
    const nC = function (e) {
      return jv(e) ? tC(e) : Hv(e);
    };
    const iC = function (e) {
      return function (t) {
        t = _s(t);
        var n = jv(t) ? nC(t) : void 0,
          i = n ? n[0] : t.charAt(0),
          o = n ? Ov(n, 1).join("") : t.slice(1);
        return i[e]() + o;
      };
    }("toUpperCase");
    Vv(function (e, t, n) {
      return e + (n ? " " : "") + iC(t);
    });
    Vo(function (e, t, n, i) {
      Eo(e, t, n, i);
    });
    var oC = o(2323),
      rC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(oC.A, rC);
    oC.A.locals;
    class sC extends Td {
      toView(e) {
        if (!e.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i)) return super.toView(e);
        let t = "",
          n = "";
        e = (e = e.replace(/<!DOCTYPE[^>]*>/i, e => (t = e, ""))).replace(/<\?xml\s[^?]*\?>/i, e => (n = e, ""));
        const i = this._toDom(e),
          o = this.domConverter.domToView(i, {
            skipComments: this.skipComments
          }),
          r = new Xu(o.document);
        return r.setCustomProperty("$fullPageDocument", i.ownerDocument.documentElement.outerHTML, o), t && r.setCustomProperty("$fullPageDocType", t, o), n && r.setCustomProperty("$fullPageXmlDeclaration", n, o), o;
      }
      toData(e) {
        let t = super.toData(e);
        const n = e.getCustomProperty("$fullPageDocument"),
          i = e.getCustomProperty("$fullPageDocType"),
          o = e.getCustomProperty("$fullPageXmlDeclaration");
        return n && (t = n.replace(/<\/body\s*>/, t + "$&"), i && (t = i + "\n" + t), o && (t = o + "\n" + t)), t;
      }
    }
    function aC(e) {
      return e.createContainerElement("figure", {
        class: "image"
      }, [e.createEmptyElement("img"), e.createSlot("children")]);
    }
    function lC(e, t) {
      const n = e.plugins.get("ImageUtils"),
        i = e.plugins.has("ImageInlineEditing") && e.plugins.has("ImageBlockEditing");
      return e => {
        if (!n.isInlineImageView(e)) return null;
        if (!i) return o(e);
        return ("block" == e.getStyle("display") || e.findAncestor(n.isBlockImageView) ? "imageBlock" : "imageInline") !== t ? null : o(e);
      };
      function o(e) {
        const t = {
          name: !0
        };
        return e.hasAttribute("src") && (t.attributes = ["src"]), t;
      }
    }
    function cC(e, t) {
      const n = Go(t.getSelectedBlocks());
      return !n || e.isObject(n) || n.isEmpty && "listItem" != n.name ? "imageBlock" : "imageInline";
    }
    function dC(e) {
      return e && e.endsWith("px") ? parseInt(e) : null;
    }
    function uC(e) {
      const t = dC(e.getStyle("width")),
        n = dC(e.getStyle("height"));
      return !(!t || !n);
    }
    const hC = /^(image|image-inline)$/;
    class mC extends Br {
      constructor() {
        super(...arguments), this._domEmitter = new (Di())();
      }
      static get pluginName() {
        return "ImageUtils";
      }
      isImage(e) {
        return this.isInlineImage(e) || this.isBlockImage(e);
      }
      isInlineImageView(e) {
        return !!e && e.is("element", "img");
      }
      isBlockImageView(e) {
        return !!e && e.is("element", "figure") && e.hasClass("image");
      }
      insertImage() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const o = this.editor,
          r = o.model,
          s = r.document.selection,
          a = pC(o, t || s, n);
        e = {
          ...Object.fromEntries(s.getAttributes()),
          ...e
        };
        for (const t in e) r.schema.checkAttribute(a, t) || delete e[t];
        return r.change(n => {
          const {
              setImageSizes: o = !0
            } = i,
            s = n.createElement(a, e);
          return r.insertObject(s, t, null, {
            setSelection: "on",
            findOptimalPosition: t || "imageInline" == a ? void 0 : "auto"
          }), s.parent ? (o && this.setImageNaturalSizeAttributes(s), s) : null;
        });
      }
      setImageNaturalSizeAttributes(e) {
        const n = e.getAttribute("src");
        n && (e.getAttribute("width") || e.getAttribute("height") || this.editor.model.change(i => {
          const o = new t.window.Image();
          this._domEmitter.listenTo(o, "load", () => {
            e.getAttribute("width") || e.getAttribute("height") || this.editor.model.enqueueChange(i.batch, t => {
              t.setAttribute("width", o.naturalWidth, e), t.setAttribute("height", o.naturalHeight, e);
            }), this._domEmitter.stopListening(o, "load");
          }), o.src = n;
        }));
      }
      getClosestSelectedImageWidget(e) {
        const t = e.getFirstPosition();
        if (!t) return null;
        const n = e.getSelectedElement();
        if (n && this.isImageWidget(n)) return n;
        let i = t.parent;
        for (; i;) {
          if (i.is("element") && this.isImageWidget(i)) return i;
          i = i.parent;
        }
        return null;
      }
      getClosestSelectedImageElement(e) {
        const t = e.getSelectedElement();
        return this.isImage(t) ? t : e.getFirstPosition().findAncestor("imageBlock");
      }
      getImageWidgetFromImageView(e) {
        return e.findAncestor({
          classes: hC
        });
      }
      isImageAllowed() {
        const e = this.editor.model.document.selection;
        return function (e, t) {
          const n = pC(e, t, null);
          if ("imageBlock" == n) {
            const n = function (e, t) {
              const n = Sw(e, t),
                i = n.start.parent;
              if (i.isEmpty && !i.is("element", "$root")) return i.parent;
              return i;
            }(t, e.model);
            if (e.model.schema.checkChild(n, "imageBlock")) return !0;
          } else if (e.model.schema.checkChild(t.focus, "imageInline")) return !0;
          return !1;
        }(this.editor, e) && function (e) {
          return [...e.focus.getAncestors()].every(e => !e.is("element", "imageBlock"));
        }(e);
      }
      toImageWidget(e, t, n) {
        t.setCustomProperty("image", !0, e);
        return vw(e, t, {
          label: () => {
            const t = this.findViewImgElement(e).getAttribute("alt");
            return t ? "".concat(t, " ").concat(n) : n;
          }
        });
      }
      isImageWidget(e) {
        return !!e.getCustomProperty("image") && Aw(e);
      }
      isBlockImage(e) {
        return !!e && e.is("element", "imageBlock");
      }
      isInlineImage(e) {
        return !!e && e.is("element", "imageInline");
      }
      findViewImgElement(e) {
        if (this.isInlineImageView(e)) return e;
        const t = this.editor.editing.view;
        for (const {
          item: n
        } of t.createRangeIn(e)) if (this.isInlineImageView(n)) return n;
      }
      destroy() {
        return this._domEmitter.stopListening(), super.destroy();
      }
    }
    function pC(e, t, n) {
      const i = e.model.schema,
        o = e.config.get("image.insert.type");
      return e.plugins.has("ImageBlockEditing") ? e.plugins.has("ImageInlineEditing") ? n || ("inline" === o ? "imageInline" : "auto" !== o ? "imageBlock" : t.is("selection") ? cC(i, t) : i.checkChild(t, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
    }
    new RegExp(String(/^(http(s)?:\/\/)?[\w-]+\.[\w.~:/[\]@!$&'()*+,;=%-]+/.source + /\.(jpg|jpeg|png|gif|ico|webp|JPG|JPEG|PNG|GIF|ICO|WEBP)/.source + /(\?[\w.~:/[\]@!$&'()*+,;=%-]*)?/.source + /(#[\w.~:/[\]@!$&'()*+,;=%-]*)?$/.source));
    class gC extends Pr {
      refresh() {
        const e = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!e, this.isEnabled && e.hasAttribute("alt") ? this.value = e.getAttribute("alt") : this.value = !1;
      }
      execute(e) {
        const t = this.editor,
          n = t.plugins.get("ImageUtils"),
          i = t.model,
          o = n.getClosestSelectedImageElement(i.document.selection);
        i.change(t => {
          t.setAttribute("alt", e.newValue, o);
        });
      }
    }
    class fC extends Br {
      static get requires() {
        return [mC];
      }
      static get pluginName() {
        return "ImageTextAlternativeEditing";
      }
      init() {
        this.editor.commands.add("imageTextAlternative", new gC(this.editor));
      }
    }
    var kC = o(3644),
      bC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(kC.A, bC);
    kC.A.locals;
    var _C = o(7817),
      wC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(_C.A, wC);
    _C.A.locals;
    class AC extends Er {
      constructor(e) {
        super(e);
        const t = this.locale.t;
        this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.labeledInput = this._createLabeledInputView(), this.saveButtonView = this._createButton(t("Save"), Wh.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(t("Cancel"), Wh.cancel, "ck-button-cancel", "cancel"), this._focusables = new er(), this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.labeledInput, this.saveButtonView, this.cancelButtonView]
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element), Tr({
          view: this
        }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(e => {
          this._focusables.add(e), this.focusTracker.add(e.element);
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createButton(e, t, n, i) {
        const o = new um(this.locale);
        return o.set({
          label: e,
          icon: t,
          tooltip: !0
        }), o.extendTemplate({
          attributes: {
            class: n
          }
        }), i && o.delegate("execute").to(this, i), o;
      }
      _createLabeledInputView() {
        const e = this.locale.t,
          t = new Rm(this.locale, Bp);
        return t.label = e("Text alternative"), t;
      }
    }
    function vC(e) {
      const t = e.editing.view,
        n = Xg.defaultPositions,
        i = e.plugins.get("ImageUtils");
      return {
        target: t.domConverter.mapViewToDom(i.getClosestSelectedImageWidget(t.document.selection)),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast, n.viewportStickyNorth]
      };
    }
    class CC extends Br {
      static get requires() {
        return [Of];
      }
      static get pluginName() {
        return "ImageTextAlternativeUI";
      }
      init() {
        this._createButton();
      }
      destroy() {
        super.destroy(), this._form && this._form.destroy();
      }
      _createButton() {
        const e = this.editor,
          t = e.t;
        e.ui.componentFactory.add("imageTextAlternative", n => {
          const i = e.commands.get("imageTextAlternative"),
            o = new um(n);
          return o.set({
            label: t("Change image text alternative"),
            icon: Wh.textAlternative,
            tooltip: !0
          }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", e => !!e), this.listenTo(o, "execute", () => {
            this._showForm();
          }), o;
        });
      }
      _createForm() {
        const e = this.editor,
          t = e.editing.view.document,
          n = e.plugins.get("ImageUtils");
        this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new (Dr(AC))(e.locale), this._form.render(), this.listenTo(this._form, "submit", () => {
          e.execute("imageTextAlternative", {
            newValue: this._form.labeledInput.fieldView.element.value
          }), this._hideForm(!0);
        }), this.listenTo(this._form, "cancel", () => {
          this._hideForm(!0);
        }), this._form.keystrokes.set("Esc", (e, t) => {
          this._hideForm(!0), t();
        }), this.listenTo(e.ui, "update", () => {
          n.getClosestSelectedImageWidget(t.selection) ? this._isVisible && function (e) {
            const t = e.plugins.get("ContextualBalloon");
            if (e.plugins.get("ImageUtils").getClosestSelectedImageWidget(e.editing.view.document.selection)) {
              const n = vC(e);
              t.updatePosition(n);
            }
          }(e) : this._hideForm(!0);
        }), Sr({
          emitter: this._form,
          activator: () => this._isVisible,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideForm()
        });
      }
      _showForm() {
        if (this._isVisible) return;
        this._form || this._createForm();
        const e = this.editor,
          t = e.commands.get("imageTextAlternative"),
          n = this._form.labeledInput;
        this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({
          view: this._form,
          position: vC(e)
        }), n.fieldView.value = n.fieldView.element.value = t.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
      }
      _hideForm() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), e && this.editor.editing.view.focus());
      }
      get _isVisible() {
        return !!this._balloon && this._balloon.visibleView === this._form;
      }
      get _isInBalloon() {
        return !!this._balloon && this._balloon.hasView(this._form);
      }
    }
    class yC extends Br {
      static get requires() {
        return [fC, CC];
      }
      static get pluginName() {
        return "ImageTextAlternative";
      }
    }
    function xC(e, t) {
      const n = (t, n, i) => {
        if (!i.consumable.consume(n.item, t.name)) return;
        const o = i.writer,
          r = i.mapper.toViewElement(n.item),
          s = e.findViewImgElement(r);
        null === n.attributeNewValue ? (o.removeAttribute("srcset", s), o.removeAttribute("sizes", s)) : n.attributeNewValue && (o.setAttribute("srcset", n.attributeNewValue, s), o.setAttribute("sizes", "100vw", s));
      };
      return e => {
        e.on("attribute:srcset:".concat(t), n);
      };
    }
    function EC(e, t, n) {
      const i = (t, n, i) => {
        if (!i.consumable.consume(n.item, t.name)) return;
        const o = i.writer,
          r = i.mapper.toViewElement(n.item),
          s = e.findViewImgElement(r);
        o.setAttribute(n.attributeKey, n.attributeNewValue || "", s);
      };
      return e => {
        e.on("attribute:".concat(n, ":").concat(t), i);
      };
    }
    class SC extends Ja {
      observe(e) {
        this.listenTo(e, "load", (e, t) => {
          const n = t.target;
          this.checkShouldIgnoreEventFromTarget(n) || "IMG" == n.tagName && this._fireEvents(t);
        }, {
          useCapture: !0
        });
      }
      stopObserving(e) {
        this.stopListening(e);
      }
      _fireEvents(e) {
        this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", e));
      }
    }
    class DC extends Pr {
      constructor(e) {
        super(e);
        const t = e.config.get("image.insert.type");
        e.plugins.has("ImageBlockEditing") || "block" === t && w("image-block-plugin-required"), e.plugins.has("ImageInlineEditing") || "inline" === t && w("image-inline-plugin-required");
      }
      refresh() {
        const e = this.editor.plugins.get("ImageUtils");
        this.isEnabled = e.isImageAllowed();
      }
      execute(e) {
        const t = _o(e.source),
          n = this.editor.model.document.selection,
          i = this.editor.plugins.get("ImageUtils"),
          o = Object.fromEntries(n.getAttributes());
        t.forEach((e, t) => {
          const r = n.getSelectedElement();
          if ("string" == typeof e && (e = {
            src: e
          }), t && r && i.isImage(r)) {
            const t = this.editor.model.createPositionAfter(r);
            i.insertImage({
              ...e,
              ...o
            }, t);
          } else i.insertImage({
            ...e,
            ...o
          });
        });
      }
    }
    class TC extends Pr {
      constructor(e) {
        super(e), this.decorate("cleanupImage");
      }
      refresh() {
        const e = this.editor.plugins.get("ImageUtils"),
          t = this.editor.model.document.selection.getSelectedElement();
        this.isEnabled = e.isImage(t), this.value = this.isEnabled ? t.getAttribute("src") : null;
      }
      execute(e) {
        const t = this.editor.model.document.selection.getSelectedElement(),
          n = this.editor.plugins.get("ImageUtils");
        this.editor.model.change(i => {
          i.setAttribute("src", e.source, t), this.cleanupImage(i, t), n.setImageNaturalSizeAttributes(t);
        });
      }
      cleanupImage(e, t) {
        e.removeAttribute("srcset", t), e.removeAttribute("sizes", t), e.removeAttribute("sources", t), e.removeAttribute("width", t), e.removeAttribute("height", t), e.removeAttribute("alt", t);
      }
    }
    class IC extends Br {
      static get requires() {
        return [mC];
      }
      static get pluginName() {
        return "ImageEditing";
      }
      init() {
        const e = this.editor,
          t = e.conversion;
        e.editing.view.addObserver(SC), t.for("upcast").attributeToAttribute({
          view: {
            name: "img",
            key: "alt"
          },
          model: "alt"
        }).attributeToAttribute({
          view: {
            name: "img",
            key: "srcset"
          },
          model: "srcset"
        });
        const n = new DC(e),
          i = new TC(e);
        e.commands.add("insertImage", n), e.commands.add("replaceImageSource", i), e.commands.add("imageInsert", n);
      }
    }
    class BC extends Br {
      static get requires() {
        return [mC];
      }
      static get pluginName() {
        return "ImageSizeAttributes";
      }
      afterInit() {
        this._registerSchema(), this._registerConverters("imageBlock"), this._registerConverters("imageInline");
      }
      _registerSchema() {
        this.editor.plugins.has("ImageBlockEditing") && this.editor.model.schema.extend("imageBlock", {
          allowAttributes: ["width", "height"]
        }), this.editor.plugins.has("ImageInlineEditing") && this.editor.model.schema.extend("imageInline", {
          allowAttributes: ["width", "height"]
        });
      }
      _registerConverters(e) {
        const t = this.editor,
          n = t.plugins.get("ImageUtils"),
          i = "imageBlock" === e ? "figure" : "img";
        function o(t, i, o, r) {
          t.on("attribute:".concat(i, ":").concat(e), (t, i, s) => {
            if (!s.consumable.consume(i.item, t.name)) return;
            const a = s.writer,
              l = s.mapper.toViewElement(i.item),
              c = n.findViewImgElement(l);
            if (null !== i.attributeNewValue ? a.setAttribute(o, i.attributeNewValue, c) : a.removeAttribute(o, c), i.item.hasAttribute("sources")) return;
            const d = i.item.hasAttribute("resizedWidth");
            if ("imageInline" === e && !d && !r) return;
            const u = i.item.getAttribute("width"),
              h = i.item.getAttribute("height");
            u && h && a.setStyle("aspect-ratio", "".concat(u, "/").concat(h), c);
          });
        }
        t.conversion.for("upcast").attributeToAttribute({
          view: {
            name: i,
            styles: {
              width: /.+/
            }
          },
          model: {
            key: "width",
            value: e => uC(e) ? dC(e.getStyle("width")) : null
          }
        }).attributeToAttribute({
          view: {
            name: i,
            key: "width"
          },
          model: "width"
        }).attributeToAttribute({
          view: {
            name: i,
            styles: {
              height: /.+/
            }
          },
          model: {
            key: "height",
            value: e => uC(e) ? dC(e.getStyle("height")) : null
          }
        }).attributeToAttribute({
          view: {
            name: i,
            key: "height"
          },
          model: "height"
        }), t.conversion.for("editingDowncast").add(e => {
          o(e, "width", "width", !0), o(e, "height", "height", !0);
        }), t.conversion.for("dataDowncast").add(e => {
          o(e, "width", "width", !1), o(e, "height", "height", !1);
        });
      }
    }
    class MC extends Pr {
      constructor(e, t) {
        super(e), this._modelElementName = t;
      }
      refresh() {
        const e = this.editor.plugins.get("ImageUtils"),
          t = e.getClosestSelectedImageElement(this.editor.model.document.selection);
        "imageBlock" === this._modelElementName ? this.isEnabled = e.isInlineImage(t) : this.isEnabled = e.isBlockImage(t);
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor,
          n = this.editor.model,
          i = t.plugins.get("ImageUtils"),
          o = i.getClosestSelectedImageElement(n.document.selection),
          r = Object.fromEntries(o.getAttributes());
        return r.src || r.uploadId ? n.change(t => {
          const {
              setImageSizes: s = !0
            } = e,
            a = Array.from(n.markers).filter(e => e.getRange().containsItem(o)),
            l = i.insertImage(r, n.createSelection(o, "on"), this._modelElementName, {
              setImageSizes: s
            });
          if (!l) return null;
          const c = t.createRangeOn(l);
          for (const e of a) {
            const n = e.getRange(),
              i = "$graveyard" != n.root.rootName ? n.getJoined(c, !0) : c;
            t.updateMarker(e, {
              range: i
            });
          }
          return {
            oldElement: o,
            newElement: l
          };
        }) : null;
      }
    }
    var PC = o(9025),
      zC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(PC.A, zC);
    PC.A.locals;
    class NC extends Br {
      static get requires() {
        return [mC];
      }
      static get pluginName() {
        return "ImagePlaceholder";
      }
      afterInit() {
        this._setupSchema(), this._setupConversion(), this._setupLoadListener();
      }
      _setupSchema() {
        const e = this.editor.model.schema;
        e.isRegistered("imageBlock") && e.extend("imageBlock", {
          allowAttributes: ["placeholder"]
        }), e.isRegistered("imageInline") && e.extend("imageInline", {
          allowAttributes: ["placeholder"]
        });
      }
      _setupConversion() {
        const e = this.editor,
          t = e.conversion,
          n = e.plugins.get("ImageUtils");
        t.for("editingDowncast").add(e => {
          e.on("attribute:placeholder", (e, t, i) => {
            if (!i.consumable.test(t.item, e.name)) return;
            if (!t.item.is("element", "imageBlock") && !t.item.is("element", "imageInline")) return;
            i.consumable.consume(t.item, e.name);
            const o = i.writer,
              r = i.mapper.toViewElement(t.item),
              s = n.findViewImgElement(r);
            t.attributeNewValue ? (o.addClass("image_placeholder", s), o.setStyle("background-image", "url(".concat(t.attributeNewValue, ")"), s), o.setCustomProperty("editingPipeline:doNotReuseOnce", !0, s)) : (o.removeClass("image_placeholder", s), o.removeStyle("background-image", s));
          });
        });
      }
      _setupLoadListener() {
        const e = this.editor,
          t = e.model,
          n = e.editing,
          i = n.view,
          o = e.plugins.get("ImageUtils");
        i.addObserver(SC), this.listenTo(i.document, "imageLoaded", (e, r) => {
          const s = i.domConverter.mapDomToView(r.target);
          if (!s) return;
          const a = o.getImageWidgetFromImageView(s);
          if (!a) return;
          const l = n.mapper.toModelElement(a);
          l && l.hasAttribute("placeholder") && t.enqueueChange({
            isUndoable: !1
          }, e => {
            e.removeAttribute("placeholder", l);
          });
        });
      }
    }
    class LC extends Br {
      static get requires() {
        return [IC, BC, mC, NC, mw];
      }
      static get pluginName() {
        return "ImageBlockEditing";
      }
      init() {
        const e = this.editor;
        e.model.schema.register("imageBlock", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["alt", "src", "srcset"]
        }), this._setupConversion(), e.plugins.has("ImageInlineEditing") && (e.commands.add("imageTypeBlock", new MC(this.editor, "imageBlock")), this._setupClipboardIntegration());
      }
      _setupConversion() {
        const e = this.editor,
          t = e.t,
          n = e.conversion,
          i = e.plugins.get("ImageUtils");
        n.for("dataDowncast").elementToStructure({
          model: "imageBlock",
          view: (e, _ref95) => {
            let {
              writer: t
            } = _ref95;
            return aC(t);
          }
        }), n.for("editingDowncast").elementToStructure({
          model: "imageBlock",
          view: (e, _ref96) => {
            let {
              writer: n
            } = _ref96;
            return i.toImageWidget(aC(n), n, t("image widget"));
          }
        }), n.for("downcast").add(EC(i, "imageBlock", "src")).add(EC(i, "imageBlock", "alt")).add(xC(i, "imageBlock")), n.for("upcast").elementToElement({
          view: lC(e, "imageBlock"),
          model: (e, _ref97) => {
            let {
              writer: t
            } = _ref97;
            return t.createElement("imageBlock", e.hasAttribute("src") ? {
              src: e.getAttribute("src")
            } : void 0);
          }
        }).add(function (e) {
          const t = (t, n, i) => {
            if (!i.consumable.test(n.viewItem, {
              name: !0,
              classes: "image"
            })) return;
            const o = e.findViewImgElement(n.viewItem);
            if (!o || !i.consumable.test(o, {
              name: !0
            })) return;
            i.consumable.consume(n.viewItem, {
              name: !0,
              classes: "image"
            });
            const r = Go(i.convertItem(o, n.modelCursor).modelRange.getItems());
            r ? (i.convertChildren(n.viewItem, r), i.updateConversionResult(r, n)) : i.consumable.revert(n.viewItem, {
              name: !0,
              classes: "image"
            });
          };
          return e => {
            e.on("element:figure", t);
          };
        }(i));
      }
      _setupClipboardIntegration() {
        const e = this.editor,
          t = e.model,
          n = e.editing.view,
          i = e.plugins.get("ImageUtils"),
          o = e.plugins.get("ClipboardPipeline");
        this.listenTo(o, "inputTransformation", (o, r) => {
          const s = Array.from(r.content.getChildren());
          let a;
          if (!s.every(i.isInlineImageView)) return;
          a = r.targetRanges ? e.editing.mapper.toModelRange(r.targetRanges[0]) : t.document.selection.getFirstRange();
          const l = t.createSelection(a);
          if ("imageBlock" === cC(t.schema, l)) {
            const e = new Xu(n.document),
              t = s.map(t => e.createElement("figure", {
                class: "image"
              }, t));
            r.content = e.createDocumentFragment(t);
          }
        }), this.listenTo(o, "contentInsertion", (e, n) => {
          "paste" === n.method && t.change(e => {
            const t = e.createRangeIn(n.content);
            for (const e of t.getItems()) e.is("element", "imageBlock") && i.setImageNaturalSizeAttributes(e);
          });
        });
      }
    }
    var RC = o(219),
      VC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(RC.A, VC);
    RC.A.locals;
    class OC extends Er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        super(e), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this._focusables = new er(), this.children = this.createCollection(), this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        for (const e of t) this.children.add(e), this._focusables.add(e), e instanceof wm && this._focusables.addMany(e.children);
        if (this._focusables.length > 1) for (const e of this._focusables) FC(e) && (e.focusCycler.on("forwardCycle", e => {
          this._focusCycler.focusNext(), e.stop();
        }), e.focusCycler.on("backwardCycle", e => {
          this._focusCycler.focusPrevious(), e.stop();
        }));
        this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-image-insert-form"],
            tabindex: -1
          },
          children: this.children
        });
      }
      render() {
        super.render(), Tr({
          view: this
        });
        for (const e of this._focusables) this.focusTracker.add(e.element);
        this.keystrokes.listenTo(this.element);
        const e = e => e.stopPropagation();
        this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
    }
    function FC(e) {
      return "focusCycler" in e;
    }
    class jC extends Br {
      static get pluginName() {
        return "ImageInsertUI";
      }
      static get requires() {
        return [mC];
      }
      constructor(e) {
        super(e), this._integrations = new Map(), e.config.define("image.insert.integrations", ["upload", "assetManager", "url"]);
      }
      init() {
        const e = this.editor,
          t = e.model.document.selection,
          n = e.plugins.get("ImageUtils");
        this.set("isImageSelected", !1), this.listenTo(e.model.document, "change", () => {
          this.isImageSelected = n.isImage(t.getSelectedElement());
        });
        const i = e => this._createToolbarComponent(e);
        e.ui.componentFactory.add("insertImage", i), e.ui.componentFactory.add("imageInsert", i);
      }
      registerIntegration(_ref98) {
        let {
          name: e,
          observable: t,
          buttonViewCreator: n,
          formViewCreator: i,
          requiresForm: o
        } = _ref98;
        this._integrations.has(e) && w("image-insert-integration-exists", {
          name: e
        }), this._integrations.set(e, {
          observable: t,
          buttonViewCreator: n,
          formViewCreator: i,
          requiresForm: !!o
        });
      }
      _createToolbarComponent(e) {
        const t = this.editor,
          n = e.t,
          i = this._prepareIntegrations();
        if (!i.length) return null;
        let o;
        const r = i[0];
        if (1 == i.length) {
          if (!r.requiresForm) return r.buttonViewCreator(!0);
          o = r.buttonViewCreator(!0);
        } else {
          const t = r.buttonViewCreator(!1);
          o = new _p(e, t), o.tooltip = !0, o.bind("label").to(this, "isImageSelected", e => n(e ? "Replace image" : "Insert image"));
        }
        const s = this.dropdownView = yp(e, o),
          a = i.map(_ref99 => {
            let {
              observable: e
            } = _ref99;
            return "function" == typeof e ? e() : e;
          });
        return s.bind("isEnabled").toMany(a, "isEnabled", function () {
          for (var _len35 = arguments.length, e = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
            e[_key35] = arguments[_key35];
          }
          return e.some(e => e);
        }), s.once("change:isOpen", () => {
          const e = i.map(_ref100 => {
              let {
                formViewCreator: e
              } = _ref100;
              return e(1 == i.length);
            }),
            n = new OC(t.locale, e);
          s.panelView.children.add(n);
        }), s;
      }
      _prepareIntegrations() {
        const e = this.editor.config.get("image.insert.integrations"),
          t = [];
        if (!e.length) return w("image-insert-integrations-not-specified"), t;
        for (const n of e) this._integrations.has(n) ? t.push(this._integrations.get(n)) : ["upload", "assetManager", "url"].includes(n) || w("image-insert-unknown-integration", {
          item: n
        });
        return t.length || w("image-insert-integrations-not-registered"), t;
      }
    }
    var HC = o(1468),
      UC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(HC.A, UC);
    HC.A.locals;
    class qC extends Br {
      static get requires() {
        return [LC, Uw, yC, jC];
      }
      static get pluginName() {
        return "ImageBlock";
      }
    }
    class GC extends Br {
      static get requires() {
        return [IC, BC, mC, NC, mw];
      }
      static get pluginName() {
        return "ImageInlineEditing";
      }
      init() {
        const e = this.editor,
          t = e.model.schema;
        t.register("imageInline", {
          inheritAllFrom: "$inlineObject",
          allowAttributes: ["alt", "src", "srcset"]
        }), t.addChildCheck((e, t) => {
          if (e.endsWith("caption") && "imageInline" === t.name) return !1;
        }), this._setupConversion(), e.plugins.has("ImageBlockEditing") && (e.commands.add("imageTypeInline", new MC(this.editor, "imageInline")), this._setupClipboardIntegration());
      }
      _setupConversion() {
        const e = this.editor,
          t = e.t,
          n = e.conversion,
          i = e.plugins.get("ImageUtils");
        n.for("dataDowncast").elementToElement({
          model: "imageInline",
          view: (e, _ref101) => {
            let {
              writer: t
            } = _ref101;
            return t.createEmptyElement("img");
          }
        }), n.for("editingDowncast").elementToStructure({
          model: "imageInline",
          view: (e, _ref102) => {
            let {
              writer: n
            } = _ref102;
            return i.toImageWidget(function (e) {
              return e.createContainerElement("span", {
                class: "image-inline"
              }, e.createEmptyElement("img"));
            }(n), n, t("image widget"));
          }
        }), n.for("downcast").add(EC(i, "imageInline", "src")).add(EC(i, "imageInline", "alt")).add(xC(i, "imageInline")), n.for("upcast").elementToElement({
          view: lC(e, "imageInline"),
          model: (e, _ref103) => {
            let {
              writer: t
            } = _ref103;
            return t.createElement("imageInline", e.hasAttribute("src") ? {
              src: e.getAttribute("src")
            } : void 0);
          }
        });
      }
      _setupClipboardIntegration() {
        const e = this.editor,
          t = e.model,
          n = e.editing.view,
          i = e.plugins.get("ImageUtils"),
          o = e.plugins.get("ClipboardPipeline");
        this.listenTo(o, "inputTransformation", (o, r) => {
          const s = Array.from(r.content.getChildren());
          let a;
          if (!s.every(i.isBlockImageView)) return;
          a = r.targetRanges ? e.editing.mapper.toModelRange(r.targetRanges[0]) : t.document.selection.getFirstRange();
          const l = t.createSelection(a);
          if ("imageInline" === cC(t.schema, l)) {
            const e = new Xu(n.document),
              t = s.map(t => 1 === t.childCount ? (Array.from(t.getAttributes()).forEach(n => e.setAttribute(...n, i.findViewImgElement(t))), t.getChild(0)) : t);
            r.content = e.createDocumentFragment(t);
          }
        }), this.listenTo(o, "contentInsertion", (e, n) => {
          "paste" === n.method && t.change(e => {
            const t = e.createRangeIn(n.content);
            for (const e of t.getItems()) e.is("element", "imageInline") && i.setImageNaturalSizeAttributes(e);
          });
        });
      }
    }
    class KC extends Br {
      static get requires() {
        return [GC, Uw, yC, jC];
      }
      static get pluginName() {
        return "ImageInline";
      }
    }
    class WC extends Br {
      static get pluginName() {
        return "ImageCaptionUtils";
      }
      static get requires() {
        return [mC];
      }
      getCaptionFromImageModelElement(e) {
        for (const t of e.getChildren()) if (t && t.is("element", "caption")) return t;
        return null;
      }
      getCaptionFromModelSelection(e) {
        const t = this.editor.plugins.get("ImageUtils"),
          n = e.getFirstPosition().findAncestor("caption");
        return n && t.isBlockImage(n.parent) ? n : null;
      }
      matchImageCaptionViewElement(e) {
        const t = this.editor.plugins.get("ImageUtils");
        return "figcaption" == e.name && t.isBlockImageView(e.parent) ? {
          name: !0
        } : null;
      }
    }
    class YC extends Pr {
      refresh() {
        const e = this.editor,
          t = e.plugins.get("ImageCaptionUtils"),
          n = e.plugins.get("ImageUtils");
        if (!e.plugins.has(LC)) return this.isEnabled = !1, void (this.value = !1);
        const i = e.model.document.selection,
          o = i.getSelectedElement();
        if (!o) {
          const e = t.getCaptionFromModelSelection(i);
          return this.isEnabled = !!e, void (this.value = !!e);
        }
        this.isEnabled = n.isImage(o), this.isEnabled ? this.value = !!t.getCaptionFromImageModelElement(o) : this.value = !1;
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          focusCaptionOnShow: t
        } = e;
        this.editor.model.change(e => {
          this.value ? this._hideImageCaption(e) : this._showImageCaption(e, t);
        });
      }
      _showImageCaption(e, t) {
        const n = this.editor.model.document.selection,
          i = this.editor.plugins.get("ImageCaptionEditing"),
          o = this.editor.plugins.get("ImageUtils");
        let r = n.getSelectedElement();
        const s = i._getSavedCaption(r);
        o.isInlineImage(r) && (this.editor.execute("imageTypeBlock"), r = n.getSelectedElement());
        const a = s || e.createElement("caption");
        e.append(a, r), t && e.setSelection(a, "in");
      }
      _hideImageCaption(e) {
        const t = this.editor,
          n = t.model.document.selection,
          i = t.plugins.get("ImageCaptionEditing"),
          o = t.plugins.get("ImageCaptionUtils");
        let r,
          s = n.getSelectedElement();
        s ? r = o.getCaptionFromImageModelElement(s) : (r = o.getCaptionFromModelSelection(n), s = r.parent), i._saveCaption(s, r), e.setSelection(s, "on"), e.remove(r);
      }
    }
    class $C extends Br {
      static get requires() {
        return [mC, WC];
      }
      static get pluginName() {
        return "ImageCaptionEditing";
      }
      constructor(e) {
        super(e), this._savedCaptionsMap = new WeakMap();
      }
      init() {
        const e = this.editor,
          t = e.model.schema;
        t.isRegistered("caption") ? t.extend("caption", {
          allowIn: "imageBlock"
        }) : t.register("caption", {
          allowIn: "imageBlock",
          allowContentOf: "$block",
          isLimit: !0
        }), e.commands.add("toggleImageCaption", new YC(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration(), this._registerCaptionReconversion();
      }
      _setupConversion() {
        const e = this.editor,
          t = e.editing.view,
          n = e.plugins.get("ImageUtils"),
          i = e.plugins.get("ImageCaptionUtils"),
          o = e.t;
        e.conversion.for("upcast").elementToElement({
          view: e => i.matchImageCaptionViewElement(e),
          model: "caption"
        }), e.conversion.for("dataDowncast").elementToElement({
          model: "caption",
          view: (e, _ref104) => {
            let {
              writer: t
            } = _ref104;
            return n.isBlockImage(e.parent) ? t.createContainerElement("figcaption") : null;
          }
        }), e.conversion.for("editingDowncast").elementToElement({
          model: "caption",
          view: (e, _ref105) => {
            let {
              writer: i
            } = _ref105;
            if (!n.isBlockImage(e.parent)) return null;
            const r = i.createEditableElement("figcaption");
            i.setCustomProperty("imageCaption", !0, r), r.placeholder = o("Enter image caption"), Ur({
              view: t,
              element: r,
              keepOnFocus: !0
            });
            const s = e.parent.getAttribute("alt");
            return Ew(r, i, {
              label: s ? o("Caption for image: %0", [s]) : o("Caption for the image")
            });
          }
        });
      }
      _setupImageTypeCommandsIntegration() {
        const e = this.editor,
          t = e.plugins.get("ImageUtils"),
          n = e.plugins.get("ImageCaptionUtils"),
          i = e.commands.get("imageTypeInline"),
          o = e.commands.get("imageTypeBlock"),
          r = e => {
            if (!e.return) return;
            const {
              oldElement: i,
              newElement: o
            } = e.return;
            if (!i) return;
            if (t.isBlockImage(i)) {
              const e = n.getCaptionFromImageModelElement(i);
              if (e) return void this._saveCaption(o, e);
            }
            const r = this._getSavedCaption(i);
            r && this._saveCaption(o, r);
          };
        i && this.listenTo(i, "execute", r, {
          priority: "low"
        }), o && this.listenTo(o, "execute", r, {
          priority: "low"
        });
      }
      _getSavedCaption(e) {
        const t = this._savedCaptionsMap.get(e);
        return t ? tc.fromJSON(t) : null;
      }
      _saveCaption(e, t) {
        this._savedCaptionsMap.set(e, t.toJSON());
      }
      _registerCaptionReconversion() {
        const e = this.editor,
          t = e.model,
          n = e.plugins.get("ImageUtils"),
          i = e.plugins.get("ImageCaptionUtils");
        t.document.on("change:data", () => {
          const o = t.document.differ.getChanges();
          for (const t of o) {
            if ("alt" !== t.attributeKey) continue;
            const o = t.range.start.nodeAfter;
            if (n.isBlockImage(o)) {
              const t = i.getCaptionFromImageModelElement(o);
              if (!t) return;
              e.editing.reconvertItem(t);
            }
          }
        });
      }
    }
    class ZC extends Br {
      static get requires() {
        return [WC];
      }
      static get pluginName() {
        return "ImageCaptionUI";
      }
      init() {
        const e = this.editor,
          t = e.editing.view,
          n = e.plugins.get("ImageCaptionUtils"),
          i = e.t;
        e.ui.componentFactory.add("toggleImageCaption", o => {
          const r = e.commands.get("toggleImageCaption"),
            s = new um(o);
          return s.set({
            icon: Wh.caption,
            tooltip: !0,
            isToggleable: !0
          }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.bind("label").to(r, "value", e => i(e ? "Toggle caption off" : "Toggle caption on")), this.listenTo(s, "execute", () => {
            e.execute("toggleImageCaption", {
              focusCaptionOnShow: !0
            });
            const i = n.getCaptionFromModelSelection(e.model.document.selection);
            if (i) {
              const n = e.editing.mapper.toViewElement(i);
              t.scrollToTheSelection(), t.change(e => {
                e.addClass("image__caption_highlighted", n);
              });
            }
            e.editing.view.focus();
          }), s;
        });
      }
    }
    var QC = o(5212),
      JC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(QC.A, JC);
    QC.A.locals;
    function XC(e) {
      const t = e.map(e => e.replace("+", "\\+"));
      return new RegExp("^image\\/(".concat(t.join("|"), ")$"));
    }
    function ey(e) {
      return new Promise((n, i) => {
        const o = e.getAttribute("src");
        fetch(o).then(e => e.blob()).then(e => {
          const t = ty(e, o),
            i = t.replace("image/", ""),
            r = new File([e], "image.".concat(i), {
              type: t
            });
          n(r);
        }).catch(e => e && "TypeError" === e.name ? function (e) {
          return function (e) {
            return new Promise((n, i) => {
              const o = t.document.createElement("img");
              o.addEventListener("load", () => {
                const e = t.document.createElement("canvas");
                e.width = o.width, e.height = o.height;
                e.getContext("2d").drawImage(o, 0, 0), e.toBlob(e => e ? n(e) : i());
              }), o.addEventListener("error", () => i()), o.src = e;
            });
          }(e).then(t => {
            const n = ty(t, e),
              i = n.replace("image/", "");
            return new File([t], "image.".concat(i), {
              type: n
            });
          });
        }(o).then(n).catch(i) : i(e));
      });
    }
    function ty(e, t) {
      return e.type ? e.type : t.match(/data:(image\/\w+);base64/) ? t.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
    }
    class ny extends Br {
      static get pluginName() {
        return "ImageUploadUI";
      }
      init() {
        const e = this.editor,
          t = e.t,
          n = () => {
            const e = this._createButton(gm);
            return e.set({
              label: t("Upload image from computer"),
              tooltip: !0
            }), e;
          };
        if (e.ui.componentFactory.add("uploadImage", n), e.ui.componentFactory.add("imageUpload", n), e.ui.componentFactory.add("menuBar:uploadImage", () => {
          const e = this._createButton(Gk);
          return e.label = t("Image from computer"), e;
        }), e.plugins.has("ImageInsertUI")) {
          const n = e.plugins.get("ImageInsertUI");
          n.registerIntegration({
            name: "upload",
            observable: () => e.commands.get("uploadImage"),
            buttonViewCreator: () => {
              const i = e.ui.componentFactory.create("uploadImage");
              return i.bind("label").to(n, "isImageSelected", e => t(e ? "Replace image from computer" : "Upload image from computer")), i;
            },
            formViewCreator: () => {
              const i = e.ui.componentFactory.create("uploadImage");
              return i.withText = !0, i.bind("label").to(n, "isImageSelected", e => t(e ? "Replace from computer" : "Upload from computer")), i.on("execute", () => {
                n.dropdownView.isOpen = !1;
              }), i;
            }
          });
        }
      }
      _createButton(e) {
        const t = this.editor,
          n = t.locale,
          i = t.commands.get("uploadImage"),
          o = t.config.get("image.upload.types"),
          r = XC(o),
          s = new e(t.locale),
          a = n.t;
        return s.set({
          acceptedType: o.map(e => "image/".concat(e)).join(","),
          allowMultipleFiles: !0,
          label: a("Upload image from computer"),
          icon: Wh.imageUpload
        }), s.bind("isEnabled").to(i), s.on("done", (e, n) => {
          const i = Array.from(n).filter(e => r.test(e.type));
          i.length && (t.execute("uploadImage", {
            file: i
          }), t.editing.view.focus());
        }), s;
      }
    }
    class iy extends q() {
      constructor() {
        super();
        const e = new window.FileReader();
        this._reader = e, this._data = void 0, this.set("loaded", 0), e.onprogress = e => {
          this.loaded = e.loaded;
        };
      }
      get error() {
        return this._reader.error;
      }
      get data() {
        return this._data;
      }
      read(e) {
        const t = this._reader;
        return this.total = e.size, new Promise((n, i) => {
          t.onload = () => {
            const e = t.result;
            this._data = e, n(e);
          }, t.onerror = () => {
            i("error");
          }, t.onabort = () => {
            i("aborted");
          }, this._reader.readAsDataURL(e);
        });
      }
      abort() {
        this._reader.abort();
      }
    }
    class oy extends Br {
      constructor() {
        super(...arguments), this.loaders = new qo(), this._loadersMap = new Map(), this._pendingAction = null;
      }
      static get pluginName() {
        return "FileRepository";
      }
      static get requires() {
        return [Kh];
      }
      init() {
        this.loaders.on("change", () => this._updatePendingAction()), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (e, t) => t ? e / t * 100 : 0);
      }
      getLoader(e) {
        return this._loadersMap.get(e) || null;
      }
      createLoader(e) {
        if (!this.createUploadAdapter) return w("filerepository-no-upload-adapter"), null;
        const t = new ry(Promise.resolve(e), this.createUploadAdapter);
        return this.loaders.add(t), this._loadersMap.set(e, t), e instanceof Promise && t.file.then(e => {
          this._loadersMap.set(e, t);
        }).catch(() => {}), t.on("change:uploaded", () => {
          let e = 0;
          for (const t of this.loaders) e += t.uploaded;
          this.uploaded = e;
        }), t.on("change:uploadTotal", () => {
          let e = 0;
          for (const t of this.loaders) t.uploadTotal && (e += t.uploadTotal);
          this.uploadTotal = e;
        }), t;
      }
      destroyLoader(e) {
        const t = e instanceof ry ? e : this.getLoader(e);
        t._destroy(), this.loaders.remove(t), this._loadersMap.forEach((e, n) => {
          e === t && this._loadersMap.delete(n);
        });
      }
      _updatePendingAction() {
        const e = this.editor.plugins.get(Kh);
        if (this.loaders.length) {
          if (!this._pendingAction) {
            const t = this.editor.t,
              n = e => "".concat(t("Upload in progress"), " ").concat(parseInt(e), "%.");
            this._pendingAction = e.add(n(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", n);
          }
        } else e.remove(this._pendingAction), this._pendingAction = null;
      }
    }
    class ry extends q() {
      constructor(e, t) {
        super(), this.id = g(), this._filePromiseWrapper = this._createFilePromiseWrapper(e), this._adapter = t(this), this._reader = new iy(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (e, t) => t ? e / t * 100 : 0), this.set("uploadResponse", null);
      }
      get file() {
        return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(e => this._filePromiseWrapper ? e : null) : Promise.resolve(null);
      }
      get data() {
        return this._reader.data;
      }
      read() {
        if ("idle" != this.status) throw new _("filerepository-read-wrong-status", this);
        return this.status = "reading", this.file.then(e => this._reader.read(e)).then(e => {
          if ("reading" !== this.status) throw this.status;
          return this.status = "idle", e;
        }).catch(e => {
          if ("aborted" === e) throw this.status = "aborted", "aborted";
          throw this.status = "error", this._reader.error ? this._reader.error : e;
        });
      }
      upload() {
        if ("idle" != this.status) throw new _("filerepository-upload-wrong-status", this);
        return this.status = "uploading", this.file.then(() => this._adapter.upload()).then(e => (this.uploadResponse = e, this.status = "idle", e)).catch(e => {
          if ("aborted" === this.status) throw "aborted";
          throw this.status = "error", e;
        });
      }
      abort() {
        const e = this.status;
        this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == e ? this._reader.abort() : "uploading" == e && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(() => {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
      }
      _destroy() {
        this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
      }
      _createFilePromiseWrapper(e) {
        const t = {};
        return t.promise = new Promise((n, i) => {
          t.rejecter = i, t.isFulfilled = !1, e.then(e => {
            t.isFulfilled = !0, n(e);
          }).catch(e => {
            t.isFulfilled = !0, i(e);
          });
        }), t;
      }
    }
    class sy {
      constructor(e) {
        this.loader = e;
      }
      upload() {
        return new Promise((e, t) => {
          const n = this.reader = new window.FileReader();
          n.addEventListener("load", () => {
            e({
              default: n.result
            });
          }), n.addEventListener("error", e => {
            t(e);
          }), n.addEventListener("abort", () => {
            t();
          }), this.loader.file.then(e => {
            n.readAsDataURL(e);
          });
        });
      }
      abort() {
        this.reader.abort();
      }
    }
    var ay = o(8034),
      ly = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(ay.A, ly);
    ay.A.locals;
    var cy = o(4484),
      dy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(cy.A, dy);
    cy.A.locals;
    var uy = o(6802),
      hy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(uy.A, hy);
    uy.A.locals;
    class my extends Br {
      static get pluginName() {
        return "ImageUploadProgress";
      }
      constructor(e) {
        super(e), this.uploadStatusChange = (e, t, n) => {
          const i = this.editor,
            o = t.item,
            r = o.getAttribute("uploadId");
          if (!n.consumable.consume(t.item, e.name)) return;
          const s = i.plugins.get("ImageUtils"),
            a = i.plugins.get(oy),
            l = r ? t.attributeNewValue : null,
            c = this.placeholder,
            d = i.editing.mapper.toViewElement(o),
            u = n.writer;
          if ("reading" == l) return py(d, u), void gy(s, c, d, u);
          if ("uploading" == l) {
            const e = a.loaders.get(r);
            return py(d, u), void (e ? (fy(d, u), function (e, t, n, i) {
              const o = function (e) {
                const t = e.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return e.setCustomProperty("progressBar", !0, t), t;
              }(t);
              t.insert(t.createPositionAt(e, "end"), o), n.on("change:uploadedPercent", (e, t, n) => {
                i.change(e => {
                  e.setStyle("width", n + "%", o);
                });
              });
            }(d, u, e, i.editing.view), function (e, t, n, i) {
              if (i.data) {
                const o = e.findViewImgElement(t);
                n.setAttribute("src", i.data, o);
              }
            }(s, d, u, e)) : gy(s, c, d, u));
          }
          "complete" == l && a.loaders.get(r) && function (e, t, n) {
            const i = t.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            t.insert(t.createPositionAt(e, "end"), i), setTimeout(() => {
              n.change(e => e.remove(e.createRangeOn(i)));
            }, 3e3);
          }(d, u, i.editing.view), function (e, t) {
            by(e, t, "progressBar");
          }(d, u), fy(d, u), function (e, t) {
            t.removeClass("ck-appear", e);
          }(d, u);
        }, this.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      }
      init() {
        const e = this.editor;
        e.plugins.has("ImageBlockEditing") && e.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", this.uploadStatusChange), e.plugins.has("ImageInlineEditing") && e.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", this.uploadStatusChange);
      }
    }
    function py(e, t) {
      e.hasClass("ck-appear") || t.addClass("ck-appear", e);
    }
    function gy(e, t, n, i) {
      n.hasClass("ck-image-upload-placeholder") || i.addClass("ck-image-upload-placeholder", n);
      const o = e.findViewImgElement(n);
      o.getAttribute("src") !== t && i.setAttribute("src", t, o), ky(n, "placeholder") || i.insert(i.createPositionAfter(o), function (e) {
        const t = e.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return e.setCustomProperty("placeholder", !0, t), t;
      }(i));
    }
    function fy(e, t) {
      e.hasClass("ck-image-upload-placeholder") && t.removeClass("ck-image-upload-placeholder", e), by(e, t, "placeholder");
    }
    function ky(e, t) {
      for (const n of e.getChildren()) if (n.getCustomProperty(t)) return n;
    }
    function by(e, t, n) {
      const i = ky(e, n);
      i && t.remove(t.createRangeOn(i));
    }
    class _y extends Pr {
      refresh() {
        const e = this.editor,
          t = e.plugins.get("ImageUtils"),
          n = e.model.document.selection.getSelectedElement();
        this.isEnabled = t.isImageAllowed() || t.isImage(n);
      }
      execute(e) {
        const t = _o(e.file),
          n = this.editor.model.document.selection,
          i = this.editor.plugins.get("ImageUtils"),
          o = Object.fromEntries(n.getAttributes());
        t.forEach((e, t) => {
          const r = n.getSelectedElement();
          if (t && r && i.isImage(r)) {
            const t = this.editor.model.createPositionAfter(r);
            this._uploadImage(e, o, t);
          } else this._uploadImage(e, o);
        });
      }
      _uploadImage(e, t, n) {
        const i = this.editor,
          o = i.plugins.get(oy).createLoader(e),
          r = i.plugins.get("ImageUtils");
        o && r.insertImage({
          ...t,
          uploadId: o.id
        }, n);
      }
    }
    class wy extends Br {
      static get requires() {
        return [oy, Mf, mw, mC];
      }
      static get pluginName() {
        return "ImageUploadEditing";
      }
      constructor(e) {
        super(e), e.config.define("image", {
          upload: {
            types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
          }
        }), this._uploadImageElements = new Map();
      }
      init() {
        const e = this.editor,
          t = e.model.document,
          n = e.conversion,
          i = e.plugins.get(oy),
          o = e.plugins.get("ImageUtils"),
          r = e.plugins.get("ClipboardPipeline"),
          s = XC(e.config.get("image.upload.types")),
          a = new _y(e);
        e.commands.add("uploadImage", a), e.commands.add("imageUpload", a), n.for("upcast").attributeToAttribute({
          view: {
            name: "img",
            key: "uploadId"
          },
          model: "uploadId"
        }), this.listenTo(e.editing.view.document, "clipboardInput", (t, n) => {
          if (i = n.dataTransfer, Array.from(i.types).includes("text/html") && "" !== i.getData("text/html")) return;
          var i;
          const o = Array.from(n.dataTransfer.files).filter(e => !!e && s.test(e.type));
          o.length && (t.stop(), e.model.change(t => {
            n.targetRanges && t.setSelection(n.targetRanges.map(t => e.editing.mapper.toModelRange(t))), e.execute("uploadImage", {
              file: o
            });
          }));
        }), this.listenTo(r, "inputTransformation", (t, n) => {
          const r = Array.from(e.editing.view.createRangeIn(n.content)).map(e => e.item).filter(e => function (e, t) {
            return !(!e.isInlineImageView(t) || !t.getAttribute("src") || !t.getAttribute("src").match(/^data:image\/\w+;base64,/g) && !t.getAttribute("src").match(/^blob:/g));
          }(o, e) && !e.getAttribute("uploadProcessed")).map(e => ({
            promise: ey(e),
            imageElement: e
          }));
          if (!r.length) return;
          const s = new Xu(e.editing.view.document);
          for (const e of r) {
            s.setAttribute("uploadProcessed", !0, e.imageElement);
            const t = i.createLoader(e.promise);
            t && (s.setAttribute("src", "", e.imageElement), s.setAttribute("uploadId", t.id, e.imageElement));
          }
        }), e.editing.view.document.on("dragover", (e, t) => {
          t.preventDefault();
        }), t.on("change", () => {
          const n = t.differ.getChanges({
              includeChangesInGraveyard: !0
            }).reverse(),
            o = new Set();
          for (const t of n) if ("insert" == t.type && "$text" != t.name) {
            const n = t.position.nodeAfter,
              r = "$graveyard" == t.position.root.rootName;
            for (const t of Ay(e, n)) {
              const e = t.getAttribute("uploadId");
              if (!e) continue;
              const n = i.loaders.get(e);
              n && (r ? o.has(e) || n.abort() : (o.add(e), this._uploadImageElements.set(e, t), "idle" == n.status && this._readAndUpload(n)));
            }
          }
        }), this.on("uploadComplete", (e, _ref106) => {
          let {
            imageElement: t,
            data: n
          } = _ref106;
          const i = n.urls ? n.urls : n;
          this.editor.model.change(e => {
            e.setAttribute("src", i.default, t), this._parseAndSetSrcsetAttributeOnImage(i, t, e), o.setImageNaturalSizeAttributes(t);
          });
        }, {
          priority: "low"
        });
      }
      afterInit() {
        const e = this.editor.model.schema;
        this.editor.plugins.has("ImageBlockEditing") && e.extend("imageBlock", {
          allowAttributes: ["uploadId", "uploadStatus"]
        }), this.editor.plugins.has("ImageInlineEditing") && e.extend("imageInline", {
          allowAttributes: ["uploadId", "uploadStatus"]
        });
      }
      _readAndUpload(e) {
        const t = this.editor,
          n = t.model,
          i = t.locale.t,
          o = t.plugins.get(oy),
          r = t.plugins.get(Mf),
          a = t.plugins.get("ImageUtils"),
          l = this._uploadImageElements;
        return n.enqueueChange({
          isUndoable: !1
        }, t => {
          t.setAttribute("uploadStatus", "reading", l.get(e.id));
        }), e.read().then(() => {
          const o = e.upload(),
            r = l.get(e.id);
          if (s.isSafari) {
            const e = t.editing.mapper.toViewElement(r),
              n = a.findViewImgElement(e);
            t.editing.view.once("render", () => {
              if (!n.parent) return;
              const e = t.editing.view.domConverter.mapViewToDom(n.parent);
              if (!e) return;
              const i = e.style.display;
              e.style.display = "none", e._ckHack = e.offsetHeight, e.style.display = i;
            });
          }
          return t.ui && t.ui.ariaLiveAnnouncer.announce(i("Uploading image")), n.enqueueChange({
            isUndoable: !1
          }, e => {
            e.setAttribute("uploadStatus", "uploading", r);
          }), o;
        }).then(o => {
          n.enqueueChange({
            isUndoable: !1
          }, n => {
            const r = l.get(e.id);
            n.setAttribute("uploadStatus", "complete", r), t.ui && t.ui.ariaLiveAnnouncer.announce(i("Image upload complete")), this.fire("uploadComplete", {
              data: o,
              imageElement: r
            });
          }), c();
        }).catch(o => {
          if (t.ui && t.ui.ariaLiveAnnouncer.announce(i("Error during image upload")), "error" !== e.status && "aborted" !== e.status) throw o;
          "error" == e.status && o && r.showWarning(o, {
            title: i("Upload failed"),
            namespace: "upload"
          }), n.enqueueChange({
            isUndoable: !1
          }, t => {
            t.remove(l.get(e.id));
          }), c();
        });
        function c() {
          n.enqueueChange({
            isUndoable: !1
          }, t => {
            const n = l.get(e.id);
            t.removeAttribute("uploadId", n), t.removeAttribute("uploadStatus", n), l.delete(e.id);
          }), o.destroyLoader(e);
        }
      }
      _parseAndSetSrcsetAttributeOnImage(e, t, n) {
        let i = 0;
        const o = Object.keys(e).filter(e => {
          const t = parseInt(e, 10);
          if (!isNaN(t)) return i = Math.max(i, t), !0;
        }).map(t => "".concat(e[t], " ").concat(t, "w")).join(", ");
        if ("" != o) {
          const e = {
            srcset: o
          };
          t.hasAttribute("width") || t.hasAttribute("height") || (e.width = i), n.setAttributes(e, t);
        }
      }
    }
    function Ay(e, t) {
      const n = e.plugins.get("ImageUtils");
      return Array.from(e.model.createRangeOn(t)).filter(e => n.isImage(e.item)).map(e => e.item);
    }
    vy = Q_;
    var vy, Cy;
    var yy = o(3111),
      xy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(yy.A, xy);
    yy.A.locals;
    var Ey = o(1240),
      Sy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Ey.A, Sy);
    Ey.A.locals;
    class Dy extends Pr {
      constructor(e, t) {
        super(e), this._defaultStyles = {
          imageBlock: !1,
          imageInline: !1
        }, this._styles = new Map(t.map(e => {
          if (e.isDefault) for (const t of e.modelElements) this._defaultStyles[t] = e.name;
          return [e.name, e];
        }));
      }
      refresh() {
        const e = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!e, this.isEnabled ? e.hasAttribute("imageStyle") ? this.value = e.getAttribute("imageStyle") : this.value = this._defaultStyles[e.name] : this.value = !1;
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor,
          n = t.model,
          i = t.plugins.get("ImageUtils");
        n.change(t => {
          const o = e.value,
            {
              setImageSizes: r = !0
            } = e;
          let s = i.getClosestSelectedImageElement(n.document.selection);
          o && this.shouldConvertImageType(o, s) && (this.editor.execute(i.isBlockImage(s) ? "imageTypeInline" : "imageTypeBlock", {
            setImageSizes: r
          }), s = i.getClosestSelectedImageElement(n.document.selection)), !o || this._styles.get(o).isDefault ? t.removeAttribute("imageStyle", s) : t.setAttribute("imageStyle", o, s), r && i.setImageNaturalSizeAttributes(s);
        });
      }
      shouldConvertImageType(e, t) {
        return !this._styles.get(e).modelElements.includes(t.name);
      }
    }
    const {
        objectFullWidth: Ty,
        objectInline: Iy,
        objectLeft: By,
        objectRight: My,
        objectCenter: Py,
        objectBlockLeft: zy,
        objectBlockRight: Ny
      } = Wh,
      Ly = {
        get inline() {
          return {
            name: "inline",
            title: "In line",
            icon: Iy,
            modelElements: ["imageInline"],
            isDefault: !0
          };
        },
        get alignLeft() {
          return {
            name: "alignLeft",
            title: "Left aligned image",
            icon: By,
            modelElements: ["imageBlock", "imageInline"],
            className: "image-style-align-left"
          };
        },
        get alignBlockLeft() {
          return {
            name: "alignBlockLeft",
            title: "Left aligned image",
            icon: zy,
            modelElements: ["imageBlock"],
            className: "image-style-block-align-left"
          };
        },
        get alignCenter() {
          return {
            name: "alignCenter",
            title: "Centered image",
            icon: Py,
            modelElements: ["imageBlock"],
            className: "image-style-align-center"
          };
        },
        get alignRight() {
          return {
            name: "alignRight",
            title: "Right aligned image",
            icon: My,
            modelElements: ["imageBlock", "imageInline"],
            className: "image-style-align-right"
          };
        },
        get alignBlockRight() {
          return {
            name: "alignBlockRight",
            title: "Right aligned image",
            icon: Ny,
            modelElements: ["imageBlock"],
            className: "image-style-block-align-right"
          };
        },
        get block() {
          return {
            name: "block",
            title: "Centered image",
            icon: Py,
            modelElements: ["imageBlock"],
            isDefault: !0
          };
        },
        get side() {
          return {
            name: "side",
            title: "Side image",
            icon: My,
            modelElements: ["imageBlock"],
            className: "image-style-side"
          };
        }
      },
      Ry = {
        full: Ty,
        left: zy,
        right: Ny,
        center: Py,
        inlineLeft: By,
        inlineRight: My,
        inline: Iy
      },
      Vy = [{
        name: "imageStyle:wrapText",
        title: "Wrap text",
        defaultItem: "imageStyle:alignLeft",
        items: ["imageStyle:alignLeft", "imageStyle:alignRight"]
      }, {
        name: "imageStyle:breakText",
        title: "Break text",
        defaultItem: "imageStyle:block",
        items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"]
      }];
    function Oy(e) {
      w("image-style-configuration-definition-invalid", e);
    }
    const Fy = {
      normalizeStyles: function (e) {
        return (e.configuredStyles.options || []).map(e => function (e) {
          e = "string" == typeof e ? Ly[e] ? {
            ...Ly[e]
          } : {
            name: e
          } : function (e, t) {
            const n = {
              ...t
            };
            for (const i in e) Object.prototype.hasOwnProperty.call(t, i) || (n[i] = e[i]);
            return n;
          }(Ly[e.name], e);
          "string" == typeof e.icon && (e.icon = Ry[e.icon] || e.icon);
          return e;
        }(e)).filter(t => function (e, _ref107) {
          let {
            isBlockPluginLoaded: t,
            isInlinePluginLoaded: n
          } = _ref107;
          const {
            modelElements: i,
            name: o
          } = e;
          if (!(i && i.length && o)) return Oy({
            style: e
          }), !1;
          {
            const o = [t ? "imageBlock" : null, n ? "imageInline" : null];
            if (!i.some(e => o.includes(e))) return w("image-style-missing-dependency", {
              style: e,
              missingPlugins: i.map(e => "imageBlock" === e ? "ImageBlockEditing" : "ImageInlineEditing")
            }), !1;
          }
          return !0;
        }(t, e));
      },
      getDefaultStylesConfiguration: function (e, t) {
        return e && t ? {
          options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"]
        } : e ? {
          options: ["block", "side"]
        } : t ? {
          options: ["inline", "alignLeft", "alignRight"]
        } : {};
      },
      getDefaultDropdownDefinitions: function (e) {
        return e.has("ImageBlockEditing") && e.has("ImageInlineEditing") ? [...Vy] : [];
      },
      warnInvalidStyle: Oy,
      DEFAULT_OPTIONS: Ly,
      DEFAULT_ICONS: Ry,
      DEFAULT_DROPDOWN_DEFINITIONS: Vy
    };
    function jy(e, t) {
      for (const n of t) if (n.name === e) return n;
    }
    class Hy extends Br {
      static get pluginName() {
        return "ImageStyleEditing";
      }
      static get requires() {
        return [mC];
      }
      init() {
        const {
            normalizeStyles: e,
            getDefaultStylesConfiguration: t
          } = Fy,
          n = this.editor,
          i = n.plugins.has("ImageBlockEditing"),
          o = n.plugins.has("ImageInlineEditing");
        n.config.define("image.styles", t(i, o)), this.normalizedStyles = e({
          configuredStyles: n.config.get("image.styles"),
          isBlockPluginLoaded: i,
          isInlinePluginLoaded: o
        }), this._setupConversion(i, o), this._setupPostFixer(), n.commands.add("imageStyle", new Dy(n, this.normalizedStyles));
      }
      _setupConversion(e, t) {
        const n = this.editor,
          i = n.model.schema,
          o = (r = this.normalizedStyles, (e, t, n) => {
            if (!n.consumable.consume(t.item, e.name)) return;
            const i = jy(t.attributeNewValue, r),
              o = jy(t.attributeOldValue, r),
              s = n.mapper.toViewElement(t.item),
              a = n.writer;
            o && a.removeClass(o.className, s), i && a.addClass(i.className, s);
          });
        var r;
        const s = function (e) {
          const t = {
            imageInline: e.filter(e => !e.isDefault && e.modelElements.includes("imageInline")),
            imageBlock: e.filter(e => !e.isDefault && e.modelElements.includes("imageBlock"))
          };
          return (e, n, i) => {
            if (!n.modelRange) return;
            const o = n.viewItem,
              r = Go(n.modelRange.getItems());
            if (r && i.schema.checkAttribute(r, "imageStyle")) for (const e of t[r.name]) i.consumable.consume(o, {
              classes: e.className
            }) && i.writer.setAttribute("imageStyle", e.name, r);
          };
        }(this.normalizedStyles);
        n.editing.downcastDispatcher.on("attribute:imageStyle", o), n.data.downcastDispatcher.on("attribute:imageStyle", o), e && (i.extend("imageBlock", {
          allowAttributes: "imageStyle"
        }), n.data.upcastDispatcher.on("element:figure", s, {
          priority: "low"
        })), t && (i.extend("imageInline", {
          allowAttributes: "imageStyle"
        }), n.data.upcastDispatcher.on("element:img", s, {
          priority: "low"
        }));
      }
      _setupPostFixer() {
        const e = this.editor,
          t = e.model.document,
          n = e.plugins.get(mC),
          i = new Map(this.normalizedStyles.map(e => [e.name, e]));
        t.registerPostFixer(e => {
          let o = !1;
          for (const r of t.differ.getChanges()) if ("insert" == r.type || "attribute" == r.type && "imageStyle" == r.attributeKey) {
            let t = "insert" == r.type ? r.position.nodeAfter : r.range.start.nodeAfter;
            if (t && t.is("element", "paragraph") && t.childCount > 0 && (t = t.getChild(0)), !n.isImage(t)) continue;
            const s = t.getAttribute("imageStyle");
            if (!s) continue;
            const a = i.get(s);
            a && a.modelElements.includes(t.name) || (e.removeAttribute("imageStyle", t), o = !0);
          }
          return o;
        });
      }
    }
    var Uy = o(3885),
      qy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Uy.A, qy);
    Uy.A.locals;
    class Gy extends Br {
      static get requires() {
        return [Hy];
      }
      static get pluginName() {
        return "ImageStyleUI";
      }
      get localizedDefaultStylesTitles() {
        const e = this.editor.t;
        return {
          "Wrap text": e("Wrap text"),
          "Break text": e("Break text"),
          "In line": e("In line"),
          "Full size image": e("Full size image"),
          "Side image": e("Side image"),
          "Left aligned image": e("Left aligned image"),
          "Centered image": e("Centered image"),
          "Right aligned image": e("Right aligned image")
        };
      }
      init() {
        const e = this.editor.plugins,
          t = this.editor.config.get("image.toolbar") || [],
          n = Ky(e.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
        for (const e of n) this._createButton(e);
        const i = Ky([...t.filter(R), ...Fy.getDefaultDropdownDefinitions(e)], this.localizedDefaultStylesTitles);
        for (const e of i) this._createDropdown(e, n);
      }
      _createDropdown(e, t) {
        const n = this.editor.ui.componentFactory;
        n.add(e.name, i => {
          let o;
          const {
              defaultItem: r,
              items: s,
              title: a
            } = e,
            l = s.filter(e => t.find(_ref108 => {
              let {
                name: t
              } = _ref108;
              return Wy(t) === e;
            })).map(e => {
              const t = n.create(e);
              return e === r && (o = t), t;
            });
          s.length !== l.length && Fy.warnInvalidStyle({
            dropdown: e
          });
          const c = yp(i, _p),
            d = c.buttonView,
            u = d.arrowView;
          return xp(c, l, {
            enableActiveItemFocusOnDropdownOpen: !0
          }), d.set({
            label: Yy(a, o.label),
            class: null,
            tooltip: !0
          }), u.unbind("label"), u.set({
            label: a
          }), d.bind("icon").toMany(l, "isOn", function () {
            for (var _len36 = arguments.length, e = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
              e[_key36] = arguments[_key36];
            }
            const t = e.findIndex(So);
            return t < 0 ? o.icon : l[t].icon;
          }), d.bind("label").toMany(l, "isOn", function () {
            for (var _len37 = arguments.length, e = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
              e[_key37] = arguments[_key37];
            }
            const t = e.findIndex(So);
            return Yy(a, t < 0 ? o.label : l[t].label);
          }), d.bind("isOn").toMany(l, "isOn", function () {
            for (var _len38 = arguments.length, e = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
              e[_key38] = arguments[_key38];
            }
            return e.some(So);
          }), d.bind("class").toMany(l, "isOn", function () {
            for (var _len39 = arguments.length, e = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
              e[_key39] = arguments[_key39];
            }
            return e.some(So) ? "ck-splitbutton_flatten" : void 0;
          }), d.on("execute", () => {
            l.some(_ref109 => {
              let {
                isOn: e
              } = _ref109;
              return e;
            }) ? c.isOpen = !c.isOpen : o.fire("execute");
          }), c.bind("isEnabled").toMany(l, "isEnabled", function () {
            for (var _len40 = arguments.length, e = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
              e[_key40] = arguments[_key40];
            }
            return e.some(So);
          }), this.listenTo(c, "execute", () => {
            this.editor.editing.view.focus();
          }), c;
        });
      }
      _createButton(e) {
        const t = e.name;
        this.editor.ui.componentFactory.add(Wy(t), n => {
          const i = this.editor.commands.get("imageStyle"),
            o = new um(n);
          return o.set({
            label: e.title,
            icon: e.icon,
            tooltip: !0,
            isToggleable: !0
          }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", e => e === t), o.on("execute", this._executeCommand.bind(this, t)), o;
        });
      }
      _executeCommand(e) {
        this.editor.execute("imageStyle", {
          value: e
        }), this.editor.editing.view.focus();
      }
    }
    function Ky(e, t) {
      for (const n of e) t[n.title] && (n.title = t[n.title]);
      return e;
    }
    function Wy(e) {
      return "imageStyle:".concat(e);
    }
    function Yy(e, t) {
      return (e ? e + ": " : "") + t;
    }
    class $y extends Br {
      static get pluginName() {
        return "IndentEditing";
      }
      init() {
        const e = this.editor;
        e.commands.add("indent", new Nr(e)), e.commands.add("outdent", new Nr(e));
      }
    }
    class Zy extends Br {
      static get pluginName() {
        return "IndentUI";
      }
      init() {
        const e = this.editor,
          t = e.locale,
          n = e.t,
          i = "ltr" == t.uiLanguageDirection ? Wh.indent : Wh.outdent,
          o = "ltr" == t.uiLanguageDirection ? Wh.outdent : Wh.indent;
        this._defineButton("indent", n("Increase indent"), i), this._defineButton("outdent", n("Decrease indent"), o);
      }
      _defineButton(e, t, n) {
        const i = this.editor;
        i.ui.componentFactory.add(e, () => {
          const i = this._createButton(um, e, t, n);
          return i.set({
            tooltip: !0
          }), i;
        }), i.ui.componentFactory.add("menuBar:" + e, () => this._createButton(qk, e, t, n));
      }
      _createButton(e, t, n, i) {
        const o = this.editor,
          r = o.commands.get(t),
          s = new e(o.locale);
        return s.set({
          label: n,
          icon: i
        }), s.bind("isEnabled").to(r, "isEnabled"), this.listenTo(s, "execute", () => {
          o.execute(t), o.editing.view.focus();
        }), s;
      }
    }
    class Qy {
      constructor() {
        this._definitions = new Set();
      }
      get length() {
        return this._definitions.size;
      }
      add(e) {
        Array.isArray(e) ? e.forEach(e => this._definitions.add(e)) : this._definitions.add(e);
      }
      getDispatcher() {
        return e => {
          e.on("attribute:linkHref", (e, t, n) => {
            if (!n.consumable.test(t.item, "attribute:linkHref")) return;
            if (!t.item.is("selection") && !n.schema.isInline(t.item)) return;
            const i = n.writer,
              o = i.document.selection;
            for (const e of this._definitions) {
              const r = i.createAttributeElement("a", e.attributes, {
                priority: 5
              });
              e.classes && i.addClass(e.classes, r);
              for (const t in e.styles) i.setStyle(t, e.styles[t], r);
              i.setCustomProperty("link", !0, r), e.callback(t.attributeNewValue) ? t.item.is("selection") ? i.wrap(o.getFirstRange(), r) : i.wrap(n.mapper.toViewRange(t.range), r) : i.unwrap(n.mapper.toViewRange(t.range), r);
            }
          }, {
            priority: "high"
          });
        };
      }
      getDispatcherForLinkedImage() {
        return e => {
          e.on("attribute:linkHref:imageBlock", (e, t, _ref110) => {
            let {
              writer: n,
              mapper: i
            } = _ref110;
            const o = i.toViewElement(t.item),
              r = Array.from(o.getChildren()).find(e => e.is("element", "a"));
            for (const e of this._definitions) {
              const i = Yo(e.attributes);
              if (e.callback(t.attributeNewValue)) {
                for (const [e, t] of i) "class" === e ? n.addClass(t, r) : n.setAttribute(e, t, r);
                e.classes && n.addClass(e.classes, r);
                for (const t in e.styles) n.setStyle(t, e.styles[t], r);
              } else {
                for (const [e, t] of i) "class" === e ? n.removeClass(t, r) : n.removeAttribute(e, r);
                e.classes && n.removeClass(e.classes, r);
                for (const t in e.styles) n.removeStyle(t, r);
              }
            }
          });
        };
      }
    }
    const Jy = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
      Xy = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
      ex = /^((\w+:(\/{2,})?)|(\W))/i,
      tx = ["https?", "ftps?", "mailto"],
      nx = "Ctrl+K";
    function ix(e, _ref111) {
      let {
        writer: t
      } = _ref111;
      const n = t.createAttributeElement("a", {
        href: e
      }, {
        priority: 5
      });
      return t.setCustomProperty("link", !0, n), n;
    }
    function ox(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tx;
      const n = String(e),
        i = t.join("|");
      return function (e, t) {
        const n = e.replace(Jy, "");
        return !!n.match(t);
      }(n, new RegExp("".concat("^(?:(?:<protocols>):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))".replace("<protocols>", i)), "i")) ? n : "#";
    }
    function rx(e, t) {
      return !!e && t.checkAttribute(e.name, "linkHref");
    }
    function sx(e, t) {
      const n = (i = e, Xy.test(i) ? "mailto:" : t);
      var i;
      const o = !!n && !ax(e);
      return e && o ? n + e : e;
    }
    function ax(e) {
      return ex.test(e);
    }
    function lx(e) {
      window.open(e, "_blank", "noopener");
    }
    class cx extends Pr {
      constructor() {
        super(...arguments), this.manualDecorators = new qo(), this.automaticDecorators = new Qy();
      }
      restoreManualDecoratorStates() {
        for (const e of this.manualDecorators) e.value = this._getDecoratorStateFromModel(e.id);
      }
      refresh() {
        const e = this.editor.model,
          t = e.document.selection,
          n = t.getSelectedElement() || Go(t.getSelectedBlocks());
        rx(n, e.schema) ? (this.value = n.getAttribute("linkHref"), this.isEnabled = e.schema.checkAttribute(n, "linkHref")) : (this.value = t.getAttribute("linkHref"), this.isEnabled = e.schema.checkAttributeInSelection(t, "linkHref"));
        for (const e of this.manualDecorators) e.value = this._getDecoratorStateFromModel(e.id);
      }
      execute(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.editor.model,
          i = n.document.selection,
          o = [],
          r = [];
        for (const e in t) t[e] ? o.push(e) : r.push(e);
        n.change(t => {
          if (i.isCollapsed) {
            const s = i.getFirstPosition();
            if (i.hasAttribute("linkHref")) {
              const a = dx(i);
              let l = Jb(s, "linkHref", i.getAttribute("linkHref"), n);
              i.getAttribute("linkHref") === a && (l = this._updateLinkContent(n, t, l, e)), t.setAttribute("linkHref", e, l), o.forEach(e => {
                t.setAttribute(e, !0, l);
              }), r.forEach(e => {
                t.removeAttribute(e, l);
              }), t.setSelection(t.createPositionAfter(l.end.nodeBefore));
            } else if ("" !== e) {
              const r = Yo(i.getAttributes());
              r.set("linkHref", e), o.forEach(e => {
                r.set(e, !0);
              });
              const {
                end: a
              } = n.insertContent(t.createText(e, r), s);
              t.setSelection(a);
            }
            ["linkHref", ...o, ...r].forEach(e => {
              t.removeSelectionAttribute(e);
            });
          } else {
            const s = n.schema.getValidRanges(i.getRanges(), "linkHref"),
              a = [];
            for (const e of i.getSelectedBlocks()) n.schema.checkAttribute(e, "linkHref") && a.push(t.createRangeOn(e));
            const l = a.slice();
            for (const e of s) this._isRangeToUpdate(e, a) && l.push(e);
            for (const s of l) {
              let a = s;
              if (1 === l.length) {
                const o = dx(i);
                i.getAttribute("linkHref") === o && (a = this._updateLinkContent(n, t, s, e), t.setSelection(t.createSelection(a)));
              }
              t.setAttribute("linkHref", e, a), o.forEach(e => {
                t.setAttribute(e, !0, a);
              }), r.forEach(e => {
                t.removeAttribute(e, a);
              });
            }
          }
        });
      }
      _getDecoratorStateFromModel(e) {
        const t = this.editor.model,
          n = t.document.selection,
          i = n.getSelectedElement();
        return rx(i, t.schema) ? i.getAttribute(e) : n.getAttribute(e);
      }
      _isRangeToUpdate(e, t) {
        for (const n of t) if (n.containsRange(e)) return !1;
        return !0;
      }
      _updateLinkContent(e, t, n, i) {
        const o = t.createText(i, {
          linkHref: i
        });
        return e.insertContent(o, n);
      }
    }
    function dx(e) {
      if (e.isCollapsed) {
        const t = e.getFirstPosition();
        return t.textNode && t.textNode.data;
      }
      {
        const t = Array.from(e.getFirstRange().getItems());
        if (t.length > 1) return null;
        const n = t[0];
        return n.is("$text") || n.is("$textProxy") ? n.data : null;
      }
    }
    class ux extends Pr {
      refresh() {
        const e = this.editor.model,
          t = e.document.selection,
          n = t.getSelectedElement();
        rx(n, e.schema) ? this.isEnabled = e.schema.checkAttribute(n, "linkHref") : this.isEnabled = e.schema.checkAttributeInSelection(t, "linkHref");
      }
      execute() {
        const e = this.editor,
          t = this.editor.model,
          n = t.document.selection,
          i = e.commands.get("link");
        t.change(e => {
          const o = n.isCollapsed ? [Jb(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), t)] : t.schema.getValidRanges(n.getRanges(), "linkHref");
          for (const t of o) if (e.removeAttribute("linkHref", t), i) for (const n of i.manualDecorators) e.removeAttribute(n.id, t);
        });
      }
    }
    class hx extends q() {
      constructor(_ref112) {
        let {
          id: e,
          label: t,
          attributes: n,
          classes: i,
          styles: o,
          defaultValue: r
        } = _ref112;
        super(), this.id = e, this.set("value", void 0), this.defaultValue = r, this.label = t, this.attributes = n, this.classes = i, this.styles = o;
      }
      _createPattern() {
        return {
          attributes: this.attributes,
          classes: this.classes,
          styles: this.styles
        };
      }
    }
    var mx = o(278),
      px = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(mx.A, px);
    mx.A.locals;
    const gx = "automatic",
      fx = /^(https?:)?\/\//;
    class kx extends Br {
      static get pluginName() {
        return "LinkEditing";
      }
      static get requires() {
        return [Vb, xb, mw];
      }
      constructor(e) {
        super(e), e.config.define("link", {
          allowCreatingEmptyLinks: !1,
          addTargetToExternalLinks: !1
        });
      }
      init() {
        const e = this.editor,
          t = this.editor.config.get("link.allowedProtocols");
        e.model.schema.extend("$text", {
          allowAttributes: "linkHref"
        }), e.conversion.for("dataDowncast").attributeToElement({
          model: "linkHref",
          view: ix
        }), e.conversion.for("editingDowncast").attributeToElement({
          model: "linkHref",
          view: (e, n) => ix(ox(e, t), n)
        }), e.conversion.for("upcast").elementToAttribute({
          view: {
            name: "a",
            attributes: {
              href: !0
            }
          },
          model: {
            key: "linkHref",
            value: e => e.getAttribute("href")
          }
        }), e.commands.add("link", new cx(e)), e.commands.add("unlink", new ux(e));
        const n = function (e, t) {
          const n = {
            "Open in a new tab": e("Open in a new tab"),
            Downloadable: e("Downloadable")
          };
          return t.forEach(e => ("label" in e && n[e.label] && (e.label = n[e.label]), e)), t;
        }(e.t, function (e) {
          const t = [];
          if (e) for (const [n, i] of Object.entries(e)) {
            const e = Object.assign({}, i, {
              id: "link".concat(iC(n))
            });
            t.push(e);
          }
          return t;
        }(e.config.get("link.decorators")));
        this._enableAutomaticDecorators(n.filter(e => e.mode === gx)), this._enableManualDecorators(n.filter(e => "manual" === e.mode));
        e.plugins.get(Vb).registerAttribute("linkHref"), function (e, t, n, i) {
          const o = e.editing.view,
            r = new Set();
          o.document.registerPostFixer(o => {
            const s = e.model.document.selection;
            let a = !1;
            if (s.hasAttribute(t)) {
              const l = Jb(s.getFirstPosition(), t, s.getAttribute(t), e.model),
                c = e.editing.mapper.toViewRange(l);
              for (const e of c.getItems()) e.is("element", n) && !e.hasClass(i) && (o.addClass(i, e), r.add(e), a = !0);
            }
            return a;
          }), e.conversion.for("editingDowncast").add(e => {
            function t() {
              o.change(e => {
                for (const t of r.values()) e.removeClass(i, t), r.delete(t);
              });
            }
            e.on("insert", t, {
              priority: "highest"
            }), e.on("remove", t, {
              priority: "highest"
            }), e.on("attribute", t, {
              priority: "highest"
            }), e.on("selection", t, {
              priority: "highest"
            });
          });
        }(e, "linkHref", "a", "ck-link_selected"), this._enableLinkOpen(), this._enableSelectionAttributesFixer(), this._enableClipboardIntegration();
      }
      _enableAutomaticDecorators(e) {
        const t = this.editor,
          n = t.commands.get("link").automaticDecorators;
        t.config.get("link.addTargetToExternalLinks") && n.add({
          id: "linkIsExternal",
          mode: gx,
          callback: e => !!e && fx.test(e),
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer"
          }
        }), n.add(e), n.length && t.conversion.for("downcast").add(n.getDispatcher());
      }
      _enableManualDecorators(e) {
        if (!e.length) return;
        const t = this.editor,
          n = t.commands.get("link").manualDecorators;
        e.forEach(e => {
          t.model.schema.extend("$text", {
            allowAttributes: e.id
          });
          const i = new hx(e);
          n.add(i), t.conversion.for("downcast").attributeToElement({
            model: i.id,
            view: (e, _ref113, _ref114) => {
              let {
                writer: t,
                schema: n
              } = _ref113;
              let {
                item: o
              } = _ref114;
              if ((o.is("selection") || n.isInline(o)) && e) {
                const e = t.createAttributeElement("a", i.attributes, {
                  priority: 5
                });
                i.classes && t.addClass(i.classes, e);
                for (const n in i.styles) t.setStyle(n, i.styles[n], e);
                return t.setCustomProperty("link", !0, e), e;
              }
            }
          }), t.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              ...i._createPattern()
            },
            model: {
              key: i.id
            }
          });
        });
      }
      _enableLinkOpen() {
        const e = this.editor,
          t = e.editing.view.document;
        this.listenTo(t, "click", (e, t) => {
          if (!(s.isMac ? t.domEvent.metaKey : t.domEvent.ctrlKey)) return;
          let n = t.domTarget;
          if ("a" != n.tagName.toLowerCase() && (n = n.closest("a")), !n) return;
          const i = n.getAttribute("href");
          i && (e.stop(), t.preventDefault(), lx(i));
        }, {
          context: "$capture"
        }), this.listenTo(t, "keydown", (t, n) => {
          const i = e.commands.get("link").value;
          !!i && n.keyCode === mo.enter && n.altKey && (t.stop(), lx(i));
        });
      }
      _enableSelectionAttributesFixer() {
        const e = this.editor.model,
          t = e.document.selection;
        this.listenTo(t, "change:attribute", (n, _ref115) => {
          let {
            attributeKeys: i
          } = _ref115;
          i.includes("linkHref") && !t.hasAttribute("linkHref") && e.change(t => {
            var n;
            !function (e, t) {
              e.removeSelectionAttribute("linkHref");
              for (const n of t) e.removeSelectionAttribute(n);
            }(t, (n = e.schema, n.getDefinition("$text").allowAttributes.filter(e => e.startsWith("link"))));
          });
        });
      }
      _enableClipboardIntegration() {
        const e = this.editor,
          t = e.model,
          n = this.editor.config.get("link.defaultProtocol");
        n && this.listenTo(e.plugins.get("ClipboardPipeline"), "contentInsertion", (e, i) => {
          t.change(e => {
            const t = e.createRangeIn(i.content);
            for (const i of t.getItems()) if (i.hasAttribute("linkHref")) {
              const t = sx(i.getAttribute("linkHref"), n);
              e.setAttribute("linkHref", t, i);
            }
          });
        });
      }
    }
    var bx = o(9392),
      _x = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(bx.A, _x);
    bx.A.locals;
    class wx extends Er {
      constructor(e, t, n) {
        super(e), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this._focusables = new er();
        const i = e.t;
        this._validators = n, this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(i("Save"), Wh.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(i("Cancel"), Wh.cancel, "ck-button-cancel", "cancel"), this._manualDecoratorSwitches = this._createManualDecoratorSwitches(t), this.children = this._createFormChildren(t.manualDecorators), this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        const o = ["ck", "ck-link-form", "ck-responsive-form"];
        t.manualDecorators.length && o.push("ck-link-form_layout-vertical", "ck-vertical-form"), this.setTemplate({
          tag: "form",
          attributes: {
            class: o,
            tabindex: "-1"
          },
          children: this.children
        });
      }
      getDecoratorSwitchesState() {
        return Array.from(this._manualDecoratorSwitches).reduce((e, t) => (e[t.name] = t.isOn, e), {});
      }
      render() {
        super.render(), Tr({
          view: this
        });
        [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView].forEach(e => {
          this._focusables.add(e), this.focusTracker.add(e.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      isValid() {
        this.resetFormStatus();
        for (const e of this._validators) {
          const t = e(this);
          if (t) return this.urlInputView.errorText = t, !1;
        }
        return !0;
      }
      resetFormStatus() {
        this.urlInputView.errorText = null;
      }
      _createUrlInput() {
        const e = this.locale.t,
          t = new Rm(this.locale, Bp);
        return t.label = e("Link URL"), t;
      }
      _createButton(e, t, n, i) {
        const o = new um(this.locale);
        return o.set({
          label: e,
          icon: t,
          tooltip: !0
        }), o.extendTemplate({
          attributes: {
            class: n
          }
        }), i && o.delegate("execute").to(this, i), o;
      }
      _createManualDecoratorSwitches(e) {
        const t = this.createCollection();
        for (const n of e.manualDecorators) {
          const i = new pm(this.locale);
          i.set({
            name: n.id,
            label: n.label,
            withText: !0
          }), i.bind("isOn").toMany([n, e], "value", (e, t) => void 0 === t && void 0 === e ? !!n.defaultValue : !!e), i.on("execute", () => {
            n.set("value", !i.isOn);
          }), t.add(i);
        }
        return t;
      }
      _createFormChildren(e) {
        const t = this.createCollection();
        if (t.add(this.urlInputView), e.length) {
          const e = new Er();
          e.setTemplate({
            tag: "ul",
            children: this._manualDecoratorSwitches.map(e => ({
              tag: "li",
              children: [e],
              attributes: {
                class: ["ck", "ck-list__item"]
              }
            })),
            attributes: {
              class: ["ck", "ck-reset", "ck-list"]
            }
          }), t.add(e);
        }
        return t.add(this.saveButtonView), t.add(this.cancelButtonView), t;
      }
      get url() {
        const {
          element: e
        } = this.urlInputView.fieldView;
        return e ? e.value.trim() : null;
      }
    }
    var Ax = o(1893),
      vx = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Ax.A, vx);
    Ax.A.locals;
    class Cx extends Er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e), this.focusTracker = new Ko(), this.keystrokes = new Wo(), this._focusables = new er();
        const n = e.t;
        this.previewButtonView = this._createPreviewButton(), this.unlinkButtonView = this._createButton(n("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), this.editButtonView = this._createButton(n("Edit link"), Wh.pencil, "edit"), this.set("href", void 0), this._linkConfig = t, this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView]
        });
      }
      render() {
        super.render();
        [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(e => {
          this._focusables.add(e), this.focusTracker.add(e.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      _createButton(e, t, n) {
        const i = new um(this.locale);
        return i.set({
          label: e,
          icon: t,
          tooltip: !0
        }), i.delegate("execute").to(this, n), i;
      }
      _createPreviewButton() {
        const e = new um(this.locale),
          t = this.bindTemplate,
          n = this.t;
        return e.set({
          withText: !0,
          tooltip: n("Open link in new tab")
        }), e.extendTemplate({
          attributes: {
            class: ["ck", "ck-link-actions__preview"],
            href: t.to("href", e => e && ox(e, this._linkConfig.allowedProtocols)),
            target: "_blank",
            rel: "noopener noreferrer"
          }
        }), e.bind("label").to(this, "href", e => e || n("This link has no URL")), e.bind("isEnabled").to(this, "href", e => !!e), e.template.tag = "a", e.template.eventListeners = {}, e;
      }
    }
    const yx = "link-ui";
    class xx extends Br {
      constructor() {
        super(...arguments), this.actionsView = null, this.formView = null;
      }
      static get requires() {
        return [Of];
      }
      static get pluginName() {
        return "LinkUI";
      }
      init() {
        const e = this.editor,
          t = this.editor.t;
        e.editing.view.addObserver(Qu), this._balloon = e.plugins.get(Of), this._createToolbarLinkButton(), this._enableBalloonActivators(), e.conversion.for("editingDowncast").markerToHighlight({
          model: yx,
          view: {
            classes: ["ck-fake-link-selection"]
          }
        }), e.conversion.for("editingDowncast").markerToElement({
          model: yx,
          view: {
            name: "span",
            classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"]
          }
        }), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Create link"),
            keystroke: nx
          }, {
            label: t("Move out of a link"),
            keystroke: [["arrowleft", "arrowleft"], ["arrowright", "arrowright"]]
          }]
        });
      }
      destroy() {
        super.destroy(), this.formView && this.formView.destroy(), this.actionsView && this.actionsView.destroy();
      }
      _createViews() {
        this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._enableUserBalloonInteractions();
      }
      _createActionsView() {
        const e = this.editor,
          t = new Cx(e.locale, e.config.get("link")),
          n = e.commands.get("link"),
          i = e.commands.get("unlink");
        return t.bind("href").to(n, "value"), t.editButtonView.bind("isEnabled").to(n), t.unlinkButtonView.bind("isEnabled").to(i), this.listenTo(t, "edit", () => {
          this._addFormView();
        }), this.listenTo(t, "unlink", () => {
          e.execute("unlink"), this._hideUI();
        }), t.keystrokes.set("Esc", (e, t) => {
          this._hideUI(), t();
        }), t.keystrokes.set(nx, (e, t) => {
          this._addFormView(), t();
        }), t;
      }
      _createFormView() {
        const e = this.editor,
          t = e.commands.get("link"),
          n = e.config.get("link.defaultProtocol"),
          i = new (Dr(wx))(e.locale, t, function (e) {
            const t = e.t,
              n = e.config.get("link.allowCreatingEmptyLinks");
            return [e => {
              if (!n && !e.url.length) return t("Link URL must not be empty.");
            }];
          }(e));
        return i.urlInputView.fieldView.bind("value").to(t, "value"), i.urlInputView.bind("isEnabled").to(t, "isEnabled"), i.saveButtonView.bind("isEnabled").to(t, "isEnabled"), this.listenTo(i, "submit", () => {
          if (i.isValid()) {
            const {
                value: t
              } = i.urlInputView.fieldView.element,
              o = sx(t, n);
            e.execute("link", o, i.getDecoratorSwitchesState()), this._closeFormView();
          }
        }), this.listenTo(i.urlInputView, "change:errorText", () => {
          e.ui.update();
        }), this.listenTo(i, "cancel", () => {
          this._closeFormView();
        }), i.keystrokes.set("Esc", (e, t) => {
          this._closeFormView(), t();
        }), i;
      }
      _createToolbarLinkButton() {
        const e = this.editor,
          t = e.commands.get("link");
        e.ui.componentFactory.add("link", () => {
          const e = this._createButton(um);
          return e.set({
            tooltip: !0,
            isToggleable: !0
          }), e.bind("isOn").to(t, "value", e => !!e), e;
        }), e.ui.componentFactory.add("menuBar:link", () => this._createButton(qk));
      }
      _createButton(e) {
        const t = this.editor,
          n = t.locale,
          i = t.commands.get("link"),
          o = new e(t.locale),
          r = n.t;
        return o.set({
          label: r("Link"),
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>',
          keystroke: nx
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => this._showUI(!0)), o;
      }
      _enableBalloonActivators() {
        const e = this.editor,
          t = e.editing.view.document;
        this.listenTo(t, "click", () => {
          this._getSelectedLinkElement() && this._showUI();
        }), e.keystrokes.set(nx, (t, n) => {
          n(), e.commands.get("link").isEnabled && this._showUI(!0);
        });
      }
      _enableUserBalloonInteractions() {
        this.editor.keystrokes.set("Tab", (e, t) => {
          this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), t());
        }, {
          priority: "high"
        }), this.editor.keystrokes.set("Esc", (e, t) => {
          this._isUIVisible && (this._hideUI(), t());
        }), Sr({
          emitter: this.formView,
          activator: () => this._isUIInPanel,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideUI()
        });
      }
      _addActionsView() {
        this.actionsView || this._createViews(), this._areActionsInPanel || this._balloon.add({
          view: this.actionsView,
          position: this._getBalloonPositionData()
        });
      }
      _addFormView() {
        if (this.formView || this._createViews(), this._isFormInPanel) return;
        const e = this.editor.commands.get("link");
        this.formView.disableCssTransitions(), this.formView.resetFormStatus(), this._balloon.add({
          view: this.formView,
          position: this._getBalloonPositionData()
        }), this.formView.urlInputView.fieldView.value = e.value || "", this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions();
      }
      _closeFormView() {
        const e = this.editor.commands.get("link");
        e.restoreManualDecoratorStates(), void 0 !== e.value ? this._removeFormView() : this._hideUI();
      }
      _removeFormView() {
        this._isFormInPanel && (this.formView.saveButtonView.focus(), this.formView.urlInputView.fieldView.reset(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
      }
      _showUI() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        this.formView || this._createViews(), this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), e && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), e && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
      }
      _hideUI() {
        if (!this._isUIInPanel) return;
        const e = this.editor;
        this.stopListening(e.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), e.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
      }
      _startUpdatingUI() {
        const e = this.editor,
          t = e.editing.view.document;
        let n = this._getSelectedLinkElement(),
          i = r();
        const o = () => {
          const e = this._getSelectedLinkElement(),
            t = r();
          n && !e || !n && t !== i ? this._hideUI() : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()), n = e, i = t;
        };
        function r() {
          return t.selection.focus.getAncestors().reverse().find(e => e.is("element"));
        }
        this.listenTo(e.ui, "update", o), this.listenTo(this._balloon, "change:visibleView", o);
      }
      get _isFormInPanel() {
        return !!this.formView && this._balloon.hasView(this.formView);
      }
      get _areActionsInPanel() {
        return !!this.actionsView && this._balloon.hasView(this.actionsView);
      }
      get _areActionsVisible() {
        return !!this.actionsView && this._balloon.visibleView === this.actionsView;
      }
      get _isUIInPanel() {
        return this._isFormInPanel || this._areActionsInPanel;
      }
      get _isUIVisible() {
        const e = this._balloon.visibleView;
        return !!this.formView && e == this.formView || this._areActionsVisible;
      }
      _getBalloonPositionData() {
        const e = this.editor.editing.view,
          t = this.editor.model,
          n = e.document;
        let i;
        if (t.markers.has(yx)) {
          const t = Array.from(this.editor.editing.mapper.markerNameToElements(yx)),
            n = e.createRange(e.createPositionBefore(t[0]), e.createPositionAfter(t[t.length - 1]));
          i = e.domConverter.viewRangeToDom(n);
        } else i = () => {
          const t = this._getSelectedLinkElement();
          return t ? e.domConverter.mapViewToDom(t) : e.domConverter.viewRangeToDom(n.selection.getFirstRange());
        };
        return {
          target: i
        };
      }
      _getSelectedLinkElement() {
        const e = this.editor.editing.view,
          t = e.document.selection,
          n = t.getSelectedElement();
        if (t.isCollapsed || n && Aw(n)) return Ex(t.getFirstPosition());
        {
          const n = t.getFirstRange().getTrimmed(),
            i = Ex(n.start),
            o = Ex(n.end);
          return i && i == o && e.createRangeIn(i).getTrimmed().isEqual(n) ? i : null;
        }
      }
      _showFakeVisualSelection() {
        const e = this.editor.model;
        e.change(t => {
          const n = e.document.selection.getFirstRange();
          if (e.markers.has(yx)) t.updateMarker(yx, {
            range: n
          });else if (n.start.isAtEnd) {
            const i = n.start.getLastMatchingPosition(_ref116 => {
              let {
                item: t
              } = _ref116;
              return !e.schema.isContent(t);
            }, {
              boundaries: n
            });
            t.addMarker(yx, {
              usingOperation: !1,
              affectsData: !1,
              range: t.createRange(i, n.end)
            });
          } else t.addMarker(yx, {
            usingOperation: !1,
            affectsData: !1,
            range: n
          });
        });
      }
      _hideFakeVisualSelection() {
        const e = this.editor.model;
        e.markers.has(yx) && e.change(e => {
          e.removeMarker(yx);
        });
      }
    }
    function Ex(e) {
      return e.getAncestors().find(e => {
        return (t = e).is("attributeElement") && !!t.getCustomProperty("link");
        var t;
      }) || null;
    }
    const Sx = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
    class Dx extends Br {
      static get requires() {
        return [zb, kx];
      }
      static get pluginName() {
        return "AutoLink";
      }
      init() {
        const e = this.editor.model.document.selection;
        e.on("change:range", () => {
          this.isEnabled = !e.anchor.parent.is("element", "codeBlock");
        }), this._enableTypingHandling();
      }
      afterInit() {
        this._enableEnterHandling(), this._enableShiftEnterHandling(), this._enablePasteLinking();
      }
      _expandLinkRange(e, t) {
        return t.textNode && t.textNode.hasAttribute("linkHref") ? Jb(t, "linkHref", t.textNode.getAttribute("linkHref"), e) : null;
      }
      _selectEntireLinks(e, t) {
        const n = this.editor.model,
          i = n.document.selection,
          o = i.getFirstPosition(),
          r = i.getLastPosition();
        let s = t.getJoined(this._expandLinkRange(n, o) || t);
        s && (s = s.getJoined(this._expandLinkRange(n, r) || t)), s && (s.start.isBefore(o) || s.end.isAfter(r)) && e.setSelection(s);
      }
      _enablePasteLinking() {
        const e = this.editor,
          t = e.model,
          n = t.document.selection,
          i = e.plugins.get("ClipboardPipeline"),
          o = e.commands.get("link");
        i.on("inputTransformation", (e, i) => {
          if (!this.isEnabled || !o.isEnabled || n.isCollapsed || "paste" !== i.method) return;
          if (n.rangeCount > 1) return;
          const r = n.getFirstRange(),
            s = i.dataTransfer.getData("text/plain");
          if (!s) return;
          const a = s.match(Sx);
          a && a[2] === s && (t.change(e => {
            this._selectEntireLinks(e, r), o.execute(s);
          }), e.stop());
        }, {
          priority: "high"
        });
      }
      _enableTypingHandling() {
        const e = this.editor,
          t = new Rb(e.model, e => {
            if (!function (e) {
              return e.length > 4 && " " === e[e.length - 1] && " " !== e[e.length - 2];
            }(e)) return;
            const t = Tx(e.substr(0, e.length - 1));
            return t ? {
              url: t
            } : void 0;
          });
        t.on("matched:data", (t, n) => {
          const {
            batch: i,
            range: o,
            url: r
          } = n;
          if (!i.isTyping) return;
          const s = o.end.getShiftedBy(-1),
            a = s.getShiftedBy(-r.length),
            l = e.model.createRange(a, s);
          this._applyAutoLink(r, l);
        }), t.bind("isEnabled").to(this);
      }
      _enableEnterHandling() {
        const e = this.editor,
          t = e.model,
          n = e.commands.get("enter");
        n && n.on("execute", () => {
          const e = t.document.selection.getFirstPosition();
          if (!e.parent.previousSibling) return;
          const n = t.createRangeIn(e.parent.previousSibling);
          this._checkAndApplyAutoLinkOnRange(n);
        });
      }
      _enableShiftEnterHandling() {
        const e = this.editor,
          t = e.model,
          n = e.commands.get("shiftEnter");
        n && n.on("execute", () => {
          const e = t.document.selection.getFirstPosition(),
            n = t.createRange(t.createPositionAt(e.parent, 0), e.getShiftedBy(-1));
          this._checkAndApplyAutoLinkOnRange(n);
        });
      }
      _checkAndApplyAutoLinkOnRange(e) {
        const t = this.editor.model,
          {
            text: n,
            range: i
          } = Lb(e, t),
          o = Tx(n);
        if (o) {
          const e = t.createRange(i.end.getShiftedBy(-o.length), i.end);
          this._applyAutoLink(o, e);
        }
      }
      _applyAutoLink(e, t) {
        const n = this.editor.model,
          i = sx(e, this.editor.config.get("link.defaultProtocol"));
        this.isEnabled && function (e, t) {
          return t.schema.checkAttributeInSelection(t.createSelection(e), "linkHref");
        }(t, n) && ax(i) && !function (e) {
          const t = e.start.nodeAfter;
          return !!t && t.hasAttribute("linkHref");
        }(t) && this._persistAutoLink(i, t);
      }
      _persistAutoLink(e, t) {
        const n = this.editor.model,
          i = this.editor.plugins.get("Delete");
        n.enqueueChange(o => {
          o.setAttribute("linkHref", e, t), n.enqueueChange(() => {
            i.requestUndoOnBackspace();
          });
        });
      }
    }
    function Tx(e) {
      const t = Sx.exec(e);
      return t ? t[2] : null;
    }
    var Ix = o(6355),
      Bx = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(Ix.A, Bx);
    Ix.A.locals;
    class Mx {
      constructor(e, t) {
        this._startElement = e, this._referenceIndent = e.getAttribute("listIndent"), this._isForward = "forward" == t.direction, this._includeSelf = !!t.includeSelf, this._sameAttributes = _o(t.sameAttributes || []), this._sameIndent = !!t.sameIndent, this._lowerIndent = !!t.lowerIndent, this._higherIndent = !!t.higherIndent;
      }
      static first(e, t) {
        return Go(new this(e, t)[Symbol.iterator]());
      }
      *[Symbol.iterator]() {
        const e = [];
        for (const {
          node: t
        } of Px(this._getStartNode(), this._isForward ? "forward" : "backward")) {
          const n = t.getAttribute("listIndent");
          if (n < this._referenceIndent) {
            if (!this._lowerIndent) break;
            this._referenceIndent = n;
          } else if (n > this._referenceIndent) {
            if (!this._higherIndent) continue;
            if (!this._isForward) {
              e.push(t);
              continue;
            }
          } else {
            if (!this._sameIndent) {
              if (this._higherIndent) {
                e.length && (yield* e, e.length = 0);
                break;
              }
              continue;
            }
            if (this._sameAttributes.some(e => t.getAttribute(e) !== this._startElement.getAttribute(e))) break;
          }
          e.length && (yield* e, e.length = 0), yield t;
        }
      }
      _getStartNode() {
        return this._includeSelf ? this._startElement : this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
      }
    }
    function Px(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "forward";
      return function* () {
        const n = "forward" == t,
          i = [];
        let o = null;
        for (; Lx(e);) {
          let t = null;
          if (o) {
            const n = e.getAttribute("listIndent"),
              r = o.getAttribute("listIndent");
            n > r ? i[r] = o : n < r ? (t = i[n], i.length = n) : t = o;
          }
          yield {
            node: e,
            previous: o,
            previousNodeInList: t
          }, o = e, e = n ? e.nextSibling : e.previousSibling;
        }
      }();
    }
    class zx {
      constructor(e) {
        this._listHead = e;
      }
      [Symbol.iterator]() {
        return Px(this._listHead, "forward");
      }
    }
    class Nx {
      static next() {
        return g();
      }
    }
    function Lx(e) {
      return !!e && e.is("element") && e.hasAttribute("listItemId");
    }
    function Rx(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return [...Vx(e, {
        ...t,
        direction: "backward"
      }), ...Vx(e, {
        ...t,
        direction: "forward"
      })];
    }
    function Vx(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const n = "forward" == t.direction,
        i = Array.from(new Mx(e, {
          ...t,
          includeSelf: n,
          sameIndent: !0,
          sameAttributes: "listItemId"
        }));
      return n ? i : i.reverse();
    }
    function Ox(e, t) {
      const n = new Mx(e, {
          sameIndent: !0,
          sameAttributes: "listType",
          ...t
        }),
        i = new Mx(e, {
          sameIndent: !0,
          sameAttributes: "listType",
          includeSelf: !0,
          direction: "forward",
          ...t
        });
      return [...Array.from(n).reverse(), ...i];
    }
    function Fx(e) {
      return !Mx.first(e, {
        sameIndent: !0,
        sameAttributes: "listItemId"
      });
    }
    function jx(e) {
      return !Mx.first(e, {
        direction: "forward",
        sameIndent: !0,
        sameAttributes: "listItemId"
      });
    }
    function Hx(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      e = _o(e);
      const n = !1 !== t.withNested,
        i = new Set();
      for (const t of e) for (const e of Rx(t, {
        higherIndent: n
      })) i.add(e);
      return $x(i);
    }
    function Ux(e) {
      e = _o(e);
      const t = new Set();
      for (const n of e) for (const e of Ox(n)) t.add(e);
      return $x(t);
    }
    function qx(e, t) {
      const n = Vx(e, {
          direction: "forward"
        }),
        i = Nx.next();
      for (const e of n) t.setAttribute("listItemId", i, e);
      return n;
    }
    function Gx(e, t, n) {
      const i = {};
      for (const [e, n] of t.getAttributes()) e.startsWith("list") && (i[e] = n);
      const o = Vx(e, {
        direction: "forward"
      });
      for (const e of o) n.setAttributes(i, e);
      return o;
    }
    function Kx(e, t) {
      let {
        expand: n,
        indentBy: i = 1
      } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      e = _o(e);
      const o = n ? Hx(e) : e;
      for (const e of o) {
        const n = e.getAttribute("listIndent") + i;
        n < 0 ? Wx(e, t) : t.setAttribute("listIndent", n, e);
      }
      return o;
    }
    function Wx(e, t) {
      e = _o(e);
      for (const n of e) n.is("element", "listItem") && t.rename(n, "paragraph");
      for (const n of e) for (const e of n.getAttributeKeys()) e.startsWith("list") && t.removeAttribute(e, n);
      return e;
    }
    function Yx(e) {
      if (!e.length) return !1;
      const t = e[0].getAttribute("listItemId");
      return !!t && !e.some(e => e.getAttribute("listItemId") != t);
    }
    function $x(e) {
      return Array.from(e).filter(e => "$graveyard" !== e.root.rootName).sort((e, t) => e.index - t.index);
    }
    function Zx(e) {
      const t = e.document.selection.getSelectedElement();
      return t && e.schema.isObject(t) && e.schema.isBlock(t) ? t : null;
    }
    function Qx(e, t) {
      return t.checkChild(e.parent, "listItem") && t.checkChild(e, "$text") && !t.isObject(e);
    }
    function Jx(e) {
      return "numbered" == e || "customNumbered" == e;
    }
    function Xx(e, t, n) {
      return Vx(t, {
        direction: "forward"
      }).pop().index > e.index ? Gx(e, t, n) : [];
    }
    class eE extends Pr {
      constructor(e, t) {
        super(e), this._direction = t;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        const e = this.editor.model,
          t = tE(e.document.selection);
        e.change(e => {
          const n = [];
          Yx(t) && !Fx(t[0]) ? ("forward" == this._direction && n.push(...Kx(t, e)), n.push(...qx(t[0], e))) : "forward" == this._direction ? n.push(...Kx(t, e, {
            expand: !0
          })) : n.push(...function (e, t) {
            const n = Hx(e = _o(e)),
              i = new Set(),
              o = Math.min(...n.map(e => e.getAttribute("listIndent"))),
              r = new Map();
            for (const e of n) r.set(e, Mx.first(e, {
              lowerIndent: !0
            }));
            for (const e of n) {
              if (i.has(e)) continue;
              i.add(e);
              const n = e.getAttribute("listIndent") - 1;
              if (n < 0) Wx(e, t);else {
                if (e.getAttribute("listIndent") == o) {
                  const n = Xx(e, r.get(e), t);
                  for (const e of n) i.add(e);
                  if (n.length) continue;
                }
                t.setAttribute("listIndent", n, e);
              }
            }
            return $x(i);
          }(t, e));
          for (const t of n) {
            if (!t.hasAttribute("listType")) continue;
            const n = Mx.first(t, {
              sameIndent: !0
            });
            n && e.setAttribute("listType", n.getAttribute("listType"), t);
          }
          this._fireAfterExecute(n);
        });
      }
      _fireAfterExecute(e) {
        this.fire("afterExecute", $x(new Set(e)));
      }
      _checkEnabled() {
        let e = tE(this.editor.model.document.selection),
          t = e[0];
        if (!t) return !1;
        if ("backward" == this._direction) return !0;
        if (Yx(e) && !Fx(e[0])) return !0;
        e = Hx(e), t = e[0];
        const n = Mx.first(t, {
          sameIndent: !0
        });
        return !!n && n.getAttribute("listType") == t.getAttribute("listType");
      }
    }
    function tE(e) {
      const t = Array.from(e.getSelectedBlocks()),
        n = t.findIndex(e => !Lx(e));
      return -1 != n && (t.length = n), t;
    }
    class nE extends Pr {
      constructor(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super(e), this.type = t, this._listWalkerOptions = n.multiLevel ? {
          higherIndent: !0,
          lowerIndent: !0,
          sameAttributes: []
        } : void 0;
      }
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document,
          i = Zx(t),
          o = Array.from(n.selection.getSelectedBlocks()).filter(e => t.schema.checkAttribute(e, "listType") || Qx(e, t.schema)),
          r = void 0 !== e.forceValue ? !e.forceValue : this.value;
        t.change(s => {
          if (r) {
            const e = o[o.length - 1],
              t = Vx(e, {
                direction: "forward"
              }),
              n = [];
            t.length > 1 && n.push(...qx(t[1], s)), n.push(...Wx(o, s)), n.push(...function (e, t) {
              const n = [];
              let i = Number.POSITIVE_INFINITY;
              for (const {
                node: o
              } of Px(e.nextSibling, "forward")) {
                const e = o.getAttribute("listIndent");
                if (0 == e) break;
                e < i && (i = e);
                const r = e - i;
                t.setAttribute("listIndent", r, o), n.push(o);
              }
              return n;
            }(e, s)), this._fireAfterExecute(n);
          } else if ((i || n.selection.isCollapsed) && Lx(o[0])) {
            const t = Ox(i || o[0], this._listWalkerOptions);
            for (const n of t) s.setAttributes({
              ...e.additionalAttributes,
              listType: this.type
            }, n);
            this._fireAfterExecute(t);
          } else {
            const n = [];
            for (const i of o) if (i.hasAttribute("listType")) for (const t of Hx(i, {
              withNested: !1
            })) t.getAttribute("listType") != this.type && (s.setAttributes({
              ...e.additionalAttributes,
              listType: this.type
            }, t), n.push(t));else !i.is("element", "listItem") && Qx(i, t.schema) && s.rename(i, "listItem"), s.setAttributes({
              ...e.additionalAttributes,
              listIndent: 0,
              listItemId: Nx.next(),
              listType: this.type
            }, i), n.push(i);
            this._fireAfterExecute(n);
          }
        });
      }
      _fireAfterExecute(e) {
        this.fire("afterExecute", $x(new Set(e)));
      }
      _getValue() {
        const e = this.editor.model.document.selection,
          t = Array.from(e.getSelectedBlocks());
        if (!t.length) return !1;
        for (const e of t) if (e.getAttribute("listType") != this.type) return !1;
        return !0;
      }
      _checkEnabled() {
        const e = this.editor.model,
          t = e.schema,
          n = e.document.selection,
          i = Array.from(n.getSelectedBlocks());
        if (!i.length) return !1;
        if (this.value) return !0;
        for (const e of i) if (t.checkAttribute(e, "listType") || Qx(e, t)) return !0;
        return !1;
      }
    }
    class iE extends Pr {
      constructor(e, t) {
        super(e), this._direction = t;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        let {
          shouldMergeOnBlocksContentLevel: e = !1
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document.selection,
          i = [];
        t.change(o => {
          const {
              firstElement: r,
              lastElement: s
            } = this._getMergeSubjectElements(n, e),
            a = r.getAttribute("listIndent") || 0,
            l = s.getAttribute("listIndent"),
            c = s.getAttribute("listItemId");
          if (a != l) {
            const e = (d = s, Array.from(new Mx(d, {
              direction: "forward",
              higherIndent: !0
            })));
            i.push(...Kx([s, ...e], o, {
              indentBy: a - l,
              expand: a < l
            }));
          }
          var d;
          if (e) {
            let e = n;
            n.isCollapsed && (e = o.createSelection(o.createRange(o.createPositionAt(r, "end"), o.createPositionAt(s, 0)))), t.deleteContent(e, {
              doNotResetEntireContent: n.isCollapsed
            });
            const a = e.getLastPosition().parent,
              l = a.nextSibling;
            i.push(a), l && l !== s && l.getAttribute("listItemId") == c && i.push(...Gx(l, a, o));
          } else i.push(...Gx(s, r, o));
          this._fireAfterExecute(i);
        });
      }
      _fireAfterExecute(e) {
        this.fire("afterExecute", $x(new Set(e)));
      }
      _checkEnabled() {
        const e = this.editor.model,
          t = e.document.selection,
          n = Zx(e);
        if (t.isCollapsed || n) {
          const e = n || t.getFirstPosition().parent;
          if (!Lx(e)) return !1;
          const i = "backward" == this._direction ? e.previousSibling : e.nextSibling;
          if (!i) return !1;
          if (Yx([e, i])) return !1;
        } else {
          const e = t.getLastPosition(),
            n = t.getFirstPosition();
          if (e.parent === n.parent) return !1;
          if (!Lx(e.parent)) return !1;
        }
        return !0;
      }
      _getMergeSubjectElements(e, t) {
        const n = Zx(this.editor.model);
        let i, o;
        if (e.isCollapsed || n) {
          const r = n || e.getFirstPosition().parent,
            s = Fx(r);
          "backward" == this._direction ? (o = r, i = s && !t ? Mx.first(r, {
            sameIndent: !0,
            lowerIndent: !0
          }) : r.previousSibling) : (i = r, o = r.nextSibling);
        } else i = e.getFirstPosition().parent, o = e.getLastPosition().parent;
        return {
          firstElement: i,
          lastElement: o
        };
      }
    }
    class oE extends Pr {
      constructor(e, t) {
        super(e), this._direction = t;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        this.editor.model.change(e => {
          const t = qx(this._getStartBlock(), e);
          this._fireAfterExecute(t);
        });
      }
      _fireAfterExecute(e) {
        this.fire("afterExecute", $x(new Set(e)));
      }
      _checkEnabled() {
        const e = this.editor.model.document.selection,
          t = this._getStartBlock();
        return e.isCollapsed && Lx(t) && !Fx(t);
      }
      _getStartBlock() {
        const e = this.editor.model.document.selection.getFirstPosition().parent;
        return "before" == this._direction ? e : e.nextSibling;
      }
    }
    class rE extends Br {
      static get pluginName() {
        return "ListUtils";
      }
      expandListBlocksToCompleteList(e) {
        return Ux(e);
      }
      isFirstBlockOfListItem(e) {
        return Fx(e);
      }
      isListItemBlock(e) {
        return Lx(e);
      }
      expandListBlocksToCompleteItems(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Hx(e, t);
      }
      isNumberedListType(e) {
        return Jx(e);
      }
    }
    function sE(e) {
      return e.is("element", "ol") || e.is("element", "ul");
    }
    function aE(e) {
      return e.is("element", "li");
    }
    function lE(e, t, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : uE(n, t);
      return e.createAttributeElement(dE(n), null, {
        priority: 2 * t / 100 - 100,
        id: i
      });
    }
    function cE(e, t, n) {
      return e.createAttributeElement("li", null, {
        priority: (2 * t + 1) / 100 - 100,
        id: n
      });
    }
    function dE(e) {
      return "numbered" == e || "customNumbered" == e ? "ol" : "ul";
    }
    function uE(e, t) {
      return "list-".concat(e, "-").concat(t);
    }
    function hE(e, t) {
      const n = e.nodeBefore;
      if (Lx(n)) {
        let e = n;
        for (const {
          node: n
        } of Px(e, "backward")) if (e = n, t.has(e)) return;
        t.set(n, e);
      } else {
        const n = e.nodeAfter;
        Lx(n) && t.set(n, n);
      }
    }
    function mE() {
      return (e, t, n) => {
        const {
          writer: i,
          schema: o
        } = n;
        if (!t.modelRange) return;
        const r = Array.from(t.modelRange.getItems({
          shallow: !0
        })).filter(e => o.checkAttribute(e, "listItemId"));
        if (!r.length) return;
        const s = Nx.next(),
          a = function (e) {
            let t = 0,
              n = e.parent;
            for (; n;) {
              if (aE(n)) t++;else {
                const e = n.previousSibling;
                e && aE(e) && t++;
              }
              n = n.parent;
            }
            return t;
          }(t.viewItem);
        let l = t.viewItem.parent && t.viewItem.parent.is("element", "ol") ? "numbered" : "bulleted";
        const c = r[0].getAttribute("listType");
        c && (l = c);
        const d = {
          listItemId: s,
          listIndent: a,
          listType: l
        };
        for (const e of r) e.hasAttribute("listItemId") || i.setAttributes(d, e);
        r.length > 1 && r[1].getAttribute("listItemId") != d.listItemId && n.keepEmptyElement(r[0]);
      };
    }
    function pE() {
      return (e, t, n) => {
        if (!n.consumable.test(t.viewItem, {
          name: !0
        })) return;
        const i = new Xu(t.viewItem.document);
        for (const e of Array.from(t.viewItem.getChildren())) aE(e) || sE(e) || i.remove(e);
      };
    }
    function gE(e, t, n) {
      let {
        dataPipeline: i
      } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const o = function (e) {
        return (t, n) => {
          const i = [];
          for (const n of e) t.hasAttribute(n) && i.push("attribute:".concat(n));
          return !!i.every(e => !1 !== n.test(t, e)) && (i.forEach(e => n.consume(t, e)), !0);
        };
      }(e);
      return (r, s, a) => {
        const {
            writer: l,
            mapper: c,
            consumable: d
          } = a,
          u = s.item;
        if (!e.includes(s.attributeKey)) return;
        if (!o(u, d)) return;
        const h = function (e, t, n) {
          const i = n.createRangeOn(e),
            o = t.toViewRange(i).getTrimmed();
          return o.end.nodeBefore;
        }(u, c, n);
        kE(h, l, c), function (e, t) {
          let n = e.parent;
          for (; n.is("attributeElement") && ["ul", "ol", "li"].includes(n.name);) {
            const i = n.parent;
            t.unwrap(t.createRangeOn(e), n), n = i;
          }
        }(h, l);
        const m = function (e, t, n, i, _ref117) {
          let {
            dataPipeline: o
          } = _ref117;
          let r = i.createRangeOn(t);
          if (!Fx(e)) return r;
          for (const s of n) {
            if ("itemMarker" != s.scope) continue;
            const n = s.createElement(i, e, {
              dataPipeline: o
            });
            if (!n) continue;
            if (i.setCustomProperty("listItemMarker", !0, n), s.canInjectMarkerIntoElement && s.canInjectMarkerIntoElement(e) ? i.insert(i.createPositionAt(t, 0), n) : (i.insert(r.start, n), r = i.createRange(i.createPositionBefore(n), i.createPositionAfter(t))), !s.createWrapperElement || !s.canWrapElement) continue;
            const a = s.createWrapperElement(i, e, {
              dataPipeline: o
            });
            i.setCustomProperty("listItemWrapper", !0, a), s.canWrapElement(e) ? r = i.wrap(r, a) : (r = i.wrap(i.createRangeOn(n), a), r = i.createRange(r.start, i.createPositionAfter(t)));
          }
          return r;
        }(u, h, t, l, {
          dataPipeline: i
        });
        !function (e, t, n, i) {
          if (!e.hasAttribute("listIndent")) return;
          const o = e.getAttribute("listIndent");
          let r = e;
          for (let e = o; e >= 0; e--) {
            const o = cE(i, e, r.getAttribute("listItemId")),
              s = lE(i, e, r.getAttribute("listType"));
            for (const e of n) "list" != e.scope && "item" != e.scope || !r.hasAttribute(e.attributeName) || e.setAttributeOnDowncast(i, r.getAttribute(e.attributeName), "list" == e.scope ? s : o);
            if (t = i.wrap(t, o), t = i.wrap(t, s), 0 == e) break;
            if (r = Mx.first(r, {
              lowerIndent: !0
            }), !r) break;
          }
        }(u, m, t, l);
      };
    }
    function fE(e) {
      let {
        dataPipeline: t
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (n, _ref118) => {
        let {
          writer: i
        } = _ref118;
        if (!bE(n, e)) return null;
        if (!t) return i.createContainerElement("span", {
          class: "ck-list-bogus-paragraph"
        });
        const o = i.createContainerElement("p");
        return i.setCustomProperty("dataPipeline:transparentRendering", !0, o), o;
      };
    }
    function kE(e, t, n) {
      for (; e.parent.is("attributeElement") && e.parent.getCustomProperty("listItemWrapper");) t.unwrap(t.createRangeOn(e), e.parent);
      const i = [];
      o(t.createPositionBefore(e).getWalker({
        direction: "backward"
      })), o(t.createRangeIn(e).getWalker());
      for (const e of i) t.remove(e);
      function o(e) {
        for (const {
          item: t
        } of e) {
          if (t.is("element") && n.toModelElement(t)) break;
          t.is("element") && t.getCustomProperty("listItemMarker") && i.push(t);
        }
      }
    }
    function bE(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Rx(e);
      if (!Lx(e)) return !1;
      for (const n of e.getAttributeKeys()) if (!n.startsWith("selection:") && !t.includes(n)) return !1;
      return n.length < 2;
    }
    var _E = o(9309),
      wE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(_E.A, wE);
    _E.A.locals;
    var AE = o(6498),
      vE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(AE.A, vE);
    AE.A.locals;
    const CE = ["listType", "listIndent", "listItemId"];
    class yE extends Br {
      static get pluginName() {
        return "ListEditing";
      }
      static get requires() {
        return [P_, zb, rE, mw];
      }
      constructor(e) {
        super(e), this._downcastStrategies = [], e.config.define("list.multiBlock", !0);
      }
      init() {
        const e = this.editor,
          t = e.model,
          n = e.config.get("list.multiBlock");
        if (e.plugins.has("LegacyListEditing")) throw new _("list-feature-conflict", this, {
          conflictPlugin: "LegacyListEditing"
        });
        t.schema.register("$listItem", {
          allowAttributes: CE
        }), n ? (t.schema.extend("$container", {
          allowAttributesOf: "$listItem"
        }), t.schema.extend("$block", {
          allowAttributesOf: "$listItem"
        }), t.schema.extend("$blockObject", {
          allowAttributesOf: "$listItem"
        })) : t.schema.register("listItem", {
          inheritAllFrom: "$block",
          allowAttributesOf: "$listItem"
        });
        for (const e of CE) t.schema.setAttributeProperties(e, {
          copyOnReplace: !0
        });
        e.commands.add("numberedList", new nE(e, "numbered")), e.commands.add("bulletedList", new nE(e, "bulleted")), e.commands.add("customNumberedList", new nE(e, "customNumbered", {
          multiLevel: !0
        })), e.commands.add("customBulletedList", new nE(e, "customBulleted", {
          multiLevel: !0
        })), e.commands.add("indentList", new eE(e, "forward")), e.commands.add("outdentList", new eE(e, "backward")), e.commands.add("splitListItemBefore", new oE(e, "before")), e.commands.add("splitListItemAfter", new oE(e, "after")), n && (e.commands.add("mergeListItemBackward", new iE(e, "backward")), e.commands.add("mergeListItemForward", new iE(e, "forward"))), this._setupDeleteIntegration(), this._setupEnterIntegration(), this._setupTabIntegration(), this._setupClipboardIntegration(), this._setupAccessibilityIntegration();
      }
      afterInit() {
        const e = this.editor.commands,
          t = e.get("indent"),
          n = e.get("outdent");
        t && t.registerChildCommand(e.get("indentList"), {
          priority: "high"
        }), n && n.registerChildCommand(e.get("outdentList"), {
          priority: "lowest"
        }), this._setupModelPostFixing(), this._setupConversion();
      }
      registerDowncastStrategy(e) {
        this._downcastStrategies.push(e);
      }
      getListAttributeNames() {
        return [...CE, ...this._downcastStrategies.map(e => e.attributeName)];
      }
      _setupDeleteIntegration() {
        const e = this.editor,
          t = e.commands.get("mergeListItemBackward"),
          n = e.commands.get("mergeListItemForward");
        this.listenTo(e.editing.view.document, "delete", (i, o) => {
          const r = e.model.document.selection;
          Zx(e.model) || e.model.change(() => {
            const s = r.getFirstPosition();
            if (r.isCollapsed && "backward" == o.direction) {
              if (!s.isAtStart) return;
              const n = s.parent;
              if (!Lx(n)) return;
              if (Mx.first(n, {
                sameAttributes: "listType",
                sameIndent: !0
              }) || 0 !== n.getAttribute("listIndent")) {
                if (!t || !t.isEnabled) return;
                t.execute({
                  shouldMergeOnBlocksContentLevel: xE(e.model, "backward")
                });
              } else jx(n) || e.execute("splitListItemAfter"), e.execute("outdentList");
              o.preventDefault(), i.stop();
            } else {
              if (r.isCollapsed && !r.getLastPosition().isAtEnd) return;
              if (!n || !n.isEnabled) return;
              n.execute({
                shouldMergeOnBlocksContentLevel: xE(e.model, "forward")
              }), o.preventDefault(), i.stop();
            }
          });
        }, {
          context: "li"
        });
      }
      _setupEnterIntegration() {
        const e = this.editor,
          t = e.model,
          n = e.commands,
          i = n.get("enter");
        this.listenTo(e.editing.view.document, "enter", (n, i) => {
          const o = t.document,
            r = o.selection.getFirstPosition().parent;
          if (o.selection.isCollapsed && Lx(r) && r.isEmpty && !i.isSoft) {
            const t = Fx(r),
              o = jx(r);
            t && o ? (e.execute("outdentList"), i.preventDefault(), n.stop()) : t && !o ? (e.execute("splitListItemAfter"), i.preventDefault(), n.stop()) : o && (e.execute("splitListItemBefore"), i.preventDefault(), n.stop());
          }
        }, {
          context: "li"
        }), this.listenTo(i, "afterExecute", () => {
          const t = n.get("splitListItemBefore");
          if (t.refresh(), !t.isEnabled) return;
          2 === Rx(e.model.document.selection.getLastPosition().parent).length && t.execute();
        });
      }
      _setupTabIntegration() {
        const e = this.editor;
        this.listenTo(e.editing.view.document, "tab", (t, n) => {
          const i = n.shiftKey ? "outdentList" : "indentList";
          this.editor.commands.get(i).isEnabled && (e.execute(i), n.stopPropagation(), n.preventDefault(), t.stop());
        }, {
          context: "li"
        });
      }
      _setupConversion() {
        const e = this.editor,
          t = e.model,
          n = this.getListAttributeNames(),
          i = e.config.get("list.multiBlock"),
          o = i ? "paragraph" : "listItem";
        e.conversion.for("upcast").elementToElement({
          view: "li",
          model: (e, _ref119) => {
            let {
              writer: t
            } = _ref119;
            return t.createElement(o, {
              listType: ""
            });
          }
        }).elementToElement({
          view: "p",
          model: (e, _ref120) => {
            let {
              writer: t
            } = _ref120;
            return e.parent && e.parent.is("element", "li") ? t.createElement(o, {
              listType: ""
            }) : null;
          },
          converterPriority: "high"
        }).add(e => {
          e.on("element:li", mE()), e.on("element:ul", pE(), {
            priority: "high"
          }), e.on("element:ol", pE(), {
            priority: "high"
          });
        }), i || e.conversion.for("downcast").elementToElement({
          model: "listItem",
          view: "p"
        }), e.conversion.for("editingDowncast").elementToElement({
          model: o,
          view: fE(n),
          converterPriority: "high"
        }).add(e => {
          var i;
          e.on("attribute", gE(n, this._downcastStrategies, t)), e.on("remove", (i = t.schema, (e, t, n) => {
            const {
                writer: o,
                mapper: r
              } = n,
              s = e.name.split(":")[1];
            if (!i.checkAttribute(s, "listItemId")) return;
            const a = r.toViewPosition(t.position),
              l = t.position.getShiftedBy(t.length),
              c = r.toViewPosition(l, {
                isPhantom: !0
              }),
              d = o.createRange(a, c).getTrimmed().end.nodeBefore;
            d && kE(d, o, r);
          }));
        }), e.conversion.for("dataDowncast").elementToElement({
          model: o,
          view: fE(n, {
            dataPipeline: !0
          }),
          converterPriority: "high"
        }).add(e => {
          e.on("attribute", gE(n, this._downcastStrategies, t, {
            dataPipeline: !0
          }));
        });
        const r = (s = this._downcastStrategies, a = e.editing.view, (e, t) => {
          if (t.modelPosition.offset > 0) return;
          const n = t.modelPosition.parent;
          if (!Lx(n)) return;
          if (!s.some(e => "itemMarker" == e.scope && e.canInjectMarkerIntoElement && e.canInjectMarkerIntoElement(n))) return;
          const i = t.mapper.toViewElement(n),
            o = a.createRangeIn(i),
            r = o.getWalker();
          let l = o.start;
          for (const {
            item: e
          } of r) {
            if (e.is("element") && t.mapper.toModelElement(e) || e.is("$textProxy")) break;
            e.is("element") && e.getCustomProperty("listItemMarker") && (l = a.createPositionAfter(e), r.skip(_ref121 => {
              let {
                previousPosition: e
              } = _ref121;
              return !e.isEqual(l);
            }));
          }
          t.viewPosition = l;
        });
        var s, a;
        e.editing.mapper.on("modelToViewPosition", r), e.data.mapper.on("modelToViewPosition", r), this.listenTo(t.document, "change:data", function (e, t, n, i) {
          return () => {
            const i = e.document.differ.getChanges(),
              s = [],
              a = new Map(),
              l = new Set();
            for (const e of i) if ("insert" == e.type && "$text" != e.name) hE(e.position, a), e.attributes.has("listItemId") ? l.add(e.position.nodeAfter) : hE(e.position.getShiftedBy(e.length), a);else if ("remove" == e.type && e.attributes.has("listItemId")) hE(e.position, a);else if ("attribute" == e.type) {
              const t = e.range.start.nodeAfter;
              n.includes(e.attributeKey) ? (hE(e.range.start, a), null === e.attributeNewValue ? (hE(e.range.start.getShiftedBy(1), a), r(t) && s.push(t)) : l.add(t)) : Lx(t) && r(t) && s.push(t);
            }
            for (const e of a.values()) s.push(...o(e, l));
            for (const e of new Set(s)) t.reconvertItem(e);
          };
          function o(e, t) {
            const i = [],
              o = new Set(),
              a = [];
            for (const {
              node: l,
              previous: c
            } of Px(e, "forward")) {
              if (o.has(l)) continue;
              const e = l.getAttribute("listIndent");
              c && e < c.getAttribute("listIndent") && (a.length = e + 1), a[e] = Object.fromEntries(Array.from(l.getAttributes()).filter(_ref122 => {
                let [e] = _ref122;
                return n.includes(e);
              }));
              const d = Vx(l, {
                direction: "forward"
              });
              for (const e of d) o.add(e), (r(e, d) || s(e, a, t)) && i.push(e);
            }
            return i;
          }
          function r(e, o) {
            const r = t.mapper.toViewElement(e);
            if (!r) return !1;
            if (i.fire("checkElement", {
              modelElement: e,
              viewElement: r
            })) return !0;
            if (!e.is("element", "paragraph") && !e.is("element", "listItem")) return !1;
            const s = bE(e, n, o);
            return !(!s || !r.is("element", "p")) || !(s || !r.is("element", "span"));
          }
          function s(e, n, o) {
            if (o.has(e)) return !1;
            const r = t.mapper.toViewElement(e);
            let s = n.length - 1;
            for (let e = r.parent; !e.is("editableElement"); e = e.parent) {
              const t = aE(e),
                o = sE(e);
              if (!o && !t) continue;
              const r = "checkAttributes:" + (t ? "item" : "list");
              if (i.fire(r, {
                viewElement: e,
                modelAttributes: n[s]
              })) break;
              if (o && (s--, s < 0)) return !1;
            }
            return !0;
          }
        }(t, e.editing, n, this), {
          priority: "high"
        }), this.on("checkAttributes:item", (e, _ref123) => {
          let {
            viewElement: t,
            modelAttributes: n
          } = _ref123;
          t.id != n.listItemId && (e.return = !0, e.stop());
        }), this.on("checkAttributes:list", (e, _ref124) => {
          let {
            viewElement: t,
            modelAttributes: n
          } = _ref124;
          t.name == dE(n.listType) && t.id == uE(n.listType, n.listIndent) || (e.return = !0, e.stop());
        });
      }
      _setupModelPostFixing() {
        const e = this.editor.model,
          t = this.getListAttributeNames();
        e.document.registerPostFixer(n => function (e, t, n, i) {
          const o = e.document.differ.getChanges(),
            r = new Map(),
            s = i.editor.config.get("list.multiBlock");
          let a = !1;
          for (const i of o) {
            if ("insert" == i.type && "$text" != i.name) {
              const o = i.position.nodeAfter;
              if (!e.schema.checkAttribute(o, "listItemId")) for (const e of Array.from(o.getAttributeKeys())) n.includes(e) && (t.removeAttribute(e, o), a = !0);
              hE(i.position, r), i.attributes.has("listItemId") || hE(i.position.getShiftedBy(i.length), r);
              for (const {
                item: t,
                previousPosition: n
              } of e.createRangeIn(o)) Lx(t) && hE(n, r);
            } else "remove" == i.type ? hE(i.position, r) : "attribute" == i.type && n.includes(i.attributeKey) && (hE(i.range.start, r), null === i.attributeNewValue && hE(i.range.start.getShiftedBy(1), r));
            if (!s && "attribute" == i.type && CE.includes(i.attributeKey)) {
              const e = i.range.start.nodeAfter;
              null === i.attributeNewValue && e && e.is("element", "listItem") ? (t.rename(e, "paragraph"), a = !0) : null === i.attributeOldValue && e && e.is("element") && "listItem" != e.name && (t.rename(e, "listItem"), a = !0);
            }
          }
          const l = new Set();
          for (const e of r.values()) a = i.fire("postFixer", {
            listNodes: new zx(e),
            listHead: e,
            writer: t,
            seenIds: l
          }) || a;
          return a;
        }(e, n, t, this)), this.on("postFixer", (e, _ref125) => {
          let {
            listNodes: t,
            writer: n
          } = _ref125;
          e.return = function (e, t) {
            let n = 0,
              i = -1,
              o = null,
              r = !1;
            for (const {
              node: s
            } of e) {
              const e = s.getAttribute("listIndent");
              if (e > n) {
                let a;
                null === o ? (o = e - n, a = n) : (o > e && (o = e), a = e - o), a > i + 1 && (a = i + 1), t.setAttribute("listIndent", a, s), r = !0, i = a;
              } else o = null, n = e + 1, i = e;
            }
            return r;
          }(t, n) || e.return;
        }, {
          priority: "high"
        }), this.on("postFixer", (e, _ref126) => {
          let {
            listNodes: t,
            writer: n,
            seenIds: i
          } = _ref126;
          e.return = function (e, t, n) {
            const i = new Set();
            let o = !1;
            for (const {
              node: r
            } of e) {
              if (i.has(r)) continue;
              let e = r.getAttribute("listType"),
                s = r.getAttribute("listItemId");
              if (t.has(s) && (s = Nx.next()), t.add(s), r.is("element", "listItem")) r.getAttribute("listItemId") != s && (n.setAttribute("listItemId", s, r), o = !0);else for (const t of Vx(r, {
                direction: "forward"
              })) i.add(t), t.getAttribute("listType") != e && (s = Nx.next(), e = t.getAttribute("listType")), t.getAttribute("listItemId") != s && (n.setAttribute("listItemId", s, t), o = !0);
            }
            return o;
          }(t, i, n) || e.return;
        }, {
          priority: "high"
        });
      }
      _setupClipboardIntegration() {
        const e = this.editor.model,
          t = this.editor.plugins.get("ClipboardPipeline");
        this.listenTo(e, "insertContent", function (e) {
          return (t, _ref127) => {
            let [n, i] = _ref127;
            const o = n.is("documentFragment") ? Array.from(n.getChildren()) : [n];
            if (!o.length) return;
            const r = (i ? e.createSelection(i) : e.document.selection).getFirstPosition();
            let s;
            if (Lx(r.parent)) s = r.parent;else {
              if (!Lx(r.nodeBefore)) return;
              s = r.nodeBefore;
            }
            e.change(e => {
              const t = s.getAttribute("listType"),
                n = s.getAttribute("listIndent"),
                i = o[0].getAttribute("listIndent") || 0,
                r = Math.max(n - i, 0);
              for (const n of o) {
                const i = Lx(n);
                s.is("element", "listItem") && n.is("element", "paragraph") && e.rename(n, "listItem"), e.setAttributes({
                  listIndent: (i ? n.getAttribute("listIndent") : 0) + r,
                  listItemId: i ? n.getAttribute("listItemId") : Nx.next(),
                  listType: t
                }, n);
              }
            });
          };
        }(e), {
          priority: "high"
        }), this.listenTo(t, "outputTransformation", (t, n) => {
          e.change(e => {
            const t = Array.from(n.content.getChildren()),
              i = t[t.length - 1];
            if (t.length > 1 && i.is("element") && i.isEmpty) {
              t.slice(0, -1).every(Lx) && e.remove(i);
            }
            if ("copy" == n.method || "cut" == n.method) {
              const t = Array.from(n.content.getChildren());
              Yx(t) && Wx(t, e);
            }
          });
        });
      }
      _setupAccessibilityIntegration() {
        const e = this.editor,
          t = e.t;
        e.accessibility.addKeystrokeInfoGroup({
          id: "list",
          label: t("Keystrokes that can be used in a list"),
          keystrokes: [{
            label: t("Increase list item indent"),
            keystroke: "Tab"
          }, {
            label: t("Decrease list item indent"),
            keystroke: "Shift+Tab"
          }]
        });
      }
    }
    function xE(e, t) {
      const n = e.document.selection;
      if (!n.isCollapsed) return !Zx(e);
      if ("forward" === t) return !0;
      const i = n.getFirstPosition().parent,
        o = i.previousSibling;
      return !e.schema.isObject(o) && (!!o.isEmpty || Yx([i, o]));
    }
    function EE(e, t, n, i) {
      e.ui.componentFactory.add(t, () => {
        const o = SE(um, e, t, n, i);
        return o.set({
          tooltip: !0,
          isToggleable: !0
        }), o;
      }), e.ui.componentFactory.add("menuBar:".concat(t), () => SE(qk, e, t, n, i));
    }
    function SE(e, t, n, i, o) {
      const r = t.commands.get(n),
        s = new e(t.locale);
      return s.set({
        label: i,
        icon: o
      }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", () => {
        t.execute(n), t.editing.view.focus();
      }), s;
    }
    class DE extends Br {
      static get pluginName() {
        return "ListUI";
      }
      init() {
        const e = this.editor.t;
        this.editor.ui.componentFactory.has("numberedList") || EE(this.editor, "numberedList", e("Numbered List"), Wh.numberedList), this.editor.ui.componentFactory.has("bulletedList") || EE(this.editor, "bulletedList", e("Bulleted List"), Wh.bulletedList);
      }
    }
    class TE extends Br {
      static get requires() {
        return [yE, DE];
      }
      static get pluginName() {
        return "List";
      }
    }
    class IE extends Pr {
      refresh() {
        const e = this._getValue();
        this.value = e, this.isEnabled = null != e;
      }
      execute() {
        let {
          startIndex: e = 1
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document;
        let i = Array.from(n.selection.getSelectedBlocks()).filter(e => Lx(e) && Jx(e.getAttribute("listType")));
        i = Ux(i), t.change(t => {
          for (const n of i) t.setAttribute("listStart", e >= 0 ? e : 1, n);
        });
      }
      _getValue() {
        const e = Go(this.editor.model.document.selection.getSelectedBlocks());
        return e && Lx(e) && Jx(e.getAttribute("listType")) ? e.getAttribute("listStart") : null;
      }
    }
    const BE = {},
      ME = {},
      PE = {},
      zE = [{
        listStyle: "disc",
        typeAttribute: "disc",
        listType: "bulleted"
      }, {
        listStyle: "circle",
        typeAttribute: "circle",
        listType: "bulleted"
      }, {
        listStyle: "square",
        typeAttribute: "square",
        listType: "bulleted"
      }, {
        listStyle: "decimal",
        typeAttribute: "1",
        listType: "numbered"
      }, {
        listStyle: "decimal-leading-zero",
        typeAttribute: null,
        listType: "numbered"
      }, {
        listStyle: "lower-roman",
        typeAttribute: "i",
        listType: "numbered"
      }, {
        listStyle: "upper-roman",
        typeAttribute: "I",
        listType: "numbered"
      }, {
        listStyle: "lower-alpha",
        typeAttribute: "a",
        listType: "numbered"
      }, {
        listStyle: "upper-alpha",
        typeAttribute: "A",
        listType: "numbered"
      }, {
        listStyle: "lower-latin",
        typeAttribute: "a",
        listType: "numbered"
      }, {
        listStyle: "upper-latin",
        typeAttribute: "A",
        listType: "numbered"
      }];
    for (const {
      listStyle: e,
      typeAttribute: t,
      listType: n
    } of zE) BE[e] = n, ME[e] = t, t && (PE[t] = e);
    function NE() {
      return zE.map(e => e.listStyle);
    }
    function LE(e) {
      return BE[e] || null;
    }
    function RE(e) {
      return PE[e] || null;
    }
    function VE(e) {
      return ME[e] || null;
    }
    class OE extends Pr {
      constructor(e, t, n) {
        super(e), this.defaultType = t, this._supportedTypes = n;
      }
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document;
        t.change(t => {
          this._tryToConvertItemsToList(e);
          let i = Array.from(n.selection.getSelectedBlocks()).filter(e => e.hasAttribute("listType"));
          if (i.length) {
            i = Ux(i);
            for (const n of i) t.setAttribute("listStyle", e.type || this.defaultType, n);
          }
        });
      }
      isStyleTypeSupported(e) {
        return !this._supportedTypes || this._supportedTypes.includes(e);
      }
      _getValue() {
        const e = Go(this.editor.model.document.selection.getSelectedBlocks());
        return Lx(e) ? e.getAttribute("listStyle") : null;
      }
      _checkEnabled() {
        const e = this.editor,
          t = e.commands.get("numberedList"),
          n = e.commands.get("bulletedList");
        return t.isEnabled || n.isEnabled;
      }
      _tryToConvertItemsToList(e) {
        if (!e.type) return;
        const t = LE(e.type);
        if (!t) return;
        const n = this.editor,
          i = "".concat(t, "List");
        n.commands.get(i).value || n.execute(i);
      }
    }
    class FE extends Pr {
      refresh() {
        const e = this._getValue();
        this.value = e, this.isEnabled = null != e;
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document;
        let i = Array.from(n.selection.getSelectedBlocks()).filter(e => Lx(e) && "numbered" == e.getAttribute("listType"));
        i = Ux(i), t.change(t => {
          for (const n of i) t.setAttribute("listReversed", !!e.reversed, n);
        });
      }
      _getValue() {
        const e = Go(this.editor.model.document.selection.getSelectedBlocks());
        return Lx(e) && "numbered" == e.getAttribute("listType") ? e.getAttribute("listReversed") : null;
      }
    }
    function jE(e) {
      return (t, n, i) => {
        const {
          writer: o,
          schema: r,
          consumable: s
        } = i;
        if (!1 === s.test(n.viewItem, e.viewConsumables)) return;
        n.modelRange || Object.assign(n, i.convertChildren(n.viewItem, n.modelCursor));
        let a = !1;
        for (const t of n.modelRange.getItems({
          shallow: !0
        })) r.checkAttribute(t, e.attributeName) && e.appliesToListItem(t) && (t.hasAttribute(e.attributeName) || (o.setAttribute(e.attributeName, e.getAttributeOnUpcast(n.viewItem), t), a = !0));
        a && s.consume(n.viewItem, e.viewConsumables);
      };
    }
    class HE extends Br {
      static get pluginName() {
        return "ListPropertiesUtils";
      }
      getAllSupportedStyleTypes() {
        return NE();
      }
      getListTypeFromListStyleType(e) {
        return LE(e);
      }
      getListStyleTypeFromTypeAttribute(e) {
        return RE(e);
      }
      getTypeAttributeFromListStyleType(e) {
        return VE(e);
      }
    }
    const UE = "default";
    class qE extends Br {
      static get requires() {
        return [yE, HE];
      }
      static get pluginName() {
        return "ListPropertiesEditing";
      }
      constructor(e) {
        super(e), e.config.define("list.properties", {
          styles: !0,
          startIndex: !1,
          reversed: !1
        });
      }
      init() {
        const e = this.editor,
          t = e.model,
          n = e.plugins.get(yE),
          i = function (e) {
            const t = [];
            if (e.styles) {
              const n = "object" == typeof e.styles && e.styles.useAttribute;
              t.push({
                attributeName: "listStyle",
                defaultValue: UE,
                viewConsumables: {
                  styles: "list-style-type"
                },
                addCommand(e) {
                  let t = NE();
                  n && (t = t.filter(e => !!VE(e))), e.commands.add("listStyle", new OE(e, UE, t));
                },
                appliesToListItem: e => "numbered" == e.getAttribute("listType") || "bulleted" == e.getAttribute("listType"),
                hasValidAttribute(e) {
                  if (!this.appliesToListItem(e)) return !e.hasAttribute("listStyle");
                  if (!e.hasAttribute("listStyle")) return !1;
                  const t = e.getAttribute("listStyle");
                  return t == UE || LE(t) == e.getAttribute("listType");
                },
                setAttributeOnDowncast(e, t, i) {
                  if (t && t !== UE) {
                    if (!n) return void e.setStyle("list-style-type", t, i);
                    {
                      const n = VE(t);
                      if (n) return void e.setAttribute("type", n, i);
                    }
                  }
                  e.removeStyle("list-style-type", i), e.removeAttribute("type", i);
                },
                getAttributeOnUpcast(e) {
                  const t = e.getStyle("list-style-type");
                  if (t) return t;
                  const n = e.getAttribute("type");
                  return n ? RE(n) : UE;
                }
              });
            }
            e.reversed && t.push({
              attributeName: "listReversed",
              defaultValue: !1,
              viewConsumables: {
                attributes: "reversed"
              },
              addCommand(e) {
                e.commands.add("listReversed", new FE(e));
              },
              appliesToListItem: e => "numbered" == e.getAttribute("listType"),
              hasValidAttribute(e) {
                return this.appliesToListItem(e) == e.hasAttribute("listReversed");
              },
              setAttributeOnDowncast(e, t, n) {
                t ? e.setAttribute("reversed", "reversed", n) : e.removeAttribute("reversed", n);
              },
              getAttributeOnUpcast: e => e.hasAttribute("reversed")
            });
            e.startIndex && t.push({
              attributeName: "listStart",
              defaultValue: 1,
              viewConsumables: {
                attributes: "start"
              },
              addCommand(e) {
                e.commands.add("listStart", new IE(e));
              },
              appliesToListItem: e => Jx(e.getAttribute("listType")),
              hasValidAttribute(e) {
                return this.appliesToListItem(e) == e.hasAttribute("listStart");
              },
              setAttributeOnDowncast(e, t, n) {
                0 == t || t > 1 ? e.setAttribute("start", t, n) : e.removeAttribute("start", n);
              },
              getAttributeOnUpcast(e) {
                const t = e.getAttribute("start");
                return t >= 0 ? t : 1;
              }
            });
            return t;
          }(e.config.get("list.properties"));
        for (const o of i) o.addCommand(e), t.schema.extend("$listItem", {
          allowAttributes: o.attributeName
        }), n.registerDowncastStrategy({
          scope: "list",
          attributeName: o.attributeName,
          setAttributeOnDowncast(e, t, n) {
            o.setAttributeOnDowncast(e, t, n);
          }
        });
        e.conversion.for("upcast").add(e => {
          for (const t of i) e.on("element:ol", jE(t)), e.on("element:ul", jE(t));
        }), n.on("checkAttributes:list", (e, _ref128) => {
          let {
            viewElement: t,
            modelAttributes: n
          } = _ref128;
          for (const o of i) o.getAttributeOnUpcast(t) != n[o.attributeName] && (e.return = !0, e.stop());
        }), this.listenTo(e.commands.get("indentList"), "afterExecute", (e, n) => {
          t.change(e => {
            for (const t of n) for (const n of i) n.appliesToListItem(t) && e.setAttribute(n.attributeName, n.defaultValue, t);
          });
        }), n.on("postFixer", (e, _ref129) => {
          let {
            listNodes: t,
            writer: n
          } = _ref129;
          for (const {
            node: o
          } of t) for (const t of i) t.hasValidAttribute(o) || (t.appliesToListItem(o) ? n.setAttribute(t.attributeName, t.defaultValue, o) : n.removeAttribute(t.attributeName, o), e.return = !0);
        }), n.on("postFixer", (e, _ref130) => {
          let {
            listNodes: t,
            writer: n
          } = _ref130;
          for (const {
            node: o,
            previousNodeInList: r
          } of t) if (r && r.getAttribute("listType") == o.getAttribute("listType")) for (const t of i) {
            const {
              attributeName: i
            } = t;
            if (!t.appliesToListItem(o)) continue;
            const s = r.getAttribute(i);
            o.getAttribute(i) != s && (n.setAttribute(i, s, o), e.return = !0);
          }
        });
      }
    }
    var GE = o(661),
      KE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(GE.A, KE);
    GE.A.locals;
    class WE extends Er {
      constructor(e, _ref131) {
        let {
          enabledProperties: t,
          styleButtonViews: n,
          styleGridAriaLabel: i
        } = _ref131;
        super(e), this.stylesView = null, this.additionalPropertiesCollapsibleView = null, this.startIndexFieldView = null, this.reversedSwitchButtonView = null, this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.focusables = new er();
        const o = ["ck", "ck-list-properties"];
        this.children = this.createCollection(), this.focusCycler = new Jm({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), t.styles ? (this.stylesView = this._createStylesView(n, i), this.children.add(this.stylesView)) : o.push("ck-list-properties_without-styles"), (t.startIndex || t.reversed) && (this._addNumberedListPropertyViews(t), o.push("ck-list-properties_with-numbered-properties")), this.setTemplate({
          tag: "div",
          attributes: {
            class: o
          },
          children: this.children
        });
      }
      render() {
        if (super.render(), this.stylesView) {
          this.focusables.add(this.stylesView), this.focusTracker.add(this.stylesView.element), (this.startIndexFieldView || this.reversedSwitchButtonView) && (this.focusables.add(this.children.last.buttonView), this.focusTracker.add(this.children.last.buttonView.element));
          for (const e of this.stylesView.children) this.stylesView.focusTracker.add(e.element);
          Ir({
            keystrokeHandler: this.stylesView.keystrokes,
            focusTracker: this.stylesView.focusTracker,
            gridItems: this.stylesView.children,
            numberOfColumns: () => t.window.getComputedStyle(this.stylesView.element).getPropertyValue("grid-template-columns").split(" ").length,
            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
          });
        }
        if (this.startIndexFieldView) {
          this.focusables.add(this.startIndexFieldView), this.focusTracker.add(this.startIndexFieldView.element);
          const e = e => e.stopPropagation();
          this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e);
        }
        this.reversedSwitchButtonView && (this.focusables.add(this.reversedSwitchButtonView), this.focusTracker.add(this.reversedSwitchButtonView.element)), this.keystrokes.listenTo(this.element);
      }
      focus() {
        this.focusCycler.focusFirst();
      }
      focusLast() {
        this.focusCycler.focusLast();
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createStylesView(e, t) {
        const n = new Er(this.locale);
        return n.children = n.createCollection(), n.children.addMany(e), n.setTemplate({
          tag: "div",
          attributes: {
            "aria-label": t,
            class: ["ck", "ck-list-styles-list"]
          },
          children: n.children
        }), n.children.delegate("execute").to(this), n.focus = function () {
          this.children.first.focus();
        }, n.focusTracker = new Ko(), n.keystrokes = new Wo(), n.render(), n.keystrokes.listenTo(n.element), n;
      }
      _addNumberedListPropertyViews(e) {
        const t = this.locale.t,
          n = [];
        e.startIndex && (this.startIndexFieldView = this._createStartIndexField(), n.push(this.startIndexFieldView)), e.reversed && (this.reversedSwitchButtonView = this._createReversedSwitchButton(), n.push(this.reversedSwitchButtonView)), e.styles ? (this.additionalPropertiesCollapsibleView = new wm(this.locale, n), this.additionalPropertiesCollapsibleView.set({
          label: t("List properties"),
          isCollapsed: !0
        }), this.additionalPropertiesCollapsibleView.buttonView.bind("isEnabled").toMany(n, "isEnabled", function () {
          for (var _len41 = arguments.length, e = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
            e[_key41] = arguments[_key41];
          }
          return e.some(e => e);
        }), this.additionalPropertiesCollapsibleView.buttonView.on("change:isEnabled", (e, t, n) => {
          n || (this.additionalPropertiesCollapsibleView.isCollapsed = !0);
        }), this.children.add(this.additionalPropertiesCollapsibleView)) : this.children.addMany(n);
      }
      _createStartIndexField() {
        const e = this.locale.t,
          t = new Rm(this.locale, Mp);
        return t.set({
          label: e("Start at"),
          class: "ck-numbered-list-properties__start-index"
        }), t.fieldView.set({
          min: 0,
          step: 1,
          value: 1,
          inputMode: "numeric"
        }), t.fieldView.on("input", () => {
          const n = t.fieldView.element,
            i = n.valueAsNumber;
          Number.isNaN(i) ? t.errorText = e("Invalid start index value.") : n.checkValidity() ? this.fire("listStart", {
            startIndex: i
          }) : t.errorText = e("Start index must be greater than 0.");
        }), t;
      }
      _createReversedSwitchButton() {
        const e = this.locale.t,
          t = new pm(this.locale);
        return t.set({
          withText: !0,
          label: e("Reversed order"),
          class: "ck-numbered-list-properties__reversed-order"
        }), t.delegate("execute").to(this, "listReversed"), t;
      }
    }
    var YE = o(9080),
      $E = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(YE.A, $E);
    YE.A.locals;
    class ZE extends Br {
      static get pluginName() {
        return "ListPropertiesUI";
      }
      init() {
        const e = this.editor,
          t = e.locale.t,
          n = e.config.get("list.properties");
        if (n.styles) {
          const i = [{
              label: t("Toggle the disc list style"),
              tooltip: t("Disc"),
              type: "disc",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/></svg>'
            }, {
              label: t("Toggle the circle list style"),
              tooltip: t("Circle"),
              type: "circle",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></svg>'
            }, {
              label: t("Toggle the square list style"),
              tooltip: t("Square"),
              type: "square",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M14 27v6H8v-6h6zm0-9v6H8v-6h6zm0-9v6H8V9h6z"/></svg>'
            }],
            o = t("Bulleted List"),
            r = t("Bulleted list styles toolbar"),
            s = "bulletedList";
          e.ui.componentFactory.add(s, QE({
            editor: e,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            buttonIcon: Wh.bulletedList,
            styleGridAriaLabel: r,
            styleDefinitions: i
          })), e.ui.componentFactory.add("menuBar:".concat(s), XE({
            editor: e,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            styleGridAriaLabel: r,
            styleDefinitions: i
          }));
        }
        if (n.styles || n.startIndex || n.reversed) {
          const i = [{
              label: t("Toggle the decimal list style"),
              tooltip: t("Decimal"),
              type: "decimal",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M10.29 15V8.531H9.286c-.14.393-.4.736-.778 1.03-.378.295-.728.495-1.05.6v1.121a4.257 4.257 0 0 0 1.595-.936V15h1.235zm3.343 0v-1.235h-1.235V15h1.235zM11.3 24v-1.147H8.848c.064-.111.148-.226.252-.343.104-.117.351-.354.74-.712.39-.357.66-.631.81-.821.225-.288.39-.562.494-.824.104-.263.156-.539.156-.829 0-.51-.182-.936-.545-1.279-.363-.342-.863-.514-1.499-.514-.58 0-1.063.148-1.45.444-.387.296-.617.784-.69 1.463l1.23.124c.024-.36.112-.619.264-.774.153-.155.358-.233.616-.233.26 0 .465.074.613.222.148.148.222.36.222.635 0 .25-.085.501-.255.756-.126.185-.468.536-1.024 1.055-.692.641-1.155 1.156-1.389 1.544-.234.389-.375.8-.422 1.233H11.3zm2.333 0v-1.235h-1.235V24h1.235zM9.204 34.11c.615 0 1.129-.2 1.542-.598.413-.398.62-.88.62-1.446 0-.39-.11-.722-.332-.997a1.5 1.5 0 0 0-.886-.532c.619-.337.928-.788.928-1.353 0-.399-.151-.756-.453-1.073-.366-.386-.852-.58-1.459-.58a2.25 2.25 0 0 0-.96.2 1.617 1.617 0 0 0-.668.55c-.16.232-.28.544-.358.933l1.138.194c.032-.282.123-.495.272-.642.15-.146.33-.22.54-.22.215 0 .386.065.515.194s.193.302.193.518c0 .255-.087.46-.263.613-.176.154-.43.227-.765.218l-.136 1.006c.22-.061.409-.092.567-.092.24 0 .444.09.61.272.168.182.251.428.251.739 0 .328-.087.589-.261.782a.833.833 0 0 1-.644.29.841.841 0 0 1-.607-.242c-.167-.16-.27-.394-.307-.698l-1.196.145c.062.542.285.98.668 1.316.384.335.868.503 1.45.503zm4.43-.11v-1.235h-1.236V34h1.235z"/></svg>'
            }, {
              label: t("Toggle the decimal with leading zero list style"),
              tooltip: t("Decimal with leading zero"),
              type: "decimal-leading-zero",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M5.714 15.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 0 1-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 0 1 .4-.143.61.61 0 0 1 .398.143c.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 0 1-.4.143zm6.078.914V8.531H10.79c-.14.393-.4.736-.778 1.03-.378.295-.728.495-1.05.6v1.121a4.257 4.257 0 0 0 1.595-.936V15h1.235zm3.344 0v-1.235h-1.235V15h1.235zm-9.422 9.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 0 1-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 0 1 .4-.143.61.61 0 0 1 .398.143c.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 0 1-.4.143zm7.088.914v-1.147H10.35c.065-.111.149-.226.253-.343.104-.117.35-.354.74-.712.39-.357.66-.631.81-.821.225-.288.39-.562.493-.824.104-.263.156-.539.156-.829 0-.51-.181-.936-.544-1.279-.364-.342-.863-.514-1.499-.514-.58 0-1.063.148-1.45.444-.387.296-.617.784-.69 1.463l1.23.124c.024-.36.112-.619.264-.774.152-.155.357-.233.615-.233.261 0 .465.074.613.222.148.148.222.36.222.635 0 .25-.085.501-.255.756-.126.185-.467.536-1.024 1.055-.691.641-1.154 1.156-1.388 1.544-.235.389-.375.8-.422 1.233h4.328zm2.334 0v-1.235h-1.235V24h1.235zM5.714 34.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 0 1-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 0 1 .4-.143.61.61 0 0 1 .398.143c.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 0 1-.4.143zm4.992 1.024c.616 0 1.13-.2 1.543-.598.413-.398.62-.88.62-1.446 0-.39-.111-.722-.332-.997a1.5 1.5 0 0 0-.886-.532c.618-.337.927-.788.927-1.353 0-.399-.15-.756-.452-1.073-.366-.386-.853-.58-1.46-.58a2.25 2.25 0 0 0-.96.2 1.617 1.617 0 0 0-.667.55c-.16.232-.28.544-.359.933l1.139.194c.032-.282.123-.495.272-.642.15-.146.33-.22.54-.22.214 0 .386.065.515.194s.193.302.193.518c0 .255-.088.46-.264.613-.175.154-.43.227-.764.218l-.136 1.006c.22-.061.408-.092.566-.092.24 0 .444.09.611.272.167.182.25.428.25.739 0 .328-.086.589-.26.782a.833.833 0 0 1-.644.29.841.841 0 0 1-.607-.242c-.167-.16-.27-.394-.308-.698l-1.195.145c.062.542.284.98.668 1.316.384.335.867.503 1.45.503zm4.43-.11v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: t("Toggle the lower–roman list style"),
              tooltip: t("Lower–roman"),
              type: "lower-roman",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11.88 8.7V7.558h-1.234V8.7h1.234zm0 5.3V9.333h-1.234V14h1.234zm2.5 0v-1.235h-1.234V14h1.235zm-4.75 4.7v-1.142H8.395V18.7H9.63zm0 5.3v-4.667H8.395V24H9.63zm2.5-5.3v-1.142h-1.234V18.7h1.235zm0 5.3v-4.667h-1.234V24h1.235zm2.501 0v-1.235h-1.235V24h1.235zM7.38 28.7v-1.142H6.145V28.7H7.38zm0 5.3v-4.667H6.145V34H7.38zm2.5-5.3v-1.142H8.646V28.7H9.88zm0 5.3v-4.667H8.646V34H9.88zm2.5-5.3v-1.142h-1.234V28.7h1.235zm0 5.3v-4.667h-1.234V34h1.235zm2.501 0v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: t("Toggle the upper–roman list style"),
              tooltip: t("Upper-roman"),
              type: "upper-roman",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11.916 15V8.558h-1.301V15h1.3zm2.465 0v-1.235h-1.235V15h1.235zM9.665 25v-6.442h-1.3V25h1.3zm2.5 0v-6.442h-1.3V25h1.3zm2.466 0v-1.235h-1.235V25h1.235zm-7.216 9v-6.442h-1.3V34h1.3zm2.5 0v-6.442h-1.3V34h1.3zm2.501 0v-6.442h-1.3V34h1.3zm2.465 0v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: t("Toggle the lower–latin list style"),
              tooltip: t("Lower-latin"),
              type: "lower-latin",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M9.62 14.105c.272 0 .528-.05.768-.153s.466-.257.677-.462c.009.024.023.072.044.145.047.161.086.283.119.365h1.221a2.649 2.649 0 0 1-.222-.626c-.04-.195-.059-.498-.059-.908l.013-1.441c0-.536-.055-.905-.165-1.105-.11-.201-.3-.367-.569-.497-.27-.13-.68-.195-1.23-.195-.607 0-1.064.108-1.371.325-.308.217-.525.55-.65 1.002l1.12.202c.076-.217.176-.369.299-.455.123-.086.294-.13.514-.13.325 0 .546.05.663.152.118.101.176.27.176.508v.123c-.222.093-.622.194-1.2.303-.427.082-.755.178-.982.288-.227.11-.403.268-.53.474a1.327 1.327 0 0 0-.188.706c0 .398.138.728.415.988.277.261.656.391 1.136.391zm.368-.87a.675.675 0 0 1-.492-.189.606.606 0 0 1-.193-.448c0-.176.08-.32.241-.435.106-.07.33-.142.673-.215a7.19 7.19 0 0 0 .751-.19v.247c0 .296-.016.496-.048.602a.773.773 0 0 1-.295.409 1.07 1.07 0 0 1-.637.22zm4.645.765v-1.235h-1.235V14h1.235zM10.2 25.105c.542 0 1.003-.215 1.382-.646.38-.43.57-1.044.57-1.84 0-.771-.187-1.362-.559-1.774a1.82 1.82 0 0 0-1.41-.617c-.522 0-.973.216-1.354.65v-2.32H7.594V25h1.147v-.686a1.9 1.9 0 0 0 .67.592c.26.133.523.2.79.2zm-.299-.975c-.354 0-.638-.164-.852-.492-.153-.232-.229-.59-.229-1.073 0-.468.098-.818.295-1.048a.93.93 0 0 1 .738-.345c.302 0 .55.118.743.354.193.236.29.62.29 1.154 0 .5-.096.868-.288 1.1-.192.233-.424.35-.697.35zm4.478.87v-1.235h-1.234V25h1.234zm-4.017 9.105c.6 0 1.08-.142 1.437-.426.357-.284.599-.704.725-1.261l-1.213-.207c-.061.326-.167.555-.316.688a.832.832 0 0 1-.576.2.916.916 0 0 1-.75-.343c-.185-.228-.278-.62-.278-1.173 0-.498.091-.853.274-1.066.183-.212.429-.318.736-.318.232 0 .42.061.565.184.145.123.238.306.28.55l1.216-.22c-.146-.501-.387-.874-.722-1.119-.336-.244-.788-.366-1.356-.366-.695 0-1.245.214-1.653.643-.407.43-.61 1.03-.61 1.8 0 .762.202 1.358.608 1.788.406.431.95.646 1.633.646zM14.633 34v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: t("Toggle the upper–latin list style"),
              tooltip: t("Upper-latin"),
              type: "upper-latin",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="m7.88 15 .532-1.463h2.575L11.549 15h1.415l-2.58-6.442H9.01L6.5 15h1.38zm2.69-2.549H8.811l.87-2.39.887 2.39zM14.88 15v-1.235h-1.234V15h1.234zM9.352 25c.83-.006 1.352-.02 1.569-.044.346-.038.636-.14.872-.305.236-.166.422-.387.558-.664.137-.277.205-.562.205-.855 0-.372-.106-.695-.317-.97-.21-.276-.512-.471-.905-.585a1.51 1.51 0 0 0 .661-.567 1.5 1.5 0 0 0 .244-.83c0-.28-.066-.53-.197-.754a1.654 1.654 0 0 0-.495-.539 1.676 1.676 0 0 0-.672-.266c-.25-.042-.63-.063-1.14-.063H7.158V25h2.193zm.142-3.88H8.46v-1.49h.747c.612 0 .983.007 1.112.022.217.026.38.102.49.226.11.125.165.287.165.486a.68.68 0 0 1-.192.503.86.86 0 0 1-.525.23 11.47 11.47 0 0 1-.944.023h.18zm.17 2.795H8.46v-1.723h1.05c.592 0 .977.03 1.154.092.177.062.313.16.406.295a.84.84 0 0 1 .14.492c0 .228-.06.41-.181.547a.806.806 0 0 1-.473.257c-.126.026-.423.04-.892.04zM14.88 25v-1.235h-1.234V25h1.234zm-5.018 9.11c.691 0 1.262-.17 1.711-.512.45-.341.772-.864.965-1.567l-1.261-.4c-.109.472-.287.818-.536 1.037-.25.22-.547.33-.892.33-.47 0-.85-.173-1.143-.519-.293-.345-.44-.925-.44-1.74 0-.767.15-1.322.447-1.665.297-.343.684-.514 1.162-.514.346 0 .64.096.881.29.242.193.4.457.477.79l1.288-.307c-.147-.516-.367-.911-.66-1.187-.492-.465-1.132-.698-1.92-.698-.902 0-1.63.296-2.184.89-.554.593-.83 1.426-.83 2.498 0 1.014.275 1.813.825 2.397.551.585 1.254.877 2.11.877zM14.88 34v-1.235h-1.234V34h1.234z"/></svg>'
            }],
            o = t("Numbered List"),
            r = t("Numbered list styles toolbar"),
            s = "numberedList";
          e.ui.componentFactory.add(s, QE({
            editor: e,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            buttonIcon: Wh.numberedList,
            styleGridAriaLabel: r,
            styleDefinitions: i
          })), n.styles && e.ui.componentFactory.add("menuBar:".concat(s), XE({
            editor: e,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            styleGridAriaLabel: r,
            styleDefinitions: i
          }));
        }
      }
    }
    function QE(_ref132) {
      let {
        editor: e,
        propertiesConfig: t,
        parentCommandName: n,
        buttonLabel: i,
        buttonIcon: o,
        styleGridAriaLabel: r,
        styleDefinitions: s
      } = _ref132;
      const a = e.commands.get(n);
      return l => {
        const c = yp(l, _p),
          d = c.buttonView;
        return c.bind("isEnabled").to(a), c.class = "ck-list-styles-dropdown", d.on("execute", () => {
          e.execute(n), e.editing.view.focus();
        }), d.set({
          label: i,
          icon: o,
          tooltip: !0,
          isToggleable: !0
        }), d.bind("isOn").to(a, "value", e => !!e), c.once("change:isOpen", () => {
          const i = function (_ref133) {
            let {
              editor: e,
              propertiesConfig: t,
              dropdownView: n,
              parentCommandName: i,
              styleDefinitions: o,
              styleGridAriaLabel: r
            } = _ref133;
            const s = e.locale,
              a = {
                ...t
              };
            "numberedList" != i && (a.startIndex = !1, a.reversed = !1);
            let l = null;
            if (a.styles) {
              const t = e.commands.get("listStyle"),
                n = JE({
                  editor: e,
                  parentCommandName: i,
                  listStyleCommand: t
                }),
                r = eS(t);
              l = o.filter(r).map(n);
            }
            const c = new WE(s, {
              styleGridAriaLabel: r,
              enabledProperties: a,
              styleButtonViews: l
            });
            a.styles && Tp(n, () => c.stylesView.children.find(e => e.isOn));
            if (a.startIndex) {
              const t = e.commands.get("listStart");
              c.startIndexFieldView.bind("isEnabled").to(t), c.startIndexFieldView.fieldView.bind("value").to(t), c.on("listStart", (t, n) => e.execute("listStart", n));
            }
            if (a.reversed) {
              const t = e.commands.get("listReversed");
              c.reversedSwitchButtonView.bind("isEnabled").to(t), c.reversedSwitchButtonView.bind("isOn").to(t, "value", e => !!e), c.on("listReversed", () => {
                const n = t.value;
                e.execute("listReversed", {
                  reversed: !n
                });
              });
            }
            return c.delegate("execute").to(n), c;
          }({
            editor: e,
            propertiesConfig: t,
            dropdownView: c,
            parentCommandName: n,
            styleGridAriaLabel: r,
            styleDefinitions: s
          });
          c.panelView.children.add(i);
        }), c.on("execute", () => {
          e.editing.view.focus();
        }), c;
      };
    }
    function JE(_ref134) {
      let {
        editor: e,
        listStyleCommand: t,
        parentCommandName: n
      } = _ref134;
      const i = e.locale,
        o = e.commands.get(n);
      return _ref135 => {
        let {
          label: r,
          type: s,
          icon: a,
          tooltip: l
        } = _ref135;
        const c = new um(i);
        return c.set({
          label: r,
          icon: a,
          tooltip: l
        }), t.on("change:value", () => {
          c.isOn = t.value === s;
        }), c.on("execute", () => {
          o.value ? t.value === s ? e.execute(n) : t.value !== s && e.execute("listStyle", {
            type: s
          }) : e.model.change(() => {
            e.execute("listStyle", {
              type: s
            });
          });
        }), c;
      };
    }
    function XE(_ref136) {
      let {
        editor: e,
        propertiesConfig: t,
        parentCommandName: n,
        buttonLabel: i,
        styleGridAriaLabel: o,
        styleDefinitions: r
      } = _ref136;
      return s => {
        const a = new Fk(s),
          l = e.commands.get(n),
          c = e.commands.get("listStyle"),
          d = eS(c),
          u = JE({
            editor: e,
            parentCommandName: n,
            listStyleCommand: c
          }),
          h = r.filter(d).map(u),
          m = new WE(s, {
            styleGridAriaLabel: o,
            enabledProperties: {
              ...t,
              startIndex: !1,
              reversed: !1
            },
            styleButtonViews: h
          });
        return m.delegate("execute").to(a), a.buttonView.set({
          label: i,
          icon: Wh[n]
        }), a.panelView.children.add(m), a.bind("isEnabled").to(l, "isEnabled"), a.on("execute", () => {
          e.editing.view.focus();
        }), a;
      };
    }
    function eS(e) {
      return "function" == typeof e.isStyleTypeSupported ? t => e.isStyleTypeSupported(t.type) : () => !0;
    }
    class tS extends Br {
      static get requires() {
        return [qE, ZE];
      }
      static get pluginName() {
        return "ListProperties";
      }
    }
    fo("Ctrl+Enter");
    var nS = o(9042),
      iS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(nS.A, iS);
    nS.A.locals;
    fo("Ctrl+Enter");
    function oS(e, t) {
      const n = (n, i, o) => {
        if (!o.consumable.consume(i.item, n.name)) return;
        const r = i.attributeNewValue,
          s = o.writer,
          a = o.mapper.toViewElement(i.item),
          l = [...a.getChildren()].find(e => e.getCustomProperty("media-content"));
        s.remove(l);
        const c = e.getMediaViewElement(s, r, t);
        s.insert(s.createPositionAt(a, 0), c);
      };
      return e => {
        e.on("attribute:url:media", n);
      };
    }
    function rS(e, t, n, i) {
      return e.createContainerElement("figure", {
        class: "media"
      }, [t.getMediaViewElement(e, n, i), e.createSlot()]);
    }
    function sS(e) {
      const t = e.getSelectedElement();
      return t && t.is("element", "media") ? t : null;
    }
    function aS(e, t, n, i) {
      e.change(o => {
        const r = o.createElement("media", {
          url: t
        });
        e.insertObject(r, n, null, {
          setSelection: "on",
          findOptimalPosition: i ? "auto" : void 0
        });
      });
    }
    class lS extends Pr {
      refresh() {
        const e = this.editor.model,
          t = e.document.selection,
          n = sS(t);
        this.value = n ? n.getAttribute("url") : void 0, this.isEnabled = function (e) {
          const t = e.getSelectedElement();
          return !!t && "media" === t.name;
        }(t) || function (e, t) {
          const n = Sw(e, t);
          let i = n.start.parent;
          i.isEmpty && !t.schema.isLimit(i) && (i = i.parent);
          return t.schema.checkChild(i, "media");
        }(t, e);
      }
      execute(e) {
        const t = this.editor.model,
          n = t.document.selection,
          i = sS(n);
        i ? t.change(t => {
          t.setAttribute("url", e, i);
        }) : aS(t, e, n, !0);
      }
    }
    class cS {
      constructor(e, t) {
        const n = t.providers,
          i = t.extraProviders || [],
          o = new Set(t.removeProviders),
          r = n.concat(i).filter(e => {
            const t = e.name;
            return t ? !o.has(t) : (w("media-embed-no-provider-name", {
              provider: e
            }), !1);
          });
        this.locale = e, this.providerDefinitions = r;
      }
      hasMedia(e) {
        return !!this._getMedia(e);
      }
      getMediaViewElement(e, t, n) {
        return this._getMedia(t).getViewElement(e, n);
      }
      _getMedia(e) {
        if (!e) return new dS(this.locale);
        e = e.trim();
        for (const t of this.providerDefinitions) {
          const n = t.html,
            i = _o(t.url);
          for (const t of i) {
            const i = this._getUrlMatches(e, t);
            if (i) return new dS(this.locale, e, i, n);
          }
        }
        return null;
      }
      _getUrlMatches(e, t) {
        let n = e.match(t);
        if (n) return n;
        let i = e.replace(/^https?:\/\//, "");
        return n = i.match(t), n || (i = i.replace(/^www\./, ""), n = i.match(t), n || null);
      }
    }
    class dS {
      constructor(e, t, n, i) {
        this.url = this._getValidUrl(t), this._locale = e, this._match = n, this._previewRenderer = i;
      }
      getViewElement(e, t) {
        const n = {};
        let i;
        if (t.renderForEditingView || t.renderMediaPreview && this.url && this._previewRenderer) {
          this.url && (n["data-oembed-url"] = this.url), t.renderForEditingView && (n.class = "ck-media__wrapper");
          const o = this._getPreviewHtml(t);
          i = e.createRawElement("div", n, (e, t) => {
            t.setContentOf(e, o);
          });
        } else this.url && (n.url = this.url), i = e.createEmptyElement(t.elementName, n);
        return e.setCustomProperty("media-content", !0, i), i;
      }
      _getPreviewHtml(e) {
        return this._previewRenderer ? this._previewRenderer(this._match) : this.url && e.renderForEditingView ? this._getPlaceholderHtml() : "";
      }
      _getPlaceholderHtml() {
        const e = new am(),
          t = this._locale.t;
        e.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', e.viewBox = "0 0 64 42";
        return new tr({
          tag: "div",
          attributes: {
            class: "ck ck-reset_all ck-media__placeholder"
          },
          children: [{
            tag: "div",
            attributes: {
              class: "ck-media__placeholder__icon"
            },
            children: [e]
          }, {
            tag: "a",
            attributes: {
              class: "ck-media__placeholder__url",
              target: "_blank",
              rel: "noopener noreferrer",
              href: this.url,
              "data-cke-tooltip-text": t("Open media in new tab")
            },
            children: [{
              tag: "span",
              attributes: {
                class: "ck-media__placeholder__url__text"
              },
              children: [this.url]
            }]
          }]
        }).render().outerHTML;
      }
      _getValidUrl(e) {
        return e ? e.match(/^https?/) ? e : "https://" + e : null;
      }
    }
    var uS = o(4861),
      hS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(uS.A, hS);
    uS.A.locals;
    class mS extends Br {
      static get pluginName() {
        return "MediaEmbedEditing";
      }
      constructor(e) {
        super(e), e.config.define("mediaEmbed", {
          elementName: "oembed",
          providers: [{
            name: "dailymotion",
            url: [/^dailymotion\.com\/video\/(\w+)/, /^dai.ly\/(\w+)/],
            html: e => "<div style=\"position: relative; padding-bottom: 100%; height: 0; \"><iframe src=\"https://www.dailymotion.com/embed/video/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" width=\"480\" height=\"270\" allowfullscreen allow=\"autoplay\"></iframe></div>")
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: e => "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;\"><iframe src=\"https://open.spotify.com/embed/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allowtransparency=\"true\" allow=\"encrypted-media\"></iframe></div>")
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/, /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/, /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/],
            html: e => {
              const t = e[1],
                n = e[2];
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://www.youtube.com/embed/".concat(t).concat(n ? "?start=".concat(n) : "", "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div>");
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: e => "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://player.vimeo.com/video/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>")
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), this.registry = new cS(e.locale, e.config.get("mediaEmbed"));
      }
      init() {
        const e = this.editor,
          t = e.model.schema,
          n = e.t,
          i = e.conversion,
          o = e.config.get("mediaEmbed.previewsInData"),
          r = e.config.get("mediaEmbed.elementName"),
          s = this.registry;
        e.commands.add("mediaEmbed", new lS(e)), t.register("media", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["url"]
        }), i.for("dataDowncast").elementToStructure({
          model: "media",
          view: (e, _ref137) => {
            let {
              writer: t
            } = _ref137;
            const n = e.getAttribute("url");
            return rS(t, s, n, {
              elementName: r,
              renderMediaPreview: !!n && o
            });
          }
        }), i.for("dataDowncast").add(oS(s, {
          elementName: r,
          renderMediaPreview: o
        })), i.for("editingDowncast").elementToStructure({
          model: "media",
          view: (e, _ref138) => {
            let {
              writer: t
            } = _ref138;
            const i = e.getAttribute("url");
            return function (e, t, n) {
              return t.setCustomProperty("media", !0, e), vw(e, t, {
                label: n
              });
            }(rS(t, s, i, {
              elementName: r,
              renderForEditingView: !0
            }), t, n("media widget"));
          }
        }), i.for("editingDowncast").add(oS(s, {
          elementName: r,
          renderForEditingView: !0
        })), i.for("upcast").elementToElement({
          view: e => ["oembed", r].includes(e.name) && e.getAttribute("url") ? {
            name: !0
          } : null,
          model: (e, _ref139) => {
            let {
              writer: t
            } = _ref139;
            const n = e.getAttribute("url");
            return s.hasMedia(n) ? t.createElement("media", {
              url: n
            }) : null;
          }
        }).elementToElement({
          view: {
            name: "div",
            attributes: {
              "data-oembed-url": !0
            }
          },
          model: (e, _ref140) => {
            let {
              writer: t
            } = _ref140;
            const n = e.getAttribute("data-oembed-url");
            return s.hasMedia(n) ? t.createElement("media", {
              url: n
            }) : null;
          }
        }).add(e => {
          e.on("element:figure", (e, t, n) => {
            if (!n.consumable.consume(t.viewItem, {
              name: !0,
              classes: "media"
            })) return;
            const {
              modelRange: i,
              modelCursor: o
            } = n.convertChildren(t.viewItem, t.modelCursor);
            t.modelRange = i, t.modelCursor = o;
            Go(i.getItems()) || n.consumable.revert(t.viewItem, {
              name: !0,
              classes: "media"
            });
          });
        });
      }
    }
    const pS = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
    class gS extends Br {
      static get requires() {
        return [hA, zb, EA];
      }
      static get pluginName() {
        return "AutoMediaEmbed";
      }
      constructor(e) {
        super(e), this._timeoutId = null, this._positionToInsert = null;
      }
      init() {
        const e = this.editor,
          n = e.model.document,
          i = e.plugins.get("ClipboardPipeline");
        this.listenTo(i, "inputTransformation", () => {
          const e = n.selection.getFirstRange(),
            t = hu.fromPosition(e.start);
          t.stickiness = "toPrevious";
          const i = hu.fromPosition(e.end);
          i.stickiness = "toNext", n.once("change:data", () => {
            this._embedMediaBetweenPositions(t, i), t.detach(), i.detach();
          }, {
            priority: "high"
          });
        });
        e.commands.get("undo").on("execute", () => {
          this._timeoutId && (t.window.clearTimeout(this._timeoutId), this._positionToInsert.detach(), this._timeoutId = null, this._positionToInsert = null);
        }, {
          priority: "high"
        });
      }
      _embedMediaBetweenPositions(e, n) {
        const i = this.editor,
          o = i.plugins.get(mS).registry,
          r = new yc(e, n),
          s = r.getWalker({
            ignoreElementEnd: !0
          });
        let a = "";
        for (const e of s) e.item.is("$textProxy") && (a += e.item.data);
        if (a = a.trim(), !a.match(pS)) return void r.detach();
        if (!o.hasMedia(a)) return void r.detach();
        i.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = hu.fromPosition(e), this._timeoutId = t.window.setTimeout(() => {
          i.model.change(e => {
            this._timeoutId = null, e.remove(r), r.detach();
            let t = null;
            "$graveyard" !== this._positionToInsert.root.rootName && (t = this._positionToInsert), aS(i.model, a, t, !1), this._positionToInsert.detach(), this._positionToInsert = null;
          }), i.plugins.get(zb).requestUndoOnBackspace();
        }, 100)) : r.detach();
      }
    }
    var fS = o(986),
      kS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(fS.A, kS);
    fS.A.locals;
    class bS extends Er {
      constructor(e, t) {
        super(t);
        const n = t.t;
        this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.set("mediaURLInputValue", ""), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(n("Save"), Wh.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(n("Cancel"), Wh.cancel, "ck-button-cancel", "cancel"), this._focusables = new er(), this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this._validators = e, this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.urlInputView, this.saveButtonView, this.cancelButtonView]
        });
      }
      render() {
        super.render(), Tr({
          view: this
        });
        [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(e => {
          this._focusables.add(e), this.focusTracker.add(e.element);
        }), this.keystrokes.listenTo(this.element);
        const e = e => e.stopPropagation();
        this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      get url() {
        return this.urlInputView.fieldView.element.value.trim();
      }
      set url(e) {
        this.urlInputView.fieldView.element.value = e.trim();
      }
      isValid() {
        this.resetFormStatus();
        for (const e of this._validators) {
          const t = e(this);
          if (t) return this.urlInputView.errorText = t, !1;
        }
        return !0;
      }
      resetFormStatus() {
        this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
      }
      _createUrlInput() {
        const e = this.locale.t,
          t = new Rm(this.locale, Bp),
          n = t.fieldView;
        return this._urlInputViewInfoDefault = e("Paste the media URL in the input."), this._urlInputViewInfoTip = e("Tip: Paste the URL into the content to embed faster."), t.label = e("Media URL"), t.infoText = this._urlInputViewInfoDefault, n.on("input", () => {
          t.infoText = n.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault, this.mediaURLInputValue = n.element.value.trim();
        }), t;
      }
      _createButton(e, t, n, i) {
        const o = new um(this.locale);
        return o.set({
          label: e,
          icon: t,
          tooltip: !0
        }), o.extendTemplate({
          attributes: {
            class: n
          }
        }), i && o.delegate("execute").to(this, i), o;
      }
    }
    class _S extends Br {
      static get requires() {
        return [mS];
      }
      static get pluginName() {
        return "MediaEmbedUI";
      }
      init() {
        const e = this.editor,
          t = e.commands.get("mediaEmbed");
        e.ui.componentFactory.add("mediaEmbed", e => {
          const n = yp(e);
          return this._setUpDropdown(n, t), n;
        });
      }
      _setUpDropdown(e, t) {
        const n = this.editor,
          i = n.t,
          o = e.buttonView,
          r = n.plugins.get(mS).registry;
        e.once("change:isOpen", () => {
          const i = new (Dr(bS))(function (e, t) {
            return [t => {
              if (!t.url.length) return e("The URL must not be empty.");
            }, n => {
              if (!t.hasMedia(n.url)) return e("This media URL is not supported.");
            }];
          }(n.t, r), n.locale);
          e.panelView.children.add(i), o.on("open", () => {
            i.disableCssTransitions(), i.url = t.value || "", i.urlInputView.fieldView.select(), i.enableCssTransitions();
          }, {
            priority: "low"
          }), e.on("submit", () => {
            i.isValid() && (n.execute("mediaEmbed", i.url), n.editing.view.focus());
          }), e.on("change:isOpen", () => i.resetFormStatus()), e.on("cancel", () => {
            n.editing.view.focus();
          }), i.delegate("submit", "cancel").to(e), i.urlInputView.fieldView.bind("value").to(t, "value"), i.urlInputView.on("change:errorText", () => {
            n.ui.update();
          }), i.urlInputView.bind("isEnabled").to(t, "isEnabled");
        }), e.bind("isEnabled").to(t), o.set({
          label: i("Insert media"),
          icon: '<svg viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.587 1.5c-.612 0-.601-.029-.601.551v14.84c0 .59-.01.559.591.559h18.846c.602 0 .591.03.591-.56V2.052c0-.58.01-.55-.591-.55H1.587Zm.701.971h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-14.24 1h13.008v12H4.467l.029-12Zm-2.208 1h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003l-.029 1h-.974v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h.974v1h-.974v-1Zm16.448 0h1.003v1h-1.003v-1Z"/><path d="M8.374 6.648a.399.399 0 0 1 .395-.4.402.402 0 0 1 .2.049l5.148 2.824a.4.4 0 0 1 0 .7l-5.148 2.824a.403.403 0 0 1-.595-.35V6.648Z"/></svg>',
          tooltip: !0
        });
      }
    }
    var wS = o(7693),
      AS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(wS.A, AS);
    wS.A.locals;
    function vS(e) {
      return void 0 !== e && e.endsWith("px");
    }
    function CS(e) {
      return e.toFixed(2).replace(/\.?0+$/, "") + "px";
    }
    function yS(e, t, n) {
      if (!e.childCount) return;
      const i = new Xu(e.document),
        o = function (e, t) {
          const n = t.createRangeIn(e),
            i = [],
            o = new Set();
          for (const e of n.getItems()) {
            if (!e.is("element") || !e.name.match(/^(p|h\d+|li|div)$/)) continue;
            let t = MS(e);
            if (void 0 === t || 0 != parseFloat(t) || Array.from(e.getClassNames()).find(e => e.startsWith("MsoList")) || (t = void 0), e.hasStyle("mso-list") || void 0 !== t && o.has(t)) {
              const n = IS(e);
              i.push({
                element: e,
                id: n.id,
                order: n.order,
                indent: n.indent,
                marginLeft: t
              }), void 0 !== t && o.add(t);
            } else o.clear();
          }
          return i;
        }(e, i);
      if (!o.length) return;
      const r = {},
        s = [];
      for (const e of o) if (void 0 !== e.indent) {
        xS(e) || (s.length = 0);
        const o = "".concat(e.id, ":").concat(e.indent),
          a = Math.min(e.indent - 1, s.length);
        if (a < s.length && s[a].id !== e.id && (s.length = a), a < s.length - 1) s.length = a + 1;else {
          const l = SS(e, t);
          if (a > s.length - 1 || s[a].listElement.name != l.type) {
            0 == a && "ol" == l.type && void 0 !== e.id && r[o] && (l.startIndex = r[o]);
            const t = TS(l, i, n);
            if (vS(e.marginLeft) && (0 == a || vS(s[a - 1].marginLeft))) {
              let n = e.marginLeft;
              a > 0 && (n = CS(parseFloat(n) - parseFloat(s[a - 1].marginLeft))), i.setStyle("padding-left", n, t);
            }
            if (0 == s.length) {
              const n = e.element.parent,
                o = n.getChildIndex(e.element) + 1;
              i.insertChild(o, t, n);
            } else {
              const e = s[a - 1].listItemElements;
              i.appendChild(t, e[e.length - 1]);
            }
            s[a] = {
              ...e,
              listElement: t,
              listItemElements: []
            }, 0 == a && void 0 !== e.id && (r[o] = l.startIndex || 1);
          }
        }
        const l = "li" == e.element.name ? e.element : i.createElement("li");
        i.appendChild(l, s[a].listElement), s[a].listItemElements.push(l), 0 == a && void 0 !== e.id && r[o]++, e.element != l && i.appendChild(e.element, l), BS(e.element, i), i.removeStyle("text-indent", e.element), i.removeStyle("margin-left", e.element);
      } else {
        const t = s.find(t => t.marginLeft == e.marginLeft);
        if (t) {
          const n = t.listItemElements;
          i.appendChild(e.element, n[n.length - 1]), i.removeStyle("margin-left", e.element);
        } else s.length = 0;
      }
    }
    function xS(e) {
      const t = e.element.previousSibling;
      return ES(t || e.element.parent);
    }
    function ES(e) {
      return e.is("element", "ol") || e.is("element", "ul");
    }
    function SS(e, t) {
      const n = new RegExp("@list l".concat(e.id, ":level").concat(e.indent, "\\s*({[^}]*)"), "gi"),
        i = /mso-level-number-format:([^;]{0,100});/gi,
        o = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi,
        r = new RegExp("@list\\s+l".concat(e.id, ":level\\d\\s*{[^{]*mso-level-text:\"%\\d\\\\."), "gi"),
        s = new RegExp("@list l".concat(e.id, ":level\\d\\s*{[^{]*mso-level-number-format:"), "gi"),
        a = r.exec(t),
        l = s.exec(t),
        c = a && !l,
        d = n.exec(t);
      let u = "decimal",
        h = "ol",
        m = null;
      if (d && d[1]) {
        const t = i.exec(d[1]);
        if (t && t[1] && (u = t[1].trim(), h = "bullet" !== u && "image" !== u ? "ol" : "ul"), "bullet" === u) {
          const t = function (e) {
            if ("li" == e.name && "ul" == e.parent.name && e.parent.hasAttribute("type")) return e.parent.getAttribute("type");
            const t = function (e) {
              if (e.getChild(0).is("$text")) return null;
              for (const t of e.getChildren()) {
                if (!t.is("element", "span")) continue;
                const e = t.getChild(0);
                if (e) return e.is("$text") ? e : e.getChild(0);
              }
              return null;
            }(e);
            if (!t) return null;
            const n = t._data;
            if ("o" === n) return "circle";
            if ("·" === n) return "disc";
            if ("§" === n) return "square";
            return null;
          }(e.element);
          t && (u = t);
        } else {
          const e = o.exec(d[1]);
          e && e[1] && (m = parseInt(e[1]));
        }
        c && (h = "ol");
      }
      return {
        type: h,
        startIndex: m,
        style: DS(u),
        isLegalStyleList: c
      };
    }
    function DS(e) {
      if (e.startsWith("arabic-leading-zero")) return "decimal-leading-zero";
      switch (e) {
        case "alpha-upper":
          return "upper-alpha";
        case "alpha-lower":
          return "lower-alpha";
        case "roman-upper":
          return "upper-roman";
        case "roman-lower":
          return "lower-roman";
        case "circle":
        case "disc":
        case "square":
          return e;
        default:
          return null;
      }
    }
    function TS(e, t, n) {
      const i = t.createElement(e.type);
      return e.style && t.setStyle("list-style-type", e.style, i), e.startIndex && e.startIndex > 1 && t.setAttribute("start", e.startIndex, i), e.isLegalStyleList && n && t.addClass("legal-list", i), i;
    }
    function IS(e) {
      const t = e.getStyle("mso-list");
      if (void 0 === t) return {};
      const n = t.match(/(^|\s{1,100})l(\d+)/i),
        i = t.match(/\s{0,100}lfo(\d+)/i),
        o = t.match(/\s{0,100}level(\d+)/i);
      return n && i && o ? {
        id: n[2],
        order: i[1],
        indent: parseInt(o[1])
      } : {
        indent: 1
      };
    }
    function BS(e, t) {
      const n = new ts({
          name: "span",
          styles: {
            "mso-list": "Ignore"
          }
        }),
        i = t.createRangeIn(e);
      for (const e of i) "elementStart" === e.type && n.match(e.item) && t.remove(e.item);
    }
    function MS(e) {
      const t = e.getStyle("margin-left");
      return void 0 === t || t.endsWith("px") ? t : function (e) {
        const t = parseFloat(e);
        return e.endsWith("pt") ? CS(96 * t / 72) : e.endsWith("pc") ? CS(12 * t * 96 / 72) : e.endsWith("in") ? CS(96 * t) : e.endsWith("cm") ? CS(96 * t / 2.54) : e.endsWith("mm") ? CS(t / 10 * 96 / 2.54) : e;
      }(t);
    }
    function PS(e, t) {
      if (!e.childCount) return;
      const n = new Xu(e.document),
        i = function (e, t) {
          const n = t.createRangeIn(e),
            i = new ts({
              name: /v:(.+)/
            }),
            o = [];
          for (const e of n) {
            if ("elementStart" != e.type) continue;
            const t = e.item,
              n = t.previousSibling,
              r = n && n.is("element") ? n.name : null,
              s = ["Chart"],
              a = i.match(t),
              l = t.getAttribute("o:gfxdata"),
              c = "v:shapetype" === r,
              d = l && s.some(e => t.getAttribute("id").includes(e));
            a && l && !c && !d && o.push(e.item.getAttribute("id"));
          }
          return o;
        }(e, n);
      !function (e, t, n) {
        const i = n.createRangeIn(t),
          o = new ts({
            name: "img"
          }),
          r = [];
        for (const t of i) if (t.item.is("element") && o.match(t.item)) {
          const n = t.item,
            i = n.getAttribute("v:shapes") ? n.getAttribute("v:shapes").split(" ") : [];
          i.length && i.every(t => e.indexOf(t) > -1) ? r.push(n) : n.getAttribute("src") || r.push(n);
        }
        for (const e of r) n.remove(e);
      }(i, e, n), function (e, t, n) {
        const i = n.createRangeIn(t),
          o = [];
        for (const t of i) if ("elementStart" == t.type && t.item.is("element", "v:shape")) {
          const n = t.item.getAttribute("id");
          if (e.includes(n)) continue;
          r(t.item.parent.getChildren(), n) || o.push(t.item);
        }
        for (const e of o) {
          const t = {
            src: s(e)
          };
          e.hasAttribute("alt") && (t.alt = e.getAttribute("alt"));
          const i = n.createElement("img", t);
          n.insertChild(e.index + 1, i, e.parent);
        }
        function r(e, t) {
          for (const n of e) if (n.is("element")) {
            if ("img" == n.name && n.getAttribute("v:shapes") == t) return !0;
            if (r(n.getChildren(), t)) return !0;
          }
          return !1;
        }
        function s(e) {
          for (const t of e.getChildren()) if (t.is("element") && t.getAttribute("src")) return t.getAttribute("src");
        }
      }(i, e, n), function (e, t) {
        const n = t.createRangeIn(e),
          i = new ts({
            name: /v:(.+)/
          }),
          o = [];
        for (const e of n) "elementStart" == e.type && i.match(e.item) && o.push(e.item);
        for (const e of o) t.remove(e);
      }(e, n);
      const o = function (e, t) {
        const n = t.createRangeIn(e),
          i = new ts({
            name: "img"
          }),
          o = [];
        for (const e of n) e.item.is("element") && i.match(e.item) && e.item.getAttribute("src").startsWith("file://") && o.push(e.item);
        return o;
      }(e, n);
      o.length && function (e, t, n) {
        if (e.length === t.length) for (let i = 0; i < e.length; i++) {
          const o = "data:".concat(t[i].type, ";base64,").concat(zS(t[i].hex));
          n.setAttribute("src", o, e[i]);
        }
      }(o, function (e) {
        if (!e) return [];
        const t = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
          n = new RegExp("(?:(" + t.source + "))([\\da-fA-F\\s]+)\\}", "g"),
          i = e.match(n),
          o = [];
        if (i) for (const e of i) {
          let n = !1;
          e.includes("\\pngblip") ? n = "image/png" : e.includes("\\jpegblip") && (n = "image/jpeg"), n && o.push({
            hex: e.replace(t, "").replace(/[^\da-fA-F]/g, ""),
            type: n
          });
        }
        return o;
      }(t), n);
    }
    function zS(e) {
      return btoa(e.match(/\w{2}/g).map(e => String.fromCharCode(parseInt(e, 16))).join(""));
    }
    const NS = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
      LS = /xmlns:o="urn:schemas-microsoft-com/i;
    class RS {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        this.document = e, this.hasMultiLevelListPlugin = t;
      }
      isActive(e) {
        return NS.test(e) || LS.test(e);
      }
      execute(e) {
        const {
          body: t,
          stylesString: n
        } = e._parsedData;
        yS(t, n, this.hasMultiLevelListPlugin), PS(t, e.dataTransfer.getData("text/rtf")), function (e) {
          const t = [],
            n = new Xu(e.document);
          for (const {
            item: i
          } of n.createRangeIn(e)) if (i.is("element")) {
            for (const e of i.getClassNames()) /\bmso/gi.exec(e) && n.removeClass(e, i);
            for (const e of i.getStyleNames()) /\bmso/gi.exec(e) && n.removeStyle(e, i);
            (i.is("element", "w:sdt") || i.is("element", "w:sdtpr") && i.isEmpty || i.is("element", "o:p") && i.isEmpty) && t.push(i);
          }
          for (const e of t) {
            const t = e.parent,
              i = t.getChildIndex(e);
            n.insertChild(i, e.getChildren(), t), n.remove(e);
          }
        }(t), e.content = t;
      }
    }
    function VS(e, t, n, _ref141) {
      let {
        blockElements: i,
        inlineObjectElements: o
      } = _ref141;
      let r = n.createPositionAt(e, "forward" == t ? "after" : "before");
      return r = r.getLastMatchingPosition(_ref142 => {
        let {
          item: e
        } = _ref142;
        return e.is("element") && !i.includes(e.name) && !o.includes(e.name);
      }, {
        direction: t
      }), "forward" == t ? r.nodeAfter : r.nodeBefore;
    }
    function OS(e, t) {
      return !!e && e.is("element") && t.includes(e.name);
    }
    const FS = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
    class jS {
      constructor(e) {
        this.document = e;
      }
      isActive(e) {
        return FS.test(e);
      }
      execute(e) {
        const t = new Xu(this.document),
          {
            body: n
          } = e._parsedData;
        !function (e, t) {
          for (const n of e.getChildren()) if (n.is("element", "b") && "normal" === n.getStyle("font-weight")) {
            const i = e.getChildIndex(n);
            t.remove(n), t.insertChild(i, n.getChildren(), e);
          }
        }(n, t), function (e, t) {
          for (const n of t.createRangeIn(e)) {
            const e = n.item;
            if (e.is("element", "li")) {
              const n = e.getChild(0);
              n && n.is("element", "p") && t.unwrapElement(n);
            }
          }
        }(n, t), function (e, t) {
          const n = new ta(t.document.stylesProcessor),
            i = new Wa(n, {
              renderingMode: "data"
            }),
            o = i.blockElements,
            r = i.inlineObjectElements,
            s = [];
          for (const n of t.createRangeIn(e)) {
            const e = n.item;
            if (e.is("element", "br")) {
              const n = VS(e, "forward", t, {
                  blockElements: o,
                  inlineObjectElements: r
                }),
                i = VS(e, "backward", t, {
                  blockElements: o,
                  inlineObjectElements: r
                }),
                a = OS(n, o);
              (OS(i, o) || a) && s.push(e);
            }
          }
          for (const e of s) e.hasClass("Apple-interchange-newline") ? t.remove(e) : t.replace(e, t.createElement("p"));
        }(n, t), e.content = n;
      }
    }
    const HS = /<google-sheets-html-origin/i;
    class US {
      constructor(e) {
        this.document = e;
      }
      isActive(e) {
        return HS.test(e);
      }
      execute(e) {
        const t = new Xu(this.document),
          {
            body: n
          } = e._parsedData;
        !function (e, t) {
          for (const n of e.getChildren()) if (n.is("element", "google-sheets-html-origin")) {
            const i = e.getChildIndex(n);
            t.remove(n), t.insertChild(i, n.getChildren(), e);
          }
        }(n, t), function (e, t) {
          for (const n of e.getChildren()) n.is("element", "table") && n.hasAttribute("xmlns") && t.removeAttribute("xmlns", n);
        }(n, t), function (e, t) {
          for (const n of e.getChildren()) n.is("element", "table") && "0px" === n.getStyle("width") && t.removeStyle("width", n);
        }(n, t), function (e, t) {
          for (const n of Array.from(e.getChildren())) n.is("element", "style") && t.remove(n);
        }(n, t), e.content = n;
      }
    }
    function qS(e) {
      return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (e, t) => 1 === t.length ? " " : Array(t.length + 1).join("  ").substr(0, t.length));
    }
    function GS(e, t) {
      const n = new DOMParser(),
        i = function (e) {
          return qS(qS(e)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/(<span\s+style=['"]letter-spacing:[^'"]+?['"]>)[\r\n]+(<\/span>)/g, "$1 $2").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
        }(function (e) {
          const t = "</body>",
            n = "</html>",
            i = e.indexOf(t);
          if (i < 0) return e;
          const o = e.indexOf(n, i + t.length);
          return e.substring(0, i + t.length) + (o >= 0 ? e.substring(o) : "");
        }(e = (e = e.replace(/<!--\[if gte vml 1]>/g, "")).replace(/<o:SmartTagType(?:\s+[^\s>=]+(?:="[^"]*")?)*\s*\/?>/gi, ""))),
        o = n.parseFromString(i, "text/html");
      !function (e) {
        e.querySelectorAll("span[style*=spacerun]").forEach(e => {
          const t = e,
            n = t.innerText.length || 0;
          t.innerText = Array(n + 1).join("  ").substr(0, n);
        });
      }(o);
      const r = o.body.innerHTML,
        s = function (e, t) {
          const n = new ta(t),
            i = new Wa(n, {
              renderingMode: "data"
            }),
            o = e.createDocumentFragment(),
            r = e.body.childNodes;
          for (; r.length > 0;) o.appendChild(r[0]);
          return i.domToView(o, {
            skipComments: !0
          });
        }(o, t),
        a = function (e) {
          const t = [],
            n = [],
            i = Array.from(e.getElementsByTagName("style"));
          for (const e of i) e.sheet && e.sheet.cssRules && e.sheet.cssRules.length && (t.push(e.sheet), n.push(e.innerHTML));
          return {
            styles: t,
            stylesString: n.join(" ")
          };
        }(o);
      return {
        body: s,
        bodyString: r,
        styles: a.styles,
        stylesString: a.stylesString
      };
    }
    const KS = "removeFormat";
    class WS extends Br {
      static get pluginName() {
        return "RemoveFormatUI";
      }
      init() {
        const e = this.editor;
        e.ui.componentFactory.add(KS, () => {
          const e = this._createButton(um);
          return e.set({
            tooltip: !0
          }), e;
        }), e.ui.componentFactory.add("menuBar:".concat(KS), () => this._createButton(qk));
      }
      _createButton(e) {
        const t = this.editor,
          n = t.locale,
          i = t.commands.get(KS),
          o = new e(t.locale),
          r = n.t;
        return o.set({
          label: r("Remove Format"),
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.69 14.915c.053.052.173.083.36.093a.366.366 0 0 1 .345.485l-.003.01a.738.738 0 0 1-.697.497h-2.67a.374.374 0 0 1-.353-.496l.013-.038a.681.681 0 0 1 .644-.458c.197-.012.325-.043.386-.093a.28.28 0 0 0 .072-.11L9.592 4.5H6.269c-.359-.017-.609.013-.75.09-.142.078-.289.265-.442.563-.192.29-.516.464-.864.464H4.17a.43.43 0 0 1-.407-.569L4.46 3h13.08l-.62 2.043a.81.81 0 0 1-.775.574h-.114a.486.486 0 0 1-.486-.486c.001-.284-.054-.464-.167-.54-.112-.076-.367-.106-.766-.091h-3.28l-2.68 10.257c-.006.074.007.127.038.158zM3 17h8a.5.5 0 1 1 0 1H3a.5.5 0 1 1 0-1zm11.299 1.17a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.06-1.06l1.415 1.414 1.414-1.415a.75.75 0 1 1 1.06 1.06l-1.413 1.415 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414-1.414 1.414z"/></svg>'
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          t.execute(KS), t.editing.view.focus();
        }), o;
      }
    }
    class YS extends Pr {
      refresh() {
        const e = this.editor.model;
        this.isEnabled = !!Go(this._getFormattingItems(e.document.selection, e.schema));
      }
      execute() {
        const e = this.editor.model,
          t = e.schema;
        e.change(n => {
          for (const i of this._getFormattingItems(e.document.selection, t)) if (i.is("selection")) for (const e of this._getFormattingAttributes(i, t)) n.removeSelectionAttribute(e);else {
            const e = n.createRangeOn(i);
            for (const o of this._getFormattingAttributes(i, t)) n.removeAttribute(o, e);
          }
        });
      }
      *_getFormattingItems(e, t) {
        const n = e => !!Go(this._getFormattingAttributes(e, t));
        for (const i of e.getRanges()) for (const e of i.getItems()) !t.isBlock(e) && n(e) && (yield e);
        for (const t of e.getSelectedBlocks()) n(t) && (yield t);
        n(e) && (yield e);
      }
      *_getFormattingAttributes(e, t) {
        for (const [n] of e.getAttributes()) {
          const e = t.getAttributeProperties(n);
          e && e.isFormatting && (yield n);
        }
      }
    }
    class $S extends Br {
      static get pluginName() {
        return "RemoveFormatEditing";
      }
      init() {
        const e = this.editor;
        e.commands.add("removeFormat", new YS(e));
      }
    }
    function ZS(e) {
      const t = [{
          name: "address",
          isVoid: !1
        }, {
          name: "article",
          isVoid: !1
        }, {
          name: "aside",
          isVoid: !1
        }, {
          name: "blockquote",
          isVoid: !1
        }, {
          name: "details",
          isVoid: !1
        }, {
          name: "dialog",
          isVoid: !1
        }, {
          name: "dd",
          isVoid: !1
        }, {
          name: "div",
          isVoid: !1
        }, {
          name: "dl",
          isVoid: !1
        }, {
          name: "dt",
          isVoid: !1
        }, {
          name: "fieldset",
          isVoid: !1
        }, {
          name: "figcaption",
          isVoid: !1
        }, {
          name: "figure",
          isVoid: !1
        }, {
          name: "footer",
          isVoid: !1
        }, {
          name: "form",
          isVoid: !1
        }, {
          name: "h1",
          isVoid: !1
        }, {
          name: "h2",
          isVoid: !1
        }, {
          name: "h3",
          isVoid: !1
        }, {
          name: "h4",
          isVoid: !1
        }, {
          name: "h5",
          isVoid: !1
        }, {
          name: "h6",
          isVoid: !1
        }, {
          name: "header",
          isVoid: !1
        }, {
          name: "hgroup",
          isVoid: !1
        }, {
          name: "hr",
          isVoid: !0
        }, {
          name: "li",
          isVoid: !1
        }, {
          name: "main",
          isVoid: !1
        }, {
          name: "nav",
          isVoid: !1
        }, {
          name: "ol",
          isVoid: !1
        }, {
          name: "p",
          isVoid: !1
        }, {
          name: "section",
          isVoid: !1
        }, {
          name: "table",
          isVoid: !1
        }, {
          name: "tbody",
          isVoid: !1
        }, {
          name: "td",
          isVoid: !1
        }, {
          name: "th",
          isVoid: !1
        }, {
          name: "thead",
          isVoid: !1
        }, {
          name: "tr",
          isVoid: !1
        }, {
          name: "ul",
          isVoid: !1
        }],
        n = t.map(e => e.name).join("|"),
        i = e.replace(new RegExp("</?(".concat(n, ")( .*?)?>"), "g"), "\n$&\n").replace(/<br[^>]*>/g, "$&\n").split("\n");
      let o = 0,
        r = !1;
      return i.filter(e => e.length).map(e => (r = function (e, t) {
        return new RegExp("<pre( .*?)?>").test(e) ? "first" : new RegExp("</pre>").test(e) ? "last" : ("first" === t || "middle" === t) && "middle";
      }(e, r), function (e, t) {
        return t.some(t => !t.isVoid && !!new RegExp("<".concat(t.name, "( .*?)?>")).test(e));
      }(e, t) ? QS(e, o++) : function (e, t) {
        return t.some(t => new RegExp("</".concat(t.name, ">")).test(e));
      }(e, t) ? QS(e, --o) : "middle" === r || "last" === r ? e : QS(e, o))).join("\n");
    }
    function QS(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "    ";
      return "".concat(n.repeat(Math.max(0, t))).concat(e);
    }
    var JS = o(3989),
      XS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(JS.A, XS);
    JS.A.locals;
    const eD = "SourceEditingMode";
    function tD(e) {
      return function (e) {
        return e.startsWith("<");
      }(e) ? ZS(e) : e;
    }
    function nD(e, t) {
      const {
        modelAttribute: n,
        styleName: i,
        viewElement: o,
        defaultValue: r,
        reduceBoxSides: s = !1,
        shouldUpcast: a = () => !0
      } = t;
      e.for("upcast").attributeToAttribute({
        view: {
          name: o,
          styles: {
            [i]: /[\s\S]+/
          }
        },
        model: {
          key: n,
          value: e => {
            if (!a(e)) return;
            const t = e.getNormalizedStyle(i),
              n = s ? sD(t) : t;
            return r !== n ? n : void 0;
          }
        }
      });
    }
    function iD(e, t, n, i) {
      e.for("upcast").add(e => e.on("element:" + t, (e, t, o) => {
        if (!t.modelRange) return;
        const r = ["border-top-width", "border-top-color", "border-top-style", "border-bottom-width", "border-bottom-color", "border-bottom-style", "border-right-width", "border-right-color", "border-right-style", "border-left-width", "border-left-color", "border-left-style"].filter(e => t.viewItem.hasStyle(e));
        if (!r.length) return;
        const s = {
          styles: r
        };
        if (!o.consumable.test(t.viewItem, s)) return;
        const a = [...t.modelRange.getItems({
          shallow: !0
        })].pop();
        o.consumable.consume(t.viewItem, s);
        const l = {
            style: t.viewItem.getNormalizedStyle("border-style"),
            color: t.viewItem.getNormalizedStyle("border-color"),
            width: t.viewItem.getNormalizedStyle("border-width")
          },
          c = {
            style: sD(l.style),
            color: sD(l.color),
            width: sD(l.width)
          };
        c.style !== i.style && o.writer.setAttribute(n.style, c.style, a), c.color !== i.color && o.writer.setAttribute(n.color, c.color, a), c.width !== i.width && o.writer.setAttribute(n.width, c.width, a);
      }));
    }
    function oD(e, t) {
      const {
        modelElement: n,
        modelAttribute: i,
        styleName: o
      } = t;
      e.for("downcast").attributeToAttribute({
        model: {
          name: n,
          key: i
        },
        view: e => ({
          key: "style",
          value: {
            [o]: e
          }
        })
      });
    }
    function rD(e, t) {
      const {
        modelAttribute: n,
        styleName: i
      } = t;
      e.for("downcast").add(e => e.on("attribute:".concat(n, ":table"), (e, t, n) => {
        const {
            item: o,
            attributeNewValue: r
          } = t,
          {
            mapper: s,
            writer: a
          } = n;
        if (!n.consumable.consume(t.item, e.name)) return;
        const l = [...s.toViewElement(o).getChildren()].find(e => e.is("element", "table"));
        r ? a.setStyle(i, r, l) : a.removeStyle(i, l);
      }));
    }
    function sD(e) {
      if (!e) return;
      const t = ["top", "right", "bottom", "left"];
      if (!t.every(t => e[t])) return e;
      const n = e.top;
      return t.every(t => e[t] === n) ? n : e;
    }
    function aD(e, t, n, i) {
      let o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      null != t && null != o && t > o ? i.setAttribute(e, t, n) : i.removeAttribute(e, n);
    }
    function lD(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const i = e.createElement("tableCell", n);
      return e.insertElement("paragraph", i), e.insert(i, t), i;
    }
    function cD(e, t) {
      const n = t.parent.parent,
        i = parseInt(n.getAttribute("headingColumns") || "0"),
        {
          column: o
        } = e.getCellLocation(t);
      return !!i && o < i;
    }
    function dD(e, t, n) {
      const {
        modelAttribute: i
      } = n;
      e.extend("tableCell", {
        allowAttributes: [i]
      }), nD(t, {
        viewElement: /^(td|th)$/,
        ...n
      }), oD(t, {
        modelElement: "tableCell",
        ...n
      });
    }
    function uD(e) {
      const t = e.getSelectedElement();
      return t && t.is("element", "table") ? t : e.getFirstPosition().findAncestor("table");
    }
    function hD() {
      return e => {
        e.on("element:table", (e, t, n) => {
          const i = t.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;
          const {
              rows: o,
              headingRows: r,
              headingColumns: s
            } = function (e) {
              let t,
                n = 0;
              const i = [],
                o = [];
              let r;
              for (const s of Array.from(e.getChildren())) {
                if ("tbody" !== s.name && "thead" !== s.name && "tfoot" !== s.name) continue;
                "thead" !== s.name || r || (r = s);
                const e = Array.from(s.getChildren()).filter(e => e.is("element", "tr"));
                for (const a of e) if (r && s === r || "tbody" === s.name && Array.from(a.getChildren()).length && Array.from(a.getChildren()).every(e => e.is("element", "th"))) n++, i.push(a);else {
                  o.push(a);
                  const e = pD(a);
                  (!t || e < t) && (t = e);
                }
              }
              return {
                headingRows: n,
                headingColumns: t || 0,
                rows: [...i, ...o]
              };
            }(i),
            a = {};
          s && (a.headingColumns = s), r && (a.headingRows = r);
          const l = n.writer.createElement("table", a);
          if (n.safeInsert(l, t.modelCursor)) {
            if (n.consumable.consume(i, {
              name: !0
            }), o.forEach(e => n.convertItem(e, n.writer.createPositionAt(l, "end"))), n.convertChildren(i, n.writer.createPositionAt(l, "end")), l.isEmpty) {
              const e = n.writer.createElement("tableRow");
              n.writer.insert(e, n.writer.createPositionAt(l, "end")), lD(n.writer, n.writer.createPositionAt(e, "end"));
            }
            n.updateConversionResult(l, t);
          }
        });
      };
    }
    function mD(e) {
      return t => {
        t.on("element:".concat(e), (e, t, _ref143) => {
          let {
            writer: n
          } = _ref143;
          if (!t.modelRange) return;
          const i = t.modelRange.start.nodeAfter,
            o = n.createPositionAt(i, 0);
          if (t.viewItem.isEmpty) return void n.insertElement("paragraph", o);
          const r = Array.from(i.getChildren());
          if (r.every(e => e.is("element", "$marker"))) {
            const e = n.createElement("paragraph");
            n.insert(e, n.createPositionAt(i, 0));
            for (const t of r) n.move(n.createRangeOn(t), n.createPositionAt(e, "end"));
          }
        }, {
          priority: "low"
        });
      };
    }
    function pD(e) {
      let t = 0,
        n = 0;
      const i = Array.from(e.getChildren()).filter(e => "th" === e.name || "td" === e.name);
      for (; n < i.length && "th" === i[n].name;) {
        const e = i[n];
        t += parseInt(e.getAttribute("colspan") || "1"), n++;
      }
      return t;
    }
    class gD {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._jumpedToStartRow = !1, this._table = e, this._startRow = void 0 !== t.row ? t.row : t.startRow || 0, this._endRow = void 0 !== t.row ? t.row : t.endRow, this._startColumn = void 0 !== t.column ? t.column : t.startColumn || 0, this._endColumn = void 0 !== t.column ? t.column : t.endColumn, this._includeAllSlots = !!t.includeAllSlots, this._skipRows = new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
      }
      [Symbol.iterator]() {
        return this;
      }
      next() {
        this._canJumpToStartRow() && this._jumpToNonSpannedRowClosestToStartRow();
        const e = this._table.getChild(this._rowIndex);
        if (!e || this._isOverEndRow()) return {
          done: !0,
          value: void 0
        };
        if (!e.is("element", "tableRow")) return this._rowIndex++, this.next();
        if (this._isOverEndColumn()) return this._advanceToNextRow();
        let t = null;
        const n = this._getSpanned();
        if (n) this._includeAllSlots && !this._shouldSkipSlot() && (t = this._formatOutValue(n.cell, n.row, n.column));else {
          const n = e.getChild(this._cellIndex);
          if (!n) return this._advanceToNextRow();
          const i = parseInt(n.getAttribute("colspan") || "1"),
            o = parseInt(n.getAttribute("rowspan") || "1");
          (i > 1 || o > 1) && this._recordSpans(n, o, i), this._shouldSkipSlot() || (t = this._formatOutValue(n)), this._nextCellAtColumn = this._column + i;
        }
        return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, t || this.next();
      }
      skipRow(e) {
        this._skipRows.add(e);
      }
      _advanceToNextRow() {
        return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
      }
      _isOverEndRow() {
        return void 0 !== this._endRow && this._row > this._endRow;
      }
      _isOverEndColumn() {
        return void 0 !== this._endColumn && this._column > this._endColumn;
      }
      _formatOutValue(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._row;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._column;
        return {
          done: !1,
          value: new fD(this, e, t, n)
        };
      }
      _shouldSkipSlot() {
        const e = this._skipRows.has(this._row),
          t = this._row < this._startRow,
          n = this._column < this._startColumn,
          i = void 0 !== this._endColumn && this._column > this._endColumn;
        return e || t || n || i;
      }
      _getSpanned() {
        const e = this._spannedCells.get(this._row);
        return e && e.get(this._column) || null;
      }
      _recordSpans(e, t, n) {
        const i = {
          cell: e,
          row: this._row,
          column: this._column
        };
        for (let e = this._row; e < this._row + t; e++) for (let t = this._column; t < this._column + n; t++) e == this._row && t == this._column || this._markSpannedCell(e, t, i);
      }
      _markSpannedCell(e, t, n) {
        this._spannedCells.has(e) || this._spannedCells.set(e, new Map());
        this._spannedCells.get(e).set(t, n);
      }
      _canJumpToStartRow() {
        return !!this._startRow && this._startRow > 0 && !this._jumpedToStartRow;
      }
      _jumpToNonSpannedRowClosestToStartRow() {
        const e = this._getRowLength(0);
        for (let t = this._startRow; !this._jumpedToStartRow; t--) e === this._getRowLength(t) && (this._row = t, this._rowIndex = t, this._jumpedToStartRow = !0);
      }
      _getRowLength(e) {
        return [...this._table.getChild(e).getChildren()].reduce((e, t) => e + parseInt(t.getAttribute("colspan") || "1"), 0);
      }
    }
    class fD {
      constructor(e, t, n, i) {
        this.cell = t, this.row = e._row, this.column = e._column, this.cellAnchorRow = n, this.cellAnchorColumn = i, this._cellIndex = e._cellIndex, this._rowIndex = e._rowIndex, this._table = e._table;
      }
      get isAnchor() {
        return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
      }
      get cellWidth() {
        return parseInt(this.cell.getAttribute("colspan") || "1");
      }
      get cellHeight() {
        return parseInt(this.cell.getAttribute("rowspan") || "1");
      }
      get rowIndex() {
        return this._rowIndex;
      }
      getPositionBefore() {
        return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
      }
    }
    function kD(e, t) {
      return (n, _ref144) => {
        let {
          writer: i
        } = _ref144;
        const o = n.getAttribute("headingRows") || 0,
          r = i.createContainerElement("table", null, []),
          s = i.createContainerElement("figure", {
            class: "table"
          }, r);
        o > 0 && i.insert(i.createPositionAt(r, "end"), i.createContainerElement("thead", null, i.createSlot(e => e.is("element", "tableRow") && e.index < o))), o < e.getRows(n) && i.insert(i.createPositionAt(r, "end"), i.createContainerElement("tbody", null, i.createSlot(e => e.is("element", "tableRow") && e.index >= o)));
        for (const {
          positionOffset: e,
          filter: n
        } of t.additionalSlots) i.insert(i.createPositionAt(r, e), i.createSlot(n));
        return i.insert(i.createPositionAt(r, "after"), i.createSlot(e => !e.is("element", "tableRow") && !t.additionalSlots.some(_ref145 => {
          let {
            filter: t
          } = _ref145;
          return t(e);
        }))), t.asWidget ? function (e, t) {
          return t.setCustomProperty("table", !0, e), vw(e, t, {
            hasSelectionHandle: !0
          });
        }(s, i) : s;
      };
    }
    function bD() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (t, _ref146) => {
        let {
          writer: n
        } = _ref146;
        const i = t.parent,
          o = i.parent,
          r = o.getChildIndex(i),
          s = new gD(o, {
            row: r
          }),
          a = o.getAttribute("headingRows") || 0,
          l = o.getAttribute("headingColumns") || 0;
        let c = null;
        for (const i of s) if (i.cell == t) {
          const t = i.row < a || i.column < l ? "th" : "td";
          c = e.asWidget ? Ew(n.createEditableElement(t), n) : n.createContainerElement(t);
          break;
        }
        return c;
      };
    }
    function _D() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (t, _ref147) => {
        let {
          writer: n
        } = _ref147;
        if (!t.parent.is("element", "tableCell")) return null;
        if (!wD(t)) return null;
        if (e.asWidget) return n.createContainerElement("span", {
          class: "ck-table-bogus-paragraph"
        });
        {
          const e = n.createContainerElement("p");
          return n.setCustomProperty("dataPipeline:transparentRendering", !0, e), e;
        }
      };
    }
    function wD(e) {
      return 1 == e.parent.childCount && !!e.getAttributeKeys().next().done;
    }
    class AD extends Pr {
      refresh() {
        const e = this.editor.model,
          t = e.document.selection,
          n = e.schema;
        this.isEnabled = function (e, t) {
          const n = e.getFirstPosition().parent,
            i = n === n.root ? n : n.parent;
          return t.checkChild(i, "table");
        }(t, n);
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor,
          n = t.model,
          i = t.plugins.get("TableUtils"),
          o = t.config.get("table.defaultHeadings.rows"),
          r = t.config.get("table.defaultHeadings.columns");
        void 0 === e.headingRows && o && (e.headingRows = o), void 0 === e.headingColumns && r && (e.headingColumns = r), n.change(t => {
          const o = i.createTable(t, e);
          n.insertObject(o, null, null, {
            findOptimalPosition: "auto"
          }), t.setSelection(t.createPositionAt(o.getNodeByPath([0, 0, 0]), 0));
        });
      }
    }
    class vD extends Pr {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e), this.order = t.order || "below";
      }
      refresh() {
        const e = this.editor.model.document.selection,
          t = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(e).length;
        this.isEnabled = t;
      }
      execute() {
        const e = this.editor,
          t = e.model.document.selection,
          n = e.plugins.get("TableUtils"),
          i = "above" === this.order,
          o = n.getSelectionAffectedTableCells(t),
          r = n.getRowIndexes(o),
          s = i ? r.first : r.last,
          a = o[0].findAncestor("table");
        n.insertRows(a, {
          at: i ? s : s + 1,
          copyStructureFromAbove: !i
        });
      }
    }
    class CD extends Pr {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e), this.order = t.order || "right";
      }
      refresh() {
        const e = this.editor.model.document.selection,
          t = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(e).length;
        this.isEnabled = t;
      }
      execute() {
        const e = this.editor,
          t = e.model.document.selection,
          n = e.plugins.get("TableUtils"),
          i = "left" === this.order,
          o = n.getSelectionAffectedTableCells(t),
          r = n.getColumnIndexes(o),
          s = i ? r.first : r.last,
          a = o[0].findAncestor("table");
        n.insertColumns(a, {
          columns: 1,
          at: i ? s : s + 1
        });
      }
    }
    class yD extends Pr {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e), this.direction = t.direction || "horizontally";
      }
      refresh() {
        const e = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = 1 === e.length;
      }
      execute() {
        const e = this.editor.plugins.get("TableUtils"),
          t = e.getSelectionAffectedTableCells(this.editor.model.document.selection)[0];
        "horizontally" === this.direction ? e.splitCellHorizontally(t, 2) : e.splitCellVertically(t, 2);
      }
    }
    function xD(e, t, n) {
      const {
          startRow: i,
          startColumn: o,
          endRow: r,
          endColumn: s
        } = t,
        a = n.createElement("table"),
        l = r - i + 1;
      for (let e = 0; e < l; e++) n.insertElement("tableRow", a, "end");
      const c = [...new gD(e, {
        startRow: i,
        endRow: r,
        startColumn: o,
        endColumn: s,
        includeAllSlots: !0
      })];
      for (const {
        row: e,
        column: t,
        cell: l,
        isAnchor: d,
        cellAnchorRow: u,
        cellAnchorColumn: h
      } of c) {
        const c = e - i,
          m = a.getChild(c);
        if (d) {
          const i = n.cloneElement(l);
          n.append(i, m), ID(i, e, t, r, s, n);
        } else (u < i || h < o) && lD(n, n.createPositionAt(m, "end"));
      }
      return function (e, t, n, i, o) {
        const r = parseInt(t.getAttribute("headingRows") || "0");
        if (r > 0) {
          aD("headingRows", r - n, e, o, 0);
        }
        const s = parseInt(t.getAttribute("headingColumns") || "0");
        if (s > 0) {
          aD("headingColumns", s - i, e, o, 0);
        }
      }(a, e, i, o, n), a;
    }
    function ED(e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      const i = [],
        o = new gD(e, {
          startRow: n,
          endRow: t - 1
        });
      for (const e of o) {
        const {
          row: n,
          cellHeight: o
        } = e;
        n < t && t <= n + o - 1 && i.push(e);
      }
      return i;
    }
    function SD(e, t, n) {
      const i = e.parent,
        o = i.parent,
        r = i.index,
        s = t - r,
        a = {},
        l = parseInt(e.getAttribute("rowspan")) - s;
      l > 1 && (a.rowspan = l);
      const c = parseInt(e.getAttribute("colspan") || "1");
      c > 1 && (a.colspan = c);
      const d = r + s,
        u = [...new gD(o, {
          startRow: r,
          endRow: d,
          includeAllSlots: !0
        })];
      let h,
        m = null;
      for (const t of u) {
        const {
          row: i,
          column: o,
          cell: r
        } = t;
        r === e && void 0 === h && (h = o), void 0 !== h && h === o && i === d && (m = lD(n, t.getPositionBefore(), a));
      }
      return aD("rowspan", s, e, n), m;
    }
    function DD(e, t) {
      const n = [],
        i = new gD(e);
      for (const e of i) {
        const {
          column: i,
          cellWidth: o
        } = e;
        i < t && t <= i + o - 1 && n.push(e);
      }
      return n;
    }
    function TD(e, t, n, i) {
      const o = n - t,
        r = {},
        s = parseInt(e.getAttribute("colspan")) - o;
      s > 1 && (r.colspan = s);
      const a = parseInt(e.getAttribute("rowspan") || "1");
      a > 1 && (r.rowspan = a);
      const l = lD(i, i.createPositionAfter(e), r);
      return aD("colspan", o, e, i), l;
    }
    function ID(e, t, n, i, o, r) {
      const s = parseInt(e.getAttribute("colspan") || "1"),
        a = parseInt(e.getAttribute("rowspan") || "1");
      if (n + s - 1 > o) {
        aD("colspan", o - n + 1, e, r, 1);
      }
      if (t + a - 1 > i) {
        aD("rowspan", i - t + 1, e, r, 1);
      }
    }
    function BD(e, t) {
      const n = t.getColumns(e),
        i = new Array(n).fill(0);
      for (const {
        column: t
      } of new gD(e)) i[t]++;
      const o = i.reduce((e, t, n) => t ? e : [...e, n], []);
      if (o.length > 0) {
        const n = o[o.length - 1];
        return t.removeColumns(e, {
          at: n
        }), !0;
      }
      return !1;
    }
    function MD(e, t) {
      const n = [],
        i = t.getRows(e);
      for (let t = 0; t < i; t++) {
        e.getChild(t).isEmpty && n.push(t);
      }
      if (n.length > 0) {
        const i = n[n.length - 1];
        return t.removeRows(e, {
          at: i
        }), !0;
      }
      return !1;
    }
    function PD(e, t) {
      BD(e, t) || MD(e, t);
    }
    function zD(e, t) {
      const n = Array.from(new gD(e, {
        startColumn: t.firstColumn,
        endColumn: t.lastColumn,
        row: t.lastRow
      }));
      if (n.every(_ref148 => {
        let {
          cellHeight: e
        } = _ref148;
        return 1 === e;
      })) return t.lastRow;
      const i = n[0].cellHeight - 1;
      return t.lastRow + i;
    }
    function ND(e, t) {
      const n = Array.from(new gD(e, {
        startRow: t.firstRow,
        endRow: t.lastRow,
        column: t.lastColumn
      }));
      if (n.every(_ref149 => {
        let {
          cellWidth: e
        } = _ref149;
        return 1 === e;
      })) return t.lastColumn;
      const i = n[0].cellWidth - 1;
      return t.lastColumn + i;
    }
    class LD extends Pr {
      constructor(e, t) {
        super(e), this.direction = t.direction, this.isHorizontal = "right" == this.direction || "left" == this.direction;
      }
      refresh() {
        const e = this._getMergeableCell();
        this.value = e, this.isEnabled = !!e;
      }
      execute() {
        const e = this.editor.model,
          t = e.document,
          n = this.editor.plugins.get("TableUtils").getTableCellsContainingSelection(t.selection)[0],
          i = this.value,
          o = this.direction;
        e.change(e => {
          const t = "right" == o || "down" == o,
            r = t ? n : i,
            s = t ? i : n,
            a = s.parent;
          !function (e, t, n) {
            RD(e) || (RD(t) && n.remove(n.createRangeIn(t)), n.move(n.createRangeIn(e), n.createPositionAt(t, "end")));
            n.remove(e);
          }(s, r, e);
          const l = this.isHorizontal ? "colspan" : "rowspan",
            c = parseInt(n.getAttribute(l) || "1"),
            d = parseInt(i.getAttribute(l) || "1");
          e.setAttribute(l, c + d, r), e.setSelection(e.createRangeIn(r));
          const u = this.editor.plugins.get("TableUtils");
          PD(a.findAncestor("table"), u);
        });
      }
      _getMergeableCell() {
        const e = this.editor.model.document,
          t = this.editor.plugins.get("TableUtils"),
          n = t.getTableCellsContainingSelection(e.selection)[0];
        if (!n) return;
        const i = this.isHorizontal ? function (e, t, n) {
          const i = e.parent,
            o = i.parent,
            r = "right" == t ? e.nextSibling : e.previousSibling,
            s = (o.getAttribute("headingColumns") || 0) > 0;
          if (!r) return;
          const a = "right" == t ? e : r,
            l = "right" == t ? r : e,
            {
              column: c
            } = n.getCellLocation(a),
            {
              column: d
            } = n.getCellLocation(l),
            u = parseInt(a.getAttribute("colspan") || "1"),
            h = cD(n, a),
            m = cD(n, l);
          if (s && h != m) return;
          return c + u === d ? r : void 0;
        }(n, this.direction, t) : function (e, t, n) {
          const i = e.parent,
            o = i.parent,
            r = o.getChildIndex(i);
          if ("down" == t && r === n.getRows(o) - 1 || "up" == t && 0 === r) return null;
          const s = parseInt(e.getAttribute("rowspan") || "1"),
            a = o.getAttribute("headingRows") || 0,
            l = "down" == t && r + s === a,
            c = "up" == t && r === a;
          if (a && (l || c)) return null;
          const d = parseInt(e.getAttribute("rowspan") || "1"),
            u = "down" == t ? r + d : r,
            h = [...new gD(o, {
              endRow: u
            })],
            m = h.find(t => t.cell === e),
            p = m.column,
            g = h.find(_ref150 => {
              let {
                row: e,
                cellHeight: n,
                column: i
              } = _ref150;
              return i === p && ("down" == t ? e === u : u === e + n);
            });
          return g && g.cell ? g.cell : null;
        }(n, this.direction, t);
        if (!i) return;
        const o = this.isHorizontal ? "rowspan" : "colspan",
          r = parseInt(n.getAttribute(o) || "1");
        return parseInt(i.getAttribute(o) || "1") === r ? i : void 0;
      }
    }
    function RD(e) {
      const t = e.getChild(0);
      return 1 == e.childCount && t.is("element", "paragraph") && t.isEmpty;
    }
    class VD extends Pr {
      refresh() {
        const e = this.editor.plugins.get("TableUtils"),
          t = e.getSelectionAffectedTableCells(this.editor.model.document.selection),
          n = t[0];
        if (n) {
          const i = n.findAncestor("table"),
            o = e.getRows(i) - 1,
            r = e.getRowIndexes(t),
            s = 0 === r.first && r.last === o;
          this.isEnabled = !s;
        } else this.isEnabled = !1;
      }
      execute() {
        const e = this.editor.model,
          t = this.editor.plugins.get("TableUtils"),
          n = t.getSelectionAffectedTableCells(e.document.selection),
          i = t.getRowIndexes(n),
          o = n[0],
          r = o.findAncestor("table"),
          s = t.getCellLocation(o).column;
        e.change(e => {
          const n = i.last - i.first + 1;
          t.removeRows(r, {
            at: i.first,
            rows: n
          });
          const o = function (e, t, n, i) {
            const o = e.getChild(Math.min(t, i - 1));
            let r = o.getChild(0),
              s = 0;
            for (const e of o.getChildren()) {
              if (s > n) return r;
              r = e, s += parseInt(e.getAttribute("colspan") || "1");
            }
            return r;
          }(r, i.first, s, t.getRows(r));
          e.setSelection(e.createPositionAt(o, 0));
        });
      }
    }
    class OD extends Pr {
      refresh() {
        const e = this.editor.plugins.get("TableUtils"),
          t = e.getSelectionAffectedTableCells(this.editor.model.document.selection),
          n = t[0];
        if (n) {
          const i = n.findAncestor("table"),
            o = e.getColumns(i),
            {
              first: r,
              last: s
            } = e.getColumnIndexes(t);
          this.isEnabled = s - r < o - 1;
        } else this.isEnabled = !1;
      }
      execute() {
        const e = this.editor.plugins.get("TableUtils"),
          [t, n] = function (e, t) {
            const n = t.getSelectionAffectedTableCells(e),
              i = n[0],
              o = n.pop(),
              r = [i, o];
            return i.isBefore(o) ? r : r.reverse();
          }(this.editor.model.document.selection, e),
          i = t.parent.parent,
          o = [...new gD(i)],
          r = {
            first: o.find(e => e.cell === t).column,
            last: o.find(e => e.cell === n).column
          },
          s = function (e, t, n, i) {
            const o = parseInt(n.getAttribute("colspan") || "1");
            return o > 1 ? n : t.previousSibling || n.nextSibling ? n.nextSibling || t.previousSibling : i.first ? e.reverse().find(_ref151 => {
              let {
                column: e
              } = _ref151;
              return e < i.first;
            }).cell : e.reverse().find(_ref152 => {
              let {
                column: e
              } = _ref152;
              return e > i.last;
            }).cell;
          }(o, t, n, r);
        this.editor.model.change(t => {
          const n = r.last - r.first + 1;
          e.removeColumns(i, {
            at: r.first,
            columns: n
          }), t.setSelection(t.createPositionAt(s, 0));
        });
      }
    }
    class FD extends Pr {
      refresh() {
        const e = this.editor.plugins.get("TableUtils"),
          t = this.editor.model,
          n = e.getSelectionAffectedTableCells(t.document.selection),
          i = n.length > 0;
        this.isEnabled = i, this.value = i && n.every(e => this._isInHeading(e, e.parent.parent));
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (e.forceValue === this.value) return;
        const t = this.editor.plugins.get("TableUtils"),
          n = this.editor.model,
          i = t.getSelectionAffectedTableCells(n.document.selection),
          o = i[0].findAncestor("table"),
          {
            first: r,
            last: s
          } = t.getRowIndexes(i),
          a = this.value ? r : s + 1,
          l = o.getAttribute("headingRows") || 0;
        n.change(e => {
          if (a) {
            const t = ED(o, a, a > l ? l : 0);
            for (const {
              cell: n
            } of t) SD(n, a, e);
          }
          aD("headingRows", a, o, e, 0);
        });
      }
      _isInHeading(e, t) {
        const n = parseInt(t.getAttribute("headingRows") || "0");
        return !!n && e.parent.index < n;
      }
    }
    class jD extends Pr {
      refresh() {
        const e = this.editor.model,
          t = this.editor.plugins.get("TableUtils"),
          n = t.getSelectionAffectedTableCells(e.document.selection),
          i = n.length > 0;
        this.isEnabled = i, this.value = i && n.every(e => cD(t, e));
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (e.forceValue === this.value) return;
        const t = this.editor.plugins.get("TableUtils"),
          n = this.editor.model,
          i = t.getSelectionAffectedTableCells(n.document.selection),
          o = i[0].findAncestor("table"),
          {
            first: r,
            last: s
          } = t.getColumnIndexes(i),
          a = this.value ? r : s + 1;
        n.change(e => {
          if (a) {
            const t = DD(o, a);
            for (const {
              cell: n,
              column: i
            } of t) TD(n, i, a, e);
          }
          aD("headingColumns", a, o, e, 0);
        });
      }
    }
    function HD(e) {
      if (e.is("element", "tableColumnGroup")) return e;
      const t = e.getChildren();
      return Array.from(t).find(e => e.is("element", "tableColumnGroup"));
    }
    function UD(e) {
      const t = HD(e);
      return t ? Array.from(t.getChildren()) : [];
    }
    class qD extends Br {
      static get pluginName() {
        return "TableUtils";
      }
      init() {
        this.decorate("insertColumns"), this.decorate("insertRows");
      }
      getCellLocation(e) {
        const t = e.parent,
          n = t.parent,
          i = n.getChildIndex(t),
          o = new gD(n, {
            row: i
          });
        for (const {
          cell: t,
          row: n,
          column: i
        } of o) if (t === e) return {
          row: n,
          column: i
        };
      }
      createTable(e, t) {
        const n = e.createElement("table"),
          i = t.rows || 2,
          o = t.columns || 2;
        return GD(e, n, 0, i, o), t.headingRows && aD("headingRows", Math.min(t.headingRows, i), n, e, 0), t.headingColumns && aD("headingColumns", Math.min(t.headingColumns, o), n, e, 0), n;
      }
      insertRows(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.editor.model,
          i = t.at || 0,
          o = t.rows || 1,
          r = void 0 !== t.copyStructureFromAbove,
          s = t.copyStructureFromAbove ? i - 1 : i,
          a = this.getRows(e),
          l = this.getColumns(e);
        if (i > a) throw new _("tableutils-insertrows-insert-out-of-range", this, {
          options: t
        });
        n.change(t => {
          const n = e.getAttribute("headingRows") || 0;
          if (n > i && aD("headingRows", n + o, e, t, 0), !r && (0 === i || i === a)) return void GD(t, e, i, o, l);
          const c = r ? Math.max(i, s) : i,
            d = new gD(e, {
              endRow: c
            }),
            u = new Array(l).fill(1);
          for (const {
            row: e,
            column: n,
            cellHeight: a,
            cellWidth: l,
            cell: c
          } of d) {
            const d = e + a - 1,
              h = e <= s && s <= d;
            e < i && i <= d ? (t.setAttribute("rowspan", a + o, c), u[n] = -l) : r && h && (u[n] = l);
          }
          for (let n = 0; n < o; n++) {
            const n = t.createElement("tableRow");
            t.insert(n, e, i);
            for (let e = 0; e < u.length; e++) {
              const i = u[e],
                o = t.createPositionAt(n, "end");
              i > 0 && lD(t, o, i > 1 ? {
                colspan: i
              } : void 0), e += Math.abs(i) - 1;
            }
          }
        });
      }
      insertColumns(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.editor.model,
          i = t.at || 0,
          o = t.columns || 1;
        n.change(t => {
          const n = e.getAttribute("headingColumns");
          i < n && t.setAttribute("headingColumns", n + o, e);
          const r = this.getColumns(e);
          if (0 === i || r === i) {
            for (const n of e.getChildren()) n.is("element", "tableRow") && KD(o, t, t.createPositionAt(n, i ? "end" : 0));
            return;
          }
          const s = new gD(e, {
            column: i,
            includeAllSlots: !0
          });
          for (const e of s) {
            const {
              row: n,
              cell: r,
              cellAnchorColumn: a,
              cellAnchorRow: l,
              cellWidth: c,
              cellHeight: d
            } = e;
            if (a < i) {
              t.setAttribute("colspan", c + o, r);
              const e = l + d - 1;
              for (let t = n; t <= e; t++) s.skipRow(t);
            } else KD(o, t, e.getPositionBefore());
          }
        });
      }
      removeRows(e, t) {
        const n = this.editor.model,
          i = t.rows || 1,
          o = this.getRows(e),
          r = t.at,
          s = r + i - 1;
        if (s > o - 1) throw new _("tableutils-removerows-row-index-out-of-range", this, {
          table: e,
          options: t
        });
        n.change(t => {
          const n = {
              first: r,
              last: s
            },
            {
              cellsToMove: i,
              cellsToTrim: o
            } = function (e, _ref153) {
              let {
                first: t,
                last: n
              } = _ref153;
              const i = new Map(),
                o = [];
              for (const {
                row: r,
                column: s,
                cellHeight: a,
                cell: l
              } of new gD(e, {
                endRow: n
              })) {
                const e = r + a - 1;
                if (r >= t && r <= n && e > n) {
                  const e = a - (n - r + 1);
                  i.set(s, {
                    cell: l,
                    rowspan: e
                  });
                }
                if (r < t && e >= t) {
                  let i;
                  i = e >= n ? n - t + 1 : e - t + 1, o.push({
                    cell: l,
                    rowspan: a - i
                  });
                }
              }
              return {
                cellsToMove: i,
                cellsToTrim: o
              };
            }(e, n);
          if (i.size) {
            !function (e, t, n, i) {
              const o = new gD(e, {
                  includeAllSlots: !0,
                  row: t
                }),
                r = [...o],
                s = e.getChild(t);
              let a;
              for (const {
                column: e,
                cell: t,
                isAnchor: o
              } of r) if (n.has(e)) {
                const {
                    cell: t,
                    rowspan: o
                  } = n.get(e),
                  r = a ? i.createPositionAfter(a) : i.createPositionAt(s, 0);
                i.move(i.createRangeOn(t), r), aD("rowspan", o, t, i), a = t;
              } else o && (a = t);
            }(e, s + 1, i, t);
          }
          for (let n = s; n >= r; n--) t.remove(e.getChild(n));
          for (const {
            rowspan: e,
            cell: n
          } of o) aD("rowspan", e, n, t);
          !function (e, _ref154, i) {
            let {
              first: t,
              last: n
            } = _ref154;
            const o = e.getAttribute("headingRows") || 0;
            if (t < o) {
              aD("headingRows", n < o ? o - (n - t + 1) : t, e, i, 0);
            }
          }(e, n, t), BD(e, this) || MD(e, this);
        });
      }
      removeColumns(e, t) {
        const n = this.editor.model,
          i = t.at,
          o = t.columns || 1,
          r = t.at + o - 1;
        n.change(t => {
          !function (e, t, n) {
            const i = e.getAttribute("headingColumns") || 0;
            if (i && t.first < i) {
              const o = Math.min(i - 1, t.last) - t.first + 1;
              n.setAttribute("headingColumns", i - o, e);
            }
          }(e, {
            first: i,
            last: r
          }, t);
          const n = UD(e);
          for (let o = r; o >= i; o--) {
            for (const {
              cell: n,
              column: i,
              cellWidth: r
            } of [...new gD(e)]) i <= o && r > 1 && i + r > o ? aD("colspan", r - 1, n, t) : i === o && t.remove(n);
            if (n[o]) {
              const e = 0 === o ? n[1] : n[o - 1],
                i = parseFloat(n[o].getAttribute("columnWidth")),
                r = parseFloat(e.getAttribute("columnWidth"));
              t.remove(n[o]), t.setAttribute("columnWidth", i + r + "%", e);
            }
          }
          MD(e, this) || BD(e, this);
        });
      }
      splitCellVertically(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        const n = this.editor.model,
          i = e.parent.parent,
          o = parseInt(e.getAttribute("rowspan") || "1"),
          r = parseInt(e.getAttribute("colspan") || "1");
        n.change(n => {
          if (r > 1) {
            const {
              newCellsSpan: i,
              updatedSpan: s
            } = WD(r, t);
            aD("colspan", s, e, n);
            const a = {};
            i > 1 && (a.colspan = i), o > 1 && (a.rowspan = o);
            KD(r > t ? t - 1 : r - 1, n, n.createPositionAfter(e), a);
          }
          if (r < t) {
            const s = t - r,
              a = [...new gD(i)],
              {
                column: l
              } = a.find(_ref155 => {
                let {
                  cell: t
                } = _ref155;
                return t === e;
              }),
              c = a.filter(_ref156 => {
                let {
                  cell: t,
                  cellWidth: n,
                  column: i
                } = _ref156;
                return t !== e && i === l || i < l && i + n > l;
              });
            for (const {
              cell: e,
              cellWidth: t
            } of c) n.setAttribute("colspan", t + s, e);
            const d = {};
            o > 1 && (d.rowspan = o), KD(s, n, n.createPositionAfter(e), d);
            const u = i.getAttribute("headingColumns") || 0;
            u > l && aD("headingColumns", u + s, i, n);
          }
        });
      }
      splitCellHorizontally(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        const n = this.editor.model,
          i = e.parent,
          o = i.parent,
          r = o.getChildIndex(i),
          s = parseInt(e.getAttribute("rowspan") || "1"),
          a = parseInt(e.getAttribute("colspan") || "1");
        n.change(n => {
          if (s > 1) {
            const i = [...new gD(o, {
                startRow: r,
                endRow: r + s - 1,
                includeAllSlots: !0
              })],
              {
                newCellsSpan: l,
                updatedSpan: c
              } = WD(s, t);
            aD("rowspan", c, e, n);
            const {
                column: d
              } = i.find(_ref157 => {
                let {
                  cell: t
                } = _ref157;
                return t === e;
              }),
              u = {};
            l > 1 && (u.rowspan = l), a > 1 && (u.colspan = a);
            for (const e of i) {
              const {
                column: t,
                row: i
              } = e;
              i >= r + c && t === d && (i + r + c) % l == 0 && KD(1, n, e.getPositionBefore(), u);
            }
          }
          if (s < t) {
            const i = t - s,
              l = [...new gD(o, {
                startRow: 0,
                endRow: r
              })];
            for (const {
              cell: t,
              cellHeight: o,
              row: s
            } of l) if (t !== e && s + o > r) {
              const e = o + i;
              n.setAttribute("rowspan", e, t);
            }
            const c = {};
            a > 1 && (c.colspan = a), GD(n, o, r + 1, i, 1, c);
            const d = o.getAttribute("headingRows") || 0;
            d > r && aD("headingRows", d + i, o, n);
          }
        });
      }
      getColumns(e) {
        return [...e.getChild(0).getChildren()].filter(e => e.is("element", "tableCell")).reduce((e, t) => e + parseInt(t.getAttribute("colspan") || "1"), 0);
      }
      getRows(e) {
        return Array.from(e.getChildren()).reduce((e, t) => t.is("element", "tableRow") ? e + 1 : e, 0);
      }
      createTableWalker(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new gD(e, t);
      }
      getSelectedTableCells(e) {
        const t = [];
        for (const n of this.sortRanges(e.getRanges())) {
          const e = n.getContainedElement();
          e && e.is("element", "tableCell") && t.push(e);
        }
        return t;
      }
      getTableCellsContainingSelection(e) {
        const t = [];
        for (const n of e.getRanges()) {
          const e = n.start.findAncestor("tableCell");
          e && t.push(e);
        }
        return t;
      }
      getSelectionAffectedTableCells(e) {
        const t = this.getSelectedTableCells(e);
        return t.length ? t : this.getTableCellsContainingSelection(e);
      }
      getRowIndexes(e) {
        const t = e.map(e => e.parent.index);
        return this._getFirstLastIndexesObject(t);
      }
      getColumnIndexes(e) {
        const t = e[0].findAncestor("table"),
          n = [...new gD(t)].filter(t => e.includes(t.cell)).map(e => e.column);
        return this._getFirstLastIndexesObject(n);
      }
      isSelectionRectangular(e) {
        if (e.length < 2 || !this._areCellInTheSameTableSection(e)) return !1;
        const t = new Set(),
          n = new Set();
        let i = 0;
        for (const o of e) {
          const {
              row: e,
              column: r
            } = this.getCellLocation(o),
            s = parseInt(o.getAttribute("rowspan")) || 1,
            a = parseInt(o.getAttribute("colspan")) || 1;
          t.add(e), n.add(r), s > 1 && t.add(e + s - 1), a > 1 && n.add(r + a - 1), i += s * a;
        }
        const o = function (e, t) {
          const n = Array.from(e.values()),
            i = Array.from(t.values()),
            o = Math.max(...n),
            r = Math.min(...n),
            s = Math.max(...i),
            a = Math.min(...i);
          return (o - r + 1) * (s - a + 1);
        }(t, n);
        return o == i;
      }
      sortRanges(e) {
        return Array.from(e).sort(YD);
      }
      _getFirstLastIndexesObject(e) {
        const t = e.sort((e, t) => e - t);
        return {
          first: t[0],
          last: t[t.length - 1]
        };
      }
      _areCellInTheSameTableSection(e) {
        const t = e[0].findAncestor("table"),
          n = this.getRowIndexes(e),
          i = parseInt(t.getAttribute("headingRows")) || 0;
        if (!this._areIndexesInSameSection(n, i)) return !1;
        const o = this.getColumnIndexes(e),
          r = parseInt(t.getAttribute("headingColumns")) || 0;
        return this._areIndexesInSameSection(o, r);
      }
      _areIndexesInSameSection(_ref158, n) {
        let {
          first: e,
          last: t
        } = _ref158;
        return e < n === t < n;
      }
    }
    function GD(e, t, n, i, o) {
      let r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      for (let s = 0; s < i; s++) {
        const i = e.createElement("tableRow");
        e.insert(i, t, n), KD(o, e, e.createPositionAt(i, "end"), r);
      }
    }
    function KD(e, t, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      for (let o = 0; o < e; o++) lD(t, n, i);
    }
    function WD(e, t) {
      if (e < t) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      const n = Math.floor(e / t);
      return {
        newCellsSpan: n,
        updatedSpan: e - n * t + n
      };
    }
    function YD(e, t) {
      const n = e.start,
        i = t.start;
      return n.isBefore(i) ? -1 : 1;
    }
    class $D extends Pr {
      refresh() {
        const e = this.editor.plugins.get(qD),
          t = e.getSelectedTableCells(this.editor.model.document.selection);
        this.isEnabled = e.isSelectionRectangular(t);
      }
      execute() {
        const e = this.editor.model,
          t = this.editor.plugins.get(qD);
        e.change(n => {
          const i = t.getSelectedTableCells(e.document.selection),
            o = i.shift(),
            {
              mergeWidth: r,
              mergeHeight: s
            } = function (e, t, n) {
              let i = 0,
                o = 0;
              for (const e of t) {
                const {
                  row: t,
                  column: r
                } = n.getCellLocation(e);
                i = JD(e, r, i, "colspan"), o = JD(e, t, o, "rowspan");
              }
              const {
                  row: r,
                  column: s
                } = n.getCellLocation(e),
                a = i - s,
                l = o - r;
              return {
                mergeWidth: a,
                mergeHeight: l
              };
            }(o, i, t);
          aD("colspan", r, o, n), aD("rowspan", s, o, n);
          for (const e of i) ZD(e, o, n);
          PD(o.findAncestor("table"), t), n.setSelection(o, "in");
        });
      }
    }
    function ZD(e, t, n) {
      QD(e) || (QD(t) && n.remove(n.createRangeIn(t)), n.move(n.createRangeIn(e), n.createPositionAt(t, "end"))), n.remove(e);
    }
    function QD(e) {
      const t = e.getChild(0);
      return 1 == e.childCount && t.is("element", "paragraph") && t.isEmpty;
    }
    function JD(e, t, n, i) {
      const o = parseInt(e.getAttribute(i) || "1");
      return Math.max(n, t + o);
    }
    class XD extends Pr {
      constructor(e) {
        super(e), this.affectsData = !1;
      }
      refresh() {
        const e = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = e.length > 0;
      }
      execute() {
        const e = this.editor.model,
          t = this.editor.plugins.get("TableUtils"),
          n = t.getSelectionAffectedTableCells(e.document.selection),
          i = t.getRowIndexes(n),
          o = n[0].findAncestor("table"),
          r = [];
        for (let t = i.first; t <= i.last; t++) for (const n of o.getChild(t).getChildren()) r.push(e.createRangeOn(n));
        e.change(e => {
          e.setSelection(r);
        });
      }
    }
    class eT extends Pr {
      constructor(e) {
        super(e), this.affectsData = !1;
      }
      refresh() {
        const e = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = e.length > 0;
      }
      execute() {
        const e = this.editor.plugins.get("TableUtils"),
          t = this.editor.model,
          n = e.getSelectionAffectedTableCells(t.document.selection),
          i = n[0],
          o = n.pop(),
          r = i.findAncestor("table"),
          s = e.getCellLocation(i),
          a = e.getCellLocation(o),
          l = Math.min(s.column, a.column),
          c = Math.max(s.column, a.column),
          d = [];
        for (const e of new gD(r, {
          startColumn: l,
          endColumn: c
        })) d.push(t.createRangeOn(e.cell));
        t.change(e => {
          e.setSelection(d);
        });
      }
    }
    function tT(e) {
      e.document.registerPostFixer(t => function (e, t) {
        const n = t.document.differ.getChanges();
        let i = !1;
        const o = new Set();
        for (const t of n) {
          let n = null;
          "insert" == t.type && "table" == t.name && (n = t.position.nodeAfter), "insert" != t.type && "remove" != t.type || "tableRow" != t.name && "tableCell" != t.name || (n = t.position.findAncestor("table")), oT(t) && (n = t.range.start.findAncestor("table")), n && !o.has(n) && (i = nT(n, e) || i, i = iT(n, e) || i, o.add(n));
        }
        return i;
      }(t, e));
    }
    function nT(e, t) {
      let n = !1;
      const i = function (e) {
        const t = parseInt(e.getAttribute("headingRows") || "0"),
          n = Array.from(e.getChildren()).reduce((e, t) => t.is("element", "tableRow") ? e + 1 : e, 0),
          i = [];
        for (const {
          row: o,
          cell: r,
          cellHeight: s
        } of new gD(e)) {
          if (s < 2) continue;
          const e = o < t ? t : n;
          if (o + s > e) {
            const t = e - o;
            i.push({
              cell: r,
              rowspan: t
            });
          }
        }
        return i;
      }(e);
      if (i.length) {
        n = !0;
        for (const e of i) aD("rowspan", e.rowspan, e.cell, t, 1);
      }
      return n;
    }
    function iT(e, t) {
      let n = !1;
      const i = function (e) {
          const t = new Array(e.childCount).fill(0);
          for (const {
            rowIndex: n
          } of new gD(e, {
            includeAllSlots: !0
          })) t[n]++;
          return t;
        }(e),
        o = [];
      for (const [t, n] of i.entries()) !n && e.getChild(t).is("element", "tableRow") && o.push(t);
      if (o.length) {
        n = !0;
        for (const n of o.reverse()) t.remove(e.getChild(n)), i.splice(n, 1);
      }
      const r = i.filter((t, n) => e.getChild(n).is("element", "tableRow")),
        s = r[0];
      if (!r.every(e => e === s)) {
        const i = r.reduce((e, t) => t > e ? t : e, 0);
        for (const [o, s] of r.entries()) {
          const r = i - s;
          if (r) {
            for (let n = 0; n < r; n++) lD(t, t.createPositionAt(e.getChild(o), "end"));
            n = !0;
          }
        }
      }
      return n;
    }
    function oT(e) {
      if ("attribute" !== e.type) return !1;
      const t = e.attributeKey;
      return "headingRows" === t || "colspan" === t || "rowspan" === t;
    }
    function rT(e) {
      e.document.registerPostFixer(t => function (e, t) {
        const n = t.document.differ.getChanges();
        let i = !1;
        for (const t of n) "insert" == t.type && "table" == t.name && (i = sT(t.position.nodeAfter, e) || i), "insert" == t.type && "tableRow" == t.name && (i = aT(t.position.nodeAfter, e) || i), "insert" == t.type && "tableCell" == t.name && (i = lT(t.position.nodeAfter, e) || i), "remove" != t.type && "insert" != t.type || !cT(t) || (i = lT(t.position.parent, e) || i);
        return i;
      }(t, e));
    }
    function sT(e, t) {
      let n = !1;
      for (const i of e.getChildren()) i.is("element", "tableRow") && (n = aT(i, t) || n);
      return n;
    }
    function aT(e, t) {
      let n = !1;
      for (const i of e.getChildren()) n = lT(i, t) || n;
      return n;
    }
    function lT(e, t) {
      if (0 == e.childCount) return t.insertElement("paragraph", e), !0;
      const n = Array.from(e.getChildren()).filter(e => e.is("$text"));
      for (const e of n) t.wrap(t.createRangeOn(e), "paragraph");
      return !!n.length;
    }
    function cT(e) {
      return !!e.position.parent.is("element", "tableCell") && ("insert" == e.type && "$text" == e.name || "remove" == e.type);
    }
    function dT(e, t) {
      if (!e.is("element", "paragraph")) return !1;
      const n = t.toViewElement(e);
      return !!n && wD(e) !== n.is("element", "span");
    }
    var uT = o(1674),
      hT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(uT.A, hT);
    uT.A.locals;
    class mT extends Br {
      static get pluginName() {
        return "TableEditing";
      }
      static get requires() {
        return [qD];
      }
      constructor(e) {
        super(e), this._additionalSlots = [];
      }
      init() {
        const e = this.editor,
          t = e.model,
          n = t.schema,
          i = e.conversion,
          o = e.plugins.get(qD);
        n.register("table", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["headingRows", "headingColumns"]
        }), n.register("tableRow", {
          allowIn: "table",
          isLimit: !0
        }), n.register("tableCell", {
          allowContentOf: "$container",
          allowIn: "tableRow",
          allowAttributes: ["colspan", "rowspan"],
          isLimit: !0,
          isSelectable: !0
        }), i.for("upcast").add(e => {
          e.on("element:figure", (e, t, n) => {
            if (!n.consumable.test(t.viewItem, {
              name: !0,
              classes: "table"
            })) return;
            const i = function (e) {
              for (const t of e.getChildren()) if (t.is("element", "table")) return t;
            }(t.viewItem);
            if (!i || !n.consumable.test(i, {
              name: !0
            })) return;
            n.consumable.consume(t.viewItem, {
              name: !0,
              classes: "table"
            });
            const o = Go(n.convertItem(i, t.modelCursor).modelRange.getItems());
            o ? (n.convertChildren(t.viewItem, n.writer.createPositionAt(o, "end")), n.updateConversionResult(o, t)) : n.consumable.revert(t.viewItem, {
              name: !0,
              classes: "table"
            });
          });
        }), i.for("upcast").add(hD()), i.for("editingDowncast").elementToStructure({
          model: {
            name: "table",
            attributes: ["headingRows"]
          },
          view: kD(o, {
            asWidget: !0,
            additionalSlots: this._additionalSlots
          })
        }), i.for("dataDowncast").elementToStructure({
          model: {
            name: "table",
            attributes: ["headingRows"]
          },
          view: kD(o, {
            additionalSlots: this._additionalSlots
          })
        }), i.for("upcast").elementToElement({
          model: "tableRow",
          view: "tr"
        }), i.for("upcast").add(e => {
          e.on("element:tr", (e, t) => {
            t.viewItem.isEmpty && 0 == t.modelCursor.index && e.stop();
          }, {
            priority: "high"
          });
        }), i.for("downcast").elementToElement({
          model: "tableRow",
          view: (e, _ref159) => {
            let {
              writer: t
            } = _ref159;
            return e.isEmpty ? t.createEmptyElement("tr") : t.createContainerElement("tr");
          }
        }), i.for("upcast").elementToElement({
          model: "tableCell",
          view: "td"
        }), i.for("upcast").elementToElement({
          model: "tableCell",
          view: "th"
        }), i.for("upcast").add(mD("td")), i.for("upcast").add(mD("th")), i.for("editingDowncast").elementToElement({
          model: "tableCell",
          view: bD({
            asWidget: !0
          })
        }), i.for("dataDowncast").elementToElement({
          model: "tableCell",
          view: bD()
        }), i.for("editingDowncast").elementToElement({
          model: "paragraph",
          view: _D({
            asWidget: !0
          }),
          converterPriority: "high"
        }), i.for("dataDowncast").elementToElement({
          model: "paragraph",
          view: _D(),
          converterPriority: "high"
        }), i.for("downcast").attributeToAttribute({
          model: "colspan",
          view: "colspan"
        }), i.for("upcast").attributeToAttribute({
          model: {
            key: "colspan",
            value: pT("colspan")
          },
          view: "colspan"
        }), i.for("downcast").attributeToAttribute({
          model: "rowspan",
          view: "rowspan"
        }), i.for("upcast").attributeToAttribute({
          model: {
            key: "rowspan",
            value: pT("rowspan")
          },
          view: "rowspan"
        }), e.config.define("table.defaultHeadings.rows", 0), e.config.define("table.defaultHeadings.columns", 0), e.commands.add("insertTable", new AD(e)), e.commands.add("insertTableRowAbove", new vD(e, {
          order: "above"
        })), e.commands.add("insertTableRowBelow", new vD(e, {
          order: "below"
        })), e.commands.add("insertTableColumnLeft", new CD(e, {
          order: "left"
        })), e.commands.add("insertTableColumnRight", new CD(e, {
          order: "right"
        })), e.commands.add("removeTableRow", new VD(e)), e.commands.add("removeTableColumn", new OD(e)), e.commands.add("splitTableCellVertically", new yD(e, {
          direction: "vertically"
        })), e.commands.add("splitTableCellHorizontally", new yD(e, {
          direction: "horizontally"
        })), e.commands.add("mergeTableCells", new $D(e)), e.commands.add("mergeTableCellRight", new LD(e, {
          direction: "right"
        })), e.commands.add("mergeTableCellLeft", new LD(e, {
          direction: "left"
        })), e.commands.add("mergeTableCellDown", new LD(e, {
          direction: "down"
        })), e.commands.add("mergeTableCellUp", new LD(e, {
          direction: "up"
        })), e.commands.add("setTableColumnHeader", new jD(e)), e.commands.add("setTableRowHeader", new FD(e)), e.commands.add("selectTableRow", new XD(e)), e.commands.add("selectTableColumn", new eT(e)), tT(t), rT(t), this.listenTo(t.document, "change:data", () => {
          !function (e, t) {
            const n = e.document.differ;
            for (const e of n.getChanges()) {
              let n,
                i = !1;
              if ("attribute" == e.type) {
                const t = e.range.start.nodeAfter;
                if (!t || !t.is("element", "table")) continue;
                if ("headingRows" != e.attributeKey && "headingColumns" != e.attributeKey) continue;
                n = t, i = "headingRows" == e.attributeKey;
              } else "tableRow" != e.name && "tableCell" != e.name || (n = e.position.findAncestor("table"), i = "tableRow" == e.name);
              if (!n) continue;
              const o = n.getAttribute("headingRows") || 0,
                r = n.getAttribute("headingColumns") || 0,
                s = new gD(n);
              for (const e of s) {
                const n = e.row < o || e.column < r ? "th" : "td",
                  s = t.mapper.toViewElement(e.cell);
                s && s.is("element") && s.name != n && t.reconvertItem(i ? e.cell.parent : e.cell);
              }
            }
          }(t, e.editing), function (e, t) {
            const n = e.document.differ,
              i = new Set();
            for (const e of n.getChanges()) {
              const t = "attribute" == e.type ? e.range.start.parent : e.position.parent;
              t.is("element", "tableCell") && i.add(t);
            }
            for (const e of i.values()) {
              const n = Array.from(e.getChildren()).filter(e => dT(e, t.mapper));
              for (const e of n) t.reconvertItem(e);
            }
          }(t, e.editing);
        });
      }
      registerAdditionalSlot(e) {
        this._additionalSlots.push(e);
      }
    }
    function pT(e) {
      return t => {
        const n = parseInt(t.getAttribute(e));
        return Number.isNaN(n) || n <= 0 ? null : n;
      };
    }
    var gT = o(3437),
      fT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(gT.A, fT);
    gT.A.locals;
    class kT extends Er {
      constructor(e) {
        super(e);
        const t = this.bindTemplate;
        this.items = this._createGridCollection(), this.keystrokes = new Wo(), this.focusTracker = new Ko(), this.set("rows", 0), this.set("columns", 0), this.bind("label").to(this, "columns", this, "rows", (e, t) => "".concat(t, " \xD7 ").concat(e)), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            on: {
              "mouseover@.ck-insert-table-dropdown-grid-box": t.to("boxover")
            },
            children: this.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-insert-table-dropdown__label"],
              "aria-hidden": !0
            },
            children: [{
              text: t.to("label")
            }]
          }],
          on: {
            mousedown: t.to(e => {
              e.preventDefault();
            }),
            click: t.to(() => {
              this.fire("execute");
            })
          }
        }), this.on("boxover", (e, t) => {
          const {
            row: n,
            column: i
          } = t.target.dataset;
          this.items.get(10 * (parseInt(n, 10) - 1) + (parseInt(i, 10) - 1)).focus();
        }), this.focusTracker.on("change:focusedElement", (e, t, n) => {
          if (!n) return;
          const {
            row: i,
            column: o
          } = n.dataset;
          this.set({
            rows: parseInt(i),
            columns: parseInt(o)
          });
        }), this.on("change:columns", () => this._highlightGridBoxes()), this.on("change:rows", () => this._highlightGridBoxes());
      }
      render() {
        super.render(), Ir({
          keystrokeHandler: this.keystrokes,
          focusTracker: this.focusTracker,
          gridItems: this.items,
          numberOfColumns: 10,
          uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
        for (const e of this.items) this.focusTracker.add(e.element);
        this.keystrokes.listenTo(this.element);
      }
      reset() {
        this.set({
          rows: 1,
          columns: 1
        });
      }
      focus() {
        this.items.get(0).focus();
      }
      focusLast() {
        this.items.get(0).focus();
      }
      _highlightGridBoxes() {
        const e = this.rows,
          t = this.columns;
        this.items.map((n, i) => {
          const o = Math.floor(i / 10) < e && i % 10 < t;
          n.set("isOn", o);
        });
      }
      _createGridButton(e, t, n, i) {
        const o = new um(e);
        return o.set({
          label: i,
          class: "ck-insert-table-dropdown-grid-box"
        }), o.extendTemplate({
          attributes: {
            "data-row": t,
            "data-column": n
          }
        }), o;
      }
      _createGridCollection() {
        const e = [];
        for (let t = 0; t < 100; t++) {
          const n = Math.floor(t / 10),
            i = t % 10,
            o = "".concat(n + 1, " \xD7 ").concat(i + 1);
          e.push(this._createGridButton(this.locale, n + 1, i + 1, o));
        }
        return this.createCollection(e);
      }
    }
    class bT extends Br {
      static get pluginName() {
        return "TableUI";
      }
      init() {
        const e = this.editor,
          t = this.editor.t,
          n = "ltr" === e.locale.contentLanguageDirection;
        e.ui.componentFactory.add("insertTable", n => {
          const i = e.commands.get("insertTable"),
            o = yp(n);
          let r;
          return o.bind("isEnabled").to(i), o.buttonView.set({
            icon: Wh.table,
            label: t("Insert table"),
            tooltip: !0
          }), o.on("change:isOpen", () => {
            r || (r = new kT(n), o.panelView.children.add(r), r.delegate("execute").to(o), o.on("execute", () => {
              e.execute("insertTable", {
                rows: r.rows,
                columns: r.columns
              }), e.editing.view.focus();
            }));
          }), o;
        }), e.ui.componentFactory.add("menuBar:insertTable", n => {
          const i = e.commands.get("insertTable"),
            o = new Fk(n),
            r = new kT(n);
          return r.delegate("execute").to(o), o.on("change:isOpen", (e, t, n) => {
            n || r.reset();
          }), r.on("execute", () => {
            e.execute("insertTable", {
              rows: r.rows,
              columns: r.columns
            }), e.editing.view.focus();
          }), o.buttonView.set({
            label: t("Table"),
            icon: Wh.table
          }), o.panelView.children.add(r), o.bind("isEnabled").to(i), o;
        }), e.ui.componentFactory.add("tableColumn", e => {
          const i = [{
            type: "switchbutton",
            model: {
              commandName: "setTableColumnHeader",
              label: t("Header column"),
              bindIsOn: !0
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: n ? "insertTableColumnLeft" : "insertTableColumnRight",
              label: t("Insert column left")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "insertTableColumnRight" : "insertTableColumnLeft",
              label: t("Insert column right")
            }
          }, {
            type: "button",
            model: {
              commandName: "removeTableColumn",
              label: t("Delete column")
            }
          }, {
            type: "button",
            model: {
              commandName: "selectTableColumn",
              label: t("Select column")
            }
          }];
          return this._prepareDropdown(t("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', i, e);
        }), e.ui.componentFactory.add("tableRow", e => {
          const n = [{
            type: "switchbutton",
            model: {
              commandName: "setTableRowHeader",
              label: t("Header row"),
              bindIsOn: !0
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: "insertTableRowAbove",
              label: t("Insert row above")
            }
          }, {
            type: "button",
            model: {
              commandName: "insertTableRowBelow",
              label: t("Insert row below")
            }
          }, {
            type: "button",
            model: {
              commandName: "removeTableRow",
              label: t("Delete row")
            }
          }, {
            type: "button",
            model: {
              commandName: "selectTableRow",
              label: t("Select row")
            }
          }];
          return this._prepareDropdown(t("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', n, e);
        }), e.ui.componentFactory.add("mergeTableCells", e => {
          const i = [{
            type: "button",
            model: {
              commandName: "mergeTableCellUp",
              label: t("Merge cell up")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "mergeTableCellRight" : "mergeTableCellLeft",
              label: t("Merge cell right")
            }
          }, {
            type: "button",
            model: {
              commandName: "mergeTableCellDown",
              label: t("Merge cell down")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "mergeTableCellLeft" : "mergeTableCellRight",
              label: t("Merge cell left")
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: "splitTableCellVertically",
              label: t("Split cell vertically")
            }
          }, {
            type: "button",
            model: {
              commandName: "splitTableCellHorizontally",
              label: t("Split cell horizontally")
            }
          }];
          return this._prepareMergeSplitButtonDropdown(t("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', i, e);
        });
      }
      _prepareDropdown(e, t, n, i) {
        const o = this.editor,
          r = yp(i),
          s = this._fillDropdownWithListOptions(r, n);
        return r.buttonView.set({
          label: e,
          icon: t,
          tooltip: !0
        }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
          for (var _len42 = arguments.length, e = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
            e[_key42] = arguments[_key42];
          }
          return e.some(e => e);
        }), this.listenTo(r, "execute", e => {
          o.execute(e.source.commandName), e.source instanceof pm || o.editing.view.focus();
        }), r;
      }
      _prepareMergeSplitButtonDropdown(e, t, n, i) {
        const o = this.editor,
          r = yp(i, _p),
          s = "mergeTableCells",
          a = o.commands.get(s),
          l = this._fillDropdownWithListOptions(r, n);
        return r.buttonView.set({
          label: e,
          icon: t,
          tooltip: !0,
          isEnabled: !0
        }), r.bind("isEnabled").toMany([a, ...l], "isEnabled", function () {
          for (var _len43 = arguments.length, e = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
            e[_key43] = arguments[_key43];
          }
          return e.some(e => e);
        }), this.listenTo(r.buttonView, "execute", () => {
          o.execute(s), o.editing.view.focus();
        }), this.listenTo(r, "execute", e => {
          o.execute(e.source.commandName), o.editing.view.focus();
        }), r;
      }
      _fillDropdownWithListOptions(e, t) {
        const n = this.editor,
          i = [],
          o = new qo();
        for (const e of t) _T(e, n, i, o);
        return Sp(e, o), i;
      }
    }
    function _T(e, t, n, i) {
      if ("button" === e.type || "switchbutton" === e.type) {
        const i = e.model = new Pf(e.model),
          {
            commandName: o,
            bindIsOn: r
          } = e.model,
          s = t.commands.get(o);
        n.push(s), i.set({
          commandName: o
        }), i.bind("isEnabled").to(s), r && i.bind("isOn").to(s, "value"), i.set({
          withText: !0
        });
      }
      i.add(e);
    }
    var wT = o(892),
      AT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(wT.A, AT);
    wT.A.locals;
    class vT extends Br {
      static get pluginName() {
        return "TableSelection";
      }
      static get requires() {
        return [qD, qD];
      }
      init() {
        const e = this.editor,
          t = e.model,
          n = e.editing.view;
        this.listenTo(t, "deleteContent", (e, t) => this._handleDeleteContent(e, t), {
          priority: "high"
        }), this.listenTo(n.document, "insertText", (e, t) => this._handleInsertTextEvent(e, t), {
          priority: "high"
        }), this._defineSelectionConverter(), this._enablePluginDisabling();
      }
      getSelectedTableCells() {
        const e = this.editor.plugins.get(qD),
          t = this.editor.model.document.selection,
          n = e.getSelectedTableCells(t);
        return 0 == n.length ? null : n;
      }
      getSelectionAsFragment() {
        const e = this.editor.plugins.get(qD),
          t = this.getSelectedTableCells();
        return t ? this.editor.model.change(n => {
          const i = n.createDocumentFragment(),
            {
              first: o,
              last: r
            } = e.getColumnIndexes(t),
            {
              first: s,
              last: a
            } = e.getRowIndexes(t),
            l = t[0].findAncestor("table");
          let c = a,
            d = r;
          if (e.isSelectionRectangular(t)) {
            const e = {
              firstColumn: o,
              lastColumn: r,
              firstRow: s,
              lastRow: a
            };
            c = zD(l, e), d = ND(l, e);
          }
          const u = xD(l, {
            startRow: s,
            startColumn: o,
            endRow: c,
            endColumn: d
          }, n);
          return n.insert(u, i, 0), i;
        }) : null;
      }
      setCellSelection(e, t) {
        const n = this._getCellsToSelect(e, t);
        this.editor.model.change(e => {
          e.setSelection(n.cells.map(t => e.createRangeOn(t)), {
            backward: n.backward
          });
        });
      }
      getFocusCell() {
        const e = [...this.editor.model.document.selection.getRanges()].pop().getContainedElement();
        return e && e.is("element", "tableCell") ? e : null;
      }
      getAnchorCell() {
        const e = Go(this.editor.model.document.selection.getRanges()).getContainedElement();
        return e && e.is("element", "tableCell") ? e : null;
      }
      _defineSelectionConverter() {
        const e = this.editor,
          t = new Set();
        e.conversion.for("editingDowncast").add(e => e.on("selection", (e, n, i) => {
          const o = i.writer;
          !function (e) {
            for (const n of t) e.removeClass("ck-editor__editable_selected", n);
            t.clear();
          }(o);
          const r = this.getSelectedTableCells();
          if (!r) return;
          for (const e of r) {
            const n = i.mapper.toViewElement(e);
            o.addClass("ck-editor__editable_selected", n), t.add(n);
          }
          const s = i.mapper.toViewElement(r[r.length - 1]);
          o.setSelection(s, 0);
        }, {
          priority: "lowest"
        }));
      }
      _enablePluginDisabling() {
        const e = this.editor;
        this.on("change:isEnabled", () => {
          if (!this.isEnabled) {
            const t = this.getSelectedTableCells();
            if (!t) return;
            e.model.change(n => {
              const i = n.createPositionAt(t[0], 0),
                o = e.model.schema.getNearestSelectionRange(i);
              n.setSelection(o);
            });
          }
        });
      }
      _handleDeleteContent(e, t) {
        const n = this.editor.plugins.get(qD),
          i = t[0],
          o = t[1],
          r = this.editor.model,
          s = !o || "backward" == o.direction,
          a = n.getSelectedTableCells(i);
        a.length && (e.stop(), r.change(e => {
          const t = a[s ? a.length - 1 : 0];
          r.change(e => {
            for (const t of a) r.deleteContent(e.createSelection(t, "in"));
          });
          const n = r.schema.getNearestSelectionRange(e.createPositionAt(t, 0));
          i.is("documentSelection") ? e.setSelection(n) : i.setTo(n);
        }));
      }
      _handleInsertTextEvent(e, t) {
        const n = this.editor,
          i = this.getSelectedTableCells();
        if (!i) return;
        const o = n.editing.view,
          r = n.editing.mapper,
          s = i.map(e => o.createRangeOn(r.toViewElement(e)));
        t.selection = o.createSelection(s);
      }
      _getCellsToSelect(e, t) {
        const n = this.editor.plugins.get("TableUtils"),
          i = n.getCellLocation(e),
          o = n.getCellLocation(t),
          r = Math.min(i.row, o.row),
          s = Math.max(i.row, o.row),
          a = Math.min(i.column, o.column),
          l = Math.max(i.column, o.column),
          c = new Array(s - r + 1).fill(null).map(() => []),
          d = {
            startRow: r,
            endRow: s,
            startColumn: a,
            endColumn: l
          };
        for (const {
          row: t,
          cell: n
        } of new gD(e.findAncestor("table"), d)) c[t - r].push(n);
        const u = o.row < i.row,
          h = o.column < i.column;
        return u && c.reverse(), h && c.forEach(e => e.reverse()), {
          cells: c.flat(),
          backward: u || h
        };
      }
    }
    class CT extends Br {
      static get pluginName() {
        return "TableClipboard";
      }
      static get requires() {
        return [hw, mw, vT, qD];
      }
      init() {
        const e = this.editor,
          t = e.editing.view.document;
        this.listenTo(t, "copy", (e, t) => this._onCopyCut(e, t)), this.listenTo(t, "cut", (e, t) => this._onCopyCut(e, t)), this.listenTo(e.model, "insertContent", (e, _ref160) => {
          let [t, n] = _ref160;
          return this._onInsertContent(e, t, n);
        }, {
          priority: "high"
        }), this.decorate("_replaceTableSlotCell");
      }
      _onCopyCut(e, t) {
        const n = this.editor.editing.view,
          i = this.editor.plugins.get(vT),
          o = this.editor.plugins.get(hw);
        i.getSelectedTableCells() && ("cut" != e.name || this.editor.model.canEditAt(this.editor.model.document.selection)) && (t.preventDefault(), e.stop(), this.editor.model.enqueueChange({
          isUndoable: "cut" === e.name
        }, () => {
          const r = o._copySelectedFragmentWithMarkers(e.name, this.editor.model.document.selection, () => i.getSelectionAsFragment());
          n.document.fire("clipboardOutput", {
            dataTransfer: t.dataTransfer,
            content: this.editor.data.toView(r),
            method: e.name
          });
        }));
      }
      _onInsertContent(e, t, n) {
        if (n && !n.is("documentSelection")) return;
        const i = this.editor.model,
          o = this.editor.plugins.get(qD),
          r = this.editor.plugins.get(hw),
          s = this.getTableIfOnlyTableInContent(t, i);
        if (!s) return;
        const a = o.getSelectionAffectedTableCells(i.document.selection);
        a.length ? (e.stop(), t.is("documentFragment") ? r._pasteMarkersIntoTransformedElement(t.markers, e => this._replaceSelectedCells(s, a, e)) : this.editor.model.change(e => {
          this._replaceSelectedCells(s, a, e);
        })) : PD(s, o);
      }
      _replaceSelectedCells(e, t, n) {
        const i = this.editor.plugins.get(qD),
          o = {
            width: i.getColumns(e),
            height: i.getRows(e)
          },
          r = function (e, t, n, i) {
            const o = e[0].findAncestor("table"),
              r = i.getColumnIndexes(e),
              s = i.getRowIndexes(e),
              a = {
                firstColumn: r.first,
                lastColumn: r.last,
                firstRow: s.first,
                lastRow: s.last
              },
              l = 1 === e.length;
            l && (a.lastRow += t.height - 1, a.lastColumn += t.width - 1, function (e, t, n, i) {
              const o = i.getColumns(e),
                r = i.getRows(e);
              n > o && i.insertColumns(e, {
                at: o,
                columns: n - o
              });
              t > r && i.insertRows(e, {
                at: r,
                rows: t - r
              });
            }(o, a.lastRow + 1, a.lastColumn + 1, i));
            l || !i.isSelectionRectangular(e) ? function (e, t, n) {
              const {
                  firstRow: i,
                  lastRow: o,
                  firstColumn: r,
                  lastColumn: s
                } = t,
                a = {
                  first: i,
                  last: o
                },
                l = {
                  first: r,
                  last: s
                };
              xT(e, r, a, n), xT(e, s + 1, a, n), yT(e, i, l, n), yT(e, o + 1, l, n, i);
            }(o, a, n) : (a.lastRow = zD(o, a), a.lastColumn = ND(o, a));
            return a;
          }(t, o, n, i),
          s = r.lastRow - r.firstRow + 1,
          a = r.lastColumn - r.firstColumn + 1;
        e = xD(e, {
          startRow: 0,
          startColumn: 0,
          endRow: Math.min(s, o.height) - 1,
          endColumn: Math.min(a, o.width) - 1
        }, n);
        const l = t[0].findAncestor("table"),
          c = this._replaceSelectedCellsWithPasted(e, o, l, r, n);
        if (this.editor.plugins.get("TableSelection").isEnabled) {
          const e = i.sortRanges(c.map(e => n.createRangeOn(e)));
          n.setSelection(e);
        } else n.setSelection(c[0], 0);
        return l;
      }
      _replaceSelectedCellsWithPasted(e, t, n, i, o) {
        const {
            width: r,
            height: s
          } = t,
          a = function (e, t, n) {
            const i = new Array(n).fill(null).map(() => new Array(t).fill(null));
            for (const {
              column: t,
              row: n,
              cell: o
            } of new gD(e)) i[n][t] = o;
            return i;
          }(e, r, s),
          l = [...new gD(n, {
            startRow: i.firstRow,
            endRow: i.lastRow,
            startColumn: i.firstColumn,
            endColumn: i.lastColumn,
            includeAllSlots: !0
          })],
          c = [];
        let d;
        for (const e of l) {
          const {
            row: t,
            column: n
          } = e;
          n === i.firstColumn && (d = e.getPositionBefore());
          const l = t - i.firstRow,
            u = n - i.firstColumn,
            h = a[l % s][u % r],
            m = h ? o.cloneElement(h) : null,
            p = this._replaceTableSlotCell(e, m, d, o);
          p && (ID(p, t, n, i.lastRow, i.lastColumn, o), c.push(p), d = o.createPositionAfter(p));
        }
        const u = parseInt(n.getAttribute("headingRows") || "0"),
          h = parseInt(n.getAttribute("headingColumns") || "0"),
          m = i.firstRow < u && u <= i.lastRow,
          p = i.firstColumn < h && h <= i.lastColumn;
        if (m) {
          const e = yT(n, u, {
            first: i.firstColumn,
            last: i.lastColumn
          }, o, i.firstRow);
          c.push(...e);
        }
        if (p) {
          const e = xT(n, h, {
            first: i.firstRow,
            last: i.lastRow
          }, o);
          c.push(...e);
        }
        return c;
      }
      _replaceTableSlotCell(e, t, n, i) {
        const {
          cell: o,
          isAnchor: r
        } = e;
        return r && i.remove(o), t ? (i.insert(t, n), t) : null;
      }
      getTableIfOnlyTableInContent(e, t) {
        if (!e.is("documentFragment") && !e.is("element")) return null;
        if (e.is("element", "table")) return e;
        if (1 == e.childCount && e.getChild(0).is("element", "table")) return e.getChild(0);
        const n = t.createRangeIn(e);
        for (const e of n.getItems()) if (e.is("element", "table")) {
          const i = t.createRange(n.start, t.createPositionBefore(e));
          if (t.hasContent(i, {
            ignoreWhitespaces: !0
          })) return null;
          const o = t.createRange(t.createPositionAfter(e), n.end);
          return t.hasContent(o, {
            ignoreWhitespaces: !0
          }) ? null : e;
        }
        return null;
      }
    }
    function yT(e, t, n, i) {
      let o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      if (t < 1) return;
      return ED(e, t, o).filter(_ref161 => {
        let {
          column: e,
          cellWidth: t
        } = _ref161;
        return ET(e, t, n);
      }).map(_ref162 => {
        let {
          cell: e
        } = _ref162;
        return SD(e, t, i);
      });
    }
    function xT(e, t, n, i) {
      if (t < 1) return;
      return DD(e, t).filter(_ref163 => {
        let {
          row: e,
          cellHeight: t
        } = _ref163;
        return ET(e, t, n);
      }).map(_ref164 => {
        let {
          cell: e,
          column: n
        } = _ref164;
        return TD(e, n, t, i);
      });
    }
    function ET(e, t, n) {
      const i = e + t - 1,
        {
          first: o,
          last: r
        } = n;
      return e >= o && e <= r || e < o && i >= o;
    }
    class ST extends Br {
      static get pluginName() {
        return "TableKeyboard";
      }
      static get requires() {
        return [vT, qD];
      }
      init() {
        var _this11 = this;
        const e = this.editor,
          t = e.editing.view.document,
          n = e.t;
        this.listenTo(t, "arrowKey", function () {
          return _this11._onArrowKey(...arguments);
        }, {
          context: "table"
        }), this.listenTo(t, "tab", function () {
          return _this11._handleTabOnSelectedTable(...arguments);
        }, {
          context: "figure"
        }), this.listenTo(t, "tab", function () {
          return _this11._handleTab(...arguments);
        }, {
          context: ["th", "td"]
        }), e.accessibility.addKeystrokeInfoGroup({
          id: "table",
          label: n("Keystrokes that can be used in a table cell"),
          keystrokes: [{
            label: n("Move the selection to the next cell"),
            keystroke: "Tab"
          }, {
            label: n("Move the selection to the previous cell"),
            keystroke: "Shift+Tab"
          }, {
            label: n("Insert a new table row (when in the last cell of a table)"),
            keystroke: "Tab"
          }, {
            label: n("Navigate through the table"),
            keystroke: [["arrowup"], ["arrowright"], ["arrowdown"], ["arrowleft"]]
          }]
        });
      }
      _handleTabOnSelectedTable(e, t) {
        const n = this.editor,
          i = n.model.document.selection.getSelectedElement();
        i && i.is("element", "table") && (t.preventDefault(), t.stopPropagation(), e.stop(), n.model.change(e => {
          e.setSelection(e.createRangeIn(i.getChild(0).getChild(0)));
        }));
      }
      _handleTab(e, t) {
        const n = this.editor,
          i = this.editor.plugins.get(qD),
          o = this.editor.plugins.get("TableSelection"),
          r = n.model.document.selection,
          s = !t.shiftKey;
        let a = i.getTableCellsContainingSelection(r)[0];
        if (a || (a = o.getFocusCell()), !a) return;
        t.preventDefault(), t.stopPropagation(), e.stop();
        const l = a.parent,
          c = l.parent,
          d = c.getChildIndex(l),
          u = l.getChildIndex(a),
          h = 0 === u;
        if (!s && h && 0 === d) return void n.model.change(e => {
          e.setSelection(e.createRangeOn(c));
        });
        const m = u === l.childCount - 1,
          p = d === i.getRows(c) - 1;
        if (s && p && m && (n.execute("insertTableRowBelow"), d === i.getRows(c) - 1)) return void n.model.change(e => {
          e.setSelection(e.createRangeOn(c));
        });
        let g;
        if (s && m) {
          const e = c.getChild(d + 1);
          g = e.getChild(0);
        } else if (!s && h) {
          const e = c.getChild(d - 1);
          g = e.getChild(e.childCount - 1);
        } else g = l.getChild(u + (s ? 1 : -1));
        n.model.change(e => {
          e.setSelection(e.createRangeIn(g));
        });
      }
      _onArrowKey(e, t) {
        const n = this.editor,
          i = bo(t.keyCode, n.locale.contentLanguageDirection);
        this._handleArrowKeys(i, t.shiftKey) && (t.preventDefault(), t.stopPropagation(), e.stop());
      }
      _handleArrowKeys(e, t) {
        const n = this.editor.plugins.get(qD),
          i = this.editor.plugins.get("TableSelection"),
          o = this.editor.model,
          r = o.document.selection,
          s = ["right", "down"].includes(e),
          a = n.getSelectedTableCells(r);
        if (a.length) {
          let n;
          return n = t ? i.getFocusCell() : s ? a[a.length - 1] : a[0], this._navigateFromCellInDirection(n, e, t), !0;
        }
        const l = r.focus.findAncestor("tableCell");
        if (!l) return !1;
        if (!r.isCollapsed) if (t) {
          if (r.isBackward == s && !r.containsEntireContent(l)) return !1;
        } else {
          const e = r.getSelectedElement();
          if (!e || !o.schema.isObject(e)) return !1;
        }
        return !!this._isSelectionAtCellEdge(r, l, s) && (this._navigateFromCellInDirection(l, e, t), !0);
      }
      _isSelectionAtCellEdge(e, t, n) {
        const i = this.editor.model,
          o = this.editor.model.schema,
          r = n ? e.getLastPosition() : e.getFirstPosition();
        if (!o.getLimitElement(r).is("element", "tableCell")) {
          return i.createPositionAt(t, n ? "end" : 0).isTouching(r);
        }
        const s = i.createSelection(r);
        return i.modifySelection(s, {
          direction: n ? "forward" : "backward"
        }), r.isEqual(s.focus);
      }
      _navigateFromCellInDirection(e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        const i = this.editor.model,
          o = e.findAncestor("table"),
          r = [...new gD(o, {
            includeAllSlots: !0
          })],
          {
            row: s,
            column: a
          } = r[r.length - 1],
          l = r.find(_ref165 => {
            let {
              cell: t
            } = _ref165;
            return t == e;
          });
        let {
          row: c,
          column: d
        } = l;
        switch (t) {
          case "left":
            d--;
            break;
          case "up":
            c--;
            break;
          case "right":
            d += l.cellWidth;
            break;
          case "down":
            c += l.cellHeight;
        }
        if (c < 0 || c > s || d < 0 && c <= 0 || d > a && c >= s) return void i.change(e => {
          e.setSelection(e.createRangeOn(o));
        });
        d < 0 ? (d = n ? 0 : a, c--) : d > a && (d = n ? a : 0, c++);
        const u = r.find(e => e.row == c && e.column == d).cell,
          h = ["right", "down"].includes(t),
          m = this.editor.plugins.get("TableSelection");
        if (n && m.isEnabled) {
          const t = m.getAnchorCell() || e;
          m.setCellSelection(t, u);
        } else {
          const e = i.createPositionAt(u, h ? 0 : "end");
          i.change(t => {
            t.setSelection(e);
          });
        }
      }
    }
    class DT extends tl {
      constructor() {
        super(...arguments), this.domEventType = ["mousemove", "mouseleave"];
      }
      onDomEvent(e) {
        this.fire(e.type, e);
      }
    }
    class TT extends Br {
      static get pluginName() {
        return "TableMouse";
      }
      static get requires() {
        return [vT, qD];
      }
      init() {
        this.editor.editing.view.addObserver(DT), this._enableShiftClickSelection(), this._enableMouseDragSelection();
      }
      _enableShiftClickSelection() {
        const e = this.editor,
          t = e.plugins.get(qD);
        let n = !1;
        const i = e.plugins.get(vT);
        this.listenTo(e.editing.view.document, "mousedown", (o, r) => {
          const s = e.model.document.selection;
          if (!this.isEnabled || !i.isEnabled) return;
          if (!r.domEvent.shiftKey) return;
          const a = i.getAnchorCell() || t.getTableCellsContainingSelection(s)[0];
          if (!a) return;
          const l = this._getModelTableCellFromDomEvent(r);
          l && IT(a, l) && (n = !0, i.setCellSelection(a, l), r.preventDefault());
        }), this.listenTo(e.editing.view.document, "mouseup", () => {
          n = !1;
        }), this.listenTo(e.editing.view.document, "selectionChange", e => {
          n && e.stop();
        }, {
          priority: "highest"
        });
      }
      _enableMouseDragSelection() {
        const e = this.editor;
        let t,
          n,
          i = !1,
          o = !1;
        const r = e.plugins.get(vT);
        this.listenTo(e.editing.view.document, "mousedown", (e, n) => {
          this.isEnabled && r.isEnabled && (n.domEvent.shiftKey || n.domEvent.ctrlKey || n.domEvent.altKey || (t = this._getModelTableCellFromDomEvent(n)));
        }), this.listenTo(e.editing.view.document, "mousemove", (e, s) => {
          if (!s.domEvent.buttons) return;
          if (!t) return;
          const a = this._getModelTableCellFromDomEvent(s);
          a && IT(t, a) && (n = a, i || n == t || (i = !0)), i && (o = !0, r.setCellSelection(t, n), s.preventDefault());
        }), this.listenTo(e.editing.view.document, "mouseup", () => {
          i = !1, o = !1, t = null, n = null;
        }), this.listenTo(e.editing.view.document, "selectionChange", e => {
          o && e.stop();
        }, {
          priority: "highest"
        });
      }
      _getModelTableCellFromDomEvent(e) {
        const t = e.target,
          n = this.editor.editing.view.createPositionAt(t, 0);
        return this.editor.editing.mapper.toModelPosition(n).parent.findAncestor("tableCell", {
          includeSelf: !0
        });
      }
    }
    function IT(e, t) {
      return e.parent.parent == t.parent.parent;
    }
    var BT = o(2524),
      MT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(BT.A, MT);
    BT.A.locals;
    function PT(e) {
      const t = zT(e);
      return t || NT(e);
    }
    function zT(e) {
      const t = e.getSelectedElement();
      return t && LT(t) ? t : null;
    }
    function NT(e) {
      const t = e.getFirstPosition();
      if (!t) return null;
      let n = t.parent;
      for (; n;) {
        if (n.is("element") && LT(n)) return n;
        n = n.parent;
      }
      return null;
    }
    function LT(e) {
      return !!e.getCustomProperty("table") && Aw(e);
    }
    var RT = o(173),
      VT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(RT.A, VT);
    RT.A.locals;
    class OT extends Er {
      constructor(e, t) {
        super(e), this.set("value", ""), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isEmpty", !0), this.options = t, this.focusTracker = new Ko(), this._focusables = new er(), this.dropdownView = this._createDropdownView(), this.inputView = this._createInputTextView(), this.keystrokes = new Wo(), this._stillTyping = !1, this.focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-input-color"]
          },
          children: [this.dropdownView, this.inputView]
        }), this.on("change:value", (e, t, n) => this._setInputValue(n));
      }
      render() {
        super.render(), [this.inputView, this.dropdownView.buttonView].forEach(e => {
          this.focusTracker.add(e.element), this._focusables.add(e);
        }), this.keystrokes.listenTo(this.element);
      }
      focus(e) {
        -1 === e ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createDropdownView() {
        const e = this.locale,
          t = e.t,
          n = this.bindTemplate,
          i = this._createColorSelector(e),
          o = yp(e),
          r = new Er();
        return r.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-input-color__button__preview"],
            style: {
              backgroundColor: n.to("value")
            }
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-input-color__button__preview__no-color-indicator", n.if("value", "ck-hidden", e => "" != e)]
            }
          }]
        }), o.buttonView.extendTemplate({
          attributes: {
            class: "ck-input-color__button"
          }
        }), o.buttonView.children.add(r), o.buttonView.label = t("Color picker"), o.buttonView.tooltip = !0, o.panelPosition = "rtl" === e.uiLanguageDirection ? "se" : "sw", o.panelView.children.add(i), o.bind("isEnabled").to(this, "isReadOnly", e => !e), o.on("change:isOpen", (e, t, n) => {
          n && (i.updateSelectedColors(), i.showColorGridsFragment());
        }), o;
      }
      _createInputTextView() {
        const e = this.locale,
          t = new Hm(e);
        return t.extendTemplate({
          on: {
            blur: t.bindTemplate.to("blur")
          }
        }), t.value = this.value, t.bind("isReadOnly", "hasError").to(this), this.bind("isFocused", "isEmpty").to(t), t.on("input", () => {
          const e = t.element.value,
            n = this.options.colorDefinitions.find(t => e === t.label);
          this._stillTyping = !0, this.value = n && n.color || e;
        }), t.on("blur", () => {
          this._stillTyping = !1, this._setInputValue(t.element.value);
        }), t.delegate("input").to(this), t;
      }
      _createColorSelector(e) {
        const t = e.t,
          n = this.options.defaultColorValue || "",
          i = t(n ? "Restore default" : "Remove color"),
          o = new yg(e, {
            colors: this.options.colorDefinitions,
            columns: this.options.columns,
            removeButtonLabel: i,
            colorPickerLabel: t("Color picker"),
            colorPickerViewConfig: !1 !== this.options.colorPickerConfig && {
              ...this.options.colorPickerConfig,
              hideInput: !0
            }
          });
        o.appendUI(), o.on("execute", (e, t) => {
          "colorPickerSaveButton" !== t.source ? (this.value = t.value || n, this.fire("input"), "colorPicker" !== t.source && (this.dropdownView.isOpen = !1)) : this.dropdownView.isOpen = !1;
        });
        let r = this.value;
        return o.on("colorPicker:cancel", () => {
          this.value = r, this.fire("input"), this.dropdownView.isOpen = !1;
        }), o.colorGridsFragmentView.colorPickerButtonView.on("execute", () => {
          r = this.value;
        }), o.bind("selectedColor").to(this, "value"), o;
      }
      _setInputValue(e) {
        if (!this._stillTyping) {
          const t = FT(e),
            n = this.options.colorDefinitions.find(e => t === FT(e.color));
          this.inputView.value = n ? n.label : e || "";
        }
      }
    }
    function FT(e) {
      return e.replace(/([(,])\s+/g, "$1").replace(/^\s+|\s+(?=[),\s]|$)/g, "").replace(/,|\s/g, " ");
    }
    const jT = e => "" === e;
    function HT(e) {
      return {
        none: e("None"),
        solid: e("Solid"),
        dotted: e("Dotted"),
        dashed: e("Dashed"),
        double: e("Double"),
        groove: e("Groove"),
        ridge: e("Ridge"),
        inset: e("Inset"),
        outset: e("Outset")
      };
    }
    function UT(e) {
      return e('The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".');
    }
    function qT(e) {
      return e('The value is invalid. Try "10px" or "2em" or simply "2".');
    }
    function GT(e) {
      return e = e.trim().toLowerCase(), jT(e) || ah(e);
    }
    function KT(e) {
      return e = e.trim(), jT(e) || JT(e) || uh(e) || mh(e);
    }
    function WT(e) {
      return e = e.trim(), jT(e) || JT(e) || uh(e);
    }
    function YT(e, t) {
      const n = new qo(),
        i = HT(e.t);
      for (const o in i) {
        const r = {
          type: "button",
          model: new Pf({
            _borderStyleValue: o,
            label: i[o],
            role: "menuitemradio",
            withText: !0
          })
        };
        "none" === o ? r.model.bind("isOn").to(e, "borderStyle", e => "none" === t ? !e : e === o) : r.model.bind("isOn").to(e, "borderStyle", e => e === o), n.add(r);
      }
      return n;
    }
    function $T(e) {
      const {
        view: t,
        icons: n,
        toolbar: i,
        labels: o,
        propertyName: r,
        nameToValue: s,
        defaultValue: a
      } = e;
      for (const e in o) {
        const l = new um(t.locale);
        l.set({
          label: o[e],
          icon: n[e],
          tooltip: o[e]
        });
        const c = s ? s(e) : e;
        l.bind("isOn").to(t, r, e => {
          let t = e;
          return "" === e && a && (t = a), c === t;
        }), l.on("execute", () => {
          t[r] = c;
        }), i.items.add(l);
      }
    }
    const ZT = [{
      color: "hsl(0, 0%, 0%)",
      label: "Black"
    }, {
      color: "hsl(0, 0%, 30%)",
      label: "Dim grey"
    }, {
      color: "hsl(0, 0%, 60%)",
      label: "Grey"
    }, {
      color: "hsl(0, 0%, 90%)",
      label: "Light grey"
    }, {
      color: "hsl(0, 0%, 100%)",
      label: "White",
      hasBorder: !0
    }, {
      color: "hsl(0, 75%, 60%)",
      label: "Red"
    }, {
      color: "hsl(30, 75%, 60%)",
      label: "Orange"
    }, {
      color: "hsl(60, 75%, 60%)",
      label: "Yellow"
    }, {
      color: "hsl(90, 75%, 60%)",
      label: "Light green"
    }, {
      color: "hsl(120, 75%, 60%)",
      label: "Green"
    }, {
      color: "hsl(150, 75%, 60%)",
      label: "Aquamarine"
    }, {
      color: "hsl(180, 75%, 60%)",
      label: "Turquoise"
    }, {
      color: "hsl(210, 75%, 60%)",
      label: "Light blue"
    }, {
      color: "hsl(240, 75%, 60%)",
      label: "Blue"
    }, {
      color: "hsl(270, 75%, 60%)",
      label: "Purple"
    }];
    function QT(e) {
      return (t, n, i) => {
        const o = new OT(t.locale, {
          colorDefinitions: (r = e.colorConfig, r.map(e => ({
            color: e.model,
            label: e.label,
            options: {
              hasBorder: e.hasBorder
            }
          }))),
          columns: e.columns,
          defaultColorValue: e.defaultColorValue,
          colorPickerConfig: e.colorPickerConfig
        });
        var r;
        return o.inputView.set({
          id: n,
          ariaDescribedById: i
        }), o.bind("isReadOnly").to(t, "isEnabled", e => !e), o.bind("hasError").to(t, "errorText", e => !!e), o.on("input", () => {
          t.errorText = null;
        }), t.bind("isEmpty", "isFocused").to(o), o;
      };
    }
    function JT(e) {
      const t = parseFloat(e);
      return !Number.isNaN(t) && e === String(t);
    }
    var XT = o(1834),
      eI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(XT.A, eI);
    XT.A.locals;
    class tI extends Er {
      constructor(e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e);
        const n = this.bindTemplate;
        this.set("class", t.class || null), this.children = this.createCollection(), t.children && t.children.forEach(e => this.children.add(e)), this.set("_role", null), this.set("_ariaLabelledBy", null), t.labelView && this.set({
          _role: "group",
          _ariaLabelledBy: t.labelView.id
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-form__row", n.to("class")],
            role: n.to("_role"),
            "aria-labelledby": n.to("_ariaLabelledBy")
          },
          children: this.children
        });
      }
    }
    var nI = o(1928),
      iI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(nI.A, iI);
    nI.A.locals;
    var oI = o(786),
      rI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(oI.A, rI);
    oI.A.locals;
    var sI = o(9311),
      aI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(sI.A, aI);
    sI.A.locals;
    const lI = {
      left: Wh.alignLeft,
      center: Wh.alignCenter,
      right: Wh.alignRight,
      justify: Wh.alignJustify,
      top: Wh.alignTop,
      middle: Wh.alignMiddle,
      bottom: Wh.alignBottom
    };
    class cI extends Er {
      constructor(e, t) {
        super(e), this.set({
          borderStyle: "",
          borderWidth: "",
          borderColor: "",
          padding: "",
          backgroundColor: "",
          width: "",
          height: "",
          horizontalAlignment: "",
          verticalAlignment: ""
        }), this.options = t;
        const {
            borderStyleDropdown: n,
            borderWidthInput: i,
            borderColorInput: o,
            borderRowLabel: r
          } = this._createBorderFields(),
          {
            backgroundRowLabel: s,
            backgroundInput: a
          } = this._createBackgroundFields(),
          {
            widthInput: l,
            operatorLabel: c,
            heightInput: d,
            dimensionsLabel: u
          } = this._createDimensionFields(),
          {
            horizontalAlignmentToolbar: h,
            verticalAlignmentToolbar: m,
            alignmentLabel: p
          } = this._createAlignmentFields();
        this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.children = this.createCollection(), this.borderStyleDropdown = n, this.borderWidthInput = i, this.borderColorInput = o, this.backgroundInput = a, this.paddingInput = this._createPaddingField(), this.widthInput = l, this.heightInput = d, this.horizontalAlignmentToolbar = h, this.verticalAlignmentToolbar = m;
        const {
          saveButtonView: g,
          cancelButtonView: f
        } = this._createActionButtons();
        this.saveButtonView = g, this.cancelButtonView = f, this._focusables = new er(), this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.children.add(new Tg(e, {
          label: this.t("Cell properties")
        })), this.children.add(new tI(e, {
          labelView: r,
          children: [r, n, o, i],
          class: "ck-table-form__border-row"
        })), this.children.add(new tI(e, {
          labelView: s,
          children: [s, a],
          class: "ck-table-form__background-row"
        })), this.children.add(new tI(e, {
          children: [new tI(e, {
            labelView: u,
            children: [u, l, c, d],
            class: "ck-table-form__dimensions-row"
          }), new tI(e, {
            children: [this.paddingInput],
            class: "ck-table-cell-properties-form__padding-row"
          })]
        })), this.children.add(new tI(e, {
          labelView: p,
          children: [p, h, m],
          class: "ck-table-cell-properties-form__alignment-row"
        })), this.children.add(new tI(e, {
          children: [this.saveButtonView, this.cancelButtonView],
          class: "ck-table-form__action-row"
        })), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-form", "ck-table-form", "ck-table-cell-properties-form"],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), Tr({
          view: this
        }), [this.borderColorInput, this.backgroundInput].forEach(e => {
          e.fieldView.focusCycler.on("forwardCycle", e => {
            this._focusCycler.focusNext(), e.stop();
          }), e.fieldView.focusCycler.on("backwardCycle", e => {
            this._focusCycler.focusPrevious(), e.stop();
          });
        }), [this.borderStyleDropdown, this.borderColorInput, this.borderWidthInput, this.backgroundInput, this.widthInput, this.heightInput, this.paddingInput, this.horizontalAlignmentToolbar, this.verticalAlignmentToolbar, this.saveButtonView, this.cancelButtonView].forEach(e => {
          this._focusables.add(e), this.focusTracker.add(e.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      _createBorderFields() {
        const e = this.options.defaultTableCellProperties,
          t = {
            style: e.borderStyle,
            width: e.borderWidth,
            color: e.borderColor
          },
          n = QT({
            colorConfig: this.options.borderColors,
            columns: 5,
            defaultColorValue: t.color,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          i = this.locale,
          o = this.t,
          r = o("Style"),
          s = new Zh(i);
        s.text = o("Border");
        const a = HT(o),
          l = new Rm(i, Pp);
        l.set({
          label: r,
          class: "ck-table-form__border-style"
        }), l.fieldView.buttonView.set({
          ariaLabel: r,
          ariaLabelledBy: void 0,
          isOn: !1,
          withText: !0,
          tooltip: r
        }), l.fieldView.buttonView.bind("label").to(this, "borderStyle", e => a[e || "none"]), l.fieldView.on("execute", e => {
          this.borderStyle = e.source._borderStyleValue;
        }), l.bind("isEmpty").to(this, "borderStyle", e => !e), Sp(l.fieldView, YT(this, t.style), {
          role: "menu",
          ariaLabel: r
        });
        const c = new Rm(i, Bp);
        c.set({
          label: o("Width"),
          class: "ck-table-form__border-width"
        }), c.fieldView.bind("value").to(this, "borderWidth"), c.bind("isEnabled").to(this, "borderStyle", dI), c.fieldView.on("input", () => {
          this.borderWidth = c.fieldView.element.value;
        });
        const d = new Rm(i, n);
        return d.set({
          label: o("Color"),
          class: "ck-table-form__border-color"
        }), d.fieldView.bind("value").to(this, "borderColor"), d.bind("isEnabled").to(this, "borderStyle", dI), d.fieldView.on("input", () => {
          this.borderColor = d.fieldView.value;
        }), this.on("change:borderStyle", (e, n, i, o) => {
          dI(i) || (this.borderColor = "", this.borderWidth = ""), dI(o) || (this.borderColor = t.color, this.borderWidth = t.width);
        }), {
          borderRowLabel: s,
          borderStyleDropdown: l,
          borderColorInput: d,
          borderWidthInput: c
        };
      }
      _createBackgroundFields() {
        const e = this.locale,
          t = this.t,
          n = new Zh(e);
        n.text = t("Background");
        const i = QT({
            colorConfig: this.options.backgroundColors,
            columns: 5,
            defaultColorValue: this.options.defaultTableCellProperties.backgroundColor,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          o = new Rm(e, i);
        return o.set({
          label: t("Color"),
          class: "ck-table-cell-properties-form__background"
        }), o.fieldView.bind("value").to(this, "backgroundColor"), o.fieldView.on("input", () => {
          this.backgroundColor = o.fieldView.value;
        }), {
          backgroundRowLabel: n,
          backgroundInput: o
        };
      }
      _createDimensionFields() {
        const e = this.locale,
          t = this.t,
          n = new Zh(e);
        n.text = t("Dimensions");
        const i = new Rm(e, Bp);
        i.set({
          label: t("Width"),
          class: "ck-table-form__dimensions-row__width"
        }), i.fieldView.bind("value").to(this, "width"), i.fieldView.on("input", () => {
          this.width = i.fieldView.element.value;
        });
        const o = new Er(e);
        o.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck-table-form__dimension-operator"]
          },
          children: [{
            text: "×"
          }]
        });
        const r = new Rm(e, Bp);
        return r.set({
          label: t("Height"),
          class: "ck-table-form__dimensions-row__height"
        }), r.fieldView.bind("value").to(this, "height"), r.fieldView.on("input", () => {
          this.height = r.fieldView.element.value;
        }), {
          dimensionsLabel: n,
          widthInput: i,
          operatorLabel: o,
          heightInput: r
        };
      }
      _createPaddingField() {
        const e = this.locale,
          t = this.t,
          n = new Rm(e, Bp);
        return n.set({
          label: t("Padding"),
          class: "ck-table-cell-properties-form__padding"
        }), n.fieldView.bind("value").to(this, "padding"), n.fieldView.on("input", () => {
          this.padding = n.fieldView.element.value;
        }), n;
      }
      _createAlignmentFields() {
        const e = this.locale,
          t = this.t,
          n = new Zh(e);
        n.text = t("Table cell text alignment");
        const i = new ap(e),
          o = "rtl" === e.contentLanguageDirection;
        i.set({
          isCompact: !0,
          ariaLabel: t("Horizontal text alignment toolbar")
        }), $T({
          view: this,
          icons: lI,
          toolbar: i,
          labels: this._horizontalAlignmentLabels,
          propertyName: "horizontalAlignment",
          nameToValue: e => {
            if (o) {
              if ("left" === e) return "right";
              if ("right" === e) return "left";
            }
            return e;
          },
          defaultValue: this.options.defaultTableCellProperties.horizontalAlignment
        });
        const r = new ap(e);
        return r.set({
          isCompact: !0,
          ariaLabel: t("Vertical text alignment toolbar")
        }), $T({
          view: this,
          icons: lI,
          toolbar: r,
          labels: this._verticalAlignmentLabels,
          propertyName: "verticalAlignment",
          defaultValue: this.options.defaultTableCellProperties.verticalAlignment
        }), {
          horizontalAlignmentToolbar: i,
          verticalAlignmentToolbar: r,
          alignmentLabel: n
        };
      }
      _createActionButtons() {
        const e = this.locale,
          t = this.t,
          n = new um(e),
          i = new um(e),
          o = [this.borderWidthInput, this.borderColorInput, this.backgroundInput, this.paddingInput];
        return n.set({
          label: t("Save"),
          icon: Wh.check,
          class: "ck-button-save",
          type: "submit",
          withText: !0
        }), n.bind("isEnabled").toMany(o, "errorText", function () {
          for (var _len44 = arguments.length, e = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
            e[_key44] = arguments[_key44];
          }
          return e.every(e => !e);
        }), i.set({
          label: t("Cancel"),
          icon: Wh.cancel,
          class: "ck-button-cancel",
          withText: !0
        }), i.delegate("execute").to(this, "cancel"), {
          saveButtonView: n,
          cancelButtonView: i
        };
      }
      get _horizontalAlignmentLabels() {
        const e = this.locale,
          t = this.t,
          n = t("Align cell text to the left"),
          i = t("Align cell text to the center"),
          o = t("Align cell text to the right"),
          r = t("Justify cell text");
        return "rtl" === e.uiLanguageDirection ? {
          right: o,
          center: i,
          left: n,
          justify: r
        } : {
          left: n,
          center: i,
          right: o,
          justify: r
        };
      }
      get _verticalAlignmentLabels() {
        const e = this.t;
        return {
          top: e("Align cell text to the top"),
          middle: e("Align cell text to the middle"),
          bottom: e("Align cell text to the bottom")
        };
      }
    }
    function dI(e) {
      return "none" !== e;
    }
    const uI = Xg.defaultPositions,
      hI = [uI.northArrowSouth, uI.northArrowSouthWest, uI.northArrowSouthEast, uI.southArrowNorth, uI.southArrowNorthWest, uI.southArrowNorthEast, uI.viewportStickyNorth];
    function mI(e, t) {
      const n = e.plugins.get("ContextualBalloon"),
        i = e.editing.view.document.selection;
      let o;
      "cell" === t ? NT(i) && (o = gI(e)) : PT(i) && (o = pI(e)), o && n.updatePosition(o);
    }
    function pI(e) {
      const t = uD(e.model.document.selection),
        n = e.editing.mapper.toViewElement(t);
      return {
        target: e.editing.view.domConverter.mapViewToDom(n),
        positions: hI
      };
    }
    function gI(e) {
      const t = e.editing.mapper,
        n = e.editing.view.domConverter,
        i = e.model.document.selection;
      if (i.rangeCount > 1) return {
        target: () => function (e, t) {
          const n = t.editing.mapper,
            i = t.editing.view.domConverter,
            o = Array.from(e).map(e => {
              const t = fI(e.start),
                o = n.toViewElement(t);
              return new Li(i.mapViewToDom(o));
            });
          return Li.getBoundingRect(o);
        }(i.getRanges(), e),
        positions: hI
      };
      const o = fI(i.getFirstPosition()),
        r = t.toViewElement(o);
      return {
        target: n.mapViewToDom(r),
        positions: hI
      };
    }
    function fI(e) {
      return e.nodeAfter && e.nodeAfter.is("element", "tableCell") ? e.nodeAfter : e.findAncestor("tableCell");
    }
    function kI(e) {
      if (!e || !R(e)) return e;
      const {
        top: t,
        right: n,
        bottom: i,
        left: o
      } = e;
      return t == n && n == i && i == o ? t : void 0;
    }
    function bI(e, t) {
      const n = parseFloat(e);
      return Number.isNaN(n) || String(n) !== String(e) ? e : "".concat(n).concat(t);
    }
    function _I(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const n = {
        borderStyle: "none",
        borderWidth: "",
        borderColor: "",
        backgroundColor: "",
        width: "",
        height: "",
        ...e
      };
      return t.includeAlignmentProperty && !n.alignment && (n.alignment = "center"), t.includePaddingProperty && !n.padding && (n.padding = ""), t.includeVerticalAlignmentProperty && !n.verticalAlignment && (n.verticalAlignment = "middle"), t.includeHorizontalAlignmentProperty && !n.horizontalAlignment && (n.horizontalAlignment = t.isRightToLeftContent ? "right" : "left"), n;
    }
    const wI = {
      borderStyle: "tableCellBorderStyle",
      borderColor: "tableCellBorderColor",
      borderWidth: "tableCellBorderWidth",
      height: "tableCellHeight",
      width: "tableCellWidth",
      padding: "tableCellPadding",
      backgroundColor: "tableCellBackgroundColor",
      horizontalAlignment: "tableCellHorizontalAlignment",
      verticalAlignment: "tableCellVerticalAlignment"
    };
    class AI extends Br {
      static get requires() {
        return [Of];
      }
      static get pluginName() {
        return "TableCellPropertiesUI";
      }
      constructor(e) {
        super(e), e.config.define("table.tableCellProperties", {
          borderColors: ZT,
          backgroundColors: ZT
        });
      }
      init() {
        const e = this.editor,
          t = e.t;
        this._defaultTableCellProperties = _I(e.config.get("table.tableCellProperties.defaultProperties"), {
          includeVerticalAlignmentProperty: !0,
          includeHorizontalAlignmentProperty: !0,
          includePaddingProperty: !0,
          isRightToLeftContent: "rtl" === e.locale.contentLanguageDirection
        }), this._balloon = e.plugins.get(Of), this.view = null, this._isReady = !1, e.ui.componentFactory.add("tableCellProperties", n => {
          const i = new um(n);
          i.set({
            label: t("Cell properties"),
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.105 18-.17 1H2.5A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1h15A1.5 1.5 0 0 1 19 2.5v9.975l-.85-.124-.15-.302V8h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5h3.105zM2 12h5V8H2v4zm10-4H8v4h4V8zM2 2v5h5V2H2zm0 16h5v-5H2v5zM13 7h5V2h-5v5zM8 2v5h4V2H8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM13 6a1 1 0 0 1 1 1v3.172a2.047 2.047 0 0 0-.293.443l-.858 1.736-1.916.28-.151.027A1.976 1.976 0 0 0 9.315 14H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm-1 2H8v4h4V8z"/></svg>',
            tooltip: !0
          }), this.listenTo(i, "execute", () => this._showView());
          const o = Object.values(wI).map(t => e.commands.get(t));
          return i.bind("isEnabled").toMany(o, "isEnabled", function () {
            for (var _len45 = arguments.length, e = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
              e[_key45] = arguments[_key45];
            }
            return e.some(e => e);
          }), i;
        });
      }
      destroy() {
        super.destroy(), this.view && this.view.destroy();
      }
      _createPropertiesView() {
        const e = this.editor,
          t = e.config.get("table.tableCellProperties"),
          n = vm(t.borderColors),
          i = Am(e.locale, n),
          o = vm(t.backgroundColors),
          r = Am(e.locale, o),
          s = !1 !== t.colorPicker,
          a = new cI(e.locale, {
            borderColors: i,
            backgroundColors: r,
            defaultTableCellProperties: this._defaultTableCellProperties,
            colorPickerConfig: !!s && (t.colorPicker || {})
          }),
          l = e.t;
        a.render(), this.listenTo(a, "submit", () => {
          this._hideView();
        }), this.listenTo(a, "cancel", () => {
          this._undoStepBatch.operations.length && e.execute("undo", this._undoStepBatch), this._hideView();
        }), a.keystrokes.set("Esc", (e, t) => {
          this._hideView(), t();
        }), Sr({
          emitter: a,
          activator: () => this._isViewInBalloon,
          contextElements: [this._balloon.view.element],
          callback: () => this._hideView()
        });
        const c = UT(l),
          d = qT(l);
        return a.on("change:borderStyle", this._getPropertyChangeCallback("tableCellBorderStyle")), a.on("change:borderColor", this._getValidatedPropertyChangeCallback({
          viewField: a.borderColorInput,
          commandName: "tableCellBorderColor",
          errorText: c,
          validator: GT
        })), a.on("change:borderWidth", this._getValidatedPropertyChangeCallback({
          viewField: a.borderWidthInput,
          commandName: "tableCellBorderWidth",
          errorText: d,
          validator: WT
        })), a.on("change:padding", this._getValidatedPropertyChangeCallback({
          viewField: a.paddingInput,
          commandName: "tableCellPadding",
          errorText: d,
          validator: KT
        })), a.on("change:width", this._getValidatedPropertyChangeCallback({
          viewField: a.widthInput,
          commandName: "tableCellWidth",
          errorText: d,
          validator: KT
        })), a.on("change:height", this._getValidatedPropertyChangeCallback({
          viewField: a.heightInput,
          commandName: "tableCellHeight",
          errorText: d,
          validator: KT
        })), a.on("change:backgroundColor", this._getValidatedPropertyChangeCallback({
          viewField: a.backgroundInput,
          commandName: "tableCellBackgroundColor",
          errorText: c,
          validator: GT
        })), a.on("change:horizontalAlignment", this._getPropertyChangeCallback("tableCellHorizontalAlignment")), a.on("change:verticalAlignment", this._getPropertyChangeCallback("tableCellVerticalAlignment")), a;
      }
      _fillViewFormFromCommandValues() {
        const e = this.editor.commands,
          t = e.get("tableCellBorderStyle");
        Object.entries(wI).map(_ref166 => {
          let [t, n] = _ref166;
          const i = this._defaultTableCellProperties[t] || "";
          return [t, e.get(n).value || i];
        }).forEach(_ref167 => {
          let [e, n] = _ref167;
          ("borderColor" !== e && "borderWidth" !== e || "none" !== t.value) && this.view.set(e, n);
        }), this._isReady = !0;
      }
      _showView() {
        const e = this.editor;
        this.view || (this.view = this._createPropertiesView()), this.listenTo(e.ui, "update", () => {
          this._updateView();
        }), this._fillViewFormFromCommandValues(), this._balloon.add({
          view: this.view,
          position: gI(e)
        }), this._undoStepBatch = e.model.createBatch(), this.view.focus();
      }
      _hideView() {
        const e = this.editor;
        this.stopListening(e.ui, "update"), this._isReady = !1, this.view.saveButtonView.focus(), this._balloon.remove(this.view), this.editor.editing.view.focus();
      }
      _updateView() {
        const e = this.editor;
        NT(e.editing.view.document.selection) ? this._isViewVisible && mI(e, "cell") : this._hideView();
      }
      get _isViewVisible() {
        return !!this.view && this._balloon.visibleView === this.view;
      }
      get _isViewInBalloon() {
        return !!this.view && this._balloon.hasView(this.view);
      }
      _getPropertyChangeCallback(e) {
        return (t, n, i) => {
          this._isReady && this.editor.execute(e, {
            value: i,
            batch: this._undoStepBatch
          });
        };
      }
      _getValidatedPropertyChangeCallback(e) {
        const {
            commandName: t,
            viewField: n,
            validator: i,
            errorText: o
          } = e,
          r = gl(() => {
            n.errorText = o;
          }, 500);
        return (e, o, s) => {
          r.cancel(), this._isReady && (i(s) ? (this.editor.execute(t, {
            value: s,
            batch: this._undoStepBatch
          }), n.errorText = null) : r());
        };
      }
    }
    class vI extends Pr {
      constructor(e, t, n) {
        super(e), this.attributeName = t, this._defaultValue = n;
      }
      refresh() {
        const e = this.editor,
          t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(e.model.document.selection);
        this.isEnabled = !!t.length, this.value = this._getSingleValue(t);
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
            value: t,
            batch: n
          } = e,
          i = this.editor.model,
          o = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(i.document.selection),
          r = this._getValueToSet(t);
        i.enqueueChange(n, e => {
          r ? o.forEach(t => e.setAttribute(this.attributeName, r, t)) : o.forEach(t => e.removeAttribute(this.attributeName, t));
        });
      }
      _getAttribute(e) {
        if (!e) return;
        const t = e.getAttribute(this.attributeName);
        return t !== this._defaultValue ? t : void 0;
      }
      _getValueToSet(e) {
        if (e !== this._defaultValue) return e;
      }
      _getSingleValue(e) {
        const t = this._getAttribute(e[0]);
        return e.every(e => this._getAttribute(e) === t) ? t : void 0;
      }
    }
    class CI extends vI {
      constructor(e, t) {
        super(e, "tableCellWidth", t);
      }
      _getValueToSet(e) {
        if ((e = bI(e, "px")) !== this._defaultValue) return e;
      }
    }
    class yI extends Br {
      static get pluginName() {
        return "TableCellWidthEditing";
      }
      static get requires() {
        return [mT];
      }
      init() {
        const e = this.editor,
          t = _I(e.config.get("table.tableCellProperties.defaultProperties"));
        dD(e.model.schema, e.conversion, {
          modelAttribute: "tableCellWidth",
          styleName: "width",
          defaultValue: t.width
        }), e.commands.add("tableCellWidth", new CI(e, t.width));
      }
    }
    class xI extends vI {
      constructor(e, t) {
        super(e, "tableCellPadding", t);
      }
      _getAttribute(e) {
        if (!e) return;
        const t = kI(e.getAttribute(this.attributeName));
        return t !== this._defaultValue ? t : void 0;
      }
      _getValueToSet(e) {
        const t = bI(e, "px");
        if (t !== this._defaultValue) return t;
      }
    }
    class EI extends vI {
      constructor(e, t) {
        super(e, "tableCellHeight", t);
      }
      _getValueToSet(e) {
        const t = bI(e, "px");
        if (t !== this._defaultValue) return t;
      }
    }
    class SI extends vI {
      constructor(e, t) {
        super(e, "tableCellBackgroundColor", t);
      }
    }
    class DI extends vI {
      constructor(e, t) {
        super(e, "tableCellVerticalAlignment", t);
      }
    }
    class TI extends vI {
      constructor(e, t) {
        super(e, "tableCellHorizontalAlignment", t);
      }
    }
    class II extends vI {
      constructor(e, t) {
        super(e, "tableCellBorderStyle", t);
      }
      _getAttribute(e) {
        if (!e) return;
        const t = kI(e.getAttribute(this.attributeName));
        return t !== this._defaultValue ? t : void 0;
      }
    }
    class BI extends vI {
      constructor(e, t) {
        super(e, "tableCellBorderColor", t);
      }
      _getAttribute(e) {
        if (!e) return;
        const t = kI(e.getAttribute(this.attributeName));
        return t !== this._defaultValue ? t : void 0;
      }
    }
    class MI extends vI {
      constructor(e, t) {
        super(e, "tableCellBorderWidth", t);
      }
      _getAttribute(e) {
        if (!e) return;
        const t = kI(e.getAttribute(this.attributeName));
        return t !== this._defaultValue ? t : void 0;
      }
      _getValueToSet(e) {
        const t = bI(e, "px");
        if (t !== this._defaultValue) return t;
      }
    }
    const PI = /^(top|middle|bottom)$/,
      zI = /^(left|center|right|justify)$/;
    class NI extends Br {
      static get pluginName() {
        return "TableCellPropertiesEditing";
      }
      static get requires() {
        return [mT, yI];
      }
      init() {
        const e = this.editor,
          t = e.model.schema,
          n = e.conversion;
        e.config.define("table.tableCellProperties.defaultProperties", {});
        const i = _I(e.config.get("table.tableCellProperties.defaultProperties"), {
          includeVerticalAlignmentProperty: !0,
          includeHorizontalAlignmentProperty: !0,
          includePaddingProperty: !0,
          isRightToLeftContent: "rtl" === e.locale.contentLanguageDirection
        });
        e.data.addStyleProcessorRules(Dh), function (e, t, n) {
          const i = {
            width: "tableCellBorderWidth",
            color: "tableCellBorderColor",
            style: "tableCellBorderStyle"
          };
          e.extend("tableCell", {
            allowAttributes: Object.values(i)
          }), iD(t, "td", i, n), iD(t, "th", i, n), oD(t, {
            modelElement: "tableCell",
            modelAttribute: i.style,
            styleName: "border-style"
          }), oD(t, {
            modelElement: "tableCell",
            modelAttribute: i.color,
            styleName: "border-color"
          }), oD(t, {
            modelElement: "tableCell",
            modelAttribute: i.width,
            styleName: "border-width"
          });
        }(t, n, {
          color: i.borderColor,
          style: i.borderStyle,
          width: i.borderWidth
        }), e.commands.add("tableCellBorderStyle", new II(e, i.borderStyle)), e.commands.add("tableCellBorderColor", new BI(e, i.borderColor)), e.commands.add("tableCellBorderWidth", new MI(e, i.borderWidth)), dD(t, n, {
          modelAttribute: "tableCellHeight",
          styleName: "height",
          defaultValue: i.height
        }), e.commands.add("tableCellHeight", new EI(e, i.height)), e.data.addStyleProcessorRules(Vh), dD(t, n, {
          modelAttribute: "tableCellPadding",
          styleName: "padding",
          reduceBoxSides: !0,
          defaultValue: i.padding
        }), e.commands.add("tableCellPadding", new xI(e, i.padding)), e.data.addStyleProcessorRules(Sh), dD(t, n, {
          modelAttribute: "tableCellBackgroundColor",
          styleName: "background-color",
          defaultValue: i.backgroundColor
        }), e.commands.add("tableCellBackgroundColor", new SI(e, i.backgroundColor)), function (e, t, n) {
          e.extend("tableCell", {
            allowAttributes: ["tableCellHorizontalAlignment"]
          }), t.for("downcast").attributeToAttribute({
            model: {
              name: "tableCell",
              key: "tableCellHorizontalAlignment"
            },
            view: e => ({
              key: "style",
              value: {
                "text-align": e
              }
            })
          }), t.for("upcast").attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              styles: {
                "text-align": zI
              }
            },
            model: {
              key: "tableCellHorizontalAlignment",
              value: e => {
                const t = e.getStyle("text-align");
                return t === n ? null : t;
              }
            }
          }).attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              attributes: {
                align: zI
              }
            },
            model: {
              key: "tableCellHorizontalAlignment",
              value: e => {
                const t = e.getAttribute("align");
                return t === n ? null : t;
              }
            }
          });
        }(t, n, i.horizontalAlignment), e.commands.add("tableCellHorizontalAlignment", new TI(e, i.horizontalAlignment)), function (e, t, n) {
          e.extend("tableCell", {
            allowAttributes: ["tableCellVerticalAlignment"]
          }), t.for("downcast").attributeToAttribute({
            model: {
              name: "tableCell",
              key: "tableCellVerticalAlignment"
            },
            view: e => ({
              key: "style",
              value: {
                "vertical-align": e
              }
            })
          }), t.for("upcast").attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              styles: {
                "vertical-align": PI
              }
            },
            model: {
              key: "tableCellVerticalAlignment",
              value: e => {
                const t = e.getStyle("vertical-align");
                return t === n ? null : t;
              }
            }
          }).attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              attributes: {
                valign: PI
              }
            },
            model: {
              key: "tableCellVerticalAlignment",
              value: e => {
                const t = e.getAttribute("valign");
                return t === n ? null : t;
              }
            }
          });
        }(t, n, i.verticalAlignment), e.commands.add("tableCellVerticalAlignment", new DI(e, i.verticalAlignment));
      }
    }
    class LI extends Pr {
      constructor(e, t, n) {
        super(e), this.attributeName = t, this._defaultValue = n;
      }
      refresh() {
        const e = uD(this.editor.model.document.selection);
        this.isEnabled = !!e, this.value = this._getValue(e);
      }
      execute() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const t = this.editor.model,
          n = t.document.selection,
          {
            value: i,
            batch: o
          } = e,
          r = uD(n),
          s = this._getValueToSet(i);
        t.enqueueChange(o, e => {
          s ? e.setAttribute(this.attributeName, s, r) : e.removeAttribute(this.attributeName, r);
        });
      }
      _getValue(e) {
        if (!e) return;
        const t = e.getAttribute(this.attributeName);
        return t !== this._defaultValue ? t : void 0;
      }
      _getValueToSet(e) {
        if (e !== this._defaultValue) return e;
      }
    }
    class RI extends LI {
      constructor(e, t) {
        super(e, "tableBackgroundColor", t);
      }
    }
    class VI extends LI {
      constructor(e, t) {
        super(e, "tableBorderColor", t);
      }
      _getValue(e) {
        if (!e) return;
        const t = kI(e.getAttribute(this.attributeName));
        return t !== this._defaultValue ? t : void 0;
      }
    }
    class OI extends LI {
      constructor(e, t) {
        super(e, "tableBorderStyle", t);
      }
      _getValue(e) {
        if (!e) return;
        const t = kI(e.getAttribute(this.attributeName));
        return t !== this._defaultValue ? t : void 0;
      }
    }
    class FI extends LI {
      constructor(e, t) {
        super(e, "tableBorderWidth", t);
      }
      _getValue(e) {
        if (!e) return;
        const t = kI(e.getAttribute(this.attributeName));
        return t !== this._defaultValue ? t : void 0;
      }
      _getValueToSet(e) {
        const t = bI(e, "px");
        if (t !== this._defaultValue) return t;
      }
    }
    class jI extends LI {
      constructor(e, t) {
        super(e, "tableWidth", t);
      }
      _getValueToSet(e) {
        if ((e = bI(e, "px")) !== this._defaultValue) return e;
      }
    }
    class HI extends LI {
      constructor(e, t) {
        super(e, "tableHeight", t);
      }
      _getValueToSet(e) {
        if ((e = bI(e, "px")) !== this._defaultValue) return e;
      }
    }
    class UI extends LI {
      constructor(e, t) {
        super(e, "tableAlignment", t);
      }
    }
    const qI = /^(left|center|right)$/,
      GI = /^(left|none|right)$/;
    class KI extends Br {
      static get pluginName() {
        return "TablePropertiesEditing";
      }
      static get requires() {
        return [mT];
      }
      init() {
        const e = this.editor,
          t = e.model.schema,
          n = e.conversion;
        e.config.define("table.tableProperties.defaultProperties", {});
        const i = _I(e.config.get("table.tableProperties.defaultProperties"), {
          includeAlignmentProperty: !0
        });
        e.data.addStyleProcessorRules(Dh), function (e, t, n) {
          const i = {
            width: "tableBorderWidth",
            color: "tableBorderColor",
            style: "tableBorderStyle"
          };
          e.extend("table", {
            allowAttributes: Object.values(i)
          }), iD(t, "table", i, n), rD(t, {
            modelAttribute: i.color,
            styleName: "border-color"
          }), rD(t, {
            modelAttribute: i.style,
            styleName: "border-style"
          }), rD(t, {
            modelAttribute: i.width,
            styleName: "border-width"
          });
        }(t, n, {
          color: i.borderColor,
          style: i.borderStyle,
          width: i.borderWidth
        }), e.commands.add("tableBorderColor", new VI(e, i.borderColor)), e.commands.add("tableBorderStyle", new OI(e, i.borderStyle)), e.commands.add("tableBorderWidth", new FI(e, i.borderWidth)), function (e, t, n) {
          e.extend("table", {
            allowAttributes: ["tableAlignment"]
          }), t.for("downcast").attributeToAttribute({
            model: {
              name: "table",
              key: "tableAlignment"
            },
            view: e => ({
              key: "style",
              value: {
                float: "center" === e ? "none" : e
              }
            }),
            converterPriority: "high"
          }), t.for("upcast").attributeToAttribute({
            view: {
              name: /^(table|figure)$/,
              styles: {
                float: GI
              }
            },
            model: {
              key: "tableAlignment",
              value: e => {
                let t = e.getStyle("float");
                return "none" === t && (t = "center"), t === n ? null : t;
              }
            }
          }).attributeToAttribute({
            view: {
              attributes: {
                align: qI
              }
            },
            model: {
              name: "table",
              key: "tableAlignment",
              value: e => {
                const t = e.getAttribute("align");
                return t === n ? null : t;
              }
            }
          });
        }(t, n, i.alignment), e.commands.add("tableAlignment", new UI(e, i.alignment)), WI(t, n, {
          modelAttribute: "tableWidth",
          styleName: "width",
          defaultValue: i.width
        }), e.commands.add("tableWidth", new jI(e, i.width)), WI(t, n, {
          modelAttribute: "tableHeight",
          styleName: "height",
          defaultValue: i.height
        }), e.commands.add("tableHeight", new HI(e, i.height)), e.data.addStyleProcessorRules(Sh), function (e, t, n) {
          const {
            modelAttribute: i
          } = n;
          e.extend("table", {
            allowAttributes: [i]
          }), nD(t, {
            viewElement: "table",
            ...n
          }), rD(t, n);
        }(t, n, {
          modelAttribute: "tableBackgroundColor",
          styleName: "background-color",
          defaultValue: i.backgroundColor
        }), e.commands.add("tableBackgroundColor", new RI(e, i.backgroundColor));
      }
    }
    function WI(e, t, n) {
      const {
        modelAttribute: i
      } = n;
      e.extend("table", {
        allowAttributes: [i]
      }), nD(t, {
        viewElement: /^(table|figure)$/,
        shouldUpcast: e => !("table" == e.name && "figure" == e.parent.name),
        ...n
      }), oD(t, {
        modelElement: "table",
        ...n
      });
    }
    var YI = o(4703),
      $I = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(YI.A, $I);
    YI.A.locals;
    const ZI = {
      left: Wh.objectLeft,
      center: Wh.objectCenter,
      right: Wh.objectRight
    };
    class QI extends Er {
      constructor(e, t) {
        super(e), this.set({
          borderStyle: "",
          borderWidth: "",
          borderColor: "",
          backgroundColor: "",
          width: "",
          height: "",
          alignment: ""
        }), this.options = t;
        const {
            borderStyleDropdown: n,
            borderWidthInput: i,
            borderColorInput: o,
            borderRowLabel: r
          } = this._createBorderFields(),
          {
            backgroundRowLabel: s,
            backgroundInput: a
          } = this._createBackgroundFields(),
          {
            widthInput: l,
            operatorLabel: c,
            heightInput: d,
            dimensionsLabel: u
          } = this._createDimensionFields(),
          {
            alignmentToolbar: h,
            alignmentLabel: m
          } = this._createAlignmentFields();
        this.focusTracker = new Ko(), this.keystrokes = new Wo(), this.children = this.createCollection(), this.borderStyleDropdown = n, this.borderWidthInput = i, this.borderColorInput = o, this.backgroundInput = a, this.widthInput = l, this.heightInput = d, this.alignmentToolbar = h;
        const {
          saveButtonView: p,
          cancelButtonView: g
        } = this._createActionButtons();
        this.saveButtonView = p, this.cancelButtonView = g, this._focusables = new er(), this._focusCycler = new Jm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.children.add(new Tg(e, {
          label: this.t("Table properties")
        })), this.children.add(new tI(e, {
          labelView: r,
          children: [r, n, o, i],
          class: "ck-table-form__border-row"
        })), this.children.add(new tI(e, {
          labelView: s,
          children: [s, a],
          class: "ck-table-form__background-row"
        })), this.children.add(new tI(e, {
          children: [new tI(e, {
            labelView: u,
            children: [u, l, c, d],
            class: "ck-table-form__dimensions-row"
          }), new tI(e, {
            labelView: m,
            children: [m, h],
            class: "ck-table-properties-form__alignment-row"
          })]
        })), this.children.add(new tI(e, {
          children: [this.saveButtonView, this.cancelButtonView],
          class: "ck-table-form__action-row"
        })), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-form", "ck-table-form", "ck-table-properties-form"],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), Tr({
          view: this
        }), [this.borderColorInput, this.backgroundInput].forEach(e => {
          e.fieldView.focusCycler.on("forwardCycle", e => {
            this._focusCycler.focusNext(), e.stop();
          }), e.fieldView.focusCycler.on("backwardCycle", e => {
            this._focusCycler.focusPrevious(), e.stop();
          });
        }), [this.borderStyleDropdown, this.borderColorInput, this.borderWidthInput, this.backgroundInput, this.widthInput, this.heightInput, this.alignmentToolbar, this.saveButtonView, this.cancelButtonView].forEach(e => {
          this._focusables.add(e), this.focusTracker.add(e.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      _createBorderFields() {
        const e = this.options.defaultTableProperties,
          t = {
            style: e.borderStyle,
            width: e.borderWidth,
            color: e.borderColor
          },
          n = QT({
            colorConfig: this.options.borderColors,
            columns: 5,
            defaultColorValue: t.color,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          i = this.locale,
          o = this.t,
          r = o("Style"),
          s = new Zh(i);
        s.text = o("Border");
        const a = HT(o),
          l = new Rm(i, Pp);
        l.set({
          label: r,
          class: "ck-table-form__border-style"
        }), l.fieldView.buttonView.set({
          ariaLabel: r,
          ariaLabelledBy: void 0,
          isOn: !1,
          withText: !0,
          tooltip: r
        }), l.fieldView.buttonView.bind("label").to(this, "borderStyle", e => a[e || "none"]), l.fieldView.on("execute", e => {
          this.borderStyle = e.source._borderStyleValue;
        }), l.bind("isEmpty").to(this, "borderStyle", e => !e), Sp(l.fieldView, YT(this, t.style), {
          role: "menu",
          ariaLabel: r
        });
        const c = new Rm(i, Bp);
        c.set({
          label: o("Width"),
          class: "ck-table-form__border-width"
        }), c.fieldView.bind("value").to(this, "borderWidth"), c.bind("isEnabled").to(this, "borderStyle", JI), c.fieldView.on("input", () => {
          this.borderWidth = c.fieldView.element.value;
        });
        const d = new Rm(i, n);
        return d.set({
          label: o("Color"),
          class: "ck-table-form__border-color"
        }), d.fieldView.bind("value").to(this, "borderColor"), d.bind("isEnabled").to(this, "borderStyle", JI), d.fieldView.on("input", () => {
          this.borderColor = d.fieldView.value;
        }), this.on("change:borderStyle", (e, n, i, o) => {
          JI(i) || (this.borderColor = "", this.borderWidth = ""), JI(o) || (this.borderColor = t.color, this.borderWidth = t.width);
        }), {
          borderRowLabel: s,
          borderStyleDropdown: l,
          borderColorInput: d,
          borderWidthInput: c
        };
      }
      _createBackgroundFields() {
        const e = this.locale,
          t = this.t,
          n = new Zh(e);
        n.text = t("Background");
        const i = QT({
            colorConfig: this.options.backgroundColors,
            columns: 5,
            defaultColorValue: this.options.defaultTableProperties.backgroundColor,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          o = new Rm(e, i);
        return o.set({
          label: t("Color"),
          class: "ck-table-properties-form__background"
        }), o.fieldView.bind("value").to(this, "backgroundColor"), o.fieldView.on("input", () => {
          this.backgroundColor = o.fieldView.value;
        }), {
          backgroundRowLabel: n,
          backgroundInput: o
        };
      }
      _createDimensionFields() {
        const e = this.locale,
          t = this.t,
          n = new Zh(e);
        n.text = t("Dimensions");
        const i = new Rm(e, Bp);
        i.set({
          label: t("Width"),
          class: "ck-table-form__dimensions-row__width"
        }), i.fieldView.bind("value").to(this, "width"), i.fieldView.on("input", () => {
          this.width = i.fieldView.element.value;
        });
        const o = new Er(e);
        o.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck-table-form__dimension-operator"]
          },
          children: [{
            text: "×"
          }]
        });
        const r = new Rm(e, Bp);
        return r.set({
          label: t("Height"),
          class: "ck-table-form__dimensions-row__height"
        }), r.fieldView.bind("value").to(this, "height"), r.fieldView.on("input", () => {
          this.height = r.fieldView.element.value;
        }), {
          dimensionsLabel: n,
          widthInput: i,
          operatorLabel: o,
          heightInput: r
        };
      }
      _createAlignmentFields() {
        const e = this.locale,
          t = this.t,
          n = new Zh(e);
        n.text = t("Alignment");
        const i = new ap(e);
        return i.set({
          isCompact: !0,
          ariaLabel: t("Table alignment toolbar")
        }), $T({
          view: this,
          icons: ZI,
          toolbar: i,
          labels: this._alignmentLabels,
          propertyName: "alignment",
          defaultValue: this.options.defaultTableProperties.alignment
        }), {
          alignmentLabel: n,
          alignmentToolbar: i
        };
      }
      _createActionButtons() {
        const e = this.locale,
          t = this.t,
          n = new um(e),
          i = new um(e),
          o = [this.borderWidthInput, this.borderColorInput, this.backgroundInput, this.widthInput, this.heightInput];
        return n.set({
          label: t("Save"),
          icon: Wh.check,
          class: "ck-button-save",
          type: "submit",
          withText: !0
        }), n.bind("isEnabled").toMany(o, "errorText", function () {
          for (var _len46 = arguments.length, e = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
            e[_key46] = arguments[_key46];
          }
          return e.every(e => !e);
        }), i.set({
          label: t("Cancel"),
          icon: Wh.cancel,
          class: "ck-button-cancel",
          withText: !0
        }), i.delegate("execute").to(this, "cancel"), {
          saveButtonView: n,
          cancelButtonView: i
        };
      }
      get _alignmentLabels() {
        const e = this.locale,
          t = this.t,
          n = t("Align table to the left"),
          i = t("Center table"),
          o = t("Align table to the right");
        return "rtl" === e.uiLanguageDirection ? {
          right: o,
          center: i,
          left: n
        } : {
          left: n,
          center: i,
          right: o
        };
      }
    }
    function JI(e) {
      return "none" !== e;
    }
    const XI = {
      borderStyle: "tableBorderStyle",
      borderColor: "tableBorderColor",
      borderWidth: "tableBorderWidth",
      backgroundColor: "tableBackgroundColor",
      width: "tableWidth",
      height: "tableHeight",
      alignment: "tableAlignment"
    };
    class eB extends Br {
      static get requires() {
        return [Of];
      }
      static get pluginName() {
        return "TablePropertiesUI";
      }
      constructor(e) {
        super(e), this.view = null, e.config.define("table.tableProperties", {
          borderColors: ZT,
          backgroundColors: ZT
        });
      }
      init() {
        const e = this.editor,
          t = e.t;
        this._defaultTableProperties = _I(e.config.get("table.tableProperties.defaultProperties"), {
          includeAlignmentProperty: !0
        }), this._balloon = e.plugins.get(Of), e.ui.componentFactory.add("tableProperties", n => {
          const i = new um(n);
          i.set({
            label: t("Table properties"),
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8 2v5h4V2h1v5h5v1h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5H7v-5H2v-1h5V8H2V7h5V2h1zm4 6H8v4h4V8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM17 1a2 2 0 0 1 2 2v9.475l-.85-.124-.857-1.736a2.048 2.048 0 0 0-.292-.44L17 3H3v14h7.808l.402.392L10.935 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14z"/></svg>',
            tooltip: !0
          }), this.listenTo(i, "execute", () => this._showView());
          const o = Object.values(XI).map(t => e.commands.get(t));
          return i.bind("isEnabled").toMany(o, "isEnabled", function () {
            for (var _len47 = arguments.length, e = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
              e[_key47] = arguments[_key47];
            }
            return e.some(e => e);
          }), i;
        });
      }
      destroy() {
        super.destroy(), this.view && this.view.destroy();
      }
      _createPropertiesView() {
        const e = this.editor,
          t = e.config.get("table.tableProperties"),
          n = vm(t.borderColors),
          i = Am(e.locale, n),
          o = vm(t.backgroundColors),
          r = Am(e.locale, o),
          s = !1 !== t.colorPicker,
          a = new QI(e.locale, {
            borderColors: i,
            backgroundColors: r,
            defaultTableProperties: this._defaultTableProperties,
            colorPickerConfig: !!s && (t.colorPicker || {})
          }),
          l = e.t;
        a.render(), this.listenTo(a, "submit", () => {
          this._hideView();
        }), this.listenTo(a, "cancel", () => {
          this._undoStepBatch.operations.length && e.execute("undo", this._undoStepBatch), this._hideView();
        }), a.keystrokes.set("Esc", (e, t) => {
          this._hideView(), t();
        }), Sr({
          emitter: a,
          activator: () => this._isViewInBalloon,
          contextElements: [this._balloon.view.element],
          callback: () => this._hideView()
        });
        const c = UT(l),
          d = qT(l);
        return a.on("change:borderStyle", this._getPropertyChangeCallback("tableBorderStyle")), a.on("change:borderColor", this._getValidatedPropertyChangeCallback({
          viewField: a.borderColorInput,
          commandName: "tableBorderColor",
          errorText: c,
          validator: GT
        })), a.on("change:borderWidth", this._getValidatedPropertyChangeCallback({
          viewField: a.borderWidthInput,
          commandName: "tableBorderWidth",
          errorText: d,
          validator: WT
        })), a.on("change:backgroundColor", this._getValidatedPropertyChangeCallback({
          viewField: a.backgroundInput,
          commandName: "tableBackgroundColor",
          errorText: c,
          validator: GT
        })), a.on("change:width", this._getValidatedPropertyChangeCallback({
          viewField: a.widthInput,
          commandName: "tableWidth",
          errorText: d,
          validator: KT
        })), a.on("change:height", this._getValidatedPropertyChangeCallback({
          viewField: a.heightInput,
          commandName: "tableHeight",
          errorText: d,
          validator: KT
        })), a.on("change:alignment", this._getPropertyChangeCallback("tableAlignment")), a;
      }
      _fillViewFormFromCommandValues() {
        const e = this.editor.commands,
          t = e.get("tableBorderStyle");
        Object.entries(XI).map(_ref168 => {
          let [t, n] = _ref168;
          const i = t,
            o = this._defaultTableProperties[i] || "";
          return [i, e.get(n).value || o];
        }).forEach(_ref169 => {
          let [e, n] = _ref169;
          ("borderColor" !== e && "borderWidth" !== e || "none" !== t.value) && this.view.set(e, n);
        }), this._isReady = !0;
      }
      _showView() {
        const e = this.editor;
        this.view || (this.view = this._createPropertiesView()), this.listenTo(e.ui, "update", () => {
          this._updateView();
        }), this._fillViewFormFromCommandValues(), this._balloon.add({
          view: this.view,
          position: pI(e)
        }), this._undoStepBatch = e.model.createBatch(), this.view.focus();
      }
      _hideView() {
        const e = this.editor;
        this.stopListening(e.ui, "update"), this._isReady = !1, this.view.saveButtonView.focus(), this._balloon.remove(this.view), this.editor.editing.view.focus();
      }
      _updateView() {
        const e = this.editor;
        PT(e.editing.view.document.selection) ? this._isViewVisible && mI(e, "table") : this._hideView();
      }
      get _isViewVisible() {
        return !!this.view && this._balloon.visibleView === this.view;
      }
      get _isViewInBalloon() {
        return !!this.view && this._balloon.hasView(this.view);
      }
      _getPropertyChangeCallback(e) {
        return (t, n, i) => {
          this._isReady && this.editor.execute(e, {
            value: i,
            batch: this._undoStepBatch
          });
        };
      }
      _getValidatedPropertyChangeCallback(e) {
        const {
            commandName: t,
            viewField: n,
            validator: i,
            errorText: o
          } = e,
          r = gl(() => {
            n.errorText = o;
          }, 500);
        return (e, o, s) => {
          r.cancel(), this._isReady && (i(s) ? (this.editor.execute(t, {
            value: s,
            batch: this._undoStepBatch
          }), n.errorText = null) : r());
        };
      }
    }
    function tB(e) {
      e.document.registerPostFixer(t => function (e, t) {
        const n = t.document.differ.getChanges();
        let i = !1;
        for (const t of n) {
          if ("insert" != t.type) continue;
          const n = t.position.parent;
          if (n.is("element", "table") || "table" == t.name) {
            const o = "table" == t.name ? t.position.nodeAfter : n,
              r = Array.from(o.getChildren()).filter(e => e.is("element", "caption")),
              s = r.shift();
            if (!s) continue;
            for (const t of r) e.move(e.createRangeIn(t), s, "end"), e.remove(t);
            s.nextSibling && (e.move(e.createRangeOn(s), o, "end"), i = !0), i = !!r.length || i;
          }
        }
        return i;
      }(t, e));
    }
    function nB(e) {
      return !!e && e.is("element", "table");
    }
    function iB(e) {
      for (const t of e.getChildren()) if (t.is("element", "caption")) return t;
      return null;
    }
    function oB(e) {
      const t = e.parent;
      return "figcaption" == e.name && t && t.is("element", "figure") && t.hasClass("table") || "caption" == e.name && t && t.is("element", "table") ? {
        name: !0
      } : null;
    }
    class rB extends Pr {
      refresh() {
        const e = uD(this.editor.model.document.selection);
        this.isEnabled = !!e, this.isEnabled ? this.value = !!iB(e) : this.value = !1;
      }
      execute() {
        let {
          focusCaptionOnShow: e = !1
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.editor.model.change(t => {
          this.value ? this._hideTableCaption(t) : this._showTableCaption(t, e);
        });
      }
      _showTableCaption(e, t) {
        const n = this.editor.model,
          i = uD(n.document.selection),
          o = this.editor.plugins.get("TableCaptionEditing")._getSavedCaption(i) || e.createElement("caption");
        n.insertContent(o, i, "end"), t && e.setSelection(o, "in");
      }
      _hideTableCaption(e) {
        const t = this.editor.model,
          n = uD(t.document.selection),
          i = this.editor.plugins.get("TableCaptionEditing"),
          o = iB(n);
        i._saveCaption(n, o), t.deleteContent(e.createSelection(o, "on"));
      }
    }
    class sB extends Br {
      static get pluginName() {
        return "TableCaptionEditing";
      }
      constructor(e) {
        super(e), this._savedCaptionsMap = new WeakMap();
      }
      init() {
        const e = this.editor,
          t = e.model.schema,
          n = e.editing.view,
          i = e.t;
        t.isRegistered("caption") ? t.extend("caption", {
          allowIn: "table"
        }) : t.register("caption", {
          allowIn: "table",
          allowContentOf: "$block",
          isLimit: !0
        }), e.commands.add("toggleTableCaption", new rB(this.editor)), e.conversion.for("upcast").elementToElement({
          view: oB,
          model: "caption"
        }), e.conversion.for("dataDowncast").elementToElement({
          model: "caption",
          view: (e, _ref170) => {
            let {
              writer: t
            } = _ref170;
            return nB(e.parent) ? t.createContainerElement("figcaption") : null;
          }
        }), e.conversion.for("editingDowncast").elementToElement({
          model: "caption",
          view: (e, _ref171) => {
            let {
              writer: t
            } = _ref171;
            if (!nB(e.parent)) return null;
            const o = t.createEditableElement("figcaption");
            return t.setCustomProperty("tableCaption", !0, o), o.placeholder = i("Enter table caption"), Ur({
              view: n,
              element: o,
              keepOnFocus: !0
            }), Ew(o, t);
          }
        }), tB(e.model);
      }
      _getSavedCaption(e) {
        const t = this._savedCaptionsMap.get(e);
        return t ? tc.fromJSON(t) : null;
      }
      _saveCaption(e, t) {
        this._savedCaptionsMap.set(e, t.toJSON());
      }
    }
    class aB extends Br {
      static get pluginName() {
        return "TableCaptionUI";
      }
      init() {
        const e = this.editor,
          t = e.editing.view,
          n = e.t;
        e.ui.componentFactory.add("toggleTableCaption", i => {
          const o = e.commands.get("toggleTableCaption"),
            r = new um(i);
          return r.set({
            icon: Wh.caption,
            tooltip: !0,
            isToggleable: !0
          }), r.bind("isOn", "isEnabled").to(o, "value", "isEnabled"), r.bind("label").to(o, "value", e => n(e ? "Toggle caption off" : "Toggle caption on")), this.listenTo(r, "execute", () => {
            if (e.execute("toggleTableCaption", {
              focusCaptionOnShow: !0
            }), o.value) {
              const n = function (e) {
                  const t = uD(e);
                  return t ? iB(t) : null;
                }(e.model.document.selection),
                i = e.editing.mapper.toViewElement(n);
              if (!i) return;
              t.scrollToTheSelection(), t.change(e => {
                e.addClass("table__caption_highlighted", i);
              });
            }
            e.editing.view.focus();
          }), r;
        });
      }
    }
    var lB = o(4412),
      cB = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(lB.A, cB);
    lB.A.locals;
    var dB = o(7642),
      uB = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Cr()(dB.A, uB);
    dB.A.locals;
    function hB(e) {
      return hB = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, hB(e);
    }
    function mB(e) {
      var t = function (e, t) {
        if ("object" != hB(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var i = n.call(e, t || "default");
          if ("object" != hB(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == hB(t) ? t : t + "";
    }
    function pB(e, t, n) {
      return (t = mB(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function gB(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? Object(arguments[t]) : {},
          i = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && i.push.apply(i, Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), i.forEach(function (t) {
          pB(e, t, n[t]);
        });
      }
      return e;
    }
    function fB(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function kB(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, mB(i.key), i);
      }
    }
    function bB(e, t, n) {
      return t && kB(e.prototype, t), n && kB(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }
    function _B(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function wB(e, t) {
      if (t && ("object" == hB(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return _B(e);
    }
    function AB(e) {
      return AB = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, AB(e);
    }
    function vB(e, t) {
      return vB = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, vB(e, t);
    }
    function CB(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && vB(e, t);
    }
    var yB = {
        type: "logger",
        log: function (e) {
          this.output("log", e);
        },
        warn: function (e) {
          this.output("warn", e);
        },
        error: function (e) {
          this.output("error", e);
        },
        output: function (e, t) {
          console && console[e] && console[e].apply(console, t);
        }
      },
      xB = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          fB(this, e), this.init(t, n);
        }
        return bB(e, [{
          key: "init",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.prefix = t.prefix || "i18next:", this.logger = e || yB, this.options = t, this.debug = t.debug;
          }
        }, {
          key: "setDebug",
          value: function (e) {
            this.debug = e;
          }
        }, {
          key: "log",
          value: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            return this.forward(t, "log", "", !0);
          }
        }, {
          key: "warn",
          value: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            return this.forward(t, "warn", "", !0);
          }
        }, {
          key: "error",
          value: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            return this.forward(t, "error", "");
          }
        }, {
          key: "deprecate",
          value: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
          }
        }, {
          key: "forward",
          value: function (e, t, n, i) {
            return i && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(n).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
          }
        }, {
          key: "create",
          value: function (t) {
            return new e(this.logger, gB({}, {
              prefix: "".concat(this.prefix, ":").concat(t, ":")
            }, this.options));
          }
        }]), e;
      }(),
      EB = new xB(),
      SB = function () {
        function e() {
          fB(this, e), this.observers = {};
        }
        return bB(e, [{
          key: "on",
          value: function (e, t) {
            var n = this;
            return e.split(" ").forEach(function (e) {
              n.observers[e] = n.observers[e] || [], n.observers[e].push(t);
            }), this;
          }
        }, {
          key: "off",
          value: function (e, t) {
            this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
              return e !== t;
            }) : delete this.observers[e]);
          }
        }, {
          key: "emit",
          value: function (e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
            this.observers[e] && [].concat(this.observers[e]).forEach(function (e) {
              e.apply(void 0, n);
            });
            this.observers["*"] && [].concat(this.observers["*"]).forEach(function (t) {
              t.apply(t, [e].concat(n));
            });
          }
        }]), e;
      }();
    function DB() {
      var e,
        t,
        n = new Promise(function (n, i) {
          e = n, t = i;
        });
      return n.resolve = e, n.reject = t, n;
    }
    function TB(e) {
      return null == e ? "" : "" + e;
    }
    function IB(e, t, n) {
      function i(e) {
        return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
      }
      function o() {
        return !e || "string" == typeof e;
      }
      for (var r = "string" != typeof t ? [].concat(t) : t.split("."); r.length > 1;) {
        if (o()) return {};
        var s = i(r.shift());
        !e[s] && n && (e[s] = new n()), e = Object.prototype.hasOwnProperty.call(e, s) ? e[s] : {};
      }
      return o() ? {} : {
        obj: e,
        k: i(r.shift())
      };
    }
    function BB(e, t, n) {
      var i = IB(e, t, Object);
      i.obj[i.k] = n;
    }
    function MB(e, t) {
      var n = IB(e, t),
        i = n.obj,
        o = n.k;
      if (i) return i[o];
    }
    function PB(e, t, n) {
      var i = MB(e, n);
      return void 0 !== i ? i : MB(t, n);
    }
    function zB(e, t, n) {
      for (var i in t) "__proto__" !== i && "constructor" !== i && (i in e ? "string" == typeof e[i] || e[i] instanceof String || "string" == typeof t[i] || t[i] instanceof String ? n && (e[i] = t[i]) : zB(e[i], t[i], n) : e[i] = t[i]);
      return e;
    }
    function NB(e) {
      return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
    var LB = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;"
    };
    function RB(e) {
      return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
        return LB[e];
      }) : e;
    }
    var VB = "undefined" != typeof window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1,
      OB = function (e) {
        function t(e) {
          var n,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              ns: ["translation"],
              defaultNS: "translation"
            };
          return fB(this, t), n = wB(this, AB(t).call(this)), VB && SB.call(_B(n)), n.data = e || {}, n.options = i, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), n;
        }
        return CB(t, e), bB(t, [{
          key: "addNamespaces",
          value: function (e) {
            this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
          }
        }, {
          key: "removeNamespaces",
          value: function (e) {
            var t = this.options.ns.indexOf(e);
            t > -1 && this.options.ns.splice(t, 1);
          }
        }, {
          key: "getResource",
          value: function (e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = void 0 !== i.keySeparator ? i.keySeparator : this.options.keySeparator,
              r = [e, t];
            return n && "string" != typeof n && (r = r.concat(n)), n && "string" == typeof n && (r = r.concat(o ? n.split(o) : n)), e.indexOf(".") > -1 && (r = e.split(".")), MB(this.data, r);
          }
        }, {
          key: "addResource",
          value: function (e, t, n, i) {
            var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
                silent: !1
              },
              r = this.options.keySeparator;
            void 0 === r && (r = ".");
            var s = [e, t];
            n && (s = s.concat(r ? n.split(r) : n)), e.indexOf(".") > -1 && (i = t, t = (s = e.split("."))[1]), this.addNamespaces(t), BB(this.data, s, i), o.silent || this.emit("added", e, t, n, i);
          }
        }, {
          key: "addResources",
          value: function (e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
              silent: !1
            };
            for (var o in n) "string" != typeof n[o] && "[object Array]" !== Object.prototype.toString.apply(n[o]) || this.addResource(e, t, o, n[o], {
              silent: !0
            });
            i.silent || this.emit("added", e, t, n);
          }
        }, {
          key: "addResourceBundle",
          value: function (e, t, n, i, o) {
            var r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
                silent: !1
              },
              s = [e, t];
            e.indexOf(".") > -1 && (i = n, n = t, t = (s = e.split("."))[1]), this.addNamespaces(t);
            var a = MB(this.data, s) || {};
            i ? zB(a, n, o) : a = gB({}, a, n), BB(this.data, s, a), r.silent || this.emit("added", e, t, n);
          }
        }, {
          key: "removeResourceBundle",
          value: function (e, t) {
            this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
          }
        }, {
          key: "hasResourceBundle",
          value: function (e, t) {
            return void 0 !== this.getResource(e, t);
          }
        }, {
          key: "getResourceBundle",
          value: function (e, t) {
            return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? gB({}, {}, this.getResource(e, t)) : this.getResource(e, t);
          }
        }, {
          key: "getDataByLanguage",
          value: function (e) {
            return this.data[e];
          }
        }, {
          key: "toJSON",
          value: function () {
            return this.data;
          }
        }]), t;
      }(SB),
      FB = {
        processors: {},
        addPostProcessor: function (e) {
          this.processors[e.name] = e;
        },
        handle: function (e, t, n, i, o) {
          var r = this;
          return e.forEach(function (e) {
            r.processors[e] && (t = r.processors[e].process(t, n, i, o));
          }), t;
        }
      },
      jB = {},
      HB = function (e) {
        function t(e) {
          var n,
            i,
            o,
            r,
            s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return fB(this, t), n = wB(this, AB(t).call(this)), VB && SB.call(_B(n)), i = ["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], o = e, r = _B(n), i.forEach(function (e) {
            o[e] && (r[e] = o[e]);
          }), n.options = s, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), n.logger = EB.create("translator"), n;
        }
        return CB(t, e), bB(t, [{
          key: "changeLanguage",
          value: function (e) {
            e && (this.language = e);
          }
        }, {
          key: "exists",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                interpolation: {}
              },
              n = this.resolve(e, t);
            return n && void 0 !== n.res;
          }
        }, {
          key: "extractFromKey",
          value: function (e, t) {
            var n = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
            void 0 === n && (n = ":");
            var i = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              o = t.ns || this.options.defaultNS;
            if (n && e.indexOf(n) > -1) {
              var r = e.match(this.interpolator.nestingRegexp);
              if (r && r.length > 0) return {
                key: e,
                namespaces: o
              };
              var s = e.split(n);
              (n !== i || n === i && this.options.ns.indexOf(s[0]) > -1) && (o = s.shift()), e = s.join(i);
            }
            return "string" == typeof o && (o = [o]), {
              key: e,
              namespaces: o
            };
          }
        }, {
          key: "translate",
          value: function (e, n, i) {
            var o = this;
            if ("object" !== hB(n) && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), n || (n = {}), null == e) return "";
            Array.isArray(e) || (e = [String(e)]);
            var r = void 0 !== n.keySeparator ? n.keySeparator : this.options.keySeparator,
              s = this.extractFromKey(e[e.length - 1], n),
              a = s.key,
              l = s.namespaces,
              c = l[l.length - 1],
              d = n.lng || this.language,
              u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
            if (d && "cimode" === d.toLowerCase()) {
              if (u) {
                var h = n.nsSeparator || this.options.nsSeparator;
                return c + h + a;
              }
              return a;
            }
            var m = this.resolve(e, n),
              p = m && m.res,
              g = m && m.usedKey || a,
              f = m && m.exactUsedKey || a,
              k = Object.prototype.toString.apply(p),
              b = void 0 !== n.joinArrays ? n.joinArrays : this.options.joinArrays,
              _ = !this.i18nFormat || this.i18nFormat.handleAsObject;
            if (_ && p && "string" != typeof p && "boolean" != typeof p && "number" != typeof p && ["[object Number]", "[object Function]", "[object RegExp]"].indexOf(k) < 0 && ("string" != typeof b || "[object Array]" !== k)) {
              if (!n.returnObjects && !this.options.returnObjects) return this.logger.warn("accessing an object - but returnObjects options is not enabled!"), this.options.returnedObjectHandler ? this.options.returnedObjectHandler(g, p, n) : "key '".concat(a, " (").concat(this.language, ")' returned an object instead of string.");
              if (r) {
                var w = "[object Array]" === k,
                  A = w ? [] : {},
                  v = w ? f : g;
                for (var C in p) if (Object.prototype.hasOwnProperty.call(p, C)) {
                  var y = "".concat(v).concat(r).concat(C);
                  A[C] = this.translate(y, gB({}, n, {
                    joinArrays: !1,
                    ns: l
                  })), A[C] === y && (A[C] = p[C]);
                }
                p = A;
              }
            } else if (_ && "string" == typeof b && "[object Array]" === k) (p = p.join(b)) && (p = this.extendTranslation(p, e, n, i));else {
              var x = !1,
                E = !1,
                S = void 0 !== n.count && "string" != typeof n.count,
                D = t.hasDefaultValue(n),
                T = S ? this.pluralResolver.getSuffix(d, n.count) : "",
                I = n["defaultValue".concat(T)] || n.defaultValue;
              !this.isValidLookup(p) && D && (x = !0, p = I), this.isValidLookup(p) || (E = !0, p = a);
              var B = D && I !== p && this.options.updateMissing;
              if (E || x || B) {
                if (this.logger.log(B ? "updateKey" : "missingKey", d, c, a, B ? I : p), r) {
                  var M = this.resolve(a, gB({}, n, {
                    keySeparator: !1
                  }));
                  M && M.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                var P = [],
                  z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
                if ("fallback" === this.options.saveMissingTo && z && z[0]) for (var N = 0; N < z.length; N++) P.push(z[N]);else "all" === this.options.saveMissingTo ? P = this.languageUtils.toResolveHierarchy(n.lng || this.language) : P.push(n.lng || this.language);
                var L = function (e, t, i) {
                  o.options.missingKeyHandler ? o.options.missingKeyHandler(e, c, t, B ? i : p, B, n) : o.backendConnector && o.backendConnector.saveMissing && o.backendConnector.saveMissing(e, c, t, B ? i : p, B, n), o.emit("missingKey", e, c, t, p);
                };
                this.options.saveMissing && (this.options.saveMissingPlurals && S ? P.forEach(function (e) {
                  o.pluralResolver.getSuffixes(e).forEach(function (t) {
                    L([e], a + t, n["defaultValue".concat(t)] || I);
                  });
                }) : L(P, a, I));
              }
              p = this.extendTranslation(p, e, n, m, i), E && p === a && this.options.appendNamespaceToMissingKey && (p = "".concat(c, ":").concat(a)), E && this.options.parseMissingKeyHandler && (p = this.options.parseMissingKeyHandler(p));
            }
            return p;
          }
        }, {
          key: "extendTranslation",
          value: function (e, t, n, i, o) {
            var r = this;
            if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, n, i.usedLng, i.usedNS, i.usedKey, {
              resolved: i
            });else if (!n.skipInterpolation) {
              n.interpolation && this.interpolator.init(gB({}, n, {
                interpolation: gB({}, this.options.interpolation, n.interpolation)
              }));
              var s,
                a = n.interpolation && n.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
              if (a) {
                var l = e.match(this.interpolator.nestingRegexp);
                s = l && l.length;
              }
              var c = n.replace && "string" != typeof n.replace ? n.replace : n;
              if (this.options.interpolation.defaultVariables && (c = gB({}, this.options.interpolation.defaultVariables, c)), e = this.interpolator.interpolate(e, c, n.lng || this.language, n), a) {
                var d = e.match(this.interpolator.nestingRegexp);
                s < (d && d.length) && (n.nest = !1);
              }
              !1 !== n.nest && (e = this.interpolator.nest(e, function () {
                for (var e = arguments.length, i = new Array(e), s = 0; s < e; s++) i[s] = arguments[s];
                return o && o[0] === i[0] && !n.context ? (r.logger.warn("It seems you are nesting recursively key: ".concat(i[0], " in key: ").concat(t[0])), null) : r.translate.apply(r, i.concat([t]));
              }, n)), n.interpolation && this.interpolator.reset();
            }
            var u = n.postProcess || this.options.postProcess,
              h = "string" == typeof u ? [u] : u;
            return null != e && h && h.length && !1 !== n.applyPostProcessor && (e = FB.handle(h, e, t, this.options && this.options.postProcessPassResolved ? gB({
              i18nResolved: i
            }, n) : n, this)), e;
          }
        }, {
          key: "resolve",
          value: function (e) {
            var t,
              n,
              i,
              o,
              r,
              s = this,
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return "string" == typeof e && (e = [e]), e.forEach(function (e) {
              if (!s.isValidLookup(t)) {
                var l = s.extractFromKey(e, a),
                  c = l.key;
                n = c;
                var d = l.namespaces;
                s.options.fallbackNS && (d = d.concat(s.options.fallbackNS));
                var u = void 0 !== a.count && "string" != typeof a.count,
                  h = void 0 !== a.context && "string" == typeof a.context && "" !== a.context,
                  m = a.lngs ? a.lngs : s.languageUtils.toResolveHierarchy(a.lng || s.language, a.fallbackLng);
                d.forEach(function (e) {
                  s.isValidLookup(t) || (r = e, !jB["".concat(m[0], "-").concat(e)] && s.utils && s.utils.hasLoadedNamespace && !s.utils.hasLoadedNamespace(r) && (jB["".concat(m[0], "-").concat(e)] = !0, s.logger.warn('key "'.concat(n, '" for languages "').concat(m.join(", "), '" won\'t get resolved as namespace "').concat(r, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach(function (n) {
                    if (!s.isValidLookup(t)) {
                      o = n;
                      var r,
                        l,
                        d = c,
                        m = [d];
                      if (s.i18nFormat && s.i18nFormat.addLookupKeys) s.i18nFormat.addLookupKeys(m, c, n, e, a);else u && (r = s.pluralResolver.getSuffix(n, a.count)), u && h && m.push(d + r), h && m.push(d += "".concat(s.options.contextSeparator).concat(a.context)), u && m.push(d += r);
                      for (; l = m.pop();) s.isValidLookup(t) || (i = l, t = s.getResource(n, e, l, a));
                    }
                  }));
                });
              }
            }), {
              res: t,
              usedKey: n,
              exactUsedKey: i,
              usedLng: o,
              usedNS: r
            };
          }
        }, {
          key: "isValidLookup",
          value: function (e) {
            return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
          }
        }, {
          key: "getResource",
          value: function (e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, n, i) : this.resourceStore.getResource(e, t, n, i);
          }
        }], [{
          key: "hasDefaultValue",
          value: function (e) {
            var t = "defaultValue";
            for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t === n.substring(0, 12) && void 0 !== e[n]) return !0;
            return !1;
          }
        }]), t;
      }(SB);
    function UB(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }
    var qB = function () {
        function e(t) {
          fB(this, e), this.options = t, this.whitelist = this.options.supportedLngs || !1, this.supportedLngs = this.options.supportedLngs || !1, this.logger = EB.create("languageUtils");
        }
        return bB(e, [{
          key: "getScriptPartFromCode",
          value: function (e) {
            if (!e || e.indexOf("-") < 0) return null;
            var t = e.split("-");
            return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
          }
        }, {
          key: "getLanguagePartFromCode",
          value: function (e) {
            if (!e || e.indexOf("-") < 0) return e;
            var t = e.split("-");
            return this.formatLanguageCode(t[0]);
          }
        }, {
          key: "formatLanguageCode",
          value: function (e) {
            if ("string" == typeof e && e.indexOf("-") > -1) {
              var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
                n = e.split("-");
              return this.options.lowerCaseLng ? n = n.map(function (e) {
                return e.toLowerCase();
              }) : 2 === n.length ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = UB(n[1].toLowerCase()))) : 3 === n.length && (n[0] = n[0].toLowerCase(), 2 === n[1].length && (n[1] = n[1].toUpperCase()), "sgn" !== n[0] && 2 === n[2].length && (n[2] = n[2].toUpperCase()), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = UB(n[1].toLowerCase())), t.indexOf(n[2].toLowerCase()) > -1 && (n[2] = UB(n[2].toLowerCase()))), n.join("-");
            }
            return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
          }
        }, {
          key: "isWhitelisted",
          value: function (e) {
            return this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.'), this.isSupportedCode(e);
          }
        }, {
          key: "isSupportedCode",
          value: function (e) {
            return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
          }
        }, {
          key: "getBestMatchFromCodes",
          value: function (e) {
            var t,
              n = this;
            return e ? (e.forEach(function (e) {
              if (!t) {
                var i = n.formatLanguageCode(e);
                n.options.supportedLngs && !n.isSupportedCode(i) || (t = i);
              }
            }), !t && this.options.supportedLngs && e.forEach(function (e) {
              if (!t) {
                var i = n.getLanguagePartFromCode(e);
                if (n.isSupportedCode(i)) return t = i;
                t = n.options.supportedLngs.find(function (e) {
                  if (0 === e.indexOf(i)) return e;
                });
              }
            }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
          }
        }, {
          key: "getFallbackCodes",
          value: function (e, t) {
            if (!e) return [];
            if ("function" == typeof e && (e = e(t)), "string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
            if (!t) return e.default || [];
            var n = e[t];
            return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
          }
        }, {
          key: "toResolveHierarchy",
          value: function (e, t) {
            var n = this,
              i = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
              o = [],
              r = function (e) {
                e && (n.isSupportedCode(e) ? o.push(e) : n.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
              };
            return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && r(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && r(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && r(this.getLanguagePartFromCode(e))) : "string" == typeof e && r(this.formatLanguageCode(e)), i.forEach(function (e) {
              o.indexOf(e) < 0 && r(n.formatLanguageCode(e));
            }), o;
          }
        }]), e;
      }(),
      GB = [{
        lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
        nr: [1, 2],
        fc: 1
      }, {
        lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
        nr: [1, 2],
        fc: 2
      }, {
        lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "kk", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
        nr: [1],
        fc: 3
      }, {
        lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
        nr: [1, 2, 5],
        fc: 4
      }, {
        lngs: ["ar"],
        nr: [0, 1, 2, 3, 11, 100],
        fc: 5
      }, {
        lngs: ["cs", "sk"],
        nr: [1, 2, 5],
        fc: 6
      }, {
        lngs: ["csb", "pl"],
        nr: [1, 2, 5],
        fc: 7
      }, {
        lngs: ["cy"],
        nr: [1, 2, 3, 8],
        fc: 8
      }, {
        lngs: ["fr"],
        nr: [1, 2],
        fc: 9
      }, {
        lngs: ["ga"],
        nr: [1, 2, 3, 7, 11],
        fc: 10
      }, {
        lngs: ["gd"],
        nr: [1, 2, 3, 20],
        fc: 11
      }, {
        lngs: ["is"],
        nr: [1, 2],
        fc: 12
      }, {
        lngs: ["jv"],
        nr: [0, 1],
        fc: 13
      }, {
        lngs: ["kw"],
        nr: [1, 2, 3, 4],
        fc: 14
      }, {
        lngs: ["lt"],
        nr: [1, 2, 10],
        fc: 15
      }, {
        lngs: ["lv"],
        nr: [1, 2, 0],
        fc: 16
      }, {
        lngs: ["mk"],
        nr: [1, 2],
        fc: 17
      }, {
        lngs: ["mnk"],
        nr: [0, 1, 2],
        fc: 18
      }, {
        lngs: ["mt"],
        nr: [1, 2, 11, 20],
        fc: 19
      }, {
        lngs: ["or"],
        nr: [2, 1],
        fc: 2
      }, {
        lngs: ["ro"],
        nr: [1, 2, 20],
        fc: 20
      }, {
        lngs: ["sl"],
        nr: [5, 1, 2, 3],
        fc: 21
      }, {
        lngs: ["he", "iw"],
        nr: [1, 2, 20, 21],
        fc: 22
      }],
      KB = {
        1: function (e) {
          return Number(e > 1);
        },
        2: function (e) {
          return Number(1 != e);
        },
        3: function (e) {
          return 0;
        },
        4: function (e) {
          return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
        },
        5: function (e) {
          return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
        },
        6: function (e) {
          return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
        },
        7: function (e) {
          return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
        },
        8: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
        },
        9: function (e) {
          return Number(e >= 2);
        },
        10: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
        },
        11: function (e) {
          return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
        },
        12: function (e) {
          return Number(e % 10 != 1 || e % 100 == 11);
        },
        13: function (e) {
          return Number(0 !== e);
        },
        14: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
        },
        15: function (e) {
          return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
        },
        16: function (e) {
          return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
        },
        17: function (e) {
          return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
        },
        18: function (e) {
          return Number(0 == e ? 0 : 1 == e ? 1 : 2);
        },
        19: function (e) {
          return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
        },
        20: function (e) {
          return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
        },
        21: function (e) {
          return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
        },
        22: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
        }
      };
    var WB = function () {
        function e(t) {
          var n,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          fB(this, e), this.languageUtils = t, this.options = i, this.logger = EB.create("pluralResolver"), this.rules = (n = {}, GB.forEach(function (e) {
            e.lngs.forEach(function (t) {
              n[t] = {
                numbers: e.nr,
                plurals: KB[e.fc]
              };
            });
          }), n);
        }
        return bB(e, [{
          key: "addRule",
          value: function (e, t) {
            this.rules[e] = t;
          }
        }, {
          key: "getRule",
          value: function (e) {
            return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
          }
        }, {
          key: "needsPlural",
          value: function (e) {
            var t = this.getRule(e);
            return t && t.numbers.length > 1;
          }
        }, {
          key: "getPluralFormsOfKey",
          value: function (e, t) {
            return this.getSuffixes(e).map(function (e) {
              return t + e;
            });
          }
        }, {
          key: "getSuffixes",
          value: function (e) {
            var t = this,
              n = this.getRule(e);
            return n ? n.numbers.map(function (n) {
              return t.getSuffix(e, n);
            }) : [];
          }
        }, {
          key: "getSuffix",
          value: function (e, t) {
            var n = this,
              i = this.getRule(e);
            if (i) {
              var o = i.noAbs ? i.plurals(t) : i.plurals(Math.abs(t)),
                r = i.numbers[o];
              this.options.simplifyPluralSuffix && 2 === i.numbers.length && 1 === i.numbers[0] && (2 === r ? r = "plural" : 1 === r && (r = ""));
              var s = function () {
                return n.options.prepend && r.toString() ? n.options.prepend + r.toString() : r.toString();
              };
              return "v1" === this.options.compatibilityJSON ? 1 === r ? "" : "number" == typeof r ? "_plural_".concat(r.toString()) : s() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === i.numbers.length && 1 === i.numbers[0] ? s() : this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
            }
            return this.logger.warn("no plural rule found for: ".concat(e)), "";
          }
        }]), e;
      }(),
      YB = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          fB(this, e), this.logger = EB.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
            return e;
          }, this.init(t);
        }
        return bB(e, [{
          key: "init",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            e.interpolation || (e.interpolation = {
              escapeValue: !0
            });
            var t = e.interpolation;
            this.escape = void 0 !== t.escape ? t.escape : RB, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? NB(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? NB(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? NB(t.nestingPrefix) : t.nestingPrefixEscaped || NB("$t("), this.nestingSuffix = t.nestingSuffix ? NB(t.nestingSuffix) : t.nestingSuffixEscaped || NB(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
          }
        }, {
          key: "reset",
          value: function () {
            this.options && this.init(this.options);
          }
        }, {
          key: "resetRegExp",
          value: function () {
            var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
            this.regexp = new RegExp(e, "g");
            var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
            this.regexpUnescape = new RegExp(t, "g");
            var n = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
            this.nestingRegexp = new RegExp(n, "g");
          }
        }, {
          key: "interpolate",
          value: function (e, t, n, i) {
            var o,
              r,
              s,
              a = this,
              l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
            function c(e) {
              return e.replace(/\$/g, "$$$$");
            }
            var d = function (e) {
              if (e.indexOf(a.formatSeparator) < 0) {
                var o = PB(t, l, e);
                return a.alwaysFormat ? a.format(o, void 0, n) : o;
              }
              var r = e.split(a.formatSeparator),
                s = r.shift().trim(),
                c = r.join(a.formatSeparator).trim();
              return a.format(PB(t, l, s), c, n, i);
            };
            this.resetRegExp();
            var u = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler,
              h = i && i.interpolation && i.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
            return [{
              regex: this.regexpUnescape,
              safeValue: function (e) {
                return c(e);
              }
            }, {
              regex: this.regexp,
              safeValue: function (e) {
                return a.escapeValue ? c(a.escape(e)) : c(e);
              }
            }].forEach(function (t) {
              for (s = 0; o = t.regex.exec(e);) {
                if (void 0 === (r = d(o[1].trim()))) {
                  if ("function" == typeof u) {
                    var n = u(e, o, i);
                    r = "string" == typeof n ? n : "";
                  } else {
                    if (h) {
                      r = o[0];
                      continue;
                    }
                    a.logger.warn("missed to pass in variable ".concat(o[1], " for interpolating ").concat(e)), r = "";
                  }
                } else "string" == typeof r || a.useRawValueToEscape || (r = TB(r));
                if (e = e.replace(o[0], t.safeValue(r)), t.regex.lastIndex = 0, ++s >= a.maxReplaces) break;
              }
            }), e;
          }
        }, {
          key: "nest",
          value: function (e, t) {
            var n,
              i,
              o = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              s = gB({}, r);
            function a(e, t) {
              var n = this.nestingOptionsSeparator;
              if (e.indexOf(n) < 0) return e;
              var i = e.split(new RegExp("".concat(n, "[ ]*{"))),
                o = "{".concat(i[1]);
              e = i[0], o = (o = this.interpolate(o, s)).replace(/'/g, '"');
              try {
                s = JSON.parse(o), t && (s = gB({}, t, s));
              } catch (t) {
                return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(n).concat(o);
              }
              return delete s.defaultValue, e;
            }
            for (s.applyPostProcessor = !1, delete s.defaultValue; n = this.nestingRegexp.exec(e);) {
              var l = [],
                c = !1;
              if (n[0].includes(this.formatSeparator) && !/{.*}/.test(n[1])) {
                var d = n[1].split(this.formatSeparator).map(function (e) {
                  return e.trim();
                });
                n[1] = d.shift(), l = d, c = !0;
              }
              if ((i = t(a.call(this, n[1].trim(), s), s)) && n[0] === e && "string" != typeof i) return i;
              "string" != typeof i && (i = TB(i)), i || (this.logger.warn("missed to resolve ".concat(n[1], " for nesting ").concat(e)), i = ""), c && (i = l.reduce(function (e, t) {
                return o.format(e, t, r.lng, r);
              }, i.trim())), e = e.replace(n[0], i), this.regexp.lastIndex = 0;
            }
            return e;
          }
        }]), e;
      }();
    var $B = function (e) {
      function t(e, n, i) {
        var o,
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return fB(this, t), o = wB(this, AB(t).call(this)), VB && SB.call(_B(o)), o.backend = e, o.store = n, o.services = i, o.languageUtils = i.languageUtils, o.options = r, o.logger = EB.create("backendConnector"), o.state = {}, o.queue = [], o.backend && o.backend.init && o.backend.init(i, r.backend, r), o;
      }
      return CB(t, e), bB(t, [{
        key: "queueLoad",
        value: function (e, t, n, i) {
          var o = this,
            r = [],
            s = [],
            a = [],
            l = [];
          return e.forEach(function (e) {
            var i = !0;
            t.forEach(function (t) {
              var a = "".concat(e, "|").concat(t);
              !n.reload && o.store.hasResourceBundle(e, t) ? o.state[a] = 2 : o.state[a] < 0 || (1 === o.state[a] ? s.indexOf(a) < 0 && s.push(a) : (o.state[a] = 1, i = !1, s.indexOf(a) < 0 && s.push(a), r.indexOf(a) < 0 && r.push(a), l.indexOf(t) < 0 && l.push(t)));
            }), i || a.push(e);
          }), (r.length || s.length) && this.queue.push({
            pending: s,
            loaded: {},
            errors: [],
            callback: i
          }), {
            toLoad: r,
            pending: s,
            toLoadLanguages: a,
            toLoadNamespaces: l
          };
        }
      }, {
        key: "loaded",
        value: function (e, t, n) {
          var i = e.split("|"),
            o = i[0],
            r = i[1];
          t && this.emit("failedLoading", o, r, t), n && this.store.addResourceBundle(o, r, n), this.state[e] = t ? -1 : 2;
          var s = {};
          this.queue.forEach(function (n) {
            !function (e, t, n, i) {
              var o = IB(e, t, Object),
                r = o.obj,
                s = o.k;
              r[s] = r[s] || [], i && (r[s] = r[s].concat(n)), i || r[s].push(n);
            }(n.loaded, [o], r), function (e, t) {
              for (var n = e.indexOf(t); -1 !== n;) e.splice(n, 1), n = e.indexOf(t);
            }(n.pending, e), t && n.errors.push(t), 0 !== n.pending.length || n.done || (Object.keys(n.loaded).forEach(function (e) {
              s[e] || (s[e] = []), n.loaded[e].length && n.loaded[e].forEach(function (t) {
                s[e].indexOf(t) < 0 && s[e].push(t);
              });
            }), n.done = !0, n.errors.length ? n.callback(n.errors) : n.callback());
          }), this.emit("loaded", s), this.queue = this.queue.filter(function (e) {
            return !e.done;
          });
        }
      }, {
        key: "read",
        value: function (e, t, n) {
          var i = this,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
            r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 350,
            s = arguments.length > 5 ? arguments[5] : void 0;
          return e.length ? this.backend[n](e, t, function (a, l) {
            a && l && o < 5 ? setTimeout(function () {
              i.read.call(i, e, t, n, o + 1, 2 * r, s);
            }, r) : s(a, l);
          }) : s(null, {});
        }
      }, {
        key: "prepareLoading",
        value: function (e, t) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = arguments.length > 3 ? arguments[3] : void 0;
          if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
          "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
          var r = this.queueLoad(e, t, i, o);
          if (!r.toLoad.length) return r.pending.length || o(), null;
          r.toLoad.forEach(function (e) {
            n.loadOne(e);
          });
        }
      }, {
        key: "load",
        value: function (e, t, n) {
          this.prepareLoading(e, t, {}, n);
        }
      }, {
        key: "reload",
        value: function (e, t, n) {
          this.prepareLoading(e, t, {
            reload: !0
          }, n);
        }
      }, {
        key: "loadOne",
        value: function (e) {
          var t = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            i = e.split("|"),
            o = i[0],
            r = i[1];
          this.read(o, r, "read", void 0, void 0, function (i, s) {
            i && t.logger.warn("".concat(n, "loading namespace ").concat(r, " for language ").concat(o, " failed"), i), !i && s && t.logger.log("".concat(n, "loaded namespace ").concat(r, " for language ").concat(o), s), t.loaded(e, i, s);
          });
        }
      }, {
        key: "saveMissing",
        value: function (e, t, n, i, o) {
          var r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t) ? this.logger.warn('did not save key "'.concat(n, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != n && "" !== n && (this.backend && this.backend.create && this.backend.create(e, t, n, i, null, gB({}, r, {
            isUpdate: o
          })), e && e[0] && this.store.addResource(e[0], t, n, i));
        }
      }]), t;
    }(SB);
    function ZB(e) {
      return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.whitelist && (e.whitelist && e.whitelist.indexOf("cimode") < 0 && (e.whitelist = e.whitelist.concat(["cimode"])), e.supportedLngs = e.whitelist), e.nonExplicitWhitelist && (e.nonExplicitSupportedLngs = e.nonExplicitWhitelist), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
    }
    function QB() {}
    var JB = function (e) {
      function t() {
        var e,
          n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          i = arguments.length > 1 ? arguments[1] : void 0;
        if (fB(this, t), e = wB(this, AB(t).call(this)), VB && SB.call(_B(e)), e.options = ZB(n), e.services = {}, e.logger = EB, e.modules = {
          external: []
        }, i && !e.isInitialized && !n.isClone) {
          if (!e.options.initImmediate) return e.init(n, i), wB(e, _B(e));
          setTimeout(function () {
            e.init(n, i);
          }, 0);
        }
        return e;
      }
      return CB(t, e), bB(t, [{
        key: "init",
        value: function () {
          var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 ? arguments[1] : void 0;
          function i(e) {
            return e ? "function" == typeof e ? new e() : e : null;
          }
          if ("function" == typeof t && (n = t, t = {}), t.whitelist && !t.supportedLngs && this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'), t.nonExplicitWhitelist && !t.nonExplicitSupportedLngs && this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'), this.options = gB({}, {
            debug: !1,
            initImmediate: !0,
            ns: ["translation"],
            defaultNS: ["translation"],
            fallbackLng: ["dev"],
            fallbackNS: !1,
            whitelist: !1,
            nonExplicitWhitelist: !1,
            supportedLngs: !1,
            nonExplicitSupportedLngs: !1,
            load: "all",
            preload: !1,
            simplifyPluralSuffix: !0,
            keySeparator: ".",
            nsSeparator: ":",
            pluralSeparator: "_",
            contextSeparator: "_",
            partialBundledLanguages: !1,
            saveMissing: !1,
            updateMissing: !1,
            saveMissingTo: "fallback",
            saveMissingPlurals: !0,
            missingKeyHandler: !1,
            missingInterpolationHandler: !1,
            postProcess: !1,
            postProcessPassResolved: !1,
            returnNull: !0,
            returnEmptyString: !0,
            returnObjects: !1,
            joinArrays: !1,
            returnedObjectHandler: !1,
            parseMissingKeyHandler: !1,
            appendNamespaceToMissingKey: !1,
            appendNamespaceToCIMode: !1,
            overloadTranslationOptionHandler: function (e) {
              var t = {};
              if ("object" === hB(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === hB(e[2]) || "object" === hB(e[3])) {
                var n = e[3] || e[2];
                Object.keys(n).forEach(function (e) {
                  t[e] = n[e];
                });
              }
              return t;
            },
            interpolation: {
              escapeValue: !0,
              format: function (e, t, n, i) {
                return e;
              },
              prefix: "{{",
              suffix: "}}",
              formatSeparator: ",",
              unescapePrefix: "-",
              nestingPrefix: "$t(",
              nestingSuffix: ")",
              nestingOptionsSeparator: ",",
              maxReplaces: 1e3,
              skipOnVariables: !1
            }
          }, this.options, ZB(t)), this.format = this.options.interpolation.format, n || (n = QB), !this.options.isClone) {
            this.modules.logger ? EB.init(i(this.modules.logger), this.options) : EB.init(null, this.options);
            var o = new qB(this.options);
            this.store = new OB(this.options.resources, this.options);
            var r = this.services;
            r.logger = EB, r.resourceStore = this.store, r.languageUtils = o, r.pluralResolver = new WB(o, {
              prepend: this.options.pluralSeparator,
              compatibilityJSON: this.options.compatibilityJSON,
              simplifyPluralSuffix: this.options.simplifyPluralSuffix
            }), r.interpolator = new YB(this.options), r.utils = {
              hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            }, r.backendConnector = new $B(i(this.modules.backend), r.resourceStore, r, this.options), r.backendConnector.on("*", function (t) {
              for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) i[o - 1] = arguments[o];
              e.emit.apply(e, [t].concat(i));
            }), this.modules.languageDetector && (r.languageDetector = i(this.modules.languageDetector), r.languageDetector.init(r, this.options.detection, this.options)), this.modules.i18nFormat && (r.i18nFormat = i(this.modules.i18nFormat), r.i18nFormat.init && r.i18nFormat.init(this)), this.translator = new HB(this.services, this.options), this.translator.on("*", function (t) {
              for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) i[o - 1] = arguments[o];
              e.emit.apply(e, [t].concat(i));
            }), this.modules.external.forEach(function (t) {
              t.init && t.init(e);
            });
          }
          if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            var s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            s.length > 0 && "dev" !== s[0] && (this.options.lng = s[0]);
          }
          this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
          ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach(function (t) {
            e[t] = function () {
              var n;
              return (n = e.store)[t].apply(n, arguments);
            };
          });
          ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach(function (t) {
            e[t] = function () {
              var n;
              return (n = e.store)[t].apply(n, arguments), e;
            };
          });
          var a = DB(),
            l = function () {
              var t = function (t, i) {
                e.isInitialized && e.logger.warn("init: i18next is already initialized. You should call init just once!"), e.isInitialized = !0, e.options.isClone || e.logger.log("initialized", e.options), e.emit("initialized", e.options), a.resolve(i), n(t, i);
              };
              if (e.languages && "v1" !== e.options.compatibilityAPI && !e.isInitialized) return t(null, e.t.bind(e));
              e.changeLanguage(e.options.lng, t);
            };
          return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), a;
        }
      }, {
        key: "loadResources",
        value: function (e) {
          var t = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : QB,
            i = "string" == typeof e ? e : this.language;
          if ("function" == typeof e && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
            if (i && "cimode" === i.toLowerCase()) return n();
            var o = [],
              r = function (e) {
                e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                  o.indexOf(e) < 0 && o.push(e);
                });
              };
            if (i) r(i);else this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach(function (e) {
              return r(e);
            });
            this.options.preload && this.options.preload.forEach(function (e) {
              return r(e);
            }), this.services.backendConnector.load(o, this.options.ns, n);
          } else n(null);
        }
      }, {
        key: "reloadResources",
        value: function (e, t, n) {
          var i = DB();
          return e || (e = this.languages), t || (t = this.options.ns), n || (n = QB), this.services.backendConnector.reload(e, t, function (e) {
            i.resolve(), n(e);
          }), i;
        }
      }, {
        key: "use",
        value: function (e) {
          if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
          if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
          return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && FB.addPostProcessor(e), "3rdParty" === e.type && this.modules.external.push(e), this;
        }
      }, {
        key: "changeLanguage",
        value: function (e, t) {
          var n = this;
          this.isLanguageChangingTo = e;
          var i = DB();
          this.emit("languageChanging", e);
          var o = function (e) {
            var o = "string" == typeof e ? e : n.services.languageUtils.getBestMatchFromCodes(e);
            o && (n.language || (n.language = o, n.languages = n.services.languageUtils.toResolveHierarchy(o)), n.translator.language || n.translator.changeLanguage(o), n.services.languageDetector && n.services.languageDetector.cacheUserLanguage(o)), n.loadResources(o, function (e) {
              !function (e, o) {
                o ? (n.language = o, n.languages = n.services.languageUtils.toResolveHierarchy(o), n.translator.changeLanguage(o), n.isLanguageChangingTo = void 0, n.emit("languageChanged", o), n.logger.log("languageChanged", o)) : n.isLanguageChangingTo = void 0, i.resolve(function () {
                  return n.t.apply(n, arguments);
                }), t && t(e, function () {
                  return n.t.apply(n, arguments);
                });
              }(e, o);
            });
          };
          return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(o) : o(e) : o(this.services.languageDetector.detect()), i;
        }
      }, {
        key: "getFixedT",
        value: function (e, t) {
          var n = this,
            i = function e(t, i) {
              var o;
              if ("object" !== hB(i)) {
                for (var r = arguments.length, s = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) s[a - 2] = arguments[a];
                o = n.options.overloadTranslationOptionHandler([t, i].concat(s));
              } else o = gB({}, i);
              return o.lng = o.lng || e.lng, o.lngs = o.lngs || e.lngs, o.ns = o.ns || e.ns, n.t(t, o);
            };
          return "string" == typeof e ? i.lng = e : i.lngs = e, i.ns = t, i;
        }
      }, {
        key: "t",
        value: function () {
          var e;
          return this.translator && (e = this.translator).translate.apply(e, arguments);
        }
      }, {
        key: "exists",
        value: function () {
          var e;
          return this.translator && (e = this.translator).exists.apply(e, arguments);
        }
      }, {
        key: "setDefaultNamespace",
        value: function (e) {
          this.options.defaultNS = e;
        }
      }, {
        key: "hasLoadedNamespace",
        value: function (e) {
          var t = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
          if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
          var i = this.languages[0],
            o = !!this.options && this.options.fallbackLng,
            r = this.languages[this.languages.length - 1];
          if ("cimode" === i.toLowerCase()) return !0;
          var s = function (e, n) {
            var i = t.services.backendConnector.state["".concat(e, "|").concat(n)];
            return -1 === i || 2 === i;
          };
          if (n.precheck) {
            var a = n.precheck(this, s);
            if (void 0 !== a) return a;
          }
          return !!this.hasResourceBundle(i, e) || !this.services.backendConnector.backend || !(!s(i, e) || o && !s(r, e));
        }
      }, {
        key: "loadNamespaces",
        value: function (e, t) {
          var n = this,
            i = DB();
          return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
            n.options.ns.indexOf(e) < 0 && n.options.ns.push(e);
          }), this.loadResources(function (e) {
            i.resolve(), t && t(e);
          }), i) : (t && t(), Promise.resolve());
        }
      }, {
        key: "loadLanguages",
        value: function (e, t) {
          var n = DB();
          "string" == typeof e && (e = [e]);
          var i = this.options.preload || [],
            o = e.filter(function (e) {
              return i.indexOf(e) < 0;
            });
          return o.length ? (this.options.preload = i.concat(o), this.loadResources(function (e) {
            n.resolve(), t && t(e);
          }), n) : (t && t(), Promise.resolve());
        }
      }, {
        key: "dir",
        value: function (e) {
          if (e || (e = this.languages && this.languages.length > 0 ? this.languages[0] : this.language), !e) return "rtl";
          return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e)) >= 0 ? "rtl" : "ltr";
        }
      }, {
        key: "createInstance",
        value: function () {
          return new t(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, arguments.length > 1 ? arguments[1] : void 0);
        }
      }, {
        key: "cloneInstance",
        value: function () {
          var e = this,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : QB,
            o = gB({}, this.options, n, {
              isClone: !0
            }),
            r = new t(o);
          return ["store", "services", "language"].forEach(function (t) {
            r[t] = e[t];
          }), r.services = gB({}, this.services), r.services.utils = {
            hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
          }, r.translator = new HB(r.services, r.options), r.translator.on("*", function (e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
            r.emit.apply(r, [e].concat(n));
          }), r.init(o, i), r.translator.options = r.options, r.translator.backendConnector.services.utils = {
            hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
          }, r;
        }
      }]), t;
    }(SB);
    const XB = new JB();
    function eM(e) {
      return eM = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, eM(e);
    }
    function tM(e) {
      var t = function (e, t) {
        if ("object" != eM(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var i = n.call(e, t || "default");
          if ("object" != eM(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == eM(t) ? t : t + "";
    }
    function nM(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, tM(i.key), i);
      }
    }
    var iM = o(3696),
      oM = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
      rM = {
        "&amp;": "&",
        "&#38;": "&",
        "&lt;": "<",
        "&#60;": "<",
        "&gt;": ">",
        "&#62;": ">",
        "&apos;": "'",
        "&#39;": "'",
        "&quot;": '"',
        "&#34;": '"',
        "&nbsp;": " ",
        "&#160;": " ",
        "&copy;": "©",
        "&#169;": "©",
        "&reg;": "®",
        "&#174;": "®",
        "&hellip;": "…",
        "&#8230;": "…",
        "&#x2F;": "/",
        "&#47;": "/"
      },
      sM = function (e) {
        return rM[e];
      };
    function aM(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }
      return n;
    }
    function lM(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? aM(Object(n), !0).forEach(function (t) {
          var i, o, r;
          i = e, o = t, r = n[t], (o = tM(o)) in i ? Object.defineProperty(i, o, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : i[o] = r;
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : aM(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var cM = {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: !0,
      transWrapTextNodes: "",
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
      useSuspense: !0,
      unescape: function (e) {
        return e.replace(oM, sM);
      }
    };
    (0, iM.createContext)();
    !function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.usedNamespaces = {};
      }
      var t, n, i;
      t = e, (n = [{
        key: "addUsedNamespaces",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            t.usedNamespaces[e] || (t.usedNamespaces[e] = !0);
          });
        }
      }, {
        key: "getUsedNamespaces",
        value: function () {
          return Object.keys(this.usedNamespaces);
        }
      }]) && nM(t.prototype, n), i && nM(t, i), Object.defineProperty(t, "prototype", {
        writable: !1
      });
    }();
    var dM = {
      type: "3rdParty",
      init: function (e) {
        !function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          cM = lM(lM({}, cM), e);
        }(e.options.react), function (e) {
          e;
        }(e);
      }
    };
    function uM(e) {
      return uM = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, uM(e);
    }
    function hM(e) {
      var t = function (e, t) {
        if ("object" != uM(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var i = n.call(e, t || "default");
          if ("object" != uM(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == uM(t) ? t : t + "";
    }
    function mM(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, hM(i.key), i);
      }
    }
    var pM = [],
      gM = pM.forEach,
      fM = pM.slice;
    var kM,
      bM = function (e, t, n, i) {
        var o,
          r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
            path: "/"
          };
        if (n) {
          var s = new Date();
          s.setTime(s.getTime() + 60 * n * 1e3), o = "; expires=" + s.toUTCString();
        } else o = "";
        i = i ? "domain=" + i + ";" : "", r = Object.keys(r).reduce(function (e, t) {
          return e + ";" + t.replace(/([A-Z])/g, function (e) {
            return "-" + e.toLowerCase();
          }) + "=" + r[t];
        }, ""), document.cookie = e + "=" + encodeURIComponent(t) + o + ";" + i + r;
      },
      _M = function (e) {
        for (var t = e + "=", n = document.cookie.split(";"), i = 0; i < n.length; i++) {
          for (var o = n[i]; " " === o.charAt(0);) o = o.substring(1, o.length);
          if (0 === o.indexOf(t)) return o.substring(t.length, o.length);
        }
        return null;
      },
      wM = {
        name: "cookie",
        lookup: function (e) {
          var t;
          if (e.lookupCookie && "undefined" != typeof document) {
            var n = _M(e.lookupCookie);
            n && (t = n);
          }
          return t;
        },
        cacheUserLanguage: function (e, t) {
          t.lookupCookie && "undefined" != typeof document && bM(t.lookupCookie, e, t.cookieMinutes, t.cookieDomain, t.cookieOptions);
        }
      },
      AM = {
        name: "querystring",
        lookup: function (e) {
          var t;
          if ("undefined" != typeof window) for (var n = window.location.search.substring(1).split("&"), i = 0; i < n.length; i++) {
            var o = n[i].indexOf("=");
            if (o > 0) n[i].substring(0, o) === e.lookupQuerystring && (t = n[i].substring(o + 1));
          }
          return t;
        }
      };
    try {
      kM = "undefined" !== window && null !== window.localStorage;
      var vM = "i18next.translate.boo";
      window.localStorage.setItem(vM, "foo"), window.localStorage.removeItem(vM);
    } catch (e) {
      kM = !1;
    }
    var CM,
      yM = {
        name: "localStorage",
        lookup: function (e) {
          var t;
          if (e.lookupLocalStorage && kM) {
            var n = window.localStorage.getItem(e.lookupLocalStorage);
            n && (t = n);
          }
          return t;
        },
        cacheUserLanguage: function (e, t) {
          t.lookupLocalStorage && kM && window.localStorage.setItem(t.lookupLocalStorage, e);
        }
      };
    try {
      CM = "undefined" !== window && null !== window.sessionStorage;
      var xM = "i18next.translate.boo";
      window.sessionStorage.setItem(xM, "foo"), window.sessionStorage.removeItem(xM);
    } catch (e) {
      CM = !1;
    }
    var EM = {
        name: "sessionStorage",
        lookup: function (e) {
          var t;
          if (e.lookupsessionStorage && CM) {
            var n = window.sessionStorage.getItem(e.lookupsessionStorage);
            n && (t = n);
          }
          return t;
        },
        cacheUserLanguage: function (e, t) {
          t.lookupsessionStorage && CM && window.sessionStorage.setItem(t.lookupsessionStorage, e);
        }
      },
      SM = {
        name: "navigator",
        lookup: function (e) {
          var t = [];
          if ("undefined" != typeof navigator) {
            if (navigator.languages) for (var n = 0; n < navigator.languages.length; n++) t.push(navigator.languages[n]);
            navigator.userLanguage && t.push(navigator.userLanguage), navigator.language && t.push(navigator.language);
          }
          return t.length > 0 ? t : void 0;
        }
      },
      DM = {
        name: "htmlTag",
        lookup: function (e) {
          var t,
            n = e.htmlTag || ("undefined" != typeof document ? document.documentElement : null);
          return n && "function" == typeof n.getAttribute && (t = n.getAttribute("lang")), t;
        }
      },
      TM = {
        name: "path",
        lookup: function (e) {
          var t;
          if ("undefined" != typeof window) {
            var n = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (n instanceof Array) if ("number" == typeof e.lookupFromPathIndex) {
              if ("string" != typeof n[e.lookupFromPathIndex]) return;
              t = n[e.lookupFromPathIndex].replace("/", "");
            } else t = n[0].replace("/", "");
          }
          return t;
        }
      },
      IM = {
        name: "subdomain",
        lookup: function (e) {
          var t;
          if ("undefined" != typeof window) {
            var n = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
            n instanceof Array && (t = "number" == typeof e.lookupFromSubdomainIndex ? n[e.lookupFromSubdomainIndex].replace("http://", "").replace("https://", "").replace(".", "") : n[0].replace("http://", "").replace("https://", "").replace(".", ""));
          }
          return t;
        }
      };
    var BM = function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, n);
      }
      var t, n, i;
      return t = e, n = [{
        key: "init",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.services = e, this.options = function (e) {
            return gM.call(fM.call(arguments, 1), function (t) {
              if (t) for (var n in t) void 0 === e[n] && (e[n] = t[n]);
            }), e;
          }(t, this.options || {}, {
            order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
            lookupQuerystring: "lng",
            lookupCookie: "i18next",
            lookupLocalStorage: "i18nextLng",
            caches: ["localStorage"],
            excludeCacheFor: ["cimode"],
            checkWhitelist: !0,
            checkForSimilarInWhitelist: !1
          }), this.options.checkForSimilarInWhitelist && (this.options.checkWhitelist = !0), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = n, this.addDetector(wM), this.addDetector(AM), this.addDetector(yM), this.addDetector(EM), this.addDetector(SM), this.addDetector(DM), this.addDetector(TM), this.addDetector(IM);
        }
      }, {
        key: "addDetector",
        value: function (e) {
          this.detectors[e.name] = e;
        }
      }, {
        key: "detect",
        value: function (e) {
          var t = this;
          e || (e = this.options.order);
          var n,
            i = [];
          if (e.forEach(function (e) {
            if (t.detectors[e]) {
              var n = t.detectors[e].lookup(t.options);
              n && "string" == typeof n && (n = [n]), n && (i = i.concat(n));
            }
          }), i.forEach(function (e) {
            if (!n) {
              var i = t.services.languageUtils.formatLanguageCode(e);
              t.options.checkWhitelist && !t.services.languageUtils.isWhitelisted(i) || (n = i), !n && t.options.checkForSimilarInWhitelist && (n = t.getSimilarInWhitelist(i));
            }
          }), !n) {
            var o = this.i18nOptions.fallbackLng;
            "string" == typeof o && (o = [o]), o || (o = []), n = "[object Array]" === Object.prototype.toString.apply(o) ? o[0] : o[0] || o.default && o.default[0];
          }
          return n;
        }
      }, {
        key: "cacheUserLanguage",
        value: function (e, t) {
          var n = this;
          t || (t = this.options.caches), t && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(e) > -1 || t.forEach(function (t) {
            n.detectors[t] && n.detectors[t].cacheUserLanguage(e, n.options);
          }));
        }
      }, {
        key: "getSimilarInWhitelist",
        value: function (e) {
          var t = this;
          if (this.i18nOptions.whitelist) {
            if (e.includes("-")) {
              var n = e.split("-")[0],
                i = this.services.languageUtils.formatLanguageCode(n);
              if (this.services.languageUtils.isWhitelisted(i)) return i;
              e = i;
            }
            var o = this.i18nOptions.whitelist.find(function (n) {
              var i = t.services.languageUtils.formatLanguageCode(n);
              if (i.startsWith(e)) return i;
            });
            return o || void 0;
          }
        }
      }], n && mM(t.prototype, n), i && mM(t, i), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }();
    BM.type = "languageDetector";
    const MM = BM;
    var PM = o(7206),
      zM = o.n(PM),
      NM = o(7531),
      LM = o.n(NM),
      RM = o(14),
      VM = o.n(RM);
    const OM = e => {
        var t = {};
        return function e(n, i) {
          for (var o in n) {
            var r = n[o],
              s = i ? i + "." + o : o;
            r && "object" == typeof r ? e(r, s) : t[s] = r;
          }
        }(e), t;
      },
      FM = {
        en: {
          translations: OM(zM())
        },
        fr: {
          translations: OM(LM())
        },
        de: {
          translations: OM(VM())
        }
      };
    XB.use(dM).use(MM).init({
      resources: FM,
      fallbackLng: "fr",
      debug: !1,
      supportedLngs: ["fr", "en", "de"],
      ns: ["translations"],
      defaultNS: "translations",
      keySeparator: !1,
      interpolation: {
        escapeValue: !1,
        formatSeparator: ","
      },
      react: {
        wait: !0
      }
    });
    const jM = XB,
      HM = ["ticket.contact.firstname", "ticket.contact.lastname", "ticket.contact.title", "ticket._id", "ticket.activated_pricing.name.fr", "ticket.activated_pricing.name.en", "ticket.activated_pricing.name.de", "ticket.activated_pricing.description.fr", "ticket.activated_pricing.description.en", "ticket.activated_pricing.description.de", "ticket.view_link.fr", "ticket.view_link.en", "ticket.view_link.de", "ticket.download_link.fr", "ticket.download_link.en", "ticket.download_link.de", "ticketID", "tickettype.description.fr", "tickettype.description.en", "tickettype.description.de", "screening._id", "screening.title.fr", "screening.title.en", "screening.title.de", "place._id", "place.cinema", "place.number", "place.name", "place.address", "place.zip", "place.city", "place.country", "user.id", "user.firstname", "user.lastname", "user.email", "application.id", "application.user.id", "application.user.firstname", "application.user.lastname", "application.user.email", "customer.id", "customer.firstname", "customer.lastname", "customer.email", "order.id", "order.parts.subject", "order.parts.heading", "order.parts.content", "order.parts.payment", "custom.text.fr", "custom.text.en", "custom.text.de"];
    class UM extends db {}
    UM.builtinPlugins = [class extends Br {
      init() {
        const e = this.editor;
        e.ui.componentFactory.add("shortcodes", t => {
          const n = yp(t);
          n.buttonView.set({
            label: jM.t("layouts.shortcodes.button"),
            withText: !0
          });
          const i = new qo();
          return HM.forEach(e => {
            i.add({
              type: "button",
              model: new Pf({
                id: e,
                withText: !0,
                label: jM.t("layouts.shortcodes.".concat(e))
              })
            });
          }), Sp(n, i), n.on("execute", t => {
            e.model.change(n => {
              t.source && t.source.id && e.model.insertContent(n.createText("[".concat(t.source.id, "]")));
            });
          }), n;
        });
      }
    }, class extends Br {
      static get requires() {
        return [bb, wb];
      }
      static get pluginName() {
        return "Alignment";
      }
    }, class extends Br {
      static get requires() {
        return [zb];
      }
      static get pluginName() {
        return "Autoformat";
      }
      afterInit() {
        const e = this.editor,
          t = this.editor.t;
        this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats(), e.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: t("Revert autoformatting action"),
            keystroke: "Backspace"
          }]
        });
      }
      _addListAutoformats() {
        const e = this.editor.commands;
        e.get("bulletedList") && e_(this.editor, this, /^[*-]\s$/, "bulletedList"), e.get("numberedList") && e_(this.editor, this, /^1[.|)]\s$/, "numberedList"), e.get("todoList") && e_(this.editor, this, /^\[\s?\]\s$/, "todoList"), e.get("checkTodoList") && e_(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
          this.editor.execute("todoList"), this.editor.execute("checkTodoList");
        });
      }
      _addBasicStylesAutoformats() {
        const e = this.editor.commands;
        if (e.get("bold")) {
          const e = i_(this.editor, "bold");
          t_(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, e), t_(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, e);
        }
        if (e.get("italic")) {
          const e = i_(this.editor, "italic");
          t_(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, e), t_(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, e);
        }
        if (e.get("code")) {
          const e = i_(this.editor, "code");
          t_(this.editor, this, /(`)([^`]+)(`)$/g, e);
        }
        if (e.get("strikethrough")) {
          const e = i_(this.editor, "strikethrough");
          t_(this.editor, this, /(~~)([^~]+)(~~)$/g, e);
        }
      }
      _addHeadingAutoformats() {
        const e = this.editor.commands.get("heading");
        e && e.modelElements.filter(e => e.match(/^heading[1-6]$/)).forEach(t => {
          const n = t[7],
            i = new RegExp("^(#{".concat(n, "})\\s$"));
          e_(this.editor, this, i, () => {
            if (!e.isEnabled || e.value === t) return !1;
            this.editor.execute("heading", {
              value: t
            });
          });
        });
      }
      _addBlockQuoteAutoformats() {
        this.editor.commands.get("blockQuote") && e_(this.editor, this, /^>\s$/, "blockQuote");
      }
      _addCodeBlockAutoformats() {
        const e = this.editor,
          t = e.model.document.selection;
        e.commands.get("codeBlock") && e_(e, this, /^```$/, () => {
          if (t.getFirstPosition().parent.is("element", "listItem")) return !1;
          this.editor.execute("codeBlock", {
            usePreviousLanguageChoice: !0
          });
        });
      }
      _addHorizontalLineAutoformats() {
        this.editor.commands.get("horizontalLine") && e_(this.editor, this, /^---$/, "horizontalLine");
      }
    }, class extends Br {
      static get requires() {
        return [oy];
      }
      static get pluginName() {
        return "Base64UploadAdapter";
      }
      init() {
        this.editor.plugins.get(oy).createUploadAdapter = e => new sy(e);
      }
    }, class extends Br {
      static get requires() {
        return [H_, G_];
      }
      static get pluginName() {
        return "BlockQuote";
      }
    }, class extends Br {
      static get requires() {
        return [s_, c_];
      }
      static get pluginName() {
        return "Bold";
      }
    }, class extends Br {
      static get requires() {
        return [nm, hA, P_, bA, R_, Nb, EA];
      }
      static get pluginName() {
        return "Essentials";
      }
    }, class extends Br {
      static get requires() {
        return [NA, RA];
      }
      static get pluginName() {
        return "FontColor";
      }
    }, class extends Br {
      static get requires() {
        return [OA, FA];
      }
      static get pluginName() {
        return "FontBackgroundColor";
      }
    }, class extends Br {
      static get pluginName() {
        return "FullPage";
      }
      init() {
        const e = this.editor,
          t = ["$fullPageDocument", "$fullPageDocType", "$fullPageXmlDeclaration"];
        e.data.processor = new sC(e.data.viewDocument), e.model.schema.extend("$root", {
          allowAttributes: t
        }), e.data.on("toModel", (n, _ref172) => {
          let [i] = _ref172;
          const o = e.model.document.getRoot();
          e.model.change(e => {
            for (const n of t) {
              const t = i.getCustomProperty(n);
              t && e.setAttribute(n, t, o);
            }
          });
        }, {
          priority: "low"
        }), e.data.on("toView", (e, _ref173) => {
          let [n] = _ref173;
          if (!n.is("rootElement")) return;
          const i = n,
            o = e.return;
          if (!i.hasAttribute("$fullPageDocument")) return;
          const r = new Xu(o.document);
          for (const e of t) {
            const t = i.getAttribute(e);
            t && r.setCustomProperty(e, t, o);
          }
        }, {
          priority: "low"
        }), e.data.on("set", () => {
          const n = e.model.document.getRoot();
          e.model.change(e => {
            for (const i of t) n.hasAttribute(i) && e.removeAttribute(i, n);
          });
        }, {
          priority: "high"
        }), e.data.on("get", (e, t) => {
          t[0] || (t[0] = {}), t[0].trim = !1;
        }, {
          priority: "high"
        });
      }
    }, class extends Br {
      static get requires() {
        return [$A, JA];
      }
      static get pluginName() {
        return "Heading";
      }
    }, class extends Br {
      static get requires() {
        return [nv, iv, Uw];
      }
      static get pluginName() {
        return "HorizontalLine";
      }
    }, class extends Br {
      static get requires() {
        return [qC, KC];
      }
      static get pluginName() {
        return "Image";
      }
    }, class extends Br {
      static get requires() {
        return [$C, ZC];
      }
      static get pluginName() {
        return "ImageCaption";
      }
    }, class extends Br {
      static get requires() {
        return [Hy, Gy];
      }
      static get pluginName() {
        return "ImageStyle";
      }
    }, class extends Br {
      static get requires() {
        return [Gw, mC];
      }
      static get pluginName() {
        return "ImageToolbar";
      }
      afterInit() {
        const e = this.editor,
          t = e.t,
          n = e.plugins.get(Gw),
          i = e.plugins.get("ImageUtils");
        var o;
        n.register("image", {
          ariaLabel: t("Image toolbar"),
          items: (o = e.config.get("image.toolbar") || [], o.map(e => R(e) ? e.name : e)),
          getRelatedElement: e => i.getClosestSelectedImageWidget(e)
        });
      }
    }, class extends Br {
      static get pluginName() {
        return "ImageUpload";
      }
      static get requires() {
        return [wy, ny, my];
      }
    }, class extends Br {
      static get pluginName() {
        return "Indent";
      }
      static get requires() {
        return [$y, Zy];
      }
    }, class extends Br {
      static get requires() {
        return [m_, g_];
      }
      static get pluginName() {
        return "Italic";
      }
    }, class extends Br {
      static get requires() {
        return [kx, xx, Dx];
      }
      static get pluginName() {
        return "Link";
      }
    }, TE, tS, class extends Br {
      static get requires() {
        return [mS, _S, gS, Uw];
      }
      static get pluginName() {
        return "MediaEmbed";
      }
    }, GA, class extends Br {
      static get pluginName() {
        return "PasteFromOffice";
      }
      static get requires() {
        return [mw];
      }
      init() {
        const e = this.editor,
          t = e.plugins.get("ClipboardPipeline"),
          n = e.editing.view.document,
          i = [],
          o = this.editor.plugins.has("MultiLevelList");
        i.push(new RS(n, o)), i.push(new jS(n)), i.push(new US(n)), t.on("inputTransformation", (t, o) => {
          if (o._isTransformedWithPasteFromOffice) return;
          if (e.model.document.selection.getFirstPosition().parent.is("element", "codeBlock")) return;
          const r = o.dataTransfer.getData("text/html"),
            s = i.find(e => e.isActive(r));
          s && (o._parsedData || (o._parsedData = GS(r, n.stylesProcessor)), s.execute(o), o._isTransformedWithPasteFromOffice = !0);
        }, {
          priority: "high"
        });
      }
    }, class extends Br {
      static get requires() {
        return [$S, WS];
      }
      static get pluginName() {
        return "RemoveFormat";
      }
    }, class extends Br {
      static get pluginName() {
        return "SourceEditing";
      }
      static get requires() {
        return [Kh];
      }
      constructor(e) {
        super(e), this.set("isSourceEditingMode", !1), this._elementReplacer = new Z(), this._replacedRoots = new Map(), this._dataFromRoots = new Map(), e.config.define("sourceEditing.allowCollaborationFeatures", !1);
      }
      init() {
        this._checkCompatibility();
        const e = this.editor,
          t = e.locale.t;
        e.ui.componentFactory.add("sourceEditing", () => {
          const e = this._createButton(um);
          return e.set({
            label: t("Source"),
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z"/><path d="M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z"/></svg>',
            tooltip: !0,
            class: "ck-source-editing-button"
          }), e;
        }), e.ui.componentFactory.add("menuBar:sourceEditing", () => {
          const e = this._createButton(qk);
          return e.set({
            label: t("Show source")
          }), e;
        }), this._isAllowedToHandleSourceEditingMode() && (this.on("change:isSourceEditingMode", (e, t, n) => {
          n ? (this._hideVisibleDialog(), this._showSourceEditing(), this._disableCommands()) : (this._hideSourceEditing(), this._enableCommands());
        }), this.on("change:isEnabled", (e, t, n) => this._handleReadOnlyMode(!n)), this.listenTo(e, "change:isReadOnly", (e, t, n) => this._handleReadOnlyMode(n))), e.data.on("get", () => {
          this.isSourceEditingMode && this.updateEditorData();
        }, {
          priority: "high"
        });
      }
      updateEditorData() {
        const e = this.editor,
          t = {};
        for (const [e, n] of this._replacedRoots) {
          const i = this._dataFromRoots.get(e),
            o = n.dataset.value;
          i !== o && (t[e] = o, this._dataFromRoots.set(e, o));
        }
        Object.keys(t).length && e.data.set(t, {
          batchType: {
            isUndoable: !0
          },
          suppressErrorInCollaboration: !0
        });
      }
      _checkCompatibility() {
        const e = this.editor,
          t = e.config.get("sourceEditing.allowCollaborationFeatures");
        if (!t && e.plugins.has("RealTimeCollaborativeEditing")) throw new _("source-editing-incompatible-with-real-time-collaboration", null);
        !t && ["CommentsEditing", "TrackChangesEditing", "RevisionHistory"].some(t => e.plugins.has(t)) && console.warn("You initialized the editor with the source editing feature and at least one of the collaboration features. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the collaboration features."), e.plugins.has("RestrictedEditingModeEditing") && console.warn("You initialized the editor with the source editing feature and restricted editing feature. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the restricted editing feature.");
      }
      _showSourceEditing() {
        const e = this.editor,
          t = e.editing.view,
          n = e.model;
        n.change(e => {
          e.setSelection(null), e.removeSelectionAttribute(n.document.selection.getAttributeKeys());
        });
        for (const [n, i] of t.domRoots) {
          const o = tD(e.data.get({
              rootName: n
            })),
            r = fe(i.ownerDocument, "textarea", {
              rows: "1",
              "aria-label": "Source code editing area"
            }),
            s = fe(i.ownerDocument, "div", {
              class: "ck-source-editing-area",
              "data-value": o
            }, [r]);
          r.value = o, r.setSelectionRange(0, 0), r.addEventListener("input", () => {
            s.dataset.value = r.value, e.ui.update();
          }), t.change(e => {
            const i = t.document.getRoot(n);
            e.addClass("ck-hidden", i);
          }), e.ui.setEditableElement("sourceEditing:" + n, r), this._replacedRoots.set(n, s), this._elementReplacer.replace(i, s), this._dataFromRoots.set(n, o);
        }
        this._focusSourceEditing();
      }
      _hideSourceEditing() {
        const e = this.editor.editing.view;
        this.updateEditorData(), e.change(t => {
          for (const [n] of this._replacedRoots) t.removeClass("ck-hidden", e.document.getRoot(n));
        }), this._elementReplacer.restore(), this._replacedRoots.clear(), this._dataFromRoots.clear(), e.focus();
      }
      _focusSourceEditing() {
        const e = this.editor,
          [t] = this._replacedRoots.values(),
          n = t.querySelector("textarea");
        e.editing.view.document.isFocused = !1, n.focus();
      }
      _disableCommands() {
        const e = this.editor;
        for (const t of e.commands.commands()) t.forceDisabled(eD);
        e.plugins.has("CommentsArchiveUI") && e.plugins.get("CommentsArchiveUI").forceDisabled(eD);
      }
      _enableCommands() {
        const e = this.editor;
        for (const t of e.commands.commands()) t.clearForceDisabled(eD);
        e.plugins.has("CommentsArchiveUI") && e.plugins.get("CommentsArchiveUI").clearForceDisabled(eD);
      }
      _handleReadOnlyMode(e) {
        if (this.isSourceEditingMode) for (const [, t] of this._replacedRoots) t.querySelector("textarea").readOnly = e;
      }
      _isAllowedToHandleSourceEditingMode() {
        const e = this.editor.ui.view.editable;
        return e && !e.hasExternalElement;
      }
      _hideVisibleDialog() {
        if (this.editor.plugins.has("Dialog")) {
          const e = this.editor.plugins.get("Dialog");
          e.isOpen && e.hide();
        }
      }
      _createButton(e) {
        const t = this.editor,
          n = new e(t.locale);
        return n.set({
          withText: !0
        }), n.bind("isOn").to(this, "isSourceEditingMode"), n.bind("isEnabled").to(this, "isEnabled", t, "isReadOnly", t.plugins.get(Kh), "hasAny", (e, t, n) => !!e && !t && !n), this.listenTo(n, "execute", () => {
          this.isSourceEditingMode = !this.isSourceEditingMode;
        }), n;
      }
    }, class extends Br {
      static get requires() {
        return [k_, __];
      }
      static get pluginName() {
        return "Strikethrough";
      }
    }, class extends Br {
      static get requires() {
        return [A_, C_];
      }
      static get pluginName() {
        return "Superscript";
      }
    }, class extends Br {
      static get requires() {
        return [mT, bT, vT, TT, ST, CT, Uw];
      }
      static get pluginName() {
        return "Table";
      }
    }, class extends Br {
      static get pluginName() {
        return "TableCaption";
      }
      static get requires() {
        return [sB, aB];
      }
    }, class extends Br {
      static get pluginName() {
        return "TableCellProperties";
      }
      static get requires() {
        return [NI, AI];
      }
    }, class extends Br {
      static get pluginName() {
        return "TableProperties";
      }
      static get requires() {
        return [KI, eB];
      }
    }, class extends Br {
      static get requires() {
        return [Gw];
      }
      static get pluginName() {
        return "TableToolbar";
      }
      afterInit() {
        const e = this.editor,
          t = e.t,
          n = e.plugins.get(Gw),
          i = e.config.get("table.contentToolbar"),
          o = e.config.get("table.tableToolbar");
        i && n.register("tableContent", {
          ariaLabel: t("Table toolbar"),
          items: i,
          getRelatedElement: NT
        }), o && n.register("table", {
          ariaLabel: t("Table toolbar"),
          items: o,
          getRelatedElement: zT
        });
      }
    }, class extends Br {
      static get requires() {
        return ["Delete", "Input"];
      }
      static get pluginName() {
        return "TextTransformation";
      }
      constructor(e) {
        super(e), e.config.define("typing", {
          transformations: {
            include: Wb
          }
        });
      }
      init() {
        const e = this.editor.model.document.selection;
        e.on("change:range", () => {
          this.isEnabled = !e.anchor.parent.is("element", "codeBlock");
        }), this._enableTransformationWatchers();
      }
      _enableTransformationWatchers() {
        const e = this.editor,
          t = e.model,
          n = e.plugins.get("Delete"),
          i = function (e) {
            const t = e.extra || [],
              n = e.remove || [],
              i = e => !n.includes(e);
            return function (e) {
              const t = new Set();
              for (const n of e) if ("string" == typeof n && Kb[n]) for (const e of Kb[n]) t.add(e);else t.add(n);
              return Array.from(t);
            }(e.include.concat(t).filter(i)).filter(i).map(e => "string" == typeof e && Gb[e] ? Gb[e] : e).filter(e => "object" == typeof e).map(e => ({
              from: Yb(e.from),
              to: $b(e.to)
            }));
          }(e.config.get("typing.transformations")),
          o = new Rb(e.model, e => {
            for (const t of i) {
              if (t.from.test(e)) return {
                normalizedTransformation: t
              };
            }
          });
        o.on("matched:data", (e, i) => {
          if (!i.batch.isTyping) return;
          const {
              from: o,
              to: r
            } = i.normalizedTransformation,
            s = o.exec(i.text),
            a = r(s.slice(1)),
            l = i.range;
          let c = s.index;
          t.enqueueChange(e => {
            for (let n = 1; n < s.length; n++) {
              const i = s[n],
                o = a[n - 1];
              if (null == o) {
                c += i.length;
                continue;
              }
              const r = l.start.getShiftedBy(c),
                d = t.createRange(r, r.getShiftedBy(i.length)),
                u = Zb(r);
              t.insertContent(e.createText(o, u), d), c += o.length;
            }
            t.enqueueChange(() => {
              n.requestUndoOnBackspace();
            });
          });
        }), o.bind("isEnabled").to(this);
      }
    }, class extends Br {
      static get requires() {
        return [x_, S_];
      }
      static get pluginName() {
        return "Underline";
      }
    }, EA], UM.defaultConfig = {
      toolbar: {
        items: ["shortcodes", "bold", "italic", "underline", "link", "fontColor", "fontBackgroundColor", "|", "horizontalLine", "|", "heading", "alignment", "|", "bulletedList", "numberedList", "outdent", "indent", "|", "insertTable", "imageUpload", "|", "strikethrough", "superscript", "blockQuote", "|", "sourceEditing", "removeFormat", "|", "undo", "redo", "|", "-", "|"],
        shouldNotGroupWhenFull: !1
      },
      language: "en",
      image: {
        toolbar: ["imageTextAlternative", "toggleImageCaption", "imageStyle:inline", "imageStyle:block", "imageStyle:side"]
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells", "tableCellProperties", "tableProperties"]
      }
    };
    const qM = UM;
  })(), r = r.default;
})());